(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@dutypay/store-modules"), require("@dutypay/utilities"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@dutypay/store-modules", "@dutypay/utilities", ], factory);
	else if(typeof exports === 'object')
		exports["design-system"] = factory(require("@dutypay/store-modules"), require("@dutypay/utilities"), require("vue"));
	else
		root["design-system"] = factory(root["@dutypay/store-modules"], root["@dutypay/utilities"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__2706__, __WEBPACK_EXTERNAL_MODULE__3351__, __WEBPACK_EXTERNAL_MODULE__7203__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7679:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 9282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4155);
/* provided dependency */ var console = __webpack_require__(5108);
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(2136),
    _require$codes = _require.codes,
    ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE,
    ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;

var AssertionError = __webpack_require__(5961);

var _require2 = __webpack_require__(69),
    inspect = _require2.inspect;

var _require$types = (__webpack_require__(69).types),
    isPromise = _require$types.isPromise,
    isRegExp = _require$types.isRegExp;

var objectAssign = Object.assign ? Object.assign : (__webpack_require__(8091).assign);
var objectIs = Object.is ? Object.is : __webpack_require__(609);
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;

function lazyLoadComparison() {
  var comparison = __webpack_require__(9158);

  isDeepEqual = comparison.isDeepEqual;
  isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex


var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = (/* unused pure expression or super */ null && (["\\u0000", "\\u0001", "\\u0002", "\\u0003", "\\u0004", "\\u0005", "\\u0006", "\\u0007", '\\b', '', '', "\\u000b", '\\f', '', "\\u000e", "\\u000f", "\\u0010", "\\u0011", "\\u0012", "\\u0013", "\\u0014", "\\u0015", "\\u0016", "\\u0017", "\\u0018", "\\u0019", "\\u001a", "\\u001b", "\\u001c", "\\u001d", "\\u001e", "\\u001f"]));

var escapeFn = function escapeFn(str) {
  return meta[str.charCodeAt(0)];
};

var warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function innerFail(obj) {
  if (obj.message instanceof Error) throw obj.message;
  throw new AssertionError(obj);
}

function fail(actual, expected, message, operator, stackStartFn) {
  var argsLen = arguments.length;
  var internalMessage;

  if (argsLen === 0) {
    internalMessage = 'Failed';
  } else if (argsLen === 1) {
    message = actual;
    actual = undefined;
  } else {
    if (warned === false) {
      warned = true;
      var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
      warn('assert.fail() with more than one argument is deprecated. ' + 'Please use assert.strictEqual() instead or only pass a message.', 'DeprecationWarning', 'DEP0094');
    }

    if (argsLen === 2) operator = '!=';
  }

  if (message instanceof Error) throw message;
  var errArgs = {
    actual: actual,
    expected: expected,
    operator: operator === undefined ? 'fail' : operator,
    stackStartFn: stackStartFn || fail
  };

  if (message !== undefined) {
    errArgs.message = message;
  }

  var err = new AssertionError(errArgs);

  if (internalMessage) {
    err.message = internalMessage;
    err.generatedMessage = true;
  }

  throw err;
}

assert.fail = fail; // The AssertionError is defined in internal/error.

assert.AssertionError = AssertionError;

function innerOk(fn, argLen, value, message) {
  if (!value) {
    var generatedMessage = false;

    if (argLen === 0) {
      generatedMessage = true;
      message = 'No value argument passed to `assert.ok()`';
    } else if (message instanceof Error) {
      throw message;
    }

    var err = new AssertionError({
      actual: value,
      expected: true,
      message: message,
      operator: '==',
      stackStartFn: fn
    });
    err.generatedMessage = generatedMessage;
    throw err;
  }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.


function ok() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  innerOk.apply(void 0, [ok, args.length].concat(args));
}

assert.ok = ok; // The equality assertion tests shallow, coercive equality with ==.

/* eslint-disable no-restricted-properties */

assert.equal = function equal(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  } // eslint-disable-next-line eqeqeq


  if (actual != expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '==',
      stackStartFn: equal
    });
  }
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.


assert.notEqual = function notEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  } // eslint-disable-next-line eqeqeq


  if (actual == expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '!=',
      stackStartFn: notEqual
    });
  }
}; // The equivalence assertion tests a deep equality relation.


assert.deepEqual = function deepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (!isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepEqual',
      stackStartFn: deepEqual
    });
  }
}; // The non-equivalence assertion tests for any deep inequality.


assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepEqual',
      stackStartFn: notDeepEqual
    });
  }
};
/* eslint-enable */


assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (!isDeepStrictEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepStrictEqual',
      stackStartFn: deepStrictEqual
    });
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;

function notDeepStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (isDeepStrictEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepStrictEqual',
      stackStartFn: notDeepStrictEqual
    });
  }
}

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (!objectIs(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'strictEqual',
      stackStartFn: strictEqual
    });
  }
};

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (objectIs(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notStrictEqual',
      stackStartFn: notStrictEqual
    });
  }
};

var Comparison = function Comparison(obj, keys, actual) {
  var _this = this;

  _classCallCheck(this, Comparison);

  keys.forEach(function (key) {
    if (key in obj) {
      if (actual !== undefined && typeof actual[key] === 'string' && isRegExp(obj[key]) && obj[key].test(actual[key])) {
        _this[key] = actual[key];
      } else {
        _this[key] = obj[key];
      }
    }
  });
};

function compareExceptionKey(actual, expected, key, message, keys, fn) {
  if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
    if (!message) {
      // Create placeholder objects to create a nice output.
      var a = new Comparison(actual, keys);
      var b = new Comparison(expected, keys, actual);
      var err = new AssertionError({
        actual: a,
        expected: b,
        operator: 'deepStrictEqual',
        stackStartFn: fn
      });
      err.actual = actual;
      err.expected = expected;
      err.operator = fn.name;
      throw err;
    }

    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: fn.name,
      stackStartFn: fn
    });
  }
}

function expectedException(actual, expected, msg, fn) {
  if (typeof expected !== 'function') {
    if (isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.

    if (arguments.length === 2) {
      throw new ERR_INVALID_ARG_TYPE('expected', ['Function', 'RegExp'], expected);
    } // Handle primitives properly.


    if (_typeof(actual) !== 'object' || actual === null) {
      var err = new AssertionError({
        actual: actual,
        expected: expected,
        message: msg,
        operator: 'deepStrictEqual',
        stackStartFn: fn
      });
      err.operator = fn.name;
      throw err;
    }

    var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
    // as well.

    if (expected instanceof Error) {
      keys.push('name', 'message');
    } else if (keys.length === 0) {
      throw new ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
    }

    if (isDeepEqual === undefined) lazyLoadComparison();
    keys.forEach(function (key) {
      if (typeof actual[key] === 'string' && isRegExp(expected[key]) && expected[key].test(actual[key])) {
        return;
      }

      compareExceptionKey(actual, expected, key, msg, keys, fn);
    });
    return true;
  } // Guard instanceof against arrow functions as they don't have a prototype.


  if (expected.prototype !== undefined && actual instanceof expected) {
    return true;
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function getActual(fn) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
  }

  try {
    fn();
  } catch (e) {
    return e;
  }

  return NO_EXCEPTION_SENTINEL;
}

function checkIsPromise(obj) {
  // Accept native ES6 promises and promises that are implemented in a similar
  // way. Do not accept thenables that use a function as `obj` and that have no
  // `catch` handler.
  // TODO: thenables are checked up until they have the correct methods,
  // but according to documentation, the `then` method should receive
  // the `fulfill` and `reject` arguments as well or it may be never resolved.
  return isPromise(obj) || obj !== null && _typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}

function waitForActual(promiseFn) {
  return Promise.resolve().then(function () {
    var resultPromise;

    if (typeof promiseFn === 'function') {
      // Return a rejected promise if `promiseFn` throws synchronously.
      resultPromise = promiseFn(); // Fail in case no promise is returned.

      if (!checkIsPromise(resultPromise)) {
        throw new ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
      }
    } else if (checkIsPromise(promiseFn)) {
      resultPromise = promiseFn;
    } else {
      throw new ERR_INVALID_ARG_TYPE('promiseFn', ['Function', 'Promise'], promiseFn);
    }

    return Promise.resolve().then(function () {
      return resultPromise;
    }).then(function () {
      return NO_EXCEPTION_SENTINEL;
    }).catch(function (e) {
      return e;
    });
  });
}

function expectsError(stackStartFn, actual, error, message) {
  if (typeof error === 'string') {
    if (arguments.length === 4) {
      throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
    }

    if (_typeof(actual) === 'object' && actual !== null) {
      if (actual.message === error) {
        throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
      }
    } else if (actual === error) {
      throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
    }

    message = error;
    error = undefined;
  } else if (error != null && _typeof(error) !== 'object' && typeof error !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
  }

  if (actual === NO_EXCEPTION_SENTINEL) {
    var details = '';

    if (error && error.name) {
      details += " (".concat(error.name, ")");
    }

    details += message ? ": ".concat(message) : '.';
    var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
    innerFail({
      actual: undefined,
      expected: error,
      operator: stackStartFn.name,
      message: "Missing expected ".concat(fnType).concat(details),
      stackStartFn: stackStartFn
    });
  }

  if (error && !expectedException(actual, error, message, stackStartFn)) {
    throw actual;
  }
}

function expectsNoError(stackStartFn, actual, error, message) {
  if (actual === NO_EXCEPTION_SENTINEL) return;

  if (typeof error === 'string') {
    message = error;
    error = undefined;
  }

  if (!error || expectedException(actual, error)) {
    var details = message ? ": ".concat(message) : '.';
    var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
    innerFail({
      actual: actual,
      expected: error,
      operator: stackStartFn.name,
      message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
      stackStartFn: stackStartFn
    });
  }

  throw actual;
}

assert.throws = function throws(promiseFn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  expectsError.apply(void 0, [throws, getActual(promiseFn)].concat(args));
};

assert.rejects = function rejects(promiseFn) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return waitForActual(promiseFn).then(function (result) {
    return expectsError.apply(void 0, [rejects, result].concat(args));
  });
};

assert.doesNotThrow = function doesNotThrow(fn) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  expectsNoError.apply(void 0, [doesNotThrow, getActual(fn)].concat(args));
};

assert.doesNotReject = function doesNotReject(fn) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  return waitForActual(fn).then(function (result) {
    return expectsNoError.apply(void 0, [doesNotReject, result].concat(args));
  });
};

assert.ifError = function ifError(err) {
  if (err !== null && err !== undefined) {
    var message = 'ifError got unwanted exception: ';

    if (_typeof(err) === 'object' && typeof err.message === 'string') {
      if (err.message.length === 0 && err.constructor) {
        message += err.constructor.name;
      } else {
        message += err.message;
      }
    } else {
      message += inspect(err);
    }

    var newErr = new AssertionError({
      actual: err,
      expected: null,
      operator: 'ifError',
      message: message,
      stackStartFn: ifError
    }); // Make sure we actually have a stack trace!

    var origStack = err.stack;

    if (typeof origStack === 'string') {
      // This will remove any duplicated frames from the error frames taken
      // from within `ifError` and add the original error frames to the newly
      // created ones.
      var tmp2 = origStack.split('\n');
      tmp2.shift(); // Filter all frames existing in err.stack.

      var tmp1 = newErr.stack.split('\n');

      for (var i = 0; i < tmp2.length; i++) {
        // Find the first occurrence of the frame.
        var pos = tmp1.indexOf(tmp2[i]);

        if (pos !== -1) {
          // Only keep new frames.
          tmp1 = tmp1.slice(0, pos);
          break;
        }
      }

      newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
    }

    throw newErr;
  }
}; // Expose a strict only variant of assert


function strict() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  innerOk.apply(void 0, [strict, args.length].concat(args));
}

assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

/***/ }),

/***/ 5961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4155);
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _require = __webpack_require__(69),
    inspect = _require.inspect;

var _require2 = __webpack_require__(2136),
    ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat


function repeat(str, count) {
  count = Math.floor(count);
  if (str.length == 0 || count == 0) return '';
  var maxCount = str.length * count;
  count = Math.floor(Math.log(count) / Math.log(2));

  while (count) {
    str += str;
    count--;
  }

  str += str.substring(0, maxCount - str.length);
  return str;
}

var blue = '';
var green = '';
var red = '';
var white = '';
var kReadableOperator = {
  deepStrictEqual: 'Expected values to be strictly deep-equal:',
  strictEqual: 'Expected values to be strictly equal:',
  strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
  deepEqual: 'Expected values to be loosely deep-equal:',
  equal: 'Expected values to be loosely equal:',
  notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
  notStrictEqual: 'Expected "actual" to be strictly unequal to:',
  notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
  notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
  notEqual: 'Expected "actual" to be loosely unequal to:',
  notIdentical: 'Values identical but not reference-equal:'
}; // Comparing short primitives should just show === / !== instead of using the
// diff.

var kMaxShortLength = 10;

function copyError(source) {
  var keys = Object.keys(source);
  var target = Object.create(Object.getPrototypeOf(source));
  keys.forEach(function (key) {
    target[key] = source[key];
  });
  Object.defineProperty(target, 'message', {
    value: source.message
  });
  return target;
}

function inspectValue(val) {
  // The util.inspect default values could be changed. This makes sure the
  // error messages contain the necessary information nevertheless.
  return inspect(val, {
    compact: false,
    customInspect: false,
    depth: 1000,
    maxArrayLength: Infinity,
    // Assert compares only enumerable properties (with a few exceptions).
    showHidden: false,
    // Having a long line as error is better than wrapping the line for
    // comparison for now.
    // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
    // have meta information about the inspected properties (i.e., know where
    // in what line the property starts and ends).
    breakLength: Infinity,
    // Assert does not detect proxies currently.
    showProxy: false,
    sorted: true,
    // Inspect getters as we also check them when comparing entries.
    getters: true
  });
}

function createErrDiff(actual, expected, operator) {
  var other = '';
  var res = '';
  var lastPos = 0;
  var end = '';
  var skipped = false;
  var actualInspected = inspectValue(actual);
  var actualLines = actualInspected.split('\n');
  var expectedLines = inspectValue(expected).split('\n');
  var i = 0;
  var indicator = ''; // In case both values are objects explicitly mark them as not reference equal
  // for the `strictEqual` operator.

  if (operator === 'strictEqual' && _typeof(actual) === 'object' && _typeof(expected) === 'object' && actual !== null && expected !== null) {
    operator = 'strictEqualObject';
  } // If "actual" and "expected" fit on a single line and they are not strictly
  // equal, check further special handling.


  if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
    var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
    // kMaxShortLength and if neither is an object and at least one of them is
    // not `zero`, use the strict equal comparison to visualize the output.

    if (inputLength <= kMaxShortLength) {
      if ((_typeof(actual) !== 'object' || actual === null) && (_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) {
        // -0 === +0
        return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
      }
    } else if (operator !== 'strictEqualObject') {
      // If the stderr is a tty and the input length is lower than the current
      // columns per line, add a mismatch indicator below the output. If it is
      // not a tty, use a default value of 80 characters.
      var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;

      if (inputLength < maxLength) {
        while (actualLines[0][i] === expectedLines[0][i]) {
          i++;
        } // Ignore the first characters.


        if (i > 2) {
          // Add position indicator for the first mismatch in case it is a
          // single line and the input length is less than the column length.
          indicator = "\n  ".concat(repeat(' ', i), "^");
          i = 0;
        }
      }
    }
  } // Remove all ending lines that match (this optimizes the output for
  // readability by reducing the number of total changed lines).


  var a = actualLines[actualLines.length - 1];
  var b = expectedLines[expectedLines.length - 1];

  while (a === b) {
    if (i++ < 2) {
      end = "\n  ".concat(a).concat(end);
    } else {
      other = a;
    }

    actualLines.pop();
    expectedLines.pop();
    if (actualLines.length === 0 || expectedLines.length === 0) break;
    a = actualLines[actualLines.length - 1];
    b = expectedLines[expectedLines.length - 1];
  }

  var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
  // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })

  if (maxLines === 0) {
    // We have to get the result again. The lines were all removed before.
    var _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
    // TODO: Accept env to always show the full error.


    if (_actualLines.length > 30) {
      _actualLines[26] = "".concat(blue, "...").concat(white);

      while (_actualLines.length > 27) {
        _actualLines.pop();
      }
    }

    return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
  }

  if (i > 3) {
    end = "\n".concat(blue, "...").concat(white).concat(end);
    skipped = true;
  }

  if (other !== '') {
    end = "\n  ".concat(other).concat(end);
    other = '';
  }

  var printedLines = 0;
  var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
  var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");

  for (i = 0; i < maxLines; i++) {
    // Only extra expected lines exist
    var cur = i - lastPos;

    if (actualLines.length < i + 1) {
      // If the last diverging line is more than one line above and the
      // current line is at least line three, add some of the former lines and
      // also add dots to indicate skipped entries.
      if (cur > 1 && i > 2) {
        if (cur > 4) {
          res += "\n".concat(blue, "...").concat(white);
          skipped = true;
        } else if (cur > 3) {
          res += "\n  ".concat(expectedLines[i - 2]);
          printedLines++;
        }

        res += "\n  ".concat(expectedLines[i - 1]);
        printedLines++;
      } // Mark the current line as the last diverging one.


      lastPos = i; // Add the expected line to the cache.

      other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
      printedLines++; // Only extra actual lines exist
    } else if (expectedLines.length < i + 1) {
      // If the last diverging line is more than one line above and the
      // current line is at least line three, add some of the former lines and
      // also add dots to indicate skipped entries.
      if (cur > 1 && i > 2) {
        if (cur > 4) {
          res += "\n".concat(blue, "...").concat(white);
          skipped = true;
        } else if (cur > 3) {
          res += "\n  ".concat(actualLines[i - 2]);
          printedLines++;
        }

        res += "\n  ".concat(actualLines[i - 1]);
        printedLines++;
      } // Mark the current line as the last diverging one.


      lastPos = i; // Add the actual line to the result.

      res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
      printedLines++; // Lines diverge
    } else {
      var expectedLine = expectedLines[i];
      var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
      // a trailing comma. In that case it is actually identical and we should
      // mark it as such.

      var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
      // add a comma at the end of the actual line. Otherwise the output could
      // look weird as in:
      //
      //   [
      //     1         // No comma at the end!
      // +   2
      //   ]
      //

      if (divergingLines && endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
        divergingLines = false;
        actualLine += ',';
      }

      if (divergingLines) {
        // If the last diverging line is more than one line above and the
        // current line is at least line three, add some of the former lines and
        // also add dots to indicate skipped entries.
        if (cur > 1 && i > 2) {
          if (cur > 4) {
            res += "\n".concat(blue, "...").concat(white);
            skipped = true;
          } else if (cur > 3) {
            res += "\n  ".concat(actualLines[i - 2]);
            printedLines++;
          }

          res += "\n  ".concat(actualLines[i - 1]);
          printedLines++;
        } // Mark the current line as the last diverging one.


        lastPos = i; // Add the actual line to the result and cache the expected diverging
        // line so consecutive diverging lines show up as +++--- and not +-+-+-.

        res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
        other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
        printedLines += 2; // Lines are identical
      } else {
        // Add all cached information to the result before adding other things
        // and reset the cache.
        res += other;
        other = ''; // If the last diverging line is exactly one line above or if it is the
        // very first line, add the line to the result.

        if (cur === 1 || i === 0) {
          res += "\n  ".concat(actualLine);
          printedLines++;
        }
      }
    } // Inspected object to big (Show ~20 rows max)


    if (printedLines > 20 && i < maxLines - 2) {
      return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
  }

  return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}

var AssertionError =
/*#__PURE__*/
function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(options) {
    var _this;

    _classCallCheck(this, AssertionError);

    if (_typeof(options) !== 'object' || options === null) {
      throw new ERR_INVALID_ARG_TYPE('options', 'Object', options);
    }

    var message = options.message,
        operator = options.operator,
        stackStartFn = options.stackStartFn;
    var actual = options.actual,
        expected = options.expected;
    var limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 0;

    if (message != null) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, String(message)));
    } else {
      if (process.stderr && process.stderr.isTTY) {
        // Reset on each call to make sure we handle dynamically set environment
        // variables correct.
        if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
          blue = "\x1B[34m";
          green = "\x1B[32m";
          white = "\x1B[39m";
          red = "\x1B[31m";
        } else {
          blue = '';
          green = '';
          white = '';
          red = '';
        }
      } // Prevent the error stack from being visible by duplicating the error
      // in a very close way to the original in case both sides are actually
      // instances of Error.


      if (_typeof(actual) === 'object' && actual !== null && _typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
        actual = copyError(actual);
        expected = copyError(expected);
      }

      if (operator === 'deepStrictEqual' || operator === 'strictEqual') {
        _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, createErrDiff(actual, expected, operator)));
      } else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
        // In case the objects are equal but the operator requires unequal, show
        // the first object and say A equals B
        var base = kReadableOperator[operator];
        var res = inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.

        if (operator === 'notStrictEqual' && _typeof(actual) === 'object' && actual !== null) {
          base = kReadableOperator.notStrictEqualObject;
        } // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.


        if (res.length > 30) {
          res[26] = "".concat(blue, "...").concat(white);

          while (res.length > 27) {
            res.pop();
          }
        } // Only print a single input.


        if (res.length === 1) {
          _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
        } else {
          _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n")));
        }
      } else {
        var _res = inspectValue(actual);

        var other = '';
        var knownOperators = kReadableOperator[operator];

        if (operator === 'notDeepEqual' || operator === 'notEqual') {
          _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);

          if (_res.length > 1024) {
            _res = "".concat(_res.slice(0, 1021), "...");
          }
        } else {
          other = "".concat(inspectValue(expected));

          if (_res.length > 512) {
            _res = "".concat(_res.slice(0, 509), "...");
          }

          if (other.length > 512) {
            other = "".concat(other.slice(0, 509), "...");
          }

          if (operator === 'deepEqual' || operator === 'equal') {
            _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
          } else {
            other = " ".concat(operator, " ").concat(other);
          }
        }

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
      }
    }

    Error.stackTraceLimit = limit;
    _this.generatedMessage = !message;
    Object.defineProperty(_assertThisInitialized(_this), 'name', {
      value: 'AssertionError [ERR_ASSERTION]',
      enumerable: false,
      writable: true,
      configurable: true
    });
    _this.code = 'ERR_ASSERTION';
    _this.actual = actual;
    _this.expected = expected;
    _this.operator = operator;

    if (Error.captureStackTrace) {
      // eslint-disable-next-line no-restricted-syntax
      Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
    } // Create error message including the error code in the name.


    _this.stack; // Reset the name.

    _this.name = 'AssertionError';
    return _possibleConstructorReturn(_this);
  }

  _createClass(AssertionError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
    }
  }, {
    key: inspect.custom,
    value: function value(recurseTimes, ctx) {
      // This limits the `actual` and `expected` property default inspection to
      // the minimum depth. Otherwise those values would be too verbose compared
      // to the actual error message which contains a combined view of these two
      // input values.
      return inspect(this, _objectSpread({}, ctx, {
        customInspect: false,
        depth: 0
      }));
    }
  }]);

  return AssertionError;
}(_wrapNativeSuper(Error));

module.exports = AssertionError;

/***/ }),

/***/ 2136:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f

/* eslint node-core/documented-errors: "error" */

/* eslint node-core/alphabetize-errors: "error" */

/* eslint node-core/prefer-util-format-errors: "error" */
 // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var codes = {}; // Lazy loaded

var assert;
var util;

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inherits(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      var _this;

      _classCallCheck(this, NodeError);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
      _this.code = code;
      return _this;
    }

    return NodeError;
  }(Base);

  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  if (assert === undefined) assert = __webpack_require__(9282);
  assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'

  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } // TODO(BridgeAR): Improve the output by showing `null` and similar.


  msg += ". Received type ".concat(_typeof(actual));
  return msg;
}, TypeError);
createErrorType('ERR_INVALID_ARG_VALUE', function (name, value) {
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
  if (util === undefined) util = __webpack_require__(69);
  var inspected = util.inspect(value);

  if (inspected.length > 128) {
    inspected = "".concat(inspected.slice(0, 128), "...");
  }

  return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
createErrorType('ERR_INVALID_RETURN_VALUE', function (input, name, value) {
  var type;

  if (value && value.constructor && value.constructor.name) {
    type = "instance of ".concat(value.constructor.name);
  } else {
    type = "type ".concat(_typeof(value));
  }

  return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);
createErrorType('ERR_MISSING_ARGS', function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (assert === undefined) assert = __webpack_require__(9282);
  assert(args.length > 0, 'At least one arg needs to be specified');
  var msg = 'The ';
  var len = args.length;
  args = args.map(function (a) {
    return "\"".concat(a, "\"");
  });

  switch (len) {
    case 1:
      msg += "".concat(args[0], " argument");
      break;

    case 2:
      msg += "".concat(args[0], " and ").concat(args[1], " arguments");
      break;

    default:
      msg += args.slice(0, len - 1).join(', ');
      msg += ", and ".concat(args[len - 1], " arguments");
      break;
  }

  return "".concat(msg, " must be specified");
}, TypeError);
module.exports.codes = codes;

/***/ }),

/***/ 9158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9


function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var regexFlagsSupported = /a/g.flags !== undefined;

var arrayFromSet = function arrayFromSet(set) {
  var array = [];
  set.forEach(function (value) {
    return array.push(value);
  });
  return array;
};

var arrayFromMap = function arrayFromMap(map) {
  var array = [];
  map.forEach(function (value, key) {
    return array.push([key, value]);
  });
  return array;
};

var objectIs = Object.is ? Object.is : __webpack_require__(609);
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function () {
  return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__(360);

function uncurryThis(f) {
  return f.call.bind(f);
}

var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);

var _require$types = (__webpack_require__(69).types),
    isAnyArrayBuffer = _require$types.isAnyArrayBuffer,
    isArrayBufferView = _require$types.isArrayBufferView,
    isDate = _require$types.isDate,
    isMap = _require$types.isMap,
    isRegExp = _require$types.isRegExp,
    isSet = _require$types.isSet,
    isNativeError = _require$types.isNativeError,
    isBoxedPrimitive = _require$types.isBoxedPrimitive,
    isNumberObject = _require$types.isNumberObject,
    isStringObject = _require$types.isStringObject,
    isBooleanObject = _require$types.isBooleanObject,
    isBigIntObject = _require$types.isBigIntObject,
    isSymbolObject = _require$types.isSymbolObject,
    isFloat32Array = _require$types.isFloat32Array,
    isFloat64Array = _require$types.isFloat64Array;

function isNonIndex(key) {
  if (key.length === 0 || key.length > 10) return true;

  for (var i = 0; i < key.length; i++) {
    var code = key.charCodeAt(i);
    if (code < 48 || code > 57) return true;
  } // The maximum size for an array is 2 ** 32 -1.


  return key.length === 10 && key >= Math.pow(2, 32);
}

function getOwnNonIndexProperties(value) {
  return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */


function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }

  if (y < x) {
    return 1;
  }

  return 0;
}

var ONLY_ENUMERABLE = undefined;
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3; // Check if they have the same source and flags

function areSimilarRegExps(a, b) {
  return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}

function areSimilarFloatArrays(a, b) {
  if (a.byteLength !== b.byteLength) {
    return false;
  }

  for (var offset = 0; offset < a.byteLength; offset++) {
    if (a[offset] !== b[offset]) {
      return false;
    }
  }

  return true;
}

function areSimilarTypedArrays(a, b) {
  if (a.byteLength !== b.byteLength) {
    return false;
  }

  return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}

function areEqualArrayBuffers(buf1, buf2) {
  return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}

function isEqualBoxedPrimitive(val1, val2) {
  if (isNumberObject(val1)) {
    return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
  }

  if (isStringObject(val1)) {
    return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
  }

  if (isBooleanObject(val1)) {
    return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
  }

  if (isBigIntObject(val1)) {
    return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
  }

  return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.


function innerDeepEqual(val1, val2, strict, memos) {
  // All identical values are equivalent, as determined by ===.
  if (val1 === val2) {
    if (val1 !== 0) return true;
    return strict ? objectIs(val1, val2) : true;
  } // Check more closely if val1 and val2 are equal.


  if (strict) {
    if (_typeof(val1) !== 'object') {
      return typeof val1 === 'number' && numberIsNaN(val1) && numberIsNaN(val2);
    }

    if (_typeof(val2) !== 'object' || val1 === null || val2 === null) {
      return false;
    }

    if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) {
      return false;
    }
  } else {
    if (val1 === null || _typeof(val1) !== 'object') {
      if (val2 === null || _typeof(val2) !== 'object') {
        // eslint-disable-next-line eqeqeq
        return val1 == val2;
      }

      return false;
    }

    if (val2 === null || _typeof(val2) !== 'object') {
      return false;
    }
  }

  var val1Tag = objectToString(val1);
  var val2Tag = objectToString(val2);

  if (val1Tag !== val2Tag) {
    return false;
  }

  if (Array.isArray(val1)) {
    // Check for sparse arrays and general fast path
    if (val1.length !== val2.length) {
      return false;
    }

    var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
    var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
  } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
  // wan't to early return out of the rest of the checks. However we can check
  // if the second value is one of these values and the first isn't.


  if (val1Tag === '[object Object]') {
    // return keyCheck(val1, val2, strict, memos, kNoIterator);
    if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) {
      return false;
    }
  }

  if (isDate(val1)) {
    if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) {
      return false;
    }
  } else if (isRegExp(val1)) {
    if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) {
      return false;
    }
  } else if (isNativeError(val1) || val1 instanceof Error) {
    // Do not compare the stack as it might differ even though the error itself
    // is otherwise identical.
    if (val1.message !== val2.message || val1.name !== val2.name) {
      return false;
    }
  } else if (isArrayBufferView(val1)) {
    if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
      if (!areSimilarFloatArrays(val1, val2)) {
        return false;
      }
    } else if (!areSimilarTypedArrays(val1, val2)) {
      return false;
    } // Buffer.compare returns true, so val1.length === val2.length. If they both
    // only contain numeric keys, we don't need to exam further than checking
    // the symbols.


    var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);

    var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);

    if (_keys.length !== _keys2.length) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
  } else if (isSet(val1)) {
    if (!isSet(val2) || val1.size !== val2.size) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kIsSet);
  } else if (isMap(val1)) {
    if (!isMap(val2) || val1.size !== val2.size) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kIsMap);
  } else if (isAnyArrayBuffer(val1)) {
    if (!areEqualArrayBuffers(val1, val2)) {
      return false;
    }
  } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) {
    return false;
  }

  return keyCheck(val1, val2, strict, memos, kNoIterator);
}

function getEnumerables(val, keys) {
  return keys.filter(function (k) {
    return propertyIsEnumerable(val, k);
  });
}

function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
  // For all remaining Object pairs, including Array, objects and Maps,
  // equivalence is determined by having:
  // a) The same number of owned enumerable properties
  // b) The same set of keys/indexes (although not necessarily the same order)
  // c) Equivalent values for every corresponding key/index
  // d) For Sets and Maps, equal contents
  // Note: this accounts for both named and indexed properties on Arrays.
  if (arguments.length === 5) {
    aKeys = Object.keys(val1);
    var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.

    if (aKeys.length !== bKeys.length) {
      return false;
    }
  } // Cheap key test


  var i = 0;

  for (; i < aKeys.length; i++) {
    if (!hasOwnProperty(val2, aKeys[i])) {
      return false;
    }
  }

  if (strict && arguments.length === 5) {
    var symbolKeysA = objectGetOwnPropertySymbols(val1);

    if (symbolKeysA.length !== 0) {
      var count = 0;

      for (i = 0; i < symbolKeysA.length; i++) {
        var key = symbolKeysA[i];

        if (propertyIsEnumerable(val1, key)) {
          if (!propertyIsEnumerable(val2, key)) {
            return false;
          }

          aKeys.push(key);
          count++;
        } else if (propertyIsEnumerable(val2, key)) {
          return false;
        }
      }

      var symbolKeysB = objectGetOwnPropertySymbols(val2);

      if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) {
        return false;
      }
    } else {
      var _symbolKeysB = objectGetOwnPropertySymbols(val2);

      if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) {
        return false;
      }
    }
  }

  if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) {
    return true;
  } // Use memos to handle cycles.


  if (memos === undefined) {
    memos = {
      val1: new Map(),
      val2: new Map(),
      position: 0
    };
  } else {
    // We prevent up to two map.has(x) calls by directly retrieving the value
    // and checking for undefined. The map can only contain numbers, so it is
    // safe to check for undefined only.
    var val2MemoA = memos.val1.get(val1);

    if (val2MemoA !== undefined) {
      var val2MemoB = memos.val2.get(val2);

      if (val2MemoB !== undefined) {
        return val2MemoA === val2MemoB;
      }
    }

    memos.position++;
  }

  memos.val1.set(val1, memos.position);
  memos.val2.set(val2, memos.position);
  var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
  memos.val1.delete(val1);
  memos.val2.delete(val2);
  return areEq;
}

function setHasEqualElement(set, val1, strict, memo) {
  // Go looking.
  var setValues = arrayFromSet(set);

  for (var i = 0; i < setValues.length; i++) {
    var val2 = setValues[i];

    if (innerDeepEqual(val1, val2, strict, memo)) {
      // Remove the matching element to make sure we do not check that again.
      set.delete(val2);
      return true;
    }
  }

  return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').


function findLooseMatchingPrimitives(prim) {
  switch (_typeof(prim)) {
    case 'undefined':
      return null;

    case 'object':
      // Only pass in null as object!
      return undefined;

    case 'symbol':
      return false;

    case 'string':
      prim = +prim;
    // Loose equal entries exist only if the string is possible to convert to
    // a regular number and not NaN.
    // Fall through

    case 'number':
      if (numberIsNaN(prim)) {
        return false;
      }

  }

  return true;
}

function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) return altValue;
  return b.has(altValue) && !a.has(altValue);
}

function mapMightHaveLoosePrim(a, b, prim, item, memo) {
  var altValue = findLooseMatchingPrimitives(prim);

  if (altValue != null) {
    return altValue;
  }

  var curB = b.get(altValue);

  if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) {
    return false;
  }

  return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}

function setEquiv(a, b, strict, memo) {
  // This is a lazily initiated Set of entries which have to be compared
  // pairwise.
  var set = null;
  var aValues = arrayFromSet(a);

  for (var i = 0; i < aValues.length; i++) {
    var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
    // heavy sets but it is a minor slow down for primitives. As they are fast
    // to check this improves the worst case scenario instead.

    if (_typeof(val) === 'object' && val !== null) {
      if (set === null) {
        set = new Set();
      } // If the specified value doesn't exist in the second set its an not null
      // object (or non strict only: a not matching primitive) we'll need to go
      // hunting for something thats deep-(strict-)equal to it. To make this
      // O(n log n) complexity we have to copy these values in a new set first.


      set.add(val);
    } else if (!b.has(val)) {
      if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.

      if (!setMightHaveLoosePrim(a, b, val)) {
        return false;
      }

      if (set === null) {
        set = new Set();
      }

      set.add(val);
    }
  }

  if (set !== null) {
    var bValues = arrayFromSet(b);

    for (var _i = 0; _i < bValues.length; _i++) {
      var _val = bValues[_i]; // We have to check if a primitive value is already
      // matching and only if it's not, go hunting for it.

      if (_typeof(_val) === 'object' && _val !== null) {
        if (!setHasEqualElement(set, _val, strict, memo)) return false;
      } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) {
        return false;
      }
    }

    return set.size === 0;
  }

  return true;
}

function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
  // To be able to handle cases like:
  //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
  // ... we need to consider *all* matching keys, not just the first we find.
  var setValues = arrayFromSet(set);

  for (var i = 0; i < setValues.length; i++) {
    var key2 = setValues[i];

    if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
      set.delete(key2);
      return true;
    }
  }

  return false;
}

function mapEquiv(a, b, strict, memo) {
  var set = null;
  var aEntries = arrayFromMap(a);

  for (var i = 0; i < aEntries.length; i++) {
    var _aEntries$i = _slicedToArray(aEntries[i], 2),
        key = _aEntries$i[0],
        item1 = _aEntries$i[1];

    if (_typeof(key) === 'object' && key !== null) {
      if (set === null) {
        set = new Set();
      }

      set.add(key);
    } else {
      // By directly retrieving the value we prevent another b.has(key) check in
      // almost all possible cases.
      var item2 = b.get(key);

      if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
        if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
        // keys.

        if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;

        if (set === null) {
          set = new Set();
        }

        set.add(key);
      }
    }
  }

  if (set !== null) {
    var bEntries = arrayFromMap(b);

    for (var _i2 = 0; _i2 < bEntries.length; _i2++) {
      var _bEntries$_i = _slicedToArray(bEntries[_i2], 2),
          key = _bEntries$_i[0],
          item = _bEntries$_i[1];

      if (_typeof(key) === 'object' && key !== null) {
        if (!mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
      } else if (!strict && (!a.has(key) || !innerDeepEqual(a.get(key), item, false, memo)) && !mapHasEqualEntry(set, a, key, item, false, memo)) {
        return false;
      }
    }

    return set.size === 0;
  }

  return true;
}

function objEquiv(a, b, strict, keys, memos, iterationType) {
  // Sets and maps don't have their entries accessible via normal object
  // properties.
  var i = 0;

  if (iterationType === kIsSet) {
    if (!setEquiv(a, b, strict, memos)) {
      return false;
    }
  } else if (iterationType === kIsMap) {
    if (!mapEquiv(a, b, strict, memos)) {
      return false;
    }
  } else if (iterationType === kIsArray) {
    for (; i < a.length; i++) {
      if (hasOwnProperty(a, i)) {
        if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) {
          return false;
        }
      } else if (hasOwnProperty(b, i)) {
        return false;
      } else {
        // Array is sparse.
        var keysA = Object.keys(a);

        for (; i < keysA.length; i++) {
          var key = keysA[i];

          if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) {
            return false;
          }
        }

        if (keysA.length !== Object.keys(b).length) {
          return false;
        }

        return true;
      }
    }
  } // The pair must have equivalent values for every corresponding key.
  // Possibly expensive deep test:


  for (i = 0; i < keys.length; i++) {
    var _key = keys[i];

    if (!innerDeepEqual(a[_key], b[_key], strict, memos)) {
      return false;
    }
  }

  return true;
}

function isDeepEqual(val1, val2) {
  return innerDeepEqual(val1, val2, kLoose);
}

function isDeepStrictEqual(val1, val2) {
  return innerDeepEqual(val1, val2, kStrict);
}

module.exports = {
  isDeepEqual: isDeepEqual,
  isDeepStrictEqual: isDeepStrictEqual
};

/***/ }),

/***/ 2014:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 3875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__(2584);
var isGeneratorFunction = __webpack_require__(8662);
var whichTypedArray = __webpack_require__(6430);
var isTypedArray = __webpack_require__(5692);

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ 69:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(4155);
/* provided dependency */ var console = __webpack_require__(5108);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (({"VUE_APP_BASE_URL":"https://docs.dutypay.eu/design-system","VUE_APP_LIBRARY_VARIABLE":"ds","VUE_APP_API_DUTYPAY":"https://api.dutypay.eu","VUE_APP_HOST_SSO":"https://sso.dutypay.eu","NODE_ENV":"production","VUE_APP_I18N_LOCALE":"en","VUE_APP_I18N_FALLBACK_LOCALE":"en-US","BASE_URL":""}).NODE_DEBUG) {
  var debugEnv = ({"VUE_APP_BASE_URL":"https://docs.dutypay.eu/design-system","VUE_APP_LIBRARY_VARIABLE":"ds","VUE_APP_API_DUTYPAY":"https://api.dutypay.eu","VUE_APP_HOST_SSO":"https://sso.dutypay.eu","NODE_ENV":"production","VUE_APP_I18N_LOCALE":"en","VUE_APP_I18N_FALLBACK_LOCALE":"en-US","BASE_URL":""}).NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__(3875);

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(2014);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(5717);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 6126:
/***/ (function(module) {

/*!
 * assertion-error
 * Copyright(c) 2013 Jake Luer <jake@qualiancy.com>
 * MIT Licensed
 */

/*!
 * Return a function that will copy properties from
 * one object to another excluding any originally
 * listed. Returned function will create a new `{}`.
 *
 * @param {String} excluded properties ...
 * @return {Function}
 */

function exclude () {
  var excludes = [].slice.call(arguments);

  function excludeProps (res, obj) {
    Object.keys(obj).forEach(function (key) {
      if (!~excludes.indexOf(key)) res[key] = obj[key];
    });
  }

  return function extendExclude () {
    var args = [].slice.call(arguments)
      , i = 0
      , res = {};

    for (; i < args.length; i++) {
      excludeProps(res, args[i]);
    }

    return res;
  };
};

/*!
 * Primary Exports
 */

module.exports = AssertionError;

/**
 * ### AssertionError
 *
 * An extension of the JavaScript `Error` constructor for
 * assertion and validation scenarios.
 *
 * @param {String} message
 * @param {Object} properties to include (optional)
 * @param {callee} start stack function (optional)
 */

function AssertionError (message, _props, ssf) {
  var extend = exclude('name', 'message', 'stack', 'constructor', 'toJSON')
    , props = extend(_props || {});

  // default values
  this.message = message || 'Unspecified AssertionError';
  this.showDiff = false;

  // copy from properties
  for (var key in props) {
    this[key] = props[key];
  }

  // capture stack trace
  ssf = ssf || AssertionError;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, ssf);
  } else {
    try {
      throw new Error();
    } catch(e) {
      this.stack = e.stack;
    }
  }
}

/*!
 * Inherit from Error.prototype
 */

AssertionError.prototype = Object.create(Error.prototype);

/*!
 * Statically set name
 */

AssertionError.prototype.name = 'AssertionError';

/*!
 * Ensure correct constructor
 */

AssertionError.prototype.constructor = AssertionError;

/**
 * Allow errors to be converted to JSON for static transfer.
 *
 * @param {Boolean} include stack (default: `true`)
 * @return {Object} object that can be `JSON.stringify`
 */

AssertionError.prototype.toJSON = function (stack) {
  var extend = exclude('constructor', 'toJSON', 'stack')
    , props = extend({ name: this.name }, this);

  // include stack if exists and not turned off
  if (false !== stack && this.stack) {
    props.stack = this.stack;
  }

  return props;
};


/***/ }),

/***/ 9742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 1924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var callBind = __webpack_require__(5559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 5559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8612);
var GetIntrinsic = __webpack_require__(210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 4960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1928);


/***/ }),

/***/ 1928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var used = [];

/*!
 * Chai version
 */

exports.version = '4.3.3';

/*!
 * Assertion Error
 */

exports.AssertionError = __webpack_require__(6126);

/*!
 * Utils for plugins (not exported)
 */

var util = __webpack_require__(4920);

/**
 * # .use(function)
 *
 * Provides a way to extend the internals of Chai.
 *
 * @param {Function}
 * @returns {this} for chaining
 * @api public
 */

exports.use = function (fn) {
  if (!~used.indexOf(fn)) {
    fn(exports, util);
    used.push(fn);
  }

  return exports;
};

/*!
 * Utility Functions
 */

exports.util = util;

/*!
 * Configuration
 */

var config = __webpack_require__(4448);
exports.config = config;

/*!
 * Primary `Assertion` prototype
 */

var assertion = __webpack_require__(9507);
exports.use(assertion);

/*!
 * Core Assertions
 */

var core = __webpack_require__(7536);
exports.use(core);

/*!
 * Expect interface
 */

var expect = __webpack_require__(8007);
exports.use(expect);

/*!
 * Should interface
 */

var should = __webpack_require__(3292);
exports.use(should);

/*!
 * Assert interface
 */

var assert = __webpack_require__(2155);
exports.use(assert);


/***/ }),

/***/ 9507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var console = __webpack_require__(5108);
/*!
 * chai
 * http://chaijs.com
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var config = __webpack_require__(4448);

module.exports = function (_chai, util) {
  /*!
   * Module dependencies.
   */

  var AssertionError = _chai.AssertionError
    , flag = util.flag;

  /*!
   * Module export.
   */

  _chai.Assertion = Assertion;

  /*!
   * Assertion Constructor
   *
   * Creates object for chaining.
   *
   * `Assertion` objects contain metadata in the form of flags. Three flags can
   * be assigned during instantiation by passing arguments to this constructor:
   *
   * - `object`: This flag contains the target of the assertion. For example, in
   *   the assertion `expect(numKittens).to.equal(7);`, the `object` flag will
   *   contain `numKittens` so that the `equal` assertion can reference it when
   *   needed.
   *
   * - `message`: This flag contains an optional custom error message to be
   *   prepended to the error message that's generated by the assertion when it
   *   fails.
   *
   * - `ssfi`: This flag stands for "start stack function indicator". It
   *   contains a function reference that serves as the starting point for
   *   removing frames from the stack trace of the error that's created by the
   *   assertion when it fails. The goal is to provide a cleaner stack trace to
   *   end users by removing Chai's internal functions. Note that it only works
   *   in environments that support `Error.captureStackTrace`, and only when
   *   `Chai.config.includeStack` hasn't been set to `false`.
   *
   * - `lockSsfi`: This flag controls whether or not the given `ssfi` flag
   *   should retain its current value, even as assertions are chained off of
   *   this object. This is usually set to `true` when creating a new assertion
   *   from within another assertion. It's also temporarily set to `true` before
   *   an overwritten assertion gets called by the overwriting assertion.
   *
   * @param {Mixed} obj target of the assertion
   * @param {String} msg (optional) custom error message
   * @param {Function} ssfi (optional) starting point for removing stack frames
   * @param {Boolean} lockSsfi (optional) whether or not the ssfi flag is locked
   * @api private
   */

  function Assertion (obj, msg, ssfi, lockSsfi) {
    flag(this, 'ssfi', ssfi || Assertion);
    flag(this, 'lockSsfi', lockSsfi);
    flag(this, 'object', obj);
    flag(this, 'message', msg);

    return util.proxify(this);
  }

  Object.defineProperty(Assertion, 'includeStack', {
    get: function() {
      console.warn('Assertion.includeStack is deprecated, use chai.config.includeStack instead.');
      return config.includeStack;
    },
    set: function(value) {
      console.warn('Assertion.includeStack is deprecated, use chai.config.includeStack instead.');
      config.includeStack = value;
    }
  });

  Object.defineProperty(Assertion, 'showDiff', {
    get: function() {
      console.warn('Assertion.showDiff is deprecated, use chai.config.showDiff instead.');
      return config.showDiff;
    },
    set: function(value) {
      console.warn('Assertion.showDiff is deprecated, use chai.config.showDiff instead.');
      config.showDiff = value;
    }
  });

  Assertion.addProperty = function (name, fn) {
    util.addProperty(this.prototype, name, fn);
  };

  Assertion.addMethod = function (name, fn) {
    util.addMethod(this.prototype, name, fn);
  };

  Assertion.addChainableMethod = function (name, fn, chainingBehavior) {
    util.addChainableMethod(this.prototype, name, fn, chainingBehavior);
  };

  Assertion.overwriteProperty = function (name, fn) {
    util.overwriteProperty(this.prototype, name, fn);
  };

  Assertion.overwriteMethod = function (name, fn) {
    util.overwriteMethod(this.prototype, name, fn);
  };

  Assertion.overwriteChainableMethod = function (name, fn, chainingBehavior) {
    util.overwriteChainableMethod(this.prototype, name, fn, chainingBehavior);
  };

  /**
   * ### .assert(expression, message, negateMessage, expected, actual, showDiff)
   *
   * Executes an expression and check expectations. Throws AssertionError for reporting if test doesn't pass.
   *
   * @name assert
   * @param {Philosophical} expression to be tested
   * @param {String|Function} message or function that returns message to display if expression fails
   * @param {String|Function} negatedMessage or function that returns negatedMessage to display if negated expression fails
   * @param {Mixed} expected value (remember to check for negation)
   * @param {Mixed} actual (optional) will default to `this.obj`
   * @param {Boolean} showDiff (optional) when set to `true`, assert will display a diff in addition to the message if expression fails
   * @api private
   */

  Assertion.prototype.assert = function (expr, msg, negateMsg, expected, _actual, showDiff) {
    var ok = util.test(this, arguments);
    if (false !== showDiff) showDiff = true;
    if (undefined === expected && undefined === _actual) showDiff = false;
    if (true !== config.showDiff) showDiff = false;

    if (!ok) {
      msg = util.getMessage(this, arguments);
      var actual = util.getActual(this, arguments);
      var assertionErrorObjectProperties = {
          actual: actual
        , expected: expected
        , showDiff: showDiff
      };

      var operator = util.getOperator(this, arguments);
      if (operator) {
        assertionErrorObjectProperties.operator = operator;
      }

      throw new AssertionError(
        msg,
        assertionErrorObjectProperties,
        (config.includeStack) ? this.assert : flag(this, 'ssfi'));
    }
  };

  /*!
   * ### ._obj
   *
   * Quick reference to stored `actual` value for plugin developers.
   *
   * @api private
   */

  Object.defineProperty(Assertion.prototype, '_obj',
    { get: function () {
        return flag(this, 'object');
      }
    , set: function (val) {
        flag(this, 'object', val);
      }
  });
};


/***/ }),

/***/ 4448:
/***/ (function(module) {

module.exports = {

  /**
   * ### config.includeStack
   *
   * User configurable property, influences whether stack trace
   * is included in Assertion error message. Default of false
   * suppresses stack trace in the error message.
   *
   *     chai.config.includeStack = true;  // enable stack on error
   *
   * @param {Boolean}
   * @api public
   */

  includeStack: false,

  /**
   * ### config.showDiff
   *
   * User configurable property, influences whether or not
   * the `showDiff` flag should be included in the thrown
   * AssertionErrors. `false` will always be `false`; `true`
   * will be true when the assertion has requested a diff
   * be shown.
   *
   * @param {Boolean}
   * @api public
   */

  showDiff: true,

  /**
   * ### config.truncateThreshold
   *
   * User configurable property, sets length threshold for actual and
   * expected values in assertion errors. If this threshold is exceeded, for
   * example for large data structures, the value is replaced with something
   * like `[ Array(3) ]` or `{ Object (prop1, prop2) }`.
   *
   * Set it to zero if you want to disable truncating altogether.
   *
   * This is especially userful when doing assertions on arrays: having this
   * set to a reasonable large value makes the failure messages readily
   * inspectable.
   *
   *     chai.config.truncateThreshold = 0;  // disable truncating
   *
   * @param {Number}
   * @api public
   */

  truncateThreshold: 40,

  /**
   * ### config.useProxy
   *
   * User configurable property, defines if chai will use a Proxy to throw
   * an error when a non-existent property is read, which protects users
   * from typos when using property-based assertions.
   *
   * Set it to false if you want to disable this feature.
   *
   *     chai.config.useProxy = false;  // disable use of Proxy
   *
   * This feature is automatically disabled regardless of this config value
   * in environments that don't support proxies.
   *
   * @param {Boolean}
   * @api public
   */

  useProxy: true,

  /**
   * ### config.proxyExcludedKeys
   *
   * User configurable property, defines which properties should be ignored
   * instead of throwing an error if they do not exist on the assertion.
   * This is only applied if the environment Chai is running in supports proxies and
   * if the `useProxy` configuration setting is enabled.
   * By default, `then` and `inspect` will not throw an error if they do not exist on the
   * assertion object because the `.inspect` property is read by `util.inspect` (for example, when
   * using `console.log` on the assertion object) and `.then` is necessary for promise type-checking.
   *
   *     // By default these keys will not throw an error if they do not exist on the assertion object
   *     chai.config.proxyExcludedKeys = ['then', 'inspect'];
   *
   * @param {Array}
   * @api public
   */

  proxyExcludedKeys: ['then', 'catch', 'inspect', 'toJSON']
};


/***/ }),

/***/ 7536:
/***/ (function(module) {

/*!
 * chai
 * http://chaijs.com
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

module.exports = function (chai, _) {
  var Assertion = chai.Assertion
    , AssertionError = chai.AssertionError
    , flag = _.flag;

  /**
   * ### Language Chains
   *
   * The following are provided as chainable getters to improve the readability
   * of your assertions.
   *
   * **Chains**
   *
   * - to
   * - be
   * - been
   * - is
   * - that
   * - which
   * - and
   * - has
   * - have
   * - with
   * - at
   * - of
   * - same
   * - but
   * - does
   * - still
   * - also
   *
   * @name language chains
   * @namespace BDD
   * @api public
   */

  [ 'to', 'be', 'been', 'is'
  , 'and', 'has', 'have', 'with'
  , 'that', 'which', 'at', 'of'
  , 'same', 'but', 'does', 'still', "also" ].forEach(function (chain) {
    Assertion.addProperty(chain);
  });

  /**
   * ### .not
   *
   * Negates all assertions that follow in the chain.
   *
   *     expect(function () {}).to.not.throw();
   *     expect({a: 1}).to.not.have.property('b');
   *     expect([1, 2]).to.be.an('array').that.does.not.include(3);
   *
   * Just because you can negate any assertion with `.not` doesn't mean you
   * should. With great power comes great responsibility. It's often best to
   * assert that the one expected output was produced, rather than asserting
   * that one of countless unexpected outputs wasn't produced. See individual
   * assertions for specific guidance.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(2).to.not.equal(1); // Not recommended
   *
   * @name not
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('not', function () {
    flag(this, 'negate', true);
  });

  /**
   * ### .deep
   *
   * Causes all `.equal`, `.include`, `.members`, `.keys`, and `.property`
   * assertions that follow in the chain to use deep equality instead of strict
   * (`===`) equality. See the `deep-eql` project page for info on the deep
   * equality algorithm: https://github.com/chaijs/deep-eql.
   *
   *     // Target object deeply (but not strictly) equals `{a: 1}`
   *     expect({a: 1}).to.deep.equal({a: 1});
   *     expect({a: 1}).to.not.equal({a: 1});
   *
   *     // Target array deeply (but not strictly) includes `{a: 1}`
   *     expect([{a: 1}]).to.deep.include({a: 1});
   *     expect([{a: 1}]).to.not.include({a: 1});
   *
   *     // Target object deeply (but not strictly) includes `x: {a: 1}`
   *     expect({x: {a: 1}}).to.deep.include({x: {a: 1}});
   *     expect({x: {a: 1}}).to.not.include({x: {a: 1}});
   *
   *     // Target array deeply (but not strictly) has member `{a: 1}`
   *     expect([{a: 1}]).to.have.deep.members([{a: 1}]);
   *     expect([{a: 1}]).to.not.have.members([{a: 1}]);
   *
   *     // Target set deeply (but not strictly) has key `{a: 1}`
   *     expect(new Set([{a: 1}])).to.have.deep.keys([{a: 1}]);
   *     expect(new Set([{a: 1}])).to.not.have.keys([{a: 1}]);
   *
   *     // Target object deeply (but not strictly) has property `x: {a: 1}`
   *     expect({x: {a: 1}}).to.have.deep.property('x', {a: 1});
   *     expect({x: {a: 1}}).to.not.have.property('x', {a: 1});
   *
   * @name deep
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('deep', function () {
    flag(this, 'deep', true);
  });

  /**
   * ### .nested
   *
   * Enables dot- and bracket-notation in all `.property` and `.include`
   * assertions that follow in the chain.
   *
   *     expect({a: {b: ['x', 'y']}}).to.have.nested.property('a.b[1]');
   *     expect({a: {b: ['x', 'y']}}).to.nested.include({'a.b[1]': 'y'});
   *
   * If `.` or `[]` are part of an actual property name, they can be escaped by
   * adding two backslashes before them.
   *
   *     expect({'.a': {'[b]': 'x'}}).to.have.nested.property('\\.a.\\[b\\]');
   *     expect({'.a': {'[b]': 'x'}}).to.nested.include({'\\.a.\\[b\\]': 'x'});
   *
   * `.nested` cannot be combined with `.own`.
   *
   * @name nested
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('nested', function () {
    flag(this, 'nested', true);
  });

  /**
   * ### .own
   *
   * Causes all `.property` and `.include` assertions that follow in the chain
   * to ignore inherited properties.
   *
   *     Object.prototype.b = 2;
   *
   *     expect({a: 1}).to.have.own.property('a');
   *     expect({a: 1}).to.have.property('b');
   *     expect({a: 1}).to.not.have.own.property('b');
   *
   *     expect({a: 1}).to.own.include({a: 1});
   *     expect({a: 1}).to.include({b: 2}).but.not.own.include({b: 2});
   *
   * `.own` cannot be combined with `.nested`.
   *
   * @name own
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('own', function () {
    flag(this, 'own', true);
  });

  /**
   * ### .ordered
   *
   * Causes all `.members` assertions that follow in the chain to require that
   * members be in the same order.
   *
   *     expect([1, 2]).to.have.ordered.members([1, 2])
   *       .but.not.have.ordered.members([2, 1]);
   *
   * When `.include` and `.ordered` are combined, the ordering begins at the
   * start of both arrays.
   *
   *     expect([1, 2, 3]).to.include.ordered.members([1, 2])
   *       .but.not.include.ordered.members([2, 3]);
   *
   * @name ordered
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('ordered', function () {
    flag(this, 'ordered', true);
  });

  /**
   * ### .any
   *
   * Causes all `.keys` assertions that follow in the chain to only require that
   * the target have at least one of the given keys. This is the opposite of
   * `.all`, which requires that the target have all of the given keys.
   *
   *     expect({a: 1, b: 2}).to.not.have.any.keys('c', 'd');
   *
   * See the `.keys` doc for guidance on when to use `.any` or `.all`.
   *
   * @name any
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('any', function () {
    flag(this, 'any', true);
    flag(this, 'all', false);
  });

  /**
   * ### .all
   *
   * Causes all `.keys` assertions that follow in the chain to require that the
   * target have all of the given keys. This is the opposite of `.any`, which
   * only requires that the target have at least one of the given keys.
   *
   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b');
   *
   * Note that `.all` is used by default when neither `.all` nor `.any` are
   * added earlier in the chain. However, it's often best to add `.all` anyway
   * because it improves readability.
   *
   * See the `.keys` doc for guidance on when to use `.any` or `.all`.
   *
   * @name all
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('all', function () {
    flag(this, 'all', true);
    flag(this, 'any', false);
  });

  /**
   * ### .a(type[, msg])
   *
   * Asserts that the target's type is equal to the given string `type`. Types
   * are case insensitive. See the `type-detect` project page for info on the
   * type detection algorithm: https://github.com/chaijs/type-detect.
   *
   *     expect('foo').to.be.a('string');
   *     expect({a: 1}).to.be.an('object');
   *     expect(null).to.be.a('null');
   *     expect(undefined).to.be.an('undefined');
   *     expect(new Error).to.be.an('error');
   *     expect(Promise.resolve()).to.be.a('promise');
   *     expect(new Float32Array).to.be.a('float32array');
   *     expect(Symbol()).to.be.a('symbol');
   *
   * `.a` supports objects that have a custom type set via `Symbol.toStringTag`.
   *
   *     var myObj = {
   *       [Symbol.toStringTag]: 'myCustomType'
   *     };
   *
   *     expect(myObj).to.be.a('myCustomType').but.not.an('object');
   *
   * It's often best to use `.a` to check a target's type before making more
   * assertions on the same target. That way, you avoid unexpected behavior from
   * any assertion that does different things based on the target's type.
   *
   *     expect([1, 2, 3]).to.be.an('array').that.includes(2);
   *     expect([]).to.be.an('array').that.is.empty;
   *
   * Add `.not` earlier in the chain to negate `.a`. However, it's often best to
   * assert that the target is the expected type, rather than asserting that it
   * isn't one of many unexpected types.
   *
   *     expect('foo').to.be.a('string'); // Recommended
   *     expect('foo').to.not.be.an('array'); // Not recommended
   *
   * `.a` accepts an optional `msg` argument which is a custom error message to
   * show when the assertion fails. The message can also be given as the second
   * argument to `expect`.
   *
   *     expect(1).to.be.a('string', 'nooo why fail??');
   *     expect(1, 'nooo why fail??').to.be.a('string');
   *
   * `.a` can also be used as a language chain to improve the readability of
   * your assertions.
   *
   *     expect({b: 2}).to.have.a.property('b');
   *
   * The alias `.an` can be used interchangeably with `.a`.
   *
   * @name a
   * @alias an
   * @param {String} type
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function an (type, msg) {
    if (msg) flag(this, 'message', msg);
    type = type.toLowerCase();
    var obj = flag(this, 'object')
      , article = ~[ 'a', 'e', 'i', 'o', 'u' ].indexOf(type.charAt(0)) ? 'an ' : 'a ';

    this.assert(
        type === _.type(obj).toLowerCase()
      , 'expected #{this} to be ' + article + type
      , 'expected #{this} not to be ' + article + type
    );
  }

  Assertion.addChainableMethod('an', an);
  Assertion.addChainableMethod('a', an);

  /**
   * ### .include(val[, msg])
   *
   * When the target is a string, `.include` asserts that the given string `val`
   * is a substring of the target.
   *
   *     expect('foobar').to.include('foo');
   *
   * When the target is an array, `.include` asserts that the given `val` is a
   * member of the target.
   *
   *     expect([1, 2, 3]).to.include(2);
   *
   * When the target is an object, `.include` asserts that the given object
   * `val`'s properties are a subset of the target's properties.
   *
   *     expect({a: 1, b: 2, c: 3}).to.include({a: 1, b: 2});
   *
   * When the target is a Set or WeakSet, `.include` asserts that the given `val` is a
   * member of the target. SameValueZero equality algorithm is used.
   *
   *     expect(new Set([1, 2])).to.include(2);
   *
   * When the target is a Map, `.include` asserts that the given `val` is one of
   * the values of the target. SameValueZero equality algorithm is used.
   *
   *     expect(new Map([['a', 1], ['b', 2]])).to.include(2);
   *
   * Because `.include` does different things based on the target's type, it's
   * important to check the target's type before using `.include`. See the `.a`
   * doc for info on testing a target's type.
   *
   *     expect([1, 2, 3]).to.be.an('array').that.includes(2);
   *
   * By default, strict (`===`) equality is used to compare array members and
   * object properties. Add `.deep` earlier in the chain to use deep equality
   * instead (WeakSet targets are not supported). See the `deep-eql` project
   * page for info on the deep equality algorithm: https://github.com/chaijs/deep-eql.
   *
   *     // Target array deeply (but not strictly) includes `{a: 1}`
   *     expect([{a: 1}]).to.deep.include({a: 1});
   *     expect([{a: 1}]).to.not.include({a: 1});
   *
   *     // Target object deeply (but not strictly) includes `x: {a: 1}`
   *     expect({x: {a: 1}}).to.deep.include({x: {a: 1}});
   *     expect({x: {a: 1}}).to.not.include({x: {a: 1}});
   *
   * By default, all of the target's properties are searched when working with
   * objects. This includes properties that are inherited and/or non-enumerable.
   * Add `.own` earlier in the chain to exclude the target's inherited
   * properties from the search.
   *
   *     Object.prototype.b = 2;
   *
   *     expect({a: 1}).to.own.include({a: 1});
   *     expect({a: 1}).to.include({b: 2}).but.not.own.include({b: 2});
   *
   * Note that a target object is always only searched for `val`'s own
   * enumerable properties.
   *
   * `.deep` and `.own` can be combined.
   *
   *     expect({a: {b: 2}}).to.deep.own.include({a: {b: 2}});
   *
   * Add `.nested` earlier in the chain to enable dot- and bracket-notation when
   * referencing nested properties.
   *
   *     expect({a: {b: ['x', 'y']}}).to.nested.include({'a.b[1]': 'y'});
   *
   * If `.` or `[]` are part of an actual property name, they can be escaped by
   * adding two backslashes before them.
   *
   *     expect({'.a': {'[b]': 2}}).to.nested.include({'\\.a.\\[b\\]': 2});
   *
   * `.deep` and `.nested` can be combined.
   *
   *     expect({a: {b: [{c: 3}]}}).to.deep.nested.include({'a.b[0]': {c: 3}});
   *
   * `.own` and `.nested` cannot be combined.
   *
   * Add `.not` earlier in the chain to negate `.include`.
   *
   *     expect('foobar').to.not.include('taco');
   *     expect([1, 2, 3]).to.not.include(4);
   *
   * However, it's dangerous to negate `.include` when the target is an object.
   * The problem is that it creates uncertain expectations by asserting that the
   * target object doesn't have all of `val`'s key/value pairs but may or may
   * not have some of them. It's often best to identify the exact output that's
   * expected, and then write an assertion that only accepts that exact output.
   *
   * When the target object isn't even expected to have `val`'s keys, it's
   * often best to assert exactly that.
   *
   *     expect({c: 3}).to.not.have.any.keys('a', 'b'); // Recommended
   *     expect({c: 3}).to.not.include({a: 1, b: 2}); // Not recommended
   *
   * When the target object is expected to have `val`'s keys, it's often best to
   * assert that each of the properties has its expected value, rather than
   * asserting that each property doesn't have one of many unexpected values.
   *
   *     expect({a: 3, b: 4}).to.include({a: 3, b: 4}); // Recommended
   *     expect({a: 3, b: 4}).to.not.include({a: 1, b: 2}); // Not recommended
   *
   * `.include` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect([1, 2, 3]).to.include(4, 'nooo why fail??');
   *     expect([1, 2, 3], 'nooo why fail??').to.include(4);
   *
   * `.include` can also be used as a language chain, causing all `.members` and
   * `.keys` assertions that follow in the chain to require the target to be a
   * superset of the expected set, rather than an identical set. Note that
   * `.members` ignores duplicates in the subset when `.include` is added.
   *
   *     // Target object's keys are a superset of ['a', 'b'] but not identical
   *     expect({a: 1, b: 2, c: 3}).to.include.all.keys('a', 'b');
   *     expect({a: 1, b: 2, c: 3}).to.not.have.all.keys('a', 'b');
   *
   *     // Target array is a superset of [1, 2] but not identical
   *     expect([1, 2, 3]).to.include.members([1, 2]);
   *     expect([1, 2, 3]).to.not.have.members([1, 2]);
   *
   *     // Duplicates in the subset are ignored
   *     expect([1, 2, 3]).to.include.members([1, 2, 2, 2]);
   *
   * Note that adding `.any` earlier in the chain causes the `.keys` assertion
   * to ignore `.include`.
   *
   *     // Both assertions are identical
   *     expect({a: 1}).to.include.any.keys('a', 'b');
   *     expect({a: 1}).to.have.any.keys('a', 'b');
   *
   * The aliases `.includes`, `.contain`, and `.contains` can be used
   * interchangeably with `.include`.
   *
   * @name include
   * @alias contain
   * @alias includes
   * @alias contains
   * @param {Mixed} val
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function SameValueZero(a, b) {
    return (_.isNaN(a) && _.isNaN(b)) || a === b;
  }

  function includeChainingBehavior () {
    flag(this, 'contains', true);
  }

  function include (val, msg) {
    if (msg) flag(this, 'message', msg);

    var obj = flag(this, 'object')
      , objType = _.type(obj).toLowerCase()
      , flagMsg = flag(this, 'message')
      , negate = flag(this, 'negate')
      , ssfi = flag(this, 'ssfi')
      , isDeep = flag(this, 'deep')
      , descriptor = isDeep ? 'deep ' : '';

    flagMsg = flagMsg ? flagMsg + ': ' : '';

    var included = false;

    switch (objType) {
      case 'string':
        included = obj.indexOf(val) !== -1;
        break;

      case 'weakset':
        if (isDeep) {
          throw new AssertionError(
            flagMsg + 'unable to use .deep.include with WeakSet',
            undefined,
            ssfi
          );
        }

        included = obj.has(val);
        break;

      case 'map':
        var isEql = isDeep ? _.eql : SameValueZero;
        obj.forEach(function (item) {
          included = included || isEql(item, val);
        });
        break;

      case 'set':
        if (isDeep) {
          obj.forEach(function (item) {
            included = included || _.eql(item, val);
          });
        } else {
          included = obj.has(val);
        }
        break;

      case 'array':
        if (isDeep) {
          included = obj.some(function (item) {
            return _.eql(item, val);
          })
        } else {
          included = obj.indexOf(val) !== -1;
        }
        break;

      default:
        // This block is for asserting a subset of properties in an object.
        // `_.expectTypes` isn't used here because `.include` should work with
        // objects with a custom `@@toStringTag`.
        if (val !== Object(val)) {
          throw new AssertionError(
            flagMsg + 'the given combination of arguments ('
            + objType + ' and '
            + _.type(val).toLowerCase() + ')'
            + ' is invalid for this assertion. '
            + 'You can use an array, a map, an object, a set, a string, '
            + 'or a weakset instead of a '
            + _.type(val).toLowerCase(),
            undefined,
            ssfi
          );
        }

        var props = Object.keys(val)
          , firstErr = null
          , numErrs = 0;

        props.forEach(function (prop) {
          var propAssertion = new Assertion(obj);
          _.transferFlags(this, propAssertion, true);
          flag(propAssertion, 'lockSsfi', true);

          if (!negate || props.length === 1) {
            propAssertion.property(prop, val[prop]);
            return;
          }

          try {
            propAssertion.property(prop, val[prop]);
          } catch (err) {
            if (!_.checkError.compatibleConstructor(err, AssertionError)) {
              throw err;
            }
            if (firstErr === null) firstErr = err;
            numErrs++;
          }
        }, this);

        // When validating .not.include with multiple properties, we only want
        // to throw an assertion error if all of the properties are included,
        // in which case we throw the first property assertion error that we
        // encountered.
        if (negate && props.length > 1 && numErrs === props.length) {
          throw firstErr;
        }
        return;
    }

    // Assert inclusion in collection or substring in a string.
    this.assert(
      included
      , 'expected #{this} to ' + descriptor + 'include ' + _.inspect(val)
      , 'expected #{this} to not ' + descriptor + 'include ' + _.inspect(val));
  }

  Assertion.addChainableMethod('include', include, includeChainingBehavior);
  Assertion.addChainableMethod('contain', include, includeChainingBehavior);
  Assertion.addChainableMethod('contains', include, includeChainingBehavior);
  Assertion.addChainableMethod('includes', include, includeChainingBehavior);

  /**
   * ### .ok
   *
   * Asserts that the target is a truthy value (considered `true` in boolean context).
   * However, it's often best to assert that the target is strictly (`===`) or
   * deeply equal to its expected value.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.be.ok; // Not recommended
   *
   *     expect(true).to.be.true; // Recommended
   *     expect(true).to.be.ok; // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.ok`.
   *
   *     expect(0).to.equal(0); // Recommended
   *     expect(0).to.not.be.ok; // Not recommended
   *
   *     expect(false).to.be.false; // Recommended
   *     expect(false).to.not.be.ok; // Not recommended
   *
   *     expect(null).to.be.null; // Recommended
   *     expect(null).to.not.be.ok; // Not recommended
   *
   *     expect(undefined).to.be.undefined; // Recommended
   *     expect(undefined).to.not.be.ok; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(false, 'nooo why fail??').to.be.ok;
   *
   * @name ok
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('ok', function () {
    this.assert(
        flag(this, 'object')
      , 'expected #{this} to be truthy'
      , 'expected #{this} to be falsy');
  });

  /**
   * ### .true
   *
   * Asserts that the target is strictly (`===`) equal to `true`.
   *
   *     expect(true).to.be.true;
   *
   * Add `.not` earlier in the chain to negate `.true`. However, it's often best
   * to assert that the target is equal to its expected value, rather than not
   * equal to `true`.
   *
   *     expect(false).to.be.false; // Recommended
   *     expect(false).to.not.be.true; // Not recommended
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.true; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(false, 'nooo why fail??').to.be.true;
   *
   * @name true
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('true', function () {
    this.assert(
        true === flag(this, 'object')
      , 'expected #{this} to be true'
      , 'expected #{this} to be false'
      , flag(this, 'negate') ? false : true
    );
  });

  /**
   * ### .false
   *
   * Asserts that the target is strictly (`===`) equal to `false`.
   *
   *     expect(false).to.be.false;
   *
   * Add `.not` earlier in the chain to negate `.false`. However, it's often
   * best to assert that the target is equal to its expected value, rather than
   * not equal to `false`.
   *
   *     expect(true).to.be.true; // Recommended
   *     expect(true).to.not.be.false; // Not recommended
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.false; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(true, 'nooo why fail??').to.be.false;
   *
   * @name false
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('false', function () {
    this.assert(
        false === flag(this, 'object')
      , 'expected #{this} to be false'
      , 'expected #{this} to be true'
      , flag(this, 'negate') ? true : false
    );
  });

  /**
   * ### .null
   *
   * Asserts that the target is strictly (`===`) equal to `null`.
   *
   *     expect(null).to.be.null;
   *
   * Add `.not` earlier in the chain to negate `.null`. However, it's often best
   * to assert that the target is equal to its expected value, rather than not
   * equal to `null`.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.null; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(42, 'nooo why fail??').to.be.null;
   *
   * @name null
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('null', function () {
    this.assert(
        null === flag(this, 'object')
      , 'expected #{this} to be null'
      , 'expected #{this} not to be null'
    );
  });

  /**
   * ### .undefined
   *
   * Asserts that the target is strictly (`===`) equal to `undefined`.
   *
   *     expect(undefined).to.be.undefined;
   *
   * Add `.not` earlier in the chain to negate `.undefined`. However, it's often
   * best to assert that the target is equal to its expected value, rather than
   * not equal to `undefined`.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.undefined; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(42, 'nooo why fail??').to.be.undefined;
   *
   * @name undefined
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('undefined', function () {
    this.assert(
        undefined === flag(this, 'object')
      , 'expected #{this} to be undefined'
      , 'expected #{this} not to be undefined'
    );
  });

  /**
   * ### .NaN
   *
   * Asserts that the target is exactly `NaN`.
   *
   *     expect(NaN).to.be.NaN;
   *
   * Add `.not` earlier in the chain to negate `.NaN`. However, it's often best
   * to assert that the target is equal to its expected value, rather than not
   * equal to `NaN`.
   *
   *     expect('foo').to.equal('foo'); // Recommended
   *     expect('foo').to.not.be.NaN; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(42, 'nooo why fail??').to.be.NaN;
   *
   * @name NaN
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('NaN', function () {
    this.assert(
        _.isNaN(flag(this, 'object'))
        , 'expected #{this} to be NaN'
        , 'expected #{this} not to be NaN'
    );
  });

  /**
   * ### .exist
   *
   * Asserts that the target is not strictly (`===`) equal to either `null` or
   * `undefined`. However, it's often best to assert that the target is equal to
   * its expected value.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.exist; // Not recommended
   *
   *     expect(0).to.equal(0); // Recommended
   *     expect(0).to.exist; // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.exist`.
   *
   *     expect(null).to.be.null; // Recommended
   *     expect(null).to.not.exist; // Not recommended
   *
   *     expect(undefined).to.be.undefined; // Recommended
   *     expect(undefined).to.not.exist; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(null, 'nooo why fail??').to.exist;
   *
   * The alias `.exists` can be used interchangeably with `.exist`.
   *
   * @name exist
   * @alias exists
   * @namespace BDD
   * @api public
   */

  function assertExist () {
    var val = flag(this, 'object');
    this.assert(
        val !== null && val !== undefined
      , 'expected #{this} to exist'
      , 'expected #{this} to not exist'
    );
  }

  Assertion.addProperty('exist', assertExist);
  Assertion.addProperty('exists', assertExist);

  /**
   * ### .empty
   *
   * When the target is a string or array, `.empty` asserts that the target's
   * `length` property is strictly (`===`) equal to `0`.
   *
   *     expect([]).to.be.empty;
   *     expect('').to.be.empty;
   *
   * When the target is a map or set, `.empty` asserts that the target's `size`
   * property is strictly equal to `0`.
   *
   *     expect(new Set()).to.be.empty;
   *     expect(new Map()).to.be.empty;
   *
   * When the target is a non-function object, `.empty` asserts that the target
   * doesn't have any own enumerable properties. Properties with Symbol-based
   * keys are excluded from the count.
   *
   *     expect({}).to.be.empty;
   *
   * Because `.empty` does different things based on the target's type, it's
   * important to check the target's type before using `.empty`. See the `.a`
   * doc for info on testing a target's type.
   *
   *     expect([]).to.be.an('array').that.is.empty;
   *
   * Add `.not` earlier in the chain to negate `.empty`. However, it's often
   * best to assert that the target contains its expected number of values,
   * rather than asserting that it's not empty.
   *
   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
   *     expect([1, 2, 3]).to.not.be.empty; // Not recommended
   *
   *     expect(new Set([1, 2, 3])).to.have.property('size', 3); // Recommended
   *     expect(new Set([1, 2, 3])).to.not.be.empty; // Not recommended
   *
   *     expect(Object.keys({a: 1})).to.have.lengthOf(1); // Recommended
   *     expect({a: 1}).to.not.be.empty; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect([1, 2, 3], 'nooo why fail??').to.be.empty;
   *
   * @name empty
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('empty', function () {
    var val = flag(this, 'object')
      , ssfi = flag(this, 'ssfi')
      , flagMsg = flag(this, 'message')
      , itemsCount;

    flagMsg = flagMsg ? flagMsg + ': ' : '';

    switch (_.type(val).toLowerCase()) {
      case 'array':
      case 'string':
        itemsCount = val.length;
        break;
      case 'map':
      case 'set':
        itemsCount = val.size;
        break;
      case 'weakmap':
      case 'weakset':
        throw new AssertionError(
          flagMsg + '.empty was passed a weak collection',
          undefined,
          ssfi
        );
      case 'function':
        var msg = flagMsg + '.empty was passed a function ' + _.getName(val);
        throw new AssertionError(msg.trim(), undefined, ssfi);
      default:
        if (val !== Object(val)) {
          throw new AssertionError(
            flagMsg + '.empty was passed non-string primitive ' + _.inspect(val),
            undefined,
            ssfi
          );
        }
        itemsCount = Object.keys(val).length;
    }

    this.assert(
        0 === itemsCount
      , 'expected #{this} to be empty'
      , 'expected #{this} not to be empty'
    );
  });

  /**
   * ### .arguments
   *
   * Asserts that the target is an `arguments` object.
   *
   *     function test () {
   *       expect(arguments).to.be.arguments;
   *     }
   *
   *     test();
   *
   * Add `.not` earlier in the chain to negate `.arguments`. However, it's often
   * best to assert which type the target is expected to be, rather than
   * asserting that it’s not an `arguments` object.
   *
   *     expect('foo').to.be.a('string'); // Recommended
   *     expect('foo').to.not.be.arguments; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect({}, 'nooo why fail??').to.be.arguments;
   *
   * The alias `.Arguments` can be used interchangeably with `.arguments`.
   *
   * @name arguments
   * @alias Arguments
   * @namespace BDD
   * @api public
   */

  function checkArguments () {
    var obj = flag(this, 'object')
      , type = _.type(obj);
    this.assert(
        'Arguments' === type
      , 'expected #{this} to be arguments but got ' + type
      , 'expected #{this} to not be arguments'
    );
  }

  Assertion.addProperty('arguments', checkArguments);
  Assertion.addProperty('Arguments', checkArguments);

  /**
   * ### .equal(val[, msg])
   *
   * Asserts that the target is strictly (`===`) equal to the given `val`.
   *
   *     expect(1).to.equal(1);
   *     expect('foo').to.equal('foo');
   *
   * Add `.deep` earlier in the chain to use deep equality instead. See the
   * `deep-eql` project page for info on the deep equality algorithm:
   * https://github.com/chaijs/deep-eql.
   *
   *     // Target object deeply (but not strictly) equals `{a: 1}`
   *     expect({a: 1}).to.deep.equal({a: 1});
   *     expect({a: 1}).to.not.equal({a: 1});
   *
   *     // Target array deeply (but not strictly) equals `[1, 2]`
   *     expect([1, 2]).to.deep.equal([1, 2]);
   *     expect([1, 2]).to.not.equal([1, 2]);
   *
   * Add `.not` earlier in the chain to negate `.equal`. However, it's often
   * best to assert that the target is equal to its expected value, rather than
   * not equal to one of countless unexpected values.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.equal(2); // Not recommended
   *
   * `.equal` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect(1).to.equal(2, 'nooo why fail??');
   *     expect(1, 'nooo why fail??').to.equal(2);
   *
   * The aliases `.equals` and `eq` can be used interchangeably with `.equal`.
   *
   * @name equal
   * @alias equals
   * @alias eq
   * @param {Mixed} val
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertEqual (val, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object');
    if (flag(this, 'deep')) {
      var prevLockSsfi = flag(this, 'lockSsfi');
      flag(this, 'lockSsfi', true);
      this.eql(val);
      flag(this, 'lockSsfi', prevLockSsfi);
    } else {
      this.assert(
          val === obj
        , 'expected #{this} to equal #{exp}'
        , 'expected #{this} to not equal #{exp}'
        , val
        , this._obj
        , true
      );
    }
  }

  Assertion.addMethod('equal', assertEqual);
  Assertion.addMethod('equals', assertEqual);
  Assertion.addMethod('eq', assertEqual);

  /**
   * ### .eql(obj[, msg])
   *
   * Asserts that the target is deeply equal to the given `obj`. See the
   * `deep-eql` project page for info on the deep equality algorithm:
   * https://github.com/chaijs/deep-eql.
   *
   *     // Target object is deeply (but not strictly) equal to {a: 1}
   *     expect({a: 1}).to.eql({a: 1}).but.not.equal({a: 1});
   *
   *     // Target array is deeply (but not strictly) equal to [1, 2]
   *     expect([1, 2]).to.eql([1, 2]).but.not.equal([1, 2]);
   *
   * Add `.not` earlier in the chain to negate `.eql`. However, it's often best
   * to assert that the target is deeply equal to its expected value, rather
   * than not deeply equal to one of countless unexpected values.
   *
   *     expect({a: 1}).to.eql({a: 1}); // Recommended
   *     expect({a: 1}).to.not.eql({b: 2}); // Not recommended
   *
   * `.eql` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect({a: 1}).to.eql({b: 2}, 'nooo why fail??');
   *     expect({a: 1}, 'nooo why fail??').to.eql({b: 2});
   *
   * The alias `.eqls` can be used interchangeably with `.eql`.
   *
   * The `.deep.equal` assertion is almost identical to `.eql` but with one
   * difference: `.deep.equal` causes deep equality comparisons to also be used
   * for any other assertions that follow in the chain.
   *
   * @name eql
   * @alias eqls
   * @param {Mixed} obj
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertEql(obj, msg) {
    if (msg) flag(this, 'message', msg);
    this.assert(
        _.eql(obj, flag(this, 'object'))
      , 'expected #{this} to deeply equal #{exp}'
      , 'expected #{this} to not deeply equal #{exp}'
      , obj
      , this._obj
      , true
    );
  }

  Assertion.addMethod('eql', assertEql);
  Assertion.addMethod('eqls', assertEql);

  /**
   * ### .above(n[, msg])
   *
   * Asserts that the target is a number or a date greater than the given number or date `n` respectively.
   * However, it's often best to assert that the target is equal to its expected
   * value.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(2).to.be.above(1); // Not recommended
   *
   * Add `.lengthOf` earlier in the chain to assert that the target's `length`
   * or `size` is greater than the given number `n`.
   *
   *     expect('foo').to.have.lengthOf(3); // Recommended
   *     expect('foo').to.have.lengthOf.above(2); // Not recommended
   *
   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
   *     expect([1, 2, 3]).to.have.lengthOf.above(2); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.above`.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(1).to.not.be.above(2); // Not recommended
   *
   * `.above` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect(1).to.be.above(2, 'nooo why fail??');
   *     expect(1, 'nooo why fail??').to.be.above(2);
   *
   * The aliases `.gt` and `.greaterThan` can be used interchangeably with
   * `.above`.
   *
   * @name above
   * @alias gt
   * @alias greaterThan
   * @param {Number} n
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertAbove (n, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , doLength = flag(this, 'doLength')
      , flagMsg = flag(this, 'message')
      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
      , ssfi = flag(this, 'ssfi')
      , objType = _.type(obj).toLowerCase()
      , nType = _.type(n).toLowerCase()
      , errorMessage
      , shouldThrow = true;

    if (doLength && objType !== 'map' && objType !== 'set') {
      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
    }

    if (!doLength && (objType === 'date' && nType !== 'date')) {
      errorMessage = msgPrefix + 'the argument to above must be a date';
    } else if (nType !== 'number' && (doLength || objType === 'number')) {
      errorMessage = msgPrefix + 'the argument to above must be a number';
    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
    } else {
      shouldThrow = false;
    }

    if (shouldThrow) {
      throw new AssertionError(errorMessage, undefined, ssfi);
    }

    if (doLength) {
      var descriptor = 'length'
        , itemsCount;
      if (objType === 'map' || objType === 'set') {
        descriptor = 'size';
        itemsCount = obj.size;
      } else {
        itemsCount = obj.length;
      }
      this.assert(
          itemsCount > n
        , 'expected #{this} to have a ' + descriptor + ' above #{exp} but got #{act}'
        , 'expected #{this} to not have a ' + descriptor + ' above #{exp}'
        , n
        , itemsCount
      );
    } else {
      this.assert(
          obj > n
        , 'expected #{this} to be above #{exp}'
        , 'expected #{this} to be at most #{exp}'
        , n
      );
    }
  }

  Assertion.addMethod('above', assertAbove);
  Assertion.addMethod('gt', assertAbove);
  Assertion.addMethod('greaterThan', assertAbove);

  /**
   * ### .least(n[, msg])
   *
   * Asserts that the target is a number or a date greater than or equal to the given
   * number or date `n` respectively. However, it's often best to assert that the target is equal to
   * its expected value.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(2).to.be.at.least(1); // Not recommended
   *     expect(2).to.be.at.least(2); // Not recommended
   *
   * Add `.lengthOf` earlier in the chain to assert that the target's `length`
   * or `size` is greater than or equal to the given number `n`.
   *
   *     expect('foo').to.have.lengthOf(3); // Recommended
   *     expect('foo').to.have.lengthOf.at.least(2); // Not recommended
   *
   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
   *     expect([1, 2, 3]).to.have.lengthOf.at.least(2); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.least`.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.at.least(2); // Not recommended
   *
   * `.least` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect(1).to.be.at.least(2, 'nooo why fail??');
   *     expect(1, 'nooo why fail??').to.be.at.least(2);
   *
   * The aliases `.gte` and `.greaterThanOrEqual` can be used interchangeably with
   * `.least`.
   *
   * @name least
   * @alias gte
   * @alias greaterThanOrEqual
   * @param {Number} n
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertLeast (n, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , doLength = flag(this, 'doLength')
      , flagMsg = flag(this, 'message')
      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
      , ssfi = flag(this, 'ssfi')
      , objType = _.type(obj).toLowerCase()
      , nType = _.type(n).toLowerCase()
      , errorMessage
      , shouldThrow = true;

    if (doLength && objType !== 'map' && objType !== 'set') {
      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
    }

    if (!doLength && (objType === 'date' && nType !== 'date')) {
      errorMessage = msgPrefix + 'the argument to least must be a date';
    } else if (nType !== 'number' && (doLength || objType === 'number')) {
      errorMessage = msgPrefix + 'the argument to least must be a number';
    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
    } else {
      shouldThrow = false;
    }

    if (shouldThrow) {
      throw new AssertionError(errorMessage, undefined, ssfi);
    }

    if (doLength) {
      var descriptor = 'length'
        , itemsCount;
      if (objType === 'map' || objType === 'set') {
        descriptor = 'size';
        itemsCount = obj.size;
      } else {
        itemsCount = obj.length;
      }
      this.assert(
          itemsCount >= n
        , 'expected #{this} to have a ' + descriptor + ' at least #{exp} but got #{act}'
        , 'expected #{this} to have a ' + descriptor + ' below #{exp}'
        , n
        , itemsCount
      );
    } else {
      this.assert(
          obj >= n
        , 'expected #{this} to be at least #{exp}'
        , 'expected #{this} to be below #{exp}'
        , n
      );
    }
  }

  Assertion.addMethod('least', assertLeast);
  Assertion.addMethod('gte', assertLeast);
  Assertion.addMethod('greaterThanOrEqual', assertLeast);

  /**
   * ### .below(n[, msg])
   *
   * Asserts that the target is a number or a date less than the given number or date `n` respectively.
   * However, it's often best to assert that the target is equal to its expected
   * value.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.be.below(2); // Not recommended
   *
   * Add `.lengthOf` earlier in the chain to assert that the target's `length`
   * or `size` is less than the given number `n`.
   *
   *     expect('foo').to.have.lengthOf(3); // Recommended
   *     expect('foo').to.have.lengthOf.below(4); // Not recommended
   *
   *     expect([1, 2, 3]).to.have.length(3); // Recommended
   *     expect([1, 2, 3]).to.have.lengthOf.below(4); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.below`.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(2).to.not.be.below(1); // Not recommended
   *
   * `.below` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect(2).to.be.below(1, 'nooo why fail??');
   *     expect(2, 'nooo why fail??').to.be.below(1);
   *
   * The aliases `.lt` and `.lessThan` can be used interchangeably with
   * `.below`.
   *
   * @name below
   * @alias lt
   * @alias lessThan
   * @param {Number} n
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertBelow (n, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , doLength = flag(this, 'doLength')
      , flagMsg = flag(this, 'message')
      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
      , ssfi = flag(this, 'ssfi')
      , objType = _.type(obj).toLowerCase()
      , nType = _.type(n).toLowerCase()
      , errorMessage
      , shouldThrow = true;

    if (doLength && objType !== 'map' && objType !== 'set') {
      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
    }

    if (!doLength && (objType === 'date' && nType !== 'date')) {
      errorMessage = msgPrefix + 'the argument to below must be a date';
    } else if (nType !== 'number' && (doLength || objType === 'number')) {
      errorMessage = msgPrefix + 'the argument to below must be a number';
    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
    } else {
      shouldThrow = false;
    }

    if (shouldThrow) {
      throw new AssertionError(errorMessage, undefined, ssfi);
    }

    if (doLength) {
      var descriptor = 'length'
        , itemsCount;
      if (objType === 'map' || objType === 'set') {
        descriptor = 'size';
        itemsCount = obj.size;
      } else {
        itemsCount = obj.length;
      }
      this.assert(
          itemsCount < n
        , 'expected #{this} to have a ' + descriptor + ' below #{exp} but got #{act}'
        , 'expected #{this} to not have a ' + descriptor + ' below #{exp}'
        , n
        , itemsCount
      );
    } else {
      this.assert(
          obj < n
        , 'expected #{this} to be below #{exp}'
        , 'expected #{this} to be at least #{exp}'
        , n
      );
    }
  }

  Assertion.addMethod('below', assertBelow);
  Assertion.addMethod('lt', assertBelow);
  Assertion.addMethod('lessThan', assertBelow);

  /**
   * ### .most(n[, msg])
   *
   * Asserts that the target is a number or a date less than or equal to the given number
   * or date `n` respectively. However, it's often best to assert that the target is equal to its
   * expected value.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.be.at.most(2); // Not recommended
   *     expect(1).to.be.at.most(1); // Not recommended
   *
   * Add `.lengthOf` earlier in the chain to assert that the target's `length`
   * or `size` is less than or equal to the given number `n`.
   *
   *     expect('foo').to.have.lengthOf(3); // Recommended
   *     expect('foo').to.have.lengthOf.at.most(4); // Not recommended
   *
   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
   *     expect([1, 2, 3]).to.have.lengthOf.at.most(4); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.most`.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(2).to.not.be.at.most(1); // Not recommended
   *
   * `.most` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect(2).to.be.at.most(1, 'nooo why fail??');
   *     expect(2, 'nooo why fail??').to.be.at.most(1);
   *
   * The aliases `.lte` and `.lessThanOrEqual` can be used interchangeably with
   * `.most`.
   *
   * @name most
   * @alias lte
   * @alias lessThanOrEqual
   * @param {Number} n
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertMost (n, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , doLength = flag(this, 'doLength')
      , flagMsg = flag(this, 'message')
      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
      , ssfi = flag(this, 'ssfi')
      , objType = _.type(obj).toLowerCase()
      , nType = _.type(n).toLowerCase()
      , errorMessage
      , shouldThrow = true;

    if (doLength && objType !== 'map' && objType !== 'set') {
      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
    }

    if (!doLength && (objType === 'date' && nType !== 'date')) {
      errorMessage = msgPrefix + 'the argument to most must be a date';
    } else if (nType !== 'number' && (doLength || objType === 'number')) {
      errorMessage = msgPrefix + 'the argument to most must be a number';
    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
    } else {
      shouldThrow = false;
    }

    if (shouldThrow) {
      throw new AssertionError(errorMessage, undefined, ssfi);
    }

    if (doLength) {
      var descriptor = 'length'
        , itemsCount;
      if (objType === 'map' || objType === 'set') {
        descriptor = 'size';
        itemsCount = obj.size;
      } else {
        itemsCount = obj.length;
      }
      this.assert(
          itemsCount <= n
        , 'expected #{this} to have a ' + descriptor + ' at most #{exp} but got #{act}'
        , 'expected #{this} to have a ' + descriptor + ' above #{exp}'
        , n
        , itemsCount
      );
    } else {
      this.assert(
          obj <= n
        , 'expected #{this} to be at most #{exp}'
        , 'expected #{this} to be above #{exp}'
        , n
      );
    }
  }

  Assertion.addMethod('most', assertMost);
  Assertion.addMethod('lte', assertMost);
  Assertion.addMethod('lessThanOrEqual', assertMost);

  /**
   * ### .within(start, finish[, msg])
   *
   * Asserts that the target is a number or a date greater than or equal to the given
   * number or date `start`, and less than or equal to the given number or date `finish` respectively.
   * However, it's often best to assert that the target is equal to its expected
   * value.
   *
   *     expect(2).to.equal(2); // Recommended
   *     expect(2).to.be.within(1, 3); // Not recommended
   *     expect(2).to.be.within(2, 3); // Not recommended
   *     expect(2).to.be.within(1, 2); // Not recommended
   *
   * Add `.lengthOf` earlier in the chain to assert that the target's `length`
   * or `size` is greater than or equal to the given number `start`, and less
   * than or equal to the given number `finish`.
   *
   *     expect('foo').to.have.lengthOf(3); // Recommended
   *     expect('foo').to.have.lengthOf.within(2, 4); // Not recommended
   *
   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
   *     expect([1, 2, 3]).to.have.lengthOf.within(2, 4); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.within`.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.within(2, 4); // Not recommended
   *
   * `.within` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect(4).to.be.within(1, 3, 'nooo why fail??');
   *     expect(4, 'nooo why fail??').to.be.within(1, 3);
   *
   * @name within
   * @param {Number} start lower bound inclusive
   * @param {Number} finish upper bound inclusive
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  Assertion.addMethod('within', function (start, finish, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , doLength = flag(this, 'doLength')
      , flagMsg = flag(this, 'message')
      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
      , ssfi = flag(this, 'ssfi')
      , objType = _.type(obj).toLowerCase()
      , startType = _.type(start).toLowerCase()
      , finishType = _.type(finish).toLowerCase()
      , errorMessage
      , shouldThrow = true
      , range = (startType === 'date' && finishType === 'date')
          ? start.toISOString() + '..' + finish.toISOString()
          : start + '..' + finish;

    if (doLength && objType !== 'map' && objType !== 'set') {
      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
    }

    if (!doLength && (objType === 'date' && (startType !== 'date' || finishType !== 'date'))) {
      errorMessage = msgPrefix + 'the arguments to within must be dates';
    } else if ((startType !== 'number' || finishType !== 'number') && (doLength || objType === 'number')) {
      errorMessage = msgPrefix + 'the arguments to within must be numbers';
    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
    } else {
      shouldThrow = false;
    }

    if (shouldThrow) {
      throw new AssertionError(errorMessage, undefined, ssfi);
    }

    if (doLength) {
      var descriptor = 'length'
        , itemsCount;
      if (objType === 'map' || objType === 'set') {
        descriptor = 'size';
        itemsCount = obj.size;
      } else {
        itemsCount = obj.length;
      }
      this.assert(
          itemsCount >= start && itemsCount <= finish
        , 'expected #{this} to have a ' + descriptor + ' within ' + range
        , 'expected #{this} to not have a ' + descriptor + ' within ' + range
      );
    } else {
      this.assert(
          obj >= start && obj <= finish
        , 'expected #{this} to be within ' + range
        , 'expected #{this} to not be within ' + range
      );
    }
  });

  /**
   * ### .instanceof(constructor[, msg])
   *
   * Asserts that the target is an instance of the given `constructor`.
   *
   *     function Cat () { }
   *
   *     expect(new Cat()).to.be.an.instanceof(Cat);
   *     expect([1, 2]).to.be.an.instanceof(Array);
   *
   * Add `.not` earlier in the chain to negate `.instanceof`.
   *
   *     expect({a: 1}).to.not.be.an.instanceof(Array);
   *
   * `.instanceof` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect(1).to.be.an.instanceof(Array, 'nooo why fail??');
   *     expect(1, 'nooo why fail??').to.be.an.instanceof(Array);
   *
   * Due to limitations in ES5, `.instanceof` may not always work as expected
   * when using a transpiler such as Babel or TypeScript. In particular, it may
   * produce unexpected results when subclassing built-in object such as
   * `Array`, `Error`, and `Map`. See your transpiler's docs for details:
   *
   * - ([Babel](https://babeljs.io/docs/usage/caveats/#classes))
   * - ([TypeScript](https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work))
   *
   * The alias `.instanceOf` can be used interchangeably with `.instanceof`.
   *
   * @name instanceof
   * @param {Constructor} constructor
   * @param {String} msg _optional_
   * @alias instanceOf
   * @namespace BDD
   * @api public
   */

  function assertInstanceOf (constructor, msg) {
    if (msg) flag(this, 'message', msg);

    var target = flag(this, 'object')
    var ssfi = flag(this, 'ssfi');
    var flagMsg = flag(this, 'message');

    try {
      var isInstanceOf = target instanceof constructor;
    } catch (err) {
      if (err instanceof TypeError) {
        flagMsg = flagMsg ? flagMsg + ': ' : '';
        throw new AssertionError(
          flagMsg + 'The instanceof assertion needs a constructor but '
            + _.type(constructor) + ' was given.',
          undefined,
          ssfi
        );
      }
      throw err;
    }

    var name = _.getName(constructor);
    if (name === null) {
      name = 'an unnamed constructor';
    }

    this.assert(
        isInstanceOf
      , 'expected #{this} to be an instance of ' + name
      , 'expected #{this} to not be an instance of ' + name
    );
  };

  Assertion.addMethod('instanceof', assertInstanceOf);
  Assertion.addMethod('instanceOf', assertInstanceOf);

  /**
   * ### .property(name[, val[, msg]])
   *
   * Asserts that the target has a property with the given key `name`.
   *
   *     expect({a: 1}).to.have.property('a');
   *
   * When `val` is provided, `.property` also asserts that the property's value
   * is equal to the given `val`.
   *
   *     expect({a: 1}).to.have.property('a', 1);
   *
   * By default, strict (`===`) equality is used. Add `.deep` earlier in the
   * chain to use deep equality instead. See the `deep-eql` project page for
   * info on the deep equality algorithm: https://github.com/chaijs/deep-eql.
   *
   *     // Target object deeply (but not strictly) has property `x: {a: 1}`
   *     expect({x: {a: 1}}).to.have.deep.property('x', {a: 1});
   *     expect({x: {a: 1}}).to.not.have.property('x', {a: 1});
   *
   * The target's enumerable and non-enumerable properties are always included
   * in the search. By default, both own and inherited properties are included.
   * Add `.own` earlier in the chain to exclude inherited properties from the
   * search.
   *
   *     Object.prototype.b = 2;
   *
   *     expect({a: 1}).to.have.own.property('a');
   *     expect({a: 1}).to.have.own.property('a', 1);
   *     expect({a: 1}).to.have.property('b');
   *     expect({a: 1}).to.not.have.own.property('b');
   *
   * `.deep` and `.own` can be combined.
   *
   *     expect({x: {a: 1}}).to.have.deep.own.property('x', {a: 1});
   *
   * Add `.nested` earlier in the chain to enable dot- and bracket-notation when
   * referencing nested properties.
   *
   *     expect({a: {b: ['x', 'y']}}).to.have.nested.property('a.b[1]');
   *     expect({a: {b: ['x', 'y']}}).to.have.nested.property('a.b[1]', 'y');
   *
   * If `.` or `[]` are part of an actual property name, they can be escaped by
   * adding two backslashes before them.
   *
   *     expect({'.a': {'[b]': 'x'}}).to.have.nested.property('\\.a.\\[b\\]');
   *
   * `.deep` and `.nested` can be combined.
   *
   *     expect({a: {b: [{c: 3}]}})
   *       .to.have.deep.nested.property('a.b[0]', {c: 3});
   *
   * `.own` and `.nested` cannot be combined.
   *
   * Add `.not` earlier in the chain to negate `.property`.
   *
   *     expect({a: 1}).to.not.have.property('b');
   *
   * However, it's dangerous to negate `.property` when providing `val`. The
   * problem is that it creates uncertain expectations by asserting that the
   * target either doesn't have a property with the given key `name`, or that it
   * does have a property with the given key `name` but its value isn't equal to
   * the given `val`. It's often best to identify the exact output that's
   * expected, and then write an assertion that only accepts that exact output.
   *
   * When the target isn't expected to have a property with the given key
   * `name`, it's often best to assert exactly that.
   *
   *     expect({b: 2}).to.not.have.property('a'); // Recommended
   *     expect({b: 2}).to.not.have.property('a', 1); // Not recommended
   *
   * When the target is expected to have a property with the given key `name`,
   * it's often best to assert that the property has its expected value, rather
   * than asserting that it doesn't have one of many unexpected values.
   *
   *     expect({a: 3}).to.have.property('a', 3); // Recommended
   *     expect({a: 3}).to.not.have.property('a', 1); // Not recommended
   *
   * `.property` changes the target of any assertions that follow in the chain
   * to be the value of the property from the original target object.
   *
   *     expect({a: 1}).to.have.property('a').that.is.a('number');
   *
   * `.property` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`. When not providing `val`, only use the
   * second form.
   *
   *     // Recommended
   *     expect({a: 1}).to.have.property('a', 2, 'nooo why fail??');
   *     expect({a: 1}, 'nooo why fail??').to.have.property('a', 2);
   *     expect({a: 1}, 'nooo why fail??').to.have.property('b');
   *
   *     // Not recommended
   *     expect({a: 1}).to.have.property('b', undefined, 'nooo why fail??');
   *
   * The above assertion isn't the same thing as not providing `val`. Instead,
   * it's asserting that the target object has a `b` property that's equal to
   * `undefined`.
   *
   * The assertions `.ownProperty` and `.haveOwnProperty` can be used
   * interchangeably with `.own.property`.
   *
   * @name property
   * @param {String} name
   * @param {Mixed} val (optional)
   * @param {String} msg _optional_
   * @returns value of property for chaining
   * @namespace BDD
   * @api public
   */

  function assertProperty (name, val, msg) {
    if (msg) flag(this, 'message', msg);

    var isNested = flag(this, 'nested')
      , isOwn = flag(this, 'own')
      , flagMsg = flag(this, 'message')
      , obj = flag(this, 'object')
      , ssfi = flag(this, 'ssfi')
      , nameType = typeof name;

    flagMsg = flagMsg ? flagMsg + ': ' : '';

    if (isNested) {
      if (nameType !== 'string') {
        throw new AssertionError(
          flagMsg + 'the argument to property must be a string when using nested syntax',
          undefined,
          ssfi
        );
      }
    } else {
      if (nameType !== 'string' && nameType !== 'number' && nameType !== 'symbol') {
        throw new AssertionError(
          flagMsg + 'the argument to property must be a string, number, or symbol',
          undefined,
          ssfi
        );
      }
    }

    if (isNested && isOwn) {
      throw new AssertionError(
        flagMsg + 'The "nested" and "own" flags cannot be combined.',
        undefined,
        ssfi
      );
    }

    if (obj === null || obj === undefined) {
      throw new AssertionError(
        flagMsg + 'Target cannot be null or undefined.',
        undefined,
        ssfi
      );
    }

    var isDeep = flag(this, 'deep')
      , negate = flag(this, 'negate')
      , pathInfo = isNested ? _.getPathInfo(obj, name) : null
      , value = isNested ? pathInfo.value : obj[name];

    var descriptor = '';
    if (isDeep) descriptor += 'deep ';
    if (isOwn) descriptor += 'own ';
    if (isNested) descriptor += 'nested ';
    descriptor += 'property ';

    var hasProperty;
    if (isOwn) hasProperty = Object.prototype.hasOwnProperty.call(obj, name);
    else if (isNested) hasProperty = pathInfo.exists;
    else hasProperty = _.hasProperty(obj, name);

    // When performing a negated assertion for both name and val, merely having
    // a property with the given name isn't enough to cause the assertion to
    // fail. It must both have a property with the given name, and the value of
    // that property must equal the given val. Therefore, skip this assertion in
    // favor of the next.
    if (!negate || arguments.length === 1) {
      this.assert(
          hasProperty
        , 'expected #{this} to have ' + descriptor + _.inspect(name)
        , 'expected #{this} to not have ' + descriptor + _.inspect(name));
    }

    if (arguments.length > 1) {
      this.assert(
          hasProperty && (isDeep ? _.eql(val, value) : val === value)
        , 'expected #{this} to have ' + descriptor + _.inspect(name) + ' of #{exp}, but got #{act}'
        , 'expected #{this} to not have ' + descriptor + _.inspect(name) + ' of #{act}'
        , val
        , value
      );
    }

    flag(this, 'object', value);
  }

  Assertion.addMethod('property', assertProperty);

  function assertOwnProperty (name, value, msg) {
    flag(this, 'own', true);
    assertProperty.apply(this, arguments);
  }

  Assertion.addMethod('ownProperty', assertOwnProperty);
  Assertion.addMethod('haveOwnProperty', assertOwnProperty);

  /**
   * ### .ownPropertyDescriptor(name[, descriptor[, msg]])
   *
   * Asserts that the target has its own property descriptor with the given key
   * `name`. Enumerable and non-enumerable properties are included in the
   * search.
   *
   *     expect({a: 1}).to.have.ownPropertyDescriptor('a');
   *
   * When `descriptor` is provided, `.ownPropertyDescriptor` also asserts that
   * the property's descriptor is deeply equal to the given `descriptor`. See
   * the `deep-eql` project page for info on the deep equality algorithm:
   * https://github.com/chaijs/deep-eql.
   *
   *     expect({a: 1}).to.have.ownPropertyDescriptor('a', {
   *       configurable: true,
   *       enumerable: true,
   *       writable: true,
   *       value: 1,
   *     });
   *
   * Add `.not` earlier in the chain to negate `.ownPropertyDescriptor`.
   *
   *     expect({a: 1}).to.not.have.ownPropertyDescriptor('b');
   *
   * However, it's dangerous to negate `.ownPropertyDescriptor` when providing
   * a `descriptor`. The problem is that it creates uncertain expectations by
   * asserting that the target either doesn't have a property descriptor with
   * the given key `name`, or that it does have a property descriptor with the
   * given key `name` but it’s not deeply equal to the given `descriptor`. It's
   * often best to identify the exact output that's expected, and then write an
   * assertion that only accepts that exact output.
   *
   * When the target isn't expected to have a property descriptor with the given
   * key `name`, it's often best to assert exactly that.
   *
   *     // Recommended
   *     expect({b: 2}).to.not.have.ownPropertyDescriptor('a');
   *
   *     // Not recommended
   *     expect({b: 2}).to.not.have.ownPropertyDescriptor('a', {
   *       configurable: true,
   *       enumerable: true,
   *       writable: true,
   *       value: 1,
   *     });
   *
   * When the target is expected to have a property descriptor with the given
   * key `name`, it's often best to assert that the property has its expected
   * descriptor, rather than asserting that it doesn't have one of many
   * unexpected descriptors.
   *
   *     // Recommended
   *     expect({a: 3}).to.have.ownPropertyDescriptor('a', {
   *       configurable: true,
   *       enumerable: true,
   *       writable: true,
   *       value: 3,
   *     });
   *
   *     // Not recommended
   *     expect({a: 3}).to.not.have.ownPropertyDescriptor('a', {
   *       configurable: true,
   *       enumerable: true,
   *       writable: true,
   *       value: 1,
   *     });
   *
   * `.ownPropertyDescriptor` changes the target of any assertions that follow
   * in the chain to be the value of the property descriptor from the original
   * target object.
   *
   *     expect({a: 1}).to.have.ownPropertyDescriptor('a')
   *       .that.has.property('enumerable', true);
   *
   * `.ownPropertyDescriptor` accepts an optional `msg` argument which is a
   * custom error message to show when the assertion fails. The message can also
   * be given as the second argument to `expect`. When not providing
   * `descriptor`, only use the second form.
   *
   *     // Recommended
   *     expect({a: 1}).to.have.ownPropertyDescriptor('a', {
   *       configurable: true,
   *       enumerable: true,
   *       writable: true,
   *       value: 2,
   *     }, 'nooo why fail??');
   *
   *     // Recommended
   *     expect({a: 1}, 'nooo why fail??').to.have.ownPropertyDescriptor('a', {
   *       configurable: true,
   *       enumerable: true,
   *       writable: true,
   *       value: 2,
   *     });
   *
   *     // Recommended
   *     expect({a: 1}, 'nooo why fail??').to.have.ownPropertyDescriptor('b');
   *
   *     // Not recommended
   *     expect({a: 1})
   *       .to.have.ownPropertyDescriptor('b', undefined, 'nooo why fail??');
   *
   * The above assertion isn't the same thing as not providing `descriptor`.
   * Instead, it's asserting that the target object has a `b` property
   * descriptor that's deeply equal to `undefined`.
   *
   * The alias `.haveOwnPropertyDescriptor` can be used interchangeably with
   * `.ownPropertyDescriptor`.
   *
   * @name ownPropertyDescriptor
   * @alias haveOwnPropertyDescriptor
   * @param {String} name
   * @param {Object} descriptor _optional_
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertOwnPropertyDescriptor (name, descriptor, msg) {
    if (typeof descriptor === 'string') {
      msg = descriptor;
      descriptor = null;
    }
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object');
    var actualDescriptor = Object.getOwnPropertyDescriptor(Object(obj), name);
    if (actualDescriptor && descriptor) {
      this.assert(
          _.eql(descriptor, actualDescriptor)
        , 'expected the own property descriptor for ' + _.inspect(name) + ' on #{this} to match ' + _.inspect(descriptor) + ', got ' + _.inspect(actualDescriptor)
        , 'expected the own property descriptor for ' + _.inspect(name) + ' on #{this} to not match ' + _.inspect(descriptor)
        , descriptor
        , actualDescriptor
        , true
      );
    } else {
      this.assert(
          actualDescriptor
        , 'expected #{this} to have an own property descriptor for ' + _.inspect(name)
        , 'expected #{this} to not have an own property descriptor for ' + _.inspect(name)
      );
    }
    flag(this, 'object', actualDescriptor);
  }

  Assertion.addMethod('ownPropertyDescriptor', assertOwnPropertyDescriptor);
  Assertion.addMethod('haveOwnPropertyDescriptor', assertOwnPropertyDescriptor);

  /**
   * ### .lengthOf(n[, msg])
   *
   * Asserts that the target's `length` or `size` is equal to the given number
   * `n`.
   *
   *     expect([1, 2, 3]).to.have.lengthOf(3);
   *     expect('foo').to.have.lengthOf(3);
   *     expect(new Set([1, 2, 3])).to.have.lengthOf(3);
   *     expect(new Map([['a', 1], ['b', 2], ['c', 3]])).to.have.lengthOf(3);
   *
   * Add `.not` earlier in the chain to negate `.lengthOf`. However, it's often
   * best to assert that the target's `length` property is equal to its expected
   * value, rather than not equal to one of many unexpected values.
   *
   *     expect('foo').to.have.lengthOf(3); // Recommended
   *     expect('foo').to.not.have.lengthOf(4); // Not recommended
   *
   * `.lengthOf` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect([1, 2, 3]).to.have.lengthOf(2, 'nooo why fail??');
   *     expect([1, 2, 3], 'nooo why fail??').to.have.lengthOf(2);
   *
   * `.lengthOf` can also be used as a language chain, causing all `.above`,
   * `.below`, `.least`, `.most`, and `.within` assertions that follow in the
   * chain to use the target's `length` property as the target. However, it's
   * often best to assert that the target's `length` property is equal to its
   * expected length, rather than asserting that its `length` property falls
   * within some range of values.
   *
   *     // Recommended
   *     expect([1, 2, 3]).to.have.lengthOf(3);
   *
   *     // Not recommended
   *     expect([1, 2, 3]).to.have.lengthOf.above(2);
   *     expect([1, 2, 3]).to.have.lengthOf.below(4);
   *     expect([1, 2, 3]).to.have.lengthOf.at.least(3);
   *     expect([1, 2, 3]).to.have.lengthOf.at.most(3);
   *     expect([1, 2, 3]).to.have.lengthOf.within(2,4);
   *
   * Due to a compatibility issue, the alias `.length` can't be chained directly
   * off of an uninvoked method such as `.a`. Therefore, `.length` can't be used
   * interchangeably with `.lengthOf` in every situation. It's recommended to
   * always use `.lengthOf` instead of `.length`.
   *
   *     expect([1, 2, 3]).to.have.a.length(3); // incompatible; throws error
   *     expect([1, 2, 3]).to.have.a.lengthOf(3);  // passes as expected
   *
   * @name lengthOf
   * @alias length
   * @param {Number} n
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertLengthChain () {
    flag(this, 'doLength', true);
  }

  function assertLength (n, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , objType = _.type(obj).toLowerCase()
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi')
      , descriptor = 'length'
      , itemsCount;

    switch (objType) {
      case 'map':
      case 'set':
        descriptor = 'size';
        itemsCount = obj.size;
        break;
      default:
        new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
        itemsCount = obj.length;
    }

    this.assert(
        itemsCount == n
      , 'expected #{this} to have a ' + descriptor + ' of #{exp} but got #{act}'
      , 'expected #{this} to not have a ' + descriptor + ' of #{act}'
      , n
      , itemsCount
    );
  }

  Assertion.addChainableMethod('length', assertLength, assertLengthChain);
  Assertion.addChainableMethod('lengthOf', assertLength, assertLengthChain);

  /**
   * ### .match(re[, msg])
   *
   * Asserts that the target matches the given regular expression `re`.
   *
   *     expect('foobar').to.match(/^foo/);
   *
   * Add `.not` earlier in the chain to negate `.match`.
   *
   *     expect('foobar').to.not.match(/taco/);
   *
   * `.match` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect('foobar').to.match(/taco/, 'nooo why fail??');
   *     expect('foobar', 'nooo why fail??').to.match(/taco/);
   *
   * The alias `.matches` can be used interchangeably with `.match`.
   *
   * @name match
   * @alias matches
   * @param {RegExp} re
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */
  function assertMatch(re, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object');
    this.assert(
        re.exec(obj)
      , 'expected #{this} to match ' + re
      , 'expected #{this} not to match ' + re
    );
  }

  Assertion.addMethod('match', assertMatch);
  Assertion.addMethod('matches', assertMatch);

  /**
   * ### .string(str[, msg])
   *
   * Asserts that the target string contains the given substring `str`.
   *
   *     expect('foobar').to.have.string('bar');
   *
   * Add `.not` earlier in the chain to negate `.string`.
   *
   *     expect('foobar').to.not.have.string('taco');
   *
   * `.string` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect('foobar').to.have.string('taco', 'nooo why fail??');
   *     expect('foobar', 'nooo why fail??').to.have.string('taco');
   *
   * @name string
   * @param {String} str
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  Assertion.addMethod('string', function (str, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi');
    new Assertion(obj, flagMsg, ssfi, true).is.a('string');

    this.assert(
        ~obj.indexOf(str)
      , 'expected #{this} to contain ' + _.inspect(str)
      , 'expected #{this} to not contain ' + _.inspect(str)
    );
  });

  /**
   * ### .keys(key1[, key2[, ...]])
   *
   * Asserts that the target object, array, map, or set has the given keys. Only
   * the target's own inherited properties are included in the search.
   *
   * When the target is an object or array, keys can be provided as one or more
   * string arguments, a single array argument, or a single object argument. In
   * the latter case, only the keys in the given object matter; the values are
   * ignored.
   *
   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b');
   *     expect(['x', 'y']).to.have.all.keys(0, 1);
   *
   *     expect({a: 1, b: 2}).to.have.all.keys(['a', 'b']);
   *     expect(['x', 'y']).to.have.all.keys([0, 1]);
   *
   *     expect({a: 1, b: 2}).to.have.all.keys({a: 4, b: 5}); // ignore 4 and 5
   *     expect(['x', 'y']).to.have.all.keys({0: 4, 1: 5}); // ignore 4 and 5
   *
   * When the target is a map or set, each key must be provided as a separate
   * argument.
   *
   *     expect(new Map([['a', 1], ['b', 2]])).to.have.all.keys('a', 'b');
   *     expect(new Set(['a', 'b'])).to.have.all.keys('a', 'b');
   *
   * Because `.keys` does different things based on the target's type, it's
   * important to check the target's type before using `.keys`. See the `.a` doc
   * for info on testing a target's type.
   *
   *     expect({a: 1, b: 2}).to.be.an('object').that.has.all.keys('a', 'b');
   *
   * By default, strict (`===`) equality is used to compare keys of maps and
   * sets. Add `.deep` earlier in the chain to use deep equality instead. See
   * the `deep-eql` project page for info on the deep equality algorithm:
   * https://github.com/chaijs/deep-eql.
   *
   *     // Target set deeply (but not strictly) has key `{a: 1}`
   *     expect(new Set([{a: 1}])).to.have.all.deep.keys([{a: 1}]);
   *     expect(new Set([{a: 1}])).to.not.have.all.keys([{a: 1}]);
   *
   * By default, the target must have all of the given keys and no more. Add
   * `.any` earlier in the chain to only require that the target have at least
   * one of the given keys. Also, add `.not` earlier in the chain to negate
   * `.keys`. It's often best to add `.any` when negating `.keys`, and to use
   * `.all` when asserting `.keys` without negation.
   *
   * When negating `.keys`, `.any` is preferred because `.not.any.keys` asserts
   * exactly what's expected of the output, whereas `.not.all.keys` creates
   * uncertain expectations.
   *
   *     // Recommended; asserts that target doesn't have any of the given keys
   *     expect({a: 1, b: 2}).to.not.have.any.keys('c', 'd');
   *
   *     // Not recommended; asserts that target doesn't have all of the given
   *     // keys but may or may not have some of them
   *     expect({a: 1, b: 2}).to.not.have.all.keys('c', 'd');
   *
   * When asserting `.keys` without negation, `.all` is preferred because
   * `.all.keys` asserts exactly what's expected of the output, whereas
   * `.any.keys` creates uncertain expectations.
   *
   *     // Recommended; asserts that target has all the given keys
   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b');
   *
   *     // Not recommended; asserts that target has at least one of the given
   *     // keys but may or may not have more of them
   *     expect({a: 1, b: 2}).to.have.any.keys('a', 'b');
   *
   * Note that `.all` is used by default when neither `.all` nor `.any` appear
   * earlier in the chain. However, it's often best to add `.all` anyway because
   * it improves readability.
   *
   *     // Both assertions are identical
   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b'); // Recommended
   *     expect({a: 1, b: 2}).to.have.keys('a', 'b'); // Not recommended
   *
   * Add `.include` earlier in the chain to require that the target's keys be a
   * superset of the expected keys, rather than identical sets.
   *
   *     // Target object's keys are a superset of ['a', 'b'] but not identical
   *     expect({a: 1, b: 2, c: 3}).to.include.all.keys('a', 'b');
   *     expect({a: 1, b: 2, c: 3}).to.not.have.all.keys('a', 'b');
   *
   * However, if `.any` and `.include` are combined, only the `.any` takes
   * effect. The `.include` is ignored in this case.
   *
   *     // Both assertions are identical
   *     expect({a: 1}).to.have.any.keys('a', 'b');
   *     expect({a: 1}).to.include.any.keys('a', 'b');
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect({a: 1}, 'nooo why fail??').to.have.key('b');
   *
   * The alias `.key` can be used interchangeably with `.keys`.
   *
   * @name keys
   * @alias key
   * @param {...String|Array|Object} keys
   * @namespace BDD
   * @api public
   */

  function assertKeys (keys) {
    var obj = flag(this, 'object')
      , objType = _.type(obj)
      , keysType = _.type(keys)
      , ssfi = flag(this, 'ssfi')
      , isDeep = flag(this, 'deep')
      , str
      , deepStr = ''
      , actual
      , ok = true
      , flagMsg = flag(this, 'message');

    flagMsg = flagMsg ? flagMsg + ': ' : '';
    var mixedArgsMsg = flagMsg + 'when testing keys against an object or an array you must give a single Array|Object|String argument or multiple String arguments';

    if (objType === 'Map' || objType === 'Set') {
      deepStr = isDeep ? 'deeply ' : '';
      actual = [];

      // Map and Set '.keys' aren't supported in IE 11. Therefore, use .forEach.
      obj.forEach(function (val, key) { actual.push(key) });

      if (keysType !== 'Array') {
        keys = Array.prototype.slice.call(arguments);
      }
    } else {
      actual = _.getOwnEnumerableProperties(obj);

      switch (keysType) {
        case 'Array':
          if (arguments.length > 1) {
            throw new AssertionError(mixedArgsMsg, undefined, ssfi);
          }
          break;
        case 'Object':
          if (arguments.length > 1) {
            throw new AssertionError(mixedArgsMsg, undefined, ssfi);
          }
          keys = Object.keys(keys);
          break;
        default:
          keys = Array.prototype.slice.call(arguments);
      }

      // Only stringify non-Symbols because Symbols would become "Symbol()"
      keys = keys.map(function (val) {
        return typeof val === 'symbol' ? val : String(val);
      });
    }

    if (!keys.length) {
      throw new AssertionError(flagMsg + 'keys required', undefined, ssfi);
    }

    var len = keys.length
      , any = flag(this, 'any')
      , all = flag(this, 'all')
      , expected = keys;

    if (!any && !all) {
      all = true;
    }

    // Has any
    if (any) {
      ok = expected.some(function(expectedKey) {
        return actual.some(function(actualKey) {
          if (isDeep) {
            return _.eql(expectedKey, actualKey);
          } else {
            return expectedKey === actualKey;
          }
        });
      });
    }

    // Has all
    if (all) {
      ok = expected.every(function(expectedKey) {
        return actual.some(function(actualKey) {
          if (isDeep) {
            return _.eql(expectedKey, actualKey);
          } else {
            return expectedKey === actualKey;
          }
        });
      });

      if (!flag(this, 'contains')) {
        ok = ok && keys.length == actual.length;
      }
    }

    // Key string
    if (len > 1) {
      keys = keys.map(function(key) {
        return _.inspect(key);
      });
      var last = keys.pop();
      if (all) {
        str = keys.join(', ') + ', and ' + last;
      }
      if (any) {
        str = keys.join(', ') + ', or ' + last;
      }
    } else {
      str = _.inspect(keys[0]);
    }

    // Form
    str = (len > 1 ? 'keys ' : 'key ') + str;

    // Have / include
    str = (flag(this, 'contains') ? 'contain ' : 'have ') + str;

    // Assertion
    this.assert(
        ok
      , 'expected #{this} to ' + deepStr + str
      , 'expected #{this} to not ' + deepStr + str
      , expected.slice(0).sort(_.compareByInspect)
      , actual.sort(_.compareByInspect)
      , true
    );
  }

  Assertion.addMethod('keys', assertKeys);
  Assertion.addMethod('key', assertKeys);

  /**
   * ### .throw([errorLike], [errMsgMatcher], [msg])
   *
   * When no arguments are provided, `.throw` invokes the target function and
   * asserts that an error is thrown.
   *
   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
   *
   *     expect(badFn).to.throw();
   *
   * When one argument is provided, and it's an error constructor, `.throw`
   * invokes the target function and asserts that an error is thrown that's an
   * instance of that error constructor.
   *
   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
   *
   *     expect(badFn).to.throw(TypeError);
   *
   * When one argument is provided, and it's an error instance, `.throw` invokes
   * the target function and asserts that an error is thrown that's strictly
   * (`===`) equal to that error instance.
   *
   *     var err = new TypeError('Illegal salmon!');
   *     var badFn = function () { throw err; };
   *
   *     expect(badFn).to.throw(err);
   *
   * When one argument is provided, and it's a string, `.throw` invokes the
   * target function and asserts that an error is thrown with a message that
   * contains that string.
   *
   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
   *
   *     expect(badFn).to.throw('salmon');
   *
   * When one argument is provided, and it's a regular expression, `.throw`
   * invokes the target function and asserts that an error is thrown with a
   * message that matches that regular expression.
   *
   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
   *
   *     expect(badFn).to.throw(/salmon/);
   *
   * When two arguments are provided, and the first is an error instance or
   * constructor, and the second is a string or regular expression, `.throw`
   * invokes the function and asserts that an error is thrown that fulfills both
   * conditions as described above.
   *
   *     var err = new TypeError('Illegal salmon!');
   *     var badFn = function () { throw err; };
   *
   *     expect(badFn).to.throw(TypeError, 'salmon');
   *     expect(badFn).to.throw(TypeError, /salmon/);
   *     expect(badFn).to.throw(err, 'salmon');
   *     expect(badFn).to.throw(err, /salmon/);
   *
   * Add `.not` earlier in the chain to negate `.throw`.
   *
   *     var goodFn = function () {};
   *
   *     expect(goodFn).to.not.throw();
   *
   * However, it's dangerous to negate `.throw` when providing any arguments.
   * The problem is that it creates uncertain expectations by asserting that the
   * target either doesn't throw an error, or that it throws an error but of a
   * different type than the given type, or that it throws an error of the given
   * type but with a message that doesn't include the given string. It's often
   * best to identify the exact output that's expected, and then write an
   * assertion that only accepts that exact output.
   *
   * When the target isn't expected to throw an error, it's often best to assert
   * exactly that.
   *
   *     var goodFn = function () {};
   *
   *     expect(goodFn).to.not.throw(); // Recommended
   *     expect(goodFn).to.not.throw(ReferenceError, 'x'); // Not recommended
   *
   * When the target is expected to throw an error, it's often best to assert
   * that the error is of its expected type, and has a message that includes an
   * expected string, rather than asserting that it doesn't have one of many
   * unexpected types, and doesn't have a message that includes some string.
   *
   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
   *
   *     expect(badFn).to.throw(TypeError, 'salmon'); // Recommended
   *     expect(badFn).to.not.throw(ReferenceError, 'x'); // Not recommended
   *
   * `.throw` changes the target of any assertions that follow in the chain to
   * be the error object that's thrown.
   *
   *     var err = new TypeError('Illegal salmon!');
   *     err.code = 42;
   *     var badFn = function () { throw err; };
   *
   *     expect(badFn).to.throw(TypeError).with.property('code', 42);
   *
   * `.throw` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`. When not providing two arguments, always use
   * the second form.
   *
   *     var goodFn = function () {};
   *
   *     expect(goodFn).to.throw(TypeError, 'x', 'nooo why fail??');
   *     expect(goodFn, 'nooo why fail??').to.throw();
   *
   * Due to limitations in ES5, `.throw` may not always work as expected when
   * using a transpiler such as Babel or TypeScript. In particular, it may
   * produce unexpected results when subclassing the built-in `Error` object and
   * then passing the subclassed constructor to `.throw`. See your transpiler's
   * docs for details:
   *
   * - ([Babel](https://babeljs.io/docs/usage/caveats/#classes))
   * - ([TypeScript](https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work))
   *
   * Beware of some common mistakes when using the `throw` assertion. One common
   * mistake is to accidentally invoke the function yourself instead of letting
   * the `throw` assertion invoke the function for you. For example, when
   * testing if a function named `fn` throws, provide `fn` instead of `fn()` as
   * the target for the assertion.
   *
   *     expect(fn).to.throw();     // Good! Tests `fn` as desired
   *     expect(fn()).to.throw();   // Bad! Tests result of `fn()`, not `fn`
   *
   * If you need to assert that your function `fn` throws when passed certain
   * arguments, then wrap a call to `fn` inside of another function.
   *
   *     expect(function () { fn(42); }).to.throw();  // Function expression
   *     expect(() => fn(42)).to.throw();             // ES6 arrow function
   *
   * Another common mistake is to provide an object method (or any stand-alone
   * function that relies on `this`) as the target of the assertion. Doing so is
   * problematic because the `this` context will be lost when the function is
   * invoked by `.throw`; there's no way for it to know what `this` is supposed
   * to be. There are two ways around this problem. One solution is to wrap the
   * method or function call inside of another function. Another solution is to
   * use `bind`.
   *
   *     expect(function () { cat.meow(); }).to.throw();  // Function expression
   *     expect(() => cat.meow()).to.throw();             // ES6 arrow function
   *     expect(cat.meow.bind(cat)).to.throw();           // Bind
   *
   * Finally, it's worth mentioning that it's a best practice in JavaScript to
   * only throw `Error` and derivatives of `Error` such as `ReferenceError`,
   * `TypeError`, and user-defined objects that extend `Error`. No other type of
   * value will generate a stack trace when initialized. With that said, the
   * `throw` assertion does technically support any type of value being thrown,
   * not just `Error` and its derivatives.
   *
   * The aliases `.throws` and `.Throw` can be used interchangeably with
   * `.throw`.
   *
   * @name throw
   * @alias throws
   * @alias Throw
   * @param {Error|ErrorConstructor} errorLike
   * @param {String|RegExp} errMsgMatcher error message
   * @param {String} msg _optional_
   * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
   * @returns error for chaining (null if no error)
   * @namespace BDD
   * @api public
   */

  function assertThrows (errorLike, errMsgMatcher, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , ssfi = flag(this, 'ssfi')
      , flagMsg = flag(this, 'message')
      , negate = flag(this, 'negate') || false;
    new Assertion(obj, flagMsg, ssfi, true).is.a('function');

    if (errorLike instanceof RegExp || typeof errorLike === 'string') {
      errMsgMatcher = errorLike;
      errorLike = null;
    }

    var caughtErr;
    try {
      obj();
    } catch (err) {
      caughtErr = err;
    }

    // If we have the negate flag enabled and at least one valid argument it means we do expect an error
    // but we want it to match a given set of criteria
    var everyArgIsUndefined = errorLike === undefined && errMsgMatcher === undefined;

    // If we've got the negate flag enabled and both args, we should only fail if both aren't compatible
    // See Issue #551 and PR #683@GitHub
    var everyArgIsDefined = Boolean(errorLike && errMsgMatcher);
    var errorLikeFail = false;
    var errMsgMatcherFail = false;

    // Checking if error was thrown
    if (everyArgIsUndefined || !everyArgIsUndefined && !negate) {
      // We need this to display results correctly according to their types
      var errorLikeString = 'an error';
      if (errorLike instanceof Error) {
        errorLikeString = '#{exp}';
      } else if (errorLike) {
        errorLikeString = _.checkError.getConstructorName(errorLike);
      }

      this.assert(
          caughtErr
        , 'expected #{this} to throw ' + errorLikeString
        , 'expected #{this} to not throw an error but #{act} was thrown'
        , errorLike && errorLike.toString()
        , (caughtErr instanceof Error ?
            caughtErr.toString() : (typeof caughtErr === 'string' ? caughtErr : caughtErr &&
                                    _.checkError.getConstructorName(caughtErr)))
      );
    }

    if (errorLike && caughtErr) {
      // We should compare instances only if `errorLike` is an instance of `Error`
      if (errorLike instanceof Error) {
        var isCompatibleInstance = _.checkError.compatibleInstance(caughtErr, errorLike);

        if (isCompatibleInstance === negate) {
          // These checks were created to ensure we won't fail too soon when we've got both args and a negate
          // See Issue #551 and PR #683@GitHub
          if (everyArgIsDefined && negate) {
            errorLikeFail = true;
          } else {
            this.assert(
                negate
              , 'expected #{this} to throw #{exp} but #{act} was thrown'
              , 'expected #{this} to not throw #{exp}' + (caughtErr && !negate ? ' but #{act} was thrown' : '')
              , errorLike.toString()
              , caughtErr.toString()
            );
          }
        }
      }

      var isCompatibleConstructor = _.checkError.compatibleConstructor(caughtErr, errorLike);
      if (isCompatibleConstructor === negate) {
        if (everyArgIsDefined && negate) {
            errorLikeFail = true;
        } else {
          this.assert(
              negate
            , 'expected #{this} to throw #{exp} but #{act} was thrown'
            , 'expected #{this} to not throw #{exp}' + (caughtErr ? ' but #{act} was thrown' : '')
            , (errorLike instanceof Error ? errorLike.toString() : errorLike && _.checkError.getConstructorName(errorLike))
            , (caughtErr instanceof Error ? caughtErr.toString() : caughtErr && _.checkError.getConstructorName(caughtErr))
          );
        }
      }
    }

    if (caughtErr && errMsgMatcher !== undefined && errMsgMatcher !== null) {
      // Here we check compatible messages
      var placeholder = 'including';
      if (errMsgMatcher instanceof RegExp) {
        placeholder = 'matching'
      }

      var isCompatibleMessage = _.checkError.compatibleMessage(caughtErr, errMsgMatcher);
      if (isCompatibleMessage === negate) {
        if (everyArgIsDefined && negate) {
            errMsgMatcherFail = true;
        } else {
          this.assert(
            negate
            , 'expected #{this} to throw error ' + placeholder + ' #{exp} but got #{act}'
            , 'expected #{this} to throw error not ' + placeholder + ' #{exp}'
            ,  errMsgMatcher
            ,  _.checkError.getMessage(caughtErr)
          );
        }
      }
    }

    // If both assertions failed and both should've matched we throw an error
    if (errorLikeFail && errMsgMatcherFail) {
      this.assert(
        negate
        , 'expected #{this} to throw #{exp} but #{act} was thrown'
        , 'expected #{this} to not throw #{exp}' + (caughtErr ? ' but #{act} was thrown' : '')
        , (errorLike instanceof Error ? errorLike.toString() : errorLike && _.checkError.getConstructorName(errorLike))
        , (caughtErr instanceof Error ? caughtErr.toString() : caughtErr && _.checkError.getConstructorName(caughtErr))
      );
    }

    flag(this, 'object', caughtErr);
  };

  Assertion.addMethod('throw', assertThrows);
  Assertion.addMethod('throws', assertThrows);
  Assertion.addMethod('Throw', assertThrows);

  /**
   * ### .respondTo(method[, msg])
   *
   * When the target is a non-function object, `.respondTo` asserts that the
   * target has a method with the given name `method`. The method can be own or
   * inherited, and it can be enumerable or non-enumerable.
   *
   *     function Cat () {}
   *     Cat.prototype.meow = function () {};
   *
   *     expect(new Cat()).to.respondTo('meow');
   *
   * When the target is a function, `.respondTo` asserts that the target's
   * `prototype` property has a method with the given name `method`. Again, the
   * method can be own or inherited, and it can be enumerable or non-enumerable.
   *
   *     function Cat () {}
   *     Cat.prototype.meow = function () {};
   *
   *     expect(Cat).to.respondTo('meow');
   *
   * Add `.itself` earlier in the chain to force `.respondTo` to treat the
   * target as a non-function object, even if it's a function. Thus, it asserts
   * that the target has a method with the given name `method`, rather than
   * asserting that the target's `prototype` property has a method with the
   * given name `method`.
   *
   *     function Cat () {}
   *     Cat.prototype.meow = function () {};
   *     Cat.hiss = function () {};
   *
   *     expect(Cat).itself.to.respondTo('hiss').but.not.respondTo('meow');
   *
   * When not adding `.itself`, it's important to check the target's type before
   * using `.respondTo`. See the `.a` doc for info on checking a target's type.
   *
   *     function Cat () {}
   *     Cat.prototype.meow = function () {};
   *
   *     expect(new Cat()).to.be.an('object').that.respondsTo('meow');
   *
   * Add `.not` earlier in the chain to negate `.respondTo`.
   *
   *     function Dog () {}
   *     Dog.prototype.bark = function () {};
   *
   *     expect(new Dog()).to.not.respondTo('meow');
   *
   * `.respondTo` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect({}).to.respondTo('meow', 'nooo why fail??');
   *     expect({}, 'nooo why fail??').to.respondTo('meow');
   *
   * The alias `.respondsTo` can be used interchangeably with `.respondTo`.
   *
   * @name respondTo
   * @alias respondsTo
   * @param {String} method
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function respondTo (method, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , itself = flag(this, 'itself')
      , context = ('function' === typeof obj && !itself)
        ? obj.prototype[method]
        : obj[method];

    this.assert(
        'function' === typeof context
      , 'expected #{this} to respond to ' + _.inspect(method)
      , 'expected #{this} to not respond to ' + _.inspect(method)
    );
  }

  Assertion.addMethod('respondTo', respondTo);
  Assertion.addMethod('respondsTo', respondTo);

  /**
   * ### .itself
   *
   * Forces all `.respondTo` assertions that follow in the chain to behave as if
   * the target is a non-function object, even if it's a function. Thus, it
   * causes `.respondTo` to assert that the target has a method with the given
   * name, rather than asserting that the target's `prototype` property has a
   * method with the given name.
   *
   *     function Cat () {}
   *     Cat.prototype.meow = function () {};
   *     Cat.hiss = function () {};
   *
   *     expect(Cat).itself.to.respondTo('hiss').but.not.respondTo('meow');
   *
   * @name itself
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('itself', function () {
    flag(this, 'itself', true);
  });

  /**
   * ### .satisfy(matcher[, msg])
   *
   * Invokes the given `matcher` function with the target being passed as the
   * first argument, and asserts that the value returned is truthy.
   *
   *     expect(1).to.satisfy(function(num) {
   *       return num > 0;
   *     });
   *
   * Add `.not` earlier in the chain to negate `.satisfy`.
   *
   *     expect(1).to.not.satisfy(function(num) {
   *       return num > 2;
   *     });
   *
   * `.satisfy` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect(1).to.satisfy(function(num) {
   *       return num > 2;
   *     }, 'nooo why fail??');
   *
   *     expect(1, 'nooo why fail??').to.satisfy(function(num) {
   *       return num > 2;
   *     });
   *
   * The alias `.satisfies` can be used interchangeably with `.satisfy`.
   *
   * @name satisfy
   * @alias satisfies
   * @param {Function} matcher
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function satisfy (matcher, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object');
    var result = matcher(obj);
    this.assert(
        result
      , 'expected #{this} to satisfy ' + _.objDisplay(matcher)
      , 'expected #{this} to not satisfy' + _.objDisplay(matcher)
      , flag(this, 'negate') ? false : true
      , result
    );
  }

  Assertion.addMethod('satisfy', satisfy);
  Assertion.addMethod('satisfies', satisfy);

  /**
   * ### .closeTo(expected, delta[, msg])
   *
   * Asserts that the target is a number that's within a given +/- `delta` range
   * of the given number `expected`. However, it's often best to assert that the
   * target is equal to its expected value.
   *
   *     // Recommended
   *     expect(1.5).to.equal(1.5);
   *
   *     // Not recommended
   *     expect(1.5).to.be.closeTo(1, 0.5);
   *     expect(1.5).to.be.closeTo(2, 0.5);
   *     expect(1.5).to.be.closeTo(1, 1);
   *
   * Add `.not` earlier in the chain to negate `.closeTo`.
   *
   *     expect(1.5).to.equal(1.5); // Recommended
   *     expect(1.5).to.not.be.closeTo(3, 1); // Not recommended
   *
   * `.closeTo` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect(1.5).to.be.closeTo(3, 1, 'nooo why fail??');
   *     expect(1.5, 'nooo why fail??').to.be.closeTo(3, 1);
   *
   * The alias `.approximately` can be used interchangeably with `.closeTo`.
   *
   * @name closeTo
   * @alias approximately
   * @param {Number} expected
   * @param {Number} delta
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function closeTo(expected, delta, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi');

    new Assertion(obj, flagMsg, ssfi, true).is.a('number');
    if (typeof expected !== 'number' || typeof delta !== 'number') {
      flagMsg = flagMsg ? flagMsg + ': ' : '';
      var deltaMessage = delta === undefined ? ", and a delta is required" : "";
      throw new AssertionError(
          flagMsg + 'the arguments to closeTo or approximately must be numbers' + deltaMessage,
          undefined,
          ssfi
      );
    }

    this.assert(
        Math.abs(obj - expected) <= delta
      , 'expected #{this} to be close to ' + expected + ' +/- ' + delta
      , 'expected #{this} not to be close to ' + expected + ' +/- ' + delta
    );
  }

  Assertion.addMethod('closeTo', closeTo);
  Assertion.addMethod('approximately', closeTo);

  // Note: Duplicates are ignored if testing for inclusion instead of sameness.
  function isSubsetOf(subset, superset, cmp, contains, ordered) {
    if (!contains) {
      if (subset.length !== superset.length) return false;
      superset = superset.slice();
    }

    return subset.every(function(elem, idx) {
      if (ordered) return cmp ? cmp(elem, superset[idx]) : elem === superset[idx];

      if (!cmp) {
        var matchIdx = superset.indexOf(elem);
        if (matchIdx === -1) return false;

        // Remove match from superset so not counted twice if duplicate in subset.
        if (!contains) superset.splice(matchIdx, 1);
        return true;
      }

      return superset.some(function(elem2, matchIdx) {
        if (!cmp(elem, elem2)) return false;

        // Remove match from superset so not counted twice if duplicate in subset.
        if (!contains) superset.splice(matchIdx, 1);
        return true;
      });
    });
  }

  /**
   * ### .members(set[, msg])
   *
   * Asserts that the target array has the same members as the given array
   * `set`.
   *
   *     expect([1, 2, 3]).to.have.members([2, 1, 3]);
   *     expect([1, 2, 2]).to.have.members([2, 1, 2]);
   *
   * By default, members are compared using strict (`===`) equality. Add `.deep`
   * earlier in the chain to use deep equality instead. See the `deep-eql`
   * project page for info on the deep equality algorithm:
   * https://github.com/chaijs/deep-eql.
   *
   *     // Target array deeply (but not strictly) has member `{a: 1}`
   *     expect([{a: 1}]).to.have.deep.members([{a: 1}]);
   *     expect([{a: 1}]).to.not.have.members([{a: 1}]);
   *
   * By default, order doesn't matter. Add `.ordered` earlier in the chain to
   * require that members appear in the same order.
   *
   *     expect([1, 2, 3]).to.have.ordered.members([1, 2, 3]);
   *     expect([1, 2, 3]).to.have.members([2, 1, 3])
   *       .but.not.ordered.members([2, 1, 3]);
   *
   * By default, both arrays must be the same size. Add `.include` earlier in
   * the chain to require that the target's members be a superset of the
   * expected members. Note that duplicates are ignored in the subset when
   * `.include` is added.
   *
   *     // Target array is a superset of [1, 2] but not identical
   *     expect([1, 2, 3]).to.include.members([1, 2]);
   *     expect([1, 2, 3]).to.not.have.members([1, 2]);
   *
   *     // Duplicates in the subset are ignored
   *     expect([1, 2, 3]).to.include.members([1, 2, 2, 2]);
   *
   * `.deep`, `.ordered`, and `.include` can all be combined. However, if
   * `.include` and `.ordered` are combined, the ordering begins at the start of
   * both arrays.
   *
   *     expect([{a: 1}, {b: 2}, {c: 3}])
   *       .to.include.deep.ordered.members([{a: 1}, {b: 2}])
   *       .but.not.include.deep.ordered.members([{b: 2}, {c: 3}]);
   *
   * Add `.not` earlier in the chain to negate `.members`. However, it's
   * dangerous to do so. The problem is that it creates uncertain expectations
   * by asserting that the target array doesn't have all of the same members as
   * the given array `set` but may or may not have some of them. It's often best
   * to identify the exact output that's expected, and then write an assertion
   * that only accepts that exact output.
   *
   *     expect([1, 2]).to.not.include(3).and.not.include(4); // Recommended
   *     expect([1, 2]).to.not.have.members([3, 4]); // Not recommended
   *
   * `.members` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`.
   *
   *     expect([1, 2]).to.have.members([1, 2, 3], 'nooo why fail??');
   *     expect([1, 2], 'nooo why fail??').to.have.members([1, 2, 3]);
   *
   * @name members
   * @param {Array} set
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  Assertion.addMethod('members', function (subset, msg) {
    if (msg) flag(this, 'message', msg);
    var obj = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi');

    new Assertion(obj, flagMsg, ssfi, true).to.be.an('array');
    new Assertion(subset, flagMsg, ssfi, true).to.be.an('array');

    var contains = flag(this, 'contains');
    var ordered = flag(this, 'ordered');

    var subject, failMsg, failNegateMsg;

    if (contains) {
      subject = ordered ? 'an ordered superset' : 'a superset';
      failMsg = 'expected #{this} to be ' + subject + ' of #{exp}';
      failNegateMsg = 'expected #{this} to not be ' + subject + ' of #{exp}';
    } else {
      subject = ordered ? 'ordered members' : 'members';
      failMsg = 'expected #{this} to have the same ' + subject + ' as #{exp}';
      failNegateMsg = 'expected #{this} to not have the same ' + subject + ' as #{exp}';
    }

    var cmp = flag(this, 'deep') ? _.eql : undefined;

    this.assert(
        isSubsetOf(subset, obj, cmp, contains, ordered)
      , failMsg
      , failNegateMsg
      , subset
      , obj
      , true
    );
  });

  /**
   * ### .oneOf(list[, msg])
   *
   * Asserts that the target is a member of the given array `list`. However,
   * it's often best to assert that the target is equal to its expected value.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.be.oneOf([1, 2, 3]); // Not recommended
   *
   * Comparisons are performed using strict (`===`) equality.
   *
   * Add `.not` earlier in the chain to negate `.oneOf`.
   *
   *     expect(1).to.equal(1); // Recommended
   *     expect(1).to.not.be.oneOf([2, 3, 4]); // Not recommended
   *
   * It can also be chained with `.contain` or `.include`, which will work with
   * both arrays and strings:
   *
   *     expect('Today is sunny').to.contain.oneOf(['sunny', 'cloudy'])
   *     expect('Today is rainy').to.not.contain.oneOf(['sunny', 'cloudy'])
   *     expect([1,2,3]).to.contain.oneOf([3,4,5])
   *     expect([1,2,3]).to.not.contain.oneOf([4,5,6])
   *
   * `.oneOf` accepts an optional `msg` argument which is a custom error message
   * to show when the assertion fails. The message can also be given as the
   * second argument to `expect`.
   *
   *     expect(1).to.be.oneOf([2, 3, 4], 'nooo why fail??');
   *     expect(1, 'nooo why fail??').to.be.oneOf([2, 3, 4]);
   *
   * @name oneOf
   * @param {Array<*>} list
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function oneOf (list, msg) {
    if (msg) flag(this, 'message', msg);
    var expected = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi')
      , contains = flag(this, 'contains')
      , isDeep = flag(this, 'deep');
    new Assertion(list, flagMsg, ssfi, true).to.be.an('array');

    if (contains) {
      this.assert(
        list.some(function(possibility) { return expected.indexOf(possibility) > -1 })
        , 'expected #{this} to contain one of #{exp}'
        , 'expected #{this} to not contain one of #{exp}'
        , list
        , expected
      );
    } else {
      if (isDeep) {
        this.assert(
          list.some(function(possibility) { return _.eql(expected, possibility) })
          , 'expected #{this} to deeply equal one of #{exp}'
          , 'expected #{this} to deeply equal one of #{exp}'
          , list
          , expected
        );
      } else {
        this.assert(
          list.indexOf(expected) > -1
          , 'expected #{this} to be one of #{exp}'
          , 'expected #{this} to not be one of #{exp}'
          , list
          , expected
        );
      }
    }
  }

  Assertion.addMethod('oneOf', oneOf);

  /**
   * ### .change(subject[, prop[, msg]])
   *
   * When one argument is provided, `.change` asserts that the given function
   * `subject` returns a different value when it's invoked before the target
   * function compared to when it's invoked afterward. However, it's often best
   * to assert that `subject` is equal to its expected value.
   *
   *     var dots = ''
   *       , addDot = function () { dots += '.'; }
   *       , getDots = function () { return dots; };
   *
   *     // Recommended
   *     expect(getDots()).to.equal('');
   *     addDot();
   *     expect(getDots()).to.equal('.');
   *
   *     // Not recommended
   *     expect(addDot).to.change(getDots);
   *
   * When two arguments are provided, `.change` asserts that the value of the
   * given object `subject`'s `prop` property is different before invoking the
   * target function compared to afterward.
   *
   *     var myObj = {dots: ''}
   *       , addDot = function () { myObj.dots += '.'; };
   *
   *     // Recommended
   *     expect(myObj).to.have.property('dots', '');
   *     addDot();
   *     expect(myObj).to.have.property('dots', '.');
   *
   *     // Not recommended
   *     expect(addDot).to.change(myObj, 'dots');
   *
   * Strict (`===`) equality is used to compare before and after values.
   *
   * Add `.not` earlier in the chain to negate `.change`.
   *
   *     var dots = ''
   *       , noop = function () {}
   *       , getDots = function () { return dots; };
   *
   *     expect(noop).to.not.change(getDots);
   *
   *     var myObj = {dots: ''}
   *       , noop = function () {};
   *
   *     expect(noop).to.not.change(myObj, 'dots');
   *
   * `.change` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`. When not providing two arguments, always
   * use the second form.
   *
   *     var myObj = {dots: ''}
   *       , addDot = function () { myObj.dots += '.'; };
   *
   *     expect(addDot).to.not.change(myObj, 'dots', 'nooo why fail??');
   *
   *     var dots = ''
   *       , addDot = function () { dots += '.'; }
   *       , getDots = function () { return dots; };
   *
   *     expect(addDot, 'nooo why fail??').to.not.change(getDots);
   *
   * `.change` also causes all `.by` assertions that follow in the chain to
   * assert how much a numeric subject was increased or decreased by. However,
   * it's dangerous to use `.change.by`. The problem is that it creates
   * uncertain expectations by asserting that the subject either increases by
   * the given delta, or that it decreases by the given delta. It's often best
   * to identify the exact output that's expected, and then write an assertion
   * that only accepts that exact output.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; }
   *       , subtractTwo = function () { myObj.val -= 2; };
   *
   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
   *     expect(addTwo).to.change(myObj, 'val').by(2); // Not recommended
   *
   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
   *     expect(subtractTwo).to.change(myObj, 'val').by(2); // Not recommended
   *
   * The alias `.changes` can be used interchangeably with `.change`.
   *
   * @name change
   * @alias changes
   * @param {String} subject
   * @param {String} prop name _optional_
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertChanges (subject, prop, msg) {
    if (msg) flag(this, 'message', msg);
    var fn = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi');
    new Assertion(fn, flagMsg, ssfi, true).is.a('function');

    var initial;
    if (!prop) {
      new Assertion(subject, flagMsg, ssfi, true).is.a('function');
      initial = subject();
    } else {
      new Assertion(subject, flagMsg, ssfi, true).to.have.property(prop);
      initial = subject[prop];
    }

    fn();

    var final = prop === undefined || prop === null ? subject() : subject[prop];
    var msgObj = prop === undefined || prop === null ? initial : '.' + prop;

    // This gets flagged because of the .by(delta) assertion
    flag(this, 'deltaMsgObj', msgObj);
    flag(this, 'initialDeltaValue', initial);
    flag(this, 'finalDeltaValue', final);
    flag(this, 'deltaBehavior', 'change');
    flag(this, 'realDelta', final !== initial);

    this.assert(
      initial !== final
      , 'expected ' + msgObj + ' to change'
      , 'expected ' + msgObj + ' to not change'
    );
  }

  Assertion.addMethod('change', assertChanges);
  Assertion.addMethod('changes', assertChanges);

  /**
   * ### .increase(subject[, prop[, msg]])
   *
   * When one argument is provided, `.increase` asserts that the given function
   * `subject` returns a greater number when it's invoked after invoking the
   * target function compared to when it's invoked beforehand. `.increase` also
   * causes all `.by` assertions that follow in the chain to assert how much
   * greater of a number is returned. It's often best to assert that the return
   * value increased by the expected amount, rather than asserting it increased
   * by any amount.
   *
   *     var val = 1
   *       , addTwo = function () { val += 2; }
   *       , getVal = function () { return val; };
   *
   *     expect(addTwo).to.increase(getVal).by(2); // Recommended
   *     expect(addTwo).to.increase(getVal); // Not recommended
   *
   * When two arguments are provided, `.increase` asserts that the value of the
   * given object `subject`'s `prop` property is greater after invoking the
   * target function compared to beforehand.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; };
   *
   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
   *     expect(addTwo).to.increase(myObj, 'val'); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.increase`. However, it's
   * dangerous to do so. The problem is that it creates uncertain expectations
   * by asserting that the subject either decreases, or that it stays the same.
   * It's often best to identify the exact output that's expected, and then
   * write an assertion that only accepts that exact output.
   *
   * When the subject is expected to decrease, it's often best to assert that it
   * decreased by the expected amount.
   *
   *     var myObj = {val: 1}
   *       , subtractTwo = function () { myObj.val -= 2; };
   *
   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
   *     expect(subtractTwo).to.not.increase(myObj, 'val'); // Not recommended
   *
   * When the subject is expected to stay the same, it's often best to assert
   * exactly that.
   *
   *     var myObj = {val: 1}
   *       , noop = function () {};
   *
   *     expect(noop).to.not.change(myObj, 'val'); // Recommended
   *     expect(noop).to.not.increase(myObj, 'val'); // Not recommended
   *
   * `.increase` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`. When not providing two arguments, always
   * use the second form.
   *
   *     var myObj = {val: 1}
   *       , noop = function () {};
   *
   *     expect(noop).to.increase(myObj, 'val', 'nooo why fail??');
   *
   *     var val = 1
   *       , noop = function () {}
   *       , getVal = function () { return val; };
   *
   *     expect(noop, 'nooo why fail??').to.increase(getVal);
   *
   * The alias `.increases` can be used interchangeably with `.increase`.
   *
   * @name increase
   * @alias increases
   * @param {String|Function} subject
   * @param {String} prop name _optional_
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertIncreases (subject, prop, msg) {
    if (msg) flag(this, 'message', msg);
    var fn = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi');
    new Assertion(fn, flagMsg, ssfi, true).is.a('function');

    var initial;
    if (!prop) {
      new Assertion(subject, flagMsg, ssfi, true).is.a('function');
      initial = subject();
    } else {
      new Assertion(subject, flagMsg, ssfi, true).to.have.property(prop);
      initial = subject[prop];
    }

    // Make sure that the target is a number
    new Assertion(initial, flagMsg, ssfi, true).is.a('number');

    fn();

    var final = prop === undefined || prop === null ? subject() : subject[prop];
    var msgObj = prop === undefined || prop === null ? initial : '.' + prop;

    flag(this, 'deltaMsgObj', msgObj);
    flag(this, 'initialDeltaValue', initial);
    flag(this, 'finalDeltaValue', final);
    flag(this, 'deltaBehavior', 'increase');
    flag(this, 'realDelta', final - initial);

    this.assert(
      final - initial > 0
      , 'expected ' + msgObj + ' to increase'
      , 'expected ' + msgObj + ' to not increase'
    );
  }

  Assertion.addMethod('increase', assertIncreases);
  Assertion.addMethod('increases', assertIncreases);

  /**
   * ### .decrease(subject[, prop[, msg]])
   *
   * When one argument is provided, `.decrease` asserts that the given function
   * `subject` returns a lesser number when it's invoked after invoking the
   * target function compared to when it's invoked beforehand. `.decrease` also
   * causes all `.by` assertions that follow in the chain to assert how much
   * lesser of a number is returned. It's often best to assert that the return
   * value decreased by the expected amount, rather than asserting it decreased
   * by any amount.
   *
   *     var val = 1
   *       , subtractTwo = function () { val -= 2; }
   *       , getVal = function () { return val; };
   *
   *     expect(subtractTwo).to.decrease(getVal).by(2); // Recommended
   *     expect(subtractTwo).to.decrease(getVal); // Not recommended
   *
   * When two arguments are provided, `.decrease` asserts that the value of the
   * given object `subject`'s `prop` property is lesser after invoking the
   * target function compared to beforehand.
   *
   *     var myObj = {val: 1}
   *       , subtractTwo = function () { myObj.val -= 2; };
   *
   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
   *     expect(subtractTwo).to.decrease(myObj, 'val'); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.decrease`. However, it's
   * dangerous to do so. The problem is that it creates uncertain expectations
   * by asserting that the subject either increases, or that it stays the same.
   * It's often best to identify the exact output that's expected, and then
   * write an assertion that only accepts that exact output.
   *
   * When the subject is expected to increase, it's often best to assert that it
   * increased by the expected amount.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; };
   *
   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
   *     expect(addTwo).to.not.decrease(myObj, 'val'); // Not recommended
   *
   * When the subject is expected to stay the same, it's often best to assert
   * exactly that.
   *
   *     var myObj = {val: 1}
   *       , noop = function () {};
   *
   *     expect(noop).to.not.change(myObj, 'val'); // Recommended
   *     expect(noop).to.not.decrease(myObj, 'val'); // Not recommended
   *
   * `.decrease` accepts an optional `msg` argument which is a custom error
   * message to show when the assertion fails. The message can also be given as
   * the second argument to `expect`. When not providing two arguments, always
   * use the second form.
   *
   *     var myObj = {val: 1}
   *       , noop = function () {};
   *
   *     expect(noop).to.decrease(myObj, 'val', 'nooo why fail??');
   *
   *     var val = 1
   *       , noop = function () {}
   *       , getVal = function () { return val; };
   *
   *     expect(noop, 'nooo why fail??').to.decrease(getVal);
   *
   * The alias `.decreases` can be used interchangeably with `.decrease`.
   *
   * @name decrease
   * @alias decreases
   * @param {String|Function} subject
   * @param {String} prop name _optional_
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertDecreases (subject, prop, msg) {
    if (msg) flag(this, 'message', msg);
    var fn = flag(this, 'object')
      , flagMsg = flag(this, 'message')
      , ssfi = flag(this, 'ssfi');
    new Assertion(fn, flagMsg, ssfi, true).is.a('function');

    var initial;
    if (!prop) {
      new Assertion(subject, flagMsg, ssfi, true).is.a('function');
      initial = subject();
    } else {
      new Assertion(subject, flagMsg, ssfi, true).to.have.property(prop);
      initial = subject[prop];
    }

    // Make sure that the target is a number
    new Assertion(initial, flagMsg, ssfi, true).is.a('number');

    fn();

    var final = prop === undefined || prop === null ? subject() : subject[prop];
    var msgObj = prop === undefined || prop === null ? initial : '.' + prop;

    flag(this, 'deltaMsgObj', msgObj);
    flag(this, 'initialDeltaValue', initial);
    flag(this, 'finalDeltaValue', final);
    flag(this, 'deltaBehavior', 'decrease');
    flag(this, 'realDelta', initial - final);

    this.assert(
      final - initial < 0
      , 'expected ' + msgObj + ' to decrease'
      , 'expected ' + msgObj + ' to not decrease'
    );
  }

  Assertion.addMethod('decrease', assertDecreases);
  Assertion.addMethod('decreases', assertDecreases);

  /**
   * ### .by(delta[, msg])
   *
   * When following an `.increase` assertion in the chain, `.by` asserts that
   * the subject of the `.increase` assertion increased by the given `delta`.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; };
   *
   *     expect(addTwo).to.increase(myObj, 'val').by(2);
   *
   * When following a `.decrease` assertion in the chain, `.by` asserts that the
   * subject of the `.decrease` assertion decreased by the given `delta`.
   *
   *     var myObj = {val: 1}
   *       , subtractTwo = function () { myObj.val -= 2; };
   *
   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2);
   *
   * When following a `.change` assertion in the chain, `.by` asserts that the
   * subject of the `.change` assertion either increased or decreased by the
   * given `delta`. However, it's dangerous to use `.change.by`. The problem is
   * that it creates uncertain expectations. It's often best to identify the
   * exact output that's expected, and then write an assertion that only accepts
   * that exact output.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; }
   *       , subtractTwo = function () { myObj.val -= 2; };
   *
   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
   *     expect(addTwo).to.change(myObj, 'val').by(2); // Not recommended
   *
   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
   *     expect(subtractTwo).to.change(myObj, 'val').by(2); // Not recommended
   *
   * Add `.not` earlier in the chain to negate `.by`. However, it's often best
   * to assert that the subject changed by its expected delta, rather than
   * asserting that it didn't change by one of countless unexpected deltas.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; };
   *
   *     // Recommended
   *     expect(addTwo).to.increase(myObj, 'val').by(2);
   *
   *     // Not recommended
   *     expect(addTwo).to.increase(myObj, 'val').but.not.by(3);
   *
   * `.by` accepts an optional `msg` argument which is a custom error message to
   * show when the assertion fails. The message can also be given as the second
   * argument to `expect`.
   *
   *     var myObj = {val: 1}
   *       , addTwo = function () { myObj.val += 2; };
   *
   *     expect(addTwo).to.increase(myObj, 'val').by(3, 'nooo why fail??');
   *     expect(addTwo, 'nooo why fail??').to.increase(myObj, 'val').by(3);
   *
   * @name by
   * @param {Number} delta
   * @param {String} msg _optional_
   * @namespace BDD
   * @api public
   */

  function assertDelta(delta, msg) {
    if (msg) flag(this, 'message', msg);

    var msgObj = flag(this, 'deltaMsgObj');
    var initial = flag(this, 'initialDeltaValue');
    var final = flag(this, 'finalDeltaValue');
    var behavior = flag(this, 'deltaBehavior');
    var realDelta = flag(this, 'realDelta');

    var expression;
    if (behavior === 'change') {
      expression = Math.abs(final - initial) === Math.abs(delta);
    } else {
      expression = realDelta === Math.abs(delta);
    }

    this.assert(
      expression
      , 'expected ' + msgObj + ' to ' + behavior + ' by ' + delta
      , 'expected ' + msgObj + ' to not ' + behavior + ' by ' + delta
    );
  }

  Assertion.addMethod('by', assertDelta);

  /**
   * ### .extensible
   *
   * Asserts that the target is extensible, which means that new properties can
   * be added to it. Primitives are never extensible.
   *
   *     expect({a: 1}).to.be.extensible;
   *
   * Add `.not` earlier in the chain to negate `.extensible`.
   *
   *     var nonExtensibleObject = Object.preventExtensions({})
   *       , sealedObject = Object.seal({})
   *       , frozenObject = Object.freeze({});
   *
   *     expect(nonExtensibleObject).to.not.be.extensible;
   *     expect(sealedObject).to.not.be.extensible;
   *     expect(frozenObject).to.not.be.extensible;
   *     expect(1).to.not.be.extensible;
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect(1, 'nooo why fail??').to.be.extensible;
   *
   * @name extensible
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('extensible', function() {
    var obj = flag(this, 'object');

    // In ES5, if the argument to this method is a primitive, then it will cause a TypeError.
    // In ES6, a non-object argument will be treated as if it was a non-extensible ordinary object, simply return false.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isExtensible
    // The following provides ES6 behavior for ES5 environments.

    var isExtensible = obj === Object(obj) && Object.isExtensible(obj);

    this.assert(
      isExtensible
      , 'expected #{this} to be extensible'
      , 'expected #{this} to not be extensible'
    );
  });

  /**
   * ### .sealed
   *
   * Asserts that the target is sealed, which means that new properties can't be
   * added to it, and its existing properties can't be reconfigured or deleted.
   * However, it's possible that its existing properties can still be reassigned
   * to different values. Primitives are always sealed.
   *
   *     var sealedObject = Object.seal({});
   *     var frozenObject = Object.freeze({});
   *
   *     expect(sealedObject).to.be.sealed;
   *     expect(frozenObject).to.be.sealed;
   *     expect(1).to.be.sealed;
   *
   * Add `.not` earlier in the chain to negate `.sealed`.
   *
   *     expect({a: 1}).to.not.be.sealed;
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect({a: 1}, 'nooo why fail??').to.be.sealed;
   *
   * @name sealed
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('sealed', function() {
    var obj = flag(this, 'object');

    // In ES5, if the argument to this method is a primitive, then it will cause a TypeError.
    // In ES6, a non-object argument will be treated as if it was a sealed ordinary object, simply return true.
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isSealed
    // The following provides ES6 behavior for ES5 environments.

    var isSealed = obj === Object(obj) ? Object.isSealed(obj) : true;

    this.assert(
      isSealed
      , 'expected #{this} to be sealed'
      , 'expected #{this} to not be sealed'
    );
  });

  /**
   * ### .frozen
   *
   * Asserts that the target is frozen, which means that new properties can't be
   * added to it, and its existing properties can't be reassigned to different
   * values, reconfigured, or deleted. Primitives are always frozen.
   *
   *     var frozenObject = Object.freeze({});
   *
   *     expect(frozenObject).to.be.frozen;
   *     expect(1).to.be.frozen;
   *
   * Add `.not` earlier in the chain to negate `.frozen`.
   *
   *     expect({a: 1}).to.not.be.frozen;
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect({a: 1}, 'nooo why fail??').to.be.frozen;
   *
   * @name frozen
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('frozen', function() {
    var obj = flag(this, 'object');

    // In ES5, if the argument to this method is a primitive, then it will cause a TypeError.
    // In ES6, a non-object argument will be treated as if it was a frozen ordinary object, simply return true.
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isFrozen
    // The following provides ES6 behavior for ES5 environments.

    var isFrozen = obj === Object(obj) ? Object.isFrozen(obj) : true;

    this.assert(
      isFrozen
      , 'expected #{this} to be frozen'
      , 'expected #{this} to not be frozen'
    );
  });

  /**
   * ### .finite
   *
   * Asserts that the target is a number, and isn't `NaN` or positive/negative
   * `Infinity`.
   *
   *     expect(1).to.be.finite;
   *
   * Add `.not` earlier in the chain to negate `.finite`. However, it's
   * dangerous to do so. The problem is that it creates uncertain expectations
   * by asserting that the subject either isn't a number, or that it's `NaN`, or
   * that it's positive `Infinity`, or that it's negative `Infinity`. It's often
   * best to identify the exact output that's expected, and then write an
   * assertion that only accepts that exact output.
   *
   * When the target isn't expected to be a number, it's often best to assert
   * that it's the expected type, rather than asserting that it isn't one of
   * many unexpected types.
   *
   *     expect('foo').to.be.a('string'); // Recommended
   *     expect('foo').to.not.be.finite; // Not recommended
   *
   * When the target is expected to be `NaN`, it's often best to assert exactly
   * that.
   *
   *     expect(NaN).to.be.NaN; // Recommended
   *     expect(NaN).to.not.be.finite; // Not recommended
   *
   * When the target is expected to be positive infinity, it's often best to
   * assert exactly that.
   *
   *     expect(Infinity).to.equal(Infinity); // Recommended
   *     expect(Infinity).to.not.be.finite; // Not recommended
   *
   * When the target is expected to be negative infinity, it's often best to
   * assert exactly that.
   *
   *     expect(-Infinity).to.equal(-Infinity); // Recommended
   *     expect(-Infinity).to.not.be.finite; // Not recommended
   *
   * A custom error message can be given as the second argument to `expect`.
   *
   *     expect('foo', 'nooo why fail??').to.be.finite;
   *
   * @name finite
   * @namespace BDD
   * @api public
   */

  Assertion.addProperty('finite', function(msg) {
    var obj = flag(this, 'object');

    this.assert(
        typeof obj === 'number' && isFinite(obj)
      , 'expected #{this} to be a finite number'
      , 'expected #{this} to not be a finite number'
    );
  });
};


/***/ }),

/***/ 2155:
/***/ (function(module) {

/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

module.exports = function (chai, util) {
  /*!
   * Chai dependencies.
   */

  var Assertion = chai.Assertion
    , flag = util.flag;

  /*!
   * Module export.
   */

  /**
   * ### assert(expression, message)
   *
   * Write your own test expressions.
   *
   *     assert('foo' !== 'bar', 'foo is not bar');
   *     assert(Array.isArray([]), 'empty arrays are arrays');
   *
   * @param {Mixed} expression to test for truthiness
   * @param {String} message to display on error
   * @name assert
   * @namespace Assert
   * @api public
   */

  var assert = chai.assert = function (express, errmsg) {
    var test = new Assertion(null, null, chai.assert, true);
    test.assert(
        express
      , errmsg
      , '[ negation message unavailable ]'
    );
  };

  /**
   * ### .fail([message])
   * ### .fail(actual, expected, [message], [operator])
   *
   * Throw a failure. Node.js `assert` module-compatible.
   *
   *     assert.fail();
   *     assert.fail("custom error message");
   *     assert.fail(1, 2);
   *     assert.fail(1, 2, "custom error message");
   *     assert.fail(1, 2, "custom error message", ">");
   *     assert.fail(1, 2, undefined, ">");
   *
   * @name fail
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @param {String} operator
   * @namespace Assert
   * @api public
   */

  assert.fail = function (actual, expected, message, operator) {
    if (arguments.length < 2) {
        // Comply with Node's fail([message]) interface

        message = actual;
        actual = undefined;
    }

    message = message || 'assert.fail()';
    throw new chai.AssertionError(message, {
        actual: actual
      , expected: expected
      , operator: operator
    }, assert.fail);
  };

  /**
   * ### .isOk(object, [message])
   *
   * Asserts that `object` is truthy.
   *
   *     assert.isOk('everything', 'everything is ok');
   *     assert.isOk(false, 'this will fail');
   *
   * @name isOk
   * @alias ok
   * @param {Mixed} object to test
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isOk = function (val, msg) {
    new Assertion(val, msg, assert.isOk, true).is.ok;
  };

  /**
   * ### .isNotOk(object, [message])
   *
   * Asserts that `object` is falsy.
   *
   *     assert.isNotOk('everything', 'this will fail');
   *     assert.isNotOk(false, 'this will pass');
   *
   * @name isNotOk
   * @alias notOk
   * @param {Mixed} object to test
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotOk = function (val, msg) {
    new Assertion(val, msg, assert.isNotOk, true).is.not.ok;
  };

  /**
   * ### .equal(actual, expected, [message])
   *
   * Asserts non-strict equality (`==`) of `actual` and `expected`.
   *
   *     assert.equal(3, '3', '== coerces values to strings');
   *
   * @name equal
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.equal = function (act, exp, msg) {
    var test = new Assertion(act, msg, assert.equal, true);

    test.assert(
        exp == flag(test, 'object')
      , 'expected #{this} to equal #{exp}'
      , 'expected #{this} to not equal #{act}'
      , exp
      , act
      , true
    );
  };

  /**
   * ### .notEqual(actual, expected, [message])
   *
   * Asserts non-strict inequality (`!=`) of `actual` and `expected`.
   *
   *     assert.notEqual(3, 4, 'these numbers are not equal');
   *
   * @name notEqual
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notEqual = function (act, exp, msg) {
    var test = new Assertion(act, msg, assert.notEqual, true);

    test.assert(
        exp != flag(test, 'object')
      , 'expected #{this} to not equal #{exp}'
      , 'expected #{this} to equal #{act}'
      , exp
      , act
      , true
    );
  };

  /**
   * ### .strictEqual(actual, expected, [message])
   *
   * Asserts strict equality (`===`) of `actual` and `expected`.
   *
   *     assert.strictEqual(true, true, 'these booleans are strictly equal');
   *
   * @name strictEqual
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.strictEqual = function (act, exp, msg) {
    new Assertion(act, msg, assert.strictEqual, true).to.equal(exp);
  };

  /**
   * ### .notStrictEqual(actual, expected, [message])
   *
   * Asserts strict inequality (`!==`) of `actual` and `expected`.
   *
   *     assert.notStrictEqual(3, '3', 'no coercion for strict equality');
   *
   * @name notStrictEqual
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notStrictEqual = function (act, exp, msg) {
    new Assertion(act, msg, assert.notStrictEqual, true).to.not.equal(exp);
  };

  /**
   * ### .deepEqual(actual, expected, [message])
   *
   * Asserts that `actual` is deeply equal to `expected`.
   *
   *     assert.deepEqual({ tea: 'green' }, { tea: 'green' });
   *
   * @name deepEqual
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @alias deepStrictEqual
   * @namespace Assert
   * @api public
   */

  assert.deepEqual = assert.deepStrictEqual = function (act, exp, msg) {
    new Assertion(act, msg, assert.deepEqual, true).to.eql(exp);
  };

  /**
   * ### .notDeepEqual(actual, expected, [message])
   *
   * Assert that `actual` is not deeply equal to `expected`.
   *
   *     assert.notDeepEqual({ tea: 'green' }, { tea: 'jasmine' });
   *
   * @name notDeepEqual
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notDeepEqual = function (act, exp, msg) {
    new Assertion(act, msg, assert.notDeepEqual, true).to.not.eql(exp);
  };

   /**
   * ### .isAbove(valueToCheck, valueToBeAbove, [message])
   *
   * Asserts `valueToCheck` is strictly greater than (>) `valueToBeAbove`.
   *
   *     assert.isAbove(5, 2, '5 is strictly greater than 2');
   *
   * @name isAbove
   * @param {Mixed} valueToCheck
   * @param {Mixed} valueToBeAbove
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isAbove = function (val, abv, msg) {
    new Assertion(val, msg, assert.isAbove, true).to.be.above(abv);
  };

   /**
   * ### .isAtLeast(valueToCheck, valueToBeAtLeast, [message])
   *
   * Asserts `valueToCheck` is greater than or equal to (>=) `valueToBeAtLeast`.
   *
   *     assert.isAtLeast(5, 2, '5 is greater or equal to 2');
   *     assert.isAtLeast(3, 3, '3 is greater or equal to 3');
   *
   * @name isAtLeast
   * @param {Mixed} valueToCheck
   * @param {Mixed} valueToBeAtLeast
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isAtLeast = function (val, atlst, msg) {
    new Assertion(val, msg, assert.isAtLeast, true).to.be.least(atlst);
  };

   /**
   * ### .isBelow(valueToCheck, valueToBeBelow, [message])
   *
   * Asserts `valueToCheck` is strictly less than (<) `valueToBeBelow`.
   *
   *     assert.isBelow(3, 6, '3 is strictly less than 6');
   *
   * @name isBelow
   * @param {Mixed} valueToCheck
   * @param {Mixed} valueToBeBelow
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isBelow = function (val, blw, msg) {
    new Assertion(val, msg, assert.isBelow, true).to.be.below(blw);
  };

   /**
   * ### .isAtMost(valueToCheck, valueToBeAtMost, [message])
   *
   * Asserts `valueToCheck` is less than or equal to (<=) `valueToBeAtMost`.
   *
   *     assert.isAtMost(3, 6, '3 is less than or equal to 6');
   *     assert.isAtMost(4, 4, '4 is less than or equal to 4');
   *
   * @name isAtMost
   * @param {Mixed} valueToCheck
   * @param {Mixed} valueToBeAtMost
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isAtMost = function (val, atmst, msg) {
    new Assertion(val, msg, assert.isAtMost, true).to.be.most(atmst);
  };

  /**
   * ### .isTrue(value, [message])
   *
   * Asserts that `value` is true.
   *
   *     var teaServed = true;
   *     assert.isTrue(teaServed, 'the tea has been served');
   *
   * @name isTrue
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isTrue = function (val, msg) {
    new Assertion(val, msg, assert.isTrue, true).is['true'];
  };

  /**
   * ### .isNotTrue(value, [message])
   *
   * Asserts that `value` is not true.
   *
   *     var tea = 'tasty chai';
   *     assert.isNotTrue(tea, 'great, time for tea!');
   *
   * @name isNotTrue
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotTrue = function (val, msg) {
    new Assertion(val, msg, assert.isNotTrue, true).to.not.equal(true);
  };

  /**
   * ### .isFalse(value, [message])
   *
   * Asserts that `value` is false.
   *
   *     var teaServed = false;
   *     assert.isFalse(teaServed, 'no tea yet? hmm...');
   *
   * @name isFalse
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isFalse = function (val, msg) {
    new Assertion(val, msg, assert.isFalse, true).is['false'];
  };

  /**
   * ### .isNotFalse(value, [message])
   *
   * Asserts that `value` is not false.
   *
   *     var tea = 'tasty chai';
   *     assert.isNotFalse(tea, 'great, time for tea!');
   *
   * @name isNotFalse
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotFalse = function (val, msg) {
    new Assertion(val, msg, assert.isNotFalse, true).to.not.equal(false);
  };

  /**
   * ### .isNull(value, [message])
   *
   * Asserts that `value` is null.
   *
   *     assert.isNull(err, 'there was no error');
   *
   * @name isNull
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNull = function (val, msg) {
    new Assertion(val, msg, assert.isNull, true).to.equal(null);
  };

  /**
   * ### .isNotNull(value, [message])
   *
   * Asserts that `value` is not null.
   *
   *     var tea = 'tasty chai';
   *     assert.isNotNull(tea, 'great, time for tea!');
   *
   * @name isNotNull
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotNull = function (val, msg) {
    new Assertion(val, msg, assert.isNotNull, true).to.not.equal(null);
  };

  /**
   * ### .isNaN
   *
   * Asserts that value is NaN.
   *
   *     assert.isNaN(NaN, 'NaN is NaN');
   *
   * @name isNaN
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNaN = function (val, msg) {
    new Assertion(val, msg, assert.isNaN, true).to.be.NaN;
  };

  /**
   * ### .isNotNaN
   *
   * Asserts that value is not NaN.
   *
   *     assert.isNotNaN(4, '4 is not NaN');
   *
   * @name isNotNaN
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */
  assert.isNotNaN = function (val, msg) {
    new Assertion(val, msg, assert.isNotNaN, true).not.to.be.NaN;
  };

  /**
   * ### .exists
   *
   * Asserts that the target is neither `null` nor `undefined`.
   *
   *     var foo = 'hi';
   *
   *     assert.exists(foo, 'foo is neither `null` nor `undefined`');
   *
   * @name exists
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.exists = function (val, msg) {
    new Assertion(val, msg, assert.exists, true).to.exist;
  };

  /**
   * ### .notExists
   *
   * Asserts that the target is either `null` or `undefined`.
   *
   *     var bar = null
   *       , baz;
   *
   *     assert.notExists(bar);
   *     assert.notExists(baz, 'baz is either null or undefined');
   *
   * @name notExists
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notExists = function (val, msg) {
    new Assertion(val, msg, assert.notExists, true).to.not.exist;
  };

  /**
   * ### .isUndefined(value, [message])
   *
   * Asserts that `value` is `undefined`.
   *
   *     var tea;
   *     assert.isUndefined(tea, 'no tea defined');
   *
   * @name isUndefined
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isUndefined = function (val, msg) {
    new Assertion(val, msg, assert.isUndefined, true).to.equal(undefined);
  };

  /**
   * ### .isDefined(value, [message])
   *
   * Asserts that `value` is not `undefined`.
   *
   *     var tea = 'cup of chai';
   *     assert.isDefined(tea, 'tea has been defined');
   *
   * @name isDefined
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isDefined = function (val, msg) {
    new Assertion(val, msg, assert.isDefined, true).to.not.equal(undefined);
  };

  /**
   * ### .isFunction(value, [message])
   *
   * Asserts that `value` is a function.
   *
   *     function serveTea() { return 'cup of tea'; };
   *     assert.isFunction(serveTea, 'great, we can have tea now');
   *
   * @name isFunction
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isFunction = function (val, msg) {
    new Assertion(val, msg, assert.isFunction, true).to.be.a('function');
  };

  /**
   * ### .isNotFunction(value, [message])
   *
   * Asserts that `value` is _not_ a function.
   *
   *     var serveTea = [ 'heat', 'pour', 'sip' ];
   *     assert.isNotFunction(serveTea, 'great, we have listed the steps');
   *
   * @name isNotFunction
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotFunction = function (val, msg) {
    new Assertion(val, msg, assert.isNotFunction, true).to.not.be.a('function');
  };

  /**
   * ### .isObject(value, [message])
   *
   * Asserts that `value` is an object of type 'Object' (as revealed by `Object.prototype.toString`).
   * _The assertion does not match subclassed objects._
   *
   *     var selection = { name: 'Chai', serve: 'with spices' };
   *     assert.isObject(selection, 'tea selection is an object');
   *
   * @name isObject
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isObject = function (val, msg) {
    new Assertion(val, msg, assert.isObject, true).to.be.a('object');
  };

  /**
   * ### .isNotObject(value, [message])
   *
   * Asserts that `value` is _not_ an object of type 'Object' (as revealed by `Object.prototype.toString`).
   *
   *     var selection = 'chai'
   *     assert.isNotObject(selection, 'tea selection is not an object');
   *     assert.isNotObject(null, 'null is not an object');
   *
   * @name isNotObject
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotObject = function (val, msg) {
    new Assertion(val, msg, assert.isNotObject, true).to.not.be.a('object');
  };

  /**
   * ### .isArray(value, [message])
   *
   * Asserts that `value` is an array.
   *
   *     var menu = [ 'green', 'chai', 'oolong' ];
   *     assert.isArray(menu, 'what kind of tea do we want?');
   *
   * @name isArray
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isArray = function (val, msg) {
    new Assertion(val, msg, assert.isArray, true).to.be.an('array');
  };

  /**
   * ### .isNotArray(value, [message])
   *
   * Asserts that `value` is _not_ an array.
   *
   *     var menu = 'green|chai|oolong';
   *     assert.isNotArray(menu, 'what kind of tea do we want?');
   *
   * @name isNotArray
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotArray = function (val, msg) {
    new Assertion(val, msg, assert.isNotArray, true).to.not.be.an('array');
  };

  /**
   * ### .isString(value, [message])
   *
   * Asserts that `value` is a string.
   *
   *     var teaOrder = 'chai';
   *     assert.isString(teaOrder, 'order placed');
   *
   * @name isString
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isString = function (val, msg) {
    new Assertion(val, msg, assert.isString, true).to.be.a('string');
  };

  /**
   * ### .isNotString(value, [message])
   *
   * Asserts that `value` is _not_ a string.
   *
   *     var teaOrder = 4;
   *     assert.isNotString(teaOrder, 'order placed');
   *
   * @name isNotString
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotString = function (val, msg) {
    new Assertion(val, msg, assert.isNotString, true).to.not.be.a('string');
  };

  /**
   * ### .isNumber(value, [message])
   *
   * Asserts that `value` is a number.
   *
   *     var cups = 2;
   *     assert.isNumber(cups, 'how many cups');
   *
   * @name isNumber
   * @param {Number} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNumber = function (val, msg) {
    new Assertion(val, msg, assert.isNumber, true).to.be.a('number');
  };

  /**
   * ### .isNotNumber(value, [message])
   *
   * Asserts that `value` is _not_ a number.
   *
   *     var cups = '2 cups please';
   *     assert.isNotNumber(cups, 'how many cups');
   *
   * @name isNotNumber
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotNumber = function (val, msg) {
    new Assertion(val, msg, assert.isNotNumber, true).to.not.be.a('number');
  };

   /**
   * ### .isFinite(value, [message])
   *
   * Asserts that `value` is a finite number. Unlike `.isNumber`, this will fail for `NaN` and `Infinity`.
   *
   *     var cups = 2;
   *     assert.isFinite(cups, 'how many cups');
   *
   *     assert.isFinite(NaN); // throws
   *
   * @name isFinite
   * @param {Number} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isFinite = function (val, msg) {
    new Assertion(val, msg, assert.isFinite, true).to.be.finite;
  };

  /**
   * ### .isBoolean(value, [message])
   *
   * Asserts that `value` is a boolean.
   *
   *     var teaReady = true
   *       , teaServed = false;
   *
   *     assert.isBoolean(teaReady, 'is the tea ready');
   *     assert.isBoolean(teaServed, 'has tea been served');
   *
   * @name isBoolean
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isBoolean = function (val, msg) {
    new Assertion(val, msg, assert.isBoolean, true).to.be.a('boolean');
  };

  /**
   * ### .isNotBoolean(value, [message])
   *
   * Asserts that `value` is _not_ a boolean.
   *
   *     var teaReady = 'yep'
   *       , teaServed = 'nope';
   *
   *     assert.isNotBoolean(teaReady, 'is the tea ready');
   *     assert.isNotBoolean(teaServed, 'has tea been served');
   *
   * @name isNotBoolean
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.isNotBoolean = function (val, msg) {
    new Assertion(val, msg, assert.isNotBoolean, true).to.not.be.a('boolean');
  };

  /**
   * ### .typeOf(value, name, [message])
   *
   * Asserts that `value`'s type is `name`, as determined by
   * `Object.prototype.toString`.
   *
   *     assert.typeOf({ tea: 'chai' }, 'object', 'we have an object');
   *     assert.typeOf(['chai', 'jasmine'], 'array', 'we have an array');
   *     assert.typeOf('tea', 'string', 'we have a string');
   *     assert.typeOf(/tea/, 'regexp', 'we have a regular expression');
   *     assert.typeOf(null, 'null', 'we have a null');
   *     assert.typeOf(undefined, 'undefined', 'we have an undefined');
   *
   * @name typeOf
   * @param {Mixed} value
   * @param {String} name
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.typeOf = function (val, type, msg) {
    new Assertion(val, msg, assert.typeOf, true).to.be.a(type);
  };

  /**
   * ### .notTypeOf(value, name, [message])
   *
   * Asserts that `value`'s type is _not_ `name`, as determined by
   * `Object.prototype.toString`.
   *
   *     assert.notTypeOf('tea', 'number', 'strings are not numbers');
   *
   * @name notTypeOf
   * @param {Mixed} value
   * @param {String} typeof name
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notTypeOf = function (val, type, msg) {
    new Assertion(val, msg, assert.notTypeOf, true).to.not.be.a(type);
  };

  /**
   * ### .instanceOf(object, constructor, [message])
   *
   * Asserts that `value` is an instance of `constructor`.
   *
   *     var Tea = function (name) { this.name = name; }
   *       , chai = new Tea('chai');
   *
   *     assert.instanceOf(chai, Tea, 'chai is an instance of tea');
   *
   * @name instanceOf
   * @param {Object} object
   * @param {Constructor} constructor
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.instanceOf = function (val, type, msg) {
    new Assertion(val, msg, assert.instanceOf, true).to.be.instanceOf(type);
  };

  /**
   * ### .notInstanceOf(object, constructor, [message])
   *
   * Asserts `value` is not an instance of `constructor`.
   *
   *     var Tea = function (name) { this.name = name; }
   *       , chai = new String('chai');
   *
   *     assert.notInstanceOf(chai, Tea, 'chai is not an instance of tea');
   *
   * @name notInstanceOf
   * @param {Object} object
   * @param {Constructor} constructor
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notInstanceOf = function (val, type, msg) {
    new Assertion(val, msg, assert.notInstanceOf, true)
      .to.not.be.instanceOf(type);
  };

  /**
   * ### .include(haystack, needle, [message])
   *
   * Asserts that `haystack` includes `needle`. Can be used to assert the
   * inclusion of a value in an array, a substring in a string, or a subset of
   * properties in an object.
   *
   *     assert.include([1,2,3], 2, 'array contains value');
   *     assert.include('foobar', 'foo', 'string contains substring');
   *     assert.include({ foo: 'bar', hello: 'universe' }, { foo: 'bar' }, 'object contains property');
   *
   * Strict equality (===) is used. When asserting the inclusion of a value in
   * an array, the array is searched for an element that's strictly equal to the
   * given value. When asserting a subset of properties in an object, the object
   * is searched for the given property keys, checking that each one is present
   * and strictly equal to the given property value. For instance:
   *
   *     var obj1 = {a: 1}
   *       , obj2 = {b: 2};
   *     assert.include([obj1, obj2], obj1);
   *     assert.include({foo: obj1, bar: obj2}, {foo: obj1});
   *     assert.include({foo: obj1, bar: obj2}, {foo: obj1, bar: obj2});
   *
   * @name include
   * @param {Array|String} haystack
   * @param {Mixed} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.include = function (exp, inc, msg) {
    new Assertion(exp, msg, assert.include, true).include(inc);
  };

  /**
   * ### .notInclude(haystack, needle, [message])
   *
   * Asserts that `haystack` does not include `needle`. Can be used to assert
   * the absence of a value in an array, a substring in a string, or a subset of
   * properties in an object.
   *
   *     assert.notInclude([1,2,3], 4, "array doesn't contain value");
   *     assert.notInclude('foobar', 'baz', "string doesn't contain substring");
   *     assert.notInclude({ foo: 'bar', hello: 'universe' }, { foo: 'baz' }, 'object doesn't contain property');
   *
   * Strict equality (===) is used. When asserting the absence of a value in an
   * array, the array is searched to confirm the absence of an element that's
   * strictly equal to the given value. When asserting a subset of properties in
   * an object, the object is searched to confirm that at least one of the given
   * property keys is either not present or not strictly equal to the given
   * property value. For instance:
   *
   *     var obj1 = {a: 1}
   *       , obj2 = {b: 2};
   *     assert.notInclude([obj1, obj2], {a: 1});
   *     assert.notInclude({foo: obj1, bar: obj2}, {foo: {a: 1}});
   *     assert.notInclude({foo: obj1, bar: obj2}, {foo: obj1, bar: {b: 2}});
   *
   * @name notInclude
   * @param {Array|String} haystack
   * @param {Mixed} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notInclude = function (exp, inc, msg) {
    new Assertion(exp, msg, assert.notInclude, true).not.include(inc);
  };

  /**
   * ### .deepInclude(haystack, needle, [message])
   *
   * Asserts that `haystack` includes `needle`. Can be used to assert the
   * inclusion of a value in an array or a subset of properties in an object.
   * Deep equality is used.
   *
   *     var obj1 = {a: 1}
   *       , obj2 = {b: 2};
   *     assert.deepInclude([obj1, obj2], {a: 1});
   *     assert.deepInclude({foo: obj1, bar: obj2}, {foo: {a: 1}});
   *     assert.deepInclude({foo: obj1, bar: obj2}, {foo: {a: 1}, bar: {b: 2}});
   *
   * @name deepInclude
   * @param {Array|String} haystack
   * @param {Mixed} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.deepInclude = function (exp, inc, msg) {
    new Assertion(exp, msg, assert.deepInclude, true).deep.include(inc);
  };

  /**
   * ### .notDeepInclude(haystack, needle, [message])
   *
   * Asserts that `haystack` does not include `needle`. Can be used to assert
   * the absence of a value in an array or a subset of properties in an object.
   * Deep equality is used.
   *
   *     var obj1 = {a: 1}
   *       , obj2 = {b: 2};
   *     assert.notDeepInclude([obj1, obj2], {a: 9});
   *     assert.notDeepInclude({foo: obj1, bar: obj2}, {foo: {a: 9}});
   *     assert.notDeepInclude({foo: obj1, bar: obj2}, {foo: {a: 1}, bar: {b: 9}});
   *
   * @name notDeepInclude
   * @param {Array|String} haystack
   * @param {Mixed} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notDeepInclude = function (exp, inc, msg) {
    new Assertion(exp, msg, assert.notDeepInclude, true).not.deep.include(inc);
  };

  /**
   * ### .nestedInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' includes 'needle'.
   * Can be used to assert the inclusion of a subset of properties in an
   * object.
   * Enables the use of dot- and bracket-notation for referencing nested
   * properties.
   * '[]' and '.' in property names can be escaped using double backslashes.
   *
   *     assert.nestedInclude({'.a': {'b': 'x'}}, {'\\.a.[b]': 'x'});
   *     assert.nestedInclude({'a': {'[b]': 'x'}}, {'a.\\[b\\]': 'x'});
   *
   * @name nestedInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.nestedInclude = function (exp, inc, msg) {
    new Assertion(exp, msg, assert.nestedInclude, true).nested.include(inc);
  };

  /**
   * ### .notNestedInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' does not include 'needle'.
   * Can be used to assert the absence of a subset of properties in an
   * object.
   * Enables the use of dot- and bracket-notation for referencing nested
   * properties.
   * '[]' and '.' in property names can be escaped using double backslashes.
   *
   *     assert.notNestedInclude({'.a': {'b': 'x'}}, {'\\.a.b': 'y'});
   *     assert.notNestedInclude({'a': {'[b]': 'x'}}, {'a.\\[b\\]': 'y'});
   *
   * @name notNestedInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notNestedInclude = function (exp, inc, msg) {
    new Assertion(exp, msg, assert.notNestedInclude, true)
      .not.nested.include(inc);
  };

  /**
   * ### .deepNestedInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' includes 'needle'.
   * Can be used to assert the inclusion of a subset of properties in an
   * object while checking for deep equality.
   * Enables the use of dot- and bracket-notation for referencing nested
   * properties.
   * '[]' and '.' in property names can be escaped using double backslashes.
   *
   *     assert.deepNestedInclude({a: {b: [{x: 1}]}}, {'a.b[0]': {x: 1}});
   *     assert.deepNestedInclude({'.a': {'[b]': {x: 1}}}, {'\\.a.\\[b\\]': {x: 1}});
   *
   * @name deepNestedInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.deepNestedInclude = function(exp, inc, msg) {
    new Assertion(exp, msg, assert.deepNestedInclude, true)
      .deep.nested.include(inc);
  };

  /**
   * ### .notDeepNestedInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' does not include 'needle'.
   * Can be used to assert the absence of a subset of properties in an
   * object while checking for deep equality.
   * Enables the use of dot- and bracket-notation for referencing nested
   * properties.
   * '[]' and '.' in property names can be escaped using double backslashes.
   *
   *     assert.notDeepNestedInclude({a: {b: [{x: 1}]}}, {'a.b[0]': {y: 1}})
   *     assert.notDeepNestedInclude({'.a': {'[b]': {x: 1}}}, {'\\.a.\\[b\\]': {y: 2}});
   *
   * @name notDeepNestedInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notDeepNestedInclude = function(exp, inc, msg) {
    new Assertion(exp, msg, assert.notDeepNestedInclude, true)
      .not.deep.nested.include(inc);
  };

  /**
   * ### .ownInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' includes 'needle'.
   * Can be used to assert the inclusion of a subset of properties in an
   * object while ignoring inherited properties.
   *
   *     assert.ownInclude({ a: 1 }, { a: 1 });
   *
   * @name ownInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.ownInclude = function(exp, inc, msg) {
    new Assertion(exp, msg, assert.ownInclude, true).own.include(inc);
  };

  /**
   * ### .notOwnInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' includes 'needle'.
   * Can be used to assert the absence of a subset of properties in an
   * object while ignoring inherited properties.
   *
   *     Object.prototype.b = 2;
   *
   *     assert.notOwnInclude({ a: 1 }, { b: 2 });
   *
   * @name notOwnInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notOwnInclude = function(exp, inc, msg) {
    new Assertion(exp, msg, assert.notOwnInclude, true).not.own.include(inc);
  };

  /**
   * ### .deepOwnInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' includes 'needle'.
   * Can be used to assert the inclusion of a subset of properties in an
   * object while ignoring inherited properties and checking for deep equality.
   *
   *      assert.deepOwnInclude({a: {b: 2}}, {a: {b: 2}});
   *
   * @name deepOwnInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.deepOwnInclude = function(exp, inc, msg) {
    new Assertion(exp, msg, assert.deepOwnInclude, true)
      .deep.own.include(inc);
  };

   /**
   * ### .notDeepOwnInclude(haystack, needle, [message])
   *
   * Asserts that 'haystack' includes 'needle'.
   * Can be used to assert the absence of a subset of properties in an
   * object while ignoring inherited properties and checking for deep equality.
   *
   *      assert.notDeepOwnInclude({a: {b: 2}}, {a: {c: 3}});
   *
   * @name notDeepOwnInclude
   * @param {Object} haystack
   * @param {Object} needle
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notDeepOwnInclude = function(exp, inc, msg) {
    new Assertion(exp, msg, assert.notDeepOwnInclude, true)
      .not.deep.own.include(inc);
  };

  /**
   * ### .match(value, regexp, [message])
   *
   * Asserts that `value` matches the regular expression `regexp`.
   *
   *     assert.match('foobar', /^foo/, 'regexp matches');
   *
   * @name match
   * @param {Mixed} value
   * @param {RegExp} regexp
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.match = function (exp, re, msg) {
    new Assertion(exp, msg, assert.match, true).to.match(re);
  };

  /**
   * ### .notMatch(value, regexp, [message])
   *
   * Asserts that `value` does not match the regular expression `regexp`.
   *
   *     assert.notMatch('foobar', /^foo/, 'regexp does not match');
   *
   * @name notMatch
   * @param {Mixed} value
   * @param {RegExp} regexp
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notMatch = function (exp, re, msg) {
    new Assertion(exp, msg, assert.notMatch, true).to.not.match(re);
  };

  /**
   * ### .property(object, property, [message])
   *
   * Asserts that `object` has a direct or inherited property named by
   * `property`.
   *
   *     assert.property({ tea: { green: 'matcha' }}, 'tea');
   *     assert.property({ tea: { green: 'matcha' }}, 'toString');
   *
   * @name property
   * @param {Object} object
   * @param {String} property
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.property = function (obj, prop, msg) {
    new Assertion(obj, msg, assert.property, true).to.have.property(prop);
  };

  /**
   * ### .notProperty(object, property, [message])
   *
   * Asserts that `object` does _not_ have a direct or inherited property named
   * by `property`.
   *
   *     assert.notProperty({ tea: { green: 'matcha' }}, 'coffee');
   *
   * @name notProperty
   * @param {Object} object
   * @param {String} property
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notProperty = function (obj, prop, msg) {
    new Assertion(obj, msg, assert.notProperty, true)
      .to.not.have.property(prop);
  };

  /**
   * ### .propertyVal(object, property, value, [message])
   *
   * Asserts that `object` has a direct or inherited property named by
   * `property` with a value given by `value`. Uses a strict equality check
   * (===).
   *
   *     assert.propertyVal({ tea: 'is good' }, 'tea', 'is good');
   *
   * @name propertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.propertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.propertyVal, true)
      .to.have.property(prop, val);
  };

  /**
   * ### .notPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` does _not_ have a direct or inherited property named
   * by `property` with value given by `value`. Uses a strict equality check
   * (===).
   *
   *     assert.notPropertyVal({ tea: 'is good' }, 'tea', 'is bad');
   *     assert.notPropertyVal({ tea: 'is good' }, 'coffee', 'is good');
   *
   * @name notPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.notPropertyVal, true)
      .to.not.have.property(prop, val);
  };

  /**
   * ### .deepPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` has a direct or inherited property named by
   * `property` with a value given by `value`. Uses a deep equality check.
   *
   *     assert.deepPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'matcha' });
   *
   * @name deepPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.deepPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.deepPropertyVal, true)
      .to.have.deep.property(prop, val);
  };

  /**
   * ### .notDeepPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` does _not_ have a direct or inherited property named
   * by `property` with value given by `value`. Uses a deep equality check.
   *
   *     assert.notDeepPropertyVal({ tea: { green: 'matcha' } }, 'tea', { black: 'matcha' });
   *     assert.notDeepPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'oolong' });
   *     assert.notDeepPropertyVal({ tea: { green: 'matcha' } }, 'coffee', { green: 'matcha' });
   *
   * @name notDeepPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notDeepPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.notDeepPropertyVal, true)
      .to.not.have.deep.property(prop, val);
  };

  /**
   * ### .ownProperty(object, property, [message])
   *
   * Asserts that `object` has a direct property named by `property`. Inherited
   * properties aren't checked.
   *
   *     assert.ownProperty({ tea: { green: 'matcha' }}, 'tea');
   *
   * @name ownProperty
   * @param {Object} object
   * @param {String} property
   * @param {String} message
   * @api public
   */

  assert.ownProperty = function (obj, prop, msg) {
    new Assertion(obj, msg, assert.ownProperty, true)
      .to.have.own.property(prop);
  };

  /**
   * ### .notOwnProperty(object, property, [message])
   *
   * Asserts that `object` does _not_ have a direct property named by
   * `property`. Inherited properties aren't checked.
   *
   *     assert.notOwnProperty({ tea: { green: 'matcha' }}, 'coffee');
   *     assert.notOwnProperty({}, 'toString');
   *
   * @name notOwnProperty
   * @param {Object} object
   * @param {String} property
   * @param {String} message
   * @api public
   */

  assert.notOwnProperty = function (obj, prop, msg) {
    new Assertion(obj, msg, assert.notOwnProperty, true)
      .to.not.have.own.property(prop);
  };

  /**
   * ### .ownPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` has a direct property named by `property` and a value
   * equal to the provided `value`. Uses a strict equality check (===).
   * Inherited properties aren't checked.
   *
   *     assert.ownPropertyVal({ coffee: 'is good'}, 'coffee', 'is good');
   *
   * @name ownPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @api public
   */

  assert.ownPropertyVal = function (obj, prop, value, msg) {
    new Assertion(obj, msg, assert.ownPropertyVal, true)
      .to.have.own.property(prop, value);
  };

  /**
   * ### .notOwnPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` does _not_ have a direct property named by `property`
   * with a value equal to the provided `value`. Uses a strict equality check
   * (===). Inherited properties aren't checked.
   *
   *     assert.notOwnPropertyVal({ tea: 'is better'}, 'tea', 'is worse');
   *     assert.notOwnPropertyVal({}, 'toString', Object.prototype.toString);
   *
   * @name notOwnPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @api public
   */

  assert.notOwnPropertyVal = function (obj, prop, value, msg) {
    new Assertion(obj, msg, assert.notOwnPropertyVal, true)
      .to.not.have.own.property(prop, value);
  };

  /**
   * ### .deepOwnPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` has a direct property named by `property` and a value
   * equal to the provided `value`. Uses a deep equality check. Inherited
   * properties aren't checked.
   *
   *     assert.deepOwnPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'matcha' });
   *
   * @name deepOwnPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @api public
   */

  assert.deepOwnPropertyVal = function (obj, prop, value, msg) {
    new Assertion(obj, msg, assert.deepOwnPropertyVal, true)
      .to.have.deep.own.property(prop, value);
  };

  /**
   * ### .notDeepOwnPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` does _not_ have a direct property named by `property`
   * with a value equal to the provided `value`. Uses a deep equality check.
   * Inherited properties aren't checked.
   *
   *     assert.notDeepOwnPropertyVal({ tea: { green: 'matcha' } }, 'tea', { black: 'matcha' });
   *     assert.notDeepOwnPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'oolong' });
   *     assert.notDeepOwnPropertyVal({ tea: { green: 'matcha' } }, 'coffee', { green: 'matcha' });
   *     assert.notDeepOwnPropertyVal({}, 'toString', Object.prototype.toString);
   *
   * @name notDeepOwnPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @api public
   */

  assert.notDeepOwnPropertyVal = function (obj, prop, value, msg) {
    new Assertion(obj, msg, assert.notDeepOwnPropertyVal, true)
      .to.not.have.deep.own.property(prop, value);
  };

  /**
   * ### .nestedProperty(object, property, [message])
   *
   * Asserts that `object` has a direct or inherited property named by
   * `property`, which can be a string using dot- and bracket-notation for
   * nested reference.
   *
   *     assert.nestedProperty({ tea: { green: 'matcha' }}, 'tea.green');
   *
   * @name nestedProperty
   * @param {Object} object
   * @param {String} property
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.nestedProperty = function (obj, prop, msg) {
    new Assertion(obj, msg, assert.nestedProperty, true)
      .to.have.nested.property(prop);
  };

  /**
   * ### .notNestedProperty(object, property, [message])
   *
   * Asserts that `object` does _not_ have a property named by `property`, which
   * can be a string using dot- and bracket-notation for nested reference. The
   * property cannot exist on the object nor anywhere in its prototype chain.
   *
   *     assert.notNestedProperty({ tea: { green: 'matcha' }}, 'tea.oolong');
   *
   * @name notNestedProperty
   * @param {Object} object
   * @param {String} property
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notNestedProperty = function (obj, prop, msg) {
    new Assertion(obj, msg, assert.notNestedProperty, true)
      .to.not.have.nested.property(prop);
  };

  /**
   * ### .nestedPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` has a property named by `property` with value given
   * by `value`. `property` can use dot- and bracket-notation for nested
   * reference. Uses a strict equality check (===).
   *
   *     assert.nestedPropertyVal({ tea: { green: 'matcha' }}, 'tea.green', 'matcha');
   *
   * @name nestedPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.nestedPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.nestedPropertyVal, true)
      .to.have.nested.property(prop, val);
  };

  /**
   * ### .notNestedPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` does _not_ have a property named by `property` with
   * value given by `value`. `property` can use dot- and bracket-notation for
   * nested reference. Uses a strict equality check (===).
   *
   *     assert.notNestedPropertyVal({ tea: { green: 'matcha' }}, 'tea.green', 'konacha');
   *     assert.notNestedPropertyVal({ tea: { green: 'matcha' }}, 'coffee.green', 'matcha');
   *
   * @name notNestedPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notNestedPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.notNestedPropertyVal, true)
      .to.not.have.nested.property(prop, val);
  };

  /**
   * ### .deepNestedPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` has a property named by `property` with a value given
   * by `value`. `property` can use dot- and bracket-notation for nested
   * reference. Uses a deep equality check.
   *
   *     assert.deepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.green', { matcha: 'yum' });
   *
   * @name deepNestedPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.deepNestedPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.deepNestedPropertyVal, true)
      .to.have.deep.nested.property(prop, val);
  };

  /**
   * ### .notDeepNestedPropertyVal(object, property, value, [message])
   *
   * Asserts that `object` does _not_ have a property named by `property` with
   * value given by `value`. `property` can use dot- and bracket-notation for
   * nested reference. Uses a deep equality check.
   *
   *     assert.notDeepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.green', { oolong: 'yum' });
   *     assert.notDeepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.green', { matcha: 'yuck' });
   *     assert.notDeepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.black', { matcha: 'yum' });
   *
   * @name notDeepNestedPropertyVal
   * @param {Object} object
   * @param {String} property
   * @param {Mixed} value
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notDeepNestedPropertyVal = function (obj, prop, val, msg) {
    new Assertion(obj, msg, assert.notDeepNestedPropertyVal, true)
      .to.not.have.deep.nested.property(prop, val);
  }

  /**
   * ### .lengthOf(object, length, [message])
   *
   * Asserts that `object` has a `length` or `size` with the expected value.
   *
   *     assert.lengthOf([1,2,3], 3, 'array has length of 3');
   *     assert.lengthOf('foobar', 6, 'string has length of 6');
   *     assert.lengthOf(new Set([1,2,3]), 3, 'set has size of 3');
   *     assert.lengthOf(new Map([['a',1],['b',2],['c',3]]), 3, 'map has size of 3');
   *
   * @name lengthOf
   * @param {Mixed} object
   * @param {Number} length
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.lengthOf = function (exp, len, msg) {
    new Assertion(exp, msg, assert.lengthOf, true).to.have.lengthOf(len);
  };

  /**
   * ### .hasAnyKeys(object, [keys], [message])
   *
   * Asserts that `object` has at least one of the `keys` provided.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.hasAnyKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'iDontExist', 'baz']);
   *     assert.hasAnyKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, iDontExist: 99, baz: 1337});
   *     assert.hasAnyKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}, 'key']);
   *     assert.hasAnyKeys(new Set([{foo: 'bar'}, 'anotherKey']), [{foo: 'bar'}, 'anotherKey']);
   *
   * @name hasAnyKeys
   * @param {Mixed} object
   * @param {Array|Object} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.hasAnyKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.hasAnyKeys, true).to.have.any.keys(keys);
  }

  /**
   * ### .hasAllKeys(object, [keys], [message])
   *
   * Asserts that `object` has all and only all of the `keys` provided.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.hasAllKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'bar', 'baz']);
   *     assert.hasAllKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, bar: 99, baz: 1337]);
   *     assert.hasAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}, 'key']);
   *     assert.hasAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{foo: 'bar'}, 'anotherKey']);
   *
   * @name hasAllKeys
   * @param {Mixed} object
   * @param {String[]} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.hasAllKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.hasAllKeys, true).to.have.all.keys(keys);
  }

  /**
   * ### .containsAllKeys(object, [keys], [message])
   *
   * Asserts that `object` has all of the `keys` provided but may have more keys not listed.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'baz']);
   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'bar', 'baz']);
   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, baz: 1337});
   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, bar: 99, baz: 1337});
   *     assert.containsAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}]);
   *     assert.containsAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}, 'key']);
   *     assert.containsAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{foo: 'bar'}]);
   *     assert.containsAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{foo: 'bar'}, 'anotherKey']);
   *
   * @name containsAllKeys
   * @param {Mixed} object
   * @param {String[]} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.containsAllKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.containsAllKeys, true)
      .to.contain.all.keys(keys);
  }

  /**
   * ### .doesNotHaveAnyKeys(object, [keys], [message])
   *
   * Asserts that `object` has none of the `keys` provided.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.doesNotHaveAnyKeys({foo: 1, bar: 2, baz: 3}, ['one', 'two', 'example']);
   *     assert.doesNotHaveAnyKeys({foo: 1, bar: 2, baz: 3}, {one: 1, two: 2, example: 'foo'});
   *     assert.doesNotHaveAnyKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{one: 'two'}, 'example']);
   *     assert.doesNotHaveAnyKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{one: 'two'}, 'example']);
   *
   * @name doesNotHaveAnyKeys
   * @param {Mixed} object
   * @param {String[]} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.doesNotHaveAnyKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.doesNotHaveAnyKeys, true)
      .to.not.have.any.keys(keys);
  }

  /**
   * ### .doesNotHaveAllKeys(object, [keys], [message])
   *
   * Asserts that `object` does not have at least one of the `keys` provided.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.doesNotHaveAllKeys({foo: 1, bar: 2, baz: 3}, ['one', 'two', 'example']);
   *     assert.doesNotHaveAllKeys({foo: 1, bar: 2, baz: 3}, {one: 1, two: 2, example: 'foo'});
   *     assert.doesNotHaveAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{one: 'two'}, 'example']);
   *     assert.doesNotHaveAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{one: 'two'}, 'example']);
   *
   * @name doesNotHaveAllKeys
   * @param {Mixed} object
   * @param {String[]} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.doesNotHaveAllKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.doesNotHaveAllKeys, true)
      .to.not.have.all.keys(keys);
  }

  /**
   * ### .hasAnyDeepKeys(object, [keys], [message])
   *
   * Asserts that `object` has at least one of the `keys` provided.
   * Since Sets and Maps can have objects as keys you can use this assertion to perform
   * a deep comparison.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.hasAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {one: 'one'});
   *     assert.hasAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), [{one: 'one'}, {two: 'two'}]);
   *     assert.hasAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{one: 'one'}, {two: 'two'}]);
   *     assert.hasAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {one: 'one'});
   *     assert.hasAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {three: 'three'}]);
   *     assert.hasAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {two: 'two'}]);
   *
   * @name hasAnyDeepKeys
   * @param {Mixed} object
   * @param {Array|Object} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.hasAnyDeepKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.hasAnyDeepKeys, true)
      .to.have.any.deep.keys(keys);
  }

 /**
   * ### .hasAllDeepKeys(object, [keys], [message])
   *
   * Asserts that `object` has all and only all of the `keys` provided.
   * Since Sets and Maps can have objects as keys you can use this assertion to perform
   * a deep comparison.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.hasAllDeepKeys(new Map([[{one: 'one'}, 'valueOne']]), {one: 'one'});
   *     assert.hasAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{one: 'one'}, {two: 'two'}]);
   *     assert.hasAllDeepKeys(new Set([{one: 'one'}]), {one: 'one'});
   *     assert.hasAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {two: 'two'}]);
   *
   * @name hasAllDeepKeys
   * @param {Mixed} object
   * @param {Array|Object} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.hasAllDeepKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.hasAllDeepKeys, true)
      .to.have.all.deep.keys(keys);
  }

 /**
   * ### .containsAllDeepKeys(object, [keys], [message])
   *
   * Asserts that `object` contains all of the `keys` provided.
   * Since Sets and Maps can have objects as keys you can use this assertion to perform
   * a deep comparison.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.containsAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {one: 'one'});
   *     assert.containsAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{one: 'one'}, {two: 'two'}]);
   *     assert.containsAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {one: 'one'});
   *     assert.containsAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {two: 'two'}]);
   *
   * @name containsAllDeepKeys
   * @param {Mixed} object
   * @param {Array|Object} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.containsAllDeepKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.containsAllDeepKeys, true)
      .to.contain.all.deep.keys(keys);
  }

 /**
   * ### .doesNotHaveAnyDeepKeys(object, [keys], [message])
   *
   * Asserts that `object` has none of the `keys` provided.
   * Since Sets and Maps can have objects as keys you can use this assertion to perform
   * a deep comparison.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.doesNotHaveAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {thisDoesNot: 'exist'});
   *     assert.doesNotHaveAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{twenty: 'twenty'}, {fifty: 'fifty'}]);
   *     assert.doesNotHaveAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {twenty: 'twenty'});
   *     assert.doesNotHaveAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{twenty: 'twenty'}, {fifty: 'fifty'}]);
   *
   * @name doesNotHaveAnyDeepKeys
   * @param {Mixed} object
   * @param {Array|Object} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.doesNotHaveAnyDeepKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.doesNotHaveAnyDeepKeys, true)
      .to.not.have.any.deep.keys(keys);
  }

 /**
   * ### .doesNotHaveAllDeepKeys(object, [keys], [message])
   *
   * Asserts that `object` does not have at least one of the `keys` provided.
   * Since Sets and Maps can have objects as keys you can use this assertion to perform
   * a deep comparison.
   * You can also provide a single object instead of a `keys` array and its keys
   * will be used as the expected set of keys.
   *
   *     assert.doesNotHaveAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {thisDoesNot: 'exist'});
   *     assert.doesNotHaveAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{twenty: 'twenty'}, {one: 'one'}]);
   *     assert.doesNotHaveAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {twenty: 'twenty'});
   *     assert.doesNotHaveAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {fifty: 'fifty'}]);
   *
   * @name doesNotHaveAllDeepKeys
   * @param {Mixed} object
   * @param {Array|Object} keys
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.doesNotHaveAllDeepKeys = function (obj, keys, msg) {
    new Assertion(obj, msg, assert.doesNotHaveAllDeepKeys, true)
      .to.not.have.all.deep.keys(keys);
  }

 /**
   * ### .throws(fn, [errorLike/string/regexp], [string/regexp], [message])
   *
   * If `errorLike` is an `Error` constructor, asserts that `fn` will throw an error that is an
   * instance of `errorLike`.
   * If `errorLike` is an `Error` instance, asserts that the error thrown is the same
   * instance as `errorLike`.
   * If `errMsgMatcher` is provided, it also asserts that the error thrown will have a
   * message matching `errMsgMatcher`.
   *
   *     assert.throws(fn, 'Error thrown must have this msg');
   *     assert.throws(fn, /Error thrown must have a msg that matches this/);
   *     assert.throws(fn, ReferenceError);
   *     assert.throws(fn, errorInstance);
   *     assert.throws(fn, ReferenceError, 'Error thrown must be a ReferenceError and have this msg');
   *     assert.throws(fn, errorInstance, 'Error thrown must be the same errorInstance and have this msg');
   *     assert.throws(fn, ReferenceError, /Error thrown must be a ReferenceError and match this/);
   *     assert.throws(fn, errorInstance, /Error thrown must be the same errorInstance and match this/);
   *
   * @name throws
   * @alias throw
   * @alias Throw
   * @param {Function} fn
   * @param {ErrorConstructor|Error} errorLike
   * @param {RegExp|String} errMsgMatcher
   * @param {String} message
   * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
   * @namespace Assert
   * @api public
   */

  assert.throws = function (fn, errorLike, errMsgMatcher, msg) {
    if ('string' === typeof errorLike || errorLike instanceof RegExp) {
      errMsgMatcher = errorLike;
      errorLike = null;
    }

    var assertErr = new Assertion(fn, msg, assert.throws, true)
      .to.throw(errorLike, errMsgMatcher);
    return flag(assertErr, 'object');
  };

  /**
   * ### .doesNotThrow(fn, [errorLike/string/regexp], [string/regexp], [message])
   *
   * If `errorLike` is an `Error` constructor, asserts that `fn` will _not_ throw an error that is an
   * instance of `errorLike`.
   * If `errorLike` is an `Error` instance, asserts that the error thrown is _not_ the same
   * instance as `errorLike`.
   * If `errMsgMatcher` is provided, it also asserts that the error thrown will _not_ have a
   * message matching `errMsgMatcher`.
   *
   *     assert.doesNotThrow(fn, 'Any Error thrown must not have this message');
   *     assert.doesNotThrow(fn, /Any Error thrown must not match this/);
   *     assert.doesNotThrow(fn, Error);
   *     assert.doesNotThrow(fn, errorInstance);
   *     assert.doesNotThrow(fn, Error, 'Error must not have this message');
   *     assert.doesNotThrow(fn, errorInstance, 'Error must not have this message');
   *     assert.doesNotThrow(fn, Error, /Error must not match this/);
   *     assert.doesNotThrow(fn, errorInstance, /Error must not match this/);
   *
   * @name doesNotThrow
   * @param {Function} fn
   * @param {ErrorConstructor} errorLike
   * @param {RegExp|String} errMsgMatcher
   * @param {String} message
   * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
   * @namespace Assert
   * @api public
   */

  assert.doesNotThrow = function (fn, errorLike, errMsgMatcher, msg) {
    if ('string' === typeof errorLike || errorLike instanceof RegExp) {
      errMsgMatcher = errorLike;
      errorLike = null;
    }

    new Assertion(fn, msg, assert.doesNotThrow, true)
      .to.not.throw(errorLike, errMsgMatcher);
  };

  /**
   * ### .operator(val1, operator, val2, [message])
   *
   * Compares two values using `operator`.
   *
   *     assert.operator(1, '<', 2, 'everything is ok');
   *     assert.operator(1, '>', 2, 'this will fail');
   *
   * @name operator
   * @param {Mixed} val1
   * @param {String} operator
   * @param {Mixed} val2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.operator = function (val, operator, val2, msg) {
    var ok;
    switch(operator) {
      case '==':
        ok = val == val2;
        break;
      case '===':
        ok = val === val2;
        break;
      case '>':
        ok = val > val2;
        break;
      case '>=':
        ok = val >= val2;
        break;
      case '<':
        ok = val < val2;
        break;
      case '<=':
        ok = val <= val2;
        break;
      case '!=':
        ok = val != val2;
        break;
      case '!==':
        ok = val !== val2;
        break;
      default:
        msg = msg ? msg + ': ' : msg;
        throw new chai.AssertionError(
          msg + 'Invalid operator "' + operator + '"',
          undefined,
          assert.operator
        );
    }
    var test = new Assertion(ok, msg, assert.operator, true);
    test.assert(
        true === flag(test, 'object')
      , 'expected ' + util.inspect(val) + ' to be ' + operator + ' ' + util.inspect(val2)
      , 'expected ' + util.inspect(val) + ' to not be ' + operator + ' ' + util.inspect(val2) );
  };

  /**
   * ### .closeTo(actual, expected, delta, [message])
   *
   * Asserts that the target is equal `expected`, to within a +/- `delta` range.
   *
   *     assert.closeTo(1.5, 1, 0.5, 'numbers are close');
   *
   * @name closeTo
   * @param {Number} actual
   * @param {Number} expected
   * @param {Number} delta
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.closeTo = function (act, exp, delta, msg) {
    new Assertion(act, msg, assert.closeTo, true).to.be.closeTo(exp, delta);
  };

  /**
   * ### .approximately(actual, expected, delta, [message])
   *
   * Asserts that the target is equal `expected`, to within a +/- `delta` range.
   *
   *     assert.approximately(1.5, 1, 0.5, 'numbers are close');
   *
   * @name approximately
   * @param {Number} actual
   * @param {Number} expected
   * @param {Number} delta
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.approximately = function (act, exp, delta, msg) {
    new Assertion(act, msg, assert.approximately, true)
      .to.be.approximately(exp, delta);
  };

  /**
   * ### .sameMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` have the same members in any order. Uses a
   * strict equality check (===).
   *
   *     assert.sameMembers([ 1, 2, 3 ], [ 2, 1, 3 ], 'same members');
   *
   * @name sameMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.sameMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.sameMembers, true)
      .to.have.same.members(set2);
  }

  /**
   * ### .notSameMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` don't have the same members in any order.
   * Uses a strict equality check (===).
   *
   *     assert.notSameMembers([ 1, 2, 3 ], [ 5, 1, 3 ], 'not same members');
   *
   * @name notSameMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notSameMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.notSameMembers, true)
      .to.not.have.same.members(set2);
  }

  /**
   * ### .sameDeepMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` have the same members in any order. Uses a
   * deep equality check.
   *
   *     assert.sameDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [{ b: 2 }, { a: 1 }, { c: 3 }], 'same deep members');
   *
   * @name sameDeepMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.sameDeepMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.sameDeepMembers, true)
      .to.have.same.deep.members(set2);
  }

  /**
   * ### .notSameDeepMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` don't have the same members in any order.
   * Uses a deep equality check.
   *
   *     assert.notSameDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [{ b: 2 }, { a: 1 }, { f: 5 }], 'not same deep members');
   *
   * @name notSameDeepMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notSameDeepMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.notSameDeepMembers, true)
      .to.not.have.same.deep.members(set2);
  }

  /**
   * ### .sameOrderedMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` have the same members in the same order.
   * Uses a strict equality check (===).
   *
   *     assert.sameOrderedMembers([ 1, 2, 3 ], [ 1, 2, 3 ], 'same ordered members');
   *
   * @name sameOrderedMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.sameOrderedMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.sameOrderedMembers, true)
      .to.have.same.ordered.members(set2);
  }

  /**
   * ### .notSameOrderedMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` don't have the same members in the same
   * order. Uses a strict equality check (===).
   *
   *     assert.notSameOrderedMembers([ 1, 2, 3 ], [ 2, 1, 3 ], 'not same ordered members');
   *
   * @name notSameOrderedMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notSameOrderedMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.notSameOrderedMembers, true)
      .to.not.have.same.ordered.members(set2);
  }

  /**
   * ### .sameDeepOrderedMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` have the same members in the same order.
   * Uses a deep equality check.
   *
   *     assert.sameDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { b: 2 }, { c: 3 } ], 'same deep ordered members');
   *
   * @name sameDeepOrderedMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.sameDeepOrderedMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.sameDeepOrderedMembers, true)
      .to.have.same.deep.ordered.members(set2);
  }

  /**
   * ### .notSameDeepOrderedMembers(set1, set2, [message])
   *
   * Asserts that `set1` and `set2` don't have the same members in the same
   * order. Uses a deep equality check.
   *
   *     assert.notSameDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { b: 2 }, { z: 5 } ], 'not same deep ordered members');
   *     assert.notSameDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { a: 1 }, { c: 3 } ], 'not same deep ordered members');
   *
   * @name notSameDeepOrderedMembers
   * @param {Array} set1
   * @param {Array} set2
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notSameDeepOrderedMembers = function (set1, set2, msg) {
    new Assertion(set1, msg, assert.notSameDeepOrderedMembers, true)
      .to.not.have.same.deep.ordered.members(set2);
  }

  /**
   * ### .includeMembers(superset, subset, [message])
   *
   * Asserts that `subset` is included in `superset` in any order. Uses a
   * strict equality check (===). Duplicates are ignored.
   *
   *     assert.includeMembers([ 1, 2, 3 ], [ 2, 1, 2 ], 'include members');
   *
   * @name includeMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.includeMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.includeMembers, true)
      .to.include.members(subset);
  }

  /**
   * ### .notIncludeMembers(superset, subset, [message])
   *
   * Asserts that `subset` isn't included in `superset` in any order. Uses a
   * strict equality check (===). Duplicates are ignored.
   *
   *     assert.notIncludeMembers([ 1, 2, 3 ], [ 5, 1 ], 'not include members');
   *
   * @name notIncludeMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notIncludeMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.notIncludeMembers, true)
      .to.not.include.members(subset);
  }

  /**
   * ### .includeDeepMembers(superset, subset, [message])
   *
   * Asserts that `subset` is included in `superset` in any order. Uses a deep
   * equality check. Duplicates are ignored.
   *
   *     assert.includeDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { a: 1 }, { b: 2 } ], 'include deep members');
   *
   * @name includeDeepMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.includeDeepMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.includeDeepMembers, true)
      .to.include.deep.members(subset);
  }

  /**
   * ### .notIncludeDeepMembers(superset, subset, [message])
   *
   * Asserts that `subset` isn't included in `superset` in any order. Uses a
   * deep equality check. Duplicates are ignored.
   *
   *     assert.notIncludeDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { f: 5 } ], 'not include deep members');
   *
   * @name notIncludeDeepMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notIncludeDeepMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.notIncludeDeepMembers, true)
      .to.not.include.deep.members(subset);
  }

  /**
   * ### .includeOrderedMembers(superset, subset, [message])
   *
   * Asserts that `subset` is included in `superset` in the same order
   * beginning with the first element in `superset`. Uses a strict equality
   * check (===).
   *
   *     assert.includeOrderedMembers([ 1, 2, 3 ], [ 1, 2 ], 'include ordered members');
   *
   * @name includeOrderedMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.includeOrderedMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.includeOrderedMembers, true)
      .to.include.ordered.members(subset);
  }

  /**
   * ### .notIncludeOrderedMembers(superset, subset, [message])
   *
   * Asserts that `subset` isn't included in `superset` in the same order
   * beginning with the first element in `superset`. Uses a strict equality
   * check (===).
   *
   *     assert.notIncludeOrderedMembers([ 1, 2, 3 ], [ 2, 1 ], 'not include ordered members');
   *     assert.notIncludeOrderedMembers([ 1, 2, 3 ], [ 2, 3 ], 'not include ordered members');
   *
   * @name notIncludeOrderedMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notIncludeOrderedMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.notIncludeOrderedMembers, true)
      .to.not.include.ordered.members(subset);
  }

  /**
   * ### .includeDeepOrderedMembers(superset, subset, [message])
   *
   * Asserts that `subset` is included in `superset` in the same order
   * beginning with the first element in `superset`. Uses a deep equality
   * check.
   *
   *     assert.includeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { b: 2 } ], 'include deep ordered members');
   *
   * @name includeDeepOrderedMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.includeDeepOrderedMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.includeDeepOrderedMembers, true)
      .to.include.deep.ordered.members(subset);
  }

  /**
   * ### .notIncludeDeepOrderedMembers(superset, subset, [message])
   *
   * Asserts that `subset` isn't included in `superset` in the same order
   * beginning with the first element in `superset`. Uses a deep equality
   * check.
   *
   *     assert.notIncludeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { f: 5 } ], 'not include deep ordered members');
   *     assert.notIncludeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { a: 1 } ], 'not include deep ordered members');
   *     assert.notIncludeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { c: 3 } ], 'not include deep ordered members');
   *
   * @name notIncludeDeepOrderedMembers
   * @param {Array} superset
   * @param {Array} subset
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.notIncludeDeepOrderedMembers = function (superset, subset, msg) {
    new Assertion(superset, msg, assert.notIncludeDeepOrderedMembers, true)
      .to.not.include.deep.ordered.members(subset);
  }

  /**
   * ### .oneOf(inList, list, [message])
   *
   * Asserts that non-object, non-array value `inList` appears in the flat array `list`.
   *
   *     assert.oneOf(1, [ 2, 1 ], 'Not found in list');
   *
   * @name oneOf
   * @param {*} inList
   * @param {Array<*>} list
   * @param {String} message
   * @namespace Assert
   * @api public
   */

  assert.oneOf = function (inList, list, msg) {
    new Assertion(inList, msg, assert.oneOf, true).to.be.oneOf(list);
  }

  /**
   * ### .changes(function, object, property, [message])
   *
   * Asserts that a function changes the value of a property.
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 22 };
   *     assert.changes(fn, obj, 'val');
   *
   * @name changes
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.changes = function (fn, obj, prop, msg) {
    if (arguments.length === 3 && typeof obj === 'function') {
      msg = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.changes, true).to.change(obj, prop);
  }

   /**
   * ### .changesBy(function, object, property, delta, [message])
   *
   * Asserts that a function changes the value of a property by an amount (delta).
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val += 2 };
   *     assert.changesBy(fn, obj, 'val', 2);
   *
   * @name changesBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.changesBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.changesBy, true)
      .to.change(obj, prop).by(delta);
  }

   /**
   * ### .doesNotChange(function, object, property, [message])
   *
   * Asserts that a function does not change the value of a property.
   *
   *     var obj = { val: 10 };
   *     var fn = function() { console.log('foo'); };
   *     assert.doesNotChange(fn, obj, 'val');
   *
   * @name doesNotChange
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.doesNotChange = function (fn, obj, prop, msg) {
    if (arguments.length === 3 && typeof obj === 'function') {
      msg = prop;
      prop = null;
    }

    return new Assertion(fn, msg, assert.doesNotChange, true)
      .to.not.change(obj, prop);
  }

  /**
   * ### .changesButNotBy(function, object, property, delta, [message])
   *
   * Asserts that a function does not change the value of a property or of a function's return value by an amount (delta)
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val += 10 };
   *     assert.changesButNotBy(fn, obj, 'val', 5);
   *
   * @name changesButNotBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.changesButNotBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.changesButNotBy, true)
      .to.change(obj, prop).but.not.by(delta);
  }

  /**
   * ### .increases(function, object, property, [message])
   *
   * Asserts that a function increases a numeric object property.
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 13 };
   *     assert.increases(fn, obj, 'val');
   *
   * @name increases
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.increases = function (fn, obj, prop, msg) {
    if (arguments.length === 3 && typeof obj === 'function') {
      msg = prop;
      prop = null;
    }

    return new Assertion(fn, msg, assert.increases, true)
      .to.increase(obj, prop);
  }

  /**
   * ### .increasesBy(function, object, property, delta, [message])
   *
   * Asserts that a function increases a numeric object property or a function's return value by an amount (delta).
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val += 10 };
   *     assert.increasesBy(fn, obj, 'val', 10);
   *
   * @name increasesBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.increasesBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.increasesBy, true)
      .to.increase(obj, prop).by(delta);
  }

  /**
   * ### .doesNotIncrease(function, object, property, [message])
   *
   * Asserts that a function does not increase a numeric object property.
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 8 };
   *     assert.doesNotIncrease(fn, obj, 'val');
   *
   * @name doesNotIncrease
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.doesNotIncrease = function (fn, obj, prop, msg) {
    if (arguments.length === 3 && typeof obj === 'function') {
      msg = prop;
      prop = null;
    }

    return new Assertion(fn, msg, assert.doesNotIncrease, true)
      .to.not.increase(obj, prop);
  }

  /**
   * ### .increasesButNotBy(function, object, property, delta, [message])
   *
   * Asserts that a function does not increase a numeric object property or function's return value by an amount (delta).
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 15 };
   *     assert.increasesButNotBy(fn, obj, 'val', 10);
   *
   * @name increasesButNotBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.increasesButNotBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.increasesButNotBy, true)
      .to.increase(obj, prop).but.not.by(delta);
  }

  /**
   * ### .decreases(function, object, property, [message])
   *
   * Asserts that a function decreases a numeric object property.
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 5 };
   *     assert.decreases(fn, obj, 'val');
   *
   * @name decreases
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.decreases = function (fn, obj, prop, msg) {
    if (arguments.length === 3 && typeof obj === 'function') {
      msg = prop;
      prop = null;
    }

    return new Assertion(fn, msg, assert.decreases, true)
      .to.decrease(obj, prop);
  }

  /**
   * ### .decreasesBy(function, object, property, delta, [message])
   *
   * Asserts that a function decreases a numeric object property or a function's return value by an amount (delta)
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val -= 5 };
   *     assert.decreasesBy(fn, obj, 'val', 5);
   *
   * @name decreasesBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.decreasesBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.decreasesBy, true)
      .to.decrease(obj, prop).by(delta);
  }

  /**
   * ### .doesNotDecrease(function, object, property, [message])
   *
   * Asserts that a function does not decreases a numeric object property.
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 15 };
   *     assert.doesNotDecrease(fn, obj, 'val');
   *
   * @name doesNotDecrease
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.doesNotDecrease = function (fn, obj, prop, msg) {
    if (arguments.length === 3 && typeof obj === 'function') {
      msg = prop;
      prop = null;
    }

    return new Assertion(fn, msg, assert.doesNotDecrease, true)
      .to.not.decrease(obj, prop);
  }

  /**
   * ### .doesNotDecreaseBy(function, object, property, delta, [message])
   *
   * Asserts that a function does not decreases a numeric object property or a function's return value by an amount (delta)
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 5 };
   *     assert.doesNotDecreaseBy(fn, obj, 'val', 1);
   *
   * @name doesNotDecreaseBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.doesNotDecreaseBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    return new Assertion(fn, msg, assert.doesNotDecreaseBy, true)
      .to.not.decrease(obj, prop).by(delta);
  }

  /**
   * ### .decreasesButNotBy(function, object, property, delta, [message])
   *
   * Asserts that a function does not decreases a numeric object property or a function's return value by an amount (delta)
   *
   *     var obj = { val: 10 };
   *     var fn = function() { obj.val = 5 };
   *     assert.decreasesButNotBy(fn, obj, 'val', 1);
   *
   * @name decreasesButNotBy
   * @param {Function} modifier function
   * @param {Object} object or getter function
   * @param {String} property name _optional_
   * @param {Number} change amount (delta)
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.decreasesButNotBy = function (fn, obj, prop, delta, msg) {
    if (arguments.length === 4 && typeof obj === 'function') {
      var tmpMsg = delta;
      delta = prop;
      msg = tmpMsg;
    } else if (arguments.length === 3) {
      delta = prop;
      prop = null;
    }

    new Assertion(fn, msg, assert.decreasesButNotBy, true)
      .to.decrease(obj, prop).but.not.by(delta);
  }

  /*!
   * ### .ifError(object)
   *
   * Asserts if value is not a false value, and throws if it is a true value.
   * This is added to allow for chai to be a drop-in replacement for Node's
   * assert class.
   *
   *     var err = new Error('I am a custom error');
   *     assert.ifError(err); // Rethrows err!
   *
   * @name ifError
   * @param {Object} object
   * @namespace Assert
   * @api public
   */

  assert.ifError = function (val) {
    if (val) {
      throw(val);
    }
  };

  /**
   * ### .isExtensible(object)
   *
   * Asserts that `object` is extensible (can have new properties added to it).
   *
   *     assert.isExtensible({});
   *
   * @name isExtensible
   * @alias extensible
   * @param {Object} object
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isExtensible = function (obj, msg) {
    new Assertion(obj, msg, assert.isExtensible, true).to.be.extensible;
  };

  /**
   * ### .isNotExtensible(object)
   *
   * Asserts that `object` is _not_ extensible.
   *
   *     var nonExtensibleObject = Object.preventExtensions({});
   *     var sealedObject = Object.seal({});
   *     var frozenObject = Object.freeze({});
   *
   *     assert.isNotExtensible(nonExtensibleObject);
   *     assert.isNotExtensible(sealedObject);
   *     assert.isNotExtensible(frozenObject);
   *
   * @name isNotExtensible
   * @alias notExtensible
   * @param {Object} object
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isNotExtensible = function (obj, msg) {
    new Assertion(obj, msg, assert.isNotExtensible, true).to.not.be.extensible;
  };

  /**
   * ### .isSealed(object)
   *
   * Asserts that `object` is sealed (cannot have new properties added to it
   * and its existing properties cannot be removed).
   *
   *     var sealedObject = Object.seal({});
   *     var frozenObject = Object.seal({});
   *
   *     assert.isSealed(sealedObject);
   *     assert.isSealed(frozenObject);
   *
   * @name isSealed
   * @alias sealed
   * @param {Object} object
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isSealed = function (obj, msg) {
    new Assertion(obj, msg, assert.isSealed, true).to.be.sealed;
  };

  /**
   * ### .isNotSealed(object)
   *
   * Asserts that `object` is _not_ sealed.
   *
   *     assert.isNotSealed({});
   *
   * @name isNotSealed
   * @alias notSealed
   * @param {Object} object
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isNotSealed = function (obj, msg) {
    new Assertion(obj, msg, assert.isNotSealed, true).to.not.be.sealed;
  };

  /**
   * ### .isFrozen(object)
   *
   * Asserts that `object` is frozen (cannot have new properties added to it
   * and its existing properties cannot be modified).
   *
   *     var frozenObject = Object.freeze({});
   *     assert.frozen(frozenObject);
   *
   * @name isFrozen
   * @alias frozen
   * @param {Object} object
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isFrozen = function (obj, msg) {
    new Assertion(obj, msg, assert.isFrozen, true).to.be.frozen;
  };

  /**
   * ### .isNotFrozen(object)
   *
   * Asserts that `object` is _not_ frozen.
   *
   *     assert.isNotFrozen({});
   *
   * @name isNotFrozen
   * @alias notFrozen
   * @param {Object} object
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isNotFrozen = function (obj, msg) {
    new Assertion(obj, msg, assert.isNotFrozen, true).to.not.be.frozen;
  };

  /**
   * ### .isEmpty(target)
   *
   * Asserts that the target does not contain any values.
   * For arrays and strings, it checks the `length` property.
   * For `Map` and `Set` instances, it checks the `size` property.
   * For non-function objects, it gets the count of own
   * enumerable string keys.
   *
   *     assert.isEmpty([]);
   *     assert.isEmpty('');
   *     assert.isEmpty(new Map);
   *     assert.isEmpty({});
   *
   * @name isEmpty
   * @alias empty
   * @param {Object|Array|String|Map|Set} target
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isEmpty = function(val, msg) {
    new Assertion(val, msg, assert.isEmpty, true).to.be.empty;
  };

  /**
   * ### .isNotEmpty(target)
   *
   * Asserts that the target contains values.
   * For arrays and strings, it checks the `length` property.
   * For `Map` and `Set` instances, it checks the `size` property.
   * For non-function objects, it gets the count of own
   * enumerable string keys.
   *
   *     assert.isNotEmpty([1, 2]);
   *     assert.isNotEmpty('34');
   *     assert.isNotEmpty(new Set([5, 6]));
   *     assert.isNotEmpty({ key: 7 });
   *
   * @name isNotEmpty
   * @alias notEmpty
   * @param {Object|Array|String|Map|Set} target
   * @param {String} message _optional_
   * @namespace Assert
   * @api public
   */

  assert.isNotEmpty = function(val, msg) {
    new Assertion(val, msg, assert.isNotEmpty, true).to.not.be.empty;
  };

  /*!
   * Aliases.
   */

  (function alias(name, as){
    assert[as] = assert[name];
    return alias;
  })
  ('isOk', 'ok')
  ('isNotOk', 'notOk')
  ('throws', 'throw')
  ('throws', 'Throw')
  ('isExtensible', 'extensible')
  ('isNotExtensible', 'notExtensible')
  ('isSealed', 'sealed')
  ('isNotSealed', 'notSealed')
  ('isFrozen', 'frozen')
  ('isNotFrozen', 'notFrozen')
  ('isEmpty', 'empty')
  ('isNotEmpty', 'notEmpty');
};


/***/ }),

/***/ 8007:
/***/ (function(module) {

/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

module.exports = function (chai, util) {
  chai.expect = function (val, message) {
    return new chai.Assertion(val, message);
  };

  /**
   * ### .fail([message])
   * ### .fail(actual, expected, [message], [operator])
   *
   * Throw a failure.
   *
   *     expect.fail();
   *     expect.fail("custom error message");
   *     expect.fail(1, 2);
   *     expect.fail(1, 2, "custom error message");
   *     expect.fail(1, 2, "custom error message", ">");
   *     expect.fail(1, 2, undefined, ">");
   *
   * @name fail
   * @param {Mixed} actual
   * @param {Mixed} expected
   * @param {String} message
   * @param {String} operator
   * @namespace BDD
   * @api public
   */

  chai.expect.fail = function (actual, expected, message, operator) {
    if (arguments.length < 2) {
        message = actual;
        actual = undefined;
    }

    message = message || 'expect.fail()';
    throw new chai.AssertionError(message, {
        actual: actual
      , expected: expected
      , operator: operator
    }, chai.expect.fail);
  };
};


/***/ }),

/***/ 3292:
/***/ (function(module) {

/*!
 * chai
 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

module.exports = function (chai, util) {
  var Assertion = chai.Assertion;

  function loadShould () {
    // explicitly define this method as function as to have it's name to include as `ssfi`
    function shouldGetter() {
      if (this instanceof String
          || this instanceof Number
          || this instanceof Boolean
          || typeof Symbol === 'function' && this instanceof Symbol
          || typeof BigInt === 'function' && this instanceof BigInt) {
        return new Assertion(this.valueOf(), null, shouldGetter);
      }
      return new Assertion(this, null, shouldGetter);
    }
    function shouldSetter(value) {
      // See https://github.com/chaijs/chai/issues/86: this makes
      // `whatever.should = someValue` actually set `someValue`, which is
      // especially useful for `global.should = require('chai').should()`.
      //
      // Note that we have to use [[DefineProperty]] instead of [[Put]]
      // since otherwise we would trigger this very setter!
      Object.defineProperty(this, 'should', {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    }
    // modify Object.prototype to have `should`
    Object.defineProperty(Object.prototype, 'should', {
      set: shouldSetter
      , get: shouldGetter
      , configurable: true
    });

    var should = {};

    /**
     * ### .fail([message])
     * ### .fail(actual, expected, [message], [operator])
     *
     * Throw a failure.
     *
     *     should.fail();
     *     should.fail("custom error message");
     *     should.fail(1, 2);
     *     should.fail(1, 2, "custom error message");
     *     should.fail(1, 2, "custom error message", ">");
     *     should.fail(1, 2, undefined, ">");
     *
     *
     * @name fail
     * @param {Mixed} actual
     * @param {Mixed} expected
     * @param {String} message
     * @param {String} operator
     * @namespace BDD
     * @api public
     */

    should.fail = function (actual, expected, message, operator) {
      if (arguments.length < 2) {
          message = actual;
          actual = undefined;
      }

      message = message || 'should.fail()';
      throw new chai.AssertionError(message, {
          actual: actual
        , expected: expected
        , operator: operator
      }, should.fail);
    };

    /**
     * ### .equal(actual, expected, [message])
     *
     * Asserts non-strict equality (`==`) of `actual` and `expected`.
     *
     *     should.equal(3, '3', '== coerces values to strings');
     *
     * @name equal
     * @param {Mixed} actual
     * @param {Mixed} expected
     * @param {String} message
     * @namespace Should
     * @api public
     */

    should.equal = function (val1, val2, msg) {
      new Assertion(val1, msg).to.equal(val2);
    };

    /**
     * ### .throw(function, [constructor/string/regexp], [string/regexp], [message])
     *
     * Asserts that `function` will throw an error that is an instance of
     * `constructor`, or alternately that it will throw an error with message
     * matching `regexp`.
     *
     *     should.throw(fn, 'function throws a reference error');
     *     should.throw(fn, /function throws a reference error/);
     *     should.throw(fn, ReferenceError);
     *     should.throw(fn, ReferenceError, 'function throws a reference error');
     *     should.throw(fn, ReferenceError, /function throws a reference error/);
     *
     * @name throw
     * @alias Throw
     * @param {Function} function
     * @param {ErrorConstructor} constructor
     * @param {RegExp} regexp
     * @param {String} message
     * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
     * @namespace Should
     * @api public
     */

    should.Throw = function (fn, errt, errs, msg) {
      new Assertion(fn, msg).to.Throw(errt, errs);
    };

    /**
     * ### .exist
     *
     * Asserts that the target is neither `null` nor `undefined`.
     *
     *     var foo = 'hi';
     *
     *     should.exist(foo, 'foo exists');
     *
     * @name exist
     * @namespace Should
     * @api public
     */

    should.exist = function (val, msg) {
      new Assertion(val, msg).to.exist;
    }

    // negation
    should.not = {}

    /**
     * ### .not.equal(actual, expected, [message])
     *
     * Asserts non-strict inequality (`!=`) of `actual` and `expected`.
     *
     *     should.not.equal(3, 4, 'these numbers are not equal');
     *
     * @name not.equal
     * @param {Mixed} actual
     * @param {Mixed} expected
     * @param {String} message
     * @namespace Should
     * @api public
     */

    should.not.equal = function (val1, val2, msg) {
      new Assertion(val1, msg).to.not.equal(val2);
    };

    /**
     * ### .throw(function, [constructor/regexp], [message])
     *
     * Asserts that `function` will _not_ throw an error that is an instance of
     * `constructor`, or alternately that it will not throw an error with message
     * matching `regexp`.
     *
     *     should.not.throw(fn, Error, 'function does not throw');
     *
     * @name not.throw
     * @alias not.Throw
     * @param {Function} function
     * @param {ErrorConstructor} constructor
     * @param {RegExp} regexp
     * @param {String} message
     * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
     * @namespace Should
     * @api public
     */

    should.not.Throw = function (fn, errt, errs, msg) {
      new Assertion(fn, msg).to.not.Throw(errt, errs);
    };

    /**
     * ### .not.exist
     *
     * Asserts that the target is neither `null` nor `undefined`.
     *
     *     var bar = null;
     *
     *     should.not.exist(bar, 'bar does not exist');
     *
     * @name not.exist
     * @namespace Should
     * @api public
     */

    should.not.exist = function (val, msg) {
      new Assertion(val, msg).to.not.exist;
    }

    should['throw'] = should['Throw'];
    should.not['throw'] = should.not['Throw'];

    return should;
  };

  chai.should = loadShould;
  chai.Should = loadShould;
};


/***/ }),

/***/ 3707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - addChainingMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Module dependencies
 */

var addLengthGuard = __webpack_require__(7758);
var chai = __webpack_require__(1928);
var flag = __webpack_require__(3183);
var proxify = __webpack_require__(925);
var transferFlags = __webpack_require__(3897);

/*!
 * Module variables
 */

// Check whether `Object.setPrototypeOf` is supported
var canSetPrototype = typeof Object.setPrototypeOf === 'function';

// Without `Object.setPrototypeOf` support, this module will need to add properties to a function.
// However, some of functions' own props are not configurable and should be skipped.
var testFn = function() {};
var excludeNames = Object.getOwnPropertyNames(testFn).filter(function(name) {
  var propDesc = Object.getOwnPropertyDescriptor(testFn, name);

  // Note: PhantomJS 1.x includes `callee` as one of `testFn`'s own properties,
  // but then returns `undefined` as the property descriptor for `callee`. As a
  // workaround, we perform an otherwise unnecessary type-check for `propDesc`,
  // and then filter it out if it's not an object as it should be.
  if (typeof propDesc !== 'object')
    return true;

  return !propDesc.configurable;
});

// Cache `Function` properties
var call  = Function.prototype.call,
    apply = Function.prototype.apply;

/**
 * ### .addChainableMethod(ctx, name, method, chainingBehavior)
 *
 * Adds a method to an object, such that the method can also be chained.
 *
 *     utils.addChainableMethod(chai.Assertion.prototype, 'foo', function (str) {
 *       var obj = utils.flag(this, 'object');
 *       new chai.Assertion(obj).to.be.equal(str);
 *     });
 *
 * Can also be accessed directly from `chai.Assertion`.
 *
 *     chai.Assertion.addChainableMethod('foo', fn, chainingBehavior);
 *
 * The result can then be used as both a method assertion, executing both `method` and
 * `chainingBehavior`, or as a language chain, which only executes `chainingBehavior`.
 *
 *     expect(fooStr).to.be.foo('bar');
 *     expect(fooStr).to.be.foo.equal('foo');
 *
 * @param {Object} ctx object to which the method is added
 * @param {String} name of method to add
 * @param {Function} method function to be used for `name`, when called
 * @param {Function} chainingBehavior function to be called every time the property is accessed
 * @namespace Utils
 * @name addChainableMethod
 * @api public
 */

module.exports = function addChainableMethod(ctx, name, method, chainingBehavior) {
  if (typeof chainingBehavior !== 'function') {
    chainingBehavior = function () { };
  }

  var chainableBehavior = {
      method: method
    , chainingBehavior: chainingBehavior
  };

  // save the methods so we can overwrite them later, if we need to.
  if (!ctx.__methods) {
    ctx.__methods = {};
  }
  ctx.__methods[name] = chainableBehavior;

  Object.defineProperty(ctx, name,
    { get: function chainableMethodGetter() {
        chainableBehavior.chainingBehavior.call(this);

        var chainableMethodWrapper = function () {
          // Setting the `ssfi` flag to `chainableMethodWrapper` causes this
          // function to be the starting point for removing implementation
          // frames from the stack trace of a failed assertion.
          //
          // However, we only want to use this function as the starting point if
          // the `lockSsfi` flag isn't set.
          //
          // If the `lockSsfi` flag is set, then this assertion is being
          // invoked from inside of another assertion. In this case, the `ssfi`
          // flag has already been set by the outer assertion.
          //
          // Note that overwriting a chainable method merely replaces the saved
          // methods in `ctx.__methods` instead of completely replacing the
          // overwritten assertion. Therefore, an overwriting assertion won't
          // set the `ssfi` or `lockSsfi` flags.
          if (!flag(this, 'lockSsfi')) {
            flag(this, 'ssfi', chainableMethodWrapper);
          }

          var result = chainableBehavior.method.apply(this, arguments);
          if (result !== undefined) {
            return result;
          }

          var newAssertion = new chai.Assertion();
          transferFlags(this, newAssertion);
          return newAssertion;
        };

        addLengthGuard(chainableMethodWrapper, name, true);

        // Use `Object.setPrototypeOf` if available
        if (canSetPrototype) {
          // Inherit all properties from the object by replacing the `Function` prototype
          var prototype = Object.create(this);
          // Restore the `call` and `apply` methods from `Function`
          prototype.call = call;
          prototype.apply = apply;
          Object.setPrototypeOf(chainableMethodWrapper, prototype);
        }
        // Otherwise, redefine all properties (slow!)
        else {
          var asserterNames = Object.getOwnPropertyNames(ctx);
          asserterNames.forEach(function (asserterName) {
            if (excludeNames.indexOf(asserterName) !== -1) {
              return;
            }

            var pd = Object.getOwnPropertyDescriptor(ctx, asserterName);
            Object.defineProperty(chainableMethodWrapper, asserterName, pd);
          });
        }

        transferFlags(this, chainableMethodWrapper);
        return proxify(chainableMethodWrapper);
      }
    , configurable: true
  });
};


/***/ }),

/***/ 7758:
/***/ (function(module) {

var fnLengthDesc = Object.getOwnPropertyDescriptor(function () {}, 'length');

/*!
 * Chai - addLengthGuard utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .addLengthGuard(fn, assertionName, isChainable)
 *
 * Define `length` as a getter on the given uninvoked method assertion. The
 * getter acts as a guard against chaining `length` directly off of an uninvoked
 * method assertion, which is a problem because it references `function`'s
 * built-in `length` property instead of Chai's `length` assertion. When the
 * getter catches the user making this mistake, it throws an error with a
 * helpful message.
 *
 * There are two ways in which this mistake can be made. The first way is by
 * chaining the `length` assertion directly off of an uninvoked chainable
 * method. In this case, Chai suggests that the user use `lengthOf` instead. The
 * second way is by chaining the `length` assertion directly off of an uninvoked
 * non-chainable method. Non-chainable methods must be invoked prior to
 * chaining. In this case, Chai suggests that the user consult the docs for the
 * given assertion.
 *
 * If the `length` property of functions is unconfigurable, then return `fn`
 * without modification.
 *
 * Note that in ES6, the function's `length` property is configurable, so once
 * support for legacy environments is dropped, Chai's `length` property can
 * replace the built-in function's `length` property, and this length guard will
 * no longer be necessary. In the mean time, maintaining consistency across all
 * environments is the priority.
 *
 * @param {Function} fn
 * @param {String} assertionName
 * @param {Boolean} isChainable
 * @namespace Utils
 * @name addLengthGuard
 */

module.exports = function addLengthGuard (fn, assertionName, isChainable) {
  if (!fnLengthDesc.configurable) return fn;

  Object.defineProperty(fn, 'length', {
    get: function () {
      if (isChainable) {
        throw Error('Invalid Chai property: ' + assertionName + '.length. Due' +
          ' to a compatibility issue, "length" cannot directly follow "' +
          assertionName + '". Use "' + assertionName + '.lengthOf" instead.');
      }

      throw Error('Invalid Chai property: ' + assertionName + '.length. See' +
        ' docs for proper usage of "' + assertionName + '".');
    }
  });

  return fn;
};


/***/ }),

/***/ 3775:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - addMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var addLengthGuard = __webpack_require__(7758);
var chai = __webpack_require__(1928);
var flag = __webpack_require__(3183);
var proxify = __webpack_require__(925);
var transferFlags = __webpack_require__(3897);

/**
 * ### .addMethod(ctx, name, method)
 *
 * Adds a method to the prototype of an object.
 *
 *     utils.addMethod(chai.Assertion.prototype, 'foo', function (str) {
 *       var obj = utils.flag(this, 'object');
 *       new chai.Assertion(obj).to.be.equal(str);
 *     });
 *
 * Can also be accessed directly from `chai.Assertion`.
 *
 *     chai.Assertion.addMethod('foo', fn);
 *
 * Then can be used as any other assertion.
 *
 *     expect(fooStr).to.be.foo('bar');
 *
 * @param {Object} ctx object to which the method is added
 * @param {String} name of method to add
 * @param {Function} method function to be used for name
 * @namespace Utils
 * @name addMethod
 * @api public
 */

module.exports = function addMethod(ctx, name, method) {
  var methodWrapper = function () {
    // Setting the `ssfi` flag to `methodWrapper` causes this function to be the
    // starting point for removing implementation frames from the stack trace of
    // a failed assertion.
    //
    // However, we only want to use this function as the starting point if the
    // `lockSsfi` flag isn't set.
    //
    // If the `lockSsfi` flag is set, then either this assertion has been
    // overwritten by another assertion, or this assertion is being invoked from
    // inside of another assertion. In the first case, the `ssfi` flag has
    // already been set by the overwriting assertion. In the second case, the
    // `ssfi` flag has already been set by the outer assertion.
    if (!flag(this, 'lockSsfi')) {
      flag(this, 'ssfi', methodWrapper);
    }

    var result = method.apply(this, arguments);
    if (result !== undefined)
      return result;

    var newAssertion = new chai.Assertion();
    transferFlags(this, newAssertion);
    return newAssertion;
  };

  addLengthGuard(methodWrapper, name, false);
  ctx[name] = proxify(methodWrapper, name);
};


/***/ }),

/***/ 7152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - addProperty utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var chai = __webpack_require__(1928);
var flag = __webpack_require__(3183);
var isProxyEnabled = __webpack_require__(3035);
var transferFlags = __webpack_require__(3897);

/**
 * ### .addProperty(ctx, name, getter)
 *
 * Adds a property to the prototype of an object.
 *
 *     utils.addProperty(chai.Assertion.prototype, 'foo', function () {
 *       var obj = utils.flag(this, 'object');
 *       new chai.Assertion(obj).to.be.instanceof(Foo);
 *     });
 *
 * Can also be accessed directly from `chai.Assertion`.
 *
 *     chai.Assertion.addProperty('foo', fn);
 *
 * Then can be used as any other assertion.
 *
 *     expect(myFoo).to.be.foo;
 *
 * @param {Object} ctx object to which the property is added
 * @param {String} name of property to add
 * @param {Function} getter function to be used for name
 * @namespace Utils
 * @name addProperty
 * @api public
 */

module.exports = function addProperty(ctx, name, getter) {
  getter = getter === undefined ? function () {} : getter;

  Object.defineProperty(ctx, name,
    { get: function propertyGetter() {
        // Setting the `ssfi` flag to `propertyGetter` causes this function to
        // be the starting point for removing implementation frames from the
        // stack trace of a failed assertion.
        //
        // However, we only want to use this function as the starting point if
        // the `lockSsfi` flag isn't set and proxy protection is disabled.
        //
        // If the `lockSsfi` flag is set, then either this assertion has been
        // overwritten by another assertion, or this assertion is being invoked
        // from inside of another assertion. In the first case, the `ssfi` flag
        // has already been set by the overwriting assertion. In the second
        // case, the `ssfi` flag has already been set by the outer assertion.
        //
        // If proxy protection is enabled, then the `ssfi` flag has already been
        // set by the proxy getter.
        if (!isProxyEnabled() && !flag(this, 'lockSsfi')) {
          flag(this, 'ssfi', propertyGetter);
        }

        var result = getter.call(this);
        if (result !== undefined)
          return result;

        var newAssertion = new chai.Assertion();
        transferFlags(this, newAssertion);
        return newAssertion;
      }
    , configurable: true
  });
};


/***/ }),

/***/ 391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - compareByInspect utility
 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Module dependencies
 */

var inspect = __webpack_require__(2563);

/**
 * ### .compareByInspect(mixed, mixed)
 *
 * To be used as a compareFunction with Array.prototype.sort. Compares elements
 * using inspect instead of default behavior of using toString so that Symbols
 * and objects with irregular/missing toString can still be sorted without a
 * TypeError.
 *
 * @param {Mixed} first element to compare
 * @param {Mixed} second element to compare
 * @returns {Number} -1 if 'a' should come before 'b'; otherwise 1
 * @name compareByInspect
 * @namespace Utils
 * @api public
 */

module.exports = function compareByInspect(a, b) {
  return inspect(a) < inspect(b) ? -1 : 1;
};


/***/ }),

/***/ 3265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - expectTypes utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .expectTypes(obj, types)
 *
 * Ensures that the object being tested against is of a valid type.
 *
 *     utils.expectTypes(this, ['array', 'object', 'string']);
 *
 * @param {Mixed} obj constructed Assertion
 * @param {Array} type A list of allowed types for this assertion
 * @namespace Utils
 * @name expectTypes
 * @api public
 */

var AssertionError = __webpack_require__(6126);
var flag = __webpack_require__(3183);
var type = __webpack_require__(7013);

module.exports = function expectTypes(obj, types) {
  var flagMsg = flag(obj, 'message');
  var ssfi = flag(obj, 'ssfi');

  flagMsg = flagMsg ? flagMsg + ': ' : '';

  obj = flag(obj, 'object');
  types = types.map(function (t) { return t.toLowerCase(); });
  types.sort();

  // Transforms ['lorem', 'ipsum'] into 'a lorem, or an ipsum'
  var str = types.map(function (t, index) {
    var art = ~[ 'a', 'e', 'i', 'o', 'u' ].indexOf(t.charAt(0)) ? 'an' : 'a';
    var or = types.length > 1 && index === types.length - 1 ? 'or ' : '';
    return or + art + ' ' + t;
  }).join(', ');

  var objType = type(obj).toLowerCase();

  if (!types.some(function (expected) { return objType === expected; })) {
    throw new AssertionError(
      flagMsg + 'object tested must be ' + str + ', but ' + objType + ' given',
      undefined,
      ssfi
    );
  }
};


/***/ }),

/***/ 3183:
/***/ (function(module) {

/*!
 * Chai - flag utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .flag(object, key, [value])
 *
 * Get or set a flag value on an object. If a
 * value is provided it will be set, else it will
 * return the currently set value or `undefined` if
 * the value is not set.
 *
 *     utils.flag(this, 'foo', 'bar'); // setter
 *     utils.flag(this, 'foo'); // getter, returns `bar`
 *
 * @param {Object} object constructed Assertion
 * @param {String} key
 * @param {Mixed} value (optional)
 * @namespace Utils
 * @name flag
 * @api private
 */

module.exports = function flag(obj, key, value) {
  var flags = obj.__flags || (obj.__flags = Object.create(null));
  if (arguments.length === 3) {
    flags[key] = value;
  } else {
    return flags[key];
  }
};


/***/ }),

/***/ 3428:
/***/ (function(module) {

/*!
 * Chai - getActual utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .getActual(object, [actual])
 *
 * Returns the `actual` value for an Assertion.
 *
 * @param {Object} object (constructed Assertion)
 * @param {Arguments} chai.Assertion.prototype.assert arguments
 * @namespace Utils
 * @name getActual
 */

module.exports = function getActual(obj, args) {
  return args.length > 4 ? args[4] : obj._obj;
};


/***/ }),

/***/ 5540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - message composition utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Module dependencies
 */

var flag = __webpack_require__(3183)
  , getActual = __webpack_require__(3428)
  , objDisplay = __webpack_require__(6020);

/**
 * ### .getMessage(object, message, negateMessage)
 *
 * Construct the error message based on flags
 * and template tags. Template tags will return
 * a stringified inspection of the object referenced.
 *
 * Message template tags:
 * - `#{this}` current asserted object
 * - `#{act}` actual value
 * - `#{exp}` expected value
 *
 * @param {Object} object (constructed Assertion)
 * @param {Arguments} chai.Assertion.prototype.assert arguments
 * @namespace Utils
 * @name getMessage
 * @api public
 */

module.exports = function getMessage(obj, args) {
  var negate = flag(obj, 'negate')
    , val = flag(obj, 'object')
    , expected = args[3]
    , actual = getActual(obj, args)
    , msg = negate ? args[2] : args[1]
    , flagMsg = flag(obj, 'message');

  if(typeof msg === "function") msg = msg();
  msg = msg || '';
  msg = msg
    .replace(/#\{this\}/g, function () { return objDisplay(val); })
    .replace(/#\{act\}/g, function () { return objDisplay(actual); })
    .replace(/#\{exp\}/g, function () { return objDisplay(expected); });

  return flagMsg ? flagMsg + ': ' + msg : msg;
};


/***/ }),

/***/ 6775:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var type = __webpack_require__(7013);

var flag = __webpack_require__(3183);

function isObjectType(obj) {
  var objectType = type(obj);
  var objectTypes = ['Array', 'Object', 'function'];

  return objectTypes.indexOf(objectType) !== -1;
}

/**
 * ### .getOperator(message)
 *
 * Extract the operator from error message.
 * Operator defined is based on below link
 * https://nodejs.org/api/assert.html#assert_assert.
 *
 * Returns the `operator` or `undefined` value for an Assertion.
 *
 * @param {Object} object (constructed Assertion)
 * @param {Arguments} chai.Assertion.prototype.assert arguments
 * @namespace Utils
 * @name getOperator
 * @api public
 */

module.exports = function getOperator(obj, args) {
  var operator = flag(obj, 'operator');
  var negate = flag(obj, 'negate');
  var expected = args[3];
  var msg = negate ? args[2] : args[1];

  if (operator) {
    return operator;
  }

  if (typeof msg === 'function') msg = msg();

  msg = msg || '';
  if (!msg) {
    return undefined;
  }

  if (/\shave\s/.test(msg)) {
    return undefined;
  }

  var isObject = isObjectType(expected);
  if (/\snot\s/.test(msg)) {
    return isObject ? 'notDeepStrictEqual' : 'notStrictEqual';
  }

  return isObject ? 'deepStrictEqual' : 'strictEqual';
};


/***/ }),

/***/ 1711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - getOwnEnumerableProperties utility
 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Module dependencies
 */

var getOwnEnumerablePropertySymbols = __webpack_require__(9663);

/**
 * ### .getOwnEnumerableProperties(object)
 *
 * This allows the retrieval of directly-owned enumerable property names and
 * symbols of an object. This function is necessary because Object.keys only
 * returns enumerable property names, not enumerable property symbols.
 *
 * @param {Object} object
 * @returns {Array}
 * @namespace Utils
 * @name getOwnEnumerableProperties
 * @api public
 */

module.exports = function getOwnEnumerableProperties(obj) {
  return Object.keys(obj).concat(getOwnEnumerablePropertySymbols(obj));
};


/***/ }),

/***/ 9663:
/***/ (function(module) {

/*!
 * Chai - getOwnEnumerablePropertySymbols utility
 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .getOwnEnumerablePropertySymbols(object)
 *
 * This allows the retrieval of directly-owned enumerable property symbols of an
 * object. This function is necessary because Object.getOwnPropertySymbols
 * returns both enumerable and non-enumerable property symbols.
 *
 * @param {Object} object
 * @returns {Array}
 * @namespace Utils
 * @name getOwnEnumerablePropertySymbols
 * @api public
 */

module.exports = function getOwnEnumerablePropertySymbols(obj) {
  if (typeof Object.getOwnPropertySymbols !== 'function') return [];

  return Object.getOwnPropertySymbols(obj).filter(function (sym) {
    return Object.getOwnPropertyDescriptor(obj, sym).enumerable;
  });
};


/***/ }),

/***/ 9475:
/***/ (function(module) {

/*!
 * Chai - getProperties utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .getProperties(object)
 *
 * This allows the retrieval of property names of an object, enumerable or not,
 * inherited or not.
 *
 * @param {Object} object
 * @returns {Array}
 * @namespace Utils
 * @name getProperties
 * @api public
 */

module.exports = function getProperties(object) {
  var result = Object.getOwnPropertyNames(object);

  function addProperty(property) {
    if (result.indexOf(property) === -1) {
      result.push(property);
    }
  }

  var proto = Object.getPrototypeOf(object);
  while (proto !== null) {
    Object.getOwnPropertyNames(proto).forEach(addProperty);
    proto = Object.getPrototypeOf(proto);
  }

  return result;
};


/***/ }),

/***/ 4920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/*!
 * chai
 * Copyright(c) 2011 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Dependencies that are used for multiple exports are required here only once
 */

var pathval = __webpack_require__(5539);

/*!
 * test utility
 */

exports.test = __webpack_require__(6765);

/*!
 * type utility
 */

exports.type = __webpack_require__(7013);

/*!
 * expectTypes utility
 */
exports.expectTypes = __webpack_require__(3265);

/*!
 * message utility
 */

exports.getMessage = __webpack_require__(5540);

/*!
 * actual utility
 */

exports.getActual = __webpack_require__(3428);

/*!
 * Inspect util
 */

exports.inspect = __webpack_require__(2563);

/*!
 * Object Display util
 */

exports.objDisplay = __webpack_require__(6020);

/*!
 * Flag utility
 */

exports.flag = __webpack_require__(3183);

/*!
 * Flag transferring utility
 */

exports.transferFlags = __webpack_require__(3897);

/*!
 * Deep equal utility
 */

exports.eql = __webpack_require__(8310);

/*!
 * Deep path info
 */

exports.getPathInfo = pathval.getPathInfo;

/*!
 * Check if a property exists
 */

exports.hasProperty = pathval.hasProperty;

/*!
 * Function name
 */

exports.getName = __webpack_require__(7643);

/*!
 * add Property
 */

exports.addProperty = __webpack_require__(7152);

/*!
 * add Method
 */

exports.addMethod = __webpack_require__(3775);

/*!
 * overwrite Property
 */

exports.overwriteProperty = __webpack_require__(3599);

/*!
 * overwrite Method
 */

exports.overwriteMethod = __webpack_require__(8632);

/*!
 * Add a chainable method
 */

exports.addChainableMethod = __webpack_require__(3707);

/*!
 * Overwrite chainable method
 */

exports.overwriteChainableMethod = __webpack_require__(3796);

/*!
 * Compare by inspect method
 */

exports.compareByInspect = __webpack_require__(391);

/*!
 * Get own enumerable property symbols method
 */

exports.getOwnEnumerablePropertySymbols = __webpack_require__(9663);

/*!
 * Get own enumerable properties method
 */

exports.getOwnEnumerableProperties = __webpack_require__(1711);

/*!
 * Checks error against a given set of criteria
 */

exports.checkError = __webpack_require__(2182);

/*!
 * Proxify util
 */

exports.proxify = __webpack_require__(925);

/*!
 * addLengthGuard util
 */

exports.addLengthGuard = __webpack_require__(7758);

/*!
 * isProxyEnabled helper
 */

exports.isProxyEnabled = __webpack_require__(3035);

/*!
 * isNaN method
 */

exports.isNaN = __webpack_require__(9046);

/*!
 * getOperator method
 */

exports.getOperator = __webpack_require__(6775);

/***/ }),

/***/ 2563:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// This is (almost) directly from Node.js utils
// https://github.com/joyent/node/blob/f8c335d0caf47f16d31413f89aa28eda3878e3aa/lib/util.js

var getName = __webpack_require__(7643);
var loupe = __webpack_require__(7161);
var config = __webpack_require__(4448);

module.exports = inspect;

/**
 * ### .inspect(obj, [showHidden], [depth], [colors])
 *
 * Echoes the value of a value. Tries to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Boolean} showHidden Flag that shows hidden (not enumerable)
 *    properties of objects. Default is false.
 * @param {Number} depth Depth in which to descend in object. Default is 2.
 * @param {Boolean} colors Flag to turn on ANSI escape codes to color the
 *    output. Default is false (no coloring).
 * @namespace Utils
 * @name inspect
 */
function inspect(obj, showHidden, depth, colors) {
  var options = {
    colors: colors,
    depth: (typeof depth === 'undefined' ? 2 : depth),
    showHidden: showHidden,
    truncate: config.truncateThreshold ? config.truncateThreshold : Infinity,
  };
  return loupe.inspect(obj, options);
}


/***/ }),

/***/ 9046:
/***/ (function(module) {

/*!
 * Chai - isNaN utility
 * Copyright(c) 2012-2015 Sakthipriyan Vairamani <thechargingvolcano@gmail.com>
 * MIT Licensed
 */

/**
 * ### .isNaN(value)
 *
 * Checks if the given value is NaN or not.
 *
 *     utils.isNaN(NaN); // true
 *
 * @param {Value} The value which has to be checked if it is NaN
 * @name isNaN
 * @api private
 */

function isNaN(value) {
  // Refer http://www.ecma-international.org/ecma-262/6.0/#sec-isnan-number
  // section's NOTE.
  return value !== value;
}

// If ECMAScript 6's Number.isNaN is present, prefer that.
module.exports = Number.isNaN || isNaN;


/***/ }),

/***/ 3035:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var config = __webpack_require__(4448);

/*!
 * Chai - isProxyEnabled helper
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .isProxyEnabled()
 *
 * Helper function to check if Chai's proxy protection feature is enabled. If
 * proxies are unsupported or disabled via the user's Chai config, then return
 * false. Otherwise, return true.
 *
 * @namespace Utils
 * @name isProxyEnabled
 */

module.exports = function isProxyEnabled() {
  return config.useProxy &&
    typeof Proxy !== 'undefined' &&
    typeof Reflect !== 'undefined';
};


/***/ }),

/***/ 6020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - flag utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Module dependencies
 */

var inspect = __webpack_require__(2563);
var config = __webpack_require__(4448);

/**
 * ### .objDisplay(object)
 *
 * Determines if an object or an array matches
 * criteria to be inspected in-line for error
 * messages or should be truncated.
 *
 * @param {Mixed} javascript object to inspect
 * @name objDisplay
 * @namespace Utils
 * @api public
 */

module.exports = function objDisplay(obj) {
  var str = inspect(obj)
    , type = Object.prototype.toString.call(obj);

  if (config.truncateThreshold && str.length >= config.truncateThreshold) {
    if (type === '[object Function]') {
      return !obj.name || obj.name === ''
        ? '[Function]'
        : '[Function: ' + obj.name + ']';
    } else if (type === '[object Array]') {
      return '[ Array(' + obj.length + ') ]';
    } else if (type === '[object Object]') {
      var keys = Object.keys(obj)
        , kstr = keys.length > 2
          ? keys.splice(0, 2).join(', ') + ', ...'
          : keys.join(', ');
      return '{ Object (' + kstr + ') }';
    } else {
      return str;
    }
  } else {
    return str;
  }
};


/***/ }),

/***/ 3796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - overwriteChainableMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var chai = __webpack_require__(1928);
var transferFlags = __webpack_require__(3897);

/**
 * ### .overwriteChainableMethod(ctx, name, method, chainingBehavior)
 *
 * Overwrites an already existing chainable method
 * and provides access to the previous function or
 * property.  Must return functions to be used for
 * name.
 *
 *     utils.overwriteChainableMethod(chai.Assertion.prototype, 'lengthOf',
 *       function (_super) {
 *       }
 *     , function (_super) {
 *       }
 *     );
 *
 * Can also be accessed directly from `chai.Assertion`.
 *
 *     chai.Assertion.overwriteChainableMethod('foo', fn, fn);
 *
 * Then can be used as any other assertion.
 *
 *     expect(myFoo).to.have.lengthOf(3);
 *     expect(myFoo).to.have.lengthOf.above(3);
 *
 * @param {Object} ctx object whose method / property is to be overwritten
 * @param {String} name of method / property to overwrite
 * @param {Function} method function that returns a function to be used for name
 * @param {Function} chainingBehavior function that returns a function to be used for property
 * @namespace Utils
 * @name overwriteChainableMethod
 * @api public
 */

module.exports = function overwriteChainableMethod(ctx, name, method, chainingBehavior) {
  var chainableBehavior = ctx.__methods[name];

  var _chainingBehavior = chainableBehavior.chainingBehavior;
  chainableBehavior.chainingBehavior = function overwritingChainableMethodGetter() {
    var result = chainingBehavior(_chainingBehavior).call(this);
    if (result !== undefined) {
      return result;
    }

    var newAssertion = new chai.Assertion();
    transferFlags(this, newAssertion);
    return newAssertion;
  };

  var _method = chainableBehavior.method;
  chainableBehavior.method = function overwritingChainableMethodWrapper() {
    var result = method(_method).apply(this, arguments);
    if (result !== undefined) {
      return result;
    }

    var newAssertion = new chai.Assertion();
    transferFlags(this, newAssertion);
    return newAssertion;
  };
};


/***/ }),

/***/ 8632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - overwriteMethod utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var addLengthGuard = __webpack_require__(7758);
var chai = __webpack_require__(1928);
var flag = __webpack_require__(3183);
var proxify = __webpack_require__(925);
var transferFlags = __webpack_require__(3897);

/**
 * ### .overwriteMethod(ctx, name, fn)
 *
 * Overwrites an already existing method and provides
 * access to previous function. Must return function
 * to be used for name.
 *
 *     utils.overwriteMethod(chai.Assertion.prototype, 'equal', function (_super) {
 *       return function (str) {
 *         var obj = utils.flag(this, 'object');
 *         if (obj instanceof Foo) {
 *           new chai.Assertion(obj.value).to.equal(str);
 *         } else {
 *           _super.apply(this, arguments);
 *         }
 *       }
 *     });
 *
 * Can also be accessed directly from `chai.Assertion`.
 *
 *     chai.Assertion.overwriteMethod('foo', fn);
 *
 * Then can be used as any other assertion.
 *
 *     expect(myFoo).to.equal('bar');
 *
 * @param {Object} ctx object whose method is to be overwritten
 * @param {String} name of method to overwrite
 * @param {Function} method function that returns a function to be used for name
 * @namespace Utils
 * @name overwriteMethod
 * @api public
 */

module.exports = function overwriteMethod(ctx, name, method) {
  var _method = ctx[name]
    , _super = function () {
      throw new Error(name + ' is not a function');
    };

  if (_method && 'function' === typeof _method)
    _super = _method;

  var overwritingMethodWrapper = function () {
    // Setting the `ssfi` flag to `overwritingMethodWrapper` causes this
    // function to be the starting point for removing implementation frames from
    // the stack trace of a failed assertion.
    //
    // However, we only want to use this function as the starting point if the
    // `lockSsfi` flag isn't set.
    //
    // If the `lockSsfi` flag is set, then either this assertion has been
    // overwritten by another assertion, or this assertion is being invoked from
    // inside of another assertion. In the first case, the `ssfi` flag has
    // already been set by the overwriting assertion. In the second case, the
    // `ssfi` flag has already been set by the outer assertion.
    if (!flag(this, 'lockSsfi')) {
      flag(this, 'ssfi', overwritingMethodWrapper);
    }

    // Setting the `lockSsfi` flag to `true` prevents the overwritten assertion
    // from changing the `ssfi` flag. By this point, the `ssfi` flag is already
    // set to the correct starting point for this assertion.
    var origLockSsfi = flag(this, 'lockSsfi');
    flag(this, 'lockSsfi', true);
    var result = method(_super).apply(this, arguments);
    flag(this, 'lockSsfi', origLockSsfi);

    if (result !== undefined) {
      return result;
    }

    var newAssertion = new chai.Assertion();
    transferFlags(this, newAssertion);
    return newAssertion;
  }

  addLengthGuard(overwritingMethodWrapper, name, false);
  ctx[name] = proxify(overwritingMethodWrapper, name);
};


/***/ }),

/***/ 3599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - overwriteProperty utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var chai = __webpack_require__(1928);
var flag = __webpack_require__(3183);
var isProxyEnabled = __webpack_require__(3035);
var transferFlags = __webpack_require__(3897);

/**
 * ### .overwriteProperty(ctx, name, fn)
 *
 * Overwrites an already existing property getter and provides
 * access to previous value. Must return function to use as getter.
 *
 *     utils.overwriteProperty(chai.Assertion.prototype, 'ok', function (_super) {
 *       return function () {
 *         var obj = utils.flag(this, 'object');
 *         if (obj instanceof Foo) {
 *           new chai.Assertion(obj.name).to.equal('bar');
 *         } else {
 *           _super.call(this);
 *         }
 *       }
 *     });
 *
 *
 * Can also be accessed directly from `chai.Assertion`.
 *
 *     chai.Assertion.overwriteProperty('foo', fn);
 *
 * Then can be used as any other assertion.
 *
 *     expect(myFoo).to.be.ok;
 *
 * @param {Object} ctx object whose property is to be overwritten
 * @param {String} name of property to overwrite
 * @param {Function} getter function that returns a getter function to be used for name
 * @namespace Utils
 * @name overwriteProperty
 * @api public
 */

module.exports = function overwriteProperty(ctx, name, getter) {
  var _get = Object.getOwnPropertyDescriptor(ctx, name)
    , _super = function () {};

  if (_get && 'function' === typeof _get.get)
    _super = _get.get

  Object.defineProperty(ctx, name,
    { get: function overwritingPropertyGetter() {
        // Setting the `ssfi` flag to `overwritingPropertyGetter` causes this
        // function to be the starting point for removing implementation frames
        // from the stack trace of a failed assertion.
        //
        // However, we only want to use this function as the starting point if
        // the `lockSsfi` flag isn't set and proxy protection is disabled.
        //
        // If the `lockSsfi` flag is set, then either this assertion has been
        // overwritten by another assertion, or this assertion is being invoked
        // from inside of another assertion. In the first case, the `ssfi` flag
        // has already been set by the overwriting assertion. In the second
        // case, the `ssfi` flag has already been set by the outer assertion.
        //
        // If proxy protection is enabled, then the `ssfi` flag has already been
        // set by the proxy getter.
        if (!isProxyEnabled() && !flag(this, 'lockSsfi')) {
          flag(this, 'ssfi', overwritingPropertyGetter);
        }

        // Setting the `lockSsfi` flag to `true` prevents the overwritten
        // assertion from changing the `ssfi` flag. By this point, the `ssfi`
        // flag is already set to the correct starting point for this assertion.
        var origLockSsfi = flag(this, 'lockSsfi');
        flag(this, 'lockSsfi', true);
        var result = getter(_super).call(this);
        flag(this, 'lockSsfi', origLockSsfi);

        if (result !== undefined) {
          return result;
        }

        var newAssertion = new chai.Assertion();
        transferFlags(this, newAssertion);
        return newAssertion;
      }
    , configurable: true
  });
};


/***/ }),

/***/ 925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var config = __webpack_require__(4448);
var flag = __webpack_require__(3183);
var getProperties = __webpack_require__(9475);
var isProxyEnabled = __webpack_require__(3035);

/*!
 * Chai - proxify utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .proxify(object)
 *
 * Return a proxy of given object that throws an error when a non-existent
 * property is read. By default, the root cause is assumed to be a misspelled
 * property, and thus an attempt is made to offer a reasonable suggestion from
 * the list of existing properties. However, if a nonChainableMethodName is
 * provided, then the root cause is instead a failure to invoke a non-chainable
 * method prior to reading the non-existent property.
 *
 * If proxies are unsupported or disabled via the user's Chai config, then
 * return object without modification.
 *
 * @param {Object} obj
 * @param {String} nonChainableMethodName
 * @namespace Utils
 * @name proxify
 */

var builtins = ['__flags', '__methods', '_obj', 'assert'];

module.exports = function proxify(obj, nonChainableMethodName) {
  if (!isProxyEnabled()) return obj;

  return new Proxy(obj, {
    get: function proxyGetter(target, property) {
      // This check is here because we should not throw errors on Symbol properties
      // such as `Symbol.toStringTag`.
      // The values for which an error should be thrown can be configured using
      // the `config.proxyExcludedKeys` setting.
      if (typeof property === 'string' &&
          config.proxyExcludedKeys.indexOf(property) === -1 &&
          !Reflect.has(target, property)) {
        // Special message for invalid property access of non-chainable methods.
        if (nonChainableMethodName) {
          throw Error('Invalid Chai property: ' + nonChainableMethodName + '.' +
            property + '. See docs for proper usage of "' +
            nonChainableMethodName + '".');
        }

        // If the property is reasonably close to an existing Chai property,
        // suggest that property to the user. Only suggest properties with a
        // distance less than 4.
        var suggestion = null;
        var suggestionDistance = 4;
        getProperties(target).forEach(function(prop) {
          if (
            !Object.prototype.hasOwnProperty(prop) &&
            builtins.indexOf(prop) === -1
          ) {
            var dist = stringDistanceCapped(
              property,
              prop,
              suggestionDistance
            );
            if (dist < suggestionDistance) {
              suggestion = prop;
              suggestionDistance = dist;
            }
          }
        });

        if (suggestion !== null) {
          throw Error('Invalid Chai property: ' + property +
            '. Did you mean "' + suggestion + '"?');
        } else {
          throw Error('Invalid Chai property: ' + property);
        }
      }

      // Use this proxy getter as the starting point for removing implementation
      // frames from the stack trace of a failed assertion. For property
      // assertions, this prevents the proxy getter from showing up in the stack
      // trace since it's invoked before the property getter. For method and
      // chainable method assertions, this flag will end up getting changed to
      // the method wrapper, which is good since this frame will no longer be in
      // the stack once the method is invoked. Note that Chai builtin assertion
      // properties such as `__flags` are skipped since this is only meant to
      // capture the starting point of an assertion. This step is also skipped
      // if the `lockSsfi` flag is set, thus indicating that this assertion is
      // being called from within another assertion. In that case, the `ssfi`
      // flag is already set to the outer assertion's starting point.
      if (builtins.indexOf(property) === -1 && !flag(target, 'lockSsfi')) {
        flag(target, 'ssfi', proxyGetter);
      }

      return Reflect.get(target, property);
    }
  });
};

/**
 * # stringDistanceCapped(strA, strB, cap)
 * Return the Levenshtein distance between two strings, but no more than cap.
 * @param {string} strA
 * @param {string} strB
 * @param {number} number
 * @return {number} min(string distance between strA and strB, cap)
 * @api private
 */

function stringDistanceCapped(strA, strB, cap) {
  if (Math.abs(strA.length - strB.length) >= cap) {
    return cap;
  }

  var memo = [];
  // `memo` is a two-dimensional array containing distances.
  // memo[i][j] is the distance between strA.slice(0, i) and
  // strB.slice(0, j).
  for (var i = 0; i <= strA.length; i++) {
    memo[i] = Array(strB.length + 1).fill(0);
    memo[i][0] = i;
  }
  for (var j = 0; j < strB.length; j++) {
    memo[0][j] = j;
  }

  for (var i = 1; i <= strA.length; i++) {
    var ch = strA.charCodeAt(i - 1);
    for (var j = 1; j <= strB.length; j++) {
      if (Math.abs(i - j) >= cap) {
        memo[i][j] = cap;
        continue;
      }
      memo[i][j] = Math.min(
        memo[i - 1][j] + 1,
        memo[i][j - 1] + 1,
        memo[i - 1][j - 1] +
          (ch === strB.charCodeAt(j - 1) ? 0 : 1)
      );
    }
  }

  return memo[strA.length][strB.length];
}


/***/ }),

/***/ 6765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Chai - test utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/*!
 * Module dependencies
 */

var flag = __webpack_require__(3183);

/**
 * ### .test(object, expression)
 *
 * Test and object for expression.
 *
 * @param {Object} object (constructed Assertion)
 * @param {Arguments} chai.Assertion.prototype.assert arguments
 * @namespace Utils
 * @name test
 */

module.exports = function test(obj, args) {
  var negate = flag(obj, 'negate')
    , expr = args[0];
  return negate ? !expr : expr;
};


/***/ }),

/***/ 3897:
/***/ (function(module) {

/*!
 * Chai - transferFlags utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .transferFlags(assertion, object, includeAll = true)
 *
 * Transfer all the flags for `assertion` to `object`. If
 * `includeAll` is set to `false`, then the base Chai
 * assertion flags (namely `object`, `ssfi`, `lockSsfi`,
 * and `message`) will not be transferred.
 *
 *
 *     var newAssertion = new Assertion();
 *     utils.transferFlags(assertion, newAssertion);
 *
 *     var anotherAssertion = new Assertion(myObj);
 *     utils.transferFlags(assertion, anotherAssertion, false);
 *
 * @param {Assertion} assertion the assertion to transfer the flags from
 * @param {Object} object the object to transfer the flags to; usually a new assertion
 * @param {Boolean} includeAll
 * @namespace Utils
 * @name transferFlags
 * @api private
 */

module.exports = function transferFlags(assertion, object, includeAll) {
  var flags = assertion.__flags || (assertion.__flags = Object.create(null));

  if (!object.__flags) {
    object.__flags = Object.create(null);
  }

  includeAll = arguments.length === 3 ? includeAll : true;

  for (var flag in flags) {
    if (includeAll ||
        (flag !== 'object' && flag !== 'ssfi' && flag !== 'lockSsfi' && flag != 'message')) {
      object.__flags[flag] = flags[flag];
    }
  }
};


/***/ }),

/***/ 2182:
/***/ (function(module) {

"use strict";


/* !
 * Chai - checkError utility
 * Copyright(c) 2012-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .checkError
 *
 * Checks that an error conforms to a given set of criteria and/or retrieves information about it.
 *
 * @api public
 */

/**
 * ### .compatibleInstance(thrown, errorLike)
 *
 * Checks if two instances are compatible (strict equal).
 * Returns false if errorLike is not an instance of Error, because instances
 * can only be compatible if they're both error instances.
 *
 * @name compatibleInstance
 * @param {Error} thrown error
 * @param {Error|ErrorConstructor} errorLike object to compare against
 * @namespace Utils
 * @api public
 */

function compatibleInstance(thrown, errorLike) {
  return errorLike instanceof Error && thrown === errorLike;
}

/**
 * ### .compatibleConstructor(thrown, errorLike)
 *
 * Checks if two constructors are compatible.
 * This function can receive either an error constructor or
 * an error instance as the `errorLike` argument.
 * Constructors are compatible if they're the same or if one is
 * an instance of another.
 *
 * @name compatibleConstructor
 * @param {Error} thrown error
 * @param {Error|ErrorConstructor} errorLike object to compare against
 * @namespace Utils
 * @api public
 */

function compatibleConstructor(thrown, errorLike) {
  if (errorLike instanceof Error) {
    // If `errorLike` is an instance of any error we compare their constructors
    return thrown.constructor === errorLike.constructor || thrown instanceof errorLike.constructor;
  } else if (errorLike.prototype instanceof Error || errorLike === Error) {
    // If `errorLike` is a constructor that inherits from Error, we compare `thrown` to `errorLike` directly
    return thrown.constructor === errorLike || thrown instanceof errorLike;
  }

  return false;
}

/**
 * ### .compatibleMessage(thrown, errMatcher)
 *
 * Checks if an error's message is compatible with a matcher (String or RegExp).
 * If the message contains the String or passes the RegExp test,
 * it is considered compatible.
 *
 * @name compatibleMessage
 * @param {Error} thrown error
 * @param {String|RegExp} errMatcher to look for into the message
 * @namespace Utils
 * @api public
 */

function compatibleMessage(thrown, errMatcher) {
  var comparisonString = typeof thrown === 'string' ? thrown : thrown.message;
  if (errMatcher instanceof RegExp) {
    return errMatcher.test(comparisonString);
  } else if (typeof errMatcher === 'string') {
    return comparisonString.indexOf(errMatcher) !== -1; // eslint-disable-line no-magic-numbers
  }

  return false;
}

/**
 * ### .getFunctionName(constructorFn)
 *
 * Returns the name of a function.
 * This also includes a polyfill function if `constructorFn.name` is not defined.
 *
 * @name getFunctionName
 * @param {Function} constructorFn
 * @namespace Utils
 * @api private
 */

var functionNameMatch = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\(\/]+)/;
function getFunctionName(constructorFn) {
  var name = '';
  if (typeof constructorFn.name === 'undefined') {
    // Here we run a polyfill if constructorFn.name is not defined
    var match = String(constructorFn).match(functionNameMatch);
    if (match) {
      name = match[1];
    }
  } else {
    name = constructorFn.name;
  }

  return name;
}

/**
 * ### .getConstructorName(errorLike)
 *
 * Gets the constructor name for an Error instance or constructor itself.
 *
 * @name getConstructorName
 * @param {Error|ErrorConstructor} errorLike
 * @namespace Utils
 * @api public
 */

function getConstructorName(errorLike) {
  var constructorName = errorLike;
  if (errorLike instanceof Error) {
    constructorName = getFunctionName(errorLike.constructor);
  } else if (typeof errorLike === 'function') {
    // If `err` is not an instance of Error it is an error constructor itself or another function.
    // If we've got a common function we get its name, otherwise we may need to create a new instance
    // of the error just in case it's a poorly-constructed error. Please see chaijs/chai/issues/45 to know more.
    constructorName = getFunctionName(errorLike).trim() ||
        getFunctionName(new errorLike()); // eslint-disable-line new-cap
  }

  return constructorName;
}

/**
 * ### .getMessage(errorLike)
 *
 * Gets the error message from an error.
 * If `err` is a String itself, we return it.
 * If the error has no message, we return an empty string.
 *
 * @name getMessage
 * @param {Error|String} errorLike
 * @namespace Utils
 * @api public
 */

function getMessage(errorLike) {
  var msg = '';
  if (errorLike && errorLike.message) {
    msg = errorLike.message;
  } else if (typeof errorLike === 'string') {
    msg = errorLike;
  }

  return msg;
}

module.exports = {
  compatibleInstance: compatibleInstance,
  compatibleConstructor: compatibleConstructor,
  compatibleMessage: compatibleMessage,
  getMessage: getMessage,
  getConstructorName: getConstructorName,
};


/***/ }),

/***/ 5108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*global window, global*/
var util = __webpack_require__(9539)
var assert = __webpack_require__(9282)
function now() { return new Date().getTime() }

var slice = Array.prototype.slice
var console
var times = {}

if (typeof __webpack_require__.g !== "undefined" && __webpack_require__.g.console) {
    console = __webpack_require__.g.console
} else if (typeof window !== "undefined" && window.console) {
    console = window.console
} else {
    console = {}
}

var functions = [
    [log, "log"],
    [info, "info"],
    [warn, "warn"],
    [error, "error"],
    [time, "time"],
    [timeEnd, "timeEnd"],
    [trace, "trace"],
    [dir, "dir"],
    [consoleAssert, "assert"]
]

for (var i = 0; i < functions.length; i++) {
    var tuple = functions[i]
    var f = tuple[0]
    var name = tuple[1]

    if (!console[name]) {
        console[name] = f
    }
}

module.exports = console

function log() {}

function info() {
    console.log.apply(console, arguments)
}

function warn() {
    console.log.apply(console, arguments)
}

function error() {
    console.warn.apply(console, arguments)
}

function time(label) {
    times[label] = now()
}

function timeEnd(label) {
    var time = times[label]
    if (!time) {
        throw new Error("No such label: " + label)
    }

    delete times[label]
    var duration = now() - time
    console.log(label + ": " + duration + "ms")
}

function trace() {
    var err = new Error()
    err.name = "Trace"
    err.message = util.format.apply(null, arguments)
    console.error(err.stack)
}

function dir(object) {
    console.log(util.inspect(object) + "\n")
}

function consoleAssert(expression) {
    if (!expression) {
        var arr = slice.call(arguments, 1)
        assert.ok(false, util.format.apply(null, arr))
    }
}


/***/ }),

/***/ 8310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* globals Symbol: false, Uint8Array: false, WeakMap: false */
/*!
 * deep-eql
 * Copyright(c) 2013 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

var type = __webpack_require__(7013);
function FakeMap() {
  this._key = 'chai/deep-eql__' + Math.random() + Date.now();
}

FakeMap.prototype = {
  get: function getMap(key) {
    return key[this._key];
  },
  set: function setMap(key, value) {
    if (Object.isExtensible(key)) {
      Object.defineProperty(key, this._key, {
        value: value,
        configurable: true,
      });
    }
  },
};

var MemoizeMap = typeof WeakMap === 'function' ? WeakMap : FakeMap;
/*!
 * Check to see if the MemoizeMap has recorded a result of the two operands
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {MemoizeMap} memoizeMap
 * @returns {Boolean|null} result
*/
function memoizeCompare(leftHandOperand, rightHandOperand, memoizeMap) {
  // Technically, WeakMap keys can *only* be objects, not primitives.
  if (!memoizeMap || isPrimitive(leftHandOperand) || isPrimitive(rightHandOperand)) {
    return null;
  }
  var leftHandMap = memoizeMap.get(leftHandOperand);
  if (leftHandMap) {
    var result = leftHandMap.get(rightHandOperand);
    if (typeof result === 'boolean') {
      return result;
    }
  }
  return null;
}

/*!
 * Set the result of the equality into the MemoizeMap
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {MemoizeMap} memoizeMap
 * @param {Boolean} result
*/
function memoizeSet(leftHandOperand, rightHandOperand, memoizeMap, result) {
  // Technically, WeakMap keys can *only* be objects, not primitives.
  if (!memoizeMap || isPrimitive(leftHandOperand) || isPrimitive(rightHandOperand)) {
    return;
  }
  var leftHandMap = memoizeMap.get(leftHandOperand);
  if (leftHandMap) {
    leftHandMap.set(rightHandOperand, result);
  } else {
    leftHandMap = new MemoizeMap();
    leftHandMap.set(rightHandOperand, result);
    memoizeMap.set(leftHandOperand, leftHandMap);
  }
}

/*!
 * Primary Export
 */

module.exports = deepEqual;
module.exports.MemoizeMap = MemoizeMap;

/**
 * Assert deeply nested sameValue equality between two objects of any type.
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {Object} [options] (optional) Additional options
 * @param {Array} [options.comparator] (optional) Override default algorithm, determining custom equality.
 * @param {Array} [options.memoize] (optional) Provide a custom memoization object which will cache the results of
    complex objects for a speed boost. By passing `false` you can disable memoization, but this will cause circular
    references to blow the stack.
 * @return {Boolean} equal match
 */
function deepEqual(leftHandOperand, rightHandOperand, options) {
  // If we have a comparator, we can't assume anything; so bail to its check first.
  if (options && options.comparator) {
    return extensiveDeepEqual(leftHandOperand, rightHandOperand, options);
  }

  var simpleResult = simpleEqual(leftHandOperand, rightHandOperand);
  if (simpleResult !== null) {
    return simpleResult;
  }

  // Deeper comparisons are pushed through to a larger function
  return extensiveDeepEqual(leftHandOperand, rightHandOperand, options);
}

/**
 * Many comparisons can be canceled out early via simple equality or primitive checks.
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @return {Boolean|null} equal match
 */
function simpleEqual(leftHandOperand, rightHandOperand) {
  // Equal references (except for Numbers) can be returned early
  if (leftHandOperand === rightHandOperand) {
    // Handle +-0 cases
    return leftHandOperand !== 0 || 1 / leftHandOperand === 1 / rightHandOperand;
  }

  // handle NaN cases
  if (
    leftHandOperand !== leftHandOperand && // eslint-disable-line no-self-compare
    rightHandOperand !== rightHandOperand // eslint-disable-line no-self-compare
  ) {
    return true;
  }

  // Anything that is not an 'object', i.e. symbols, functions, booleans, numbers,
  // strings, and undefined, can be compared by reference.
  if (isPrimitive(leftHandOperand) || isPrimitive(rightHandOperand)) {
    // Easy out b/c it would have passed the first equality check
    return false;
  }
  return null;
}

/*!
 * The main logic of the `deepEqual` function.
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {Object} [options] (optional) Additional options
 * @param {Array} [options.comparator] (optional) Override default algorithm, determining custom equality.
 * @param {Array} [options.memoize] (optional) Provide a custom memoization object which will cache the results of
    complex objects for a speed boost. By passing `false` you can disable memoization, but this will cause circular
    references to blow the stack.
 * @return {Boolean} equal match
*/
function extensiveDeepEqual(leftHandOperand, rightHandOperand, options) {
  options = options || {};
  options.memoize = options.memoize === false ? false : options.memoize || new MemoizeMap();
  var comparator = options && options.comparator;

  // Check if a memoized result exists.
  var memoizeResultLeft = memoizeCompare(leftHandOperand, rightHandOperand, options.memoize);
  if (memoizeResultLeft !== null) {
    return memoizeResultLeft;
  }
  var memoizeResultRight = memoizeCompare(rightHandOperand, leftHandOperand, options.memoize);
  if (memoizeResultRight !== null) {
    return memoizeResultRight;
  }

  // If a comparator is present, use it.
  if (comparator) {
    var comparatorResult = comparator(leftHandOperand, rightHandOperand);
    // Comparators may return null, in which case we want to go back to default behavior.
    if (comparatorResult === false || comparatorResult === true) {
      memoizeSet(leftHandOperand, rightHandOperand, options.memoize, comparatorResult);
      return comparatorResult;
    }
    // To allow comparators to override *any* behavior, we ran them first. Since it didn't decide
    // what to do, we need to make sure to return the basic tests first before we move on.
    var simpleResult = simpleEqual(leftHandOperand, rightHandOperand);
    if (simpleResult !== null) {
      // Don't memoize this, it takes longer to set/retrieve than to just compare.
      return simpleResult;
    }
  }

  var leftHandType = type(leftHandOperand);
  if (leftHandType !== type(rightHandOperand)) {
    memoizeSet(leftHandOperand, rightHandOperand, options.memoize, false);
    return false;
  }

  // Temporarily set the operands in the memoize object to prevent blowing the stack
  memoizeSet(leftHandOperand, rightHandOperand, options.memoize, true);

  var result = extensiveDeepEqualByType(leftHandOperand, rightHandOperand, leftHandType, options);
  memoizeSet(leftHandOperand, rightHandOperand, options.memoize, result);
  return result;
}

function extensiveDeepEqualByType(leftHandOperand, rightHandOperand, leftHandType, options) {
  switch (leftHandType) {
    case 'String':
    case 'Number':
    case 'Boolean':
    case 'Date':
      // If these types are their instance types (e.g. `new Number`) then re-deepEqual against their values
      return deepEqual(leftHandOperand.valueOf(), rightHandOperand.valueOf());
    case 'Promise':
    case 'Symbol':
    case 'function':
    case 'WeakMap':
    case 'WeakSet':
    case 'Error':
      return leftHandOperand === rightHandOperand;
    case 'Arguments':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'Array':
      return iterableEqual(leftHandOperand, rightHandOperand, options);
    case 'RegExp':
      return regexpEqual(leftHandOperand, rightHandOperand);
    case 'Generator':
      return generatorEqual(leftHandOperand, rightHandOperand, options);
    case 'DataView':
      return iterableEqual(new Uint8Array(leftHandOperand.buffer), new Uint8Array(rightHandOperand.buffer), options);
    case 'ArrayBuffer':
      return iterableEqual(new Uint8Array(leftHandOperand), new Uint8Array(rightHandOperand), options);
    case 'Set':
      return entriesEqual(leftHandOperand, rightHandOperand, options);
    case 'Map':
      return entriesEqual(leftHandOperand, rightHandOperand, options);
    default:
      return objectEqual(leftHandOperand, rightHandOperand, options);
  }
}

/*!
 * Compare two Regular Expressions for equality.
 *
 * @param {RegExp} leftHandOperand
 * @param {RegExp} rightHandOperand
 * @return {Boolean} result
 */

function regexpEqual(leftHandOperand, rightHandOperand) {
  return leftHandOperand.toString() === rightHandOperand.toString();
}

/*!
 * Compare two Sets/Maps for equality. Faster than other equality functions.
 *
 * @param {Set} leftHandOperand
 * @param {Set} rightHandOperand
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */

function entriesEqual(leftHandOperand, rightHandOperand, options) {
  // IE11 doesn't support Set#entries or Set#@@iterator, so we need manually populate using Set#forEach
  if (leftHandOperand.size !== rightHandOperand.size) {
    return false;
  }
  if (leftHandOperand.size === 0) {
    return true;
  }
  var leftHandItems = [];
  var rightHandItems = [];
  leftHandOperand.forEach(function gatherEntries(key, value) {
    leftHandItems.push([ key, value ]);
  });
  rightHandOperand.forEach(function gatherEntries(key, value) {
    rightHandItems.push([ key, value ]);
  });
  return iterableEqual(leftHandItems.sort(), rightHandItems.sort(), options);
}

/*!
 * Simple equality for flat iterable objects such as Arrays, TypedArrays or Node.js buffers.
 *
 * @param {Iterable} leftHandOperand
 * @param {Iterable} rightHandOperand
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */

function iterableEqual(leftHandOperand, rightHandOperand, options) {
  var length = leftHandOperand.length;
  if (length !== rightHandOperand.length) {
    return false;
  }
  if (length === 0) {
    return true;
  }
  var index = -1;
  while (++index < length) {
    if (deepEqual(leftHandOperand[index], rightHandOperand[index], options) === false) {
      return false;
    }
  }
  return true;
}

/*!
 * Simple equality for generator objects such as those returned by generator functions.
 *
 * @param {Iterable} leftHandOperand
 * @param {Iterable} rightHandOperand
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */

function generatorEqual(leftHandOperand, rightHandOperand, options) {
  return iterableEqual(getGeneratorEntries(leftHandOperand), getGeneratorEntries(rightHandOperand), options);
}

/*!
 * Determine if the given object has an @@iterator function.
 *
 * @param {Object} target
 * @return {Boolean} `true` if the object has an @@iterator function.
 */
function hasIteratorFunction(target) {
  return typeof Symbol !== 'undefined' &&
    typeof target === 'object' &&
    typeof Symbol.iterator !== 'undefined' &&
    typeof target[Symbol.iterator] === 'function';
}

/*!
 * Gets all iterator entries from the given Object. If the Object has no @@iterator function, returns an empty array.
 * This will consume the iterator - which could have side effects depending on the @@iterator implementation.
 *
 * @param {Object} target
 * @returns {Array} an array of entries from the @@iterator function
 */
function getIteratorEntries(target) {
  if (hasIteratorFunction(target)) {
    try {
      return getGeneratorEntries(target[Symbol.iterator]());
    } catch (iteratorError) {
      return [];
    }
  }
  return [];
}

/*!
 * Gets all entries from a Generator. This will consume the generator - which could have side effects.
 *
 * @param {Generator} target
 * @returns {Array} an array of entries from the Generator.
 */
function getGeneratorEntries(generator) {
  var generatorResult = generator.next();
  var accumulator = [ generatorResult.value ];
  while (generatorResult.done === false) {
    generatorResult = generator.next();
    accumulator.push(generatorResult.value);
  }
  return accumulator;
}

/*!
 * Gets all own and inherited enumerable keys from a target.
 *
 * @param {Object} target
 * @returns {Array} an array of own and inherited enumerable keys from the target.
 */
function getEnumerableKeys(target) {
  var keys = [];
  for (var key in target) {
    keys.push(key);
  }
  return keys;
}

/*!
 * Determines if two objects have matching values, given a set of keys. Defers to deepEqual for the equality check of
 * each key. If any value of the given key is not equal, the function will return false (early).
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {Array} keys An array of keys to compare the values of leftHandOperand and rightHandOperand against
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */
function keysEqual(leftHandOperand, rightHandOperand, keys, options) {
  var length = keys.length;
  if (length === 0) {
    return true;
  }
  for (var i = 0; i < length; i += 1) {
    if (deepEqual(leftHandOperand[keys[i]], rightHandOperand[keys[i]], options) === false) {
      return false;
    }
  }
  return true;
}

/*!
 * Recursively check the equality of two Objects. Once basic sameness has been established it will defer to `deepEqual`
 * for each enumerable key in the object.
 *
 * @param {Mixed} leftHandOperand
 * @param {Mixed} rightHandOperand
 * @param {Object} [options] (Optional)
 * @return {Boolean} result
 */

function objectEqual(leftHandOperand, rightHandOperand, options) {
  var leftHandKeys = getEnumerableKeys(leftHandOperand);
  var rightHandKeys = getEnumerableKeys(rightHandOperand);
  if (leftHandKeys.length && leftHandKeys.length === rightHandKeys.length) {
    leftHandKeys.sort();
    rightHandKeys.sort();
    if (iterableEqual(leftHandKeys, rightHandKeys) === false) {
      return false;
    }
    return keysEqual(leftHandOperand, rightHandOperand, leftHandKeys, options);
  }

  var leftHandEntries = getIteratorEntries(leftHandOperand);
  var rightHandEntries = getIteratorEntries(rightHandOperand);
  if (leftHandEntries.length && leftHandEntries.length === rightHandEntries.length) {
    leftHandEntries.sort();
    rightHandEntries.sort();
    return iterableEqual(leftHandEntries, rightHandEntries, options);
  }

  if (leftHandKeys.length === 0 &&
      leftHandEntries.length === 0 &&
      rightHandKeys.length === 0 &&
      rightHandEntries.length === 0) {
    return true;
  }

  return false;
}

/*!
 * Returns true if the argument is a primitive.
 *
 * This intentionally returns true for all objects that can be compared by reference,
 * including functions and symbols.
 *
 * @param {Mixed} value
 * @return {Boolean} result
 */
function isPrimitive(value) {
  return value === null || typeof value !== 'object';
}


/***/ }),

/***/ 4289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(2215);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(1044)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 8091:
/***/ (function(module) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */



function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};


/***/ }),

/***/ 4029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(5320);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 7648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 8612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(7648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 7643:
/***/ (function(module) {

"use strict";


/* !
 * Chai - getFuncName utility
 * Copyright(c) 2012-2016 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */

/**
 * ### .getFuncName(constructorFn)
 *
 * Returns the name of a function.
 * When a non-function instance is passed, returns `null`.
 * This also includes a polyfill function if `aFunc.name` is not defined.
 *
 * @name getFuncName
 * @param {Function} funct
 * @namespace Utils
 * @api public
 */

var toString = Function.prototype.toString;
var functionNameMatch = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\s\(\/]+)/;
function getFuncName(aFunc) {
  if (typeof aFunc !== 'function') {
    return null;
  }

  var name = '';
  if (typeof Function.prototype.name === 'undefined' && typeof aFunc.name === 'undefined') {
    // Here we run a polyfill if Function does not support the `name` property and if aFunc.name is not defined
    var match = toString.call(aFunc).match(functionNameMatch);
    if (match) {
      name = match[1];
    }
  } else {
    // If we've got a `name` property we just use it
    name = aFunc.name;
  }

  return name;
}

module.exports = getFuncName;


/***/ }),

/***/ 210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1405)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(8612);
var hasOwn = __webpack_require__(7642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 1044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 1405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(5419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 5419:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 6410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(5419);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 5717:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 2584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(6410)();
var callBound = __webpack_require__(1924);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 5320:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),

/***/ 8662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = __webpack_require__(6410)();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ 8611:
/***/ (function(module) {

"use strict";


/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function isNaN(value) {
	return value !== value;
};


/***/ }),

/***/ 360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(5559);
var define = __webpack_require__(4289);

var implementation = __webpack_require__(8611);
var getPolyfill = __webpack_require__(9415);
var shim = __webpack_require__(3194);

var polyfill = callBind(getPolyfill(), Number);

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 9415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(8611);

module.exports = function getPolyfill() {
	if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
		return Number.isNaN;
	}
	return implementation;
};


/***/ }),

/***/ 3194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var getPolyfill = __webpack_require__(9415);

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function shimNumberIsNaN() {
	var polyfill = getPolyfill();
	define(Number, { isNaN: polyfill }, {
		isNaN: function testIsNaN() {
			return Number.isNaN !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 5692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(4029);
var availableTypedArrays = __webpack_require__(3083);
var callBound = __webpack_require__(1924);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(6410)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var gOPD = __webpack_require__(882);
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			toStrTags[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

module.exports = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) {
		var tag = $slice($toString(value), 8, -1);
		return $indexOf(typedArrays, tag) > -1;
	}
	if (!gOPD) { return false; }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 8552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(1789),
    hashDelete = __webpack_require__(401),
    hashGet = __webpack_require__(7667),
    hashHas = __webpack_require__(1327),
    hashSet = __webpack_require__(1866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 8407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(7040),
    listCacheDelete = __webpack_require__(4125),
    listCacheGet = __webpack_require__(2117),
    listCacheHas = __webpack_require__(7529),
    listCacheSet = __webpack_require__(4705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 7071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 3369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(4785),
    mapCacheDelete = __webpack_require__(1285),
    mapCacheGet = __webpack_require__(6000),
    mapCacheHas = __webpack_require__(9916),
    mapCacheSet = __webpack_require__(5265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 8525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 8668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3369),
    setCacheAdd = __webpack_require__(619),
    setCacheHas = __webpack_require__(2385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 6384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407),
    stackClear = __webpack_require__(7465),
    stackDelete = __webpack_require__(3779),
    stackGet = __webpack_require__(7599),
    stackHas = __webpack_require__(4758),
    stackSet = __webpack_require__(4309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 2705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 7412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 4963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 4636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(2545),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(4144),
    isIndex = __webpack_require__(5776),
    isTypedArray = __webpack_require__(6719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 9932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 2488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 2663:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 2908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 8470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(7813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 9881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(7816),
    createBaseEach = __webpack_require__(9291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 1848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 8483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(5063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 7816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(8483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 7786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1811),
    toKey = __webpack_require__(327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 8866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(2488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 4239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    getRawTag = __webpack_require__(9607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(7005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6384),
    equalArrays = __webpack_require__(7114),
    equalByTag = __webpack_require__(8351),
    equalObjects = __webpack_require__(6096),
    getTag = __webpack_require__(4160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(4144),
    isTypedArray = __webpack_require__(6719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6384),
    baseIsEqual = __webpack_require__(939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 8458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(3560),
    isMasked = __webpack_require__(5346),
    isObject = __webpack_require__(3218),
    toSource = __webpack_require__(346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 8749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isLength = __webpack_require__(1780),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 7206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(1573),
    baseMatchesProperty = __webpack_require__(6432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(9601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5726),
    nativeKeys = __webpack_require__(6916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(9881),
    isArrayLike = __webpack_require__(1240);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 1573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(2634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 6432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(939),
    get = __webpack_require__(7361),
    hasIn = __webpack_require__(9095),
    isKey = __webpack_require__(5403),
    isStrictComparable = __webpack_require__(9162),
    matchesStrictComparable = __webpack_require__(2634),
    toKey = __webpack_require__(327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 9152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 107:
/***/ (function(module) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ 2545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    arrayMap = __webpack_require__(9932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(7990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 4757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 4290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 1811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(5403),
    stringToPath = __webpack_require__(5514),
    toString = __webpack_require__(9833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 4429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 9291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(1240);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 5063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 7740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(7206),
    isArrayLike = __webpack_require__(1240),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 7114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8668),
    arraySome = __webpack_require__(2908),
    cacheHas = __webpack_require__(4757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 8351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    Uint8Array = __webpack_require__(1149),
    eq = __webpack_require__(7813),
    equalArrays = __webpack_require__(7114),
    mapToArray = __webpack_require__(8776),
    setToArray = __webpack_require__(1814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 6096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(8234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 1957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 8234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(8866),
    getSymbols = __webpack_require__(9551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 5050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(7019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(9162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(8458),
    getValue = __webpack_require__(7801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 9607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 9551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(4963),
    stubArray = __webpack_require__(479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(8552),
    Map = __webpack_require__(7071),
    Promise = __webpack_require__(3818),
    Set = __webpack_require__(8525),
    WeakMap = __webpack_require__(577),
    baseGetTag = __webpack_require__(4239),
    toSource = __webpack_require__(346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 7801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1811),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(5776),
    isLength = __webpack_require__(1780),
    toKey = __webpack_require__(327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 1789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 7667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 1327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 1866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 5403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(3448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 7019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 5346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(4429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 5726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 9162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 7040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 4125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 2117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 7529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 4785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(8407),
    Map = __webpack_require__(7071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 1285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 6000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 9916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 5265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 8776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 2634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 4523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(8306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 4536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(1957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 5639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 2385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 7465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 3779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 7599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 4758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 4309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407),
    Map = __webpack_require__(7071),
    MapCache = __webpack_require__(3369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 5514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(4523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 6073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4486);


/***/ }),

/***/ 7813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 3311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(7740),
    findIndex = __webpack_require__(998);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ 998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1848),
    baseIteratee = __webpack_require__(7206),
    toInteger = __webpack_require__(554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 4486:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(7412),
    baseEach = __webpack_require__(9881),
    castFunction = __webpack_require__(4290),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 7361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 9095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 5694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(7005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 1240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(3560),
    isLength = __webpack_require__(1780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(5639),
    stubFalse = __webpack_require__(5062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(4160),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(1240),
    isBuffer = __webpack_require__(4144),
    isPrototype = __webpack_require__(5726),
    isTypedArray = __webpack_require__(6719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 3560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObject = __webpack_require__(3218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 3218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 7005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 3448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 6719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(8749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(1167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(4636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(1240);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 6486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 5161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(9932),
    baseIteratee = __webpack_require__(7206),
    baseMap = __webpack_require__(9199),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 8306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 9601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(371),
    basePropertyDeep = __webpack_require__(9152),
    isKey = __webpack_require__(5403),
    toKey = __webpack_require__(327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 4061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(2663),
    baseEach = __webpack_require__(9881),
    baseIteratee = __webpack_require__(7206),
    baseReduce = __webpack_require__(107),
    isArray = __webpack_require__(1469);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),

/***/ 479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 5062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 8601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(4841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(8601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 4841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(7561),
    isObject = __webpack_require__(3218),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 9833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 7161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(3085)["lW"];
/* provided dependency */ var process = __webpack_require__(4155);
(function (global, factory) {
   true ? factory(exports) :
  0;
}(this, (function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var ansiColors = {
    bold: ['1', '22'],
    dim: ['2', '22'],
    italic: ['3', '23'],
    underline: ['4', '24'],
    // 5 & 6 are blinking
    inverse: ['7', '27'],
    hidden: ['8', '28'],
    strike: ['9', '29'],
    // 10-20 are fonts
    // 21-29 are resets for 1-9
    black: ['30', '39'],
    red: ['31', '39'],
    green: ['32', '39'],
    yellow: ['33', '39'],
    blue: ['34', '39'],
    magenta: ['35', '39'],
    cyan: ['36', '39'],
    white: ['37', '39'],
    brightblack: ['30;1', '39'],
    brightred: ['31;1', '39'],
    brightgreen: ['32;1', '39'],
    brightyellow: ['33;1', '39'],
    brightblue: ['34;1', '39'],
    brightmagenta: ['35;1', '39'],
    brightcyan: ['36;1', '39'],
    brightwhite: ['37;1', '39'],
    grey: ['90', '39']
  };
  var styles = {
    special: 'cyan',
    number: 'yellow',
    bigint: 'yellow',
    boolean: 'yellow',
    undefined: 'grey',
    null: 'bold',
    string: 'green',
    symbol: 'green',
    date: 'magenta',
    regexp: 'red'
  };
  var truncator = '…';

  function colorise(value, styleType) {
    var color = ansiColors[styles[styleType]] || ansiColors[styleType];

    if (!color) {
      return String(value);
    }

    return "\x1B[".concat(color[0], "m").concat(String(value), "\x1B[").concat(color[1], "m");
  }

  function normaliseOptions() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$showHidden = _ref.showHidden,
        showHidden = _ref$showHidden === void 0 ? false : _ref$showHidden,
        _ref$depth = _ref.depth,
        depth = _ref$depth === void 0 ? 2 : _ref$depth,
        _ref$colors = _ref.colors,
        colors = _ref$colors === void 0 ? false : _ref$colors,
        _ref$customInspect = _ref.customInspect,
        customInspect = _ref$customInspect === void 0 ? true : _ref$customInspect,
        _ref$showProxy = _ref.showProxy,
        showProxy = _ref$showProxy === void 0 ? false : _ref$showProxy,
        _ref$maxArrayLength = _ref.maxArrayLength,
        maxArrayLength = _ref$maxArrayLength === void 0 ? Infinity : _ref$maxArrayLength,
        _ref$breakLength = _ref.breakLength,
        breakLength = _ref$breakLength === void 0 ? Infinity : _ref$breakLength,
        _ref$seen = _ref.seen,
        seen = _ref$seen === void 0 ? [] : _ref$seen,
        _ref$truncate = _ref.truncate,
        truncate = _ref$truncate === void 0 ? Infinity : _ref$truncate,
        _ref$stylize = _ref.stylize,
        stylize = _ref$stylize === void 0 ? String : _ref$stylize;

    var options = {
      showHidden: Boolean(showHidden),
      depth: Number(depth),
      colors: Boolean(colors),
      customInspect: Boolean(customInspect),
      showProxy: Boolean(showProxy),
      maxArrayLength: Number(maxArrayLength),
      breakLength: Number(breakLength),
      truncate: Number(truncate),
      seen: seen,
      stylize: stylize
    };

    if (options.colors) {
      options.stylize = colorise;
    }

    return options;
  }
  function truncate(string, length) {
    var tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : truncator;
    string = String(string);
    var tailLength = tail.length;
    var stringLength = string.length;

    if (tailLength > length && stringLength > tailLength) {
      return tail;
    }

    if (stringLength > length && stringLength > tailLength) {
      return "".concat(string.slice(0, length - tailLength)).concat(tail);
    }

    return string;
  } // eslint-disable-next-line complexity

  function inspectList(list, options, inspectItem) {
    var separator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ', ';
    inspectItem = inspectItem || options.inspect;
    var size = list.length;
    if (size === 0) return '';
    var originalLength = options.truncate;
    var output = '';
    var peek = '';
    var truncated = '';

    for (var i = 0; i < size; i += 1) {
      var last = i + 1 === list.length;
      var secondToLast = i + 2 === list.length;
      truncated = "".concat(truncator, "(").concat(list.length - i, ")");
      var value = list[i]; // If there is more than one remaining we need to account for a separator of `, `

      options.truncate = originalLength - output.length - (last ? 0 : separator.length);
      var string = peek || inspectItem(value, options) + (last ? '' : separator);
      var nextLength = output.length + string.length;
      var truncatedLength = nextLength + truncated.length; // If this is the last element, and adding it would
      // take us over length, but adding the truncator wouldn't - then break now

      if (last && nextLength > originalLength && output.length + truncated.length <= originalLength) {
        break;
      } // If this isn't the last or second to last element to scan,
      // but the string is already over length then break here


      if (!last && !secondToLast && truncatedLength > originalLength) {
        break;
      } // Peek at the next string to determine if we should
      // break early before adding this item to the output


      peek = last ? '' : inspectItem(list[i + 1], options) + (secondToLast ? '' : separator); // If we have one element left, but this element and
      // the next takes over length, the break early

      if (!last && secondToLast && truncatedLength > originalLength && nextLength + peek.length > originalLength) {
        break;
      }

      output += string; // If the next element takes us to length -
      // but there are more after that, then we should truncate now

      if (!last && !secondToLast && nextLength + peek.length >= originalLength) {
        truncated = "".concat(truncator, "(").concat(list.length - i - 1, ")");
        break;
      }

      truncated = '';
    }

    return "".concat(output).concat(truncated);
  }

  function quoteComplexKey(key) {
    if (key.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/)) {
      return key;
    }

    return JSON.stringify(key).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
  }

  function inspectProperty(_ref2, options) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    options.truncate -= 2;

    if (typeof key === 'string') {
      key = quoteComplexKey(key);
    } else if (typeof key !== 'number') {
      key = "[".concat(options.inspect(key, options), "]");
    }

    options.truncate -= key.length;
    value = options.inspect(value, options);
    return "".concat(key, ": ").concat(value);
  }

  function inspectArray(array, options) {
    // Object.keys will always output the Array indices first, so we can slice by
    // `array.length` to get non-index properties
    var nonIndexProperties = Object.keys(array).slice(array.length);
    if (!array.length && !nonIndexProperties.length) return '[]';
    options.truncate -= 4;
    var listContents = inspectList(array, options);
    options.truncate -= listContents.length;
    var propertyContents = '';

    if (nonIndexProperties.length) {
      propertyContents = inspectList(nonIndexProperties.map(function (key) {
        return [key, array[key]];
      }), options, inspectProperty);
    }

    return "[ ".concat(listContents).concat(propertyContents ? ", ".concat(propertyContents) : '', " ]");
  }

  /* !
   * Chai - getFuncName utility
   * Copyright(c) 2012-2016 Jake Luer <jake@alogicalparadox.com>
   * MIT Licensed
   */

  /**
   * ### .getFuncName(constructorFn)
   *
   * Returns the name of a function.
   * When a non-function instance is passed, returns `null`.
   * This also includes a polyfill function if `aFunc.name` is not defined.
   *
   * @name getFuncName
   * @param {Function} funct
   * @namespace Utils
   * @api public
   */

  var toString = Function.prototype.toString;
  var functionNameMatch = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\s\(\/]+)/;
  function getFuncName(aFunc) {
    if (typeof aFunc !== 'function') {
      return null;
    }

    var name = '';
    if (typeof Function.prototype.name === 'undefined' && typeof aFunc.name === 'undefined') {
      // Here we run a polyfill if Function does not support the `name` property and if aFunc.name is not defined
      var match = toString.call(aFunc).match(functionNameMatch);
      if (match) {
        name = match[1];
      }
    } else {
      // If we've got a `name` property we just use it
      name = aFunc.name;
    }

    return name;
  }

  var getFuncName_1 = getFuncName;

  var getArrayName = function getArrayName(array) {
    // We need to special case Node.js' Buffers, which report to be Uint8Array
    if (typeof Buffer === 'function' && array instanceof Buffer) {
      return 'Buffer';
    }

    if (array[Symbol.toStringTag]) {
      return array[Symbol.toStringTag];
    }

    return getFuncName_1(array.constructor);
  };

  function inspectTypedArray(array, options) {
    var name = getArrayName(array);
    options.truncate -= name.length + 4; // Object.keys will always output the Array indices first, so we can slice by
    // `array.length` to get non-index properties

    var nonIndexProperties = Object.keys(array).slice(array.length);
    if (!array.length && !nonIndexProperties.length) return "".concat(name, "[]"); // As we know TypedArrays only contain Unsigned Integers, we can skip inspecting each one and simply
    // stylise the toString() value of them

    var output = '';

    for (var i = 0; i < array.length; i++) {
      var string = "".concat(options.stylize(truncate(array[i], options.truncate), 'number')).concat(i === array.length - 1 ? '' : ', ');
      options.truncate -= string.length;

      if (array[i] !== array.length && options.truncate <= 3) {
        output += "".concat(truncator, "(").concat(array.length - array[i] + 1, ")");
        break;
      }

      output += string;
    }

    var propertyContents = '';

    if (nonIndexProperties.length) {
      propertyContents = inspectList(nonIndexProperties.map(function (key) {
        return [key, array[key]];
      }), options, inspectProperty);
    }

    return "".concat(name, "[ ").concat(output).concat(propertyContents ? ", ".concat(propertyContents) : '', " ]");
  }

  function inspectDate(dateObject, options) {
    // If we need to - truncate the time portion, but never the date
    var split = dateObject.toJSON().split('T');
    var date = split[0];
    return options.stylize("".concat(date, "T").concat(truncate(split[1], options.truncate - date.length - 1)), 'date');
  }

  function inspectFunction(func, options) {
    var name = getFuncName_1(func);

    if (!name) {
      return options.stylize('[Function]', 'special');
    }

    return options.stylize("[Function ".concat(truncate(name, options.truncate - 11), "]"), 'special');
  }

  function inspectMapEntry(_ref, options) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    options.truncate -= 4;
    key = options.inspect(key, options);
    options.truncate -= key.length;
    value = options.inspect(value, options);
    return "".concat(key, " => ").concat(value);
  } // IE11 doesn't support `map.entries()`


  function mapToEntries(map) {
    var entries = [];
    map.forEach(function (value, key) {
      entries.push([key, value]);
    });
    return entries;
  }

  function inspectMap(map, options) {
    var size = map.size - 1;

    if (size <= 0) {
      return 'Map{}';
    }

    options.truncate -= 7;
    return "Map{ ".concat(inspectList(mapToEntries(map), options, inspectMapEntry), " }");
  }

  var isNaN = Number.isNaN || function (i) {
    return i !== i;
  }; // eslint-disable-line no-self-compare


  function inspectNumber(number, options) {
    if (isNaN(number)) {
      return options.stylize('NaN', 'number');
    }

    if (number === Infinity) {
      return options.stylize('Infinity', 'number');
    }

    if (number === -Infinity) {
      return options.stylize('-Infinity', 'number');
    }

    if (number === 0) {
      return options.stylize(1 / number === Infinity ? '+0' : '-0', 'number');
    }

    return options.stylize(truncate(number, options.truncate), 'number');
  }

  function inspectBigInt(number, options) {
    var nums = truncate(number.toString(), options.truncate - 1);
    if (nums !== truncator) nums += 'n';
    return options.stylize(nums, 'bigint');
  }

  function inspectRegExp(value, options) {
    var flags = value.toString().split('/')[2];
    var sourceLength = options.truncate - (2 + flags.length);
    var source = value.source;
    return options.stylize("/".concat(truncate(source, sourceLength), "/").concat(flags), 'regexp');
  }

  function arrayFromSet(set) {
    var values = [];
    set.forEach(function (value) {
      values.push(value);
    });
    return values;
  }

  function inspectSet(set, options) {
    if (set.size === 0) return 'Set{}';
    options.truncate -= 7;
    return "Set{ ".concat(inspectList(arrayFromSet(set), options), " }");
  }

  var stringEscapeChars = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5" + "\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]", 'g');
  var escapeCharacters = {
    '\b': '\\b',
    '\t': '\\t',
    '\n': '\\n',
    '\f': '\\f',
    '\r': '\\r',
    "'": "\\'",
    '\\': '\\\\'
  };
  var hex = 16;
  var unicodeLength = 4;

  function escape(char) {
    return escapeCharacters[char] || "\\u".concat("0000".concat(char.charCodeAt(0).toString(hex)).slice(-unicodeLength));
  }

  function inspectString(string, options) {
    if (stringEscapeChars.test(string)) {
      string = string.replace(stringEscapeChars, escape);
    }

    return options.stylize("'".concat(truncate(string, options.truncate - 2), "'"), 'string');
  }

  function inspectSymbol(value) {
    if ('description' in Symbol.prototype) {
      return value.description ? "Symbol(".concat(value.description, ")") : 'Symbol()';
    }

    return value.toString();
  }

  var getPromiseValue = function getPromiseValue() {
    return 'Promise{…}';
  };

  try {
    var _process$binding = process.binding('util'),
        getPromiseDetails = _process$binding.getPromiseDetails,
        kPending = _process$binding.kPending,
        kRejected = _process$binding.kRejected;

    if (Array.isArray(getPromiseDetails(Promise.resolve()))) {
      getPromiseValue = function getPromiseValue(value, options) {
        var _getPromiseDetails = getPromiseDetails(value),
            _getPromiseDetails2 = _slicedToArray(_getPromiseDetails, 2),
            state = _getPromiseDetails2[0],
            innerValue = _getPromiseDetails2[1];

        if (state === kPending) {
          return 'Promise{<pending>}';
        }

        return "Promise".concat(state === kRejected ? '!' : '', "{").concat(options.inspect(innerValue, options), "}");
      };
    }
  } catch (notNode) {
    /* ignore */
  }

  var inspectPromise = getPromiseValue;

  function inspectObject(object, options) {
    var properties = Object.getOwnPropertyNames(object);
    var symbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : [];

    if (properties.length === 0 && symbols.length === 0) {
      return '{}';
    }

    options.truncate -= 4;
    options.seen = options.seen || [];

    if (options.seen.indexOf(object) >= 0) {
      return '[Circular]';
    }

    options.seen.push(object);
    var propertyContents = inspectList(properties.map(function (key) {
      return [key, object[key]];
    }), options, inspectProperty);
    var symbolContents = inspectList(symbols.map(function (key) {
      return [key, object[key]];
    }), options, inspectProperty);
    options.seen.pop();
    var sep = '';

    if (propertyContents && symbolContents) {
      sep = ', ';
    }

    return "{ ".concat(propertyContents).concat(sep).concat(symbolContents, " }");
  }

  var toStringTag = typeof Symbol !== 'undefined' && Symbol.toStringTag ? Symbol.toStringTag : false;
  function inspectClass(value, options) {
    var name = '';

    if (toStringTag && toStringTag in value) {
      name = value[toStringTag];
    }

    name = name || getFuncName_1(value.constructor); // Babel transforms anonymous classes to the name `_class`

    if (!name || name === '_class') {
      name = '<Anonymous Class>';
    }

    options.truncate -= name.length;
    return "".concat(name).concat(inspectObject(value, options));
  }

  function inspectArguments(args, options) {
    if (args.length === 0) return 'Arguments[]';
    options.truncate -= 13;
    return "Arguments[ ".concat(inspectList(args, options), " ]");
  }

  var errorKeys = ['stack', 'line', 'column', 'name', 'message', 'fileName', 'lineNumber', 'columnNumber', 'number', 'description'];
  function inspectObject$1(error, options) {
    var properties = Object.getOwnPropertyNames(error).filter(function (key) {
      return errorKeys.indexOf(key) === -1;
    });
    var name = error.name;
    options.truncate -= name.length;
    var message = '';

    if (typeof error.message === 'string') {
      message = truncate(error.message, options.truncate);
    } else {
      properties.unshift('message');
    }

    message = message ? ": ".concat(message) : '';
    options.truncate -= message.length + 5;
    var propertyContents = inspectList(properties.map(function (key) {
      return [key, error[key]];
    }), options, inspectProperty);
    return "".concat(name).concat(message).concat(propertyContents ? " { ".concat(propertyContents, " }") : '');
  }

  function inspectAttribute(_ref, options) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    options.truncate -= 3;

    if (!value) {
      return "".concat(options.stylize(key, 'yellow'));
    }

    return "".concat(options.stylize(key, 'yellow'), "=").concat(options.stylize("\"".concat(value, "\""), 'string'));
  }
  function inspectHTMLCollection(collection, options) {
    // eslint-disable-next-line no-use-before-define
    return inspectList(collection, options, inspectHTML, '\n');
  }
  function inspectHTML(element, options) {
    var properties = element.getAttributeNames();
    var name = element.tagName.toLowerCase();
    var head = options.stylize("<".concat(name), 'special');
    var headClose = options.stylize(">", 'special');
    var tail = options.stylize("</".concat(name, ">"), 'special');
    options.truncate -= name.length * 2 + 5;
    var propertyContents = '';

    if (properties.length > 0) {
      propertyContents += ' ';
      propertyContents += inspectList(properties.map(function (key) {
        return [key, element.getAttribute(key)];
      }), options, inspectAttribute, ' ');
    }

    options.truncate -= propertyContents.length;
    var truncate = options.truncate;
    var children = inspectHTMLCollection(element.children, options);

    if (children && children.length > truncate) {
      children = "".concat(truncator, "(").concat(element.children.length, ")");
    }

    return "".concat(head).concat(propertyContents).concat(headClose).concat(children).concat(tail);
  }

  var symbolsSupported = typeof Symbol === 'function' && typeof Symbol.for === 'function';
  var chaiInspect = symbolsSupported ? Symbol.for('chai/inspect') : '@@chai/inspect';
  var nodeInspect = false;

  try {
    // eslint-disable-next-line global-require
    var nodeUtil = __webpack_require__(6952);

    nodeInspect = nodeUtil.inspect ? nodeUtil.inspect.custom : false;
  } catch (noNodeInspect) {
    nodeInspect = false;
  }

  var constructorMap = new WeakMap();
  var stringTagMap = {};
  var baseTypesMap = {
    undefined: function undefined$1(value, options) {
      return options.stylize('undefined', 'undefined');
    },
    null: function _null(value, options) {
      return options.stylize(null, 'null');
    },
    boolean: function boolean(value, options) {
      return options.stylize(value, 'boolean');
    },
    Boolean: function Boolean(value, options) {
      return options.stylize(value, 'boolean');
    },
    number: inspectNumber,
    Number: inspectNumber,
    bigint: inspectBigInt,
    BigInt: inspectBigInt,
    string: inspectString,
    String: inspectString,
    function: inspectFunction,
    Function: inspectFunction,
    symbol: inspectSymbol,
    // A Symbol polyfill will return `Symbol` not `symbol` from typedetect
    Symbol: inspectSymbol,
    Array: inspectArray,
    Date: inspectDate,
    Map: inspectMap,
    Set: inspectSet,
    RegExp: inspectRegExp,
    Promise: inspectPromise,
    // WeakSet, WeakMap are totally opaque to us
    WeakSet: function WeakSet(value, options) {
      return options.stylize('WeakSet{…}', 'special');
    },
    WeakMap: function WeakMap(value, options) {
      return options.stylize('WeakMap{…}', 'special');
    },
    Arguments: inspectArguments,
    Int8Array: inspectTypedArray,
    Uint8Array: inspectTypedArray,
    Uint8ClampedArray: inspectTypedArray,
    Int16Array: inspectTypedArray,
    Uint16Array: inspectTypedArray,
    Int32Array: inspectTypedArray,
    Uint32Array: inspectTypedArray,
    Float32Array: inspectTypedArray,
    Float64Array: inspectTypedArray,
    Generator: function Generator() {
      return '';
    },
    DataView: function DataView() {
      return '';
    },
    ArrayBuffer: function ArrayBuffer() {
      return '';
    },
    Error: inspectObject$1,
    HTMLCollection: inspectHTMLCollection,
    NodeList: inspectHTMLCollection
  }; // eslint-disable-next-line complexity

  var inspectCustom = function inspectCustom(value, options, type) {
    if (chaiInspect in value && typeof value[chaiInspect] === 'function') {
      return value[chaiInspect](options);
    }

    if (nodeInspect && nodeInspect in value && typeof value[nodeInspect] === 'function') {
      return value[nodeInspect](options.depth, options);
    }

    if ('inspect' in value && typeof value.inspect === 'function') {
      return value.inspect(options.depth, options);
    }

    if ('constructor' in value && constructorMap.has(value.constructor)) {
      return constructorMap.get(value.constructor)(value, options);
    }

    if (stringTagMap[type]) {
      return stringTagMap[type](value, options);
    }

    return '';
  };

  var toString$1 = Object.prototype.toString; // eslint-disable-next-line complexity

  function inspect(value, options) {
    options = normaliseOptions(options);
    options.inspect = inspect;
    var _options = options,
        customInspect = _options.customInspect;
    var type = value === null ? 'null' : _typeof(value);

    if (type === 'object') {
      type = toString$1.call(value).slice(8, -1);
    } // If it is a base value that we already support, then use Loupe's inspector


    if (baseTypesMap[type]) {
      return baseTypesMap[type](value, options);
    } // If `options.customInspect` is set to true then try to use the custom inspector


    if (customInspect && value) {
      var output = inspectCustom(value, options, type);

      if (output) {
        if (typeof output === 'string') return output;
        return inspect(output, options);
      }
    }

    var proto = value ? Object.getPrototypeOf(value) : false; // If it's a plain Object then use Loupe's inspector

    if (proto === Object.prototype || proto === null) {
      return inspectObject(value, options);
    } // Specifically account for HTMLElements
    // eslint-disable-next-line no-undef


    if (value && typeof HTMLElement === 'function' && value instanceof HTMLElement) {
      return inspectHTML(value, options);
    }

    if ('constructor' in value) {
      // If it is a class, inspect it like an object but add the constructor name
      if (value.constructor !== Object) {
        return inspectClass(value, options);
      } // If it is an object with an anonymous prototype, display it as an object.


      return inspectObject(value, options);
    } // last chance to check if it's an object


    if (value === Object(value)) {
      return inspectObject(value, options);
    } // We have run out of options! Just stringify the value


    return options.stylize(String(value), type);
  }
  function registerConstructor(constructor, inspector) {
    if (constructorMap.has(constructor)) {
      return false;
    }

    constructorMap.add(constructor, inspector);
    return true;
  }
  function registerStringTag(stringTag, inspector) {
    if (stringTag in stringTagMap) {
      return false;
    }

    stringTagMap[stringTag] = inspector;
    return true;
  }
  var custom = chaiInspect;

  exports.custom = custom;
  exports.default = inspect;
  exports.inspect = inspect;
  exports.registerConstructor = registerConstructor;
  exports.registerStringTag = registerStringTag;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 3085:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/* provided dependency */ var console = __webpack_require__(5108);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(9742)
const ieee754 = __webpack_require__(645)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 4244:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var callBind = __webpack_require__(5559);

var implementation = __webpack_require__(4244);
var getPolyfill = __webpack_require__(5624);
var shim = __webpack_require__(2281);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 5624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(4244);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 2281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(5624);
var define = __webpack_require__(4289);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 8987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(1414); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 2215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(1414);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(8987);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 1414:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 5539:
/***/ (function(module) {

"use strict";


/* !
 * Chai - pathval utility
 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
 * @see https://github.com/logicalparadox/filtr
 * MIT Licensed
 */

/**
 * ### .hasProperty(object, name)
 *
 * This allows checking whether an object has own
 * or inherited from prototype chain named property.
 *
 * Basically does the same thing as the `in`
 * operator but works properly with null/undefined values
 * and other primitives.
 *
 *     var obj = {
 *         arr: ['a', 'b', 'c']
 *       , str: 'Hello'
 *     }
 *
 * The following would be the results.
 *
 *     hasProperty(obj, 'str');  // true
 *     hasProperty(obj, 'constructor');  // true
 *     hasProperty(obj, 'bar');  // false
 *
 *     hasProperty(obj.str, 'length'); // true
 *     hasProperty(obj.str, 1);  // true
 *     hasProperty(obj.str, 5);  // false
 *
 *     hasProperty(obj.arr, 'length');  // true
 *     hasProperty(obj.arr, 2);  // true
 *     hasProperty(obj.arr, 3);  // false
 *
 * @param {Object} object
 * @param {String|Symbol} name
 * @returns {Boolean} whether it exists
 * @namespace Utils
 * @name hasProperty
 * @api public
 */

function hasProperty(obj, name) {
  if (typeof obj === 'undefined' || obj === null) {
    return false;
  }

  // The `in` operator does not work with primitives.
  return name in Object(obj);
}

/* !
 * ## parsePath(path)
 *
 * Helper function used to parse string object
 * paths. Use in conjunction with `internalGetPathValue`.
 *
 *      var parsed = parsePath('myobject.property.subprop');
 *
 * ### Paths:
 *
 * * Can be infinitely deep and nested.
 * * Arrays are also valid using the formal `myobject.document[3].property`.
 * * Literal dots and brackets (not delimiter) must be backslash-escaped.
 *
 * @param {String} path
 * @returns {Object} parsed
 * @api private
 */

function parsePath(path) {
  var str = path.replace(/([^\\])\[/g, '$1.[');
  var parts = str.match(/(\\\.|[^.]+?)+/g);
  return parts.map(function mapMatches(value) {
    if (
      value === 'constructor' ||
      value === '__proto__' ||
      value === 'prototype'
    ) {
      return {};
    }
    var regexp = /^\[(\d+)\]$/;
    var mArr = regexp.exec(value);
    var parsed = null;
    if (mArr) {
      parsed = { i: parseFloat(mArr[1]) };
    } else {
      parsed = { p: value.replace(/\\([.[\]])/g, '$1') };
    }

    return parsed;
  });
}

/* !
 * ## internalGetPathValue(obj, parsed[, pathDepth])
 *
 * Helper companion function for `.parsePath` that returns
 * the value located at the parsed address.
 *
 *      var value = getPathValue(obj, parsed);
 *
 * @param {Object} object to search against
 * @param {Object} parsed definition from `parsePath`.
 * @param {Number} depth (nesting level) of the property we want to retrieve
 * @returns {Object|Undefined} value
 * @api private
 */

function internalGetPathValue(obj, parsed, pathDepth) {
  var temporaryValue = obj;
  var res = null;
  pathDepth = typeof pathDepth === 'undefined' ? parsed.length : pathDepth;

  for (var i = 0; i < pathDepth; i++) {
    var part = parsed[i];
    if (temporaryValue) {
      if (typeof part.p === 'undefined') {
        temporaryValue = temporaryValue[part.i];
      } else {
        temporaryValue = temporaryValue[part.p];
      }

      if (i === pathDepth - 1) {
        res = temporaryValue;
      }
    }
  }

  return res;
}

/* !
 * ## internalSetPathValue(obj, value, parsed)
 *
 * Companion function for `parsePath` that sets
 * the value located at a parsed address.
 *
 *  internalSetPathValue(obj, 'value', parsed);
 *
 * @param {Object} object to search and define on
 * @param {*} value to use upon set
 * @param {Object} parsed definition from `parsePath`
 * @api private
 */

function internalSetPathValue(obj, val, parsed) {
  var tempObj = obj;
  var pathDepth = parsed.length;
  var part = null;
  // Here we iterate through every part of the path
  for (var i = 0; i < pathDepth; i++) {
    var propName = null;
    var propVal = null;
    part = parsed[i];

    // If it's the last part of the path, we set the 'propName' value with the property name
    if (i === pathDepth - 1) {
      propName = typeof part.p === 'undefined' ? part.i : part.p;
      // Now we set the property with the name held by 'propName' on object with the desired val
      tempObj[propName] = val;
    } else if (typeof part.p !== 'undefined' && tempObj[part.p]) {
      tempObj = tempObj[part.p];
    } else if (typeof part.i !== 'undefined' && tempObj[part.i]) {
      tempObj = tempObj[part.i];
    } else {
      // If the obj doesn't have the property we create one with that name to define it
      var next = parsed[i + 1];
      // Here we set the name of the property which will be defined
      propName = typeof part.p === 'undefined' ? part.i : part.p;
      // Here we decide if this property will be an array or a new object
      propVal = typeof next.p === 'undefined' ? [] : {};
      tempObj[propName] = propVal;
      tempObj = tempObj[propName];
    }
  }
}

/**
 * ### .getPathInfo(object, path)
 *
 * This allows the retrieval of property info in an
 * object given a string path.
 *
 * The path info consists of an object with the
 * following properties:
 *
 * * parent - The parent object of the property referenced by `path`
 * * name - The name of the final property, a number if it was an array indexer
 * * value - The value of the property, if it exists, otherwise `undefined`
 * * exists - Whether the property exists or not
 *
 * @param {Object} object
 * @param {String} path
 * @returns {Object} info
 * @namespace Utils
 * @name getPathInfo
 * @api public
 */

function getPathInfo(obj, path) {
  var parsed = parsePath(path);
  var last = parsed[parsed.length - 1];
  var info = {
    parent:
      parsed.length > 1 ?
        internalGetPathValue(obj, parsed, parsed.length - 1) :
        obj,
    name: last.p || last.i,
    value: internalGetPathValue(obj, parsed),
  };
  info.exists = hasProperty(info.parent, info.name);

  return info;
}

/**
 * ### .getPathValue(object, path)
 *
 * This allows the retrieval of values in an
 * object given a string path.
 *
 *     var obj = {
 *         prop1: {
 *             arr: ['a', 'b', 'c']
 *           , str: 'Hello'
 *         }
 *       , prop2: {
 *             arr: [ { nested: 'Universe' } ]
 *           , str: 'Hello again!'
 *         }
 *     }
 *
 * The following would be the results.
 *
 *     getPathValue(obj, 'prop1.str'); // Hello
 *     getPathValue(obj, 'prop1.att[2]'); // b
 *     getPathValue(obj, 'prop2.arr[0].nested'); // Universe
 *
 * @param {Object} object
 * @param {String} path
 * @returns {Object} value or `undefined`
 * @namespace Utils
 * @name getPathValue
 * @api public
 */

function getPathValue(obj, path) {
  var info = getPathInfo(obj, path);
  return info.value;
}

/**
 * ### .setPathValue(object, path, value)
 *
 * Define the value in an object at a given string path.
 *
 * ```js
 * var obj = {
 *     prop1: {
 *         arr: ['a', 'b', 'c']
 *       , str: 'Hello'
 *     }
 *   , prop2: {
 *         arr: [ { nested: 'Universe' } ]
 *       , str: 'Hello again!'
 *     }
 * };
 * ```
 *
 * The following would be acceptable.
 *
 * ```js
 * var properties = require('tea-properties');
 * properties.set(obj, 'prop1.str', 'Hello Universe!');
 * properties.set(obj, 'prop1.arr[2]', 'B');
 * properties.set(obj, 'prop2.arr[0].nested.value', { hello: 'universe' });
 * ```
 *
 * @param {Object} object
 * @param {String} path
 * @param {Mixed} value
 * @api private
 */

function setPathValue(obj, path, val) {
  var parsed = parsePath(path);
  internalSetPathValue(obj, val, parsed);
  return obj;
}

module.exports = {
  hasProperty: hasProperty,
  getPathInfo: getPathInfo,
  getPathValue: getPathValue,
  setPathValue: setPathValue,
};


/***/ }),

/***/ 8262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nv": function() { return /* binding */ mapActions; },
  "rn": function() { return /* binding */ mapState; },
  "Jk": function() { return /* binding */ storeToRefs; }
});

// UNUSED EXPORTS: MutationType, PiniaVuePlugin, acceptHMRUpdate, createPinia, defineStore, getActivePinia, mapGetters, mapStores, mapWritableState, setActivePinia, setMapStoreSuffix, skipHydrate

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-demi/lib/index.mjs


var lib_isVue2 = false
var isVue3 = true
var Vue2 = (/* unused pure expression or super */ null && (undefined))

function install() {}

function lib_set(target, key, val) {
  if (Array.isArray(target)) {
    target.length = Math.max(target.length, key)
    target.splice(key, 1, val)
    return val
  }
  target[key] = val
  return val
}

function lib_del(target, key) {
  if (Array.isArray(target)) {
    target.splice(key, 1)
    return
  }
  delete target[key]
}




;// CONCATENATED MODULE: ./node_modules/pinia/dist/pinia.esm-browser.js
/* provided dependency */ var console = __webpack_require__(5108);
/*!
  * pinia v2.0.20
  * (c) 2022 Eduardo San Martin Morote
  * @license MIT
  */



/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */
let activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */
const setActivePinia = (pinia) => (activePinia = pinia);
/**
 * Get the currently active pinia if there is any.
 */
const getActivePinia = () => (getCurrentInstance() && inject(piniaSymbol)) || activePinia;
const piniaSymbol = (Symbol('pinia') );

function isPlainObject(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return (o &&
        typeof o === 'object' &&
        Object.prototype.toString.call(o) === '[object Object]' &&
        typeof o.toJSON !== 'function');
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */
var MutationType;
(function (MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */
    MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */
    MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */
    MutationType["patchFunction"] = "patch function";
    // maybe reset? for $state = {} and $reset
})(MutationType || (MutationType = {}));

const IS_CLIENT = typeof window !== 'undefined';
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */
const USE_DEVTOOLS = (/* unused pure expression or super */ null && (IS_CLIENT));

/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */
// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const _global = /*#__PURE__*/ (() => typeof window === 'object' && window.window === window
    ? window
    : typeof self === 'object' && self.self === self
        ? self
        : typeof __webpack_require__.g === 'object' && __webpack_require__.g.global === __webpack_require__.g
            ? __webpack_require__.g
            : typeof globalThis === 'object'
                ? globalThis
                : { HTMLElement: null })();
function bom(blob, { autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom &&
        /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
        return new Blob([String.fromCharCode(0xfeff), blob], { type: blob.type });
    }
    return blob;
}
function download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function () {
        saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function () {
        console.error('could not download file');
    };
    xhr.send();
}
function corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    }
    catch (e) { }
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    }
    catch (e) {
        const evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const _navigator = 
 typeof navigator === 'object' ? navigator : { userAgent: '' };
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const isMacOSWebView = /*#__PURE__*/ (() => /Macintosh/.test(_navigator.userAgent) &&
    /AppleWebKit/.test(_navigator.userAgent) &&
    !/Safari/.test(_navigator.userAgent))();
const saveAs = !IS_CLIENT
    ? () => { } // noop
    : // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
        typeof HTMLAnchorElement !== 'undefined' &&
            'download' in HTMLAnchorElement.prototype &&
            !isMacOSWebView
            ? downloadSaveAs
            : // Use msSaveOrOpenBlob as a second approach
                'msSaveOrOpenBlob' in _navigator
                    ? msSaveAs
                    : // Fallback to using FileReader and a popup
                        fileSaverSaveAs;
function downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if (corsEnabled(a.href)) {
                download(blob, name, opts);
            }
            else {
                a.target = '_blank';
                click(a);
            }
        }
        else {
            click(a);
        }
    }
    else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function () {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function () {
            click(a);
        }, 0);
    }
}
function msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if (corsEnabled(blob)) {
            download(blob, name, opts);
        }
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function () {
                click(a);
            });
        }
    }
    else {
        // @ts-ignore: works on windows
        navigator.msSaveOrOpenBlob(bom(blob, opts), name);
    }
}
function fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) {
        popup.document.title = popup.document.body.innerText = 'downloading...';
    }
    if (typeof blob === 'string')
        return download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String(_global.HTMLElement)) || 'safari' in _global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || (force && isSafari) || isMacOSWebView) &&
        typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function () {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS
                ? url
                : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) {
                popup.location.href = url;
            }
            else {
                location.assign(url);
            }
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    }
    else {
        const url = URL.createObjectURL(blob);
        if (popup)
            popup.location.assign(url);
        else
            location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function () {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}

/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */
function toastMessage(message, type) {
    const piniaMessage = '🍍 ' + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') {
        __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    }
    else if (type === 'error') {
        console.error(piniaMessage);
    }
    else if (type === 'warn') {
        console.warn(piniaMessage);
    }
    else {
        console.log(piniaMessage);
    }
}
function isPinia(o) {
    return '_a' in o && 'install' in o;
}

function checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function checkNotFocusedError(error) {
    if (error instanceof Error &&
        error.message.toLowerCase().includes('document is not focused')) {
        toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function actionGlobalCopyState(pinia) {
    if (checkClipboardAccess())
        return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        toastMessage('Global state copied to clipboard.');
    }
    catch (error) {
        if (checkNotFocusedError(error))
            return;
        toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function actionGlobalPasteState(pinia) {
    if (checkClipboardAccess())
        return;
    try {
        pinia.state.value = JSON.parse(await navigator.clipboard.readText());
        toastMessage('Global state pasted from clipboard.');
    }
    catch (error) {
        if (checkNotFocusedError(error))
            return;
        toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function actionGlobalSaveState(pinia) {
    try {
        saveAs(new Blob([JSON.stringify(pinia.state.value)], {
            type: 'text/plain;charset=utf-8',
        }), 'pinia-state.json');
    }
    catch (error) {
        toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let fileInput;
function getFileOpener() {
    if (!fileInput) {
        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject) => {
            fileInput.onchange = async () => {
                const files = fileInput.files;
                if (!files)
                    return resolve(null);
                const file = files.item(0);
                if (!file)
                    return resolve(null);
                return resolve({ text: await file.text(), file });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            fileInput.oncancel = () => resolve(null);
            fileInput.onerror = reject;
            fileInput.click();
        });
    }
    return openFile;
}
async function actionGlobalOpenStateFile(pinia) {
    try {
        const open = await getFileOpener();
        const result = await open();
        if (!result)
            return;
        const { text, file } = result;
        pinia.state.value = JSON.parse(text);
        toastMessage(`Global state imported from "${file.name}".`);
    }
    catch (error) {
        toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}

function formatDisplay(display) {
    return {
        _custom: {
            display,
        },
    };
}
const PINIA_ROOT_LABEL = '🍍 Pinia (root)';
const PINIA_ROOT_ID = '_root';
function formatStoreForInspectorTree(store) {
    return isPinia(store)
        ? {
            id: PINIA_ROOT_ID,
            label: PINIA_ROOT_LABEL,
        }
        : {
            id: store.$id,
            label: store.$id,
        };
}
function formatStoreForInspectorState(store) {
    if (isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId) => ({
                editable: true,
                key: storeId,
                value: store.state.value[storeId],
            })),
            getters: storeNames
                .filter((id) => storeMap.get(id)._getters)
                .map((id) => {
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key) => {
                        getters[key] = store[key];
                        return getters;
                    }, {}),
                };
            }),
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key) => ({
            editable: true,
            key,
            value: store.$state[key],
        })),
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) {
        state.getters = store._getters.map((getterName) => ({
            editable: false,
            key: getterName,
            value: store[getterName],
        }));
    }
    if (store._customProperties.size) {
        state.customProperties = Array.from(store._customProperties).map((key) => ({
            editable: true,
            key,
            value: store[key],
        }));
    }
    return state;
}
function formatEventData(events) {
    if (!events)
        return {};
    if (Array.isArray(events)) {
        // TODO: handle add and delete for arrays and objects
        return events.reduce((data, event) => {
            data.keys.push(event.key);
            data.operations.push(event.type);
            data.oldValue[event.key] = event.oldValue;
            data.newValue[event.key] = event.newValue;
            return data;
        }, {
            oldValue: {},
            keys: [],
            operations: [],
            newValue: {},
        });
    }
    else {
        return {
            operation: formatDisplay(events.type),
            key: formatDisplay(events.key),
            oldValue: events.oldValue,
            newValue: events.newValue,
        };
    }
}
function formatMutationType(type) {
    switch (type) {
        case MutationType.direct:
            return 'mutation';
        case MutationType.patchFunction:
            return '$patch';
        case MutationType.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}

// timeline can be paused when directly changing the state
let isTimelineActive = true;
const componentStateTypes = (/* unused pure expression or super */ null && ([]));
const MUTATIONS_LAYER_ID = 'pinia:mutations';
const INSPECTOR_ID = 'pinia';
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */
const getStoreType = (id) => '🍍 ' + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */
function registerPiniaDevtools(app, pinia) {
    setupDevtoolsPlugin({
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes,
        app,
    }, (api) => {
        if (typeof api.now !== 'function') {
            toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        }
        api.addTimelineLayer({
            id: MUTATIONS_LAYER_ID,
            label: `Pinia 🍍`,
            color: 0xe5df88,
        });
        api.addInspector({
            id: INSPECTOR_ID,
            label: 'Pinia 🍍',
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: () => {
                        actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state',
                },
                {
                    icon: 'content_paste',
                    action: async () => {
                        await actionGlobalPasteState(pinia);
                        api.sendInspectorTree(INSPECTOR_ID);
                        api.sendInspectorState(INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard',
                },
                {
                    icon: 'save',
                    action: () => {
                        actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file',
                },
                {
                    icon: 'folder_open',
                    action: async () => {
                        await actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree(INSPECTOR_ID);
                        api.sendInspectorState(INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file',
                },
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (option store only)',
                    action: (nodeId) => {
                        const store = pinia._s.get(nodeId);
                        if (!store) {
                            toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        }
                        else if (!store._isOptionsAPI) {
                            toastMessage(`Cannot reset "${nodeId}" store because it's a setup store.`, 'warn');
                        }
                        else {
                            store.$reset();
                            toastMessage(`Store "${nodeId}" reset.`);
                        }
                    },
                },
            ],
        });
        api.on.inspectComponent((payload, ctx) => {
            const proxy = (payload.componentInstance &&
                payload.componentInstance.proxy);
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store) => {
                    payload.instanceData.state.push({
                        type: getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI
                            ? {
                                _custom: {
                                    value: toRaw(store.$state),
                                    actions: [
                                        {
                                            icon: 'restore',
                                            tooltip: 'Reset the state of this store',
                                            action: () => store.$reset(),
                                        },
                                    ],
                                },
                            }
                            : // NOTE: workaround to unwrap transferred refs
                                Object.keys(store.$state).reduce((state, key) => {
                                    state[key] = store.$state[key];
                                    return state;
                                }, {}),
                    });
                    if (store._getters && store._getters.length) {
                        payload.instanceData.state.push({
                            type: getStoreType(store.$id),
                            key: 'getters',
                            editable: false,
                            value: store._getters.reduce((getters, key) => {
                                try {
                                    getters[key] = store[key];
                                }
                                catch (error) {
                                    // @ts-expect-error: we just want to show it in devtools
                                    getters[key] = error;
                                }
                                return getters;
                            }, {}),
                        });
                    }
                });
            }
        });
        api.on.getInspectorTree((payload) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                let stores = [pinia];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter
                    ? stores.filter((store) => '$id' in store
                        ? store.$id
                            .toLowerCase()
                            .includes(payload.filter.toLowerCase())
                        : PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase()))
                    : stores).map(formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === PINIA_ROOT_ID
                    ? pinia
                    : pinia._s.get(payload.nodeId);
                if (!inspectedStore) {
                    // this could be the selected store restored for a different project
                    // so it's better not to say anything here
                    return;
                }
                if (inspectedStore) {
                    payload.state = formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload, ctx) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === PINIA_ROOT_ID
                    ? pinia
                    : pinia._s.get(payload.nodeId);
                if (!inspectedStore) {
                    return toastMessage(`store "${payload.nodeId}" not found`, 'error');
                }
                const { path } = payload;
                if (!isPinia(inspectedStore)) {
                    // access only the state
                    if (path.length !== 1 ||
                        !inspectedStore._customProperties.has(path[0]) ||
                        path[0] in inspectedStore.$state) {
                        path.unshift('$state');
                    }
                }
                else {
                    // Root access, we can omit the `.value` because the devtools API does it for us
                    path.unshift('state');
                }
                isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload) => {
            if (payload.type.startsWith('🍍')) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) {
                    return toastMessage(`store "${storeId}" not found`, 'error');
                }
                const { path } = payload;
                if (path[0] !== 'state') {
                    return toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                }
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                isTimelineActive = true;
            }
        });
    });
}
function addStoreToDevtools(app, store) {
    if (!componentStateTypes.includes(getStoreType(store.$id))) {
        componentStateTypes.push(getStoreType(store.$id));
    }
    setupDevtoolsPlugin({
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes,
        app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true,
            },
            // useEmojis: {
            //   label: 'Use emojis in messages ⚡️',
            //   type: 'boolean',
            //   defaultValue: true,
            // },
        },
    }, (api) => {
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after, onError, name, args }) => {
            const groupId = runningActionId++;
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: '🛫 ' + name,
                    subtitle: 'start',
                    data: {
                        store: formatDisplay(store.$id),
                        action: formatDisplay(name),
                        args,
                    },
                    groupId,
                },
            });
            after((result) => {
                activeAction = undefined;
                api.addTimelineEvent({
                    layerId: MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: '🛬 ' + name,
                        subtitle: 'end',
                        data: {
                            store: formatDisplay(store.$id),
                            action: formatDisplay(name),
                            args,
                            result,
                        },
                        groupId,
                    },
                });
            });
            onError((error) => {
                activeAction = undefined;
                api.addTimelineEvent({
                    layerId: MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: '💥 ' + name,
                        subtitle: 'end',
                        data: {
                            store: formatDisplay(store.$id),
                            action: formatDisplay(name),
                            args,
                            error,
                        },
                        groupId,
                    },
                });
            });
        }, true);
        store._customProperties.forEach((name) => {
            watch(() => unref(store[name]), (newValue, oldValue) => {
                api.notifyComponentUpdate();
                api.sendInspectorState(INSPECTOR_ID);
                if (isTimelineActive) {
                    api.addTimelineEvent({
                        layerId: MUTATIONS_LAYER_ID,
                        event: {
                            time: now(),
                            title: 'Change',
                            subtitle: name,
                            data: {
                                newValue,
                                oldValue,
                            },
                            groupId: activeAction,
                        },
                    });
                }
            }, { deep: true });
        });
        store.$subscribe(({ events, type }, state) => {
            api.notifyComponentUpdate();
            api.sendInspectorState(INSPECTOR_ID);
            if (!isTimelineActive)
                return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: formatMutationType(type),
                data: {
                    store: formatDisplay(store.$id),
                    ...formatEventData(events),
                },
                groupId: activeAction,
            };
            // reset for the next mutation
            activeAction = undefined;
            if (type === MutationType.patchFunction) {
                eventData.subtitle = '⤵️';
            }
            else if (type === MutationType.patchObject) {
                eventData.subtitle = '🧩';
            }
            else if (events && !Array.isArray(events)) {
                eventData.subtitle = events.type;
            }
            if (events) {
                eventData.data['rawEvent(s)'] = {
                    _custom: {
                        display: 'DebuggerEvent',
                        type: 'object',
                        tooltip: 'raw DebuggerEvent[]',
                        value: events,
                    },
                };
            }
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: eventData,
            });
        }, { detached: true, flush: 'sync' });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = markRaw((newStore) => {
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: '🔥 ' + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: formatDisplay(store.$id),
                        info: formatDisplay(`HMR update`),
                    },
                },
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
        });
        const { $dispose } = store;
        store.$dispose = () => {
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
            api.getSettings().logStoreChanges &&
                toastMessage(`Disposed "${store.$id}" store 🗑`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree(INSPECTOR_ID);
        api.sendInspectorState(INSPECTOR_ID);
        api.getSettings().logStoreChanges &&
            toastMessage(`"${store.$id}" store installed 🆕`);
    });
}
let runningActionId = 0;
let activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */
function patchActionForGrouping(store, actionNames) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName) => {
        // use toRaw to avoid tracking #541
        storeActions[actionName] = toRaw(store)[actionName];
        return storeActions;
    }, {});
    for (const actionName in actions) {
        store[actionName] = function () {
            // setActivePinia(store._p)
            // the running action id is incremented in a before action hook
            const _actionId = runningActionId;
            const trackedStore = new Proxy(store, {
                get(...args) {
                    activeAction = _actionId;
                    return Reflect.get(...args);
                },
                set(...args) {
                    activeAction = _actionId;
                    return Reflect.set(...args);
                },
            });
            return actions[actionName].apply(trackedStore, arguments);
        };
    }
}
/**
 * pinia.use(devtoolsPlugin)
 */
function devtoolsPlugin({ app, store, options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) {
        return;
    }
    // detect option api vs setup api
    if (options.state) {
        store._isOptionsAPI = true;
    }
    // only wrap actions in option-defined stores as this technique relies on
    // wrapping the context of the action with a proxy
    if (typeof options.state === 'function') {
        patchActionForGrouping(
        // @ts-expect-error: can cast the store...
        store, Object.keys(options.actions));
        const originalHotUpdate = store._hotUpdate;
        // Upgrade the HMR to also update the new actions
        toRaw(store)._hotUpdate = function (newStore) {
            originalHotUpdate.apply(this, arguments);
            patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions));
        };
    }
    addStoreToDevtools(app, 
    // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}

/**
 * Creates a Pinia instance to be used by the application
 */
function createPinia() {
    const scope = effectScope(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(() => ref({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = markRaw({
        install(app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            setActivePinia(pinia);
            if (!isVue2) {
                pinia._a = app;
                app.provide(piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */
                if (USE_DEVTOOLS) {
                    registerPiniaDevtools(app, pinia);
                }
                toBeInstalled.forEach((plugin) => _p.push(plugin));
                toBeInstalled = [];
            }
        },
        use(plugin) {
            if (!this._a && !isVue2) {
                toBeInstalled.push(plugin);
            }
            else {
                _p.push(plugin);
            }
            return this;
        },
        _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state,
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (USE_DEVTOOLS && typeof Proxy !== 'undefined') {
        pinia.use(devtoolsPlugin);
    }
    return pinia;
}

/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */
const isUseStore = (fn) => {
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */
function patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for (const key in oldState) {
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) {
            continue;
        }
        const targetValue = newState[key];
        if (isPlainObject(targetValue) &&
            isPlainObject(subPatch) &&
            !isRef(subPatch) &&
            !isReactive(subPatch)) {
            newState[key] = patchObject(targetValue, subPatch);
        }
        else {
            // objects are either a bit more complex (e.g. refs) or primitives, so we
            // just set the whole thing
            if (isVue2) {
                set(newState, key, subPatch);
            }
            else {
                newState[key] = subPatch;
            }
        }
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */
function acceptHMRUpdate(initialUseStore, hot) {
    return (newModule) => {
        const pinia = hot.data.pinia || initialUseStore._pinia;
        if (!pinia) {
            // this store is still not used
            return;
        }
        // preserve the pinia instance across loads
        hot.data.pinia = pinia;
        // console.log('got data', newStore)
        for (const exportName in newModule) {
            const useStore = newModule[exportName];
            // console.log('checking for', exportName)
            if (isUseStore(useStore) && pinia._s.has(useStore.$id)) {
                // console.log('Accepting update for', useStore.$id)
                const id = useStore.$id;
                if (id !== initialUseStore.$id) {
                    console.warn(`The id of the store changed from "${initialUseStore.$id}" to "${id}". Reloading.`);
                    // return import.meta.hot.invalidate()
                    return hot.invalidate();
                }
                const existingStore = pinia._s.get(id);
                if (!existingStore) {
                    console.log(`[Pinia]: skipping hmr because store doesn't exist yet`);
                    return;
                }
                useStore(pinia, existingStore);
            }
        }
    };
}

const noop = () => { };
function addSubscription(subscriptions, callback, detached, onCleanup = noop) {
    subscriptions.push(callback);
    const removeSubscription = () => {
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && getCurrentInstance()) {
        onUnmounted(removeSubscription);
    }
    return removeSubscription;
}
function triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback) => {
        callback(...args);
    });
}

function mergeReactiveObjects(target, patchToApply) {
    // no need to go through symbols because they cannot be serialized anyway
    for (const key in patchToApply) {
        if (!patchToApply.hasOwnProperty(key))
            continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if (isPlainObject(targetValue) &&
            isPlainObject(subPatch) &&
            target.hasOwnProperty(key) &&
            !isRef(subPatch) &&
            !isReactive(subPatch)) {
            target[key] = mergeReactiveObjects(targetValue, subPatch);
        }
        else {
            // @ts-expect-error: subPatch is a valid value
            target[key] = subPatch;
        }
    }
    return target;
}
const skipHydrateSymbol = Symbol('pinia:skipHydration')
    ;
const skipHydrateMap = /*#__PURE__*/ new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */
function skipHydrate(obj) {
    return isVue2
        ? // in @vue/composition-api, the refs are sealed so defineProperty doesn't work...
            /* istanbul ignore next */ skipHydrateMap.set(obj, 1) && obj
        : Object.defineProperty(obj, skipHydrateSymbol, {});
}
function shouldHydrate(obj) {
    return isVue2
        ? /* istanbul ignore next */ !skipHydrateMap.has(obj)
        : !isPlainObject(obj) || !obj.hasOwnProperty(skipHydrateSymbol);
}
const { assign: pinia_esm_browser_assign } = Object;
function isComputed(o) {
    return !!(isRef(o) && o.effect);
}
function createOptionsStore(id, options, pinia, hot) {
    const { state, actions, getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && (!hot)) {
            /* istanbul ignore if */
            if (isVue2) {
                set(pinia.state.value, id, state ? state() : {});
            }
            else {
                pinia.state.value[id] = state ? state() : {};
            }
        }
        // avoid creating a state in pinia.state.value
        const localState = hot
            ? // use ref() to unwrap refs inside state TODO: check if this is still necessary
                toRefs(ref(state ? state() : {}).value)
            : toRefs(pinia.state.value[id]);
        return pinia_esm_browser_assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
            if (name in localState) {
                console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${name}" in store "${id}".`);
            }
            computedGetters[name] = markRaw(computed(() => {
                setActivePinia(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore next */
                if (isVue2 && !store._r)
                    return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = createSetupStore(id, setup, options, pinia, hot, true);
    store.$reset = function $reset() {
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state) => {
            pinia_esm_browser_assign($state, newState);
        });
    };
    return store;
}
function createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = pinia_esm_browser_assign({ actions: {} }, options);
    /* istanbul ignore if */
    // @ts-expect-error: active is an internal property
    if (!pinia._e.active) {
        throw new Error('Pinia destroyed');
    }
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true,
        // flush: 'post',
    };
    /* istanbul ignore else */
    if (!isVue2) {
        $subscribeOptions.onTrigger = (event) => {
            /* istanbul ignore else */
            if (isListening) {
                debuggerEvents = event;
                // avoid triggering this while the store is being built and the state is being set in pinia
            }
            else if (isListening == false && !store._hotUpdating) {
                // let patch send all the events together later
                /* istanbul ignore else */
                if (Array.isArray(debuggerEvents)) {
                    debuggerEvents.push(event);
                }
                else {
                    console.error('🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.');
                }
            }
        };
    }
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = markRaw([]);
    let actionSubscriptions = markRaw([]);
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && (!hot)) {
        /* istanbul ignore if */
        if (isVue2) {
            set(pinia.state.value, $id, {});
        }
        else {
            pinia.state.value[$id] = {};
        }
    }
    const hotState = ref({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        // reset the debugger events since patches are sync
        /* istanbul ignore else */
        {
            debuggerEvents = [];
        }
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: MutationType.patchFunction,
                storeId: $id,
                events: debuggerEvents,
            };
        }
        else {
            mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: MutationType.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents,
            };
        }
        const myListenerId = (activeListener = Symbol());
        nextTick().then(() => {
            if (activeListener === myListenerId) {
                isListening = true;
            }
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    /* istanbul ignore next */
    const $reset = () => {
            throw new Error(`🍍: Store "${$id}" is built using the setup syntax and does not implement $reset().`);
        }
        ;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Wraps an action to handle subscriptions.
     *
     * @param name - name of the action
     * @param action - action to wrap
     * @returns a wrapped action to handle subscriptions
     */
    function wrapAction(name, action) {
        return function () {
            setActivePinia(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            triggerSubscriptions(actionSubscriptions, {
                args,
                name,
                store,
                after,
                onError,
            });
            let ret;
            try {
                ret = action.apply(this && this.$id === $id ? this : store, args);
                // handle sync errors
            }
            catch (error) {
                triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) {
                return ret
                    .then((value) => {
                    triggerSubscriptions(afterCallbackList, value);
                    return value;
                })
                    .catch((error) => {
                    triggerSubscriptions(onErrorCallbackList, error);
                    return Promise.reject(error);
                });
            }
            // allow the afterCallback to override the return value
            triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
    }
    const _hmrPayload = /*#__PURE__*/ markRaw({
        actions: {},
        getters: {},
        state: [],
        hotState,
    });
    const partialStore = {
        _p: pinia,
        // _s: scope,
        $id,
        $onAction: addSubscription.bind(null, actionSubscriptions),
        $patch,
        $reset,
        $subscribe(callback, options = {}) {
            const removeSubscription = addSubscription(subscriptions, callback, options.detached, () => stopWatcher());
            const stopWatcher = scope.run(() => watch(() => pinia.state.value[$id], (state) => {
                if (options.flush === 'sync' ? isSyncListening : isListening) {
                    callback({
                        storeId: $id,
                        type: MutationType.direct,
                        events: debuggerEvents,
                    }, state);
                }
            }, pinia_esm_browser_assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose,
    };
    /* istanbul ignore if */
    if (isVue2) {
        // start as non ready
        partialStore._r = false;
    }
    const store = reactive(pinia_esm_browser_assign(IS_CLIENT
        ? // devtools custom properties
            {
                _customProperties: markRaw(new Set()),
                _hmrPayload,
            }
        : {}, partialStore
    // must be added later
    // setupStore
    ));
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = pinia._e.run(() => {
        scope = effectScope();
        return scope.run(() => setup());
    });
    // overwrite existing actions to support $onAction
    for (const key in setupStore) {
        const prop = setupStore[key];
        if ((isRef(prop) && !isComputed(prop)) || isReactive(prop)) {
            // mark it as a piece of state to be serialized
            if (hot) {
                set(hotState.value, key, toRef(setupStore, key));
                // createOptionStore directly sets the state in pinia.state.value so we
                // can just skip that
            }
            else if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && shouldHydrate(prop)) {
                    if (isRef(prop)) {
                        prop.value = initialState[key];
                    }
                    else {
                        // probably a reactive object, lets recursively assign
                        mergeReactiveObjects(prop, initialState[key]);
                    }
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */
                if (isVue2) {
                    set(pinia.state.value[$id], key, prop);
                }
                else {
                    pinia.state.value[$id][key] = prop;
                }
            }
            /* istanbul ignore else */
            {
                _hmrPayload.state.push(key);
            }
            // action
        }
        else if (typeof prop === 'function') {
            // @ts-expect-error: we are overriding the function we avoid wrapping if
            const actionValue = hot ? prop : wrapAction(key, prop);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */
            if (isVue2) {
                set(setupStore, key, actionValue);
            }
            else {
                // @ts-expect-error
                setupStore[key] = actionValue;
            }
            /* istanbul ignore else */
            {
                _hmrPayload.actions[key] = prop;
            }
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
        else {
            // add getters for devtools
            if (isComputed(prop)) {
                _hmrPayload.getters[key] = isOptionsStore
                    ? // @ts-expect-error
                        options.getters[key]
                    : prop;
                if (IS_CLIENT) {
                    const getters = 
                    // @ts-expect-error: it should be on the store
                    setupStore._getters || (setupStore._getters = markRaw([]));
                    getters.push(key);
                }
            }
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */
    if (isVue2) {
        Object.keys(setupStore).forEach((key) => {
            set(store, key, 
            // @ts-expect-error: valid key indexing
            setupStore[key]);
        });
    }
    else {
        pinia_esm_browser_assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        pinia_esm_browser_assign(toRaw(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: () => (hot ? hotState.value : pinia.state.value[$id]),
        set: (state) => {
            /* istanbul ignore if */
            if (hot) {
                throw new Error('cannot set hotState');
            }
            $patch(($state) => {
                pinia_esm_browser_assign($state, state);
            });
        },
    });
    // add the hotUpdate before plugins to allow them to override it
    /* istanbul ignore else */
    {
        store._hotUpdate = markRaw((newStore) => {
            store._hotUpdating = true;
            newStore._hmrPayload.state.forEach((stateKey) => {
                if (stateKey in store.$state) {
                    const newStateTarget = newStore.$state[stateKey];
                    const oldStateSource = store.$state[stateKey];
                    if (typeof newStateTarget === 'object' &&
                        isPlainObject(newStateTarget) &&
                        isPlainObject(oldStateSource)) {
                        patchObject(newStateTarget, oldStateSource);
                    }
                    else {
                        // transfer the ref
                        newStore.$state[stateKey] = oldStateSource;
                    }
                }
                // patch direct access properties to allow store.stateProperty to work as
                // store.$state.stateProperty
                set(store, stateKey, toRef(newStore.$state, stateKey));
            });
            // remove deleted state properties
            Object.keys(store.$state).forEach((stateKey) => {
                if (!(stateKey in newStore.$state)) {
                    del(store, stateKey);
                }
            });
            // avoid devtools logging this as a mutation
            isListening = false;
            isSyncListening = false;
            pinia.state.value[$id] = toRef(newStore._hmrPayload, 'hotState');
            isSyncListening = true;
            nextTick().then(() => {
                isListening = true;
            });
            for (const actionName in newStore._hmrPayload.actions) {
                const action = newStore[actionName];
                set(store, actionName, wrapAction(actionName, action));
            }
            // TODO: does this work in both setup and option store?
            for (const getterName in newStore._hmrPayload.getters) {
                const getter = newStore._hmrPayload.getters[getterName];
                const getterValue = isOptionsStore
                    ? // special handling of options api
                        computed(() => {
                            setActivePinia(pinia);
                            return getter.call(store, store);
                        })
                    : getter;
                set(store, getterName, getterValue);
            }
            // remove deleted getters
            Object.keys(store._hmrPayload.getters).forEach((key) => {
                if (!(key in newStore._hmrPayload.getters)) {
                    del(store, key);
                }
            });
            // remove old actions
            Object.keys(store._hmrPayload.actions).forEach((key) => {
                if (!(key in newStore._hmrPayload.actions)) {
                    del(store, key);
                }
            });
            // update the values used in devtools and to allow deleting new properties later on
            store._hmrPayload = newStore._hmrPayload;
            store._getters = newStore._getters;
            store._hotUpdating = false;
        });
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false,
        };
        if (IS_CLIENT) {
            ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach((p) => {
                Object.defineProperty(store, p, {
                    value: store[p],
                    ...nonEnumerable,
                });
            });
        }
    }
    /* istanbul ignore if */
    if (isVue2) {
        // mark the store as ready before plugins
        store._r = true;
    }
    // apply all plugins
    pinia._p.forEach((extender) => {
        /* istanbul ignore else */
        if (IS_CLIENT) {
            const extensions = scope.run(() => extender({
                store,
                app: pinia._a,
                pinia,
                options: optionsForPlugin,
            }));
            Object.keys(extensions || {}).forEach((key) => store._customProperties.add(key));
            pinia_esm_browser_assign(store, extensions);
        }
        else {
            pinia_esm_browser_assign(store, scope.run(() => extender({
                store,
                app: pinia._a,
                pinia,
                options: optionsForPlugin,
            })));
        }
    });
    if (store.$state &&
        typeof store.$state === 'object' &&
        typeof store.$state.constructor === 'function' &&
        !store.$state.constructor.toString().includes('[native code]')) {
        console.warn(`[🍍]: The "state" must be a plain object. It cannot be\n` +
            `\tstate: () => new MyClass()\n` +
            `Found in store "${store.$id}".`);
    }
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState &&
        isOptionsStore &&
        options.hydrate) {
        options.hydrate(store.$state, initialState);
    }
    isListening = true;
    isSyncListening = true;
    return store;
}
function defineStore(
// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === 'function';
    if (typeof idOrOptions === 'string') {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    }
    else {
        options = idOrOptions;
        id = idOrOptions.id;
    }
    function useStore(pinia, hot) {
        const currentInstance = getCurrentInstance();
        pinia =
            // in test mode, ignore the argument provided as we can always retrieve a
            // pinia instance with getActivePinia()
            (pinia) ||
                (currentInstance && inject(piniaSymbol));
        if (pinia)
            setActivePinia(pinia);
        if (!activePinia) {
            throw new Error(`[🍍]: getActivePinia was called with no active Pinia. Did you forget to install pinia?\n` +
                `\tconst pinia = createPinia()\n` +
                `\tapp.use(pinia)\n` +
                `This will fail in production.`);
        }
        pinia = activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) {
                createSetupStore(id, setup, options, pinia);
            }
            else {
                createOptionsStore(id, options, pinia);
            }
            /* istanbul ignore else */
            {
                // @ts-expect-error: not the right inferred type
                useStore._pinia = pinia;
            }
        }
        const store = pinia._s.get(id);
        if (hot) {
            const hotId = '__hot:' + id;
            const newStore = isSetupStore
                ? createSetupStore(hotId, setup, options, pinia, true)
                : createOptionsStore(hotId, pinia_esm_browser_assign({}, options), pinia, true);
            hot._hotUpdate(newStore);
            // cleanup the state properties and the store from the cache
            delete pinia.state.value[hotId];
            pinia._s.delete(hotId);
        }
        // save stores in instances to access them devtools
        if (IS_CLIENT &&
            currentInstance &&
            currentInstance.proxy &&
            // avoid adding stores that are just built for hot module replacement
            !hot) {
            const vm = currentInstance.proxy;
            const cache = '_pStores' in vm ? vm._pStores : (vm._pStores = {});
            cache[id] = store;
        }
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}

let mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */
function setMapStoreSuffix(suffix // could be 'Store' but that would be annoying for JS
) {
    mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */
function mapStores(...stores) {
    if (Array.isArray(stores[0])) {
        console.warn(`[🍍]: Directly pass all stores to "mapStores()" without putting them in an array:\n` +
            `Replace\n` +
            `\tmapStores([useAuthStore, useCartStore])\n` +
            `with\n` +
            `\tmapStores(useAuthStore, useCartStore)\n` +
            `This will fail in production if not fixed.`);
        stores = stores[0];
    }
    return stores.reduce((reduced, useStore) => {
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + mapStoreSuffix] = function () {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapState(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            reduced[key] = function () {
                return useStore(this.$pinia)[key];
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function () {
                const store = useStore(this.$pinia);
                const storeKey = keysOrMapper[key];
                // for some reason TS is unable to infer the type of storeKey to be a
                // function
                return typeof storeKey === 'function'
                    ? storeKey.call(this, store)
                    : store[storeKey];
            };
            return reduced;
        }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */
const mapGetters = (/* unused pure expression or super */ null && (mapState));
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapActions(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function (...args) {
                return useStore(this.$pinia)[key](...args);
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function (...args) {
                return useStore(this.$pinia)[keysOrMapper[key]](...args);
            };
            return reduced;
        }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapWritableState(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            // @ts-ignore
            reduced[key] = {
                get() {
                    return useStore(this.$pinia)[key];
                },
                set(value) {
                    // it's easier to type it here as any
                    return (useStore(this.$pinia)[key] = value);
                },
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-ignore
            reduced[key] = {
                get() {
                    return useStore(this.$pinia)[keysOrMapper[key]];
                },
                set(value) {
                    // it's easier to type it here as any
                    return (useStore(this.$pinia)[keysOrMapper[key]] = value);
                },
            };
            return reduced;
        }, {});
}

/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */
function storeToRefs(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (lib_isVue2) {
        // @ts-expect-error: toRefs include methods and others
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRefs)(store);
    }
    else {
        store = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRaw)(store);
        const refs = {};
        for (const key in store) {
            const value = store[key];
            if ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(value) || (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isReactive)(value)) {
                // @ts-expect-error: the key is state or getter
                refs[key] =
                    // ---
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRef)(store, key);
            }
        }
        return refs;
    }
}

/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */
const PiniaVuePlugin = function (_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate() {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */
                if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, '_provided', {
                        get: () => provideCache,
                        set: (v) => Object.assign(provideCache, v),
                    });
                }
                this._provided[piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */
                if (!this.$pinia) {
                    this.$pinia = pinia;
                }
                pinia._a = this;
                if (IS_CLIENT) {
                    // this allows calling useStore() outside of a component setup after
                    // installing pinia's plugin
                    setActivePinia(pinia);
                }
                if (USE_DEVTOOLS) {
                    registerPiniaDevtools(pinia._a, pinia);
                }
            }
            else if (!this.$pinia && options.parent && options.parent.$pinia) {
                this.$pinia = options.parent.$pinia;
            }
        },
        destroyed() {
            delete this._pStores;
        },
    });
};




/***/ }),

/***/ 4155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 7013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	0;
}(this, (function () { 'use strict';

/* !
 * type-detect
 * Copyright(c) 2013 jake luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
var promiseExists = typeof Promise === 'function';

/* eslint-disable no-undef */
var globalObject = typeof self === 'object' ? self : __webpack_require__.g; // eslint-disable-line id-blacklist

var symbolExists = typeof Symbol !== 'undefined';
var mapExists = typeof Map !== 'undefined';
var setExists = typeof Set !== 'undefined';
var weakMapExists = typeof WeakMap !== 'undefined';
var weakSetExists = typeof WeakSet !== 'undefined';
var dataViewExists = typeof DataView !== 'undefined';
var symbolIteratorExists = symbolExists && typeof Symbol.iterator !== 'undefined';
var symbolToStringTagExists = symbolExists && typeof Symbol.toStringTag !== 'undefined';
var setEntriesExists = setExists && typeof Set.prototype.entries === 'function';
var mapEntriesExists = mapExists && typeof Map.prototype.entries === 'function';
var setIteratorPrototype = setEntriesExists && Object.getPrototypeOf(new Set().entries());
var mapIteratorPrototype = mapEntriesExists && Object.getPrototypeOf(new Map().entries());
var arrayIteratorExists = symbolIteratorExists && typeof Array.prototype[Symbol.iterator] === 'function';
var arrayIteratorPrototype = arrayIteratorExists && Object.getPrototypeOf([][Symbol.iterator]());
var stringIteratorExists = symbolIteratorExists && typeof String.prototype[Symbol.iterator] === 'function';
var stringIteratorPrototype = stringIteratorExists && Object.getPrototypeOf(''[Symbol.iterator]());
var toStringLeftSliceLength = 8;
var toStringRightSliceLength = -1;
/**
 * ### typeOf (obj)
 *
 * Uses `Object.prototype.toString` to determine the type of an object,
 * normalising behaviour across engine versions & well optimised.
 *
 * @param {Mixed} object
 * @return {String} object type
 * @api public
 */
function typeDetect(obj) {
  /* ! Speed optimisation
   * Pre:
   *   string literal     x 3,039,035 ops/sec ±1.62% (78 runs sampled)
   *   boolean literal    x 1,424,138 ops/sec ±4.54% (75 runs sampled)
   *   number literal     x 1,653,153 ops/sec ±1.91% (82 runs sampled)
   *   undefined          x 9,978,660 ops/sec ±1.92% (75 runs sampled)
   *   function           x 2,556,769 ops/sec ±1.73% (77 runs sampled)
   * Post:
   *   string literal     x 38,564,796 ops/sec ±1.15% (79 runs sampled)
   *   boolean literal    x 31,148,940 ops/sec ±1.10% (79 runs sampled)
   *   number literal     x 32,679,330 ops/sec ±1.90% (78 runs sampled)
   *   undefined          x 32,363,368 ops/sec ±1.07% (82 runs sampled)
   *   function           x 31,296,870 ops/sec ±0.96% (83 runs sampled)
   */
  var typeofObj = typeof obj;
  if (typeofObj !== 'object') {
    return typeofObj;
  }

  /* ! Speed optimisation
   * Pre:
   *   null               x 28,645,765 ops/sec ±1.17% (82 runs sampled)
   * Post:
   *   null               x 36,428,962 ops/sec ±1.37% (84 runs sampled)
   */
  if (obj === null) {
    return 'null';
  }

  /* ! Spec Conformance
   * Test: `Object.prototype.toString.call(window)``
   *  - Node === "[object global]"
   *  - Chrome === "[object global]"
   *  - Firefox === "[object Window]"
   *  - PhantomJS === "[object Window]"
   *  - Safari === "[object Window]"
   *  - IE 11 === "[object Window]"
   *  - IE Edge === "[object Window]"
   * Test: `Object.prototype.toString.call(this)``
   *  - Chrome Worker === "[object global]"
   *  - Firefox Worker === "[object DedicatedWorkerGlobalScope]"
   *  - Safari Worker === "[object DedicatedWorkerGlobalScope]"
   *  - IE 11 Worker === "[object WorkerGlobalScope]"
   *  - IE Edge Worker === "[object WorkerGlobalScope]"
   */
  if (obj === globalObject) {
    return 'global';
  }

  /* ! Speed optimisation
   * Pre:
   *   array literal      x 2,888,352 ops/sec ±0.67% (82 runs sampled)
   * Post:
   *   array literal      x 22,479,650 ops/sec ±0.96% (81 runs sampled)
   */
  if (
    Array.isArray(obj) &&
    (symbolToStringTagExists === false || !(Symbol.toStringTag in obj))
  ) {
    return 'Array';
  }

  // Not caching existence of `window` and related properties due to potential
  // for `window` to be unset before tests in quasi-browser environments.
  if (typeof window === 'object' && window !== null) {
    /* ! Spec Conformance
     * (https://html.spec.whatwg.org/multipage/browsers.html#location)
     * WhatWG HTML$7.7.3 - The `Location` interface
     * Test: `Object.prototype.toString.call(window.location)``
     *  - IE <=11 === "[object Object]"
     *  - IE Edge <=13 === "[object Object]"
     */
    if (typeof window.location === 'object' && obj === window.location) {
      return 'Location';
    }

    /* ! Spec Conformance
     * (https://html.spec.whatwg.org/#document)
     * WhatWG HTML$3.1.1 - The `Document` object
     * Note: Most browsers currently adher to the W3C DOM Level 2 spec
     *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-26809268)
     *       which suggests that browsers should use HTMLTableCellElement for
     *       both TD and TH elements. WhatWG separates these.
     *       WhatWG HTML states:
     *         > For historical reasons, Window objects must also have a
     *         > writable, configurable, non-enumerable property named
     *         > HTMLDocument whose value is the Document interface object.
     * Test: `Object.prototype.toString.call(document)``
     *  - Chrome === "[object HTMLDocument]"
     *  - Firefox === "[object HTMLDocument]"
     *  - Safari === "[object HTMLDocument]"
     *  - IE <=10 === "[object Document]"
     *  - IE 11 === "[object HTMLDocument]"
     *  - IE Edge <=13 === "[object HTMLDocument]"
     */
    if (typeof window.document === 'object' && obj === window.document) {
      return 'Document';
    }

    if (typeof window.navigator === 'object') {
      /* ! Spec Conformance
       * (https://html.spec.whatwg.org/multipage/webappapis.html#mimetypearray)
       * WhatWG HTML$8.6.1.5 - Plugins - Interface MimeTypeArray
       * Test: `Object.prototype.toString.call(navigator.mimeTypes)``
       *  - IE <=10 === "[object MSMimeTypesCollection]"
       */
      if (typeof window.navigator.mimeTypes === 'object' &&
          obj === window.navigator.mimeTypes) {
        return 'MimeTypeArray';
      }

      /* ! Spec Conformance
       * (https://html.spec.whatwg.org/multipage/webappapis.html#pluginarray)
       * WhatWG HTML$8.6.1.5 - Plugins - Interface PluginArray
       * Test: `Object.prototype.toString.call(navigator.plugins)``
       *  - IE <=10 === "[object MSPluginsCollection]"
       */
      if (typeof window.navigator.plugins === 'object' &&
          obj === window.navigator.plugins) {
        return 'PluginArray';
      }
    }

    if ((typeof window.HTMLElement === 'function' ||
        typeof window.HTMLElement === 'object') &&
        obj instanceof window.HTMLElement) {
      /* ! Spec Conformance
      * (https://html.spec.whatwg.org/multipage/webappapis.html#pluginarray)
      * WhatWG HTML$4.4.4 - The `blockquote` element - Interface `HTMLQuoteElement`
      * Test: `Object.prototype.toString.call(document.createElement('blockquote'))``
      *  - IE <=10 === "[object HTMLBlockElement]"
      */
      if (obj.tagName === 'BLOCKQUOTE') {
        return 'HTMLQuoteElement';
      }

      /* ! Spec Conformance
       * (https://html.spec.whatwg.org/#htmltabledatacellelement)
       * WhatWG HTML$4.9.9 - The `td` element - Interface `HTMLTableDataCellElement`
       * Note: Most browsers currently adher to the W3C DOM Level 2 spec
       *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-82915075)
       *       which suggests that browsers should use HTMLTableCellElement for
       *       both TD and TH elements. WhatWG separates these.
       * Test: Object.prototype.toString.call(document.createElement('td'))
       *  - Chrome === "[object HTMLTableCellElement]"
       *  - Firefox === "[object HTMLTableCellElement]"
       *  - Safari === "[object HTMLTableCellElement]"
       */
      if (obj.tagName === 'TD') {
        return 'HTMLTableDataCellElement';
      }

      /* ! Spec Conformance
       * (https://html.spec.whatwg.org/#htmltableheadercellelement)
       * WhatWG HTML$4.9.9 - The `td` element - Interface `HTMLTableHeaderCellElement`
       * Note: Most browsers currently adher to the W3C DOM Level 2 spec
       *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-82915075)
       *       which suggests that browsers should use HTMLTableCellElement for
       *       both TD and TH elements. WhatWG separates these.
       * Test: Object.prototype.toString.call(document.createElement('th'))
       *  - Chrome === "[object HTMLTableCellElement]"
       *  - Firefox === "[object HTMLTableCellElement]"
       *  - Safari === "[object HTMLTableCellElement]"
       */
      if (obj.tagName === 'TH') {
        return 'HTMLTableHeaderCellElement';
      }
    }
  }

  /* ! Speed optimisation
  * Pre:
  *   Float64Array       x 625,644 ops/sec ±1.58% (80 runs sampled)
  *   Float32Array       x 1,279,852 ops/sec ±2.91% (77 runs sampled)
  *   Uint32Array        x 1,178,185 ops/sec ±1.95% (83 runs sampled)
  *   Uint16Array        x 1,008,380 ops/sec ±2.25% (80 runs sampled)
  *   Uint8Array         x 1,128,040 ops/sec ±2.11% (81 runs sampled)
  *   Int32Array         x 1,170,119 ops/sec ±2.88% (80 runs sampled)
  *   Int16Array         x 1,176,348 ops/sec ±5.79% (86 runs sampled)
  *   Int8Array          x 1,058,707 ops/sec ±4.94% (77 runs sampled)
  *   Uint8ClampedArray  x 1,110,633 ops/sec ±4.20% (80 runs sampled)
  * Post:
  *   Float64Array       x 7,105,671 ops/sec ±13.47% (64 runs sampled)
  *   Float32Array       x 5,887,912 ops/sec ±1.46% (82 runs sampled)
  *   Uint32Array        x 6,491,661 ops/sec ±1.76% (79 runs sampled)
  *   Uint16Array        x 6,559,795 ops/sec ±1.67% (82 runs sampled)
  *   Uint8Array         x 6,463,966 ops/sec ±1.43% (85 runs sampled)
  *   Int32Array         x 5,641,841 ops/sec ±3.49% (81 runs sampled)
  *   Int16Array         x 6,583,511 ops/sec ±1.98% (80 runs sampled)
  *   Int8Array          x 6,606,078 ops/sec ±1.74% (81 runs sampled)
  *   Uint8ClampedArray  x 6,602,224 ops/sec ±1.77% (83 runs sampled)
  */
  var stringTag = (symbolToStringTagExists && obj[Symbol.toStringTag]);
  if (typeof stringTag === 'string') {
    return stringTag;
  }

  var objPrototype = Object.getPrototypeOf(obj);
  /* ! Speed optimisation
  * Pre:
  *   regex literal      x 1,772,385 ops/sec ±1.85% (77 runs sampled)
  *   regex constructor  x 2,143,634 ops/sec ±2.46% (78 runs sampled)
  * Post:
  *   regex literal      x 3,928,009 ops/sec ±0.65% (78 runs sampled)
  *   regex constructor  x 3,931,108 ops/sec ±0.58% (84 runs sampled)
  */
  if (objPrototype === RegExp.prototype) {
    return 'RegExp';
  }

  /* ! Speed optimisation
  * Pre:
  *   date               x 2,130,074 ops/sec ±4.42% (68 runs sampled)
  * Post:
  *   date               x 3,953,779 ops/sec ±1.35% (77 runs sampled)
  */
  if (objPrototype === Date.prototype) {
    return 'Date';
  }

  /* ! Spec Conformance
   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-promise.prototype-@@tostringtag)
   * ES6$25.4.5.4 - Promise.prototype[@@toStringTag] should be "Promise":
   * Test: `Object.prototype.toString.call(Promise.resolve())``
   *  - Chrome <=47 === "[object Object]"
   *  - Edge <=20 === "[object Object]"
   *  - Firefox 29-Latest === "[object Promise]"
   *  - Safari 7.1-Latest === "[object Promise]"
   */
  if (promiseExists && objPrototype === Promise.prototype) {
    return 'Promise';
  }

  /* ! Speed optimisation
  * Pre:
  *   set                x 2,222,186 ops/sec ±1.31% (82 runs sampled)
  * Post:
  *   set                x 4,545,879 ops/sec ±1.13% (83 runs sampled)
  */
  if (setExists && objPrototype === Set.prototype) {
    return 'Set';
  }

  /* ! Speed optimisation
  * Pre:
  *   map                x 2,396,842 ops/sec ±1.59% (81 runs sampled)
  * Post:
  *   map                x 4,183,945 ops/sec ±6.59% (82 runs sampled)
  */
  if (mapExists && objPrototype === Map.prototype) {
    return 'Map';
  }

  /* ! Speed optimisation
  * Pre:
  *   weakset            x 1,323,220 ops/sec ±2.17% (76 runs sampled)
  * Post:
  *   weakset            x 4,237,510 ops/sec ±2.01% (77 runs sampled)
  */
  if (weakSetExists && objPrototype === WeakSet.prototype) {
    return 'WeakSet';
  }

  /* ! Speed optimisation
  * Pre:
  *   weakmap            x 1,500,260 ops/sec ±2.02% (78 runs sampled)
  * Post:
  *   weakmap            x 3,881,384 ops/sec ±1.45% (82 runs sampled)
  */
  if (weakMapExists && objPrototype === WeakMap.prototype) {
    return 'WeakMap';
  }

  /* ! Spec Conformance
   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-dataview.prototype-@@tostringtag)
   * ES6$24.2.4.21 - DataView.prototype[@@toStringTag] should be "DataView":
   * Test: `Object.prototype.toString.call(new DataView(new ArrayBuffer(1)))``
   *  - Edge <=13 === "[object Object]"
   */
  if (dataViewExists && objPrototype === DataView.prototype) {
    return 'DataView';
  }

  /* ! Spec Conformance
   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%mapiteratorprototype%-@@tostringtag)
   * ES6$23.1.5.2.2 - %MapIteratorPrototype%[@@toStringTag] should be "Map Iterator":
   * Test: `Object.prototype.toString.call(new Map().entries())``
   *  - Edge <=13 === "[object Object]"
   */
  if (mapExists && objPrototype === mapIteratorPrototype) {
    return 'Map Iterator';
  }

  /* ! Spec Conformance
   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%setiteratorprototype%-@@tostringtag)
   * ES6$23.2.5.2.2 - %SetIteratorPrototype%[@@toStringTag] should be "Set Iterator":
   * Test: `Object.prototype.toString.call(new Set().entries())``
   *  - Edge <=13 === "[object Object]"
   */
  if (setExists && objPrototype === setIteratorPrototype) {
    return 'Set Iterator';
  }

  /* ! Spec Conformance
   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%arrayiteratorprototype%-@@tostringtag)
   * ES6$22.1.5.2.2 - %ArrayIteratorPrototype%[@@toStringTag] should be "Array Iterator":
   * Test: `Object.prototype.toString.call([][Symbol.iterator]())``
   *  - Edge <=13 === "[object Object]"
   */
  if (arrayIteratorExists && objPrototype === arrayIteratorPrototype) {
    return 'Array Iterator';
  }

  /* ! Spec Conformance
   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%stringiteratorprototype%-@@tostringtag)
   * ES6$21.1.5.2.2 - %StringIteratorPrototype%[@@toStringTag] should be "String Iterator":
   * Test: `Object.prototype.toString.call(''[Symbol.iterator]())``
   *  - Edge <=13 === "[object Object]"
   */
  if (stringIteratorExists && objPrototype === stringIteratorPrototype) {
    return 'String Iterator';
  }

  /* ! Speed optimisation
  * Pre:
  *   object from null   x 2,424,320 ops/sec ±1.67% (76 runs sampled)
  * Post:
  *   object from null   x 5,838,000 ops/sec ±0.99% (84 runs sampled)
  */
  if (objPrototype === null) {
    return 'Object';
  }

  return Object
    .prototype
    .toString
    .call(obj)
    .slice(toStringLeftSliceLength, toStringRightSliceLength);
}

return typeDetect;

})));


/***/ }),

/***/ 384:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 9539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(4155);
/* provided dependency */ var console = __webpack_require__(5108);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(__webpack_require__.g.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = ({"VUE_APP_BASE_URL":"https://docs.dutypay.eu/design-system","VUE_APP_LIBRARY_VARIABLE":"ds","VUE_APP_API_DUTYPAY":"https://api.dutypay.eu","VUE_APP_HOST_SSO":"https://sso.dutypay.eu","NODE_ENV":"production","VUE_APP_I18N_LOCALE":"en","VUE_APP_I18N_FALLBACK_LOCALE":"en-US","BASE_URL":""}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(384);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(5717);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


/***/ }),

/***/ 9150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QT": function() { return /* binding */ useI18n; }
});

// UNUSED EXPORTS: DatetimeFormat, I18nInjectionKey, NumberFormat, Translation, VERSION, castToVueI18n, createI18n, vTDirective

;// CONCATENATED MODULE: ./node_modules/@intlify/shared/dist/shared.esm-bundler.js
/* provided dependency */ var console = __webpack_require__(5108);
/*!
  * shared v9.2.0-beta.36
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */
const inBrowser = typeof window !== 'undefined';
let mark;
let measure;
if ((false)) {}
const RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */
function shared_esm_bundler_format(message, ...args) {
    if (args.length === 1 && shared_esm_bundler_isObject(args[0])) {
        args = args[0];
    }
    if (!args || !args.hasOwnProperty) {
        args = {};
    }
    return message.replace(RE_ARGS, (match, identifier) => {
        return args.hasOwnProperty(identifier) ? args[identifier] : '';
    });
}
const hasSymbol = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
const shared_esm_bundler_makeSymbol = (name) => hasSymbol ? Symbol(name) : name;
const generateFormatCacheKey = (locale, key, source) => friendlyJSONstringify({ l: locale, k: key, s: source });
const friendlyJSONstringify = (json) => JSON.stringify(json)
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
    .replace(/\u0027/g, '\\u0027');
const shared_esm_bundler_isNumber = (val) => typeof val === 'number' && isFinite(val);
const isDate = (val) => toTypeString(val) === '[object Date]';
const shared_esm_bundler_isRegExp = (val) => toTypeString(val) === '[object RegExp]';
const isEmptyObject = (val) => shared_esm_bundler_isPlainObject(val) && Object.keys(val).length === 0;
function shared_esm_bundler_warn(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */
        if (err) {
            console.warn(err.stack);
        }
    }
}
const shared_esm_bundler_assign = Object.assign;
let _globalThis;
const getGlobalThis = () => {
    // prettier-ignore
    return (_globalThis ||
        (_globalThis =
            typeof globalThis !== 'undefined'
                ? globalThis
                : typeof self !== 'undefined'
                    ? self
                    : typeof window !== 'undefined'
                        ? window
                        : typeof __webpack_require__.g !== 'undefined'
                            ? __webpack_require__.g
                            : {}));
};
function escapeHtml(rawText) {
    return rawText
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
const shared_esm_bundler_hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return shared_esm_bundler_hasOwnProperty.call(obj, key);
}
/* eslint-enable */
/**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */
const shared_esm_bundler_isArray = Array.isArray;
const shared_esm_bundler_isFunction = (val) => typeof val === 'function';
const shared_esm_bundler_isString = (val) => typeof val === 'string';
const shared_esm_bundler_isBoolean = (val) => typeof val === 'boolean';
const isSymbol = (val) => typeof val === 'symbol';
const shared_esm_bundler_isObject = (val) => // eslint-disable-line
 val !== null && typeof val === 'object';
const isPromise = (val) => {
    return shared_esm_bundler_isObject(val) && shared_esm_bundler_isFunction(val.then) && shared_esm_bundler_isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const shared_esm_bundler_isPlainObject = (val) => toTypeString(val) === '[object Object]';
// for converting list and named values to displayed strings.
const toDisplayString = (val) => {
    return val == null
        ? ''
        : shared_esm_bundler_isArray(val) || (shared_esm_bundler_isPlainObject(val) && val.toString === objectToString)
            ? JSON.stringify(val, null, 2)
            : String(val);
};
const RANGE = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for (let i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (let j = i - RANGE; j <= i + RANGE || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                }
                else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}

/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */
/**
 * Create a event emitter
 *
 * @returns An event emitter
 */
function createEmitter() {
    const events = new Map();
    const emitter = {
        events,
        on(event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) {
                events.set(event, [handler]);
            }
        },
        off(event, handler) {
            const handlers = events.get(event);
            if (handlers) {
                handlers.splice(handlers.indexOf(handler) >>> 0, 1);
            }
        },
        emit(event, payload) {
            (events.get(event) || [])
                .slice()
                .map(handler => handler(payload));
            (events.get('*') || [])
                .slice()
                .map(handler => handler(event, payload));
        }
    };
    return emitter;
}



;// CONCATENATED MODULE: ./node_modules/@intlify/message-compiler/dist/message-compiler.esm-bundler.js
/*!
  * message-compiler v9.2.0-beta.36
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */


const CompileErrorCodes = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 15
};
/** @internal */
const errorMessages = {
    // tokenizer error messages
    [CompileErrorCodes.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [CompileErrorCodes.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [CompileErrorCodes.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`
};
function createCompileError(code, loc, options = {}) {
    const { domain, messages, args } = options;
    const msg = ( false)
        ? 0
        : code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) {
        error.location = loc;
    }
    error.domain = domain;
    return error;
}
/** @internal */
function defaultOnError(error) {
    throw error;
}

const LocationStub = {
    start: { line: 1, column: 1, offset: 0 },
    end: { line: 1, column: 1, offset: 0 }
};
function createPosition(line, column, offset) {
    return { line, column, offset };
}
function createLocation(start, end, source) {
    const loc = { start, end };
    if (source != null) {
        loc.source = source;
    }
    return loc;
}

const CHAR_SP = ' ';
const CHAR_CR = '\r';
const CHAR_LF = '\n';
const CHAR_LS = String.fromCharCode(0x2028);
const CHAR_PS = String.fromCharCode(0x2029);
function createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index) => _buf[index] === CHAR_CR && _buf[index + 1] === CHAR_LF;
    const isLF = (index) => _buf[index] === CHAR_LF;
    const isPS = (index) => _buf[index] === CHAR_PS;
    const isLS = (index) => _buf[index] === CHAR_LS;
    const isLineEnd = (index) => isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = () => _index;
    const line = () => _line;
    const column = () => _column;
    const peekOffset = () => _peekOffset;
    const charAt = (offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? CHAR_LF : _buf[offset];
    const currentChar = () => charAt(_index);
    const currentPeek = () => charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) {
            _index++;
        }
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) {
            _peekOffset++;
        }
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while (target !== _index) {
            next();
        }
        _peekOffset = 0;
    }
    return {
        index,
        line,
        column,
        peekOffset,
        charAt,
        currentChar,
        currentPeek,
        next,
        peek,
        reset,
        resetPeek,
        skipToPeek
    };
}

const EOF = undefined;
const LITERAL_DELIMITER = "'";
const ERROR_DOMAIN$1 = 'tokenizer';
function createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = createScanner(source);
    const currentOffset = () => _scnr.index();
    const currentPosition = () => createPosition(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* EOF */,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* EOF */,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ''
    };
    const context = () => _context;
    const { onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = createLocation(ctx.startLoc, pos);
            const err = createCompileError(code, loc, {
                domain: ERROR_DOMAIN$1,
                args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = { type };
        if (location) {
            token.loc = createLocation(context.startLoc, context.endLoc);
        }
        if (value != null) {
            token.value = value;
        }
        return token;
    }
    const getEndToken = (context) => getToken(context, 14 /* EOF */);
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        }
        else {
            emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return '';
        }
    }
    function peekSpaces(scnr) {
        let buf = '';
        while (scnr.currentPeek() === CHAR_SP || scnr.currentPeek() === CHAR_LF) {
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            cc === 95 // _
        );
    }
    function isNumberStart(ch) {
        if (ch === EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === '-' ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 8 /* LinkedAlias */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* LinkedDot */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 9 /* LinkedDot */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType } = context;
        if (!(currentType === 8 /* LinkedAlias */ ||
            currentType === 12 /* LinkedModifier */)) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* LinkedDelimiter */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 10 /* LinkedDelimiter */) {
            return false;
        }
        const fn = () => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */) {
                return isIdentifierStart(scnr.peek());
            }
            else if (ch === "@" /* LinkedAlias */ ||
                ch === "%" /* Modulo */ ||
                ch === "|" /* Pipe */ ||
                ch === ":" /* LinkedDelimiter */ ||
                ch === "." /* LinkedDot */ ||
                ch === CHAR_SP ||
                !ch) {
                return false;
            }
            else if (ch === CHAR_LF) {
                scnr.peek();
                return fn();
            }
            else {
                // other characters
                return isIdentifierStart(ch);
            }
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* Pipe */;
        scnr.resetPeek();
        return ret;
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = '', detectModulo = false) => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */) {
                return prev === "%" /* Modulo */ ? false : hasSpace;
            }
            else if (ch === "@" /* LinkedAlias */ || !ch) {
                return prev === "%" /* Modulo */ ? true : hasSpace;
            }
            else if (ch === "%" /* Modulo */) {
                scnr.peek();
                return fn(hasSpace, "%" /* Modulo */, true);
            }
            else if (ch === "|" /* Pipe */) {
                return prev === "%" /* Modulo */ || detectModulo
                    ? true
                    : !(prev === CHAR_SP || prev === CHAR_LF);
            }
            else if (ch === CHAR_SP) {
                scnr.peek();
                return fn(true, CHAR_SP, detectModulo);
            }
            else if (ch === CHAR_LF) {
                scnr.peek();
                return fn(true, CHAR_LF, detectModulo);
            }
            else {
                return true;
            }
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === EOF) {
            return EOF;
        }
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function takeIdentifierChar(scnr) {
        const closure = (ch) => {
            const cc = ch.charCodeAt(0);
            return ((cc >= 97 && cc <= 122) || // a-z
                (cc >= 65 && cc <= 90) || // A-Z
                (cc >= 48 && cc <= 57) || // 0-9
                cc === 95 || // _
                cc === 36 // $
            );
        };
        return takeChar(scnr, closure);
    }
    function takeDigit(scnr) {
        const closure = (ch) => {
            const cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57; // 0-9
        };
        return takeChar(scnr, closure);
    }
    function takeHexDigit(scnr) {
        const closure = (ch) => {
            const cc = ch.charCodeAt(0);
            return ((cc >= 48 && cc <= 57) || // 0-9
                (cc >= 65 && cc <= 70) || // A-F
                (cc >= 97 && cc <= 102)); // a-f
        };
        return takeChar(scnr, closure);
    }
    function getDigits(scnr) {
        let ch = '';
        let num = '';
        while ((ch = takeDigit(scnr))) {
            num += ch;
        }
        return num;
    }
    function readText(scnr) {
        let buf = '';
        while (true) {
            const ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */ ||
                ch === "}" /* BraceRight */ ||
                ch === "@" /* LinkedAlias */ ||
                ch === "|" /* Pipe */ ||
                !ch) {
                break;
            }
            else if (ch === "%" /* Modulo */) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                }
                else {
                    break;
                }
            }
            else if (ch === CHAR_SP || ch === CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                }
                else if (isPluralStart(scnr)) {
                    break;
                }
                else {
                    buf += ch;
                    scnr.next();
                }
            }
            else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let name = '';
        while ((ch = takeIdentifierChar(scnr))) {
            name += ch;
        }
        if (scnr.currentChar() === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = '';
        if (scnr.currentChar() === '-') {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        }
        else {
            value += getDigits(scnr);
        }
        if (scnr.currentChar() === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return value;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        eat(scnr, `\'`);
        let ch = '';
        let literal = '';
        const fn = (x) => x !== LITERAL_DELIMITER && x !== CHAR_LF;
        while ((ch = takeChar(scnr, fn))) {
            if (ch === '\\') {
                literal += readEscapeSequence(scnr);
            }
            else {
                literal += ch;
            }
        }
        const current = scnr.currentChar();
        if (current === CHAR_LF || current === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === CHAR_LF) {
                scnr.next();
                eat(scnr, `\'`);
            }
            return literal;
        }
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch (ch) {
            case '\\':
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case 'u':
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case 'U':
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return '';
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = '';
        for (let i = 0; i < digits; i++) {
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let identifiers = '';
        const closure = (ch) => ch !== "{" /* BraceLeft */ &&
            ch !== "}" /* BraceRight */ &&
            ch !== CHAR_SP &&
            ch !== CHAR_LF;
        while ((ch = takeChar(scnr, closure))) {
            identifiers += ch;
        }
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = '';
        let name = '';
        while ((ch = takeIdentifierChar(scnr))) {
            name += ch;
        }
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (detect = false, buf) => {
            const ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */ ||
                ch === "%" /* Modulo */ ||
                ch === "@" /* LinkedAlias */ ||
                ch === "|" /* Pipe */ ||
                !ch) {
                return buf;
            }
            else if (ch === CHAR_SP) {
                return buf;
            }
            else if (ch === CHAR_LF) {
                buf += ch;
                scnr.next();
                return fn(detect, buf);
            }
            else {
                buf += ch;
                scnr.next();
                return fn(true, buf);
            }
        };
        return fn(false, '');
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* Pipe */);
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* BraceLeft */:
                if (context.braceNest >= 1) {
                    emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 2 /* BraceLeft */, "{" /* BraceLeft */);
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* BraceRight */:
                if (context.braceNest > 0 &&
                    context.currentType === 2 /* BraceLeft */) {
                    emitError(CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 3 /* BraceRight */, "}" /* BraceRight */);
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) {
                    context.inLinked = false;
                }
                return token;
            case "@" /* LinkedAlias */:
                if (context.braceNest > 0) {
                    emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                }
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                let validNamedIdentifier = true;
                let validListIdentifier = true;
                let validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) {
                        emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    }
                    token = getToken(context, 1 /* Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 &&
                    (context.currentType === 5 /* Named */ ||
                        context.currentType === 6 /* List */ ||
                        context.currentType === 7 /* Literal */)) {
                    emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if ((validNamedIdentifier = isNamedIdentifierStart(scnr, context))) {
                    token = getToken(context, 5 /* Named */, readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validListIdentifier = isListIdentifierStart(scnr, context))) {
                    token = getToken(context, 6 /* List */, readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validLiteral = isLiteralStart(scnr, context))) {
                    token = getToken(context, 7 /* Literal */, readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 13 /* InvalidPlace */, readInvalidIdentifier(scnr));
                    emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* LinkedAlias */ ||
            currentType === 9 /* LinkedDot */ ||
            currentType === 12 /* LinkedModifier */ ||
            currentType === 10 /* LinkedDelimiter */) &&
            (ch === CHAR_LF || ch === CHAR_SP)) {
            emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
        }
        switch (ch) {
            case "@" /* LinkedAlias */:
                scnr.next();
                token = getToken(context, 8 /* LinkedAlias */, "@" /* LinkedAlias */);
                context.inLinked = true;
                return token;
            case "." /* LinkedDot */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* LinkedDot */, "." /* LinkedDot */);
            case ":" /* LinkedDelimiter */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* LinkedDelimiter */, ":" /* LinkedDelimiter */);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) ||
                    isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* LinkedModifier */, readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* BraceLeft */) {
                        // scan the placeholder
                        return readTokenInPlaceholder(scnr, context) || token;
                    }
                    else {
                        return getToken(context, 11 /* LinkedKey */, readLinkedRefer(scnr));
                    }
                }
                if (currentType === 8 /* LinkedAlias */) {
                    emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
                }
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = { type: 14 /* EOF */ };
        if (context.braceNest > 0) {
            return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        }
        if (context.inLinked) {
            return readTokenInLinked(scnr, context) || getEndToken(context);
        }
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* BraceLeft */:
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* BraceRight */:
                emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* BraceRight */, "}" /* BraceRight */);
            case "@" /* LinkedAlias */:
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isTextStart(scnr)) {
                    return getToken(context, 0 /* Text */, readText(scnr));
                }
                if (ch === "%" /* Modulo */) {
                    scnr.next();
                    return getToken(context, 4 /* Modulo */, "%" /* Modulo */);
                }
                break;
        }
        return token;
    }
    function nextToken() {
        const { currentType, offset, startLoc, endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === EOF) {
            return getToken(_context, 14 /* EOF */);
        }
        return readToken(_scnr, _context);
    }
    return {
        nextToken,
        currentOffset,
        currentPosition,
        context
    };
}

const ERROR_DOMAIN = 'parser';
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(match, codePoint4, codePoint6) {
    switch (match) {
        case `\\\\`:
            return `\\`;
        case `\\\'`:
            return `\'`;
        default: {
            const codePoint = parseInt(codePoint4 || codePoint6, 16);
            if (codePoint <= 0xd7ff || codePoint >= 0xe000) {
                return String.fromCodePoint(codePoint);
            }
            // invalid ...
            // Replace them with U+FFFD REPLACEMENT CHARACTER.
            return '�';
        }
    }
}
function createParser(options = {}) {
    const location = options.location !== false;
    const { onError } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = createLocation(start, end);
            const err = createCompileError(code, loc, {
                domain: ERROR_DOMAIN,
                args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type,
            start: offset,
            end: offset
        };
        if (location) {
            node.loc = { start: loc, end: loc };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        node.end = offset;
        if (type) {
            node.type = type;
        }
        if (location && node.loc) {
            node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* Text */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* List */, offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* Named */, offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* Literal */, offset, loc);
        node.value = value.replace(KNOWN_ESCAPES, fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* LinkedModifier */, offset, loc);
        if (token.type !== 12 /* LinkedModifier */) {
            // empty modifier
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = '';
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node
            };
        }
        // check token
        if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        node.value = token.value || '';
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* LinkedKey */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* Linked */, context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* LinkedDot */) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* LinkedDelimiter */) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* BraceLeft */) {
            token = tokenizer.nextToken();
        }
        switch (token.type) {
            case 11 /* LinkedKey */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseLinkedKey(tokenizer, token.value || '');
                break;
            case 5 /* Named */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseNamed(tokenizer, token.value || '');
                break;
            case 6 /* List */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseList(tokenizer, token.value || '');
                break;
            case 7 /* Literal */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseLiteral(tokenizer, token.value || '');
                break;
            default:
                // empty key
                emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                const nextContext = tokenizer.context();
                const emptyLinkedKeyNode = startNode(7 /* LinkedKey */, nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = '';
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* Pipe */
            ? tokenizer.currentOffset()
            : context.offset;
        const startLoc = context.currentType === 1 /* Pipe */
            ? context.endLoc
            : context.startLoc;
        const node = startNode(2 /* Message */, startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch (token.type) {
                case 0 /* Text */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseText(tokenizer, token.value || ''));
                    break;
                case 6 /* List */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseList(tokenizer, token.value || ''));
                    break;
                case 5 /* Named */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseNamed(tokenizer, token.value || ''));
                    break;
                case 7 /* Literal */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseLiteral(tokenizer, token.value || ''));
                    break;
                case 8 /* LinkedAlias */:
                    const parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
            }
        } while (context.currentType !== 14 /* EOF */ &&
            context.currentType !== 1 /* Pipe */);
        // adjust message node loc
        const endOffset = context.currentType === 1 /* Pipe */
            ? context.lastOffset
            : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* Pipe */
            ? context.lastEndLoc
            : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* Plural */, offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) {
                hasEmptyMessage = msg.items.length === 0;
            }
            node.cases.push(msg);
        } while (context.currentType !== 14 /* EOF */);
        if (hasEmptyMessage) {
            emitError(tokenizer, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset, startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* EOF */) {
            return msgNode;
        }
        else {
            return parsePlural(tokenizer, offset, startLoc, msgNode);
        }
    }
    function parse(source) {
        const tokenizer = createTokenizer(source, shared_esm_bundler_assign({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* Resource */, context.offset, context.startLoc);
        if (location && node.loc) {
            node.loc.source = source;
        }
        node.body = parseResource(tokenizer);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* EOF */) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || '');
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return { parse };
}
function getTokenCaption(token) {
    if (token.type === 14 /* EOF */) {
        return 'EOF';
    }
    const name = (token.value || '').replace(/\r?\n/gu, '\\n');
    return name.length > 10 ? name.slice(0, 9) + '…' : name;
}

function createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast,
        helpers: new Set()
    };
    const context = () => _context;
    const helper = (name) => {
        _context.helpers.add(name);
        return name;
    };
    return { context, helper };
}
function traverseNodes(nodes, transformer) {
    for (let i = 0; i < nodes.length; i++) {
        traverseNode(nodes[i], transformer);
    }
}
function traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch (node.type) {
        case 1 /* Plural */:
            traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* PLURAL */);
            break;
        case 2 /* Message */:
            traverseNodes(node.items, transformer);
            break;
        case 6 /* Linked */:
            const linked = node;
            traverseNode(linked.key, transformer);
            transformer.helper("linked" /* LINKED */);
            transformer.helper("type" /* TYPE */);
            break;
        case 5 /* List */:
            transformer.helper("interpolate" /* INTERPOLATE */);
            transformer.helper("list" /* LIST */);
            break;
        case 4 /* Named */:
            transformer.helper("interpolate" /* INTERPOLATE */);
            transformer.helper("named" /* NAMED */);
            break;
    }
    // TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function transform(ast, options = {} // eslint-disable-line
) {
    const transformer = createTransformer(ast);
    transformer.helper("normalize" /* NORMALIZE */);
    // traverse
    ast.body && traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}

function createCodeGenerator(ast, options) {
    const { sourceMap, filename, breakLineCode, needIndent: _needIndent } = options;
    const _context = {
        source: ast.loc.source,
        filename,
        code: '',
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    const context = () => _context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : '';
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key) => `_${key}`;
    const needIndent = () => _context.needIndent;
    return {
        context,
        push,
        indent,
        deindent,
        newline,
        helper,
        needIndent
    };
}
function generateLinkedNode(generator, node) {
    const { helper } = generator;
    generator.push(`${helper("linked" /* LINKED */)}(`);
    generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        generateNode(generator, node.modifier);
        generator.push(`, _type`);
    }
    else {
        generator.push(`, undefined, _type`);
    }
    generator.push(`)`);
}
function generateMessageNode(generator, node) {
    const { helper, needIndent } = generator;
    generator.push(`${helper("normalize" /* NORMALIZE */)}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for (let i = 0; i < length; i++) {
        generateNode(generator, node.items[i]);
        if (i === length - 1) {
            break;
        }
        generator.push(', ');
    }
    generator.deindent(needIndent());
    generator.push('])');
}
function generatePluralNode(generator, node) {
    const { helper, needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* PLURAL */)}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for (let i = 0; i < length; i++) {
            generateNode(generator, node.cases[i]);
            if (i === length - 1) {
                break;
            }
            generator.push(', ');
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function generateResource(generator, node) {
    if (node.body) {
        generateNode(generator, node.body);
    }
    else {
        generator.push('null');
    }
}
function generateNode(generator, node) {
    const { helper } = generator;
    switch (node.type) {
        case 0 /* Resource */:
            generateResource(generator, node);
            break;
        case 1 /* Plural */:
            generatePluralNode(generator, node);
            break;
        case 2 /* Message */:
            generateMessageNode(generator, node);
            break;
        case 6 /* Linked */:
            generateLinkedNode(generator, node);
            break;
        case 8 /* LinkedModifier */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* LinkedKey */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* List */:
            generator.push(`${helper("interpolate" /* INTERPOLATE */)}(${helper("list" /* LIST */)}(${node.index}))`, node);
            break;
        case 4 /* Named */:
            generator.push(`${helper("interpolate" /* INTERPOLATE */)}(${helper("named" /* NAMED */)}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* Literal */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* Text */:
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
            if ((false)) {}
    }
}
// generate code from AST
const generate = (ast, options = {} // eslint-disable-line
) => {
    const mode = shared_esm_bundler_isString(options.mode) ? options.mode : 'normal';
    const filename = shared_esm_bundler_isString(options.filename)
        ? options.filename
        : 'message.intl';
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null
        ? options.breakLineCode
        : mode === 'arrow'
            ? ';'
            : '\n';
    const needIndent = options.needIndent ? options.needIndent : mode !== 'arrow';
    const helpers = ast.helpers || [];
    const generator = createCodeGenerator(ast, {
        mode,
        filename,
        sourceMap,
        breakLineCode,
        needIndent
    });
    generator.push(mode === 'normal' ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${helpers.map(s => `${s}: _${s}`).join(', ')} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    const { code, map } = generator.context();
    return {
        ast,
        code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};

function baseCompile(source, options = {}) {
    const assignedOptions = shared_esm_bundler_assign({}, options);
    // parse source codes
    const parser = createParser(assignedOptions);
    const ast = parser.parse(source);
    // transform ASTs
    transform(ast, assignedOptions);
    // generate javascript codes
    return generate(ast, assignedOptions);
}



;// CONCATENATED MODULE: ./node_modules/@intlify/devtools-if/dist/devtools-if.esm-bundler.js
/*!
  * devtools-if v9.2.0-beta.36
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const IntlifyDevToolsHooks =  {
    I18nInit: 'i18n:init',
    FunctionTranslate: 'function:translate'
};



;// CONCATENATED MODULE: ./node_modules/@intlify/core-base/dist/core-base.esm-bundler.js
/*!
  * core-base v9.2.0-beta.36
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */





const pathStateMachine =  [];
pathStateMachine[0 /* BEFORE_PATH */] = {
    ["w" /* WORKSPACE */]: [0 /* BEFORE_PATH */],
    ["i" /* IDENT */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["[" /* LEFT_BRACKET */]: [4 /* IN_SUB_PATH */],
    ["o" /* END_OF_FAIL */]: [7 /* AFTER_PATH */]
};
pathStateMachine[1 /* IN_PATH */] = {
    ["w" /* WORKSPACE */]: [1 /* IN_PATH */],
    ["." /* DOT */]: [2 /* BEFORE_IDENT */],
    ["[" /* LEFT_BRACKET */]: [4 /* IN_SUB_PATH */],
    ["o" /* END_OF_FAIL */]: [7 /* AFTER_PATH */]
};
pathStateMachine[2 /* BEFORE_IDENT */] = {
    ["w" /* WORKSPACE */]: [2 /* BEFORE_IDENT */],
    ["i" /* IDENT */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["0" /* ZERO */]: [3 /* IN_IDENT */, 0 /* APPEND */]
};
pathStateMachine[3 /* IN_IDENT */] = {
    ["i" /* IDENT */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["0" /* ZERO */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["w" /* WORKSPACE */]: [1 /* IN_PATH */, 1 /* PUSH */],
    ["." /* DOT */]: [2 /* BEFORE_IDENT */, 1 /* PUSH */],
    ["[" /* LEFT_BRACKET */]: [4 /* IN_SUB_PATH */, 1 /* PUSH */],
    ["o" /* END_OF_FAIL */]: [7 /* AFTER_PATH */, 1 /* PUSH */]
};
pathStateMachine[4 /* IN_SUB_PATH */] = {
    ["'" /* SINGLE_QUOTE */]: [5 /* IN_SINGLE_QUOTE */, 0 /* APPEND */],
    ["\"" /* DOUBLE_QUOTE */]: [6 /* IN_DOUBLE_QUOTE */, 0 /* APPEND */],
    ["[" /* LEFT_BRACKET */]: [
        4 /* IN_SUB_PATH */,
        2 /* INC_SUB_PATH_DEPTH */
    ],
    ["]" /* RIGHT_BRACKET */]: [1 /* IN_PATH */, 3 /* PUSH_SUB_PATH */],
    ["o" /* END_OF_FAIL */]: 8 /* ERROR */,
    ["l" /* ELSE */]: [4 /* IN_SUB_PATH */, 0 /* APPEND */]
};
pathStateMachine[5 /* IN_SINGLE_QUOTE */] = {
    ["'" /* SINGLE_QUOTE */]: [4 /* IN_SUB_PATH */, 0 /* APPEND */],
    ["o" /* END_OF_FAIL */]: 8 /* ERROR */,
    ["l" /* ELSE */]: [5 /* IN_SINGLE_QUOTE */, 0 /* APPEND */]
};
pathStateMachine[6 /* IN_DOUBLE_QUOTE */] = {
    ["\"" /* DOUBLE_QUOTE */]: [4 /* IN_SUB_PATH */, 0 /* APPEND */],
    ["o" /* END_OF_FAIL */]: 8 /* ERROR */,
    ["l" /* ELSE */]: [6 /* IN_DOUBLE_QUOTE */, 0 /* APPEND */]
};
/**
 * Check if an expression is a literal value.
 */
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
    return literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */
function stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */
function getPathCharType(ch) {
    if (ch === undefined || ch === null) {
        return "o" /* END_OF_FAIL */;
    }
    const code = ch.charCodeAt(0);
    switch (code) {
        case 0x5b: // [
        case 0x5d: // ]
        case 0x2e: // .
        case 0x22: // "
        case 0x27: // '
            return ch;
        case 0x5f: // _
        case 0x24: // $
        case 0x2d: // -
            return "i" /* IDENT */;
        case 0x09: // Tab (HT)
        case 0x0a: // Newline (LF)
        case 0x0d: // Return (CR)
        case 0xa0: // No-break space (NBSP)
        case 0xfeff: // Byte Order Mark (BOM)
        case 0x2028: // Line Separator (LS)
        case 0x2029: // Paragraph Separator (PS)
            return "w" /* WORKSPACE */;
    }
    return "i" /* IDENT */;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */
function formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(parseInt(path))) {
        return false;
    }
    return isLiteral(trimmed)
        ? stripQuotes(trimmed)
        : "*" /* ASTARISK */ + trimmed;
}
/**
 * Parse a string path into an array of segments
 */
function parse(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* BEFORE_PATH */;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* APPEND */] = () => {
        if (key === undefined) {
            key = newChar;
        }
        else {
            key += newChar;
        }
    };
    actions[1 /* PUSH */] = () => {
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* INC_SUB_PATH_DEPTH */] = () => {
        actions[0 /* APPEND */]();
        subPathDepth++;
    };
    actions[3 /* PUSH_SUB_PATH */] = () => {
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* IN_SUB_PATH */;
            actions[0 /* APPEND */]();
        }
        else {
            subPathDepth = 0;
            if (key === undefined) {
                return false;
            }
            key = formatSubPath(key);
            if (key === false) {
                return false;
            }
            else {
                actions[1 /* PUSH */]();
            }
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if ((mode === 5 /* IN_SINGLE_QUOTE */ &&
            nextChar === "'" /* SINGLE_QUOTE */) ||
            (mode === 6 /* IN_DOUBLE_QUOTE */ &&
                nextChar === "\"" /* DOUBLE_QUOTE */)) {
            index++;
            newChar = '\\' + nextChar;
            actions[0 /* APPEND */]();
            return true;
        }
    }
    while (mode !== null) {
        index++;
        c = path[index];
        if (c === '\\' && maybeUnescapeQuote()) {
            continue;
        }
        type = getPathCharType(c);
        typeMap = pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* ELSE */] || 8 /* ERROR */;
        // check parse error
        if (transition === 8 /* ERROR */) {
            return;
        }
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) {
                    return;
                }
            }
        }
        // check parse finish
        if (mode === 7 /* AFTER_PATH */) {
            return keys;
        }
    }
}
// path token cache
const cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function resolveWithKeyValue(obj, path) {
    return shared_esm_bundler_isObject(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function resolveValue(obj, path) {
    // check object
    if (!shared_esm_bundler_isObject(obj)) {
        return null;
    }
    // parse path
    let hit = cache.get(path);
    if (!hit) {
        hit = parse(path);
        if (hit) {
            cache.set(path, hit);
        }
    }
    // check hit
    if (!hit) {
        return null;
    }
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while (i < len) {
        const val = last[hit[i]];
        if (val === undefined) {
            return null;
        }
        last = val;
        i++;
    }
    return last;
}

const DEFAULT_MODIFIER = (str) => str;
const DEFAULT_MESSAGE = (ctx) => ''; // eslint-disable-line
const DEFAULT_MESSAGE_DATA_TYPE = 'text';
const DEFAULT_NORMALIZE = (values) => values.length === 0 ? '' : values.join('');
const DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) {
        // prettier-ignore
        return choice
            ? choice > 1
                ? 1
                : 0
            : 1;
    }
    return choice ? Math.min(choice, 2) : 0;
}
function getPluralIndex(options) {
    // prettier-ignore
    const index = shared_esm_bundler_isNumber(options.pluralIndex)
        ? options.pluralIndex
        : -1;
    // prettier-ignore
    return options.named && (shared_esm_bundler_isNumber(options.named.count) || shared_esm_bundler_isNumber(options.named.n))
        ? shared_esm_bundler_isNumber(options.named.count)
            ? options.named.count
            : shared_esm_bundler_isNumber(options.named.n)
                ? options.named.n
                : index
        : index;
}
function normalizeNamed(pluralIndex, props) {
    if (!props.count) {
        props.count = pluralIndex;
    }
    if (!props.n) {
        props.n = pluralIndex;
    }
}
function createMessageContext(options = {}) {
    const locale = options.locale;
    const pluralIndex = getPluralIndex(options);
    const pluralRule = shared_esm_bundler_isObject(options.pluralRules) &&
        shared_esm_bundler_isString(locale) &&
        shared_esm_bundler_isFunction(options.pluralRules[locale])
        ? options.pluralRules[locale]
        : pluralDefault;
    const orgPluralRule = shared_esm_bundler_isObject(options.pluralRules) &&
        shared_esm_bundler_isString(locale) &&
        shared_esm_bundler_isFunction(options.pluralRules[locale])
        ? pluralDefault
        : undefined;
    const plural = (messages) => {
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index) => _list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || {};
    shared_esm_bundler_isNumber(options.pluralIndex) && normalizeNamed(pluralIndex, _named);
    const named = (key) => _named[key];
    function message(key) {
        // prettier-ignore
        const msg = shared_esm_bundler_isFunction(options.messages)
            ? options.messages(key)
            : shared_esm_bundler_isObject(options.messages)
                ? options.messages[key]
                : false;
        return !msg
            ? options.parent
                ? options.parent.message(key) // resolve from parent messages
                : DEFAULT_MESSAGE
            : msg;
    }
    const _modifier = (name) => options.modifiers
        ? options.modifiers[name]
        : DEFAULT_MODIFIER;
    const normalize = shared_esm_bundler_isPlainObject(options.processor) && shared_esm_bundler_isFunction(options.processor.normalize)
        ? options.processor.normalize
        : DEFAULT_NORMALIZE;
    const interpolate = shared_esm_bundler_isPlainObject(options.processor) &&
        shared_esm_bundler_isFunction(options.processor.interpolate)
        ? options.processor.interpolate
        : DEFAULT_INTERPOLATE;
    const type = shared_esm_bundler_isPlainObject(options.processor) && shared_esm_bundler_isString(options.processor.type)
        ? options.processor.type
        : DEFAULT_MESSAGE_DATA_TYPE;
    const linked = (key, ...args) => {
        const [arg1, arg2] = args;
        let type = 'text';
        let modifier = '';
        if (args.length === 1) {
            if (shared_esm_bundler_isObject(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            }
            else if (shared_esm_bundler_isString(arg1)) {
                modifier = arg1 || modifier;
            }
        }
        else if (args.length === 2) {
            if (shared_esm_bundler_isString(arg1)) {
                modifier = arg1 || modifier;
            }
            if (shared_esm_bundler_isString(arg2)) {
                type = arg2 || type;
            }
        }
        let msg = message(key)(ctx);
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        if (type === 'vnode' && shared_esm_bundler_isArray(msg) && modifier) {
            msg = msg[0];
        }
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* LIST */]: list,
        ["named" /* NAMED */]: named,
        ["plural" /* PLURAL */]: plural,
        ["linked" /* LINKED */]: linked,
        ["message" /* MESSAGE */]: message,
        ["type" /* TYPE */]: type,
        ["interpolate" /* INTERPOLATE */]: interpolate,
        ["normalize" /* NORMALIZE */]: normalize
    };
    return ctx;
}

let devtools = null;
function setDevToolsHook(hook) {
    devtools = hook;
}
function getDevToolsHook() {
    return devtools;
}
function initI18nDevTools(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    devtools &&
        devtools.emit(IntlifyDevToolsHooks.I18nInit, {
            timestamp: Date.now(),
            i18n,
            version,
            meta
        });
}
const translateDevTools = /* #__PURE__*/ createDevToolsHook(IntlifyDevToolsHooks.FunctionTranslate);
function createDevToolsHook(hook) {
    return (payloads) => devtools && devtools.emit(hook, payloads);
}

const CoreWarnCodes = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    __EXTEND_POINT__: 7
};
/** @internal */
const warnMessages = {
    [CoreWarnCodes.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [CoreWarnCodes.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [CoreWarnCodes.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [CoreWarnCodes.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [CoreWarnCodes.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`
};
function getWarnMessage(code, ...args) {
    return format(warnMessages[code], ...args);
}

/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */
function fallbackWithSimple(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [...new Set([
            start,
            ...(shared_esm_bundler_isArray(fallback)
                ? fallback
                : shared_esm_bundler_isObject(fallback)
                    ? Object.keys(fallback)
                    : shared_esm_bundler_isString(fallback)
                        ? [fallback]
                        : [start])
        ])];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */
function fallbackWithLocaleChain(ctx, fallback, start) {
    const startLocale = shared_esm_bundler_isString(start) ? start : core_base_esm_bundler_DEFAULT_LOCALE;
    const context = ctx;
    if (!context.__localeChainCache) {
        context.__localeChainCache = new Map();
    }
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [start];
        // while any intervening block found
        while (shared_esm_bundler_isArray(block)) {
            block = appendBlockToChain(chain, block, fallback);
        }
        // prettier-ignore
        // last block defined by default
        const defaults = shared_esm_bundler_isArray(fallback) || !shared_esm_bundler_isPlainObject(fallback)
            ? fallback
            : fallback['default']
                ? fallback['default']
                : null;
        // convert defaults to array
        block = shared_esm_bundler_isString(defaults) ? [defaults] : defaults;
        if (shared_esm_bundler_isArray(block)) {
            appendBlockToChain(chain, block, false);
        }
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for (let i = 0; i < block.length && shared_esm_bundler_isBoolean(follow); i++) {
        const locale = block[i];
        if (shared_esm_bundler_isString(locale)) {
            follow = appendLocaleToChain(chain, block[i], blocks);
        }
    }
    return follow;
}
function appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split('-');
    do {
        const target = tokens.join('-');
        follow = appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    } while (tokens.length && follow === true);
    return follow;
}
function appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== '!';
            const locale = target.replace(/!/g, '');
            chain.push(locale);
            if ((shared_esm_bundler_isArray(blocks) || shared_esm_bundler_isPlainObject(blocks)) &&
                blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                follow = blocks[locale];
            }
        }
    }
    return follow;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Intlify core-base version
 * @internal
 */
const VERSION = '9.2.0-beta.36';
const NOT_REOSLVED = -1;
const core_base_esm_bundler_DEFAULT_LOCALE = 'en-US';
const MISSING_RESOLVE_VALUE = '';
const capitalize = (str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function getDefaultLinkedModifiers() {
    return {
        upper: (val, type) => {
            // prettier-ignore
            return type === 'text' && shared_esm_bundler_isString(val)
                ? val.toUpperCase()
                : type === 'vnode' && shared_esm_bundler_isObject(val) && '__v_isVNode' in val
                    ? val.children.toUpperCase()
                    : val;
        },
        lower: (val, type) => {
            // prettier-ignore
            return type === 'text' && shared_esm_bundler_isString(val)
                ? val.toLowerCase()
                : type === 'vnode' && shared_esm_bundler_isObject(val) && '__v_isVNode' in val
                    ? val.children.toLowerCase()
                    : val;
        },
        capitalize: (val, type) => {
            // prettier-ignore
            return (type === 'text' && shared_esm_bundler_isString(val)
                ? capitalize(val)
                : type === 'vnode' && shared_esm_bundler_isObject(val) && '__v_isVNode' in val
                    ? capitalize(val.children)
                    : val);
        }
    };
}
let _compiler;
function registerMessageCompiler(compiler) {
    _compiler = compiler;
}
let _resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */
function registerMessageResolver(resolver) {
    _resolver = resolver;
}
let _fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */
function registerLocaleFallbacker(fallbacker) {
    _fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let _additionalMeta = null;
const setAdditionalMeta =  (meta) => {
    _additionalMeta = meta;
};
const getAdditionalMeta =  () => _additionalMeta;
let _fallbackContext = null;
const setFallbackContext = (context) => {
    _fallbackContext = context;
};
const getFallbackContext = () => _fallbackContext;
// ID for CoreContext
let _cid = 0;
function createCoreContext(options = {}) {
    // setup options
    const version = shared_esm_bundler_isString(options.version) ? options.version : VERSION;
    const locale = shared_esm_bundler_isString(options.locale) ? options.locale : core_base_esm_bundler_DEFAULT_LOCALE;
    const fallbackLocale = shared_esm_bundler_isArray(options.fallbackLocale) ||
        shared_esm_bundler_isPlainObject(options.fallbackLocale) ||
        shared_esm_bundler_isString(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : locale;
    const messages = shared_esm_bundler_isPlainObject(options.messages)
        ? options.messages
        : { [locale]: {} };
    const datetimeFormats = shared_esm_bundler_isPlainObject(options.datetimeFormats)
            ? options.datetimeFormats
            : { [locale]: {} }
        ;
    const numberFormats = shared_esm_bundler_isPlainObject(options.numberFormats)
            ? options.numberFormats
            : { [locale]: {} }
        ;
    const modifiers = shared_esm_bundler_assign({}, options.modifiers || {}, getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || {};
    const missing = shared_esm_bundler_isFunction(options.missing) ? options.missing : null;
    const missingWarn = shared_esm_bundler_isBoolean(options.missingWarn) || shared_esm_bundler_isRegExp(options.missingWarn)
        ? options.missingWarn
        : true;
    const fallbackWarn = shared_esm_bundler_isBoolean(options.fallbackWarn) || shared_esm_bundler_isRegExp(options.fallbackWarn)
        ? options.fallbackWarn
        : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = shared_esm_bundler_isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    const processor = shared_esm_bundler_isPlainObject(options.processor) ? options.processor : null;
    const warnHtmlMessage = shared_esm_bundler_isBoolean(options.warnHtmlMessage)
        ? options.warnHtmlMessage
        : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = shared_esm_bundler_isFunction(options.messageCompiler)
        ? options.messageCompiler
        : _compiler;
    const messageResolver = shared_esm_bundler_isFunction(options.messageResolver)
        ? options.messageResolver
        : _resolver || resolveWithKeyValue;
    const localeFallbacker = shared_esm_bundler_isFunction(options.localeFallbacker)
        ? options.localeFallbacker
        : _fallbacker || fallbackWithSimple;
    const fallbackContext = shared_esm_bundler_isObject(options.fallbackContext)
        ? options.fallbackContext
        : undefined;
    const onWarn = shared_esm_bundler_isFunction(options.onWarn) ? options.onWarn : shared_esm_bundler_warn;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = shared_esm_bundler_isObject(internalOptions.__datetimeFormatters)
            ? internalOptions.__datetimeFormatters
            : new Map()
        ;
    const __numberFormatters = shared_esm_bundler_isObject(internalOptions.__numberFormatters)
            ? internalOptions.__numberFormatters
            : new Map()
        ;
    const __meta = shared_esm_bundler_isObject(internalOptions.__meta) ? internalOptions.__meta : {};
    _cid++;
    const context = {
        version,
        cid: _cid,
        locale,
        fallbackLocale,
        messages,
        modifiers,
        pluralRules,
        missing,
        missingWarn,
        fallbackWarn,
        fallbackFormat,
        unresolving,
        postTranslation,
        processor,
        warnHtmlMessage,
        escapeParameter,
        messageCompiler,
        messageResolver,
        localeFallbacker,
        fallbackContext,
        onWarn,
        __meta
    };
    {
        context.datetimeFormats = datetimeFormats;
        context.numberFormats = numberFormats;
        context.__datetimeFormatters = __datetimeFormatters;
        context.__numberFormatters = __numberFormatters;
    }
    // for vue-devtools timeline event
    if ((false)) {}
    // NOTE: experimental !!
    if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
        initI18nDevTools(context, version, __meta);
    }
    return context;
}
/** @internal */
function isTranslateFallbackWarn(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */
function isTranslateMissingWarn(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */
function handleMissing(context, key, locale, missingWarn, type) {
    const { missing, onWarn } = context;
    // for vue-devtools timeline event
    if ((false)) {}
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return shared_esm_bundler_isString(ret) ? ret : key;
    }
    else {
        if (false) {}
        return key;
    }
}
/** @internal */
function updateFallbackLocale(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const WARN_MESSAGE = (/* unused pure expression or super */ null && (`Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`));
function checkHtmlMessage(source, options) {
    const warnHtmlMessage = isBoolean(options.warnHtmlMessage)
        ? options.warnHtmlMessage
        : true;
    if (warnHtmlMessage && RE_HTML_TAG.test(source)) {
        warn(format(WARN_MESSAGE, { source }));
    }
}
const defaultOnCacheKey = (source) => source;
let compileCache = Object.create(null);
function clearCompileCache() {
    compileCache = Object.create(null);
}
function compileToFunction(source, options = {}) {
    {
        // check HTML message
        ( false) && 0;
        // check caches
        const onCacheKey = options.onCacheKey || defaultOnCacheKey;
        const key = onCacheKey(source);
        const cached = compileCache[key];
        if (cached) {
            return cached;
        }
        // compile error detecting
        let occurred = false;
        const onError = options.onError || defaultOnError;
        options.onError = (err) => {
            occurred = true;
            onError(err);
        };
        // compile
        const { code } = baseCompile(source, options);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !occurred ? (compileCache[key] = msg) : msg;
    }
}

let code = CompileErrorCodes.__EXTEND_POINT__;
const inc = () => ++code;
const CoreErrorCodes = {
    INVALID_ARGUMENT: code,
    INVALID_DATE_ARGUMENT: inc(),
    INVALID_ISO_DATE_ARGUMENT: inc(),
    __EXTEND_POINT__: inc() // 18
};
function createCoreError(code) {
    return createCompileError(code, null, ( false) ? 0 : undefined);
}
/** @internal */
const core_base_esm_bundler_errorMessages = {
    [CoreErrorCodes.INVALID_ARGUMENT]: 'Invalid arguments',
    [CoreErrorCodes.INVALID_DATE_ARGUMENT]: 'The date provided is an invalid Date object.' +
        'Make sure your Date represents a valid date.',
    [CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT]: 'The argument provided is not a valid ISO date string'
};

const NOOP_MESSAGE_FUNCTION = () => '';
const isMessageFunction = (val) => shared_esm_bundler_isFunction(val);
// implementation of `translate` function
function translate(context, ...args) {
    const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context;
    const [key, options] = parseTranslateArgs(...args);
    const missingWarn = shared_esm_bundler_isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = shared_esm_bundler_isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const escapeParameter = shared_esm_bundler_isBoolean(options.escapeParameter)
        ? options.escapeParameter
        : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = shared_esm_bundler_isString(options.default) || shared_esm_bundler_isBoolean(options.default) // default by function option
        ? !shared_esm_bundler_isBoolean(options.default)
            ? options.default
            : (!messageCompiler ? () => key : key)
        : fallbackFormat // default by `fallbackFormat` option
            ? (!messageCompiler ? () => key : key)
            : '';
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== '';
    const locale = shared_esm_bundler_isString(options.locale) ? options.locale : context.locale;
    // escape params
    escapeParameter && escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage
        ? resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn)
        : [
            key,
            locale,
            messages[locale] || {}
        ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage &&
        !(shared_esm_bundler_isString(format) || isMessageFunction(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage &&
        (!(shared_esm_bundler_isString(format) || isMessageFunction(format)) ||
            !shared_esm_bundler_isString(targetLocale))) {
        return unresolving ? NOT_REOSLVED : key;
    }
    if (false) {}
    // setup compile error detecting
    let occurred = false;
    const errorDetector = () => {
        occurred = true;
    };
    // compile message format
    const msg = !isMessageFunction(format)
        ? compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector)
        : format;
    // if occurred compile error, return the message format
    if (occurred) {
        return format;
    }
    // evaluate message with context
    const ctxOptions = getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = createMessageContext(ctxOptions);
    const messaged = evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation ? postTranslation(messaged) : messaged;
    // NOTE: experimental !!
    if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: shared_esm_bundler_isString(key)
                ? key
                : isMessageFunction(format)
                    ? format.key
                    : '',
            locale: targetLocale || (isMessageFunction(format)
                ? format.locale
                : ''),
            format: shared_esm_bundler_isString(format)
                ? format
                : isMessageFunction(format)
                    ? format.source
                    : '',
            message: ret
        };
        payloads.meta = shared_esm_bundler_assign({}, context.__meta, getAdditionalMeta() || {});
        translateDevTools(payloads);
    }
    return ret;
}
function escapeParams(options) {
    if (shared_esm_bundler_isArray(options.list)) {
        options.list = options.list.map(item => shared_esm_bundler_isString(item) ? escapeHtml(item) : item);
    }
    else if (shared_esm_bundler_isObject(options.named)) {
        Object.keys(options.named).forEach(key => {
            if (shared_esm_bundler_isString(options.named[key])) {
                options.named[key] = escapeHtml(options.named[key]);
            }
        });
    }
}
function resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages, onWarn, messageResolver: resolveValue, localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'translate';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if (false) {}
        // for vue-devtools timeline event
        if (false) {}
        message =
            messages[targetLocale] || {};
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if (false) {}
        if ((format = resolveValue(message, key)) === null) {
            // if null, resolve with object key path
            format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        }
        // for vue-devtools timeline event
        if (false) {}
        if (shared_esm_bundler_isString(format) || shared_esm_bundler_isFunction(format))
            break;
        const missingRet = handleMissing(context, // eslint-disable-line @typescript-eslint/no-explicit-any
        key, targetLocale, missingWarn, type);
        if (missingRet !== key) {
            format = missingRet;
        }
        from = to;
    }
    return [format, targetLocale, message];
}
function compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) {
    const { messageCompiler, warnHtmlMessage } = context;
    if (isMessageFunction(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = (() => format);
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if (false) {}
    const msg = messageCompiler(format, getCompileOptions(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, errorDetector));
    // for vue-devtools timeline event
    if (false) {}
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if (false) {}
    const messaged = msg(msgCtx);
    // for vue-devtools timeline event
    if (false) {}
    return messaged;
}
/** @internal */
function parseTranslateArgs(...args) {
    const [arg1, arg2, arg3] = args;
    const options = {};
    if (!shared_esm_bundler_isString(arg1) && !shared_esm_bundler_isNumber(arg1) && !isMessageFunction(arg1)) {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    // prettier-ignore
    const key = shared_esm_bundler_isNumber(arg1)
        ? String(arg1)
        : isMessageFunction(arg1)
            ? arg1
            : arg1;
    if (shared_esm_bundler_isNumber(arg2)) {
        options.plural = arg2;
    }
    else if (shared_esm_bundler_isString(arg2)) {
        options.default = arg2;
    }
    else if (shared_esm_bundler_isPlainObject(arg2) && !isEmptyObject(arg2)) {
        options.named = arg2;
    }
    else if (shared_esm_bundler_isArray(arg2)) {
        options.list = arg2;
    }
    if (shared_esm_bundler_isNumber(arg3)) {
        options.plural = arg3;
    }
    else if (shared_esm_bundler_isString(arg3)) {
        options.default = arg3;
    }
    else if (shared_esm_bundler_isPlainObject(arg3)) {
        shared_esm_bundler_assign(options, arg3);
    }
    return [key, options];
}
function getCompileOptions(context, locale, key, source, warnHtmlMessage, errorDetector) {
    return {
        warnHtmlMessage,
        onError: (err) => {
            errorDetector && errorDetector(err);
            if ((false)) {}
            else {
                throw err;
            }
        },
        onCacheKey: (source) => generateFormatCacheKey(locale, key, source)
    };
}
function getMessageContextOptions(context, locale, message, options) {
    const { modifiers, pluralRules, messageResolver: resolveValue, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context;
    const resolveMessage = (key) => {
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if (shared_esm_bundler_isString(val)) {
            let occurred = false;
            const errorDetector = () => {
                occurred = true;
            };
            const msg = compileMessageFormat(context, key, locale, val, key, errorDetector);
            return !occurred
                ? msg
                : NOOP_MESSAGE_FUNCTION;
        }
        else if (isMessageFunction(val)) {
            return val;
        }
        else {
            // TODO: should be implemented warning message
            return NOOP_MESSAGE_FUNCTION;
        }
    };
    const ctxOptions = {
        locale,
        modifiers,
        pluralRules,
        messages: resolveMessage
    };
    if (context.processor) {
        ctxOptions.processor = context.processor;
    }
    if (options.list) {
        ctxOptions.list = options.list;
    }
    if (options.named) {
        ctxOptions.named = options.named;
    }
    if (shared_esm_bundler_isNumber(options.plural)) {
        ctxOptions.pluralIndex = options.plural;
    }
    return ctxOptions;
}

const intlDefined = typeof Intl !== 'undefined';
const Availabilities = {
    dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
    numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
};

// implementation of `datetime` function
function datetime(context, ...args) {
    const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __datetimeFormatters } = context;
    if (false) {}
    const [key, value, options, overrides] = parseDateTimeArgs(...args);
    const missingWarn = shared_esm_bundler_isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = shared_esm_bundler_isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = shared_esm_bundler_isString(options.locale) ? options.locale : context.locale;
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!shared_esm_bundler_isString(key) || key === '') {
        return new Intl.DateTimeFormat(locale).format(value);
    }
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'datetime format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if (false) {}
        // for vue-devtools timeline event
        if (false) {}
        datetimeFormat =
            datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if (shared_esm_bundler_isPlainObject(format))
            break;
        handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!shared_esm_bundler_isPlainObject(format) || !shared_esm_bundler_isString(targetLocale)) {
        return unresolving ? NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, shared_esm_bundler_assign({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
const DATETIME_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'formatMatcher',
    'hour12',
    'timeZone',
    'dateStyle',
    'timeStyle',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'hourCycle',
    'fractionalSecondDigits'
];
/** @internal */
function parseDateTimeArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    let value;
    if (shared_esm_bundler_isString(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) {
            throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3]
            ? matches[3].trim().startsWith('T')
                ? `${matches[1].trim()}${matches[3].trim()}`
                : `${matches[1].trim()}T${matches[3].trim()}`
            : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        }
        catch (e) {
            throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
    }
    else if (isDate(arg1)) {
        if (isNaN(arg1.getTime())) {
            throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
        }
        value = arg1;
    }
    else if (shared_esm_bundler_isNumber(arg1)) {
        value = arg1;
    }
    else {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    if (shared_esm_bundler_isString(arg2)) {
        options.key = arg2;
    }
    else if (shared_esm_bundler_isPlainObject(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (DATETIME_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (shared_esm_bundler_isString(arg3)) {
        options.locale = arg3;
    }
    else if (shared_esm_bundler_isPlainObject(arg3)) {
        overrides = arg3;
    }
    if (shared_esm_bundler_isPlainObject(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function clearDateTimeFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) {
            continue;
        }
        context.__datetimeFormatters.delete(id);
    }
}

// implementation of `number` function
function number(context, ...args) {
    const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __numberFormatters } = context;
    if (false) {}
    const [key, value, options, overrides] = parseNumberArgs(...args);
    const missingWarn = shared_esm_bundler_isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = shared_esm_bundler_isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = shared_esm_bundler_isString(options.locale) ? options.locale : context.locale;
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!shared_esm_bundler_isString(key) || key === '') {
        return new Intl.NumberFormat(locale).format(value);
    }
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'number format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if (false) {}
        // for vue-devtools timeline event
        if (false) {}
        numberFormat =
            numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if (shared_esm_bundler_isPlainObject(format))
            break;
        handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!shared_esm_bundler_isPlainObject(format) || !shared_esm_bundler_isString(targetLocale)) {
        return unresolving ? NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, shared_esm_bundler_assign({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
const NUMBER_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'currencySign',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'compactDisplay',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay'
];
/** @internal */
function parseNumberArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    if (!shared_esm_bundler_isNumber(arg1)) {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    const value = arg1;
    if (shared_esm_bundler_isString(arg2)) {
        options.key = arg2;
    }
    else if (shared_esm_bundler_isPlainObject(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (NUMBER_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (shared_esm_bundler_isString(arg3)) {
        options.locale = arg3;
    }
    else if (shared_esm_bundler_isPlainObject(arg3)) {
        overrides = arg3;
    }
    if (shared_esm_bundler_isPlainObject(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function clearNumberFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) {
            continue;
        }
        context.__numberFormatters.delete(id);
    }
}

// TODO: we could not exports for Node native ES Moudles yet...
{
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
}



// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js
/* provided dependency */ var vue_i18n_esm_bundler_console = __webpack_require__(5108);
/*!
  * vue-i18n v9.2.0-beta.36
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */






/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */
const vue_i18n_esm_bundler_VERSION = '9.2.0-beta.36';
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function initFeatureFlags() {
    let needWarn = false;
    if (false) {}
    if (false) {}
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
    if (false) {}
}

let code$1 = CoreWarnCodes.__EXTEND_POINT__;
const inc$1 = () => ++code$1;
const I18nWarnCodes = {
    FALLBACK_TO_ROOT: code$1,
    NOT_SUPPORTED_PRESERVE: inc$1(),
    NOT_SUPPORTED_FORMATTER: inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: inc$1(),
    NOT_FOUND_PARENT_SCOPE: inc$1() // 13
};
const vue_i18n_esm_bundler_warnMessages = {
    [I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`
};
function vue_i18n_esm_bundler_getWarnMessage(code, ...args) {
    return format(vue_i18n_esm_bundler_warnMessages[code], ...args);
}

let vue_i18n_esm_bundler_code = CompileErrorCodes.__EXTEND_POINT__;
const vue_i18n_esm_bundler_inc = () => ++vue_i18n_esm_bundler_code;
const I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: vue_i18n_esm_bundler_code,
    // legacy module errors
    INVALID_ARGUMENT: vue_i18n_esm_bundler_inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: vue_i18n_esm_bundler_inc(),
    NOT_INSLALLED: vue_i18n_esm_bundler_inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: vue_i18n_esm_bundler_inc(),
    // directive module errors
    REQUIRED_VALUE: vue_i18n_esm_bundler_inc(),
    INVALID_VALUE: vue_i18n_esm_bundler_inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: vue_i18n_esm_bundler_inc(),
    NOT_INSLALLED_WITH_PROVIDE: vue_i18n_esm_bundler_inc(),
    // unexpected error
    UNEXPECTED_ERROR: vue_i18n_esm_bundler_inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: vue_i18n_esm_bundler_inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: vue_i18n_esm_bundler_inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: vue_i18n_esm_bundler_inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: vue_i18n_esm_bundler_inc(),
    // for enhancement
    __EXTEND_POINT__: vue_i18n_esm_bundler_inc() // 29
};
function createI18nError(code, ...args) {
    return createCompileError(code, null, ( false) ? 0 : undefined);
}
const vue_i18n_esm_bundler_errorMessages = {
    [I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: 'Unexpected return type in composer',
    [I18nErrorCodes.INVALID_ARGUMENT]: 'Invalid argument',
    [I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: 'Must be called at the top of a `setup` function',
    [I18nErrorCodes.NOT_INSLALLED]: 'Need to install with `app.use` function',
    [I18nErrorCodes.UNEXPECTED_ERROR]: 'Unexpected error',
    [I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: 'Not available in legacy mode',
    [I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE]: 'Need to install with `provide` function',
    [I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: 'Not compatible legacy VueI18n.',
    [I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: 'vue-i18n-bridge support Vue 2.x only',
    [I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: 'Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode',
    [I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: 'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly'
};

const TransrateVNodeSymbol = 
/* #__PURE__*/ shared_esm_bundler_makeSymbol('__transrateVNode');
const DatetimePartsSymbol = /* #__PURE__*/ shared_esm_bundler_makeSymbol('__datetimeParts');
const NumberPartsSymbol = /* #__PURE__*/ shared_esm_bundler_makeSymbol('__numberParts');
const EnableEmitter = /* #__PURE__*/ (/* unused pure expression or super */ null && (makeSymbol('__enableEmitter')));
const DisableEmitter = /* #__PURE__*/ (/* unused pure expression or super */ null && (makeSymbol('__disableEmitter')));
const SetPluralRulesSymbol = shared_esm_bundler_makeSymbol('__setPluralRules');
shared_esm_bundler_makeSymbol('__intlifyMeta');
const InejctWithOption = /* #__PURE__*/ shared_esm_bundler_makeSymbol('__injectWithOption');
const __VUE_I18N_BRIDGE__ =  '__VUE_I18N_BRIDGE__';

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Transform flat json in obj to normal json in obj
 */
function handleFlatJson(obj) {
    // check obj
    if (!shared_esm_bundler_isObject(obj)) {
        return obj;
    }
    for (const key in obj) {
        // check key
        if (!hasOwn(obj, key)) {
            continue;
        }
        // handle for normal json
        if (!key.includes('.')) {
            // recursive process value if value is also a object
            if (shared_esm_bundler_isObject(obj[key])) {
                handleFlatJson(obj[key]);
            }
        }
        // handle for flat json, transform to normal json
        else {
            // go to the last object
            const subKeys = key.split('.');
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            for (let i = 0; i < lastIndex; i++) {
                if (!(subKeys[i] in currentObj)) {
                    currentObj[subKeys[i]] = {};
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            currentObj[subKeys[lastIndex]] = obj[key];
            delete obj[key];
            // recursive process value if value is also a object
            if (shared_esm_bundler_isObject(currentObj[subKeys[lastIndex]])) {
                handleFlatJson(currentObj[subKeys[lastIndex]]);
            }
        }
    }
    return obj;
}
function getLocaleMessages(locale, options) {
    const { messages, __i18n, messageResolver, flatJson } = options;
    // prettier-ignore
    const ret = shared_esm_bundler_isPlainObject(messages)
        ? messages
        : shared_esm_bundler_isArray(__i18n)
            ? {}
            : { [locale]: {} };
    // merge locale messages of i18n custom block
    if (shared_esm_bundler_isArray(__i18n)) {
        __i18n.forEach(custom => {
            if ('locale' in custom && 'resource' in custom) {
                const { locale, resource } = custom;
                if (locale) {
                    ret[locale] = ret[locale] || {};
                    deepCopy(resource, ret[locale]);
                }
                else {
                    deepCopy(resource, ret);
                }
            }
            else {
                shared_esm_bundler_isString(custom) && deepCopy(JSON.parse(custom), ret);
            }
        });
    }
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for (const key in ret) {
            if (hasOwn(ret, key)) {
                handleFlatJson(ret[key]);
            }
        }
    }
    return ret;
}
const isNotObjectOrIsArray = (val) => !shared_esm_bundler_isObject(val) || shared_esm_bundler_isArray(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function deepCopy(src, des) {
    // src and des should both be objects, and non of then can be a array
    if (isNotObjectOrIsArray(src) || isNotObjectOrIsArray(des)) {
        throw createI18nError(I18nErrorCodes.INVALID_VALUE);
    }
    for (const key in src) {
        if (hasOwn(src, key)) {
            if (isNotObjectOrIsArray(src[key]) || isNotObjectOrIsArray(des[key])) {
                // replace with src[key] when:
                // src[key] or des[key] is not a object, or
                // src[key] or des[key] is a array
                des[key] = src[key];
            }
            else {
                // src[key] and des[key] are both object, merge them
                deepCopy(src[key], des[key]);
            }
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getComponentOptions(instance) {
    return instance.type ;
}
function adjustI18nResources(global, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = shared_esm_bundler_isObject(options.messages) ? options.messages : {};
    if ('__i18nGlobal' in componentOptions) {
        messages = getLocaleMessages(global.locale.value, {
            messages,
            __i18n: componentOptions.__i18nGlobal
        });
    }
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) {
        locales.forEach(locale => {
            global.mergeLocaleMessage(locale, messages[locale]);
        });
    }
    {
        // merge datetime formats
        if (shared_esm_bundler_isObject(options.datetimeFormats)) {
            const locales = Object.keys(options.datetimeFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    global.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
                });
            }
        }
        // merge number formats
        if (shared_esm_bundler_isObject(options.numberFormats)) {
            const locales = Object.keys(options.numberFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    global.mergeNumberFormat(locale, options.numberFormats[locale]);
                });
            }
        }
    }
}
function createTextNode(key) {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(external_commonjs_vue_commonjs2_vue_root_Vue_.Text, null, key, 0)
        ;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-explicit-any */
// extend VNode interface
const DEVTOOLS_META = '__INTLIFY_META__';
let composerID = 0;
function defineCoreMissingHandler(missing) {
    return ((ctx, locale, key, type) => {
        return missing(locale, key, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)() || undefined, type);
    });
}
// for Intlify DevTools
const getMetaInfo =  () => {
    const instance = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = getComponentOptions(instance)[DEVTOOLS_META])
        ? { [DEVTOOLS_META]: meta } // eslint-disable-line @typescript-eslint/no-explicit-any
        : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createComposer(options = {}, VueI18nLegacy) {
    const { __root } = options;
    const _isGlobal = __root === undefined;
    let _inheritLocale = shared_esm_bundler_isBoolean(options.inheritLocale)
        ? options.inheritLocale
        : true;
    const _locale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.locale.value
        : shared_esm_bundler_isString(options.locale)
            ? options.locale
            : core_base_esm_bundler_DEFAULT_LOCALE);
    const _fallbackLocale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.fallbackLocale.value
        : shared_esm_bundler_isString(options.fallbackLocale) ||
            shared_esm_bundler_isArray(options.fallbackLocale) ||
            shared_esm_bundler_isPlainObject(options.fallbackLocale) ||
            options.fallbackLocale === false
            ? options.fallbackLocale
            : _locale.value);
    const _messages = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(shared_esm_bundler_isPlainObject(options.datetimeFormats)
            ? options.datetimeFormats
            : { [_locale.value]: {} })
        ;
    // prettier-ignore
    const _numberFormats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(shared_esm_bundler_isPlainObject(options.numberFormats)
            ? options.numberFormats
            : { [_locale.value]: {} })
        ;
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root
        ? __root.missingWarn
        : shared_esm_bundler_isBoolean(options.missingWarn) || shared_esm_bundler_isRegExp(options.missingWarn)
            ? options.missingWarn
            : true;
    // prettier-ignore
    let _fallbackWarn = __root
        ? __root.fallbackWarn
        : shared_esm_bundler_isBoolean(options.fallbackWarn) || shared_esm_bundler_isRegExp(options.fallbackWarn)
            ? options.fallbackWarn
            : true;
    // prettier-ignore
    let _fallbackRoot = __root
        ? __root.fallbackRoot
        : shared_esm_bundler_isBoolean(options.fallbackRoot)
            ? options.fallbackRoot
            : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = shared_esm_bundler_isFunction(options.missing) ? options.missing : null;
    let _runtimeMissing = shared_esm_bundler_isFunction(options.missing)
        ? defineCoreMissingHandler(options.missing)
        : null;
    // postTranslation handler
    let _postTranslation = shared_esm_bundler_isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    // prettier-ignore
    let _warnHtmlMessage = __root
        ? __root.warnHtmlMessage
        : shared_esm_bundler_isBoolean(options.warnHtmlMessage)
            ? options.warnHtmlMessage
            : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root
        ? __root.modifiers
        : shared_esm_bundler_isPlainObject(options.modifiers)
            ? options.modifiers
            : {};
    // pluralRules
    let _pluralRules = options.pluralRules || (__root && __root.pluralRules);
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    function getCoreContext() {
        _isGlobal && setFallbackContext(null);
        const ctxOptions = {
            version: vue_i18n_esm_bundler_VERSION,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            __meta: { framework: 'vue' }
        };
        {
            ctxOptions.datetimeFormats = _datetimeFormats.value;
            ctxOptions.numberFormats = _numberFormats.value;
            ctxOptions.__datetimeFormatters = shared_esm_bundler_isPlainObject(_context)
                ? _context.__datetimeFormatters
                : undefined;
            ctxOptions.__numberFormatters = shared_esm_bundler_isPlainObject(_context)
                ? _context.__numberFormatters
                : undefined;
        }
        if ((false)) {}
        const ctx = createCoreContext(ctxOptions);
        _isGlobal && setFallbackContext(ctx);
        return ctx;
    }
    _context = getCoreContext();
    updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
                _locale.value,
                _fallbackLocale.value,
                _messages.value,
                _datetimeFormats.value,
                _numberFormats.value
            ]
            ;
    }
    // locale
    const locale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
        get: () => _locale.value,
        set: val => {
            _locale.value = val;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
        get: () => _fallbackLocale.value,
        set: val => {
            _fallbackLocale.value = val;
            _context.fallbackLocale = _fallbackLocale.value;
            updateFallbackLocale(_context, _locale.value, val);
        }
    });
    // messages
    const messages = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return shared_esm_bundler_isFunction(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler) {
        _postTranslation = handler;
        _context.postTranslation = handler;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler) {
        if (handler !== null) {
            _runtimeMissing = defineCoreMissingHandler(handler);
        }
        _missing = handler;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== 'translate' || !arg.resolvedMessage;
    }
    function wrapWithDeps(fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
            try {
                setAdditionalMeta(getMetaInfo());
                if (!_isGlobal) {
                    _context.fallbackContext = __root
                        ? getFallbackContext()
                        : undefined;
                }
                ret = fn(_context);
            }
            finally {
                setAdditionalMeta(null);
                if (!_isGlobal) {
                    _context.fallbackContext = undefined;
                }
            }
        }
        else {
            ret = fn(_context);
        }
        if (shared_esm_bundler_isNumber(ret) && ret === NOT_REOSLVED) {
            const [key, arg2] = argumentParser();
            if (false) {}
            return __root && _fallbackRoot
                ? fallbackSuccess(__root)
                : fallbackFail(key);
        }
        else if (successCondition(ret)) {
            return ret;
        }
        else {
            /* istanbul ignore next */
            throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
        }
    }
    // t
    function t(...args) {
        return wrapWithDeps(context => Reflect.apply(translate, null, [context, ...args]), () => parseTranslateArgs(...args), 'translate', root => Reflect.apply(root.t, root, [...args]), key => key, val => shared_esm_bundler_isString(val));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !shared_esm_bundler_isObject(arg3)) {
            throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        return t(...[arg1, arg2, shared_esm_bundler_assign({ resolvedMessage: true }, arg3 || {})]);
    }
    // d
    function d(...args) {
        return wrapWithDeps(context => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), 'datetime format', root => Reflect.apply(root.d, root, [...args]), () => MISSING_RESOLVE_VALUE, val => shared_esm_bundler_isString(val));
    }
    // n
    function n(...args) {
        return wrapWithDeps(context => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), 'number format', root => Reflect.apply(root.n, root, [...args]), () => MISSING_RESOLVE_VALUE, val => shared_esm_bundler_isString(val));
    }
    // for custom processor
    function normalize(values) {
        return values.map(val => shared_esm_bundler_isString(val) || shared_esm_bundler_isNumber(val) || shared_esm_bundler_isBoolean(val)
            ? createTextNode(String(val))
            : val);
    }
    const interpolate = (val) => val;
    const processor = {
        normalize,
        interpolate,
        type: 'vnode'
    };
    // transrateVNode, using for `i18n-t` component
    function transrateVNode(...args) {
        return wrapWithDeps(context => {
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply(translate, null, [_context, ...args]);
            }
            finally {
                _context.processor = null;
            }
            return ret;
        }, () => parseTranslateArgs(...args), 'translate', 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        root => root[TransrateVNodeSymbol](...args), key => [createTextNode(key)], val => shared_esm_bundler_isArray(val));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps(context => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), 'number format', 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        root => root[NumberPartsSymbol](...args), () => [], val => shared_esm_bundler_isString(val) || shared_esm_bundler_isArray(val));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps(context => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), 'datetime format', 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        root => root[DatetimePartsSymbol](...args), () => [], val => shared_esm_bundler_isString(val) || shared_esm_bundler_isArray(val));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        const targetLocale = shared_esm_bundler_isString(locale) ? locale : _locale.value;
        const message = getLocaleMessage(targetLocale);
        return _context.messageResolver(message, key) !== null;
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
        for (let i = 0; i < locales.length; i++) {
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null
            ? messages
            : __root
                ? __root.tm(key) || {}
                : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return (_messages.value[locale] || {});
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = shared_esm_bundler_assign(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = shared_esm_bundler_assign(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // for debug
    composerID++;
    // watch root locale & fallbackLocale
    if (__root && inBrowser) {
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(__root.locale, (val) => {
            if (_inheritLocale) {
                _locale.value = val;
                _context.locale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(__root.fallbackLocale, (val) => {
            if (_inheritLocale) {
                _fallbackLocale.value = val;
                _context.fallbackLocale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: composerID,
        locale,
        fallbackLocale,
        get inheritLocale() {
            return _inheritLocale;
        },
        set inheritLocale(val) {
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales() {
            return Object.keys(_messages.value).sort();
        },
        messages,
        get modifiers() {
            return _modifiers;
        },
        get pluralRules() {
            return _pluralRules || {};
        },
        get isGlobal() {
            return _isGlobal;
        },
        get missingWarn() {
            return _missingWarn;
        },
        set missingWarn(val) {
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn() {
            return _fallbackWarn;
        },
        set fallbackWarn(val) {
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot() {
            return _fallbackRoot;
        },
        set fallbackRoot(val) {
            _fallbackRoot = val;
        },
        get fallbackFormat() {
            return _fallbackFormat;
        },
        set fallbackFormat(val) {
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage() {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage(val) {
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter() {
            return _escapeParameter;
        },
        set escapeParameter(val) {
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t,
        getLocaleMessage,
        setLocaleMessage,
        mergeLocaleMessage,
        getPostTranslationHandler,
        setPostTranslationHandler,
        getMissingHandler,
        setMissingHandler,
        [SetPluralRulesSymbol]: setPluralRules
    };
    {
        composer.datetimeFormats = datetimeFormats;
        composer.numberFormats = numberFormats;
        composer.rt = rt;
        composer.te = te;
        composer.tm = tm;
        composer.d = d;
        composer.n = n;
        composer.getDateTimeFormat = getDateTimeFormat;
        composer.setDateTimeFormat = setDateTimeFormat;
        composer.mergeDateTimeFormat = mergeDateTimeFormat;
        composer.getNumberFormat = getNumberFormat;
        composer.setNumberFormat = setNumberFormat;
        composer.mergeNumberFormat = mergeNumberFormat;
        composer[InejctWithOption] = options.__injectWithOption;
        composer[TransrateVNodeSymbol] = transrateVNode;
        composer[DatetimePartsSymbol] = datetimeParts;
        composer[NumberPartsSymbol] = numberParts;
    }
    // for vue-devtools timeline event
    if ((false)) {}
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */
function convertComposerOptions(options) {
    const locale = isString(options.locale) ? options.locale : DEFAULT_LOCALE;
    const fallbackLocale = isString(options.fallbackLocale) ||
        isArray(options.fallbackLocale) ||
        isPlainObject(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : locale;
    const missing = isFunction(options.missing) ? options.missing : undefined;
    const missingWarn = isBoolean(options.silentTranslationWarn) ||
        isRegExp(options.silentTranslationWarn)
        ? !options.silentTranslationWarn
        : true;
    const fallbackWarn = isBoolean(options.silentFallbackWarn) ||
        isRegExp(options.silentFallbackWarn)
        ? !options.silentFallbackWarn
        : true;
    const fallbackRoot = isBoolean(options.fallbackRoot)
        ? options.fallbackRoot
        : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = isPlainObject(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = isFunction(options.postTranslation)
        ? options.postTranslation
        : undefined;
    const warnHtmlMessage = isString(options.warnHtmlInMessage)
        ? options.warnHtmlInMessage !== 'off'
        : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = isBoolean(options.sync) ? options.sync : true;
    if (false) {}
    if (false) {}
    let messages = options.messages;
    if (isPlainObject(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale) => {
            const message = messages[locale] || (messages[locale] = {});
            assign(message, sharedMessages[locale]);
            return messages;
        }, (messages || {}));
    }
    const { __i18n, __root, __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    return {
        locale,
        fallbackLocale,
        messages,
        flatJson,
        datetimeFormats,
        numberFormats,
        missing,
        missingWarn,
        fallbackWarn,
        fallbackRoot,
        fallbackFormat,
        modifiers,
        pluralRules: pluralizationRules,
        postTranslation,
        warnHtmlMessage,
        escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale,
        __i18n,
        __root,
        __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = createComposer(convertComposerOptions(options));
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale() {
                return composer.locale.value;
            },
            set locale(val) {
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale() {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale(val) {
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages() {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats() {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats() {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales() {
                return composer.availableLocales;
            },
            // formatter
            get formatter() {
                ( false) && 0;
                // dummy
                return {
                    interpolate() {
                        return [];
                    }
                };
            },
            set formatter(val) {
                ( false) && 0;
            },
            // missing
            get missing() {
                return composer.getMissingHandler();
            },
            set missing(handler) {
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn() {
                return isBoolean(composer.missingWarn)
                    ? !composer.missingWarn
                    : composer.missingWarn;
            },
            set silentTranslationWarn(val) {
                composer.missingWarn = isBoolean(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn() {
                return isBoolean(composer.fallbackWarn)
                    ? !composer.fallbackWarn
                    : composer.fallbackWarn;
            },
            set silentFallbackWarn(val) {
                composer.fallbackWarn = isBoolean(val) ? !val : val;
            },
            // modifiers
            get modifiers() {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages() {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages(val) {
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation() {
                return composer.getPostTranslationHandler();
            },
            set postTranslation(handler) {
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync() {
                return composer.inheritLocale;
            },
            set sync(val) {
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage() {
                return composer.warnHtmlMessage ? 'warn' : 'off';
            },
            set warnHtmlInMessage(val) {
                composer.warnHtmlMessage = val !== 'off';
            },
            // escapeParameterHtml
            get escapeParameterHtml() {
                return composer.escapeParameter;
            },
            set escapeParameterHtml(val) {
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent() {
                ( false) &&
                    0;
                return true;
            },
            set preserveDirectiveContent(val) {
                ( false) &&
                    0;
            },
            // pluralizationRules
            get pluralizationRules() {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t(...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!isString(arg1)) {
                    throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
                }
                const key = arg1;
                if (isString(arg2)) {
                    options.locale = arg2;
                }
                else if (isArray(arg2)) {
                    list = arg2;
                }
                else if (isPlainObject(arg2)) {
                    named = arg2;
                }
                if (isArray(arg3)) {
                    list = arg3;
                }
                else if (isPlainObject(arg3)) {
                    named = arg3;
                }
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    (list || named || {}),
                    options
                ]);
            },
            rt(...args) {
                return Reflect.apply(composer.rt, composer, [...args]);
            },
            // tc
            tc(...args) {
                const [arg1, arg2, arg3] = args;
                const options = { plural: 1 };
                let list = null;
                let named = null;
                if (!isString(arg1)) {
                    throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
                }
                const key = arg1;
                if (isString(arg2)) {
                    options.locale = arg2;
                }
                else if (isNumber(arg2)) {
                    options.plural = arg2;
                }
                else if (isArray(arg2)) {
                    list = arg2;
                }
                else if (isPlainObject(arg2)) {
                    named = arg2;
                }
                if (isString(arg3)) {
                    options.locale = arg3;
                }
                else if (isArray(arg3)) {
                    list = arg3;
                }
                else if (isPlainObject(arg3)) {
                    named = arg3;
                }
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    (list || named || {}),
                    options
                ]);
            },
            // te
            te(key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm(key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage(locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage(locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage(locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d(...args) {
                return Reflect.apply(composer.d, composer, [...args]);
            },
            // getDateTimeFormat
            getDateTimeFormat(locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat(locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat(locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n(...args) {
                return Reflect.apply(composer.n, composer, [...args]);
            },
            // getNumberFormat
            getNumberFormat(locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat(locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat(locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex(choice, choicesLength) {
                ( false) &&
                    0;
                return -1;
            },
            // for internal
            __onComponentInstanceCreated(target) {
                const { componentInstanceCreatedListener } = options;
                if (componentInstanceCreatedListener) {
                    componentInstanceCreatedListener(target, vueI18n);
                }
            }
        };
        // for vue-devtools timeline event
        if ((false)) {}
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const baseFormatProps = {
    tag: {
        type: [String, Object]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val /* ComponetI18nScope */) => val === 'parent' || val === 'global',
        default: 'parent' /* ComponetI18nScope */
    },
    i18n: {
        type: Object
    }
};

function getInterpolateArg(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots }, // SetupContext,
keys) {
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current) => {
            return (slot = [
                ...slot,
                ...(shared_esm_bundler_isArray(current.children) ? current.children : [current])
            ]);
        }, []);
    }
    else {
        // named slots
        return keys.reduce((arg, key) => {
            const slot = slots[key];
            if (slot) {
                arg[key] = slot();
            }
            return arg;
        }, {});
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFragmentableTag(tag) {
    return external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment ;
}

/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n path="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */
const Translation =  /* defineComponent */ {
    /* eslint-disable */
    name: 'i18n-t',
    props: shared_esm_bundler_assign({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [Number, String],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val) => shared_esm_bundler_isNumber(val) || !isNaN(val)
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const { slots, attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        const keys = Object.keys(slots).filter(key => key !== '_');
        return () => {
            const options = {};
            if (props.locale) {
                options.locale = props.locale;
            }
            if (props.plural !== undefined) {
                options.plural = shared_esm_bundler_isString(props.plural) ? +props.plural : props.plural;
            }
            const arg = getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[TransrateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = shared_esm_bundler_assign({}, attrs);
            const tag = shared_esm_bundler_isString(props.tag) || shared_esm_bundler_isObject(props.tag)
                ? props.tag
                : getFragmentableTag();
            return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.h)(tag, assignedAttrs, children);
        };
    }
};

function isVNode(target) {
    return shared_esm_bundler_isArray(target) && !shared_esm_bundler_isString(target[0]);
}
function renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots, attrs } = context;
    return () => {
        const options = { part: true };
        let overrides = {};
        if (props.locale) {
            options.locale = props.locale;
        }
        if (shared_esm_bundler_isString(props.format)) {
            options.key = props.format;
        }
        else if (shared_esm_bundler_isObject(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (shared_esm_bundler_isString(props.format.key)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                options.key = props.format.key;
            }
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop) => {
                return slotKeys.includes(prop)
                    ? shared_esm_bundler_assign({}, options, { [prop]: props.format[prop] }) // eslint-disable-line @typescript-eslint/no-explicit-any
                    : options;
            }, {});
        }
        const parts = partFormatter(...[props.value, options, overrides]);
        let children = [options.key];
        if (shared_esm_bundler_isArray(parts)) {
            children = parts.map((part, index) => {
                const slot = slots[part.type];
                const node = slot
                    ? slot({ [part.type]: part.value, index, parts })
                    : [part.value];
                if (isVNode(node)) {
                    node[0].key = `${part.type}-${index}`;
                }
                return node;
            });
        }
        else if (shared_esm_bundler_isString(parts)) {
            children = [parts];
        }
        const assignedAttrs = shared_esm_bundler_assign({}, attrs);
        const tag = shared_esm_bundler_isString(props.tag) || shared_esm_bundler_isObject(props.tag)
            ? props.tag
            : getFragmentableTag();
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.h)(tag, assignedAttrs, children);
    };
}

const NUMBER_FORMAT_KEYS = [
    'localeMatcher',
    'style',
    'unit',
    'unitDisplay',
    'currency',
    'currencyDisplay',
    'useGrouping',
    'numberingSystem',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'notation',
    'formatMatcher'
];
/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */
const NumberFormat =  /* defineComponent */ {
    /* eslint-disable */
    name: 'i18n-n',
    props: shared_esm_bundler_assign({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            useI18n({ useScope: 'parent', __useComponent: true });
        return renderFormatter(props, context, NUMBER_FORMAT_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[NumberPartsSymbol](...args));
    }
};

const DATETIME_FORMAT_KEYS = [
    'dateStyle',
    'timeStyle',
    'fractionalSecondDigits',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'localeMatcher',
    'timeZone',
    'hour12',
    'hourCycle',
    'formatMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName'
];
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */
const DatetimeFormat =  /*defineComponent */ {
    /* eslint-disable */
    name: 'i18n-d',
    props: shared_esm_bundler_assign({
        value: {
            type: [Number, Date],
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            useI18n({ useScope: 'parent', __useComponent: true });
        return renderFormatter(props, context, DATETIME_FORMAT_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[DatetimePartsSymbol](...args));
    }
};

function getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === 'composition') {
        return (i18nInternal.__getInstance(instance) || i18n.global);
    }
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null
            ? vueI18n.__composer
            : i18n.global.__composer;
    }
}
function vTDirective(i18n) {
    const bind = (el, { instance, value, modifiers }) => {
        /* istanbul ignore if */
        if (!instance || !instance.$) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        const composer = getComposer$2(i18n, instance.$);
        if (false) {}
        const parsedValue = parseValue(value);
        // el.textContent = composer.t(...makeParams(parsedValue))
        el.textContent = Reflect.apply(composer.t, composer, [
            ...makeParams(parsedValue)
        ]);
    };
    return {
        beforeMount: bind,
        beforeUpdate: bind
    };
}
function parseValue(value) {
    if (isString(value)) {
        return { path: value };
    }
    else if (isPlainObject(value)) {
        if (!('path' in value)) {
            throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, 'path');
        }
        return value;
    }
    else {
        throw createI18nError(I18nErrorCodes.INVALID_VALUE);
    }
}
function makeParams(value) {
    const { path, locale, args, choice, plural } = value;
    const options = {};
    const named = args || {};
    if (isString(locale)) {
        options.locale = locale;
    }
    if (isNumber(choice)) {
        options.plural = choice;
    }
    if (isNumber(plural)) {
        options.plural = plural;
    }
    return [path, named, options];
}

function apply(app, i18n, ...options) {
    const pluginOptions = isPlainObject(options[0])
        ? options[0]
        : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = isBoolean(pluginOptions.globalInstall)
        ? pluginOptions.globalInstall
        : true;
    if (false) {}
    if (globalInstall) {
        // install components
        app.component(!useI18nComponentName ? Translation.name : 'i18n', Translation);
        app.component(NumberFormat.name, NumberFormat);
        app.component(DatetimeFormat.name, DatetimeFormat);
    }
    // install directive
    {
        app.directive('t', vTDirective(i18n));
    }
}

const VUE_I18N_COMPONENT_TYPES = 'vue-i18n: composer properties';
let devtoolsApi;
async function enableDevTools(app, i18n) {
    return new Promise((resolve, reject) => {
        try {
            setupDevtoolsPlugin({
                id: "vue-devtools-plugin-vue-i18n" /* PLUGIN */,
                label: VueDevToolsLabels["vue-devtools-plugin-vue-i18n" /* PLUGIN */],
                packageName: 'vue-i18n',
                homepage: 'https://vue-i18n.intlify.dev',
                logo: 'https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png',
                componentStateTypes: [VUE_I18N_COMPONENT_TYPES],
                app
            }, api => {
                devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance, treeNode }) => {
                    updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance, instanceData }) => {
                    if (componentInstance.vnode.el &&
                        componentInstance.vnode.el.__VUE_I18N__ &&
                        instanceData) {
                        if (i18n.mode === 'legacy') {
                            // ignore global scope on legacy mode
                            if (componentInstance.vnode.el.__VUE_I18N__ !==
                                i18n.global.__composer) {
                                inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                            }
                        }
                        else {
                            inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        }
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */,
                    label: VueDevToolsLabels["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */],
                    icon: 'language',
                    treeFilterPlaceholder: VueDevToolsPlaceholders["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */]
                });
                api.on.getInspectorTree(payload => {
                    if (payload.app === app &&
                        payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */) {
                        registerScope(payload, i18n);
                    }
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload) => {
                    if (payload.app === app &&
                        payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */) {
                        api.unhighlightElement();
                        inspectScope(payload, i18n);
                        if (payload.nodeId === 'global') {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        }
                        else {
                            const instance = getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState(payload => {
                    if (payload.app === app &&
                        payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */) {
                        editScope(payload, i18n);
                    }
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* TIMELINE */,
                    label: VueDevToolsLabels["vue-i18n-timeline" /* TIMELINE */],
                    color: VueDevToolsTimelineColors["vue-i18n-timeline" /* TIMELINE */]
                });
                resolve(true);
            });
        }
        catch (e) {
            vue_i18n_esm_bundler_console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getI18nScopeLable(instance) {
    return (instance.type.name ||
        instance.type.displayName ||
        instance.type.__file ||
        'Anonymous');
}
function updateComponentTreeTags(instance, // eslint-disable-line @typescript-eslint/no-explicit-any
treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) {
        // add custom tags local scope only
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function inspectComposer(instanceData, composer) {
    const type = VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type,
        key: 'locale',
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type,
        key: 'availableLocales',
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type,
        key: 'fallbackLocale',
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type,
        key: 'inheritLocale',
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type,
        key: 'messages',
        editable: false,
        value: getLocaleMessageValue(composer.messages.value)
    });
    {
        instanceData.state.push({
            type,
            key: 'datetimeFormats',
            editable: false,
            value: composer.datetimeFormats.value
        });
        instanceData.state.push({
            type,
            key: 'numberFormats',
            editable: false,
            value: composer.numberFormats.value
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key) => {
        const v = messages[key];
        if (isFunction(v) && 'source' in v) {
            value[key] = getMessageFunctionDetails(v);
        }
        else if (isObject(v)) {
            value[key] = getLocaleMessageValue(v);
        }
        else {
            value[key] = v;
        }
    });
    return value;
}
const ESC = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '&': '&amp;'
};
function vue_i18n_esm_bundler_escape(s) {
    return s.replace(/[<>"&]/g, escapeChar);
}
function escapeChar(a) {
    return ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMessageFunctionDetails(func) {
    const argString = func.source ? `("${vue_i18n_esm_bundler_escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: 'function',
            display: `<span>ƒ</span> ${argString}`
        }
    };
}
function registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: 'global',
        label: 'Global Scope'
    });
    // prettier-ignore
    const global = i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances) {
        // prettier-ignore
        const composer = i18n.mode === 'composition'
            ? instance
            : instance.__composer;
        if (global === composer) {
            continue;
        }
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== 'global') {
        for (const [component, composer] of i18n.__instances.entries()) {
            if (composer.id.toString() === nodeId) {
                instance = component;
                break;
            }
        }
    }
    return instance;
}
function getComposer$1(nodeId, i18n) {
    if (nodeId === 'global') {
        return i18n.mode === 'composition'
            ? i18n.global
            : i18n.global.__composer;
    }
    else {
        const instance = Array.from(i18n.__instances.values()).find(item => item.id.toString() === nodeId);
        if (instance) {
            return i18n.mode === 'composition'
                ? instance
                : instance.__composer;
        }
        else {
            return null;
        }
    }
}
function inspectScope(payload, i18n
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    const composer = getComposer$1(payload.nodeId, i18n);
    if (composer) {
        // TODO:
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload.state = makeScopeInspectState(composer);
    }
    return null;
}
function makeScopeInspectState(composer) {
    const state = {};
    const localeType = 'Locale related info';
    const localeStates = [
        {
            type: localeType,
            key: 'locale',
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: 'fallbackLocale',
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: 'availableLocales',
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: 'inheritLocale',
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = 'Locale messages info';
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: 'messages',
            editable: false,
            value: getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = 'Datetime formats info';
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: 'datetimeFormats',
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = 'Datetime formats info';
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: 'numberFormats',
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function addTimelineEvent(event, payload) {
    if (devtoolsApi) {
        let groupId;
        if (payload && 'groupId' in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* TIMELINE */,
            event: {
                title: event,
                groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* COMPILE_ERROR */
                    ? 'error'
                    : event === "fallback" /* FALBACK */ ||
                        event === "missing" /* MISSING */
                        ? 'warning'
                        : 'default'
            }
        });
    }
}
function editScope(payload, i18n) {
    const composer = getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === 'locale' && isString(payload.state.value)) {
            composer.locale.value = payload.state.value;
        }
        else if (field === 'fallbackLocale' &&
            (isString(payload.state.value) ||
                isArray(payload.state.value) ||
                isObject(payload.state.value))) {
            composer.fallbackLocale.value = payload.state.value;
        }
        else if (field === 'inheritLocale' && isBoolean(payload.state.value)) {
            composer.inheritLocale = payload.state.value;
        }
    }
}

/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */
function defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate() {
            const instance = getCurrentInstance();
            /* istanbul ignore if */
            if (!instance) {
                throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
            }
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) {
                    optionsI18n.__i18n = options.__i18n;
                }
                optionsI18n.__root = composer;
                if (this === this.$root) {
                    this.$i18n = mergeToRoot(vuei18n, optionsI18n);
                }
                else {
                    optionsI18n.__injectWithOption = true;
                    this.$i18n = createVueI18n(optionsI18n);
                }
            }
            else if (options.__i18n) {
                if (this === this.$root) {
                    this.$i18n = mergeToRoot(vuei18n, options);
                }
                else {
                    this.$i18n = createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __root: composer
                    });
                }
            }
            else {
                // set global
                this.$i18n = vuei18n;
            }
            if (options.__i18nGlobal) {
                adjustI18nResources(composer, options, options);
            }
            vuei18n.__onComponentInstanceCreated(this.$i18n);
            i18n.__setInstance(instance, this.$i18n);
            // defines vue-i18n legacy APIs
            this.$t = (...args) => this.$i18n.t(...args);
            this.$rt = (...args) => this.$i18n.rt(...args);
            this.$tc = (...args) => this.$i18n.tc(...args);
            this.$te = (key, locale) => this.$i18n.te(key, locale);
            this.$d = (...args) => this.$i18n.d(...args);
            this.$n = (...args) => this.$i18n.n(...args);
            this.$tm = (key) => this.$i18n.tm(key);
        },
        mounted() {
            /* istanbul ignore if */
            if (false) {}
        },
        unmounted() {
            const instance = getCurrentInstance();
            /* istanbul ignore if */
            if (!instance) {
                throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
            }
            /* istanbul ignore if */
            if (false) {}
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function mergeToRoot(root, options) {
    root.locale = options.locale || root.locale;
    root.fallbackLocale = options.fallbackLocale || root.fallbackLocale;
    root.missing = options.missing || root.missing;
    root.silentTranslationWarn =
        options.silentTranslationWarn || root.silentFallbackWarn;
    root.silentFallbackWarn =
        options.silentFallbackWarn || root.silentFallbackWarn;
    root.formatFallbackMessages =
        options.formatFallbackMessages || root.formatFallbackMessages;
    root.postTranslation = options.postTranslation || root.postTranslation;
    root.warnHtmlInMessage = options.warnHtmlInMessage || root.warnHtmlInMessage;
    root.escapeParameterHtml =
        options.escapeParameterHtml || root.escapeParameterHtml;
    root.sync = options.sync || root.sync;
    root.__composer[SetPluralRulesSymbol](options.pluralizationRules || root.pluralizationRules);
    const messages = getLocaleMessages(root.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach(locale => root.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) {
        Object.keys(options.datetimeFormats).forEach(locale => root.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    }
    if (options.numberFormats) {
        Object.keys(options.numberFormats).forEach(locale => root.mergeNumberFormat(locale, options.numberFormats[locale]));
    }
    return root;
}

/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */
const I18nInjectionKey = 
/* #__PURE__*/ shared_esm_bundler_makeSymbol('global-vue-i18n');
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function createI18n(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode =  true && isBoolean(options.legacy)
            ? options.legacy
            : true;
    // prettier-ignore
    const __globalInjection = isBoolean(options.globalInjection)
        ? options.globalInjection
        : true;
    // prettier-ignore
    const __allowComposition =  true && __legacyMode
            ? !!options.allowComposition
            : true;
    const __instances = new Map();
    const [globalScope, __global] = createGlobal(options, __legacyMode);
    const symbol = makeSymbol(( false) ? 0 : '');
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode() {
                return  true && __legacyMode
                    ? 'legacy'
                    : 'composition';
            },
            // allowComposition
            get allowComposition() {
                return __allowComposition;
            },
            // install plugin
            async install(app, ...options) {
                if (false) {}
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // global method and properties injection for Composition API
                if (!__legacyMode && __globalInjection) {
                    injectGlobalFields(app, i18n.global);
                }
                // install built-in components and directive
                if (false) {}
                // setup mixin for Legacy API
                if ( true && __legacyMode) {
                    app.mixin(defineMixin(__global, __global.__composer, i18n));
                }
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = () => {
                    i18n.dispose();
                    unmountApp();
                };
                // setup vue-devtools plugin
                if (false) {}
            },
            // global accessor
            get global() {
                return __global;
            },
            dispose() {
                globalScope.stop();
            },
            // @internal
            __instances,
            // @internal
            __getInstance,
            // @internal
            __setInstance,
            // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useI18n(options = {}) {
    const instance = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)();
    if (instance == null) {
        throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    }
    if (!instance.isCE &&
        instance.appContext.app != null &&
        !instance.appContext.app.__VUE_I18N_SYMBOL__) {
        throw createI18nError(I18nErrorCodes.NOT_INSLALLED);
    }
    const i18n = getI18nInstance(instance);
    const global = getGlobalComposer(i18n);
    const componentOptions = getComponentOptions(instance);
    const scope = getScope(options, componentOptions);
    if (true) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (i18n.mode === 'legacy' && !options.__useComponent) {
            if (!i18n.allowComposition) {
                throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            }
            return useI18nForLegacy(instance, scope, global, options);
        }
    }
    if (scope === 'global') {
        adjustI18nResources(global, options, componentOptions);
        return global;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = getComposer(i18n, instance, options.__useComponent);
        if (composer == null) {
            if ((false)) {}
            composer = global;
        }
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = shared_esm_bundler_assign({}, options);
        if ('__i18n' in componentOptions) {
            composerOptions.__i18n = componentOptions.__i18n;
        }
        if (global) {
            composerOptions.__root = global;
        }
        composer = createComposer(composerOptions);
        setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */
const castToVueI18n =  (i18n
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => {
    if (!(__VUE_I18N_BRIDGE__ in i18n)) {
        throw createI18nError(I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    }
    return i18n;
};
function createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = effectScope();
    {
        const obj =  true && legacyMode
            ? scope.run(() => createVueI18n(options))
            : scope.run(() => createComposer(options));
        if (obj == null) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        return [scope, obj];
    }
}
function getI18nInstance(instance) {
    {
        const i18n = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(!instance.isCE
            ? instance.appContext.app.__VUE_I18N_SYMBOL__
            : I18nInjectionKey);
        /* istanbul ignore if */
        if (!i18n) {
            throw createI18nError(!instance.isCE
                ? I18nErrorCodes.UNEXPECTED_ERROR
                : I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE);
        }
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getScope(options, componentOptions) {
    // prettier-ignore
    return isEmptyObject(options)
        ? ('__i18n' in componentOptions)
            ? 'local'
            : 'global'
        : !options.useScope
            ? 'local'
            : options.useScope;
}
function getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition'
            ? i18n.global
            : i18n.global.__composer
        ;
}
function getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = target.parent;
    while (current != null) {
        const i18nInternal = i18n;
        if (i18n.mode === 'composition') {
            composer = i18nInternal.__getInstance(current);
        }
        else {
            if (true) {
                const vueI18n = i18nInternal.__getInstance(current);
                if (vueI18n != null) {
                    composer = vueI18n
                        .__composer;
                    if (useComponent &&
                        composer &&
                        !composer[InejctWithOption] // eslint-disable-line @typescript-eslint/no-explicit-any
                    ) {
                        composer = null;
                    }
                }
            }
        }
        if (composer != null) {
            break;
        }
        if (root === current) {
            break;
        }
        current = current.parent;
    }
    return composer;
}
function setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    {
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
            // inject composer instance to DOM for intlify-devtools
            if (false) {}
        }, target);
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
            // remove composer instance from DOM for intlify-devtools
            if (false) {}
            i18n.__deleteInstance(target);
        }, target);
    }
}
function useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocale = scope === 'local';
    const _composer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.shallowRef)(null);
    if (isLocale &&
        instance.proxy &&
        !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) {
        throw createI18nError(I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    }
    const _inheritLocale = shared_esm_bundler_isBoolean(options.inheritLocale)
        ? options.inheritLocale
        : true;
    const _locale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(
    // prettier-ignore
    isLocale && _inheritLocale
        ? root.locale.value
        : shared_esm_bundler_isString(options.locale)
            ? options.locale
            : core_base_esm_bundler_DEFAULT_LOCALE);
    const _fallbackLocale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(
    // prettier-ignore
    isLocale && _inheritLocale
        ? root.fallbackLocale.value
        : shared_esm_bundler_isString(options.fallbackLocale) ||
            shared_esm_bundler_isArray(options.fallbackLocale) ||
            shared_esm_bundler_isPlainObject(options.fallbackLocale) ||
            options.fallbackLocale === false
            ? options.fallbackLocale
            : _locale.value);
    const _messages = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(shared_esm_bundler_isPlainObject(options.datetimeFormats)
        ? options.datetimeFormats
        : { [_locale.value]: {} });
    // prettier-ignore
    const _numberFormats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(shared_esm_bundler_isPlainObject(options.numberFormats)
        ? options.numberFormats
        : { [_locale.value]: {} });
    // prettier-ignore
    const _missingWarn = isLocale
        ? root.missingWarn
        : shared_esm_bundler_isBoolean(options.missingWarn) || shared_esm_bundler_isRegExp(options.missingWarn)
            ? options.missingWarn
            : true;
    // prettier-ignore
    const _fallbackWarn = isLocale
        ? root.fallbackWarn
        : shared_esm_bundler_isBoolean(options.fallbackWarn) || shared_esm_bundler_isRegExp(options.fallbackWarn)
            ? options.fallbackWarn
            : true;
    // prettier-ignore
    const _fallbackRoot = isLocale
        ? root.fallbackRoot
        : shared_esm_bundler_isBoolean(options.fallbackRoot)
            ? options.fallbackRoot
            : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = shared_esm_bundler_isFunction(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = shared_esm_bundler_isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocale
        ? root.warnHtmlMessage
        : shared_esm_bundler_isBoolean(options.warnHtmlMessage)
            ? options.warnHtmlMessage
            : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocale
        ? root.modifiers
        : shared_esm_bundler_isPlainObject(options.modifiers)
            ? options.modifiers
            : {};
    // pluralRules
    const _pluralRules = options.pluralRules || (isLocale && root.pluralRules);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
        get: () => {
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: val => {
            if (_composer.value) {
                _composer.value.locale.value = val;
            }
            _locale.value = val;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
        get: () => {
            return _composer.value
                ? _composer.value.fallbackLocale.value
                : _fallbackLocale.value;
        },
        set: val => {
            if (_composer.value) {
                _composer.value.fallbackLocale.value = val;
            }
            _fallbackLocale.value = val;
        }
    });
    // messages
    const messages = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        if (_composer.value) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return _composer.value.messages.value;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return _messages.value;
        }
    });
    const datetimeFormats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _datetimeFormats.value);
    const numberFormats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value
            ? _composer.value.getPostTranslationHandler()
            : _postTranslation;
    }
    function setPostTranslationHandler(handler) {
        if (_composer.value) {
            _composer.value.setPostTranslationHandler(handler);
        }
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler) {
        if (_composer.value) {
            _composer.value.setMissingHandler(handler);
        }
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value
            ? warpWithDeps(() => Reflect.apply(_composer.value.t, null, [...args]))
            : warpWithDeps(() => '');
    }
    function rt(...args) {
        return _composer.value
            ? Reflect.apply(_composer.value.rt, null, [...args])
            : '';
    }
    function d(...args) {
        return _composer.value
            ? warpWithDeps(() => Reflect.apply(_composer.value.d, null, [...args]))
            : warpWithDeps(() => '');
    }
    function n(...args) {
        return _composer.value
            ? warpWithDeps(() => Reflect.apply(_composer.value.n, null, [...args]))
            : warpWithDeps(() => '');
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.mergeLocaleMessage(locale, message);
        }
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.mergeDateTimeFormat(locale, format);
        }
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.mergeNumberFormat(locale, format);
        }
    }
    const wrapper = {
        get id() {
            return _composer.value ? _composer.value.id : -1;
        },
        locale,
        fallbackLocale,
        messages,
        datetimeFormats,
        numberFormats,
        get inheritLocale() {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale(val) {
            if (_composer.value) {
                _composer.value.inheritLocale = val;
            }
        },
        get availableLocales() {
            return _composer.value
                ? _composer.value.availableLocales
                : Object.keys(_messages.value);
        },
        get modifiers() {
            return (_composer.value ? _composer.value.modifiers : _modifiers);
        },
        get pluralRules() {
            return (_composer.value ? _composer.value.pluralRules : _pluralRules);
        },
        get isGlobal() {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn() {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn(val) {
            if (_composer.value) {
                _composer.value.missingWarn = val;
            }
        },
        get fallbackWarn() {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn(val) {
            if (_composer.value) {
                _composer.value.missingWarn = val;
            }
        },
        get fallbackRoot() {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot(val) {
            if (_composer.value) {
                _composer.value.fallbackRoot = val;
            }
        },
        get fallbackFormat() {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat(val) {
            if (_composer.value) {
                _composer.value.fallbackFormat = val;
            }
        },
        get warnHtmlMessage() {
            return _composer.value
                ? _composer.value.warnHtmlMessage
                : _warnHtmlMessage;
        },
        set warnHtmlMessage(val) {
            if (_composer.value) {
                _composer.value.warnHtmlMessage = val;
            }
        },
        get escapeParameter() {
            return _composer.value
                ? _composer.value.escapeParameter
                : _escapeParameter;
        },
        set escapeParameter(val) {
            if (_composer.value) {
                _composer.value.escapeParameter = val;
            }
        },
        t,
        getPostTranslationHandler,
        setPostTranslationHandler,
        getMissingHandler,
        setMissingHandler,
        rt,
        d,
        n,
        tm,
        te,
        getLocaleMessage,
        setLocaleMessage,
        mergeLocaleMessage,
        getDateTimeFormat,
        setDateTimeFormat,
        mergeDateTimeFormat,
        getNumberFormat,
        setNumberFormat,
        mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach(locale => {
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach(locale => {
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach(locale => {
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeMount)(() => {
        if (instance.proxy == null || instance.proxy.$i18n == null) {
            throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = (_composer.value = instance.proxy.$i18n
            .__composer);
        if (scope === 'global') {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        }
        else if (isLocale) {
            sync(composer);
        }
    });
    return wrapper;
}
const globalExportProps = (/* unused pure expression or super */ null && ([
    'locale',
    'fallbackLocale',
    'availableLocales'
]));
const globalExportMethods = (/* unused pure expression or super */ null && (['t', 'rt', 'd', 'n', 'tm'])) ;
function injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    globalExportProps.forEach(prop => {
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        const wrap = isRef(desc.value) // check computed props
            ? {
                get() {
                    return desc.value.value;
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                set(val) {
                    desc.value.value = val;
                }
            }
            : {
                get() {
                    return desc.get && desc.get();
                }
            };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    globalExportMethods.forEach(method => {
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
}

// register message compiler at vue-i18n
registerMessageCompiler(compileToFunction);
// register message resolver at vue-i18n
registerMessageResolver(resolveValue);
// register fallback locale at vue-i18n
registerLocaleFallbacker(fallbackWithLocaleChain);
{
    initFeatureFlags();
}
// NOTE: experimental !!
if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
    const target = getGlobalThis();
    target.__INTLIFY__ = true;
    setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
if ((false)) {}




/***/ }),

/***/ 3744:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 9017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CookieNotice; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CookieNotice.vue?vue&type=script&setup=true&lang=js


const _withScopeId = n => (_pushScopeId("data-v-5137eadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-notice"
}
const _hoisted_2 = ["href"]


  const __default__ = {
    name: "CookieNotice",
    props: {
      routerToPrivacyPolicy: {
        type: String
      }
    },
    data() {
      return {
        noticeVisible: false,
      };
    },
    created() {
      if (!this.getAcceptStatus() === true) {
        this.noticeVisible = true;
      }
    },
    methods: {
      setAccept() {
        // if (typeof (Storage) !== "undefined") {
        localStorage.setItem('dp-gdpr:cookie', true);
        // }
      },
      setDeny() {
        // if (typeof (Storage) !== "undefined") {
        localStorage.setItem('dp-gdpr:cookie', false);
        // }
      },
      getAcceptStatus() {
        // if (typeof (Storage) !== "undefined") {
        return localStorage.getItem('dp-gdpr:cookie');
        // }
      },
      acceptGDPR() {
        this.setAccept();
        this.noticeVisible = false;
        this.$emit('accept');
      },
      denyGDPR() {
        this.setDeny();
        this.noticeVisible = false;
        this.$emit('deny');
      }
    }
  };



/* harmony default export */ var CookieNoticevue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  const _component_i18n_t = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("i18n-t")
  const _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col")
  const _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row")
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")

  return (_ctx.noticeVisible)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('bodyText.label')) + " ", 1),
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_i18n_t, {
                    keypath: "linkToPrivacyPolicy.label",
                    tag: "span"
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
                        target: "_blank",
                        href: __props.routerToPrivacyPolicy || 'https://www.dutypay.eu/de/datenschutz.html'
                      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('privacyPolicy.label')), 9, _hoisted_2)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
          type: "flex",
          justify: "space-around",
          gutter: 25,
          align: "middle",
          class: "buttons-container"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "secondary",
                  small: "",
                  onClick: _ctx.denyGDPR
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('buttonDeny.buttonLabel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { align: "right" }, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  small: "",
                  onClick: _ctx.acceptGDPR
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('buttonAgree.buttonLabel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
}
}

}));
;// CONCATENATED MODULE: ./src/components/CookieNotice.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CookieNotice.vue?vue&type=style&index=0&id=5137eadc&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/CookieNotice.vue?vue&type=style&index=0&id=5137eadc&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CookieNotice.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function CookieNoticevue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.CookieNotice.bodyText.label"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.CookieNotice.linkToPrivacyPolicy.label"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.CookieNotice.privacyPolicy.label"])}
        }
      },
      "de-AT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-CH": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-US": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agree"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Decline"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-GB": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agree"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Decline"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "it-IT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Essere d'accordo"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declino"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-FR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se mettre d'accord"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclin"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "es-ES": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De acuerdo"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disminución"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pl-PL": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zgodzić się"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upadek"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "nl-NL": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mee eens"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afwijzen"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bg-BG": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Съгласен"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отклонение"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bs-BA": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slažem se"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbij"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "zh-CN": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下降"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "da-DK": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enig"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nedgang"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "et-EE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nõus"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keeldu"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fi-FI": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olla samaa mieltä"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hylkää"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-GR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Συμφωνώ"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πτώση"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "he-IL": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַסכִּים"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["יְרִידָה"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ga-IE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aontaigh"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meath"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ja-JP": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意する"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["低下"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hr-HR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pristani"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbiti"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lv-LV": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piekrītu"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noraidīt"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lt-LT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sutikite"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atmesti"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pt-PT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aceita"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declínio"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ro-RO": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De acord"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declin"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ru-RU": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Согласен"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отказаться"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sv-SE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hålla med"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nedgång"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sk-SK": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Súhlasím"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokles"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "cs-CZ": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Souhlasit"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokles"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-TR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katılıyorum"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reddet"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hu-HU": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Egyetért"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hanyatlás"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-AE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوافق على"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انخفاض"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-BE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se mettre d'accord"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclin"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-LU": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se mettre d'accord"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclin"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "mt-MT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naqbel"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tnaqqis"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strinjam se"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zavrni"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-CY": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Συμφωνώ"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πτώση"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-CY": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katılıyorum"])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reddet"])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/CookieNotice.vue



;
/* custom blocks */

if (typeof CookieNoticevue_type_custom_index_0_blockType_i18n === 'function') CookieNoticevue_type_custom_index_0_blockType_i18n(CookieNoticevue_type_script_setup_true_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CookieNoticevue_type_script_setup_true_lang_js, [['__scopeId',"data-v-5137eadc"]])

/* harmony default export */ var CookieNotice = (__exports__);

/***/ }),

/***/ 9166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpApplicationContainer; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./src/components/DpHeader.vue + 29 modules
var DpHeader = __webpack_require__(1628);
// EXTERNAL MODULE: ./src/components/DpContent.vue + 6 modules
var DpContent = __webpack_require__(7381);
// EXTERNAL MODULE: ./node_modules/pinia/dist/pinia.esm-browser.js + 1 modules
var pinia_esm_browser = __webpack_require__(8262);
// EXTERNAL MODULE: external "@dutypay/store-modules"
var store_modules_ = __webpack_require__(2706);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationContainer.vue?vue&type=script&setup=true&lang=js






const tests = [
  {
    title: ""
  }
  // TODO: menuItems
  // TODO: hasCompanySwitch
  // TODO: Slot reminder
  // TODO: Slot default
];

const __default__ = {
  name: "DpApplicationContainer",
  description: "Holds the content of an application. Makes use of DpContent to render the wrapper and DpHeader.",
  components: {DpHeader: DpHeader["default"], DpContent: DpContent["default"]},
  props: {
    menuItems: { type: Array },
    hasCompanySwitch: { type: Boolean, default: true }
  },
  // tests,
}

;


/* harmony default export */ var DpApplicationContainervue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const envStore = (0,store_modules_.useEnvStore)()
const {globalLoading} = (0,pinia_esm_browser/* storeToRefs */.Jk)(envStore)

return (_ctx, _cache) => {
  const _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading")

  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpHeader["default"]), {
      menuItems: __props.menuItems,
      hasCompanySwitch: __props.hasCompanySwitch
    }, null, 8, ["menuItems", "hasCompanySwitch"]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpContent["default"]), null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "reminder"),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ])), [
    [
      _directive_loading,
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(globalLoading),
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpApplicationContainer.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationContainer.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpApplicationContainervue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpApplicationContainer.vue


/* custom blocks */
;
if (typeof DpApplicationContainervue_type_custom_index_0_blockType_i18n === 'function') DpApplicationContainervue_type_custom_index_0_blockType_i18n(DpApplicationContainervue_type_script_setup_true_lang_js)


const __exports__ = DpApplicationContainervue_type_script_setup_true_lang_js;

/* harmony default export */ var DpApplicationContainer = (__exports__);

/***/ }),

/***/ 5159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_DpApplicationLogo; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo.vue?vue&type=template&id=32fe8f2a


function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)($options.componentName), {
    version: $props.version,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)($options.logoHeight)
  }, null, 8, ["version", "style"]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo.vue?vue&type=template&id=32fe8f2a

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/AccountingHub.vue?vue&type=template&id=531a697c&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-531a697c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2244.83",
  height: "267",
  viewBox: "0 0 2244.83 267"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-531a697c></polygon><path d=\"M58.69,190.39l-14.35,1c-7.5,0-11-2.23-11-7.07a13.52,13.52,0,0,1,.33-2.82l.21-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.21-3.26-6.68-3.26H38.58l.82-4.24,10.22-1c9.56,0,13.47,2.18,13.47,7.29a15.86,15.86,0,0,1-.38,3ZM47.88,175.61c-4.41,0-5,2.23-5.66,5.49,0,.16-.1.38-.1.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M90.16,166.31H83.64c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.08,2.17,4.72,2.17h6.64L85,190.66l-7.07.71c-6.3,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M114.3,166.31h-6.52c-5.11,0-5.77,1.09-6.64,4.95L99,181.53a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17H110l-.87,4.29-7.07.71c-6.3,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#9dcc4a\" data-v-531a697c></path><polygon points=\"121.4 144.79 115.48 144.79 117.02 137.58 112.93 137.58 109.15 155.38 113.25 155.38 114.89 147.67 120.81 147.67 119.16 155.38 123.26 155.38 127.03 137.58 122.94 137.58 121.4 144.79\" fill=\"#9dcc4a\" data-v-531a697c></polygon><path d=\"M140.06,137.65l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.55,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M160.2,139.24c-.86-1.06-2.5-1.57-5-1.57h-7.46L144,155.3h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.64,4.64,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.2,139.24Zm-6.64,5.56H151c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.56,144.8Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M470.29,254.63l-10.21-53.94v.73h-86v-.73l-11.3,53.94H311l66.7-240.17h94.39l69.61,240.17ZM427.65,43.25H406.51L380.63,170.44h74Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M642,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H642.68c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M815.43,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H816.16c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M1086.58,190.85c0,68.52-76.53,65.61-107.14,65.61-58,0-92.94-19.32-92.94-65.61V78.24c0-46.29,34.62-65.6,92.57-65.6H994c57.59,0,92.57,19.31,92.57,65.6ZM1024.26,78.24c0-23.69-8.74-34.63-36.44-34.63h-2.55c-27.7,0-36.45,10.94-36.45,34.63V190.85c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M1304.89,190.85c0,43.74-31.34,65.61-92.57,65.61h-14.94c-61.23,0-92.57-21.87-92.57-65.61V14.46h63V190.85c0,22.24,7.65,34.26,35.72,34.26h2.55c28.06,0,35.71-12,35.71-34.26V14.46h63.05Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M1460.88,254.63,1368.31,75V254.63h-40.09V14.46H1400l89.65,177.12V14.46h39.73V254.63Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M1663.89,45.44V254.63H1601.2V45.44h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M1735.69,254.63V14.46h62.68V254.63Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M1961.65,254.63,1869.08,75V254.63H1829V14.46h71.79l89.66,177.12V14.46h39.73V254.63Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M2151.17,257.19c-48.48,0-102.78-3.28-102.78-65.61V77.87c0-62.68,59-66.69,105-66.69l81.28,5.1V42.52h-80.18c-41.19,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V114.68h62.32V251.35Z\" fill=\"#fff\" data-v-531a697c></path>", 17)
const _hoisted_20 = [
  _hoisted_3
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#9dcc4a\" data-v-531a697c></polygon><path d=\"M58.69,190.39l-14.35,1c-7.5,0-11-2.23-11-7.07a13.52,13.52,0,0,1,.33-2.82l.21-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.21-3.26-6.68-3.26H38.58l.82-4.24,10.22-1c9.56,0,13.47,2.18,13.47,7.29a15.86,15.86,0,0,1-.38,3ZM47.88,175.61c-4.41,0-5,2.23-5.66,5.49,0,.16-.1.38-.1.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M90.16,166.31H83.64c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.08,2.17,4.72,2.17h6.64L85,190.66l-7.07.71c-6.3,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M114.3,166.31h-6.52c-5.11,0-5.77,1.09-6.64,4.95L99,181.53a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17H110l-.87,4.29-7.07.71c-6.3,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-531a697c></path><polygon points=\"121.4 144.79 115.48 144.79 117.02 137.58 112.93 137.58 109.15 155.38 113.25 155.38 114.89 147.67 120.81 147.67 119.16 155.38 123.26 155.38 127.03 137.58 122.94 137.58 121.4 144.79\" fill=\"#fff\" data-v-531a697c></polygon><path d=\"M140.06,137.65l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.55,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M160.2,139.24c-.86-1.06-2.5-1.57-5-1.57h-7.46L144,155.3h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.64,4.64,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.2,139.24Zm-6.64,5.56H151c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.56,144.8Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-531a697c></path><path d=\"M470.29,254.63l-10.21-53.94v.73h-86v-.73l-11.3,53.94H311l66.7-240.17h94.39l69.61,240.17ZM427.65,43.25H406.51L380.63,170.44h74Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M642,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H642.68c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M815.43,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H816.16c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M1086.58,190.85c0,68.52-76.53,65.61-107.14,65.61-58,0-92.94-19.32-92.94-65.61V78.24c0-46.29,34.62-65.6,92.57-65.6H994c57.59,0,92.57,19.31,92.57,65.6ZM1024.26,78.24c0-23.69-8.74-34.63-36.44-34.63h-2.55c-27.7,0-36.45,10.94-36.45,34.63V190.85c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M1304.89,190.85c0,43.74-31.34,65.61-92.57,65.61h-14.94c-61.23,0-92.57-21.87-92.57-65.61V14.46h63V190.85c0,22.24,7.65,34.26,35.72,34.26h2.55c28.06,0,35.71-12,35.71-34.26V14.46h63.05Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M1460.88,254.63,1368.31,75V254.63h-40.09V14.46H1400l89.65,177.12V14.46h39.73V254.63Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M1663.89,45.44V254.63H1601.2V45.44h-51.75v-31h166.19v31Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M1735.69,254.63V14.46h62.68V254.63Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M1961.65,254.63,1869.08,75V254.63H1829V14.46h71.79l89.66,177.12V14.46h39.73V254.63Z\" fill=\"#9dcc4a\" data-v-531a697c></path><path d=\"M2151.17,257.19c-48.48,0-102.78-3.28-102.78-65.61V77.87c0-62.68,59-66.69,105-66.69l81.28,5.1V42.52h-80.18c-41.19,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V114.68h62.32V251.35Z\" fill=\"#9dcc4a\" data-v-531a697c></path>", 17)
const _hoisted_39 = [
  _hoisted_22
]

function AccountingHubvue_type_template_id_531a697c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_2, _hoisted_20))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_21, _hoisted_39))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/AccountingHub.vue?vue&type=template&id=531a697c&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/AccountingHub.vue?vue&type=script&lang=js

  /* harmony default export */ var AccountingHubvue_type_script_lang_js = ({
    name: "AccountingHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/AccountingHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/AccountingHub.vue?vue&type=style&index=0&id=531a697c&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/AccountingHub.vue?vue&type=style&index=0&id=531a697c&scoped=true&lang=css

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/AccountingHub.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AccountingHubvue_type_script_lang_js, [['render',AccountingHubvue_type_template_id_531a697c_scoped_true_render],['__scopeId',"data-v-531a697c"]])

/* harmony default export */ var AccountingHub = (__exports__);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/CopyrightHub.vue?vue&type=template&id=23bee88a&scoped=true


const CopyrightHubvue_type_template_id_23bee88a_scoped_true_withScopeId = n => (_pushScopeId("data-v-23bee88a"),n=n(),_popScopeId(),n)
const CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2054.29",
  height: "267",
  viewBox: "0 0 2054.29 267"
}
const CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_2 = { key: 0 }
const CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-23bee88a></polygon><path d=\"M59.1,166.22H52.58c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14.17,14.17,0,0,0-.39,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10L60,162Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M87.69,181.33c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H72.31l-4.19,19.56h5.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M117.86,173.13h-6.31a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2H104l-5.16,24.24H90.52l6.09-28.59,13.53-1.09c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#e6ae24\" data-v-23bee88a></path><polygon points=\"119.9 144.89 113.99 144.89 115.53 137.67 111.43 137.67 107.66 155.47 111.75 155.47 113.39 147.76 119.31 147.76 117.67 155.47 121.76 155.47 125.54 137.67 121.44 137.67 119.9 144.89\" fill=\"#e6ae24\" data-v-23bee88a></polygon><path d=\"M138.57,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M158.71,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,158.71,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,152.06,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M426,257.5c-48.1,0-102.41-5.1-102.41-65.6V78.19c0-61.23,55-66.7,102.41-66.7L484.3,16.6v27H426.71c-37.9,0-40.82,10.2-40.82,34.62V191.9c0,25.15,3.65,33.53,40.82,33.53H484.3v27Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M697.14,191.17c0,68.52-76.53,65.6-107.15,65.6-58,0-92.94-19.31-92.94-65.6V78.55c0-46.28,34.63-65.6,92.58-65.6h14.94c57.58,0,92.57,19.32,92.57,65.6ZM634.82,78.55c0-23.69-8.75-34.62-36.45-34.62h-2.55c-27.7,0-36.44,10.93-36.44,34.62V191.17c0,23.69,8.74,34.26,36.44,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M911.08,106.25c0,48.84-28.8,65.6-94.4,65.6h-39V255H715.36V14.77H818.5c60.87,0,92.58,21.51,92.58,65.24ZM849.85,80c0-22.23-7.66-34.26-36.08-34.26H777.69v95.12h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M1043.38,167.11V255H980.69V167.11C956.64,117.91,929.3,64,905.25,14.77H976l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M1203,255h-63.78V14.77h107.88c58.31,0,92.93,15.67,92.93,60.87V89.12c0,41.91-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.11c46.29,0,53.94-8,53.94-28.06V80c0-20.41-4.74-33.89-41.18-33.89H1203Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M1368.84,255V14.77h62.68V255Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M1552.52,257.5c-48.47,0-102.78-3.28-102.78-65.6V78.19c0-62.69,59-66.7,105-66.7L1636,16.6V42.84H1555.8c-41.18,0-43.74,10.93-43.74,34.25V191.9c0,24.42,3.29,34.62,40.82,34.62h31V115h62.33V251.67Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M1804.73,255V146.34h-73.62c0,36.08.36,72.53.36,108.61h-63V14.77h62.69V115h73.62V14.77h62.32V255Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M1994.24,45.75V255h-62.68V45.75h-51.75v-31H2046v31Z\" fill=\"#fff\" data-v-23bee88a></path>", 16)
const _hoisted_19 = [
  CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_3
]
const CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_20 = { key: 1 }
const CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e6ae24\" data-v-23bee88a></polygon><path d=\"M59.1,166.22H52.58c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14.17,14.17,0,0,0-.39,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10L60,162Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M87.69,181.33c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H72.31l-4.19,19.56h5.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M117.86,173.13h-6.31a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2H104l-5.16,24.24H90.52l6.09-28.59,13.53-1.09c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#fff\" data-v-23bee88a></path><polygon points=\"119.9 144.89 113.99 144.89 115.53 137.67 111.43 137.67 107.66 155.47 111.75 155.47 113.39 147.76 119.31 147.76 117.67 155.47 121.76 155.47 125.54 137.67 121.44 137.67 119.9 144.89\" fill=\"#fff\" data-v-23bee88a></polygon><path d=\"M138.57,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M158.71,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,158.71,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,152.06,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-23bee88a></path><path d=\"M426,257.5c-48.1,0-102.41-5.1-102.41-65.6V78.19c0-61.23,55-66.7,102.41-66.7L484.3,16.6v27H426.71c-37.9,0-40.82,10.2-40.82,34.62V191.9c0,25.15,3.65,33.53,40.82,33.53H484.3v27Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M697.14,191.17c0,68.52-76.53,65.6-107.15,65.6-58,0-92.94-19.31-92.94-65.6V78.55c0-46.28,34.63-65.6,92.58-65.6h14.94c57.58,0,92.57,19.32,92.57,65.6ZM634.82,78.55c0-23.69-8.75-34.62-36.45-34.62h-2.55c-27.7,0-36.44,10.93-36.44,34.62V191.17c0,23.69,8.74,34.26,36.44,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M911.08,106.25c0,48.84-28.8,65.6-94.4,65.6h-39V255H715.36V14.77H818.5c60.87,0,92.58,21.51,92.58,65.24ZM849.85,80c0-22.23-7.66-34.26-36.08-34.26H777.69v95.12h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M1043.38,167.11V255H980.69V167.11C956.64,117.91,929.3,64,905.25,14.77H976l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M1203,255h-63.78V14.77h107.88c58.31,0,92.93,15.67,92.93,60.87V89.12c0,41.91-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.11c46.29,0,53.94-8,53.94-28.06V80c0-20.41-4.74-33.89-41.18-33.89H1203Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M1368.84,255V14.77h62.68V255Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M1552.52,257.5c-48.47,0-102.78-3.28-102.78-65.6V78.19c0-62.69,59-66.7,105-66.7L1636,16.6V42.84H1555.8c-41.18,0-43.74,10.93-43.74,34.25V191.9c0,24.42,3.29,34.62,40.82,34.62h31V115h62.33V251.67Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M1804.73,255V146.34h-73.62c0,36.08.36,72.53.36,108.61h-63V14.77h62.69V115h73.62V14.77h62.32V255Z\" fill=\"#e6ae24\" data-v-23bee88a></path><path d=\"M1994.24,45.75V255h-62.68V45.75h-51.75v-31H2046v31Z\" fill=\"#e6ae24\" data-v-23bee88a></path>", 16)
const _hoisted_37 = [
  CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_21
]

function CopyrightHubvue_type_template_id_23bee88a_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_2, _hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", CopyrightHubvue_type_template_id_23bee88a_scoped_true_hoisted_20, _hoisted_37))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/CopyrightHub.vue?vue&type=template&id=23bee88a&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/CopyrightHub.vue?vue&type=script&lang=js

  /* harmony default export */ var CopyrightHubvue_type_script_lang_js = ({
    name: "CopyrightHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/CopyrightHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/CopyrightHub.vue?vue&type=style&index=0&id=23bee88a&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/CopyrightHub.vue?vue&type=style&index=0&id=23bee88a&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/CopyrightHub.vue




;


const CopyrightHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CopyrightHubvue_type_script_lang_js, [['render',CopyrightHubvue_type_template_id_23bee88a_scoped_true_render],['__scopeId',"data-v-23bee88a"]])

/* harmony default export */ var CopyrightHub = (CopyrightHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/DutyPay.vue?vue&type=template&id=72c53864&scoped=true


const DutyPayvue_type_template_id_72c53864_scoped_true_withScopeId = n => (_pushScopeId("data-v-72c53864"),n=n(),_popScopeId(),n)
const DutyPayvue_type_template_id_72c53864_scoped_true_hoisted_1 = {
  key: 0,
  id: "dutypay-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "273.84",
  height: "60",
  viewBox: "0 0 273.84 60"
}
const DutyPayvue_type_template_id_72c53864_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"8.07 60 4.99 57.78 1.91 60 3.06 56.38 0 54.13 3.8 54.12 4.99 50.51 6.18 54.12 9.98 54.13 6.92 56.38 8.07 60\" fill=\"#ffffff\" data-v-72c53864></polygon><polygon points=\"31.4 60 28.31 57.78 25.23 60 26.39 56.38 23.32 54.13 27.12 54.12 28.31 50.51 29.5 54.12 33.3 54.13 30.24 56.38 31.4 60\" fill=\"#ffffff\" data-v-72c53864></polygon><polygon points=\"54.71 60 51.63 57.78 48.55 60 49.71 56.38 46.65 54.13 50.44 54.12 51.63 50.51 52.83 54.12 56.62 54.13 53.56 56.38 54.71 60\" fill=\"#ffffff\" data-v-72c53864></polygon><polygon points=\"78.04 60 74.96 57.78 71.87 60 73.03 56.38 69.97 54.13 73.77 54.12 74.96 50.51 76.15 54.12 79.94 54.13 76.88 56.38 78.04 60\" fill=\"#ffffff\" data-v-72c53864></polygon><polygon points=\"101.36 60 98.28 57.78 95.2 60 96.35 56.38 93.29 54.13 97.09 54.12 98.28 50.51 99.47 54.12 103.26 54.13 100.2 56.38 101.36 60\" fill=\"#ffffff\" data-v-72c53864></polygon><path d=\"M264.48,51.56a65.77,65.77,0,0,1,10.93.65,19,19,0,0,1,6.16,2.21A14.16,14.16,0,0,1,288,62a21.25,21.25,0,0,1,.66,11.4,27,27,0,0,1-4.81,11.37,24.28,24.28,0,0,1-9.16,7.53,25.73,25.73,0,0,1-7,2.18,69.44,69.44,0,0,1-11.18.65H236l7.94-43.52ZM254.3,60.29,249.6,86h8.83q7.8,0,12.47-3.28a14.3,14.3,0,0,0,5.81-9.61q1.16-6.32-2.29-9.59t-11.3-3.27Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#ffffff\" data-v-72c53864></path><path d=\"M331.84,62.58l-5.92,32.5H315.4l.89-4.89a23.67,23.67,0,0,1-6.79,4.27A19.91,19.91,0,0,1,302,95.87a17.78,17.78,0,0,1-7.28-1.31,8.43,8.43,0,0,1-4.24-3.81,8.68,8.68,0,0,1-.9-3.68,33.94,33.94,0,0,1,.74-6.58l3.26-17.9h10.52l-2.87,15.75c-.66,3.61-.57,6.09.29,7.43s2.64,2,5.36,2a11.88,11.88,0,0,0,7.64-2.42,10.68,10.68,0,0,0,3.85-6.75l2.93-16Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#ffffff\" data-v-72c53864></path><path d=\"M384.41,62.58l-13.66,23.2-5.25-23.2H349.68L351.24,54H340.73l-1.56,8.55h-4.95l-1.4,7.66h4.95l-3.31,18.15q-.76,4.15,1.52,6t8.34,1.84h7.1l1.43-7.84h-4.4c-1.52,0-2.44-.19-2.77-.58s-.29-1.66.1-3.83l2.51-13.74h7.62L363,95.85a5.09,5.09,0,0,1,.13,1,7.56,7.56,0,0,1-.1,1.26,3.59,3.59,0,0,1-1.4,2.43,5.15,5.15,0,0,1-3.11.83h-8.43l-1.63,9.88h9.69a22.8,22.8,0,0,0,3.4-.19,7.4,7.4,0,0,0,2.15-.69A11.05,11.05,0,0,0,367,108a25.65,25.65,0,0,0,3.17-4.1L396,62.58Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#ffffff\" data-v-72c53864></path><path d=\"M399.18,95.08l7.92-43.52h18.52q8.52,0,12.06,3.15t2.35,9.7q-1.18,6.51-5.88,9.67t-13.22,3.16H407L403.7,95.08ZM407.75,73h13.17q7.21,0,10.35-1.94c2.07-1.29,3.41-3.53,4-6.71s.08-5.47-1.54-6.78-4.82-2-9.62-2H410.93Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#ffffff\" data-v-72c53864></path><path d=\"M471.6,91,471,94.66a14.83,14.83,0,0,1-2,.44,10.37,10.37,0,0,1-1.76.15,3.48,3.48,0,0,1-3-1.13c-.54-.77-.73-2.06-.54-3.93a21.73,21.73,0,0,1-6.91,4.33,24,24,0,0,1-8.43,1.35c-4.05,0-7-.83-8.9-2.5s-2.55-4.05-2-7.09A9.69,9.69,0,0,1,439,82.45a11,11,0,0,1,3.18-3,14.74,14.74,0,0,1,4-1.62,79.08,79.08,0,0,1,8.35-1.41l3.52-.41q8.32-.95,9-4.54a3.59,3.59,0,0,0-1.63-4c-1.4-.92-3.62-1.37-6.65-1.37q-5.73,0-9,1.84a8.49,8.49,0,0,0-4.23,5.56h-4.33A13.29,13.29,0,0,1,447,65.13q4.44-2.79,11.91-2.79a24.7,24.7,0,0,1,7.53.91,7.55,7.55,0,0,1,4.1,3,6.16,6.16,0,0,1,.93,2.85A19.14,19.14,0,0,1,471,74l-.32,1.77-2.26,12.39a5.29,5.29,0,0,0-.09,2.66c.2.38.64.55,1.32.55a6,6,0,0,0,.95-.08,6.61,6.61,0,0,0,1-.22m-5.7-13.27a17.57,17.57,0,0,1-3.83,1.2q-2.51.54-8.13,1.34-7.43,1.09-9.56,2.33a5.28,5.28,0,0,0-2.6,3.76,3.93,3.93,0,0,0,1.59,4.13,9.92,9.92,0,0,0,6,1.54,19.3,19.3,0,0,0,10.55-2.75,10.57,10.57,0,0,0,5.15-7.19l.1-.5Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#ffffff\" data-v-72c53864></path><path d=\"M485.42,98.93q-3.18,4.83-5.72,6.25a13.09,13.09,0,0,1-6.56,1.39,10.11,10.11,0,0,1-1.65-.14c-.59-.11-1.26-.26-2-.45l.74-4q1.33.27,2.37.39a12.16,12.16,0,0,0,1.81.14,7,7,0,0,0,4.42-1.49A25.32,25.32,0,0,0,483.62,95l-9.45-31.8h5.05l7.44,27.67,17.63-27.67h4.85Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#ffffff\" data-v-72c53864></path>", 11)
const _hoisted_13 = [
  DutyPayvue_type_template_id_72c53864_scoped_true_hoisted_2
]
const _hoisted_14 = {
  key: 1,
  id: "dutypay-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "273.84",
  height: "60",
  viewBox: "0 0 273.84 60"
}
const _hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"8.07 60 4.99 57.78 1.91 60 3.06 56.38 0 54.13 3.8 54.12 4.99 50.51 6.18 54.12 9.98 54.13 6.92 56.38 8.07 60\" fill=\"#000000\" data-v-72c53864></polygon><polygon points=\"31.4 60 28.31 57.78 25.23 60 26.39 56.38 23.32 54.13 27.12 54.12 28.31 50.51 29.5 54.12 33.3 54.13 30.24 56.38 31.4 60\" fill=\"#000000\" data-v-72c53864></polygon><polygon points=\"54.71 60 51.63 57.78 48.55 60 49.71 56.38 46.65 54.13 50.44 54.12 51.63 50.51 52.83 54.12 56.62 54.13 53.56 56.38 54.71 60\" fill=\"#000000\" data-v-72c53864></polygon><polygon points=\"78.04 60 74.96 57.78 71.87 60 73.03 56.38 69.97 54.13 73.77 54.12 74.96 50.51 76.15 54.12 79.94 54.13 76.88 56.38 78.04 60\" fill=\"#000000\" data-v-72c53864></polygon><polygon points=\"101.36 60 98.28 57.78 95.2 60 96.35 56.38 93.29 54.13 97.09 54.12 98.28 50.51 99.47 54.12 103.26 54.13 100.2 56.38 101.36 60\" fill=\"#000000\" data-v-72c53864></polygon><path d=\"M264.48,51.56a65.77,65.77,0,0,1,10.93.65,19,19,0,0,1,6.16,2.21A14.16,14.16,0,0,1,288,62a21.25,21.25,0,0,1,.66,11.4,27,27,0,0,1-4.81,11.37,24.28,24.28,0,0,1-9.16,7.53,25.73,25.73,0,0,1-7,2.18,69.44,69.44,0,0,1-11.18.65H236l7.94-43.52ZM254.3,60.29,249.6,86h8.83q7.8,0,12.47-3.28a14.3,14.3,0,0,0,5.81-9.61q1.16-6.32-2.29-9.59t-11.3-3.27Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#000000\" data-v-72c53864></path><path d=\"M331.84,62.58l-5.92,32.5H315.4l.89-4.89a23.67,23.67,0,0,1-6.79,4.27A19.91,19.91,0,0,1,302,95.87a17.78,17.78,0,0,1-7.28-1.31,8.43,8.43,0,0,1-4.24-3.81,8.68,8.68,0,0,1-.9-3.68,33.94,33.94,0,0,1,.74-6.58l3.26-17.9h10.52l-2.87,15.75c-.66,3.61-.57,6.09.29,7.43s2.64,2,5.36,2a11.88,11.88,0,0,0,7.64-2.42,10.68,10.68,0,0,0,3.85-6.75l2.93-16Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#000000\" data-v-72c53864></path><path d=\"M384.41,62.58l-13.66,23.2-5.25-23.2H349.68L351.24,54H340.73l-1.56,8.55h-4.95l-1.4,7.66h4.95l-3.31,18.15q-.76,4.15,1.52,6t8.34,1.84h7.1l1.43-7.84h-4.4c-1.52,0-2.44-.19-2.77-.58s-.29-1.66.1-3.83l2.51-13.74h7.62L363,95.85a5.09,5.09,0,0,1,.13,1,7.56,7.56,0,0,1-.1,1.26,3.59,3.59,0,0,1-1.4,2.43,5.15,5.15,0,0,1-3.11.83h-8.43l-1.63,9.88h9.69a22.8,22.8,0,0,0,3.4-.19,7.4,7.4,0,0,0,2.15-.69A11.05,11.05,0,0,0,367,108a25.65,25.65,0,0,0,3.17-4.1L396,62.58Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#000000\" data-v-72c53864></path><path d=\"M399.18,95.08l7.92-43.52h18.52q8.52,0,12.06,3.15t2.35,9.7q-1.18,6.51-5.88,9.67t-13.22,3.16H407L403.7,95.08ZM407.75,73h13.17q7.21,0,10.35-1.94c2.07-1.29,3.41-3.53,4-6.71s.08-5.47-1.54-6.78-4.82-2-9.62-2H410.93Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#000000\" data-v-72c53864></path><path d=\"M471.6,91,471,94.66a14.83,14.83,0,0,1-2,.44,10.37,10.37,0,0,1-1.76.15,3.48,3.48,0,0,1-3-1.13c-.54-.77-.73-2.06-.54-3.93a21.73,21.73,0,0,1-6.91,4.33,24,24,0,0,1-8.43,1.35c-4.05,0-7-.83-8.9-2.5s-2.55-4.05-2-7.09A9.69,9.69,0,0,1,439,82.45a11,11,0,0,1,3.18-3,14.74,14.74,0,0,1,4-1.62,79.08,79.08,0,0,1,8.35-1.41l3.52-.41q8.32-.95,9-4.54a3.59,3.59,0,0,0-1.63-4c-1.4-.92-3.62-1.37-6.65-1.37q-5.73,0-9,1.84a8.49,8.49,0,0,0-4.23,5.56h-4.33A13.29,13.29,0,0,1,447,65.13q4.44-2.79,11.91-2.79a24.7,24.7,0,0,1,7.53.91,7.55,7.55,0,0,1,4.1,3,6.16,6.16,0,0,1,.93,2.85A19.14,19.14,0,0,1,471,74l-.32,1.77-2.26,12.39a5.29,5.29,0,0,0-.09,2.66c.2.38.64.55,1.32.55a6,6,0,0,0,.95-.08,6.61,6.61,0,0,0,1-.22m-5.7-13.27a17.57,17.57,0,0,1-3.83,1.2q-2.51.54-8.13,1.34-7.43,1.09-9.56,2.33a5.28,5.28,0,0,0-2.6,3.76,3.93,3.93,0,0,0,1.59,4.13,9.92,9.92,0,0,0,6,1.54,19.3,19.3,0,0,0,10.55-2.75,10.57,10.57,0,0,0,5.15-7.19l.1-.5Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#000000\" data-v-72c53864></path><path d=\"M485.42,98.93q-3.18,4.83-5.72,6.25a13.09,13.09,0,0,1-6.56,1.39,10.11,10.11,0,0,1-1.65-.14c-.59-.11-1.26-.26-2-.45l.74-4q1.33.27,2.37.39a12.16,12.16,0,0,0,1.81.14,7,7,0,0,0,4.42-1.49A25.32,25.32,0,0,0,483.62,95l-9.45-31.8h5.05l7.44,27.67,17.63-27.67h4.85Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#000000\" data-v-72c53864></path>", 11)
const _hoisted_26 = [
  _hoisted_15
]
const _hoisted_27 = {
  key: 2,
  id: "dutypay-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "273.84",
  height: "60",
  viewBox: "0 0 273.84 60"
}
const _hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"8.07 60 4.99 57.78 1.91 60 3.06 56.38 0 54.13 3.8 54.12 4.99 50.51 6.18 54.12 9.98 54.13 6.92 56.38 8.07 60\" fill=\"#eeb111\" data-v-72c53864></polygon><polygon points=\"31.4 60 28.31 57.78 25.23 60 26.39 56.38 23.32 54.13 27.12 54.12 28.31 50.51 29.5 54.12 33.3 54.13 30.24 56.38 31.4 60\" fill=\"#eeb111\" data-v-72c53864></polygon><polygon points=\"54.71 60 51.63 57.78 48.55 60 49.71 56.38 46.65 54.13 50.44 54.12 51.63 50.51 52.83 54.12 56.62 54.13 53.56 56.38 54.71 60\" fill=\"#eeb111\" data-v-72c53864></polygon><polygon points=\"78.04 60 74.96 57.78 71.87 60 73.03 56.38 69.97 54.13 73.77 54.12 74.96 50.51 76.15 54.12 79.94 54.13 76.88 56.38 78.04 60\" fill=\"#eeb111\" data-v-72c53864></polygon><polygon points=\"101.36 60 98.28 57.78 95.2 60 96.35 56.38 93.29 54.13 97.09 54.12 98.28 50.51 99.47 54.12 103.26 54.13 100.2 56.38 101.36 60\" fill=\"#eeb111\" data-v-72c53864></polygon><path d=\"M264.48,51.56a65.77,65.77,0,0,1,10.93.65,19,19,0,0,1,6.16,2.21A14.16,14.16,0,0,1,288,62a21.25,21.25,0,0,1,.66,11.4,27,27,0,0,1-4.81,11.37,24.28,24.28,0,0,1-9.16,7.53,25.73,25.73,0,0,1-7,2.18,69.44,69.44,0,0,1-11.18.65H236l7.94-43.52ZM254.3,60.29,249.6,86h8.83q7.8,0,12.47-3.28a14.3,14.3,0,0,0,5.81-9.61q1.16-6.32-2.29-9.59t-11.3-3.27Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#221f72\" data-v-72c53864></path><path d=\"M331.84,62.58l-5.92,32.5H315.4l.89-4.89a23.67,23.67,0,0,1-6.79,4.27A19.91,19.91,0,0,1,302,95.87a17.78,17.78,0,0,1-7.28-1.31,8.43,8.43,0,0,1-4.24-3.81,8.68,8.68,0,0,1-.9-3.68,33.94,33.94,0,0,1,.74-6.58l3.26-17.9h10.52l-2.87,15.75c-.66,3.61-.57,6.09.29,7.43s2.64,2,5.36,2a11.88,11.88,0,0,0,7.64-2.42,10.68,10.68,0,0,0,3.85-6.75l2.93-16Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#221f72\" data-v-72c53864></path><path d=\"M384.41,62.58l-13.66,23.2-5.25-23.2H349.68L351.24,54H340.73l-1.56,8.55h-4.95l-1.4,7.66h4.95l-3.31,18.15q-.76,4.15,1.52,6t8.34,1.84h7.1l1.43-7.84h-4.4c-1.52,0-2.44-.19-2.77-.58s-.29-1.66.1-3.83l2.51-13.74h7.62L363,95.85a5.09,5.09,0,0,1,.13,1,7.56,7.56,0,0,1-.1,1.26,3.59,3.59,0,0,1-1.4,2.43,5.15,5.15,0,0,1-3.11.83h-8.43l-1.63,9.88h9.69a22.8,22.8,0,0,0,3.4-.19,7.4,7.4,0,0,0,2.15-.69A11.05,11.05,0,0,0,367,108a25.65,25.65,0,0,0,3.17-4.1L396,62.58Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#221f72\" data-v-72c53864></path><path d=\"M399.18,95.08l7.92-43.52h18.52q8.52,0,12.06,3.15t2.35,9.7q-1.18,6.51-5.88,9.67t-13.22,3.16H407L403.7,95.08ZM407.75,73h13.17q7.21,0,10.35-1.94c2.07-1.29,3.41-3.53,4-6.71s.08-5.47-1.54-6.78-4.82-2-9.62-2H410.93Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#007dc3\" data-v-72c53864></path><path d=\"M471.6,91,471,94.66a14.83,14.83,0,0,1-2,.44,10.37,10.37,0,0,1-1.76.15,3.48,3.48,0,0,1-3-1.13c-.54-.77-.73-2.06-.54-3.93a21.73,21.73,0,0,1-6.91,4.33,24,24,0,0,1-8.43,1.35c-4.05,0-7-.83-8.9-2.5s-2.55-4.05-2-7.09A9.69,9.69,0,0,1,439,82.45a11,11,0,0,1,3.18-3,14.74,14.74,0,0,1,4-1.62,79.08,79.08,0,0,1,8.35-1.41l3.52-.41q8.32-.95,9-4.54a3.59,3.59,0,0,0-1.63-4c-1.4-.92-3.62-1.37-6.65-1.37q-5.73,0-9,1.84a8.49,8.49,0,0,0-4.23,5.56h-4.33A13.29,13.29,0,0,1,447,65.13q4.44-2.79,11.91-2.79a24.7,24.7,0,0,1,7.53.91,7.55,7.55,0,0,1,4.1,3,6.16,6.16,0,0,1,.93,2.85A19.14,19.14,0,0,1,471,74l-.32,1.77-2.26,12.39a5.29,5.29,0,0,0-.09,2.66c.2.38.64.55,1.32.55a6,6,0,0,0,.95-.08,6.61,6.61,0,0,0,1-.22m-5.7-13.27a17.57,17.57,0,0,1-3.83,1.2q-2.51.54-8.13,1.34-7.43,1.09-9.56,2.33a5.28,5.28,0,0,0-2.6,3.76,3.93,3.93,0,0,0,1.59,4.13,9.92,9.92,0,0,0,6,1.54,19.3,19.3,0,0,0,10.55-2.75,10.57,10.57,0,0,0,5.15-7.19l.1-.5Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#007dc3\" data-v-72c53864></path><path d=\"M485.42,98.93q-3.18,4.83-5.72,6.25a13.09,13.09,0,0,1-6.56,1.39,10.11,10.11,0,0,1-1.65-.14c-.59-.11-1.26-.26-2-.45l.74-4q1.33.27,2.37.39a12.16,12.16,0,0,0,1.81.14,7,7,0,0,0,4.42-1.49A25.32,25.32,0,0,0,483.62,95l-9.45-31.8h5.05l7.44,27.67,17.63-27.67h4.85Z\" transform=\"translate(-235.3 -51.56)\" fill=\"#007dc3\" data-v-72c53864></path>", 11)
const DutyPayvue_type_template_id_72c53864_scoped_true_hoisted_39 = [
  _hoisted_28
]

function DutyPayvue_type_template_id_72c53864_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version === 'light')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DutyPayvue_type_template_id_72c53864_scoped_true_hoisted_1, _hoisted_13))
    : ($props.version === 'dark')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_14, _hoisted_26))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_27, DutyPayvue_type_template_id_72c53864_scoped_true_hoisted_39))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/DutyPay.vue?vue&type=template&id=72c53864&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/DutyPay.vue?vue&type=script&lang=js

  /* harmony default export */ var DutyPayvue_type_script_lang_js = ({
    name: "DutyPay",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/DutyPay.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/DutyPay.vue?vue&type=style&index=0&id=72c53864&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/DutyPay.vue?vue&type=style&index=0&id=72c53864&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/DutyPay.vue




;


const DutyPay_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DutyPayvue_type_script_lang_js, [['render',DutyPayvue_type_template_id_72c53864_scoped_true_render],['__scopeId',"data-v-72c53864"]])

/* harmony default export */ var DutyPay = (DutyPay_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ECompanyHub.vue?vue&type=template&id=399593be&scoped=true


const ECompanyHubvue_type_template_id_399593be_scoped_true_withScopeId = n => (_pushScopeId("data-v-399593be"),n=n(),_popScopeId(),n)
const ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2069.6",
  height: "267",
  viewBox: "0 0 2069.6 267"
}
const ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_2 = { key: 0 }
const ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-399593be></polygon><path d=\"M55.1,166.72H48.58c-5.11,0-5.76,1.09-6.63,4.95l-2.18,10.27a14.9,14.9,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M98.42,191.35c-5.65,0-7.5,0-7.5-2.94A41.63,41.63,0,0,1,92,182l2.17-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.69-2.61h-6a12,12,0,0,1,.44,3,9.7,9.7,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.94,13.37H72.33l4.13-19.46a12.88,12.88,0,0,0,.33-2.28c0-1.69-.92-2.45-3.7-2.45H68.15L63,191.35H54.67l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a10.86,10.86,0,0,1-.27,2.55Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M132,181.83c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L105,181.89l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66h-5.44l-4.18,19.56h5.49c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#099192\" data-v-399593be></path><polygon points=\"123.9 144.39 117.99 144.39 119.53 137.17 115.43 137.17 111.66 154.97 115.75 154.97 117.39 147.26 123.31 147.26 121.67 154.97 125.76 154.97 129.54 137.17 125.44 137.17 123.9 144.39\" fill=\"#099192\" data-v-399593be></polygon><path d=\"M142.57,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M162.71,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.73,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.71,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.06,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M325.84,254.32V14.14H477.45V44.76h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M592.62,256.87c-48.11,0-102.42-5.1-102.42-65.6V77.56c0-61.23,55-66.7,102.42-66.7L650.93,16v27H593.35c-37.91,0-40.82,10.2-40.82,34.62V191.27c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M856.48,190.54c0,68.52-76.53,65.6-107.15,65.6-58,0-92.93-19.31-92.93-65.6V77.92c0-46.28,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.32,92.57,65.6ZM794.16,77.92c0-23.69-8.75-34.62-36.44-34.62h-2.56c-27.69,0-36.44,10.93-36.44,34.62V190.54c0,23.69,8.75,34.26,36.44,34.26h2.56c27.69,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M1131.65,254.32V48.77h-14.22l-68.15,205.55H999.35L929.74,48.77H916.25V254.32H875.8V14.14H980.4l57.95,173.12,55.76-173.12h98.4V254.32Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M1411.55,105.62c0,48.84-28.79,65.6-94.39,65.6h-39v83.1h-62.32V14.14H1319c60.86,0,92.57,21.51,92.57,65.24Zm-61.23-26.24c0-22.23-7.65-34.26-36.08-34.26h-36.08v95.12h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M1546.4,254.32l-10.2-53.94v.73h-86v-.73l-11.3,53.94h-51.75l66.69-240.18h94.39l69.62,240.18ZM1503.76,42.94h-21.14l-25.87,127.19h74Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M1760.7,254.32,1668.13,74.64V254.32H1628V14.14h71.8l89.66,177.13V14.14h39.72V254.32Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M1981.57,166.49v87.83h-62.69V166.49c-24.05-49.21-51.39-103.15-75.44-152.35h70.7l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#fff\" data-v-399593be></path>", 15)
const _hoisted_18 = [
  ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_3
]
const ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_19 = { key: 1 }
const ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#099192\" data-v-399593be></polygon><path d=\"M55.1,166.72H48.58c-5.11,0-5.76,1.09-6.63,4.95l-2.18,10.27a14.9,14.9,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M98.42,191.35c-5.65,0-7.5,0-7.5-2.94A41.63,41.63,0,0,1,92,182l2.17-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.69-2.61h-6a12,12,0,0,1,.44,3,9.7,9.7,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.94,13.37H72.33l4.13-19.46a12.88,12.88,0,0,0,.33-2.28c0-1.69-.92-2.45-3.7-2.45H68.15L63,191.35H54.67l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a10.86,10.86,0,0,1-.27,2.55Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M132,181.83c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L105,181.89l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66h-5.44l-4.18,19.56h5.49c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#fff\" data-v-399593be></path><polygon points=\"123.9 144.39 117.99 144.39 119.53 137.17 115.43 137.17 111.66 154.97 115.75 154.97 117.39 147.26 123.31 147.26 121.67 154.97 125.76 154.97 129.54 137.17 125.44 137.17 123.9 144.39\" fill=\"#fff\" data-v-399593be></polygon><path d=\"M142.57,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M162.71,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.73,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.71,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.06,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-399593be></path><path d=\"M325.84,254.32V14.14H477.45V44.76h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M592.62,256.87c-48.11,0-102.42-5.1-102.42-65.6V77.56c0-61.23,55-66.7,102.42-66.7L650.93,16v27H593.35c-37.91,0-40.82,10.2-40.82,34.62V191.27c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M856.48,190.54c0,68.52-76.53,65.6-107.15,65.6-58,0-92.93-19.31-92.93-65.6V77.92c0-46.28,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.32,92.57,65.6ZM794.16,77.92c0-23.69-8.75-34.62-36.44-34.62h-2.56c-27.69,0-36.44,10.93-36.44,34.62V190.54c0,23.69,8.75,34.26,36.44,34.26h2.56c27.69,0,36.44-10.57,36.44-34.26Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M1131.65,254.32V48.77h-14.22l-68.15,205.55H999.35L929.74,48.77H916.25V254.32H875.8V14.14H980.4l57.95,173.12,55.76-173.12h98.4V254.32Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M1411.55,105.62c0,48.84-28.79,65.6-94.39,65.6h-39v83.1h-62.32V14.14H1319c60.86,0,92.57,21.51,92.57,65.24Zm-61.23-26.24c0-22.23-7.65-34.26-36.08-34.26h-36.08v95.12h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M1546.4,254.32l-10.2-53.94v.73h-86v-.73l-11.3,53.94h-51.75l66.69-240.18h94.39l69.62,240.18ZM1503.76,42.94h-21.14l-25.87,127.19h74Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M1760.7,254.32,1668.13,74.64V254.32H1628V14.14h71.8l89.66,177.13V14.14h39.72V254.32Z\" fill=\"#099192\" data-v-399593be></path><path d=\"M1981.57,166.49v87.83h-62.69V166.49c-24.05-49.21-51.39-103.15-75.44-152.35h70.7l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#099192\" data-v-399593be></path>", 15)
const _hoisted_35 = [
  ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_20
]

function ECompanyHubvue_type_template_id_399593be_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_2, _hoisted_18))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ECompanyHubvue_type_template_id_399593be_scoped_true_hoisted_19, _hoisted_35))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ECompanyHub.vue?vue&type=template&id=399593be&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ECompanyHub.vue?vue&type=script&lang=js

  /* harmony default export */ var ECompanyHubvue_type_script_lang_js = ({
    name: "ECompanyHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ECompanyHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ECompanyHub.vue?vue&type=style&index=0&id=399593be&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ECompanyHub.vue?vue&type=style&index=0&id=399593be&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ECompanyHub.vue




;


const ECompanyHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ECompanyHubvue_type_script_lang_js, [['render',ECompanyHubvue_type_template_id_399593be_scoped_true_render],['__scopeId',"data-v-399593be"]])

/* harmony default export */ var ECompanyHub = (ECompanyHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/EIdHub.vue?vue&type=template&id=09888d52&scoped=true


const EIdHubvue_type_template_id_09888d52_scoped_true_withScopeId = n => (_pushScopeId("data-v-09888d52"),n=n(),_popScopeId(),n)
const EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "808.94",
  height: "267",
  viewBox: "0 0 808.94 267"
}
const EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_2 = { key: 0 }
const EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-09888d52></polygon><path d=\"M66.1,175.54c-1.52,7.17-4.07,9.4-11.79,9.4L45.78,184l-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.76,2.34,3.75,2.34H61.92l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a14.26,14.26,0,0,1,.32-2.83l2.18-10.16c1.41-6.63,6.74-9.89,14.56-9.89h2c6.91,0,10.71,2.34,10.71,7.28a12.2,12.2,0,0,1-.32,2.66Zm-8-3.32c0-1.68-.87-2.44-3.64-2.44H53.33c-3.64,0-4.95,2-5.6,4.94l-1.25,5.71h3.7c5.81,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,58.06,172.22Z\" fill=\"#e83c89\" data-v-09888d52></path><path d=\"M77.84,194.35H68.06l7.61-35.82h9.78Z\" fill=\"#e83c89\" data-v-09888d52></path><path d=\"M115.67,184.51c-1.52,6.52-6.9,9.84-16,9.84H83.44l7.61-35.82h16.14c8,0,12.23,2.5,12.23,7.55a12.65,12.65,0,0,1-.27,2.34Zm-6.19-16.14a9.62,9.62,0,0,0,.27-2c0-2-1.14-2.88-4.4-2.88H99.64L94.1,189.4h5.54c4.35,0,5.71-1.63,6.41-5Z\" fill=\"#e83c89\" data-v-09888d52></path><polygon points=\"117.9 141.39 111.99 141.39 113.53 134.17 109.43 134.17 105.66 151.97 109.75 151.97 111.39 144.26 117.31 144.26 115.67 151.97 119.76 151.97 123.54 134.17 119.44 134.17 117.9 141.39\" fill=\"#e83c89\" data-v-09888d52></polygon><path d=\"M136.57,134.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e83c89\" data-v-09888d52></path><path d=\"M156.71,135.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,156.71,135.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,150.06,141.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#e83c89\" data-v-09888d52></path><path d=\"M325.84,255.44V15.25H477.46V45.86H389.25v69.62h69.62v31.34H389.25v77.64h88.21v31Z\" fill=\"#fff\" data-v-09888d52></path><path d=\"M509.89,255.44V15.25h62.69V255.44Z\" fill=\"#fff\" data-v-09888d52></path><path d=\"M802.92,189.83c0,44.47-30.62,65.61-92.58,65.61H603.19V15.25H710.34c61.23,0,92.58,21.87,92.58,65.6Zm-62.33-109c0-22.59-7.65-34.26-36.45-34.26h-39V224.46h39c29.53,0,36.45-11.3,36.45-34.63Z\" fill=\"#fff\" data-v-09888d52></path>", 10)
const EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_13 = [
  EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_3
]
const EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_14 = { key: 1 }
const EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e83c89\" data-v-09888d52></polygon><path d=\"M66.1,175.54c-1.52,7.17-4.07,9.4-11.79,9.4L45.78,184l-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.76,2.34,3.75,2.34H61.92l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a14.26,14.26,0,0,1,.32-2.83l2.18-10.16c1.41-6.63,6.74-9.89,14.56-9.89h2c6.91,0,10.71,2.34,10.71,7.28a12.2,12.2,0,0,1-.32,2.66Zm-8-3.32c0-1.68-.87-2.44-3.64-2.44H53.33c-3.64,0-4.95,2-5.6,4.94l-1.25,5.71h3.7c5.81,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,58.06,172.22Z\" fill=\"#fff\" data-v-09888d52></path><path d=\"M77.84,194.35H68.06l7.61-35.82h9.78Z\" fill=\"#fff\" data-v-09888d52></path><path d=\"M115.67,184.51c-1.52,6.52-6.9,9.84-16,9.84H83.44l7.61-35.82h16.14c8,0,12.23,2.5,12.23,7.55a12.65,12.65,0,0,1-.27,2.34Zm-6.19-16.14a9.62,9.62,0,0,0,.27-2c0-2-1.14-2.88-4.4-2.88H99.64L94.1,189.4h5.54c4.35,0,5.71-1.63,6.41-5Z\" fill=\"#fff\" data-v-09888d52></path><polygon points=\"117.9 141.39 111.99 141.39 113.53 134.17 109.43 134.17 105.66 151.97 109.75 151.97 111.39 144.26 117.31 144.26 115.67 151.97 119.76 151.97 123.54 134.17 119.44 134.17 117.9 141.39\" fill=\"#fff\" data-v-09888d52></polygon><path d=\"M136.57,134.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-09888d52></path><path d=\"M156.71,135.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,156.71,135.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,150.06,141.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-09888d52></path><path d=\"M325.84,255.44V15.25H477.46V45.86H389.25v69.62h69.62v31.34H389.25v77.64h88.21v31Z\" fill=\"#e83c89\" data-v-09888d52></path><path d=\"M509.89,255.44V15.25h62.69V255.44Z\" fill=\"#e83c89\" data-v-09888d52></path><path d=\"M802.92,189.83c0,44.47-30.62,65.61-92.58,65.61H603.19V15.25H710.34c61.23,0,92.58,21.87,92.58,65.6Zm-62.33-109c0-22.59-7.65-34.26-36.45-34.26h-39V224.46h39c29.53,0,36.45-11.3,36.45-34.63Z\" fill=\"#e83c89\" data-v-09888d52></path>", 10)
const _hoisted_25 = [
  EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_15
]

function EIdHubvue_type_template_id_09888d52_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_2, EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_13))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", EIdHubvue_type_template_id_09888d52_scoped_true_hoisted_14, _hoisted_25))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/EIdHub.vue?vue&type=template&id=09888d52&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/EIdHub.vue?vue&type=script&lang=js

  /* harmony default export */ var EIdHubvue_type_script_lang_js = ({
    name: "EIdHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/EIdHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/EIdHub.vue?vue&type=style&index=0&id=09888d52&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/EIdHub.vue?vue&type=style&index=0&id=09888d52&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/EIdHub.vue




;


const EIdHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(EIdHubvue_type_script_lang_js, [['render',EIdHubvue_type_template_id_09888d52_scoped_true_render],['__scopeId',"data-v-09888d52"]])

/* harmony default export */ var EIdHub = (EIdHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ExciseHub.vue?vue&type=template&id=e1e8211a&scoped=true


const ExciseHubvue_type_template_id_e1e8211a_scoped_true_withScopeId = n => (_pushScopeId("data-v-e1e8211a"),n=n(),_popScopeId(),n)
const ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1307.51",
  height: "267",
  viewBox: "0 0 1307.51 267"
}
const ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_2 = { key: 0 }
const ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-e1e8211a></polygon><path d=\"M62.71,172c-1.52,7.18-4.07,9.4-11.79,9.4l-8.53-.92-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.77,2.34,3.75,2.34H58.53l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a13.61,13.61,0,0,1,.33-2.83l2.17-10.16c1.41-6.63,6.74-9.89,14.57-9.89h2c6.9,0,10.7,2.34,10.7,7.28a11.76,11.76,0,0,1-.32,2.67Zm-8-3.31c0-1.69-.87-2.45-3.64-2.45H49.94c-3.64,0-4.94,2-5.6,4.95l-1.25,5.7h3.7c5.82,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,54.67,168.67Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M86.3,175.41,92,190.79h-9.3l-3.58-12.07H76.52l-8.15,12.07H60.11L72.17,175.3l-4.89-13.65h9.4l3.1,10.82H82l9-10.82h7.34Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M119.68,166.17h-6.52c-5.11,0-5.76,1.08-6.63,4.94l-2.18,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10.05c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><polygon points=\"121.29 144.94 115.38 144.94 116.91 137.73 112.82 137.73 109.05 155.53 113.14 155.53 114.78 147.82 120.7 147.82 119.06 155.53 123.15 155.53 126.92 137.73 122.83 137.73 121.29 144.94\" fill=\"#38d2dd\" data-v-e1e8211a></polygon><path d=\"M140,137.8l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44H134a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M160.09,139.39c-.86-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.09,139.39ZM153.45,145h-2.58c.22-1,.42-1.95.62-2.93l.28-1.36H154c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.45,145Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M325.84,254.16V14H477.45V44.6h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M640.36,254.16,598.45,147.74H579.86L538.31,254.16H484l62-128.29C528.47,90.16,507.7,49.34,490.2,14h70l34.26,86.37h20.41C625.42,71.93,636.72,42.78,647.28,14H699L649.47,125.87c19.68,41.91,41.55,86.38,61.23,128.29Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M809.47,256.71c-48.11,0-102.41-5.1-102.41-65.6V77.4c0-61.23,55-66.7,102.41-66.7l58.31,5.11v27H810.2c-37.91,0-40.82,10.2-40.82,34.62V191.11c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M885.64,254.16V14h62.69V254.16Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M1136.75,188.56c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.37h63.05c40.82,0,43-15.31,43-34.26V177.26L967.64,113.48c-2.55-6.92-6.19-17.13-6.19-29.52,0-44.46,24.78-73.26,91.84-73.26l72.16,5.84V42.41h-45.92c-46.29,0-50.66,13.85-50.66,35.35V88l99.86,62c4,8,8,21.5,8,33.16Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M1149.87,254.16V14h151.61V44.6h-88.19v69.61h69.61v31.34h-69.61v77.63h88.19v31Z\" fill=\"#fff\" data-v-e1e8211a></path>", 13)
const _hoisted_16 = [
  ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_3
]
const _hoisted_17 = { key: 1 }
const ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#38d2dd\" data-v-e1e8211a></polygon><path d=\"M62.71,172c-1.52,7.18-4.07,9.4-11.79,9.4l-8.53-.92-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.77,2.34,3.75,2.34H58.53l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a13.61,13.61,0,0,1,.33-2.83l2.17-10.16c1.41-6.63,6.74-9.89,14.57-9.89h2c6.9,0,10.7,2.34,10.7,7.28a11.76,11.76,0,0,1-.32,2.67Zm-8-3.31c0-1.69-.87-2.45-3.64-2.45H49.94c-3.64,0-4.94,2-5.6,4.95l-1.25,5.7h3.7c5.82,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,54.67,168.67Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M86.3,175.41,92,190.79h-9.3l-3.58-12.07H76.52l-8.15,12.07H60.11L72.17,175.3l-4.89-13.65h9.4l3.1,10.82H82l9-10.82h7.34Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M119.68,166.17h-6.52c-5.11,0-5.76,1.08-6.63,4.94l-2.18,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10.05c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-e1e8211a></path><polygon points=\"121.29 144.94 115.38 144.94 116.91 137.73 112.82 137.73 109.05 155.53 113.14 155.53 114.78 147.82 120.7 147.82 119.06 155.53 123.15 155.53 126.92 137.73 122.83 137.73 121.29 144.94\" fill=\"#fff\" data-v-e1e8211a></polygon><path d=\"M140,137.8l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44H134a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M160.09,139.39c-.86-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.09,139.39ZM153.45,145h-2.58c.22-1,.42-1.95.62-2.93l.28-1.36H154c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.45,145Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-e1e8211a></path><path d=\"M325.84,254.16V14H477.45V44.6h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M640.36,254.16,598.45,147.74H579.86L538.31,254.16H484l62-128.29C528.47,90.16,507.7,49.34,490.2,14h70l34.26,86.37h20.41C625.42,71.93,636.72,42.78,647.28,14H699L649.47,125.87c19.68,41.91,41.55,86.38,61.23,128.29Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M809.47,256.71c-48.11,0-102.41-5.1-102.41-65.6V77.4c0-61.23,55-66.7,102.41-66.7l58.31,5.11v27H810.2c-37.91,0-40.82,10.2-40.82,34.62V191.11c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M885.64,254.16V14h62.69V254.16Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M1136.75,188.56c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.37h63.05c40.82,0,43-15.31,43-34.26V177.26L967.64,113.48c-2.55-6.92-6.19-17.13-6.19-29.52,0-44.46,24.78-73.26,91.84-73.26l72.16,5.84V42.41h-45.92c-46.29,0-50.66,13.85-50.66,35.35V88l99.86,62c4,8,8,21.5,8,33.16Z\" fill=\"#38d2dd\" data-v-e1e8211a></path><path d=\"M1149.87,254.16V14h151.61V44.6h-88.19v69.61h69.61v31.34h-69.61v77.63h88.19v31Z\" fill=\"#38d2dd\" data-v-e1e8211a></path>", 13)
const _hoisted_31 = [
  ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_18
]

function ExciseHubvue_type_template_id_e1e8211a_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ExciseHubvue_type_template_id_e1e8211a_scoped_true_hoisted_2, _hoisted_16))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_17, _hoisted_31))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExciseHub.vue?vue&type=template&id=e1e8211a&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ExciseHub.vue?vue&type=script&lang=js

  /* harmony default export */ var ExciseHubvue_type_script_lang_js = ({
    name: "ExciseHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExciseHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ExciseHub.vue?vue&type=style&index=0&id=e1e8211a&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExciseHub.vue?vue&type=style&index=0&id=e1e8211a&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExciseHub.vue




;


const ExciseHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ExciseHubvue_type_script_lang_js, [['render',ExciseHubvue_type_template_id_e1e8211a_scoped_true_render],['__scopeId',"data-v-e1e8211a"]])

/* harmony default export */ var ExciseHub = (ExciseHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ExpertHub.vue?vue&type=template&id=1b42e4d6&scoped=true


const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_withScopeId = n => (_pushScopeId("data-v-1b42e4d6"),n=n(),_popScopeId(),n)
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1531.66",
  height: "267",
  viewBox: "0 0 1531.66 267"
}
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_2 = { key: 0 }
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-1b42e4d6></polygon><path d=\"M58.64,172.81c-1.41,6.65-3.78,8.72-10.93,8.72l-7.91-.86-.2.76a12.23,12.23,0,0,0-.41,2.42c0,1.31.71,2.16,3.48,2.16H54.76l-.8,3.83-12.6.81c-6.65,0-9.87-2.12-9.87-6.6a12.77,12.77,0,0,1,.3-2.62l2-9.42c1.31-6.15,6.25-9.17,13.51-9.17h1.86c6.4,0,9.93,2.16,9.93,6.75a10.63,10.63,0,0,1-.31,2.47Zm-7.45-3.07c0-1.56-.81-2.27-3.38-2.27h-1c-3.37,0-4.58,1.82-5.19,4.59l-1.16,5.29h3.43c5.39,0,6-.86,7-5.34A10.67,10.67,0,0,0,51.19,169.74Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M80.5,176l5.25,14.26H77.13L73.8,179.06H71.44l-7.56,11.19H56.22l11.19-14.36-4.54-12.65h8.72l2.87,10h2.06l8.37-10h6.8Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M116.17,181.43c-1.56,7.36-7.1,9-11.18,9.12l-7.91-.91c-1.77,8.26-2.47,8.87-9.58,8.92l3.63-17.08.35-1.71,3.43-16,13.55-1c6.25,0,10,2.26,10,6.9a12.17,12.17,0,0,1-.25,2.22Zm-5.89-9.22a10.1,10.1,0,0,0,.25-2c0-1.71-.91-2.47-3.58-2.47h-5L98,185.91h5.09c3.63,0,4.54-1.46,5.19-4.53Z\" fill=\"#e83158\" data-v-1b42e4d6></path><polygon points=\"123.06 146.45 117.14 146.45 118.67 139.26 114.57 139.26 110.8 157.06 114.89 157.06 116.54 149.34 122.45 149.34 120.81 157.06 124.91 157.06 128.68 139.26 124.58 139.26 123.06 146.45\" fill=\"#e83158\" data-v-1b42e4d6></polygon><path d=\"M141.71,139.33,139,152.18c-.37,1.76-1.23,2.45-3.1,2.45h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.16-1.8l2.75-12.95H132l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.62,7.55-4.84l2.75-12.95Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M161.85,140.92c-.86-1.06-2.5-1.58-5-1.58h-7.46L145.64,157h7.81c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.83,2.83,0,0,0-.91-.84,4.61,4.61,0,0,0,2.76-3.71A3.9,3.9,0,0,0,161.85,140.92Zm-6.64,5.55h-2.58c.22-1,.41-1.95.62-2.92l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.75A1.94,1.94,0,0,1,155.21,146.47Zm-.23,2.87a1.25,1.25,0,0,1,1,.43,1.08,1.08,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14H151l1-4.74Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M325.84,255.42V15.24H477.45V45.86h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M654.94,255.42,613,149H594.44L552.89,255.42h-54.3l62-128.29c-17.5-35.71-38.27-76.53-55.77-111.89h70L609,101.62h20.41C640,73.19,651.29,44,661.86,15.24h51.76L664.05,127.13c19.68,41.91,41.55,86.38,61.23,128.29Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M939.94,106.72c0,48.84-28.79,65.6-94.39,65.6h-39v83.1H744.23V15.24H847.37c60.87,0,92.57,21.51,92.57,65.24ZM878.72,80.48c0-22.23-7.66-34.26-36.09-34.26H806.55v95.13h36.08c28.8,0,36.09-11.67,36.09-34.63Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M965.09,255.42V15.24h151.62V45.86h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M1212.92,255.42h-63.78V15.24H1257c58.32,0,92.94,15.68,92.94,60.87V89.59c0,41.92-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.58c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M1473.88,46.22v209.2h-62.69V46.22h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-1b42e4d6></path>", 13)
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_16 = [
  ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_3
]
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_17 = { key: 1 }
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e83158\" data-v-1b42e4d6></polygon><path d=\"M58.64,172.81c-1.41,6.65-3.78,8.72-10.93,8.72l-7.91-.86-.2.76a12.23,12.23,0,0,0-.41,2.42c0,1.31.71,2.16,3.48,2.16H54.76l-.8,3.83-12.6.81c-6.65,0-9.87-2.12-9.87-6.6a12.77,12.77,0,0,1,.3-2.62l2-9.42c1.31-6.15,6.25-9.17,13.51-9.17h1.86c6.4,0,9.93,2.16,9.93,6.75a10.63,10.63,0,0,1-.31,2.47Zm-7.45-3.07c0-1.56-.81-2.27-3.38-2.27h-1c-3.37,0-4.58,1.82-5.19,4.59l-1.16,5.29h3.43c5.39,0,6-.86,7-5.34A10.67,10.67,0,0,0,51.19,169.74Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M80.5,176l5.25,14.26H77.13L73.8,179.06H71.44l-7.56,11.19H56.22l11.19-14.36-4.54-12.65h8.72l2.87,10h2.06l8.37-10h6.8Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M116.17,181.43c-1.56,7.36-7.1,9-11.18,9.12l-7.91-.91c-1.77,8.26-2.47,8.87-9.58,8.92l3.63-17.08.35-1.71,3.43-16,13.55-1c6.25,0,10,2.26,10,6.9a12.17,12.17,0,0,1-.25,2.22Zm-5.89-9.22a10.1,10.1,0,0,0,.25-2c0-1.71-.91-2.47-3.58-2.47h-5L98,185.91h5.09c3.63,0,4.54-1.46,5.19-4.53Z\" fill=\"#fff\" data-v-1b42e4d6></path><polygon points=\"123.06 146.45 117.14 146.45 118.67 139.26 114.57 139.26 110.8 157.06 114.89 157.06 116.54 149.34 122.45 149.34 120.81 157.06 124.91 157.06 128.68 139.26 124.58 139.26 123.06 146.45\" fill=\"#fff\" data-v-1b42e4d6></polygon><path d=\"M141.71,139.33,139,152.18c-.37,1.76-1.23,2.45-3.1,2.45h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.16-1.8l2.75-12.95H132l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.62,7.55-4.84l2.75-12.95Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M161.85,140.92c-.86-1.06-2.5-1.58-5-1.58h-7.46L145.64,157h7.81c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.83,2.83,0,0,0-.91-.84,4.61,4.61,0,0,0,2.76-3.71A3.9,3.9,0,0,0,161.85,140.92Zm-6.64,5.55h-2.58c.22-1,.41-1.95.62-2.92l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.75A1.94,1.94,0,0,1,155.21,146.47Zm-.23,2.87a1.25,1.25,0,0,1,1,.43,1.08,1.08,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14H151l1-4.74Z\" fill=\"#fff\" data-v-1b42e4d6></path><path d=\"M325.84,255.42V15.24H477.45V45.86h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M654.94,255.42,613,149H594.44L552.89,255.42h-54.3l62-128.29c-17.5-35.71-38.27-76.53-55.77-111.89h70L609,101.62h20.41C640,73.19,651.29,44,661.86,15.24h51.76L664.05,127.13c19.68,41.91,41.55,86.38,61.23,128.29Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M939.94,106.72c0,48.84-28.79,65.6-94.39,65.6h-39v83.1H744.23V15.24H847.37c60.87,0,92.57,21.51,92.57,65.24ZM878.72,80.48c0-22.23-7.66-34.26-36.09-34.26H806.55v95.13h36.08c28.8,0,36.09-11.67,36.09-34.63Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M965.09,255.42V15.24h151.62V45.86h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M1212.92,255.42h-63.78V15.24H1257c58.32,0,92.94,15.68,92.94,60.87V89.59c0,41.92-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.58c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#e83158\" data-v-1b42e4d6></path><path d=\"M1473.88,46.22v209.2h-62.69V46.22h-51.75v-31h166.19v31Z\" fill=\"#e83158\" data-v-1b42e4d6></path>", 13)
const ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_31 = [
  ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_18
]

function ExpertHubvue_type_template_id_1b42e4d6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_2, ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_16))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_17, ExpertHubvue_type_template_id_1b42e4d6_scoped_true_hoisted_31))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExpertHub.vue?vue&type=template&id=1b42e4d6&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ExpertHub.vue?vue&type=script&lang=js

  /* harmony default export */ var ExpertHubvue_type_script_lang_js = ({
    name: "ExpertHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExpertHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ExpertHub.vue?vue&type=style&index=0&id=1b42e4d6&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExpertHub.vue?vue&type=style&index=0&id=1b42e4d6&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ExpertHub.vue




;


const ExpertHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ExpertHubvue_type_script_lang_js, [['render',ExpertHubvue_type_template_id_1b42e4d6_scoped_true_render],['__scopeId',"data-v-1b42e4d6"]])

/* harmony default export */ var ExpertHub = (ExpertHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/FinanceHub.vue?vue&type=template&id=a0a75944&scoped=true


const FinanceHubvue_type_template_id_a0a75944_scoped_true_withScopeId = n => (_pushScopeId("data-v-a0a75944"),n=n(),_popScopeId(),n)
const FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1591.79",
  height: "267",
  viewBox: "0 0 1591.79 267"
}
const FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_2 = { key: 0 }
const FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-a0a75944></polygon><path d=\"M63.44,157.42H59c-5,0-5.38,1.52-5.55,2.28s-.32,1.31-.43,2h8.2l-.81,3.92-8.48,1-5.16,24.13c-1.8,8.42-1.91,8.75-10.11,8.75l8.31-39c1.47-6.9,6.85-7.88,11.74-7.88l7.5.59Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M69,190.85H60.72l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.23,1.14,4,2.33Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M102.19,190.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63l2.12-9.73a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.7-2.55H88.88l-5.17,24.19H75.23l6.09-28.54,14.79-1c6.84,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#136389\" data-v-a0a75944></path><polygon points=\"115.57 144.89 109.65 144.89 111.19 137.67 107.09 137.67 103.32 155.47 107.42 155.47 109.06 147.76 114.97 147.76 113.33 155.47 117.42 155.47 121.2 137.67 117.1 137.67 115.57 144.89\" fill=\"#136389\" data-v-a0a75944></polygon><path d=\"M134.23,137.74,131.5,150.6c-.37,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.13,2.13,0,0,1-.16-1.79l2.75-13h-4.48l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M154.37,139.33c-.86-1.06-2.5-1.57-5-1.57H141.9l-3.74,17.63H146c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,154.37,139.33Zm-6.64,5.56h-2.58c.22-1,.41-1.95.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,147.73,144.89Zm-.23,2.87a1.25,1.25,0,0,1,1,.42,1.09,1.09,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M388.16,44.49v69.25H456v31.34H388.16V253.69H325.84V13.51H473.08v31Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M493.49,253.69V13.51h62.68V253.69Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M712.16,253.69,619.59,74V253.69H579.5V13.51h71.79L741,190.64V13.51h39.73V253.69Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M954.52,253.69l-10.2-53.94v.73h-86v-.73L847,253.69H795.26L862,13.51h94.4L1026,253.69ZM911.88,42.3H890.75L864.87,169.5h74Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M1168.83,253.69,1076.26,74V253.69h-40.09V13.51H1108l89.66,177.13V13.51h39.73V253.69Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M1358,256.24c-48.11,0-102.41-5.1-102.41-65.6V76.93c0-61.23,55-66.7,102.41-66.7l58.32,5.1v27h-57.59c-37.9,0-40.82,10.21-40.82,34.63V190.64c0,25.14,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M1434.15,253.69V13.51h151.62V44.13h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-a0a75944></path>", 14)
const FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_17 = [
  FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_3
]
const FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_18 = { key: 1 }
const FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#136389\" data-v-a0a75944></polygon><path d=\"M63.44,157.42H59c-5,0-5.38,1.52-5.55,2.28s-.32,1.31-.43,2h8.2l-.81,3.92-8.48,1-5.16,24.13c-1.8,8.42-1.91,8.75-10.11,8.75l8.31-39c1.47-6.9,6.85-7.88,11.74-7.88l7.5.59Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M69,190.85H60.72l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.23,1.14,4,2.33Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M102.19,190.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63l2.12-9.73a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.7-2.55H88.88l-5.17,24.19H75.23l6.09-28.54,14.79-1c6.84,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#fff\" data-v-a0a75944></path><polygon points=\"115.57 144.89 109.65 144.89 111.19 137.67 107.09 137.67 103.32 155.47 107.42 155.47 109.06 147.76 114.97 147.76 113.33 155.47 117.42 155.47 121.2 137.67 117.1 137.67 115.57 144.89\" fill=\"#fff\" data-v-a0a75944></polygon><path d=\"M134.23,137.74,131.5,150.6c-.37,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.13,2.13,0,0,1-.16-1.79l2.75-13h-4.48l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M154.37,139.33c-.86-1.06-2.5-1.57-5-1.57H141.9l-3.74,17.63H146c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,154.37,139.33Zm-6.64,5.56h-2.58c.22-1,.41-1.95.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,147.73,144.89Zm-.23,2.87a1.25,1.25,0,0,1,1,.42,1.09,1.09,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-a0a75944></path><path d=\"M388.16,44.49v69.25H456v31.34H388.16V253.69H325.84V13.51H473.08v31Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M493.49,253.69V13.51h62.68V253.69Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M712.16,253.69,619.59,74V253.69H579.5V13.51h71.79L741,190.64V13.51h39.73V253.69Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M954.52,253.69l-10.2-53.94v.73h-86v-.73L847,253.69H795.26L862,13.51h94.4L1026,253.69ZM911.88,42.3H890.75L864.87,169.5h74Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M1168.83,253.69,1076.26,74V253.69h-40.09V13.51H1108l89.66,177.13V13.51h39.73V253.69Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M1358,256.24c-48.11,0-102.41-5.1-102.41-65.6V76.93c0-61.23,55-66.7,102.41-66.7l58.32,5.1v27h-57.59c-37.9,0-40.82,10.21-40.82,34.63V190.64c0,25.14,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#136389\" data-v-a0a75944></path><path d=\"M1434.15,253.69V13.51h151.62V44.13h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#136389\" data-v-a0a75944></path>", 14)
const _hoisted_33 = [
  FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_19
]

function FinanceHubvue_type_template_id_a0a75944_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_2, FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_17))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", FinanceHubvue_type_template_id_a0a75944_scoped_true_hoisted_18, _hoisted_33))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/FinanceHub.vue?vue&type=template&id=a0a75944&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/FinanceHub.vue?vue&type=script&lang=js

  /* harmony default export */ var FinanceHubvue_type_script_lang_js = ({
    name: "FinanceHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/FinanceHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/FinanceHub.vue?vue&type=style&index=0&id=a0a75944&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/FinanceHub.vue?vue&type=style&index=0&id=a0a75944&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/FinanceHub.vue




;


const FinanceHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FinanceHubvue_type_script_lang_js, [['render',FinanceHubvue_type_template_id_a0a75944_scoped_true_render],['__scopeId',"data-v-a0a75944"]])

/* harmony default export */ var FinanceHub = (FinanceHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/HundredBridges.vue?vue&type=template&id=c111b8bc&scoped=true


const HundredBridgesvue_type_template_id_c111b8bc_scoped_true_withScopeId = n => (_pushScopeId("data-v-c111b8bc"),n=n(),_popScopeId(),n)
const HundredBridgesvue_type_template_id_c111b8bc_scoped_true_hoisted_1 = {
  key: 0,
  id: "100bridges-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "421.43",
  height: "60",
  viewBox: "0 0 421.43 60"
}
const HundredBridgesvue_type_template_id_c111b8bc_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M368.82,297.13a19.15,19.15,0,0,0,4.69-2.29,13.45,13.45,0,0,0,3.2-3,11.52,11.52,0,0,0,1.84-3.54,13.15,13.15,0,0,0,.59-3.92,16.81,16.81,0,0,0-1.21-6.58,12.31,12.31,0,0,0-3.93-5,19.63,19.63,0,0,0-6.9-3.18,40.58,40.58,0,0,0-10.23-1.12h-21.1v59.4h23a30.35,30.35,0,0,0,9.36-1.32,19.67,19.67,0,0,0,6.86-3.7,16.38,16.38,0,0,0,4.26-5.61,16.72,16.72,0,0,0,1.43-7,12,12,0,0,0-2.9-8.4C375.88,299.64,372.87,298.09,368.82,297.13Zm-20.75-19.35h8.8a20.53,20.53,0,0,1,4.48.4,7.64,7.64,0,0,1,3.1,1.39,5.54,5.54,0,0,1,1.82,2.5,10.48,10.48,0,0,1,.61,3.77,8.85,8.85,0,0,1-.73,3.69,6.48,6.48,0,0,1-2.07,2.5,9.59,9.59,0,0,1-3.37,1.35,21.81,21.81,0,0,1-4.58.43h-8.06Zm20,35.3a7.09,7.09,0,0,1-1.57,2.76,9.81,9.81,0,0,1-3.08,1.91,14.49,14.49,0,0,1-4.86.65h-10.5V302.16H358.5a16,16,0,0,1,4.7.56,8.55,8.55,0,0,1,3.1,1.51,5.73,5.73,0,0,1,1.7,2.47,8.85,8.85,0,0,1,.53,3.24A11.19,11.19,0,0,1,368.08,313.08Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M414.91,304.32a9.22,9.22,0,0,0-2.21-1.6A22.66,22.66,0,0,0,418,300a17.77,17.77,0,0,0,4-3.88,17.56,17.56,0,0,0,2.4-4.8,19,19,0,0,0-.46-12.6,13.64,13.64,0,0,0-4.13-5.46,20.46,20.46,0,0,0-7.24-3.6,39.64,39.64,0,0,0-10.67-1.27H383.2v59.4h12.3V305.22h4.16a5.32,5.32,0,0,1,2.49.47,4.36,4.36,0,0,1,1.54,1.59L415,325.47a4.79,4.79,0,0,0,4.5,2.36h11.08l-13.82-21.38A11.52,11.52,0,0,0,414.91,304.32Zm-4.37-10.59A10,10,0,0,1,407,295.8a15.48,15.48,0,0,1-5.16.75H395.5V277.78h6.37c3.83,0,6.69.76,8.55,2.31a8,8,0,0,1,2.8,6.56,11.28,11.28,0,0,1-.66,3.92A8.2,8.2,0,0,1,410.54,293.73Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><rect x=\"225.46\" y=\"0.44\" width=\"12.38\" height=\"59.41\" fill=\"#ffffff\" data-v-c111b8bc></rect><path d=\"M510.09,283.89a15.42,15.42,0,0,1,5.55-4,18.7,18.7,0,0,1,7.33-1.39,27.74,27.74,0,0,1,4.29.29,17.66,17.66,0,0,1,3.35.79,21,21,0,0,1,3,1.23c.89.45,1.87,1,2.78,1.58a4.13,4.13,0,0,0,2.85.65,3.3,3.3,0,0,0,2-1.58l3.47-5.35a24.87,24.87,0,0,0-4-3.09,31.64,31.64,0,0,0-4.87-2.44,33.28,33.28,0,0,0-5.77-1.59,37.4,37.4,0,0,0-6.75-.58,33.83,33.83,0,0,0-12.58,2.21,27.19,27.19,0,0,0-9.56,6.13,25.78,25.78,0,0,0-3.35,4A26.77,26.77,0,0,0,485,270.64a33.46,33.46,0,0,0-12.42-2.21H449.71v59.4h22.86A33.26,33.26,0,0,0,485,325.62a28.61,28.61,0,0,0,9.6-6.09,27,27,0,0,0,3.5-4.26,26.55,26.55,0,0,0,3.51,4.12,28,28,0,0,0,9.95,6.2,35.07,35.07,0,0,0,13,2.26,37.07,37.07,0,0,0,10.63-1.54,30.77,30.77,0,0,0,9.45-4.75v-24H524.68v6.74a1.83,1.83,0,0,0,.66,1.51,2.59,2.59,0,0,0,1.8.67h6.6v9.78a25.89,25.89,0,0,1-4.44,1.52,19.35,19.35,0,0,1-5.17.65,21.5,21.5,0,0,1-7.68-1.4,15.8,15.8,0,0,1-5.93-3.93,17.1,17.1,0,0,1-3.87-6.44,25.41,25.41,0,0,1-1.33-8.55,23.92,23.92,0,0,1,1.2-8.06A17.93,17.93,0,0,1,510.09,283.89Zm-21,22.67a16.82,16.82,0,0,1-3.53,6.34,14.6,14.6,0,0,1-5.6,4,19.09,19.09,0,0,1-7.43,1.35H462.09V278h10.48a19.08,19.08,0,0,1,7.43,1.39,15.63,15.63,0,0,1,5.6,4,16.48,16.48,0,0,1,3.53,6.33,25.65,25.65,0,0,1,1.27,8.4A26,26,0,0,1,489.13,306.56Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><polygon points=\"340.92 59.84 378.78 59.84 378.78 50.23 353.3 50.23 353.3 34.61 373.1 34.61 373.1 25.32 353.3 25.32 353.3 10.04 378.78 10.04 378.78 0.44 340.92 0.44 340.92 59.84\" fill=\"#ffffff\" data-v-c111b8bc></polygon><path d=\"M627.77,302.63a13.91,13.91,0,0,0-3-4.32,16.92,16.92,0,0,0-4.25-2.9,40.87,40.87,0,0,0-4.81-2c-1.69-.58-3.29-1.13-4.87-1.59a26.27,26.27,0,0,1-4.2-1.65,10,10,0,0,1-3-2.17,4.67,4.67,0,0,1-1.15-3.18,6.23,6.23,0,0,1,2.1-4.88c1.37-1.24,3.47-1.87,6.25-1.87a12.34,12.34,0,0,1,4.12.63A28.82,28.82,0,0,1,618,280c.89.5,1.72.94,2.39,1.36a3.69,3.69,0,0,0,1.92.63,2.39,2.39,0,0,0,1.47-.42,4.11,4.11,0,0,0,1.15-1.36l3-5.63a21.52,21.52,0,0,0-7.57-4.53,28.07,28.07,0,0,0-9.69-1.6,22.5,22.5,0,0,0-8.31,1.44,18.82,18.82,0,0,0-6.11,3.81,16.39,16.39,0,0,0-3.76,5.41,15.9,15.9,0,0,0-1.29,6.28,17.78,17.78,0,0,0,1.15,6.77,13.44,13.44,0,0,0,3,4.56,15.84,15.84,0,0,0,4.21,3,43.61,43.61,0,0,0,4.83,1.9c1.67.56,3.27,1,4.85,1.46a22.8,22.8,0,0,1,4.19,1.58,9.33,9.33,0,0,1,3,2.29,5.4,5.4,0,0,1,1.14,3.59,7,7,0,0,1-2.3,5.67,9.93,9.93,0,0,1-6.5,2,13.07,13.07,0,0,1-5-.84,31.06,31.06,0,0,1-3.64-1.74c-1-.68-1.94-1.27-2.75-1.75a4,4,0,0,0-2.3-.83,2.93,2.93,0,0,0-1.49.42,3.68,3.68,0,0,0-1.17,1l-3.54,5.73a19.87,19.87,0,0,0,3.93,3.07,28.82,28.82,0,0,0,4.8,2.43,31.65,31.65,0,0,0,5.26,1.57,30.62,30.62,0,0,0,5.53.57,25.22,25.22,0,0,0,8.68-1.46,18.87,18.87,0,0,0,6.4-4.12,18,18,0,0,0,4-6.06,20.34,20.34,0,0,0,1.36-7.39A15.28,15.28,0,0,0,627.77,302.63Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M290.87,291.53s.09-.07.06-.07-.06.05-.08.07-.13.07-.13.05.06-.05,0-.07,0,.05-.06.06-.13-.05-.19,0,0,.07,0,.11-.05,0-.07,0,0,0,0,0a.19.19,0,0,1,0,.08c.07-.08.21-.19.25-.14s-.15.34-.08.34,0-.13,0-.18c.12-.32.08-.08.28-.23C291,291.52,290.89,291.57,290.87,291.53Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M293.3,287l-.06,0,0,0s.1,0,.13,0S293.32,287,293.3,287Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M291.41,289.27s.1.05.15,0,0-.07,0-.06Z\" transform=\"translate(-207.47 -267.99)\" data-v-c111b8bc></path><path d=\"M291.66,289.23s-.07,0-.07-.05,0-.05,0-.07a.05.05,0,0,0,0,0s0,.09,0,.11.11.07.15.11,0,.07,0,.07S291.74,289.3,291.66,289.23Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M294.56,284.65c.06.08.06.28.16,0S294.61,284.63,294.56,284.65Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M296.05,288.85l0,0,.06.09s0-.05,0-.06A.24.24,0,0,0,296.05,288.85Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M290.78,290.67l0-.05C290.88,290.41,290.84,290.53,290.78,290.67Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M298.66,280.6a.41.41,0,0,0,0,.08.21.21,0,0,0,0,.07.93.93,0,0,0,0-.13Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M304.36,284.84s0,0,0,0a.43.43,0,0,0,0-.05l0-.09s0,0,0,0S304.25,284.75,304.36,284.84Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M306.07,305.58s-.08.05-.11.09.11.1.1.16-.11.1-.08.15.09-.07.15-.07S306.18,305.65,306.07,305.58Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M290.14,291.36a.21.21,0,0,0,0-.06Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M291,289.89s0,0,0,0c0,.16,0,.29.1.06C291.1,289.88,291,289.92,291,289.89Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M290.49,292.52s.06-.1,0-.13,0,.08,0,.12l0,.09a1,1,0,0,1,.22-.1C290.67,292.45,290.53,292.56,290.49,292.52Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M299,296.71c0-.08-.08-.16-.07-.25s0,0,0,0,0-.06,0-.09,0-.09,0-.08,0,.06,0,0,0-.09,0-.14a.48.48,0,0,0-.08-.18c0,.09,0,.2,0,.23a.47.47,0,0,1-.06.21,1,1,0,0,1-.13.23l0,0,0,.05C298.57,296.81,299,296.81,299,296.71Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M307.49,303l0,0s0,0,0,0Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M317.93,299.81a0,0,0,0,0,0,0s-.11,0-.08,0A.08.08,0,0,0,317.93,299.81Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M307.3,302.86l.13.1v0a.08.08,0,0,0,0,0,.57.57,0,0,0-.15-.12S307.29,302.85,307.3,302.86Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M298.66,280.76a.21.21,0,0,1,0,.13s0,.06,0,.09,0,0,0,0a.28.28,0,0,0,0-.09C298.69,280.71,298.67,280.76,298.66,280.76Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M297.07,268a29.67,29.67,0,0,0-24.5,12.93,29.7,29.7,0,0,0-53.83,12V268.27H207.47V328h11.27V302.42a29.7,29.7,0,0,0,53.83,12A29.69,29.69,0,1,0,297.07,268Zm-4,19.09a.09.09,0,0,1-.07,0Zm-12.67,12s0,0,0-.07.14,0,.21,0,.12,0,.16,0-.08-.08-.12-.06,0,.05,0,.06a.9.9,0,0,1-.28-.17s0,0,.06,0,0,0,0,0a.37.37,0,0,1,.21,0c.07,0,.11.07.18.1s-.12-.12-.09-.19.12,0,.17,0,0-.06.06-.07l.22,0s0,0,0,0-.06,0-.09,0a.18.18,0,0,1-.07-.05s0,0,0,0a.93.93,0,0,1-.26,0s.06,0,.08,0a1.4,1.4,0,0,1,.17-.09s.05,0,.07,0,0-.09.07-.13l.07,0s-.06,0-.07,0,.07-.07.1-.1,0-.07.07-.08,0,.06.06.05a.43.43,0,0,0,.18-.06s-.06,0-.06,0,.05,0,.05,0a3,3,0,0,1-.33,0c-.17-.05,0,0,0-.17s-.26,0-.32-.13.15-.14.15-.14,0,0,0,0a.24.24,0,0,1,.13-.13c.06,0,.12,0,.18,0l0,0c.1-.24-.19-.06-.2-.13s.07,0,.09,0,0-.11,0-.11.07-.13,0-.17-.09.08-.12.05.05-.07.06-.11-.07,0,0,0,.44,0,.48.09,0,.14,0,.15.05-.07.09-.1.27.2.28.17-.05-.11-.05-.18.25,0,.25-.05a.35.35,0,0,0,.15-.12s-.12,0-.12,0,0,0-.1,0,0,0,0,0,0,0,0,0-.18,0-.16-.11.2,0,.25,0-.1-.07-.07-.1.09,0,.13,0,0-.07,0-.09,0,0,.06,0-.31,0,.1-.19l.08,0a1.14,1.14,0,0,1,.33.08c.05,0-.14.12-.11.17s.1,0,.13-.06,0-.08,0-.08.12.19.2.15.06-.1.1-.12.11,0,.15,0,.1,0,.14,0,.09.06.13.08.07,0,.08,0a.28.28,0,0,1,0,.2s0,0,0,0c.09.34.05-.1.14.2,0,.08-.17.2-.17.2s.27-.13.25.18-.25.14-.31.21,0,.18-.16.15-.07,0-.1-.07.09.07.06.11-.13,0-.17,0,.06,0,.06.07,0,.13,0,.19.06.09.06.14-.06.06-.06.11.05.06,0,.09-.09,0-.11,0,0,.06.05.1,0,0,0,0a.82.82,0,0,1,0,.27,2.93,2.93,0,0,1-.34.5s-.05,0-.06.06,0,.11,0,.17h0c0-.06,0,0-.11,0s0-.05-.06-.06-.23.07-.27,0,0,0,0,0,0,0-.08,0-.15-.07-.26,0,0,0,0,.06-.15.07-.15.07,0-.05-.07,0-.08.09-.13.13-.06-.15-.21-.13,0,.09,0,.13-.07,0-.11.06,0,.06-.07.07,0,0,0,0a0,0,0,0,0-.06,0s0,.06,0,.07-.22-.09-.27-.08-.1.05-.16.06.09-.11,0-.09a.77.77,0,0,1-.25,0c0-.05.27-.13.3-.2s0,0,0,0a2.39,2.39,0,0,1-.41,0l.11,0s0,0,0,0l0,0c.07-.07,0,0,.13,0s.18,0,.15-.07l-.37,0c-.07,0-.13-.12-.12-.2S280.38,299.11,280.4,299.1Zm-15.85-1.69a10.09,10.09,0,0,0-1.39,1.29,17.82,17.82,0,0,1-1.18,1.4,4.44,4.44,0,0,0-1.16,1.83,5.45,5.45,0,0,0,.31,3.46,6.6,6.6,0,0,1,.42,1.88c.08,1,.06,1.13-.24,1.58a3.8,3.8,0,0,1-1.17.94,3.22,3.22,0,0,0-1,.72,7.55,7.55,0,0,1-.71.89c-.5.54-.56.69-.5,1.15a4,4,0,0,0,.26,1c.24.59.1.85-.67,1.28s-.92.57-.92,1.4c0,.54-.07.8-.21.85a2,2,0,0,0-.56.63,13.41,13.41,0,0,1-2.83,2.85,3.35,3.35,0,0,1-1.5.28,9.4,9.4,0,0,0-1.59.13c-.47.09-.62.06-.78-.13a1.36,1.36,0,0,1-.17-.8,1.6,1.6,0,0,0-.33-1.1,2.48,2.48,0,0,1-.36-.69,4,4,0,0,0-.57-.92,2.66,2.66,0,0,1-.66-1.71,11.4,11.4,0,0,0-1.21-4.11,5.56,5.56,0,0,1-.6-1.44,5.38,5.38,0,0,1,.75-2.54,2,2,0,0,0,.26-1.94,3.13,3.13,0,0,1-.14-1,2.08,2.08,0,0,0-.26-1.08,4.83,4.83,0,0,1-.46-1.16,3.53,3.53,0,0,0-1-1.56c-.72-.78-.77-.88-.69-1.37a7.15,7.15,0,0,0,.07-3,1.73,1.73,0,0,0-1.62-.77c-.56,0-.65,0-.72-.35a1.23,1.23,0,0,0-.69-.66,3.43,3.43,0,0,0-3,.27,3,3,0,0,1-1.72.35,8.11,8.11,0,0,0-1.79.19,3.87,3.87,0,0,1-1.3.14,6.52,6.52,0,0,1-2.63-2.42A5.47,5.47,0,0,0,228.8,291c-.11,0-.26-.13-.34-.29s-.11-.29,0-.29.17-.6-.07-.92-.17-.32.11-.71.32-.64.32-1.52a6.94,6.94,0,0,0-.2-1.7c-.2-.6-.2-.62.31-1.36.28-.41.68-1.09.9-1.51a5.44,5.44,0,0,1,1.66-1.9,2.7,2.7,0,0,0,1.28-1.38,2.35,2.35,0,0,1,1.17-1.93,3.57,3.57,0,0,0,.95-.87c.16-.28.29-.36.4-.27a3.2,3.2,0,0,0,1,.23,2,2,0,0,0,1.67-.37,5,5,0,0,1,3.27-.73,6.8,6.8,0,0,0,1.9-.16c.21-.09.42-.13.47-.08a3.16,3.16,0,0,1,.08.94c0,.74,0,.89.37,1.21a2.09,2.09,0,0,0,.82.45c1.24.29,1.45.39,1.69.79a1,1,0,0,0,.78.51,4.41,4.41,0,0,1,.93.31,2,2,0,0,0,.73.2,1.15,1.15,0,0,0,1-1.13c0-.64.26-.68,1.24-.19a11.41,11.41,0,0,0,4.36.85l.79,0,0,.51c0,.39.09.74.56,1.51.33.55.87,1.51,1.18,2.14a13.78,13.78,0,0,0,.91,1.6,1.72,1.72,0,0,1,.33.9c0,.55.17.88.8,1.67a3.08,3.08,0,0,1,.56,1c.07.32.36.66,1,1.19a5.06,5.06,0,0,1,1.11,1.17c.1.23.23.42.28.42s.12.2.17.43a1.33,1.33,0,0,0,1.28.87,23.94,23.94,0,0,0,3.13-.65c.06,0,.14,0,.18.12a11.23,11.23,0,0,1-1,2.3C265.74,296.43,265.68,296.51,264.55,297.41Zm54.3-10.83a1.53,1.53,0,0,1,.21.27,8.84,8.84,0,0,1,.62,1.15c.09.22.18.75-.17.8,0,.26-.14.61.08.79a.88.88,0,0,1,.31.79c.31,0,.46.45.73.48a.19.19,0,0,0,.14,0c-.12.05,0,.09,0,.13s-.19.11-.22.12.13.18.1.21-.07,0-.1,0,0,.06,0,.09-.28-.08-.29-.08,0,.05-.07.09-.17.1-.15.14.06,0,.07.06-.17,0-.18,0,.11.11,0,.23-.07,0-.09,0,.07.12.07.16l-.08.35c0,.05-.11,0-.18,0s0,.05-.06.06-.6-.19-.61,0c0,0,0,.08,0,.09s.09-.05.13,0,.18.21.16.29a.1.1,0,0,1-.16,0,.27.27,0,0,1-.07-.14s0-.1,0-.1h-.24s-.51.28-.39.58.3.15.46.57-.08.46.11.69.53.49.61.72,0,.27.07.57.08.42.16.69a4.3,4.3,0,0,0,.26.6l-.19,0-.08,0a.79.79,0,0,0-.26,0c-.07,0-.22,0-.26.12s0,.29-.05.26-.07,0-.07.07,0,.12,0,.07-.1,0-.09.06,0,.17-.05.15,0,.18,0,.18a1.63,1.63,0,0,1-.17.31c-.05,0-.1,0-.09,0s-.11-.06-.12,0a1.3,1.3,0,0,0,0,.26c0,.1.07.18.07.21,0,.4-.15,0-.2.14s.09,0,.06.06-.1-.1-.11,0,.15.11.2.19-.16,0-.19,0,0,.13,0,.19-.05,0-.07,0,0,.05,0,.07a.44.44,0,0,1-.12.15c-.08.08-.09-.05-.1,0s.07.09,0,.12-.14,0-.19-.06H318c0,.05.1.07.13.1s.05.07,0,.07h-.05a.31.31,0,0,1,0,.18s-.07,0-.06,0,.06,0,.07,0,0,.07,0,.11.05.07.05.11-.05,0-.05,0,.06.16,0,.24-.05,0-.05,0,.13.17.07.17-.08-.13-.12-.1.06.1.06.15-.2.18-.07.34.07,0,.28,0c.06,0,.07.08.12.09s.06,0,.09,0,.06.08.1.11.28.18.28.21-.07.17.07.28h0c0-.08-.12-.37-.11-.38s.08-.09.1-.06,0,.12,0,.18a.75.75,0,0,0,0,.16c0,.07,0,.21.09.26s.07-.06.07,0-.08.17.06.31a.37.37,0,0,0,.15,0h.07s.07.19.13.2.07,0,.1,0a3.39,3.39,0,0,1,.52.29c.05,0,.08.1.13.12s.09,0,.13,0h.05v0c0,.46,0,.2-.16.54,0,.07,0,.27,0,.29s-.36.23-.48.14.25-.06-.2-.18c0,0,0,.05-.05.05l-.25-.08s0-.1-.07-.09a.31.31,0,0,0-.14.06c.22.09-.1.08,0,0h0s-.14.05-.18,0-.06,0-.08,0l-.2.09s0,0-.07-.06h-.24c0-.05,0-.3-.06-.3l-.15,0s-.06.09-.1.09-.15-.1-.39-.07c-.07,0,0,.15,0,.19s-.13-.1-.2-.07c-.23.11-.16.44-.47.44-.11,0,0-.16,0-.16s-.38.06-.56,0l-.11,0s0-.05,0-.05-.26.07-.26.07-.12,0-.18,0c-.45.1,0,0-.21.16l-.35.13c-.06,0-.12-.06-.18-.07l-.24.1c-.1,0-.2-.09-.3-.07s-.06.07-.1.08c-.23.11-.32-.08-.32.28l-.06,0s0-.06-.07-.07-.08,0-.12,0a3.29,3.29,0,0,1-.42-.21,2.45,2.45,0,0,0-.62-.19c-.1,0-.19.1-.29.07s-.37-.24-.41-.23.08.07.06.1L312,304c-.13,0-.18-.18-.3-.23s-.33.07-.48,0,.33-.11.21-.22-.08.08-.12.06,0-.1,0-.14.07,0,.11,0,.09,0,.12,0,0,0,0,0,0,0,0-.05a.59.59,0,0,1,.14-.06s0,0,0,0,0-.09.06-.11.12,0,.17,0,0,0,0,0,0-.05,0-.08-.17-.11-.21-.18.07,0,.08,0,0,0,0,0,.06-.09.08-.14-.08-.23,0-.28.06,0,.16.17c0,0,0-.05,0-.07s-.06-.26,0-.28.19.1.25,0,0,0,0-.06-.15,0-.22,0-.07-.08-.13-.09c-.22,0-.19.07-.33-.1s-.08-.06-.07-.08.07,0,.1,0a.21.21,0,0,0,.11,0c.05-.05,0-.15.11-.18s0,0,0,0,.23,0,.2-.05-.11,0-.16,0,.06-.15.06-.15.22-.32.27-.35,0,0,0,0,.09,0,.11,0,0-.2-.1-.24a.2.2,0,0,0-.13,0c-.14.06,0,.05,0,.13s-.34.17-.41.25,0,.1-.05.14,0-.06,0-.06a1.36,1.36,0,0,0-.33.14c-.05,0-.05.25-.07.27s-.05-.05-.09,0l-.18.22c0,.06,0,.16,0,.19s-.09-.1-.15-.09-.1.16-.17.24,0,0,0,0-.17-.06-.28.09,0,.12-.08.17-.06,0-.09.07,0,.47-.2.5-.1-.11-.15-.08a1.07,1.07,0,0,0,.12.24c.07.09.51.51.64.47s.09-.06.13-.1,0-.16,0-.16,0,0,0,.05a.12.12,0,0,0,.1,0s0-.12,0-.15l.33-.07s-.06.11-.07.17.11.27-.05.33h-.12c-.05,0-.06.1-.12.1s-.08-.05-.12-.06a.17.17,0,0,0-.14,0s-.09.08-.05.12,0,0,0,0,0,.05-.1.09,0,.16-.06.21-.06,0-.09,0a.35.35,0,0,0-.16.08c-.25.17-.17.62-.56.66-.07,0-.07-.05-.12-.07s-.16,0-.18,0,.09-.05.12-.08,0-.05-.08-.16.14-.09-.07-.31-.15,0-.22,0-.23-.12-.28-.12-.12.13-.32.05.18-.23.19-.24,0,0,0,0a.15.15,0,0,1,0-.06l.17-.15s0,0,0-.05.05,0,.07,0a2,2,0,0,0,.29-.3s-.07.05-.1,0,.05-.29-.08-.21,0,.1-.08.14-.11-.1-.18-.11,0,.09-.06.1,0,0-.06,0,0,.05,0,.05-.12,0-.17,0-.09.1-.15.12a.27.27,0,0,1-.18,0s0-.06,0-.07-.31.05-.33,0,.14-.1.12-.18-.07,0-.08,0-.11,0-.16,0,0,.08,0,.07a.42.42,0,0,1-.15-.11s.17,0,.18,0l.41-.05c.07,0,0-.09.05-.14l.1-.08c-.24.16-.49.31-.5-.14,0,0,0,0-.05,0s0,.07,0,.16.12.17,0,.19h-.13s-.07.07-.09,0,0-.18-.07-.15,0,.12,0,.19-.23,0-.4.19.09.07,0,.17-.07,0-.07.05,0,.07,0,.1a3.61,3.61,0,0,1-.17.46s0,.07-.07.07-.09,0-.13,0,0,.08,0,.09,0,0,0,0,.15.12-.08.21c-.07,0-.06-.15-.13-.17s0,.06,0,.09a.57.57,0,0,0,0,.26c.06.1,0,0,.07,0s0,0,0,0,0,0,0,0,0,.21,0,.26h0a0,0,0,0,0,0,0s0,0,0,0a1.72,1.72,0,0,1,0,.32c0,.1-.24.11-.3.16s0,.14-.08.13,0,0,0,0-.24.12-.1.21,0,0,0-.06,0-.15.07-.12-.14.34-.14.35.24.91.11,1-.07,0-.11,0c-.28.07-.1.07-.18.24s-.06,0-.08.05.05,0,.05,0a1.19,1.19,0,0,0,0,.33c0,.05.05.11,0,.15s-.1,0-.14,0l0,0s-.06,0-.06.07,0,.05,0,.06-.1.07-.13.11.2-.09.28.12c0,0,0,0,0,.05l.22.14c.16.17-.09.27.28.49.2.13.57.07.74.12s0,.07,0,.1,0,.11,0,.16-.21.1-.28.1-.06-.06-.07-.09c0,.18,0,0-.22.06a.35.35,0,0,0-.16.08s0,.07,0,.08-.21-.1-.34.07,0,.09,0,.14a1.42,1.42,0,0,1-.08.18c-.1.17-.31.2-.42.36s-.15.36-.3.49,0-.11,0-.15a.08.08,0,0,0,0-.07s-.05,0-.05-.06.4-.28.41-.38-.43.16-.54.12c-.3-.11,0-.1-.1-.23s-.31.07-.38.06c-.25,0-.28-.18-.45,0a.46.46,0,0,1-.12.12c-.22.11-.1-.16-.32,0s0,.19-.19.27-.17-.13-.31.05,0,.07.06.08.07.16.13.22h.08l0,0s0,0,0,0,0,.06.06.07.27.05.3.17-.2-.1-.2-.1-.34-.08-.36.07.18.06.24.12,0,.21,0,.18-.14-.18-.26-.25H303s-.09,0-.11,0c-.18.19.34.24.3.31s-.22,0-.28,0a1.21,1.21,0,0,1-.08-.25c-.06-.08-.28,0-.36-.1s0-.1,0-.25-.09.05-.14.09-.1.07-.1.13.07,0,.07.08l-.05.23c0,.15.2.22.29.32l.1.2c0,.05.45.25.39.34s-.32-.13-.35-.12,0,0,0,.07-.1.17,0,.16,0-.05,0,0,0,0,0,.06.23,0,.09.16a1.19,1.19,0,0,1-.36.16s0,0,.07,0,0,0,.07,0,0,0,.05.06,0,0,.05,0a.55.55,0,0,1,.18,0s0,.1.08.1.11-.07.16,0,0,.12,0,.14.14-.07.19,0,0,.14.13.15.2-.05.31.08,0,0,0,.11,0,.06.06.09,0,.09,0,.12.14.1.06.23-.05,0-.07,0,0,0,0,0a.38.38,0,0,0-.11-.08s0,0,0,0-.14-.19-.22-.22,0,.09-.1.1-.35.11-.33.15.12,0,.17.06-.05,0-.05,0,0,0,.05,0,0,.08,0,.1.23,0,.31.14-.13.07-.2.07h-.22s0-.05,0-.07h0c-.06,0-.14-.05-.18,0s.19.28.22.33,0,.07,0,.09.06,0,.07,0,.13.23.16.3-.06,0-.06,0,0,0,0,0,0,0,0,.06.19.11.17.18-.07,0-.1,0,0-.06,0-.08,0,0-.07,0-.18-.41-.38-.14a1.07,1.07,0,0,0,0,.27s0,.08,0,.07c-.19,0-.07-.21-.13-.3h0a.83.83,0,0,1-.11-.15s0-.11-.09-.12c-.37-.09,0,.27-.17.33s-.16-.15-.17-.21h0c-.07,0-.11-.09-.12-.17s.07,0,.09-.17-.19-.28-.3-.31,0,.05-.06,0,0-.11,0-.15-.25,0-.14-.13h0c.13-.09.07-.16.1-.3s0,0,0,0,0,0,0,0,.15.07.21,0,0-.09.13-.19.19,0,.27.07a2.7,2.7,0,0,0,.41.07c.07,0,.12.11.2.12s.09,0,.08-.07-.1,0-.11,0,.19.09.28-.17c0,0-.05,0-.08,0s0-.05,0-.05,0,.1-.06.05-.11,0-.21,0-.07-.12-.13-.13,0,.12-.06.12-.05-.33-.15-.15,0,.09,0,.12-.31-.05-.36,0-.18.14-.33.17-.11-.1-.15-.13,0,.06,0,.07a.33.33,0,0,1-.13.11s0,0,0,0,0-.11-.05-.19a.37.37,0,0,0-.12-.13s0,0-.05,0,0-.1-.06-.12-.21.15-.1-.14c0,0,0,0-.05,0s0-.06,0-.08-.3-.21-.39-.29,0-.09,0-.12-.16.07-.23-.15v-.05c0-.05,0-.09,0-.12s-.06,0-.07,0,0-.09-.07-.12-.55-.2-.49-.33.13,0,.15,0-.15-.11-.17-.2,0,0,0-.05,0-.07,0-.11,0-.07,0-.1.08,0,.1,0,0-.08,0-.08,0,.07,0,.09,0-.26,0-.34-.11-.05-.11-.14a.34.34,0,0,1,0-.2s.09,0,.12,0,0,0,0,0,0-.14,0-.17-.12,0-.18,0a.31.31,0,0,1-.17-.09s0-.07,0-.09-.13-.07-.19-.15,0-.05,0-.07-.13.17-.24-.07a.05.05,0,0,1,0-.05.48.48,0,0,1-.31-.1c-.41-.33-.35-.11-.62-.25,0,0,0,0,0,0l-.16-.06c-.05,0-.11,0-.15,0s0,0,0-.05,0,0,0,0,.11,0,.17,0,.22.13.34.14,0-.05,0-.05a.11.11,0,0,0-.07,0h0c-.11,0-.05,0-.08-.1H298a.91.91,0,0,0-.21-.11c-.09,0-.15-.18-.23-.21s-.14,0-.2,0-.08-.13-.24-.1a1.2,1.2,0,0,1-.27.08c0-.05,0-.13,0-.19s-.21-.08-.26-.12l.05,0c-.05-.07-.41-.27-.42-.37,0-.29.17-.07.28-.1s-.13-.05-.19-.08a2.41,2.41,0,0,1-.24-.21c-.15-.17,0-.38-.13-.54s-.07,0-.1,0-.06-.2-.29-.19c-.07,0,0,.21-.08.24h0v0a.49.49,0,0,1,0,.12c-.09.14-.06,0-.1,0v0h0a.14.14,0,0,1,0,.07.91.91,0,0,1-.09.17s-.06-.16-.09-.21-.18-.11-.13-.16h0a.32.32,0,0,1,0-.17v0c0-.05-.08-.1-.08-.16s.05,0,.07,0,.16-.15.09-.22-.14-.08-.23,0h0c0-.07-.15-.09-.22-.06s0,.11,0,.14-.08,0-.13,0-.21.18-.33.2-.08,0-.11,0,0,.05,0,.09,0,0,0,.06h0s0,.08,0,.1,0-.05,0,0,0,.09,0,.11,0,0,0,0h0s.12.06.13.11c.05.22-.14.13-.2.27a3,3,0,0,0,.11.5,4.93,4.93,0,0,0,.7.53c.11.06.14,0,.24.11a7,7,0,0,1,.35.86,1.34,1.34,0,0,0,.4.42c.05,0,.12,0,.16.08s0,.06,0,.08c.21.22.61.15.86.11.05,0,.17-.1.24,0s-.39.3-.1.5.67.17,1,.32c.1,0,.14.14.26.18a2.16,2.16,0,0,1,.43.14s0,.07,0,.1.34.11.42.38c0,.1,0,.07-.06.14s0,.19,0,.21-.08,0-.13,0c-.24-.1-.14-.24-.26-.4s-.3,0-.42,0-.24-.23-.38-.08-.21.41-.21.43,0,.05,0,.08-.19.14-.06.31.1,0,.19,0,.15.12.24.16.08,0,.09,0,0,.06,0,.09c0,.22.11,0,.1.29s-.32.11-.46.27,0,.23,0,.37-.1.09-.18.15-.06.54-.45.43c-.07,0-.16-.23-.11-.31s.11,0,.15-.08a.42.42,0,0,0,0-.12s0-.07,0-.11-.09-.07-.08-.11.22-.07.27-.14,0-.18-.08-.27,0-.22-.08-.32a.68.68,0,0,0-.09-.17l-.06,0c-.14-.21,0-.08-.08-.32s-.19-.14-.42-.13c0,0,0,0,0,0a.54.54,0,0,0-.12-.09c-.05,0-.14,0-.17-.06s.06-.1.05-.17a.48.48,0,0,0-.08-.16c-.19-.26-.22.1-.44,0,0,0,.15-.13.07-.18-.28-.21,0,0-.31,0,0,0,0,0,0-.07a.9.9,0,0,0-.27-.38c-.21-.08-.05.07-.12.06s-.13-.1-.21-.1-.12.11-.18.1-.06-.12-.11-.17-.2,0-.24-.06l-.12-.16c-.05-.05-.14-.06-.19-.11s0-.12-.09-.2l-.15-.1s0,0-.07,0-.08-.2-.17-.27-.24,0-.39-.09,0,0,.05-.05-.05-.16-.07-.18-.05,0-.06,0,0-.08-.06-.1-.11,0-.14-.06,0-.09,0-.11-.12,0-.18,0,0-.08,0-.13a.41.41,0,0,0-.08-.34c-.17-.24-.05-.45-.25-.62a.07.07,0,0,0-.07,0s0,0,0,0-.06-.06-.1-.06,0,.07,0,.06a.39.39,0,0,1-.16-.1s-.22-.22-.28-.22,0,0,0,.05a0,0,0,0,1-.05,0,.6.6,0,0,0-.28-.12.92.92,0,0,0-.25.15s0,.08,0,.1-.09,0-.11,0-.09.17-.16.23-.28.09-.39.11a.64.64,0,0,0-.16.06s0,0,0,0,0,0,0,0a.29.29,0,0,0-.13.05s0,.07,0,.1-.09,0-.13,0,0,.09-.06.12-.07,0-.1,0,0,.05,0,.07-.09,0-.1.08.06.08,0,.1-.12,0-.17,0-.12.08-.18.11,0-.09-.17-.1,0,0,0,.06h-.07s-.05,0-.06,0,.06-.05-.05-.11h-.08a.37.37,0,0,1-.15,0s0-.12,0-.16-.05,0-.08,0-.14,0-.13,0,.14,0,.15-.1-.08-.11-.14-.1,0,.09,0,.12a.23.23,0,0,1-.16.06c-.12,0-.08-.23-.11-.2s.13.18.06.21c-.24.1-.14-.06-.14-.09s-.28-.06-.31-.08-.14-.13-.21-.08-.21.2-.3.24-.23,0-.33.14,0,.05,0,.07-.12.13-.13.21.06,0,.06,0-.06.1,0,.26.19.16.16.25-.12.05-.16.08.1.21,0,.35-.37.21-.47.25a1,1,0,0,0-.28.12s-.11.15-.18.16c-.27.08-.74,0-.95.2s-.16.08-.15.15.14.05.13.1-.24.08-.25.09-.13.2-.21.28a3.2,3.2,0,0,0-.64.73.93.93,0,0,0,.09.59s.31.19.24.24-.18.06-.24.1,0,.06,0,.06,0,0-.05,0a.47.47,0,0,0-.19.06s0,.08,0,.1-.06,0-.08,0,0,.1,0,.13-.09,0-.11,0,0,.12,0,.16-.2,0-.21.23c0,.06.12.09.11.14s-.11.05-.17,0-.08,0-.12-.05a.66.66,0,0,0-.5.13c-.24.15-.24.46-.49.58-.09.05-.12-.2-.36-.14,0,0-.07.08-.12.09s-.23-.11-.3-.11-.2,0-.3,0-.08-.06-.14-.08a3.78,3.78,0,0,0-.64-.09c-.1,0-.14.14-.23.18s-.28-.09-.45,0-.12.13-.19.24-.06,0-.09,0-.09.1-.15.12,0,0,0-.06l-.11,0s0-.1-.07-.13-.07,0-.1,0a1.21,1.21,0,0,1-.14-.39s.11.11.1,0-.05,0-.06,0,0,0,0,0-.14,0-.14-.2c0,0,.31-.14.24-.16s-.1.12-.17.1,0-.1-.05-.15a.94.94,0,0,0-.09-.12l-.21-.2s.1-.1.06-.1,0,.1-.09.1-.07-.05-.11-.07a.84.84,0,0,0-.37,0l-.28.12s-.46-.25-.58-.29l-.07,0h-.14s-.09.06-.1,0,.18-.34.21-.4,0-.17,0-.25.06,0,.08,0,0,0-.06,0,0-.11,0-.17-.05-.05-.05-.08.13-.17.15-.27a.92.92,0,0,0,0-.16s-.12-.1-.07-.11,0,.24.25.14c0,0-.07,0-.1-.06s0-.09,0-.12,0,.08,0,.07-.05-.05-.08-.05-.05,0-.08,0a.41.41,0,0,1-.19,0s0-.06-.05-.19-.07-.11-.09-.16.21-.4.24-.48-.06-.11,0-.15.12,0,.18,0,0,0,0,0,.07-.05.1-.08a2.59,2.59,0,0,0,.25-.39s.05-.1.09-.13.07.05.06,0-.08-.05-.08-.09,0-.06.06-.1.09-.2.15-.3.14,0,.18-.09,0-.11,0-.1-.06.13-.11.15,0-.1.07-.14a.72.72,0,0,0,.11-.32s0,0,0-.06a1.33,1.33,0,0,1,0-.49s.12,0,.11,0-.11,0-.14-.07.15-.11.16-.18-.07-.12-.07-.18,0,0,.06,0,0,0,0-.05.13-.05.18-.09.05,0,0,0-.1.05-.14.06-.06-.06,0-.09.15,0,.17-.07-.1,0-.14,0a.1.1,0,0,1-.06-.08c0-.08.06,0,.07,0s0-.07,0-.1.09,0,.1-.09c0-.38-.27.05-.34-.32s.17-.18.18-.22-.06,0-.08,0,0,0,0,0a.6.6,0,0,1,.19,0,2.7,2.7,0,0,0,.66-.27c.07,0,.15-.13.22-.08s-.05.11,0,.12.1-.1.17-.1.19.37.38.41c0,0,.06-.08.1-.07.22.06.1.06.32.09.05,0,.15,0,.2,0s.07.06.12.06.11-.08.17-.06.07.11.11.14.14,0,.19,0,0,0,0,.05.07,0,.09,0a1.51,1.51,0,0,0,1,.31s0,0,0-.05h.09c.06,0,.23,0,.27.09s-.06.06,0,.06,0,0,0,0,.23.18.29.18,0-.06,0-.07.05,0,.08,0c.23,0,.08,0,.17.1s.09,0,.13,0,.07.07.1.1a.83.83,0,0,0,.58,0c.22-.1.32-.85.4-1.08,0,0,0-.1.07-.11s.11.05.12,0,0-.1-.08-.11,0,.11-.08.09,0-.15.05-.23a2.29,2.29,0,0,1,.2-.64s.14.15.17.23c.11.23,0,0,0,.27,0,0,.07.08.08.13s0,.09,0,.08.06-.06.06-.09-.07-.06-.11-.1,0-.29,0-.4a1.24,1.24,0,0,0-.14-.18.55.55,0,0,0-.11-.1h0c.05,0,.1,0,.14,0s-.11-.11-.1-.17.09-.09.1-.15-.05-.09-.05-.14.05-.1.05-.16h-.07s0,.06,0,.05,0-.08-.08-.1-.05,0-.08,0,0-.07,0-.09-.06.16-.19-.1a1.2,1.2,0,0,0,0-.23h0a.83.83,0,0,1-.09-.16c0-.07.12-.15.14-.18s-.16-.12-.16-.13a.12.12,0,0,1,0-.12s0,0,0,0c-.32,0,0-.11,0-.28s-.32,0-.33-.05.08-.09.13-.12,0,0-.05,0,0,0,0,0,0,0-.05,0-.12,0-.18,0l0,0h0c0-.1.09-.2-.07-.21s-.07.1-.13.06-.11-.13-.15-.16-.07,0-.1,0,0-.17-.17-.15c0,0,0,0,0,0s-.13.07-.18,0,0-.11,0-.17-.13-.07-.19-.11l0,0h.23s.06,0,.06,0a1,1,0,0,0-.12-.2h.14s.1,0,.08,0-.15,0-.17-.07.11,0,.12-.08-.47.27-.31-.15a2.44,2.44,0,0,1,.34-.1c.08,0-.11.1.07,0s.11-.07.17-.05,0,.11.07.12,0-.09,0-.1.09.1.14.09,0-.12.07-.15,0,0,.07,0,.1-.05.14,0,0,.1,0,.12,0,0,.05-.05.16.3.19.36,0,0,0,0A.59.59,0,0,1,284,303s.08-.09.11-.07,0,.3.2.22,0-.12.06-.17,0,.1.09.11a.66.66,0,0,0,.14,0s.14.07.15,0-.16-.15-.14-.24a1,1,0,0,1,.06-.16s0,0,0,0a.48.48,0,0,0,.06-.18s0,0-.05,0,0-.11,0-.14-.06,0-.07-.05a.3.3,0,0,1,0-.16s0,0,0,0a1,1,0,0,0,0-.17s0,0,0,0l.18.08s0,0,.06,0,.12,0,.18,0,0,.06,0,.09l0,0a.77.77,0,0,0,.07.27c.32.05-.14-.14.11,0s.26.07.37.12.06.08.1.09.14-.08.28-.12H286c-.08,0-.16-.08-.05-.26s.6-.14.74-.22.09-.07.15-.1.13,0,.15-.06-.06-.07-.07-.12a.12.12,0,0,1,0-.08s.05,0,.05,0,0,0,0,0h0l-.15,0s-.06.08-.1.08-.2-.13-.27-.15-.44.09-.47,0,.11,0,0-.06,0,0,0,.06,0,0-.05,0,.06-.05,0-.05,0,.05-.07,0,0-.05,0-.07,0,.07,0,.06-.17-.19-.19-.16.06.09.05.14-.44,0-.46,0,.06.09,0,.14,0,0-.07,0h0s-.16-.11-.2-.09,0,.09-.05.13,0-.05,0-.07a.21.21,0,0,0-.09-.1.69.69,0,0,0-.54-.12s-.08.37-.2.43-.25-.19-.32-.22.08.07,0,.05-.23-.12-.33-.09,0,.08-.06.1-.1,0-.15,0h0s-.11.23-.14.23,0-.11-.05-.15-.23,0-.23-.11.31-.07.31-.07a.12.12,0,0,0,.09-.07s0,0,0,0,.05,0,.07,0,.07-.12.12-.16.06,0,.09,0,0-.05,0-.06.1-.05.14-.1,0-.21.07-.23.07.06.1.06c.18,0,0-.25.4-.18.15,0,.34.23.49.11s0-.11.06-.16.38-.25.42-.3-.2.11-.23.13l-.12,0s0,0-.06,0c-.19.05-.15.22-.38.08-.08-.05-.06-.18-.13-.25s-.18.08-.26,0,0-.25,0-.28,0,0,0,0,0-.06-.17,0c0,0,0,0,0,.06a.29.29,0,0,1-.16,0s-.11-.05-.09-.08.1,0,.15,0-.2,0-.22,0a.32.32,0,0,1,0-.17c0-.15.29-.06.33-.08s.06-.09.11-.1.08,0,.12,0a1,1,0,0,0,.42-.35.91.91,0,0,0-.07-.38c-.13-.16-.28.3-.33,0,0-.05.15-.06.25-.14s0-.06,0-.08a.12.12,0,0,1,.05,0,.1.1,0,0,1-.07,0s0,0,0,0c0-.17-.16-.2,0-.26.14.11.25.17.1.24a.39.39,0,0,0,.21,0s0-.07,0-.06.08.07.14.08.13-.09.21,0,.05.16.1.13,0-.12,0-.17,0,0,.09,0a.34.34,0,0,1,0-.14.23.23,0,0,1,.1-.12s.11,0,.1,0-.11,0-.13-.09c-.1-.22.17-.05.17-.14s-.06,0,0-.08.09-.09.08-.15-.1.09-.21.1,0-.15,0-.21-.05.06-.08.05,0-.11,0-.16l-.09-.19c0-.1.25-.35.26-.35s0,0,0,0,.15,0,.16-.08-.09,0-.14,0-.06,0-.1,0-.07.08-.11.1-.09,0-.13,0-.07,0-.11.07,0,0,0,0,0-.06,0-.07,0,.05,0,.06,0,0,0,0,0-.16-.13-.17,0,.1,0,.23-.07-.08-.11-.13c-.22-.29,0,.05-.29-.13-.08,0,.11,0,.1,0s0-.17.13-.29-.14,0,.11-.19c0,0,.08,0,.09-.05s-.11-.24-.12-.25,0,0,0-.05,0-.12,0-.18.09,0,.16,0c.26.12-.13-.07-.13-.08a.33.33,0,0,1,0-.17s0-.09,0-.12a2.06,2.06,0,0,0-.35.19c-.06.05,0,.16,0,.25s-.07,0-.1,0a.15.15,0,0,0,0,.07s0,0,0,.07-.08.09-.11.15,0,.05,0,.06a.26.26,0,0,1-.19,0c-.05,0,.06-.09.09-.13s0-.16.07-.22l.17-.14s-.1,0-.12,0,.21-.16.1-.18-.07.1-.11.07.11-.07.14-.12,0-.2,0-.26a.19.19,0,0,1,.1-.1s.11.08.11,0-.09,0-.11-.08.26-.16.27-.16-.1,0-.1,0,.08-.06.09-.1,0,0-.07,0,0,.06-.09.08-.2.14-.27.11,0,0,0,0,0,0,0,0-.37.16-.43.05,0,0,0,0,0,.17.22-.09-.36-.08,0-.2a.19.19,0,0,0,.05.09l0,0,0-.09s.06,0,.08,0,.13,0,.18,0-.42,0-.36-.11.25,0,.27,0-.2-.17,0-.23c.05,0,.11.06.17,0s-.05-.18-.05-.18.14,0,.18,0,0-.12,0-.18a.56.56,0,0,0,0-.13s-.27-.28-.1-.35.05.12.1.1,0-.19.07-.13l.13.07c0-.11-.06-.11-.06-.21s.1,0,.12,0,0-.12,0-.18,0,0,0,0,.14.07.17,0-.07-.08-.09-.13.08,0,.08,0,0-.05,0-.06.06,0,.06,0-.06,0-.05-.06.06-.09.09-.14.13.07.15.12,0,0,0,0,0,.11,0,.14.05-.06.08-.07a2.08,2.08,0,0,1,.54,0c.06,0,.14,0,.18,0s-.06.08-.08.13,0,.09,0,.14a6.89,6.89,0,0,1-.6.4c-.15.12.07,0,.15.05s0,0-.07.07,0,.06-.08.07,0-.06,0-.06-.06,0-.08,0-.06,0-.09,0,.09.19.13.14,0,0,0,0,.08,0,.13,0,.19-.1.3-.07.1.06.16.07.56,0,.63.19a.17.17,0,0,1,0,.14l-.18.18a.21.21,0,0,0,0,.11s0,0,0,0-.39.57-.49.58-.21-.06-.35,0,.05,0,.07,0a1,1,0,0,0,.18-.05c.1,0,0,.07,0,.09s.12.07.11.13-.18,0-.23,0c-.24,0,.19.14-.31.1,0,0,0,.09,0,.09s0,0,0,0,.19.12.26.07,0-.08.07-.09a2.14,2.14,0,0,1,.34.24c.06,0,.08.23.13.29s.08,0,.1.07,0,0,0,.06a.71.71,0,0,0,0,.15,5.71,5.71,0,0,0,.11.83s0,0,0,0,.05,0,.08.07.11,0,.24.17,0,.15.07.21.14,0,.14.17-.08,0-.09.09.12.3.15.41-.09-.07-.1.1.28.33.14.48-.15,0-.23.18c0,0,.06,0,.07,0s0,.07.06.09.07.06.09.05,0-.21.2-.18.69.15.62.57c0,.13-.21.48-.34.53s-.12-.08-.13,0,.29.1,0,.19c0,0,0,0-.06,0h0c-.07,0-.16,0-.19,0s.12,0,.15,0,0,.09,0,.13-.23,0-.32.07-.08,0-.06,0,.23-.07.23,0-.1,0-.13,0,0,.05.08.05l0,0s0-.05,0-.05l.06,0,.2,0a1.18,1.18,0,0,0,.28,0c.18,0,.48-.31.66-.27s.07.1.21.1,0-.07.08-.06.18.16.21.14,0-.11,0-.14-.08,0-.11,0-.06-.06-.09,0,0,.05,0,.05a.88.88,0,0,1-.29-.16c0-.06.12-.08.26,0s.16.29.28.14-.17-.05-.18-.12.11,0,.14,0,0-.07-.06-.08-.05,0-.08,0a1.13,1.13,0,0,1-.18-.12c-.06,0,.18,0,.26-.1s0-.11,0-.15.06,0,.09,0,.06-.07.09-.11a1.13,1.13,0,0,0,.23-.34c0-.13,0-.38.11-.5h.06c.05,0,.11,0,.17,0s.16-.13.23-.23a1.68,1.68,0,0,1,.8-.22c.15,0,.16.4.37.19.05,0-.14,0-.19,0s.11-.32.17-.35.09,0,.13,0c.58,0-.61-.07.28,0l0,0c.05.09.08.44.28.37s-.07-.56.11-.56c0,0,0,0,0,.05a.16.16,0,0,0,.1,0c.07,0,.15-.06.22,0h0s-.2,0-.19-.07.12-.29.05-.37-.19.06-.22,0,0,0,.06,0-.06-.05,0-.05.21.05.23-.1-.18-.21-.19-.24a.75.75,0,0,1,0-.3s.07-.08,0-.11-.14,0-.14,0,.11,0,.14,0,0-.1,0-.16,0-.12,0-.15-.27,0-.31-.13.06-.19.06-.29a.07.07,0,0,1,0-.05s0-.11,0-.08a.25.25,0,0,1,0,.08.11.11,0,0,1,0,.05h0a0,0,0,0,0,0,0c.24.11.09-.2.07-.23s0-.06,0-.05,0,.09-.07.1,0-.06,0-.08,0-.11,0-.16,0-.1,0-.13a0,0,0,0,1,0,0h0s-.05-.35,0-.32,0,.09,0,.13.4-.24.42-.24,0,.21,0,.25.09,0,.15,0h0s0-.09,0-.12-.06,0-.07,0,0-.05,0-.08-.1-.13,0-.23a.12.12,0,0,1,.15,0s0,.08,0,.07,0-.11.07-.13h.1s0,0,0,0-.18,0-.24,0-.1.07-.15.08,0,0-.07,0a.47.47,0,0,0-.17,0s0,.06,0,.07,0-.26-.14.15c0,0,0,.23,0,.23-.26,0-.12-.5,0-.55s.32,0,.45-.05.14-.33.3-.42.13,0,.18,0,.09-.14.15-.14-.06.08-.07.15,0,0,.08.16-.06.5-.2.46-.08-.08-.14-.08,0,0,0,0a1.83,1.83,0,0,0,.23.07c0,.05,0,.1,0,.16s.07.07.05.11-.07,0-.1,0,.12,0,.11.09l0,0s.05.08.09.08.23-.1.27.07-.17.38-.23.35-.06-.14-.12-.16-.06.38-.08.43a.23.23,0,0,1-.21.17c-.06,0-.18-.09-.16,0s.15,0,.18.08-.2.11-.2.12.07,0,.09,0-.05,0-.05.06a.3.3,0,0,0,0,.13s.05,0,.05.05-.14.12-.16.21.06,0,.09,0a.2.2,0,0,1,.1.15s-.05-.06-.08-.05-.15.17-.1.14,0-.07.08-.07,0,0,0,.05.05,0,.07,0a.24.24,0,0,1,.15,0,.08.08,0,0,1,0,.07h0s-.05,0,0,0,0,0,.05,0a.13.13,0,0,1,0,.12s-.12.07-.09.1.18-.08.19,0-.08.13,0,.15.05-.11.11-.12.22.15.26.13.17-.18.22-.08-.43.41-.14.44c.06,0,.11-.07.17-.07s0,.23.16.12.07-.22.14-.26.22-.08.26,0,0-.07,0-.08a1.49,1.49,0,0,1,.14-.12,1.86,1.86,0,0,0,.1-.2.64.64,0,0,1,.21.05h.1c.05,0,0,.11.05.16s.08,0,.1,0,.07.15.14.14.12,0,.18,0,0,.05,0,.07a.82.82,0,0,0,.06.19c0,.06.1.08.16.1.26.09,0-.16.08-.2s.07,0,.11,0,.12-.1.19-.13a5.85,5.85,0,0,1,.83-.3s.07-.2.2-.31.14,0,.21-.07.52-.38.8-.33l.14.05c.07,0,.08,0,.09.06h0a.16.16,0,0,1,.08.06s0,0,0,0a.18.18,0,0,1-.09-.09l-.09-.06h-.07s0,.05,0,.07,0,.25.17.31a.57.57,0,0,0,.69-.48,1.37,1.37,0,0,1,0-.19s0,0,0,0,.22,0,.31-.11l.16-.26a.94.94,0,0,0,.06-.31c0-.07-.07-.13,0-.19h0l0-.05c-.07-.2,0-.07,0-.27s-.19-.36-.1-.47h0l0,0s0-.1,0-.15,0-.1,0-.15.13-.11.15-.19-.09-.42.1-.61.17-.09.25-.16.12-.14.19-.11,0,.12,0,.16.25.1.32.17.07.17.12.25.06,0,.14.05.07.05.12,0,.3-.24.32-.35-.15-.4-.18-.56,0-.1,0-.28,0-.12,0-.18.06-.06,0-.08c-.16-.19-.16.1-.21.13s-.07-.05-.11-.06-.08,0-.12,0,0-.13-.07-.2-.14-.12-.17-.21.08-.15.06-.22-.25.06-.14-.23c0-.08.27-.06.3-.12s-.06-.07,0-.11.28-.12.36-.15-.06-.09,0-.11.05,0,.08.05a.37.37,0,0,0,.25,0,.26.26,0,0,0,.11-.12s0-.09,0-.1,0,.08.08.09c.25,0-.08-.06.06-.09s.05,0,.07,0a4.66,4.66,0,0,0,.93,0c.22-.14-.11-.31,0-.43s0,0,.06,0,.08.08.11.05,0-.1,0-.15.18,0,.21,0c.18,0-.16-.25.26-.27.14,0,.59.07.37-.11,0,0-.11,0-.16,0s-.06-.19-.25-.11-.15.13-.25.08,0,0,0-.05a.35.35,0,0,0-.11-.1s-.09,0-.11,0,0-.25-.07-.35-.15.22-.16.22-.13,0-.18,0,0,0,0,.06a.29.29,0,0,1-.12.1s-.17-.09-.17-.09,0,0,0,.07h-.05s0,0,0,0,.24,0-.13.16,0-.12-.11-.17,0,.21-.06.26,0-.07-.06-.07-.15-.05-.17,0,.12.07.13.13c.07.29-.22,0-.23,0s0,.14,0,.15a1.13,1.13,0,0,1-.22.14s0-.06,0-.05,0,.05,0,.07,0,0-.05,0-.12,0-.16,0,.06.06,0,.08-.23.06-.28.09,0,.09-.08.11-.13.07-.18,0,.06-.14,0-.12,0,.23-.27.33c0,0,0,0,.05-.07s.09,0,.11-.08.05-.12,0-.11,0,.14-.09.12.08-.09.07-.14-.08,0-.11,0c-.19-.07-.09-.2-.05-.32s0,0,0,0a1.43,1.43,0,0,1-.22.15s.1,0,0-.21c0,0,0,0,0,0a.07.07,0,0,1-.06,0s0,0,0,0,0,0-.08,0-.06-.07-.11-.08-.11,0-.16,0,0-.11,0-.11,0,.27-.2,0a.31.31,0,0,1-.05-.1s.07,0,.05-.05-.15-.11-.14-.31c0,0,.09,0,.09,0s0,0,0-.08,0,0,.05-.07-.05,0-.05,0,0-.06,0-.08-.11-.09-.09-.16.13,0,.14-.05-.08-.08-.12-.13a.08.08,0,0,1,0,0s0,0,0,0,0,0-.06,0,0,0,0-.05a.83.83,0,0,0-.07-.13s-.07,0-.08,0,0-.25,0-.37,0-.05,0-.05,0,.08,0,.07,0-.06,0-.08,0,0,0,0,0-.18,0-.18c-.08-.2-.13.33-.09-.18,0-.09.21-.22.23-.3s-.25,0-.13-.19a.18.18,0,0,1,.17-.06s0,.1.07.11,0-.08,0-.11.21,0,.14-.21c0,0-.07-.05-.07-.09s0,.07.06.05,0-.2,0-.26.07.05.1.05a.81.81,0,0,0,.06-.2c0-.13.21-.11.24-.26s-.05-.05,0-.07.09-.1.13-.19,0-.09,0-.14.11-.09.12-.16,0-.08,0-.12a.63.63,0,0,1,0-.19s0,0,.06,0,0-.05,0-.07.09-.07.13-.1.13,0,.15-.07c.09-.22-.12-.07-.14-.14s0-.23-.05-.41-.05,0-.1,0,0-.06,0-.06-.11.05-.16,0,0-.14-.08-.17-.18.09-.25.13-.06-.06-.1-.06,0,.05,0,.05-.14-.05-.19,0,0,.12,0,.14-.21-.08-.33-.1,0,0,0,.07,0,0,0,0-.05.1,0,.15a0,0,0,0,0,0,0l.07,0-.07,0h0l-.17-.05s-.05-.07-.06-.05.2.05.21.14-.09,0-.14,0,0,0,0,0,.09.06,0,.1,0,0,0,0,0,0,0,0-.24,0-.27.12,0,0,.06,0a.37.37,0,0,1,.13.15c0,.14-.19.21-.2.36s.25.2.31.34-.15.21-.18.28-.06.48-.16.49,0-.05,0,0,0,.13,0,.15,0-.09,0-.08,0,0,0,0h0s0,.07,0,.08-.12,0-.14.07,0,.09-.06.11-.11-.07-.14,0,.08.11.06.17-.08-.08-.11-.06,0,.1,0,.14,0,.14-.07.17-.1-.06-.16-.05.07,0,.08.05,0,0,0,0,0,0,0-.06h-.05s0,0,0,.07-.06,0-.09,0,0,0,.05,0,0,0,0,0,0,.09,0,.11-.15,0-.12,0,.19,0,.17,0-.09.1-.13.16,0,0-.05,0-.07,0-.07,0,.06,0,.07,0-.07,0-.1,0l0,.08c0,.05.06.2,0,.19s0-.08,0-.07,0,.11,0,.14-.05,0-.08,0a.34.34,0,0,0-.17,0c-.12.09.09.13.18.24s0,0,0,0h0c0,.06,0,.12,0,.18s0,.07-.05.11a.66.66,0,0,0,0,.14h0c0,.06.12.14.07.18s-.11-.08-.18-.06.13.23.1.4-.07,0-.07,0,.05.05.06.08,0,0,0,0a.34.34,0,0,0,0,.1s0,.07,0,.1,0,0,0,0,0,0,0,0a.06.06,0,0,0,0,.06s.07.06.08.11,0,.09,0,.14h0s0,.06,0,.06.24-.05.32,0,0,.07,0,.1a.29.29,0,0,0,.11.11s0,0,.05,0,0,.05,0,.06.41-.16.2.07c0,0-.1-.07-.15-.05s.05.05.08.08,0,.11.08.14,0-.07.07-.06,0,.09.05.11.2,0,.18.26-.08,0-.09,0,0,0-.07.08,0,.15-.22.25c0,0,0,.07,0,.08s-.06,0-.09,0-.11.06-.17.06,0-.12,0-.17,0-.05-.06-.08,0,0,0,0,0-.12-.09-.14a.12.12,0,0,0-.12.06s.06,0,.07,0,0,.13,0,.17.14,0,.12.07-.32-.09-.37-.08-.09.11-.16.11-.06-.11-.1-.1,0,.09,0,.13,0,0-.05,0a.65.65,0,0,0-.19,0s0,0,0,.05.14,0,.19,0,.15.09.22.07-.06-.11,0-.1.06.08.11.1.11,0,.15,0-.06.08,0,.11.07,0,.1,0-.05-.06,0-.06.07,0,.1,0,.11.05.17,0,0-.11,0-.13.09,0,.13,0,.06-.12.12-.13.13.07.11.11-.14,0-.2,0,0,0,0,0a.34.34,0,0,1,.07.15s0,0-.05,0a.35.35,0,0,0-.15.12c0,.05,0,.12,0,.17s0-.11-.08-.1,0,.1,0,.09,0-.3-.09-.28,0,.34-.12.44-.12,0-.17,0,.06,0,.06,0-.08,0-.1.05.05,0,.05,0,0,0,0,0l0,0s-.41-.05-.38,0,0,0,.06,0,0,0,0,0,0,.06,0,.05,0-.05,0-.05a.22.22,0,0,1,.28.13h-.05s0,.07,0,.07-.14-.08-.18,0,.12,0,.17.05a.29.29,0,0,1,.07.2s-.1,0-.11,0,.17.25.11.32-.13,0-.18,0,0,0,0,.05.16.07.16.14-.11.08-.1.14.08.05.11.09,0,0,0,0a.67.67,0,0,0-.07.18c0,.05.1.22.09.23s-.06,0-.08,0,.07.19.05.29-.07,0-.07,0,0,.06,0,.08c-.08.26-.05-.19-.08.08s0,.42-.17.54,0,0,0,0,0,0,0-.05-.13,0-.13,0,0,0,0,0-.08.05-.12.09,0-.06-.05-.06a.26.26,0,0,1-.14.05s-.07,0-.11,0-.07,0-.08,0,.07.09.05.13-.11,0-.17,0-.05.07-.08.11c-.2.3.06.2,0,.4a.35.35,0,0,1-.09.17s-.17,0-.19,0c-.19,0-.13.12-.33.12s-.11,0-.17-.05a.37.37,0,0,1-.11,0c-.05,0,.09-.06.09-.06s-.05-.08,0-.13.06-.07.08-.11-.41-.57-.37-.63.14.09.21.06-.16-.12-.13-.18.13,0,.16,0a.19.19,0,0,0,0-.19s-.06,0-.09,0,0-.14-.1-.19-.09,0-.12-.08,0-.07,0-.1a1.71,1.71,0,0,0-.11-.17s0,0,0,0,0,0-.06,0a.31.31,0,0,1-.09-.11c0-.07,0-.26-.05-.35s-.07,0-.09,0a.27.27,0,0,1,0-.13c0-.12.21-.39.1-.52s-.06.31-.35,0c0,0,0-.19,0-.24s-.1-.44-.1-.44.12,0,.17,0,0-.08,0-.11c-.16-.26-.08.12-.34-.12,0,0,0-.07,0-.1s0,0,0,0,0-.19,0-.17,0,0,0,.05,0-.06,0-.08l-.06-.23c0-.05.07-.15,0-.15s.14.24-.05.38l0,0c0-.05,0-.1,0-.14s-.1-.11-.11-.07.07.1.1.16,0,.1,0,.14.11.07.06.18,0,0,0,0,0,0-.05,0,0,.24-.05.24,0-.11,0-.09.12.17-.21.17c0,0,0-.08,0-.1s-.11-.11-.13-.07.07.09.1.14-.21,0-.23.12.08.06.06.08-.14,0-.18.05.07,0,.07.07c-.05.32-.11-.09-.15.07s0,0,0,.05-.24.29-.24.3,0,0-.06,0,0,.14-.1.15-.05-.12-.11-.1,0,.12-.07.15-.08,0-.12,0,0,0-.05,0-.05,0-.16,0-.12.09-.15.05.1-.07.08-.12-.07.06-.11.06a.33.33,0,0,1-.19,0c-.13-.06.13-.14.15-.2s-.05-.06-.08-.05,0,.08-.06.08-.09,0-.14,0-.15-.18-.2-.21-.06,0-.1,0a.62.62,0,0,1-.14-.28s.06-.08.07-.14,0-.16,0-.14,0,.14.08.17,0-.08.08-.1.08.16.15.14,0-.08,0-.11.18,0,.27-.09-.07,0-.11,0-.1,0-.14,0,0,.12-.07.09-.05-.11-.07-.17.11,0,.14-.08-.07,0-.07,0a.2.2,0,0,1,.1-.08s.14,0,.16-.06-.19,0-.23,0-.05.05-.05,0,.14-.07.13-.13a.16.16,0,0,0-.18-.06c-.1,0-.06.27-.17.26s0-.1,0-.13-.12-.06-.13-.11.09,0,.13,0,0-.14.08-.16.06.06.1.07,0,0,0-.05h.05s-.07,0-.07,0l.3-.14c-.25,0-.09.19-.33,0h0s0-.06,0-.06.07,0,.11,0,0,0,0-.05a.43.43,0,0,1,0-.07s.13,0,.14,0-.1,0-.1-.08,0,0,0-.07,0,0-.06,0a.39.39,0,0,0-.08.1c0,.06,0,.14-.06.18s0-.06,0-.08-.08-.07-.05-.14.15-.21.08-.19-.13.37-.22.19a.85.85,0,0,1-.06-.17c0-.07.11,0,.25-.05s.07-.23.07-.23c0-.25-.17.07-.24.08s0-.08,0-.11-.15-.15-.11-.16.11.06.16.1h0s0,0,0-.06.1-.06.15-.1,0,0,0,0-.17.09-.22.06,0-.22,0-.25.12.08.19.08.16-.18.33-.09.07.1.12.12-.05-.11.13-.16,0,.33.24.32-.06-.14-.05-.24.4.15.35-.13c0-.05-.11.05-.16,0s0-.05,0-.08.22-.17.14-.2-.13.28-.14.32a.75.75,0,0,1-.17,0s0,0,0,0l-.17-.07h0s0,.1-.06.11a2.28,2.28,0,0,0-.31-.1s0,0,0,0a.36.36,0,0,1-.27,0s-.13-.13-.11-.15.11-.08.16-.1.18.06.18,0-.12,0-.18,0-.07.05-.11,0,0-.15.08-.15.21.1.3,0-.27,0-.32-.09.18,0,.14-.06-.11,0-.15,0,0-.17,0-.24a.21.21,0,0,1,.14-.07.3.3,0,0,1,.24.08s-.05.09,0,.12,0-.09,0-.1.06.07.1.08-.07-.06-.05-.07.22.11.36,0,0,0-.07,0c-.27,0,.14.07-.09.08,0,0-.28-.11-.39-.12s-.07,0-.11,0-.13.07-.14,0,.12-.06.14-.11-.14-.1-.14-.18.07,0,.09,0,0,.13.07.13-.05-.14,0-.14.09.11.16.11,0-.14.06-.11,0,.1,0,.15,0,0,0,0,0-.11.07-.11,0,0,0,.07.12.07.14,0-.1,0-.12-.05a.25.25,0,0,1-.05-.16s0-.05,0-.07v0s0,0,0,0a.17.17,0,0,1,.13,0s0,.07,0,.1.06.08.07.13,0,0,0,0,0,0,0,0c0-.16-.2-.26.07-.31.1,0,.11.12.11.26a.06.06,0,0,1,0-.06c.05,0,.18,0,.16,0s-.12,0-.17-.05,0-.1-.06-.14a1.46,1.46,0,0,0-.28-.14s0,0,0,0h.1s0,.05,0,.05.12-.16.23-.07,0,.1,0,.12,0-.09,0-.11.17.14.17.15.14,0,.11-.07-.11,0-.15,0,0-.12.12-.15l-.15,0c-.47,0-.06-.05-.07-.14s-.11-.06-.15-.11,0-.12.18-.09c0,0,0,.09.09.11s.06,0,.09,0a.22.22,0,0,1,.14,0l0,0c0-.05.05-.1.1-.1s0,0,0,.07.08,0,.1.07,0,.07,0,.1.14.11.17.05-.13-.08-.13-.14.08,0,.11,0-.05,0-.07,0,.05,0,0,0-.07.06-.1.05a.23.23,0,0,1-.08-.16l.06,0s-.08-.08,0-.06.32.16.29-.05-.25.23-.21-.11c0-.07.2-.19.25-.16s0,.13,0,.17,0,0,.07,0,.14,0,.11-.05-.13.08-.12,0,.08-.07.12-.11.05-.14.11-.15,0,.08.05.11.07.05.07.09-.07.07-.06.12,0,0,.07,0,.11.12.13.08-.09-.11-.09-.17.32,0,.33,0a.22.22,0,0,0,.05-.19s-.1,0-.09,0,.34-.12.33-.2-.2-.06-.16-.11.17,0,.18-.1c0-.31-.26.07-.32.12s-.12.05-.1.09.12,0,.18,0l0,0-.13.07s-.23.2-.29.19,0-.07,0-.11-.07-.05-.06-.08.1-.06.15-.1,0,0-.05,0,0,0,0,0-.14.15-.22.12.06-.15.14-.2.11,0,.14-.07-.07,0-.1,0,0,0,0,0,0-.11,0-.15.07,0,.09,0,0,0,0,0,0-.05,0-.07.08,0,.1,0,0-.07,0-.1.1,0,.11-.07-.1-.07-.07-.08.1.08.16.06-.06,0-.09-.08.08-.12.14-.16.09.14.16.17a.12.12,0,0,0,.14,0s-.1,0-.09,0,.13,0,.15-.08-.24.18-.17-.12.12.34.18-.11c0,0-.07,0-.08,0s0,0,0,0h0a.52.52,0,0,1-.17.12c-.12.05.22-.15.19-.18s0,0-.06,0h0s-.06,0-.05,0,.26,0,.3-.05,0-.06,0-.07.27,0,.31-.27c0,0-.06,0-.09.06h-.12s-.08.05-.08,0,.29-.1.22-.23-.27.06-.19-.13.12,0,.18-.06,0,0-.05,0a.24.24,0,0,1-.05-.1c0-.05.06-.22.11-.22s.09.09.15.1,0-.05,0-.08,0-.11-.05-.13-.11,0-.14,0,.13-.06.17-.07.07-.14.18-.11.07.08.12.08-.06,0-.07-.08,0,0,.05,0a.34.34,0,0,0,.14-.09c.07,0-.14.08-.21.1s0-.05,0-.06-.13.13-.22.12c-.27,0,.15-.09.2-.13s0,0-.06,0-.1,0-.15,0-.05-.14,0-.2c.05-.29.17-.17.36-.25s-.12-.12-.15-.17.07,0,.1,0-.13-.13.06-.07c0,0,0,0,0,.05s0-.06,0-.07,0-.05,0,0,0,.09,0,.1.15,0,.16-.08-.08-.08-.09-.13.18-.12.25-.09,0,.14,0,.14,0-.11,0-.14h0l0,0s0-.06,0-.07,0,0-.07.07-.17.09-.25,0,.06-.07.09-.11.06-.33.18-.24-.12.07-.08.1.08,0,.13-.06a.16.16,0,0,1,.11.05c.05.05.13.22.11.15s-.09-.1-.08-.16.1-.06.13-.11,0,0-.07,0-.15.09-.21-.06,0,0,.05-.07h0c0-.07.19,0,.22,0s-.18-.17-.2-.17,0,0,0,.05-.16.21-.2.18-.07-.11,0-.16.09,0,.12-.05-.07,0-.08,0,.1-.08.14,0,0,0,0,0,.32,0,.31-.21-.05,0-.07,0,0,0,0,0,0,0,0,0h-.08s-.11,0-.13,0c-.1-.2.21-.06.21-.06s0-.12,0-.18,0,.06,0,.09,0,0,0,0,0,.09,0,.13.17.26.21.22-.29-.45-.18-.51.12,0,.18.09,0,0,0-.06-.16,0-.14-.07.11,0,.17-.06c.33,0,0,.11.26.21s-.17-.24,0-.24.06.05.1.05.11,0,.1-.05c0-.33-.24,0-.31,0s0,0,0,0,0,0,0,0,0,0-.05,0-.13,0-.15,0a.17.17,0,0,1,0-.07c-.05,0-.11,0-.13.05s0,.13-.05.17,0-.09,0-.12a.11.11,0,0,0-.11,0s0,.06,0,.08l-.09.08-.07.09v0c0-.06.06-.1.08-.17s0-.07,0-.1.12,0,.16-.06-.27-.11,0-.35.13.18.1.35a.1.1,0,0,1,.06-.08s0,.05,0,0,0-.41.12-.23a.61.61,0,0,1,.09.2.22.22,0,0,1,.12-.07s0,.07.08.07a.37.37,0,0,0,.18,0c.08-.05-.16,0-.18-.09a.09.09,0,0,1,.08-.07c.05,0,.12.09.13.05s-.13,0-.13-.07.1,0,.13-.06,0,0,0,0a.19.19,0,0,1-.07-.19c0-.07.17,0,.18-.07s0-.11,0-.18a.47.47,0,0,1,0-.17c0-.06.06.16.11.19a.22.22,0,0,0,.18,0s-.23-.09-.22-.14.07-.13.13-.12,0,.1.08.14.09,0,.14.07.05.12.06.09-.39-.14-.22-.5c0-.06.16-.14.22-.1s0,.4,0,.42,0,0,.05,0,0-.11,0-.15.12,0,.13,0-.11,0-.13-.09.06-.37.18-.23a2.78,2.78,0,0,1,0,.5s-.12.15-.06.16.07-.22.12-.26.11,0,.16,0,0,0-.06-.05-.17-.1-.12-.21c.2-.45,0,.06.23-.1.07,0,0-.15.05-.21s0,0,.05,0,0,0,0,.06l.12.07s.06.07.1.09-.07-.06-.09-.1l0,0a.59.59,0,0,0,0-.27s-.27.2-.33,0,.2-.18.26-.16.08.08.14.09,0,0,0-.05,0,0,.06,0h.14c.1,0,0,.26.18.24,0,0,.06-.06.05-.1s-.05,0-.07,0-.06,0-.06,0,.09,0,.06-.07,0-.09,0-.24.23-.1.26-.14-.09,0-.1-.06.18-.11.19-.13-.21-.16-.21-.18.12.06.14,0-.07-.11-.06-.17.19,0,.32,0c-.3-.3.12-.3.15-.12s-.1.07-.14.12l.13,0a3.89,3.89,0,0,1-.19.42h0s0,0,0,0,.06,0,.08,0-.13.1,0,.14,0,.08,0,.13,0,.24.12.11,0-.07,0-.1,0-.08,0-.12-.07,0,0-.06a2.63,2.63,0,0,1,.25-.69l.06.21c0,.05-.1.08-.09.13s.08-.05.1,0,0,.14,0,.16.13,0,.18,0-.07-.05-.07-.09,0-.13,0-.17.1-.07.13-.11,0,0-.05,0-.15,0-.15-.1.12,0,.14,0,0-.12,0-.17.06.07.1.05.11-.08.23,0-.16.39-.18.44,0,0,.05,0,.07-.12.13-.14,0,.07,0,.11-.11.11-.08.17.11-.1.15-.07l0,0s.05,0,.06,0-.07-.08-.07-.08a1,1,0,0,1,0-.34c.14-.18.23.16.24.16.5,0-.26-.3.24-.15.26.08.07.09,0,.19s0,0,.05,0,.09-.06.14-.06,0,0,0,0l.08,0,0,0a.61.61,0,0,1,.14.1s0,0-.05,0-.09,0-.12.07,0,.17-.07.2-.38,0-.52.13a.24.24,0,0,1,.08,0l.11,0s0,0,0,0,.15,0,.19,0-.1.1-.07.14.05-.11.1-.1,0,.27,0,.29,0-.09,0-.1.13,0,.19,0,0,0,0-.06a.32.32,0,0,1,0-.14s0,0,0,0a.54.54,0,0,0,.18,0l.38,0s-.07-.06-.07-.1a.31.31,0,0,1,0-.19s.22.07.25.1.16-.07.22,0a.17.17,0,0,1,0,.19c-.07.08-.25-.15-.32-.07a.17.17,0,0,0,0,.19s.1-.08.14-.05,0,.07,0,.11.39-.16.41-.09-.11-.11,0,.17c0,0,.1,0,.1.09s-.2.14-.06.24,0-.07,0-.1.08-.1.11-.16v-.05a.67.67,0,0,1,.07-.17c.12-.11.17,0,.28,0s.27-.15.48-.1a7,7,0,0,1,.84.22c.05,0,.09.08.15.1s.08,0,.12,0,0,.07.06.08.13,0,.15,0-.06,0-.11,0h0s0,0,0,0,.54.23.58.13-.09-.07-.09-.12.06,0,.08,0,.1.08.14.1.08,0,.11,0,.07.08.11.12.12-.07.19-.06.07.18.13.23l0,0c.09,0,.08.16.12.2s.08,0,.12,0,.11.42.09.54,0,.17,0,.28a1.11,1.11,0,0,1-.79.79,1.59,1.59,0,0,1-.38,0c-.16,0-.3.08-.46.09a.78.78,0,0,1-.21,0c-.09,0-.27-.13-.37-.09s0,.09-.09.11-.05-.06-.08-.06-.08,0-.11,0,0-.11,0-.11,0,.09-.05.11a.21.21,0,0,1-.16,0s-.33-.08-.37-.16.05-.07,0-.11a2.45,2.45,0,0,0-.43.06s0,.05,0,.05.22-.09.29.06-.05,0-.06,0,0,0,.05,0,0,0,0,.05,0,0,0,0,.09.11.15.12c.25.05.12-.06.35.08,0,0,.09,0,.11.07s-.19.11-.12.17.07-.05.11-.06a1.72,1.72,0,0,1,.56.17l.11.15s.13,0,.09.07-.1-.06-.14,0,.11.16.11.17c.1.27,0,.06-.11.28,0,0,.07,0,.09,0l.26.25s0,0,0,.07.14,0,.15.09-.07.08,0,.11.08-.07.11,0-.06,0-.06.09a.19.19,0,0,0,0,.16,1.71,1.71,0,0,0,.36.1s0-.15.3,0c.65.25-.4-.14.18.19a5.68,5.68,0,0,0,.59,0s0-.08,0-.11.06,0,.08,0,0-.3-.1-.41-.05,0-.12,0,0-.06,0-.05,0,0,0,.06,0,0,0,0a.26.26,0,0,1-.19.06,2.26,2.26,0,0,1-.54-.41c0-.05.11-.06.15-.1s-.08-.12-.08-.19.56.09.58.09.12-.07.18-.06,0,0,0,.05h0c.08-.09.47.06.53,0s0-.11.06-.14.19.09.33,0-.09-.11-.12-.17,0,0,0-.05-.49-.28-.6-.42,0-.31.08-.49,0-.16,0-.22.2-.19.25-.36a3,3,0,0,1,0-.44.47.47,0,0,1,.17,0c.11,0,0,.09,0,.09.24-.14.08-.21.32-.12.05,0,.11,0,.16,0s0,0,0,.07a.09.09,0,0,1,.08-.05c.12,0,.16.23.28.22s0-.06-.21-.27,0-.33-.08-.53l0,0s-.08,0-.1-.09,0-.05,0-.06a.32.32,0,0,0,0-.09,1.43,1.43,0,0,0-.26-.15c-.05,0-.1.05-.17,0s-.1-.28-.11-.33,0-.16,0-.16a.69.69,0,0,1-.14-.24c0-.05,0-.1,0-.15s0,.08-.06.07,0-.23-.38-.31c0,0-.32-.06-.23-.12s.21,0,.3,0,.29-.22.37-.25a.49.49,0,0,1,.29-.05s0,0,0,0a.22.22,0,0,0,.1.09c.16.07.4.09.49.29a.8.8,0,0,0-.17.14c0,.05-.25.18-.22.25h0s.05.05,0,.08-.15.18,0,.3.25,0,.33,0,.24.27.34.22.1-.21.15-.16,0,.12,0,.16,0-.08,0-.12a.86.86,0,0,1,.21-.26s.07,0,.09,0-.13-.27-.15-.29,0-.22-.05-.28-.19-.06-.12-.19.07.05.08,0,0-.08,0-.12.08,0,.1,0,0-.07,0-.07.13,0,.19,0-.13,0-.17,0,0-.08,0-.1-.1,0-.13,0,.07,0,.11,0a.24.24,0,0,0,.13-.09c.07-.07.07-.27.11-.35s0,.06,0,.09,0,0,0,0a2.4,2.4,0,0,1,.05-.46s.07,0,.1,0,0-.1,0-.15,0,0,0,0,0,0,0,0,.05,0,.05,0,0-.14.07-.18.13.23.2.22,0-.12,0-.19,0,0,0,0l-.16,0s0-.09,0-.08a.24.24,0,0,0,0,.07s0,0,0,0,0,0,0,0a1.38,1.38,0,0,1,.33-.81s0,0,.05,0,0,.06,0,.09-.19.19-.17.21.09-.07.15-.06,0,.06,0,.08a.67.67,0,0,0,.06.15c.07.06.2.07.24.15s-.38.28-.06.27c0,0,.05-.07.09-.1s.09,0,.11,0-.05-.1,0-.12.05.11.08.09,0-.13,0-.15.12.05.18,0-.13-.19-.13-.21.05-.19.1-.31,0-.1,0-.15,0,0,.07,0c.2-.05.07-.07.14-.12s.07,0,.1,0a.6.6,0,0,0,.13-.09c.05-.06-.06-.14-.06-.21s.07-.06.08-.1-.05-.15,0-.18.16.13.16.07-.12,0-.16-.1a.64.64,0,0,1,.1-.23s0,0,0,.06.05,0,.07,0c.4,0,.11.08.21.22s.11.16.25.1.09,0,.11,0c.12-.27-.17-.14-.22-.31s.11-.13.14-.18,0-.19,0-.27-.6-.21-.71-.28,0-.12.06-.2-.11-.12-.11-.19.25-.1.25-.1a4.09,4.09,0,0,1,.51-.4,1.73,1.73,0,0,1,.64-.17H310a.32.32,0,0,0,.14,0,1.4,1.4,0,0,0,.16-.1c.09,0-.14.08,0,.09-.07,0-.07.35,0,.39a2.58,2.58,0,0,0,.92.67,7.32,7.32,0,0,0,.89.17,30.61,30.61,0,0,1,.13,3.45l.09.13c.05.09-.09,0-.09.09,0,.49.52.78.66,1.24.05.13.18.17.32.22s.17.26.31.35a16.21,16.21,0,0,1,2.38,3.05,3.55,3.55,0,0,0,.84.8,7.26,7.26,0,0,0,1.59.44C318.58,285.87,318.62,286.32,318.85,286.58ZM283.41,304s0,.07,0,.09S283.39,304,283.41,304Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M305.71,282.41s-.06.07-.06.11.16.12.15.07-.1,0-.11-.07A.15.15,0,0,1,305.71,282.41Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M281.52,298.6s-.1,0-.12-.06,0-.06,0-.08a1.09,1.09,0,0,1-.2.12A.91.91,0,0,0,281.52,298.6Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M284,304.36a.49.49,0,0,1,.27.08c-.05-.05-.13-.14-.22-.12Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M298.64,295.16s0,.14,0,.11a.11.11,0,0,0,0-.1Z\" transform=\"translate(-207.47 -267.99)\" data-v-c111b8bc></path><path d=\"M301.21,312.84s-.1-.13-.15-.1,0,.12,0,.17.22,0,.27-.08S301.22,312.84,301.21,312.84Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M292.17,298.6c-.07-.06-.07-.2-.17-.25.05,0,.05.1.08.14s.25.46.25.2C292.33,298.63,292.22,298.65,292.17,298.6Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path><path d=\"M293.86,297.93s.09-.13.1-.14l.17,0a.15.15,0,0,0-.09,0C293.9,297.75,293.86,297.78,293.86,297.93Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#ffffff\" data-v-c111b8bc></path>", 32)
const _hoisted_34 = [
  HundredBridgesvue_type_template_id_c111b8bc_scoped_true_hoisted_2
]
const HundredBridgesvue_type_template_id_c111b8bc_scoped_true_hoisted_35 = {
  key: 1,
  id: "100bridges-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "421.43",
  height: "60",
  viewBox: "0 0 421.43 60"
}
const _hoisted_36 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M368.82,297.13a19.15,19.15,0,0,0,4.69-2.29,13.45,13.45,0,0,0,3.2-3,11.52,11.52,0,0,0,1.84-3.54,13.15,13.15,0,0,0,.59-3.92,16.81,16.81,0,0,0-1.21-6.58,12.31,12.31,0,0,0-3.93-5,19.63,19.63,0,0,0-6.9-3.18,40.58,40.58,0,0,0-10.23-1.12h-21.1v59.4h23a30.35,30.35,0,0,0,9.36-1.32,19.67,19.67,0,0,0,6.86-3.7,16.38,16.38,0,0,0,4.26-5.61,16.72,16.72,0,0,0,1.43-7,12,12,0,0,0-2.9-8.4C375.88,299.64,372.87,298.09,368.82,297.13Zm-20.75-19.35h8.8a20.53,20.53,0,0,1,4.48.4,7.64,7.64,0,0,1,3.1,1.39,5.54,5.54,0,0,1,1.82,2.5,10.48,10.48,0,0,1,.61,3.77,8.85,8.85,0,0,1-.73,3.69,6.48,6.48,0,0,1-2.07,2.5,9.59,9.59,0,0,1-3.37,1.35,21.81,21.81,0,0,1-4.58.43h-8.06Zm20,35.3a7.09,7.09,0,0,1-1.57,2.76,9.81,9.81,0,0,1-3.08,1.91,14.49,14.49,0,0,1-4.86.65h-10.5V302.16H358.5a16,16,0,0,1,4.7.56,8.55,8.55,0,0,1,3.1,1.51,5.73,5.73,0,0,1,1.7,2.47,8.85,8.85,0,0,1,.53,3.24A11.19,11.19,0,0,1,368.08,313.08Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M414.91,304.32a9.22,9.22,0,0,0-2.21-1.6A22.66,22.66,0,0,0,418,300a17.77,17.77,0,0,0,4-3.88,17.56,17.56,0,0,0,2.4-4.8,19,19,0,0,0-.46-12.6,13.64,13.64,0,0,0-4.13-5.46,20.46,20.46,0,0,0-7.24-3.6,39.64,39.64,0,0,0-10.67-1.27H383.2v59.4h12.3V305.22h4.16a5.32,5.32,0,0,1,2.49.47,4.36,4.36,0,0,1,1.54,1.59L415,325.47a4.79,4.79,0,0,0,4.5,2.36h11.08l-13.82-21.38A11.52,11.52,0,0,0,414.91,304.32Zm-4.37-10.59A10,10,0,0,1,407,295.8a15.48,15.48,0,0,1-5.16.75H395.5V277.78h6.37c3.83,0,6.69.76,8.55,2.31a8,8,0,0,1,2.8,6.56,11.28,11.28,0,0,1-.66,3.92A8.2,8.2,0,0,1,410.54,293.73Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><rect x=\"225.46\" y=\"0.44\" width=\"12.38\" height=\"59.41\" fill=\"#515151\" data-v-c111b8bc></rect><path d=\"M510.09,283.89a15.42,15.42,0,0,1,5.55-4,18.7,18.7,0,0,1,7.33-1.39,27.74,27.74,0,0,1,4.29.29,17.66,17.66,0,0,1,3.35.79,21,21,0,0,1,3,1.23c.89.45,1.87,1,2.78,1.58a4.13,4.13,0,0,0,2.85.65,3.3,3.3,0,0,0,2-1.58l3.47-5.35a24.87,24.87,0,0,0-4-3.09,31.64,31.64,0,0,0-4.87-2.44,33.28,33.28,0,0,0-5.77-1.59,37.4,37.4,0,0,0-6.75-.58,33.83,33.83,0,0,0-12.58,2.21,27.19,27.19,0,0,0-9.56,6.13,25.78,25.78,0,0,0-3.35,4A26.77,26.77,0,0,0,485,270.64a33.46,33.46,0,0,0-12.42-2.21H449.71v59.4h22.86A33.26,33.26,0,0,0,485,325.62a28.61,28.61,0,0,0,9.6-6.09,27,27,0,0,0,3.5-4.26,26.55,26.55,0,0,0,3.51,4.12,28,28,0,0,0,9.95,6.2,35.07,35.07,0,0,0,13,2.26,37.07,37.07,0,0,0,10.63-1.54,30.77,30.77,0,0,0,9.45-4.75v-24H524.68v6.74a1.83,1.83,0,0,0,.66,1.51,2.59,2.59,0,0,0,1.8.67h6.6v9.78a25.89,25.89,0,0,1-4.44,1.52,19.35,19.35,0,0,1-5.17.65,21.5,21.5,0,0,1-7.68-1.4,15.8,15.8,0,0,1-5.93-3.93,17.1,17.1,0,0,1-3.87-6.44,25.41,25.41,0,0,1-1.33-8.55,23.92,23.92,0,0,1,1.2-8.06A17.93,17.93,0,0,1,510.09,283.89Zm-21,22.67a16.82,16.82,0,0,1-3.53,6.34,14.6,14.6,0,0,1-5.6,4,19.09,19.09,0,0,1-7.43,1.35H462.09V278h10.48a19.08,19.08,0,0,1,7.43,1.39,15.63,15.63,0,0,1,5.6,4,16.48,16.48,0,0,1,3.53,6.33,25.65,25.65,0,0,1,1.27,8.4A26,26,0,0,1,489.13,306.56Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><polygon points=\"340.92 59.84 378.78 59.84 378.78 50.23 353.3 50.23 353.3 34.61 373.1 34.61 373.1 25.32 353.3 25.32 353.3 10.04 378.78 10.04 378.78 0.44 340.92 0.44 340.92 59.84\" fill=\"#515151\" data-v-c111b8bc></polygon><path d=\"M627.77,302.63a13.91,13.91,0,0,0-3-4.32,16.92,16.92,0,0,0-4.25-2.9,40.87,40.87,0,0,0-4.81-2c-1.69-.58-3.29-1.13-4.87-1.59a26.27,26.27,0,0,1-4.2-1.65,10,10,0,0,1-3-2.17,4.67,4.67,0,0,1-1.15-3.18,6.23,6.23,0,0,1,2.1-4.88c1.37-1.24,3.47-1.87,6.25-1.87a12.34,12.34,0,0,1,4.12.63A28.82,28.82,0,0,1,618,280c.89.5,1.72.94,2.39,1.36a3.69,3.69,0,0,0,1.92.63,2.39,2.39,0,0,0,1.47-.42,4.11,4.11,0,0,0,1.15-1.36l3-5.63a21.52,21.52,0,0,0-7.57-4.53,28.07,28.07,0,0,0-9.69-1.6,22.5,22.5,0,0,0-8.31,1.44,18.82,18.82,0,0,0-6.11,3.81,16.39,16.39,0,0,0-3.76,5.41,15.9,15.9,0,0,0-1.29,6.28,17.78,17.78,0,0,0,1.15,6.77,13.44,13.44,0,0,0,3,4.56,15.84,15.84,0,0,0,4.21,3,43.61,43.61,0,0,0,4.83,1.9c1.67.56,3.27,1,4.85,1.46a22.8,22.8,0,0,1,4.19,1.58,9.33,9.33,0,0,1,3,2.29,5.4,5.4,0,0,1,1.14,3.59,7,7,0,0,1-2.3,5.67,9.93,9.93,0,0,1-6.5,2,13.07,13.07,0,0,1-5-.84,31.06,31.06,0,0,1-3.64-1.74c-1-.68-1.94-1.27-2.75-1.75a4,4,0,0,0-2.3-.83,2.93,2.93,0,0,0-1.49.42,3.68,3.68,0,0,0-1.17,1l-3.54,5.73a19.87,19.87,0,0,0,3.93,3.07,28.82,28.82,0,0,0,4.8,2.43,31.65,31.65,0,0,0,5.26,1.57,30.62,30.62,0,0,0,5.53.57,25.22,25.22,0,0,0,8.68-1.46,18.87,18.87,0,0,0,6.4-4.12,18,18,0,0,0,4-6.06,20.34,20.34,0,0,0,1.36-7.39A15.28,15.28,0,0,0,627.77,302.63Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M290.87,291.53s.09-.07.06-.07-.06.05-.08.07-.13.07-.13.05.06-.05,0-.07,0,.05-.06.06-.13-.05-.19,0,0,.07,0,.11-.05,0-.07,0,0,0,0,0a.19.19,0,0,1,0,.08c.07-.08.21-.19.25-.14s-.15.34-.08.34,0-.13,0-.18c.12-.32.08-.08.28-.23C291,291.52,290.89,291.57,290.87,291.53Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M293.3,287l-.06,0,0,0s.1,0,.13,0S293.32,287,293.3,287Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M291.41,289.27s.1.05.15,0,0-.07,0-.06Z\" transform=\"translate(-207.47 -267.99)\" data-v-c111b8bc></path><path d=\"M291.66,289.23s-.07,0-.07-.05,0-.05,0-.07a.05.05,0,0,0,0,0s0,.09,0,.11.11.07.15.11,0,.07,0,.07S291.74,289.3,291.66,289.23Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M294.56,284.65c.06.08.06.28.16,0S294.61,284.63,294.56,284.65Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M296.05,288.85l0,0,.06.09s0-.05,0-.06A.24.24,0,0,0,296.05,288.85Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M290.78,290.67l0-.05C290.88,290.41,290.84,290.53,290.78,290.67Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M298.66,280.6a.41.41,0,0,0,0,.08.21.21,0,0,0,0,.07.93.93,0,0,0,0-.13Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M304.36,284.84s0,0,0,0a.43.43,0,0,0,0-.05l0-.09s0,0,0,0S304.25,284.75,304.36,284.84Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M306.07,305.58s-.08.05-.11.09.11.1.1.16-.11.1-.08.15.09-.07.15-.07S306.18,305.65,306.07,305.58Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M290.14,291.36a.21.21,0,0,0,0-.06Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M291,289.89s0,0,0,0c0,.16,0,.29.1.06C291.1,289.88,291,289.92,291,289.89Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M290.49,292.52s.06-.1,0-.13,0,.08,0,.12l0,.09a1,1,0,0,1,.22-.1C290.67,292.45,290.53,292.56,290.49,292.52Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M299,296.71c0-.08-.08-.16-.07-.25s0,0,0,0,0-.06,0-.09,0-.09,0-.08,0,.06,0,0,0-.09,0-.14a.48.48,0,0,0-.08-.18c0,.09,0,.2,0,.23a.47.47,0,0,1-.06.21,1,1,0,0,1-.13.23l0,0,0,.05C298.57,296.81,299,296.81,299,296.71Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M307.49,303l0,0s0,0,0,0Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M317.93,299.81a0,0,0,0,0,0,0s-.11,0-.08,0A.08.08,0,0,0,317.93,299.81Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M307.3,302.86l.13.1v0a.08.08,0,0,0,0,0,.57.57,0,0,0-.15-.12S307.29,302.85,307.3,302.86Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M298.66,280.76a.21.21,0,0,1,0,.13s0,.06,0,.09,0,0,0,0a.28.28,0,0,0,0-.09C298.69,280.71,298.67,280.76,298.66,280.76Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M297.07,268a29.67,29.67,0,0,0-24.5,12.93,29.7,29.7,0,0,0-53.83,12V268.27H207.47V328h11.27V302.42a29.7,29.7,0,0,0,53.83,12A29.69,29.69,0,1,0,297.07,268Zm-4,19.09a.09.09,0,0,1-.07,0Zm-12.67,12s0,0,0-.07.14,0,.21,0,.12,0,.16,0-.08-.08-.12-.06,0,.05,0,.06a.9.9,0,0,1-.28-.17s0,0,.06,0,0,0,0,0a.37.37,0,0,1,.21,0c.07,0,.11.07.18.1s-.12-.12-.09-.19.12,0,.17,0,0-.06.06-.07l.22,0s0,0,0,0-.06,0-.09,0a.18.18,0,0,1-.07-.05s0,0,0,0a.93.93,0,0,1-.26,0s.06,0,.08,0a1.4,1.4,0,0,1,.17-.09s.05,0,.07,0,0-.09.07-.13l.07,0s-.06,0-.07,0,.07-.07.1-.1,0-.07.07-.08,0,.06.06.05a.43.43,0,0,0,.18-.06s-.06,0-.06,0,.05,0,.05,0a3,3,0,0,1-.33,0c-.17-.05,0,0,0-.17s-.26,0-.32-.13.15-.14.15-.14,0,0,0,0a.24.24,0,0,1,.13-.13c.06,0,.12,0,.18,0l0,0c.1-.24-.19-.06-.2-.13s.07,0,.09,0,0-.11,0-.11.07-.13,0-.17-.09.08-.12.05.05-.07.06-.11-.07,0,0,0,.44,0,.48.09,0,.14,0,.15.05-.07.09-.1.27.2.28.17-.05-.11-.05-.18.25,0,.25-.05a.35.35,0,0,0,.15-.12s-.12,0-.12,0,0,0-.1,0,0,0,0,0,0,0,0,0-.18,0-.16-.11.2,0,.25,0-.1-.07-.07-.1.09,0,.13,0,0-.07,0-.09,0,0,.06,0-.31,0,.1-.19l.08,0a1.14,1.14,0,0,1,.33.08c.05,0-.14.12-.11.17s.1,0,.13-.06,0-.08,0-.08.12.19.2.15.06-.1.1-.12.11,0,.15,0,.1,0,.14,0,.09.06.13.08.07,0,.08,0a.28.28,0,0,1,0,.2s0,0,0,0c.09.34.05-.1.14.2,0,.08-.17.2-.17.2s.27-.13.25.18-.25.14-.31.21,0,.18-.16.15-.07,0-.1-.07.09.07.06.11-.13,0-.17,0,.06,0,.06.07,0,.13,0,.19.06.09.06.14-.06.06-.06.11.05.06,0,.09-.09,0-.11,0,0,.06.05.1,0,0,0,0a.82.82,0,0,1,0,.27,2.93,2.93,0,0,1-.34.5s-.05,0-.06.06,0,.11,0,.17h0c0-.06,0,0-.11,0s0-.05-.06-.06-.23.07-.27,0,0,0,0,0,0,0-.08,0-.15-.07-.26,0,0,0,0,.06-.15.07-.15.07,0-.05-.07,0-.08.09-.13.13-.06-.15-.21-.13,0,.09,0,.13-.07,0-.11.06,0,.06-.07.07,0,0,0,0a0,0,0,0,0-.06,0s0,.06,0,.07-.22-.09-.27-.08-.1.05-.16.06.09-.11,0-.09a.77.77,0,0,1-.25,0c0-.05.27-.13.3-.2s0,0,0,0a2.39,2.39,0,0,1-.41,0l.11,0s0,0,0,0l0,0c.07-.07,0,0,.13,0s.18,0,.15-.07l-.37,0c-.07,0-.13-.12-.12-.2S280.38,299.11,280.4,299.1Zm-15.85-1.69a10.09,10.09,0,0,0-1.39,1.29,17.82,17.82,0,0,1-1.18,1.4,4.44,4.44,0,0,0-1.16,1.83,5.45,5.45,0,0,0,.31,3.46,6.6,6.6,0,0,1,.42,1.88c.08,1,.06,1.13-.24,1.58a3.8,3.8,0,0,1-1.17.94,3.22,3.22,0,0,0-1,.72,7.55,7.55,0,0,1-.71.89c-.5.54-.56.69-.5,1.15a4,4,0,0,0,.26,1c.24.59.1.85-.67,1.28s-.92.57-.92,1.4c0,.54-.07.8-.21.85a2,2,0,0,0-.56.63,13.41,13.41,0,0,1-2.83,2.85,3.35,3.35,0,0,1-1.5.28,9.4,9.4,0,0,0-1.59.13c-.47.09-.62.06-.78-.13a1.36,1.36,0,0,1-.17-.8,1.6,1.6,0,0,0-.33-1.1,2.48,2.48,0,0,1-.36-.69,4,4,0,0,0-.57-.92,2.66,2.66,0,0,1-.66-1.71,11.4,11.4,0,0,0-1.21-4.11,5.56,5.56,0,0,1-.6-1.44,5.38,5.38,0,0,1,.75-2.54,2,2,0,0,0,.26-1.94,3.13,3.13,0,0,1-.14-1,2.08,2.08,0,0,0-.26-1.08,4.83,4.83,0,0,1-.46-1.16,3.53,3.53,0,0,0-1-1.56c-.72-.78-.77-.88-.69-1.37a7.15,7.15,0,0,0,.07-3,1.73,1.73,0,0,0-1.62-.77c-.56,0-.65,0-.72-.35a1.23,1.23,0,0,0-.69-.66,3.43,3.43,0,0,0-3,.27,3,3,0,0,1-1.72.35,8.11,8.11,0,0,0-1.79.19,3.87,3.87,0,0,1-1.3.14,6.52,6.52,0,0,1-2.63-2.42A5.47,5.47,0,0,0,228.8,291c-.11,0-.26-.13-.34-.29s-.11-.29,0-.29.17-.6-.07-.92-.17-.32.11-.71.32-.64.32-1.52a6.94,6.94,0,0,0-.2-1.7c-.2-.6-.2-.62.31-1.36.28-.41.68-1.09.9-1.51a5.44,5.44,0,0,1,1.66-1.9,2.7,2.7,0,0,0,1.28-1.38,2.35,2.35,0,0,1,1.17-1.93,3.57,3.57,0,0,0,.95-.87c.16-.28.29-.36.4-.27a3.2,3.2,0,0,0,1,.23,2,2,0,0,0,1.67-.37,5,5,0,0,1,3.27-.73,6.8,6.8,0,0,0,1.9-.16c.21-.09.42-.13.47-.08a3.16,3.16,0,0,1,.08.94c0,.74,0,.89.37,1.21a2.09,2.09,0,0,0,.82.45c1.24.29,1.45.39,1.69.79a1,1,0,0,0,.78.51,4.41,4.41,0,0,1,.93.31,2,2,0,0,0,.73.2,1.15,1.15,0,0,0,1-1.13c0-.64.26-.68,1.24-.19a11.41,11.41,0,0,0,4.36.85l.79,0,0,.51c0,.39.09.74.56,1.51.33.55.87,1.51,1.18,2.14a13.78,13.78,0,0,0,.91,1.6,1.72,1.72,0,0,1,.33.9c0,.55.17.88.8,1.67a3.08,3.08,0,0,1,.56,1c.07.32.36.66,1,1.19a5.06,5.06,0,0,1,1.11,1.17c.1.23.23.42.28.42s.12.2.17.43a1.33,1.33,0,0,0,1.28.87,23.94,23.94,0,0,0,3.13-.65c.06,0,.14,0,.18.12a11.23,11.23,0,0,1-1,2.3C265.74,296.43,265.68,296.51,264.55,297.41Zm54.3-10.83a1.53,1.53,0,0,1,.21.27,8.84,8.84,0,0,1,.62,1.15c.09.22.18.75-.17.8,0,.26-.14.61.08.79a.88.88,0,0,1,.31.79c.31,0,.46.45.73.48a.19.19,0,0,0,.14,0c-.12.05,0,.09,0,.13s-.19.11-.22.12.13.18.1.21-.07,0-.1,0,0,.06,0,.09-.28-.08-.29-.08,0,.05-.07.09-.17.1-.15.14.06,0,.07.06-.17,0-.18,0,.11.11,0,.23-.07,0-.09,0,.07.12.07.16l-.08.35c0,.05-.11,0-.18,0s0,.05-.06.06-.6-.19-.61,0c0,0,0,.08,0,.09s.09-.05.13,0,.18.21.16.29a.1.1,0,0,1-.16,0,.27.27,0,0,1-.07-.14s0-.1,0-.1h-.24s-.51.28-.39.58.3.15.46.57-.08.46.11.69.53.49.61.72,0,.27.07.57.08.42.16.69a4.3,4.3,0,0,0,.26.6l-.19,0-.08,0a.79.79,0,0,0-.26,0c-.07,0-.22,0-.26.12s0,.29-.05.26-.07,0-.07.07,0,.12,0,.07-.1,0-.09.06,0,.17-.05.15,0,.18,0,.18a1.63,1.63,0,0,1-.17.31c-.05,0-.1,0-.09,0s-.11-.06-.12,0a1.3,1.3,0,0,0,0,.26c0,.1.07.18.07.21,0,.4-.15,0-.2.14s.09,0,.06.06-.1-.1-.11,0,.15.11.2.19-.16,0-.19,0,0,.13,0,.19-.05,0-.07,0,0,.05,0,.07a.44.44,0,0,1-.12.15c-.08.08-.09-.05-.1,0s.07.09,0,.12-.14,0-.19-.06H318c0,.05.1.07.13.1s.05.07,0,.07h-.05a.31.31,0,0,1,0,.18s-.07,0-.06,0,.06,0,.07,0,0,.07,0,.11.05.07.05.11-.05,0-.05,0,.06.16,0,.24-.05,0-.05,0,.13.17.07.17-.08-.13-.12-.1.06.1.06.15-.2.18-.07.34.07,0,.28,0c.06,0,.07.08.12.09s.06,0,.09,0,.06.08.1.11.28.18.28.21-.07.17.07.28h0c0-.08-.12-.37-.11-.38s.08-.09.1-.06,0,.12,0,.18a.75.75,0,0,0,0,.16c0,.07,0,.21.09.26s.07-.06.07,0-.08.17.06.31a.37.37,0,0,0,.15,0h.07s.07.19.13.2.07,0,.1,0a3.39,3.39,0,0,1,.52.29c.05,0,.08.1.13.12s.09,0,.13,0h.05v0c0,.46,0,.2-.16.54,0,.07,0,.27,0,.29s-.36.23-.48.14.25-.06-.2-.18c0,0,0,.05-.05.05l-.25-.08s0-.1-.07-.09a.31.31,0,0,0-.14.06c.22.09-.1.08,0,0h0s-.14.05-.18,0-.06,0-.08,0l-.2.09s0,0-.07-.06h-.24c0-.05,0-.3-.06-.3l-.15,0s-.06.09-.1.09-.15-.1-.39-.07c-.07,0,0,.15,0,.19s-.13-.1-.2-.07c-.23.11-.16.44-.47.44-.11,0,0-.16,0-.16s-.38.06-.56,0l-.11,0s0-.05,0-.05-.26.07-.26.07-.12,0-.18,0c-.45.1,0,0-.21.16l-.35.13c-.06,0-.12-.06-.18-.07l-.24.1c-.1,0-.2-.09-.3-.07s-.06.07-.1.08c-.23.11-.32-.08-.32.28l-.06,0s0-.06-.07-.07-.08,0-.12,0a3.29,3.29,0,0,1-.42-.21,2.45,2.45,0,0,0-.62-.19c-.1,0-.19.1-.29.07s-.37-.24-.41-.23.08.07.06.1L312,304c-.13,0-.18-.18-.3-.23s-.33.07-.48,0,.33-.11.21-.22-.08.08-.12.06,0-.1,0-.14.07,0,.11,0,.09,0,.12,0,0,0,0,0,0,0,0-.05a.59.59,0,0,1,.14-.06s0,0,0,0,0-.09.06-.11.12,0,.17,0,0,0,0,0,0-.05,0-.08-.17-.11-.21-.18.07,0,.08,0,0,0,0,0,.06-.09.08-.14-.08-.23,0-.28.06,0,.16.17c0,0,0-.05,0-.07s-.06-.26,0-.28.19.1.25,0,0,0,0-.06-.15,0-.22,0-.07-.08-.13-.09c-.22,0-.19.07-.33-.1s-.08-.06-.07-.08.07,0,.1,0a.21.21,0,0,0,.11,0c.05-.05,0-.15.11-.18s0,0,0,0,.23,0,.2-.05-.11,0-.16,0,.06-.15.06-.15.22-.32.27-.35,0,0,0,0,.09,0,.11,0,0-.2-.1-.24a.2.2,0,0,0-.13,0c-.14.06,0,.05,0,.13s-.34.17-.41.25,0,.1-.05.14,0-.06,0-.06a1.36,1.36,0,0,0-.33.14c-.05,0-.05.25-.07.27s-.05-.05-.09,0l-.18.22c0,.06,0,.16,0,.19s-.09-.1-.15-.09-.1.16-.17.24,0,0,0,0-.17-.06-.28.09,0,.12-.08.17-.06,0-.09.07,0,.47-.2.5-.1-.11-.15-.08a1.07,1.07,0,0,0,.12.24c.07.09.51.51.64.47s.09-.06.13-.1,0-.16,0-.16,0,0,0,.05a.12.12,0,0,0,.1,0s0-.12,0-.15l.33-.07s-.06.11-.07.17.11.27-.05.33h-.12c-.05,0-.06.1-.12.1s-.08-.05-.12-.06a.17.17,0,0,0-.14,0s-.09.08-.05.12,0,0,0,0,0,.05-.1.09,0,.16-.06.21-.06,0-.09,0a.35.35,0,0,0-.16.08c-.25.17-.17.62-.56.66-.07,0-.07-.05-.12-.07s-.16,0-.18,0,.09-.05.12-.08,0-.05-.08-.16.14-.09-.07-.31-.15,0-.22,0-.23-.12-.28-.12-.12.13-.32.05.18-.23.19-.24,0,0,0,0a.15.15,0,0,1,0-.06l.17-.15s0,0,0-.05.05,0,.07,0a2,2,0,0,0,.29-.3s-.07.05-.1,0,.05-.29-.08-.21,0,.1-.08.14-.11-.1-.18-.11,0,.09-.06.1,0,0-.06,0,0,.05,0,.05-.12,0-.17,0-.09.1-.15.12a.27.27,0,0,1-.18,0s0-.06,0-.07-.31.05-.33,0,.14-.1.12-.18-.07,0-.08,0-.11,0-.16,0,0,.08,0,.07a.42.42,0,0,1-.15-.11s.17,0,.18,0l.41-.05c.07,0,0-.09.05-.14l.1-.08c-.24.16-.49.31-.5-.14,0,0,0,0-.05,0s0,.07,0,.16.12.17,0,.19h-.13s-.07.07-.09,0,0-.18-.07-.15,0,.12,0,.19-.23,0-.4.19.09.07,0,.17-.07,0-.07.05,0,.07,0,.1a3.61,3.61,0,0,1-.17.46s0,.07-.07.07-.09,0-.13,0,0,.08,0,.09,0,0,0,0,.15.12-.08.21c-.07,0-.06-.15-.13-.17s0,.06,0,.09a.57.57,0,0,0,0,.26c.06.1,0,0,.07,0s0,0,0,0,0,0,0,0,0,.21,0,.26h0a0,0,0,0,0,0,0s0,0,0,0a1.72,1.72,0,0,1,0,.32c0,.1-.24.11-.3.16s0,.14-.08.13,0,0,0,0-.24.12-.1.21,0,0,0-.06,0-.15.07-.12-.14.34-.14.35.24.91.11,1-.07,0-.11,0c-.28.07-.1.07-.18.24s-.06,0-.08.05.05,0,.05,0a1.19,1.19,0,0,0,0,.33c0,.05.05.11,0,.15s-.1,0-.14,0l0,0s-.06,0-.06.07,0,.05,0,.06-.1.07-.13.11.2-.09.28.12c0,0,0,0,0,.05l.22.14c.16.17-.09.27.28.49.2.13.57.07.74.12s0,.07,0,.1,0,.11,0,.16-.21.1-.28.1-.06-.06-.07-.09c0,.18,0,0-.22.06a.35.35,0,0,0-.16.08s0,.07,0,.08-.21-.1-.34.07,0,.09,0,.14a1.42,1.42,0,0,1-.08.18c-.1.17-.31.2-.42.36s-.15.36-.3.49,0-.11,0-.15a.08.08,0,0,0,0-.07s-.05,0-.05-.06.4-.28.41-.38-.43.16-.54.12c-.3-.11,0-.1-.1-.23s-.31.07-.38.06c-.25,0-.28-.18-.45,0a.46.46,0,0,1-.12.12c-.22.11-.1-.16-.32,0s0,.19-.19.27-.17-.13-.31.05,0,.07.06.08.07.16.13.22h.08l0,0s0,0,0,0,0,.06.06.07.27.05.3.17-.2-.1-.2-.1-.34-.08-.36.07.18.06.24.12,0,.21,0,.18-.14-.18-.26-.25H303s-.09,0-.11,0c-.18.19.34.24.3.31s-.22,0-.28,0a1.21,1.21,0,0,1-.08-.25c-.06-.08-.28,0-.36-.1s0-.1,0-.25-.09.05-.14.09-.1.07-.1.13.07,0,.07.08l-.05.23c0,.15.2.22.29.32l.1.2c0,.05.45.25.39.34s-.32-.13-.35-.12,0,0,0,.07-.1.17,0,.16,0-.05,0,0,0,0,0,.06.23,0,.09.16a1.19,1.19,0,0,1-.36.16s0,0,.07,0,0,0,.07,0,0,0,.05.06,0,0,.05,0a.55.55,0,0,1,.18,0s0,.1.08.1.11-.07.16,0,0,.12,0,.14.14-.07.19,0,0,.14.13.15.2-.05.31.08,0,0,0,.11,0,.06.06.09,0,.09,0,.12.14.1.06.23-.05,0-.07,0,0,0,0,0a.38.38,0,0,0-.11-.08s0,0,0,0-.14-.19-.22-.22,0,.09-.1.1-.35.11-.33.15.12,0,.17.06-.05,0-.05,0,0,0,.05,0,0,.08,0,.1.23,0,.31.14-.13.07-.2.07h-.22s0-.05,0-.07h0c-.06,0-.14-.05-.18,0s.19.28.22.33,0,.07,0,.09.06,0,.07,0,.13.23.16.3-.06,0-.06,0,0,0,0,0,0,0,0,.06.19.11.17.18-.07,0-.1,0,0-.06,0-.08,0,0-.07,0-.18-.41-.38-.14a1.07,1.07,0,0,0,0,.27s0,.08,0,.07c-.19,0-.07-.21-.13-.3h0a.83.83,0,0,1-.11-.15s0-.11-.09-.12c-.37-.09,0,.27-.17.33s-.16-.15-.17-.21h0c-.07,0-.11-.09-.12-.17s.07,0,.09-.17-.19-.28-.3-.31,0,.05-.06,0,0-.11,0-.15-.25,0-.14-.13h0c.13-.09.07-.16.1-.3s0,0,0,0,0,0,0,0,.15.07.21,0,0-.09.13-.19.19,0,.27.07a2.7,2.7,0,0,0,.41.07c.07,0,.12.11.2.12s.09,0,.08-.07-.1,0-.11,0,.19.09.28-.17c0,0-.05,0-.08,0s0-.05,0-.05,0,.1-.06.05-.11,0-.21,0-.07-.12-.13-.13,0,.12-.06.12-.05-.33-.15-.15,0,.09,0,.12-.31-.05-.36,0-.18.14-.33.17-.11-.1-.15-.13,0,.06,0,.07a.33.33,0,0,1-.13.11s0,0,0,0,0-.11-.05-.19a.37.37,0,0,0-.12-.13s0,0-.05,0,0-.1-.06-.12-.21.15-.1-.14c0,0,0,0-.05,0s0-.06,0-.08-.3-.21-.39-.29,0-.09,0-.12-.16.07-.23-.15v-.05c0-.05,0-.09,0-.12s-.06,0-.07,0,0-.09-.07-.12-.55-.2-.49-.33.13,0,.15,0-.15-.11-.17-.2,0,0,0-.05,0-.07,0-.11,0-.07,0-.1.08,0,.1,0,0-.08,0-.08,0,.07,0,.09,0-.26,0-.34-.11-.05-.11-.14a.34.34,0,0,1,0-.2s.09,0,.12,0,0,0,0,0,0-.14,0-.17-.12,0-.18,0a.31.31,0,0,1-.17-.09s0-.07,0-.09-.13-.07-.19-.15,0-.05,0-.07-.13.17-.24-.07a.05.05,0,0,1,0-.05.48.48,0,0,1-.31-.1c-.41-.33-.35-.11-.62-.25,0,0,0,0,0,0l-.16-.06c-.05,0-.11,0-.15,0s0,0,0-.05,0,0,0,0,.11,0,.17,0,.22.13.34.14,0-.05,0-.05a.11.11,0,0,0-.07,0h0c-.11,0-.05,0-.08-.1H298a.91.91,0,0,0-.21-.11c-.09,0-.15-.18-.23-.21s-.14,0-.2,0-.08-.13-.24-.1a1.2,1.2,0,0,1-.27.08c0-.05,0-.13,0-.19s-.21-.08-.26-.12l.05,0c-.05-.07-.41-.27-.42-.37,0-.29.17-.07.28-.1s-.13-.05-.19-.08a2.41,2.41,0,0,1-.24-.21c-.15-.17,0-.38-.13-.54s-.07,0-.1,0-.06-.2-.29-.19c-.07,0,0,.21-.08.24h0v0a.49.49,0,0,1,0,.12c-.09.14-.06,0-.1,0v0h0a.14.14,0,0,1,0,.07.91.91,0,0,1-.09.17s-.06-.16-.09-.21-.18-.11-.13-.16h0a.32.32,0,0,1,0-.17v0c0-.05-.08-.1-.08-.16s.05,0,.07,0,.16-.15.09-.22-.14-.08-.23,0h0c0-.07-.15-.09-.22-.06s0,.11,0,.14-.08,0-.13,0-.21.18-.33.2-.08,0-.11,0,0,.05,0,.09,0,0,0,.06h0s0,.08,0,.1,0-.05,0,0,0,.09,0,.11,0,0,0,0h0s.12.06.13.11c.05.22-.14.13-.2.27a3,3,0,0,0,.11.5,4.93,4.93,0,0,0,.7.53c.11.06.14,0,.24.11a7,7,0,0,1,.35.86,1.34,1.34,0,0,0,.4.42c.05,0,.12,0,.16.08s0,.06,0,.08c.21.22.61.15.86.11.05,0,.17-.1.24,0s-.39.3-.1.5.67.17,1,.32c.1,0,.14.14.26.18a2.16,2.16,0,0,1,.43.14s0,.07,0,.1.34.11.42.38c0,.1,0,.07-.06.14s0,.19,0,.21-.08,0-.13,0c-.24-.1-.14-.24-.26-.4s-.3,0-.42,0-.24-.23-.38-.08-.21.41-.21.43,0,.05,0,.08-.19.14-.06.31.1,0,.19,0,.15.12.24.16.08,0,.09,0,0,.06,0,.09c0,.22.11,0,.1.29s-.32.11-.46.27,0,.23,0,.37-.1.09-.18.15-.06.54-.45.43c-.07,0-.16-.23-.11-.31s.11,0,.15-.08a.42.42,0,0,0,0-.12s0-.07,0-.11-.09-.07-.08-.11.22-.07.27-.14,0-.18-.08-.27,0-.22-.08-.32a.68.68,0,0,0-.09-.17l-.06,0c-.14-.21,0-.08-.08-.32s-.19-.14-.42-.13c0,0,0,0,0,0a.54.54,0,0,0-.12-.09c-.05,0-.14,0-.17-.06s.06-.1.05-.17a.48.48,0,0,0-.08-.16c-.19-.26-.22.1-.44,0,0,0,.15-.13.07-.18-.28-.21,0,0-.31,0,0,0,0,0,0-.07a.9.9,0,0,0-.27-.38c-.21-.08-.05.07-.12.06s-.13-.1-.21-.1-.12.11-.18.1-.06-.12-.11-.17-.2,0-.24-.06l-.12-.16c-.05-.05-.14-.06-.19-.11s0-.12-.09-.2l-.15-.1s0,0-.07,0-.08-.2-.17-.27-.24,0-.39-.09,0,0,.05-.05-.05-.16-.07-.18-.05,0-.06,0,0-.08-.06-.1-.11,0-.14-.06,0-.09,0-.11-.12,0-.18,0,0-.08,0-.13a.41.41,0,0,0-.08-.34c-.17-.24-.05-.45-.25-.62a.07.07,0,0,0-.07,0s0,0,0,0-.06-.06-.1-.06,0,.07,0,.06a.39.39,0,0,1-.16-.1s-.22-.22-.28-.22,0,0,0,.05a0,0,0,0,1-.05,0,.6.6,0,0,0-.28-.12.92.92,0,0,0-.25.15s0,.08,0,.1-.09,0-.11,0-.09.17-.16.23-.28.09-.39.11a.64.64,0,0,0-.16.06s0,0,0,0,0,0,0,0a.29.29,0,0,0-.13.05s0,.07,0,.1-.09,0-.13,0,0,.09-.06.12-.07,0-.1,0,0,.05,0,.07-.09,0-.1.08.06.08,0,.1-.12,0-.17,0-.12.08-.18.11,0-.09-.17-.1,0,0,0,.06h-.07s-.05,0-.06,0,.06-.05-.05-.11h-.08a.37.37,0,0,1-.15,0s0-.12,0-.16-.05,0-.08,0-.14,0-.13,0,.14,0,.15-.1-.08-.11-.14-.1,0,.09,0,.12a.23.23,0,0,1-.16.06c-.12,0-.08-.23-.11-.2s.13.18.06.21c-.24.1-.14-.06-.14-.09s-.28-.06-.31-.08-.14-.13-.21-.08-.21.2-.3.24-.23,0-.33.14,0,.05,0,.07-.12.13-.13.21.06,0,.06,0-.06.1,0,.26.19.16.16.25-.12.05-.16.08.1.21,0,.35-.37.21-.47.25a1,1,0,0,0-.28.12s-.11.15-.18.16c-.27.08-.74,0-.95.2s-.16.08-.15.15.14.05.13.1-.24.08-.25.09-.13.2-.21.28a3.2,3.2,0,0,0-.64.73.93.93,0,0,0,.09.59s.31.19.24.24-.18.06-.24.1,0,.06,0,.06,0,0-.05,0a.47.47,0,0,0-.19.06s0,.08,0,.1-.06,0-.08,0,0,.1,0,.13-.09,0-.11,0,0,.12,0,.16-.2,0-.21.23c0,.06.12.09.11.14s-.11.05-.17,0-.08,0-.12-.05a.66.66,0,0,0-.5.13c-.24.15-.24.46-.49.58-.09.05-.12-.2-.36-.14,0,0-.07.08-.12.09s-.23-.11-.3-.11-.2,0-.3,0-.08-.06-.14-.08a3.78,3.78,0,0,0-.64-.09c-.1,0-.14.14-.23.18s-.28-.09-.45,0-.12.13-.19.24-.06,0-.09,0-.09.1-.15.12,0,0,0-.06l-.11,0s0-.1-.07-.13-.07,0-.1,0a1.21,1.21,0,0,1-.14-.39s.11.11.1,0-.05,0-.06,0,0,0,0,0-.14,0-.14-.2c0,0,.31-.14.24-.16s-.1.12-.17.1,0-.1-.05-.15a.94.94,0,0,0-.09-.12l-.21-.2s.1-.1.06-.1,0,.1-.09.1-.07-.05-.11-.07a.84.84,0,0,0-.37,0l-.28.12s-.46-.25-.58-.29l-.07,0h-.14s-.09.06-.1,0,.18-.34.21-.4,0-.17,0-.25.06,0,.08,0,0,0-.06,0,0-.11,0-.17-.05-.05-.05-.08.13-.17.15-.27a.92.92,0,0,0,0-.16s-.12-.1-.07-.11,0,.24.25.14c0,0-.07,0-.1-.06s0-.09,0-.12,0,.08,0,.07-.05-.05-.08-.05-.05,0-.08,0a.41.41,0,0,1-.19,0s0-.06-.05-.19-.07-.11-.09-.16.21-.4.24-.48-.06-.11,0-.15.12,0,.18,0,0,0,0,0,.07-.05.1-.08a2.59,2.59,0,0,0,.25-.39s.05-.1.09-.13.07.05.06,0-.08-.05-.08-.09,0-.06.06-.1.09-.2.15-.3.14,0,.18-.09,0-.11,0-.1-.06.13-.11.15,0-.1.07-.14a.72.72,0,0,0,.11-.32s0,0,0-.06a1.33,1.33,0,0,1,0-.49s.12,0,.11,0-.11,0-.14-.07.15-.11.16-.18-.07-.12-.07-.18,0,0,.06,0,0,0,0-.05.13-.05.18-.09.05,0,0,0-.1.05-.14.06-.06-.06,0-.09.15,0,.17-.07-.1,0-.14,0a.1.1,0,0,1-.06-.08c0-.08.06,0,.07,0s0-.07,0-.1.09,0,.1-.09c0-.38-.27.05-.34-.32s.17-.18.18-.22-.06,0-.08,0,0,0,0,0a.6.6,0,0,1,.19,0,2.7,2.7,0,0,0,.66-.27c.07,0,.15-.13.22-.08s-.05.11,0,.12.1-.1.17-.1.19.37.38.41c0,0,.06-.08.1-.07.22.06.1.06.32.09.05,0,.15,0,.2,0s.07.06.12.06.11-.08.17-.06.07.11.11.14.14,0,.19,0,0,0,0,.05.07,0,.09,0a1.51,1.51,0,0,0,1,.31s0,0,0-.05h.09c.06,0,.23,0,.27.09s-.06.06,0,.06,0,0,0,0,.23.18.29.18,0-.06,0-.07.05,0,.08,0c.23,0,.08,0,.17.1s.09,0,.13,0,.07.07.1.1a.83.83,0,0,0,.58,0c.22-.1.32-.85.4-1.08,0,0,0-.1.07-.11s.11.05.12,0,0-.1-.08-.11,0,.11-.08.09,0-.15.05-.23a2.29,2.29,0,0,1,.2-.64s.14.15.17.23c.11.23,0,0,0,.27,0,0,.07.08.08.13s0,.09,0,.08.06-.06.06-.09-.07-.06-.11-.1,0-.29,0-.4a1.24,1.24,0,0,0-.14-.18.55.55,0,0,0-.11-.1h0c.05,0,.1,0,.14,0s-.11-.11-.1-.17.09-.09.1-.15-.05-.09-.05-.14.05-.1.05-.16h-.07s0,.06,0,.05,0-.08-.08-.1-.05,0-.08,0,0-.07,0-.09-.06.16-.19-.1a1.2,1.2,0,0,0,0-.23h0a.83.83,0,0,1-.09-.16c0-.07.12-.15.14-.18s-.16-.12-.16-.13a.12.12,0,0,1,0-.12s0,0,0,0c-.32,0,0-.11,0-.28s-.32,0-.33-.05.08-.09.13-.12,0,0-.05,0,0,0,0,0,0,0-.05,0-.12,0-.18,0l0,0h0c0-.1.09-.2-.07-.21s-.07.1-.13.06-.11-.13-.15-.16-.07,0-.1,0,0-.17-.17-.15c0,0,0,0,0,0s-.13.07-.18,0,0-.11,0-.17-.13-.07-.19-.11l0,0h.23s.06,0,.06,0a1,1,0,0,0-.12-.2h.14s.1,0,.08,0-.15,0-.17-.07.11,0,.12-.08-.47.27-.31-.15a2.44,2.44,0,0,1,.34-.1c.08,0-.11.1.07,0s.11-.07.17-.05,0,.11.07.12,0-.09,0-.1.09.1.14.09,0-.12.07-.15,0,0,.07,0,.1-.05.14,0,0,.1,0,.12,0,0,.05-.05.16.3.19.36,0,0,0,0A.59.59,0,0,1,284,303s.08-.09.11-.07,0,.3.2.22,0-.12.06-.17,0,.1.09.11a.66.66,0,0,0,.14,0s.14.07.15,0-.16-.15-.14-.24a1,1,0,0,1,.06-.16s0,0,0,0a.48.48,0,0,0,.06-.18s0,0-.05,0,0-.11,0-.14-.06,0-.07-.05a.3.3,0,0,1,0-.16s0,0,0,0a1,1,0,0,0,0-.17s0,0,0,0l.18.08s0,0,.06,0,.12,0,.18,0,0,.06,0,.09l0,0a.77.77,0,0,0,.07.27c.32.05-.14-.14.11,0s.26.07.37.12.06.08.1.09.14-.08.28-.12H286c-.08,0-.16-.08-.05-.26s.6-.14.74-.22.09-.07.15-.1.13,0,.15-.06-.06-.07-.07-.12a.12.12,0,0,1,0-.08s.05,0,.05,0,0,0,0,0h0l-.15,0s-.06.08-.1.08-.2-.13-.27-.15-.44.09-.47,0,.11,0,0-.06,0,0,0,.06,0,0-.05,0,.06-.05,0-.05,0,.05-.07,0,0-.05,0-.07,0,.07,0,.06-.17-.19-.19-.16.06.09.05.14-.44,0-.46,0,.06.09,0,.14,0,0-.07,0h0s-.16-.11-.2-.09,0,.09-.05.13,0-.05,0-.07a.21.21,0,0,0-.09-.1.69.69,0,0,0-.54-.12s-.08.37-.2.43-.25-.19-.32-.22.08.07,0,.05-.23-.12-.33-.09,0,.08-.06.1-.1,0-.15,0h0s-.11.23-.14.23,0-.11-.05-.15-.23,0-.23-.11.31-.07.31-.07a.12.12,0,0,0,.09-.07s0,0,0,0,.05,0,.07,0,.07-.12.12-.16.06,0,.09,0,0-.05,0-.06.1-.05.14-.1,0-.21.07-.23.07.06.1.06c.18,0,0-.25.4-.18.15,0,.34.23.49.11s0-.11.06-.16.38-.25.42-.3-.2.11-.23.13l-.12,0s0,0-.06,0c-.19.05-.15.22-.38.08-.08-.05-.06-.18-.13-.25s-.18.08-.26,0,0-.25,0-.28,0,0,0,0,0-.06-.17,0c0,0,0,0,0,.06a.29.29,0,0,1-.16,0s-.11-.05-.09-.08.1,0,.15,0-.2,0-.22,0a.32.32,0,0,1,0-.17c0-.15.29-.06.33-.08s.06-.09.11-.1.08,0,.12,0a1,1,0,0,0,.42-.35.91.91,0,0,0-.07-.38c-.13-.16-.28.3-.33,0,0-.05.15-.06.25-.14s0-.06,0-.08a.12.12,0,0,1,.05,0,.1.1,0,0,1-.07,0s0,0,0,0c0-.17-.16-.2,0-.26.14.11.25.17.1.24a.39.39,0,0,0,.21,0s0-.07,0-.06.08.07.14.08.13-.09.21,0,.05.16.1.13,0-.12,0-.17,0,0,.09,0a.34.34,0,0,1,0-.14.23.23,0,0,1,.1-.12s.11,0,.1,0-.11,0-.13-.09c-.1-.22.17-.05.17-.14s-.06,0,0-.08.09-.09.08-.15-.1.09-.21.1,0-.15,0-.21-.05.06-.08.05,0-.11,0-.16l-.09-.19c0-.1.25-.35.26-.35s0,0,0,0,.15,0,.16-.08-.09,0-.14,0-.06,0-.1,0-.07.08-.11.1-.09,0-.13,0-.07,0-.11.07,0,0,0,0,0-.06,0-.07,0,.05,0,.06,0,0,0,0,0-.16-.13-.17,0,.1,0,.23-.07-.08-.11-.13c-.22-.29,0,.05-.29-.13-.08,0,.11,0,.1,0s0-.17.13-.29-.14,0,.11-.19c0,0,.08,0,.09-.05s-.11-.24-.12-.25,0,0,0-.05,0-.12,0-.18.09,0,.16,0c.26.12-.13-.07-.13-.08a.33.33,0,0,1,0-.17s0-.09,0-.12a2.06,2.06,0,0,0-.35.19c-.06.05,0,.16,0,.25s-.07,0-.1,0a.15.15,0,0,0,0,.07s0,0,0,.07-.08.09-.11.15,0,.05,0,.06a.26.26,0,0,1-.19,0c-.05,0,.06-.09.09-.13s0-.16.07-.22l.17-.14s-.1,0-.12,0,.21-.16.1-.18-.07.1-.11.07.11-.07.14-.12,0-.2,0-.26a.19.19,0,0,1,.1-.1s.11.08.11,0-.09,0-.11-.08.26-.16.27-.16-.1,0-.1,0,.08-.06.09-.1,0,0-.07,0,0,.06-.09.08-.2.14-.27.11,0,0,0,0,0,0,0,0-.37.16-.43.05,0,0,0,0,0,.17.22-.09-.36-.08,0-.2a.19.19,0,0,0,.05.09l0,0,0-.09s.06,0,.08,0,.13,0,.18,0-.42,0-.36-.11.25,0,.27,0-.2-.17,0-.23c.05,0,.11.06.17,0s-.05-.18-.05-.18.14,0,.18,0,0-.12,0-.18a.56.56,0,0,0,0-.13s-.27-.28-.1-.35.05.12.1.1,0-.19.07-.13l.13.07c0-.11-.06-.11-.06-.21s.1,0,.12,0,0-.12,0-.18,0,0,0,0,.14.07.17,0-.07-.08-.09-.13.08,0,.08,0,0-.05,0-.06.06,0,.06,0-.06,0-.05-.06.06-.09.09-.14.13.07.15.12,0,0,0,0,0,.11,0,.14.05-.06.08-.07a2.08,2.08,0,0,1,.54,0c.06,0,.14,0,.18,0s-.06.08-.08.13,0,.09,0,.14a6.89,6.89,0,0,1-.6.4c-.15.12.07,0,.15.05s0,0-.07.07,0,.06-.08.07,0-.06,0-.06-.06,0-.08,0-.06,0-.09,0,.09.19.13.14,0,0,0,0,.08,0,.13,0,.19-.1.3-.07.1.06.16.07.56,0,.63.19a.17.17,0,0,1,0,.14l-.18.18a.21.21,0,0,0,0,.11s0,0,0,0-.39.57-.49.58-.21-.06-.35,0,.05,0,.07,0a1,1,0,0,0,.18-.05c.1,0,0,.07,0,.09s.12.07.11.13-.18,0-.23,0c-.24,0,.19.14-.31.1,0,0,0,.09,0,.09s0,0,0,0,.19.12.26.07,0-.08.07-.09a2.14,2.14,0,0,1,.34.24c.06,0,.08.23.13.29s.08,0,.1.07,0,0,0,.06a.71.71,0,0,0,0,.15,5.71,5.71,0,0,0,.11.83s0,0,0,0,.05,0,.08.07.11,0,.24.17,0,.15.07.21.14,0,.14.17-.08,0-.09.09.12.3.15.41-.09-.07-.1.1.28.33.14.48-.15,0-.23.18c0,0,.06,0,.07,0s0,.07.06.09.07.06.09.05,0-.21.2-.18.69.15.62.57c0,.13-.21.48-.34.53s-.12-.08-.13,0,.29.1,0,.19c0,0,0,0-.06,0h0c-.07,0-.16,0-.19,0s.12,0,.15,0,0,.09,0,.13-.23,0-.32.07-.08,0-.06,0,.23-.07.23,0-.1,0-.13,0,0,.05.08.05l0,0s0-.05,0-.05l.06,0,.2,0a1.18,1.18,0,0,0,.28,0c.18,0,.48-.31.66-.27s.07.1.21.1,0-.07.08-.06.18.16.21.14,0-.11,0-.14-.08,0-.11,0-.06-.06-.09,0,0,.05,0,.05a.88.88,0,0,1-.29-.16c0-.06.12-.08.26,0s.16.29.28.14-.17-.05-.18-.12.11,0,.14,0,0-.07-.06-.08-.05,0-.08,0a1.13,1.13,0,0,1-.18-.12c-.06,0,.18,0,.26-.1s0-.11,0-.15.06,0,.09,0,.06-.07.09-.11a1.13,1.13,0,0,0,.23-.34c0-.13,0-.38.11-.5h.06c.05,0,.11,0,.17,0s.16-.13.23-.23a1.68,1.68,0,0,1,.8-.22c.15,0,.16.4.37.19.05,0-.14,0-.19,0s.11-.32.17-.35.09,0,.13,0c.58,0-.61-.07.28,0l0,0c.05.09.08.44.28.37s-.07-.56.11-.56c0,0,0,0,0,.05a.16.16,0,0,0,.1,0c.07,0,.15-.06.22,0h0s-.2,0-.19-.07.12-.29.05-.37-.19.06-.22,0,0,0,.06,0-.06-.05,0-.05.21.05.23-.1-.18-.21-.19-.24a.75.75,0,0,1,0-.3s.07-.08,0-.11-.14,0-.14,0,.11,0,.14,0,0-.1,0-.16,0-.12,0-.15-.27,0-.31-.13.06-.19.06-.29a.07.07,0,0,1,0-.05s0-.11,0-.08a.25.25,0,0,1,0,.08.11.11,0,0,1,0,.05h0a0,0,0,0,0,0,0c.24.11.09-.2.07-.23s0-.06,0-.05,0,.09-.07.1,0-.06,0-.08,0-.11,0-.16,0-.1,0-.13a0,0,0,0,1,0,0h0s-.05-.35,0-.32,0,.09,0,.13.4-.24.42-.24,0,.21,0,.25.09,0,.15,0h0s0-.09,0-.12-.06,0-.07,0,0-.05,0-.08-.1-.13,0-.23a.12.12,0,0,1,.15,0s0,.08,0,.07,0-.11.07-.13h.1s0,0,0,0-.18,0-.24,0-.1.07-.15.08,0,0-.07,0a.47.47,0,0,0-.17,0s0,.06,0,.07,0-.26-.14.15c0,0,0,.23,0,.23-.26,0-.12-.5,0-.55s.32,0,.45-.05.14-.33.3-.42.13,0,.18,0,.09-.14.15-.14-.06.08-.07.15,0,0,.08.16-.06.5-.2.46-.08-.08-.14-.08,0,0,0,0a1.83,1.83,0,0,0,.23.07c0,.05,0,.1,0,.16s.07.07.05.11-.07,0-.1,0,.12,0,.11.09l0,0s.05.08.09.08.23-.1.27.07-.17.38-.23.35-.06-.14-.12-.16-.06.38-.08.43a.23.23,0,0,1-.21.17c-.06,0-.18-.09-.16,0s.15,0,.18.08-.2.11-.2.12.07,0,.09,0-.05,0-.05.06a.3.3,0,0,0,0,.13s.05,0,.05.05-.14.12-.16.21.06,0,.09,0a.2.2,0,0,1,.1.15s-.05-.06-.08-.05-.15.17-.1.14,0-.07.08-.07,0,0,0,.05.05,0,.07,0a.24.24,0,0,1,.15,0,.08.08,0,0,1,0,.07h0s-.05,0,0,0,0,0,.05,0a.13.13,0,0,1,0,.12s-.12.07-.09.1.18-.08.19,0-.08.13,0,.15.05-.11.11-.12.22.15.26.13.17-.18.22-.08-.43.41-.14.44c.06,0,.11-.07.17-.07s0,.23.16.12.07-.22.14-.26.22-.08.26,0,0-.07,0-.08a1.49,1.49,0,0,1,.14-.12,1.86,1.86,0,0,0,.1-.2.64.64,0,0,1,.21.05h.1c.05,0,0,.11.05.16s.08,0,.1,0,.07.15.14.14.12,0,.18,0,0,.05,0,.07a.82.82,0,0,0,.06.19c0,.06.1.08.16.1.26.09,0-.16.08-.2s.07,0,.11,0,.12-.1.19-.13a5.85,5.85,0,0,1,.83-.3s.07-.2.2-.31.14,0,.21-.07.52-.38.8-.33l.14.05c.07,0,.08,0,.09.06h0a.16.16,0,0,1,.08.06s0,0,0,0a.18.18,0,0,1-.09-.09l-.09-.06h-.07s0,.05,0,.07,0,.25.17.31a.57.57,0,0,0,.69-.48,1.37,1.37,0,0,1,0-.19s0,0,0,0,.22,0,.31-.11l.16-.26a.94.94,0,0,0,.06-.31c0-.07-.07-.13,0-.19h0l0-.05c-.07-.2,0-.07,0-.27s-.19-.36-.1-.47h0l0,0s0-.1,0-.15,0-.1,0-.15.13-.11.15-.19-.09-.42.1-.61.17-.09.25-.16.12-.14.19-.11,0,.12,0,.16.25.1.32.17.07.17.12.25.06,0,.14.05.07.05.12,0,.3-.24.32-.35-.15-.4-.18-.56,0-.1,0-.28,0-.12,0-.18.06-.06,0-.08c-.16-.19-.16.1-.21.13s-.07-.05-.11-.06-.08,0-.12,0,0-.13-.07-.2-.14-.12-.17-.21.08-.15.06-.22-.25.06-.14-.23c0-.08.27-.06.3-.12s-.06-.07,0-.11.28-.12.36-.15-.06-.09,0-.11.05,0,.08.05a.37.37,0,0,0,.25,0,.26.26,0,0,0,.11-.12s0-.09,0-.1,0,.08.08.09c.25,0-.08-.06.06-.09s.05,0,.07,0a4.66,4.66,0,0,0,.93,0c.22-.14-.11-.31,0-.43s0,0,.06,0,.08.08.11.05,0-.1,0-.15.18,0,.21,0c.18,0-.16-.25.26-.27.14,0,.59.07.37-.11,0,0-.11,0-.16,0s-.06-.19-.25-.11-.15.13-.25.08,0,0,0-.05a.35.35,0,0,0-.11-.1s-.09,0-.11,0,0-.25-.07-.35-.15.22-.16.22-.13,0-.18,0,0,0,0,.06a.29.29,0,0,1-.12.1s-.17-.09-.17-.09,0,0,0,.07h-.05s0,0,0,0,.24,0-.13.16,0-.12-.11-.17,0,.21-.06.26,0-.07-.06-.07-.15-.05-.17,0,.12.07.13.13c.07.29-.22,0-.23,0s0,.14,0,.15a1.13,1.13,0,0,1-.22.14s0-.06,0-.05,0,.05,0,.07,0,0-.05,0-.12,0-.16,0,.06.06,0,.08-.23.06-.28.09,0,.09-.08.11-.13.07-.18,0,.06-.14,0-.12,0,.23-.27.33c0,0,0,0,.05-.07s.09,0,.11-.08.05-.12,0-.11,0,.14-.09.12.08-.09.07-.14-.08,0-.11,0c-.19-.07-.09-.2-.05-.32s0,0,0,0a1.43,1.43,0,0,1-.22.15s.1,0,0-.21c0,0,0,0,0,0a.07.07,0,0,1-.06,0s0,0,0,0,0,0-.08,0-.06-.07-.11-.08-.11,0-.16,0,0-.11,0-.11,0,.27-.2,0a.31.31,0,0,1-.05-.1s.07,0,.05-.05-.15-.11-.14-.31c0,0,.09,0,.09,0s0,0,0-.08,0,0,.05-.07-.05,0-.05,0,0-.06,0-.08-.11-.09-.09-.16.13,0,.14-.05-.08-.08-.12-.13a.08.08,0,0,1,0,0s0,0,0,0,0,0-.06,0,0,0,0-.05a.83.83,0,0,0-.07-.13s-.07,0-.08,0,0-.25,0-.37,0-.05,0-.05,0,.08,0,.07,0-.06,0-.08,0,0,0,0,0-.18,0-.18c-.08-.2-.13.33-.09-.18,0-.09.21-.22.23-.3s-.25,0-.13-.19a.18.18,0,0,1,.17-.06s0,.1.07.11,0-.08,0-.11.21,0,.14-.21c0,0-.07-.05-.07-.09s0,.07.06.05,0-.2,0-.26.07.05.1.05a.81.81,0,0,0,.06-.2c0-.13.21-.11.24-.26s-.05-.05,0-.07.09-.1.13-.19,0-.09,0-.14.11-.09.12-.16,0-.08,0-.12a.63.63,0,0,1,0-.19s0,0,.06,0,0-.05,0-.07.09-.07.13-.1.13,0,.15-.07c.09-.22-.12-.07-.14-.14s0-.23-.05-.41-.05,0-.1,0,0-.06,0-.06-.11.05-.16,0,0-.14-.08-.17-.18.09-.25.13-.06-.06-.1-.06,0,.05,0,.05-.14-.05-.19,0,0,.12,0,.14-.21-.08-.33-.1,0,0,0,.07,0,0,0,0-.05.1,0,.15a0,0,0,0,0,0,0l.07,0-.07,0h0l-.17-.05s-.05-.07-.06-.05.2.05.21.14-.09,0-.14,0,0,0,0,0,.09.06,0,.1,0,0,0,0,0,0,0,0-.24,0-.27.12,0,0,.06,0a.37.37,0,0,1,.13.15c0,.14-.19.21-.2.36s.25.2.31.34-.15.21-.18.28-.06.48-.16.49,0-.05,0,0,0,.13,0,.15,0-.09,0-.08,0,0,0,0h0s0,.07,0,.08-.12,0-.14.07,0,.09-.06.11-.11-.07-.14,0,.08.11.06.17-.08-.08-.11-.06,0,.1,0,.14,0,.14-.07.17-.1-.06-.16-.05.07,0,.08.05,0,0,0,0,0,0,0-.06h-.05s0,0,0,.07-.06,0-.09,0,0,0,.05,0,0,0,0,0,0,.09,0,.11-.15,0-.12,0,.19,0,.17,0-.09.1-.13.16,0,0-.05,0-.07,0-.07,0,.06,0,.07,0-.07,0-.1,0l0,.08c0,.05.06.2,0,.19s0-.08,0-.07,0,.11,0,.14-.05,0-.08,0a.34.34,0,0,0-.17,0c-.12.09.09.13.18.24s0,0,0,0h0c0,.06,0,.12,0,.18s0,.07-.05.11a.66.66,0,0,0,0,.14h0c0,.06.12.14.07.18s-.11-.08-.18-.06.13.23.1.4-.07,0-.07,0,.05.05.06.08,0,0,0,0a.34.34,0,0,0,0,.1s0,.07,0,.1,0,0,0,0,0,0,0,0a.06.06,0,0,0,0,.06s.07.06.08.11,0,.09,0,.14h0s0,.06,0,.06.24-.05.32,0,0,.07,0,.1a.29.29,0,0,0,.11.11s0,0,.05,0,0,.05,0,.06.41-.16.2.07c0,0-.1-.07-.15-.05s.05.05.08.08,0,.11.08.14,0-.07.07-.06,0,.09.05.11.2,0,.18.26-.08,0-.09,0,0,0-.07.08,0,.15-.22.25c0,0,0,.07,0,.08s-.06,0-.09,0-.11.06-.17.06,0-.12,0-.17,0-.05-.06-.08,0,0,0,0,0-.12-.09-.14a.12.12,0,0,0-.12.06s.06,0,.07,0,0,.13,0,.17.14,0,.12.07-.32-.09-.37-.08-.09.11-.16.11-.06-.11-.1-.1,0,.09,0,.13,0,0-.05,0a.65.65,0,0,0-.19,0s0,0,0,.05.14,0,.19,0,.15.09.22.07-.06-.11,0-.1.06.08.11.1.11,0,.15,0-.06.08,0,.11.07,0,.1,0-.05-.06,0-.06.07,0,.1,0,.11.05.17,0,0-.11,0-.13.09,0,.13,0,.06-.12.12-.13.13.07.11.11-.14,0-.2,0,0,0,0,0a.34.34,0,0,1,.07.15s0,0-.05,0a.35.35,0,0,0-.15.12c0,.05,0,.12,0,.17s0-.11-.08-.1,0,.1,0,.09,0-.3-.09-.28,0,.34-.12.44-.12,0-.17,0,.06,0,.06,0-.08,0-.1.05.05,0,.05,0,0,0,0,0l0,0s-.41-.05-.38,0,0,0,.06,0,0,0,0,0,0,.06,0,.05,0-.05,0-.05a.22.22,0,0,1,.28.13h-.05s0,.07,0,.07-.14-.08-.18,0,.12,0,.17.05a.29.29,0,0,1,.07.2s-.1,0-.11,0,.17.25.11.32-.13,0-.18,0,0,0,0,.05.16.07.16.14-.11.08-.1.14.08.05.11.09,0,0,0,0a.67.67,0,0,0-.07.18c0,.05.1.22.09.23s-.06,0-.08,0,.07.19.05.29-.07,0-.07,0,0,.06,0,.08c-.08.26-.05-.19-.08.08s0,.42-.17.54,0,0,0,0,0,0,0-.05-.13,0-.13,0,0,0,0,0-.08.05-.12.09,0-.06-.05-.06a.26.26,0,0,1-.14.05s-.07,0-.11,0-.07,0-.08,0,.07.09.05.13-.11,0-.17,0-.05.07-.08.11c-.2.3.06.2,0,.4a.35.35,0,0,1-.09.17s-.17,0-.19,0c-.19,0-.13.12-.33.12s-.11,0-.17-.05a.37.37,0,0,1-.11,0c-.05,0,.09-.06.09-.06s-.05-.08,0-.13.06-.07.08-.11-.41-.57-.37-.63.14.09.21.06-.16-.12-.13-.18.13,0,.16,0a.19.19,0,0,0,0-.19s-.06,0-.09,0,0-.14-.1-.19-.09,0-.12-.08,0-.07,0-.1a1.71,1.71,0,0,0-.11-.17s0,0,0,0,0,0-.06,0a.31.31,0,0,1-.09-.11c0-.07,0-.26-.05-.35s-.07,0-.09,0a.27.27,0,0,1,0-.13c0-.12.21-.39.1-.52s-.06.31-.35,0c0,0,0-.19,0-.24s-.1-.44-.1-.44.12,0,.17,0,0-.08,0-.11c-.16-.26-.08.12-.34-.12,0,0,0-.07,0-.1s0,0,0,0,0-.19,0-.17,0,0,0,.05,0-.06,0-.08l-.06-.23c0-.05.07-.15,0-.15s.14.24-.05.38l0,0c0-.05,0-.1,0-.14s-.1-.11-.11-.07.07.1.1.16,0,.1,0,.14.11.07.06.18,0,0,0,0,0,0-.05,0,0,.24-.05.24,0-.11,0-.09.12.17-.21.17c0,0,0-.08,0-.1s-.11-.11-.13-.07.07.09.1.14-.21,0-.23.12.08.06.06.08-.14,0-.18.05.07,0,.07.07c-.05.32-.11-.09-.15.07s0,0,0,.05-.24.29-.24.3,0,0-.06,0,0,.14-.1.15-.05-.12-.11-.1,0,.12-.07.15-.08,0-.12,0,0,0-.05,0-.05,0-.16,0-.12.09-.15.05.1-.07.08-.12-.07.06-.11.06a.33.33,0,0,1-.19,0c-.13-.06.13-.14.15-.2s-.05-.06-.08-.05,0,.08-.06.08-.09,0-.14,0-.15-.18-.2-.21-.06,0-.1,0a.62.62,0,0,1-.14-.28s.06-.08.07-.14,0-.16,0-.14,0,.14.08.17,0-.08.08-.1.08.16.15.14,0-.08,0-.11.18,0,.27-.09-.07,0-.11,0-.1,0-.14,0,0,.12-.07.09-.05-.11-.07-.17.11,0,.14-.08-.07,0-.07,0a.2.2,0,0,1,.1-.08s.14,0,.16-.06-.19,0-.23,0-.05.05-.05,0,.14-.07.13-.13a.16.16,0,0,0-.18-.06c-.1,0-.06.27-.17.26s0-.1,0-.13-.12-.06-.13-.11.09,0,.13,0,0-.14.08-.16.06.06.1.07,0,0,0-.05h.05s-.07,0-.07,0l.3-.14c-.25,0-.09.19-.33,0h0s0-.06,0-.06.07,0,.11,0,0,0,0-.05a.43.43,0,0,1,0-.07s.13,0,.14,0-.1,0-.1-.08,0,0,0-.07,0,0-.06,0a.39.39,0,0,0-.08.1c0,.06,0,.14-.06.18s0-.06,0-.08-.08-.07-.05-.14.15-.21.08-.19-.13.37-.22.19a.85.85,0,0,1-.06-.17c0-.07.11,0,.25-.05s.07-.23.07-.23c0-.25-.17.07-.24.08s0-.08,0-.11-.15-.15-.11-.16.11.06.16.1h0s0,0,0-.06.1-.06.15-.1,0,0,0,0-.17.09-.22.06,0-.22,0-.25.12.08.19.08.16-.18.33-.09.07.1.12.12-.05-.11.13-.16,0,.33.24.32-.06-.14-.05-.24.4.15.35-.13c0-.05-.11.05-.16,0s0-.05,0-.08.22-.17.14-.2-.13.28-.14.32a.75.75,0,0,1-.17,0s0,0,0,0l-.17-.07h0s0,.1-.06.11a2.28,2.28,0,0,0-.31-.1s0,0,0,0a.36.36,0,0,1-.27,0s-.13-.13-.11-.15.11-.08.16-.1.18.06.18,0-.12,0-.18,0-.07.05-.11,0,0-.15.08-.15.21.1.3,0-.27,0-.32-.09.18,0,.14-.06-.11,0-.15,0,0-.17,0-.24a.21.21,0,0,1,.14-.07.3.3,0,0,1,.24.08s-.05.09,0,.12,0-.09,0-.1.06.07.1.08-.07-.06-.05-.07.22.11.36,0,0,0-.07,0c-.27,0,.14.07-.09.08,0,0-.28-.11-.39-.12s-.07,0-.11,0-.13.07-.14,0,.12-.06.14-.11-.14-.1-.14-.18.07,0,.09,0,0,.13.07.13-.05-.14,0-.14.09.11.16.11,0-.14.06-.11,0,.1,0,.15,0,0,0,0,0-.11.07-.11,0,0,0,.07.12.07.14,0-.1,0-.12-.05a.25.25,0,0,1-.05-.16s0-.05,0-.07v0s0,0,0,0a.17.17,0,0,1,.13,0s0,.07,0,.1.06.08.07.13,0,0,0,0,0,0,0,0c0-.16-.2-.26.07-.31.1,0,.11.12.11.26a.06.06,0,0,1,0-.06c.05,0,.18,0,.16,0s-.12,0-.17-.05,0-.1-.06-.14a1.46,1.46,0,0,0-.28-.14s0,0,0,0h.1s0,.05,0,.05.12-.16.23-.07,0,.1,0,.12,0-.09,0-.11.17.14.17.15.14,0,.11-.07-.11,0-.15,0,0-.12.12-.15l-.15,0c-.47,0-.06-.05-.07-.14s-.11-.06-.15-.11,0-.12.18-.09c0,0,0,.09.09.11s.06,0,.09,0a.22.22,0,0,1,.14,0l0,0c0-.05.05-.1.1-.1s0,0,0,.07.08,0,.1.07,0,.07,0,.1.14.11.17.05-.13-.08-.13-.14.08,0,.11,0-.05,0-.07,0,.05,0,0,0-.07.06-.1.05a.23.23,0,0,1-.08-.16l.06,0s-.08-.08,0-.06.32.16.29-.05-.25.23-.21-.11c0-.07.2-.19.25-.16s0,.13,0,.17,0,0,.07,0,.14,0,.11-.05-.13.08-.12,0,.08-.07.12-.11.05-.14.11-.15,0,.08.05.11.07.05.07.09-.07.07-.06.12,0,0,.07,0,.11.12.13.08-.09-.11-.09-.17.32,0,.33,0a.22.22,0,0,0,.05-.19s-.1,0-.09,0,.34-.12.33-.2-.2-.06-.16-.11.17,0,.18-.1c0-.31-.26.07-.32.12s-.12.05-.1.09.12,0,.18,0l0,0-.13.07s-.23.2-.29.19,0-.07,0-.11-.07-.05-.06-.08.1-.06.15-.1,0,0-.05,0,0,0,0,0-.14.15-.22.12.06-.15.14-.2.11,0,.14-.07-.07,0-.1,0,0,0,0,0,0-.11,0-.15.07,0,.09,0,0,0,0,0,0-.05,0-.07.08,0,.1,0,0-.07,0-.1.1,0,.11-.07-.1-.07-.07-.08.1.08.16.06-.06,0-.09-.08.08-.12.14-.16.09.14.16.17a.12.12,0,0,0,.14,0s-.1,0-.09,0,.13,0,.15-.08-.24.18-.17-.12.12.34.18-.11c0,0-.07,0-.08,0s0,0,0,0h0a.52.52,0,0,1-.17.12c-.12.05.22-.15.19-.18s0,0-.06,0h0s-.06,0-.05,0,.26,0,.3-.05,0-.06,0-.07.27,0,.31-.27c0,0-.06,0-.09.06h-.12s-.08.05-.08,0,.29-.1.22-.23-.27.06-.19-.13.12,0,.18-.06,0,0-.05,0a.24.24,0,0,1-.05-.1c0-.05.06-.22.11-.22s.09.09.15.1,0-.05,0-.08,0-.11-.05-.13-.11,0-.14,0,.13-.06.17-.07.07-.14.18-.11.07.08.12.08-.06,0-.07-.08,0,0,.05,0a.34.34,0,0,0,.14-.09c.07,0-.14.08-.21.1s0-.05,0-.06-.13.13-.22.12c-.27,0,.15-.09.2-.13s0,0-.06,0-.1,0-.15,0-.05-.14,0-.2c.05-.29.17-.17.36-.25s-.12-.12-.15-.17.07,0,.1,0-.13-.13.06-.07c0,0,0,0,0,.05s0-.06,0-.07,0-.05,0,0,0,.09,0,.1.15,0,.16-.08-.08-.08-.09-.13.18-.12.25-.09,0,.14,0,.14,0-.11,0-.14h0l0,0s0-.06,0-.07,0,0-.07.07-.17.09-.25,0,.06-.07.09-.11.06-.33.18-.24-.12.07-.08.1.08,0,.13-.06a.16.16,0,0,1,.11.05c.05.05.13.22.11.15s-.09-.1-.08-.16.1-.06.13-.11,0,0-.07,0-.15.09-.21-.06,0,0,.05-.07h0c0-.07.19,0,.22,0s-.18-.17-.2-.17,0,0,0,.05-.16.21-.2.18-.07-.11,0-.16.09,0,.12-.05-.07,0-.08,0,.1-.08.14,0,0,0,0,0,.32,0,.31-.21-.05,0-.07,0,0,0,0,0,0,0,0,0h-.08s-.11,0-.13,0c-.1-.2.21-.06.21-.06s0-.12,0-.18,0,.06,0,.09,0,0,0,0,0,.09,0,.13.17.26.21.22-.29-.45-.18-.51.12,0,.18.09,0,0,0-.06-.16,0-.14-.07.11,0,.17-.06c.33,0,0,.11.26.21s-.17-.24,0-.24.06.05.1.05.11,0,.1-.05c0-.33-.24,0-.31,0s0,0,0,0,0,0,0,0,0,0-.05,0-.13,0-.15,0a.17.17,0,0,1,0-.07c-.05,0-.11,0-.13.05s0,.13-.05.17,0-.09,0-.12a.11.11,0,0,0-.11,0s0,.06,0,.08l-.09.08-.07.09v0c0-.06.06-.1.08-.17s0-.07,0-.1.12,0,.16-.06-.27-.11,0-.35.13.18.1.35a.1.1,0,0,1,.06-.08s0,.05,0,0,0-.41.12-.23a.61.61,0,0,1,.09.2.22.22,0,0,1,.12-.07s0,.07.08.07a.37.37,0,0,0,.18,0c.08-.05-.16,0-.18-.09a.09.09,0,0,1,.08-.07c.05,0,.12.09.13.05s-.13,0-.13-.07.1,0,.13-.06,0,0,0,0a.19.19,0,0,1-.07-.19c0-.07.17,0,.18-.07s0-.11,0-.18a.47.47,0,0,1,0-.17c0-.06.06.16.11.19a.22.22,0,0,0,.18,0s-.23-.09-.22-.14.07-.13.13-.12,0,.1.08.14.09,0,.14.07.05.12.06.09-.39-.14-.22-.5c0-.06.16-.14.22-.1s0,.4,0,.42,0,0,.05,0,0-.11,0-.15.12,0,.13,0-.11,0-.13-.09.06-.37.18-.23a2.78,2.78,0,0,1,0,.5s-.12.15-.06.16.07-.22.12-.26.11,0,.16,0,0,0-.06-.05-.17-.1-.12-.21c.2-.45,0,.06.23-.1.07,0,0-.15.05-.21s0,0,.05,0,0,0,0,.06l.12.07s.06.07.1.09-.07-.06-.09-.1l0,0a.59.59,0,0,0,0-.27s-.27.2-.33,0,.2-.18.26-.16.08.08.14.09,0,0,0-.05,0,0,.06,0h.14c.1,0,0,.26.18.24,0,0,.06-.06.05-.1s-.05,0-.07,0-.06,0-.06,0,.09,0,.06-.07,0-.09,0-.24.23-.1.26-.14-.09,0-.1-.06.18-.11.19-.13-.21-.16-.21-.18.12.06.14,0-.07-.11-.06-.17.19,0,.32,0c-.3-.3.12-.3.15-.12s-.1.07-.14.12l.13,0a3.89,3.89,0,0,1-.19.42h0s0,0,0,0,.06,0,.08,0-.13.1,0,.14,0,.08,0,.13,0,.24.12.11,0-.07,0-.1,0-.08,0-.12-.07,0,0-.06a2.63,2.63,0,0,1,.25-.69l.06.21c0,.05-.1.08-.09.13s.08-.05.1,0,0,.14,0,.16.13,0,.18,0-.07-.05-.07-.09,0-.13,0-.17.1-.07.13-.11,0,0-.05,0-.15,0-.15-.1.12,0,.14,0,0-.12,0-.17.06.07.1.05.11-.08.23,0-.16.39-.18.44,0,0,.05,0,.07-.12.13-.14,0,.07,0,.11-.11.11-.08.17.11-.1.15-.07l0,0s.05,0,.06,0-.07-.08-.07-.08a1,1,0,0,1,0-.34c.14-.18.23.16.24.16.5,0-.26-.3.24-.15.26.08.07.09,0,.19s0,0,.05,0,.09-.06.14-.06,0,0,0,0l.08,0,0,0a.61.61,0,0,1,.14.1s0,0-.05,0-.09,0-.12.07,0,.17-.07.2-.38,0-.52.13a.24.24,0,0,1,.08,0l.11,0s0,0,0,0,.15,0,.19,0-.1.1-.07.14.05-.11.1-.1,0,.27,0,.29,0-.09,0-.1.13,0,.19,0,0,0,0-.06a.32.32,0,0,1,0-.14s0,0,0,0a.54.54,0,0,0,.18,0l.38,0s-.07-.06-.07-.1a.31.31,0,0,1,0-.19s.22.07.25.1.16-.07.22,0a.17.17,0,0,1,0,.19c-.07.08-.25-.15-.32-.07a.17.17,0,0,0,0,.19s.1-.08.14-.05,0,.07,0,.11.39-.16.41-.09-.11-.11,0,.17c0,0,.1,0,.1.09s-.2.14-.06.24,0-.07,0-.1.08-.1.11-.16v-.05a.67.67,0,0,1,.07-.17c.12-.11.17,0,.28,0s.27-.15.48-.1a7,7,0,0,1,.84.22c.05,0,.09.08.15.1s.08,0,.12,0,0,.07.06.08.13,0,.15,0-.06,0-.11,0h0s0,0,0,0,.54.23.58.13-.09-.07-.09-.12.06,0,.08,0,.1.08.14.1.08,0,.11,0,.07.08.11.12.12-.07.19-.06.07.18.13.23l0,0c.09,0,.08.16.12.2s.08,0,.12,0,.11.42.09.54,0,.17,0,.28a1.11,1.11,0,0,1-.79.79,1.59,1.59,0,0,1-.38,0c-.16,0-.3.08-.46.09a.78.78,0,0,1-.21,0c-.09,0-.27-.13-.37-.09s0,.09-.09.11-.05-.06-.08-.06-.08,0-.11,0,0-.11,0-.11,0,.09-.05.11a.21.21,0,0,1-.16,0s-.33-.08-.37-.16.05-.07,0-.11a2.45,2.45,0,0,0-.43.06s0,.05,0,.05.22-.09.29.06-.05,0-.06,0,0,0,.05,0,0,0,0,.05,0,0,0,0,.09.11.15.12c.25.05.12-.06.35.08,0,0,.09,0,.11.07s-.19.11-.12.17.07-.05.11-.06a1.72,1.72,0,0,1,.56.17l.11.15s.13,0,.09.07-.1-.06-.14,0,.11.16.11.17c.1.27,0,.06-.11.28,0,0,.07,0,.09,0l.26.25s0,0,0,.07.14,0,.15.09-.07.08,0,.11.08-.07.11,0-.06,0-.06.09a.19.19,0,0,0,0,.16,1.71,1.71,0,0,0,.36.1s0-.15.3,0c.65.25-.4-.14.18.19a5.68,5.68,0,0,0,.59,0s0-.08,0-.11.06,0,.08,0,0-.3-.1-.41-.05,0-.12,0,0-.06,0-.05,0,0,0,.06,0,0,0,0a.26.26,0,0,1-.19.06,2.26,2.26,0,0,1-.54-.41c0-.05.11-.06.15-.1s-.08-.12-.08-.19.56.09.58.09.12-.07.18-.06,0,0,0,.05h0c.08-.09.47.06.53,0s0-.11.06-.14.19.09.33,0-.09-.11-.12-.17,0,0,0-.05-.49-.28-.6-.42,0-.31.08-.49,0-.16,0-.22.2-.19.25-.36a3,3,0,0,1,0-.44.47.47,0,0,1,.17,0c.11,0,0,.09,0,.09.24-.14.08-.21.32-.12.05,0,.11,0,.16,0s0,0,0,.07a.09.09,0,0,1,.08-.05c.12,0,.16.23.28.22s0-.06-.21-.27,0-.33-.08-.53l0,0s-.08,0-.1-.09,0-.05,0-.06a.32.32,0,0,0,0-.09,1.43,1.43,0,0,0-.26-.15c-.05,0-.1.05-.17,0s-.1-.28-.11-.33,0-.16,0-.16a.69.69,0,0,1-.14-.24c0-.05,0-.1,0-.15s0,.08-.06.07,0-.23-.38-.31c0,0-.32-.06-.23-.12s.21,0,.3,0,.29-.22.37-.25a.49.49,0,0,1,.29-.05s0,0,0,0a.22.22,0,0,0,.1.09c.16.07.4.09.49.29a.8.8,0,0,0-.17.14c0,.05-.25.18-.22.25h0s.05.05,0,.08-.15.18,0,.3.25,0,.33,0,.24.27.34.22.1-.21.15-.16,0,.12,0,.16,0-.08,0-.12a.86.86,0,0,1,.21-.26s.07,0,.09,0-.13-.27-.15-.29,0-.22-.05-.28-.19-.06-.12-.19.07.05.08,0,0-.08,0-.12.08,0,.1,0,0-.07,0-.07.13,0,.19,0-.13,0-.17,0,0-.08,0-.1-.1,0-.13,0,.07,0,.11,0a.24.24,0,0,0,.13-.09c.07-.07.07-.27.11-.35s0,.06,0,.09,0,0,0,0a2.4,2.4,0,0,1,.05-.46s.07,0,.1,0,0-.1,0-.15,0,0,0,0,0,0,0,0,.05,0,.05,0,0-.14.07-.18.13.23.2.22,0-.12,0-.19,0,0,0,0l-.16,0s0-.09,0-.08a.24.24,0,0,0,0,.07s0,0,0,0,0,0,0,0a1.38,1.38,0,0,1,.33-.81s0,0,.05,0,0,.06,0,.09-.19.19-.17.21.09-.07.15-.06,0,.06,0,.08a.67.67,0,0,0,.06.15c.07.06.2.07.24.15s-.38.28-.06.27c0,0,.05-.07.09-.1s.09,0,.11,0-.05-.1,0-.12.05.11.08.09,0-.13,0-.15.12.05.18,0-.13-.19-.13-.21.05-.19.1-.31,0-.1,0-.15,0,0,.07,0c.2-.05.07-.07.14-.12s.07,0,.1,0a.6.6,0,0,0,.13-.09c.05-.06-.06-.14-.06-.21s.07-.06.08-.1-.05-.15,0-.18.16.13.16.07-.12,0-.16-.1a.64.64,0,0,1,.1-.23s0,0,0,.06.05,0,.07,0c.4,0,.11.08.21.22s.11.16.25.1.09,0,.11,0c.12-.27-.17-.14-.22-.31s.11-.13.14-.18,0-.19,0-.27-.6-.21-.71-.28,0-.12.06-.2-.11-.12-.11-.19.25-.1.25-.1a4.09,4.09,0,0,1,.51-.4,1.73,1.73,0,0,1,.64-.17H310a.32.32,0,0,0,.14,0,1.4,1.4,0,0,0,.16-.1c.09,0-.14.08,0,.09-.07,0-.07.35,0,.39a2.58,2.58,0,0,0,.92.67,7.32,7.32,0,0,0,.89.17,30.61,30.61,0,0,1,.13,3.45l.09.13c.05.09-.09,0-.09.09,0,.49.52.78.66,1.24.05.13.18.17.32.22s.17.26.31.35a16.21,16.21,0,0,1,2.38,3.05,3.55,3.55,0,0,0,.84.8,7.26,7.26,0,0,0,1.59.44C318.58,285.87,318.62,286.32,318.85,286.58ZM283.41,304s0,.07,0,.09S283.39,304,283.41,304Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M305.71,282.41s-.06.07-.06.11.16.12.15.07-.1,0-.11-.07A.15.15,0,0,1,305.71,282.41Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M281.52,298.6s-.1,0-.12-.06,0-.06,0-.08a1.09,1.09,0,0,1-.2.12A.91.91,0,0,0,281.52,298.6Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M284,304.36a.49.49,0,0,1,.27.08c-.05-.05-.13-.14-.22-.12Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M298.64,295.16s0,.14,0,.11a.11.11,0,0,0,0-.1Z\" transform=\"translate(-207.47 -267.99)\" data-v-c111b8bc></path><path d=\"M301.21,312.84s-.1-.13-.15-.1,0,.12,0,.17.22,0,.27-.08S301.22,312.84,301.21,312.84Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M292.17,298.6c-.07-.06-.07-.2-.17-.25.05,0,.05.1.08.14s.25.46.25.2C292.33,298.63,292.22,298.65,292.17,298.6Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path><path d=\"M293.86,297.93s.09-.13.1-.14l.17,0a.15.15,0,0,0-.09,0C293.9,297.75,293.86,297.78,293.86,297.93Z\" transform=\"translate(-207.47 -267.99)\" fill=\"#515151\" data-v-c111b8bc></path>", 32)
const _hoisted_68 = [
  _hoisted_36
]

function HundredBridgesvue_type_template_id_c111b8bc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version === 'light')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", HundredBridgesvue_type_template_id_c111b8bc_scoped_true_hoisted_1, _hoisted_34))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", HundredBridgesvue_type_template_id_c111b8bc_scoped_true_hoisted_35, _hoisted_68))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/HundredBridges.vue?vue&type=template&id=c111b8bc&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/HundredBridges.vue?vue&type=script&lang=js

  /* harmony default export */ var HundredBridgesvue_type_script_lang_js = ({
    name: "HundredBridges",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/HundredBridges.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/HundredBridges.vue?vue&type=style&index=0&id=c111b8bc&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/HundredBridges.vue?vue&type=style&index=0&id=c111b8bc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/HundredBridges.vue




;


const HundredBridges_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(HundredBridgesvue_type_script_lang_js, [['render',HundredBridgesvue_type_template_id_c111b8bc_scoped_true_render],['__scopeId',"data-v-c111b8bc"]])

/* harmony default export */ var HundredBridges = (HundredBridges_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/IntrastatHub.vue?vue&type=template&id=9d76e6a8&scoped=true


const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_withScopeId = n => (_pushScopeId("data-v-9d76e6a8"),n=n(),_popScopeId(),n)
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1927.1",
  height: "267",
  viewBox: "0 0 1927.1 267"
}
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_2 = { key: 0 }
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-9d76e6a8></polygon><path d=\"M49.2,192.85H40.88l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.24,1.14,4,2.33Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M82.35,192.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63L78,173.55a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.69-2.55H69l-5.16,24.19H55.4l6.08-28.54,14.79-1c6.85,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M111.11,168l-9.89.87-3.1,14.68a10.2,10.2,0,0,0-.33,2.33c0,1.69.87,2.5,3.7,2.5h5.22l-.93,4.46-5.38.54c-7.34,0-11.09-1.84-11.09-6.9a16.74,16.74,0,0,1,.38-3l4.19-19.56c4.08-.55,4.78-1.85,5.65-5h3.86l-1,4.83H112Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><polygon points=\"112.9 142.89 106.99 142.89 108.53 135.67 104.43 135.67 100.66 153.47 104.75 153.47 106.39 145.76 112.31 145.76 110.67 153.47 114.76 153.47 118.54 135.67 114.44 135.67 112.9 142.89\" fill=\"#65adc1\" data-v-9d76e6a8></polygon><path d=\"M131.57,135.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M151.71,137.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,151.71,137.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,145.06,142.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M325.84,254V13.83h62.68V254Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M544.51,254,451.94,74.33V254H411.85V13.83h71.79L573.3,191V13.83H613V254Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M740.22,44.81V254H677.54V44.81H625.78v-31H792v31Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M868.51,254H804.73V13.83H912.61c58.31,0,92.94,15.67,92.94,60.86V88.18c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V123.16c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.9-41.18-33.9H868.51Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M1177.57,254l-10.2-53.94v.73h-86v-.73L1070.06,254h-51.75L1085,13.83h94.4L1249,254ZM1134.93,42.62h-21.14l-25.87,127.19h74Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M1424.31,188.4c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.21h63c40.82,0,43-15.3,43-34.26V177.1L1255.2,113.32c-2.55-6.92-6.19-17.13-6.19-29.52,0-44.46,24.78-73.25,91.84-73.25L1413,16.38V42.25h-45.92c-46.28,0-50.66,13.85-50.66,35.36v10.2l99.86,62c4,8,8,21.5,8,33.17Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M1543.13,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M1726.09,254l-10.21-53.94v.73h-86v-.73L1618.57,254h-51.75l66.69-240.17h94.4L1797.52,254ZM1683.44,42.62h-21.13l-25.88,127.19h74Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M1883.9,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-9d76e6a8></path>", 16)
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_19 = [
  IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_3
]
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_20 = { key: 1 }
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#65adc1\" data-v-9d76e6a8></polygon><path d=\"M49.2,192.85H40.88l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.24,1.14,4,2.33Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M82.35,192.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63L78,173.55a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.69-2.55H69l-5.16,24.19H55.4l6.08-28.54,14.79-1c6.85,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M111.11,168l-9.89.87-3.1,14.68a10.2,10.2,0,0,0-.33,2.33c0,1.69.87,2.5,3.7,2.5h5.22l-.93,4.46-5.38.54c-7.34,0-11.09-1.84-11.09-6.9a16.74,16.74,0,0,1,.38-3l4.19-19.56c4.08-.55,4.78-1.85,5.65-5h3.86l-1,4.83H112Z\" fill=\"#fff\" data-v-9d76e6a8></path><polygon points=\"112.9 142.89 106.99 142.89 108.53 135.67 104.43 135.67 100.66 153.47 104.75 153.47 106.39 145.76 112.31 145.76 110.67 153.47 114.76 153.47 118.54 135.67 114.44 135.67 112.9 142.89\" fill=\"#fff\" data-v-9d76e6a8></polygon><path d=\"M131.57,135.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M151.71,137.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,151.71,137.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,145.06,142.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-9d76e6a8></path><path d=\"M325.84,254V13.83h62.68V254Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M544.51,254,451.94,74.33V254H411.85V13.83h71.79L573.3,191V13.83H613V254Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M740.22,44.81V254H677.54V44.81H625.78v-31H792v31Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M868.51,254H804.73V13.83H912.61c58.31,0,92.94,15.67,92.94,60.86V88.18c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V123.16c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.9-41.18-33.9H868.51Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M1177.57,254l-10.2-53.94v.73h-86v-.73L1070.06,254h-51.75L1085,13.83h94.4L1249,254ZM1134.93,42.62h-21.14l-25.87,127.19h74Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M1424.31,188.4c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.21h63c40.82,0,43-15.3,43-34.26V177.1L1255.2,113.32c-2.55-6.92-6.19-17.13-6.19-29.52,0-44.46,24.78-73.25,91.84-73.25L1413,16.38V42.25h-45.92c-46.28,0-50.66,13.85-50.66,35.36v10.2l99.86,62c4,8,8,21.5,8,33.17Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M1543.13,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M1726.09,254l-10.21-53.94v.73h-86v-.73L1618.57,254h-51.75l66.69-240.17h94.4L1797.52,254ZM1683.44,42.62h-21.13l-25.88,127.19h74Z\" fill=\"#65adc1\" data-v-9d76e6a8></path><path d=\"M1883.9,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#65adc1\" data-v-9d76e6a8></path>", 16)
const IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_37 = [
  IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_21
]

function IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_2, IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_20, IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_hoisted_37))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/IntrastatHub.vue?vue&type=template&id=9d76e6a8&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/IntrastatHub.vue?vue&type=script&lang=js

  /* harmony default export */ var IntrastatHubvue_type_script_lang_js = ({
    name: "IntrastatHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/IntrastatHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/IntrastatHub.vue?vue&type=style&index=0&id=9d76e6a8&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/IntrastatHub.vue?vue&type=style&index=0&id=9d76e6a8&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/IntrastatHub.vue




;


const IntrastatHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(IntrastatHubvue_type_script_lang_js, [['render',IntrastatHubvue_type_template_id_9d76e6a8_scoped_true_render],['__scopeId',"data-v-9d76e6a8"]])

/* harmony default export */ var IntrastatHub = (IntrastatHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/InvoiceHub.vue?vue&type=template&id=28a11aa4&scoped=true


const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_withScopeId = n => (_pushScopeId("data-v-28a11aa4"),n=n(),_popScopeId(),n)
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1484.27",
  height: "267",
  viewBox: "0 0 1484.27 267"
}
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_2 = { key: 0 }
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-28a11aa4></polygon><path d=\"M42.08,190.74H33.66l6.27-29.48h8.42Zm8-34.37c-.27,1.2-1.87,2.25-4.89,2.25h-.88c-3.14,0-4.35-1.05-4-2.31l.5-2.37c.27-1.15,1.87-2.25,4.89-2.25h.83c3.08,0,4.29,1.15,4.07,2.36Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M75.63,190.74c-5.83,0-7.7,0-7.7-3a42.34,42.34,0,0,1,1.16-6.71l2.14-9.84a13.77,13.77,0,0,0,.33-2.37c0-1.76-.93-2.58-3.74-2.58H62.16l-5.23,24.47H48.35l6.16-28.87,15-1.05c6.93,0,10.67,2.42,10.67,7.43a11.38,11.38,0,0,1-.27,2.64Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M97.86,190.74H85.59l-1.87-29.48h9l.33,23.49h2.48l10.23-23.49h7.48Z\" fill=\"#8b85db\" data-v-28a11aa4></path><polygon points=\"120.15 144.82 114.24 144.82 115.77 137.61 111.67 137.61 107.9 155.41 111.99 155.41 113.64 147.7 119.55 147.7 117.91 155.41 122 155.41 125.78 137.61 121.68 137.61 120.15 144.82\" fill=\"#8b85db\" data-v-28a11aa4></polygon><path d=\"M138.81,137.68l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.18,2.18,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63H133c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M159,139.27c-.86-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.64h7.8c4.27,0,6.78-1.63,7.44-4.84a4.23,4.23,0,0,0-.34-3.24,2.83,2.83,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.92,3.92,0,0,0,159,139.27Zm-6.65,5.55h-2.57c.21-1,.41-1.94.61-2.92l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A1.94,1.94,0,0,1,152.3,144.82Zm-.22,2.88a1.26,1.26,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M325.84,253.53V13.35h62.68V253.53Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M544.51,253.53,451.94,73.85V253.53H411.85V13.35h71.79L573.3,190.48V13.35H613V253.53Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M785.78,253.53H690.29L627.61,13.35h65.6L739.86,214.9h17.49L799.26,13.35h52.12Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M1056.2,189.75c0,68.52-76.53,65.6-107.15,65.6-57.94,0-92.93-19.31-92.93-65.6V77.13c0-46.28,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.32,92.57,65.6ZM993.88,77.13c0-23.69-8.74-34.62-36.44-34.62h-2.55c-27.7,0-36.45,10.93-36.45,34.62V189.75c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M1081.72,253.53V13.35h62.68V253.53Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M1272.32,256.08c-48.1,0-102.41-5.1-102.41-65.6V76.77c0-61.23,55-66.7,102.41-66.7l58.32,5.11v27h-57.59c-37.9,0-40.82,10.2-40.82,34.62V190.48c0,25.15,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M1348.5,253.53V13.35h151.61V44h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-28a11aa4></path>", 14)
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_17 = [
  InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_3
]
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_18 = { key: 1 }
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#8b85db\" data-v-28a11aa4></polygon><path d=\"M42.08,190.74H33.66l6.27-29.48h8.42Zm8-34.37c-.27,1.2-1.87,2.25-4.89,2.25h-.88c-3.14,0-4.35-1.05-4-2.31l.5-2.37c.27-1.15,1.87-2.25,4.89-2.25h.83c3.08,0,4.29,1.15,4.07,2.36Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M75.63,190.74c-5.83,0-7.7,0-7.7-3a42.34,42.34,0,0,1,1.16-6.71l2.14-9.84a13.77,13.77,0,0,0,.33-2.37c0-1.76-.93-2.58-3.74-2.58H62.16l-5.23,24.47H48.35l6.16-28.87,15-1.05c6.93,0,10.67,2.42,10.67,7.43a11.38,11.38,0,0,1-.27,2.64Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M97.86,190.74H85.59l-1.87-29.48h9l.33,23.49h2.48l10.23-23.49h7.48Z\" fill=\"#fff\" data-v-28a11aa4></path><polygon points=\"120.15 144.82 114.24 144.82 115.77 137.61 111.67 137.61 107.9 155.41 111.99 155.41 113.64 147.7 119.55 147.7 117.91 155.41 122 155.41 125.78 137.61 121.68 137.61 120.15 144.82\" fill=\"#fff\" data-v-28a11aa4></polygon><path d=\"M138.81,137.68l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.18,2.18,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63H133c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M159,139.27c-.86-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.64h7.8c4.27,0,6.78-1.63,7.44-4.84a4.23,4.23,0,0,0-.34-3.24,2.83,2.83,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.92,3.92,0,0,0,159,139.27Zm-6.65,5.55h-2.57c.21-1,.41-1.94.61-2.92l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A1.94,1.94,0,0,1,152.3,144.82Zm-.22,2.88a1.26,1.26,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-28a11aa4></path><path d=\"M325.84,253.53V13.35h62.68V253.53Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M544.51,253.53,451.94,73.85V253.53H411.85V13.35h71.79L573.3,190.48V13.35H613V253.53Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M785.78,253.53H690.29L627.61,13.35h65.6L739.86,214.9h17.49L799.26,13.35h52.12Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M1056.2,189.75c0,68.52-76.53,65.6-107.15,65.6-57.94,0-92.93-19.31-92.93-65.6V77.13c0-46.28,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.32,92.57,65.6ZM993.88,77.13c0-23.69-8.74-34.62-36.44-34.62h-2.55c-27.7,0-36.45,10.93-36.45,34.62V189.75c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M1081.72,253.53V13.35h62.68V253.53Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M1272.32,256.08c-48.1,0-102.41-5.1-102.41-65.6V76.77c0-61.23,55-66.7,102.41-66.7l58.32,5.11v27h-57.59c-37.9,0-40.82,10.2-40.82,34.62V190.48c0,25.15,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#8b85db\" data-v-28a11aa4></path><path d=\"M1348.5,253.53V13.35h151.61V44h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#8b85db\" data-v-28a11aa4></path>", 14)
const InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_33 = [
  InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_19
]

function InvoiceHubvue_type_template_id_28a11aa4_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_2, InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_17))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_18, InvoiceHubvue_type_template_id_28a11aa4_scoped_true_hoisted_33))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/InvoiceHub.vue?vue&type=template&id=28a11aa4&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/InvoiceHub.vue?vue&type=script&lang=js

  /* harmony default export */ var InvoiceHubvue_type_script_lang_js = ({
    name: "InvoiceHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/InvoiceHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/InvoiceHub.vue?vue&type=style&index=0&id=28a11aa4&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/InvoiceHub.vue?vue&type=style&index=0&id=28a11aa4&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/InvoiceHub.vue




;


const InvoiceHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(InvoiceHubvue_type_script_lang_js, [['render',InvoiceHubvue_type_template_id_28a11aa4_scoped_true_render],['__scopeId',"data-v-28a11aa4"]])

/* harmony default export */ var InvoiceHub = (InvoiceHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/MergerHub.vue?vue&type=template&id=a024f274&scoped=true


const MergerHubvue_type_template_id_a024f274_scoped_true_withScopeId = n => (_pushScopeId("data-v-a024f274"),n=n(),_popScopeId(),n)
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1662.86",
  height: "267",
  viewBox: "0 0 1662.86 267"
}
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_2 = { key: 0 }
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-a024f274></polygon><path d=\"M70.14,191.35c-5.66,0-7.51,0-7.51-2.94A41.63,41.63,0,0,1,63.72,182l2.18-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.7-2.61h-6a12.39,12.39,0,0,1,.43,3,9.13,9.13,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.93,13.37H44.05l4.13-19.46a13.76,13.76,0,0,0,.32-2.28c0-1.69-.92-2.45-3.69-2.45h-5L34.7,191.35H26.38l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a11.42,11.42,0,0,1-.27,2.55Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M102,173.63h-6.3a16.51,16.51,0,0,0,.43-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7L83,191.35H74.7l6.09-28.59,13.53-1.09c5.66,0,9.35,2.88,9.35,6.58a7.28,7.28,0,0,1-.49,2.39Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M128.79,192.05c-1.25,5.44-4.95,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.2,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a10.86,10.86,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.57-9.84,14.51-9.84h2c6.9,0,10.71,2.34,10.71,7.34a11.56,11.56,0,0,1-.27,2.56Zm-12.51-5.22h5.28l3.31-15.27a10.24,10.24,0,0,0,.27-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C112.37,186.07,113.29,186.83,116.28,186.83Z\" fill=\"#b81d58\" data-v-a024f274></path><polygon points=\"127.4 144.39 121.49 144.39 123.03 137.17 118.93 137.17 115.16 154.97 119.25 154.97 120.89 147.26 126.81 147.26 125.17 154.97 129.26 154.97 133.04 137.17 128.94 137.17 127.4 144.39\" fill=\"#b81d58\" data-v-a024f274></polygon><path d=\"M146.07,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M166.21,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46L150,154.89h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,166.21,138.83Zm-6.65,5.56H157c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,159.56,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M581.36,255.26V49.71H567.14L499,255.26H449.06L379.45,49.71H366V255.26H325.51V15.09h104.6L488.05,188.2,543.82,15.09h98.4V255.26Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M665.55,255.26V15.09H817.16V45.7H729v69.61h69.61v31.35H729v77.62h88.2v31Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M898.8,255.26H835V15.09H942.9c58.31,0,92.93,15.67,92.93,60.86V89.44c0,41.91-14.94,60.5-55.39,60.86,19.68,29.52,48.83,73.26,70.7,105h-78l-59-109.7V124.42c46.28,0,53.93-8,53.93-28.06v-16c0-20.4-4.73-33.89-41.18-33.89H898.8Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M1155,257.82c-48.47,0-102.77-3.29-102.77-65.61V78.5c0-62.68,59-66.69,105-66.69l81.27,5.1V43.15h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V115.31h62.32V252Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M1270.91,255.26V15.09h151.62V45.7h-88.2v69.61h69.61v31.35h-69.61v77.62h88.2v31Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M1504.16,255.26h-63.77V15.09h107.87c58.32,0,92.94,15.67,92.94,60.86V89.44c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V124.42c46.29,0,53.94-8,53.94-28.06v-16c0-20.4-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#fff\" data-v-a024f274></path>", 13)
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_16 = [
  MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_3
]
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_17 = { key: 1 }
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#b81d58\" data-v-a024f274></polygon><path d=\"M70.14,191.35c-5.66,0-7.51,0-7.51-2.94A41.63,41.63,0,0,1,63.72,182l2.18-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.7-2.61h-6a12.39,12.39,0,0,1,.43,3,9.13,9.13,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.93,13.37H44.05l4.13-19.46a13.76,13.76,0,0,0,.32-2.28c0-1.69-.92-2.45-3.69-2.45h-5L34.7,191.35H26.38l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a11.42,11.42,0,0,1-.27,2.55Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M102,173.63h-6.3a16.51,16.51,0,0,0,.43-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7L83,191.35H74.7l6.09-28.59,13.53-1.09c5.66,0,9.35,2.88,9.35,6.58a7.28,7.28,0,0,1-.49,2.39Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M128.79,192.05c-1.25,5.44-4.95,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.2,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a10.86,10.86,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.57-9.84,14.51-9.84h2c6.9,0,10.71,2.34,10.71,7.34a11.56,11.56,0,0,1-.27,2.56Zm-12.51-5.22h5.28l3.31-15.27a10.24,10.24,0,0,0,.27-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C112.37,186.07,113.29,186.83,116.28,186.83Z\" fill=\"#fff\" data-v-a024f274></path><polygon points=\"127.4 144.39 121.49 144.39 123.03 137.17 118.93 137.17 115.16 154.97 119.25 154.97 120.89 147.26 126.81 147.26 125.17 154.97 129.26 154.97 133.04 137.17 128.94 137.17 127.4 144.39\" fill=\"#fff\" data-v-a024f274></polygon><path d=\"M146.07,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M166.21,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46L150,154.89h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,166.21,138.83Zm-6.65,5.56H157c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,159.56,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-a024f274></path><path d=\"M581.36,255.26V49.71H567.14L499,255.26H449.06L379.45,49.71H366V255.26H325.51V15.09h104.6L488.05,188.2,543.82,15.09h98.4V255.26Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M665.55,255.26V15.09H817.16V45.7H729v69.61h69.61v31.35H729v77.62h88.2v31Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M898.8,255.26H835V15.09H942.9c58.31,0,92.93,15.67,92.93,60.86V89.44c0,41.91-14.94,60.5-55.39,60.86,19.68,29.52,48.83,73.26,70.7,105h-78l-59-109.7V124.42c46.28,0,53.93-8,53.93-28.06v-16c0-20.4-4.73-33.89-41.18-33.89H898.8Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M1155,257.82c-48.47,0-102.77-3.29-102.77-65.61V78.5c0-62.68,59-66.69,105-66.69l81.27,5.1V43.15h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V115.31h62.32V252Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M1270.91,255.26V15.09h151.62V45.7h-88.2v69.61h69.61v31.35h-69.61v77.62h88.2v31Z\" fill=\"#b81d58\" data-v-a024f274></path><path d=\"M1504.16,255.26h-63.77V15.09h107.87c58.32,0,92.94,15.67,92.94,60.86V89.44c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V124.42c46.29,0,53.94-8,53.94-28.06v-16c0-20.4-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#b81d58\" data-v-a024f274></path>", 13)
const MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_31 = [
  MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_18
]

function MergerHubvue_type_template_id_a024f274_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_2, MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_16))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_17, MergerHubvue_type_template_id_a024f274_scoped_true_hoisted_31))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/MergerHub.vue?vue&type=template&id=a024f274&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/MergerHub.vue?vue&type=script&lang=js

  /* harmony default export */ var MergerHubvue_type_script_lang_js = ({
    name: "MergerHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/MergerHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/MergerHub.vue?vue&type=style&index=0&id=a024f274&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/MergerHub.vue?vue&type=style&index=0&id=a024f274&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/MergerHub.vue




;


const MergerHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(MergerHubvue_type_script_lang_js, [['render',MergerHubvue_type_template_id_a024f274_scoped_true_render],['__scopeId',"data-v-a024f274"]])

/* harmony default export */ var MergerHub = (MergerHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/PackagingHub.vue?vue&type=template&id=ceca7fd8&scoped=true


const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_withScopeId = n => (_pushScopeId("data-v-ceca7fd8"),n=n(),_popScopeId(),n)
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2081.99",
  height: "267",
  viewBox: "0 0 2081.99 267"
}
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_2 = { key: 0 }
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-ceca7fd8></polygon><path d=\"M59.1,181.83c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H43.71l-4.18,19.56H45c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M70.24,191.35H61.92l8.1-38.1c5.6,0,7.45,0,7.45,2.93a37.74,37.74,0,0,1-1,6.25Zm12.39-18,8.43,18H81L74.86,175.8l.71-3.21,11.74-10.38h9.62Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M118.78,192.05c-1.25,5.44-5,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a11.42,11.42,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.58-9.84,14.51-9.84h2c6.91,0,10.71,2.34,10.71,7.34a11,11,0,0,1-.27,2.56Zm-12.5-5.22h5.27l3.31-15.27a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C102.36,186.07,103.29,186.83,106.28,186.83Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><polygon points=\"124.09 144.39 118.18 144.39 119.72 137.17 115.62 137.17 111.85 154.97 115.94 154.97 117.58 147.26 123.5 147.26 121.86 154.97 125.95 154.97 129.73 137.17 125.63 137.17 124.09 144.39\" fill=\"#c78ad6\" data-v-ceca7fd8></polygon><path d=\"M142.76,137.24,140,150.1c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13H133l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M162.9,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.9,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.25,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14H152l1-4.73Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M521.55,104.68c0,48.83-28.79,65.6-94.4,65.6h-39v83.09H325.84V13.2H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,78.44c0-22.24-7.65-34.26-36.08-34.26H388.16V139.3h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M656.4,253.37l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,13.2h94.39l69.61,240.17ZM613.76,42H592.62L566.74,169.18h74Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M828.06,255.93c-48.11,0-102.41-5.11-102.41-65.61V76.61c0-61.23,55-66.69,102.41-66.69L886.37,15V42H828.79C790.88,42,788,52.19,788,76.61V190.32c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M966.55,253.37H904.23V13.2h62.32Zm65.24-141,90.39,141h-71.8L980,136V116L1058,13.2h64.87Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M1286.18,253.37,1276,199.43v.73h-86v-.73l-11.3,53.94h-51.75L1193.61,13.2H1288l69.61,240.17ZM1243.54,42H1222.4l-25.87,127.19h74Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M1458.21,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V113.42h62.32V250.09Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M1581.4,253.37V13.2h62.69V253.37Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M1807.36,253.37,1714.79,73.7V253.37H1674.7V13.2h71.8l89.65,177.12V13.2h39.73V253.37Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M1996.88,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59.05-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.81,34.63h31V113.42h62.33V250.09Z\" fill=\"#fff\" data-v-ceca7fd8></path>", 16)
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_19 = [
  PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_3
]
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_20 = { key: 1 }
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#c78ad6\" data-v-ceca7fd8></polygon><path d=\"M59.1,181.83c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H43.71l-4.18,19.56H45c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M70.24,191.35H61.92l8.1-38.1c5.6,0,7.45,0,7.45,2.93a37.74,37.74,0,0,1-1,6.25Zm12.39-18,8.43,18H81L74.86,175.8l.71-3.21,11.74-10.38h9.62Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M118.78,192.05c-1.25,5.44-5,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a11.42,11.42,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.58-9.84,14.51-9.84h2c6.91,0,10.71,2.34,10.71,7.34a11,11,0,0,1-.27,2.56Zm-12.5-5.22h5.27l3.31-15.27a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C102.36,186.07,103.29,186.83,106.28,186.83Z\" fill=\"#fff\" data-v-ceca7fd8></path><polygon points=\"124.09 144.39 118.18 144.39 119.72 137.17 115.62 137.17 111.85 154.97 115.94 154.97 117.58 147.26 123.5 147.26 121.86 154.97 125.95 154.97 129.73 137.17 125.63 137.17 124.09 144.39\" fill=\"#fff\" data-v-ceca7fd8></polygon><path d=\"M142.76,137.24,140,150.1c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13H133l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M162.9,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.9,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.25,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14H152l1-4.73Z\" fill=\"#fff\" data-v-ceca7fd8></path><path d=\"M521.55,104.68c0,48.83-28.79,65.6-94.4,65.6h-39v83.09H325.84V13.2H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,78.44c0-22.24-7.65-34.26-36.08-34.26H388.16V139.3h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M656.4,253.37l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,13.2h94.39l69.61,240.17ZM613.76,42H592.62L566.74,169.18h74Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M828.06,255.93c-48.11,0-102.41-5.11-102.41-65.61V76.61c0-61.23,55-66.69,102.41-66.69L886.37,15V42H828.79C790.88,42,788,52.19,788,76.61V190.32c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M966.55,253.37H904.23V13.2h62.32Zm65.24-141,90.39,141h-71.8L980,136V116L1058,13.2h64.87Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M1286.18,253.37,1276,199.43v.73h-86v-.73l-11.3,53.94h-51.75L1193.61,13.2H1288l69.61,240.17ZM1243.54,42H1222.4l-25.87,127.19h74Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M1458.21,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V113.42h62.32V250.09Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M1581.4,253.37V13.2h62.69V253.37Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M1807.36,253.37,1714.79,73.7V253.37H1674.7V13.2h71.8l89.65,177.12V13.2h39.73V253.37Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path><path d=\"M1996.88,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59.05-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.81,34.63h31V113.42h62.33V250.09Z\" fill=\"#c78ad6\" data-v-ceca7fd8></path>", 16)
const PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_37 = [
  PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_21
]

function PackagingHubvue_type_template_id_ceca7fd8_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_2, PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_20, PackagingHubvue_type_template_id_ceca7fd8_scoped_true_hoisted_37))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PackagingHub.vue?vue&type=template&id=ceca7fd8&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/PackagingHub.vue?vue&type=script&lang=js

  /* harmony default export */ var PackagingHubvue_type_script_lang_js = ({
    name: "PackagingHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PackagingHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/PackagingHub.vue?vue&type=style&index=0&id=ceca7fd8&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PackagingHub.vue?vue&type=style&index=0&id=ceca7fd8&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PackagingHub.vue




;


const PackagingHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PackagingHubvue_type_script_lang_js, [['render',PackagingHubvue_type_template_id_ceca7fd8_scoped_true_render],['__scopeId',"data-v-ceca7fd8"]])

/* harmony default export */ var PackagingHub = (PackagingHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/PaymentHub.vue?vue&type=template&id=358691c2&scoped=true


const PaymentHubvue_type_template_id_358691c2_scoped_true_withScopeId = n => (_pushScopeId("data-v-358691c2"),n=n(),_popScopeId(),n)
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1983.58",
  height: "267",
  viewBox: "0 0 1983.58 267"
}
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_2 = { key: 0 }
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-358691c2></polygon><path d=\"M59.6,181.33c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H44.21L40,186.17h5.49c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M88.73,190.3l-14.35,1c-7.5,0-11-2.23-11-7.07a14.17,14.17,0,0,1,.32-2.82l.22-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.22-3.26-6.68-3.26H68.62l.82-4.24,10.21-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM77.91,175.52c-4.4,0-4.94,2.23-5.65,5.49,0,.16-.11.38-.11.54a11.27,11.27,0,0,0-.32,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M119.66,191.55c-1.2,5.6-4.84,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.08-2,.16-.87.43-1.68.59-2.55-2.88.27-5.92.65-8.8.92-3.75,0-8-2-8-7.28a11.24,11.24,0,0,1,.33-2.61l4.23-19.68c5.6,0,7.45-.05,7.45,2.88a37.54,37.54,0,0,1-1.09,6.53l-2.17,10.32a10.74,10.74,0,0,0-.33,2.39c0,1.69.93,2.5,3.92,2.5h5.27l5.27-24.62h8.37Z\" fill=\"#00bd8e\" data-v-358691c2></path><polygon points=\"123.59 144.89 117.68 144.89 119.22 137.67 115.12 137.67 111.35 155.47 115.44 155.47 117.08 147.76 123 147.76 121.36 155.47 125.45 155.47 129.23 137.67 125.13 137.67 123.59 144.89\" fill=\"#00bd8e\" data-v-358691c2></polygon><path d=\"M142.26,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M162.4,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63H154c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.4,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,155.75,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M521.55,105.78c0,48.84-28.79,65.6-94.4,65.6h-39v83.1H325.84V14.3H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,79.54c0-22.23-7.65-34.26-36.08-34.26H388.16V140.4h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M656.4,254.48l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,14.3h94.39l69.61,240.18ZM613.76,43.09H592.62l-25.88,127.2h74Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M819,166.64v87.84H756.26V166.64c-24-49.2-51.39-103.14-75.44-152.34h70.7l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45H901Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M1164.45,254.48V48.92h-14.22l-68.15,205.56h-49.93L962.54,48.92H949.06V254.48H908.6V14.3h104.6l58,173.12L1126.91,14.3h98.4V254.48Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M1248.64,254.48V14.3h151.61V44.91h-88.2v69.62h69.62v31.34h-69.62V223.5h88.2v31Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M1550.77,254.48,1458.2,74.8V254.48h-40.09V14.3h71.8l89.65,177.13V14.3h39.73V254.48Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M1753.78,45.28v209.2h-62.69V45.28h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M1977.55,188.87c0,44.1-30.61,67.79-91.11,67.79l-80.54-5.1V225.68h63c40.82,0,43-15.3,43-34.25V177.58l-103.5-63.78c-2.55-6.93-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.84-73.26l72.17,5.83V42.73h-45.93c-46.28,0-50.66,13.85-50.66,35.35v10.2l99.87,62c4,8,8,21.5,8,33.17Z\" fill=\"#fff\" data-v-358691c2></path>", 15)
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_18 = [
  PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_3
]
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_19 = { key: 1 }
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#00bd8e\" data-v-358691c2></polygon><path d=\"M59.6,181.33c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H44.21L40,186.17h5.49c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M88.73,190.3l-14.35,1c-7.5,0-11-2.23-11-7.07a14.17,14.17,0,0,1,.32-2.82l.22-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.22-3.26-6.68-3.26H68.62l.82-4.24,10.21-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM77.91,175.52c-4.4,0-4.94,2.23-5.65,5.49,0,.16-.11.38-.11.54a11.27,11.27,0,0,0-.32,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M119.66,191.55c-1.2,5.6-4.84,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.08-2,.16-.87.43-1.68.59-2.55-2.88.27-5.92.65-8.8.92-3.75,0-8-2-8-7.28a11.24,11.24,0,0,1,.33-2.61l4.23-19.68c5.6,0,7.45-.05,7.45,2.88a37.54,37.54,0,0,1-1.09,6.53l-2.17,10.32a10.74,10.74,0,0,0-.33,2.39c0,1.69.93,2.5,3.92,2.5h5.27l5.27-24.62h8.37Z\" fill=\"#fff\" data-v-358691c2></path><polygon points=\"123.59 144.89 117.68 144.89 119.22 137.67 115.12 137.67 111.35 155.47 115.44 155.47 117.08 147.76 123 147.76 121.36 155.47 125.45 155.47 129.23 137.67 125.13 137.67 123.59 144.89\" fill=\"#fff\" data-v-358691c2></polygon><path d=\"M142.26,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M162.4,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63H154c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.4,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,155.75,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-358691c2></path><path d=\"M521.55,105.78c0,48.84-28.79,65.6-94.4,65.6h-39v83.1H325.84V14.3H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,79.54c0-22.23-7.65-34.26-36.08-34.26H388.16V140.4h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M656.4,254.48l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,14.3h94.39l69.61,240.18ZM613.76,43.09H592.62l-25.88,127.2h74Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M819,166.64v87.84H756.26V166.64c-24-49.2-51.39-103.14-75.44-152.34h70.7l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45H901Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M1164.45,254.48V48.92h-14.22l-68.15,205.56h-49.93L962.54,48.92H949.06V254.48H908.6V14.3h104.6l58,173.12L1126.91,14.3h98.4V254.48Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M1248.64,254.48V14.3h151.61V44.91h-88.2v69.62h69.62v31.34h-69.62V223.5h88.2v31Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M1550.77,254.48,1458.2,74.8V254.48h-40.09V14.3h71.8l89.65,177.13V14.3h39.73V254.48Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M1753.78,45.28v209.2h-62.69V45.28h-51.75v-31h166.19v31Z\" fill=\"#00bd8e\" data-v-358691c2></path><path d=\"M1977.55,188.87c0,44.1-30.61,67.79-91.11,67.79l-80.54-5.1V225.68h63c40.82,0,43-15.3,43-34.25V177.58l-103.5-63.78c-2.55-6.93-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.84-73.26l72.17,5.83V42.73h-45.93c-46.28,0-50.66,13.85-50.66,35.35v10.2l99.87,62c4,8,8,21.5,8,33.17Z\" fill=\"#00bd8e\" data-v-358691c2></path>", 15)
const PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_35 = [
  PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_20
]

function PaymentHubvue_type_template_id_358691c2_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_2, PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_18))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_19, PaymentHubvue_type_template_id_358691c2_scoped_true_hoisted_35))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PaymentHub.vue?vue&type=template&id=358691c2&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/PaymentHub.vue?vue&type=script&lang=js

  /* harmony default export */ var PaymentHubvue_type_script_lang_js = ({
    name: "PaymentHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PaymentHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/PaymentHub.vue?vue&type=style&index=0&id=358691c2&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PaymentHub.vue?vue&type=style&index=0&id=358691c2&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/PaymentHub.vue




;


const PaymentHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PaymentHubvue_type_script_lang_js, [['render',PaymentHubvue_type_template_id_358691c2_scoped_true_render],['__scopeId',"data-v-358691c2"]])

/* harmony default export */ var PaymentHub = (PaymentHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ProductsHub.vue?vue&type=template&id=4cd55436&scoped=true


const ProductsHubvue_type_template_id_4cd55436_scoped_true_withScopeId = n => (_pushScopeId("data-v-4cd55436"),n=n(),_popScopeId(),n)
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1938.03",
  height: "267",
  viewBox: "0 0 1938.03 267"
}
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_2 = { key: 0 }
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-4cd55436></polygon><path d=\"M61.57,184.92c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L34.56,185l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39ZM55.21,175a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H46.19L42,189.76H47.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M91.74,176.72H85.43a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7l-5.16,24.24H64.4l6.09-28.59L84,164.76c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M118.59,193.89l-14.78,1c-6.91,0-10.6-2.4-10.6-7.34a11,11,0,0,1,.27-2.56l2.23-10.27c1.63-7.77,7.28-9.78,12-9.78l8.53.87c2-8.81,2.72-9.4,10.38-9.51Zm-8.81-24c-3.91,0-4.89,1.58-5.59,5L102,185.09a13.35,13.35,0,0,0-.33,2.34c0,1.73.93,2.55,3.7,2.55h5.6c1.41-6.69,2.93-13.32,4.34-20.06Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><polygon points=\"121.62 141.29 115.7 141.29 117.24 134.08 113.15 134.08 109.37 151.88 113.47 151.88 115.11 144.17 121.02 144.17 119.38 151.88 123.48 151.88 127.25 134.08 123.16 134.08 121.62 141.29\" fill=\"#f2dc1d\" data-v-4cd55436></polygon><path d=\"M140.28,134.15,137.55,147c-.36,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.14,2.14,0,0,1-.16-1.8L135,134.15h-4.48L127.84,147a3.73,3.73,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63h1c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M160.42,135.74c-.86-1.06-2.5-1.57-5-1.57H148l-3.74,17.63H152c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,160.42,135.74Zm-6.64,5.56H151.2c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,153.78,141.3Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M521.55,106.41c0,48.84-28.79,65.6-94.4,65.6h-39v83.1H325.84V14.93H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,80.17c0-22.23-7.65-34.26-36.08-34.26H388.16V141h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M603.19,255.11H539.41V14.93H647.29c58.31,0,92.93,15.67,92.93,60.86V89.28c0,41.91-14.94,60.5-55.39,60.86,19.68,29.52,48.83,73.26,70.7,105h-78l-59-109.7V124.27c46.29,0,53.94-8,53.94-28.07v-16c0-20.41-4.73-33.9-41.18-33.9H603.19Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M956.71,191.33c0,68.51-76.53,65.6-107.15,65.6-57.95,0-92.93-19.32-92.93-65.6V78.71c0-46.29,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.31,92.57,65.6ZM894.39,78.71c0-23.69-8.75-34.62-36.45-34.62h-2.55C827.69,44.09,819,55,819,78.71V191.33c0,23.69,8.74,34.26,36.44,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M1174.66,189.5c0,44.47-30.62,65.61-92.57,65.61H974.94V14.93h107.15c61.22,0,92.57,21.87,92.57,65.6Zm-62.32-109c0-22.59-7.66-34.26-36.45-34.26h-39V224.13h39c29.52,0,36.45-11.3,36.45-34.63Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M1393,191.33c0,43.73-31.35,65.6-92.57,65.6h-15c-61.23,0-92.57-21.87-92.57-65.6V14.93h63v176.4c0,22.23,7.66,34.26,35.72,34.26h2.55c28.06,0,35.72-12,35.72-34.26V14.93h63Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M1513.6,257.66c-48.11,0-102.41-5.1-102.41-65.6V78.35c0-61.23,55-66.7,102.41-66.7l58.32,5.1v27h-57.59c-37.9,0-40.82,10.21-40.82,34.63V192.06c0,25.14,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M1700.93,45.91v209.2h-62.68V45.91h-51.76v-31h166.2v31Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M1932,189.5c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V226.31h63.05c40.82,0,43-15.3,43-34.25V178.21l-103.51-63.78c-2.55-6.93-6.19-17.13-6.19-29.52,0-44.47,24.78-73.26,91.84-73.26l72.16,5.83V43.36h-45.92c-46.29,0-50.66,13.85-50.66,35.35v10.2l99.86,62c4,8,8,21.5,8,33.17Z\" fill=\"#fff\" data-v-4cd55436></path>", 15)
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_18 = [
  ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_3
]
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_19 = { key: 1 }
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#f2dc1d\" data-v-4cd55436></polygon><path d=\"M61.57,184.92c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L34.56,185l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39ZM55.21,175a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H46.19L42,189.76H47.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M91.74,176.72H85.43a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7l-5.16,24.24H64.4l6.09-28.59L84,164.76c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M118.59,193.89l-14.78,1c-6.91,0-10.6-2.4-10.6-7.34a11,11,0,0,1,.27-2.56l2.23-10.27c1.63-7.77,7.28-9.78,12-9.78l8.53.87c2-8.81,2.72-9.4,10.38-9.51Zm-8.81-24c-3.91,0-4.89,1.58-5.59,5L102,185.09a13.35,13.35,0,0,0-.33,2.34c0,1.73.93,2.55,3.7,2.55h5.6c1.41-6.69,2.93-13.32,4.34-20.06Z\" fill=\"#fff\" data-v-4cd55436></path><polygon points=\"121.62 141.29 115.7 141.29 117.24 134.08 113.15 134.08 109.37 151.88 113.47 151.88 115.11 144.17 121.02 144.17 119.38 151.88 123.48 151.88 127.25 134.08 123.16 134.08 121.62 141.29\" fill=\"#fff\" data-v-4cd55436></polygon><path d=\"M140.28,134.15,137.55,147c-.36,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.14,2.14,0,0,1-.16-1.8L135,134.15h-4.48L127.84,147a3.73,3.73,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63h1c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M160.42,135.74c-.86-1.06-2.5-1.57-5-1.57H148l-3.74,17.63H152c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,160.42,135.74Zm-6.64,5.56H151.2c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,153.78,141.3Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-4cd55436></path><path d=\"M521.55,106.41c0,48.84-28.79,65.6-94.4,65.6h-39v83.1H325.84V14.93H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,80.17c0-22.23-7.65-34.26-36.08-34.26H388.16V141h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M603.19,255.11H539.41V14.93H647.29c58.31,0,92.93,15.67,92.93,60.86V89.28c0,41.91-14.94,60.5-55.39,60.86,19.68,29.52,48.83,73.26,70.7,105h-78l-59-109.7V124.27c46.29,0,53.94-8,53.94-28.07v-16c0-20.41-4.73-33.9-41.18-33.9H603.19Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M956.71,191.33c0,68.51-76.53,65.6-107.15,65.6-57.95,0-92.93-19.32-92.93-65.6V78.71c0-46.29,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.31,92.57,65.6ZM894.39,78.71c0-23.69-8.75-34.62-36.45-34.62h-2.55C827.69,44.09,819,55,819,78.71V191.33c0,23.69,8.74,34.26,36.44,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M1174.66,189.5c0,44.47-30.62,65.61-92.57,65.61H974.94V14.93h107.15c61.22,0,92.57,21.87,92.57,65.6Zm-62.32-109c0-22.59-7.66-34.26-36.45-34.26h-39V224.13h39c29.52,0,36.45-11.3,36.45-34.63Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M1393,191.33c0,43.73-31.35,65.6-92.57,65.6h-15c-61.23,0-92.57-21.87-92.57-65.6V14.93h63v176.4c0,22.23,7.66,34.26,35.72,34.26h2.55c28.06,0,35.72-12,35.72-34.26V14.93h63Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M1513.6,257.66c-48.11,0-102.41-5.1-102.41-65.6V78.35c0-61.23,55-66.7,102.41-66.7l58.32,5.1v27h-57.59c-37.9,0-40.82,10.21-40.82,34.63V192.06c0,25.14,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M1700.93,45.91v209.2h-62.68V45.91h-51.76v-31h166.2v31Z\" fill=\"#f2dc1d\" data-v-4cd55436></path><path d=\"M1932,189.5c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V226.31h63.05c40.82,0,43-15.3,43-34.25V178.21l-103.51-63.78c-2.55-6.93-6.19-17.13-6.19-29.52,0-44.47,24.78-73.26,91.84-73.26l72.16,5.83V43.36h-45.92c-46.29,0-50.66,13.85-50.66,35.35v10.2l99.86,62c4,8,8,21.5,8,33.17Z\" fill=\"#f2dc1d\" data-v-4cd55436></path>", 15)
const ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_35 = [
  ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_20
]

function ProductsHubvue_type_template_id_4cd55436_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_2, ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_18))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_19, ProductsHubvue_type_template_id_4cd55436_scoped_true_hoisted_35))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ProductsHub.vue?vue&type=template&id=4cd55436&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ProductsHub.vue?vue&type=script&lang=js

  /* harmony default export */ var ProductsHubvue_type_script_lang_js = ({
    name: "ProductsHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ProductsHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/ProductsHub.vue?vue&type=style&index=0&id=4cd55436&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ProductsHub.vue?vue&type=style&index=0&id=4cd55436&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/ProductsHub.vue




;


const ProductsHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProductsHubvue_type_script_lang_js, [['render',ProductsHubvue_type_template_id_4cd55436_scoped_true_render],['__scopeId',"data-v-4cd55436"]])

/* harmony default export */ var ProductsHub = (ProductsHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/SupportHub.vue?vue&type=template&id=5f705690&scoped=true


const SupportHubvue_type_template_id_5f705690_scoped_true_withScopeId = n => (_pushScopeId("data-v-5f705690"),n=n(),_popScopeId(),n)
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1745.97",
  height: "267",
  viewBox: "0 0 1745.97 267"
}
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_2 = { key: 0 }
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-5f705690></polygon><path d=\"M64.66,168.13H56.29c-4.08,0-5.33,1-6.14,4.4l12.06,6.36c-.11,1.69-.32,3.86-.49,4.84-1.63,7.18-6.63,9.51-16,9.51l-8.58-.81.81-4.19h8.59c5.11,0,5.82-1.74,6.36-4.29l.22-.82L41,176.77a15.1,15.1,0,0,1,.1-4.13c1.63-7.44,7-9.51,16-9.51l8.37.82Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M93.36,183.24c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.9,8.91-2.66,9.57-10.33,9.62l3.91-18.42.39-1.85,3.69-17.29L85,163.08c6.74,0,10.76,2.44,10.76,7.44a12.51,12.51,0,0,1-.27,2.4Zm-6.36-10a11,11,0,0,0,.27-2.11c0-1.85-1-2.67-3.86-2.67H78l-4.19,19.57h5.49c3.91,0,4.89-1.58,5.6-4.89Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M119.29,167.86l-9.9.87-3.1,14.67a10.86,10.86,0,0,0-.32,2.34c0,1.69.87,2.5,3.69,2.5h5.22L114,192.7l-5.38.54c-7.34,0-11.09-1.85-11.09-6.9a15.87,15.87,0,0,1,.38-3l4.18-19.57c4.08-.54,4.79-1.84,5.66-5h3.86l-1,4.84h9.62Z\" fill=\"#e09dea\" data-v-5f705690></path><polygon points=\"115.81 142.98 109.9 142.98 111.44 135.77 107.34 135.77 103.57 153.56 107.66 153.56 109.3 145.85 115.22 145.85 113.58 153.56 117.67 153.56 121.45 135.77 117.35 135.77 115.81 142.98\" fill=\"#e09dea\" data-v-5f705690></polygon><path d=\"M134.48,135.83l-2.73,12.86c-.37,1.76-1.24,2.44-3.1,2.44h-.18a2.32,2.32,0,0,1-1.82-.54,2.19,2.19,0,0,1-.17-1.8l2.75-13h-4.47L122,148.69a3.8,3.8,0,0,0,.54,3.32c.87,1.07,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M154.62,137.43c-.87-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.63h7.8c4.27,0,6.78-1.63,7.44-4.83a4.25,4.25,0,0,0-.34-3.25,3.07,3.07,0,0,0-.91-.84,4.59,4.59,0,0,0,2.76-3.7A3.93,3.93,0,0,0,154.62,137.43ZM148,143h-2.58c.22-1,.42-1.95.62-2.92l.29-1.37h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,148,143Zm-.22,2.87a1.25,1.25,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.27,1.27c-.36,1.63-1.06,2.15-2.89,2.15h-2.1l1-4.74Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M493.78,187.61c0,44.1-30.61,67.79-91.12,67.79l-80.54-5.1V224.42h63.05c40.82,0,43-15.31,43-34.26V176.31L324.67,112.53c-2.55-6.92-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.85-73.26l72.16,5.83V41.46H436.56c-46.29,0-50.66,13.85-50.66,35.35V87l99.86,62c4,8,8,21.5,8,33.16Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M707,189.43c0,43.74-31.34,65.61-92.57,65.61H599.47c-61.23,0-92.57-21.87-92.57-65.61V13H570v176.4c0,22.24,7.66,34.26,35.72,34.26h2.55c28.06,0,35.72-12,35.72-34.26V13h63Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M926,104.51c0,48.84-28.79,65.61-94.4,65.61h-39v83.1H730.31V13H833.45C894.32,13,926,34.53,926,78.27ZM864.8,78.27C864.8,56,857.15,44,828.72,44H792.63v95.13h36.09c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M1139.6,104.51c0,48.84-28.79,65.61-94.39,65.61h-39v83.1H943.88V13H1047c60.87,0,92.57,21.5,92.57,65.24Zm-61.23-26.24c0-22.23-7.65-34.26-36.08-34.26h-36.08v95.13h36.08c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M1359.74,189.43c0,68.52-76.54,65.61-107.16,65.61-57.95,0-92.94-19.32-92.94-65.61V76.81c0-46.29,34.63-65.6,92.58-65.6h14.94c57.59,0,92.58,19.31,92.58,65.6ZM1297.41,76.81c0-23.69-8.74-34.62-36.44-34.62h-2.56c-27.7,0-36.44,10.93-36.44,34.62V189.43c0,23.69,8.74,34.26,36.44,34.26H1261c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M1449,253.22h-63.78V13h107.89c58.31,0,92.94,15.67,92.94,60.87V87.38c0,41.92-15,60.5-55.4,60.87,19.68,29.52,48.84,73.26,70.7,105h-78l-59.05-109.71V122.37c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.73-33.9-41.18-33.9H1449Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M1710,44V253.22h-62.69V44h-51.75V13h166.19V44Z\" fill=\"#fff\" data-v-5f705690></path>", 14)
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_17 = [
  SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_3
]
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_18 = { key: 1 }
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e09dea\" data-v-5f705690></polygon><path d=\"M64.66,168.13H56.29c-4.08,0-5.33,1-6.14,4.4l12.06,6.36c-.11,1.69-.32,3.86-.49,4.84-1.63,7.18-6.63,9.51-16,9.51l-8.58-.81.81-4.19h8.59c5.11,0,5.82-1.74,6.36-4.29l.22-.82L41,176.77a15.1,15.1,0,0,1,.1-4.13c1.63-7.44,7-9.51,16-9.51l8.37.82Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M93.36,183.24c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.9,8.91-2.66,9.57-10.33,9.62l3.91-18.42.39-1.85,3.69-17.29L85,163.08c6.74,0,10.76,2.44,10.76,7.44a12.51,12.51,0,0,1-.27,2.4Zm-6.36-10a11,11,0,0,0,.27-2.11c0-1.85-1-2.67-3.86-2.67H78l-4.19,19.57h5.49c3.91,0,4.89-1.58,5.6-4.89Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M119.29,167.86l-9.9.87-3.1,14.67a10.86,10.86,0,0,0-.32,2.34c0,1.69.87,2.5,3.69,2.5h5.22L114,192.7l-5.38.54c-7.34,0-11.09-1.85-11.09-6.9a15.87,15.87,0,0,1,.38-3l4.18-19.57c4.08-.54,4.79-1.84,5.66-5h3.86l-1,4.84h9.62Z\" fill=\"#fff\" data-v-5f705690></path><polygon points=\"115.81 142.98 109.9 142.98 111.44 135.77 107.34 135.77 103.57 153.56 107.66 153.56 109.3 145.85 115.22 145.85 113.58 153.56 117.67 153.56 121.45 135.77 117.35 135.77 115.81 142.98\" fill=\"#fff\" data-v-5f705690></polygon><path d=\"M134.48,135.83l-2.73,12.86c-.37,1.76-1.24,2.44-3.1,2.44h-.18a2.32,2.32,0,0,1-1.82-.54,2.19,2.19,0,0,1-.17-1.8l2.75-13h-4.47L122,148.69a3.8,3.8,0,0,0,.54,3.32c.87,1.07,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M154.62,137.43c-.87-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.63h7.8c4.27,0,6.78-1.63,7.44-4.83a4.25,4.25,0,0,0-.34-3.25,3.07,3.07,0,0,0-.91-.84,4.59,4.59,0,0,0,2.76-3.7A3.93,3.93,0,0,0,154.62,137.43ZM148,143h-2.58c.22-1,.42-1.95.62-2.92l.29-1.37h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,148,143Zm-.22,2.87a1.25,1.25,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.27,1.27c-.36,1.63-1.06,2.15-2.89,2.15h-2.1l1-4.74Z\" fill=\"#fff\" data-v-5f705690></path><path d=\"M493.78,187.61c0,44.1-30.61,67.79-91.12,67.79l-80.54-5.1V224.42h63.05c40.82,0,43-15.31,43-34.26V176.31L324.67,112.53c-2.55-6.92-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.85-73.26l72.16,5.83V41.46H436.56c-46.29,0-50.66,13.85-50.66,35.35V87l99.86,62c4,8,8,21.5,8,33.16Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M707,189.43c0,43.74-31.34,65.61-92.57,65.61H599.47c-61.23,0-92.57-21.87-92.57-65.61V13H570v176.4c0,22.24,7.66,34.26,35.72,34.26h2.55c28.06,0,35.72-12,35.72-34.26V13h63Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M926,104.51c0,48.84-28.79,65.61-94.4,65.61h-39v83.1H730.31V13H833.45C894.32,13,926,34.53,926,78.27ZM864.8,78.27C864.8,56,857.15,44,828.72,44H792.63v95.13h36.09c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M1139.6,104.51c0,48.84-28.79,65.61-94.39,65.61h-39v83.1H943.88V13H1047c60.87,0,92.57,21.5,92.57,65.24Zm-61.23-26.24c0-22.23-7.65-34.26-36.08-34.26h-36.08v95.13h36.08c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M1359.74,189.43c0,68.52-76.54,65.61-107.16,65.61-57.95,0-92.94-19.32-92.94-65.61V76.81c0-46.29,34.63-65.6,92.58-65.6h14.94c57.59,0,92.58,19.31,92.58,65.6ZM1297.41,76.81c0-23.69-8.74-34.62-36.44-34.62h-2.56c-27.7,0-36.44,10.93-36.44,34.62V189.43c0,23.69,8.74,34.26,36.44,34.26H1261c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M1449,253.22h-63.78V13h107.89c58.31,0,92.94,15.67,92.94,60.87V87.38c0,41.92-15,60.5-55.4,60.87,19.68,29.52,48.84,73.26,70.7,105h-78l-59.05-109.71V122.37c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.73-33.9-41.18-33.9H1449Z\" fill=\"#e09dea\" data-v-5f705690></path><path d=\"M1710,44V253.22h-62.69V44h-51.75V13h166.19V44Z\" fill=\"#e09dea\" data-v-5f705690></path>", 14)
const SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_33 = [
  SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_19
]

function SupportHubvue_type_template_id_5f705690_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_2, SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_17))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_18, SupportHubvue_type_template_id_5f705690_scoped_true_hoisted_33))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/SupportHub.vue?vue&type=template&id=5f705690&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/SupportHub.vue?vue&type=script&lang=js

  /* harmony default export */ var SupportHubvue_type_script_lang_js = ({
    name: "SupportHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/SupportHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/SupportHub.vue?vue&type=style&index=0&id=5f705690&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/SupportHub.vue?vue&type=style&index=0&id=5f705690&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/SupportHub.vue




;


const SupportHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SupportHubvue_type_script_lang_js, [['render',SupportHubvue_type_template_id_5f705690_scoped_true_render],['__scopeId',"data-v-5f705690"]])

/* harmony default export */ var SupportHub = (SupportHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/TaxHub.vue?vue&type=template&id=2f6696a6&scoped=true


const TaxHubvue_type_template_id_2f6696a6_scoped_true_withScopeId = n => (_pushScopeId("data-v-2f6696a6"),n=n(),_popScopeId(),n)
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "955.46",
  height: "267",
  viewBox: "0 0 955.46 267"
}
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_2 = { key: 0 }
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-2f6696a6></polygon><polygon points=\"121.11 145.4 115.19 145.4 116.73 138.18 112.64 138.18 108.86 155.98 112.96 155.98 114.6 148.27 120.51 148.27 118.87 155.98 122.97 155.98 126.74 138.18 122.65 138.18 121.11 145.4\" fill=\"#5399d3\" data-v-2f6696a6></polygon><path d=\"M139.77,138.25,137,151.11c-.36,1.75-1.23,2.44-3.09,2.44h-.18A2.27,2.27,0,0,1,132,153a2.12,2.12,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63H134c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M159.91,139.84c-.86-1.06-2.5-1.57-5-1.57h-7.46L143.7,155.9h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.63,4.63,0,0,0,2.77-3.7A3.92,3.92,0,0,0,159.91,139.84Zm-6.64,5.56h-2.58c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42s.25.79.1,1.58l-.16.76A1.94,1.94,0,0,1,153.27,145.4Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M55.78,165.44l-9.9.87L42.79,181a10.2,10.2,0,0,0-.33,2.34c0,1.68.87,2.5,3.7,2.5h5.21l-.92,4.45-5.38.55C37.73,190.83,34,189,34,183.92a15.87,15.87,0,0,1,.38-3l4.19-19.56c4.07-.55,4.78-1.85,5.65-5h3.86l-1,4.83h9.62Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M80.51,189.79l-14.35,1c-7.5,0-11-2.23-11-7.06a13.54,13.54,0,0,1,.33-2.83l.22-1c1.47-6.74,5.76-9.4,11.79-9.4l8.64.76.44-2c.43-2-.22-3.26-6.69-3.26H60.4l.81-4.24,10.22-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM69.69,175c-4.4,0-5,2.23-5.65,5.49,0,.16-.11.38-.11.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.7,2.5H73c.76-3.64,1.63-7.22,2.39-10.92Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M109.91,175l5.66,15.38h-9.3l-3.59-12.07h-2.55L92,190.34H83.71l12.07-15.49L90.89,161.2h9.4l3.1,10.82h2.23l9-10.82H122Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M430.93,44.64V253.85H368.24V44.64H316.49v-31h166.2v31Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M635.76,253.85l-10.21-53.94v.72h-86v-.72l-11.3,53.94H476.48l66.7-240.19h94.4l69.61,240.19ZM593.12,42.45H572L546.1,169.65h74Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M869.74,253.85,827.83,147.42H809.24L767.69,253.85H713.38l62-128.3C757.85,89.83,737.07,49,719.58,13.66h70L823.82,100h20.41c10.57-28.43,21.87-57.59,32.44-86.38h51.75L878.85,125.55c19.69,41.92,41.55,86.38,61.23,128.3Z\" fill=\"#fff\" data-v-2f6696a6></path>", 10)
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_13 = [
  TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_3
]
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_14 = { key: 1 }
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#5399d3\" data-v-2f6696a6></polygon><polygon points=\"121.11 145.4 115.19 145.4 116.73 138.18 112.64 138.18 108.86 155.98 112.96 155.98 114.6 148.27 120.51 148.27 118.87 155.98 122.97 155.98 126.74 138.18 122.65 138.18 121.11 145.4\" fill=\"#fff\" data-v-2f6696a6></polygon><path d=\"M139.77,138.25,137,151.11c-.36,1.75-1.23,2.44-3.09,2.44h-.18A2.27,2.27,0,0,1,132,153a2.12,2.12,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63H134c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M159.91,139.84c-.86-1.06-2.5-1.57-5-1.57h-7.46L143.7,155.9h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.63,4.63,0,0,0,2.77-3.7A3.92,3.92,0,0,0,159.91,139.84Zm-6.64,5.56h-2.58c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42s.25.79.1,1.58l-.16.76A1.94,1.94,0,0,1,153.27,145.4Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M55.78,165.44l-9.9.87L42.79,181a10.2,10.2,0,0,0-.33,2.34c0,1.68.87,2.5,3.7,2.5h5.21l-.92,4.45-5.38.55C37.73,190.83,34,189,34,183.92a15.87,15.87,0,0,1,.38-3l4.19-19.56c4.07-.55,4.78-1.85,5.65-5h3.86l-1,4.83h9.62Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M80.51,189.79l-14.35,1c-7.5,0-11-2.23-11-7.06a13.54,13.54,0,0,1,.33-2.83l.22-1c1.47-6.74,5.76-9.4,11.79-9.4l8.64.76.44-2c.43-2-.22-3.26-6.69-3.26H60.4l.81-4.24,10.22-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM69.69,175c-4.4,0-5,2.23-5.65,5.49,0,.16-.11.38-.11.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.7,2.5H73c.76-3.64,1.63-7.22,2.39-10.92Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M109.91,175l5.66,15.38h-9.3l-3.59-12.07h-2.55L92,190.34H83.71l12.07-15.49L90.89,161.2h9.4l3.1,10.82h2.23l9-10.82H122Z\" fill=\"#fff\" data-v-2f6696a6></path><path d=\"M430.93,44.64V253.85H368.24V44.64H316.49v-31h166.2v31Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M635.76,253.85l-10.21-53.94v.72h-86v-.72l-11.3,53.94H476.48l66.7-240.19h94.4l69.61,240.19ZM593.12,42.45H572L546.1,169.65h74Z\" fill=\"#5399d3\" data-v-2f6696a6></path><path d=\"M869.74,253.85,827.83,147.42H809.24L767.69,253.85H713.38l62-128.3C757.85,89.83,737.07,49,719.58,13.66h70L823.82,100h20.41c10.57-28.43,21.87-57.59,32.44-86.38h51.75L878.85,125.55c19.69,41.92,41.55,86.38,61.23,128.3Z\" fill=\"#5399d3\" data-v-2f6696a6></path>", 10)
const TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_25 = [
  TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_15
]

function TaxHubvue_type_template_id_2f6696a6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_2, TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_13))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_14, TaxHubvue_type_template_id_2f6696a6_scoped_true_hoisted_25))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/TaxHub.vue?vue&type=template&id=2f6696a6&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/TaxHub.vue?vue&type=script&lang=js

  /* harmony default export */ var TaxHubvue_type_script_lang_js = ({
    name: "TaxHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/TaxHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/TaxHub.vue?vue&type=style&index=0&id=2f6696a6&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/TaxHub.vue?vue&type=style&index=0&id=2f6696a6&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/TaxHub.vue




;


const TaxHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TaxHubvue_type_script_lang_js, [['render',TaxHubvue_type_template_id_2f6696a6_scoped_true_render],['__scopeId',"data-v-2f6696a6"]])

/* harmony default export */ var TaxHub = (TaxHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/W3EHub.vue?vue&type=template&id=5fb1de08&scoped=true


const W3EHubvue_type_template_id_5fb1de08_scoped_true_withScopeId = n => (_pushScopeId("data-v-5fb1de08"),n=n(),_popScopeId(),n)
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1207.65",
  height: "267",
  viewBox: "0 0 1207.65 267"
}
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_2 = { key: 0 }
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-5fb1de08></polygon><path d=\"M68.2,193H56.45l1.18-23.6c-2.77,7.67-5.83,15.94-8.55,23.6h-12l-.66-31H45.6l-1.22,25.61h1.36l9.4-25.61H65L63.6,187.66h1.45l9.45-25.61h7.38Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M98.61,177.27c2.21.47,3.53,1.51,3.53,4.28a13.55,13.55,0,0,1-.38,3.1c-1.31,5.45-5.5,8.74-13.86,8.74l-9.59-.61.8-3.95h6.3c5.31,0,7-1.92,7.56-4.27.14-.75.38-1.6.52-2.35.19-.9-.23-3-4-3H85.22l.89-4.28h4.14c3,0,5-1.31,5.5-3l.28-1.41a8.88,8.88,0,0,0,.19-1.41c0-1.74-1.23-2.68-5.69-2.68H84l.8-4,9.77-.71c7,0,10.43,2.4,10.43,6.77a11.61,11.61,0,0,1-.23,2.11C103.74,175.39,102,176.8,98.61,177.27Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M129.49,166.28H118.07l-1.83,8.6h9l-.89,4.27h-9c-.66,3.25-1.36,6.39-2,9.59H124.6l-.84,4.28H103.88l6.58-31h19.92Z\" fill=\"#e27110\" data-v-5fb1de08></path><polygon points=\"120.72 144.54 114.8 144.54 116.34 137.33 112.25 137.33 108.47 155.13 112.57 155.13 114.21 147.41 120.12 147.41 118.48 155.13 122.58 155.13 126.35 137.33 122.26 137.33 120.72 144.54\" fill=\"#e27110\" data-v-5fb1de08></polygon><path d=\"M139.38,137.39l-2.73,12.86c-.36,1.76-1.23,2.44-3.09,2.44h-.19a2.3,2.3,0,0,1-1.81-.54,2.15,2.15,0,0,1-.17-1.8l2.75-13h-4.47l-2.73,12.86a3.77,3.77,0,0,0,.54,3.32c.86,1.08,2.55,1.62,5,1.62h1.06c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M159.52,139c-.86-1.06-2.5-1.58-5-1.58h-7.46L143.31,155h7.81c4.27,0,6.77-1.63,7.44-4.83a4.31,4.31,0,0,0-.35-3.25,3,3,0,0,0-.91-.84,4.62,4.62,0,0,0,2.77-3.7A3.9,3.9,0,0,0,159.52,139Zm-6.64,5.55H150.3c.22-1,.42-1.95.62-2.92l.28-1.37h2.23c.87,0,1.4.14,1.63.42a2.05,2.05,0,0,1,.1,1.58L155,143A1.94,1.94,0,0,1,152.88,144.54Zm-.23,2.87a1.26,1.26,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.28,1.27c-.36,1.63-1.05,2.15-2.88,2.15h-2.11l1-4.74Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M610.32,254.79H521.4L489.69,62c-8.75,60.14-19.32,133-27.7,192.8H370.87L315.48,14.62h68.15L416.8,215.8h13.12L459.8,14.62h74.35L565.49,215.8h14.22L610.32,14.62H663.9Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M686.13,254.79V14.62H837.75V45.23h-88.2v69.61h69.61v31.34H749.55v77.63h88.2v31Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M862.9,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34H926.31v77.63h88.2v31Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M1039.66,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-5fb1de08></path>", 11)
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_14 = [
  W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_3
]
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_15 = { key: 1 }
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e27110\" data-v-5fb1de08></polygon><path d=\"M68.2,193H56.45l1.18-23.6c-2.77,7.67-5.83,15.94-8.55,23.6h-12l-.66-31H45.6l-1.22,25.61h1.36l9.4-25.61H65L63.6,187.66h1.45l9.45-25.61h7.38Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M98.61,177.27c2.21.47,3.53,1.51,3.53,4.28a13.55,13.55,0,0,1-.38,3.1c-1.31,5.45-5.5,8.74-13.86,8.74l-9.59-.61.8-3.95h6.3c5.31,0,7-1.92,7.56-4.27.14-.75.38-1.6.52-2.35.19-.9-.23-3-4-3H85.22l.89-4.28h4.14c3,0,5-1.31,5.5-3l.28-1.41a8.88,8.88,0,0,0,.19-1.41c0-1.74-1.23-2.68-5.69-2.68H84l.8-4,9.77-.71c7,0,10.43,2.4,10.43,6.77a11.61,11.61,0,0,1-.23,2.11C103.74,175.39,102,176.8,98.61,177.27Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M129.49,166.28H118.07l-1.83,8.6h9l-.89,4.27h-9c-.66,3.25-1.36,6.39-2,9.59H124.6l-.84,4.28H103.88l6.58-31h19.92Z\" fill=\"#fff\" data-v-5fb1de08></path><polygon points=\"120.72 144.54 114.8 144.54 116.34 137.33 112.25 137.33 108.47 155.13 112.57 155.13 114.21 147.41 120.12 147.41 118.48 155.13 122.58 155.13 126.35 137.33 122.26 137.33 120.72 144.54\" fill=\"#fff\" data-v-5fb1de08></polygon><path d=\"M139.38,137.39l-2.73,12.86c-.36,1.76-1.23,2.44-3.09,2.44h-.19a2.3,2.3,0,0,1-1.81-.54,2.15,2.15,0,0,1-.17-1.8l2.75-13h-4.47l-2.73,12.86a3.77,3.77,0,0,0,.54,3.32c.86,1.08,2.55,1.62,5,1.62h1.06c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M159.52,139c-.86-1.06-2.5-1.58-5-1.58h-7.46L143.31,155h7.81c4.27,0,6.77-1.63,7.44-4.83a4.31,4.31,0,0,0-.35-3.25,3,3,0,0,0-.91-.84,4.62,4.62,0,0,0,2.77-3.7A3.9,3.9,0,0,0,159.52,139Zm-6.64,5.55H150.3c.22-1,.42-1.95.62-2.92l.28-1.37h2.23c.87,0,1.4.14,1.63.42a2.05,2.05,0,0,1,.1,1.58L155,143A1.94,1.94,0,0,1,152.88,144.54Zm-.23,2.87a1.26,1.26,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.28,1.27c-.36,1.63-1.05,2.15-2.88,2.15h-2.11l1-4.74Z\" fill=\"#fff\" data-v-5fb1de08></path><path d=\"M610.32,254.79H521.4L489.69,62c-8.75,60.14-19.32,133-27.7,192.8H370.87L315.48,14.62h68.15L416.8,215.8h13.12L459.8,14.62h74.35L565.49,215.8h14.22L610.32,14.62H663.9Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M686.13,254.79V14.62H837.75V45.23h-88.2v69.61h69.61v31.34H749.55v77.63h88.2v31Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M862.9,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34H926.31v77.63h88.2v31Z\" fill=\"#e27110\" data-v-5fb1de08></path><path d=\"M1039.66,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#e27110\" data-v-5fb1de08></path>", 11)
const W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_27 = [
  W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_16
]

function W3EHubvue_type_template_id_5fb1de08_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_2, W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_14))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_15, W3EHubvue_type_template_id_5fb1de08_scoped_true_hoisted_27))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/W3EHub.vue?vue&type=template&id=5fb1de08&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/W3EHub.vue?vue&type=script&lang=js

  /* harmony default export */ var W3EHubvue_type_script_lang_js = ({
    name: "W3EHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/W3EHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Default/W3EHub.vue?vue&type=style&index=0&id=5fb1de08&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/W3EHub.vue?vue&type=style&index=0&id=5fb1de08&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Default/W3EHub.vue




;


const W3EHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(W3EHubvue_type_script_lang_js, [['render',W3EHubvue_type_template_id_5fb1de08_scoped_true_render],['__scopeId',"data-v-5fb1de08"]])

/* harmony default export */ var W3EHub = (W3EHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/AccountingHub.vue?vue&type=template&id=daef1bbc&scoped=true


const AccountingHubvue_type_template_id_daef1bbc_scoped_true_withScopeId = n => (_pushScopeId("data-v-daef1bbc"),n=n(),_popScopeId(),n)
const AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2244.83",
  height: "267",
  viewBox: "0 0 2244.83 267"
}
const AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_2 = { key: 0 }
const AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M470.29,254.63l-10.21-53.94v.73h-86v-.73l-11.3,53.94H311l66.7-240.17h94.39l69.61,240.17ZM427.65,43.25H406.51L380.63,170.44h74Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M642,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H642.68c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M815.43,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H816.16c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M1086.58,190.85c0,68.52-76.53,65.61-107.14,65.61-58,0-92.94-19.32-92.94-65.61V78.24c0-46.29,34.62-65.6,92.57-65.6H994c57.59,0,92.57,19.31,92.57,65.6ZM1024.26,78.24c0-23.69-8.74-34.63-36.44-34.63h-2.55c-27.7,0-36.45,10.94-36.45,34.63V190.85c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M1304.89,190.85c0,43.74-31.34,65.61-92.57,65.61h-14.94c-61.23,0-92.57-21.87-92.57-65.61V14.46h63V190.85c0,22.24,7.65,34.26,35.72,34.26h2.55c28.06,0,35.71-12,35.71-34.26V14.46h63.05Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M1460.88,254.63,1368.31,75V254.63h-40.09V14.46H1400l89.65,177.12V14.46h39.73V254.63Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M1663.89,45.44V254.63H1601.2V45.44h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M1735.69,254.63V14.46h62.68V254.63Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M1961.65,254.63,1869.08,75V254.63H1829V14.46h71.79l89.66,177.12V14.46h39.73V254.63Z\" fill=\"#fff\" data-v-daef1bbc></path><path d=\"M2151.17,257.19c-48.48,0-102.78-3.28-102.78-65.61V77.87c0-62.68,59-66.69,105-66.69l81.28,5.1V42.52h-80.18c-41.19,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V114.68h62.32V251.35Z\" fill=\"#fff\" data-v-daef1bbc></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-daef1bbc></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path>", 24)
const AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_27 = [
  AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_3
]
const AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M470.29,254.63l-10.21-53.94v.73h-86v-.73l-11.3,53.94H311l66.7-240.17h94.39l69.61,240.17ZM427.65,43.25H406.51L380.63,170.44h74Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M642,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H642.68c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M815.43,257.19c-48.11,0-102.41-5.11-102.41-65.61V77.87c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27H816.16c-37.91,0-40.82,10.2-40.82,34.62V191.58c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M1086.58,190.85c0,68.52-76.53,65.61-107.14,65.61-58,0-92.94-19.32-92.94-65.61V78.24c0-46.29,34.62-65.6,92.57-65.6H994c57.59,0,92.57,19.31,92.57,65.6ZM1024.26,78.24c0-23.69-8.74-34.63-36.44-34.63h-2.55c-27.7,0-36.45,10.94-36.45,34.63V190.85c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M1304.89,190.85c0,43.74-31.34,65.61-92.57,65.61h-14.94c-61.23,0-92.57-21.87-92.57-65.61V14.46h63V190.85c0,22.24,7.65,34.26,35.72,34.26h2.55c28.06,0,35.71-12,35.71-34.26V14.46h63.05Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M1460.88,254.63,1368.31,75V254.63h-40.09V14.46H1400l89.65,177.12V14.46h39.73V254.63Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M1663.89,45.44V254.63H1601.2V45.44h-51.75v-31h166.19v31Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M1735.69,254.63V14.46h62.68V254.63Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M1961.65,254.63,1869.08,75V254.63H1829V14.46h71.79l89.66,177.12V14.46h39.73V254.63Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><path d=\"M2151.17,257.19c-48.48,0-102.78-3.28-102.78-65.61V77.87c0-62.68,59-66.69,105-66.69l81.28,5.1V42.52h-80.18c-41.19,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V114.68h62.32V251.35Z\" fill=\"#9dcc4a\" data-v-daef1bbc></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#9dcc4a\" data-v-daef1bbc></polygon>", 17)
const _hoisted_46 = [
  _hoisted_29
]

function AccountingHubvue_type_template_id_daef1bbc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_2, AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_27))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", AccountingHubvue_type_template_id_daef1bbc_scoped_true_hoisted_28, _hoisted_46))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/AccountingHub.vue?vue&type=template&id=daef1bbc&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/AccountingHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_AccountingHubvue_type_script_lang_js = ({
    name: "AccountingHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/AccountingHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/AccountingHub.vue?vue&type=style&index=0&id=daef1bbc&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/AccountingHub.vue?vue&type=style&index=0&id=daef1bbc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/AccountingHub.vue




;


const AccountingHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_AccountingHubvue_type_script_lang_js, [['render',AccountingHubvue_type_template_id_daef1bbc_scoped_true_render],['__scopeId',"data-v-daef1bbc"]])

/* harmony default export */ var Mobile_AccountingHub = (AccountingHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue?vue&type=template&id=58098fb6&scoped=true


const CopyrightHubvue_type_template_id_58098fb6_scoped_true_withScopeId = n => (_pushScopeId("data-v-58098fb6"),n=n(),_popScopeId(),n)
const CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2054.29",
  height: "267",
  viewBox: "0 0 2054.29 267"
}
const CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_2 = { key: 0 }
const CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M426,257.5c-48.1,0-102.41-5.1-102.41-65.6V78.19c0-61.23,55-66.7,102.41-66.7L484.3,16.6v27H426.71c-37.9,0-40.82,10.2-40.82,34.62V191.9c0,25.15,3.65,33.53,40.82,33.53H484.3v27Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M697.14,191.17c0,68.52-76.53,65.6-107.15,65.6-58,0-92.94-19.31-92.94-65.6V78.55c0-46.28,34.63-65.6,92.58-65.6h14.94c57.58,0,92.57,19.32,92.57,65.6ZM634.82,78.55c0-23.69-8.75-34.62-36.45-34.62h-2.55c-27.7,0-36.44,10.93-36.44,34.62V191.17c0,23.69,8.74,34.26,36.44,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M911.08,106.25c0,48.84-28.8,65.6-94.4,65.6h-39V255H715.36V14.77H818.5c60.87,0,92.58,21.51,92.58,65.24ZM849.85,80c0-22.23-7.66-34.26-36.08-34.26H777.69v95.12h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M1043.38,167.11V255H980.69V167.11C956.64,117.91,929.3,64,905.25,14.77H976l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M1203,255h-63.78V14.77h107.88c58.31,0,92.93,15.67,92.93,60.87V89.12c0,41.91-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.11c46.29,0,53.94-8,53.94-28.06V80c0-20.41-4.74-33.89-41.18-33.89H1203Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M1368.84,255V14.77h62.68V255Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M1552.52,257.5c-48.47,0-102.78-3.28-102.78-65.6V78.19c0-62.69,59-66.7,105-66.7L1636,16.6V42.84H1555.8c-41.18,0-43.73,10.93-43.73,34.25V191.9c0,24.42,3.28,34.62,40.81,34.62h31V115h62.33V251.67Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M1804.73,255V146.34h-73.62c0,36.08.36,72.53.36,108.61h-63V14.77h62.69V115h73.62V14.77h62.32V255Z\" fill=\"#fff\" data-v-58098fb6></path><path d=\"M1994.24,45.75V255h-62.68V45.75h-51.75v-31H2046v31Z\" fill=\"#fff\" data-v-58098fb6></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-58098fb6></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#e6ae24\" data-v-58098fb6></path>", 23)
const CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_26 = [
  CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_3
]
const CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_27 = { key: 1 }
const CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M426,257.5c-48.1,0-102.41-5.1-102.41-65.6V78.19c0-61.23,55-66.7,102.41-66.7L484.3,16.6v27H426.71c-37.9,0-40.82,10.2-40.82,34.62V191.9c0,25.15,3.65,33.53,40.82,33.53H484.3v27Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M697.14,191.17c0,68.52-76.53,65.6-107.15,65.6-58,0-92.94-19.31-92.94-65.6V78.55c0-46.28,34.63-65.6,92.58-65.6h14.94c57.58,0,92.57,19.32,92.57,65.6ZM634.82,78.55c0-23.69-8.75-34.62-36.45-34.62h-2.55c-27.7,0-36.44,10.93-36.44,34.62V191.17c0,23.69,8.74,34.26,36.44,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M911.08,106.25c0,48.84-28.8,65.6-94.4,65.6h-39V255H715.36V14.77H818.5c60.87,0,92.58,21.51,92.58,65.24ZM849.85,80c0-22.23-7.66-34.26-36.08-34.26H777.69v95.12h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M1043.38,167.11V255H980.69V167.11C956.64,117.91,929.3,64,905.25,14.77H976l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M1203,255h-63.78V14.77h107.88c58.31,0,92.93,15.67,92.93,60.87V89.12c0,41.91-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.11c46.29,0,53.94-8,53.94-28.06V80c0-20.41-4.74-33.89-41.18-33.89H1203Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M1368.84,255V14.77h62.68V255Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M1552.52,257.5c-48.47,0-102.78-3.28-102.78-65.6V78.19c0-62.69,59-66.7,105-66.7L1636,16.6V42.84H1555.8c-41.18,0-43.74,10.93-43.74,34.25V191.9c0,24.42,3.29,34.62,40.82,34.62h31V115h62.33V251.67Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M1804.73,255V146.34h-73.62c0,36.08.36,72.53.36,108.61h-63V14.77h62.69V115h73.62V14.77h62.32V255Z\" fill=\"#e6ae24\" data-v-58098fb6></path><path d=\"M1994.24,45.75V255h-62.68V45.75h-51.75v-31H2046v31Z\" fill=\"#e6ae24\" data-v-58098fb6></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#e6ae24\" data-v-58098fb6></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#e6ae24\" data-v-58098fb6></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#e6ae24\" data-v-58098fb6></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#e6ae24\" data-v-58098fb6></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#e6ae24\" data-v-58098fb6></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#e6ae24\" data-v-58098fb6></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#e6ae24\" data-v-58098fb6></polygon>", 16)
const _hoisted_44 = [
  CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_28
]

function CopyrightHubvue_type_template_id_58098fb6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_2, CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_26))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", CopyrightHubvue_type_template_id_58098fb6_scoped_true_hoisted_27, _hoisted_44))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue?vue&type=template&id=58098fb6&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_CopyrightHubvue_type_script_lang_js = ({
    name: "CopyrightHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue?vue&type=style&index=0&id=58098fb6&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue?vue&type=style&index=0&id=58098fb6&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/CopyrightHub.vue




;


const Mobile_CopyrightHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_CopyrightHubvue_type_script_lang_js, [['render',CopyrightHubvue_type_template_id_58098fb6_scoped_true_render],['__scopeId',"data-v-58098fb6"]])

/* harmony default export */ var Mobile_CopyrightHub = (Mobile_CopyrightHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue?vue&type=template&id=aa64676c&scoped=true


const ECompanyHubvue_type_template_id_aa64676c_scoped_true_withScopeId = n => (_pushScopeId("data-v-aa64676c"),n=n(),_popScopeId(),n)
const ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2069.6",
  height: "267",
  viewBox: "0 0 2069.6 267"
}
const ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_2 = { key: 0 }
const ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M326.56,254.32V14.14H478.17V44.76H390v69.61h69.62v31.34H390v77.63h88.2v31Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M593.34,256.87c-48.11,0-102.41-5.1-102.41-65.6V77.56c0-61.23,55-66.7,102.41-66.7L651.65,16v27H594.07c-37.9,0-40.82,10.2-40.82,34.62V191.27c0,25.15,3.65,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M857.21,190.54c0,68.52-76.54,65.6-107.15,65.6-57.95,0-92.94-19.31-92.94-65.6V77.92c0-46.28,34.62-65.6,92.57-65.6h14.95c57.58,0,92.57,19.32,92.57,65.6ZM794.89,77.92c0-23.69-8.75-34.62-36.45-34.62h-2.55c-27.7,0-36.45,10.93-36.45,34.62V190.54c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M1132.37,254.32V48.77h-14.21L1050,254.32h-49.94L930.46,48.77H917V254.32H876.52V14.14h104.6l57.95,173.12,55.76-173.12h98.41V254.32Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M1412.28,105.62c0,48.84-28.8,65.6-94.4,65.6h-39v83.1h-62.32V14.14H1319.7c60.87,0,92.58,21.51,92.58,65.24Zm-61.23-26.24c0-22.23-7.66-34.26-36.08-34.26h-36.09v95.12H1315c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M1547.13,254.32l-10.21-53.94v.73h-86v-.73l-11.3,53.94h-51.75l66.69-240.18H1549l69.61,240.18ZM1504.49,42.94h-21.14l-25.88,127.19h74Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M1761.43,254.32,1668.86,74.64V254.32h-40.09V14.14h71.79l89.66,177.13V14.14H1830V254.32Z\" fill=\"#fff\" data-v-aa64676c></path><path d=\"M1982.29,166.49v87.83H1919.6V166.49c-24-49.21-51.38-103.15-75.44-152.35h70.71l45.55,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#fff\" data-v-aa64676c></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-aa64676c></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#099192\" data-v-aa64676c></path>", 22)
const ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_25 = [
  ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_3
]
const ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_26 = { key: 1 }
const ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M326.56,254.32V14.14H478.17V44.76H390v69.61h69.62v31.34H390v77.63h88.2v31Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M593.34,256.87c-48.11,0-102.41-5.1-102.41-65.6V77.56c0-61.23,55-66.7,102.41-66.7L651.65,16v27H594.07c-37.9,0-40.82,10.2-40.82,34.62V191.27c0,25.15,3.65,33.53,40.82,33.53h57.58v27Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M857.21,190.54c0,68.52-76.54,65.6-107.15,65.6-57.95,0-92.94-19.31-92.94-65.6V77.92c0-46.28,34.62-65.6,92.57-65.6h14.95c57.58,0,92.57,19.32,92.57,65.6ZM794.89,77.92c0-23.69-8.75-34.62-36.45-34.62h-2.55c-27.7,0-36.45,10.93-36.45,34.62V190.54c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M1132.37,254.32V48.77h-14.21L1050,254.32h-49.94L930.46,48.77H917V254.32H876.52V14.14h104.6l57.95,173.12,55.76-173.12h98.41V254.32Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M1412.28,105.62c0,48.84-28.8,65.6-94.4,65.6h-39v83.1h-62.32V14.14H1319.7c60.87,0,92.58,21.51,92.58,65.24Zm-61.23-26.24c0-22.23-7.66-34.26-36.08-34.26h-36.09v95.12H1315c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M1547.13,254.32l-10.21-53.94v.73h-86v-.73l-11.3,53.94h-51.75l66.69-240.18H1549l69.61,240.18ZM1504.49,42.94h-21.14l-25.88,127.19h74Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M1761.43,254.32,1668.86,74.64V254.32h-40.09V14.14h71.79l89.66,177.13V14.14H1830V254.32Z\" fill=\"#099192\" data-v-aa64676c></path><path d=\"M1982.29,166.49v87.83H1919.6V166.49c-24-49.21-51.38-103.15-75.44-152.35h70.71l45.55,118.45c16.4-39,34.26-79.45,50.66-118.45h53.21Z\" fill=\"#099192\" data-v-aa64676c></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#099192\" data-v-aa64676c></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#099192\" data-v-aa64676c></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#099192\" data-v-aa64676c></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#099192\" data-v-aa64676c></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#099192\" data-v-aa64676c></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#099192\" data-v-aa64676c></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#099192\" data-v-aa64676c></polygon>", 15)
const _hoisted_42 = [
  ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_27
]

function ECompanyHubvue_type_template_id_aa64676c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_2, ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_25))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ECompanyHubvue_type_template_id_aa64676c_scoped_true_hoisted_26, _hoisted_42))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue?vue&type=template&id=aa64676c&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_ECompanyHubvue_type_script_lang_js = ({
    name: "ECompanyHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue?vue&type=style&index=0&id=aa64676c&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue?vue&type=style&index=0&id=aa64676c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ECompanyHub.vue




;


const Mobile_ECompanyHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_ECompanyHubvue_type_script_lang_js, [['render',ECompanyHubvue_type_template_id_aa64676c_scoped_true_render],['__scopeId',"data-v-aa64676c"]])

/* harmony default export */ var Mobile_ECompanyHub = (Mobile_ECompanyHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/EIdHub.vue?vue&type=template&id=288ff35c&scoped=true


const EIdHubvue_type_template_id_288ff35c_scoped_true_withScopeId = n => (_pushScopeId("data-v-288ff35c"),n=n(),_popScopeId(),n)
const EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "808.94",
  height: "267",
  viewBox: "0 0 808.94 267"
}
const EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_2 = { key: 0 }
const EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,255.44V15.25H477.46V45.86H389.25v69.62h69.62v31.34H389.25v77.64h88.21v31Z\" fill=\"#fff\" data-v-288ff35c></path><path d=\"M509.89,255.44V15.25h62.69V255.44Z\" fill=\"#fff\" data-v-288ff35c></path><path d=\"M802.92,189.83c0,44.47-30.62,65.61-92.58,65.61H603.19V15.25H710.34c61.23,0,92.58,21.87,92.58,65.6Zm-62.33-109c0-22.59-7.65-34.26-36.45-34.26h-39V224.46h39c29.53,0,36.45-11.3,36.45-34.63Z\" fill=\"#fff\" data-v-288ff35c></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-288ff35c></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#e83c89\" data-v-288ff35c></path>", 17)
const EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_20 = [
  EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_3
]
const EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_21 = { key: 1 }
const EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,255.44V15.25H477.46V45.86H389.25v69.62h69.62v31.34H389.25v77.64h88.21v31Z\" fill=\"#e83c89\" data-v-288ff35c></path><path d=\"M509.89,255.44V15.25h62.69V255.44Z\" fill=\"#e83c89\" data-v-288ff35c></path><path d=\"M802.92,189.83c0,44.47-30.62,65.61-92.58,65.61H603.19V15.25H710.34c61.23,0,92.58,21.87,92.58,65.6Zm-62.33-109c0-22.59-7.65-34.26-36.45-34.26h-39V224.46h39c29.53,0,36.45-11.3,36.45-34.63Z\" fill=\"#e83c89\" data-v-288ff35c></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#e83c89\" data-v-288ff35c></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#e83c89\" data-v-288ff35c></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#e83c89\" data-v-288ff35c></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#e83c89\" data-v-288ff35c></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#e83c89\" data-v-288ff35c></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#e83c89\" data-v-288ff35c></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#e83c89\" data-v-288ff35c></polygon>", 10)
const _hoisted_32 = [
  EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_22
]

function EIdHubvue_type_template_id_288ff35c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_2, EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_20))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", EIdHubvue_type_template_id_288ff35c_scoped_true_hoisted_21, _hoisted_32))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/EIdHub.vue?vue&type=template&id=288ff35c&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/EIdHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_EIdHubvue_type_script_lang_js = ({
    name: "EIdHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/EIdHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/EIdHub.vue?vue&type=style&index=0&id=288ff35c&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/EIdHub.vue?vue&type=style&index=0&id=288ff35c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/EIdHub.vue




;


const Mobile_EIdHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_EIdHubvue_type_script_lang_js, [['render',EIdHubvue_type_template_id_288ff35c_scoped_true_render],['__scopeId',"data-v-288ff35c"]])

/* harmony default export */ var Mobile_EIdHub = (Mobile_EIdHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ExciseHub.vue?vue&type=template&id=38b3b144&scoped=true


const ExciseHubvue_type_template_id_38b3b144_scoped_true_withScopeId = n => (_pushScopeId("data-v-38b3b144"),n=n(),_popScopeId(),n)
const ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1307.51",
  height: "267",
  viewBox: "0 0 1307.51 267"
}
const ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_2 = { key: 0 }
const ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M326.56,254.16V14H478.17V44.6H390v69.61h69.62v31.34H390v77.63h88.2v31Z\" fill=\"#fff\" data-v-38b3b144></path><path d=\"M641.08,254.16,599.17,147.74H580.59L539,254.16H484.73l62-128.29C529.2,90.16,508.42,49.34,490.93,14h70l34.26,86.37h20.41C626.14,71.93,637.44,42.78,648,14h51.75L650.2,125.87c19.68,41.91,41.54,86.38,61.22,128.29Z\" fill=\"#fff\" data-v-38b3b144></path><path d=\"M810.19,256.71c-48.1,0-102.41-5.1-102.41-65.6V77.4c0-61.23,55-66.7,102.41-66.7l58.32,5.11v27H810.92C773,42.78,770.1,53,770.1,77.4V191.11c0,25.15,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#fff\" data-v-38b3b144></path><path d=\"M886.37,254.16V14h62.68V254.16Z\" fill=\"#fff\" data-v-38b3b144></path><path d=\"M1137.47,188.56c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.37h63.06c40.81,0,43-15.31,43-34.26V177.26l-103.5-63.78c-2.56-6.92-6.2-17.13-6.2-29.52C962.17,39.5,987,10.7,1054,10.7l72.16,5.84V42.41h-45.92c-46.28,0-50.66,13.85-50.66,35.35V88l99.87,62c4,8,8,21.5,8,33.16Z\" fill=\"#fff\" data-v-38b3b144></path><path d=\"M1150.6,254.16V14h151.61V44.6H1214v69.61h69.61v31.34H1214v77.63h88.2v31Z\" fill=\"#fff\" data-v-38b3b144></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-38b3b144></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#38d2dd\" data-v-38b3b144></path>", 20)
const _hoisted_23 = [
  ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_3
]
const _hoisted_24 = { key: 1 }
const ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M326.56,254.16V14H478.17V44.6H390v69.61h69.62v31.34H390v77.63h88.2v31Z\" fill=\"#38d2dd\" data-v-38b3b144></path><path d=\"M641.08,254.16,599.17,147.74H580.59L539,254.16H484.73l62-128.29C529.2,90.16,508.42,49.34,490.93,14h70l34.26,86.37h20.41C626.14,71.93,637.44,42.78,648,14h51.75L650.2,125.87c19.68,41.91,41.54,86.38,61.22,128.29Z\" fill=\"#38d2dd\" data-v-38b3b144></path><path d=\"M810.19,256.71c-48.1,0-102.41-5.1-102.41-65.6V77.4c0-61.23,55-66.7,102.41-66.7l58.32,5.11v27H810.92C773,42.78,770.1,53,770.1,77.4V191.11c0,25.15,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#38d2dd\" data-v-38b3b144></path><path d=\"M886.37,254.16V14h62.68V254.16Z\" fill=\"#38d2dd\" data-v-38b3b144></path><path d=\"M1137.47,188.56c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.37h63.06c40.81,0,43-15.31,43-34.26V177.26l-103.5-63.78c-2.56-6.92-6.2-17.13-6.2-29.52C962.17,39.5,987,10.7,1054,10.7l72.16,5.84V42.41h-45.92c-46.28,0-50.66,13.85-50.66,35.35V88l99.87,62c4,8,8,21.5,8,33.16Z\" fill=\"#38d2dd\" data-v-38b3b144></path><path d=\"M1150.6,254.16V14h151.61V44.6H1214v69.61h69.61v31.34H1214v77.63h88.2v31Z\" fill=\"#38d2dd\" data-v-38b3b144></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#38d2dd\" data-v-38b3b144></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#38d2dd\" data-v-38b3b144></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#38d2dd\" data-v-38b3b144></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#38d2dd\" data-v-38b3b144></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#38d2dd\" data-v-38b3b144></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#38d2dd\" data-v-38b3b144></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#38d2dd\" data-v-38b3b144></polygon>", 13)
const _hoisted_38 = [
  ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_25
]

function ExciseHubvue_type_template_id_38b3b144_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ExciseHubvue_type_template_id_38b3b144_scoped_true_hoisted_2, _hoisted_23))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_24, _hoisted_38))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExciseHub.vue?vue&type=template&id=38b3b144&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ExciseHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_ExciseHubvue_type_script_lang_js = ({
    name: "ExciseHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExciseHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ExciseHub.vue?vue&type=style&index=0&id=38b3b144&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExciseHub.vue?vue&type=style&index=0&id=38b3b144&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExciseHub.vue




;


const Mobile_ExciseHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_ExciseHubvue_type_script_lang_js, [['render',ExciseHubvue_type_template_id_38b3b144_scoped_true_render],['__scopeId',"data-v-38b3b144"]])

/* harmony default export */ var Mobile_ExciseHub = (Mobile_ExciseHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ExpertHub.vue?vue&type=template&id=9986161c&scoped=true


const ExpertHubvue_type_template_id_9986161c_scoped_true_withScopeId = n => (_pushScopeId("data-v-9986161c"),n=n(),_popScopeId(),n)
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1531.66",
  height: "267",
  viewBox: "0 0 1531.66 267"
}
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_2 = { key: 0 }
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,255.42V15.24H477.45V45.86h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#fff\" data-v-9986161c></path><path d=\"M654.94,255.42,613,149H594.44L552.89,255.42h-54.3l62-128.29c-17.5-35.71-38.27-76.53-55.77-111.89h70L609,101.62h20.41C640,73.19,651.29,44,661.86,15.24h51.76L664.05,127.13c19.68,41.91,41.55,86.38,61.23,128.29Z\" fill=\"#fff\" data-v-9986161c></path><path d=\"M939.94,106.72c0,48.84-28.79,65.6-94.39,65.6h-39v83.1H744.23V15.24H847.37c60.87,0,92.57,21.51,92.57,65.24ZM878.72,80.48c0-22.23-7.66-34.26-36.09-34.26H806.55v95.13h36.08c28.8,0,36.09-11.67,36.09-34.63Z\" fill=\"#fff\" data-v-9986161c></path><path d=\"M965.09,255.42V15.24h151.62V45.86h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-9986161c></path><path d=\"M1212.92,255.42h-63.78V15.24H1257c58.32,0,92.94,15.68,92.94,60.87V89.59c0,41.92-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.58c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#fff\" data-v-9986161c></path><path d=\"M1473.88,46.22v209.2h-62.69V46.22h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-9986161c></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-9986161c></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#e83158\" data-v-9986161c></path>", 20)
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_23 = [
  ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_3
]
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_24 = { key: 1 }
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,255.42V15.24H477.45V45.86h-88.2v69.61h69.61v31.34H389.25v77.63h88.2v31Z\" fill=\"#e83158\" data-v-9986161c></path><path d=\"M654.94,255.42,613,149H594.44L552.89,255.42h-54.3l62-128.29c-17.5-35.71-38.27-76.53-55.77-111.89h70L609,101.62h20.41C640,73.19,651.29,44,661.86,15.24h51.76L664.05,127.13c19.68,41.91,41.55,86.38,61.23,128.29Z\" fill=\"#e83158\" data-v-9986161c></path><path d=\"M939.94,106.72c0,48.84-28.79,65.6-94.39,65.6h-39v83.1H744.23V15.24H847.37c60.87,0,92.57,21.51,92.57,65.24ZM878.72,80.48c0-22.23-7.66-34.26-36.09-34.26H806.55v95.13h36.08c28.8,0,36.09-11.67,36.09-34.63Z\" fill=\"#e83158\" data-v-9986161c></path><path d=\"M965.09,255.42V15.24h151.62V45.86h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#e83158\" data-v-9986161c></path><path d=\"M1212.92,255.42h-63.78V15.24H1257c58.32,0,92.94,15.68,92.94,60.87V89.59c0,41.92-14.94,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.71,105h-78l-59-109.7V124.58c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#e83158\" data-v-9986161c></path><path d=\"M1473.88,46.22v209.2h-62.69V46.22h-51.75v-31h166.19v31Z\" fill=\"#e83158\" data-v-9986161c></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#e83158\" data-v-9986161c></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#e83158\" data-v-9986161c></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#e83158\" data-v-9986161c></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#e83158\" data-v-9986161c></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#e83158\" data-v-9986161c></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#e83158\" data-v-9986161c></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#e83158\" data-v-9986161c></polygon>", 13)
const ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_38 = [
  ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_25
]

function ExpertHubvue_type_template_id_9986161c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_2, ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_23))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_24, ExpertHubvue_type_template_id_9986161c_scoped_true_hoisted_38))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExpertHub.vue?vue&type=template&id=9986161c&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ExpertHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_ExpertHubvue_type_script_lang_js = ({
    name: "ExpertHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExpertHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ExpertHub.vue?vue&type=style&index=0&id=9986161c&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExpertHub.vue?vue&type=style&index=0&id=9986161c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ExpertHub.vue




;


const Mobile_ExpertHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_ExpertHubvue_type_script_lang_js, [['render',ExpertHubvue_type_template_id_9986161c_scoped_true_render],['__scopeId',"data-v-9986161c"]])

/* harmony default export */ var Mobile_ExpertHub = (Mobile_ExpertHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/FinanceHub.vue?vue&type=template&id=9b67b340&scoped=true


const FinanceHubvue_type_template_id_9b67b340_scoped_true_withScopeId = n => (_pushScopeId("data-v-9b67b340"),n=n(),_popScopeId(),n)
const FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1591.79",
  height: "267",
  viewBox: "0 0 1591.79 267"
}
const FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_2 = { key: 0 }
const FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M388.16,44.39v69.25H456V145H388.16V253.59H325.84V13.41H473.08v31Z\" fill=\"#fff\" data-v-9b67b340></path><path d=\"M493.49,253.59V13.41h62.68V253.59Z\" fill=\"#fff\" data-v-9b67b340></path><path d=\"M712.16,253.59,619.59,73.91V253.59H579.5V13.41h71.79L741,190.54V13.41h39.73V253.59Z\" fill=\"#fff\" data-v-9b67b340></path><path d=\"M954.52,253.59l-10.2-53.94v.73h-86v-.73L847,253.59H795.26L862,13.41h94.4L1026,253.59ZM911.88,42.2H890.75L864.87,169.4h74Z\" fill=\"#fff\" data-v-9b67b340></path><path d=\"M1168.83,253.59,1076.26,73.91V253.59h-40.09V13.41H1108l89.66,177.13V13.41h39.73V253.59Z\" fill=\"#fff\" data-v-9b67b340></path><path d=\"M1358,256.14c-48.11,0-102.41-5.1-102.41-65.6V76.83c0-61.23,55-66.7,102.41-66.7l58.32,5.1v27h-57.59c-37.9,0-40.82,10.21-40.82,34.63V190.54c0,25.14,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#fff\" data-v-9b67b340></path><path d=\"M1434.15,253.59V13.41h151.62V44h-88.2v69.61h69.61V145h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-9b67b340></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-9b67b340></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#136389\" data-v-9b67b340></path>", 21)
const FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_24 = [
  FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_3
]
const FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_25 = { key: 1 }
const FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M388.16,44.39v69.25H456V145H388.16V253.59H325.84V13.41H473.08v31Z\" fill=\"#136389\" data-v-9b67b340></path><path d=\"M493.49,253.59V13.41h62.68V253.59Z\" fill=\"#136389\" data-v-9b67b340></path><path d=\"M712.16,253.59,619.59,73.91V253.59H579.5V13.41h71.79L741,190.54V13.41h39.73V253.59Z\" fill=\"#136389\" data-v-9b67b340></path><path d=\"M954.52,253.59l-10.2-53.94v.73h-86v-.73L847,253.59H795.26L862,13.41h94.4L1026,253.59ZM911.88,42.2H890.75L864.87,169.4h74Z\" fill=\"#136389\" data-v-9b67b340></path><path d=\"M1168.83,253.59,1076.26,73.91V253.59h-40.09V13.41H1108l89.66,177.13V13.41h39.73V253.59Z\" fill=\"#136389\" data-v-9b67b340></path><path d=\"M1358,256.14c-48.11,0-102.41-5.1-102.41-65.6V76.83c0-61.23,55-66.7,102.41-66.7l58.32,5.1v27h-57.59c-37.9,0-40.82,10.21-40.82,34.63V190.54c0,25.14,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#136389\" data-v-9b67b340></path><path d=\"M1434.15,253.59V13.41h151.62V44h-88.2v69.61h69.61V145h-69.61v77.63h88.2v31Z\" fill=\"#136389\" data-v-9b67b340></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#136389\" data-v-9b67b340></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#136389\" data-v-9b67b340></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#136389\" data-v-9b67b340></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#136389\" data-v-9b67b340></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#136389\" data-v-9b67b340></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#136389\" data-v-9b67b340></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#136389\" data-v-9b67b340></polygon>", 14)
const _hoisted_40 = [
  FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_26
]

function FinanceHubvue_type_template_id_9b67b340_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_2, FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_24))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", FinanceHubvue_type_template_id_9b67b340_scoped_true_hoisted_25, _hoisted_40))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/FinanceHub.vue?vue&type=template&id=9b67b340&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/FinanceHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_FinanceHubvue_type_script_lang_js = ({
    name: "FinanceHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/FinanceHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/FinanceHub.vue?vue&type=style&index=0&id=9b67b340&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/FinanceHub.vue?vue&type=style&index=0&id=9b67b340&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/FinanceHub.vue




;


const Mobile_FinanceHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_FinanceHubvue_type_script_lang_js, [['render',FinanceHubvue_type_template_id_9b67b340_scoped_true_render],['__scopeId',"data-v-9b67b340"]])

/* harmony default export */ var Mobile_FinanceHub = (Mobile_FinanceHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue?vue&type=template&id=0a2d8cae&scoped=true


const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_withScopeId = n => (_pushScopeId("data-v-0a2d8cae"),n=n(),_popScopeId(),n)
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1927.1",
  height: "267",
  viewBox: "0 0 1927.1 267"
}
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_2 = { key: 0 }
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,254V13.83h62.68V254Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M544.51,254,451.94,74.33V254H411.85V13.83h71.79L573.3,191V13.83H613V254Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M740.22,44.81V254H677.54V44.81H625.78v-31H792v31Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M868.51,254H804.73V13.83H912.61c58.31,0,92.94,15.67,92.94,60.86V88.18c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V123.16c46.29,0,53.94-8,53.94-28.06v-16c0-20.4-4.74-33.89-41.18-33.89H868.51Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M1177.57,254l-10.2-53.94v.73h-86v-.73L1070.06,254h-51.75L1085,13.83h94.4L1249,254ZM1134.93,42.62h-21.14l-25.87,127.19h74Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M1424.31,188.4c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.21h63c40.82,0,43-15.31,43-34.26V177.1L1255.2,113.32c-2.55-6.92-6.19-17.13-6.19-29.52,0-44.46,24.78-73.25,91.84-73.25L1413,16.38V42.25h-45.92c-46.28,0-50.66,13.85-50.66,35.36v10.2l99.86,62c4,8,8,21.5,8,33.17Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M1543.13,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M1726.09,254l-10.21-53.94v.73h-86v-.73L1618.57,254h-51.75l66.69-240.17h94.4L1797.52,254ZM1683.44,42.62h-21.13l-25.88,127.19h74Z\" fill=\"#fff\" data-v-0a2d8cae></path><path d=\"M1883.9,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-0a2d8cae></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-0a2d8cae></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#65adc1\" data-v-0a2d8cae></path>", 23)
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_26 = [
  IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_3
]
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_27 = { key: 1 }
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,254V13.83h62.68V254Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M544.51,254,451.94,74.33V254H411.85V13.83h71.79L573.3,191V13.83H613V254Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M740.22,44.81V254H677.54V44.81H625.78v-31H792v31Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M868.51,254H804.73V13.83H912.61c58.31,0,92.94,15.67,92.94,60.86V88.18c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V123.16c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.9-41.18-33.9H868.51Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M1177.57,254l-10.2-53.94v.73h-86v-.73L1070.06,254h-51.75L1085,13.83h94.4L1249,254ZM1134.93,42.62h-21.14l-25.87,127.19h74Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M1424.31,188.4c0,44.1-30.61,67.79-91.11,67.79l-80.55-5.1V225.21h63c40.82,0,43-15.3,43-34.26V177.1L1255.2,113.32c-2.55-6.92-6.19-17.13-6.19-29.52,0-44.46,24.78-73.25,91.84-73.25L1413,16.38V42.25h-45.92c-46.28,0-50.66,13.85-50.66,35.36v10.2l99.86,62c4,8,8,21.5,8,33.17Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M1543.13,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M1726.09,254l-10.21-53.94v.73h-86v-.73L1618.57,254h-51.75l66.69-240.17h94.4L1797.52,254ZM1683.44,42.62h-21.13l-25.88,127.19h74Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><path d=\"M1883.9,44.81V254h-62.69V44.81h-51.75v-31h166.19v31Z\" fill=\"#65adc1\" data-v-0a2d8cae></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#65adc1\" data-v-0a2d8cae></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#65adc1\" data-v-0a2d8cae></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#65adc1\" data-v-0a2d8cae></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#65adc1\" data-v-0a2d8cae></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#65adc1\" data-v-0a2d8cae></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#65adc1\" data-v-0a2d8cae></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#65adc1\" data-v-0a2d8cae></polygon>", 16)
const IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_44 = [
  IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_28
]

function IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_2, IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_26))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_27, IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_hoisted_44))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue?vue&type=template&id=0a2d8cae&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_IntrastatHubvue_type_script_lang_js = ({
    name: "IntrastatHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue?vue&type=style&index=0&id=0a2d8cae&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue?vue&type=style&index=0&id=0a2d8cae&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/IntrastatHub.vue




;


const Mobile_IntrastatHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_IntrastatHubvue_type_script_lang_js, [['render',IntrastatHubvue_type_template_id_0a2d8cae_scoped_true_render],['__scopeId',"data-v-0a2d8cae"]])

/* harmony default export */ var Mobile_IntrastatHub = (Mobile_IntrastatHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue?vue&type=template&id=ddc3df86&scoped=true


const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_withScopeId = n => (_pushScopeId("data-v-ddc3df86"),n=n(),_popScopeId(),n)
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1484.27",
  height: "267",
  viewBox: "0 0 1484.27 267"
}
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_2 = { key: 0 }
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,253.53V13.35h62.68V253.53Z\" fill=\"#fff\" data-v-ddc3df86></path><path d=\"M544.51,253.53,451.94,73.85V253.53H411.85V13.35h71.79L573.3,190.48V13.35H613V253.53Z\" fill=\"#fff\" data-v-ddc3df86></path><path d=\"M785.78,253.53H690.29L627.61,13.35h65.6L739.86,214.9h17.49L799.26,13.35h52.12Z\" fill=\"#fff\" data-v-ddc3df86></path><path d=\"M1056.2,189.75c0,68.52-76.53,65.6-107.15,65.6-57.94,0-92.93-19.31-92.93-65.6V77.13c0-46.28,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.32,92.57,65.6ZM993.88,77.13c0-23.69-8.74-34.62-36.44-34.62h-2.55c-27.7,0-36.45,10.93-36.45,34.62V189.75c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-ddc3df86></path><path d=\"M1081.72,253.53V13.35h62.68V253.53Z\" fill=\"#fff\" data-v-ddc3df86></path><path d=\"M1272.32,256.08c-48.1,0-102.41-5.1-102.41-65.6V76.77c0-61.23,55-66.7,102.41-66.7l58.32,5.11v27h-57.59c-37.9,0-40.82,10.2-40.82,34.62V190.48c0,25.15,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#fff\" data-v-ddc3df86></path><path d=\"M1348.5,253.53V13.35h151.61V44h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-ddc3df86></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-ddc3df86></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#8b85db\" data-v-ddc3df86></path>", 21)
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_24 = [
  InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_3
]
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_25 = { key: 1 }
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M325.84,253.53V13.35h62.68V253.53Z\" fill=\"#8b85db\" data-v-ddc3df86></path><path d=\"M544.51,253.53,451.94,73.85V253.53H411.85V13.35h71.79L573.3,190.48V13.35H613V253.53Z\" fill=\"#8b85db\" data-v-ddc3df86></path><path d=\"M785.78,253.53H690.29L627.61,13.35h65.6L739.86,214.9h17.49L799.26,13.35h52.12Z\" fill=\"#8b85db\" data-v-ddc3df86></path><path d=\"M1056.2,189.75c0,68.52-76.53,65.6-107.15,65.6-57.94,0-92.93-19.31-92.93-65.6V77.13c0-46.28,34.62-65.6,92.57-65.6h14.94c57.59,0,92.57,19.32,92.57,65.6ZM993.88,77.13c0-23.69-8.74-34.62-36.44-34.62h-2.55c-27.7,0-36.45,10.93-36.45,34.62V189.75c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#8b85db\" data-v-ddc3df86></path><path d=\"M1081.72,253.53V13.35h62.68V253.53Z\" fill=\"#8b85db\" data-v-ddc3df86></path><path d=\"M1272.32,256.08c-48.1,0-102.41-5.1-102.41-65.6V76.77c0-61.23,55-66.7,102.41-66.7l58.32,5.11v27h-57.59c-37.9,0-40.82,10.2-40.82,34.62V190.48c0,25.15,3.65,33.53,40.82,33.53h57.59v27Z\" fill=\"#8b85db\" data-v-ddc3df86></path><path d=\"M1348.5,253.53V13.35h151.61V44h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#8b85db\" data-v-ddc3df86></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#8b85db\" data-v-ddc3df86></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#8b85db\" data-v-ddc3df86></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#8b85db\" data-v-ddc3df86></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#8b85db\" data-v-ddc3df86></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#8b85db\" data-v-ddc3df86></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#8b85db\" data-v-ddc3df86></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#8b85db\" data-v-ddc3df86></polygon>", 14)
const InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_40 = [
  InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_26
]

function InvoiceHubvue_type_template_id_ddc3df86_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_2, InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_24))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_25, InvoiceHubvue_type_template_id_ddc3df86_scoped_true_hoisted_40))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue?vue&type=template&id=ddc3df86&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_InvoiceHubvue_type_script_lang_js = ({
    name: "InvoiceHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue?vue&type=style&index=0&id=ddc3df86&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue?vue&type=style&index=0&id=ddc3df86&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/InvoiceHub.vue




;


const Mobile_InvoiceHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_InvoiceHubvue_type_script_lang_js, [['render',InvoiceHubvue_type_template_id_ddc3df86_scoped_true_render],['__scopeId',"data-v-ddc3df86"]])

/* harmony default export */ var Mobile_InvoiceHub = (Mobile_InvoiceHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/MergerHub.vue?vue&type=template&id=3fd58334&scoped=true


const MergerHubvue_type_template_id_3fd58334_scoped_true_withScopeId = n => (_pushScopeId("data-v-3fd58334"),n=n(),_popScopeId(),n)
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1662.86",
  height: "267",
  viewBox: "0 0 1662.86 267"
}
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_2 = { key: 0 }
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M581.36,255.26V49.71H567.14L499,255.26H449.06L379.45,49.71H366V255.26H325.51V15.09h104.6L488.05,188.2,543.82,15.09h98.4V255.26Z\" fill=\"#fff\" data-v-3fd58334></path><path d=\"M665.55,255.26V15.09H817.16V45.7H729v69.61h69.61v31.35H729v77.62h88.2v31Z\" fill=\"#fff\" data-v-3fd58334></path><path d=\"M898.8,255.26H835V15.09H942.9c58.31,0,92.93,15.67,92.93,60.86V89.44c0,41.91-14.94,60.5-55.39,60.86,19.68,29.52,48.83,73.26,70.7,105h-78l-59-109.7V124.42c46.28,0,53.93-8,53.93-28.06v-16c0-20.4-4.73-33.89-41.18-33.89H898.8Z\" fill=\"#fff\" data-v-3fd58334></path><path d=\"M1155,257.82c-48.47,0-102.77-3.29-102.77-65.61V78.5c0-62.68,59-66.69,105-66.69l81.27,5.1V43.15h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V115.31h62.32V252Z\" fill=\"#fff\" data-v-3fd58334></path><path d=\"M1270.91,255.26V15.09h151.62V45.7h-88.2v69.61h69.61v31.35h-69.61v77.62h88.2v31Z\" fill=\"#fff\" data-v-3fd58334></path><path d=\"M1504.16,255.26h-63.77V15.09h107.87c58.32,0,92.94,15.67,92.94,60.86V89.44c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V124.42c46.29,0,53.94-8,53.94-28.06v-16c0-20.4-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#fff\" data-v-3fd58334></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-3fd58334></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#b81d58\" data-v-3fd58334></path>", 20)
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_23 = [
  MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_3
]
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_24 = { key: 1 }
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M581.36,255.26V49.71H567.14L499,255.26H449.06L379.45,49.71H366V255.26H325.51V15.09h104.6L488.05,188.2,543.82,15.09h98.4V255.26Z\" fill=\"#b81d58\" data-v-3fd58334></path><path d=\"M665.55,255.26V15.09H817.16V45.7H729v69.61h69.61v31.35H729v77.62h88.2v31Z\" fill=\"#b81d58\" data-v-3fd58334></path><path d=\"M898.8,255.26H835V15.09H942.9c58.31,0,92.93,15.67,92.93,60.86V89.44c0,41.91-14.94,60.5-55.39,60.86,19.68,29.52,48.83,73.26,70.7,105h-78l-59-109.7V124.42c46.28,0,53.93-8,53.93-28.06v-16c0-20.4-4.73-33.89-41.18-33.89H898.8Z\" fill=\"#b81d58\" data-v-3fd58334></path><path d=\"M1155,257.82c-48.47,0-102.77-3.29-102.77-65.61V78.5c0-62.68,59-66.69,105-66.69l81.27,5.1V43.15h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V115.31h62.32V252Z\" fill=\"#b81d58\" data-v-3fd58334></path><path d=\"M1270.91,255.26V15.09h151.62V45.7h-88.2v69.61h69.61v31.35h-69.61v77.62h88.2v31Z\" fill=\"#b81d58\" data-v-3fd58334></path><path d=\"M1504.16,255.26h-63.77V15.09h107.87c58.32,0,92.94,15.67,92.94,60.86V89.44c0,41.91-14.94,60.5-55.4,60.86,19.68,29.52,48.84,73.26,70.71,105h-78l-59-109.7V124.42c46.29,0,53.94-8,53.94-28.06v-16c0-20.4-4.74-33.89-41.18-33.89h-28.07Z\" fill=\"#b81d58\" data-v-3fd58334></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#b81d58\" data-v-3fd58334></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#b81d58\" data-v-3fd58334></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#b81d58\" data-v-3fd58334></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#b81d58\" data-v-3fd58334></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#b81d58\" data-v-3fd58334></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#b81d58\" data-v-3fd58334></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#b81d58\" data-v-3fd58334></polygon>", 13)
const MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_38 = [
  MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_25
]

function MergerHubvue_type_template_id_3fd58334_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_2, MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_23))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_24, MergerHubvue_type_template_id_3fd58334_scoped_true_hoisted_38))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/MergerHub.vue?vue&type=template&id=3fd58334&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/MergerHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_MergerHubvue_type_script_lang_js = ({
    name: "MergerHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/MergerHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/MergerHub.vue?vue&type=style&index=0&id=3fd58334&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/MergerHub.vue?vue&type=style&index=0&id=3fd58334&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/MergerHub.vue




;


const Mobile_MergerHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_MergerHubvue_type_script_lang_js, [['render',MergerHubvue_type_template_id_3fd58334_scoped_true_render],['__scopeId',"data-v-3fd58334"]])

/* harmony default export */ var Mobile_MergerHub = (Mobile_MergerHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/PackagingHub.vue?vue&type=template&id=31ba1933&scoped=true


const PackagingHubvue_type_template_id_31ba1933_scoped_true_withScopeId = n => (_pushScopeId("data-v-31ba1933"),n=n(),_popScopeId(),n)
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2081.99",
  height: "267",
  viewBox: "0 0 2081.99 267"
}
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_2 = { key: 0 }
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M521.55,104.68c0,48.83-28.79,65.6-94.4,65.6h-39v83.09H325.84V13.2H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,78.44c0-22.24-7.65-34.26-36.08-34.26H388.16V139.3h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M656.4,253.37l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,13.2h94.39l69.61,240.17ZM613.76,42H592.62L566.74,169.18h74Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M828.06,255.93c-48.11,0-102.41-5.11-102.41-65.61V76.61c0-61.23,55-66.69,102.41-66.69L886.37,15V42H828.79C790.88,42,788,52.19,788,76.61V190.32c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M966.55,253.37H904.23V13.2h62.32Zm65.24-141,90.39,141h-71.8L980,136V116L1058,13.2h64.87Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M1286.18,253.37,1276,199.43v.73h-86v-.73l-11.3,53.94h-51.75L1193.61,13.2H1288l69.61,240.17ZM1243.54,42H1222.4l-25.87,127.19h74Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M1458.21,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V113.42h62.32V250.09Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M1581.4,253.37V13.2h62.69V253.37Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M1807.36,253.37,1714.79,73.7V253.37H1674.7V13.2h71.8l89.65,177.12V13.2h39.73V253.37Z\" fill=\"#fff\" data-v-31ba1933></path><path d=\"M1996.88,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59.05-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.81,34.63h31V113.42h62.33V250.09Z\" fill=\"#fff\" data-v-31ba1933></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-31ba1933></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#c78ad6\" data-v-31ba1933></path>", 23)
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_26 = [
  PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_3
]
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_27 = { key: 1 }
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M521.55,104.68c0,48.83-28.79,65.6-94.4,65.6h-39v83.09H325.84V13.2H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,78.44c0-22.24-7.65-34.26-36.08-34.26H388.16V139.3h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M656.4,253.37l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,13.2h94.39l69.61,240.17ZM613.76,42H592.62L566.74,169.18h74Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M828.06,255.93c-48.11,0-102.41-5.11-102.41-65.61V76.61c0-61.23,55-66.69,102.41-66.69L886.37,15V42H828.79C790.88,42,788,52.19,788,76.61V190.32c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M966.55,253.37H904.23V13.2h62.32Zm65.24-141,90.39,141h-71.8L980,136V116L1058,13.2h64.87Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M1286.18,253.37,1276,199.43v.73h-86v-.73l-11.3,53.94h-51.75L1193.61,13.2H1288l69.61,240.17ZM1243.54,42H1222.4l-25.87,127.19h74Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M1458.21,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.74,10.93-43.74,34.26v114.8c0,24.42,3.28,34.63,40.82,34.63h31V113.42h62.32V250.09Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M1581.4,253.37V13.2h62.69V253.37Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M1807.36,253.37,1714.79,73.7V253.37H1674.7V13.2h71.8l89.65,177.12V13.2h39.73V253.37Z\" fill=\"#c78ad6\" data-v-31ba1933></path><path d=\"M1996.88,255.93c-48.47,0-102.78-3.28-102.78-65.61V76.61c0-62.68,59.05-66.69,105-66.69l81.27,5.1V41.26h-80.18c-41.18,0-43.73,10.93-43.73,34.26v114.8c0,24.42,3.28,34.63,40.81,34.63h31V113.42h62.33V250.09Z\" fill=\"#c78ad6\" data-v-31ba1933></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#c78ad6\" data-v-31ba1933></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#c78ad6\" data-v-31ba1933></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#c78ad6\" data-v-31ba1933></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#c78ad6\" data-v-31ba1933></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#c78ad6\" data-v-31ba1933></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#c78ad6\" data-v-31ba1933></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#c78ad6\" data-v-31ba1933></polygon>", 16)
const PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_44 = [
  PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_28
]

function PackagingHubvue_type_template_id_31ba1933_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_2, PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_26))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_27, PackagingHubvue_type_template_id_31ba1933_scoped_true_hoisted_44))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PackagingHub.vue?vue&type=template&id=31ba1933&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/PackagingHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_PackagingHubvue_type_script_lang_js = ({
    name: "PackagingHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PackagingHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/PackagingHub.vue?vue&type=style&index=0&id=31ba1933&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PackagingHub.vue?vue&type=style&index=0&id=31ba1933&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PackagingHub.vue




;


const Mobile_PackagingHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_PackagingHubvue_type_script_lang_js, [['render',PackagingHubvue_type_template_id_31ba1933_scoped_true_render],['__scopeId',"data-v-31ba1933"]])

/* harmony default export */ var Mobile_PackagingHub = (Mobile_PackagingHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/PaymentHub.vue?vue&type=template&id=6d9429cc&scoped=true


const PaymentHubvue_type_template_id_6d9429cc_scoped_true_withScopeId = n => (_pushScopeId("data-v-6d9429cc"),n=n(),_popScopeId(),n)
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1983.58",
  height: "267",
  viewBox: "0 0 1983.58 267"
}
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_2 = { key: 0 }
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M521.55,105.78c0,48.84-28.79,65.6-94.4,65.6h-39v83.1H325.84V14.3H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,79.54c0-22.23-7.65-34.26-36.08-34.26H388.16V140.4h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M656.4,254.48l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,14.3h94.39l69.61,240.18ZM613.76,43.09H592.62l-25.88,127.2h74Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M819,166.64v87.84H756.26V166.64c-24-49.2-51.39-103.14-75.44-152.34h70.7l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45H901Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M1164.45,254.48V48.92h-14.22l-68.15,205.56h-49.93L962.54,48.92H949.06V254.48H908.6V14.3h104.6l58,173.12L1126.91,14.3h98.4V254.48Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M1248.64,254.48V14.3h151.61V44.91h-88.2v69.62h69.62v31.34h-69.62V223.5h88.2v31Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M1550.77,254.48,1458.2,74.8V254.48h-40.09V14.3h71.8l89.66,177.13V14.3h39.72V254.48Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M1753.78,45.28v209.2h-62.69V45.28h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-6d9429cc></path><path d=\"M1977.55,188.87c0,44.1-30.61,67.79-91.11,67.79l-80.54-5.1V225.68h63c40.82,0,43-15.3,43-34.25V177.58l-103.5-63.78c-2.55-6.93-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.84-73.26l72.17,5.83V42.73h-45.93c-46.28,0-50.66,13.85-50.66,35.35v10.2l99.87,62c4,8,8,21.5,8,33.17Z\" fill=\"#fff\" data-v-6d9429cc></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-6d9429cc></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#00bd8e\" data-v-6d9429cc></path>", 22)
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_25 = [
  PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_3
]
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_26 = { key: 1 }
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M521.55,105.78c0,48.84-28.79,65.6-94.4,65.6h-39v83.1H325.84V14.3H429c60.86,0,92.57,21.5,92.57,65.24ZM460.32,79.54c0-22.23-7.65-34.26-36.08-34.26H388.16V140.4h36.08c28.79,0,36.08-11.66,36.08-34.62Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M656.4,254.48l-10.21-53.94v.73h-86v-.73l-11.3,53.94H497.13L563.83,14.3h94.39l69.61,240.18ZM613.76,43.09H592.62l-25.88,127.2h74Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M819,166.64v87.84H756.26V166.64c-24-49.2-51.39-103.14-75.44-152.34h70.7l45.56,118.45c16.4-39,34.26-79.45,50.66-118.45H901Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M1164.45,254.48V48.92h-14.22l-68.15,205.56h-49.93L962.54,48.92H949.06V254.48H908.6V14.3h104.6l58,173.12L1126.91,14.3h98.4V254.48Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M1248.64,254.48V14.3h151.61V44.91h-88.2v69.62h69.62v31.34h-69.62V223.5h88.2v31Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M1550.77,254.48,1458.2,74.8V254.48h-40.09V14.3h71.8l89.65,177.13V14.3h39.73V254.48Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M1753.78,45.28v209.2h-62.69V45.28h-51.75v-31h166.19v31Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><path d=\"M1977.55,188.87c0,44.1-30.61,67.79-91.11,67.79l-80.54-5.1V225.68h63c40.82,0,43-15.3,43-34.25V177.58l-103.5-63.78c-2.55-6.93-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.84-73.26l72.17,5.83V42.73h-45.93c-46.28,0-50.66,13.85-50.66,35.35v10.2l99.87,62c4,8,8,21.5,8,33.17Z\" fill=\"#00bd8e\" data-v-6d9429cc></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#00bd8e\" data-v-6d9429cc></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#00bd8e\" data-v-6d9429cc></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#00bd8e\" data-v-6d9429cc></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#00bd8e\" data-v-6d9429cc></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#00bd8e\" data-v-6d9429cc></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#00bd8e\" data-v-6d9429cc></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#00bd8e\" data-v-6d9429cc></polygon>", 15)
const PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_42 = [
  PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_27
]

function PaymentHubvue_type_template_id_6d9429cc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_2, PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_25))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_26, PaymentHubvue_type_template_id_6d9429cc_scoped_true_hoisted_42))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PaymentHub.vue?vue&type=template&id=6d9429cc&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/PaymentHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_PaymentHubvue_type_script_lang_js = ({
    name: "PaymentHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PaymentHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/PaymentHub.vue?vue&type=style&index=0&id=6d9429cc&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PaymentHub.vue?vue&type=style&index=0&id=6d9429cc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/PaymentHub.vue




;


const Mobile_PaymentHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_PaymentHubvue_type_script_lang_js, [['render',PaymentHubvue_type_template_id_6d9429cc_scoped_true_render],['__scopeId',"data-v-6d9429cc"]])

/* harmony default export */ var Mobile_PaymentHub = (Mobile_PaymentHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ProductsHub.vue?vue&type=template&id=1480a3b6&scoped=true


const ProductsHubvue_type_template_id_1480a3b6_scoped_true_withScopeId = n => (_pushScopeId("data-v-1480a3b6"),n=n(),_popScopeId(),n)
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1938.03",
  height: "267",
  viewBox: "0 0 1938.03 267"
}
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_2 = { key: 0 }
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M522.27,107.34c0,48.84-28.79,65.61-94.39,65.61h-39V256H326.56V15.87H429.7c60.86,0,92.57,21.5,92.57,65.23ZM461,81.1c0-22.23-7.65-34.26-36.08-34.26H388.88V142H425C453.75,142,461,130.3,461,107.34Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M603.91,256H540.13V15.87H648c58.31,0,92.94,15.67,92.94,60.86V90.21c0,41.92-15,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.7,105h-78l-59-109.7V125.2c46.28,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.89-41.19-33.89H603.91Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M957.44,192.26c0,68.52-76.54,65.6-107.15,65.6-57.95,0-92.94-19.31-92.94-65.6V79.64C757.35,33.36,792,14,849.92,14h15c57.58,0,92.57,19.32,92.57,65.6ZM895.12,79.64C895.12,56,886.37,45,858.67,45h-2.55c-27.7,0-36.45,10.94-36.45,34.62V192.26c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M1175.38,190.44c0,44.46-30.61,65.6-92.57,65.6H975.66V15.87h107.15c61.23,0,92.57,21.86,92.57,65.6Zm-62.32-109c0-22.6-7.65-34.26-36.45-34.26h-39V225.06h39c29.52,0,36.45-11.3,36.45-34.62Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M1393.69,192.26c0,43.74-31.34,65.6-92.57,65.6h-14.94c-61.23,0-92.57-21.86-92.57-65.6V15.87h63.05V192.26c0,22.23,7.65,34.26,35.71,34.26h2.55c28.07,0,35.72-12,35.72-34.26V15.87h63Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M1514.33,258.59c-48.11,0-102.41-5.1-102.41-65.6V79.28c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27h-57.58c-37.91,0-40.82,10.2-40.82,34.62V193c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M1701.66,46.84V256H1639V46.84h-51.75v-31h166.19v31Z\" fill=\"#fff\" data-v-1480a3b6></path><path d=\"M1932.72,190.44c0,44.1-30.61,67.79-91.11,67.79l-80.54-5.1V227.25h63c40.82,0,43-15.31,43-34.26V179.14l-103.5-63.78c-2.55-6.92-6.2-17.13-6.2-29.52,0-44.46,24.78-73.25,91.84-73.25l72.17,5.83V44.29h-45.92c-46.29,0-50.67,13.85-50.67,35.35V89.85l99.87,62c4,8,8,21.5,8,33.16Z\" fill=\"#fff\" data-v-1480a3b6></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-1480a3b6></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path>", 22)
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_25 = [
  ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_3
]
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_26 = { key: 1 }
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M522.27,107.34c0,48.84-28.79,65.61-94.39,65.61h-39V256H326.56V15.87H429.7c60.86,0,92.57,21.5,92.57,65.23ZM461,81.1c0-22.23-7.65-34.26-36.08-34.26H388.88V142H425C453.75,142,461,130.3,461,107.34Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M603.91,256H540.13V15.87H648c58.31,0,92.94,15.67,92.94,60.86V90.21c0,41.92-15,60.5-55.4,60.87,19.68,29.52,48.84,73.25,70.7,105h-78l-59-109.7V125.2c46.28,0,53.94-8,53.94-28.06v-16c0-20.41-4.74-33.89-41.19-33.89H603.91Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M957.44,192.26c0,68.52-76.54,65.6-107.15,65.6-57.95,0-92.94-19.31-92.94-65.6V79.64C757.35,33.36,792,14,849.92,14h15c57.58,0,92.57,19.32,92.57,65.6ZM895.12,79.64C895.12,56,886.37,45,858.67,45h-2.55c-27.7,0-36.45,10.94-36.45,34.62V192.26c0,23.69,8.75,34.26,36.45,34.26h2.55c27.7,0,36.45-10.57,36.45-34.26Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M1175.38,190.44c0,44.46-30.61,65.6-92.57,65.6H975.66V15.87h107.15c61.23,0,92.57,21.86,92.57,65.6Zm-62.32-109c0-22.6-7.65-34.26-36.45-34.26h-39V225.06h39c29.52,0,36.45-11.3,36.45-34.62Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M1393.69,192.26c0,43.74-31.34,65.6-92.57,65.6h-14.94c-61.23,0-92.57-21.86-92.57-65.6V15.87h63.05V192.26c0,22.23,7.65,34.26,35.71,34.26h2.55c28.07,0,35.72-12,35.72-34.26V15.87h63Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M1514.33,258.59c-48.11,0-102.41-5.1-102.41-65.6V79.28c0-61.23,55-66.69,102.41-66.69l58.31,5.1v27h-57.58c-37.91,0-40.82,10.2-40.82,34.62V193c0,25.15,3.64,33.53,40.82,33.53h57.58v27Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M1701.66,46.84V256H1639V46.84h-51.75v-31h166.19v31Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><path d=\"M1932.72,190.44c0,44.1-30.61,67.79-91.11,67.79l-80.54-5.1V227.25h63c40.82,0,43-15.31,43-34.26V179.14l-103.5-63.78c-2.55-6.92-6.2-17.13-6.2-29.52,0-44.46,24.78-73.25,91.84-73.25l72.17,5.83V44.29h-45.92c-46.29,0-50.67,13.85-50.67,35.35V89.85l99.87,62c4,8,8,21.5,8,33.16Z\" fill=\"#f2dc1d\" data-v-1480a3b6></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#f2dc1d\" data-v-1480a3b6></polygon>", 15)
const ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_42 = [
  ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_27
]

function ProductsHubvue_type_template_id_1480a3b6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_2, ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_25))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_26, ProductsHubvue_type_template_id_1480a3b6_scoped_true_hoisted_42))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ProductsHub.vue?vue&type=template&id=1480a3b6&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ProductsHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_ProductsHubvue_type_script_lang_js = ({
    name: "ProductsHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ProductsHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/ProductsHub.vue?vue&type=style&index=0&id=1480a3b6&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ProductsHub.vue?vue&type=style&index=0&id=1480a3b6&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/ProductsHub.vue




;


const Mobile_ProductsHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_ProductsHubvue_type_script_lang_js, [['render',ProductsHubvue_type_template_id_1480a3b6_scoped_true_render],['__scopeId',"data-v-1480a3b6"]])

/* harmony default export */ var Mobile_ProductsHub = (Mobile_ProductsHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/SupportHub.vue?vue&type=template&id=3ff06e9d&scoped=true


const SupportHubvue_type_template_id_3ff06e9d_scoped_true_withScopeId = n => (_pushScopeId("data-v-3ff06e9d"),n=n(),_popScopeId(),n)
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1745.97",
  height: "267",
  viewBox: "0 0 1745.97 267"
}
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_2 = { key: 0 }
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M493.78,187.61c0,44.1-30.61,67.79-91.12,67.79l-80.54-5.1V224.42h63.05c40.82,0,43-15.31,43-34.26V176.31L324.67,112.53c-2.55-6.93-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.85-73.26l72.16,5.83V41.46H436.56c-46.29,0-50.66,13.85-50.66,35.35V87l99.86,62c4,8,8,21.5,8,33.16Z\" fill=\"#fff\" data-v-3ff06e9d></path><path d=\"M707,189.43c0,43.74-31.34,65.61-92.57,65.61H599.47c-61.23,0-92.57-21.87-92.57-65.61V13H570v176.4c0,22.24,7.66,34.26,35.72,34.26h2.55c28.06,0,35.72-12,35.72-34.26V13h63Z\" fill=\"#fff\" data-v-3ff06e9d></path><path d=\"M926,104.51c0,48.84-28.79,65.61-94.4,65.61h-39v83.1H730.31V13H833.45C894.32,13,926,34.53,926,78.27ZM864.8,78.27C864.8,56,857.15,44,828.72,44H792.63v95.13h36.09c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#fff\" data-v-3ff06e9d></path><path d=\"M1139.6,104.51c0,48.84-28.79,65.61-94.39,65.61h-39v83.1H943.88V13H1047c60.87,0,92.57,21.5,92.57,65.24Zm-61.23-26.24c0-22.23-7.65-34.26-36.08-34.26h-36.08v95.13h36.08c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#fff\" data-v-3ff06e9d></path><path d=\"M1359.74,189.43c0,68.52-76.54,65.61-107.16,65.61-57.95,0-92.94-19.32-92.94-65.61V76.81c0-46.29,34.63-65.6,92.58-65.6h14.94c57.59,0,92.58,19.31,92.58,65.6ZM1297.41,76.81c0-23.69-8.74-34.62-36.44-34.62h-2.56c-27.7,0-36.44,10.93-36.44,34.62V189.43c0,23.69,8.74,34.26,36.44,34.26H1261c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#fff\" data-v-3ff06e9d></path><path d=\"M1449,253.22h-63.78V13h107.89c58.31,0,92.94,15.67,92.94,60.87V87.38c0,41.92-15,60.5-55.4,60.87,19.68,29.52,48.84,73.26,70.7,105h-78l-59.05-109.71V122.37c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.73-33.9-41.18-33.9H1449Z\" fill=\"#fff\" data-v-3ff06e9d></path><path d=\"M1710,44V253.22h-62.69V44h-51.75V13h166.19V44Z\" fill=\"#fff\" data-v-3ff06e9d></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-3ff06e9d></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#e09dea\" data-v-3ff06e9d></path>", 21)
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_24 = [
  SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_3
]
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_25 = { key: 1 }
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M493.78,187.61c0,44.1-30.61,67.79-91.12,67.79l-80.54-5.1V224.42h63.05c40.82,0,43-15.31,43-34.26V176.31L324.67,112.53c-2.55-6.92-6.2-17.13-6.2-29.52,0-44.47,24.78-73.26,91.85-73.26l72.16,5.83V41.46H436.56c-46.29,0-50.66,13.85-50.66,35.35V87l99.86,62c4,8,8,21.5,8,33.16Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><path d=\"M707,189.43c0,43.74-31.34,65.61-92.57,65.61H599.47c-61.23,0-92.57-21.87-92.57-65.61V13H570v176.4c0,22.24,7.66,34.26,35.72,34.26h2.55c28.06,0,35.72-12,35.72-34.26V13h63Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><path d=\"M926,104.51c0,48.84-28.79,65.61-94.4,65.61h-39v83.1H730.31V13H833.45C894.32,13,926,34.53,926,78.27ZM864.8,78.27C864.8,56,857.15,44,828.72,44H792.63v95.13h36.09c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><path d=\"M1139.6,104.51c0,48.84-28.79,65.61-94.39,65.61h-39v83.1H943.88V13H1047c60.87,0,92.57,21.5,92.57,65.24Zm-61.23-26.24c0-22.23-7.65-34.26-36.08-34.26h-36.08v95.13h36.08c28.79,0,36.08-11.67,36.08-34.63Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><path d=\"M1359.74,189.43c0,68.52-76.54,65.61-107.16,65.61-57.95,0-92.94-19.32-92.94-65.61V76.81c0-46.29,34.63-65.6,92.58-65.6h14.94c57.59,0,92.58,19.31,92.58,65.6ZM1297.41,76.81c0-23.69-8.74-34.62-36.44-34.62h-2.56c-27.7,0-36.44,10.93-36.44,34.62V189.43c0,23.69,8.74,34.26,36.44,34.26H1261c27.7,0,36.44-10.57,36.44-34.26Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><path d=\"M1449,253.22h-63.78V13h107.89c58.31,0,92.94,15.67,92.94,60.87V87.38c0,41.92-15,60.5-55.4,60.87,19.68,29.52,48.84,73.26,70.7,105h-78l-59.05-109.71V122.37c46.29,0,53.94-8,53.94-28.06v-16c0-20.41-4.73-33.9-41.18-33.9H1449Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><path d=\"M1710,44V253.22h-62.69V44h-51.75V13h166.19V44Z\" fill=\"#e09dea\" data-v-3ff06e9d></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#e09dea\" data-v-3ff06e9d></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#e09dea\" data-v-3ff06e9d></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#e09dea\" data-v-3ff06e9d></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#e09dea\" data-v-3ff06e9d></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#e09dea\" data-v-3ff06e9d></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#e09dea\" data-v-3ff06e9d></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#e09dea\" data-v-3ff06e9d></polygon>", 14)
const SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_40 = [
  SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_26
]

function SupportHubvue_type_template_id_3ff06e9d_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_2, SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_24))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_25, SupportHubvue_type_template_id_3ff06e9d_scoped_true_hoisted_40))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/SupportHub.vue?vue&type=template&id=3ff06e9d&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/SupportHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_SupportHubvue_type_script_lang_js = ({
    name: "SupportHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/SupportHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/SupportHub.vue?vue&type=style&index=0&id=3ff06e9d&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/SupportHub.vue?vue&type=style&index=0&id=3ff06e9d&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/SupportHub.vue




;


const Mobile_SupportHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_SupportHubvue_type_script_lang_js, [['render',SupportHubvue_type_template_id_3ff06e9d_scoped_true_render],['__scopeId',"data-v-3ff06e9d"]])

/* harmony default export */ var Mobile_SupportHub = (Mobile_SupportHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/TaxHub.vue?vue&type=template&id=52ccfc08&scoped=true


const TaxHubvue_type_template_id_52ccfc08_scoped_true_withScopeId = n => (_pushScopeId("data-v-52ccfc08"),n=n(),_popScopeId(),n)
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "955.46",
  height: "267",
  viewBox: "0 0 955.46 267"
}
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_2 = { key: 0 }
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M430.93,44.64V253.85H368.24V44.64H316.49v-31h166.2v31Z\" fill=\"#fff\" data-v-52ccfc08></path><path d=\"M635.76,253.85,625.55,199.9v.73h-86v-.73l-11.3,53.95H476.48l66.7-240.19h94.4l69.61,240.19ZM593.12,42.45H572L546.1,169.65h74Z\" fill=\"#fff\" data-v-52ccfc08></path><path d=\"M869.74,253.85,827.83,147.42H809.24L767.69,253.85H713.38l62-128.3C757.85,89.83,737.07,49,719.58,13.66h70L823.82,100h20.41c10.57-28.43,21.87-57.59,32.44-86.38h51.75L878.85,125.55c19.69,41.92,41.55,86.38,61.23,128.3Z\" fill=\"#fff\" data-v-52ccfc08></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-52ccfc08></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#5399d3\" data-v-52ccfc08></path>", 17)
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_20 = [
  TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_3
]
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_21 = { key: 1 }
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M430.93,44.64V253.85H368.24V44.64H316.49v-31h166.2v31Z\" fill=\"#5399d3\" data-v-52ccfc08></path><path d=\"M635.76,253.85l-10.21-53.94v.72h-86v-.72l-11.3,53.94H476.48l66.7-240.19h94.4l69.61,240.19ZM593.12,42.45H572L546.1,169.65h74Z\" fill=\"#5399d3\" data-v-52ccfc08></path><path d=\"M869.74,253.85,827.83,147.42H809.24L767.69,253.85H713.38l62-128.3C757.85,89.83,737.07,49,719.58,13.66h70L823.82,100h20.41c10.57-28.43,21.87-57.59,32.44-86.38h51.75L878.85,125.55c19.69,41.92,41.55,86.38,61.23,128.3Z\" fill=\"#5399d3\" data-v-52ccfc08></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#5399d3\" data-v-52ccfc08></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#5399d3\" data-v-52ccfc08></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#5399d3\" data-v-52ccfc08></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#5399d3\" data-v-52ccfc08></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#5399d3\" data-v-52ccfc08></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#5399d3\" data-v-52ccfc08></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#5399d3\" data-v-52ccfc08></polygon>", 10)
const TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_32 = [
  TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_22
]

function TaxHubvue_type_template_id_52ccfc08_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_2, TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_20))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_21, TaxHubvue_type_template_id_52ccfc08_scoped_true_hoisted_32))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/TaxHub.vue?vue&type=template&id=52ccfc08&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/TaxHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_TaxHubvue_type_script_lang_js = ({
    name: "TaxHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/TaxHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/TaxHub.vue?vue&type=style&index=0&id=52ccfc08&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/TaxHub.vue?vue&type=style&index=0&id=52ccfc08&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/TaxHub.vue




;


const Mobile_TaxHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_TaxHubvue_type_script_lang_js, [['render',TaxHubvue_type_template_id_52ccfc08_scoped_true_render],['__scopeId',"data-v-52ccfc08"]])

/* harmony default export */ var Mobile_TaxHub = (Mobile_TaxHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/W3EHub.vue?vue&type=template&id=58350ce8&scoped=true


const W3EHubvue_type_template_id_58350ce8_scoped_true_withScopeId = n => (_pushScopeId("data-v-58350ce8"),n=n(),_popScopeId(),n)
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1207.65",
  height: "267",
  viewBox: "0 0 1207.65 267"
}
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_2 = { key: 0 }
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M610.32,254.79H521.4L489.69,62c-8.75,60.14-19.32,133-27.7,192.8H370.87L315.48,14.62h68.15L416.8,215.8h13.12L459.8,14.62h74.35L565.49,215.8h14.22L610.32,14.62H663.9Z\" fill=\"#fff\" data-v-58350ce8></path><path d=\"M686.13,254.79V14.62H837.75V45.23h-88.2v69.61h69.61v31.34H749.55v77.63h88.2v31Z\" fill=\"#fff\" data-v-58350ce8></path><path d=\"M862.9,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34H926.31v77.63h88.2v31Z\" fill=\"#fff\" data-v-58350ce8></path><path d=\"M1039.66,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#fff\" data-v-58350ce8></path><polygon points=\"150.71 116.29 150.71 36.14 181.85 5 262 5 262 85.04 230.75 116.29 150.71 116.29\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M257,10V83l-28.32,28.32h-73V38.21L183.92,10H257M267,0H179.78L145.71,34.07v87.22h87.11L267,87.11V0Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"5 262 5 181.85 36.14 150.71 116.29 150.71 116.29 230.75 85.04 262 5 262\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M111.29,155.71v73L83,257H10V183.92l28.21-28.21h73.08m10-10H34.07L0,179.78V267H87.11l34.18-34.18V145.71Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"5 116.29 5 36.14 36.14 5 116.29 5 116.29 85.04 85.04 116.29 5 116.29\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M111.29,10V83L83,111.29H10V38.21L38.21,10h73.08m10-10H34.07L0,34.07v87.22H87.11l34.18-34.18V0Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"150.71 195.29 150.71 163.11 163.11 150.71 195.29 150.71 195.29 182.84 182.84 195.29 150.71 195.29\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M190.29,155.71v25.06l-9.52,9.52H155.71V165.18l9.47-9.47h25.11m10-10H161L145.71,161v39.25h39.2l15.38-15.38v-39.2Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"217.42 195.29 217.42 163.11 229.82 150.71 262 150.71 262 182.84 249.55 195.29 217.42 195.29\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M257,155.71v25.06l-9.52,9.52H222.42V165.18l9.47-9.47H257m10-10H227.75L212.42,161v39.25h39.2L267,184.91v-39.2Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"217.42 262 217.42 229.82 229.82 217.42 262 217.42 262 249.55 249.55 262 217.42 262\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M257,222.42v25.06L247.48,257H222.42V231.89l9.47-9.47H257m10-10H227.75l-15.33,15.33V267h39.2L267,251.62v-39.2Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"150.71 262 150.71 229.82 163.11 217.42 195.29 217.42 195.29 249.55 182.84 262 150.71 262\" fill=\"#fff\" data-v-58350ce8></polygon><path d=\"M190.29,222.42v25.06L180.77,257H155.71V231.89l9.47-9.47h25.11m10-10H161l-15.33,15.33V267h39.2l15.38-15.38v-39.2Z\" fill=\"#e27110\" data-v-58350ce8></path>", 18)
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_21 = [
  W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_3
]
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_22 = { key: 1 }
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path d=\"M610.32,254.79H521.4L489.69,62c-8.75,60.14-19.32,133-27.7,192.8H370.87L315.48,14.62h68.15L416.8,215.8h13.12L459.8,14.62h74.35L565.49,215.8h14.22L610.32,14.62H663.9Z\" fill=\"#e27110\" data-v-58350ce8></path><path d=\"M686.13,254.79V14.62H837.75V45.23h-88.2v69.61h69.61v31.34H749.55v77.63h88.2v31Z\" fill=\"#e27110\" data-v-58350ce8></path><path d=\"M862.9,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34H926.31v77.63h88.2v31Z\" fill=\"#e27110\" data-v-58350ce8></path><path d=\"M1039.66,254.79V14.62h151.61V45.23h-88.2v69.61h69.61v31.34h-69.61v77.63h88.2v31Z\" fill=\"#e27110\" data-v-58350ce8></path><polygon points=\"267 87.11 267 0 179.78 0 145.71 34.07 145.71 121.29 232.82 121.29 267 87.11\" fill=\"#e27110\" data-v-58350ce8></polygon><polygon points=\"121.29 232.82 121.29 145.71 34.07 145.71 0 179.78 0 267 87.11 267 121.29 232.82\" fill=\"#e27110\" data-v-58350ce8></polygon><polygon points=\"121.29 87.11 121.29 0 34.07 0 0 34.07 0 121.29 87.11 121.29 121.29 87.11\" fill=\"#e27110\" data-v-58350ce8></polygon><polygon points=\"200.29 184.91 200.29 145.71 161.04 145.71 145.71 161.04 145.71 200.29 184.91 200.29 200.29 184.91\" fill=\"#e27110\" data-v-58350ce8></polygon><polygon points=\"267 184.91 267 145.71 227.75 145.71 212.42 161.04 212.42 200.29 251.62 200.29 267 184.91\" fill=\"#e27110\" data-v-58350ce8></polygon><polygon points=\"267 251.62 267 212.42 227.75 212.42 212.42 227.75 212.42 267 251.62 267 267 251.62\" fill=\"#e27110\" data-v-58350ce8></polygon><polygon points=\"200.29 251.62 200.29 212.42 161.04 212.42 145.71 227.75 145.71 267 184.91 267 200.29 251.62\" fill=\"#e27110\" data-v-58350ce8></polygon>", 11)
const W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_34 = [
  W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_23
]

function W3EHubvue_type_template_id_58350ce8_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_1, [
    ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_2, W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_21))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_22, W3EHubvue_type_template_id_58350ce8_scoped_true_hoisted_34))
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/W3EHub.vue?vue&type=template&id=58350ce8&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/W3EHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Mobile_W3EHubvue_type_script_lang_js = ({
    name: "W3EHub",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/W3EHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Mobile/W3EHub.vue?vue&type=style&index=0&id=58350ce8&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/W3EHub.vue?vue&type=style&index=0&id=58350ce8&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Mobile/W3EHub.vue




;


const Mobile_W3EHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mobile_W3EHubvue_type_script_lang_js, [['render',W3EHubvue_type_template_id_58350ce8_scoped_true_render],['__scopeId',"data-v-58350ce8"]])

/* harmony default export */ var Mobile_W3EHub = (Mobile_W3EHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/AccountingHub.vue?vue&type=template&id=fd959566&scoped=true


const AccountingHubvue_type_template_id_fd959566_scoped_true_withScopeId = n => (_pushScopeId("data-v-fd959566"),n=n(),_popScopeId(),n)
const AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-fd959566></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M58.69,190.39l-14.35,1c-7.5,0-11-2.23-11-7.07a13.52,13.52,0,0,1,.33-2.82l.21-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.21-3.26-6.68-3.26H38.58l.82-4.24,10.22-1c9.56,0,13.47,2.18,13.47,7.29a15.86,15.86,0,0,1-.38,3ZM47.88,175.61c-4.41,0-5,2.23-5.66,5.49,0,.16-.1.38-.1.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M90.16,166.31H83.64c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.08,2.17,4.72,2.17h6.64L85,190.66l-7.07.71c-6.3,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M114.3,166.31h-6.52c-5.11,0-5.77,1.09-6.64,4.95L99,181.53a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17H110l-.87,4.29-7.07.71c-6.3,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#9dcc4a\" data-v-fd959566></path><polygon points=\"121.4 144.79 115.48 144.79 117.02 137.58 112.93 137.58 109.15 155.38 113.25 155.38 114.89 147.67 120.81 147.67 119.16 155.38 123.26 155.38 127.03 137.58 122.94 137.58 121.4 144.79\" fill=\"#9dcc4a\" data-v-fd959566></polygon><path d=\"M140.06,137.65l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.55,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M160.2,139.24c-.86-1.06-2.5-1.57-5-1.57h-7.46L144,155.3h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.64,4.64,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.2,139.24Zm-6.64,5.56H151c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.56,144.8Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#9dcc4a\" data-v-fd959566></path>", 8)
const _hoisted_10 = [
  AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_2
]
const _hoisted_11 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const _hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-fd959566></polygon><path d=\"M58.69,190.39l-14.35,1c-7.5,0-11-2.23-11-7.07a13.52,13.52,0,0,1,.33-2.82l.21-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.21-3.26-6.68-3.26H38.58l.82-4.24,10.22-1c9.56,0,13.47,2.18,13.47,7.29a15.86,15.86,0,0,1-.38,3ZM47.88,175.61c-4.41,0-5,2.23-5.66,5.49,0,.16-.1.38-.1.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M90.16,166.31H83.64c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.08,2.17,4.72,2.17h6.64L85,190.66l-7.07.71c-6.3,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M114.3,166.31h-6.52c-5.11,0-5.77,1.09-6.64,4.95L99,181.53a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17H110l-.87,4.29-7.07.71c-6.3,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#9dcc4a\" data-v-fd959566></path><polygon points=\"121.4 144.79 115.48 144.79 117.02 137.58 112.93 137.58 109.15 155.38 113.25 155.38 114.89 147.67 120.81 147.67 119.16 155.38 123.26 155.38 127.03 137.58 122.94 137.58 121.4 144.79\" fill=\"#9dcc4a\" data-v-fd959566></polygon><path d=\"M140.06,137.65l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.55,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#9dcc4a\" data-v-fd959566></path><path d=\"M160.2,139.24c-.86-1.06-2.5-1.57-5-1.57h-7.46L144,155.3h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.64,4.64,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.2,139.24Zm-6.64,5.56H151c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.56,144.8Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#9dcc4a\" data-v-fd959566></path>", 7)
const AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_19 = [
  _hoisted_12
]
const AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#9dcc4a\" data-v-fd959566></polygon><path d=\"M58.69,190.39l-14.35,1c-7.5,0-11-2.23-11-7.07a13.52,13.52,0,0,1,.33-2.82l.21-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.21-3.26-6.68-3.26H38.58l.82-4.24,10.22-1c9.56,0,13.47,2.18,13.47,7.29a15.86,15.86,0,0,1-.38,3ZM47.88,175.61c-4.41,0-5,2.23-5.66,5.49,0,.16-.1.38-.1.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#fff\" data-v-fd959566></path><path d=\"M90.16,166.31H83.64c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.08,2.17,4.72,2.17h6.64L85,190.66l-7.07.71c-6.3,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-fd959566></path><path d=\"M114.3,166.31h-6.52c-5.11,0-5.77,1.09-6.64,4.95L99,181.53a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17H110l-.87,4.29-7.07.71c-6.3,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-fd959566></path><polygon points=\"121.4 144.79 115.48 144.79 117.02 137.58 112.93 137.58 109.15 155.38 113.25 155.38 114.89 147.67 120.81 147.67 119.16 155.38 123.26 155.38 127.03 137.58 122.94 137.58 121.4 144.79\" fill=\"#fff\" data-v-fd959566></polygon><path d=\"M140.06,137.65l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.55,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-fd959566></path><path d=\"M160.2,139.24c-.86-1.06-2.5-1.57-5-1.57h-7.46L144,155.3h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.64,4.64,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.2,139.24Zm-6.64,5.56H151c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.56,144.8Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-fd959566></path>", 7)
const AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_28 = [
  AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_21
]

function AccountingHubvue_type_template_id_fd959566_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='outlined')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_1, _hoisted_10))
    : ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_11, AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_20, AccountingHubvue_type_template_id_fd959566_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/AccountingHub.vue?vue&type=template&id=fd959566&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/AccountingHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_AccountingHubvue_type_script_lang_js = ({
    name: "AccountingHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/AccountingHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/AccountingHub.vue?vue&type=style&index=0&id=fd959566&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/AccountingHub.vue?vue&type=style&index=0&id=fd959566&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/AccountingHub.vue




;


const Square_AccountingHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_AccountingHubvue_type_script_lang_js, [['render',AccountingHubvue_type_template_id_fd959566_scoped_true_render],['__scopeId',"data-v-fd959566"]])

/* harmony default export */ var Square_AccountingHub = (Square_AccountingHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/CopyrightHub.vue?vue&type=template&id=5699a73d&scoped=true


const CopyrightHubvue_type_template_id_5699a73d_scoped_true_withScopeId = n => (_pushScopeId("data-v-5699a73d"),n=n(),_popScopeId(),n)
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-5699a73d></polygon><path d=\"M59.1,166.22H52.58c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14.17,14.17,0,0,0-.39,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10L60,162Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M87.69,181.33c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H72.31l-4.19,19.56h5.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M117.86,173.13h-6.31a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2H104l-5.16,24.24H90.52l6.09-28.59,13.53-1.09c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#e6ae24\" data-v-5699a73d></path><polygon points=\"119.9 144.89 113.99 144.89 115.53 137.67 111.43 137.67 107.66 155.47 111.75 155.47 113.39 147.76 119.31 147.76 117.67 155.47 121.76 155.47 125.54 137.67 121.44 137.67 119.9 144.89\" fill=\"#e6ae24\" data-v-5699a73d></polygon><path d=\"M138.57,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M158.71,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,158.71,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,152.06,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#e6ae24\" data-v-5699a73d></path>", 7)
const _hoisted_9 = [
  CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_2
]
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-5699a73d></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M59.1,166.22H52.58c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14.17,14.17,0,0,0-.39,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10L60,162Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M87.69,181.33c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H72.31l-4.19,19.56h5.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M117.86,173.13h-6.31a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2H104l-5.16,24.24H90.52l6.09-28.59,13.53-1.09c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#e6ae24\" data-v-5699a73d></path><polygon points=\"119.9 144.89 113.99 144.89 115.53 137.67 111.43 137.67 107.66 155.47 111.75 155.47 113.39 147.76 119.31 147.76 117.67 155.47 121.76 155.47 125.54 137.67 121.44 137.67 119.9 144.89\" fill=\"#e6ae24\" data-v-5699a73d></polygon><path d=\"M138.57,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e6ae24\" data-v-5699a73d></path><path d=\"M158.71,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,158.71,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,152.06,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#e6ae24\" data-v-5699a73d></path>", 8)
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_19 = [
  CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_11
]
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e6ae24\" data-v-5699a73d></polygon><path d=\"M59.1,166.22H52.58c-5.11,0-5.76,1.09-6.63,4.95l-2.17,10.27a14.17,14.17,0,0,0-.39,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10L60,162Z\" fill=\"#fff\" data-v-5699a73d></path><path d=\"M87.69,181.33c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H72.31l-4.19,19.56h5.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#fff\" data-v-5699a73d></path><path d=\"M117.86,173.13h-6.31a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2H104l-5.16,24.24H90.52l6.09-28.59,13.53-1.09c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#fff\" data-v-5699a73d></path><polygon points=\"119.9 144.89 113.99 144.89 115.53 137.67 111.43 137.67 107.66 155.47 111.75 155.47 113.39 147.76 119.31 147.76 117.67 155.47 121.76 155.47 125.54 137.67 121.44 137.67 119.9 144.89\" fill=\"#fff\" data-v-5699a73d></polygon><path d=\"M138.57,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-5699a73d></path><path d=\"M158.71,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,158.71,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,152.06,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-5699a73d></path>", 7)
const CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_28 = [
  CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_21
]

function CopyrightHubvue_type_template_id_5699a73d_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_1, _hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_10, CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_20, CopyrightHubvue_type_template_id_5699a73d_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/CopyrightHub.vue?vue&type=template&id=5699a73d&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/CopyrightHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_CopyrightHubvue_type_script_lang_js = ({
    name: "CopyrightHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/CopyrightHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/CopyrightHub.vue?vue&type=style&index=0&id=5699a73d&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/CopyrightHub.vue?vue&type=style&index=0&id=5699a73d&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/CopyrightHub.vue




;


const Square_CopyrightHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_CopyrightHubvue_type_script_lang_js, [['render',CopyrightHubvue_type_template_id_5699a73d_scoped_true_render],['__scopeId',"data-v-5699a73d"]])

/* harmony default export */ var Square_CopyrightHub = (Square_CopyrightHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ECompanyHub.vue?vue&type=template&id=34f4279c&scoped=true


const ECompanyHubvue_type_template_id_34f4279c_scoped_true_withScopeId = n => (_pushScopeId("data-v-34f4279c"),n=n(),_popScopeId(),n)
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-34f4279c></polygon><path d=\"M55.1,166.72H48.58c-5.11,0-5.76,1.09-6.63,4.95l-2.18,10.27a14.9,14.9,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M98.42,191.35c-5.65,0-7.5,0-7.5-2.94A41.63,41.63,0,0,1,92,182l2.17-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.69-2.61h-6a12,12,0,0,1,.44,3,9.7,9.7,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.94,13.37H72.33l4.13-19.46a12.88,12.88,0,0,0,.33-2.28c0-1.69-.92-2.45-3.7-2.45H68.15L63,191.35H54.67l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a10.86,10.86,0,0,1-.27,2.55Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M132,181.83c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L105,181.89l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66h-5.44l-4.18,19.56h5.49c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#099192\" data-v-34f4279c></path><polygon points=\"123.9 144.39 117.99 144.39 119.53 137.17 115.43 137.17 111.66 154.97 115.75 154.97 117.39 147.26 123.31 147.26 121.67 154.97 125.76 154.97 129.54 137.17 125.44 137.17 123.9 144.39\" fill=\"#099192\" data-v-34f4279c></polygon><path d=\"M142.57,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M162.71,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.73,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.71,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.06,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#099192\" data-v-34f4279c></path>", 7)
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_9 = [
  ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_2
]
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-34f4279c></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M55.1,166.72H48.58c-5.11,0-5.76,1.09-6.63,4.95l-2.18,10.27a14.9,14.9,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M98.42,191.35c-5.65,0-7.5,0-7.5-2.94A41.63,41.63,0,0,1,92,182l2.17-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.69-2.61h-6a12,12,0,0,1,.44,3,9.7,9.7,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.94,13.37H72.33l4.13-19.46a12.88,12.88,0,0,0,.33-2.28c0-1.69-.92-2.45-3.7-2.45H68.15L63,191.35H54.67l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a10.86,10.86,0,0,1-.27,2.55Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M132,181.83c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L105,181.89l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66h-5.44l-4.18,19.56h5.49c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#099192\" data-v-34f4279c></path><polygon points=\"123.9 144.39 117.99 144.39 119.53 137.17 115.43 137.17 111.66 154.97 115.75 154.97 117.39 147.26 123.31 147.26 121.67 154.97 125.76 154.97 129.54 137.17 125.44 137.17 123.9 144.39\" fill=\"#099192\" data-v-34f4279c></polygon><path d=\"M142.57,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#099192\" data-v-34f4279c></path><path d=\"M162.71,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.73,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.71,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.06,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#099192\" data-v-34f4279c></path>", 8)
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_19 = [
  ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_11
]
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#099192\" data-v-34f4279c></polygon><path d=\"M55.1,166.72H48.58c-5.11,0-5.76,1.09-6.63,4.95l-2.18,10.27a14.9,14.9,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.73,13.73,0,0,1,.32-2.72l2.18-10.05c2.06-9,9.67-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-34f4279c></path><path d=\"M98.42,191.35c-5.65,0-7.5,0-7.5-2.94A41.63,41.63,0,0,1,92,182l2.17-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.69-2.61h-6a12,12,0,0,1,.44,3,9.7,9.7,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.94,13.37H72.33l4.13-19.46a12.88,12.88,0,0,0,.33-2.28c0-1.69-.92-2.45-3.7-2.45H68.15L63,191.35H54.67l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a10.86,10.86,0,0,1-.27,2.55Z\" fill=\"#fff\" data-v-34f4279c></path><path d=\"M132,181.83c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L105,181.89l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66h-5.44l-4.18,19.56h5.49c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#fff\" data-v-34f4279c></path><polygon points=\"123.9 144.39 117.99 144.39 119.53 137.17 115.43 137.17 111.66 154.97 115.75 154.97 117.39 147.26 123.31 147.26 121.67 154.97 125.76 154.97 129.54 137.17 125.44 137.17 123.9 144.39\" fill=\"#fff\" data-v-34f4279c></polygon><path d=\"M142.57,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-34f4279c></path><path d=\"M162.71,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.73,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.71,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.06,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-34f4279c></path>", 7)
const ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_28 = [
  ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_21
]

function ECompanyHubvue_type_template_id_34f4279c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_1, ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_10, ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_20, ECompanyHubvue_type_template_id_34f4279c_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ECompanyHub.vue?vue&type=template&id=34f4279c&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ECompanyHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_ECompanyHubvue_type_script_lang_js = ({
    name: "ECompanyHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ECompanyHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ECompanyHub.vue?vue&type=style&index=0&id=34f4279c&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ECompanyHub.vue?vue&type=style&index=0&id=34f4279c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ECompanyHub.vue




;


const Square_ECompanyHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_ECompanyHubvue_type_script_lang_js, [['render',ECompanyHubvue_type_template_id_34f4279c_scoped_true_render],['__scopeId',"data-v-34f4279c"]])

/* harmony default export */ var Square_ECompanyHub = (Square_ECompanyHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/EIdHub.vue?vue&type=template&id=6ce06eca&scoped=true


const EIdHubvue_type_template_id_6ce06eca_scoped_true_withScopeId = n => (_pushScopeId("data-v-6ce06eca"),n=n(),_popScopeId(),n)
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-6ce06eca></polygon><path d=\"M66.1,175.54c-1.52,7.17-4.07,9.4-11.79,9.4L45.78,184l-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.76,2.34,3.75,2.34H61.92l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a14.26,14.26,0,0,1,.32-2.83l2.18-10.16c1.41-6.63,6.74-9.89,14.56-9.89h2c6.91,0,10.71,2.34,10.71,7.28a12.2,12.2,0,0,1-.32,2.66Zm-8-3.32c0-1.68-.87-2.44-3.64-2.44H53.33c-3.64,0-4.95,2-5.6,4.94l-1.25,5.71h3.7c5.81,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,58.06,172.22Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M77.84,194.35H68.06l7.61-35.82h9.78Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M115.67,184.51c-1.52,6.52-6.9,9.84-16,9.84H83.44l7.61-35.82h16.14c8,0,12.23,2.5,12.23,7.55a12.65,12.65,0,0,1-.27,2.34Zm-6.19-16.14a9.62,9.62,0,0,0,.27-2c0-2-1.14-2.88-4.4-2.88H99.64L94.1,189.4h5.54c4.35,0,5.71-1.63,6.41-5Z\" fill=\"#e83c89\" data-v-6ce06eca></path><polygon points=\"117.9 141.39 111.99 141.39 113.53 134.17 109.43 134.17 105.66 151.97 109.75 151.97 111.39 144.26 117.31 144.26 115.67 151.97 119.76 151.97 123.54 134.17 119.44 134.17 117.9 141.39\" fill=\"#e83c89\" data-v-6ce06eca></polygon><path d=\"M136.57,134.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M156.71,135.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,156.71,135.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,150.06,141.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#e83c89\" data-v-6ce06eca></path>", 7)
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_9 = [
  EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_2
]
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-6ce06eca></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M66.1,175.54c-1.52,7.17-4.07,9.4-11.79,9.4L45.78,184l-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.76,2.34,3.75,2.34H61.92l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a14.26,14.26,0,0,1,.32-2.83l2.18-10.16c1.41-6.63,6.74-9.89,14.56-9.89h2c6.91,0,10.71,2.34,10.71,7.28a12.2,12.2,0,0,1-.32,2.66Zm-8-3.32c0-1.68-.87-2.44-3.64-2.44H53.33c-3.64,0-4.95,2-5.6,4.94l-1.25,5.71h3.7c5.81,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,58.06,172.22Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M77.84,194.35H68.06l7.61-35.82h9.78Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M115.67,184.51c-1.52,6.52-6.9,9.84-16,9.84H83.44l7.61-35.82h16.14c8,0,12.23,2.5,12.23,7.55a12.65,12.65,0,0,1-.27,2.34Zm-6.19-16.14a9.62,9.62,0,0,0,.27-2c0-2-1.14-2.88-4.4-2.88H99.64L94.1,189.4h5.54c4.35,0,5.71-1.63,6.41-5Z\" fill=\"#e83c89\" data-v-6ce06eca></path><polygon points=\"117.9 141.39 111.99 141.39 113.53 134.17 109.43 134.17 105.66 151.97 109.75 151.97 111.39 144.26 117.31 144.26 115.67 151.97 119.76 151.97 123.54 134.17 119.44 134.17 117.9 141.39\" fill=\"#e83c89\" data-v-6ce06eca></polygon><path d=\"M136.57,134.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e83c89\" data-v-6ce06eca></path><path d=\"M156.71,135.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,156.71,135.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,150.06,141.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#e83c89\" data-v-6ce06eca></path>", 8)
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_19 = [
  EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_11
]
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e83c89\" data-v-6ce06eca></polygon><path d=\"M66.1,175.54c-1.52,7.17-4.07,9.4-11.79,9.4L45.78,184l-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.76,2.34,3.75,2.34H61.92l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a14.26,14.26,0,0,1,.32-2.83l2.18-10.16c1.41-6.63,6.74-9.89,14.56-9.89h2c6.91,0,10.71,2.34,10.71,7.28a12.2,12.2,0,0,1-.32,2.66Zm-8-3.32c0-1.68-.87-2.44-3.64-2.44H53.33c-3.64,0-4.95,2-5.6,4.94l-1.25,5.71h3.7c5.81,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,58.06,172.22Z\" fill=\"#fff\" data-v-6ce06eca></path><path d=\"M77.84,194.35H68.06l7.61-35.82h9.78Z\" fill=\"#fff\" data-v-6ce06eca></path><path d=\"M115.67,184.51c-1.52,6.52-6.9,9.84-16,9.84H83.44l7.61-35.82h16.14c8,0,12.23,2.5,12.23,7.55a12.65,12.65,0,0,1-.27,2.34Zm-6.19-16.14a9.62,9.62,0,0,0,.27-2c0-2-1.14-2.88-4.4-2.88H99.64L94.1,189.4h5.54c4.35,0,5.71-1.63,6.41-5Z\" fill=\"#fff\" data-v-6ce06eca></path><polygon points=\"117.9 141.39 111.99 141.39 113.53 134.17 109.43 134.17 105.66 151.97 109.75 151.97 111.39 144.26 117.31 144.26 115.67 151.97 119.76 151.97 123.54 134.17 119.44 134.17 117.9 141.39\" fill=\"#fff\" data-v-6ce06eca></polygon><path d=\"M136.57,134.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-6ce06eca></path><path d=\"M156.71,135.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,156.71,135.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,150.06,141.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-6ce06eca></path>", 7)
const EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_28 = [
  EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_21
]

function EIdHubvue_type_template_id_6ce06eca_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_1, EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_10, EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_20, EIdHubvue_type_template_id_6ce06eca_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/EIdHub.vue?vue&type=template&id=6ce06eca&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/EIdHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_EIdHubvue_type_script_lang_js = ({
    name: "EIdHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/EIdHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/EIdHub.vue?vue&type=style&index=0&id=6ce06eca&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/EIdHub.vue?vue&type=style&index=0&id=6ce06eca&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/EIdHub.vue




;


const Square_EIdHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_EIdHubvue_type_script_lang_js, [['render',EIdHubvue_type_template_id_6ce06eca_scoped_true_render],['__scopeId',"data-v-6ce06eca"]])

/* harmony default export */ var Square_EIdHub = (Square_EIdHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ExciseHub.vue?vue&type=template&id=5ba53f89&scoped=true


const ExciseHubvue_type_template_id_5ba53f89_scoped_true_withScopeId = n => (_pushScopeId("data-v-5ba53f89"),n=n(),_popScopeId(),n)
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-5ba53f89></polygon><path d=\"M62.71,172c-1.52,7.18-4.07,9.4-11.79,9.4l-8.53-.92-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.77,2.34,3.75,2.34H58.53l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a13.61,13.61,0,0,1,.33-2.83l2.17-10.16c1.41-6.63,6.74-9.89,14.57-9.89h2c6.9,0,10.7,2.34,10.7,7.28a11.76,11.76,0,0,1-.32,2.67Zm-8-3.31c0-1.69-.87-2.45-3.64-2.45H49.94c-3.64,0-4.94,2-5.6,4.95l-1.25,5.7h3.7c5.82,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,54.67,168.67Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M86.3,175.41,92,190.79h-9.3l-3.58-12.07H76.52l-8.15,12.07H60.11L72.17,175.3l-4.89-13.65h9.4l3.1,10.82H82l9-10.82h7.34Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M119.68,166.17h-6.52c-5.11,0-5.76,1.08-6.63,4.94l-2.18,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10.05c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><polygon points=\"121.29 144.94 115.38 144.94 116.91 137.73 112.82 137.73 109.05 155.53 113.14 155.53 114.78 147.82 120.7 147.82 119.06 155.53 123.15 155.53 126.92 137.73 122.83 137.73 121.29 144.94\" fill=\"#38d2dd\" data-v-5ba53f89></polygon><path d=\"M140,137.8l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44H134a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M160.09,139.39c-.86-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.09,139.39ZM153.45,145h-2.58c.22-1,.42-1.95.62-2.93l.28-1.36H154c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.45,145Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#38d2dd\" data-v-5ba53f89></path>", 7)
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_9 = [
  ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_2
]
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-5ba53f89></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M62.71,172c-1.52,7.18-4.07,9.4-11.79,9.4l-8.53-.92-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.77,2.34,3.75,2.34H58.53l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a13.61,13.61,0,0,1,.33-2.83l2.17-10.16c1.41-6.63,6.74-9.89,14.57-9.89h2c6.9,0,10.7,2.34,10.7,7.28a11.76,11.76,0,0,1-.32,2.67Zm-8-3.31c0-1.69-.87-2.45-3.64-2.45H49.94c-3.64,0-4.94,2-5.6,4.95l-1.25,5.7h3.7c5.82,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,54.67,168.67Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M86.3,175.41,92,190.79h-9.3l-3.58-12.07H76.52l-8.15,12.07H60.11L72.17,175.3l-4.89-13.65h9.4l3.1,10.82H82l9-10.82h7.34Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M119.68,166.17h-6.52c-5.11,0-5.76,1.08-6.63,4.94l-2.18,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10.05c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><polygon points=\"121.29 144.94 115.38 144.94 116.91 137.73 112.82 137.73 109.05 155.53 113.14 155.53 114.78 147.82 120.7 147.82 119.06 155.53 123.15 155.53 126.92 137.73 122.83 137.73 121.29 144.94\" fill=\"#38d2dd\" data-v-5ba53f89></polygon><path d=\"M140,137.8l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44H134a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#38d2dd\" data-v-5ba53f89></path><path d=\"M160.09,139.39c-.86-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.09,139.39ZM153.45,145h-2.58c.22-1,.42-1.95.62-2.93l.28-1.36H154c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.45,145Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#38d2dd\" data-v-5ba53f89></path>", 8)
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_19 = [
  ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_11
]
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#38d2dd\" data-v-5ba53f89></polygon><path d=\"M62.71,172c-1.52,7.18-4.07,9.4-11.79,9.4l-8.53-.92-.22.81a12.91,12.91,0,0,0-.44,2.61c0,1.42.77,2.34,3.75,2.34H58.53l-.87,4.13-13.59.87c-7.17,0-10.65-2.28-10.65-7.12a13.61,13.61,0,0,1,.33-2.83l2.17-10.16c1.41-6.63,6.74-9.89,14.57-9.89h2c6.9,0,10.7,2.34,10.7,7.28a11.76,11.76,0,0,1-.32,2.67Zm-8-3.31c0-1.69-.87-2.45-3.64-2.45H49.94c-3.64,0-4.94,2-5.6,4.95l-1.25,5.7h3.7c5.82,0,6.52-.92,7.55-5.76A11.06,11.06,0,0,0,54.67,168.67Z\" fill=\"#fff\" data-v-5ba53f89></path><path d=\"M86.3,175.41,92,190.79h-9.3l-3.58-12.07H76.52l-8.15,12.07H60.11L72.17,175.3l-4.89-13.65h9.4l3.1,10.82H82l9-10.82h7.34Z\" fill=\"#fff\" data-v-5ba53f89></path><path d=\"M119.68,166.17h-6.52c-5.11,0-5.76,1.08-6.63,4.94l-2.18,10.27a14,14,0,0,0-.38,2.67c0,1.68,1.09,2.17,4.73,2.17h6.63l-.87,4.29-7.06.71c-6.31,0-12-1-12-7.23a13.09,13.09,0,0,1,.33-2.72l2.17-10.05c2.07-9,9.68-10,15.87-10l6.85.71Z\" fill=\"#fff\" data-v-5ba53f89></path><polygon points=\"121.29 144.94 115.38 144.94 116.91 137.73 112.82 137.73 109.05 155.53 113.14 155.53 114.78 147.82 120.7 147.82 119.06 155.53 123.15 155.53 126.92 137.73 122.83 137.73 121.29 144.94\" fill=\"#fff\" data-v-5ba53f89></polygon><path d=\"M140,137.8l-2.72,12.86c-.37,1.75-1.24,2.44-3.1,2.44H134a2.27,2.27,0,0,1-1.82-.55,2.14,2.14,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-5ba53f89></path><path d=\"M160.09,139.39c-.86-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A3.92,3.92,0,0,0,160.09,139.39ZM153.45,145h-2.58c.22-1,.42-1.95.62-2.93l.28-1.36H154c.87,0,1.4.14,1.63.42a2,2,0,0,1,.1,1.58l-.15.76A2,2,0,0,1,153.45,145Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1.05,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-5ba53f89></path>", 7)
const ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_28 = [
  ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_21
]

function ExciseHubvue_type_template_id_5ba53f89_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_1, ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_10, ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_20, ExciseHubvue_type_template_id_5ba53f89_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExciseHub.vue?vue&type=template&id=5ba53f89&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ExciseHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_ExciseHubvue_type_script_lang_js = ({
    name: "ExciseHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExciseHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ExciseHub.vue?vue&type=style&index=0&id=5ba53f89&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExciseHub.vue?vue&type=style&index=0&id=5ba53f89&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExciseHub.vue




;


const Square_ExciseHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_ExciseHubvue_type_script_lang_js, [['render',ExciseHubvue_type_template_id_5ba53f89_scoped_true_render],['__scopeId',"data-v-5ba53f89"]])

/* harmony default export */ var Square_ExciseHub = (Square_ExciseHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ExpertHub.vue?vue&type=template&id=2bb39d22&scoped=true


const ExpertHubvue_type_template_id_2bb39d22_scoped_true_withScopeId = n => (_pushScopeId("data-v-2bb39d22"),n=n(),_popScopeId(),n)
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-2bb39d22></polygon><path d=\"M58.64,172.81c-1.41,6.65-3.78,8.72-10.93,8.72l-7.91-.86-.2.76a12.23,12.23,0,0,0-.41,2.42c0,1.31.71,2.16,3.48,2.16H54.76l-.8,3.83-12.6.81c-6.65,0-9.87-2.12-9.87-6.6a12.77,12.77,0,0,1,.3-2.62l2-9.42c1.31-6.15,6.25-9.17,13.51-9.17h1.86c6.4,0,9.93,2.16,9.93,6.75a10.63,10.63,0,0,1-.31,2.47Zm-7.45-3.07c0-1.56-.81-2.27-3.38-2.27h-1c-3.37,0-4.58,1.82-5.19,4.59l-1.16,5.29h3.43c5.39,0,6-.86,7-5.34A10.67,10.67,0,0,0,51.19,169.74Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M80.5,176l5.25,14.26H77.13L73.8,179.06H71.44l-7.56,11.19H56.22l11.19-14.36-4.54-12.65h8.72l2.87,10h2.06l8.37-10h6.8Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M116.17,181.43c-1.56,7.36-7.1,9-11.18,9.12l-7.91-.91c-1.77,8.26-2.47,8.87-9.58,8.92l3.63-17.08.35-1.71,3.43-16,13.55-1c6.25,0,10,2.26,10,6.9a12.17,12.17,0,0,1-.25,2.22Zm-5.89-9.22a10.1,10.1,0,0,0,.25-2c0-1.71-.91-2.47-3.58-2.47h-5L98,185.91h5.09c3.63,0,4.54-1.46,5.19-4.53Z\" fill=\"#e83158\" data-v-2bb39d22></path><polygon points=\"123.06 146.45 117.14 146.45 118.67 139.26 114.57 139.26 110.8 157.06 114.89 157.06 116.54 149.34 122.45 149.34 120.81 157.06 124.91 157.06 128.68 139.26 124.58 139.26 123.06 146.45\" fill=\"#e83158\" data-v-2bb39d22></polygon><path d=\"M141.71,139.33,139,152.18c-.37,1.76-1.23,2.45-3.1,2.45h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.16-1.8l2.75-12.95H132l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.62,7.55-4.84l2.75-12.95Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M161.85,140.92c-.86-1.06-2.5-1.58-5-1.58h-7.46L145.64,157h7.81c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.83,2.83,0,0,0-.91-.84,4.61,4.61,0,0,0,2.76-3.71A3.9,3.9,0,0,0,161.85,140.92Zm-6.64,5.55h-2.58c.22-1,.41-1.95.62-2.92l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.75A1.94,1.94,0,0,1,155.21,146.47Zm-.23,2.87a1.25,1.25,0,0,1,1,.43,1.08,1.08,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14H151l1-4.74Z\" fill=\"#e83158\" data-v-2bb39d22></path>", 7)
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_9 = [
  ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_2
]
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-2bb39d22></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M58.64,172.81c-1.41,6.65-3.78,8.72-10.93,8.72l-7.91-.86-.2.76a12.23,12.23,0,0,0-.41,2.42c0,1.31.71,2.16,3.48,2.16H54.76l-.8,3.83-12.6.81c-6.65,0-9.87-2.12-9.87-6.6a12.77,12.77,0,0,1,.3-2.62l2-9.42c1.31-6.15,6.25-9.17,13.51-9.17h1.86c6.4,0,9.93,2.16,9.93,6.75a10.63,10.63,0,0,1-.31,2.47Zm-7.45-3.07c0-1.56-.81-2.27-3.38-2.27h-1c-3.37,0-4.58,1.82-5.19,4.59l-1.16,5.29h3.43c5.39,0,6-.86,7-5.34A10.67,10.67,0,0,0,51.19,169.74Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M80.5,176l5.25,14.26H77.13L73.8,179.06H71.44l-7.56,11.19H56.22l11.19-14.36-4.54-12.65h8.72l2.87,10h2.06l8.37-10h6.8Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M116.17,181.43c-1.56,7.36-7.1,9-11.18,9.12l-7.91-.91c-1.77,8.26-2.47,8.87-9.58,8.92l3.63-17.08.35-1.71,3.43-16,13.55-1c6.25,0,10,2.26,10,6.9a12.17,12.17,0,0,1-.25,2.22Zm-5.89-9.22a10.1,10.1,0,0,0,.25-2c0-1.71-.91-2.47-3.58-2.47h-5L98,185.91h5.09c3.63,0,4.54-1.46,5.19-4.53Z\" fill=\"#e83158\" data-v-2bb39d22></path><polygon points=\"123.06 146.45 117.14 146.45 118.67 139.26 114.57 139.26 110.8 157.06 114.89 157.06 116.54 149.34 122.45 149.34 120.81 157.06 124.91 157.06 128.68 139.26 124.58 139.26 123.06 146.45\" fill=\"#e83158\" data-v-2bb39d22></polygon><path d=\"M141.71,139.33,139,152.18c-.37,1.76-1.23,2.45-3.1,2.45h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.16-1.8l2.75-12.95H132l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.62,7.55-4.84l2.75-12.95Z\" fill=\"#e83158\" data-v-2bb39d22></path><path d=\"M161.85,140.92c-.86-1.06-2.5-1.58-5-1.58h-7.46L145.64,157h7.81c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.83,2.83,0,0,0-.91-.84,4.61,4.61,0,0,0,2.76-3.71A3.9,3.9,0,0,0,161.85,140.92Zm-6.64,5.55h-2.58c.22-1,.41-1.95.62-2.92l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.75A1.94,1.94,0,0,1,155.21,146.47Zm-.23,2.87a1.25,1.25,0,0,1,1,.43,1.08,1.08,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14H151l1-4.74Z\" fill=\"#e83158\" data-v-2bb39d22></path>", 8)
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_19 = [
  ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_11
]
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e83158\" data-v-2bb39d22></polygon><path d=\"M58.64,172.81c-1.41,6.65-3.78,8.72-10.93,8.72l-7.91-.86-.2.76a12.23,12.23,0,0,0-.41,2.42c0,1.31.71,2.16,3.48,2.16H54.76l-.8,3.83-12.6.81c-6.65,0-9.87-2.12-9.87-6.6a12.77,12.77,0,0,1,.3-2.62l2-9.42c1.31-6.15,6.25-9.17,13.51-9.17h1.86c6.4,0,9.93,2.16,9.93,6.75a10.63,10.63,0,0,1-.31,2.47Zm-7.45-3.07c0-1.56-.81-2.27-3.38-2.27h-1c-3.37,0-4.58,1.82-5.19,4.59l-1.16,5.29h3.43c5.39,0,6-.86,7-5.34A10.67,10.67,0,0,0,51.19,169.74Z\" fill=\"#fff\" data-v-2bb39d22></path><path d=\"M80.5,176l5.25,14.26H77.13L73.8,179.06H71.44l-7.56,11.19H56.22l11.19-14.36-4.54-12.65h8.72l2.87,10h2.06l8.37-10h6.8Z\" fill=\"#fff\" data-v-2bb39d22></path><path d=\"M116.17,181.43c-1.56,7.36-7.1,9-11.18,9.12l-7.91-.91c-1.77,8.26-2.47,8.87-9.58,8.92l3.63-17.08.35-1.71,3.43-16,13.55-1c6.25,0,10,2.26,10,6.9a12.17,12.17,0,0,1-.25,2.22Zm-5.89-9.22a10.1,10.1,0,0,0,.25-2c0-1.71-.91-2.47-3.58-2.47h-5L98,185.91h5.09c3.63,0,4.54-1.46,5.19-4.53Z\" fill=\"#fff\" data-v-2bb39d22></path><polygon points=\"123.06 146.45 117.14 146.45 118.67 139.26 114.57 139.26 110.8 157.06 114.89 157.06 116.54 149.34 122.45 149.34 120.81 157.06 124.91 157.06 128.68 139.26 124.58 139.26 123.06 146.45\" fill=\"#fff\" data-v-2bb39d22></polygon><path d=\"M141.71,139.33,139,152.18c-.37,1.76-1.23,2.45-3.1,2.45h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.16-1.8l2.75-12.95H132l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.62,7.55-4.84l2.75-12.95Z\" fill=\"#fff\" data-v-2bb39d22></path><path d=\"M161.85,140.92c-.86-1.06-2.5-1.58-5-1.58h-7.46L145.64,157h7.81c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.83,2.83,0,0,0-.91-.84,4.61,4.61,0,0,0,2.76-3.71A3.9,3.9,0,0,0,161.85,140.92Zm-6.64,5.55h-2.58c.22-1,.41-1.95.62-2.92l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.75A1.94,1.94,0,0,1,155.21,146.47Zm-.23,2.87a1.25,1.25,0,0,1,1,.43,1.08,1.08,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14H151l1-4.74Z\" fill=\"#fff\" data-v-2bb39d22></path>", 7)
const ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_28 = [
  ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_21
]

function ExpertHubvue_type_template_id_2bb39d22_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_1, ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_10, ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_20, ExpertHubvue_type_template_id_2bb39d22_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExpertHub.vue?vue&type=template&id=2bb39d22&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ExpertHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_ExpertHubvue_type_script_lang_js = ({
    name: "ExpertHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExpertHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ExpertHub.vue?vue&type=style&index=0&id=2bb39d22&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExpertHub.vue?vue&type=style&index=0&id=2bb39d22&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ExpertHub.vue




;


const Square_ExpertHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_ExpertHubvue_type_script_lang_js, [['render',ExpertHubvue_type_template_id_2bb39d22_scoped_true_render],['__scopeId',"data-v-2bb39d22"]])

/* harmony default export */ var Square_ExpertHub = (Square_ExpertHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/FinanceHub.vue?vue&type=template&id=22f0a955&scoped=true


const FinanceHubvue_type_template_id_22f0a955_scoped_true_withScopeId = n => (_pushScopeId("data-v-22f0a955"),n=n(),_popScopeId(),n)
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-22f0a955></polygon><path d=\"M63.44,157.42H59c-5,0-5.38,1.52-5.55,2.28s-.32,1.31-.43,2h8.2l-.81,3.92-8.48,1-5.16,24.13c-1.8,8.42-1.91,8.75-10.11,8.75l8.31-39c1.47-6.9,6.85-7.88,11.74-7.88l7.5.59Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M69,190.85H60.72l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.23,1.14,4,2.33Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M102.19,190.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63l2.12-9.73a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.7-2.55H88.88l-5.17,24.19H75.23l6.09-28.54,14.79-1c6.84,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#136389\" data-v-22f0a955></path><polygon points=\"115.57 144.89 109.65 144.89 111.19 137.67 107.09 137.67 103.32 155.47 107.42 155.47 109.06 147.76 114.97 147.76 113.33 155.47 117.42 155.47 121.2 137.67 117.1 137.67 115.57 144.89\" fill=\"#136389\" data-v-22f0a955></polygon><path d=\"M134.23,137.74,131.5,150.6c-.37,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.13,2.13,0,0,1-.16-1.79l2.75-13h-4.48l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M154.37,139.33c-.86-1.06-2.5-1.57-5-1.57H141.9l-3.74,17.63H146c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,154.37,139.33Zm-6.64,5.56h-2.58c.22-1,.41-1.95.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,147.73,144.89Zm-.23,2.87a1.25,1.25,0,0,1,1,.42,1.09,1.09,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#136389\" data-v-22f0a955></path>", 7)
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_9 = [
  FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_2
]
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-22f0a955></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M63.44,157.42H59c-5,0-5.38,1.52-5.55,2.28s-.32,1.31-.43,2h8.2l-.81,3.92-8.48,1-5.16,24.13c-1.8,8.42-1.91,8.75-10.11,8.75l8.31-39c1.47-6.9,6.85-7.88,11.74-7.88l7.5.59Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M69,190.85H60.72l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.23,1.14,4,2.33Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M102.19,190.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63l2.12-9.73a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.7-2.55H88.88l-5.17,24.19H75.23l6.09-28.54,14.79-1c6.84,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#136389\" data-v-22f0a955></path><polygon points=\"115.57 144.89 109.65 144.89 111.19 137.67 107.09 137.67 103.32 155.47 107.42 155.47 109.06 147.76 114.97 147.76 113.33 155.47 117.42 155.47 121.2 137.67 117.1 137.67 115.57 144.89\" fill=\"#136389\" data-v-22f0a955></polygon><path d=\"M134.23,137.74,131.5,150.6c-.37,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.13,2.13,0,0,1-.16-1.79l2.75-13h-4.48l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#136389\" data-v-22f0a955></path><path d=\"M154.37,139.33c-.86-1.06-2.5-1.57-5-1.57H141.9l-3.74,17.63H146c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,154.37,139.33Zm-6.64,5.56h-2.58c.22-1,.41-1.95.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,147.73,144.89Zm-.23,2.87a1.25,1.25,0,0,1,1,.42,1.09,1.09,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#136389\" data-v-22f0a955></path>", 8)
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_19 = [
  FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_11
]
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#136389\" data-v-22f0a955></polygon><path d=\"M63.44,157.42H59c-5,0-5.38,1.52-5.55,2.28s-.32,1.31-.43,2h8.2l-.81,3.92-8.48,1-5.16,24.13c-1.8,8.42-1.91,8.75-10.11,8.75l8.31-39c1.47-6.9,6.85-7.88,11.74-7.88l7.5.59Z\" fill=\"#fff\" data-v-22f0a955></path><path d=\"M69,190.85H60.72l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.23,1.14,4,2.33Z\" fill=\"#fff\" data-v-22f0a955></path><path d=\"M102.19,190.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63l2.12-9.73a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.7-2.55H88.88l-5.17,24.19H75.23l6.09-28.54,14.79-1c6.84,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#fff\" data-v-22f0a955></path><polygon points=\"115.57 144.89 109.65 144.89 111.19 137.67 107.09 137.67 103.32 155.47 107.42 155.47 109.06 147.76 114.97 147.76 113.33 155.47 117.42 155.47 121.2 137.67 117.1 137.67 115.57 144.89\" fill=\"#fff\" data-v-22f0a955></polygon><path d=\"M134.23,137.74,131.5,150.6c-.37,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.13,2.13,0,0,1-.16-1.79l2.75-13h-4.48l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-22f0a955></path><path d=\"M154.37,139.33c-.86-1.06-2.5-1.57-5-1.57H141.9l-3.74,17.63H146c4.26,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,154.37,139.33Zm-6.64,5.56h-2.58c.22-1,.41-1.95.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,147.73,144.89Zm-.23,2.87a1.25,1.25,0,0,1,1,.42,1.09,1.09,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-22f0a955></path>", 7)
const FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_28 = [
  FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_21
]

function FinanceHubvue_type_template_id_22f0a955_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_1, FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_10, FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_20, FinanceHubvue_type_template_id_22f0a955_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/FinanceHub.vue?vue&type=template&id=22f0a955&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/FinanceHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_FinanceHubvue_type_script_lang_js = ({
    name: "FinanceHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/FinanceHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/FinanceHub.vue?vue&type=style&index=0&id=22f0a955&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/FinanceHub.vue?vue&type=style&index=0&id=22f0a955&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/FinanceHub.vue




;


const Square_FinanceHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_FinanceHubvue_type_script_lang_js, [['render',FinanceHubvue_type_template_id_22f0a955_scoped_true_render],['__scopeId',"data-v-22f0a955"]])

/* harmony default export */ var Square_FinanceHub = (Square_FinanceHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/IntrastatHub.vue?vue&type=template&id=292ff240&scoped=true


const IntrastatHubvue_type_template_id_292ff240_scoped_true_withScopeId = n => (_pushScopeId("data-v-292ff240"),n=n(),_popScopeId(),n)
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-292ff240></polygon><path d=\"M49.2,192.85H40.88l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.24,1.14,4,2.33Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M82.35,192.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63L78,173.55a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.69-2.55H69l-5.16,24.19H55.4l6.08-28.54,14.79-1c6.85,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M111.11,168l-9.89.87-3.1,14.68a10.2,10.2,0,0,0-.33,2.33c0,1.69.87,2.5,3.7,2.5h5.22l-.93,4.46-5.38.54c-7.34,0-11.09-1.84-11.09-6.9a16.74,16.74,0,0,1,.38-3l4.19-19.56c4.08-.55,4.78-1.85,5.65-5h3.86l-1,4.83H112Z\" fill=\"#65adc1\" data-v-292ff240></path><polygon points=\"112.9 142.89 106.99 142.89 108.53 135.67 104.43 135.67 100.66 153.47 104.75 153.47 106.39 145.76 112.31 145.76 110.67 153.47 114.76 153.47 118.54 135.67 114.44 135.67 112.9 142.89\" fill=\"#65adc1\" data-v-292ff240></polygon><path d=\"M131.57,135.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M151.71,137.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,151.71,137.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,145.06,142.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#65adc1\" data-v-292ff240></path>", 7)
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_9 = [
  IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_2
]
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-292ff240></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M49.2,192.85H40.88l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.24,1.14,4,2.33Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M82.35,192.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63L78,173.55a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.69-2.55H69l-5.16,24.19H55.4l6.08-28.54,14.79-1c6.85,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M111.11,168l-9.89.87-3.1,14.68a10.2,10.2,0,0,0-.33,2.33c0,1.69.87,2.5,3.7,2.5h5.22l-.93,4.46-5.38.54c-7.34,0-11.09-1.84-11.09-6.9a16.74,16.74,0,0,1,.38-3l4.19-19.56c4.08-.55,4.78-1.85,5.65-5h3.86l-1,4.83H112Z\" fill=\"#65adc1\" data-v-292ff240></path><polygon points=\"112.9 142.89 106.99 142.89 108.53 135.67 104.43 135.67 100.66 153.47 104.75 153.47 106.39 145.76 112.31 145.76 110.67 153.47 114.76 153.47 118.54 135.67 114.44 135.67 112.9 142.89\" fill=\"#65adc1\" data-v-292ff240></polygon><path d=\"M131.57,135.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#65adc1\" data-v-292ff240></path><path d=\"M151.71,137.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,151.71,137.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,145.06,142.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#65adc1\" data-v-292ff240></path>", 8)
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_19 = [
  IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_11
]
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#65adc1\" data-v-292ff240></polygon><path d=\"M49.2,192.85H40.88l6.2-29.14h8.31Zm7.88-34c-.27,1.19-1.85,2.22-4.84,2.22h-.87c-3.1,0-4.29-1-4-2.28l.49-2.34c.28-1.14,1.85-2.22,4.84-2.22h.82c3,0,4.24,1.14,4,2.33Z\" fill=\"#fff\" data-v-292ff240></path><path d=\"M82.35,192.85c-5.76,0-7.61,0-7.61-2.94a41.06,41.06,0,0,1,1.15-6.63L78,173.55a14.24,14.24,0,0,0,.32-2.34c0-1.74-.92-2.55-3.69-2.55H69l-5.16,24.19H55.4l6.08-28.54,14.79-1c6.85,0,10.54,2.39,10.54,7.34a11,11,0,0,1-.27,2.6Z\" fill=\"#fff\" data-v-292ff240></path><path d=\"M111.11,168l-9.89.87-3.1,14.68a10.2,10.2,0,0,0-.33,2.33c0,1.69.87,2.5,3.7,2.5h5.22l-.93,4.46-5.38.54c-7.34,0-11.09-1.84-11.09-6.9a16.74,16.74,0,0,1,.38-3l4.19-19.56c4.08-.55,4.78-1.85,5.65-5h3.86l-1,4.83H112Z\" fill=\"#fff\" data-v-292ff240></path><polygon points=\"112.9 142.89 106.99 142.89 108.53 135.67 104.43 135.67 100.66 153.47 104.75 153.47 106.39 145.76 112.31 145.76 110.67 153.47 114.76 153.47 118.54 135.67 114.44 135.67 112.9 142.89\" fill=\"#fff\" data-v-292ff240></polygon><path d=\"M131.57,135.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-292ff240></path><path d=\"M151.71,137.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,151.71,137.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,145.06,142.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-292ff240></path>", 7)
const IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_28 = [
  IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_21
]

function IntrastatHubvue_type_template_id_292ff240_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_1, IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_10, IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_20, IntrastatHubvue_type_template_id_292ff240_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/IntrastatHub.vue?vue&type=template&id=292ff240&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/IntrastatHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_IntrastatHubvue_type_script_lang_js = ({
    name: "IntrastatHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/IntrastatHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/IntrastatHub.vue?vue&type=style&index=0&id=292ff240&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/IntrastatHub.vue?vue&type=style&index=0&id=292ff240&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/IntrastatHub.vue




;


const Square_IntrastatHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_IntrastatHubvue_type_script_lang_js, [['render',IntrastatHubvue_type_template_id_292ff240_scoped_true_render],['__scopeId',"data-v-292ff240"]])

/* harmony default export */ var Square_IntrastatHub = (Square_IntrastatHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/InvoiceHub.vue?vue&type=template&id=5a77b43c&scoped=true


const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_withScopeId = n => (_pushScopeId("data-v-5a77b43c"),n=n(),_popScopeId(),n)
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-5a77b43c></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M42.08,190.74H33.66l6.27-29.48h8.42Zm8-34.37c-.27,1.2-1.87,2.25-4.89,2.25h-.88c-3.14,0-4.35-1.05-4-2.31l.5-2.37c.27-1.15,1.87-2.25,4.89-2.25h.83c3.08,0,4.29,1.15,4.07,2.36Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M75.63,190.74c-5.83,0-7.7,0-7.7-3a42.34,42.34,0,0,1,1.16-6.71l2.14-9.84a13.77,13.77,0,0,0,.33-2.37c0-1.76-.93-2.58-3.74-2.58H62.16l-5.23,24.47H48.35l6.16-28.87,15-1.05c6.93,0,10.67,2.42,10.67,7.43a11.38,11.38,0,0,1-.27,2.64Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M97.86,190.74H85.59l-1.87-29.48h9l.33,23.49h2.48l10.23-23.49h7.48Z\" fill=\"#8b85db\" data-v-5a77b43c></path><polygon points=\"120.15 144.82 114.24 144.82 115.77 137.61 111.67 137.61 107.9 155.41 111.99 155.41 113.64 147.7 119.55 147.7 117.91 155.41 122 155.41 125.78 137.61 121.68 137.61 120.15 144.82\" fill=\"#8b85db\" data-v-5a77b43c></polygon><path d=\"M138.81,137.68l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.18,2.18,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63H133c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M159,139.27c-.86-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.64h7.8c4.27,0,6.78-1.63,7.44-4.84a4.23,4.23,0,0,0-.34-3.24,2.83,2.83,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.92,3.92,0,0,0,159,139.27Zm-6.65,5.55h-2.57c.21-1,.41-1.94.61-2.92l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A1.94,1.94,0,0,1,152.3,144.82Zm-.22,2.88a1.26,1.26,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#8b85db\" data-v-5a77b43c></path>", 8)
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_10 = [
  InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_2
]
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_11 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-5a77b43c></polygon><path d=\"M42.08,190.74H33.66l6.27-29.48h8.42Zm8-34.37c-.27,1.2-1.87,2.25-4.89,2.25h-.88c-3.14,0-4.35-1.05-4-2.31l.5-2.37c.27-1.15,1.87-2.25,4.89-2.25h.83c3.08,0,4.29,1.15,4.07,2.36Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M75.63,190.74c-5.83,0-7.7,0-7.7-3a42.34,42.34,0,0,1,1.16-6.71l2.14-9.84a13.77,13.77,0,0,0,.33-2.37c0-1.76-.93-2.58-3.74-2.58H62.16l-5.23,24.47H48.35l6.16-28.87,15-1.05c6.93,0,10.67,2.42,10.67,7.43a11.38,11.38,0,0,1-.27,2.64Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M97.86,190.74H85.59l-1.87-29.48h9l.33,23.49h2.48l10.23-23.49h7.48Z\" fill=\"#8b85db\" data-v-5a77b43c></path><polygon points=\"120.15 144.82 114.24 144.82 115.77 137.61 111.67 137.61 107.9 155.41 111.99 155.41 113.64 147.7 119.55 147.7 117.91 155.41 122 155.41 125.78 137.61 121.68 137.61 120.15 144.82\" fill=\"#8b85db\" data-v-5a77b43c></polygon><path d=\"M138.81,137.68l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.18,2.18,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63H133c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#8b85db\" data-v-5a77b43c></path><path d=\"M159,139.27c-.86-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.64h7.8c4.27,0,6.78-1.63,7.44-4.84a4.23,4.23,0,0,0-.34-3.24,2.83,2.83,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.92,3.92,0,0,0,159,139.27Zm-6.65,5.55h-2.57c.21-1,.41-1.94.61-2.92l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A1.94,1.94,0,0,1,152.3,144.82Zm-.22,2.88a1.26,1.26,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#8b85db\" data-v-5a77b43c></path>", 7)
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_19 = [
  InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_12
]
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#8b85db\" data-v-5a77b43c></polygon><path d=\"M42.08,190.74H33.66l6.27-29.48h8.42Zm8-34.37c-.27,1.2-1.87,2.25-4.89,2.25h-.88c-3.14,0-4.35-1.05-4-2.31l.5-2.37c.27-1.15,1.87-2.25,4.89-2.25h.83c3.08,0,4.29,1.15,4.07,2.36Z\" fill=\"#fff\" data-v-5a77b43c></path><path d=\"M75.63,190.74c-5.83,0-7.7,0-7.7-3a42.34,42.34,0,0,1,1.16-6.71l2.14-9.84a13.77,13.77,0,0,0,.33-2.37c0-1.76-.93-2.58-3.74-2.58H62.16l-5.23,24.47H48.35l6.16-28.87,15-1.05c6.93,0,10.67,2.42,10.67,7.43a11.38,11.38,0,0,1-.27,2.64Z\" fill=\"#fff\" data-v-5a77b43c></path><path d=\"M97.86,190.74H85.59l-1.87-29.48h9l.33,23.49h2.48l10.23-23.49h7.48Z\" fill=\"#fff\" data-v-5a77b43c></path><polygon points=\"120.15 144.82 114.24 144.82 115.77 137.61 111.67 137.61 107.9 155.41 111.99 155.41 113.64 147.7 119.55 147.7 117.91 155.41 122 155.41 125.78 137.61 121.68 137.61 120.15 144.82\" fill=\"#fff\" data-v-5a77b43c></polygon><path d=\"M138.81,137.68l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.18,2.18,0,0,1-.17-1.8l2.75-12.95h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63H133c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-5a77b43c></path><path d=\"M159,139.27c-.86-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.64h7.8c4.27,0,6.78-1.63,7.44-4.84a4.23,4.23,0,0,0-.34-3.24,2.83,2.83,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.92,3.92,0,0,0,159,139.27Zm-6.65,5.55h-2.57c.21-1,.41-1.94.61-2.92l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A1.94,1.94,0,0,1,152.3,144.82Zm-.22,2.88a1.26,1.26,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-5a77b43c></path>", 7)
const InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_28 = [
  InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_21
]

function InvoiceHubvue_type_template_id_5a77b43c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='outlined')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_1, InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_10))
    : ($props.version==='inverted')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_11, InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_20, InvoiceHubvue_type_template_id_5a77b43c_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/InvoiceHub.vue?vue&type=template&id=5a77b43c&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/InvoiceHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_InvoiceHubvue_type_script_lang_js = ({
    name: "InvoiceHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/InvoiceHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/InvoiceHub.vue?vue&type=style&index=0&id=5a77b43c&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/InvoiceHub.vue?vue&type=style&index=0&id=5a77b43c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/InvoiceHub.vue




;


const Square_InvoiceHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_InvoiceHubvue_type_script_lang_js, [['render',InvoiceHubvue_type_template_id_5a77b43c_scoped_true_render],['__scopeId',"data-v-5a77b43c"]])

/* harmony default export */ var Square_InvoiceHub = (Square_InvoiceHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/MergerHub.vue?vue&type=template&id=81055bd8&scoped=true


const MergerHubvue_type_template_id_81055bd8_scoped_true_withScopeId = n => (_pushScopeId("data-v-81055bd8"),n=n(),_popScopeId(),n)
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-81055bd8></polygon><path d=\"M70.14,191.35c-5.66,0-7.51,0-7.51-2.94A41.63,41.63,0,0,1,63.72,182l2.18-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.7-2.61h-6a12.39,12.39,0,0,1,.43,3,9.13,9.13,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.93,13.37H44.05l4.13-19.46a13.76,13.76,0,0,0,.32-2.28c0-1.69-.92-2.45-3.69-2.45h-5L34.7,191.35H26.38l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a11.42,11.42,0,0,1-.27,2.55Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M102,173.63h-6.3a16.51,16.51,0,0,0,.43-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7L83,191.35H74.7l6.09-28.59,13.53-1.09c5.66,0,9.35,2.88,9.35,6.58a7.28,7.28,0,0,1-.49,2.39Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M128.79,192.05c-1.25,5.44-4.95,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.2,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a10.86,10.86,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.57-9.84,14.51-9.84h2c6.9,0,10.71,2.34,10.71,7.34a11.56,11.56,0,0,1-.27,2.56Zm-12.51-5.22h5.28l3.31-15.27a10.24,10.24,0,0,0,.27-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C112.37,186.07,113.29,186.83,116.28,186.83Z\" fill=\"#b81d58\" data-v-81055bd8></path><polygon points=\"127.4 144.39 121.49 144.39 123.03 137.17 118.93 137.17 115.16 154.97 119.25 154.97 120.89 147.26 126.81 147.26 125.17 154.97 129.26 154.97 133.04 137.17 128.94 137.17 127.4 144.39\" fill=\"#b81d58\" data-v-81055bd8></polygon><path d=\"M146.07,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M166.21,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46L150,154.89h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,166.21,138.83Zm-6.65,5.56H157c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,159.56,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#b81d58\" data-v-81055bd8></path>", 7)
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_9 = [
  MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_2
]
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-81055bd8></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M70.14,191.35c-5.66,0-7.51,0-7.51-2.94A41.63,41.63,0,0,1,63.72,182l2.18-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.7-2.61h-6a12.39,12.39,0,0,1,.43,3,9.13,9.13,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.93,13.37H44.05l4.13-19.46a13.76,13.76,0,0,0,.32-2.28c0-1.69-.92-2.45-3.69-2.45h-5L34.7,191.35H26.38l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a11.42,11.42,0,0,1-.27,2.55Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M102,173.63h-6.3a16.51,16.51,0,0,0,.43-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7L83,191.35H74.7l6.09-28.59,13.53-1.09c5.66,0,9.35,2.88,9.35,6.58a7.28,7.28,0,0,1-.49,2.39Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M128.79,192.05c-1.25,5.44-4.95,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.2,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a10.86,10.86,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.57-9.84,14.51-9.84h2c6.9,0,10.71,2.34,10.71,7.34a11.56,11.56,0,0,1-.27,2.56Zm-12.51-5.22h5.28l3.31-15.27a10.24,10.24,0,0,0,.27-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C112.37,186.07,113.29,186.83,116.28,186.83Z\" fill=\"#b81d58\" data-v-81055bd8></path><polygon points=\"127.4 144.39 121.49 144.39 123.03 137.17 118.93 137.17 115.16 154.97 119.25 154.97 120.89 147.26 126.81 147.26 125.17 154.97 129.26 154.97 133.04 137.17 128.94 137.17 127.4 144.39\" fill=\"#b81d58\" data-v-81055bd8></polygon><path d=\"M146.07,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#b81d58\" data-v-81055bd8></path><path d=\"M166.21,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46L150,154.89h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,166.21,138.83Zm-6.65,5.56H157c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,159.56,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#b81d58\" data-v-81055bd8></path>", 8)
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_19 = [
  MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_11
]
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#b81d58\" data-v-81055bd8></polygon><path d=\"M70.14,191.35c-5.66,0-7.51,0-7.51-2.94A41.63,41.63,0,0,1,63.72,182l2.18-10.11a13.16,13.16,0,0,0,.27-2.28c0-1.74-.87-2.61-3.7-2.61h-6a12.39,12.39,0,0,1,.43,3,9.13,9.13,0,0,1-.27,2.12c-.38,1.63-.76,3.69-1.25,5.87-1,4.29-2,9.07-2.93,13.37H44.05l4.13-19.46a13.76,13.76,0,0,0,.32-2.28c0-1.69-.92-2.45-3.69-2.45h-5L34.7,191.35H26.38l6.09-28.48,14-1a19.85,19.85,0,0,1,7.61,1.52l10.11-1.68c6.74.05,10.49,2.39,10.49,7.34a11.42,11.42,0,0,1-.27,2.55Z\" fill=\"#fff\" data-v-81055bd8></path><path d=\"M102,173.63h-6.3a16.51,16.51,0,0,0,.43-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7L83,191.35H74.7l6.09-28.59,13.53-1.09c5.66,0,9.35,2.88,9.35,6.58a7.28,7.28,0,0,1-.49,2.39Z\" fill=\"#fff\" data-v-81055bd8></path><path d=\"M128.79,192.05c-1.25,5.44-4.95,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.2,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a10.86,10.86,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.57-9.84,14.51-9.84h2c6.9,0,10.71,2.34,10.71,7.34a11.56,11.56,0,0,1-.27,2.56Zm-12.51-5.22h5.28l3.31-15.27a10.24,10.24,0,0,0,.27-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C112.37,186.07,113.29,186.83,116.28,186.83Z\" fill=\"#fff\" data-v-81055bd8></path><polygon points=\"127.4 144.39 121.49 144.39 123.03 137.17 118.93 137.17 115.16 154.97 119.25 154.97 120.89 147.26 126.81 147.26 125.17 154.97 129.26 154.97 133.04 137.17 128.94 137.17 127.4 144.39\" fill=\"#fff\" data-v-81055bd8></polygon><path d=\"M146.07,137.24l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-81055bd8></path><path d=\"M166.21,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46L150,154.89h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.6,4.6,0,0,0,2.76-3.7A4,4,0,0,0,166.21,138.83Zm-6.65,5.56H157c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,159.56,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-81055bd8></path>", 7)
const MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_28 = [
  MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_21
]

function MergerHubvue_type_template_id_81055bd8_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_1, MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_10, MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_20, MergerHubvue_type_template_id_81055bd8_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/MergerHub.vue?vue&type=template&id=81055bd8&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/MergerHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_MergerHubvue_type_script_lang_js = ({
    name: "MergerHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/MergerHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/MergerHub.vue?vue&type=style&index=0&id=81055bd8&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/MergerHub.vue?vue&type=style&index=0&id=81055bd8&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/MergerHub.vue




;


const Square_MergerHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_MergerHubvue_type_script_lang_js, [['render',MergerHubvue_type_template_id_81055bd8_scoped_true_render],['__scopeId',"data-v-81055bd8"]])

/* harmony default export */ var Square_MergerHub = (Square_MergerHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/PackagingHub.vue?vue&type=template&id=2cf39f23&scoped=true


const PackagingHubvue_type_template_id_2cf39f23_scoped_true_withScopeId = n => (_pushScopeId("data-v-2cf39f23"),n=n(),_popScopeId(),n)
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-2cf39f23></polygon><path d=\"M59.1,181.83c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H43.71l-4.18,19.56H45c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M70.24,191.35H61.92l8.1-38.1c5.6,0,7.45,0,7.45,2.93a37.74,37.74,0,0,1-1,6.25Zm12.39-18,8.43,18H81L74.86,175.8l.71-3.21,11.74-10.38h9.62Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M118.78,192.05c-1.25,5.44-5,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a11.42,11.42,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.58-9.84,14.51-9.84h2c6.91,0,10.71,2.34,10.71,7.34a11,11,0,0,1-.27,2.56Zm-12.5-5.22h5.27l3.31-15.27a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C102.36,186.07,103.29,186.83,106.28,186.83Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><polygon points=\"124.09 144.39 118.18 144.39 119.72 137.17 115.62 137.17 111.85 154.97 115.94 154.97 117.58 147.26 123.5 147.26 121.86 154.97 125.95 154.97 129.73 137.17 125.63 137.17 124.09 144.39\" fill=\"#c78ad6\" data-v-2cf39f23></polygon><path d=\"M142.76,137.24,140,150.1c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13H133l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M162.9,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.9,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.25,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14H152l1-4.73Z\" fill=\"#c78ad6\" data-v-2cf39f23></path>", 7)
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_9 = [
  PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_2
]
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-2cf39f23></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M59.1,181.83c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H43.71l-4.18,19.56H45c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M70.24,191.35H61.92l8.1-38.1c5.6,0,7.45,0,7.45,2.93a37.74,37.74,0,0,1-1,6.25Zm12.39-18,8.43,18H81L74.86,175.8l.71-3.21,11.74-10.38h9.62Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M118.78,192.05c-1.25,5.44-5,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a11.42,11.42,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.58-9.84,14.51-9.84h2c6.91,0,10.71,2.34,10.71,7.34a11,11,0,0,1-.27,2.56Zm-12.5-5.22h5.27l3.31-15.27a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C102.36,186.07,103.29,186.83,106.28,186.83Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><polygon points=\"124.09 144.39 118.18 144.39 119.72 137.17 115.62 137.17 111.85 154.97 115.94 154.97 117.58 147.26 123.5 147.26 121.86 154.97 125.95 154.97 129.73 137.17 125.63 137.17 124.09 144.39\" fill=\"#c78ad6\" data-v-2cf39f23></polygon><path d=\"M142.76,137.24,140,150.1c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13H133l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#c78ad6\" data-v-2cf39f23></path><path d=\"M162.9,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.9,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.25,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14H152l1-4.73Z\" fill=\"#c78ad6\" data-v-2cf39f23></path>", 8)
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_19 = [
  PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_11
]
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#c78ad6\" data-v-2cf39f23></polygon><path d=\"M59.1,181.83c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H43.71l-4.18,19.56H45c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#fff\" data-v-2cf39f23></path><path d=\"M70.24,191.35H61.92l8.1-38.1c5.6,0,7.45,0,7.45,2.93a37.74,37.74,0,0,1-1,6.25Zm12.39-18,8.43,18H81L74.86,175.8l.71-3.21,11.74-10.38h9.62Z\" fill=\"#fff\" data-v-2cf39f23></path><path d=\"M118.78,192.05c-1.25,5.44-5,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.07-2,.17-.87.44-1.68.6-2.55-2.88.27-5.92.65-8.8.92-3.7.22-8.21-2.12-8.21-7.45a11.42,11.42,0,0,1,.27-2.55l2.23-10.22c1.47-6.68,6.58-9.84,14.51-9.84h2c6.91,0,10.71,2.34,10.71,7.34a11,11,0,0,1-.27,2.56Zm-12.5-5.22h5.27l3.31-15.27a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.72-3.86-2.72h-1c-3.75,0-5,1.85-5.6,4.9l-2,10.32a10.74,10.74,0,0,0-.33,2.39C102.36,186.07,103.29,186.83,106.28,186.83Z\" fill=\"#fff\" data-v-2cf39f23></path><polygon points=\"124.09 144.39 118.18 144.39 119.72 137.17 115.62 137.17 111.85 154.97 115.94 154.97 117.58 147.26 123.5 147.26 121.86 154.97 125.95 154.97 129.73 137.17 125.63 137.17 124.09 144.39\" fill=\"#fff\" data-v-2cf39f23></polygon><path d=\"M142.76,137.24,140,150.1c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13H133l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-2cf39f23></path><path d=\"M162.9,138.83c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63h7.8c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.9,138.83Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,156.25,144.39Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14H152l1-4.73Z\" fill=\"#fff\" data-v-2cf39f23></path>", 7)
const PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_28 = [
  PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_21
]

function PackagingHubvue_type_template_id_2cf39f23_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_1, PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_10, PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_20, PackagingHubvue_type_template_id_2cf39f23_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PackagingHub.vue?vue&type=template&id=2cf39f23&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/PackagingHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_PackagingHubvue_type_script_lang_js = ({
    name: "PackagingHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PackagingHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/PackagingHub.vue?vue&type=style&index=0&id=2cf39f23&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PackagingHub.vue?vue&type=style&index=0&id=2cf39f23&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PackagingHub.vue




;


const Square_PackagingHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_PackagingHubvue_type_script_lang_js, [['render',PackagingHubvue_type_template_id_2cf39f23_scoped_true_render],['__scopeId',"data-v-2cf39f23"]])

/* harmony default export */ var Square_PackagingHub = (Square_PackagingHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/PaymentHub.vue?vue&type=template&id=79a44834&scoped=true


const PaymentHubvue_type_template_id_79a44834_scoped_true_withScopeId = n => (_pushScopeId("data-v-79a44834"),n=n(),_popScopeId(),n)
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-79a44834></polygon><path d=\"M59.6,181.33c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H44.21L40,186.17h5.49c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M88.73,190.3l-14.35,1c-7.5,0-11-2.23-11-7.07a14.17,14.17,0,0,1,.32-2.82l.22-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.22-3.26-6.68-3.26H68.62l.82-4.24,10.21-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM77.91,175.52c-4.4,0-4.94,2.23-5.65,5.49,0,.16-.11.38-.11.54a11.27,11.27,0,0,0-.32,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M119.66,191.55c-1.2,5.6-4.84,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.08-2,.16-.87.43-1.68.59-2.55-2.88.27-5.92.65-8.8.92-3.75,0-8-2-8-7.28a11.24,11.24,0,0,1,.33-2.61l4.23-19.68c5.6,0,7.45-.05,7.45,2.88a37.54,37.54,0,0,1-1.09,6.53l-2.17,10.32a10.74,10.74,0,0,0-.33,2.39c0,1.69.93,2.5,3.92,2.5h5.27l5.27-24.62h8.37Z\" fill=\"#00bd8e\" data-v-79a44834></path><polygon points=\"123.59 144.89 117.68 144.89 119.22 137.67 115.12 137.67 111.35 155.47 115.44 155.47 117.08 147.76 123 147.76 121.36 155.47 125.45 155.47 129.23 137.67 125.13 137.67 123.59 144.89\" fill=\"#00bd8e\" data-v-79a44834></polygon><path d=\"M142.26,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M162.4,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63H154c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.4,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,155.75,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#00bd8e\" data-v-79a44834></path>", 7)
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_9 = [
  PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_2
]
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-79a44834></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M59.6,181.33c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H44.21L40,186.17h5.49c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M88.73,190.3l-14.35,1c-7.5,0-11-2.23-11-7.07a14.17,14.17,0,0,1,.32-2.82l.22-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.22-3.26-6.68-3.26H68.62l.82-4.24,10.21-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM77.91,175.52c-4.4,0-4.94,2.23-5.65,5.49,0,.16-.11.38-.11.54a11.27,11.27,0,0,0-.32,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M119.66,191.55c-1.2,5.6-4.84,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.08-2,.16-.87.43-1.68.59-2.55-2.88.27-5.92.65-8.8.92-3.75,0-8-2-8-7.28a11.24,11.24,0,0,1,.33-2.61l4.23-19.68c5.6,0,7.45-.05,7.45,2.88a37.54,37.54,0,0,1-1.09,6.53l-2.17,10.32a10.74,10.74,0,0,0-.33,2.39c0,1.69.93,2.5,3.92,2.5h5.27l5.27-24.62h8.37Z\" fill=\"#00bd8e\" data-v-79a44834></path><polygon points=\"123.59 144.89 117.68 144.89 119.22 137.67 115.12 137.67 111.35 155.47 115.44 155.47 117.08 147.76 123 147.76 121.36 155.47 125.45 155.47 129.23 137.67 125.13 137.67 123.59 144.89\" fill=\"#00bd8e\" data-v-79a44834></polygon><path d=\"M142.26,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#00bd8e\" data-v-79a44834></path><path d=\"M162.4,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63H154c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.4,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,155.75,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#00bd8e\" data-v-79a44834></path>", 8)
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_19 = [
  PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_11
]
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#00bd8e\" data-v-79a44834></polygon><path d=\"M59.6,181.33c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.91,8.92-2.67,9.57-10.33,9.62l3.91-18.42.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39Zm-6.36-9.94a11,11,0,0,0,.27-2.12c0-1.85-1-2.66-3.86-2.66H44.21L40,186.17h5.49c3.91,0,4.89-1.57,5.6-4.89Z\" fill=\"#fff\" data-v-79a44834></path><path d=\"M88.73,190.3l-14.35,1c-7.5,0-11-2.23-11-7.07a14.17,14.17,0,0,1,.32-2.82l.22-1c1.47-6.74,5.76-9.4,11.8-9.4l8.64.76.43-2c.44-2-.22-3.26-6.68-3.26H68.62l.82-4.24,10.21-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM77.91,175.52c-4.4,0-4.94,2.23-5.65,5.49,0,.16-.11.38-.11.54a11.27,11.27,0,0,0-.32,2.39c0,1.74.87,2.5,3.69,2.5h5.66c.76-3.64,1.63-7.23,2.39-10.92Z\" fill=\"#fff\" data-v-79a44834></path><path d=\"M119.66,191.55c-1.2,5.6-4.84,8.32-13.59,8.32l-15.38-.93.81-4.07h15.44c3.21,0,4-1.47,4.08-2,.16-.87.43-1.68.59-2.55-2.88.27-5.92.65-8.8.92-3.75,0-8-2-8-7.28a11.24,11.24,0,0,1,.33-2.61l4.23-19.68c5.6,0,7.45-.05,7.45,2.88a37.54,37.54,0,0,1-1.09,6.53l-2.17,10.32a10.74,10.74,0,0,0-.33,2.39c0,1.69.93,2.5,3.92,2.5h5.27l5.27-24.62h8.37Z\" fill=\"#fff\" data-v-79a44834></path><polygon points=\"123.59 144.89 117.68 144.89 119.22 137.67 115.12 137.67 111.35 155.47 115.44 155.47 117.08 147.76 123 147.76 121.36 155.47 125.45 155.47 129.23 137.67 125.13 137.67 123.59 144.89\" fill=\"#fff\" data-v-79a44834></polygon><path d=\"M142.26,137.74l-2.73,12.86c-.37,1.75-1.24,2.44-3.1,2.44h-.18a2.27,2.27,0,0,1-1.82-.55,2.16,2.16,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.87,1.08,2.56,1.63,5,1.63h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-79a44834></path><path d=\"M162.4,139.33c-.87-1.06-2.5-1.57-5-1.57h-7.46l-3.74,17.63H154c4.27,0,6.77-1.63,7.44-4.84a4.19,4.19,0,0,0-.35-3.24,2.79,2.79,0,0,0-.9-.84,4.62,4.62,0,0,0,2.76-3.7A4,4,0,0,0,162.4,139.33Zm-6.65,5.56h-2.58c.22-1,.42-1.95.62-2.93l.29-1.36h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,155.75,144.89Zm-.22,2.87a1.27,1.27,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.27,1.28c-.36,1.62-1.06,2.14-2.89,2.14h-2.1l1-4.73Z\" fill=\"#fff\" data-v-79a44834></path>", 7)
const PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_28 = [
  PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_21
]

function PaymentHubvue_type_template_id_79a44834_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_1, PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_10, PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_20, PaymentHubvue_type_template_id_79a44834_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PaymentHub.vue?vue&type=template&id=79a44834&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/PaymentHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_PaymentHubvue_type_script_lang_js = ({
    name: "PaymentHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PaymentHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/PaymentHub.vue?vue&type=style&index=0&id=79a44834&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PaymentHub.vue?vue&type=style&index=0&id=79a44834&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/PaymentHub.vue




;


const Square_PaymentHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_PaymentHubvue_type_script_lang_js, [['render',PaymentHubvue_type_template_id_79a44834_scoped_true_render],['__scopeId',"data-v-79a44834"]])

/* harmony default export */ var Square_PaymentHub = (Square_PaymentHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ProductsHub.vue?vue&type=template&id=55aa66dc&scoped=true


const ProductsHubvue_type_template_id_55aa66dc_scoped_true_withScopeId = n => (_pushScopeId("data-v-55aa66dc"),n=n(),_popScopeId(),n)
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-55aa66dc></polygon><path d=\"M61.57,184.92c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L34.56,185l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39ZM55.21,175a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H46.19L42,189.76H47.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M91.74,176.72H85.43a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7l-5.16,24.24H64.4l6.09-28.59L84,164.76c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M118.59,193.89l-14.78,1c-6.91,0-10.6-2.4-10.6-7.34a11,11,0,0,1,.27-2.56l2.23-10.27c1.63-7.77,7.28-9.78,12-9.78l8.53.87c2-8.81,2.72-9.4,10.38-9.51Zm-8.81-24c-3.91,0-4.89,1.58-5.59,5L102,185.09a13.35,13.35,0,0,0-.33,2.34c0,1.73.93,2.55,3.7,2.55h5.6c1.41-6.69,2.93-13.32,4.34-20.06Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><polygon points=\"121.62 141.29 115.7 141.29 117.24 134.08 113.15 134.08 109.37 151.88 113.47 151.88 115.11 144.17 121.02 144.17 119.38 151.88 123.48 151.88 127.25 134.08 123.16 134.08 121.62 141.29\" fill=\"#f2dc1d\" data-v-55aa66dc></polygon><path d=\"M140.28,134.15,137.55,147c-.36,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.14,2.14,0,0,1-.16-1.8L135,134.15h-4.48L127.84,147a3.73,3.73,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63h1c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M160.42,135.74c-.86-1.06-2.5-1.57-5-1.57H148l-3.74,17.63H152c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,160.42,135.74Zm-6.64,5.56H151.2c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,153.78,141.3Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path>", 7)
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_9 = [
  ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_2
]
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-55aa66dc></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M61.57,184.92c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L34.56,185l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39ZM55.21,175a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H46.19L42,189.76H47.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M91.74,176.72H85.43a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7l-5.16,24.24H64.4l6.09-28.59L84,164.76c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M118.59,193.89l-14.78,1c-6.91,0-10.6-2.4-10.6-7.34a11,11,0,0,1,.27-2.56l2.23-10.27c1.63-7.77,7.28-9.78,12-9.78l8.53.87c2-8.81,2.72-9.4,10.38-9.51Zm-8.81-24c-3.91,0-4.89,1.58-5.59,5L102,185.09a13.35,13.35,0,0,0-.33,2.34c0,1.73.93,2.55,3.7,2.55h5.6c1.41-6.69,2.93-13.32,4.34-20.06Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><polygon points=\"121.62 141.29 115.7 141.29 117.24 134.08 113.15 134.08 109.37 151.88 113.47 151.88 115.11 144.17 121.02 144.17 119.38 151.88 123.48 151.88 127.25 134.08 123.16 134.08 121.62 141.29\" fill=\"#f2dc1d\" data-v-55aa66dc></polygon><path d=\"M140.28,134.15,137.55,147c-.36,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.14,2.14,0,0,1-.16-1.8L135,134.15h-4.48L127.84,147a3.73,3.73,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63h1c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path><path d=\"M160.42,135.74c-.86-1.06-2.5-1.57-5-1.57H148l-3.74,17.63H152c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,160.42,135.74Zm-6.64,5.56H151.2c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,153.78,141.3Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#f2dc1d\" data-v-55aa66dc></path>", 8)
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_19 = [
  ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_11
]
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#f2dc1d\" data-v-55aa66dc></polygon><path d=\"M61.57,184.92c-1.68,7.94-7.66,9.73-12.06,9.84l-8.54-1c-1.9,8.92-2.66,9.57-10.32,9.62L34.56,185l.38-1.85,3.7-17.28,14.62-1.09c6.74,0,10.76,2.45,10.76,7.45a13.16,13.16,0,0,1-.27,2.39ZM55.21,175a10.31,10.31,0,0,0,.28-2.12c0-1.85-1-2.66-3.86-2.66H46.19L42,189.76H47.5c3.91,0,4.89-1.57,5.59-4.89Z\" fill=\"#fff\" data-v-55aa66dc></path><path d=\"M91.74,176.72H85.43a15.9,15.9,0,0,0,.44-3.32c0-2.5-1.36-3.2-4.29-3.2h-3.7l-5.16,24.24H64.4l6.09-28.59L84,164.76c5.65,0,9.35,2.88,9.35,6.58a7.55,7.55,0,0,1-.49,2.39Z\" fill=\"#fff\" data-v-55aa66dc></path><path d=\"M118.59,193.89l-14.78,1c-6.91,0-10.6-2.4-10.6-7.34a11,11,0,0,1,.27-2.56l2.23-10.27c1.63-7.77,7.28-9.78,12-9.78l8.53.87c2-8.81,2.72-9.4,10.38-9.51Zm-8.81-24c-3.91,0-4.89,1.58-5.59,5L102,185.09a13.35,13.35,0,0,0-.33,2.34c0,1.73.93,2.55,3.7,2.55h5.6c1.41-6.69,2.93-13.32,4.34-20.06Z\" fill=\"#fff\" data-v-55aa66dc></path><polygon points=\"121.62 141.29 115.7 141.29 117.24 134.08 113.15 134.08 109.37 151.88 113.47 151.88 115.11 144.17 121.02 144.17 119.38 151.88 123.48 151.88 127.25 134.08 123.16 134.08 121.62 141.29\" fill=\"#fff\" data-v-55aa66dc></polygon><path d=\"M140.28,134.15,137.55,147c-.36,1.75-1.23,2.44-3.1,2.44h-.18a2.28,2.28,0,0,1-1.82-.55,2.14,2.14,0,0,1-.16-1.8L135,134.15h-4.48L127.84,147a3.73,3.73,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63h1c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-55aa66dc></path><path d=\"M160.42,135.74c-.86-1.06-2.5-1.57-5-1.57H148l-3.74,17.63H152c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.6,4.6,0,0,0,2.76-3.7A3.89,3.89,0,0,0,160.42,135.74Zm-6.64,5.56H151.2c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.86,0,1.4.14,1.63.42s.25.79.09,1.58l-.15.76A1.94,1.94,0,0,1,153.78,141.3Zm-.23,2.87a1.28,1.28,0,0,1,1,.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.36,1.62-1.06,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-55aa66dc></path>", 7)
const ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_28 = [
  ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_21
]

function ProductsHubvue_type_template_id_55aa66dc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_1, ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_10, ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_20, ProductsHubvue_type_template_id_55aa66dc_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ProductsHub.vue?vue&type=template&id=55aa66dc&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ProductsHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_ProductsHubvue_type_script_lang_js = ({
    name: "ProductsHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ProductsHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/ProductsHub.vue?vue&type=style&index=0&id=55aa66dc&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ProductsHub.vue?vue&type=style&index=0&id=55aa66dc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/ProductsHub.vue




;


const Square_ProductsHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_ProductsHubvue_type_script_lang_js, [['render',ProductsHubvue_type_template_id_55aa66dc_scoped_true_render],['__scopeId',"data-v-55aa66dc"]])

/* harmony default export */ var Square_ProductsHub = (Square_ProductsHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/SupportHub.vue?vue&type=template&id=e4a8fe98&scoped=true


const SupportHubvue_type_template_id_e4a8fe98_scoped_true_withScopeId = n => (_pushScopeId("data-v-e4a8fe98"),n=n(),_popScopeId(),n)
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-e4a8fe98></polygon><path d=\"M64.66,168.13H56.29c-4.08,0-5.33,1-6.14,4.4l12.06,6.36c-.11,1.69-.32,3.86-.49,4.84-1.63,7.18-6.63,9.51-16,9.51l-8.58-.81.81-4.19h8.59c5.11,0,5.82-1.74,6.36-4.29l.22-.82L41,176.77a15.1,15.1,0,0,1,.1-4.13c1.63-7.44,7-9.51,16-9.51l8.37.82Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M93.36,183.24c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.9,8.91-2.66,9.57-10.33,9.62l3.91-18.42.39-1.85,3.69-17.29L85,163.08c6.74,0,10.76,2.44,10.76,7.44a12.51,12.51,0,0,1-.27,2.4Zm-6.36-10a11,11,0,0,0,.27-2.11c0-1.85-1-2.67-3.86-2.67H78l-4.19,19.57h5.49c3.91,0,4.89-1.58,5.6-4.89Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M119.29,167.86l-9.9.87-3.1,14.67a10.86,10.86,0,0,0-.32,2.34c0,1.69.87,2.5,3.69,2.5h5.22L114,192.7l-5.38.54c-7.34,0-11.09-1.85-11.09-6.9a15.87,15.87,0,0,1,.38-3l4.18-19.57c4.08-.54,4.79-1.84,5.66-5h3.86l-1,4.84h9.62Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><polygon points=\"115.81 142.98 109.9 142.98 111.44 135.77 107.34 135.77 103.57 153.56 107.66 153.56 109.3 145.85 115.22 145.85 113.58 153.56 117.67 153.56 121.45 135.77 117.35 135.77 115.81 142.98\" fill=\"#e09dea\" data-v-e4a8fe98></polygon><path d=\"M134.48,135.83l-2.73,12.86c-.37,1.76-1.24,2.44-3.1,2.44h-.18a2.32,2.32,0,0,1-1.82-.54,2.19,2.19,0,0,1-.17-1.8l2.75-13h-4.47L122,148.69a3.8,3.8,0,0,0,.54,3.32c.87,1.07,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M154.62,137.43c-.87-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.63h7.8c4.27,0,6.78-1.63,7.44-4.83a4.25,4.25,0,0,0-.34-3.25,3.07,3.07,0,0,0-.91-.84,4.59,4.59,0,0,0,2.76-3.7A3.93,3.93,0,0,0,154.62,137.43ZM148,143h-2.58c.22-1,.42-1.95.62-2.92l.29-1.37h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,148,143Zm-.22,2.87a1.25,1.25,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.27,1.27c-.36,1.63-1.06,2.15-2.89,2.15h-2.1l1-4.74Z\" fill=\"#e09dea\" data-v-e4a8fe98></path>", 7)
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_9 = [
  SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_2
]
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-e4a8fe98></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M64.66,168.13H56.29c-4.08,0-5.33,1-6.14,4.4l12.06,6.36c-.11,1.69-.32,3.86-.49,4.84-1.63,7.18-6.63,9.51-16,9.51l-8.58-.81.81-4.19h8.59c5.11,0,5.82-1.74,6.36-4.29l.22-.82L41,176.77a15.1,15.1,0,0,1,.1-4.13c1.63-7.44,7-9.51,16-9.51l8.37.82Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M93.36,183.24c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.9,8.91-2.66,9.57-10.33,9.62l3.91-18.42.39-1.85,3.69-17.29L85,163.08c6.74,0,10.76,2.44,10.76,7.44a12.51,12.51,0,0,1-.27,2.4Zm-6.36-10a11,11,0,0,0,.27-2.11c0-1.85-1-2.67-3.86-2.67H78l-4.19,19.57h5.49c3.91,0,4.89-1.58,5.6-4.89Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M119.29,167.86l-9.9.87-3.1,14.67a10.86,10.86,0,0,0-.32,2.34c0,1.69.87,2.5,3.69,2.5h5.22L114,192.7l-5.38.54c-7.34,0-11.09-1.85-11.09-6.9a15.87,15.87,0,0,1,.38-3l4.18-19.57c4.08-.54,4.79-1.84,5.66-5h3.86l-1,4.84h9.62Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><polygon points=\"115.81 142.98 109.9 142.98 111.44 135.77 107.34 135.77 103.57 153.56 107.66 153.56 109.3 145.85 115.22 145.85 113.58 153.56 117.67 153.56 121.45 135.77 117.35 135.77 115.81 142.98\" fill=\"#e09dea\" data-v-e4a8fe98></polygon><path d=\"M134.48,135.83l-2.73,12.86c-.37,1.76-1.24,2.44-3.1,2.44h-.18a2.32,2.32,0,0,1-1.82-.54,2.19,2.19,0,0,1-.17-1.8l2.75-13h-4.47L122,148.69a3.8,3.8,0,0,0,.54,3.32c.87,1.07,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#e09dea\" data-v-e4a8fe98></path><path d=\"M154.62,137.43c-.87-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.63h7.8c4.27,0,6.78-1.63,7.44-4.83a4.25,4.25,0,0,0-.34-3.25,3.07,3.07,0,0,0-.91-.84,4.59,4.59,0,0,0,2.76-3.7A3.93,3.93,0,0,0,154.62,137.43ZM148,143h-2.58c.22-1,.42-1.95.62-2.92l.29-1.37h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,148,143Zm-.22,2.87a1.25,1.25,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.27,1.27c-.36,1.63-1.06,2.15-2.89,2.15h-2.1l1-4.74Z\" fill=\"#e09dea\" data-v-e4a8fe98></path>", 8)
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_19 = [
  SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_11
]
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e09dea\" data-v-e4a8fe98></polygon><path d=\"M64.66,168.13H56.29c-4.08,0-5.33,1-6.14,4.4l12.06,6.36c-.11,1.69-.32,3.86-.49,4.84-1.63,7.18-6.63,9.51-16,9.51l-8.58-.81.81-4.19h8.59c5.11,0,5.82-1.74,6.36-4.29l.22-.82L41,176.77a15.1,15.1,0,0,1,.1-4.13c1.63-7.44,7-9.51,16-9.51l8.37.82Z\" fill=\"#fff\" data-v-e4a8fe98></path><path d=\"M93.36,183.24c-1.69,7.94-7.67,9.73-12.07,9.84l-8.53-1c-1.9,8.91-2.66,9.57-10.33,9.62l3.91-18.42.39-1.85,3.69-17.29L85,163.08c6.74,0,10.76,2.44,10.76,7.44a12.51,12.51,0,0,1-.27,2.4Zm-6.36-10a11,11,0,0,0,.27-2.11c0-1.85-1-2.67-3.86-2.67H78l-4.19,19.57h5.49c3.91,0,4.89-1.58,5.6-4.89Z\" fill=\"#fff\" data-v-e4a8fe98></path><path d=\"M119.29,167.86l-9.9.87-3.1,14.67a10.86,10.86,0,0,0-.32,2.34c0,1.69.87,2.5,3.69,2.5h5.22L114,192.7l-5.38.54c-7.34,0-11.09-1.85-11.09-6.9a15.87,15.87,0,0,1,.38-3l4.18-19.57c4.08-.54,4.79-1.84,5.66-5h3.86l-1,4.84h9.62Z\" fill=\"#fff\" data-v-e4a8fe98></path><polygon points=\"115.81 142.98 109.9 142.98 111.44 135.77 107.34 135.77 103.57 153.56 107.66 153.56 109.3 145.85 115.22 145.85 113.58 153.56 117.67 153.56 121.45 135.77 117.35 135.77 115.81 142.98\" fill=\"#fff\" data-v-e4a8fe98></polygon><path d=\"M134.48,135.83l-2.73,12.86c-.37,1.76-1.24,2.44-3.1,2.44h-.18a2.32,2.32,0,0,1-1.82-.54,2.19,2.19,0,0,1-.17-1.8l2.75-13h-4.47L122,148.69a3.8,3.8,0,0,0,.54,3.32c.87,1.07,2.56,1.62,5,1.62h1.06c4.31,0,6.85-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-e4a8fe98></path><path d=\"M154.62,137.43c-.87-1.06-2.5-1.58-5-1.58h-7.46l-3.74,17.63h7.8c4.27,0,6.78-1.63,7.44-4.83a4.25,4.25,0,0,0-.34-3.25,3.07,3.07,0,0,0-.91-.84,4.59,4.59,0,0,0,2.76-3.7A3.93,3.93,0,0,0,154.62,137.43ZM148,143h-2.58c.22-1,.42-1.95.62-2.92l.29-1.37h2.23c.86,0,1.39.14,1.62.42s.26.79.1,1.58l-.15.76A2,2,0,0,1,148,143Zm-.22,2.87a1.25,1.25,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.27,1.27c-.36,1.63-1.06,2.15-2.89,2.15h-2.1l1-4.74Z\" fill=\"#fff\" data-v-e4a8fe98></path>", 7)
const SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_28 = [
  SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_21
]

function SupportHubvue_type_template_id_e4a8fe98_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_1, SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_10, SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_20, SupportHubvue_type_template_id_e4a8fe98_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/SupportHub.vue?vue&type=template&id=e4a8fe98&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/SupportHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_SupportHubvue_type_script_lang_js = ({
    name: "SupportHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/SupportHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/SupportHub.vue?vue&type=style&index=0&id=e4a8fe98&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/SupportHub.vue?vue&type=style&index=0&id=e4a8fe98&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/SupportHub.vue




;


const Square_SupportHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_SupportHubvue_type_script_lang_js, [['render',SupportHubvue_type_template_id_e4a8fe98_scoped_true_render],['__scopeId',"data-v-e4a8fe98"]])

/* harmony default export */ var Square_SupportHub = (Square_SupportHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/TaxHub.vue?vue&type=template&id=3525d1d0&scoped=true


const TaxHubvue_type_template_id_3525d1d0_scoped_true_withScopeId = n => (_pushScopeId("data-v-3525d1d0"),n=n(),_popScopeId(),n)
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-3525d1d0></polygon><polygon points=\"121.11 145.4 115.19 145.4 116.73 138.18 112.64 138.18 108.86 155.98 112.96 155.98 114.6 148.27 120.51 148.27 118.87 155.98 122.97 155.98 126.74 138.18 122.65 138.18 121.11 145.4\" fill=\"#5399d3\" data-v-3525d1d0></polygon><path d=\"M139.77,138.25,137,151.11c-.36,1.75-1.23,2.44-3.09,2.44h-.18A2.27,2.27,0,0,1,132,153a2.12,2.12,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63H134c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M159.91,139.84c-.86-1.06-2.5-1.57-5-1.57h-7.46L143.7,155.9h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.63,4.63,0,0,0,2.77-3.7A3.92,3.92,0,0,0,159.91,139.84Zm-6.64,5.56h-2.58c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42s.25.79.1,1.58l-.16.76A1.94,1.94,0,0,1,153.27,145.4Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M55.78,165.44l-9.9.87L42.79,181a10.2,10.2,0,0,0-.33,2.34c0,1.68.87,2.5,3.7,2.5h5.21l-.92,4.45-5.38.55C37.73,190.83,34,189,34,183.92a15.87,15.87,0,0,1,.38-3l4.19-19.56c4.07-.55,4.78-1.85,5.65-5h3.86l-1,4.83h9.62Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M80.51,189.79l-14.35,1c-7.5,0-11-2.23-11-7.06a13.54,13.54,0,0,1,.33-2.83l.22-1c1.47-6.74,5.76-9.4,11.79-9.4l8.64.76.44-2c.43-2-.22-3.26-6.69-3.26H60.4l.81-4.24,10.22-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM69.69,175c-4.4,0-5,2.23-5.65,5.49,0,.16-.11.38-.11.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.7,2.5H73c.76-3.64,1.63-7.22,2.39-10.92Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M109.91,175l5.66,15.38h-9.3l-3.59-12.07h-2.55L92,190.34H83.71l12.07-15.49L90.89,161.2h9.4l3.1,10.82h2.23l9-10.82H122Z\" fill=\"#5399d3\" data-v-3525d1d0></path>", 7)
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_9 = [
  TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_2
]
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-3525d1d0></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#5399d3\" data-v-3525d1d0></path><polygon points=\"121.11 145.4 115.19 145.4 116.73 138.18 112.64 138.18 108.86 155.98 112.96 155.98 114.6 148.27 120.51 148.27 118.87 155.98 122.97 155.98 126.74 138.18 122.65 138.18 121.11 145.4\" fill=\"#5399d3\" data-v-3525d1d0></polygon><path d=\"M139.77,138.25,137,151.11c-.36,1.75-1.23,2.44-3.09,2.44h-.18A2.27,2.27,0,0,1,132,153a2.12,2.12,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63H134c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M159.91,139.84c-.86-1.06-2.5-1.57-5-1.57h-7.46L143.7,155.9h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.63,4.63,0,0,0,2.77-3.7A3.92,3.92,0,0,0,159.91,139.84Zm-6.64,5.56h-2.58c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42s.25.79.1,1.58l-.16.76A1.94,1.94,0,0,1,153.27,145.4Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M55.78,165.44l-9.9.87L42.79,181a10.2,10.2,0,0,0-.33,2.34c0,1.68.87,2.5,3.7,2.5h5.21l-.92,4.45-5.38.55C37.73,190.83,34,189,34,183.92a15.87,15.87,0,0,1,.38-3l4.19-19.56c4.07-.55,4.78-1.85,5.65-5h3.86l-1,4.83h9.62Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M80.51,189.79l-14.35,1c-7.5,0-11-2.23-11-7.06a13.54,13.54,0,0,1,.33-2.83l.22-1c1.47-6.74,5.76-9.4,11.79-9.4l8.64.76.44-2c.43-2-.22-3.26-6.69-3.26H60.4l.81-4.24,10.22-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM69.69,175c-4.4,0-5,2.23-5.65,5.49,0,.16-.11.38-.11.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.7,2.5H73c.76-3.64,1.63-7.22,2.39-10.92Z\" fill=\"#5399d3\" data-v-3525d1d0></path><path d=\"M109.91,175l5.66,15.38h-9.3l-3.59-12.07h-2.55L92,190.34H83.71l12.07-15.49L90.89,161.2h9.4l3.1,10.82h2.23l9-10.82H122Z\" fill=\"#5399d3\" data-v-3525d1d0></path>", 8)
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_19 = [
  TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_11
]
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#5399d3\" data-v-3525d1d0></polygon><polygon points=\"121.11 145.4 115.19 145.4 116.73 138.18 112.64 138.18 108.86 155.98 112.96 155.98 114.6 148.27 120.51 148.27 118.87 155.98 122.97 155.98 126.74 138.18 122.65 138.18 121.11 145.4\" fill=\"#fff\" data-v-3525d1d0></polygon><path d=\"M139.77,138.25,137,151.11c-.36,1.75-1.23,2.44-3.09,2.44h-.18A2.27,2.27,0,0,1,132,153a2.12,2.12,0,0,1-.17-1.79l2.75-13h-4.47l-2.73,12.85a3.8,3.8,0,0,0,.54,3.32c.86,1.08,2.55,1.63,5,1.63H134c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-3525d1d0></path><path d=\"M159.91,139.84c-.86-1.06-2.5-1.57-5-1.57h-7.46L143.7,155.9h7.81c4.27,0,6.77-1.63,7.44-4.84a4.29,4.29,0,0,0-.35-3.24,2.73,2.73,0,0,0-.91-.84,4.63,4.63,0,0,0,2.77-3.7A3.92,3.92,0,0,0,159.91,139.84Zm-6.64,5.56h-2.58c.22-1,.42-2,.62-2.93l.28-1.36h2.23c.87,0,1.4.14,1.63.42s.25.79.1,1.58l-.16.76A1.94,1.94,0,0,1,153.27,145.4Zm-.23,2.87a1.28,1.28,0,0,1,1.05.42,1.13,1.13,0,0,1,.23.89l-.28,1.28c-.35,1.62-1,2.14-2.88,2.14h-2.11l1-4.73Z\" fill=\"#fff\" data-v-3525d1d0></path><path d=\"M55.78,165.44l-9.9.87L42.79,181a10.2,10.2,0,0,0-.33,2.34c0,1.68.87,2.5,3.7,2.5h5.21l-.92,4.45-5.38.55C37.73,190.83,34,189,34,183.92a15.87,15.87,0,0,1,.38-3l4.19-19.56c4.07-.55,4.78-1.85,5.65-5h3.86l-1,4.83h9.62Z\" fill=\"#fff\" data-v-3525d1d0></path><path d=\"M80.51,189.79l-14.35,1c-7.5,0-11-2.23-11-7.06a13.54,13.54,0,0,1,.33-2.83l.22-1c1.47-6.74,5.76-9.4,11.79-9.4l8.64.76.44-2c.43-2-.22-3.26-6.69-3.26H60.4l.81-4.24,10.22-1c9.57,0,13.48,2.18,13.48,7.29a15.86,15.86,0,0,1-.38,3ZM69.69,175c-4.4,0-5,2.23-5.65,5.49,0,.16-.11.38-.11.54a10.74,10.74,0,0,0-.33,2.39c0,1.74.87,2.5,3.7,2.5H73c.76-3.64,1.63-7.22,2.39-10.92Z\" fill=\"#fff\" data-v-3525d1d0></path><path d=\"M109.91,175l5.66,15.38h-9.3l-3.59-12.07h-2.55L92,190.34H83.71l12.07-15.49L90.89,161.2h9.4l3.1,10.82h2.23l9-10.82H122Z\" fill=\"#fff\" data-v-3525d1d0></path>", 7)
const TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_28 = [
  TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_21
]

function TaxHubvue_type_template_id_3525d1d0_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_1, TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_10, TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_20, TaxHubvue_type_template_id_3525d1d0_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/TaxHub.vue?vue&type=template&id=3525d1d0&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/TaxHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_TaxHubvue_type_script_lang_js = ({
    name: "TaxHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/TaxHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/TaxHub.vue?vue&type=style&index=0&id=3525d1d0&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/TaxHub.vue?vue&type=style&index=0&id=3525d1d0&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/TaxHub.vue




;


const Square_TaxHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_TaxHubvue_type_script_lang_js, [['render',TaxHubvue_type_template_id_3525d1d0_scoped_true_render],['__scopeId',"data-v-3525d1d0"]])

/* harmony default export */ var Square_TaxHub = (Square_TaxHub_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/W3EHub.vue?vue&type=template&id=34d3cc0d&scoped=true


const W3EHubvue_type_template_id_34d3cc0d_scoped_true_withScopeId = n => (_pushScopeId("data-v-34d3cc0d"),n=n(),_popScopeId(),n)
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#fff\" data-v-34d3cc0d></polygon><path d=\"M68.2,193H56.45l1.18-23.6c-2.77,7.67-5.83,15.94-8.55,23.6h-12l-.66-31H45.6l-1.22,25.61h1.36l9.4-25.61H65L63.6,187.66h1.45l9.45-25.61h7.38Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M98.61,177.27c2.21.47,3.53,1.51,3.53,4.28a13.55,13.55,0,0,1-.38,3.1c-1.31,5.45-5.5,8.74-13.86,8.74l-9.59-.61.8-3.95h6.3c5.31,0,7-1.92,7.56-4.27.14-.75.38-1.6.52-2.35.19-.9-.23-3-4-3H85.22l.89-4.28h4.14c3,0,5-1.31,5.5-3l.28-1.41a8.88,8.88,0,0,0,.19-1.41c0-1.74-1.23-2.68-5.69-2.68H84l.8-4,9.77-.71c7,0,10.43,2.4,10.43,6.77a11.61,11.61,0,0,1-.23,2.11C103.74,175.39,102,176.8,98.61,177.27Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M129.49,166.28H118.07l-1.83,8.6h9l-.89,4.27h-9c-.66,3.25-1.36,6.39-2,9.59H124.6l-.84,4.28H103.88l6.58-31h19.92Z\" fill=\"#e27110\" data-v-34d3cc0d></path><polygon points=\"120.72 144.54 114.8 144.54 116.34 137.33 112.25 137.33 108.47 155.13 112.57 155.13 114.21 147.41 120.12 147.41 118.48 155.13 122.58 155.13 126.35 137.33 122.26 137.33 120.72 144.54\" fill=\"#e27110\" data-v-34d3cc0d></polygon><path d=\"M139.38,137.39l-2.73,12.86c-.36,1.76-1.23,2.44-3.09,2.44h-.19a2.3,2.3,0,0,1-1.81-.54,2.15,2.15,0,0,1-.17-1.8l2.75-13h-4.47l-2.73,12.86a3.77,3.77,0,0,0,.54,3.32c.86,1.08,2.55,1.62,5,1.62h1.06c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M159.52,139c-.86-1.06-2.5-1.58-5-1.58h-7.46L143.31,155h7.81c4.27,0,6.77-1.63,7.44-4.83a4.31,4.31,0,0,0-.35-3.25,3,3,0,0,0-.91-.84,4.62,4.62,0,0,0,2.77-3.7A3.9,3.9,0,0,0,159.52,139Zm-6.64,5.55H150.3c.22-1,.42-1.95.62-2.92l.28-1.37h2.23c.87,0,1.4.14,1.63.42a2.05,2.05,0,0,1,.1,1.58L155,143A1.94,1.94,0,0,1,152.88,144.54Zm-.23,2.87a1.26,1.26,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.28,1.27c-.36,1.63-1.05,2.15-2.88,2.15h-2.11l1-4.74Z\" fill=\"#e27110\" data-v-34d3cc0d></path>", 7)
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_9 = [
  W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_2
]
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"5 262 5 77.07 77.07 5 262 5 262 189.69 189.69 262 5 262\" fill=\"#fff\" data-v-34d3cc0d></polygon><path d=\"M257,10V187.62L187.62,257H10V79.14L79.14,10H257M267,0H75L0,75V267H191.76L267,191.76V0Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M68.2,193H56.45l1.18-23.6c-2.77,7.67-5.83,15.94-8.55,23.6h-12l-.66-31H45.6l-1.22,25.61h1.36l9.4-25.61H65L63.6,187.66h1.45l9.45-25.61h7.38Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M98.61,177.27c2.21.47,3.53,1.51,3.53,4.28a13.55,13.55,0,0,1-.38,3.1c-1.31,5.45-5.5,8.74-13.86,8.74l-9.59-.61.8-3.95h6.3c5.31,0,7-1.92,7.56-4.27.14-.75.38-1.6.52-2.35.19-.9-.23-3-4-3H85.22l.89-4.28h4.14c3,0,5-1.31,5.5-3l.28-1.41a8.88,8.88,0,0,0,.19-1.41c0-1.74-1.23-2.68-5.69-2.68H84l.8-4,9.77-.71c7,0,10.43,2.4,10.43,6.77a11.61,11.61,0,0,1-.23,2.11C103.74,175.39,102,176.8,98.61,177.27Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M129.49,166.28H118.07l-1.83,8.6h9l-.89,4.27h-9c-.66,3.25-1.36,6.39-2,9.59H124.6l-.84,4.28H103.88l6.58-31h19.92Z\" fill=\"#e27110\" data-v-34d3cc0d></path><polygon points=\"120.72 144.54 114.8 144.54 116.34 137.33 112.25 137.33 108.47 155.13 112.57 155.13 114.21 147.41 120.12 147.41 118.48 155.13 122.58 155.13 126.35 137.33 122.26 137.33 120.72 144.54\" fill=\"#e27110\" data-v-34d3cc0d></polygon><path d=\"M139.38,137.39l-2.73,12.86c-.36,1.76-1.23,2.44-3.09,2.44h-.19a2.3,2.3,0,0,1-1.81-.54,2.15,2.15,0,0,1-.17-1.8l2.75-13h-4.47l-2.73,12.86a3.77,3.77,0,0,0,.54,3.32c.86,1.08,2.55,1.62,5,1.62h1.06c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#e27110\" data-v-34d3cc0d></path><path d=\"M159.52,139c-.86-1.06-2.5-1.58-5-1.58h-7.46L143.31,155h7.81c4.27,0,6.77-1.63,7.44-4.83a4.31,4.31,0,0,0-.35-3.25,3,3,0,0,0-.91-.84,4.62,4.62,0,0,0,2.77-3.7A3.9,3.9,0,0,0,159.52,139Zm-6.64,5.55H150.3c.22-1,.42-1.95.62-2.92l.28-1.37h2.23c.87,0,1.4.14,1.63.42a2.05,2.05,0,0,1,.1,1.58L155,143A1.94,1.94,0,0,1,152.88,144.54Zm-.23,2.87a1.26,1.26,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.28,1.27c-.36,1.63-1.05,2.15-2.88,2.15h-2.11l1-4.74Z\" fill=\"#e27110\" data-v-34d3cc0d></path>", 8)
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_19 = [
  W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_11
]
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_20 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "267",
  height: "267",
  viewBox: "0 0 267 267"
}
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<polygon points=\"267 191.76 267 0 75 0 0 75 0 267 191.76 267 267 191.76\" fill=\"#e27110\" data-v-34d3cc0d></polygon><path d=\"M68.2,193H56.45l1.18-23.6c-2.77,7.67-5.83,15.94-8.55,23.6h-12l-.66-31H45.6l-1.22,25.61h1.36l9.4-25.61H65L63.6,187.66h1.45l9.45-25.61h7.38Z\" fill=\"#fff\" data-v-34d3cc0d></path><path d=\"M98.61,177.27c2.21.47,3.53,1.51,3.53,4.28a13.55,13.55,0,0,1-.38,3.1c-1.31,5.45-5.5,8.74-13.86,8.74l-9.59-.61.8-3.95h6.3c5.31,0,7-1.92,7.56-4.27.14-.75.38-1.6.52-2.35.19-.9-.23-3-4-3H85.22l.89-4.28h4.14c3,0,5-1.31,5.5-3l.28-1.41a8.88,8.88,0,0,0,.19-1.41c0-1.74-1.23-2.68-5.69-2.68H84l.8-4,9.77-.71c7,0,10.43,2.4,10.43,6.77a11.61,11.61,0,0,1-.23,2.11C103.74,175.39,102,176.8,98.61,177.27Z\" fill=\"#fff\" data-v-34d3cc0d></path><path d=\"M129.49,166.28H118.07l-1.83,8.6h9l-.89,4.27h-9c-.66,3.25-1.36,6.39-2,9.59H124.6l-.84,4.28H103.88l6.58-31h19.92Z\" fill=\"#fff\" data-v-34d3cc0d></path><polygon points=\"120.72 144.54 114.8 144.54 116.34 137.33 112.25 137.33 108.47 155.13 112.57 155.13 114.21 147.41 120.12 147.41 118.48 155.13 122.58 155.13 126.35 137.33 122.26 137.33 120.72 144.54\" fill=\"#fff\" data-v-34d3cc0d></polygon><path d=\"M139.38,137.39l-2.73,12.86c-.36,1.76-1.23,2.44-3.09,2.44h-.19a2.3,2.3,0,0,1-1.81-.54,2.15,2.15,0,0,1-.17-1.8l2.75-13h-4.47l-2.73,12.86a3.77,3.77,0,0,0,.54,3.32c.86,1.08,2.55,1.62,5,1.62h1.06c4.3,0,6.84-1.63,7.55-4.84l2.75-13Z\" fill=\"#fff\" data-v-34d3cc0d></path><path d=\"M159.52,139c-.86-1.06-2.5-1.58-5-1.58h-7.46L143.31,155h7.81c4.27,0,6.77-1.63,7.44-4.83a4.31,4.31,0,0,0-.35-3.25,3,3,0,0,0-.91-.84,4.62,4.62,0,0,0,2.77-3.7A3.9,3.9,0,0,0,159.52,139Zm-6.64,5.55H150.3c.22-1,.42-1.95.62-2.92l.28-1.37h2.23c.87,0,1.4.14,1.63.42a2.05,2.05,0,0,1,.1,1.58L155,143A1.94,1.94,0,0,1,152.88,144.54Zm-.23,2.87a1.26,1.26,0,0,1,1,.43,1.12,1.12,0,0,1,.23.89l-.28,1.27c-.36,1.63-1.05,2.15-2.88,2.15h-2.11l1-4.74Z\" fill=\"#fff\" data-v-34d3cc0d></path>", 7)
const W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_28 = [
  W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_21
]

function W3EHubvue_type_template_id_34d3cc0d_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.version==='inverted')
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_1, W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_9))
    : ($props.version==='outlined')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_10, W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_19))
      : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_20, W3EHubvue_type_template_id_34d3cc0d_scoped_true_hoisted_28))
}
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/W3EHub.vue?vue&type=template&id=34d3cc0d&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/W3EHub.vue?vue&type=script&lang=js

  /* harmony default export */ var Square_W3EHubvue_type_script_lang_js = ({
    name: "W3EHubSquare",
    props: {
      version: {
        type: String
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/W3EHub.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo/Square/W3EHub.vue?vue&type=style&index=0&id=34d3cc0d&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/W3EHub.vue?vue&type=style&index=0&id=34d3cc0d&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/Square/W3EHub.vue




;


const Square_W3EHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Square_W3EHubvue_type_script_lang_js, [['render',W3EHubvue_type_template_id_34d3cc0d_scoped_true_render],['__scopeId',"data-v-34d3cc0d"]])

/* harmony default export */ var Square_W3EHub = (Square_W3EHub_exports_);
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo/index.js
// Default



















// Mobile

















// Square

















/* harmony default export */ var DpApplicationLogo = ({
  // Default
  AccountingHub: AccountingHub,
  CopyrightHub: CopyrightHub,
  DutyPay: DutyPay,
  ECompanyHub: ECompanyHub,
  EIdHub: EIdHub,
  ExciseHub: ExciseHub,
  ExpertHub: ExpertHub,
  FinanceHub: FinanceHub,
  HundredBridges: HundredBridges,
  IntrastatHub: IntrastatHub,
  InvoiceHub: InvoiceHub,
  MergerHub: MergerHub,
  PackagingHub: PackagingHub,
  PaymentHub: PaymentHub,
  ProductsHub: ProductsHub,
  SupportHub: SupportHub,
  TaxHub: TaxHub,
  W3EHub: W3EHub,

  // Mobile
  AccountingHubMobile: Mobile_AccountingHub,
  CopyrightHubMobile: Mobile_CopyrightHub,
  ECompanyHubMobile: Mobile_ECompanyHub,
  EIdHubMobile: Mobile_EIdHub,
  ExciseHubMobile: Mobile_ExciseHub,
  ExpertHubMobile: Mobile_ExpertHub,
  FinanceHubMobile: Mobile_FinanceHub,
  IntrastatHubMobile: Mobile_IntrastatHub,
  InvoiceHubMobile: Mobile_InvoiceHub,
  MergerHubMobile: Mobile_MergerHub,
  PackagingHubMobile: Mobile_PackagingHub,
  PaymentHubMobile: Mobile_PaymentHub,
  ProductsHubMobile: Mobile_ProductsHub,
  SupportHubMobile: Mobile_SupportHub,
  TaxHubMobile: Mobile_TaxHub,
  W3EHubMobile: Mobile_W3EHub,

  // Square
  AccountingHubSquare: Square_AccountingHub,
  CopyrightHubSquare: Square_CopyrightHub,
  ECompanyHubSquare: Square_ECompanyHub,
  EIdHubSquare: Square_EIdHub,
  ExciseHubSquare: Square_ExciseHub,
  ExpertHubSquare: Square_ExpertHub,
  FinanceHubSquare: Square_FinanceHub,
  IntrastatHubSquare: Square_IntrastatHub,
  InvoiceHubSquare: Square_InvoiceHub,
  MergerHubSquare: Square_MergerHub,
  PackagingHubSquare: Square_PackagingHub,
  PaymentHubSquare: Square_PaymentHub,
  ProductsHubSquare: Square_ProductsHub,
  SupportHubSquare: Square_SupportHub,
  TaxHubSquare: Square_TaxHub,
  W3EHubSquare: Square_W3EHub,
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpApplicationLogo.vue?vue&type=script&lang=js



/* harmony default export */ var DpApplicationLogovue_type_script_lang_js = ({
  name: "DpApplicationLogo",
  components: {
    ...DpApplicationLogo
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    version: {
      type: String
    },
    application: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 60
    }
  },
  computed: {
    logoHeight() {
      return {
        'height': this.height + 'px'
      };
    },
    applicationName() {
      switch (this.application) {
        case 'dutypay': return 'DutyPay';
        case '100bridges': return 'HundredBridges';
        case 'accountinghub': return 'AccountingHub';
        case 'copyrighthub': return 'CopyrightHub';
        case 'ecompanyhub': return 'ECompanyHub';
        case 'eidhub': return 'EIdHub';
        case 'excisehub': return 'ExciseHub';
        case 'experthub': return 'ExpertHub';
        case 'financehub': return 'FinanceHub';
        case 'intrastathub': return 'IntrastatHub';
        case 'invoicehub': return 'InvoiceHub';
        case 'mergerhub': return 'MergerHub';
        case 'packaginghub': return 'PackagingHub';
        case 'paymenthub': return 'PaymentHub';
        case 'productshub': return 'ProductsHub';
        case 'supporthub': return 'SupportHub';
        case 'taxhub': return 'TaxHub';
        case 'w3ehub': return 'W3EHub';
        default: return 'DutyPay';
      }
    },
    componentName() {
      return this.applicationName + this.type.replace(/^\w/, (firstLetter) => firstLetter.toUpperCase());
    }
  }
});

;// CONCATENATED MODULE: ./src/components/DpApplicationLogo.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpApplicationLogo.vue




;
const DpApplicationLogo_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpApplicationLogovue_type_script_lang_js, [['render',render]])

/* harmony default export */ var components_DpApplicationLogo = (DpApplicationLogo_exports_);

/***/ }),

/***/ 549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpButton; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpButton.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = ["disabled"]


const __default__ = {
  name: "DpButton"
}

;


/* harmony default export */ var DpButtonvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  props: {
  action: {type: Function},
  purpose: {type: String, default: 'primary'},
  size: {type: String, default: 'default'},
  label: {type: String},
  inactive: {type: Boolean, default: false}
},
  setup(__props) {

const props = __props



const classes = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return {
    'dp-button__primary': (
        props.purpose === 'primary'
        || props.purpose === 'primaryAction'
        || props.purpose === 'primary-action'
    ),
    'dp-button__secondary': (
        props.purpose === 'secondary'
        || props.purpose === 'secondaryAction'
        || props.purpose === 'secondary-action'
    ),
    'dp-button__destructive': (
        props.purpose === 'destructive'
        || props.purpose === 'destructiveAction'
        || props.purpose === 'destructive-action'
    ),
    'dp-button--tiny': props.size === 'tiny',
    'dp-button--small': props.size === 'small',
    'dp-button--default': props.size === 'default',
    'dp-button--large': props.size === 'large',
    'dp-button--grand': props.size === 'grand',
    'dp-button--inactive': props.inactive
  }
})

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-button", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(classes)]),
    disabled: __props.inactive
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "prefix"),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.label), 1)
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "suffix")
  ], 10, _hoisted_1))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpButton.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpButton.vue



const __exports__ = DpButtonvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpButton = (__exports__);

/***/ }),

/***/ 2785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpCollapse; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpCollapse.vue?vue&type=template&id=289bafa3


function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_transition = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-collapse-transition")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_collapse_transition, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.$attrs)), [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
      ], 16)
    ]),
    _: 3
  }))
}
;// CONCATENATED MODULE: ./src/components/DpCollapse.vue?vue&type=template&id=289bafa3

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpCollapse.vue?vue&type=script&lang=js

// TODO: Deprecated
  /* harmony default export */ var DpCollapsevue_type_script_lang_js = ({
    name: "DpCollapse",
    inheritAttrs: false
  });

;// CONCATENATED MODULE: ./src/components/DpCollapse.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpCollapse.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpCollapsevue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpCollapse = (__exports__);

/***/ }),

/***/ 7381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpContent; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpContent.vue?vue&type=template&id=4c5a0657&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-4c5a0657"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dp-content" }

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpWrapper = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpWrapper")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpWrapper, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    })
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpContent.vue?vue&type=template&id=4c5a0657&scoped=true

// EXTERNAL MODULE: ./node_modules/chai/index.mjs
var chai = __webpack_require__(2757);
// EXTERNAL MODULE: ./src/components/DpWrapper.vue + 6 modules
var DpWrapper = __webpack_require__(9293);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpContent.vue?vue&type=script&lang=js



const tests = [
  {
    title: "Place content",
    description: "Place the content to render in the default slot.",
    slots: {
      default: '<span style="color:#ff0000">Example content</span>'
    },
    stubs: {
      DpWrapper: {
        template: '<div><slot></slot></div>'
      }
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.include('Example content');
    }
  }
];


/* harmony default export */ var DpContentvue_type_script_lang_js = ({
  name: "DpContent",
  description: "Wrapper for content. Utilizes DpWrapper to keep content away from edges of the viewport.",
  components: {DpWrapper: DpWrapper["default"]},
  // tests
});

;// CONCATENATED MODULE: ./src/components/DpContent.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpContent.vue?vue&type=style&index=0&id=4c5a0657&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpContent.vue?vue&type=style&index=0&id=4c5a0657&scoped=true&lang=scss

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpContent.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpContentvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-4c5a0657"]])

/* harmony default export */ var DpContent = (__exports__);

/***/ }),

/***/ 9867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpCopyToClipboard; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpCopyToClipboard.vue?vue&type=template&id=34d366c0&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-34d366c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pop-message" }
const _hoisted_2 = { class: "pop-message__content" }

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["area-flash", {'flash-outline': $data.areaFlash && !!(_ctx.$slots.default)}])
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, undefined, true),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-flex row", {'inline': $props.inline}])
    }, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_1, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_2, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["el-icon-success", {'flip-icon': $props.rtl}])
          }, null, 2),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('copied.message')), 1)
        ])
      ], 512), [
        [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, $data.popMessage]
      ]),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        tabindex: "0",
        purpose: "secondaryAction",
        size: "small",
        style: {"margin-top":"0.5em"},
        onClick: $options.copyToClipboard
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["el-icon-copy-document", {'flip-icon': $props.rtl}])
            }, null, 2),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(($options.isEmpty($props.label)) ? _ctx.$t('copy.label') : $props.label), 1)
          ])
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 2)
  ], 2))
}
;// CONCATENATED MODULE: ./src/components/DpCopyToClipboard.vue?vue&type=template&id=34d366c0&scoped=true

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpCopyToClipboard.vue?vue&type=script&lang=js

  

  /* harmony default export */ var DpCopyToClipboardvue_type_script_lang_js = ({
    name: "DpCopyToClipboard",
    props: {
      value: [String,Number],
      inline: {type: Boolean, default: false},
      label: {type: String, default: undefined},
      rtl: {type: Boolean, default: false},
      disableAnimation: {type: Boolean, default: false}
    },
    data() {
      return {
        popMessage: false,
        areaFlash: false
      };
    },
    computed: {
      isEmpty() {return (isEmpty_default());},
      copyString() {return this.value.toString()}
    },
    methods: {
      popMessageAnimation() {
        this.popMessage = true;
        let self = this;
        setTimeout(function () {
          self.popMessage = false;
        }, 2500);
      },
      areaFlashAnimation() {
        this.areaFlash = true;
        let self = this;
        setTimeout(function () {
          self.areaFlash = false;
        }, 250);
      },
      copyToClipboard() {
        // https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f (17/09/2020)
        const el = document.createElement('textarea');  // Create a <textarea> element
        el.value = this.copyString;                                 // Set its value to the string that you want copied
        el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        el.style.position = 'absolute';
        el.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
        const selected =
          document.getSelection().rangeCount > 0        // Check if there is any content selected previously
            ? document.getSelection().getRangeAt(0)     // Store selection if found
            : false;                                    // Mark as false to know no selection existed before
        el.select();                                    // Select the <textarea> content
        document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
          document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
          document.getSelection().addRange(selected);   // Restore the original selection
        }
        if (!this.disableAnimation) {
          this.popMessageAnimation();
          this.areaFlashAnimation();
        }
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpCopyToClipboard.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpCopyToClipboard.vue?vue&type=style&index=0&id=34d366c0&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpCopyToClipboard.vue?vue&type=style&index=0&id=34d366c0&lang=scss&scoped=true

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpCopyToClipboard.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpCopyToClipboardvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "de-AT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "de-CH": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In die Zwischenablage kopiert"])}
        }
      },
      "en-US": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copied to clipboard"])}
        }
      },
      "en-GB": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copied to clipboard"])}
        }
      },
      "it-IT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copia"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiato negli appunti"])}
        }
      },
      "fr-FR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copié dans le presse-papier"])}
        }
      },
      "es-ES": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiar"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiado al portapapeles"])}
        }
      },
      "pl-PL": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiuj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiowane do schowka"])}
        }
      },
      "nl-NL": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiëren"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gekopieerd naar klembord"])}
        }
      },
      "bg-BG": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Копиране"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Копирано в клипборда"])}
        }
      },
      "bs-BA": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiraj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopirano u međuspremnik"])}
        }
      },
      "zh-CN": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["复制"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["复制到剪贴板"])}
        }
      },
      "da-DK": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieret til udklipsholderen"])}
        }
      },
      "et-EE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopeeri"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopeeritud lõikelauale"])}
        }
      },
      "fi-FI": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopioi"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopioitu leikepöydälle"])}
        }
      },
      "el-GR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγραφή"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγράφηκε στο πρόχειρο"])}
        }
      },
      "he-IL": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עותק"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הועתק ללוח"])}
        }
      },
      "ga-IE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cóipeáil"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cóipeáladh chuig an ngearrthaisce é"])}
        }
      },
      "ja-JP": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["コピー"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリップボードにコピー"])}
        }
      },
      "hr-HR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiraj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopirano u međuspremnik"])}
        }
      },
      "lv-LV": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopēt"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nokopēts starpliktuvē"])}
        }
      },
      "lt-LT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopijuoti"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nukopijuota į mainų sritį"])}
        }
      },
      "pt-PT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiar"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiado para a área de transferência"])}
        }
      },
      "ro-RO": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiere"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copiat în clipboard"])}
        }
      },
      "ru-RU": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скопировать"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скопировано в буфер обмена"])}
        }
      },
      "sv-SE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiera"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopieras till Urklipp"])}
        }
      },
      "sk-SK": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kópia"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopírované do schránky"])}
        }
      },
      "cs-CZ": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopírovat"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zkopírováno do schránky"])}
        }
      },
      "tr-TR": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopyala"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Panoya kopyalandı"])}
        }
      },
      "hu-HU": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Másol"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A vágólapra másolva"])}
        }
      },
      "ar-AE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نسخ"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم النسخ إلى الحافظة"])}
        }
      },
      "fr-BE": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copié dans le presse-papier"])}
        }
      },
      "fr-LU": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copier"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copié dans le presse-papier"])}
        }
      },
      "mt-MT": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkopja"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkoppjat fuq il-klibbord"])}
        }
      },
      "sl-SI": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiraj"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopirano v odložišče"])}
        }
      },
      "el-CY": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγραφή"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αντιγράφηκε στο πρόχειρο"])}
        }
      },
      "tr-CY": {
        "copy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopyala"])}
        },
        "copied": {
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Panoya kopyalandı"])}
        }
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpCopyToClipboard.vue




;
/* custom blocks */

if (typeof DpCopyToClipboardvue_type_custom_index_0_blockType_i18n === 'function') DpCopyToClipboardvue_type_custom_index_0_blockType_i18n(DpCopyToClipboardvue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpCopyToClipboardvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-34d366c0"]])

/* harmony default export */ var DpCopyToClipboard = (__exports__);

/***/ }),

/***/ 4577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpDismissAll; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpDismissAll.vue?vue&type=template&id=17b10166


const _hoisted_1 = {
  key: 0,
  class: "dp-dismiss-all"
}

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpIcon")

  return (!$options.allDismissed)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.dismissAll && $options.dismissAll(...args)))
        }, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpIcon, {
            icon: "close",
            size: 14,
            color: "#909399",
            float: "none"
          }),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(($props.label)?$props.label:_ctx.$t('dismissAll.label')), 1)
        ]),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($data.dismissed), 1)
      ]))
    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
}
;// CONCATENATED MODULE: ./src/components/DpDismissAll.vue?vue&type=template&id=17b10166

// EXTERNAL MODULE: ./src/components/DpIcon.vue + 2 modules
var DpIcon = __webpack_require__(5172);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpDismissAll.vue?vue&type=script&lang=js
/* provided dependency */ var console = __webpack_require__(5108);

  
  /* harmony default export */ var DpDismissAllvue_type_script_lang_js = ({
    name: "DpDismissAll",
    components: {DpIcon: DpIcon["default"]},
    props: {
      modelValue: {type: Array},
      label: {type: String},
      // dismissed: {type: Array, required: true}
    },
    data() {
      return {dismissed: this.modelValue};
    },
    computed: {
      allDismissed() {
        return (this.dismissed.every((state) => {return (state === true);}));
      }
    },
    // watch: {
    //   dismissed: {
    //     deep: true,
    //     handler() {
    //       console.log(this.dismissed);
    //       // True if all elements in array 'dismissed' are true
    //       this.allDismissed = (this.dismissed.every((state) => {return (state === true);}));
    //     }
    //   }
    // },
    methods: {
      dismissAll() {
        this.$emit('click', Array(this.dismissed.length).fill(true));
        console.log(this.dismissed);
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpDismissAll.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpDismissAll.vue?vue&type=style&index=0&id=17b10166&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpDismissAll.vue?vue&type=style&index=0&id=17b10166&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpDismissAll.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpDismissAllvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpDismissAll.dismissAll.label"])}
        }
      },
      "de-AT": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-CH": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-US": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-GB": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "it-IT": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-FR": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "es-ES": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pl-PL": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "nl-NL": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bg-BG": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bs-BA": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "zh-CN": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "da-DK": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "et-EE": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fi-FI": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-GR": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "he-IL": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ga-IE": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ja-JP": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hr-HR": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lv-LV": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lt-LT": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pt-PT": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ro-RO": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ru-RU": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sv-SE": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sk-SK": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "cs-CZ": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-TR": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hu-HU": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-AE": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-BE": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-LU": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "mt-MT": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-CY": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-CY": {
        "dismissAll": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpDismissAll.vue




;
/* custom blocks */

if (typeof DpDismissAllvue_type_custom_index_0_blockType_i18n === 'function') DpDismissAllvue_type_custom_index_0_blockType_i18n(DpDismissAllvue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpDismissAllvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpDismissAll = (__exports__);

/***/ }),

/***/ 4177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpExpand; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpExpand.vue?vue&type=script&setup=true&lang=js



/* harmony default export */ var DpExpandvue_type_script_setup_true_lang_js = ({
  __name: 'DpExpand',
  props: {
  fast: {type: Boolean, default: false}
},
  setup(__props) {


const on = {
  beforeEnter(el) {
    if (!el.dataset) el.dataset = {}
    el.dataset.oldPaddingTop = el.style.paddingTop
    el.dataset.oldPaddingBottom = el.style.paddingBottom
    el.dataset.oldMarginTop = el.style.marginTop
    el.dataset.oldMarginBottom = el.style.marginBottom
    el.style.maxHeight = 0
    el.style.paddingTop = 0
    el.style.paddingBottom = 0
    el.style.marginTop = 0
    el.style.marginBottom = 0
  },

  enter(el) {
    el.dataset.oldOverflow = el.style.overflow
    if (el.scrollHeight !== 0) {
      el.style.maxHeight = `${el.scrollHeight}px`
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
      el.style.marginTop = el.dataset.oldMarginTop
      el.style.marginBottom = el.dataset.oldMarginBottom
    } else {
      el.style.maxHeight = 0
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
      el.style.marginTop = el.dataset.oldMarginTop
      el.style.marginBottom = el.dataset.oldMarginBottom
    }
    el.style.overflow = 'hidden'
  },

  afterEnter(el) {
    el.style.maxHeight = ''
    el.style.overflow = el.dataset.oldOverflow
  },

  beforeLeave(el) {
    if (!el.dataset) el.dataset = {}
    el.dataset.oldPaddingTop = el.style.paddingTop
    el.dataset.oldPaddingBottom = el.style.paddingBottom
    el.dataset.oldMarginTop = el.style.marginTop
    el.dataset.oldMarginBottom = el.style.marginBottom
    el.dataset.oldOverflow = el.style.overflow
    el.style.maxHeight = `${el.scrollHeight}px`
    el.style.overflow = 'hidden'
  },

  leave(el) {
    if (el.scrollHeight !== 0) {
      el.style.maxHeight = 0
      el.style.paddingTop = 0
      el.style.paddingBottom = 0
      el.style.marginTop = 0
      el.style.marginBottom = 0
    }
  },

  afterLeave(el) {
    el.style.maxHeight = ''
    el.style.overflow = el.dataset.oldOverflow
    el.style.paddingTop = el.dataset.oldPaddingTop
    el.style.paddingBottom = el.dataset.oldPaddingBottom
    el.style.marginTop = el.dataset.oldMarginTop
    el.style.marginBottom = el.dataset.oldMarginBottom
  }
}

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    name: `dp-expand${__props.fast ? '-fast' : ''}`
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toHandlers)(on)), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["name"]))
}
}

});
;// CONCATENATED MODULE: ./src/components/DpExpand.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpExpand.vue?vue&type=style&index=0&id=d7d7a8de&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpExpand.vue?vue&type=style&index=0&id=d7d7a8de&lang=css

;// CONCATENATED MODULE: ./src/components/DpExpand.vue



;

const __exports__ = DpExpandvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpExpand = (__exports__);

/***/ }),

/***/ 9574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpFeaturedButton; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFeaturedButton.vue?vue&type=template&id=2807b0d5


function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col")
  const _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row")
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
    purpose: "secondaryAction",
    class: "dp-featured-button"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
        type: "flex",
        class: "dp-featured-button__headline"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { align: "left" }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "headline")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
        type: "flex",
        class: "dp-featured-button__description"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { align: "left" }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "description")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
;// CONCATENATED MODULE: ./src/components/DpFeaturedButton.vue?vue&type=template&id=2807b0d5

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFeaturedButton.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFeaturedButtonvue_type_script_lang_js = ({
    //TODO: deprecated?
    inheritAttrs: true,
    name: "DpFeaturedButton"
  });

;// CONCATENATED MODULE: ./src/components/DpFeaturedButton.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFeaturedButton.vue?vue&type=style&index=0&id=2807b0d5&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpFeaturedButton.vue?vue&type=style&index=0&id=2807b0d5&lang=scss

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpFeaturedButton.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFeaturedButtonvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpFeaturedButton = (__exports__);

/***/ }),

/***/ 9963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpFeedforward; }
});

// EXTERNAL MODULE: ./src/components/DpNotificationPersist.vue + 7 modules
var DpNotificationPersist = __webpack_require__(451);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFeedforward.vue?vue&type=script&lang=js

  

  /* harmony default export */ var DpFeedforwardvue_type_script_lang_js = ({
    name: "DpFeedforward",
    mixins: [DpNotificationPersist["default"]]
  });

;// CONCATENATED MODULE: ./src/components/DpFeedforward.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFeedforward.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpFeedforwardvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpFeedforward.vue


/* custom blocks */
;
if (typeof DpFeedforwardvue_type_custom_index_0_blockType_i18n === 'function') DpFeedforwardvue_type_custom_index_0_blockType_i18n(DpFeedforwardvue_type_script_lang_js)


const __exports__ = DpFeedforwardvue_type_script_lang_js;

/* harmony default export */ var DpFeedforward = (__exports__);

/***/ }),

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpFileIcon; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon.vue?vue&type=template&id=3de07528


const _hoisted_1 = ["width", "height", "viewBox"]

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpFileIconCSV = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconCSV")
  const _component_DpFileIconDOC = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconDOC")
  const _component_DpFileIconDOCX = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconDOCX")
  const _component_DpFileIconJPG = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconJPG")
  const _component_DpFileIconPDF = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconPDF")
  const _component_DpFileIconPNG = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconPNG")
  const _component_DpFileIconPPT = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconPPT")
  const _component_DpFileIconPPTX = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconPPTX")
  const _component_DpFileIconSVG = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconSVG")
  const _component_DpFileIconTIFF = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconTIFF")
  const _component_DpFileIconTXT = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconTXT")
  const _component_DpFileIconXLS = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconXLS")
  const _component_DpFileIconXLSX = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconXLSX")
  const _component_DpFileIconXML = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIconXML")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", {
    class: "dp-file-icon",
    xmlns: "http://www.w3.org/2000/svg",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)($options.style),
    width: $options.defaultWidth,
    height: $options.defaultHeight,
    viewBox: $options.viewBox
  }, [
    ($props.fileExtension === 'csv')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconCSV, {
          key: 0,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'doc')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconDOC, {
          key: 1,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'docx')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconDOCX, {
          key: 2,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'jpg')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconJPG, {
          key: 3,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'pdf')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconPDF, {
          key: 4,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'png')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconPNG, {
          key: 5,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'ppt')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconPPT, {
          key: 6,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'pptx')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconPPTX, {
          key: 7,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'svg')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconSVG, {
          key: 8,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'tiff')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconTIFF, {
          key: 9,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'txt')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconTXT, {
          key: 10,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'xls')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconXLS, {
          key: 11,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'xlsx')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconXLSX, {
          key: 12,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.fileExtension === 'xml')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFileIconXML, {
          key: 13,
          outlined: $props.outlined,
          inverted: $props.inverted
        }, null, 8, ["outlined", "inverted"]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
  ], 12, _hoisted_1))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon.vue?vue&type=template&id=3de07528

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconCSV.vue?vue&type=template&id=f76ce6d2


const DpFileIconCSVvue_type_template_id_f76ce6d2_hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30,48.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,27.46,54a2.71,2.71,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.6,2.6,0,0,0,.51-.85,3.86,3.86,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,31.4,53a4.29,4.29,0,0,1-.91,1.3,4,4,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.79,3.79,0,0,1,.45,1.46Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M34.22,51.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,10.7,10.7,0,0,0-1.26-.38l-1.77-.46A4.11,4.11,0,0,1,34,49.91a2.62,2.62,0,0,1-.69-.62,2.4,2.4,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.78,2.78,0,0,1,.84-.93,3.76,3.76,0,0,1,1.2-.55,5.16,5.16,0,0,1,1.35-.18A5.23,5.23,0,0,1,38,45a3.7,3.7,0,0,1,1.24.62,2.91,2.91,0,0,1,.85,1,3,3,0,0,1,.31,1.4H38.66A1.71,1.71,0,0,0,38,46.65a2.65,2.65,0,0,0-1.52-.41,2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.11,2.11,0,0,0,.88.47l.44.12.88.23.94.25.67.18a2.93,2.93,0,0,1,.87.42,3,3,0,0,1,.61.62,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.06,6.06,0,0,1-1.48.18,6.17,6.17,0,0,1-1.63-.22,3.89,3.89,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.77,45h1.85l2.54,8h0l2.61-8h1.8L46.13,55.19h-2Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_8 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const _hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28,46.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,25.46,52a2.54,2.54,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.5,2.5,0,0,0,.51-.85,3.86,3.86,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,29.4,51a4.17,4.17,0,0,1-.91,1.3,3.84,3.84,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.79,3.79,0,0,1,.45,1.46Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.22,49.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,10.7,10.7,0,0,0-1.26-.38l-1.77-.46A4.11,4.11,0,0,1,32,47.91a2.62,2.62,0,0,1-.69-.62,2.4,2.4,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.87,2.87,0,0,1,.84-.93,3.76,3.76,0,0,1,1.2-.55,5.16,5.16,0,0,1,1.35-.18A5.23,5.23,0,0,1,36,43a3.7,3.7,0,0,1,1.24.62,2.91,2.91,0,0,1,.85,1,3,3,0,0,1,.31,1.4H36.66A1.71,1.71,0,0,0,36,44.65a2.65,2.65,0,0,0-1.52-.41,3.58,3.58,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.11,2.11,0,0,0,.88.47l.44.12.88.23.94.25.67.18a3,3,0,0,1,.87.43,2.71,2.71,0,0,1,.61.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.06,6.06,0,0,1-1.48.18,6.17,6.17,0,0,1-1.63-.22,3.89,3.89,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M38.77,43h1.85l2.54,8h0l2.61-8h1.8L44.13,53.19h-2Z",
  fill: "#15ada6"
}, null, -1)
const _hoisted_16 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30,48.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,5.63,5.63,0,0,0-.17,1.42,5.71,5.71,0,0,0,.17,1.43,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,27.46,54a2.71,2.71,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.6,2.6,0,0,0,.51-.85,3.86,3.86,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,31.4,53a4.29,4.29,0,0,1-.91,1.3,4,4,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.79,3.79,0,0,1,.45,1.46Z",
  fill: "#099192"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M34.22,51.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.33,1.33,0,0,0-.57-.39,10.7,10.7,0,0,0-1.26-.38l-1.77-.46A4.11,4.11,0,0,1,34,49.91a2.62,2.62,0,0,1-.69-.62,2.4,2.4,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.78,2.78,0,0,1,.84-.93,3.76,3.76,0,0,1,1.2-.55A5.31,5.31,0,0,1,38,45a3.7,3.7,0,0,1,1.24.62,2.91,2.91,0,0,1,.85,1,3,3,0,0,1,.31,1.4H38.66A1.71,1.71,0,0,0,38,46.65a2.65,2.65,0,0,0-1.52-.41,2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.11,2.11,0,0,0,.88.47l.44.12.88.23.94.25.67.18a2.93,2.93,0,0,1,.87.42,3,3,0,0,1,.61.62,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.06,6.06,0,0,1-1.48.18,6.17,6.17,0,0,1-1.63-.22,3.89,3.89,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#099192"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.77,45h1.85l2.54,8h0l2.61-8h1.8L46.13,55.19h-2Z",
  fill: "#099192"
}, null, -1)
const _hoisted_24 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28,46.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,25.46,52a2.54,2.54,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.5,2.5,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,29.4,51a4.17,4.17,0,0,1-.91,1.3,3.93,3.93,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.62,3.62,0,0,1,.44,1.46Z",
  fill: "#099192"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.22,49.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,10.7,10.7,0,0,0-1.26-.38l-1.77-.46A4.11,4.11,0,0,1,32,47.91a2.62,2.62,0,0,1-.69-.62,2.4,2.4,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.87,2.87,0,0,1,.84-.93,3.76,3.76,0,0,1,1.2-.55A5.31,5.31,0,0,1,36,43a3.7,3.7,0,0,1,1.24.62,2.91,2.91,0,0,1,.85,1,3,3,0,0,1,.31,1.4H36.66A1.71,1.71,0,0,0,36,44.65a2.65,2.65,0,0,0-1.52-.41,3.58,3.58,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.11,2.11,0,0,0,.88.47l.44.12.88.23.94.25.67.18a2.77,2.77,0,0,1,.86.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#099192"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M38.77,43h1.85l2.54,8h0l2.61-8h1.8L44.13,53.19h-2Z",
  fill: "#099192"
}, null, -1)
const _hoisted_32 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]

function DpFileIconCSVvue_type_template_id_f76ce6d2_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconCSVvue_type_template_id_f76ce6d2_hoisted_1, _hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_9, _hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_17, _hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", _hoisted_25, _hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconCSV.vue?vue&type=template&id=f76ce6d2

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconCSV.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconCSVvue_type_script_lang_js = ({
    name: "DpFileIconCSV",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconCSV.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconCSV.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconCSVvue_type_script_lang_js, [['render',DpFileIconCSVvue_type_template_id_f76ce6d2_render]])

/* harmony default export */ var DpFileIconCSV = (__exports__);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconDOC.vue?vue&type=template&id=5abd2e7b


const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_1 = { key: 0 }
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.55,45h4.21a4.82,4.82,0,0,1,2,.4,3.81,3.81,0,0,1,1.4,1.09,4.55,4.55,0,0,1,.8,1.62,7.36,7.36,0,0,1,0,4,4.55,4.55,0,0,1-.8,1.62,3.81,3.81,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H21.55Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.78,2.78,0,0,0,.51-1.16,7.08,7.08,0,0,0,.14-1.43,7.22,7.22,0,0,0-.14-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H23.33Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M35.79,44.79a4.7,4.7,0,0,1,2.05.43,4.61,4.61,0,0,1,1.53,1.15,5.44,5.44,0,0,1,1,1.7,6.23,6.23,0,0,1,.33,2,6.41,6.41,0,0,1-.33,2.07,5.39,5.39,0,0,1-1,1.69A4.61,4.61,0,0,1,37.84,55a5.19,5.19,0,0,1-4.09,0,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15A4.66,4.66,0,0,1,35.79,44.79Zm0,1.45a2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.13,6.13,0,0,0-.17,1.42,6.22,6.22,0,0,0,.17,1.43,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,2.88,2.88,0,0,0,1.41-.32,2.79,2.79,0,0,0,1-.88,3.86,3.86,0,0,0,.54-1.24,5.72,5.72,0,0,0,.18-1.43,5.64,5.64,0,0,0-.18-1.42,3.86,3.86,0,0,0-.54-1.24,2.79,2.79,0,0,0-1-.88A2.88,2.88,0,0,0,35.79,46.24Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M48.79,48.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,46.25,54a2.71,2.71,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.6,2.6,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,50.19,53a4.29,4.29,0,0,1-.91,1.3,4.09,4.09,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.62,3.62,0,0,1,.44,1.46Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_8 = [
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_2,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_3,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_4,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_5,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_6,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_7
]
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_9 = { key: 1 }
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.55,43h4.21a4.82,4.82,0,0,1,2,.4,3.81,3.81,0,0,1,1.4,1.09,4.55,4.55,0,0,1,.8,1.62,7.63,7.63,0,0,1,0,4,4.55,4.55,0,0,1-.8,1.62,3.81,3.81,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H19.55Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.84,2.84,0,0,0,.51-1.16,7.08,7.08,0,0,0,.14-1.43,7.22,7.22,0,0,0-.14-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H21.33Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M33.79,42.79a4.85,4.85,0,0,1,2.05.43,4.61,4.61,0,0,1,1.53,1.15,5.44,5.44,0,0,1,1,1.7,6.23,6.23,0,0,1,.33,2,6.41,6.41,0,0,1-.33,2.07,5.39,5.39,0,0,1-1,1.69A4.61,4.61,0,0,1,35.84,53a5.19,5.19,0,0,1-4.09,0,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15A4.8,4.8,0,0,1,33.79,42.79Zm0,1.45a2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,2.88,2.88,0,0,0,1.41-.32,2.79,2.79,0,0,0,1-.88,3.86,3.86,0,0,0,.54-1.24,5.73,5.73,0,0,0,0-2.85,3.86,3.86,0,0,0-.54-1.24,2.79,2.79,0,0,0-1-.88A2.88,2.88,0,0,0,33.79,44.24Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.79,46.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,44.25,52a2.54,2.54,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.5,2.5,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,48.19,51a4.17,4.17,0,0,1-.91,1.3,3.93,3.93,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.62,3.62,0,0,1,.44,1.46Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_16 = [
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_10,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_11,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_12,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_13,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_14,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_15
]
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_17 = { key: 2 }
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.55,45h4.21a4.82,4.82,0,0,1,2,.4,3.81,3.81,0,0,1,1.4,1.09,4.55,4.55,0,0,1,.8,1.62,7.36,7.36,0,0,1,0,4,4.55,4.55,0,0,1-.8,1.62,3.81,3.81,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H21.55Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.78,2.78,0,0,0,.51-1.16,7.08,7.08,0,0,0,.14-1.43,7.22,7.22,0,0,0-.14-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H23.33Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M35.79,44.79a4.7,4.7,0,0,1,2.05.43,4.61,4.61,0,0,1,1.53,1.15,5.44,5.44,0,0,1,1,1.7,6.23,6.23,0,0,1,.33,2,6.41,6.41,0,0,1-.33,2.07,5.39,5.39,0,0,1-1,1.69A4.61,4.61,0,0,1,37.84,55a5.19,5.19,0,0,1-4.09,0,4.61,4.61,0,0,1-1.53-1.15,5.39,5.39,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.44,5.44,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15A4.66,4.66,0,0,1,35.79,44.79Zm0,1.45a2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.13,6.13,0,0,0-.17,1.42,6.22,6.22,0,0,0,.17,1.43,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,2.88,2.88,0,0,0,1.41-.32,2.79,2.79,0,0,0,1-.88,3.86,3.86,0,0,0,.54-1.24,5.72,5.72,0,0,0,.18-1.43,5.64,5.64,0,0,0-.18-1.42,3.86,3.86,0,0,0-.54-1.24,2.79,2.79,0,0,0-1-.88A2.88,2.88,0,0,0,35.79,46.24Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M48.79,48.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43,3.88,3.88,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,2.71,2.71,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.6,2.6,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,50.19,53a4.29,4.29,0,0,1-.91,1.3,4.09,4.09,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.62,3.62,0,0,1,.44,1.46Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_24 = [
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_18,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_19,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_20,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_21,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_22,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_23
]
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_25 = { key: 3 }
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.55,43h4.21a4.82,4.82,0,0,1,2,.4,3.81,3.81,0,0,1,1.4,1.09,4.55,4.55,0,0,1,.8,1.62,7.63,7.63,0,0,1,0,4,4.55,4.55,0,0,1-.8,1.62,3.81,3.81,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H19.55Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.84,2.84,0,0,0,.51-1.16,7.08,7.08,0,0,0,.14-1.43,7.22,7.22,0,0,0-.14-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H21.33Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M33.79,42.79a4.85,4.85,0,0,1,2.05.43,4.61,4.61,0,0,1,1.53,1.15,5.44,5.44,0,0,1,1,1.7,6.23,6.23,0,0,1,.33,2,6.41,6.41,0,0,1-.33,2.07,5.39,5.39,0,0,1-1,1.69A4.61,4.61,0,0,1,35.84,53a5.19,5.19,0,0,1-4.09,0,4.61,4.61,0,0,1-1.53-1.15,5.2,5.2,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.25,5.25,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15A4.8,4.8,0,0,1,33.79,42.79Zm0,1.45a2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,2.88,2.88,0,0,0,1.41-.32,2.79,2.79,0,0,0,1-.88,3.86,3.86,0,0,0,.54-1.24,5.73,5.73,0,0,0,0-2.85,3.86,3.86,0,0,0-.54-1.24,2.79,2.79,0,0,0-1-.88A2.88,2.88,0,0,0,33.79,44.24Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.79,46.26a3.6,3.6,0,0,0-.32-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.71,2.71,0,0,0-2.36,1.21,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24A2.68,2.68,0,0,0,44.25,52a2.54,2.54,0,0,0,1.06-.2,2.46,2.46,0,0,0,.78-.57,2.5,2.5,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74A4.93,4.93,0,0,1,48.19,51a4.17,4.17,0,0,1-.91,1.3,3.93,3.93,0,0,1-1.33.85,4.67,4.67,0,0,1-1.7.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43,5.27,5.27,0,0,1,1.61.24,4,4,0,0,1,1.33.68,3.36,3.36,0,0,1,.93,1.09,3.62,3.62,0,0,1,.44,1.46Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_32 = [
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_26,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_27,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_28,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_29,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_30,
  DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_31
]

function DpFileIconDOCvue_type_template_id_5abd2e7b_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_1, DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_9, DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_17, DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_25, DpFileIconDOCvue_type_template_id_5abd2e7b_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconDOC.vue?vue&type=template&id=5abd2e7b

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconDOC.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconDOCvue_type_script_lang_js = ({
    name: "DpFileIconDOC",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconDOC.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconDOC.vue




;
const DpFileIconDOC_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconDOCvue_type_script_lang_js, [['render',DpFileIconDOCvue_type_template_id_5abd2e7b_render]])

/* harmony default export */ var DpFileIconDOC = (DpFileIconDOC_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconDOCX.vue?vue&type=template&id=62219aac


const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_1 = { key: 0 }
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M17.12,45h4.21a4.82,4.82,0,0,1,2,.4,3.9,3.9,0,0,1,1.4,1.09,4.73,4.73,0,0,1,.8,1.62,7.63,7.63,0,0,1,0,4,4.73,4.73,0,0,1-.8,1.62,3.9,3.9,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H17.12Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.78,2.78,0,0,0,.51-1.16A7.1,7.1,0,0,0,24,50.11a7.24,7.24,0,0,0-.13-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H18.9Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31.36,44.79a4.63,4.63,0,0,1,2,.43,4.41,4.41,0,0,1,1.53,1.15,5.07,5.07,0,0,1,1,1.7,6,6,0,0,1,.34,2,6.16,6.16,0,0,1-.34,2.07,5,5,0,0,1-1,1.69A4.41,4.41,0,0,1,33.4,55a5.16,5.16,0,0,1-4.08,0,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58Zm0,1.45A2.71,2.71,0,0,0,29,47.45a3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43A3.88,3.88,0,0,0,29,52.78a3,3,0,0,0,3.76.88,2.63,2.63,0,0,0,1-.88,3.88,3.88,0,0,0,.55-1.24,5.72,5.72,0,0,0,.18-1.43,5.64,5.64,0,0,0-.18-1.42,3.88,3.88,0,0,0-.55-1.24,2.63,2.63,0,0,0-1-.88A2.81,2.81,0,0,0,31.36,46.24Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.35,48.26a3.58,3.58,0,0,0-.31-.81,2.2,2.2,0,0,0-1.25-1.06,3.17,3.17,0,0,0-2.37.18,2.71,2.71,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43,3.88,3.88,0,0,0,.55,1.24,2.71,2.71,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,2.62,2.62,0,0,0,1-.2,2.39,2.39,0,0,0,.79-.57,3,3,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74a4.71,4.71,0,0,1-.4,1.67,4.09,4.09,0,0,1-.9,1.3,4,4,0,0,1-1.34.85,4.58,4.58,0,0,1-1.69.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69A6.42,6.42,0,0,1,37,50.11a6.24,6.24,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.27,5.27,0,0,1,1.61.24,4.08,4.08,0,0,1,1.33.68,3.6,3.6,0,0,1,1.37,2.55Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.53,45h2.12L51,48.62,53.36,45h2L52,49.93l3.6,5.26H53.43L50.9,51.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_9 = [
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_2,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_3,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_4,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_5,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_6,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_7,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_8
]
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_10 = { key: 1 }
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M15.12,43h4.21a4.82,4.82,0,0,1,2,.4,3.9,3.9,0,0,1,1.4,1.09,4.73,4.73,0,0,1,.8,1.62,7.63,7.63,0,0,1,0,4,4.73,4.73,0,0,1-.8,1.62,3.9,3.9,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H15.12Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.84,2.84,0,0,0,.51-1.16A7.1,7.1,0,0,0,22,48.11a7.24,7.24,0,0,0-.13-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H16.9Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29.36,42.79a4.77,4.77,0,0,1,2,.43,4.41,4.41,0,0,1,1.53,1.15,5.07,5.07,0,0,1,1,1.7,6,6,0,0,1,.34,2,6.16,6.16,0,0,1-.34,2.07,5,5,0,0,1-1,1.69A4.41,4.41,0,0,1,31.4,53a5.16,5.16,0,0,1-4.08,0,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15A4.77,4.77,0,0,1,29.36,42.79Zm0,1.45A2.71,2.71,0,0,0,27,45.45a3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85A3.88,3.88,0,0,0,27,50.78a3,3,0,0,0,3.76.88,2.63,2.63,0,0,0,1-.88,3.88,3.88,0,0,0,.55-1.24,5.73,5.73,0,0,0,0-2.85,3.88,3.88,0,0,0-.55-1.24,2.63,2.63,0,0,0-1-.88A2.81,2.81,0,0,0,29.36,44.24Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.35,46.26a3.58,3.58,0,0,0-.31-.81,2.2,2.2,0,0,0-1.25-1.06,3.17,3.17,0,0,0-2.37.18,2.71,2.71,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24,2.71,2.71,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,2.46,2.46,0,0,0,1-.2,2.39,2.39,0,0,0,.79-.57,2.87,2.87,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74a4.71,4.71,0,0,1-.4,1.67,4,4,0,0,1-.9,1.3,3.88,3.88,0,0,1-1.34.85,4.58,4.58,0,0,1-1.69.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69A6.42,6.42,0,0,1,35,48.11a6.24,6.24,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43,5.27,5.27,0,0,1,1.61.24,4.08,4.08,0,0,1,1.33.68,3.6,3.6,0,0,1,1.37,2.55Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_17 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.53,43h2.12L49,46.62,51.36,43h2L50,47.93l3.6,5.26H51.43L48.9,49.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_18 = [
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_11,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_12,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_13,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_14,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_15,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_16,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_17
]
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_19 = { key: 2 }
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M17.12,45h4.21a4.82,4.82,0,0,1,2,.4,3.81,3.81,0,0,1,1.4,1.09,4.73,4.73,0,0,1,.8,1.62,7.63,7.63,0,0,1,0,4,4.73,4.73,0,0,1-.8,1.62,3.81,3.81,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H17.12Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.78,2.78,0,0,0,.51-1.16A7.1,7.1,0,0,0,24,50.11a7.24,7.24,0,0,0-.13-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H18.9Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31.36,44.79a4.63,4.63,0,0,1,2,.43,4.41,4.41,0,0,1,1.53,1.15,5.07,5.07,0,0,1,1,1.7,6,6,0,0,1,.34,2,6.16,6.16,0,0,1-.34,2.07,5,5,0,0,1-1,1.69A4.41,4.41,0,0,1,33.4,55a5.16,5.16,0,0,1-4.08,0,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58Zm0,1.45A2.71,2.71,0,0,0,29,47.45a3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43A3.88,3.88,0,0,0,29,52.78a3,3,0,0,0,3.76.88,2.63,2.63,0,0,0,1-.88,3.88,3.88,0,0,0,.55-1.24,5.72,5.72,0,0,0,.18-1.43,5.64,5.64,0,0,0-.18-1.42,3.88,3.88,0,0,0-.55-1.24,2.63,2.63,0,0,0-1-.88A2.81,2.81,0,0,0,31.36,46.24Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.35,48.26a3.58,3.58,0,0,0-.31-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.81,2.81,0,0,0-1.4.33,2.71,2.71,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43,3.88,3.88,0,0,0,.55,1.24,2.71,2.71,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,2.62,2.62,0,0,0,1-.2,2.39,2.39,0,0,0,.79-.57,3,3,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74a4.71,4.71,0,0,1-.4,1.67,4.09,4.09,0,0,1-.9,1.3,4,4,0,0,1-1.34.85,4.58,4.58,0,0,1-1.69.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69A6.42,6.42,0,0,1,37,50.11a6.24,6.24,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.27,5.27,0,0,1,1.61.24,4.08,4.08,0,0,1,1.33.68,3.6,3.6,0,0,1,1.37,2.55Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.53,45h2.12L51,48.62,53.36,45h2L52,49.93l3.6,5.26H53.43L50.9,51.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_27 = [
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_20,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_21,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_22,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_23,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_24,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_25,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_26
]
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_28 = { key: 3 }
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#136389"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconDOCXvue_type_template_id_62219aac_hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M15.12,43h4.21a4.82,4.82,0,0,1,2,.4,3.81,3.81,0,0,1,1.4,1.09,4.73,4.73,0,0,1,.8,1.62,7.63,7.63,0,0,1,0,4,4.73,4.73,0,0,1-.8,1.62,3.81,3.81,0,0,1-1.4,1.09,4.82,4.82,0,0,1-2,.39H15.12Zm1.78,8.71h1.75a4.55,4.55,0,0,0,1.7-.27,2.6,2.6,0,0,0,1-.77,2.84,2.84,0,0,0,.51-1.16A7.1,7.1,0,0,0,22,48.11a7.24,7.24,0,0,0-.13-1.43,2.8,2.8,0,0,0-.51-1.15,2.51,2.51,0,0,0-1-.77,4.55,4.55,0,0,0-1.7-.27H16.9Z",
  fill: "#136389"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29.36,42.79a4.77,4.77,0,0,1,2,.43,4.41,4.41,0,0,1,1.53,1.15,5.07,5.07,0,0,1,1,1.7,6,6,0,0,1,.34,2,6.16,6.16,0,0,1-.34,2.07,5,5,0,0,1-1,1.69A4.41,4.41,0,0,1,31.4,53a5.16,5.16,0,0,1-4.08,0,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15A4.77,4.77,0,0,1,29.36,42.79Zm0,1.45A2.71,2.71,0,0,0,27,45.45a3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85A3.88,3.88,0,0,0,27,50.78a3,3,0,0,0,3.76.88,2.63,2.63,0,0,0,1-.88,3.88,3.88,0,0,0,.55-1.24,5.73,5.73,0,0,0,0-2.85,3.88,3.88,0,0,0-.55-1.24,2.63,2.63,0,0,0-1-.88A2.81,2.81,0,0,0,29.36,44.24Z",
  fill: "#136389"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.35,46.26a3.58,3.58,0,0,0-.31-.81,2.25,2.25,0,0,0-.51-.64,2.29,2.29,0,0,0-.73-.42,2.93,2.93,0,0,0-1-.15,2.81,2.81,0,0,0-1.4.33,2.71,2.71,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24,2.71,2.71,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,2.46,2.46,0,0,0,1-.2,2.39,2.39,0,0,0,.79-.57,2.87,2.87,0,0,0,.51-.85,4.27,4.27,0,0,0,.24-1h1.74a4.71,4.71,0,0,1-.4,1.67,4,4,0,0,1-.9,1.3,3.88,3.88,0,0,1-1.34.85,4.58,4.58,0,0,1-1.69.3,4.77,4.77,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69A6.42,6.42,0,0,1,35,48.11a6.24,6.24,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43,5.27,5.27,0,0,1,1.61.24,4.08,4.08,0,0,1,1.33.68,3.6,3.6,0,0,1,1.37,2.55Z",
  fill: "#136389"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.53,43h2.12L49,46.62,51.36,43h2L50,47.93l3.6,5.26H51.43L48.9,49.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#136389"
}, null, -1)
const _hoisted_36 = [
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_29,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_30,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_31,
  DpFileIconDOCXvue_type_template_id_62219aac_hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]

function DpFileIconDOCXvue_type_template_id_62219aac_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCXvue_type_template_id_62219aac_hoisted_1, DpFileIconDOCXvue_type_template_id_62219aac_hoisted_9))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCXvue_type_template_id_62219aac_hoisted_10, DpFileIconDOCXvue_type_template_id_62219aac_hoisted_18))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCXvue_type_template_id_62219aac_hoisted_19, DpFileIconDOCXvue_type_template_id_62219aac_hoisted_27))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconDOCXvue_type_template_id_62219aac_hoisted_28, _hoisted_36))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconDOCX.vue?vue&type=template&id=62219aac

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconDOCX.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconDOCXvue_type_script_lang_js = ({
    name: "DpFileIconDOCX",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconDOCX.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconDOCX.vue




;
const DpFileIconDOCX_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconDOCXvue_type_script_lang_js, [['render',DpFileIconDOCXvue_type_template_id_62219aac_render]])

/* harmony default export */ var DpFileIconDOCX = (DpFileIconDOCX_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconJPG.vue?vue&type=template&id=5087dfe0


const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_1 = { key: 0 }
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.74,51.92a6.91,6.91,0,0,1-.11,1.3,2.92,2.92,0,0,1-.46,1.12,2.42,2.42,0,0,1-1,.8,4.32,4.32,0,0,1-1.76.3A3.54,3.54,0,0,1,24,55.19a2.64,2.64,0,0,1-.94-.69,2.61,2.61,0,0,1-.54-1,4.85,4.85,0,0,1-.17-1.29v-.54h1.78v.52a2.65,2.65,0,0,0,.29,1.35,1.19,1.19,0,0,0,1.1.47,1.81,1.81,0,0,0,.71-.12,1.08,1.08,0,0,0,.44-.38,1.57,1.57,0,0,0,.22-.62A5.35,5.35,0,0,0,27,52V45h1.77Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.55,45H35a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1A2.68,2.68,0,0,1,36.8,51,4.46,4.46,0,0,1,35,51.3h-2.7v3.89H30.55Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H32.33Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M48.55,55.19H47.41L47.14,54a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32A4.77,4.77,0,0,1,42,55a4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.61,3.61,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H46.7a2.36,2.36,0,0,0-.3-.87,2.25,2.25,0,0,0-.6-.63,2.43,2.43,0,0,0-.79-.39,3.54,3.54,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24A5.63,5.63,0,0,0,41,50.11a5.71,5.71,0,0,0,.17,1.43,3.88,3.88,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.46,2.46,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V49.84h4.32Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_8 = [
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_2,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_3,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_4,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_5,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_6,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_7
]
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_9 = { key: 1 }
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M26.74,49.92a6.91,6.91,0,0,1-.11,1.3,2.92,2.92,0,0,1-.46,1.12,2.42,2.42,0,0,1-1,.8,4.32,4.32,0,0,1-1.76.3A3.54,3.54,0,0,1,22,53.19a2.64,2.64,0,0,1-.94-.69,2.61,2.61,0,0,1-.54-1,4.85,4.85,0,0,1-.17-1.29v-.54h1.78v.52a2.65,2.65,0,0,0,.29,1.35,1.17,1.17,0,0,0,1.1.47,1.81,1.81,0,0,0,.71-.12,1.08,1.08,0,0,0,.44-.38,1.57,1.57,0,0,0,.22-.62A5.35,5.35,0,0,0,25,50V43h1.77Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.55,43H33a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1A2.68,2.68,0,0,1,34.8,49,4.46,4.46,0,0,1,33,49.3h-2.7v3.89H28.55Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H30.33Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.55,53.19H45.41L45.14,52a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32A4.77,4.77,0,0,1,40,53a4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7A4.61,4.61,0,0,1,40,43.22a4.77,4.77,0,0,1,2-.43,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.61,3.61,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H44.7a2.36,2.36,0,0,0-.3-.87,2.25,2.25,0,0,0-.6-.63,2.65,2.65,0,0,0-.79-.39,3.54,3.54,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.46,2.46,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V47.84h4.32Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_16 = [
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_10,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_11,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_12,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_13,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_14,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_15
]
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_17 = { key: 2 }
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.74,51.92a6.91,6.91,0,0,1-.11,1.3,2.92,2.92,0,0,1-.46,1.12,2.42,2.42,0,0,1-1,.8,4.32,4.32,0,0,1-1.76.3A3.54,3.54,0,0,1,24,55.19a2.64,2.64,0,0,1-.94-.69,2.61,2.61,0,0,1-.54-1,4.85,4.85,0,0,1-.17-1.29v-.54h1.78v.52a2.65,2.65,0,0,0,.29,1.35,1.19,1.19,0,0,0,1.1.47,1.81,1.81,0,0,0,.71-.12,1.08,1.08,0,0,0,.44-.38,1.57,1.57,0,0,0,.22-.62A5.35,5.35,0,0,0,27,52V45h1.77Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.55,45H35a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1A2.68,2.68,0,0,1,36.8,51,4.46,4.46,0,0,1,35,51.3h-2.7v3.89H30.55Zm1.78,4.81h2.6a2.25,2.25,0,0,0,.62-.08,1.78,1.78,0,0,0,.57-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.28,1.28,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H32.33Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M48.55,55.19H47.41L47.14,54a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32A4.77,4.77,0,0,1,42,55a4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7,4.61,4.61,0,0,1,3.57-1.58,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.61,3.61,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H46.7a2.14,2.14,0,0,0-.89-1.5,2.59,2.59,0,0,0-.8-.39,3.54,3.54,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24A5.63,5.63,0,0,0,41,50.11a5.71,5.71,0,0,0,.17,1.43,3.88,3.88,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.46,2.46,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V49.84h4.32Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_24 = [
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_18,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_19,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_20,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_21,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_22,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_23
]
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_25 = { key: 3 }
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M26.74,49.92a6.91,6.91,0,0,1-.11,1.3,2.92,2.92,0,0,1-.46,1.12,2.42,2.42,0,0,1-1,.8,4.32,4.32,0,0,1-1.76.3A3.54,3.54,0,0,1,22,53.19a2.64,2.64,0,0,1-.94-.69,2.61,2.61,0,0,1-.54-1,4.85,4.85,0,0,1-.17-1.29v-.54h1.78v.52a2.65,2.65,0,0,0,.29,1.35,1.17,1.17,0,0,0,1.1.47,1.81,1.81,0,0,0,.71-.12,1.08,1.08,0,0,0,.44-.38,1.57,1.57,0,0,0,.22-.62A5.35,5.35,0,0,0,25,50V43h1.77Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.55,43H33a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1A2.68,2.68,0,0,1,34.8,49,4.46,4.46,0,0,1,33,49.3h-2.7v3.89H28.55Zm1.78,4.81h2.6a2.25,2.25,0,0,0,.62-.08,1.78,1.78,0,0,0,.57-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H30.33Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.55,53.19H45.41L45.14,52a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32A4.77,4.77,0,0,1,40,53a4.61,4.61,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.07,5.07,0,0,1,1-1.7A4.61,4.61,0,0,1,40,43.22a4.77,4.77,0,0,1,2-.43,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.61,3.61,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H44.7a2.14,2.14,0,0,0-.89-1.5,2.83,2.83,0,0,0-.8-.39,3.54,3.54,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,3.88,3.88,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.46,2.46,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V47.84h4.32Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_32 = [
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_26,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_27,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_28,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_29,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_30,
  DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_31
]

function DpFileIconJPGvue_type_template_id_5087dfe0_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_1, DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_9, DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_17, DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_25, DpFileIconJPGvue_type_template_id_5087dfe0_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconJPG.vue?vue&type=template&id=5087dfe0

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconJPG.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconJPGvue_type_script_lang_js = ({
    name: "DpFileIconJPG",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconJPG.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconJPG.vue




;
const DpFileIconJPG_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconJPGvue_type_script_lang_js, [['render',DpFileIconJPGvue_type_template_id_5087dfe0_render]])

/* harmony default export */ var DpFileIconJPG = (DpFileIconJPG_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPDF.vue?vue&type=template&id=c0542e3c


const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_1 = { key: 0 }
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.13,45h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78,4.46,4.46,0,0,1-1.77.31h-2.7v3.89H23.13Zm1.78,4.81h2.6a2.55,2.55,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H24.91Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.27,45h4.21a4.82,4.82,0,0,1,2,.4,3.78,3.78,0,0,1,1.39,1.09,4.74,4.74,0,0,1,.81,1.62,7.33,7.33,0,0,1,.26,2,7.4,7.4,0,0,1-.26,2,4.74,4.74,0,0,1-.81,1.62A3.78,3.78,0,0,1,38.5,54.8a4.82,4.82,0,0,1-2,.39H32.27ZM34,53.74h1.75a4.61,4.61,0,0,0,1.71-.27,2.57,2.57,0,0,0,1-.77,2.73,2.73,0,0,0,.52-1.16,7.1,7.1,0,0,0,.13-1.43,7.24,7.24,0,0,0-.13-1.43,2.69,2.69,0,0,0-.52-1.15,2.48,2.48,0,0,0-1-.77,4.61,4.61,0,0,0-1.71-.27H34Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.18,45h7v1.54H44v2.66h4.6v1.45H44v4.51H42.18Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_8 = [
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_2,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_3,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_4,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_5,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_6,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_7
]
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_9 = { key: 1 }
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.13,43h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78,4.47,4.47,0,0,1-1.77.3h-2.7v3.9H21.13Zm1.78,4.81h2.6a2.55,2.55,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H22.91Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.27,43h4.21a4.82,4.82,0,0,1,2,.4,3.78,3.78,0,0,1,1.39,1.09,4.74,4.74,0,0,1,.81,1.62,7.33,7.33,0,0,1,.26,2,7.4,7.4,0,0,1-.26,2,4.74,4.74,0,0,1-.81,1.62,3.65,3.65,0,0,1-1.39,1.08,4.67,4.67,0,0,1-2,.4H30.27ZM32,51.74h1.75a4.31,4.31,0,0,0,1.7-.28,2.43,2.43,0,0,0,1-.76,2.73,2.73,0,0,0,.52-1.16,7.1,7.1,0,0,0,.13-1.43,7.24,7.24,0,0,0-.13-1.43,2.69,2.69,0,0,0-.52-1.15,2.45,2.45,0,0,0-1-.77,4.52,4.52,0,0,0-1.7-.27H32Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.18,43h7v1.54H42v2.66h4.6v1.45H42v4.51H40.18Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_16 = [
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_10,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_11,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_12,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_13,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_14,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_15
]
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_17 = { key: 2 }
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.13,45h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78,4.46,4.46,0,0,1-1.77.31h-2.7v3.89H23.13Zm1.78,4.81h2.6a2.55,2.55,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2,2,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H24.91Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.27,45h4.21a4.82,4.82,0,0,1,2,.4,3.78,3.78,0,0,1,1.39,1.09,4.74,4.74,0,0,1,.81,1.62,7.33,7.33,0,0,1,.26,2,7.4,7.4,0,0,1-.26,2,4.74,4.74,0,0,1-.81,1.62A3.78,3.78,0,0,1,38.5,54.8a4.82,4.82,0,0,1-2,.39H32.27ZM34,53.74h1.75a4.61,4.61,0,0,0,1.71-.27,2.57,2.57,0,0,0,1-.77,2.73,2.73,0,0,0,.52-1.16,7.1,7.1,0,0,0,.13-1.43,7.24,7.24,0,0,0-.13-1.43,2.69,2.69,0,0,0-.52-1.15,2.48,2.48,0,0,0-1-.77,4.61,4.61,0,0,0-1.71-.27H34Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.18,45h7v1.54H44v2.66h4.6v1.45H44v4.51H42.18Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_24 = [
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_18,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_19,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_20,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_21,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_22,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_23
]
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_25 = { key: 3 }
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.13,43h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78,4.47,4.47,0,0,1-1.77.3h-2.7v3.9H21.13Zm1.78,4.81h2.6a2.55,2.55,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.38,1.38,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H22.91Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.27,43h4.21a4.82,4.82,0,0,1,2,.4,3.78,3.78,0,0,1,1.39,1.09,4.74,4.74,0,0,1,.81,1.62,7.33,7.33,0,0,1,.26,2,7.4,7.4,0,0,1-.26,2,4.74,4.74,0,0,1-.81,1.62,3.65,3.65,0,0,1-1.39,1.08,4.67,4.67,0,0,1-2,.4H30.27ZM32,51.74h1.75a4.31,4.31,0,0,0,1.7-.28,2.43,2.43,0,0,0,1-.76,2.73,2.73,0,0,0,.52-1.16,7.1,7.1,0,0,0,.13-1.43,7.24,7.24,0,0,0-.13-1.43,2.69,2.69,0,0,0-.52-1.15,2.45,2.45,0,0,0-1-.77,4.52,4.52,0,0,0-1.7-.27H32Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.18,43h7v1.54H42v2.66h4.6v1.45H42v4.51H40.18Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_32 = [
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_26,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_27,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_28,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_29,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_30,
  DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_31
]

function DpFileIconPDFvue_type_template_id_c0542e3c_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_1, DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_9, DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_17, DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_25, DpFileIconPDFvue_type_template_id_c0542e3c_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPDF.vue?vue&type=template&id=c0542e3c

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPDF.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconPDFvue_type_script_lang_js = ({
    name: "DpFileIconPDF",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPDF.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPDF.vue




;
const DpFileIconPDF_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconPDFvue_type_script_lang_js, [['render',DpFileIconPDFvue_type_template_id_c0542e3c_render]])

/* harmony default export */ var DpFileIconPDF = (DpFileIconPDF_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPNG.vue?vue&type=template&id=d52d639c


const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_1 = { key: 0 }
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M22,45h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1A2.68,2.68,0,0,1,28.2,51a4.46,4.46,0,0,1-1.77.31h-2.7v3.89H22Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28A1.43,1.43,0,0,0,28,49a1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H23.73Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31,45h1.88l4.64,7.49h0V45h1.69V55.19H37.37l-4.62-7.47h0v7.47H31Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.87,55.19H48.73L48.46,54A4.33,4.33,0,0,1,47,55.12a4,4,0,0,1-1.64.32,4.77,4.77,0,0,1-2-.42,4.51,4.51,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.16,6.16,0,0,1-.34-2.07,6,6,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.51,4.51,0,0,1,1.53-1.15,4.63,4.63,0,0,1,2-.43A5.78,5.78,0,0,1,47,45a4.25,4.25,0,0,1,1.33.66,3.64,3.64,0,0,1,1,1.09,3.59,3.59,0,0,1,.48,1.5H48a2.19,2.19,0,0,0-.9-1.5,2.48,2.48,0,0,0-.8-.39,3.46,3.46,0,0,0-.92-.13,2.81,2.81,0,0,0-1.4.33,2.63,2.63,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43A3.88,3.88,0,0,0,43,52.78a2.63,2.63,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,3.51,3.51,0,0,0,1.21-.17,2.32,2.32,0,0,0,1.44-1.45,3.86,3.86,0,0,0,.2-1.16H45.54V49.84h4.33Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_8 = [
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_2,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_3,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_4,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_5,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_6,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_7
]
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_9 = { key: 1 }
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M20,43h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1A2.68,2.68,0,0,1,26.2,49a4.46,4.46,0,0,1-1.77.31h-2.7v3.89H20Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28A1.43,1.43,0,0,0,26,47a1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H21.73Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29,43h1.88l4.64,7.49h0V43h1.69V53.19H35.37l-4.62-7.47h0v7.47H29Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M47.87,53.19H46.73L46.46,52A4.33,4.33,0,0,1,45,53.12a4,4,0,0,1-1.64.32,4.77,4.77,0,0,1-2-.42,4.41,4.41,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.16,6.16,0,0,1-.34-2.07,6,6,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.41,4.41,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43A5.78,5.78,0,0,1,45,43a4.25,4.25,0,0,1,1.33.66,3.64,3.64,0,0,1,1,1.09,3.59,3.59,0,0,1,.48,1.5H46a2.19,2.19,0,0,0-.9-1.5,2.71,2.71,0,0,0-.8-.39,3.46,3.46,0,0,0-.92-.13,2.81,2.81,0,0,0-1.4.33,2.63,2.63,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85A3.88,3.88,0,0,0,41,50.78a2.63,2.63,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,3.51,3.51,0,0,0,1.21-.17,2.32,2.32,0,0,0,1.44-1.45,3.57,3.57,0,0,0,.19-1.16h-2.7V47.84h4.33Z",
  fill: "#9494ed"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_16 = [
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_10,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_11,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_12,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_13,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_14,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_15
]
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_17 = { key: 2 }
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M22,45h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1A2.68,2.68,0,0,1,28.2,51a4.46,4.46,0,0,1-1.77.31h-2.7v3.89H22Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28A1.43,1.43,0,0,0,28,49a1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H23.73Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31,45h1.88l4.64,7.49h0V45h1.69V55.19H37.37l-4.62-7.47h0v7.47H31Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.87,55.19H48.73L48.46,54A4.33,4.33,0,0,1,47,55.12a4,4,0,0,1-1.64.32,4.77,4.77,0,0,1-2-.42,4.51,4.51,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.16,6.16,0,0,1-.34-2.07,6,6,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.51,4.51,0,0,1,1.53-1.15,4.63,4.63,0,0,1,2-.43A5.78,5.78,0,0,1,47,45a4.25,4.25,0,0,1,1.33.66,3.64,3.64,0,0,1,1,1.09,3.59,3.59,0,0,1,.48,1.5H48a2.19,2.19,0,0,0-.9-1.5,2.48,2.48,0,0,0-.8-.39,3.46,3.46,0,0,0-.92-.13,2.81,2.81,0,0,0-1.4.33,2.63,2.63,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.64,5.64,0,0,0-.18,1.42,5.72,5.72,0,0,0,.18,1.43A3.88,3.88,0,0,0,43,52.78a2.63,2.63,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,3.51,3.51,0,0,0,1.21-.17,2.32,2.32,0,0,0,1.44-1.45,3.86,3.86,0,0,0,.2-1.16H45.54V49.84h4.33Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_24 = [
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_18,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_19,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_20,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_21,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_22,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_23
]
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_25 = { key: 3 }
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M20,43h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1A2.68,2.68,0,0,1,26.2,49a4.46,4.46,0,0,1-1.77.31h-2.7v3.89H20Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28A1.43,1.43,0,0,0,26,47a1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H21.73Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29,43h1.88l4.64,7.49h0V43h1.69V53.19H35.37l-4.62-7.47h0v7.47H29Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M47.87,53.19H46.73L46.46,52A4.33,4.33,0,0,1,45,53.12a4,4,0,0,1-1.64.32,4.77,4.77,0,0,1-2-.42,4.41,4.41,0,0,1-1.53-1.15,5,5,0,0,1-1-1.69,6.16,6.16,0,0,1-.34-2.07,6,6,0,0,1,.34-2,5.07,5.07,0,0,1,1-1.7,4.41,4.41,0,0,1,1.53-1.15,4.77,4.77,0,0,1,2-.43A5.78,5.78,0,0,1,45,43a4.25,4.25,0,0,1,1.33.66,3.64,3.64,0,0,1,1,1.09,3.59,3.59,0,0,1,.48,1.5H46a2.19,2.19,0,0,0-.9-1.5,2.71,2.71,0,0,0-.8-.39,3.46,3.46,0,0,0-.92-.13,2.81,2.81,0,0,0-1.4.33,2.63,2.63,0,0,0-1,.88,3.88,3.88,0,0,0-.55,1.24,5.73,5.73,0,0,0,0,2.85A3.88,3.88,0,0,0,41,50.78a2.63,2.63,0,0,0,1,.88,2.81,2.81,0,0,0,1.4.32,3.51,3.51,0,0,0,1.21-.17,2.32,2.32,0,0,0,1.44-1.45,3.57,3.57,0,0,0,.19-1.16h-2.7V47.84h4.33Z",
  fill: "#8b85db"
}, null, -1)
const DpFileIconPNGvue_type_template_id_d52d639c_hoisted_32 = [
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_26,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_27,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_28,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_29,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_30,
  DpFileIconPNGvue_type_template_id_d52d639c_hoisted_31
]

function DpFileIconPNGvue_type_template_id_d52d639c_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPNGvue_type_template_id_d52d639c_hoisted_1, DpFileIconPNGvue_type_template_id_d52d639c_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPNGvue_type_template_id_d52d639c_hoisted_9, DpFileIconPNGvue_type_template_id_d52d639c_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPNGvue_type_template_id_d52d639c_hoisted_17, DpFileIconPNGvue_type_template_id_d52d639c_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPNGvue_type_template_id_d52d639c_hoisted_25, DpFileIconPNGvue_type_template_id_d52d639c_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPNG.vue?vue&type=template&id=d52d639c

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPNG.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconPNGvue_type_script_lang_js = ({
    name: "DpFileIconPNG",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPNG.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPNG.vue




;
const DpFileIconPNG_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconPNGvue_type_script_lang_js, [['render',DpFileIconPNGvue_type_template_id_d52d639c_render]])

/* harmony default export */ var DpFileIconPNG = (DpFileIconPNG_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPPT.vue?vue&type=template&id=6467b6ec


const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_1 = { key: 0 }
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.52,45H28a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78A4.46,4.46,0,0,1,28,51.3H25.3v3.89H23.52Zm1.78,4.81h2.6a2.25,2.25,0,0,0,.62-.08,1.78,1.78,0,0,0,.57-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2,2,0,0,0-.14-.82,1.28,1.28,0,0,0-.38-.52,1.26,1.26,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H25.3Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.66,45h4.48a4.19,4.19,0,0,1,1.76.32,2.84,2.84,0,0,1,1.06.78,2.7,2.7,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.73,2.73,0,0,1-.5,1A2.64,2.64,0,0,1,38.9,51a4.37,4.37,0,0,1-1.76.31h-2.7v3.89H32.66Zm1.78,4.81H37a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.51,1.51,0,0,0,.42-.51,1.77,1.77,0,0,0,.17-.81,2.16,2.16,0,0,0-.14-.82,1.4,1.4,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.93,2.93,0,0,0-.67-.07H34.44Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.82,45h8.23v1.54H45.82v8.62H44V46.57H40.82Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_8 = [
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_2,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_3,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_4,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_5,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_6,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_7
]
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_9 = { key: 1 }
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.52,43H26a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78A4.46,4.46,0,0,1,26,49.3H23.3v3.89H21.52Zm1.78,4.81h2.6a2.25,2.25,0,0,0,.62-.08,1.78,1.78,0,0,0,.57-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2,2,0,0,0-.14-.82,1.28,1.28,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H23.3Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.66,43h4.48a4.19,4.19,0,0,1,1.76.32,2.84,2.84,0,0,1,1.06.78,2.7,2.7,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.73,2.73,0,0,1-.5,1A2.64,2.64,0,0,1,36.9,49a4.37,4.37,0,0,1-1.76.31h-2.7v3.89H30.66Zm1.78,4.81H35a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.51,1.51,0,0,0,.42-.51,1.74,1.74,0,0,0,.17-.81,2.16,2.16,0,0,0-.14-.82,1.4,1.4,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.93,2.93,0,0,0-.67-.07H32.44Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M38.82,43h8.23v1.54H43.82v8.62H42V44.57H38.82Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_16 = [
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_10,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_11,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_12,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_13,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_14,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_15
]
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_17 = { key: 2 }
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.52,45H28a4.24,4.24,0,0,1,1.77.32,2.8,2.8,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1A2.65,2.65,0,0,1,29.77,51,4.42,4.42,0,0,1,28,51.3H25.3v3.89H23.52Zm1.78,4.81h2.6a2.25,2.25,0,0,0,.62-.08,1.69,1.69,0,0,0,.57-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2,2,0,0,0-.14-.82,1.28,1.28,0,0,0-.38-.52,1.26,1.26,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H25.3Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.66,45h4.48a4.19,4.19,0,0,1,1.76.32,2.84,2.84,0,0,1,1.06.78,2.7,2.7,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.73,2.73,0,0,1-.5,1A2.64,2.64,0,0,1,38.9,51a4.37,4.37,0,0,1-1.76.31h-2.7v3.89H32.66Zm1.78,4.81H37a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.54,1.54,0,0,0,.43-.51,1.91,1.91,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.4,1.4,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H34.44Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.82,45h8.23v1.54H45.82v8.62H44V46.57H40.82Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_24 = [
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_18,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_19,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_20,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_21,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_22,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_23
]
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_25 = { key: 3 }
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.52,43H26a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.68,2.68,0,0,1-1.05.78A4.46,4.46,0,0,1,26,49.3H23.3v3.89H21.52Zm1.78,4.81h2.6a2.25,2.25,0,0,0,.62-.08,1.78,1.78,0,0,0,.57-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2,2,0,0,0-.14-.82,1.28,1.28,0,0,0-.38-.52,1.31,1.31,0,0,0-.56-.26,2.87,2.87,0,0,0-.67-.07H23.3Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.66,43h4.48a4.19,4.19,0,0,1,1.76.32,2.84,2.84,0,0,1,1.06.78,2.7,2.7,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.73,2.73,0,0,1-.5,1A2.64,2.64,0,0,1,36.9,49a4.37,4.37,0,0,1-1.76.31h-2.7v3.89H30.66Zm1.78,4.81H35a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.41,1.41,0,0,0,.42-.51,1.74,1.74,0,0,0,.17-.81,2.16,2.16,0,0,0-.14-.82,1.4,1.4,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H32.44Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M38.82,43h8.23v1.54H43.82v8.62H42V44.57H38.82Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_32 = [
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_26,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_27,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_28,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_29,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_30,
  DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_31
]

function DpFileIconPPTvue_type_template_id_6467b6ec_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_1, DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_9, DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_17, DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_25, DpFileIconPPTvue_type_template_id_6467b6ec_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPPT.vue?vue&type=template&id=6467b6ec

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPPT.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconPPTvue_type_script_lang_js = ({
    name: "DpFileIconPPT",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPPT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPPT.vue




;
const DpFileIconPPT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconPPTvue_type_script_lang_js, [['render',DpFileIconPPTvue_type_template_id_6467b6ec_render]])

/* harmony default export */ var DpFileIconPPT = (DpFileIconPPT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPPTX.vue?vue&type=template&id=4c17c422


const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_1 = { key: 0 }
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.09,45h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1,2.68,2.68,0,0,1-1.05.78,4.46,4.46,0,0,1-1.77.31h-2.7v3.89H19.09Zm1.78,4.81h2.6a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H20.87Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.22,45h4.49a4.19,4.19,0,0,1,1.76.32,2.72,2.72,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.54,2.54,0,0,1-1.05.78,4.37,4.37,0,0,1-1.76.31H30v3.89H28.22ZM30,49.84h2.61a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.51,1.51,0,0,0,.42-.51,1.77,1.77,0,0,0,.17-.81,2,2,0,0,0-.15-.82,1.28,1.28,0,0,0-.38-.52,1.26,1.26,0,0,0-.56-.26,2.78,2.78,0,0,0-.66-.07H30Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M36.39,45h8.23v1.54H41.39v8.62H39.61V46.57H36.39Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.56,45h2.12L49,48.62,51.39,45h2L50,49.93l3.6,5.26H51.46l-2.53-3.88-2.58,3.88h-2l3.6-5.26Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_9 = [
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_2,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_3,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_4,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_5,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_6,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_7,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_8
]
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_10 = { key: 1 }
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M17.09,43h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1,2.68,2.68,0,0,1-1.05.78,4.46,4.46,0,0,1-1.77.31h-2.7v3.89H17.09Zm1.78,4.81h2.6a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H18.87Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M26.22,43h4.49a4.19,4.19,0,0,1,1.76.32,2.72,2.72,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.54,2.54,0,0,1-1.05.78,4.37,4.37,0,0,1-1.76.31H28v3.89H26.22ZM28,47.84h2.61a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.51,1.51,0,0,0,.42-.51,1.74,1.74,0,0,0,.17-.81,2,2,0,0,0-.15-.82,1.28,1.28,0,0,0-.38-.52,1.26,1.26,0,0,0-.56-.26,2.78,2.78,0,0,0-.66-.07H28Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M34.39,43h8.23v1.54H39.39v8.62H37.61V44.57H34.39Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_17 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.56,43h2.12L47,46.62,49.39,43h2L48,47.93l3.6,5.26H49.46l-2.53-3.88-2.58,3.88h-2l3.6-5.26Z",
  fill: "#f93d6e"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_18 = [
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_11,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_12,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_13,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_14,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_15,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_16,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_17
]
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_19 = { key: 2 }
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.09,45h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1,2.68,2.68,0,0,1-1.05.78,4.46,4.46,0,0,1-1.77.31h-2.7v3.89H19.09Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.73,1.73,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.77,1.77,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H20.87Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.23,45h4.48a4.19,4.19,0,0,1,1.76.32,2.72,2.72,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.54,2.54,0,0,1-1.05.78,4.37,4.37,0,0,1-1.76.31H30v3.89H28.23ZM30,49.84h2.61a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.51,1.51,0,0,0,.42-.51,1.77,1.77,0,0,0,.17-.81,2,2,0,0,0-.15-.82,1.28,1.28,0,0,0-.38-.52,1.26,1.26,0,0,0-.56-.26,2.78,2.78,0,0,0-.66-.07H30Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M36.39,45h8.23v1.54H41.39v8.62H39.61V46.57H36.39Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.56,45h2.12L49,48.62,51.39,45h2L50,49.93l3.6,5.26H51.46l-2.53-3.88-2.58,3.88h-2l3.6-5.26Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_27 = [
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_20,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_21,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_22,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_23,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_24,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_25,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_26
]
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_28 = { key: 3 }
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M17.09,43h4.48a4.28,4.28,0,0,1,1.77.32,2.89,2.89,0,0,1,1.05.78,2.56,2.56,0,0,1,.5,1,4.44,4.44,0,0,1,.14,1,4.37,4.37,0,0,1-.14,1,2.59,2.59,0,0,1-.5,1,2.68,2.68,0,0,1-1.05.78,4.46,4.46,0,0,1-1.77.31h-2.7v3.89H17.09Zm1.78,4.81h2.6a2.13,2.13,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.43,1.43,0,0,0,.43-.51,1.74,1.74,0,0,0,.16-.81,2.16,2.16,0,0,0-.14-.82,1.3,1.3,0,0,0-.39-.52,1.22,1.22,0,0,0-.55-.26,2.87,2.87,0,0,0-.67-.07H18.87Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M26.22,43h4.49a4.19,4.19,0,0,1,1.76.32,2.72,2.72,0,0,1,1.05.78,2.58,2.58,0,0,1,.51,1,4.4,4.4,0,0,1,.13,1,4.32,4.32,0,0,1-.13,1,2.61,2.61,0,0,1-.51,1,2.54,2.54,0,0,1-1.05.78,4.37,4.37,0,0,1-1.76.31H28v3.89H26.22ZM28,47.84h2.61a2.18,2.18,0,0,0,.61-.08,1.83,1.83,0,0,0,.58-.28,1.51,1.51,0,0,0,.42-.51,1.74,1.74,0,0,0,.17-.81,2,2,0,0,0-.15-.82,1.28,1.28,0,0,0-.38-.52,1.26,1.26,0,0,0-.56-.26,2.78,2.78,0,0,0-.66-.07H28Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_34 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M34.39,43h8.23v1.54H39.39v8.62H37.61V44.57H34.39Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_35 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.56,43h2.12L47,46.62,49.39,43h2L48,47.93l3.6,5.26H49.46l-2.53-3.88-2.58,3.88h-2l3.6-5.26Z",
  fill: "#e83158"
}, null, -1)
const DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_36 = [
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_29,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_30,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_31,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_32,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_33,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_34,
  DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_35
]

function DpFileIconPPTXvue_type_template_id_4c17c422_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_1, DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_9))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_10, DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_18))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_19, DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_27))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_28, DpFileIconPPTXvue_type_template_id_4c17c422_hoisted_36))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPPTX.vue?vue&type=template&id=4c17c422

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconPPTX.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconPPTXvue_type_script_lang_js = ({
    name: "DpFileIconPPTX",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPPTX.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconPPTX.vue




;
const DpFileIconPPTX_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconPPTXvue_type_script_lang_js, [['render',DpFileIconPPTXvue_type_template_id_4c17c422_render]])

/* harmony default export */ var DpFileIconPPTX = (DpFileIconPPTX_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconSVG.vue?vue&type=template&id=08700c2a


const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_1 = { key: 0 }
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M24,51.81a2.27,2.27,0,0,0,.2,1,1.84,1.84,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,11.31,11.31,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2.19,2.19,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78A2.57,2.57,0,0,1,23,46.45a2.68,2.68,0,0,1,.84-.93A3.66,3.66,0,0,1,25,45a5.16,5.16,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,3,3,0,0,1,.85,1,3.07,3.07,0,0,1,.31,1.4H28.48a1.71,1.71,0,0,0-.67-1.39,2.65,2.65,0,0,0-1.52-.41,2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47l.45.12.88.23.94.25.67.18a2.76,2.76,0,0,1,.86.42,2.8,2.8,0,0,1,.62.62,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.59,45h1.85l2.54,8h0l2.61-8h1.8L36,55.19H34Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M48.94,55.19H47.8L47.53,54a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32,4.8,4.8,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5.2,5.2,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.25,5.25,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.66,4.66,0,0,1,2-.43,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.48,3.48,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H47.09a2.14,2.14,0,0,0-.89-1.5,2.59,2.59,0,0,0-.8-.39,3.48,3.48,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.13,6.13,0,0,0-.17,1.42,6.22,6.22,0,0,0,.17,1.43,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.37,2.37,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V49.84h4.32Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_8 = [
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_2,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_3,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_4,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_5,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_6,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_7
]
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_9 = { key: 1 }
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M22,49.81a2.27,2.27,0,0,0,.2,1,1.84,1.84,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,11.31,11.31,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2.19,2.19,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78A2.57,2.57,0,0,1,21,44.45a2.87,2.87,0,0,1,.84-.93A3.66,3.66,0,0,1,23,43a5.16,5.16,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,3,3,0,0,1,.85,1,3.1,3.1,0,0,1,.31,1.4H26.48a1.71,1.71,0,0,0-.67-1.39,2.65,2.65,0,0,0-1.52-.41,3.58,3.58,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47l.45.12.88.23.94.25.67.18a2.77,2.77,0,0,1,.86.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.59,43h1.85l2.54,8h0l2.61-8h1.8L34,53.19H32Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.94,53.19H45.8L45.53,52a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32,4.8,4.8,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5.2,5.2,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.25,5.25,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.8,4.8,0,0,1,2-.43,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.48,3.48,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H45.09a2.14,2.14,0,0,0-.89-1.5,2.83,2.83,0,0,0-.8-.39,3.48,3.48,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.37,2.37,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V47.84h4.32Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_16 = [
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_10,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_11,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_12,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_13,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_14,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_15
]
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_17 = { key: 2 }
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M24,51.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,10.7,10.7,0,0,0-1.26-.38l-1.77-.46a4.11,4.11,0,0,1-1.09-.45,2.62,2.62,0,0,1-.69-.62,2.4,2.4,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78A2.57,2.57,0,0,1,23,46.45a2.68,2.68,0,0,1,.84-.93A3.66,3.66,0,0,1,25,45a5.16,5.16,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,2.91,2.91,0,0,1,.85,1,3,3,0,0,1,.31,1.4H28.48a1.71,1.71,0,0,0-.67-1.39,2.65,2.65,0,0,0-1.52-.41,2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47l.45.12.88.23.94.25.67.18a2.76,2.76,0,0,1,.86.42,2.8,2.8,0,0,1,.62.62,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.59,45h1.85l2.54,8h0l2.61-8h1.8L36,55.19H34Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M48.94,55.19H47.8L47.53,54a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32,4.83,4.83,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5.2,5.2,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.25,5.25,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.69,4.69,0,0,1,2-.43,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.48,3.48,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H47.09a2.14,2.14,0,0,0-.89-1.5,2.59,2.59,0,0,0-.8-.39,3.48,3.48,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.13,6.13,0,0,0-.17,1.42,6.22,6.22,0,0,0,.17,1.43,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.37,2.37,0,0,0,.89-.56,2.2,2.2,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V49.84h4.32Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_24 = [
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_18,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_19,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_20,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_21,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_22,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_23
]
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_25 = { key: 3 }
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M22,49.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13,2,2,0,0,0,.67-.35,1.23,1.23,0,0,0,.37-.49,1.4,1.4,0,0,0,.11-.56,1.18,1.18,0,0,0-.26-.86,1.39,1.39,0,0,0-.57-.39,11.31,11.31,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2.19,2.19,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78A2.57,2.57,0,0,1,21,44.45a2.87,2.87,0,0,1,.84-.93A3.66,3.66,0,0,1,23,43a5.16,5.16,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,2.91,2.91,0,0,1,.85,1,3.1,3.1,0,0,1,.31,1.4H26.48a1.71,1.71,0,0,0-.67-1.39,2.65,2.65,0,0,0-1.52-.41,3.58,3.58,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47l.45.12.88.23.94.25.67.18a2.77,2.77,0,0,1,.86.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.34,1.46,3.11,3.11,0,0,1-.92,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13,3.76,3.76,0,0,1-.36-1.63Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.59,43h1.85l2.54,8h0l2.61-8h1.8L34,53.19H32Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M46.94,53.19H45.8L45.53,52a4.23,4.23,0,0,1-1.42,1.12,4,4,0,0,1-1.64.32,4.8,4.8,0,0,1-2-.42,4.61,4.61,0,0,1-1.53-1.15,5.2,5.2,0,0,1-1-1.69,6.41,6.41,0,0,1-.33-2.07,6.23,6.23,0,0,1,.33-2,5.25,5.25,0,0,1,1-1.7,4.61,4.61,0,0,1,1.53-1.15,4.8,4.8,0,0,1,2-.43,5.85,5.85,0,0,1,1.58.22,4.36,4.36,0,0,1,1.33.66,3.48,3.48,0,0,1,1,1.09,3.74,3.74,0,0,1,.49,1.5H45.09a2.14,2.14,0,0,0-.89-1.5,2.83,2.83,0,0,0-.8-.39,3.54,3.54,0,0,0-.93-.13,2.84,2.84,0,0,0-1.4.33,2.79,2.79,0,0,0-1,.88,4.11,4.11,0,0,0-.55,1.24,6.06,6.06,0,0,0,0,2.85,4.11,4.11,0,0,0,.55,1.24,2.79,2.79,0,0,0,1,.88,2.84,2.84,0,0,0,1.4.32,3.47,3.47,0,0,0,1.21-.17,2.46,2.46,0,0,0,.89-.56,2.31,2.31,0,0,0,.55-.89,3.86,3.86,0,0,0,.2-1.16h-2.7V47.84h4.32Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconSVGvue_type_template_id_08700c2a_hoisted_32 = [
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_26,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_27,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_28,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_29,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_30,
  DpFileIconSVGvue_type_template_id_08700c2a_hoisted_31
]

function DpFileIconSVGvue_type_template_id_08700c2a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconSVGvue_type_template_id_08700c2a_hoisted_1, DpFileIconSVGvue_type_template_id_08700c2a_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconSVGvue_type_template_id_08700c2a_hoisted_9, DpFileIconSVGvue_type_template_id_08700c2a_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconSVGvue_type_template_id_08700c2a_hoisted_17, DpFileIconSVGvue_type_template_id_08700c2a_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconSVGvue_type_template_id_08700c2a_hoisted_25, DpFileIconSVGvue_type_template_id_08700c2a_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconSVG.vue?vue&type=template&id=08700c2a

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconSVG.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconSVGvue_type_script_lang_js = ({
    name: "DpFileIconSVG",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconSVG.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconSVG.vue




;
const DpFileIconSVG_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconSVGvue_type_script_lang_js, [['render',DpFileIconSVGvue_type_template_id_08700c2a_render]])

/* harmony default export */ var DpFileIconSVG = (DpFileIconSVG_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconTIFF.vue?vue&type=template&id=db2d210c


const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_1 = { key: 0 }
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.81,45H30v1.54H26.8v8.62H25V46.57H21.81Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.86,45h1.77V55.19H30.86Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M34.46,45h7v1.54H36.24v2.66h4.59v1.45H36.24v4.51H34.46Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.54,45h7v1.54H44.32v2.66h4.59v1.45H44.32v4.51H42.54Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_9 = [
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_2,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_3,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_4,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_5,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_6,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_7,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_8
]
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_10 = { key: 1 }
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.81,43H28v1.54H24.8v8.62H23V44.57H19.81Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.86,43h1.77V53.19H28.86Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.46,43h7v1.54H34.24v2.66h4.59v1.45H34.24v4.51H32.46Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_17 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.54,43h7v1.54H42.32v2.66h4.59v1.45H42.32v4.51H40.54Z",
  fill: "#f97e2b"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_18 = [
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_11,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_12,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_13,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_14,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_15,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_16,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_17
]
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_19 = { key: 2 }
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.81,45H30v1.54H26.8v8.62H25V46.57H21.81Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.86,45h1.78V55.19H30.86Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M34.46,45h7v1.54H36.24v2.66h4.59v1.45H36.24v4.51H34.46Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.54,45h7v1.54H44.32v2.66h4.59v1.45H44.32v4.51H42.54Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_27 = [
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_20,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_21,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_22,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_23,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_24,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_25,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_26
]
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_28 = { key: 3 }
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.81,43H28v1.54H24.8v8.62H23V44.57H19.81Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.86,43h1.78V53.19H28.86Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_34 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.46,43h7v1.54H34.24v2.66h4.59v1.45H34.24v4.51H32.46Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_35 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.54,43h7v1.54H42.32v2.66h4.59v1.45H42.32v4.51H40.54Z",
  fill: "#e27110"
}, null, -1)
const DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_36 = [
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_29,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_30,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_31,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_32,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_33,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_34,
  DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_35
]

function DpFileIconTIFFvue_type_template_id_db2d210c_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_1, DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_9))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_10, DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_18))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_19, DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_27))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_28, DpFileIconTIFFvue_type_template_id_db2d210c_hoisted_36))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconTIFF.vue?vue&type=template&id=db2d210c

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconTIFF.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconTIFFvue_type_script_lang_js = ({
    name: "DpFileIconTIFF",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconTIFF.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconTIFF.vue




;
const DpFileIconTIFF_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconTIFFvue_type_script_lang_js, [['render',DpFileIconTIFFvue_type_template_id_db2d210c_render]])

/* harmony default export */ var DpFileIconTIFF = (DpFileIconTIFF_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconTXT.vue?vue&type=template&id=1ff50228


const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_1 = { key: 0 }
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.22,45h8.22v1.54H28.21v8.62H26.43V46.57H23.22Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31.38,45H33.5l2.31,3.59L38.21,45h2l-3.35,4.9,3.6,5.26H38.29l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.16,45h8.23v1.54H45.16v8.62H43.38V46.57H40.16Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_8 = [
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_2,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_3,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_4,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_5,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_6,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_7
]
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_9 = { key: 1 }
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.22,43h8.22v1.54H26.21v8.62H24.43V44.57H21.22Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29.38,43H31.5l2.31,3.59L36.21,43h2l-3.35,4.9,3.6,5.26H36.29l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M38.16,43h8.23v1.54H43.16v8.62H41.38V44.57H38.16Z",
  fill: "#1a83a3"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_16 = [
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_10,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_11,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_12,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_13,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_14,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_15
]
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_17 = { key: 2 }
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.22,45h8.22v1.54H28.21v8.62H26.43V46.57H23.22Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31.38,45H33.5l2.31,3.59L38.21,45h2l-3.36,4.9,3.6,5.26H38.29l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M40.16,45h8.23v1.54H45.16v8.62H43.38V46.57H40.16Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_24 = [
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_18,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_19,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_20,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_21,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_22,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_23
]
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_25 = { key: 3 }
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.22,43h8.22v1.54H26.21v8.62H24.43V44.57H21.22Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29.38,43H31.5l2.31,3.59L36.21,43h2l-3.36,4.9,3.6,5.26H36.28l-2.53-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M38.16,43h8.23v1.54H43.16v8.62H41.38V44.57H38.16Z",
  fill: "#136389"
}, null, -1)
const DpFileIconTXTvue_type_template_id_1ff50228_hoisted_32 = [
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_26,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_27,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_28,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_29,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_30,
  DpFileIconTXTvue_type_template_id_1ff50228_hoisted_31
]

function DpFileIconTXTvue_type_template_id_1ff50228_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTXTvue_type_template_id_1ff50228_hoisted_1, DpFileIconTXTvue_type_template_id_1ff50228_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTXTvue_type_template_id_1ff50228_hoisted_9, DpFileIconTXTvue_type_template_id_1ff50228_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTXTvue_type_template_id_1ff50228_hoisted_17, DpFileIconTXTvue_type_template_id_1ff50228_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconTXTvue_type_template_id_1ff50228_hoisted_25, DpFileIconTXTvue_type_template_id_1ff50228_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconTXT.vue?vue&type=template&id=1ff50228

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconTXT.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconTXTvue_type_script_lang_js = ({
    name: "DpFileIconTXT",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconTXT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconTXT.vue




;
const DpFileIconTXT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconTXTvue_type_script_lang_js, [['render',DpFileIconTXTvue_type_template_id_1ff50228_render]])

/* harmony default export */ var DpFileIconTXT = (DpFileIconTXT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconXLS.vue?vue&type=template&id=022ee434


const DpFileIconXLSvue_type_template_id_022ee434_hoisted_1 = { key: 0 }
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23,45h2.13l2.3,3.59L29.87,45h2l-3.36,4.9,3.6,5.26H30l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.79,45h1.78v8.63h5.17v1.53h-7Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M41.77,51.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.21,3.21,0,0,0,1-.13A2,2,0,0,0,46,53.5a1.33,1.33,0,0,0,.37-.49,1.4,1.4,0,0,0,.11-.56,1.18,1.18,0,0,0-.26-.86,1.39,1.39,0,0,0-.57-.39,12,12,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2,2,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.78,2.78,0,0,1,.84-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,3,3,0,0,1,.85,1A3.18,3.18,0,0,1,48,48H46.21a1.71,1.71,0,0,0-.67-1.39A2.67,2.67,0,0,0,44,46.24a2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.22,1.22,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.88.23.94.25.66.18a2.72,2.72,0,0,1,.87.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.82,2.82,0,0,1-.35,1.46,3,3,0,0,1-.91,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13A3.76,3.76,0,0,1,40,51.81Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_8 = [
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_2,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_3,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_4,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_5,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_6,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_7
]
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_9 = { key: 1 }
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21,43h2.13l2.3,3.59L27.87,43h2l-3.36,4.9,3.6,5.26H28l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.79,43h1.78v8.63h5.17v1.53h-7Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M39.77,49.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.21,3.21,0,0,0,1-.13A2,2,0,0,0,44,51.5a1.33,1.33,0,0,0,.37-.49,1.4,1.4,0,0,0,.11-.56,1.18,1.18,0,0,0-.26-.86,1.39,1.39,0,0,0-.57-.39,12,12,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2,2,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.78,2.78,0,0,1,.84-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,3,3,0,0,1,.85,1A3.15,3.15,0,0,1,46,46H44.21a1.71,1.71,0,0,0-.67-1.39A2.67,2.67,0,0,0,42,44.24a2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.22,1.22,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.88.23.94.25.66.18a2.72,2.72,0,0,1,.87.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.82,2.82,0,0,1-.35,1.46,3,3,0,0,1-.91,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13A3.76,3.76,0,0,1,38,49.81Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_16 = [
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_10,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_11,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_12,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_13,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_14,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_15
]
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_17 = { key: 2 }
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M23.05,45h2.12l2.3,3.59L29.88,45h2l-3.36,4.9,3.6,5.26H30l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M32.79,45h1.78v8.63h5.17v1.53h-7Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M41.77,51.81a2.27,2.27,0,0,0,.2,1,1.77,1.77,0,0,0,.56.68,2.42,2.42,0,0,0,.81.38,4.05,4.05,0,0,0,1,.12,3.17,3.17,0,0,0,1-.13A2,2,0,0,0,46,53.5a1.33,1.33,0,0,0,.37-.49,1.41,1.41,0,0,0,.12-.56,1.18,1.18,0,0,0-.27-.86,1.39,1.39,0,0,0-.57-.39,12,12,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2,2,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.78,2.78,0,0,1,.84-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,3,3,0,0,1,.85,1A3.18,3.18,0,0,1,48,48H46.21a1.71,1.71,0,0,0-.67-1.39A2.65,2.65,0,0,0,44,46.24a2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.26,1.26,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.88.23.94.25.67.18a2.77,2.77,0,0,1,.86.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.82,2.82,0,0,1-.35,1.46,3,3,0,0,1-.91,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13A3.76,3.76,0,0,1,40,51.81Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_24 = [
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_18,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_19,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_20,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_21,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_22,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_23
]
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_25 = { key: 3 }
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.05,43h2.12l2.3,3.59L27.88,43h2l-3.36,4.9,3.6,5.26H28l-2.54-3.88-2.57,3.88h-2l3.6-5.26Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M30.79,43h1.78v8.63h5.17v1.53h-7Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M39.77,49.81a2.27,2.27,0,0,0,.2,1,1.84,1.84,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4.05,4.05,0,0,0,1,.12,3.21,3.21,0,0,0,1-.13A2,2,0,0,0,44,51.5a1.33,1.33,0,0,0,.37-.49,1.4,1.4,0,0,0,.11-.56,1.18,1.18,0,0,0-.26-.86,1.39,1.39,0,0,0-.57-.39,12,12,0,0,0-1.26-.38l-1.78-.46a4.18,4.18,0,0,1-1.08-.45,2.62,2.62,0,0,1-.69-.62,2,2,0,0,1-.37-.73,2.88,2.88,0,0,1-.1-.78,2.57,2.57,0,0,1,.32-1.33,2.78,2.78,0,0,1,.84-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62,3.08,3.08,0,0,1,.85,1A3.15,3.15,0,0,1,46,46H44.21a1.71,1.71,0,0,0-.67-1.39A2.65,2.65,0,0,0,42,44.24a2.85,2.85,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.22,1.22,0,0,0,.16,1.48,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.88.23.94.25.67.18a2.77,2.77,0,0,1,.86.43,2.57,2.57,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.82,2.82,0,0,1-.35,1.46,3,3,0,0,1-.91,1,4.13,4.13,0,0,1-1.3.56,6.16,6.16,0,0,1-3.11,0,3.8,3.8,0,0,1-1.34-.65,3.27,3.27,0,0,1-.91-1.13A3.76,3.76,0,0,1,38,49.81Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSvue_type_template_id_022ee434_hoisted_32 = [
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_26,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_27,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_28,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_29,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_30,
  DpFileIconXLSvue_type_template_id_022ee434_hoisted_31
]

function DpFileIconXLSvue_type_template_id_022ee434_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSvue_type_template_id_022ee434_hoisted_1, DpFileIconXLSvue_type_template_id_022ee434_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSvue_type_template_id_022ee434_hoisted_9, DpFileIconXLSvue_type_template_id_022ee434_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSvue_type_template_id_022ee434_hoisted_17, DpFileIconXLSvue_type_template_id_022ee434_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSvue_type_template_id_022ee434_hoisted_25, DpFileIconXLSvue_type_template_id_022ee434_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXLS.vue?vue&type=template&id=022ee434

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconXLS.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconXLSvue_type_script_lang_js = ({
    name: "DpFileIconXLS",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXLS.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXLS.vue




;
const DpFileIconXLS_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconXLSvue_type_script_lang_js, [['render',DpFileIconXLSvue_type_template_id_022ee434_render]])

/* harmony default export */ var DpFileIconXLS = (DpFileIconXLS_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconXLSX.vue?vue&type=template&id=10eaea5d


const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_1 = { key: 0 }
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M18.61,45h2.12L23,48.62,25.44,45h2l-3.36,4.9,3.6,5.26H25.51L23,51.31l-2.57,3.88h-2L22,49.93Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.36,45h1.78v8.63H35.3v1.53H28.36Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M37.34,51.81a2.13,2.13,0,0,0,.2,1,1.84,1.84,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4,4,0,0,0,1,.12,3.28,3.28,0,0,0,1-.13,2.11,2.11,0,0,0,.67-.35A1.33,1.33,0,0,0,42,53a1.59,1.59,0,0,0,.11-.56,1.23,1.23,0,0,0-.26-.86,1.42,1.42,0,0,0-.58-.39A10.7,10.7,0,0,0,40,50.82l-1.77-.46a4.26,4.26,0,0,1-1.09-.45,2.62,2.62,0,0,1-.69-.62,2.16,2.16,0,0,1-.36-.73,2.88,2.88,0,0,1-.11-.78,2.67,2.67,0,0,1,.32-1.33,2.92,2.92,0,0,1,.85-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62A3,3,0,0,1,43.56,48H41.78a1.71,1.71,0,0,0-.67-1.39,2.67,2.67,0,0,0-1.52-.41,2.79,2.79,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.08,1.08,0,0,0-.18.64,1.05,1.05,0,0,0,.34.84,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.87.23,1,.25.66.18a2.83,2.83,0,0,1,.87.43,2.76,2.76,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.35,1.46,3,3,0,0,1-.92,1,4.07,4.07,0,0,1-1.29.56,6.12,6.12,0,0,1-1.48.18,6.25,6.25,0,0,1-1.64-.22,3.76,3.76,0,0,1-1.33-.65,3.3,3.3,0,0,1-.92-1.13,3.91,3.91,0,0,1-.35-1.63Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.15,45h2.12l2.31,3.59L51,45h2l-3.36,4.9,3.6,5.26H51.05l-2.53-3.88L46,55.19h-2l3.6-5.26Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_9 = [
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_2,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_3,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_4,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_5,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_6,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_7,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_8
]
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_10 = { key: 1 }
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M16.61,43h2.12L21,46.62,23.44,43h2l-3.36,4.9,3.6,5.26H23.51L21,49.31l-2.57,3.88h-2L20,47.93Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M26.36,43h1.78v8.63H33.3v1.53H26.36Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M35.34,49.81a2.13,2.13,0,0,0,.2,1,1.84,1.84,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4,4,0,0,0,1,.12,3.28,3.28,0,0,0,1-.13,2.11,2.11,0,0,0,.67-.35A1.33,1.33,0,0,0,40,51a1.59,1.59,0,0,0,.11-.56,1.23,1.23,0,0,0-.26-.86,1.42,1.42,0,0,0-.58-.39A10.7,10.7,0,0,0,38,48.82l-1.77-.46a4.26,4.26,0,0,1-1.09-.45,2.62,2.62,0,0,1-.69-.62,2.16,2.16,0,0,1-.36-.73,2.88,2.88,0,0,1-.11-.78,2.67,2.67,0,0,1,.32-1.33,2.92,2.92,0,0,1,.85-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62A3,3,0,0,1,41.56,46H39.78a1.71,1.71,0,0,0-.67-1.39,2.67,2.67,0,0,0-1.52-.41,2.79,2.79,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.08,1.08,0,0,0-.18.64,1.05,1.05,0,0,0,.34.84,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.87.23,1,.25.66.18a2.83,2.83,0,0,1,.87.43,2.76,2.76,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.35,1.46,3,3,0,0,1-.92,1,4.07,4.07,0,0,1-1.29.56,6.12,6.12,0,0,1-1.48.18,6.25,6.25,0,0,1-1.64-.22,3.76,3.76,0,0,1-1.33-.65,3.3,3.3,0,0,1-.92-1.13,3.91,3.91,0,0,1-.35-1.63Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_17 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.15,43h2.12l2.31,3.59L49,43h2l-3.36,4.9,3.6,5.26H49.05l-2.53-3.88L44,53.19h-2l3.6-5.26Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_18 = [
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_11,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_12,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_13,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_14,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_15,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_16,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_17
]
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_19 = { key: 2 }
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M18.61,45h2.12L23,48.62,25.44,45h2l-3.36,4.9,3.6,5.26H25.51L23,51.31l-2.57,3.88h-2L22,49.93Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M28.36,45h1.78v8.63H35.3v1.53H28.36Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M37.34,51.81a2.13,2.13,0,0,0,.2,1,1.84,1.84,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4,4,0,0,0,1,.12,3.28,3.28,0,0,0,1-.13,2.11,2.11,0,0,0,.67-.35A1.33,1.33,0,0,0,42,53a1.59,1.59,0,0,0,.11-.56,1.23,1.23,0,0,0-.26-.86,1.42,1.42,0,0,0-.58-.39A10.7,10.7,0,0,0,40,50.82l-1.77-.46a4.26,4.26,0,0,1-1.09-.45,2.62,2.62,0,0,1-.69-.62,2.16,2.16,0,0,1-.36-.73,2.88,2.88,0,0,1-.11-.78,2.67,2.67,0,0,1,.32-1.33,2.92,2.92,0,0,1,.85-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62A3,3,0,0,1,43.56,48H41.78a1.71,1.71,0,0,0-.67-1.39,2.67,2.67,0,0,0-1.52-.41,2.79,2.79,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.08,1.08,0,0,0-.18.64,1.05,1.05,0,0,0,.34.84,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.87.23,1,.25.66.18a2.83,2.83,0,0,1,.87.43,2.76,2.76,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.35,1.46,3,3,0,0,1-.92,1,4.07,4.07,0,0,1-1.29.56,6.12,6.12,0,0,1-1.48.18,6.25,6.25,0,0,1-1.64-.22,3.76,3.76,0,0,1-1.33-.65,3.3,3.3,0,0,1-.92-1.13,3.91,3.91,0,0,1-.35-1.63Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M44.15,45h2.12l2.31,3.59L51,45h2l-3.36,4.9,3.6,5.26H51.06l-2.54-3.88L46,55.19h-2l3.6-5.26Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_27 = [
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_20,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_21,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_22,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_23,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_24,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_25,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_26
]
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_28 = { key: 3 }
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M16.61,43h2.12L21,46.62,23.44,43h2l-3.35,4.9,3.6,5.26H23.51L21,49.31l-2.57,3.88h-2L20,47.93Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M26.36,43h1.78v8.63H33.3v1.53H26.36Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_34 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M35.34,49.81a2.13,2.13,0,0,0,.2,1,1.75,1.75,0,0,0,.55.68,2.47,2.47,0,0,0,.82.38,4,4,0,0,0,1,.12,3.28,3.28,0,0,0,1-.13,2.11,2.11,0,0,0,.67-.35A1.33,1.33,0,0,0,40,51a1.59,1.59,0,0,0,.11-.56,1.23,1.23,0,0,0-.26-.86,1.42,1.42,0,0,0-.58-.39A10.7,10.7,0,0,0,38,48.82l-1.77-.46a4.26,4.26,0,0,1-1.09-.45,2.62,2.62,0,0,1-.69-.62,2.16,2.16,0,0,1-.36-.73,2.88,2.88,0,0,1-.11-.78,2.67,2.67,0,0,1,.32-1.33,2.92,2.92,0,0,1,.85-.93,3.66,3.66,0,0,1,1.2-.55,5.11,5.11,0,0,1,1.35-.18,5.23,5.23,0,0,1,1.5.21,3.7,3.7,0,0,1,1.24.62A3,3,0,0,1,41.56,46H39.78a1.71,1.71,0,0,0-.67-1.39,2.67,2.67,0,0,0-1.52-.41,2.79,2.79,0,0,0-.64.07,1.94,1.94,0,0,0-.6.21,1.36,1.36,0,0,0-.45.41,1.08,1.08,0,0,0-.18.64,1.05,1.05,0,0,0,.34.84,2.13,2.13,0,0,0,.87.47s.19,0,.45.12l.87.23,1,.25.66.18a3,3,0,0,1,.87.43,2.76,2.76,0,0,1,.62.61,2.62,2.62,0,0,1,.37.75,2.77,2.77,0,0,1,.12.8,2.92,2.92,0,0,1-.35,1.46,3,3,0,0,1-.92,1,4.17,4.17,0,0,1-1.29.56,6.12,6.12,0,0,1-1.48.18,6.25,6.25,0,0,1-1.64-.22,3.76,3.76,0,0,1-1.33-.65,3.3,3.3,0,0,1-.92-1.13,3.91,3.91,0,0,1-.35-1.63Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_35 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M42.15,43h2.12l2.31,3.59L49,43h2l-3.36,4.9,3.6,5.26H49.06l-2.54-3.88L44,53.19h-2l3.6-5.26Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_36 = [
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_29,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_30,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_31,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_32,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_33,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_34,
  DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_35
]

function DpFileIconXLSXvue_type_template_id_10eaea5d_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_1, DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_9))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_10, DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_18))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_19, DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_27))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_28, DpFileIconXLSXvue_type_template_id_10eaea5d_hoisted_36))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXLSX.vue?vue&type=template&id=10eaea5d

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconXLSX.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconXLSXvue_type_script_lang_js = ({
    name: "DpFileIconXLSX",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXLSX.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXLSX.vue




;
const DpFileIconXLSX_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconXLSXvue_type_script_lang_js, [['render',DpFileIconXLSXvue_type_template_id_10eaea5d_render]])

/* harmony default export */ var DpFileIconXLSX = (DpFileIconXLSX_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconXML.vue?vue&type=template&id=4b0c6984


const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_1 = { key: 0 }
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z" }, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.33,45h2.12l2.31,3.59L28.16,45h2l-3.36,4.9,3.6,5.26H28.23L25.7,51.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31.05,45h2.5l2.81,8h0l2.74-8h2.47V55.19H39.9V47.35h0l-2.82,7.84H35.59l-2.82-7.84h0v7.84H31.05Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M43.37,45h1.78v8.63h5.17v1.53h-7Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_8 = [
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_2,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_3,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_4,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_5,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_6,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_7
]
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_9 = { key: 1 }
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z" }, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#e0e0e0"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.33,43h2.12l2.31,3.59L26.16,43h2l-3.36,4.9,3.6,5.26H26.23L23.7,49.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29.05,43h2.5l2.81,8h0l2.74-8h2.47V53.19H37.9V45.35h0l-2.82,7.84H33.59l-2.82-7.84h0v7.84H29.05Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M41.37,43h1.78v8.63h5.17v1.53h-7Z",
  fill: "#15ada6"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_16 = [
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_10,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_11,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_12,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_13,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_14,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_15
]
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_17 = { key: 2 }
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M60.1,33.6H56V20.68a2,2,0,0,0-.59-1.42L36.74.59A2,2,0,0,0,35.32,0h-27A8.33,8.33,0,0,0,0,8.32V64.68A8.33,8.33,0,0,0,8.32,73H47.68a8.3,8.3,0,0,0,8.06-6.29,2,2,0,0,0,.06-.48h4.3a3.76,3.76,0,0,0,3.65-3.86V37.46A3.76,3.76,0,0,0,60.1,33.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.36,64.23H12.88A3.39,3.39,0,0,1,9.5,60.84V39a3.39,3.39,0,0,1,3.38-3.38H58.36A3.39,3.39,0,0,1,61.75,39V60.84A3.39,3.39,0,0,1,58.36,64.23ZM12.88,37.6A1.38,1.38,0,0,0,11.5,39V60.84a1.39,1.39,0,0,0,1.38,1.39H58.36a1.39,1.39,0,0,0,1.39-1.39V39a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M51.7,66.23a4.31,4.31,0,0,1-4,2.77H8.32A4.33,4.33,0,0,1,4,64.68V8.32A4.33,4.33,0,0,1,8.32,4H34.49l.42.41V15.77a5.32,5.32,0,0,0,5.31,5.32H51.59l.41.42V33.6h2V20.68L35.32,2h-27A6.32,6.32,0,0,0,2,8.32V64.68A6.32,6.32,0,0,0,8.32,71H47.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M21.33,45h2.12l2.31,3.59L28.16,45h2l-3.36,4.9,3.6,5.26H28.23L25.7,51.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M31.05,45h2.5l2.81,8h0l2.73-8h2.47V55.19H39.9V47.35h0l-2.82,7.84H35.59l-2.82-7.84h0v7.84H31.05Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M43.37,45h1.78v8.63h5.17v1.53h-7Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_24 = [
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_18,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_19,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_20,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_21,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_22,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_23
]
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_25 = { key: 3 }
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M58.1,31.6H52V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77h6.3a3.76,3.76,0,0,0,3.65-3.86V35.46A3.76,3.76,0,0,0,58.1,31.6Z",
  fill: "#fff"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M56.36,62.23H10.88A3.39,3.39,0,0,1,7.5,58.84V37a3.39,3.39,0,0,1,3.38-3.38H56.36A3.39,3.39,0,0,1,59.75,37V58.84A3.39,3.39,0,0,1,56.36,62.23ZM10.88,35.6A1.38,1.38,0,0,0,9.5,37V58.84a1.39,1.39,0,0,0,1.38,1.39H56.36a1.39,1.39,0,0,0,1.39-1.39V37a1.38,1.38,0,0,0-1.39-1.38Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M49.7,64.23a4.31,4.31,0,0,1-4,2.77H6.32A4.33,4.33,0,0,1,2,62.68V6.32A4.33,4.33,0,0,1,6.32,2H32.49l.42.41V13.77a5.32,5.32,0,0,0,5.31,5.32H49.59l.41.42V31.6h2V18.68L33.32,0h-27A6.32,6.32,0,0,0,0,6.32V62.68A6.32,6.32,0,0,0,6.32,69H45.68a6.33,6.33,0,0,0,6.12-4.77Z",
  fill: "#bfbfbf"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M19.33,43h2.12l2.31,3.59L26.16,43h2l-3.36,4.9,3.6,5.26H26.23L23.7,49.31l-2.58,3.88h-2l3.6-5.26Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M29.05,43h2.5l2.81,8h0l2.73-8h2.47V53.19H37.9V45.35h0l-2.82,7.84H33.59l-2.82-7.84h0v7.84H29.05Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M41.37,43h1.78v8.63h5.17v1.53h-7Z",
  fill: "#099192"
}, null, -1)
const DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_32 = [
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_26,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_27,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_28,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_29,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_30,
  DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_31
]

function DpFileIconXMLvue_type_template_id_4b0c6984_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.inverted && $props.outlined)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_1, DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_8))
    : ($props.inverted)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_9, DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_16))
      : ($props.outlined)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_17, DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_24))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("g", DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_25, DpFileIconXMLvue_type_template_id_4b0c6984_hoisted_32))
}
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXML.vue?vue&type=template&id=4b0c6984

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon/DpFileIconXML.vue?vue&type=script&lang=js

  /* harmony default export */ var DpFileIconXMLvue_type_script_lang_js = ({
    name: "DpFileIconXML",
    props: {
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXML.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon/DpFileIconXML.vue




;
const DpFileIconXML_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconXMLvue_type_script_lang_js, [['render',DpFileIconXMLvue_type_template_id_4b0c6984_render]])

/* harmony default export */ var DpFileIconXML = (DpFileIconXML_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFileIcon.vue?vue&type=script&lang=js

  

  
  
  
  
  
  
  
  
  
  
  
  
  
  

  /* harmony default export */ var DpFileIconvue_type_script_lang_js = ({
    name: "DpFileIcon",
    props: {
      fileExtension: {type: String, required: true},
      width: {type: String},
      height: {type: String},
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    },
    components: {
      DpFileIconCSV: DpFileIconCSV,
      DpFileIconDOC: DpFileIconDOC,
      DpFileIconDOCX: DpFileIconDOCX,
      DpFileIconJPG: DpFileIconJPG,
      DpFileIconPDF: DpFileIconPDF,
      DpFileIconPNG: DpFileIconPNG,
      DpFileIconPPT: DpFileIconPPT,
      DpFileIconPPTX: DpFileIconPPTX,
      DpFileIconSVG: DpFileIconSVG,
      DpFileIconTIFF: DpFileIconTIFF,
      DpFileIconTXT: DpFileIconTXT,
      DpFileIconXLS: DpFileIconXLS,
      DpFileIconXLSX: DpFileIconXLSX,
      DpFileIconXML: DpFileIconXML
    },
    computed: {
      style() {
        if (isEmpty_default()(this.width) && isEmpty_default()(this.height))
          return undefined;
        return {
          width: (isEmpty_default()(this.width)) ? 'auto' : this.width,
          height: (isEmpty_default()(this.height)) ? 'auto' : this.height,
        }
      },
      viewBox() {
        return this.outlined ? '0 0 63.75 73' : '0 0 61.75 69';
      },
      defaultWidth() {
        return this.outlined ? '63.75' : '61.75';
      },
      defaultHeight() {
        return this.outlined ? '73' : '69';
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpFileIcon.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFileIcon.vue




;
const DpFileIcon_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFileIconvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpFileIcon = (DpFileIcon_exports_);

/***/ }),

/***/ 4776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_DpFlag; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag.vue?vue&type=template&id=56c9ff3e&scoped=true


function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.hasFlagISOCode)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)('DpFlag'+$props.flagISOCode.toString().toUpperCase()), {
        key: 0,
        square: $props.square,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-flag-icon", {'square': $props.square}])
      }, null, 8, ["square", "class"]))
    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
}
;// CONCATENATED MODULE: ./src/components/DpFlag.vue?vue&type=template&id=56c9ff3e&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagAE.vue?vue&type=template&id=85dcd590


const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#00732f",
  d: "M0 0h512v170.667H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 170.667h512v170.667H0z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M0 341.333h512V512H0z" }, null, -1)
const _hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "red",
  d: "M0 0h180v512H0z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const _hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#00732f",
  d: "M0 0h640v160H0z"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 160h640v160H0z"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M0 320h640v160H0z" }, null, -1)
const _hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "red",
  d: "M0 0h220v480H0z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]

function DpFlagAEvue_type_template_id_85dcd590_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_1, _hoisted_6))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_7, _hoisted_12))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagAE.vue?vue&type=template&id=85dcd590

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagAE.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagAEvue_type_script_lang_js = ({
  name: "DpFlagAE",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagAE.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagAE.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagAEvue_type_script_lang_js, [['render',DpFlagAEvue_type_template_id_85dcd590_render]])

/* harmony default export */ var DpFlagAE = (__exports__);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagAT.vue?vue&type=template&id=068a975c


const DpFlagATvue_type_template_id_068a975c_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagATvue_type_template_id_068a975c_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M512 512H0V0h512z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#df0000",
    d: "M512 512H0V341.33h512zm0-341.2H0V.13h512z"
  })
], -1)
const DpFlagATvue_type_template_id_068a975c_hoisted_3 = [
  DpFlagATvue_type_template_id_068a975c_hoisted_2
]
const DpFlagATvue_type_template_id_068a975c_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagATvue_type_template_id_068a975c_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M640 480H0V0h640z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#df0000",
    d: "M640 480H0V319.997h640zm0-319.875H0V.122h640z"
  })
], -1)
const DpFlagATvue_type_template_id_068a975c_hoisted_6 = [
  DpFlagATvue_type_template_id_068a975c_hoisted_5
]

function DpFlagATvue_type_template_id_068a975c_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagATvue_type_template_id_068a975c_hoisted_1, DpFlagATvue_type_template_id_068a975c_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagATvue_type_template_id_068a975c_hoisted_4, DpFlagATvue_type_template_id_068a975c_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagAT.vue?vue&type=template&id=068a975c

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagAT.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagATvue_type_script_lang_js = ({
  name: "DpFlagAT",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagAT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagAT.vue




;
const DpFlagAT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagATvue_type_script_lang_js, [['render',DpFlagATvue_type_template_id_068a975c_render]])

/* harmony default export */ var DpFlagAT = (DpFlagAT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagBA.vue?vue&type=template&id=80800468


const DpFlagBAvue_type_template_id_80800468_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagBAvue_type_template_id_80800468_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M0 0h512v512H0z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\"><path fill=\"#009\" d=\"M0 0h512v512H0z\"></path><path d=\"M77 .006l436.91 436.91V.006H77z\" fill=\"#fc0\"></path><path fill=\"#FFF\" d=\"M461.41 470.395l-26.123-19.086-26.849 18.994 10.151-31.164-26.419-19.246 32.731.066 10.177-31.117 10.055 31.156 32.74.094-26.195 19.365 9.732 30.938zm76.714 10.447l-32.74-.094-10.055-31.156-10.177 31.117-32.731-.066 26.419 19.246-10.151 31.164 26.849-18.994 26.123 19.086-9.731-30.938 26.194-19.365zm-146.32-101.26l26.195-19.365-32.74-.094-10.055-31.156-10.177 31.117-32.731-.066 26.419 19.246-10.151 31.164 26.849-18.994 26.123 19.086-9.732-30.938zm-60.333-60.416l26.195-19.367-32.74-.092-10.055-31.156-10.177 31.117-32.731-.066 26.419 19.244-10.151 31.166 26.849-18.996 26.123 19.088-9.732-30.938zM271.804 259.5l26.195-19.368-32.74-.093-10.055-31.156L245.029 240l-32.732-.066 26.418 19.246-10.151 31.166 26.849-18.996 26.123 19.088-9.732-30.938zm-60.417-60.251l26.195-19.367-32.74-.093-10.055-31.156-10.177 31.117-32.731-.066 26.419 19.245-10.151 31.166 26.849-18.996 26.123 19.088-9.732-30.938zm-59.667-59.917l26.195-19.367-32.74-.093-10.055-31.156-10.177 31.117-32.731-.066 26.419 19.245-10.151 31.166 26.849-18.996 26.123 19.088-9.732-30.938zm-60-60l26.195-19.367-32.74-.093-10.054-31.156-10.177 31.117-32.731-.066 26.419 19.245-10.152 31.165 26.849-18.996 26.123 19.088-9.732-30.937zm-60-60L57.915-.035l-32.74-.093-10.054-31.156L4.944-.167l-32.731-.066 26.419 19.245-10.152 31.165 26.849-18.996 26.123 19.088-9.732-30.937z\"></path></g>", 2)
const DpFlagBAvue_type_template_id_80800468_hoisted_4 = [
  DpFlagBAvue_type_template_id_80800468_hoisted_2
]
const DpFlagBAvue_type_template_id_80800468_hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagBAvue_type_template_id_80800468_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-85.333 0h682.67v512h-682.67z\"></path></clipPath></defs><g clip-path=\"url(#a)\" transform=\"translate(80) scale(.9375)\" fill-rule=\"evenodd\"><path fill=\"#009\" d=\"M-85.333 0h682.67v512h-682.67V0z\"></path><path fill=\"#FC0\" d=\"M56.489 0l510.978 512.267v-512L56.489 0z\"></path><path fill=\"#FFF\" d=\"M439.883 481.532l-27.865-20.359-28.639 20.261 10.828-33.243-28.18-20.528 34.914.071 10.855-33.192 10.725 33.233 34.923.099-27.942 20.657 10.381 33.001zm81.294 10.343l-34.923-.099-10.725-33.233-10.855 33.192-34.914-.071 28.18 20.528-10.828 33.243 28.639-20.261 27.865 20.359-10.38-33 27.941-20.658zM365.636 384.666l27.942-20.657-34.923-.099-10.725-33.233-10.855 33.192-34.914-.071 28.18 20.528-10.828 33.243 28.639-20.261 27.865 20.359-10.381-33.001zm-64.355-64.445l27.942-20.657-34.923-.099-10.725-33.233-10.855 33.192-34.914-.071 28.18 20.528-10.828 33.243 28.639-20.261 27.865 20.359-10.381-33.001zm-63.645-63.644l27.941-20.658-34.922-.099-10.725-33.233-10.855 33.192-34.914-.071 28.18 20.528-10.828 33.243 28.639-20.263 27.865 20.36-10.381-32.999zm-64.445-64.267l27.941-20.658-34.922-.099-10.725-33.233-10.855 33.192-34.914-.071 28.18 20.528-10.828 33.243 28.639-20.262 27.865 20.36-10.381-33zm-63.644-63.912l27.941-20.658-34.922-.099L91.84 74.408 80.985 107.6l-34.914-.071 28.18 20.528L63.423 161.3l28.639-20.262 27.865 20.36-10.38-33zm-64-64L73.488 43.74l-34.922-.099L27.84 10.408 16.985 43.6l-34.914-.071 28.18 20.528L-.576 97.3l28.639-20.262 27.865 20.36-10.381-33zm-64-64L9.488-20.259l-34.922-.099-10.726-33.234L-47.015-20.4l-34.914-.071L-53.749.057-64.576 33.3l28.639-20.263 27.865 20.36L-18.453.398z\"></path></g>", 2)
const DpFlagBAvue_type_template_id_80800468_hoisted_8 = [
  DpFlagBAvue_type_template_id_80800468_hoisted_6
]

function DpFlagBAvue_type_template_id_80800468_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagBAvue_type_template_id_80800468_hoisted_1, DpFlagBAvue_type_template_id_80800468_hoisted_4))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagBAvue_type_template_id_80800468_hoisted_5, DpFlagBAvue_type_template_id_80800468_hoisted_8))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBA.vue?vue&type=template&id=80800468

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagBA.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagBAvue_type_script_lang_js = ({
  name: "DpFlagBA",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBA.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBA.vue




;
const DpFlagBA_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagBAvue_type_script_lang_js, [['render',DpFlagBAvue_type_template_id_80800468_render]])

/* harmony default export */ var DpFlagBA = (DpFlagBA_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagBE.vue?vue&type=template&id=3db64dcc


const DpFlagBEvue_type_template_id_3db64dcc_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagBEvue_type_template_id_3db64dcc_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M0 0h170.664v512.01H0z" }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ffd90c",
    d: "M170.664 0h170.664v512.01H170.664z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#f31830",
    d: "M341.328 0h170.665v512.01H341.328z"
  })
], -1)
const DpFlagBEvue_type_template_id_3db64dcc_hoisted_3 = [
  DpFlagBEvue_type_template_id_3db64dcc_hoisted_2
]
const DpFlagBEvue_type_template_id_3db64dcc_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagBEvue_type_template_id_3db64dcc_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M0 0h213.335v479.997H0z" }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ffd90c",
    d: "M213.335 0H426.67v479.997H213.335z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#f31830",
    d: "M426.67 0h213.335v479.997H426.67z"
  })
], -1)
const DpFlagBEvue_type_template_id_3db64dcc_hoisted_6 = [
  DpFlagBEvue_type_template_id_3db64dcc_hoisted_5
]

function DpFlagBEvue_type_template_id_3db64dcc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagBEvue_type_template_id_3db64dcc_hoisted_1, DpFlagBEvue_type_template_id_3db64dcc_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagBEvue_type_template_id_3db64dcc_hoisted_4, DpFlagBEvue_type_template_id_3db64dcc_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBE.vue?vue&type=template&id=3db64dcc

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagBE.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagBEvue_type_script_lang_js = ({
  name: "DpFlagBE",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBE.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBE.vue




;
const DpFlagBE_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagBEvue_type_script_lang_js, [['render',DpFlagBEvue_type_template_id_3db64dcc_render]])

/* harmony default export */ var DpFlagBE = (DpFlagBE_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagBG.vue?vue&type=template&id=480e9606


const DpFlagBGvue_type_template_id_480e9606_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagBGvue_type_template_id_480e9606_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d62612",
    d: "M0 341.332h512v170.666H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h512v170.666H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#00966e",
    d: "M0 170.666h512v170.666H0z"
  })
], -1)
const DpFlagBGvue_type_template_id_480e9606_hoisted_3 = [
  DpFlagBGvue_type_template_id_480e9606_hoisted_2
]
const DpFlagBGvue_type_template_id_480e9606_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagBGvue_type_template_id_480e9606_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d62612",
    d: "M0 319.997h640V480H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h640v160.003H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#00966e",
    d: "M0 160.003h640v160.003H0z"
  })
], -1)
const DpFlagBGvue_type_template_id_480e9606_hoisted_6 = [
  DpFlagBGvue_type_template_id_480e9606_hoisted_5
]

function DpFlagBGvue_type_template_id_480e9606_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagBGvue_type_template_id_480e9606_hoisted_1, DpFlagBGvue_type_template_id_480e9606_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagBGvue_type_template_id_480e9606_hoisted_4, DpFlagBGvue_type_template_id_480e9606_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBG.vue?vue&type=template&id=480e9606

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagBG.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagBGvue_type_script_lang_js = ({
  name: "DpFlagBG",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBG.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagBG.vue




;
const DpFlagBG_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagBGvue_type_script_lang_js, [['render',DpFlagBGvue_type_template_id_480e9606_render]])

/* harmony default export */ var DpFlagBG = (DpFlagBG_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCH.vue?vue&type=template&id=26c815d8


const DpFlagCHvue_type_template_id_26c815d8_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagCHvue_type_template_id_26c815d8_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#d52b1e\" d=\"M0 0h511.984v511.983H0z\"></path><g fill=\"#fff\"><path d=\"M95.994 207.993h319.99v95.994H95.993z\"></path><path d=\"M207.99 95.995h95.995v319.99H207.99z\"></path></g></g>", 1)
const DpFlagCHvue_type_template_id_26c815d8_hoisted_3 = [
  DpFlagCHvue_type_template_id_26c815d8_hoisted_2
]
const DpFlagCHvue_type_template_id_26c815d8_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagCHvue_type_template_id_26c815d8_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#d52b1e\" d=\"M0 0h640v480H0z\"></path><g fill=\"#fff\"><path d=\"M170 194.997h299.996v89.997H170z\"></path><path d=\"M275 89.997h89.996v299.996H275z\"></path></g></g>", 1)
const DpFlagCHvue_type_template_id_26c815d8_hoisted_6 = [
  DpFlagCHvue_type_template_id_26c815d8_hoisted_5
]

function DpFlagCHvue_type_template_id_26c815d8_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCHvue_type_template_id_26c815d8_hoisted_1, DpFlagCHvue_type_template_id_26c815d8_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCHvue_type_template_id_26c815d8_hoisted_4, DpFlagCHvue_type_template_id_26c815d8_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCH.vue?vue&type=template&id=26c815d8

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCH.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagCHvue_type_script_lang_js = ({
  name: "DpFlagCH",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCH.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCH.vue




;
const DpFlagCH_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagCHvue_type_script_lang_js, [['render',DpFlagCHvue_type_template_id_26c815d8_render]])

/* harmony default export */ var DpFlagCH = (DpFlagCH_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCN.vue?vue&type=template&id=0fce0999


const DpFlagCNvue_type_template_id_0fce0999_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 20 20"
}
const DpFlagCNvue_type_template_id_0fce0999_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><path id=\"s\" d=\"M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z\" fill=\"#FFFF00\"></path></defs><rect width=\"30\" height=\"20\" fill=\"#EE1C25\"></rect><use xlink:href=\"#s\" transform=\"translate(5,5) scale(3)\"></use><use xlink:href=\"#s\" transform=\"translate(10,2) rotate(23.036243)\"></use><use xlink:href=\"#s\" transform=\"translate(12,4) rotate(45.869898)\"></use><use xlink:href=\"#s\" transform=\"translate(12,7) rotate(69.945396)\"></use><use xlink:href=\"#s\" transform=\"translate(10,9) rotate(20.659808)\"></use>", 7)
const DpFlagCNvue_type_template_id_0fce0999_hoisted_9 = [
  DpFlagCNvue_type_template_id_0fce0999_hoisted_2
]
const DpFlagCNvue_type_template_id_0fce0999_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 30 20"
}
const DpFlagCNvue_type_template_id_0fce0999_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><path id=\"s\" d=\"M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z\" fill=\"#FFFF00\"></path></defs><rect width=\"30\" height=\"20\" fill=\"#EE1C25\"></rect><use xlink:href=\"#s\" transform=\"translate(5,5) scale(3)\"></use><use xlink:href=\"#s\" transform=\"translate(10,2) rotate(23.036243)\"></use><use xlink:href=\"#s\" transform=\"translate(12,4) rotate(45.869898)\"></use><use xlink:href=\"#s\" transform=\"translate(12,7) rotate(69.945396)\"></use><use xlink:href=\"#s\" transform=\"translate(10,9) rotate(20.659808)\"></use>", 7)
const _hoisted_18 = [
  DpFlagCNvue_type_template_id_0fce0999_hoisted_11
]

function DpFlagCNvue_type_template_id_0fce0999_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCNvue_type_template_id_0fce0999_hoisted_1, DpFlagCNvue_type_template_id_0fce0999_hoisted_9))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCNvue_type_template_id_0fce0999_hoisted_10, _hoisted_18))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCN.vue?vue&type=template&id=0fce0999

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCN.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagCNvue_type_script_lang_js = ({
  name: "DpFlagCN",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCN.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCN.vue




;
const DpFlagCN_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagCNvue_type_script_lang_js, [['render',DpFlagCNvue_type_template_id_0fce0999_render]])

/* harmony default export */ var DpFlagCN = (DpFlagCN_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCY.vue?vue&type=template&id=9ebcc22e


const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 0h512v512H0z"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  id: "a",
  d: "M243.03 425.173a.87.87 0 0 1-.297-.21l-.106-.1c-.277-.252-.735-.7-1.35-1.4-1.137-1.292-2.662-3.182-4.003-4.852-2.658-3.312-4.854-6.167-5.268-6.704l-.677-.88-6.63-2.045-4.838-2.255 2.586-2.906 8.88 3.8 6.63 1.36 12.256 9.016-.01.007c-.025.02-1.783 1.483-3.53 3.07-.78.71-1.76 1.62-2.455 2.376-.32.347-.602.693-.794.972a2.18 2.18 0 0 0-.216.402l.762-.474.825.642-1.68.157-.076.016zm-45.517-13.67c-5.784 0-11.496-1.6-16.978-4.75l-.006-.004v-.007s.718-1.366 2.457-2.64c1.657-1.217 4.644-2.67 9.472-2.69h.1c5.717 0 12.715 1.944 20.797 5.778-.273.182-6.618 4.314-15.843 4.314l.01.01zm-25.063-5.555c-1.07 0-2.03-.405-2.705-1.138-.554-.602-.95-1.404-1.213-2.456-.43-1.722-.312-3.434-.3-3.598a3.71 3.71 0 0 1 1.333-.302l.096-.002c2.143 0 3.832 1.858 4.556 3.7.41 1.048.49 1.928.234 2.618s-1.06 1.17-1.997 1.17zm44.1-5.112c-14.813-2.115-21.09-7.47-23.75-11.59-2.836-4.394-2.254-8.46-2.248-8.5l.002-.012.01-.003c.005 0 .906-.242 2.27-.25 3.94 0 14.02 1.984 23.72 20.346l.006.012-.017-.01zm-30.36-2.935c-6.33 0-11.147-1.09-14.322-3.245-1.824-1.238-2.717-2.597-3.145-3.52a5.768 5.768 0 0 1-.507-1.727c.167-.076 2.758-1.227 6.626-1.408.327-.015.656-.024 1.002-.025 4.89 0 12.33 1.596 20.178 9.2l.007.006-.01.002c-3.585.47-6.896.716-9.84.716zm-30.644-1.177c-6.673 0-15.84-2.038-21.558-7.754l-.006-.007.017-.004c.06-.016 6.264-1.59 13.245-1.76.417-.01.836-.017 1.26-.017 6.256 0 11.044 1.214 14.234 3.606 1.113.834 1.72 1.61 1.858 2.373.114.637-.222 1.323-.9 1.835-1.438 1.085-4.005 1.663-7.634 1.72l-.512.018zm-21.624-11.093a2.736 2.736 0 0 1-2.115-.996c-.432-.524-.732-1.208-.946-2.152-.355-1.577-.248-3.12-.247-3.135v-.016c.31-.145.66-.224 1.04-.233.99 0 1.74.537 2.21.988a5.942 5.942 0 0 1 1.44 2.257c.312.88.363 1.614.155 2.248-.17.504-.75 1.033-1.536 1.033zm49.946-1.127c-1.07 0-2.03-.404-2.705-1.137-.554-.602-.95-1.405-1.214-2.456-.43-1.722-.312-3.435-.3-3.598a3.71 3.71 0 0 1 1.333-.303l.095-.002c2.143 0 3.832 1.858 4.555 3.7.41 1.047.49 1.928.234 2.618-.256.7-1.067 1.17-1.997 1.17zm-24.33-1.006c-13.428-.473-20.397-4.29-23.878-7.41-1.96-1.756-3.05-3.497-3.62-4.648-.535-1.088-.738-1.92-.773-2.08l.017-.008c.002 0 1.27-.454 3.316-.495l.314-.003c4.528 0 13.748 1.903 24.62 14.638v.01zm14.585-1.357c-10.804-1.645-16.925-6.283-20.158-9.886-3.388-3.776-4.403-7.293-4.448-7.457.02-.006 1.34-.35 3.328-.4a16.2 16.2 0 0 1 .92 0c5.433.12 15.303 2.58 20.355 17.737h.01zm-55.467-5.19c-3.54 0-6.975-.408-10.208-1.216-5.656-1.415-8.083-3.575-9.123-5.138-.59-.888-.804-1.666-.88-2.163a3.642 3.642 0 0 1-.026-.915l.026-.01c.014-.003 3.754-1.054 8.93-1.133a37.36 37.36 0 0 1 7.927.703c8.99 1.798 13.652 8.584 13.697 8.653l.004.008-.01.002c-.052.01-4.336 1.21-10.343 1.21zm25.08-9.112c-1.083 0-2.044-.395-2.707-1.113-.547-.59-.943-1.402-1.213-2.48-.432-1.72-.312-3.416-.3-3.573a3.71 3.71 0 0 1 1.333-.302l.096-.002c2.138 0 3.83 1.86 4.556 3.702.4 1.014.47 1.884.207 2.59-.265.716-1.042 1.177-1.972 1.177zm-18.86-2.586c-.08-.02-5.1-1.31-10.21-4.458-4.732-2.913-10.52-8.064-11.225-16.07v-.003l.013-.002s.44-.106 1.09-.13c.09-.004.186-.006.286-.006 1.412 0 4.305.398 7.804 3.058 4.454 3.397 8.568 9.32 12.245 17.622zm12.314-.452c-.03-.013-3.608-1.445-8.08-5.192-4.166-3.492-10.023-9.78-14.264-19.908.002 0 .974-.52 2.463-.613a3.71 3.71 0 0 1 .26-.007c.128 0 .26.004.395.007 2.057.058 5.19.913 8.665 4.662 3.99 4.306 7.552 11.383 10.584 21.035l.01.027-.026-.01zm-31.906-.93c-4.114 0-5.522-2.232-5.936-3.192-.68-1.577-.475-3.148-.473-3.163l.002-.017a9.065 9.065 0 0 1 2.046-.268h.14c3.243 0 5.802 1.645 6.9 3.277.217.323.884 1.445.332 2.322-.444.69-1.45 1.04-3.012 1.04zm-9.113-11.495c-2.297 0-5.81-.14-9.506-.812-3.665-.666-5.742-3.782-6.838-6.277-1.194-2.718-1.53-5.31-1.534-5.337h.01c11.334.332 16.687 3.644 19.182 6.363 2.575 2.807 2.728 5.722 2.735 5.906h-.008c-.017 0-1.613.154-4.045.154zm11.802-11.793a45.616 45.616 0 0 1-2.588-3.607c-1.342-2.087-2.584-4.264-2.584-6.046 0-1.72-.404-5.347-.646-7.355-.305-2.548-.614-4.728-.64-4.913l.01.003c.29.105 7.09 2.657 7.09 9.038 0 6.39-.63 12.812-.635 12.876l-.002.01h-.01zm-8.815-.605c-.07 0-.142-.006-.213-.018-2.01-.337-5.543-1.874-9.45-4.113-4.336-2.486-7.857-5.15-9.915-7.5-1.876-2.145-2.99-5.51-3.312-10.008-.227-3.19.046-5.85.075-6.113a3.532 3.532 0 0 1 1.122-.174c1.505.025 3.112.702 5.28 2.196 1.69 1.164 3.555 2.748 5.54 4.705a84.457 84.457 0 0 1 6.142 6.802l.028.034c.226.406 2.165 3.9 3.675 7.304.96 2.16 1.508 3.718 1.727 4.903.126.675.162 1.118-.003 1.52-.07.166-.2.32-.33.382a.924.924 0 0 1-.374.076z",
  fill: "#435125"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("use", {
  height: "100%",
  width: "100%",
  "xlink:href": "#a",
  transform: "matrix(-1 0 0 1 462.66 0)"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M468.335 81.473l-2.01.8-.787.314-2.436-.134-2.28 1.095-4.045 2.764-.18.128-1.507.393-1.4-.604-.795.36-.274 1.64-.756 1.176-.932.655-3.228.33-2.722 1.405-3.542-.948-1.645.644-3.498 3.15-1.787.848-.625-.036-2.37-.122-1 .328-1.497 1.445-2.828.22-.882.61-1.38 2.782-1.496 1.542-.856.18-.928-.338-.697.122-.315 1.78-.676.746-1.895.65-1.513 1.262-1.328.682-1.778-.045h-.41l-1.77.978-3.333.292-1.385 1.322-.306.28-.647.392-1.058.632-.26.157-1.275-.227-1.493.59-.606-.928-1.033.62-1.368.06-1.705-.76-1.298-.578-.95.137-.33 1.656-.035.176-.998 1.328-1.864 1.13-.253.33-2.12 2.737-4.03 4.24-3.408 1.73-3.532 1.073-2.472 2.03-6.484 3.216L357.79 135l-2.094.67-3.004.48-5.357 1.974-4.727 1.426-.263.08-.935.283-6.664 2.017-3.102-.328-1.838.667-4.782-.53-3.326.064-2.105.438-3.957 1.898-6.68 3.21-2.206 2.02-3.436 1.792-4.024 1.274.01-1.69-.023-.072-1.397.44-1.007.32-3.264.503h-1.817l-1.127-.328-.175.058-6.67 2.198-7.44.72-3.723 1.193-2.782-.046-1.74.518-3.408.417-1.22-.327-.274-.075-10.026.435-4.584-.517-2.188.497-3.666-1.233-5.35-.62-1.25-.375-2.813-.835-1.272.733-.952.102-2.276-.825-.82-.022-1.878.68-1.083-.278-1.004-.8-2.356-.35-1.435-1.207-8.023 1.063-2.178-.64-7.3-2.127-1.16.058-1.448 1.085-2.174.793-1.888.49-2.57.09-2.984-.783-3.078-1.492-1.137-.27-2.538.256-.776.07-4.666-2.5-6.01-3.76-4.076-1.958-1.53-.248-.207.727.76 2.394.26 2.368-.078 2.187-.042 1.355.38 1.216 1.472 1.63.614 1.64.45 4.51-.006 4.574-.716 7.297-.242 1.11-.854 3.78-.78 3.473-3.026 9.245-.83 1.146-2.04 1.392-4.625 3.148-3.405 1.963-1.078.446-2.764.208-1.722-.09-2.144-1.16-2.105-.542-2.76-1.984-3.067-.634-3.363-1.944-.876-1.053-1.83-.17-2.54-.763.002-.004-.933-.28-.644-.187-3.24-.09-3.02-1.394-1.592-.384-2.173-.11-2.275 1.058v-.003l-1.154.536-1.457-.58-1.055.066-1.193 1.805-.18.28-.82.436-1.025-.014-.802-.022-.867.38-1.167.505v.002l-1.03.45-.503.218-.01-.01-.31.063-.55.096-.682.13-1.203-.703-.64-.376-1.073-.22-.58.42-.112 1.962-.528 1.176-1.673 1.48-1.7 1.497-1.186 1.746-3.136 7.16-1.965 2.888-.61.673-2.056 2.267-1.823 1.414-4.2 3.255-3.974 1.486-3.425.7-1.664.005-3.154-.42-2.835-.87-3.115-1.948-3.416-2.745-4.944-4.885-.7-.42-.146-.098-1.557-.996-1.156.03-.453.745-.246 1.077-.21.956-.566 5.433.042.315.298 2.238 3.755 5.248 1.16 2.788.19.318.774 1.302.59.992.06.1 1.282 3.83-.903 2.163.456 1.447-1.14.885-.21 1.25 3.372 4.227.736 1.863-.82 2.585-1.312 1.426-.366.39.185 1.092 1.55 1.395 2.637 2.348 1.405 3.487 1.07.935 1.24-.264.692.527 1.048-.018 1.03 1.03.668.324 1.055.525.834 1.085.184 3.338 1.556 4.147.024 2.248.008.32.968 1.662.304 1.312-.516 3.473 1.233 1.114 1.337-.273.864.137 1.388 1.156 1.68 2.56 1.643-.24 1.042.503 5.036 4.55 1.143.578.064.036.822.412 1.02 1.03 1.585-1.05.177-.018 1.722-.152.755.51 1.454.98 1.905-.025 4.134 1.267 1.807.464 3.636 2.26 1.546.955.913.743 1.216.99 2.426 1.045 2.082.5 1.13.268.848.327.02-.052.013.003-.022.053 4.51 1.726 2.442.57 2.26.832 1.644.6 1.206.02 1.707-1.436 1.653-.096 1.373.342 1.34-.224 2.12-1.306.414-.614 1.503-.716 5.073-.63 1.482.482 3.806-1.656 2.55.71 2.258-.8 4.93 1.094 1.312.923 1.465 1.678.18.007 1.63.03-.68 1.137 2.152 2.26 1.945 2.94.13.387 1.415 4.15 1.05 1.47.737 2.052.036 1.338-1.144.872-.188.498-.064.184.232.56.43-.237.823-.454.994-.155 1.763.188 1.164.122 1.84-.912 1.217-.606 1.957.842 2.15-.024.903.402 2.556 1.16 1.304.122.482-.317.307-.73-.158-.85-.978-1.13-2.16-2.506-.884-1.29-.673-1.865-.21-2.384-.148-1.608.268-2.114.58-.754.427-1.68h.007l.11-.44 1.2-1.59 3.177-2.043 3.413-3.056 2.698-1.78 2.782-1.204.074-.338.31.125 7.076-2.406.117-.012 3.15-.55 21.265 1.5.79-.24.002-.004.708-1.99.382-.367.253-.24 2.338-1.03 1.093-.156 3.035.75 1.242.306 1.99-1.115 1.412.025 2.915-1.592 1.802.045.685-.274 3.508-2.522 3.38-.968.88-.468.31-.17 3.463-1.83 2.202-1.69 1.9-1.01 2.08-.536 5.444-.383 1.095-1.825 2.342-.312 1.414-1.596 1.618-.658 1.16-1.67.972-1.4 1.358-.787 4.352-.274 5.158.64.682-.414 1.166-4.16 1.22-.78 3.286-4.79.01-1.745.004-1.458.54-2.076-.367-3.747.436-3.794 2.043-4.82 1.8-1.946 2.902-1.963 1.476-.643 2.09-.35v-.006l.308-.052.532-.09 7.196-.1c.1-.074 2.618-.036 2.618-.036l2.4-.032 6.07 1.08.43.075 2.054.664 2.367 1.84 2.505 2.448.47.456 1.624.684.49.214 1.34-.214 1.91-.994 1.44-1.218 1.964-1.072.047-.07 1.105-1.66.034-.035.024.006.002-.01-.02-.005.437-.662 3.795-1.478 4.463-.26.5-.27.28-.15 1.18-1.385 1.105-.01 2.675.967 1.88-.373 1.494.597 1.16-.137 2.188-.26 2.35 1.655 1.37.175 4.828 2.824.25.04.13.025.277.045.573-.17.852-.246.112-.032.108.148.548.774.753.108.89-1.19-.354-.538-.134-.197-1.725-.35-1.55-2.648 1.476-1.588-2.313-2.838-.384-.472-.13-.2-.8-1.214-4.05-6.174-5.276-4.21-.002.002-1.847-1.478-.01-.01-.648-.507-2.818-2.866-2.012-2.67-.264-.575-.415-.906-1.206-2.628-2.1-1.618-1.713-1.87-.083-.11-3.532-4.8-.58-.805-.835-.483-1.763-.012-.166-.167-.1-.103.06-.063.846-.84.943-.238.406-.93-1.8-5.208-.012-.182-.134-1.664 1.466-7.556.188-.92 2.5-5.085 1.547-1.27 1.69-3.32 1.447-2.124 1.386-1.35.243-.143 2.504-1.515 2.104-.297 2.003-.28 3.5 1.078 3.328-.065.65-.07 1.51-.173 2.484-.782 1.172-.724.61-.932 1.268-4.256.408-1.354.782-1.47 4.528-5.214 3.423-3.165 7.696-5.643 3.766-2.252 1.924-1.15 17.174-7.634 4.463-4.524 2.325-2.353 4.114-2.76 4.814-1.972 4.142-3.28.904-1.137 1.14-3.672.95-.23.858-1.855.244-.526 3.38-2.383.382-.19L456 94.953l1.91.262 1.02-1.53 3.82-.64.704-.12.942-.47.802-1.365v-.27l.11-3.647.815-.986.445-2.403.42-.554.437-.577 1.082-.76-.188-.454z",
  fill: "#d47600"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_6 = [
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_2,
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_3,
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_4,
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_5
]
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 0h640v480H0z"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  id: "a",
  d: "M307.84 398.6a.815.815 0 0 1-.278-.196l-.1-.094c-.26-.237-.688-.657-1.265-1.314-1.066-1.21-2.495-2.982-3.752-4.548-2.492-3.106-4.55-5.782-4.94-6.286l-.634-.826-6.212-1.916-4.537-2.115 2.425-2.725 8.326 3.565 6.215 1.275 11.49 8.45-.01.008c-.022.02-1.67 1.39-3.308 2.88-.73.663-1.65 1.516-2.3 2.226-.3.326-.565.65-.745.912-.11.16-.172.306-.202.377l.714-.444.773.6-1.574.147-.072.016zm-42.672-12.816c-5.422 0-10.777-1.5-15.916-4.454l-.006-.003.002-.006s.672-1.28 2.302-2.475c1.553-1.14 4.354-2.503 8.88-2.52h.094c5.36 0 11.92 1.822 19.498 5.416-.256.17-6.204 4.045-14.852 4.045l.008.008zm-23.496-5.208c-1.002 0-1.903-.38-2.536-1.066-.52-.565-.89-1.317-1.138-2.303-.403-1.614-.292-3.22-.28-3.373a3.48 3.48 0 0 1 1.25-.284l.09-.002c2.008 0 3.59 1.743 4.27 3.47.384.982.458 1.807.218 2.454-.24.648-.992 1.096-1.872 1.096zm41.344-4.792c-13.887-1.983-19.774-7.004-22.266-10.866-2.66-4.12-2.113-7.93-2.108-7.968l.002-.012.01-.003c.005 0 .85-.228 2.127-.234 3.696 0 13.145 1.86 22.24 19.075l.006.01-.016-.007zm-28.464-2.752c-5.933 0-10.45-1.024-13.426-3.043-1.71-1.16-2.547-2.436-2.948-3.3a5.408 5.408 0 0 1-.476-1.62c.157-.072 2.586-1.15 6.212-1.32.307-.014.616-.023.94-.024 4.585 0 11.558 1.496 18.916 8.624l.007.007h-.01c-3.36.44-6.463.673-9.223.673zm-28.728-1.104c-6.256 0-14.85-1.91-20.21-7.27l-.006-.006.016-.004c.056-.014 5.873-1.49 12.418-1.65.39-.01.783-.014 1.18-.014 5.866 0 10.355 1.137 13.346 3.38 1.044.783 1.614 1.512 1.742 2.226.107.597-.208 1.24-.845 1.72-1.346 1.017-3.753 1.56-7.156 1.614l-.48.016zm-20.272-10.4a2.56 2.56 0 0 1-1.983-.934c-.406-.49-.688-1.132-.888-2.017-.334-1.48-.233-2.925-.232-2.94v-.014a2.43 2.43 0 0 1 .974-.22h.002c.926 0 1.63.504 2.07.927a5.57 5.57 0 0 1 1.352 2.116c.292.824.34 1.513.144 2.108-.16.472-.704.968-1.44.968zm46.824-1.056c-1.002 0-1.903-.38-2.536-1.066-.52-.565-.89-1.317-1.138-2.303-.403-1.614-.292-3.22-.28-3.373a3.48 3.48 0 0 1 1.25-.284l.09-.002c2.008 0 3.59 1.743 4.27 3.47.384.982.458 1.807.218 2.454-.24.656-1 1.096-1.872 1.096zm-22.808-.944c-12.59-.443-19.123-4.022-22.387-6.946-1.837-1.647-2.858-3.28-3.39-4.358-.504-1.02-.694-1.8-.728-1.95l.017-.007s1.19-.426 3.107-.464l.295-.003c4.245 0 12.888 1.784 23.08 13.723v.008zm13.672-1.272c-10.13-1.542-15.867-5.89-18.898-9.268-3.176-3.54-4.128-6.837-4.17-6.99.018-.006 1.256-.328 3.12-.376a14.24 14.24 0 0 1 .862 0c5.094.112 14.347 2.42 19.084 16.628h.008zm-52-4.864c-3.32 0-6.54-.384-9.57-1.142-5.303-1.326-7.578-3.35-8.552-4.816-.554-.832-.755-1.562-.825-2.028a3.414 3.414 0 0 1-.025-.858l.025-.01c.013-.002 3.52-.987 8.37-1.06a35.027 35.027 0 0 1 7.43.66c8.43 1.683 12.802 8.046 12.845 8.11l.004.007-.01.002c-.05.008-4.065 1.136-9.697 1.136zm23.512-8.544c-1.015 0-1.916-.37-2.538-1.043-.51-.553-.883-1.315-1.136-2.327-.404-1.612-.292-3.2-.28-3.348a3.48 3.48 0 0 1 1.25-.283l.09-.002c2.004 0 3.59 1.743 4.27 3.47.374.95.44 1.767.194 2.428-.248.672-.976 1.104-1.848 1.104zm-17.68-2.424c-.076-.018-4.782-1.23-9.574-4.18-4.435-2.73-9.86-7.56-10.522-15.064v-.004l.01-.003c.002 0 .414-.1 1.024-.123.084-.003.173-.005.267-.005 1.325 0 4.037.373 7.317 2.867 4.176 3.184 8.032 8.736 11.48 16.52zm11.544-.424c-.03-.012-3.383-1.354-7.575-4.867-3.905-3.274-9.396-9.168-13.372-18.664.002-.002.914-.488 2.31-.576a3.31 3.31 0 0 1 .244-.007c.12 0 .244.004.37.007 1.93.055 4.866.856 8.123 4.37 3.74 4.038 7.08 10.673 9.923 19.722l.008.025-.024-.007zm-29.912-.872c-3.857 0-5.177-2.092-5.566-2.992-.638-1.48-.444-2.95-.443-2.966l.002-.016a8.498 8.498 0 0 1 1.92-.25l.13-.002c3.04 0 5.44 1.544 6.468 3.073.204.303.83 1.355.312 2.177-.416.648-1.36.976-2.824.976zm-8.544-10.776c-2.154 0-5.45-.132-8.913-.762-3.435-.624-5.382-3.545-6.41-5.884-1.12-2.548-1.435-4.98-1.44-5.004h.01c10.627.312 15.645 3.417 17.984 5.966 2.415 2.632 2.558 5.365 2.566 5.538h-.007c-.017 0-1.513.144-3.793.144zm11.064-11.056a42.733 42.733 0 0 1-2.426-3.382c-1.26-1.956-2.423-3.997-2.423-5.668 0-1.612-.38-5.012-.605-6.895-.287-2.387-.576-4.43-.6-4.604l.01.003c.27.097 6.646 2.49 6.646 8.47 0 5.993-.59 12.013-.596 12.073v.01h-.008zm-8.264-.568c-.067 0-.134-.006-.2-.017-1.885-.313-5.197-1.754-8.858-3.853-4.066-2.33-7.368-4.83-9.296-7.033-1.76-2.01-2.803-5.166-3.104-9.38-.214-2.992.042-5.484.07-5.73.33-.11.68-.164 1.05-.164 1.412.023 2.92.658 4.952 2.06 1.585 1.09 3.332 2.576 5.192 4.41 3.21 3.166 5.735 6.346 5.76 6.377l.025.032c.213.38 2.03 3.656 3.447 6.845.9 2.026 1.413 3.486 1.62 4.597.117.633.15 1.048-.004 1.425a.721.721 0 0 1-.308.358.866.866 0 0 1-.352.072z",
  fill: "#435125"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("use", {
  height: "100%",
  width: "100%",
  "xlink:href": "#a",
  transform: "matrix(-1 0 0 1 593.742 0)"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M519.064 76.38l-1.884.75-.738.296-2.284-.126-2.138 1.026-3.792 2.592-.167.12-1.413.368-1.313-.566-.745.34-.258 1.535-.71 1.103-.873.614-3.028.31-2.552 1.316-3.32-.89-1.542.605-3.28 2.953-1.675.794-.586-.034-2.222-.114-.94.307-1.4 1.354-2.652.206-.827.572-1.294 2.608-1.402 1.446-.803.17-.87-.318-.653.115-.296 1.67-.634.698-1.776.612-1.418 1.182-1.245.64-1.667-.043h-.383l-1.66.918-3.125.274-1.3 1.24-.286.264-.606.366-.992.592-.243.147-1.196-.212-1.4.554-.567-.87-.968.58-1.284.056-1.598-.712-1.218-.542-.89.13-.31 1.55-.03.166-.937 1.245-1.747 1.06-.238.308-1.988 2.567-3.777 3.972-3.195 1.623-3.31 1.007-2.318 1.904-6.08 3.014-9.595 4.773-1.962.63-2.816.45-5.024 1.848-4.43 1.338-.247.075-.878.266-6.248 1.89-2.908-.308-1.722.626-4.484-.498-3.118.062-1.974.41-3.71 1.78-6.26 3.01-2.07 1.892-3.22 1.68-3.773 1.195.01-1.586-.024-.067-1.307.413-.945.3-3.06.47h-1.703l-1.056-.306-.165.055-6.254 2.06-6.974.673-3.49 1.12-2.61-.042-1.63.486-3.195.39-1.14-.304-.26-.07-9.4.408-4.297-.486-2.05.466-3.438-1.156-5.015-.58-1.172-.352-2.636-.783-1.193.686-.893.096-2.134-.774-.768-.02-1.762.637-1.013-.26-.942-.75-2.21-.33-1.344-1.13-7.522.996-2.04-.6-6.844-1.992-1.09.055-1.355 1.017-2.04.743-1.768.46-2.41.084-2.798-.735-2.884-1.398-1.067-.254-2.38.24-.727.067-4.374-2.346-5.633-3.522-3.823-1.837-1.435-.232-.193.683.712 2.245.243 2.22-.073 2.05-.04 1.27.357 1.14 1.38 1.53.577 1.535.42 4.227-.005 4.29-.67 6.84-.227 1.042-.8 3.543-.732 3.255-2.837 8.666-.78 1.075-1.912 1.304-4.335 2.95-3.193 1.84-1.01.42-2.592.195-1.614-.085-2.01-1.09-1.973-.507-2.586-1.86-2.875-.594-3.153-1.822-.82-.987-1.717-.16-2.38-.716v-.005l-.873-.26-.604-.177-3.037-.084-2.83-1.308-1.492-.36-2.038-.103-2.133.99v-.002l-1.08.505-1.367-.543-.988.062-1.12 1.692-.166.262-.772.408-.96-.013-.75-.02-.814.355-1.094.474v.002l-.966.422-.472.204-.008-.008-.29.058-.517.09-.64.122-1.128-.66-.6-.353-1.005-.205-.542.39-.106 1.842-.495 1.102-1.57 1.386-1.593 1.404-1.11 1.638-2.942 6.712-1.842 2.708-.572.63-1.927 2.126-1.708 1.325-3.937 3.05-3.727 1.394-3.21.656-1.562.006-2.956-.393-2.66-.816-2.92-1.826-3.2-2.573-4.636-4.58-.656-.393-.137-.09-1.46-.935-1.082.027-.424.7-.232 1.01-.196.896-.532 5.093.04.295.28 2.1 3.52 4.92 1.086 2.613.178.298.727 1.22.553.93.055.096 1.203 3.59-.846 2.027.428 1.358-1.07.83-.195 1.173 3.16 3.962.69 1.748-.77 2.423-1.23 1.337-.342.366.174 1.023 1.454 1.308 2.47 2.2 1.32 3.27 1 .876 1.166-.248.648.495.982-.017.967.966.626.303.99.493.78 1.018.174 3.13 1.457 3.887.023 2.108.008.3.907 1.558.285 1.23-.484 3.256 1.156 1.045 1.254-.257.81.128 1.3 1.084 1.576 2.4 1.54-.225.978.47 4.722 4.267 1.07.54.06.035.77.386.958.967 1.485-.986.165-.018 1.614-.142.71.477 1.362.92 1.787-.024 3.875 1.188 1.696.436 3.408 2.118 1.45.896.857.697 1.138.93 2.276.978 1.952.467 1.058.25.796.31.02-.05.01.002-.018.05 4.227 1.62 2.288.533 2.12.78 1.54.563 1.132.018 1.6-1.346 1.55-.09 1.286.322 1.256-.21 1.988-1.226.388-.575 1.41-.67 4.755-.59 1.39.45 3.568-1.552 2.39.666 2.117-.75 4.623 1.026 1.23.865 1.373 1.572.168.006 1.53.03-.64 1.065 2.02 2.118 1.823 2.756.123.364 1.326 3.89.985 1.38.69 1.924.033 1.254-1.072.818-.176.466-.06.173.217.524.404-.22.77-.427.933-.145 1.653.176 1.09.115 1.724-.855 1.142-.568 1.834.79 2.016-.023.847.376 2.396 1.087 1.222.115.452-.297.288-.684-.148-.797-.916-1.06-2.025-2.35-.83-1.207-.63-1.75-.196-2.234-.14-1.51.252-1.98.543-.708.4-1.575h.007l.103-.412 1.125-1.492 2.98-1.915 3.2-2.865 2.53-1.668 2.607-1.13.07-.317.29.117 6.634-2.255.108-.013 2.954-.514 19.936 1.404.74-.224.002-.005.664-1.864.358-.345.237-.227 2.19-.965 1.026-.146 2.845.702 1.166.288 1.865-1.046 1.324.022 2.734-1.492 1.69.042.64-.257 3.29-2.363 3.17-.908.824-.44.29-.158 3.248-1.716 2.063-1.584 1.78-.947 1.95-.503 5.105-.36 1.027-1.71 2.195-.292 1.326-1.496 1.516-.617 1.088-1.567.91-1.312 1.274-.737 4.08-.255 4.836.6.64-.39 1.092-3.9 1.144-.73 3.08-4.49.01-1.637.004-1.366.506-1.946-.344-3.512.408-3.557 1.915-4.52 1.688-1.823 2.72-1.84 1.384-.604 1.96-.33v-.004l.287-.05.5-.085 6.745-.09c.093-.07 2.453-.035 2.453-.035l2.25-.03 5.69 1.012.406.07 1.923.624 2.22 1.727 2.348 2.294.44.43 1.523.64.46.2 1.257-.2 1.79-.932 1.35-1.142 1.84-1.005.045-.063 1.036-1.56.033-.03.022.005.002-.01-.018-.003.408-.62 3.558-1.387 4.184-.243.47-.255.262-.14 1.105-1.298 1.036-.01 2.508.908 1.765-.35 1.4.56 1.088-.13 2.052-.242 2.203 1.55 1.284.164 4.526 2.648.235.038.122.023.26.042.536-.16.8-.23.105-.03.1.138.515.725.706.102.835-1.114-.33-.506-.127-.184-1.616-.33-1.452-2.48 1.382-1.49-2.17-2.66-.36-.44-.12-.19-.75-1.137-3.798-5.787-4.946-3.948-.002.003-1.732-1.386-.01-.008-.608-.476-2.64-2.687-1.888-2.503-.247-.54-.39-.85-1.13-2.46-1.97-1.518-1.604-1.754-.08-.103-3.31-4.5-.545-.755-.782-.452-1.653-.01-.156-.158-.093-.097.056-.058.793-.788.884-.222.38-.872-1.686-4.883-.01-.17-.125-1.56 1.374-7.084.175-.863 2.342-4.767 1.452-1.19 1.583-3.112 1.356-1.99 1.3-1.265.227-.135 2.347-1.42 1.972-.278 1.878-.265 3.28 1.01 3.12-.06.61-.064 1.415-.163 2.328-.733 1.1-.68.57-.873 1.19-3.99.38-1.27.735-1.378 4.245-4.887 3.21-2.97 7.214-5.29 3.532-2.11 1.803-1.078 16.1-7.157 4.185-4.24 2.18-2.207 3.857-2.588 4.51-1.85 3.885-3.072.848-1.068 1.068-3.442.892-.215.804-1.74.23-.494 3.167-2.234.36-.18 12.31-6.167 1.788.245.96-1.435 3.58-.6.66-.112.883-.44.75-1.28v-.253l.104-3.42.765-.923.417-2.252.39-.52.412-.54 1.014-.714-.176-.425z",
  fill: "#d47600"
}, null, -1)
const DpFlagCYvue_type_template_id_9ebcc22e_hoisted_12 = [
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_8,
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_9,
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_10,
  DpFlagCYvue_type_template_id_9ebcc22e_hoisted_11
]

function DpFlagCYvue_type_template_id_9ebcc22e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCYvue_type_template_id_9ebcc22e_hoisted_1, DpFlagCYvue_type_template_id_9ebcc22e_hoisted_6))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCYvue_type_template_id_9ebcc22e_hoisted_7, DpFlagCYvue_type_template_id_9ebcc22e_hoisted_12))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCY.vue?vue&type=template&id=9ebcc22e

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCY.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagCYvue_type_script_lang_js = ({
  name: "DpFlagCY",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCY.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCY.vue




;
const DpFlagCY_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagCYvue_type_script_lang_js, [['render',DpFlagCYvue_type_template_id_9ebcc22e_render]])

/* harmony default export */ var DpFlagCY = (DpFlagCY_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCZ.vue?vue&type=template&id=78cdf9cc


const DpFlagCZvue_type_template_id_78cdf9cc_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagCZvue_type_template_id_78cdf9cc_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  transform: "translate(-74) scale(.722)",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#e80000",
    d: "M0 0h1063v708.66H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h1063v354.33H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    d: "M0 0l529.732 353.88L0 707.3V0z",
    fill: "#00006f"
  })
], -1)
const DpFlagCZvue_type_template_id_78cdf9cc_hoisted_3 = [
  DpFlagCZvue_type_template_id_78cdf9cc_hoisted_2
]
const DpFlagCZvue_type_template_id_78cdf9cc_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagCZvue_type_template_id_78cdf9cc_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-74 0h682.67v512H-74z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\" transform=\"translate(69.38) scale(.94)\" stroke-width=\"1pt\"><path fill=\"#e80000\" d=\"M-74 0h768v512H-74z\"></path><path fill=\"#fff\" d=\"M-74 0h768v256H-74z\"></path><path d=\"M-74 0l382.73 255.67L-74 511.01V0z\" fill=\"#00006f\"></path></g>", 2)
const DpFlagCZvue_type_template_id_78cdf9cc_hoisted_7 = [
  DpFlagCZvue_type_template_id_78cdf9cc_hoisted_5
]

function DpFlagCZvue_type_template_id_78cdf9cc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCZvue_type_template_id_78cdf9cc_hoisted_1, DpFlagCZvue_type_template_id_78cdf9cc_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagCZvue_type_template_id_78cdf9cc_hoisted_4, DpFlagCZvue_type_template_id_78cdf9cc_hoisted_7))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCZ.vue?vue&type=template&id=78cdf9cc

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagCZ.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagCZvue_type_script_lang_js = ({
  name: "DpFlagCZ",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCZ.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagCZ.vue




;
const DpFlagCZ_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagCZvue_type_script_lang_js, [['render',DpFlagCZvue_type_template_id_78cdf9cc_render]])

/* harmony default export */ var DpFlagCZ = (DpFlagCZ_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagDE.vue?vue&type=template&id=213f7b37


const DpFlagDEvue_type_template_id_213f7b37_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagDEvue_type_template_id_213f7b37_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#ffce00",
  d: "M0 341.338h512.005v170.67H0z"
}, null, -1)
const DpFlagDEvue_type_template_id_213f7b37_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M0 0h512.005v170.67H0z" }, null, -1)
const DpFlagDEvue_type_template_id_213f7b37_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#d00",
  d: "M0 170.67h512.005v170.668H0z"
}, null, -1)
const DpFlagDEvue_type_template_id_213f7b37_hoisted_5 = [
  DpFlagDEvue_type_template_id_213f7b37_hoisted_2,
  DpFlagDEvue_type_template_id_213f7b37_hoisted_3,
  DpFlagDEvue_type_template_id_213f7b37_hoisted_4
]
const DpFlagDEvue_type_template_id_213f7b37_hoisted_6 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagDEvue_type_template_id_213f7b37_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#ffce00",
  d: "M0 320h640v160.002H0z"
}, null, -1)
const DpFlagDEvue_type_template_id_213f7b37_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", { d: "M0 0h640v160H0z" }, null, -1)
const DpFlagDEvue_type_template_id_213f7b37_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#d00",
  d: "M0 160h640v160H0z"
}, null, -1)
const DpFlagDEvue_type_template_id_213f7b37_hoisted_10 = [
  DpFlagDEvue_type_template_id_213f7b37_hoisted_7,
  DpFlagDEvue_type_template_id_213f7b37_hoisted_8,
  DpFlagDEvue_type_template_id_213f7b37_hoisted_9
]

function DpFlagDEvue_type_template_id_213f7b37_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagDEvue_type_template_id_213f7b37_hoisted_1, DpFlagDEvue_type_template_id_213f7b37_hoisted_5))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagDEvue_type_template_id_213f7b37_hoisted_6, DpFlagDEvue_type_template_id_213f7b37_hoisted_10))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagDE.vue?vue&type=template&id=213f7b37

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagDE.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagDEvue_type_script_lang_js = ({
  name: "DpFlagDE",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagDE.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagDE.vue




;
const DpFlagDE_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagDEvue_type_script_lang_js, [['render',DpFlagDEvue_type_template_id_213f7b37_render]])

/* harmony default export */ var DpFlagDE = (DpFlagDE_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagDK.vue?vue&type=template&id=5ad8f75d


const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#c60c30",
  d: "M0 0h512.1v512H0z"
}, null, -1)
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M144 0h73.143v512H144z"
}, null, -1)
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 219.43h512.1v73.142H0z"
}, null, -1)
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_5 = [
  DpFlagDKvue_type_template_id_5ad8f75d_hoisted_2,
  DpFlagDKvue_type_template_id_5ad8f75d_hoisted_3,
  DpFlagDKvue_type_template_id_5ad8f75d_hoisted_4
]
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_6 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#c60c30",
  d: "M0 0h640.1v480H0z"
}, null, -1)
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M205.714 0h68.57v480h-68.57z"
}, null, -1)
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 205.714h640.1v68.57H0z"
}, null, -1)
const DpFlagDKvue_type_template_id_5ad8f75d_hoisted_10 = [
  DpFlagDKvue_type_template_id_5ad8f75d_hoisted_7,
  DpFlagDKvue_type_template_id_5ad8f75d_hoisted_8,
  DpFlagDKvue_type_template_id_5ad8f75d_hoisted_9
]

function DpFlagDKvue_type_template_id_5ad8f75d_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagDKvue_type_template_id_5ad8f75d_hoisted_1, DpFlagDKvue_type_template_id_5ad8f75d_hoisted_5))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagDKvue_type_template_id_5ad8f75d_hoisted_6, DpFlagDKvue_type_template_id_5ad8f75d_hoisted_10))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagDK.vue?vue&type=template&id=5ad8f75d

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagDK.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagDKvue_type_script_lang_js = ({
  name: "DpFlagDK",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagDK.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagDK.vue




;
const DpFlagDK_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagDKvue_type_script_lang_js, [['render',DpFlagDKvue_type_template_id_5ad8f75d_render]])

/* harmony default export */ var DpFlagDK = (DpFlagDK_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagEE.vue?vue&type=template&id=753450de


const DpFlagEEvue_type_template_id_753450de_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagEEvue_type_template_id_753450de_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  transform: "scale(.482 .72)",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "708.66",
    width: "1063"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "236.22",
    width: "1063",
    y: "475.56",
    fill: "#fff"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#1291ff",
    d: "M0 0h1063v236.22H0z"
  })
], -1)
const DpFlagEEvue_type_template_id_753450de_hoisted_3 = [
  DpFlagEEvue_type_template_id_753450de_hoisted_2
]
const DpFlagEEvue_type_template_id_753450de_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagEEvue_type_template_id_753450de_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "477.9",
    width: "640"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "159.3",
    width: "640",
    y: "320.7",
    fill: "#fff"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#1291ff",
    d: "M0 0h640v159.3H0z"
  })
], -1)
const DpFlagEEvue_type_template_id_753450de_hoisted_6 = [
  DpFlagEEvue_type_template_id_753450de_hoisted_5
]

function DpFlagEEvue_type_template_id_753450de_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagEEvue_type_template_id_753450de_hoisted_1, DpFlagEEvue_type_template_id_753450de_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagEEvue_type_template_id_753450de_hoisted_4, DpFlagEEvue_type_template_id_753450de_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagEE.vue?vue&type=template&id=753450de

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagEE.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagEEvue_type_script_lang_js = ({
  name: "DpFlagEE",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagEE.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagEE.vue




;
const DpFlagEE_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagEEvue_type_script_lang_js, [['render',DpFlagEEvue_type_template_id_753450de_render]])

/* harmony default export */ var DpFlagEE = (DpFlagEE_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagES.vue?vue&type=template&id=305428e2


const DpFlagESvue_type_template_id_305428e2_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagESvue_type_template_id_305428e2_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"#c60b1e\" d=\"M0 0h512v512H0z\"></path><path fill=\"#ffc400\" d=\"M0 128h512v256H0z\"></path><path d=\"M171.727 227.575s-.523 0-.81-.164c-.29-.166-1.156-.987-1.156-.987l-.694-.496-.633-.876s-.753-1.198-.408-2.133c.345-.93.925-1.262 1.448-1.534.52-.274 1.616-.603 1.616-.603s.87-.383 1.158-.44c.288-.055 1.333-.328 1.333-.328s.29-.163.577-.273c.292-.11.695-.11.93-.168.23-.055.81-.24 1.155-.26.538-.02 1.39.096 1.68.096.29 0 1.273.058 1.676.058s1.85-.113 2.256-.113c.404 0 .696-.05 1.16 0 .46.055 1.27.327 1.505.44.23.11 1.62.604 2.14.767.52.16 1.795.382 2.376.656.574.276.93.738 1.216 1.122.292.383.345.8.46 1.076.112.274.116.863.005 1.136-.117.272-.526.837-.526.837l-.637 1.04-.81.653s-.58.553-1.04.495c-.465-.047-5.153-.877-8.163-.877-3.01 0-7.817.877-7.817.877\" fill=\"#ad1519\"></path><path d=\"M171.727 227.575s-.523 0-.81-.164c-.29-.166-1.156-.987-1.156-.987l-.694-.496-.633-.876s-.753-1.198-.408-2.133c.345-.93.925-1.262 1.448-1.534.52-.274 1.616-.603 1.616-.603s.87-.383 1.158-.44c.288-.055 1.333-.328 1.333-.328s.29-.163.577-.273c.292-.11.695-.11.93-.168.23-.055.81-.24 1.155-.26.538-.02 1.39.096 1.68.096.29 0 1.273.058 1.676.058s1.85-.113 2.256-.113c.404 0 .696-.05 1.16 0 .46.055 1.27.327 1.505.44.23.11 1.62.604 2.14.767.52.16 1.795.382 2.376.656.574.276.93.738 1.216 1.122.292.383.345.8.46 1.076.112.274.116.863.005 1.136-.117.272-.526.837-.526.837l-.637 1.04-.81.653s-.58.553-1.04.495c-.465-.047-5.153-.877-8.163-.877-3.01 0-7.817.877-7.817.877h.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\" stroke-linejoin=\"round\"></path><path d=\"M178.166 220.858c0-1.414.633-2.556 1.412-2.556.78 0 1.413 1.142 1.413 2.556 0 1.408-.633 2.553-1.412 2.553-.78 0-1.412-1.144-1.412-2.552\" fill=\"#c8b100\"></path><path d=\"M178.166 220.858c0-1.414.633-2.556 1.412-2.556.78 0 1.413 1.142 1.413 2.556 0 1.408-.633 2.553-1.412 2.553-.78 0-1.412-1.144-1.412-2.552z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M178.957 220.858c0-1.3.29-2.355.648-2.355.36 0 .65 1.055.65 2.355 0 1.292-.29 2.346-.65 2.346-.357 0-.648-1.054-.648-2.346\" fill=\"#c8b100\"></path><path d=\"M178.957 220.858c0-1.3.29-2.355.648-2.355.36 0 .65 1.055.65 2.355 0 1.292-.29 2.346-.65 2.346-.357 0-.648-1.054-.648-2.346z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M178.652 218.157c0-.49.423-.898.946-.898.522 0 .945.407.945.897 0 .495-.423.89-.945.89-.523 0-.946-.395-.946-.89\" fill=\"#c8b100\"></path><path d=\"M180.265 217.84v.597h-1.462v-.596h.48v-1.34h-.634v-.594h.632v-.58h.622v.58h.63v.593h-.63v1.34h.36\" fill=\"#c8b100\"></path><path d=\"M180.265 217.84v.597h-1.462v-.596h.48v-1.34h-.634v-.594h.632v-.58h.622v.58h.63v.593h-.63v1.34h.36\" fill=\"none\" stroke=\"#000\" stroke-width=\".307\"></path><path d=\"M180.92 217.84v.597h-2.597v-.596h.96v-1.34h-.634v-.594h.632v-.58h.622v.58h.63v.593h-.63v1.34h1.015\" fill=\"#c8b100\"></path><path d=\"M180.92 217.84v.597h-2.597v-.596h.96v-1.34h-.634v-.594h.632v-.58h.622v.58h.63v.593h-.63v1.34h1.015\" fill=\"none\" stroke=\"#000\" stroke-width=\".307\"></path><path d=\"M179.87 217.296a.9.9 0 0 1 .673.86c0 .496-.423.892-.945.892-.523 0-.946-.396-.946-.89 0-.415.296-.768.7-.866\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.6 227.41h-4.922l-.113-1.206-.232-1.258-.245-1.57c-1.356-1.79-2.604-2.965-3.022-2.713.1-.33.22-.58.48-.73 1.206-.718 3.693 1.002 5.564 3.827.168.258.33.516.472.776h4.066c.146-.255.307-.513.476-.776 1.867-2.825 4.357-4.545 5.56-3.828.26.152.38.4.483.73-.42-.247-1.666.923-3.03 2.713l-.24 1.57-.232 1.26-.11 1.206h-4.95\" fill=\"#c8b100\"></path><path d=\"M179.6 227.41h-4.922l-.113-1.206-.232-1.258-.245-1.57c-1.356-1.79-2.604-2.965-3.022-2.713.1-.33.22-.58.48-.73 1.206-.718 3.693 1.002 5.564 3.827.168.258.33.516.472.776h4.066c.146-.255.307-.513.476-.776 1.867-2.825 4.357-4.545 5.56-3.828.26.152.38.4.483.73-.42-.247-1.666.923-3.03 2.713l-.24 1.57-.232 1.26-.11 1.206H179.6z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M171.282 220.616c.924-.546 3.086 1.167 4.84 3.827m11.826-3.827c-.928-.546-3.086 1.167-4.84 3.827\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M172.33 229.633a4.794 4.794 0 0 0-.592-1.11c1.993-.585 4.77-.952 7.855-.96 3.084.008 5.883.375 7.872.96 0 0-.223.393-.53.94-.174.3-.4.827-.384.827-1.8-.552-4.12-.835-6.972-.838-2.85.003-5.59.352-7.018.875.015 0-.1-.33-.242-.694h.01\" fill=\"#c8b100\"></path><path d=\"M172.33 229.633a4.794 4.794 0 0 0-.592-1.11c1.993-.585 4.77-.952 7.855-.96 3.084.008 5.883.375 7.872.96 0 0-.223.393-.53.94-.174.3-.4.827-.384.827-1.8-.552-4.12-.835-6.972-.838-2.85.003-5.59.352-7.018.875.015 0-.1-.33-.242-.694h.01\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.593 232.167c2.49-.004 5.233-.382 6.244-.643.68-.197 1.074-.502 1.002-.855-.036-.168-.18-.313-.378-.397-1.49-.476-4.166-.814-6.87-.818-2.698.004-5.393.342-6.88.818-.194.084-.34.23-.375.396-.073.352.323.657.998.854 1.014.26 3.77.64 6.258.643\" fill=\"#c8b100\"></path><path d=\"M179.593 232.167c2.49-.004 5.233-.382 6.244-.643.68-.197 1.074-.502 1.002-.855-.036-.168-.18-.313-.378-.397-1.49-.476-4.166-.814-6.87-.818-2.698.004-5.393.342-6.88.818-.194.084-.34.23-.375.396-.073.352.323.657.998.854 1.014.26 3.77.64 6.258.643z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M187.592 227.41l-.61-.547s-.577.355-1.303.246c-.723-.11-.956-.985-.956-.985s-.81.68-1.475.63c-.665-.06-1.1-.63-1.1-.63s-.72.515-1.358.465c-.637-.06-1.245-.85-1.245-.85s-.637.82-1.273.878c-.638.052-1.16-.553-1.16-.553s-.288.605-1.1.74c-.808.137-1.5-.63-1.5-.63s-.464.74-1.013.934c-.548.19-1.274-.278-1.274-.278s-.116.277-.2.44c-.088.165-.318.194-.318.194l.18.49c1.984-.574 4.672-.93 7.713-.933 3.046.003 5.807.36 7.796.938l.203-.55\" fill=\"#c8b100\"></path><path d=\"M187.592 227.41l-.61-.547s-.577.355-1.303.246c-.723-.11-.956-.985-.956-.985s-.81.68-1.475.63c-.665-.06-1.1-.63-1.1-.63s-.72.515-1.358.465c-.637-.06-1.245-.85-1.245-.85s-.637.82-1.273.878c-.638.052-1.16-.553-1.16-.553s-.288.605-1.1.74c-.808.137-1.5-.63-1.5-.63s-.464.74-1.013.934c-.548.19-1.274-.278-1.274-.278s-.116.277-.2.44c-.088.165-.318.194-.318.194l.18.49c1.984-.574 4.672-.93 7.713-.933 3.046.003 5.807.36 7.796.938l.203-.55h-.008z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.61 224.76l.287.052c-.047.12-.058.246-.058.38 0 .597.51 1.08 1.144 1.08.506 0 .933-.312 1.082-.744.02.01.112-.393.158-.386.034 0 .03.42.05.41.07.542.568.914 1.13.914.628 0 1.133-.483 1.133-1.08 0-.044 0-.088-.006-.13l.36-.358.194.455a.923.923 0 0 0-.107.47c0 .57.488 1.032 1.086 1.032.38 0 .71-.185.906-.462l.23-.29-.004.36c0 .355.153.676.504.734 0 0 .394.03.933-.393.53-.418.82-.767.82-.767l.035.43s-.522.857-.998 1.13c-.258.152-.658.313-.972.257-.33-.05-.567-.32-.69-.624a1.59 1.59 0 0 1-.815.22c-.645 0-1.225-.355-1.454-.882a1.59 1.59 0 0 1-1.192.512c-.515 0-.987-.23-1.282-.59a1.65 1.65 0 0 1-1.12.435c-.57 0-1.08-.285-1.368-.703-.29.418-.795.703-1.363.703a1.64 1.64 0 0 1-1.12-.434c-.296.36-.77.59-1.285.59a1.59 1.59 0 0 1-1.19-.512c-.23.524-.81.883-1.454.883-.3 0-.58-.08-.815-.22-.12.305-.36.574-.69.624-.314.056-.71-.105-.97-.258-.477-.272-1.038-1.13-1.038-1.13l.073-.43s.296.35.822.768c.535.422.933.393.933.393.35-.058.504-.38.504-.734l-.004-.36.23.29c.195.277.527.462.905.462.6 0 1.087-.462 1.087-1.032a.965.965 0 0 0-.103-.47l.19-.455.357.358a.808.808 0 0 0-.01.13c0 .597.507 1.08 1.14 1.08.56 0 1.056-.372 1.13-.913.015.007.01-.41.048-.41.047-.008.143.396.158.385.15.432.58.745 1.087.745.628 0 1.14-.484 1.14-1.08a.98.98 0 0 0-.058-.38l.3-.053\" fill=\"#c8b100\"></path><path d=\"M179.61 224.76l.287.052c-.047.12-.058.246-.058.38 0 .597.51 1.08 1.144 1.08.506 0 .933-.312 1.082-.744.02.01.112-.393.158-.386.034 0 .03.42.05.41.07.542.568.914 1.13.914.628 0 1.133-.483 1.133-1.08 0-.044 0-.088-.006-.13l.36-.358.194.455a.923.923 0 0 0-.107.47c0 .57.488 1.032 1.086 1.032.38 0 .71-.185.906-.462l.23-.29-.004.36c0 .355.153.676.504.734 0 0 .394.03.933-.393.53-.418.82-.767.82-.767l.035.43s-.522.857-.998 1.13c-.258.152-.658.313-.972.257-.33-.05-.567-.32-.69-.624a1.59 1.59 0 0 1-.815.22c-.645 0-1.225-.355-1.454-.882a1.59 1.59 0 0 1-1.192.512c-.515 0-.987-.23-1.282-.59a1.65 1.65 0 0 1-1.12.435c-.57 0-1.08-.285-1.368-.703-.29.418-.795.703-1.363.703a1.64 1.64 0 0 1-1.12-.434c-.296.36-.77.59-1.285.59a1.59 1.59 0 0 1-1.19-.512c-.23.524-.81.883-1.454.883-.3 0-.58-.08-.815-.22-.12.305-.36.574-.69.624-.314.056-.71-.105-.97-.258-.477-.272-1.038-1.13-1.038-1.13l.073-.43s.296.35.822.768c.535.422.933.393.933.393.35-.058.504-.38.504-.734l-.004-.36.23.29c.195.277.527.462.905.462.6 0 1.087-.462 1.087-1.032a.965.965 0 0 0-.103-.47l.19-.455.357.358a.808.808 0 0 0-.01.13c0 .597.507 1.08 1.14 1.08.56 0 1.056-.372 1.13-.913.015.007.01-.41.048-.41.047-.008.143.396.158.385.15.432.58.745 1.087.745.628 0 1.14-.484 1.14-1.08a.98.98 0 0 0-.058-.38l.3-.053h.008z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.593 227.568c-3.086.003-5.862.37-7.85.96-.136.043-.3-.06-.343-.18-.043-.125.054-.282.185-.326 2-.61 4.844-.996 8.008-1 3.16.004 6.017.39 8.017 1 .13.044.227.2.185.327-.038.12-.207.22-.338.178-1.992-.59-4.78-.957-7.864-.96\" fill=\"#c8b100\"></path><path d=\"M179.593 227.568c-3.086.003-5.862.37-7.85.96-.136.043-.3-.06-.343-.18-.043-.125.054-.282.185-.326 2-.61 4.844-.996 8.008-1 3.16.004 6.017.39 8.017 1 .13.044.227.2.185.327-.038.12-.207.22-.338.178-1.992-.59-4.78-.957-7.864-.96z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\" stroke-linejoin=\"round\"></path><path d=\"M176.606 228.662c0-.232.2-.422.45-.422.246 0 .444.19.444.422 0 .236-.198.42-.445.42-.25 0-.45-.184-.45-.42\" fill=\"#fff\"></path><path d=\"M176.606 228.662c0-.232.2-.422.45-.422.246 0 .444.19.444.422 0 .236-.198.42-.445.42-.25 0-.45-.184-.45-.42z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.628 228.845h-.99c-.184 0-.338-.146-.338-.32 0-.173.15-.313.33-.313h2.01a.32.32 0 0 1 .333.312.33.33 0 0 1-.335.32h-1.01\" fill=\"#ad1519\"></path><path d=\"M179.628 228.845h-.99c-.184 0-.338-.146-.338-.32 0-.173.15-.313.33-.313h2.01a.32.32 0 0 1 .333.312.33.33 0 0 1-.335.32h-1.01\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M174.656 229.186l-.71.105c-.18.027-.357-.09-.384-.264a.316.316 0 0 1 .277-.357l.712-.106.73-.113c.18-.02.35.092.38.263.023.17-.1.334-.28.36l-.726.113\" fill=\"#058e6e\"></path><path d=\"M174.656 229.186l-.71.105c-.18.027-.357-.09-.384-.264a.316.316 0 0 1 .277-.357l.712-.106.73-.113c.18-.02.35.092.38.263.023.17-.1.334-.28.36l-.726.113\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M171.788 229.683l.315-.508.672.127-.393.572-.594-.19\" fill=\"#ad1519\"></path><path d=\"M171.788 229.683l.315-.508.672.127-.393.572-.594-.19\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M181.69 228.662c0-.232.2-.422.45-.422.245 0 .445.19.445.422 0 .236-.2.42-.446.42-.25 0-.45-.184-.45-.42\" fill=\"#fff\"></path><path d=\"M181.69 228.662c0-.232.2-.422.45-.422.245 0 .445.19.445.422 0 .236-.2.42-.446.42-.25 0-.45-.184-.45-.42z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M184.534 229.186l.715.105c.18.027.35-.09.38-.264a.313.313 0 0 0-.273-.357l-.718-.106-.727-.113c-.185-.02-.353.092-.38.263-.03.17.096.334.28.36l.72.113\" fill=\"#058e6e\"></path><path d=\"M184.534 229.186l.715.105c.18.027.35-.09.38-.264a.313.313 0 0 0-.273-.357l-.718-.106-.727-.113c-.185-.02-.353.092-.38.263-.03.17.096.334.28.36l.72.113\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M187.345 229.713l-.253-.542-.69.06.33.606.613-.123\" fill=\"#ad1519\"></path><path d=\"M187.345 229.713l-.253-.542-.69.06.33.606.613-.123\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.585 231.59c-2.49-.004-4.744-.222-6.457-.666 1.713-.44 3.967-.712 6.457-.72 2.493.003 4.758.277 6.475.72-1.717.444-3.982.662-6.475.665\" fill=\"#ad1519\"></path><path d=\"M179.585 231.59c-2.49-.004-4.744-.222-6.457-.666 1.713-.44 3.967-.712 6.457-.72 2.493.003 4.758.277 6.475.72-1.717.444-3.982.662-6.475.665z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\" stroke-linejoin=\"round\"></path><path d=\"M187.446 226.186c.064-.192.004-.383-.135-.43-.137-.04-.306.085-.37.27-.067.196-.01.39.133.433.138.04.303-.08.373-.274\" fill=\"#c8b100\"></path><path d=\"M187.446 226.186c.064-.192.004-.383-.135-.43-.137-.04-.306.085-.37.27-.067.196-.01.39.133.433.138.04.303-.08.373-.274z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M182.485 225.227c.023-.2-.073-.38-.22-.398-.145-.018-.284.135-.306.334-.028.2.07.378.214.397.146.015.285-.138.31-.333\" fill=\"#c8b100\"></path><path d=\"M182.485 225.227c.023-.2-.073-.38-.22-.398-.145-.018-.284.135-.306.334-.028.2.07.378.214.397.146.015.285-.138.31-.333z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M176.72 225.227c-.02-.2.075-.38.22-.398.147-.018.285.135.312.334.023.2-.073.378-.22.397-.142.015-.284-.138-.31-.333\" fill=\"#c8b100\"></path><path d=\"M176.72 225.227c-.02-.2.075-.38.22-.398.147-.018.285.135.312.334.023.2-.073.378-.22.397-.142.015-.284-.138-.31-.333z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M171.76 226.186c-.064-.192-.003-.383.136-.43.138-.04.306.085.372.27.065.196.007.39-.135.433-.138.04-.304-.08-.372-.274\" fill=\"#c8b100\"></path><path d=\"M171.76 226.186c-.064-.192-.003-.383.136-.43.138-.04.306.085.372.27.065.196.007.39-.135.433-.138.04-.304-.08-.372-.274z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.585 222.36l-.878.53.653 1.415.225.15.224-.15.655-1.414-.88-.53\" fill=\"#c8b100\"></path><path d=\"M179.585 222.36l-.878.53.653 1.415.225.15.224-.15.655-1.414-.88-.53\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M177.662 224.5l.4.58 1.374-.422.142-.19-.146-.2-1.37-.4-.4.63\" fill=\"#c8b100\"></path><path d=\"M177.662 224.5l.4.58 1.374-.422.142-.19-.146-.2-1.37-.4-.4.63\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M181.52 224.5l-.398.58-1.375-.422-.146-.19.15-.2 1.372-.4.4.63\" fill=\"#c8b100\"></path><path d=\"M181.52 224.5l-.398.58-1.375-.422-.146-.19.15-.2 1.372-.4.4.63\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M173.872 222.99l-.69.65.882 1.165.235.093.17-.178.31-1.406-.908-.324\" fill=\"#c8b100\"></path><path d=\"M173.872 222.99l-.69.65.882 1.165.235.093.17-.178.31-1.406-.908-.324\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M172.424 225.324l.52.486 1.25-.675.097-.217-.18-.165-1.432-.123-.254.694\" fill=\"#c8b100\"></path><path d=\"M172.424 225.324l.52.486 1.25-.675.097-.217-.18-.165-1.432-.123-.254.694\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M176.204 224.564l-.265.643-1.438-.13-.184-.165.1-.22 1.256-.662.53.534\" fill=\"#c8b100\"></path><path d=\"M176.204 224.564l-.265.643-1.438-.13-.184-.165.1-.22 1.256-.662.53.534\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M171.043 225.505l-.116.68-1.43.15-.216-.124.047-.23 1.08-.896.636.42\" fill=\"#c8b100\"></path><path d=\"M171.043 225.505l-.116.68-1.43.15-.216-.124.047-.23 1.08-.896.636.42\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M173.808 224.92c0-.265.226-.48.503-.48s.503.215.503.48a.492.492 0 0 1-.502.477.492.492 0 0 1-.502-.476\" fill=\"#c8b100\"></path><path d=\"M173.808 224.92c0-.265.226-.48.503-.48s.503.215.503.48a.492.492 0 0 1-.502.477.492.492 0 0 1-.502-.476z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M185.327 222.99l.69.65-.884 1.165-.237.093-.168-.178-.31-1.406.91-.324\" fill=\"#c8b100\"></path><path d=\"M185.327 222.99l.69.65-.884 1.165-.237.093-.168-.178-.31-1.406.91-.324\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M186.77 225.324l-.518.486-1.253-.675-.1-.217.188-.165 1.433-.123.25.694\" fill=\"#c8b100\"></path><path d=\"M186.77 225.324l-.518.486-1.253-.675-.1-.217.188-.165 1.433-.123.25.694\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M182.995 224.564l.265.643 1.428-.13.19-.165-.105-.22-1.25-.662-.528.534\" fill=\"#c8b100\"></path><path d=\"M182.995 224.564l.265.643 1.428-.13.19-.165-.105-.22-1.25-.662-.528.534\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M187.955 225.505l.12.68 1.433.15.214-.124-.05-.23-1.078-.896-.64.42\" fill=\"#c8b100\"></path><path d=\"M187.955 225.505l.12.68 1.433.15.214-.124-.05-.23-1.078-.896-.64.42\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M179.09 224.47c0-.27.228-.48.503-.48.28 0 .504.21.504.48a.49.49 0 0 1-.504.476c-.275 0-.502-.215-.502-.476\" fill=\"#c8b100\"></path><path d=\"M179.09 224.47c0-.27.228-.48.503-.48.28 0 .504.21.504.48a.49.49 0 0 1-.504.476c-.275 0-.502-.215-.502-.476z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M184.393 224.92c0-.265.226-.48.503-.48a.49.49 0 0 1 .503.48.49.49 0 0 1-.504.477.492.492 0 0 1-.503-.476\" fill=\"#c8b100\"></path><path d=\"M184.393 224.92c0-.265.226-.48.503-.48a.49.49 0 0 1 .503.48.49.49 0 0 1-.504.477.492.492 0 0 1-.503-.476z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M169.108 226.302c-.016.01-.387-.495-.672-.75-.204-.177-.69-.33-.69-.33 0-.09.283-.294.594-.294.184 0 .357.075.456.204l.042-.197s.25.047.366.328c.116.29.042.73.042.73s-.046.203-.138.31\" fill=\"#c8b100\"></path><path d=\"M169.108 226.302c-.016.01-.387-.495-.672-.75-.204-.177-.69-.33-.69-.33 0-.09.283-.294.594-.294.184 0 .357.075.456.204l.042-.197s.25.047.366.328c.116.29.042.73.042.73s-.046.203-.138.31z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M169.127 226.05c.12-.123.365-.097.545.06.184.156.24.384.12.512-.12.127-.366.1-.546-.058-.184-.157-.238-.39-.12-.513\" fill=\"#c8b100\"></path><path d=\"M169.127 226.05c.12-.123.365-.097.545.06.184.156.24.384.12.512-.12.127-.366.1-.546-.058-.184-.157-.238-.39-.12-.513z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M189.895 226.302c.01.01.388-.495.673-.75.194-.177.69-.33.69-.33 0-.09-.288-.294-.6-.294a.59.59 0 0 0-.456.204l-.042-.197s-.25.047-.364.328c-.112.29-.04.73-.04.73s.044.203.14.31\" fill=\"#c8b100\"></path><path d=\"M189.895 226.302c.01.01.388-.495.673-.75.194-.177.69-.33.69-.33 0-.09-.288-.294-.6-.294a.59.59 0 0 0-.456.204l-.042-.197s-.25.047-.364.328c-.112.29-.04.73-.04.73s.044.203.14.31z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M189.906 226.05c-.118-.123-.364-.097-.548.06-.185.156-.238.384-.12.512.12.127.365.1.55-.058.184-.157.234-.39.118-.513\" fill=\"#c8b100\"></path><path d=\"M189.906 226.05c-.118-.123-.364-.097-.548.06-.185.156-.238.384-.12.512.12.127.365.1.55-.058.184-.157.234-.39.118-.513z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M168.236 237.946h22.822v-5.982h-22.822v5.982z\" fill=\"#c8b100\"></path><path d=\"M168.236 237.946h22.822v-5.982h-22.822v5.982z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M170.63 241.926c.144-.057.248-.064.424-.064h17.09c.17 0 .33.028.465.083-.585-.196-1.007-.726-1.007-1.353 0-.625.457-1.166 1.048-1.37a1.798 1.798 0 0 1-.494.084h-17.102a1.51 1.51 0 0 1-.48-.056l.093.015c.61.19.96.73.96 1.327 0 .574-.388 1.15-.996 1.334\" fill=\"#c8b100\"></path><path d=\"M170.63 241.926c.144-.057.248-.064.424-.064h17.09c.17 0 .33.028.465.083-.585-.196-1.007-.726-1.007-1.353 0-.625.457-1.166 1.048-1.37a1.798 1.798 0 0 1-.494.084h-17.102a1.51 1.51 0 0 1-.48-.056l.093.015c.61.19.96.73.96 1.327 0 .574-.388 1.15-.996 1.334z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M171.054 241.862h17.09c.58 0 1.048.36 1.048.8 0 .443-.47.803-1.047.803h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.798 1.05-.798\" fill=\"#c8b100\"></path><path d=\"M171.054 241.862h17.09c.58 0 1.048.36 1.048.8 0 .443-.47.803-1.047.803h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.798 1.05-.798z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M171.054 237.946h17.102c.576 0 1.05.305 1.05.676 0 .378-.474.684-1.05.684h-17.102c-.58 0-1.048-.306-1.048-.684 0-.37.47-.676 1.048-.676\" fill=\"#c8b100\"></path><path d=\"M171.054 237.946h17.102c.576 0 1.05.305 1.05.676 0 .378-.474.684-1.05.684h-17.102c-.58 0-1.048-.306-1.048-.684 0-.37.47-.676 1.048-.676z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M195.577 338.612c-1.577 0-2.983-.33-4.02-.883-1.03-.525-2.422-.845-3.958-.845-1.544 0-2.973.324-4.002.85-1.033.543-2.46.877-4.02.877-1.578 0-2.983-.367-4.02-.92-1.02-.502-2.388-.807-3.885-.807-1.547 0-2.922.295-3.95.83-1.038.55-2.474.897-4.048.897v2.472c1.574 0 3.01-.36 4.047-.905 1.03-.53 2.404-.833 3.95-.833 1.494 0 2.862.31 3.886.815 1.033.548 2.442.922 4.02.922 1.56 0 2.987-.34 4.02-.878 1.03-.535 2.458-.86 4-.86 1.537 0 2.93.325 3.96.852 1.036.552 2.42.886 4 .886l.02-2.472\" fill=\"#005bbf\"></path><path d=\"M195.577 338.612c-1.577 0-2.983-.33-4.02-.883-1.03-.525-2.422-.845-3.958-.845-1.544 0-2.973.324-4.002.85-1.033.543-2.46.877-4.02.877-1.578 0-2.983-.367-4.02-.92-1.02-.502-2.388-.807-3.885-.807-1.547 0-2.922.295-3.95.83-1.038.55-2.474.897-4.048.897v2.472c1.574 0 3.01-.36 4.047-.905 1.03-.53 2.404-.833 3.95-.833 1.494 0 2.862.31 3.886.815 1.033.548 2.442.922 4.02.922 1.56 0 2.987-.34 4.02-.878 1.03-.535 2.458-.86 4-.86 1.537 0 2.93.325 3.96.852 1.036.552 2.42.886 4 .886l.02-2.472z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M195.577 341.084c-1.577 0-2.983-.334-4.02-.886-1.03-.527-2.422-.85-3.958-.85-1.544 0-2.973.323-4.002.858-1.033.537-2.46.878-4.02.878-1.578 0-2.983-.374-4.02-.922-1.02-.506-2.388-.815-3.885-.815-1.547 0-2.922.302-3.95.832-1.038.545-2.474.904-4.048.904v2.466c1.574 0 3.01-.352 4.047-.898 1.03-.54 2.404-.837 3.95-.837 1.494 0 2.862.31 3.886.815 1.033.55 2.442.92 4.02.92 1.56 0 2.987-.34 4.02-.88 1.03-.53 2.458-.855 4-.855 1.537 0 2.93.325 3.96.85 1.036.55 2.42.885 4 .885l.02-2.466\" fill=\"#ccc\"></path><path d=\"M195.577 341.084c-1.577 0-2.983-.334-4.02-.886-1.03-.527-2.422-.85-3.958-.85-1.544 0-2.973.323-4.002.858-1.033.537-2.46.878-4.02.878-1.578 0-2.983-.374-4.02-.922-1.02-.506-2.388-.815-3.885-.815-1.547 0-2.922.302-3.95.832-1.038.545-2.474.904-4.048.904v2.466c1.574 0 3.01-.352 4.047-.898 1.03-.54 2.404-.837 3.95-.837 1.494 0 2.862.31 3.886.815 1.033.55 2.442.92 4.02.92 1.56 0 2.987-.34 4.02-.88 1.03-.53 2.458-.855 4-.855 1.537 0 2.93.325 3.96.85 1.036.55 2.42.885 4 .885l.02-2.466\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M195.577 343.55c-1.577 0-2.983-.334-4.02-.884-1.03-.526-2.422-.85-3.958-.85-1.544 0-2.973.324-4.002.854-1.033.54-2.46.88-4.02.88-1.578 0-2.983-.37-4.02-.92-1.02-.505-2.388-.815-3.885-.815-1.547 0-2.922.298-3.95.837-1.038.546-2.474.898-4.048.898v2.465c1.574 0 3.01-.353 4.047-.9 1.03-.532 2.404-.83 3.95-.83 1.494 0 2.862.31 3.886.81 1.033.553 2.442.92 4.02.92 1.56 0 2.987-.337 4.02-.875 1.03-.53 2.458-.855 4-.855 1.537 0 2.93.32 3.96.848 1.036.555 2.42.882 4 .882l.02-2.465\" fill=\"#005bbf\"></path><path d=\"M195.577 343.55c-1.577 0-2.983-.334-4.02-.884-1.03-.526-2.422-.85-3.958-.85-1.544 0-2.973.324-4.002.854-1.033.54-2.46.88-4.02.88-1.578 0-2.983-.37-4.02-.92-1.02-.505-2.388-.815-3.885-.815-1.547 0-2.922.298-3.95.837-1.038.546-2.474.898-4.048.898v2.465c1.574 0 3.01-.353 4.047-.9 1.03-.532 2.404-.83 3.95-.83 1.494 0 2.862.31 3.886.81 1.033.553 2.442.92 4.02.92 1.56 0 2.987-.337 4.02-.875 1.03-.53 2.458-.855 4-.855 1.537 0 2.93.32 3.96.848 1.036.555 2.42.882 4 .882l.02-2.465\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M195.56 348.485c-1.583 0-2.966-.334-4.003-.887-1.03-.523-2.422-.845-3.958-.845-1.544 0-2.973.322-4.002.852-1.033.54-2.46.88-4.02.88-1.578 0-2.983-.372-4.02-.924-1.02-.5-2.388-.807-3.885-.807-1.547 0-2.922.3-3.95.83-1.038.55-2.474.902-4.048.902v-2.454c1.574 0 3.01-.368 4.047-.916 1.03-.53 2.404-.83 3.95-.83 1.494 0 2.862.31 3.886.81 1.033.554 2.442.92 4.02.92 1.56 0 2.987-.336 4.02-.874 1.03-.53 2.458-.855 4-.855 1.537 0 2.93.32 3.96.848 1.036.555 2.442.882 4.02.882l-.02 2.47\" fill=\"#ccc\"></path><path d=\"M195.56 348.485c-1.583 0-2.966-.334-4.003-.887-1.03-.523-2.422-.845-3.958-.845-1.544 0-2.973.322-4.002.852-1.033.54-2.46.88-4.02.88-1.578 0-2.983-.372-4.02-.924-1.02-.5-2.388-.807-3.885-.807-1.547 0-2.922.3-3.95.83-1.038.55-2.474.902-4.048.902v-2.454c1.574 0 3.01-.368 4.047-.916 1.03-.53 2.404-.83 3.95-.83 1.494 0 2.862.31 3.886.81 1.033.554 2.442.92 4.02.92 1.56 0 2.987-.336 4.02-.874 1.03-.53 2.458-.855 4-.855 1.537 0 2.93.32 3.96.848 1.036.555 2.442.882 4.02.882l-.02 2.47\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M195.56 350.953c-1.583 0-2.966-.334-4.003-.882-1.03-.53-2.422-.854-3.958-.854-1.544 0-2.973.326-4.002.858-1.033.537-2.46.88-4.02.88-1.578 0-2.983-.375-4.02-.924-1.02-.505-2.388-.814-3.885-.814-1.547 0-2.922.302-3.95.835-1.038.547-2.474.903-4.048.903v-2.447c1.574 0 3.01-.374 4.047-.924 1.03-.53 2.404-.825 3.95-.825 1.494 0 2.862.305 3.886.808 1.033.548 2.442.92 4.02.92 1.56 0 2.987-.34 4.02-.88 1.03-.53 2.458-.848 4-.848 1.537 0 2.93.318 3.96.844 1.036.55 2.434.885 4.015.885l-.014 2.468\" fill=\"#005bbf\"></path><path d=\"M195.56 350.953c-1.583 0-2.966-.334-4.003-.882-1.03-.53-2.422-.854-3.958-.854-1.544 0-2.973.326-4.002.858-1.033.537-2.46.88-4.02.88-1.578 0-2.983-.375-4.02-.924-1.02-.505-2.388-.814-3.885-.814-1.547 0-2.922.302-3.95.835-1.038.547-2.474.903-4.048.903v-2.447c1.574 0 3.01-.374 4.047-.924 1.03-.53 2.404-.825 3.95-.825 1.494 0 2.862.305 3.886.808 1.033.548 2.442.92 4.02.92 1.56 0 2.987-.34 4.02-.88 1.03-.53 2.458-.848 4-.848 1.537 0 2.93.318 3.96.844 1.036.55 2.434.885 4.015.885l-.014 2.468z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M170.63 328.482c.057.208.132.41.132.633 0 1.498-1.293 2.69-2.875 2.69h23.487c-1.583 0-2.877-1.192-2.877-2.69 0-.218.042-.425.097-.633a1.377 1.377 0 0 1-.45.055h-17.09c-.138 0-.3-.015-.423-.055\" fill=\"#c8b100\"></path><path d=\"M170.63 328.482c.057.208.132.41.132.633 0 1.498-1.293 2.69-2.875 2.69h23.487c-1.583 0-2.877-1.192-2.877-2.69 0-.218.042-.425.097-.633a1.377 1.377 0 0 1-.45.055h-17.09c-.138 0-.3-.015-.423-.055z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M171.054 326.93h17.09c.58 0 1.048.363 1.048.803 0 .444-.47.804-1.047.804h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.804 1.05-.804\" fill=\"#c8b100\"></path><path d=\"M171.054 326.93h17.09c.58 0 1.048.363 1.048.803 0 .444-.47.804-1.047.804h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.804 1.05-.804z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M167.918 337.78h23.425v-5.975h-23.425v5.975z\" fill=\"#c8b100\"></path><path d=\"M167.918 337.78h23.425v-5.975h-23.425v5.975z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M166.086 305.785c-2.318 1.338-3.89 2.708-3.635 3.392.128.63.864 1.098 1.916 1.796 1.655 1.153 2.66 3.212 1.873 4.16 1.37-1.104 2.238-2.756 2.238-4.592 0-1.92-.913-3.65-2.392-4.755\" fill=\"#ad1519\"></path><path d=\"M166.086 305.785c-2.318 1.338-3.89 2.708-3.635 3.392.128.63.864 1.098 1.916 1.796 1.655 1.153 2.66 3.212 1.873 4.16 1.37-1.104 2.238-2.756 2.238-4.592 0-1.92-.913-3.65-2.392-4.755z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M171.273 325.962h16.645v-81.548h-16.645v81.548z\" fill=\"#ccc\"></path><path d=\"M183.138 244.527v81.37m1.87-81.37v81.37m-13.735.065h16.645v-81.548h-16.645v81.548z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M204.92 274.917c-3.633-1.5-9.807-2.614-16.89-2.846-2.443.02-5.165.248-7.976.717-9.955 1.66-17.54 5.636-16.936 8.872.012.068.034.21.05.272 0 0-3.73-8.41-3.793-8.73-.664-3.593 7.748-8.008 18.798-9.85a57.01 57.01 0 0 1 9.787-.776c7.07 0 13.212.905 16.912 2.28l.047 10.06\" fill=\"#ad1519\"></path><path d=\"M204.92 274.917c-3.633-1.5-9.807-2.614-16.89-2.846-2.443.02-5.165.248-7.976.717-9.955 1.66-17.54 5.636-16.936 8.872.012.068.034.21.05.272 0 0-3.73-8.41-3.793-8.73-.664-3.593 7.748-8.008 18.798-9.85a57.01 57.01 0 0 1 9.787-.776c7.07 0 13.212.905 16.912 2.28l.047 10.06\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M171.247 285.153c-4.615-.33-7.767-1.563-8.13-3.494-.283-1.54 1.276-3.24 4.064-4.786 1.245.134 2.646.305 4.093.305l-.026 7.973\" fill=\"#ad1519\"></path><path d=\"M171.247 285.153c-4.615-.33-7.767-1.563-8.13-3.494-.283-1.54 1.276-3.24 4.064-4.786 1.245.134 2.646.305 4.093.305l-.026 7.973\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M187.948 278.92c2.884.437 5.05 1.153 6.128 2.034l.096.177c.514 1.057-2.02 3.3-6.25 5.805l.026-8.014\" fill=\"#ad1519\"></path><path d=\"M187.948 278.92c2.884.437 5.05 1.153 6.128 2.034l.096.177c.514 1.057-2.02 3.3-6.25 5.805l.026-8.014\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M160.906 300.884c-.438-1.317 4.064-3.953 10.425-6.286 2.908-1.04 5.307-2.125 8.282-3.437 8.836-3.905 15.363-8.39 14.56-10.024l-.088-.168c.472.382 1.2 8.436 1.2 8.436.808 1.498-5.166 5.916-13.303 9.814-2.602 1.244-8.1 3.276-10.695 4.185-4.642 1.61-9.257 4.648-8.834 5.774l-1.544-8.29\" fill=\"#ad1519\"></path><path d=\"M160.906 300.884c-.438-1.317 4.064-3.953 10.425-6.286 2.908-1.04 5.307-2.125 8.282-3.437 8.836-3.905 15.363-8.39 14.56-10.024l-.088-.168c.472.382 1.2 8.436 1.2 8.436.808 1.498-5.166 5.916-13.303 9.814-2.602 1.244-8.1 3.276-10.695 4.185-4.642 1.61-9.257 4.648-8.834 5.774l-1.544-8.29v-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M170.126 271.006c2.035-.743 3.368-1.62 2.714-3.223-.41-1.018-1.463-1.214-3.033-.64l-2.784 1.012 2.508 6.178c.273-.124.545-.252.83-.357.28-.102.576-.18.863-.262l-1.097-2.705v-.004zm-1.21-2.982l.703-.255c.582-.215 1.243.094 1.535.814.218.55.16 1.16-.51 1.588a4.69 4.69 0 0 1-.72.335l-1.01-2.483m7.716-2.583c-.292.078-.584.166-.88.223-.295.06-.6.092-.898.132l1.443 6.425 4.488-.902c-.053-.127-.123-.262-.15-.393-.03-.134-.026-.284-.034-.418-.787.225-1.648.47-2.68.677l-1.286-5.745m8.987 5.541c.847-2.33 1.872-4.564 2.88-6.825a5.394 5.394 0 0 1-1.109.072c-.535 1.64-1.204 3.28-1.906 4.913-.845-1.55-1.778-3.062-2.49-4.623-.348.045-.705.096-1.06.12-.347.023-.712.02-1.062.023 1.295 2.108 2.542 4.21 3.725 6.386.165-.03.334-.07.513-.08.166-.013.34.004.51.01m9.381-4.941c.156-.313.315-.62.49-.91-.24-.228-.982-.562-1.85-.65-1.83-.182-2.883.632-3.006 1.738-.258 2.313 3.394 2.113 3.226 3.647-.074.662-.776.93-1.52.858-.834-.084-1.44-.542-1.55-1.222l-.224-.02c-.12.402-.296.79-.486 1.18.534.346 1.23.542 1.894.607 1.866.186 3.29-.562 3.425-1.79.244-2.2-3.443-2.326-3.3-3.62.06-.545.48-.902 1.43-.807.684.07 1.107.44 1.29.97l.182.02\" fill=\"#c8b100\"></path><path d=\"M332.35 225.713s-.754.793-1.304.905c-.548.11-1.243-.493-1.243-.493s-.495.515-1.102.653c-.605.138-1.448-.684-1.448-.684s-.578.822-1.097 1.015c-.522.19-1.156-.247-1.156-.247s-.23.407-.665.632c-.184.087-.49-.058-.49-.058l-.613-.382-.695-.742-.636-.248s-.287-.93-.318-1.093c-.022-.164-.085-.58-.085-.58-.13-.663.895-1.435 2.358-1.766.84-.196 1.573-.18 2.112-.015.584-.496 1.82-.842 3.275-.842 1.317 0 2.473.28 3.11.712.63-.433 1.786-.712 3.107-.712 1.445 0 2.68.346 3.266.843.54-.165 1.27-.177 2.116.016 1.458.33 2.487 1.103 2.356 1.767 0 0-.06.415-.087.58-.03.162-.318 1.092-.318 1.092l-.637.248-.696.742-.603.382s-.307.145-.49.058c-.436-.222-.67-.632-.67-.632s-.637.438-1.156.246c-.52-.194-1.1-1.016-1.1-1.016s-.838.822-1.45.684c-.605-.138-1.098-.653-1.098-.653s-.695.603-1.242.493c-.553-.112-1.297-.905-1.297-.905\" fill=\"#ad1519\"></path><path d=\"M332.35 225.713s-.754.793-1.304.905c-.548.11-1.243-.493-1.243-.493s-.495.515-1.102.653c-.605.138-1.448-.684-1.448-.684s-.578.822-1.097 1.015c-.522.19-1.156-.247-1.156-.247s-.23.407-.665.632c-.184.087-.49-.058-.49-.058l-.613-.382-.695-.742-.636-.248s-.287-.93-.318-1.093c-.022-.164-.085-.58-.085-.58-.13-.663.895-1.435 2.358-1.766.84-.196 1.573-.18 2.112-.015.584-.496 1.82-.842 3.275-.842 1.317 0 2.473.28 3.11.712.63-.433 1.786-.712 3.107-.712 1.445 0 2.68.346 3.266.843.54-.165 1.27-.177 2.116.016 1.458.33 2.487 1.103 2.356 1.767 0 0-.06.415-.087.58-.03.162-.318 1.092-.318 1.092l-.637.248-.696.742-.603.382s-.307.145-.49.058c-.436-.222-.67-.632-.67-.632s-.637.438-1.156.246c-.52-.194-1.1-1.016-1.1-1.016s-.838.822-1.45.684c-.605-.138-1.098-.653-1.098-.653s-.695.603-1.242.493c-.553-.112-1.297-.905-1.297-.905h-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".276\"></path><path d=\"M330.916 221.386c0-1.11.63-2.007 1.41-2.007.778 0 1.412.897 1.412 2.006 0 1.113-.634 2.014-1.413 2.014-.778 0-1.41-.9-1.41-2.014\" fill=\"#c8b100\"></path><path d=\"M330.916 221.386c0-1.11.63-2.007 1.41-2.007.778 0 1.412.897 1.412 2.006 0 1.113-.634 2.014-1.413 2.014-.778 0-1.41-.9-1.41-2.014z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M331.704 221.386c0-1.018.29-1.847.65-1.847.358 0 .647.828.647 1.846 0 1.022-.288 1.85-.647 1.85-.358 0-.65-.828-.65-1.85\" fill=\"#c8b100\"></path><path d=\"M331.704 221.386c0-1.018.29-1.847.65-1.847.358 0 .647.828.647 1.846 0 1.022-.288 1.85-.647 1.85-.358 0-.65-.828-.65-1.85z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M325.08 229.633a4.838 4.838 0 0 0-.597-1.11c1.995-.585 4.77-.952 7.857-.96 3.088.008 5.882.375 7.876.96l-.534.94c-.172.3-.4.827-.384.827-1.802-.552-4.12-.835-6.97-.838-2.852.003-5.594.352-7.022.875.02 0-.1-.33-.242-.694h.015\" fill=\"#c8b100\"></path><path d=\"M325.08 229.633a4.838 4.838 0 0 0-.597-1.11c1.995-.585 4.77-.952 7.857-.96 3.088.008 5.882.375 7.876.96l-.534.94c-.172.3-.4.827-.384.827-1.802-.552-4.12-.835-6.97-.838-2.852.003-5.594.352-7.022.875.02 0-.1-.33-.242-.694h.015\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M332.34 232.167c2.492-.004 5.234-.382 6.248-.643.675-.197 1.07-.502.997-.855-.034-.168-.18-.313-.377-.397-1.485-.476-4.164-.814-6.868-.818-2.698.004-5.39.342-6.88.818-.19.084-.342.23-.374.396-.075.352.32.657 1 .854 1.01.26 3.765.64 6.254.643\" fill=\"#c8b100\"></path><path d=\"M332.34 232.167c2.492-.004 5.234-.382 6.248-.643.675-.197 1.07-.502.997-.855-.034-.168-.18-.313-.377-.397-1.485-.476-4.164-.814-6.868-.818-2.698.004-5.39.342-6.88.818-.19.084-.342.23-.374.396-.075.352.32.657 1 .854 1.01.26 3.765.64 6.254.643z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M338.38 222.285a.45.45 0 0 1 .46-.44c.258 0 .466.195.466.44 0 .244-.208.436-.466.436a.448.448 0 0 1-.46-.435\" fill=\"#fff\"></path><path d=\"M338.38 222.285a.45.45 0 0 1 .46-.44c.258 0 .466.195.466.44 0 .244-.208.436-.466.436a.448.448 0 0 1-.46-.435zm-.26-1.535a.45.45 0 0 1 .46-.44c.256 0 .465.196.465.44 0 .24-.21.437-.464.437a.45.45 0 0 1-.46-.437zm-1.16-.96a.45.45 0 0 1 .465-.44c.252 0 .46.197.46.44 0 .244-.208.44-.46.44a.45.45 0 0 1-.465-.44zm-1.45-.463c0-.246.21-.443.466-.443a.45.45 0 0 1 .462.443.45.45 0 0 1-.462.438c-.256 0-.465-.2-.465-.438zm-1.473.052a.45.45 0 0 1 .46-.44c.26 0 .467.195.467.44 0 .242-.208.435-.466.435a.448.448 0 0 1-.46-.436z\" fill=\"none\" stroke=\"#000\" stroke-width=\".215\"></path><path d=\"M342.957 225.266a2.92 2.92 0 0 0 .225-1.102c0-1.628-1.292-2.952-2.893-2.952a2.82 2.82 0 0 0-1.41.378\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\" stroke-linecap=\"round\"></path><path d=\"M337.805 223.193c.15-.265.257-.59.257-.894 0-1.175-1.214-2.128-2.707-2.128-.638 0-1.22.174-1.68.46\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M343.357 223.928c0-.24.21-.44.465-.44.256 0 .463.2.463.44 0 .244-.207.437-.463.437-.254 0-.465-.193-.465-.437zm-.175-1.615c0-.244.21-.436.465-.436.254 0 .462.192.462.436 0 .24-.21.437-.463.437-.256 0-.465-.196-.465-.437zm-1.04-1.235a.45.45 0 0 1 .462-.437c.257 0 .464.197.464.438 0 .242-.207.44-.464.44a.45.45 0 0 1-.46-.44zm-1.39-.66c0-.24.21-.435.465-.435.254 0 .46.196.46.435a.454.454 0 0 1-.46.444.455.455 0 0 1-.464-.444zm-1.477.06c0-.244.208-.44.464-.44s.465.196.465.44c0 .24-.21.436-.466.436-.257 0-.465-.197-.465-.437z\" fill=\"none\" stroke=\"#000\" stroke-width=\".215\"></path><path d=\"M340.337 227.41l-.605-.547s-.58.355-1.305.246c-.722-.11-.953-.985-.953-.985s-.813.68-1.475.63c-.664-.06-1.098-.63-1.098-.63s-.727.515-1.363.465c-.638-.06-1.246-.85-1.246-.85s-.637.82-1.274.878c-.637.052-1.157-.553-1.157-.553s-.29.605-1.1.74c-.81.137-1.506-.63-1.506-.63s-.456.74-1.01.934c-.548.19-1.27-.278-1.27-.278s-.116.277-.204.44c-.088.165-.32.194-.32.194l.182.49c1.983-.574 4.673-.93 7.714-.933 3.043.003 5.807.36 7.788.938l.204-.55\" fill=\"#c8b100\"></path><path d=\"M340.337 227.41l-.605-.547s-.58.355-1.305.246c-.722-.11-.953-.985-.953-.985s-.813.68-1.475.63c-.664-.06-1.098-.63-1.098-.63s-.727.515-1.363.465c-.638-.06-1.246-.85-1.246-.85s-.637.82-1.274.878c-.637.052-1.157-.553-1.157-.553s-.29.605-1.1.74c-.81.137-1.506-.63-1.506-.63s-.456.74-1.01.934c-.548.19-1.27-.278-1.27-.278s-.116.277-.204.44c-.088.165-.32.194-.32.194l.182.49c1.983-.574 4.673-.93 7.714-.933 3.043.003 5.807.36 7.788.938l.204-.55h-.005z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M325.315 222.285a.45.45 0 0 1 .464-.44.45.45 0 0 1 .46.44.448.448 0 0 1-.46.436c-.26 0-.465-.19-.465-.435\" fill=\"#fff\"></path><path d=\"M325.315 222.285a.45.45 0 0 1 .464-.44.45.45 0 0 1 .46.44.448.448 0 0 1-.46.436c-.26 0-.465-.19-.465-.435zm.261-1.535a.45.45 0 0 1 .464-.44.45.45 0 0 1 .46.44.45.45 0 0 1-.46.437c-.257 0-.464-.198-.464-.437zm1.155-.96c0-.243.21-.44.466-.44.257 0 .465.197.465.44 0 .244-.207.44-.464.44a.452.452 0 0 1-.465-.44zm1.45-.463c0-.246.207-.443.463-.443.258 0 .465.197.465.443 0 .238-.207.438-.465.438-.256 0-.464-.2-.464-.438zm1.477.052a.45.45 0 0 1 .46-.44.45.45 0 0 1 .465.44c0 .242-.207.435-.465.435a.448.448 0 0 1-.46-.436z\" fill=\"none\" stroke=\"#000\" stroke-width=\".215\"></path><path d=\"M321.66 225.266a2.98 2.98 0 0 1-.223-1.102c0-1.628 1.293-2.952 2.893-2.952.512 0 .99.138 1.41.378\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\" stroke-linecap=\"round\"></path><path d=\"M326.85 223.157c-.15-.262-.293-.553-.293-.858 0-1.175 1.214-2.128 2.707-2.128.634 0 1.222.174 1.683.46\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M320.335 223.928c0-.24.206-.44.465-.44.25 0 .46.2.46.44a.45.45 0 0 1-.46.437c-.26 0-.465-.193-.465-.437zm.172-1.615c0-.244.21-.436.465-.436.258 0 .465.192.465.436 0 .24-.207.437-.465.437-.254 0-.465-.196-.465-.437zm1.045-1.235c0-.24.206-.437.465-.437a.45.45 0 0 1 .46.438.45.45 0 0 1-.46.44.452.452 0 0 1-.465-.44zm1.39-.66a.45.45 0 0 1 .46-.435c.258 0 .464.196.464.435a.454.454 0 0 1-.465.444c-.252 0-.46-.2-.46-.444zm1.474.06c0-.244.207-.44.465-.44a.45.45 0 0 1 .46.44c0 .24-.202.436-.46.436-.257 0-.464-.197-.464-.437z\" fill=\"none\" stroke=\"#000\" stroke-width=\".215\"></path><path d=\"M332.356 224.76l.288.052c-.045.12-.055.246-.055.38 0 .597.51 1.08 1.14 1.08.508 0 .938-.312 1.084-.744.018.01.11-.393.156-.386.043 0 .036.42.046.41.076.542.572.914 1.133.914.63 0 1.138-.483 1.138-1.08a.737.737 0 0 0-.01-.13l.36-.358.192.455a.955.955 0 0 0-.108.47c0 .57.49 1.032 1.088 1.032a1.1 1.1 0 0 0 .906-.462l.23-.29-.004.36c0 .355.155.676.502.734 0 0 .404.03.934-.393.534-.418.826-.767.826-.767l.03.43s-.522.857-.994 1.13c-.26.152-.658.313-.97.257-.336-.05-.57-.32-.693-.624a1.59 1.59 0 0 1-.817.22c-.645 0-1.224-.355-1.45-.882a1.6 1.6 0 0 1-1.196.512 1.67 1.67 0 0 1-1.283-.59c-.29.27-.685.435-1.12.435a1.667 1.667 0 0 1-1.366-.703c-.29.418-.79.703-1.364.703-.434 0-.828-.164-1.12-.434a1.66 1.66 0 0 1-1.282.59c-.483 0-.895-.192-1.19-.512-.228.524-.81.883-1.452.883-.3 0-.577-.08-.814-.22-.123.305-.36.574-.69.624-.316.056-.712-.105-.972-.258-.477-.272-1.04-1.13-1.04-1.13l.072-.43s.29.35.823.768c.532.422.935.393.935.393.35-.058.498-.38.498-.734v-.36l.23.29c.194.277.527.462.904.462.604 0 1.09-.462 1.09-1.032a.955.955 0 0 0-.107-.47l.192-.455.357.358c-.007.043-.007.086-.007.13 0 .597.507 1.08 1.13 1.08.566 0 1.062-.372 1.135-.913.015.007.01-.41.05-.41.05-.008.14.396.157.385.148.432.578.745 1.085.745.63 0 1.14-.484 1.14-1.08 0-.135-.006-.26-.052-.38l.296-.053\" fill=\"#c8b100\"></path><path d=\"M332.356 224.76l.288.052c-.045.12-.055.246-.055.38 0 .597.51 1.08 1.14 1.08.508 0 .938-.312 1.084-.744.018.01.11-.393.156-.386.043 0 .036.42.046.41.076.542.572.914 1.133.914.63 0 1.138-.483 1.138-1.08a.737.737 0 0 0-.01-.13l.36-.358.192.455a.955.955 0 0 0-.108.47c0 .57.49 1.032 1.088 1.032a1.1 1.1 0 0 0 .906-.462l.23-.29-.004.36c0 .355.155.676.502.734 0 0 .404.03.934-.393.534-.418.826-.767.826-.767l.03.43s-.522.857-.994 1.13c-.26.152-.658.313-.97.257-.336-.05-.57-.32-.693-.624a1.59 1.59 0 0 1-.817.22c-.645 0-1.224-.355-1.45-.882a1.6 1.6 0 0 1-1.196.512 1.67 1.67 0 0 1-1.283-.59c-.29.27-.685.435-1.12.435a1.667 1.667 0 0 1-1.366-.703c-.29.418-.79.703-1.364.703-.434 0-.828-.164-1.12-.434a1.66 1.66 0 0 1-1.282.59c-.483 0-.895-.192-1.19-.512-.228.524-.81.883-1.452.883-.3 0-.577-.08-.814-.22-.123.305-.36.574-.69.624-.316.056-.712-.105-.972-.258-.477-.272-1.04-1.13-1.04-1.13l.072-.43s.29.35.823.768c.532.422.935.393.935.393.35-.058.498-.38.498-.734v-.36l.23.29c.194.277.527.462.904.462.604 0 1.09-.462 1.09-1.032a.955.955 0 0 0-.107-.47l.192-.455.357.358c-.007.043-.007.086-.007.13 0 .597.507 1.08 1.13 1.08.566 0 1.062-.372 1.135-.913.015.007.01-.41.05-.41.05-.008.14.396.157.385.148.432.578.745 1.085.745.63 0 1.14-.484 1.14-1.08 0-.135-.006-.26-.052-.38l.296-.053h.006z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M332.34 227.568c-3.087.003-5.86.37-7.852.96-.133.043-.297-.06-.34-.18-.044-.125.054-.282.182-.326 2.006-.61 4.847-.996 8.01-1 3.16.004 6.016.39 8.018 1 .133.044.23.2.188.327-.042.12-.212.22-.34.178-1.995-.59-4.778-.957-7.866-.96\" fill=\"#c8b100\"></path><path d=\"M332.34 227.568c-3.087.003-5.86.37-7.852.96-.133.043-.297-.06-.34-.18-.044-.125.054-.282.182-.326 2.006-.61 4.847-.996 8.01-1 3.16.004 6.016.39 8.018 1 .133.044.23.2.188.327-.042.12-.212.22-.34.178-1.995-.59-4.778-.957-7.866-.96z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M329.353 228.662c0-.232.2-.422.45-.422.246 0 .445.19.445.422 0 .236-.2.42-.445.42-.25 0-.45-.184-.45-.42\" fill=\"#fff\"></path><path d=\"M329.353 228.662c0-.232.2-.422.45-.422.246 0 .445.19.445.422 0 .236-.2.42-.445.42-.25 0-.45-.184-.45-.42z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M332.378 228.845h-.993c-.185 0-.34-.146-.34-.32 0-.173.15-.313.336-.313h2.01a.32.32 0 0 1 .328.312c0 .175-.15.32-.333.32h-1.007\" fill=\"#ad1519\"></path><path d=\"M332.378 228.845h-.993c-.185 0-.34-.146-.34-.32 0-.173.15-.313.336-.313h2.01a.32.32 0 0 1 .328.312c0 .175-.15.32-.333.32h-1.007\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M327.404 229.186l-.71.105a.337.337 0 0 1-.385-.264.314.314 0 0 1 .275-.357l.713-.106.73-.113c.182-.02.35.092.38.263.028.17-.1.334-.28.36l-.724.113\" fill=\"#058e6e\"></path><path d=\"M327.404 229.186l-.71.105a.337.337 0 0 1-.385-.264.314.314 0 0 1 .275-.357l.713-.106.73-.113c.182-.02.35.092.38.263.028.17-.1.334-.28.36l-.724.113\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M324.535 229.683l.315-.508.676.127-.392.572-.6-.19\" fill=\"#ad1519\"></path><path d=\"M324.535 229.683l.315-.508.676.127-.392.572-.6-.19\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M334.438 228.662c0-.232.202-.422.448-.422.247 0 .45.19.45.422 0 .236-.203.42-.45.42-.246 0-.448-.184-.448-.42\" fill=\"#fff\"></path><path d=\"M334.438 228.662c0-.232.202-.422.448-.422.247 0 .45.19.45.422 0 .236-.203.42-.45.42-.246 0-.448-.184-.448-.42z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M337.282 229.186l.715.105c.18.027.348-.09.38-.264a.312.312 0 0 0-.272-.357l-.715-.106-.73-.113c-.184-.02-.354.092-.38.263-.03.17.1.334.28.36l.722.113\" fill=\"#058e6e\"></path><path d=\"M337.282 229.186l.715.105c.18.027.348-.09.38-.264a.312.312 0 0 0-.272-.357l-.715-.106-.73-.113c-.184-.02-.354.092-.38.263-.03.17.1.334.28.36l.722.113\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M340.093 229.713l-.254-.542-.694.06.333.606.613-.123\" fill=\"#ad1519\"></path><path d=\"M340.093 229.713l-.254-.542-.694.06.333.606.613-.123\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M332.336 231.59c-2.49-.004-4.745-.222-6.46-.666 1.715-.44 3.97-.712 6.46-.72 2.493.003 4.758.277 6.47.72-1.712.444-3.977.662-6.47.665\" fill=\"#ad1519\"></path><path d=\"M332.336 231.59c-2.49-.004-4.745-.222-6.46-.666 1.715-.44 3.97-.712 6.46-.72 2.493.003 4.758.277 6.47.72-1.712.444-3.977.662-6.47.665z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\" stroke-linejoin=\"round\"></path><path d=\"M340.193 226.186c.065-.192.01-.383-.136-.43-.138-.04-.302.085-.367.27-.07.196-.01.39.13.433.138.04.307-.08.373-.274\" fill=\"#c8b100\"></path><path d=\"M340.193 226.186c.065-.192.01-.383-.136-.43-.138-.04-.302.085-.367.27-.07.196-.01.39.13.433.138.04.307-.08.373-.274z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M335.23 225.227c.028-.2-.07-.38-.217-.398-.142-.018-.285.135-.307.334-.027.2.07.378.215.397.146.015.285-.138.31-.333\" fill=\"#c8b100\"></path><path d=\"M335.23 225.227c.028-.2-.07-.38-.217-.398-.142-.018-.285.135-.307.334-.027.2.07.378.215.397.146.015.285-.138.31-.333z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M329.473 225.227c-.026-.2.068-.38.214-.398.147-.018.284.135.312.334.02.2-.074.378-.216.397-.146.015-.285-.138-.31-.333\" fill=\"#c8b100\"></path><path d=\"M329.473 225.227c-.026-.2.068-.38.214-.398.147-.018.284.135.312.334.02.2-.074.378-.216.397-.146.015-.285-.138-.31-.333z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M324.512 226.186c-.07-.192-.007-.383.13-.43.137-.04.307.085.373.27.064.196.007.39-.13.433-.143.04-.308-.08-.373-.274\" fill=\"#c8b100\"></path><path d=\"M324.512 226.186c-.07-.192-.007-.383.13-.43.137-.04.307.085.373.27.064.196.007.39-.13.433-.143.04-.308-.08-.373-.274z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M332.336 222.36l-.878.53.65 1.415.228.15.224-.15.656-1.414-.88-.53\" fill=\"#c8b100\"></path><path d=\"M332.336 222.36l-.878.53.65 1.415.228.15.224-.15.656-1.414-.88-.53\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M330.408 224.5l.402.58 1.37-.422.145-.19-.145-.2-1.37-.4-.402.63\" fill=\"#c8b100\"></path><path d=\"M330.408 224.5l.402.58 1.37-.422.145-.19-.145-.2-1.37-.4-.402.63\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M334.272 224.5l-.404.58-1.37-.422-.145-.19.145-.2 1.37-.4.404.63\" fill=\"#c8b100\"></path><path d=\"M334.272 224.5l-.404.58-1.37-.422-.145-.19.145-.2 1.37-.4.404.63\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M326.618 222.99l-.69.65.884 1.165.234.093.173-.178.31-1.406-.912-.324\" fill=\"#c8b100\"></path><path d=\"M326.618 222.99l-.69.65.884 1.165.234.093.173-.178.31-1.406-.912-.324\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M325.172 225.324l.518.486 1.252-.675.095-.217-.18-.165-1.43-.123-.254.694\" fill=\"#c8b100\"></path><path d=\"M325.172 225.324l.518.486 1.252-.675.095-.217-.18-.165-1.43-.123-.254.694\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M328.95 224.564l-.264.643-1.434-.13-.186-.165.098-.22 1.257-.662.53.534\" fill=\"#c8b100\"></path><path d=\"M328.95 224.564l-.264.643-1.434-.13-.186-.165.098-.22 1.257-.662.53.534\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M323.794 225.505l-.12.68-1.433.15-.216-.124.054-.23 1.078-.896.638.42\" fill=\"#c8b100\"></path><path d=\"M323.794 225.505l-.12.68-1.433.15-.216-.124.054-.23 1.078-.896.638.42\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M326.555 224.92c0-.265.226-.48.503-.48a.49.49 0 0 1 .502.48.49.49 0 0 1-.502.477.492.492 0 0 1-.503-.476\" fill=\"#c8b100\"></path><path d=\"M326.555 224.92c0-.265.226-.48.503-.48a.49.49 0 0 1 .502.48.49.49 0 0 1-.502.477.492.492 0 0 1-.503-.476z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M338.073 222.99l.69.65-.883 1.165-.234.093-.172-.178-.31-1.406.91-.324\" fill=\"#c8b100\"></path><path d=\"M338.073 222.99l.69.65-.883 1.165-.234.093-.172-.178-.31-1.406.91-.324\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M339.52 225.324l-.517.486-1.253-.675-.1-.217.185-.165 1.432-.123.254.694\" fill=\"#c8b100\"></path><path d=\"M339.52 225.324l-.517.486-1.253-.675-.1-.217.185-.165 1.432-.123.254.694\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M335.742 224.564l.264.643 1.434-.13.183-.165-.095-.22-1.255-.662-.53.534\" fill=\"#c8b100\"></path><path d=\"M335.742 224.564l.264.643 1.434-.13.183-.165-.095-.22-1.255-.662-.53.534\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M340.707 225.505l.115.68 1.43.15.217-.124-.055-.23-1.075-.896-.633.42\" fill=\"#c8b100\"></path><path d=\"M340.707 225.505l.115.68 1.43.15.217-.124-.055-.23-1.075-.896-.633.42\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M331.842 224.47c0-.27.22-.48.503-.48.272 0 .502.21.502.48 0 .26-.227.476-.502.476a.49.49 0 0 1-.503-.476\" fill=\"#c8b100\"></path><path d=\"M331.842 224.47c0-.27.22-.48.503-.48.272 0 .502.21.502.48 0 .26-.227.476-.502.476a.49.49 0 0 1-.503-.476z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M337.14 224.92c0-.265.226-.48.503-.48.28 0 .508.215.508.48 0 .262-.228.477-.507.477a.492.492 0 0 1-.503-.476\" fill=\"#c8b100\"></path><path d=\"M337.14 224.92c0-.265.226-.48.503-.48.28 0 .508.215.508.48 0 .262-.228.477-.507.477a.492.492 0 0 1-.503-.476z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M331.4 219.09c0-.497.422-.896.945-.896.52 0 .948.4.948.895 0 .492-.428.893-.948.893-.523 0-.945-.4-.945-.894\" fill=\"#c8b100\"></path><path d=\"M333.012 218.77v.594h-1.46v-.593h.478v-1.337h-.634v-.596h.634v-.585h.626v.585h.62v.596h-.62v1.338h.352\" fill=\"#c8b100\"></path><path d=\"M333.012 218.77v.594h-1.46v-.593h.478v-1.337h-.634v-.596h.634v-.585h.626v.585h.62v.596h-.62v1.338h.356z\" fill=\"none\" stroke=\"#000\" stroke-width=\".307\"></path><path d=\"M333.666 218.77v.594h-2.596v-.593h.96v-1.337h-.634v-.596h.634v-.585h.626v.585h.625v.596h-.624v1.338h1.01\" fill=\"#c8b100\"></path><path d=\"M332.617 218.23a.9.9 0 0 1 .676.86c0 .492-.422.893-.948.893-.523 0-.945-.4-.945-.894 0-.416.296-.762.7-.867\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M321.855 226.302c-.012.01-.388-.495-.672-.75-.2-.177-.69-.33-.69-.33 0-.09.288-.294.6-.294.18 0 .35.075.453.204l.036-.197s.254.047.365.328c.116.29.043.73.043.73s-.047.203-.135.31\" fill=\"#c8b100\"></path><path d=\"M321.855 226.302c-.012.01-.388-.495-.672-.75-.2-.177-.69-.33-.69-.33 0-.09.288-.294.6-.294.18 0 .35.075.453.204l.036-.197s.254.047.365.328c.116.29.043.73.043.73s-.047.203-.135.31z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M321.874 226.05c.12-.123.365-.097.546.06.184.156.238.384.117.512-.117.127-.36.1-.543-.058-.185-.157-.24-.39-.12-.513\" fill=\"#c8b100\"></path><path d=\"M321.874 226.05c.12-.123.365-.097.546.06.184.156.238.384.117.512-.117.127-.36.1-.543-.058-.185-.157-.24-.39-.12-.513z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M342.64 226.302c.016.01.388-.495.674-.75.196-.177.69-.33.69-.33 0-.09-.287-.294-.598-.294a.59.59 0 0 0-.457.204l-.04-.197s-.254.047-.364.328c-.115.29-.043.73-.043.73s.046.203.138.31\" fill=\"#c8b100\"></path><path d=\"M342.64 226.302c.016.01.388-.495.674-.75.196-.177.69-.33.69-.33 0-.09-.287-.294-.598-.294a.59.59 0 0 0-.457.204l-.04-.197s-.254.047-.364.328c-.115.29-.043.73-.043.73s.046.203.138.31z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M342.654 226.05c-.12-.123-.364-.097-.55.06-.184.156-.233.384-.12.512.12.127.366.1.55-.058.184-.157.24-.39.12-.513\" fill=\"#c8b100\"></path><path d=\"M342.654 226.05c-.12-.123-.364-.097-.55.06-.184.156-.233.384-.12.512.12.127.366.1.55-.058.184-.157.24-.39.12-.513z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M320.95 237.946h22.82v-5.982h-22.82v5.982z\" fill=\"#c8b100\"></path><path d=\"M320.95 237.946h22.82v-5.982h-22.82v5.982z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M341.375 241.926a1.007 1.007 0 0 0-.422-.064h-17.09c-.17 0-.33.028-.472.083.59-.196 1.01-.726 1.01-1.353 0-.625-.46-1.166-1.05-1.37.14.043.332.084.5.084h17.103c.17 0 .334-.007.48-.056l-.097.015c-.61.19-.96.73-.96 1.327 0 .574.388 1.15 1 1.334\" fill=\"#c8b100\"></path><path d=\"M341.375 241.926a1.007 1.007 0 0 0-.422-.064h-17.09c-.17 0-.33.028-.472.083.59-.196 1.01-.726 1.01-1.353 0-.625-.46-1.166-1.05-1.37.14.043.332.084.5.084h17.103c.17 0 .334-.007.48-.056l-.097.015c-.61.19-.96.73-.96 1.327 0 .574.388 1.15 1 1.334z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M323.863 241.862h17.09c.575 0 1.045.36 1.045.8 0 .443-.47.803-1.045.803h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.798 1.05-.798\" fill=\"#c8b100\"></path><path d=\"M323.863 241.862h17.09c.575 0 1.045.36 1.045.8 0 .443-.47.803-1.045.803h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.798 1.05-.798z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M323.85 237.946h17.103c.575 0 1.045.305 1.045.676 0 .378-.47.684-1.045.684H323.85c-.578 0-1.047-.306-1.047-.684 0-.37.47-.676 1.048-.676\" fill=\"#c8b100\"></path><path d=\"M323.85 237.946h17.103c.575 0 1.045.305 1.045.676 0 .378-.47.684-1.045.684H323.85c-.578 0-1.047-.306-1.047-.684 0-.37.47-.676 1.048-.676z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M316.426 338.612c1.582 0 2.985-.33 4.023-.883 1.03-.525 2.423-.845 3.958-.845 1.54 0 2.972.324 4 .85 1.03.543 2.458.877 4.017.877 1.574 0 2.987-.367 4.024-.92 1.02-.502 2.383-.807 3.884-.807 1.548 0 2.918.295 3.95.83 1.034.55 2.473.897 4.047.897v2.472c-1.573 0-3.012-.36-4.045-.905-1.033-.53-2.403-.833-3.95-.833-1.502 0-2.865.31-3.886.815-1.033.548-2.45.922-4.025.922-1.555 0-2.983-.34-4.016-.878-1.03-.535-2.458-.86-4.002-.86-1.535 0-2.93.325-3.96.852-1.037.552-2.42.886-4 .886l-.02-2.472\" fill=\"#005bbf\"></path><path d=\"M316.426 338.612c1.582 0 2.985-.33 4.023-.883 1.03-.525 2.423-.845 3.958-.845 1.54 0 2.972.324 4 .85 1.03.543 2.458.877 4.017.877 1.574 0 2.987-.367 4.024-.92 1.02-.502 2.383-.807 3.884-.807 1.548 0 2.918.295 3.95.83 1.034.55 2.473.897 4.047.897v2.472c-1.573 0-3.012-.36-4.045-.905-1.033-.53-2.403-.833-3.95-.833-1.502 0-2.865.31-3.886.815-1.033.548-2.45.922-4.025.922-1.555 0-2.983-.34-4.016-.878-1.03-.535-2.458-.86-4.002-.86-1.535 0-2.93.325-3.96.852-1.037.552-2.42.886-4 .886l-.02-2.472z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M316.426 341.084c1.582 0 2.985-.334 4.023-.886 1.03-.527 2.423-.85 3.958-.85 1.54 0 2.972.323 4 .858 1.03.537 2.458.878 4.017.878 1.574 0 2.987-.374 4.024-.922 1.02-.506 2.383-.815 3.884-.815 1.548 0 2.918.302 3.95.832 1.034.545 2.473.904 4.047.904v2.466c-1.573 0-3.012-.352-4.045-.898-1.033-.54-2.403-.837-3.95-.837-1.502 0-2.865.31-3.886.815-1.033.55-2.45.92-4.025.92-1.555 0-2.983-.34-4.016-.88-1.03-.53-2.458-.855-4.002-.855-1.535 0-2.93.325-3.96.85-1.037.55-2.42.885-4 .885l-.02-2.466\" fill=\"#ccc\"></path><path d=\"M316.426 341.084c1.582 0 2.985-.334 4.023-.886 1.03-.527 2.423-.85 3.958-.85 1.54 0 2.972.323 4 .858 1.03.537 2.458.878 4.017.878 1.574 0 2.987-.374 4.024-.922 1.02-.506 2.383-.815 3.884-.815 1.548 0 2.918.302 3.95.832 1.034.545 2.473.904 4.047.904v2.466c-1.573 0-3.012-.352-4.045-.898-1.033-.54-2.403-.837-3.95-.837-1.502 0-2.865.31-3.886.815-1.033.55-2.45.92-4.025.92-1.555 0-2.983-.34-4.016-.88-1.03-.53-2.458-.855-4.002-.855-1.535 0-2.93.325-3.96.85-1.037.55-2.42.885-4 .885l-.02-2.466\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M316.426 343.55c1.582 0 2.985-.334 4.023-.884 1.03-.526 2.423-.85 3.958-.85 1.54 0 2.972.324 4 .854 1.03.54 2.458.88 4.017.88 1.574 0 2.987-.37 4.024-.92 1.02-.505 2.383-.815 3.884-.815 1.548 0 2.918.298 3.95.837 1.034.546 2.473.898 4.047.898v2.465c-1.573 0-3.012-.353-4.045-.9-1.033-.532-2.403-.83-3.95-.83-1.502 0-2.865.31-3.886.81-1.033.553-2.45.92-4.025.92-1.555 0-2.983-.337-4.016-.875-1.03-.53-2.458-.855-4.002-.855-1.535 0-2.93.32-3.96.848-1.037.555-2.42.882-4 .882l-.02-2.465\" fill=\"#005bbf\"></path><path d=\"M316.426 343.55c1.582 0 2.985-.334 4.023-.884 1.03-.526 2.423-.85 3.958-.85 1.54 0 2.972.324 4 .854 1.03.54 2.458.88 4.017.88 1.574 0 2.987-.37 4.024-.92 1.02-.505 2.383-.815 3.884-.815 1.548 0 2.918.298 3.95.837 1.034.546 2.473.898 4.047.898v2.465c-1.573 0-3.012-.353-4.045-.9-1.033-.532-2.403-.83-3.95-.83-1.502 0-2.865.31-3.886.81-1.033.553-2.45.92-4.025.92-1.555 0-2.983-.337-4.016-.875-1.03-.53-2.458-.855-4.002-.855-1.535 0-2.93.32-3.96.848-1.037.555-2.42.882-4 .882l-.02-2.465\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M316.45 348.485c1.577 0 2.96-.334 4-.887 1.03-.523 2.423-.845 3.958-.845 1.54 0 2.972.322 4 .852 1.03.54 2.458.88 4.017.88 1.574 0 2.987-.372 4.024-.924 1.02-.5 2.383-.807 3.884-.807 1.548 0 2.918.3 3.95.83 1.034.55 2.473.902 4.047.902v-2.454c-1.573 0-3.012-.368-4.045-.916-1.033-.53-2.403-.83-3.95-.83-1.502 0-2.865.31-3.886.81-1.033.554-2.45.92-4.025.92-1.555 0-2.983-.336-4.016-.874-1.03-.53-2.458-.855-4.002-.855-1.535 0-2.93.32-3.96.848-1.037.555-2.44.882-4.022.882l.023 2.47\" fill=\"#ccc\"></path><path d=\"M316.45 348.485c1.577 0 2.96-.334 4-.887 1.03-.523 2.423-.845 3.958-.845 1.54 0 2.972.322 4 .852 1.03.54 2.458.88 4.017.88 1.574 0 2.987-.372 4.024-.924 1.02-.5 2.383-.807 3.884-.807 1.548 0 2.918.3 3.95.83 1.034.55 2.473.902 4.047.902v-2.454c-1.573 0-3.012-.368-4.045-.916-1.033-.53-2.403-.83-3.95-.83-1.502 0-2.865.31-3.886.81-1.033.554-2.45.92-4.025.92-1.555 0-2.983-.336-4.016-.874-1.03-.53-2.458-.855-4.002-.855-1.535 0-2.93.32-3.96.848-1.037.555-2.44.882-4.022.882l.023 2.47\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M316.45 350.953c1.577 0 2.96-.334 4-.882 1.03-.53 2.423-.854 3.958-.854 1.54 0 2.972.326 4 .858 1.03.537 2.458.88 4.017.88 1.574 0 2.987-.375 4.024-.924 1.02-.505 2.383-.814 3.884-.814 1.548 0 2.918.302 3.95.835 1.034.547 2.473.903 4.047.903v-2.447c-1.573 0-3.012-.374-4.045-.924-1.033-.53-2.403-.825-3.95-.825-1.502 0-2.865.305-3.886.808-1.033.548-2.45.92-4.025.92-1.555 0-2.983-.34-4.016-.88-1.03-.53-2.458-.848-4.002-.848-1.535 0-2.93.318-3.96.844-1.037.55-2.436.885-4.014.885l.015 2.468\" fill=\"#005bbf\"></path><path d=\"M316.45 350.953c1.577 0 2.96-.334 4-.882 1.03-.53 2.423-.854 3.958-.854 1.54 0 2.972.326 4 .858 1.03.537 2.458.88 4.017.88 1.574 0 2.987-.375 4.024-.924 1.02-.505 2.383-.814 3.884-.814 1.548 0 2.918.302 3.95.835 1.034.547 2.473.903 4.047.903v-2.447c-1.573 0-3.012-.374-4.045-.924-1.033-.53-2.403-.825-3.95-.825-1.502 0-2.865.305-3.886.808-1.033.548-2.45.92-4.025.92-1.555 0-2.983-.34-4.016-.88-1.03-.53-2.458-.848-4.002-.848-1.535 0-2.93.318-3.96.844-1.037.55-2.436.885-4.014.885l.015 2.468z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M341.37 328.482c-.052.208-.125.41-.125.633 0 1.498 1.292 2.69 2.87 2.69h-23.482c1.578 0 2.87-1.192 2.87-2.69a2.84 2.84 0 0 0-.09-.633c.127.048.29.055.446.055h17.09c.136 0 .298-.015.417-.055\" fill=\"#c8b100\"></path><path d=\"M341.37 328.482c-.052.208-.125.41-.125.633 0 1.498 1.292 2.69 2.87 2.69h-23.482c1.578 0 2.87-1.192 2.87-2.69a2.84 2.84 0 0 0-.09-.633c.127.048.29.055.446.055h17.09c.136 0 .298-.015.417-.055h.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M323.863 326.93h17.09c.575 0 1.045.363 1.045.803 0 .444-.47.804-1.045.804h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.804 1.05-.804\" fill=\"#c8b100\"></path><path d=\"M323.863 326.93h17.09c.575 0 1.045.363 1.045.803 0 .444-.47.804-1.045.804h-17.09c-.58 0-1.05-.36-1.05-.804 0-.44.47-.804 1.05-.804z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M320.66 337.78h23.427v-5.975H320.66v5.975z\" fill=\"#c8b100\"></path><path d=\"M320.66 337.78h23.427v-5.975H320.66v5.975z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M345.917 305.785c2.32 1.338 3.894 2.708 3.64 3.392-.128.63-.864 1.098-1.916 1.796-1.654 1.153-2.664 3.212-1.876 4.16-1.367-1.104-2.23-2.756-2.23-4.592 0-1.92.91-3.65 2.383-4.755\" fill=\"#ad1519\"></path><path d=\"M345.917 305.785c2.32 1.338 3.894 2.708 3.64 3.392-.128.63-.864 1.098-1.916 1.796-1.654 1.153-2.664 3.212-1.876 4.16-1.367-1.104-2.23-2.756-2.23-4.592 0-1.92.91-3.65 2.383-4.755z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M324.086 325.962h16.644v-81.548h-16.644v81.548z\" fill=\"#ccc\"></path><path d=\"M336.16 244.385v81.373m1.87-81.373v81.373m-13.944.204h16.644v-81.548h-16.644v81.548z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M307.085 274.917c3.634-1.5 9.81-2.614 16.893-2.846 2.44.02 5.164.248 7.974.717 9.953 1.66 17.536 5.636 16.933 8.872-.012.068-.03.21-.05.272 0 0 3.735-8.41 3.79-8.73.668-3.593-7.74-8.008-18.79-9.85a57.043 57.043 0 0 0-9.788-.776c-7.072 0-13.216.905-16.916 2.28l-.045 10.06\" fill=\"#ad1519\"></path><path d=\"M307.085 274.917c3.634-1.5 9.81-2.614 16.893-2.846 2.44.02 5.164.248 7.974.717 9.953 1.66 17.536 5.636 16.933 8.872-.012.068-.03.21-.05.272 0 0 3.735-8.41 3.79-8.73.668-3.593-7.74-8.008-18.79-9.85a57.043 57.043 0 0 0-9.788-.776c-7.072 0-13.216.905-16.916 2.28l-.045 10.06\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M340.76 285.153c4.616-.33 7.768-1.563 8.125-3.494.29-1.54-1.275-3.24-4.06-4.786-1.246.134-2.648.305-4.095.305l.03 7.973\" fill=\"#ad1519\"></path><path d=\"M340.76 285.153c4.616-.33 7.768-1.563 8.125-3.494.29-1.54-1.275-3.24-4.06-4.786-1.246.134-2.648.305-4.095.305l.03 7.973\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M324.06 278.92c-2.888.437-5.05 1.153-6.133 2.034l-.096.177c-.518 1.057 2.02 3.3 6.252 5.805l-.023-8.014\" fill=\"#ad1519\"></path><path d=\"M324.06 278.92c-2.888.437-5.05 1.153-6.133 2.034l-.096.177c-.518 1.057 2.02 3.3 6.252 5.805l-.023-8.014\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M351.096 300.884c.437-1.317-4.063-3.953-10.423-6.286-2.907-1.04-5.308-2.125-8.282-3.437-8.834-3.905-15.36-8.39-14.555-10.024l.086-.168c-.465.382-1.193 8.436-1.193 8.436-.807 1.498 5.167 5.916 13.293 9.814 2.605 1.244 8.106 3.276 10.702 4.185 4.642 1.61 9.254 4.648 8.835 5.774l1.54-8.29\" fill=\"#ad1519\"></path><path d=\"M351.096 300.884c.437-1.317-4.063-3.953-10.423-6.286-2.907-1.04-5.308-2.125-8.282-3.437-8.834-3.905-15.36-8.39-14.555-10.024l.086-.168c-.465.382-1.193 8.436-1.193 8.436-.807 1.498 5.167 5.916 13.293 9.814 2.605 1.244 8.106 3.276 10.702 4.185 4.642 1.61 9.254 4.648 8.835 5.774l1.54-8.29v-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M317.458 271.344c.63-2.39 1.444-4.698 2.242-7.036a5.675 5.675 0 0 1-.545.112 5.39 5.39 0 0 1-.556.05c-.38 1.68-.896 3.368-1.45 5.055-.982-1.476-2.053-2.91-2.905-4.4-.34.07-.696.152-1.044.205-.34.05-.707.075-1.06.11a140.003 140.003 0 0 1 4.302 6.052c.165-.043.324-.098.507-.124.164-.02.336-.017.508-.024m6.33-6.989c-.304.014-.607.037-.91.032-.303-.003-.607-.04-.907-.062l-.122 6.567 4.59.078c-.022-.135-.056-.28-.052-.42 0-.134.042-.275.064-.41a31.97 31.97 0 0 1-2.77.088l.107-5.873m7.209 1.08c.734.062 1.44.19 2.147.317-.013-.14-.034-.277-.023-.42.01-.133.062-.27.1-.4l-6.217-.515c.016.14.04.273.024.407-.012.145-.06.276-.097.41.634-.014 1.398-.02 2.255.052l-.542 5.908c.303.007.606.004.906.03.3.02.602.076.9.12l.543-5.91m2.548 6.473c.3.047.6.083.898.15.295.06.583.156.87.24l.738-3.02.08.02c.172.413.397.918.51 1.21l.923 2.28c.36.058.72.105 1.074.182.364.08.713.184 1.063.282l-.32-.684c-.495-1.03-1.016-2.054-1.446-3.096 1.145.05 2.032-.365 2.254-1.284.158-.64-.096-1.143-.7-1.572-.443-.317-1.307-.484-1.864-.607l-2.506-.55-1.575 6.447m3.215-5.552c.723.16 1.625.276 1.625 1.097a2.032 2.032 0 0 1-.057.484c-.235.964-.964 1.298-2.18.935l.612-2.515m8.624 7.52c-.055.713-.182 1.404-.32 2.152.314.15.625.284.928.45.303.17.583.354.876.536l.614-7.403a3.632 3.632 0 0 1-.8-.436l-6.526 4.144c.172.084.35.16.52.25.168.096.31.196.48.292.547-.462 1.123-.837 1.784-1.328l2.442 1.34.002.002zm-1.85-1.69l2.174-1.408-.253 2.455-1.92-1.047\" fill=\"#c8b100\"></path><path d=\"M230.31 205.26c0-1.165.994-2.106 2.22-2.106 1.22 0 2.218.94 2.218 2.106 0 1.16-.994 2.1-2.22 2.1-1.224 0-2.218-.94-2.218-2.1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M255.347 187.108c6.804 0 12.858 1.007 16.802 2.57 2.256 1.02 5.287 1.772 8.603 2.216 2.527.337 4.927.406 7.015.246 2.792-.054 6.83.763 10.87 2.542 3.344 1.484 6.135 3.287 7.99 5.033l-1.606 1.43-.464 4.056-4.4 5.04-2.2 1.867-5.21 4.17-2.662.218-.81 2.303-33.707-3.95-33.81 3.95-.81-2.303-2.667-.217-5.21-4.17-2.198-1.867-4.4-5.04-.458-4.056-1.613-1.43c1.863-1.745 4.654-3.548 7.99-5.032 4.04-1.78 8.08-2.596 10.87-2.542 2.087.16 4.488.09 7.014-.246 3.32-.444 6.352-1.197 8.605-2.215 3.948-1.565 9.665-2.572 16.464-2.572z\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M255.864 231.607c-12.558-.018-23.808-1.505-31.835-3.923-.59-.178-.896-.716-.862-1.273-.01-.54.293-1.03.86-1.203 8.028-2.414 19.278-3.9 31.836-3.92 12.556.02 23.8 1.506 31.827 3.92.57.172.867.663.857 1.203.03.558-.272 1.096-.856 1.274-8.027 2.418-19.27 3.905-31.826 3.923\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.833 229.96c-11.333-.015-21.576-1.323-29.374-3.338 7.797-2.018 18.04-3.25 29.373-3.272 11.332.02 21.63 1.254 29.428 3.272-7.797 2.015-18.095 3.323-29.427 3.338\" fill=\"#ad1519\"></path><path d=\"M256.675 230.028v-6.724\" fill=\"none\" stroke=\"#000\" stroke-width=\".092\"></path><path d=\"M254.848 230.028v-6.724\" fill=\"none\" stroke=\"#000\" stroke-width=\".143\"></path><path d=\"M253.124 230.028v-6.724\" fill=\"none\" stroke=\"#000\" stroke-width=\".184\"></path><path d=\"M251.415 230.028v-6.724\" fill=\"none\" stroke=\"#000\" stroke-width=\".236\"></path><path d=\"M249.89 230.028v-6.724\" fill=\"none\" stroke=\"#000\" stroke-width=\".287\"></path><path d=\"M246.986 229.666l-.04-6.12m1.417 6.2v-6.402\" fill=\"none\" stroke=\"#000\" stroke-width=\".338\"></path><path d=\"M244.304 229.39v-5.64m1.36 5.802l-.04-6.002\" fill=\"none\" stroke=\"#000\" stroke-width=\".379\"></path><path d=\"M240.707 229.07v-4.956m1.18 5.035v-5.197m1.216 5.357v-5.398\" fill=\"none\" stroke=\"#000\" stroke-width=\".43\"></path><path d=\"M239.445 229.028v-4.793\" fill=\"none\" stroke=\"#000\" stroke-width=\".471\"></path><path d=\"M238.27 228.786v-4.47\" fill=\"none\" stroke=\"#000\" stroke-width=\".522\"></path><path d=\"M237.008 228.665v-4.15\" fill=\"none\" stroke=\"#000\" stroke-width=\".573\"></path><path d=\"M234.427 228.304l-.04-3.304m1.363 3.465v-3.706\" fill=\"none\" stroke=\"#000\" stroke-width=\".614\"></path><path d=\"M233.104 228.02v-2.9\" fill=\"none\" stroke=\"#000\" stroke-width=\".645\"></path><path d=\"M231.89 227.786v-2.416\" fill=\"none\" stroke=\"#000\" stroke-width=\".696\"></path><path d=\"M230.568 227.464v-1.892\" fill=\"none\" stroke=\"#000\" stroke-width=\".748\"></path><path d=\"M229.208 227.303v-1.41\" fill=\"none\" stroke=\"#000\" stroke-width=\".788\"></path><path d=\"M227.77 226.98v-.683\" fill=\"none\" stroke=\"#000\" stroke-width=\".932\"></path><path d=\"M263.942 229.666v-6.16m-3.094 6.362l.04-6.524m-2.296 6.604v-6.644\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M255.777 221.277c-12.71.025-24.115 1.618-32.144 4.09.666-.316.607-1.138-.224-3.275-1.002-2.586-2.565-2.473-2.565-2.473 8.877-2.622 21.233-4.263 34.985-4.28 13.758.018 26.214 1.658 35.09 4.28 0 0-1.563-.114-2.564 2.472-.83 2.137-.89 2.96-.224 3.276-8.027-2.473-19.647-4.066-32.355-4.09\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.83 215.342c-13.752.023-26.108 1.66-34.985 4.285-.592.177-1.217-.055-1.41-.615-.19-.56.128-1.204.72-1.385 8.914-2.735 21.59-4.452 35.678-4.48 14.094.025 26.817 1.745 35.732 4.48.592.18.91.824.72 1.385-.194.56-.82.792-1.41.615-8.878-2.626-21.287-4.262-35.045-4.285\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.833 229.96c-11.333-.015-21.576-1.323-29.374-3.338 7.797-2.018 18.04-3.25 29.373-3.272 11.332.02 21.63 1.254 29.428 3.272-7.797 2.015-18.095 3.323-29.427 3.338z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\" stroke-linejoin=\"round\"></path><path d=\"M246.02 218.466c0-.585.503-1.062 1.122-1.062.622 0 1.126.477 1.126 1.062 0 .585-.504 1.065-1.126 1.065-.62 0-1.12-.48-1.12-1.064\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.858 219.303h-3.365c-.62 0-1.136-.473-1.136-1.062 0-.585.504-1.064 1.123-1.064h6.8c.62 0 1.124.48 1.124 1.065 0 .59-.515 1.063-1.138 1.063h-3.408\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M238.953 220.23l-2.42.28c-.618.073-1.19-.342-1.268-.92-.075-.585.363-1.117.98-1.185l2.435-.284 2.476-.283c.614-.072 1.175.334 1.252.92.072.582-.376 1.116-.99 1.185l-2.465.288\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M229.116 220.442c0-.586.503-1.063 1.12-1.063.623 0 1.126.476 1.126 1.062 0 .588-.503 1.065-1.126 1.065-.617 0-1.12-.477-1.12-1.065\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M221.633 222.376l1.248-1.633 3.45.436-2.76 2.01-1.937-.814\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M272.767 220.23l2.42.28c.612.073 1.19-.342 1.266-.92.07-.585-.365-1.117-.98-1.185l-2.433-.284-2.476-.283c-.62-.072-1.18.334-1.253.92-.076.582.378 1.116.99 1.185l2.467.288\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M263.452 218.466c0-.585.504-1.062 1.122-1.062.622 0 1.125.477 1.125 1.062 0 .585-.504 1.065-1.126 1.065-.618 0-1.122-.48-1.122-1.064m16.906 1.975c0-.586.504-1.063 1.122-1.063.62 0 1.124.476 1.124 1.062 0 .588-.503 1.065-1.125 1.065-.62 0-1.123-.477-1.123-1.065\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M290.086 222.376l-1.247-1.633-3.45.436 2.758 2.01 1.938-.814\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M225.104 226.982c7.94-2.23 18.736-3.61 30.73-3.632 11.99.02 22.842 1.403 30.782 3.632\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M230.452 196.013l1.42 1.14 2.13-3.48c-2.31-1.416-3.896-3.874-3.896-6.674 0-.318.02-.626.06-.932.22-4.44 5.63-8.11 12.5-8.11 3.562 0 6.78.976 9.046 2.54.06-.688.123-1.276.218-1.902-2.496-1.455-5.733-2.33-9.265-2.33-7.897 0-14.075 4.485-14.375 9.8-.03.308-.046.62-.046.933 0 2.832 1.294 5.384 3.34 7.16l-1.132 1.853\" fill=\"#c8b100\"></path><path d=\"M230.452 196.013l1.42 1.14 2.13-3.48c-2.31-1.416-3.896-3.874-3.896-6.674 0-.318.02-.626.06-.932.22-4.44 5.63-8.11 12.5-8.11 3.562 0 6.78.976 9.046 2.54.06-.688.123-1.276.218-1.902-2.496-1.455-5.733-2.33-9.265-2.33-7.897 0-14.075 4.485-14.375 9.8-.03.308-.046.62-.046.933 0 2.832 1.294 5.384 3.34 7.16l-1.132 1.853\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M230.544 196.052c-2.696-2.01-4.37-4.744-4.37-7.755 0-3.47 2.27-6.563 5.717-8.614-2.126 1.708-3.416 3.916-3.6 6.382-.03.31-.046.62-.046.934 0 2.832 1.294 5.384 3.34 7.16l-1.04 1.892\" fill=\"#c8b100\"></path><path d=\"M230.544 196.052c-2.696-2.01-4.37-4.744-4.37-7.755 0-3.47 2.27-6.563 5.717-8.614-2.126 1.708-3.416 3.916-3.6 6.382-.03.31-.046.62-.046.934 0 2.832 1.294 5.384 3.34 7.16l-1.04 1.892\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M206.766 199.565c-1.51-1.69-2.434-3.876-2.434-6.265 0-1.44.333-2.818.936-4.046 2.18-4.488 9.023-7.753 17.155-7.753 2.216 0 4.336.242 6.294.688-.434.473-.775.992-1.108 1.517a27.215 27.215 0 0 0-5.187-.488c-7.444 0-13.672 2.895-15.476 6.807a7.54 7.54 0 0 0-.75 3.276c0 2.378 1.114 4.51 2.857 5.964l-2.695 4.402-1.444-1.147 1.85-2.95\" fill=\"#c8b100\"></path><path d=\"M206.766 199.565c-1.51-1.69-2.434-3.876-2.434-6.265 0-1.44.333-2.818.936-4.046 2.18-4.488 9.023-7.753 17.155-7.753 2.216 0 4.336.242 6.294.688-.434.473-.775.992-1.108 1.517a27.215 27.215 0 0 0-5.187-.488c-7.444 0-13.672 2.895-15.476 6.807a7.54 7.54 0 0 0-.75 3.276c0 2.378 1.114 4.51 2.857 5.964l-2.695 4.402-1.444-1.147 1.85-2.95v-.005z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M209.527 184.814c-1.96 1.232-3.44 2.75-4.26 4.44a9.17 9.17 0 0 0-.935 4.046c0 2.39.925 4.575 2.434 6.265l-1.636 2.656c-1.566-2.012-2.476-4.36-2.476-6.858 0-4.302 2.737-8.06 6.873-10.548\" fill=\"#c8b100\"></path><path d=\"M209.527 184.814c-1.96 1.232-3.44 2.75-4.26 4.44a9.17 9.17 0 0 0-.935 4.046c0 2.39.925 4.575 2.434 6.265l-1.636 2.656c-1.566-2.012-2.476-4.36-2.476-6.858 0-4.302 2.737-8.06 6.873-10.548z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.746 175.377c1.805 0 3.356 1.193 3.726 2.794.24 1.415.39 3.026.425 4.742.003.178-.013.352-.013.527.005.202.044.42.047.628.063 3.6.578 6.778 1.31 8.724l-5.497 5.258-5.557-5.258c.737-1.946 1.248-5.125 1.317-8.724.004-.207.044-.426.044-.63 0-.174-.012-.348-.01-.526.028-1.716.18-3.327.423-4.74.365-1.602 1.98-2.795 3.782-2.795\" fill=\"#c8b100\"></path><path d=\"M255.746 175.377c1.805 0 3.356 1.193 3.726 2.794.24 1.415.39 3.026.425 4.742.003.178-.013.352-.013.527.005.202.044.42.047.628.063 3.6.578 6.778 1.31 8.724l-5.497 5.258-5.557-5.258c.737-1.946 1.248-5.125 1.317-8.724.004-.207.044-.426.044-.63 0-.174-.012-.348-.01-.526.028-1.716.18-3.327.423-4.74.365-1.602 1.98-2.795 3.782-2.795h.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.746 177.09c.937 0 1.727.598 1.92 1.425a30.65 30.65 0 0 1 .403 4.48c0 .168-.01.335-.01.498 0 .2.035.4.04.604.057 3.4.544 6.396 1.243 8.24l-3.625 3.432-3.628-3.433c.692-1.84 1.18-4.84 1.24-8.24.005-.204.04-.404.043-.604 0-.163-.01-.33-.01-.498.03-1.614.175-3.142.404-4.48.19-.827 1.045-1.424 1.978-1.424\" fill=\"#c8b100\"></path><path d=\"M255.746 177.09c.937 0 1.727.598 1.92 1.425a30.65 30.65 0 0 1 .403 4.48c0 .168-.01.335-.01.498 0 .2.035.4.04.604.057 3.4.544 6.396 1.243 8.24l-3.625 3.432-3.628-3.433c.692-1.84 1.18-4.84 1.24-8.24.005-.204.04-.404.043-.604 0-.163-.01-.33-.01-.498.03-1.614.175-3.142.404-4.48.19-.827 1.045-1.424 1.978-1.424z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M281 196.013l-1.422 1.14-2.13-3.48c2.31-1.416 3.896-3.874 3.896-6.674 0-.318-.018-.626-.056-.932-.22-4.44-5.637-8.11-12.5-8.11-3.57 0-6.784.976-9.052 2.54a24.522 24.522 0 0 0-.22-1.902c2.497-1.455 5.733-2.33 9.273-2.33 7.894 0 14.07 4.485 14.374 9.8.027.308.042.62.042.933 0 2.832-1.292 5.384-3.34 7.16l1.133 1.853\" fill=\"#c8b100\"></path><path d=\"M281 196.013l-1.422 1.14-2.13-3.48c2.31-1.416 3.896-3.874 3.896-6.674 0-.318-.018-.626-.056-.932-.22-4.44-5.637-8.11-12.5-8.11-3.57 0-6.784.976-9.052 2.54a24.522 24.522 0 0 0-.22-1.902c2.497-1.455 5.733-2.33 9.273-2.33 7.894 0 14.07 4.485 14.374 9.8.027.308.042.62.042.933 0 2.832-1.292 5.384-3.34 7.16l1.133 1.853\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M280.907 196.052c2.695-2.01 4.37-4.744 4.37-7.755 0-3.47-2.27-6.563-5.713-8.614 2.122 1.708 3.41 3.916 3.6 6.382.027.31.042.62.042.934 0 2.832-1.292 5.384-3.34 7.16l1.04 1.892\" fill=\"#c8b100\"></path><path d=\"M280.907 196.052c2.695-2.01 4.37-4.744 4.37-7.755 0-3.47-2.27-6.563-5.713-8.614 2.122 1.708 3.41 3.916 3.6 6.382.027.31.042.62.042.934 0 2.832-1.292 5.384-3.34 7.16l1.04 1.892\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M304.688 199.565c1.506-1.69 2.43-3.876 2.43-6.265 0-1.44-.333-2.818-.93-4.046-2.187-4.488-9.028-7.753-17.162-7.753a28.4 28.4 0 0 0-6.292.688c.438.473.776.992 1.11 1.517 1.62-.317 3.37-.488 5.178-.488 7.447 0 13.678 2.895 15.478 6.807.483.997.75 2.11.75 3.276 0 2.378-1.115 4.51-2.857 5.964l2.695 4.402 1.447-1.147-1.85-2.95\" fill=\"#c8b100\"></path><path d=\"M304.688 199.565c1.506-1.69 2.43-3.876 2.43-6.265 0-1.44-.333-2.818-.93-4.046-2.187-4.488-9.028-7.753-17.162-7.753a28.4 28.4 0 0 0-6.292.688c.438.473.776.992 1.11 1.517 1.62-.317 3.37-.488 5.178-.488 7.447 0 13.678 2.895 15.478 6.807.483.997.75 2.11.75 3.276 0 2.378-1.115 4.51-2.857 5.964l2.695 4.402 1.447-1.147-1.85-2.95.003-.005z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M301.925 184.814c1.957 1.232 3.44 2.75 4.26 4.44a9.28 9.28 0 0 1 .932 4.046c0 2.39-.923 4.575-2.43 6.265l1.634 2.656c1.566-2.012 2.473-4.36 2.473-6.858 0-4.302-2.733-8.06-6.868-10.548\" fill=\"#c8b100\"></path><path d=\"M301.925 184.814c1.957 1.232 3.44 2.75 4.26 4.44a9.28 9.28 0 0 1 .932 4.046c0 2.39-.923 4.575-2.43 6.265l1.634 2.656c1.566-2.012 2.473-4.36 2.473-6.858 0-4.302-2.733-8.06-6.868-10.548z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M253.793 193.467c0-1.017.874-1.84 1.95-1.84 1.075 0 1.95.823 1.95 1.84 0 1.022-.875 1.85-1.95 1.85-1.076 0-1.95-.828-1.95-1.85\" fill=\"#fff\"></path><path d=\"M253.793 193.467c0-1.017.874-1.84 1.95-1.84 1.075 0 1.95.823 1.95 1.84 0 1.022-.875 1.85-1.95 1.85-1.076 0-1.95-.828-1.95-1.85z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M253.793 189.85c0-1.018.874-1.848 1.95-1.848 1.075 0 1.95.83 1.95 1.848 0 1.018-.875 1.843-1.95 1.843-1.076 0-1.95-.825-1.95-1.843m.391-3.892c0-.815.7-1.472 1.56-1.472.854 0 1.554.657 1.554 1.472 0 .814-.7 1.474-1.555 1.474-.86 0-1.56-.66-1.56-1.474m.437-3.508c0-.585.505-1.062 1.123-1.062.622 0 1.12.477 1.12 1.06 0 .59-.498 1.068-1.12 1.068-.618 0-1.122-.477-1.122-1.067m.223-3.069c0-.472.402-.85.9-.85.494 0 .897.378.897.85 0 .47-.402.852-.897.852-.497 0-.9-.382-.9-.85\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.908 204.572l1.267.233c-.204.512-.246 1.072-.246 1.662 0 2.63 2.257 4.767 5.036 4.767 2.23 0 4.132-1.382 4.784-3.29.074.05.48-1.725.69-1.702.178.018.16 1.843.224 1.81.323 2.404 2.52 4.03 4.992 4.03 2.775 0 5.025-2.128 5.025-4.76 0-.196-.01-.393-.036-.583l1.577-1.564.848 1.993c-.337.624-.47 1.327-.47 2.08 0 2.512 2.15 4.544 4.803 4.544 1.67 0 3.136-.803 3.998-2.022l1.01-1.284-.008 1.575c0 1.58.668 3 2.212 3.25 0 0 1.772.11 4.12-1.733 2.35-1.844 3.643-3.37 3.643-3.37l.203 1.845s-1.95 3.016-4.073 4.245c-1.16.675-2.922 1.384-4.323 1.156-1.483-.24-2.54-1.43-3.083-2.8a7.167 7.167 0 0 1-3.642.984c-2.87 0-5.452-1.574-6.473-3.944-1.32 1.425-3.16 2.3-5.317 2.3-2.293 0-4.394-1.03-5.71-2.617a7.397 7.397 0 0 1-4.992 1.905c-2.538 0-4.802-1.244-6.085-3.12-1.28 1.876-3.543 3.12-6.078 3.12-1.937 0-3.7-.727-4.995-1.906-1.312 1.585-3.416 2.617-5.71 2.617-2.156 0-3.995-.876-5.317-2.3-1.02 2.37-3.6 3.943-6.473 3.943a7.145 7.145 0 0 1-3.635-.984c-.55 1.37-1.606 2.56-3.084 2.8-1.4.228-3.164-.48-4.326-1.156-2.125-1.23-4.072-4.245-4.072-4.245l.204-1.846s1.295 1.526 3.64 3.37c2.35 1.846 4.12 1.733 4.12 1.733 1.544-.25 2.21-1.67 2.21-3.25l-.006-1.575 1.01 1.284c.86 1.22 2.33 2.022 3.997 2.022 2.654 0 4.803-2.032 4.803-4.545 0-.753-.135-1.456-.472-2.08l.847-1.994 1.58 1.563c-.024.19-.038.386-.038.58 0 2.634 2.248 4.762 5.025 4.762 2.477 0 4.67-1.626 4.992-4.03.068.033.05-1.792.225-1.81.21-.023.618 1.752.688 1.702.656 1.908 2.554 3.29 4.792 3.29 2.78 0 5.03-2.138 5.03-4.767 0-.59-.035-1.15-.242-1.662l1.313-.233\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M290.478 210.855c.29-.853.03-1.698-.583-1.882-.614-.193-1.352.345-1.643 1.196-.293.85-.03 1.69.584 1.882.613.185 1.35-.35 1.642-1.197m-21.888-4.238c.114-.89-.312-1.67-.953-1.742-.64-.076-1.255.58-1.37 1.47-.116.886.31 1.668.95 1.745.643.07 1.258-.587 1.373-1.474m-25.414.001c-.115-.89.315-1.67.952-1.742.64-.076 1.255.58 1.37 1.47.112.886-.31 1.668-.95 1.745-.643.07-1.258-.587-1.372-1.474m-21.886 4.24c-.29-.853-.03-1.698.584-1.882.615-.193 1.348.345 1.64 1.196.288.85.027 1.69-.584 1.882-.614.185-1.347-.35-1.64-1.197\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M230.798 196.25c1.086.686 2.034 1.828 2.364 3.105 0 0 .127-.262.725-.608.604-.338 1.114-.328 1.114-.328s-.17.993-.256 1.35c-.087.348-.095 1.414-.326 2.374-.23.96-.65 1.727-.65 1.727a2.026 2.026 0 0 0-1.612-.425c-.6.103-1.082.455-1.358.92 0 0-.673-.585-1.233-1.41-.565-.827-.95-1.823-1.164-2.125-.21-.305-.73-1.185-.73-1.185s.478-.178 1.166-.05c.686.127.902.334.902.334-.146-1.313.29-2.685 1.06-3.68\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M231.258 206.704a1.862 1.862 0 0 1-.69-1.106 1.74 1.74 0 0 1 .238-1.255s-.908-.457-1.88-.712c-.737-.192-2.033-.2-2.425-.206-.39-.012-1.174-.03-1.174-.03s.066.18.288.567c.268.47.507.764.507.764-1.297.3-2.403 1.153-3.102 2.143 1.015.7 2.363 1.127 3.686.992 0 0-.115.353-.2.886-.068.44-.064.623-.064.623l1.094-.404c.365-.136 1.582-.557 2.208-.98.817-.558 1.516-1.28 1.516-1.28m2.91-.491a1.76 1.76 0 0 0 .248-1.257 1.835 1.835 0 0 0-.675-1.105s.683-.724 1.5-1.28c.623-.422 1.843-.848 2.208-.978.366-.134 1.096-.408 1.096-.408s.003.186-.066.626c-.083.53-.2.884-.2.884 1.326-.14 2.676.305 3.69 1.01-.698.985-1.812 1.825-3.105 2.124a7.094 7.094 0 0 0 .795 1.331l-1.176-.023c-.39-.007-1.69-.01-2.426-.208-.97-.26-1.89-.71-1.89-.71\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M230.31 205.26c0-1.165.994-2.106 2.22-2.106 1.22 0 2.218.94 2.218 2.106 0 1.16-.994 2.1-2.22 2.1-1.224 0-2.218-.94-2.218-2.1\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M255.823 192.886c1.067.967 1.89 2.413 1.994 3.9 0 0 .19-.267.933-.536.74-.27 1.308-.164 1.308-.164s-.395 1.08-.568 1.457c-.172.38-.395 1.565-.857 2.587a8.78 8.78 0 0 1-1.074 1.803 2.272 2.272 0 0 0-1.714-.767c-.687 0-1.3.302-1.708.767 0 0-.626-.774-1.08-1.803-.456-1.022-.683-2.208-.852-2.587-.172-.377-.572-1.457-.572-1.457s.572-.106 1.31.164c.74.27.937.537.937.537.104-1.488.88-2.934 1.943-3.9\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M254.168 204.627a2.044 2.044 0 0 1-.54-1.36c0-.513.195-.992.525-1.353 0 0-.913-.684-1.943-1.15-.78-.355-2.227-.602-2.66-.683l-1.307-.245s.036.206.204.683c.204.578.408.95.408.95-1.504.09-2.923.84-3.906 1.81.982.963 2.395 1.694 3.905 1.793 0 0-.204.368-.408.95-.168.47-.204.68-.204.68l1.306-.24c.433-.088 1.88-.33 2.66-.69 1.03-.467 1.958-1.14 1.958-1.14m3.347-.005c.33-.368.54-.844.54-1.36a2 2 0 0 0-.525-1.353s.914-.684 1.944-1.15c.782-.355 2.23-.602 2.663-.683l1.297-.245s-.03.206-.202.683a7.6 7.6 0 0 1-.404.95c1.506.09 2.922.84 3.9 1.81-.978.963-2.39 1.694-3.9 1.793 0 0 .2.368.404.95.17.47.202.68.202.68l-1.297-.24c-.434-.088-1.88-.33-2.663-.69a12.963 12.963 0 0 1-1.96-1.14m23.455-8.382c-1.082.686-2.03 1.828-2.36 3.105 0 0-.132-.262-.73-.608-.598-.338-1.114-.328-1.114-.328s.173.993.262 1.35c.09.348.092 1.414.322 2.374.23.96.648 1.727.648 1.727a2.037 2.037 0 0 1 1.614-.425 1.97 1.97 0 0 1 1.362.92s.668-.585 1.233-1.41c.56-.827.948-1.823 1.154-2.125.21-.305.734-1.185.734-1.185s-.48-.178-1.168-.05c-.687.127-.903.334-.903.334.154-1.313-.283-2.685-1.056-3.68\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M280.51 206.704c.344-.274.608-.656.688-1.106a1.747 1.747 0 0 0-.234-1.255s.902-.457 1.873-.712c.74-.192 2.04-.2 2.426-.206.393-.012 1.176-.03 1.176-.03s-.063.18-.288.567c-.27.47-.507.764-.507.764 1.296.3 2.402 1.153 3.102 2.143-1.01.7-2.357 1.127-3.686.992 0 0 .12.353.2.886.066.44.06.623.06.623l-1.088-.404c-.365-.136-1.582-.557-2.21-.98a11.48 11.48 0 0 1-1.51-1.28m-2.915-.491a1.785 1.785 0 0 1-.25-1.257c.086-.45.334-.833.68-1.105 0 0-.688-.724-1.505-1.28-.622-.422-1.844-.848-2.207-.978-.366-.134-1.09-.408-1.09-.408s-.004.186.063.626c.082.53.197.884.197.884-1.325-.14-2.677.305-3.686 1.01.698.985 1.808 1.825 3.1 2.124 0 0-.232.295-.502.764a3.99 3.99 0 0 0-.287.567l1.17-.023c.39-.007 1.695-.01 2.427-.208.97-.26 1.886-.71 1.886-.71\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M277.018 205.26c0-1.165.993-2.106 2.22-2.106 1.228 0 2.222.94 2.222 2.106 0 1.16-.994 2.1-2.223 2.1-1.226 0-2.22-.94-2.22-2.1m24.823 4.668c-.524-.552-1.606-.436-2.415.255-.81.687-1.045 1.698-.523 2.247.523.553 1.605.433 2.414-.254.81-.694 1.046-1.702.524-2.248\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M298.688 211.267c.11-.378.364-.764.737-1.084.81-.69 1.89-.807 2.415-.255.064.074.138.17.18.258 0 0 1.125-2.134 2.457-2.842 1.334-.717 3.588-.536 3.588-.536 0-1.636-1.34-2.958-3.07-2.958-1.013 0-1.973.42-2.538 1.133l-.232-1.097s-1.39.276-2.03 1.864c-.632 1.594.06 3.895.06 3.895-.002 0-.347-.99-.868-1.648-.52-.653-1.85-1.37-2.545-1.697-.696-.323-1.406-.81-1.406-.81s-.03.177-.058.618c-.027.526.016.85.016.85-1.275-.167-2.762.04-3.92.49.494.975 1.438 1.89 2.675 2.36 0 0-.446.368-.854.77-.336.343-.444.503-.444.503l1.31.187c.432.058 1.88.286 2.744.23a15.693 15.693 0 0 0 1.782-.23m-85.609-.001c-.11-.378-.362-.764-.737-1.084-.81-.69-1.888-.807-2.415-.255a1.13 1.13 0 0 0-.18.258s-1.13-2.134-2.46-2.842c-1.33-.717-3.582-.536-3.582-.536 0-1.636 1.34-2.958 3.066-2.958 1.017 0 1.97.42 2.54 1.133l.232-1.097s1.39.276 2.027 1.864c.635 1.594-.06 3.895-.06 3.895s.347-.99.87-1.648c.52-.653 1.853-1.37 2.548-1.697.692-.323 1.405-.81 1.405-.81s.027.177.055.618c.027.526-.016.85-.016.85 1.27-.167 2.76.04 3.92.49-.495.975-1.436 1.89-2.675 2.36 0 0 .445.368.85.77.34.343.45.503.45.503l-1.308.187c-.44.058-1.883.286-2.747.23a15.646 15.646 0 0 1-1.785-.23\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M209.925 209.928c.527-.552 1.606-.436 2.416.255.815.687 1.044 1.698.523 2.247-.522.553-1.605.433-2.414-.254-.812-.694-1.046-1.702-.525-2.248m43.703-6.661c0-1.163.993-2.1 2.218-2.1s2.223.937 2.223 2.1-.995 2.105-2.224 2.105c-1.225 0-2.218-.942-2.218-2.105\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M251.226 171.316c0-2.38 2.033-4.3 4.536-4.3 2.503 0 4.534 1.92 4.534 4.3 0 2.37-2.03 4.29-4.534 4.29-2.503 0-4.536-1.92-4.536-4.29\" fill=\"#005bbf\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M254.574 159.27v2.32h-2.48v2.35h2.48v6.77h-3.125c-.038.22-.227.382-.227.612 0 .593.124 1.163.355 1.676.006.014.025.018.03.032h8.314c.006-.014.027-.018.033-.032a4.1 4.1 0 0 0 .354-1.676c0-.23-.19-.392-.226-.612h-3.03v-6.77h2.482v-2.35h-2.48v-2.32h-2.482z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M256.21 352.597c-13.395 0-26.672-3.283-37.834-8.745-8.227-4.075-13.683-12.293-13.683-21.696v-34.1h102.833v34.1c0 9.403-5.455 17.62-13.685 21.696-11.16 5.462-24.23 8.745-37.63 8.745\" fill=\"#ccc\"></path><path d=\"M256.21 352.597c-13.395 0-26.672-3.283-37.834-8.745-8.227-4.075-13.683-12.293-13.683-21.696v-34.1h102.833v34.1c0 9.403-5.455 17.62-13.685 21.696-11.16 5.462-24.23 8.745-37.63 8.745z\" fill=\"none\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M255.992 287.997h51.53v-57.05h-51.53v57.05z\" fill=\"#ccc\"></path><path d=\"M255.992 287.997h51.53v-57.05h-51.53v57.05z\" fill=\"none\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M256.03 322.116c0 13.475-11.42 24.398-25.643 24.398-14.23 0-25.763-10.923-25.763-24.398v-34.152h51.407v34.152\" fill=\"#ad1519\"></path><path d=\"M215.854 342.25c1.607.854 3.813 2.273 6.17 2.84l-.15-58.33h-6.02v55.49z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M204.54 321.656c.156 7.196 3.013 12.546 5.87 16.05v-50.66h-5.798l-.073 34.61z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".512\" stroke-linejoin=\"round\"></path><path d=\"M227.316 346.37c2.355.237 4.112.19 6.02 0v-59.61h-6.02v59.61z\" fill=\"#c7b500\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M238.63 345.09c2.356-.472 5.014-1.94 6.17-2.697V286.76h-6.02l-.15 58.33z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M204.627 287.997h51.383v-57.05h-51.383v57.05z\" fill=\"#ad1519\"></path><path d=\"M204.627 287.997h51.383v-57.05h-51.383v57.05z\" fill=\"none\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M250.395 337.138c2.507-2.225 4.863-7.292 5.72-13.068l.15-37.31h-6.02l.15 50.378z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M256.03 322.116c0 13.475-11.42 24.398-25.643 24.398-14.23 0-25.763-10.923-25.763-24.398v-34.152h51.407v34.152\" fill=\"none\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M307.572 287.964v34.152c0 13.475-11.55 24.398-25.778 24.398-14.226 0-25.763-10.923-25.763-24.398v-34.152h51.542\" fill=\"#ad1519\"></path><path d=\"M307.572 287.964v34.152c0 13.475-11.55 24.398-25.778 24.398-14.226 0-25.763-10.923-25.763-24.398v-34.152h51.542\" fill=\"none\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M265.406 313.74c.082.175.128.35.128.536 0 .63-.534 1.13-1.2 1.13-.66 0-1.196-.5-1.196-1.13 0-.185.046-.36.13-.513l-1.674-.022c-.034.172-.055.35-.055.536 0 1.185.818 2.19 1.95 2.527l-.003 4.11 1.755.01.003-4.138a2.73 2.73 0 0 0 1.737-1.655h4.713v-1.388h-6.29m23.123 0v1.388l-4.24.012a2.72 2.72 0 0 1-.27.52l4.92 5.592-1.32 1.07-4.9-5.6c-.09.028-.134.064-.23.09l-.01 9.254h-1.736l-.004-9.294c-.074-.018-.135-.054-.204-.087l-5.1 5.636-1.32-1.07 5.096-5.657a2.27 2.27 0 0 1-.212-.466h-4.38v-1.388h13.914-.004zm2.823 0v1.388h4.718c.28.78.915 1.39 1.736 1.655l.003 4.138 1.752-.01-.005-4.11c1.133-.338 1.955-1.342 1.955-2.527 0-.185-.02-.364-.063-.535h-1.666c.082.175.124.35.124.536 0 .63-.53 1.13-1.194 1.13-.66 0-1.198-.5-1.198-1.13 0-.185.046-.36.13-.513l-6.29-.022m-7.125 23.595a16.58 16.58 0 0 0 3.894-1.122l.86 1.465a18.773 18.773 0 0 1-4.607 1.305c-.27 1.196-1.385 2.094-2.73 2.094-1.34 0-2.457-.887-2.734-2.075a18.662 18.662 0 0 1-4.845-1.324l.864-1.465c1.316.556 2.72.927 4.18 1.13a2.66 2.66 0 0 1 1.613-1.425l.015-7.174h1.73l.017 7.15c.768.228 1.416.75 1.74 1.44h.002zm-11.77-2.406l-.853 1.47a17.764 17.764 0 0 1-3.89-3.29c-.89.262-1.897.107-2.657-.512-1.175-.953-1.317-2.625-.31-3.734l.146-.156a16.29 16.29 0 0 1-1.352-5.124l1.752.007a14.01 14.01 0 0 0 1.12 4.38 3.1 3.1 0 0 1 1.49.163l4.38-4.847 1.32 1.066-4.352 4.84a2.506 2.506 0 0 1-.108 2.926 16.184 16.184 0 0 0 3.316 2.81zm-6.494-5.084a1.243 1.243 0 0 1 1.69-.128c.503.407.565 1.127.134 1.6a1.246 1.246 0 0 1-1.69.127 1.096 1.096 0 0 1-.134-1.6zm-2.208-4.794l-1.8-.402-.254-4.56 1.787-.59.002 2.616c0 1.013.09 1.974.265 2.936zm1.494-5.653l1.792.42s.092 2.93.054 2.273c-.047-.767.196 2.292.196 2.292l-1.808.596c-.18-.93-.242-1.883-.242-2.864l.003-2.717h.004zm5.91 14.587a16.71 16.71 0 0 0 5.163 2.74l.4-1.733a14.61 14.61 0 0 1-4.275-2.145l-1.287 1.137m-.867 1.498a18.56 18.56 0 0 0 5.16 2.717l-1.34 1.254a19.954 19.954 0 0 1-4.218-2.164l.398-1.807m2.34-10.05l1.712.727 3.133-3.476-1.03-1.48-3.815 4.23m-1.328-1.074l-1.027-1.487 3.134-3.476 1.707.73-3.815 4.232m19.285 10.567l.856 1.47a17.812 17.812 0 0 0 3.89-3.29c.886.262 1.897.107 2.655-.512 1.177-.953 1.312-2.625.312-3.734l-.15-.156c.712-1.6 1.192-3.32 1.35-5.124l-1.743.007a14.152 14.152 0 0 1-1.123 4.38 3.11 3.11 0 0 0-1.493.163l-4.377-4.847-1.32 1.066 4.35 4.84a2.518 2.518 0 0 0 .107 2.926 16.09 16.09 0 0 1-3.314 2.81zm6.492-5.084a1.236 1.236 0 0 0-1.684-.128 1.093 1.093 0 0 0-.136 1.6c.43.476 1.187.535 1.69.127.504-.41.56-1.123.13-1.6zm2.21-4.794l1.8-.402.253-4.56-1.782-.59-.004 2.616c0 1.013-.09 1.974-.27 2.936zm-1.49-5.653l-1.794.42s-.097 2.93-.058 2.273c.05-.767-.196 2.292-.196 2.292l1.808.596c.182-.93.242-1.883.242-2.864l-.003-2.717m-5.913 14.587a16.77 16.77 0 0 1-5.16 2.74l-.4-1.733a14.586 14.586 0 0 0 4.27-2.145l1.29 1.137m.87 1.498a18.616 18.616 0 0 1-5.162 2.717l1.34 1.254a19.962 19.962 0 0 0 4.22-2.164l-.4-1.807m-2.338-10.05l-1.712.727-3.134-3.476 1.03-1.48 3.817 4.23m1.327-1.074l1.027-1.487-3.132-3.476-1.708.73 3.814 4.232m-21.446-9.228l.527 1.708h4.826l.52-1.708H270.3m22.545 0l-.53 1.708h-4.823l-.52-1.708h5.873m-12.397 23.293c0-.63.537-1.138 1.198-1.138.66 0 1.193.507 1.193 1.137 0 .626-.533 1.13-1.193 1.13s-1.198-.504-1.198-1.13zm2.03-8.27l1.802-.504v-4.564l-1.8-.495v5.563m-1.747 0l-1.796-.505v-4.564l1.797-.495v5.563\" fill=\"#c8b100\"></path><path d=\"M261.594 313.78c.207-.95.95-1.722 1.91-2.01l-.015-5.635h1.737l.003 5.665c.857.27 1.516.903 1.78 1.72l4.685.006v.255h-6.29a1.237 1.237 0 0 0-1.07-.603 1.21 1.21 0 0 0-1.067.626l-1.674-.022m13.02 0v-.254h4.35c.05-.142.114-.28.188-.412l-5.368-5.982 1.32-1.07 5.3 5.884c.09-.045.19-.085.283-.118l.005-7.84h1.734v7.792c.078.023.196.044.274.067l5.176-5.894 1.33 1.055-5.196 5.87c.134.197.225.416.3.648h4.214v.255H274.61h.003zm23.03 0a1.23 1.23 0 0 1 1.066-.603c.47 0 .873.258 1.07.626l1.667-.022c-.207-.95-.944-1.722-1.903-2.01l.01-5.632h-1.732l-.007 5.665c-.852.27-1.512.9-1.777 1.716l-4.687.006v.255h6.293m-32.136-15.912l6.457 7.24 1.322-1.072-6.493-7.21c.13-.194.222-.404.3-.63h4.722v-1.648h-4.726c-.363-1.067-1.422-1.832-2.67-1.832-1.543 0-2.8 1.188-2.8 2.653 0 1.16.787 2.152 1.885 2.51l-.01 5.584h1.734v-5.548c.073-.02.206-.02.277-.048zm34.068.037l-.016 5.56h-1.737v-5.582a2.61 2.61 0 0 1-.39-.158l-6.42 7.248-1.328-1.057 6.544-7.39a2.42 2.42 0 0 1-.15-.33h-4.75v-1.648h4.735c.365-1.067 1.414-1.832 2.657-1.832 1.543 0 2.8 1.188 2.8 2.653 0 1.19-.812 2.195-1.947 2.535zm-17.13-.022l-.014 3.424h-1.734l.004-3.395a2.743 2.743 0 0 1-1.83-1.717h-4.234v-1.647h4.235c.367-1.067 1.41-1.832 2.655-1.832 1.244 0 2.295.765 2.66 1.832h4.32v1.647h-4.33a2.696 2.696 0 0 1-1.73 1.688zm-18.935 4.156l-1.8.506v4.576l1.8.496v-5.58m1.747 0l1.796.508v4.576l-1.796.496v-5.58m32.55 0l-1.796.508v4.576l1.797.496v-5.58m1.748 0l1.8.508v4.576l-1.8.496v-5.58m-27.25.904l1.714-.727 3.132 3.483-1.03 1.485-3.817-4.24m-1.327 1.078l-1.025 1.492 3.133 3.48 1.708-.733-3.816-4.24m19.674-1.212l-1.717-.714-3.102 3.508 1.04 1.476 3.78-4.27m1.335 1.068l1.04 1.478-3.102 3.51-1.713-.72 3.775-4.268m-21.69 9.646l.527-1.71h4.826l.52 1.71h-5.87m-7.077-18.15c0-.626.536-1.137 1.198-1.137.66 0 1.195.51 1.195 1.137s-.535 1.133-1.194 1.133c-.66 0-1.197-.506-1.197-1.133zm12.907.826l-.53 1.714h-4.822l-.52-1.714h5.872m0-1.657l-.53-1.707h-4.822l-.52 1.708h5.872m16.713 18.982l-.53-1.71h-4.822l-.52 1.71h5.873m4.682-18.15c0-.626.533-1.137 1.197-1.137.66 0 1.195.51 1.195 1.137s-.534 1.133-1.195 1.133c-.664 0-1.197-.506-1.197-1.133zm-17.197 0c0-.626.537-1.137 1.197-1.137s1.195.51 1.195 1.137-.534 1.133-1.195 1.133c-.66 0-1.197-.506-1.197-1.133zm6.683.826l.532 1.714h4.822l.522-1.714h-5.875m0-1.657l.532-1.707h4.822l.522 1.708h-5.875m-6.298 5.346l-1.797.506v4.576l1.797.496v-5.578m1.727 0l1.795.506v4.576l-1.796.496v-5.578\" fill=\"#c8b100\"></path><path d=\"M284.227 337.335a16.58 16.58 0 0 0 3.894-1.122l.86 1.465a18.773 18.773 0 0 1-4.607 1.305c-.27 1.196-1.385 2.094-2.73 2.094-1.34 0-2.457-.887-2.734-2.075a18.662 18.662 0 0 1-4.845-1.324l.864-1.465c1.316.556 2.72.927 4.18 1.13a2.66 2.66 0 0 1 1.613-1.425l.015-7.174h1.73l.017 7.148c.768.23 1.416.753 1.74 1.443h.002zm-5.02-21.736a2.434 2.434 0 0 1-.213-.47h-4.38v-1.644h4.35c.05-.138.12-.276.19-.407l-5.37-5.975 1.32-1.07 5.304 5.873a2.16 2.16 0 0 1 .284-.115l.004-7.826h1.73v7.778c.078.02.196.044.274.07l5.176-5.89 1.33 1.06-5.196 5.855c.134.196.225.414.3.646h4.214v1.644l-4.24.01c-.06.187-.168.358-.267.52l4.922 5.598-1.322 1.07-4.9-5.605c-.09.033-.134.07-.233.095l-.012 9.253h-1.735l-.005-9.292c-.073-.022-.133-.06-.203-.092l-5.1 5.64-1.318-1.068 5.094-5.66m-13.7-17.74l6.457 7.226 1.322-1.07-6.492-7.196c.13-.193.22-.403.3-.63h4.722v-1.642h-4.726c-.363-1.065-1.422-1.83-2.67-1.83-1.544 0-2.8 1.186-2.8 2.65 0 1.158.786 2.147 1.885 2.502l-.01 5.576h1.734v-5.538c.073-.02.206-.02.277-.048zm6.952 37.07l-.854 1.474a17.764 17.764 0 0 1-3.89-3.292c-.89.263-1.897.107-2.656-.512-1.176-.953-1.318-2.625-.312-3.734l.147-.156a16.29 16.29 0 0 1-1.352-5.124l1.752.007c.137 1.54.52 3.006 1.12 4.38a3.1 3.1 0 0 1 1.49.164l4.38-4.848 1.32 1.066-4.352 4.84a2.506 2.506 0 0 1-.108 2.926 16.184 16.184 0 0 0 3.316 2.81zm-8.97-14.015v-4.11c-1.13-.335-1.952-1.342-1.952-2.527 0-1.183.833-2.2 1.967-2.543l-.014-5.62h1.736l.003 5.653c.857.27 1.516.898 1.78 1.713l4.685.006v1.644h-4.713a2.73 2.73 0 0 1-1.737 1.655l-.003 4.138-1.755-.01m2.476 8.932a1.243 1.243 0 0 1 1.69-.128c.503.408.565 1.128.135 1.6a1.246 1.246 0 0 1-1.69.128 1.095 1.095 0 0 1-.135-1.6zm-2.208-4.793l-1.8-.403-.254-4.56 1.787-.59.002 2.615c0 1.014.09 1.974.265 2.937zm1.494-5.654l1.792.422s.092 2.93.054 2.273c-.047-.767.196 2.29.196 2.29l-1.808.597c-.18-.93-.242-1.884-.242-2.865l.003-2.717h.004zm5.91 14.588a16.71 16.71 0 0 0 5.163 2.742l.4-1.734a14.61 14.61 0 0 1-4.275-2.145l-1.287 1.136m-.867 1.498a18.56 18.56 0 0 0 5.16 2.717l-1.34 1.256a19.954 19.954 0 0 1-4.218-2.164l.398-1.808\" fill=\"none\" stroke=\"#c8b100\" stroke-width=\".266\"></path><path d=\"M272.633 325.435l1.712.727 3.133-3.476-1.03-1.48-3.815 4.23m-1.328-1.074l-1.027-1.487 3.134-3.476 1.707.73-3.815 4.232m-8.167-10.086c0-.63.536-1.138 1.197-1.138.66 0 1.195.508 1.195 1.138 0 .63-.534 1.13-1.195 1.13-.66 0-1.197-.5-1.197-1.13zm27.452 20.653l.856 1.47a17.812 17.812 0 0 0 3.89-3.29c.886.262 1.897.107 2.655-.512 1.177-.953 1.312-2.625.312-3.734l-.15-.156c.712-1.6 1.192-3.32 1.35-5.124l-1.743.007a14.152 14.152 0 0 1-1.123 4.38 3.11 3.11 0 0 0-1.493.163l-4.377-4.847-1.32 1.066 4.35 4.84a2.518 2.518 0 0 0 .107 2.926 16.09 16.09 0 0 1-3.314 2.81zm8.973-14.018l-.004-4.11c1.132-.334 1.953-1.34 1.953-2.526 0-1.183-.832-2.2-1.965-2.543l.01-5.62h-1.735l-.007 5.653c-.852.27-1.513.898-1.778 1.713l-4.687.006v1.644h4.72c.28.778.913 1.39 1.734 1.654l.003 4.138 1.752-.01h.003zm-2.48 8.934a1.236 1.236 0 0 0-1.685-.128 1.093 1.093 0 0 0-.136 1.6c.43.476 1.187.535 1.69.127.504-.41.56-1.123.13-1.6zm2.208-4.794l1.8-.402.255-4.56-1.782-.59-.004 2.616c0 1.013-.09 1.974-.27 2.936zm-1.49-5.653l-1.792.42s-.097 2.932-.057 2.273c.05-.767-.196 2.292-.196 2.292l1.808.596c.182-.93.242-1.883.242-2.864l-.003-2.717m1.775-21.505l-.016 5.55h-1.738v-5.573a2.4 2.4 0 0 1-.388-.156l-6.42 7.233-1.33-1.055 6.545-7.375a2.535 2.535 0 0 1-.15-.33h-4.75v-1.645h4.735c.365-1.065 1.413-1.828 2.657-1.828 1.543 0 2.8 1.185 2.8 2.648 0 1.188-.812 2.19-1.947 2.53zm-17.13-.023l-.014 3.42h-1.734l.004-3.39a2.74 2.74 0 0 1-1.83-1.713h-4.234v-1.645h4.235c.367-1.065 1.41-1.828 2.654-1.828 1.245 0 2.296.763 2.662 1.828h4.32v1.644h-4.332a2.69 2.69 0 0 1-1.728 1.682zm9.442 36.115a16.77 16.77 0 0 1-5.16 2.74l-.4-1.733a14.586 14.586 0 0 0 4.27-2.145l1.29 1.137m.87 1.498a18.617 18.617 0 0 1-5.162 2.717l1.34 1.254a19.962 19.962 0 0 0 4.22-2.164l-.4-1.807m-29.245-33.463l-1.8.506v4.567l1.8.493v-5.566m1.747 0l1.796.506v4.567l-1.796.493v-5.566m32.55 0l-1.796.506v4.567l1.797.493v-5.566\" fill=\"none\" stroke=\"#c8b100\" stroke-width=\".266\"></path><path d=\"M299.555 302.022l1.8.505v4.568l-1.8.493v-5.566m-9.138 23.413l-1.712.727-3.134-3.476 1.03-1.48 3.817 4.23m1.327-1.074l1.027-1.487-3.132-3.476-1.708.73 3.814 4.232m-19.44-21.44l1.715-.726 3.132 3.477-1.03 1.483-3.818-4.233M270.978 304l-1.025 1.487 3.133 3.473 1.708-.73-3.816-4.23m19.673-1.21l-1.715-.713-3.103 3.5 1.04 1.474 3.78-4.26m1.336 1.064l1.04 1.476-3.103 3.502-1.712-.717 3.775-4.26m-21.69 9.628l.527-1.706h4.826l.52 1.706H270.3m0 1.65l.527 1.71h4.826l.52-1.71H270.3m-7.075-19.765c0-.625.536-1.135 1.198-1.135.66 0 1.195.51 1.195 1.135s-.535 1.13-1.194 1.13c-.66 0-1.197-.505-1.197-1.13zm12.907.825l-.53 1.71h-4.822l-.522-1.71h5.874m0-1.655l-.53-1.705h-4.822l-.522 1.705h5.874m21.382 19.738c0-.63.54-1.138 1.198-1.138.665 0 1.194.508 1.194 1.138 0 .63-.53 1.13-1.194 1.13-.66 0-1.198-.5-1.198-1.13zm-4.67-.793l-.53-1.706h-4.822l-.52 1.706h5.873m0 1.65l-.53 1.71h-4.823l-.52-1.71h5.873m-12.397 23.294c0-.63.537-1.138 1.198-1.138.66 0 1.193.507 1.193 1.137 0 .626-.533 1.13-1.193 1.13s-1.198-.504-1.198-1.13zm2.03-8.27l1.802-.504v-4.564l-1.8-.495v5.563m-1.747 0l-1.796-.505v-4.564l1.797-.495v5.563m16.794-34.79c0-.625.534-1.135 1.198-1.135.66 0 1.195.51 1.195 1.135s-.534 1.13-1.195 1.13c-.664 0-1.198-.505-1.198-1.13zm-17.197 0c0-.625.538-1.135 1.197-1.135.662 0 1.195.51 1.195 1.135s-.534 1.13-1.196 1.13c-.66 0-1.197-.505-1.197-1.13zm6.684.825l.53 1.71h4.824l.522-1.71h-5.875m0-1.655l.53-1.705h4.824l.522 1.705h-5.875m-6.307 5.336l-1.796.505v4.567l1.797.495v-5.567m1.73 0l1.795.505v4.567l-1.796.495v-5.567\" fill=\"none\" stroke=\"#c8b100\" stroke-width=\".266\"></path><path d=\"M278.84 314.305c0-1.47 1.257-2.658 2.804-2.658 1.543 0 2.8 1.19 2.8 2.658 0 1.462-1.257 2.647-2.8 2.647-1.547 0-2.803-1.185-2.803-2.647\" fill=\"#058e6e\"></path><path d=\"M282.258 245.003l.057-.633.088-.353s-1.65.135-2.518-.108c-.868-.248-1.65-.606-2.462-1.29-.81-.687-1.128-1.116-1.708-1.202-1.39-.222-2.46.408-2.46.408s1.044.384 1.828 1.34c.778.965 1.628 1.45 1.995 1.568.608.185 2.72.054 3.3.077.578.03 1.88.196 1.88.196\" fill=\"#db4446\"></path><path d=\"M282.258 245.003l.057-.633.088-.353s-1.65.135-2.518-.108c-.868-.248-1.65-.606-2.462-1.29-.81-.687-1.128-1.116-1.708-1.202-1.39-.222-2.46.408-2.46.408s1.044.384 1.828 1.34c.778.965 1.628 1.45 1.995 1.568.608.185 2.72.054 3.3.077.578.03 1.88.196 1.88.196v-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M289.972 242.683s.004.738.076 1.444c.07.677-.218 1.268-.107 1.643.108.38.16.677.308.948.138.274.215.965.215.965s-.395-.28-.76-.553c-.36-.276-.62-.447-.62-.447s.074.738.108 1.054c.04.317.225.913.524 1.266.296.345.888.912 1.07 1.367.19.46.152 1.47.152 1.47s-.48-.77-.893-.906c-.405-.142-1.296-.637-1.296-.637s.817.81.817 1.582c0 .77-.333 1.646-.333 1.646s-.37-.698-.848-1.156c-.483-.455-1.152-.912-1.152-.912s.522 1.19.522 1.995c0 .81-.145 2.53-.145 2.53s-.408-.664-.815-.988c-.41-.312-.89-.592-1.04-.8-.146-.21.485.662.552 1.19.073.527.323 2.406 1.967 4.806.96 1.405 2.447 3.86 5.63 3.052 3.186-.804 2.003-5.086 1.336-7.087-.67-1.996-1.003-4.21-.964-4.985.035-.767.59-3.047.518-3.473-.073-.417-.246-2.047.15-3.36.407-1.366.745-1.897.963-2.46.22-.56.403-.878.477-1.368.073-.492.073-1.41.073-1.41s.59 1.093.74 1.478c.147.39.147 1.542.147 1.542s.11-1.153 1.003-1.713c.89-.568 1.926-1.16 2.186-1.477.258-.32.334-.526.334-.526s-.076 1.967-.63 2.74c-.368.503-1.82 2.14-1.82 2.14s.746-.285 1.263-.313c.52-.04.888 0 .888 0s-.63.492-1.444 1.684c-.813 1.19-.48 1.294-1.073 2.276-.596.98-1.077 1.018-1.818 1.615-1.114.894-.514 4.45-.37 4.978.15.523 2.075 4.878 2.113 5.93.034 1.055.223 3.404-1.632 4.912-1.193.98-3.147.986-3.593 1.266-.446.277-1.33 1.154-1.33 2.98 0 1.828.663 2.105 1.18 2.563.523.457 1.188.21 1.336.564.15.348.223.56.447.77.223.207.372.455.296.835-.073.39-.926 1.267-1.222 1.903-.3.625-.89 2.28-.89 2.523 0 .248-.07 1.02.183 1.407 0 0 .926 1.082.295 1.29-.406.14-.805-.254-.997-.208-.553.145-.842.486-1.002.457-.37-.07-.37-.25-.407-.77-.034-.525-.015-.74-.18-.74-.224 0-.335.183-.373.46-.04.28-.04.908-.296.908-.26 0-.63-.455-.852-.556-.223-.107-.852-.21-.888-.49-.038-.28.37-.877.776-.984.408-.105.78-.312.52-.522-.26-.212-.52-.212-.777 0-.26.21-.814.032-.78-.284.04-.316.113-.7.073-.876-.035-.17-.48-.524.107-.845.595-.312.852.285 1.444.178.596-.1.892-.32 1.114-.664.224-.35.185-1.09-.222-1.542-.407-.46-.814-.532-.964-.812-.15-.28-.368-.946-.368-.946s.107 1.226.034 1.404c-.072.175-.034.91-.034.91s-.408-.456-.74-.804c-.33-.352-.666-1.403-.666-1.403s-.035.98-.035 1.37c0 .38.44.734.295.877-.15.138-.85-.74-1.036-.877-.19-.14-.78-.596-1.042-1.09-.257-.492-.446-1.19-.518-1.44-.075-.245-.195-1.34-.075-1.615.186-.42.483-1.157.483-1.157h-1.445c-.775 0-1.332-.243-1.628.28-.295.528-.15 1.582.22 2.95.372 1.362.59 2.032.483 2.28-.108.243-.59.807-.775.908-.19.11-.707.073-.93-.03-.22-.105-.587-.283-1.294-.283-.704 0-1.15.033-1.406-.03-.26-.07-.89-.388-1.19-.318-.297.07-.808.333-.67.738.228.632-.218.774-.517.738-.296-.037-.55-.142-.925-.245-.368-.108-.926 0-.85-.424.07-.423.22-.456.404-.768.188-.32.257-.524.05-.546-.26-.026-.522-.055-.725.112-.195.164-.514.518-.775.386-.262-.138-.465-.44-.465-1.102 0-.658-.695-1.232-.057-1.204.637.03 1.448.496 1.593.14.143-.36.055-.52-.29-.8-.35-.273-.78-.437-.317-.794.46-.353.576-.353.753-.55.173-.188.42-.805.745-.653.636.303.03.743.667 1.45.638.714 1.04.966 2.112.852 1.07-.108 1.363-.247 1.363-.55 0-.3-.09-.846-.12-1.068-.026-.218.148-1.015.148-1.015s-.493.305-.638.602c-.14.303-.43.82-.43.82s-.12-.615-.085-1.117c.02-.294.124-.807.112-.91-.028-.27-.23-.958-.23-.958s-.175.74-.29.96c-.114.217-.172 1.098-.172 1.098s-.68-.593-.49-1.59c.14-.767-.117-1.78.113-2.112.228-.33.777-1.673 2.11-1.73 1.33-.05 2.37.057 2.837.032.463-.033 2.112-.33 2.112-.33s-3.04-1.56-3.733-2.03c-.695-.462-1.766-1.67-2.115-2.218-.348-.55-.666-1.615-.666-1.615s-.546.025-1.04.298a5.25 5.25 0 0 0-1.27 1.01c-.294.332-.754 1.074-.754 1.074s.084-.96.084-1.26c0-.296-.057-.88-.057-.88s-.346 1.315-1.04 1.805c-.696.497-1.506 1.18-1.506 1.18s.09-.733.09-.9c0-.164.172-1.015.172-1.015s-.49.734-1.244.88c-.752.135-1.854.106-1.942.575-.084.46.203 1.094.03 1.42-.174.33-.548.55-.548.55s-.434-.36-.81-.386c-.377-.028-.726.167-.726.167s-.32-.413-.204-.685c.12-.273.695-.684.553-.85-.145-.165-.61.058-.897.192-.288.138-.898.272-.84-.193.057-.466.202-.738.057-1.07-.144-.322-.058-.545.176-.628.23-.076 1.155.025 1.244-.185.085-.22-.23-.495-.84-.633-.608-.134-.9-.493-.58-.795.32-.303.406-.382.55-.658.145-.276.202-.77.754-.52.546.244.43.847 1.015 1.04.57.195 1.934-.08 2.22-.244.294-.168 1.218-.85 1.537-1.018.32-.16 1.647-1.15 1.647-1.15s-.78-.542-1.07-.82c-.29-.274-.807-.93-1.064-1.067-.262-.142-1.536-.63-1.97-.658-.434-.03-1.766-.49-1.766-.49s.607-.197.81-.36c.203-.165.66-.58.898-.55.227.03.283.03.283.03s-1.24-.06-1.5-.135c-.26-.088-1.014-.553-1.3-.553-.293 0-.87.112-.87.112s.78-.494 1.418-.604c.637-.105 1.13-.084 1.13-.084s-.984-.273-1.218-.6c-.23-.33-.46-.818-.638-1.04-.172-.217-.288-.578-.607-.603-.318-.028-.87.387-1.186.357-.315-.024-.55-.222-.58-.684-.023-.468 0-.305-.11-.55-.116-.25-.58-.824-.147-.958.438-.138 1.363.08 1.447-.084.09-.163-.49-.657-.866-.85-.377-.19-.984-.52-.666-.793.32-.272.636-.38.81-.628.174-.248.377-.932.754-.715.375.22.897 1.29 1.186 1.208.292-.084.314-.85.26-1.177-.057-.332 0-.906.285-.852.292.054.522.437.987.47.46.024 1.155-.11 1.097.214-.056.327-.318.734-.636 1.094-.31.36-.457 1.07-.257 1.534.203.47.726 1.212 1.187 1.51.46.3 1.328.524 1.88.876.55.36 1.825 1.37 2.26 1.48.432.113.866.33.866.33s.49-.217 1.16-.217c.664 0 2.196.108 2.775-.14.58-.25 1.333-.657 1.1-1.18-.227-.518-1.503-.987-1.387-1.393.115-.41.58-.44 1.358-.47.78-.025 1.85.14 2.052-.96.202-1.093.26-1.727-.834-1.97-1.102-.248-1.914-.272-2.11-1.07-.206-.792-.41-.984-.18-1.206.236-.215.638-.328 1.45-.378.81-.058 1.734-.058 1.996-.255.26-.185.315-.71.633-.93.317-.215 1.567-.412 1.567-.412s1.487.73 2.868 1.754c1.236.923 2.354 2.287 2.354 2.287\" fill=\"#ed72aa\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M279.305 241.912s-.173-.494-.202-.632c-.027-.135-.117-.302-.117-.302s.9 0 .87.272c-.028.277-.29.277-.347.382-.058.113-.205.28-.205.28\"></path><path d=\"M279.305 241.912s-.173-.494-.202-.632c-.027-.135-.117-.302-.117-.302s.9 0 .87.272c-.028.277-.29.277-.347.382-.058.113-.205.28-.205.28z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M283.418 240.483l-.062-.44s.784.008 1.16.273c.58.41.952 1.043.925 1.07-.1.097-.548-.274-.867-.382 0 0-.23.054-.464.054-.23 0-.347-.11-.378-.218-.025-.113.03-.302.03-.302l-.344-.05\"></path><path d=\"M283.418 240.483l-.062-.44s.784.008 1.16.273c.58.41.952 1.043.925 1.07-.1.097-.548-.274-.867-.382 0 0-.23.054-.464.054-.23 0-.347-.11-.378-.218-.025-.113.03-.302.03-.302l-.344-.05v-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M289.062 246.68s-.35-.495-.434-.662a7.966 7.966 0 0 1-.235-.49\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M267.87 241.745s.493.352.87.407c.376.058.783.058.84.058.058 0 .177-.553.115-.93-.203-1.236-1.332-1.51-1.332-1.51s.337.75.173 1.095c-.23.494-.665.88-.665.88\" fill=\"#db4446\"></path><path d=\"M267.87 241.745s.493.352.87.407c.376.058.783.058.84.058.058 0 .177-.553.115-.93-.203-1.236-1.332-1.51-1.332-1.51s.337.75.173 1.095c-.23.494-.665.88-.665.88z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M265.526 242.814s-.435-.796-1.36-.687c-.925.108-1.535.825-1.535.825s1.023-.032 1.275.134c.377.248.492.88.492.88s.553-.33.725-.55c.173-.22.403-.602.403-.602\" fill=\"#db4446\"></path><path d=\"M265.526 242.814s-.435-.796-1.36-.687c-.925.108-1.535.825-1.535.825s1.023-.032 1.275.134c.377.248.492.88.492.88s.553-.33.725-.55c.173-.22.403-.602.403-.602z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M264.397 246.018s-.78.112-1.213.607c-.44.494-.376 1.425-.376 1.425s.517-.545.982-.545c.466 0 1.187.164 1.187.164s-.23-.583-.23-.828-.35-.824-.35-.824\" fill=\"#db4446\"></path><path d=\"M264.397 246.018s-.78.112-1.213.607c-.44.494-.376 1.425-.376 1.425s.517-.545.982-.545c.466 0 1.187.164 1.187.164s-.23-.583-.23-.828-.35-.824-.35-.824z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M279.336 245.908l.345-.545.342.495-.686.05\"></path><path d=\"M279.336 245.908l.345-.545.342.495-.686.05\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M280.173 245.883l.406-.546.435.49-.842.056\"></path><path d=\"M280.173 245.883l.406-.546.435.49-.842.056\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M279.798 242.512l.84.302-.753.382-.087-.684\"></path><path d=\"M279.798 242.512l.84.302-.753.382-.087-.684\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M280.81 242.788l.752.19-.606.465-.146-.655\"></path><path d=\"M280.81 242.788l.752.19-.606.465-.146-.655\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M275.165 249.228s-.824.24-1.128.684c-.376.548-.348 1.098-.348 1.098s.693-.574 1.59-.33c.9.246.984.33 1.364.304.377-.028 1.303-.36 1.303-.36s-.753.877-.668 1.484c.086.6.198.872.174 1.178-.062.742-.61 1.647-.61 1.647s.32-.196 1.072-.36a4.884 4.884 0 0 0 1.793-.822c.402-.304.924-1.042.924-1.042s-.168 1.015 0 1.454c.173.44.23 1.702.23 1.702s.484-.428.867-.633c.205-.11.727-.384.932-.71.14-.234.32-1.092.32-1.092s.113.923.4 1.37c.293.433.722 1.783.722 1.783s.293-.876.61-1.235c.317-.357.697-.822.723-1.098.027-.273-.084-.874-.084-.874l.403.874m-11.69.63s.49-.85.955-1.126c.466-.274 1.103-.766 1.275-.82.17-.055.926-.47.926-.47m1.014 5.295s1.115-.57 1.447-.77c.697-.408 1.188-1.15 1.188-1.15\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M267.03 256.38s-.433-.46-1.186-.327c-.753.14-1.244.99-1.244.99s.637-.17 1.015-.085c.374.084.637.466.637.466s.345-.302.46-.466c.116-.162.315-.577.315-.577\" fill=\"#db4446\"></path><path d=\"M267.03 256.38s-.433-.46-1.186-.327c-.753.14-1.244.99-1.244.99s.637-.17 1.015-.085c.374.084.637.466.637.466s.345-.302.46-.466c.116-.162.315-.577.315-.577h.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M266.162 259.423s-.637-.107-1.185.332c-.55.44-.58 1.287-.58 1.287s.522-.44.93-.38c.402.05.894.27.894.27s.09-.523.115-.657c.09-.383-.173-.852-.173-.852\" fill=\"#db4446\"></path><path d=\"M266.162 259.423s-.637-.107-1.185.332c-.55.44-.58 1.287-.58 1.287s.522-.44.93-.38c.402.05.894.27.894.27s.09-.523.115-.657c.09-.383-.173-.852-.173-.852z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M267.64 262.224s-.04.814.347 1.313c.407.523 1.16.604 1.16.604s-.254-.545-.292-.822c-.058-.41.346-.767.346-.767s-.372-.38-.748-.38c-.378 0-.81.054-.81.054\" fill=\"#db4446\"></path><path d=\"M267.64 262.224s-.04.814.347 1.313c.407.523 1.16.604 1.16.604s-.254-.545-.292-.822c-.058-.41.346-.767.346-.767s-.372-.38-.748-.38c-.378 0-.81.054-.81.054zm17.08 1.366s2.084 1.292 2.027 2.36c-.062 1.07-1.16 2.47-1.16 2.47\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M275.165 269.434s-.52-.658-1.243-.632c-.726.03-1.48.71-1.48.71s.9-.078 1.13.22c.235.306.465.684.465.684s.404-.215.58-.353c.174-.134.548-.63.548-.63\" fill=\"#db4446\"></path><path d=\"M275.165 269.434s-.52-.658-1.243-.632c-.726.03-1.48.71-1.48.71s.9-.078 1.13.22c.235.306.465.684.465.684s.404-.215.58-.353c.174-.134.548-.63.548-.63z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M272.936 272.31s-.952-.137-1.417.357c-.466.49-.435 1.396-.435 1.396s.58-.628 1.1-.575c.52.055 1.1.332 1.1.332s-.09-.55-.146-.797a14.064 14.064 0 0 0-.204-.713\" fill=\"#db4446\"></path><path d=\"M272.936 272.31s-.952-.137-1.417.357c-.466.49-.435 1.396-.435 1.396s.58-.628 1.1-.575c.52.055 1.1.332 1.1.332s-.09-.55-.146-.797a14.064 14.064 0 0 0-.204-.713z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M274.993 275.355s-.464.657-.114 1.177c.344.523 1.067.77 1.067.77s-.258-.38-.143-.825c.092-.348.695-.82.695-.82l-1.507-.3\" fill=\"#db4446\"></path><path d=\"M274.993 275.355s-.464.657-.114 1.177c.344.523 1.067.77 1.067.77s-.258-.38-.143-.825c.092-.348.695-.82.695-.82l-1.507-.3v-.002z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M287.698 276.59s-.835-.196-1.3.08c-.46.273-.838 1.426-.838 1.426s.753-.63 1.303-.553c.547.087.955.306.955.306s.084-.47.026-.794a2.756 2.756 0 0 0-.146-.465\" fill=\"#db4446\"></path><path d=\"M287.698 276.59s-.835-.196-1.3.08c-.46.273-.838 1.426-.838 1.426s.753-.63 1.303-.553c.547.087.955.306.955.306s.084-.47.026-.794a2.756 2.756 0 0 0-.146-.465z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M288.106 279.656s-.637.658-.408 1.207a7.32 7.32 0 0 0 .638 1.123s-.023-.817.235-1.04c.373-.327 1.068-.384 1.068-.384s-.55-.492-.725-.546c-.17-.058-.807-.36-.807-.36\" fill=\"#db4446\"></path><path d=\"M288.106 279.656s-.637.658-.408 1.207a7.32 7.32 0 0 0 .638 1.123s-.023-.817.235-1.04c.373-.327 1.068-.384 1.068-.384s-.55-.492-.725-.546c-.17-.058-.807-.36-.807-.36z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M291.288 280.62s-.318.792.292 1.312c.606.523 1.13.578 1.13.578s-.465-.826-.32-1.262c.15-.455.55-.74.55-.74s-.754-.248-.868-.22c-.115.026-.784.33-.784.33\" fill=\"#db4446\"></path><path d=\"M291.288 280.62s-.318.792.292 1.312c.606.523 1.13.578 1.13.578s-.465-.826-.32-1.262c.15-.455.55-.74.55-.74s-.754-.248-.868-.22c-.115.026-.784.33-.784.33z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M258.683 337.46c2.143.644 3.23 2.24 3.23 4.11 0 2.432-2.362 4.278-5.425 4.278-3.064 0-5.548-1.846-5.548-4.28 0-1.84 1.02-3.894 3.152-4.042 0 0-.066-.194-.25-.51-.22-.236-.656-.676-.656-.676s.813-.153 1.282.026c.472.178.783.476.783.476s.224-.436.535-.774c.315-.335.722-.546.722-.546s.47.396.626.66c.153.275.254.598.254.598s.433-.357.81-.502c.375-.15.86-.265.86-.265s-.14.47-.232.708-.142.74-.142.74\" fill=\"#ffd691\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M256.035 348.49s-4.074-2.747-5.84-3.118c-2.26-.476-4.796-.09-5.894-.15.032.033 1.318.95 1.882 1.517.564.563 2.446 1.69 3.51 1.956 3.305.83 6.343-.207 6.343-.207m1.161.24s2.61-2.713 5.342-3.087c3.227-.447 5.34.267 6.593.594.03 0-1.036.505-1.598.89-.567.386-2.02 1.604-4.244 1.63-2.226.033-4.683-.234-5.09-.17-.408.053-1.003.144-1.003.144\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M256.415 345.372a5.175 5.175 0 0 1 .003-7.607 5.168 5.168 0 0 1 1.655 3.8 5.19 5.19 0 0 1-1.658 3.807\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M255.378 350.935s.63-1.555.69-2.894c.054-1.118-.157-2.224-.157-2.224h.815s.408 1.19.408 2.225c0 1.04-.19 2.423-.19 2.423s-.563.087-.75.174c-.186.09-.815.298-.815.298\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".532\"></path><path d=\"M306.91 203.442c0-.59.504-1.06 1.123-1.06.622 0 1.12.47 1.12 1.06 0 .59-.498 1.06-1.12 1.06-.62 0-1.122-.47-1.122-1.06\" fill=\"#fff\"></path><path d=\"M306.91 203.442c0-.59.504-1.06 1.123-1.06.622 0 1.12.47 1.12 1.06 0 .59-.498 1.06-1.12 1.06-.62 0-1.122-.47-1.122-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M308.446 200.722c0-.585.5-1.058 1.123-1.058.616 0 1.12.473 1.12 1.058 0 .593-.504 1.065-1.12 1.065-.624 0-1.124-.472-1.124-1.065\" fill=\"#fff\"></path><path d=\"M308.446 200.722c0-.585.5-1.058 1.123-1.058.616 0 1.12.473 1.12 1.058 0 .593-.504 1.065-1.12 1.065-.624 0-1.124-.472-1.124-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M309.467 197.574c0-.586.504-1.062 1.128-1.062.617 0 1.12.476 1.12 1.062 0 .588-.503 1.065-1.12 1.065-.624 0-1.128-.478-1.128-1.066\" fill=\"#fff\"></path><path d=\"M309.467 197.574c0-.586.504-1.062 1.128-1.062.617 0 1.12.476 1.12 1.062 0 .588-.503 1.065-1.12 1.065-.624 0-1.128-.478-1.128-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M309.6 194.194c0-.588.5-1.06 1.12-1.06.617 0 1.12.472 1.12 1.06 0 .59-.503 1.062-1.12 1.062-.62 0-1.12-.472-1.12-1.062\" fill=\"#fff\"></path><path d=\"M309.6 194.194c0-.588.5-1.06 1.12-1.06.617 0 1.12.472 1.12 1.06 0 .59-.503 1.062-1.12 1.062-.62 0-1.12-.472-1.12-1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M308.766 190.868c0-.585.504-1.058 1.12-1.058.623 0 1.126.473 1.126 1.058 0 .592-.503 1.065-1.126 1.065-.616 0-1.12-.473-1.12-1.065\" fill=\"#fff\"></path><path d=\"M308.766 190.868c0-.585.504-1.058 1.12-1.058.623 0 1.126.473 1.126 1.058 0 .592-.503 1.065-1.126 1.065-.616 0-1.12-.473-1.12-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M307.038 187.85c0-.59.503-1.062 1.122-1.062.62 0 1.123.473 1.123 1.062 0 .59-.502 1.066-1.123 1.066-.62 0-1.122-.476-1.122-1.066\" fill=\"#fff\"></path><path d=\"M307.038 187.85c0-.59.503-1.062 1.122-1.062.62 0 1.123.473 1.123 1.062 0 .59-.502 1.066-1.123 1.066-.62 0-1.122-.476-1.122-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M304.734 185.37c0-.59.503-1.065 1.122-1.065.622 0 1.124.476 1.124 1.065 0 .585-.502 1.06-1.124 1.06-.62 0-1.122-.475-1.122-1.06\" fill=\"#fff\"></path><path d=\"M304.734 185.37c0-.59.503-1.065 1.122-1.065.622 0 1.124.476 1.124 1.065 0 .585-.502 1.06-1.124 1.06-.62 0-1.122-.475-1.122-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M302.058 183.308c0-.59.504-1.066 1.126-1.066.618 0 1.12.476 1.12 1.066 0 .585-.502 1.06-1.12 1.06-.622 0-1.126-.475-1.126-1.06\" fill=\"#fff\"></path><path d=\"M302.058 183.308c0-.59.504-1.066 1.126-1.066.618 0 1.12.476 1.12 1.066 0 .585-.502 1.06-1.12 1.06-.622 0-1.126-.475-1.126-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M298.86 181.62c0-.588.503-1.057 1.122-1.057.622 0 1.124.47 1.124 1.058 0 .59-.502 1.067-1.124 1.067-.62 0-1.12-.476-1.12-1.066\" fill=\"#fff\"></path><path d=\"M298.86 181.62c0-.588.503-1.057 1.122-1.057.622 0 1.124.47 1.124 1.058 0 .59-.502 1.067-1.124 1.067-.62 0-1.12-.476-1.12-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M295.543 180.418c0-.586.503-1.062 1.124-1.062.618 0 1.123.476 1.123 1.062 0 .588-.505 1.064-1.123 1.064-.62 0-1.124-.476-1.124-1.064\" fill=\"#fff\"></path><path d=\"M295.543 180.418c0-.586.503-1.062 1.124-1.062.618 0 1.123.476 1.123 1.062 0 .588-.505 1.064-1.123 1.064-.62 0-1.124-.476-1.124-1.064z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M291.834 179.755c0-.585.502-1.065 1.12-1.065.624 0 1.125.48 1.125 1.065 0 .586-.502 1.063-1.125 1.063-.62 0-1.12-.477-1.12-1.063\" fill=\"#fff\"></path><path d=\"M291.834 179.755c0-.585.502-1.065 1.12-1.065.624 0 1.125.48 1.125 1.065 0 .586-.502 1.063-1.125 1.063-.62 0-1.12-.477-1.12-1.063z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M288.313 179.57c0-.586.503-1.058 1.125-1.058.618 0 1.122.472 1.122 1.058 0 .59-.504 1.066-1.122 1.066-.622 0-1.125-.477-1.125-1.066\" fill=\"#fff\"></path><path d=\"M288.313 179.57c0-.586.503-1.058 1.125-1.058.618 0 1.122.472 1.122 1.058 0 .59-.504 1.066-1.122 1.066-.622 0-1.125-.477-1.125-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M284.857 179.69c0-.585.504-1.06 1.125-1.06.623 0 1.12.475 1.12 1.06 0 .59-.497 1.065-1.12 1.065-.62 0-1.125-.476-1.125-1.064\" fill=\"#fff\"></path><path d=\"M284.857 179.69c0-.585.504-1.06 1.125-1.06.623 0 1.12.475 1.12 1.06 0 .59-.497 1.065-1.12 1.065-.62 0-1.125-.476-1.125-1.064z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M281.406 179.69c0-.585.502-1.06 1.12-1.06.618 0 1.12.475 1.12 1.06 0 .59-.502 1.065-1.12 1.065-.618 0-1.12-.476-1.12-1.064\" fill=\"#fff\"></path><path d=\"M281.406 179.69c0-.585.502-1.06 1.12-1.06.618 0 1.12.475 1.12 1.06 0 .59-.502 1.065-1.12 1.065-.618 0-1.12-.476-1.12-1.064z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M283.134 182.654c0-.59.503-1.065 1.12-1.065.623 0 1.122.475 1.122 1.064 0 .586-.5 1.065-1.122 1.065-.617 0-1.12-.48-1.12-1.066m.703 3.275c0-.59.502-1.066 1.12-1.066.623 0 1.126.478 1.126 1.067 0 .58-.503 1.057-1.125 1.057-.62 0-1.12-.476-1.12-1.057m.125 3.26c0-.593.503-1.066 1.125-1.066.62 0 1.12.473 1.12 1.066 0 .585-.5 1.062-1.12 1.062-.622 0-1.125-.477-1.125-1.062m-1.021 2.967c0-.586.502-1.065 1.12-1.065.623 0 1.122.48 1.122 1.065 0 .588-.5 1.062-1.122 1.062-.618 0-1.12-.474-1.12-1.062m-1.909 2.728c0-.586.504-1.065 1.12-1.065.622 0 1.123.48 1.123 1.065s-.5 1.06-1.122 1.06c-.617 0-1.12-.475-1.12-1.06\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M278.79 177.632c0-.585.504-1.06 1.126-1.06.618 0 1.12.475 1.12 1.06 0 .59-.502 1.065-1.12 1.065-.622 0-1.125-.476-1.125-1.065\" fill=\"#fff\"></path><path d=\"M278.79 177.632c0-.585.504-1.06 1.126-1.06.618 0 1.12.475 1.12 1.06 0 .59-.502 1.065-1.12 1.065-.622 0-1.125-.476-1.125-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M275.723 175.938c0-.586.5-1.065 1.122-1.065.618 0 1.12.48 1.12 1.065s-.502 1.06-1.12 1.06c-.622 0-1.123-.475-1.123-1.06\" fill=\"#fff\"></path><path d=\"M275.723 175.938c0-.586.5-1.065 1.122-1.065.618 0 1.12.48 1.12 1.065s-.502 1.06-1.12 1.06c-.622 0-1.123-.475-1.123-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M272.34 174.916c0-.586.504-1.058 1.125-1.058.618 0 1.122.472 1.122 1.058 0 .588-.504 1.066-1.122 1.066-.62 0-1.124-.478-1.124-1.066\" fill=\"#fff\"></path><path d=\"M272.34 174.916c0-.586.504-1.058 1.125-1.058.618 0 1.122.472 1.122 1.058 0 .588-.504 1.066-1.122 1.066-.62 0-1.124-.478-1.124-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M268.824 174.312c0-.585.504-1.06 1.12-1.06.623 0 1.122.475 1.122 1.06 0 .585-.5 1.062-1.12 1.062-.618 0-1.122-.477-1.122-1.062\" fill=\"#fff\"></path><path d=\"M268.824 174.312c0-.585.504-1.06 1.12-1.06.623 0 1.122.475 1.122 1.06 0 .585-.5 1.062-1.12 1.062-.618 0-1.122-.477-1.122-1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M265.38 174.37c0-.585.502-1.065 1.12-1.065.623 0 1.126.48 1.126 1.065 0 .59-.503 1.063-1.125 1.063-.618 0-1.12-.473-1.12-1.063\" fill=\"#fff\"></path><path d=\"M265.38 174.37c0-.585.502-1.065 1.12-1.065.623 0 1.126.48 1.126 1.065 0 .59-.503 1.063-1.125 1.063-.618 0-1.12-.473-1.12-1.063z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M261.797 174.974c0-.585.504-1.06 1.122-1.06.62 0 1.124.475 1.124 1.06 0 .592-.503 1.066-1.125 1.066-.62 0-1.123-.474-1.123-1.066\" fill=\"#fff\"></path><path d=\"M261.797 174.974c0-.585.504-1.06 1.122-1.06.62 0 1.124.475 1.124 1.06 0 .592-.503 1.066-1.125 1.066-.62 0-1.123-.474-1.123-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M258.48 176.12c0-.59.503-1.066 1.12-1.066.623 0 1.126.476 1.126 1.066 0 .585-.503 1.065-1.125 1.065-.617 0-1.12-.48-1.12-1.065\" fill=\"#fff\"></path><path d=\"M258.48 176.12c0-.59.503-1.066 1.12-1.066.623 0 1.126.476 1.126 1.066 0 .585-.503 1.065-1.125 1.065-.617 0-1.12-.48-1.12-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M202.297 203.442c0-.59.503-1.06 1.12-1.06.623 0 1.122.47 1.122 1.06 0 .59-.5 1.06-1.122 1.06-.618 0-1.12-.47-1.12-1.06\" fill=\"#fff\"></path><path d=\"M202.297 203.442c0-.59.503-1.06 1.12-1.06.623 0 1.122.47 1.122 1.06 0 .59-.5 1.06-1.122 1.06-.618 0-1.12-.47-1.12-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M200.76 200.722c0-.585.503-1.058 1.122-1.058.622 0 1.125.473 1.125 1.058 0 .593-.503 1.065-1.125 1.065-.62 0-1.12-.472-1.12-1.065\" fill=\"#fff\"></path><path d=\"M200.76 200.722c0-.585.503-1.058 1.122-1.058.622 0 1.125.473 1.125 1.058 0 .593-.503 1.065-1.125 1.065-.62 0-1.12-.472-1.12-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M199.736 197.574c0-.586.502-1.062 1.125-1.062.62 0 1.122.476 1.122 1.062 0 .588-.503 1.065-1.12 1.065-.624 0-1.126-.478-1.126-1.066\" fill=\"#fff\"></path><path d=\"M199.736 197.574c0-.586.502-1.062 1.125-1.062.62 0 1.122.476 1.122 1.062 0 .588-.503 1.065-1.12 1.065-.624 0-1.126-.478-1.126-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M199.61 194.194c0-.588.502-1.06 1.12-1.06.622 0 1.125.472 1.125 1.06 0 .59-.503 1.062-1.124 1.062-.618 0-1.12-.472-1.12-1.062\" fill=\"#fff\"></path><path d=\"M199.61 194.194c0-.588.502-1.06 1.12-1.06.622 0 1.125.472 1.125 1.06 0 .59-.503 1.062-1.124 1.062-.618 0-1.12-.472-1.12-1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M200.442 190.868c0-.585.503-1.058 1.12-1.058.62 0 1.123.473 1.123 1.058 0 .592-.504 1.065-1.123 1.065-.617 0-1.12-.473-1.12-1.065\" fill=\"#fff\"></path><path d=\"M200.442 190.868c0-.585.503-1.058 1.12-1.058.62 0 1.123.473 1.123 1.058 0 .592-.504 1.065-1.123 1.065-.617 0-1.12-.473-1.12-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M202.166 187.85c0-.59.503-1.062 1.126-1.062.617 0 1.12.473 1.12 1.062 0 .59-.503 1.066-1.12 1.066-.623 0-1.127-.476-1.127-1.066\" fill=\"#fff\"></path><path d=\"M202.166 187.85c0-.59.503-1.062 1.126-1.062.617 0 1.12.473 1.12 1.062 0 .59-.503 1.066-1.12 1.066-.623 0-1.127-.476-1.127-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M204.47 185.37c0-.59.503-1.065 1.125-1.065.617 0 1.12.476 1.12 1.065 0 .585-.503 1.06-1.12 1.06-.622 0-1.124-.475-1.124-1.06\" fill=\"#fff\"></path><path d=\"M204.47 185.37c0-.59.503-1.065 1.125-1.065.617 0 1.12.476 1.12 1.065 0 .585-.503 1.06-1.12 1.06-.622 0-1.124-.475-1.124-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M207.146 183.308c0-.59.503-1.066 1.125-1.066.62 0 1.123.476 1.123 1.066 0 .585-.504 1.06-1.122 1.06-.62 0-1.124-.475-1.124-1.06\" fill=\"#fff\"></path><path d=\"M207.146 183.308c0-.59.503-1.066 1.125-1.066.62 0 1.123.476 1.123 1.066 0 .585-.504 1.06-1.122 1.06-.62 0-1.124-.475-1.124-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M210.344 181.62c0-.588.503-1.057 1.126-1.057.618 0 1.12.47 1.12 1.058 0 .59-.502 1.067-1.12 1.067-.623 0-1.126-.476-1.126-1.066\" fill=\"#fff\"></path><path d=\"M210.344 181.62c0-.588.503-1.057 1.126-1.057.618 0 1.12.47 1.12 1.058 0 .59-.502 1.067-1.12 1.067-.623 0-1.126-.476-1.126-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M213.662 180.418c0-.586.503-1.062 1.12-1.062.623 0 1.126.476 1.126 1.062 0 .588-.503 1.064-1.125 1.064-.618 0-1.12-.476-1.12-1.064\" fill=\"#fff\"></path><path d=\"M213.662 180.418c0-.586.503-1.062 1.12-1.062.623 0 1.126.476 1.126 1.062 0 .588-.503 1.064-1.125 1.064-.618 0-1.12-.476-1.12-1.064z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M217.375 179.755c0-.585.502-1.065 1.12-1.065.62 0 1.122.48 1.122 1.065 0 .586-.503 1.063-1.12 1.063-.62 0-1.122-.477-1.122-1.063\" fill=\"#fff\"></path><path d=\"M217.375 179.755c0-.585.502-1.065 1.12-1.065.62 0 1.122.48 1.122 1.065 0 .586-.503 1.063-1.12 1.063-.62 0-1.122-.477-1.122-1.063z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M220.892 179.57c0-.586.502-1.058 1.125-1.058.617 0 1.12.472 1.12 1.058 0 .59-.503 1.066-1.12 1.066-.623 0-1.125-.477-1.125-1.066\" fill=\"#fff\"></path><path d=\"M220.892 179.57c0-.586.502-1.058 1.125-1.058.617 0 1.12.472 1.12 1.058 0 .59-.503 1.066-1.12 1.066-.623 0-1.125-.477-1.125-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M224.346 179.69c0-.585.504-1.06 1.122-1.06.622 0 1.125.475 1.125 1.06 0 .59-.503 1.065-1.125 1.065-.618 0-1.122-.476-1.122-1.064\" fill=\"#fff\"></path><path d=\"M224.346 179.69c0-.585.504-1.06 1.122-1.06.622 0 1.125.475 1.125 1.06 0 .59-.503 1.065-1.125 1.065-.618 0-1.122-.476-1.122-1.064z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M227.802 179.69c0-.585.503-1.06 1.122-1.06.62 0 1.125.475 1.125 1.06 0 .59-.505 1.065-1.126 1.065-.62 0-1.122-.476-1.122-1.064\" fill=\"#fff\"></path><path d=\"M227.802 179.69c0-.585.503-1.06 1.122-1.06.62 0 1.125.475 1.125 1.06 0 .59-.505 1.065-1.126 1.065-.62 0-1.122-.476-1.122-1.064z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M226.075 182.654c0-.59.503-1.065 1.12-1.065.623 0 1.126.475 1.126 1.064 0 .586-.502 1.065-1.124 1.065-.618 0-1.12-.48-1.12-1.066m-.705 3.275c0-.59.5-1.066 1.122-1.066.617 0 1.12.478 1.12 1.067 0 .58-.503 1.057-1.12 1.057-.623 0-1.122-.476-1.122-1.057m-.13 3.26c0-.593.503-1.066 1.125-1.066.617 0 1.12.473 1.12 1.066 0 .585-.503 1.062-1.12 1.062-.622 0-1.125-.477-1.125-1.062m1.025 2.967c0-.586.503-1.065 1.12-1.065.623 0 1.126.48 1.126 1.065 0 .588-.503 1.062-1.125 1.062-.618 0-1.12-.474-1.12-1.062m1.906 2.728c0-.586.505-1.065 1.12-1.065.624 0 1.127.48 1.127 1.065s-.502 1.06-1.125 1.06c-.616 0-1.12-.475-1.12-1.06\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M230.414 177.632c0-.585.503-1.06 1.12-1.06.622 0 1.125.475 1.125 1.06 0 .59-.504 1.065-1.125 1.065-.618 0-1.12-.476-1.12-1.065\" fill=\"#fff\"></path><path d=\"M230.414 177.632c0-.585.503-1.06 1.12-1.06.622 0 1.125.475 1.125 1.06 0 .59-.504 1.065-1.125 1.065-.618 0-1.12-.476-1.12-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M233.486 175.938c0-.586.502-1.065 1.12-1.065.62 0 1.125.48 1.125 1.065s-.503 1.06-1.124 1.06c-.618 0-1.12-.475-1.12-1.06\" fill=\"#fff\"></path><path d=\"M233.486 175.938c0-.586.502-1.065 1.12-1.065.62 0 1.125.48 1.125 1.065s-.503 1.06-1.124 1.06c-.618 0-1.12-.475-1.12-1.06z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M236.863 174.916c0-.586.505-1.058 1.125-1.058s1.12.472 1.12 1.058c0 .588-.5 1.066-1.12 1.066-.62 0-1.125-.478-1.125-1.066\" fill=\"#fff\"></path><path d=\"M236.863 174.916c0-.586.505-1.058 1.125-1.058s1.12.472 1.12 1.058c0 .588-.5 1.066-1.12 1.066-.62 0-1.125-.478-1.125-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M240.383 174.312c0-.585.504-1.06 1.122-1.06.623 0 1.126.475 1.126 1.06 0 .585-.502 1.062-1.125 1.062-.618 0-1.122-.477-1.122-1.062\" fill=\"#fff\"></path><path d=\"M240.383 174.312c0-.585.504-1.06 1.122-1.06.623 0 1.126.475 1.126 1.06 0 .585-.502 1.062-1.125 1.062-.618 0-1.122-.477-1.122-1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M243.83 174.37c0-.585.497-1.065 1.12-1.065.618 0 1.12.48 1.12 1.065 0 .59-.502 1.063-1.12 1.063-.623 0-1.12-.473-1.12-1.063\" fill=\"#fff\"></path><path d=\"M243.83 174.37c0-.585.497-1.065 1.12-1.065.618 0 1.12.48 1.12 1.065 0 .59-.502 1.063-1.12 1.063-.623 0-1.12-.473-1.12-1.063z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M247.41 174.974c0-.585.504-1.06 1.12-1.06.625 0 1.124.475 1.124 1.06 0 .592-.5 1.066-1.123 1.066-.616 0-1.12-.474-1.12-1.066\" fill=\"#fff\"></path><path d=\"M247.41 174.974c0-.585.504-1.06 1.12-1.06.625 0 1.124.475 1.124 1.06 0 .592-.5 1.066-1.123 1.066-.616 0-1.12-.474-1.12-1.066z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M250.725 176.12c0-.59.5-1.066 1.124-1.066.617 0 1.12.476 1.12 1.066 0 .585-.503 1.065-1.12 1.065-.624 0-1.125-.48-1.125-1.065\" fill=\"#fff\"></path><path d=\"M250.725 176.12c0-.59.5-1.066 1.124-1.066.617 0 1.12.476 1.12 1.066 0 .585-.503 1.065-1.12 1.065-.624 0-1.125-.48-1.125-1.065z\" fill=\"none\" stroke=\"#000\" stroke-width=\".399\"></path><path d=\"M222.264 244.134h-.947v-.946h-1.656v3.785h1.657v2.602h-3.55v7.573h1.894v15.143h-3.785v7.81h29.104v-7.81h-3.787V257.15h1.893v-7.573h-3.55v-2.602h1.657v-3.785h-1.657v.946h-.946v-.946h-1.657v.946h-1.182v-.946h-1.656v3.785h1.657v2.602h-3.55v-8.28h1.894v-3.786H232.2v.945h-.945v-.946h-1.657v.945h-.946v-.946h-1.893v3.784h1.892v8.28h-3.55v-2.6h1.657v-3.786h-1.657v.946h-.947v-.946h-1.892v.946zm-6.39 35.966h29.105m-29.105-1.894h29.104m-29.105-1.893h29.104m-29.105-1.892h29.104m-29.105-2.13h29.104m-25.32-1.655h21.533m-21.532-1.893h21.533m-21.532-2.13h21.533m-21.532-1.893h21.533m-21.532-1.894h21.533m-21.532-1.892h21.533m-21.532-1.894h21.533m-23.425-1.892h25.318m-25.318-1.893h25.318m-25.318-1.893h25.318m-25.318-1.893h25.318m-21.77-1.895h18.22m-10.884-1.892h3.55m-3.55-1.893h3.55m-3.55-1.893h3.55m-3.55-1.893h3.55m-5.443-2.365h7.334m-12.777 8.043h3.786m-5.442-2.366h7.1m-7.1 34.783v-1.894m0-1.893v-1.892m-1.892 1.893v1.893m3.55 0v-1.893m1.892 3.787v-1.894m0-1.893v-1.892m0-2.13v-1.655m0-1.893v-2.13m-1.893 7.81v-2.13m-3.55 2.13v-2.13m7.336 0v2.13m1.656-2.13v-1.657m-5.443-1.893v1.893m3.786-1.893v1.893m3.55-1.893v1.893m-1.894-1.893v-2.13m1.892-1.893v1.893m0-5.68v1.893m-1.893-3.786v1.894m1.892-3.786v1.892m-3.55-1.892v1.892m-3.785-1.892v1.892m-1.656-3.785v1.893m3.55-1.893v1.893m3.55-1.893v1.893m1.892-3.786v1.893m-3.55-1.893v1.893m-3.785-1.893v1.893m-1.656-3.786v1.892m7.1-1.893v1.892m-3.55-5.68v1.893m16.326-1.892h-3.785m5.443-2.366h-7.1m7.1 34.783v-1.894m0-1.893v-1.892m1.893 1.893v1.893m-3.55 0v-1.893m-1.893 3.787v-1.894m0-1.893v-1.892m0-2.13v-1.655m0-1.893v-2.13m1.893 7.81v-2.13m3.55 2.13v-2.13m-7.335 0v2.13m-1.656-2.13v-1.657m5.442-1.893v1.893m-3.785-1.893v1.893m-3.55-1.893v1.893m1.894-1.893v-2.13m-1.893-1.893v1.893m0-5.68v1.893m1.894-3.786v1.894m-1.893-3.786v1.892m3.55-1.892v1.892m3.786-1.892v1.892m1.657-3.785v1.893m-3.55-1.893v1.893m-3.55-1.893v1.893m-1.892-3.786v1.893m3.55-1.893v1.893m3.786-1.893v1.893m1.657-3.786v1.892m-7.1-1.893v1.892m3.55-5.68v1.893m-7.335 19.167v-2.13m0-5.678v-1.894m0 5.68v-1.894m0-5.678v-1.893m0-1.893v-1.893m0-3.787v-1.893m0-1.893v-1.893m-8.99 4.97h3.785m3.55-5.68h3.548m3.55 5.68h3.786\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".471\"></path><path d=\"M235.278 280.1v-4.97c0-.946-.474-3.785-4.97-3.785-4.26 0-4.732 2.84-4.732 3.785v4.97h9.702z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".471\"></path><path d=\"M227.232 275.367l-2.365-.237c0-.946.236-2.366.946-2.84l2.13 1.658c-.237.236-.71.946-.71 1.42zm6.388 0l2.367-.237c0-.946-.236-2.366-.946-2.84l-2.13 1.658c.238.236.71.946.71 1.42zM231.255 273l1.183-2.128c-.473-.237-1.42-.474-2.13-.474-.473 0-1.42.237-1.892.474l1.182 2.128h1.657zm-4.495-5.914v-5.206c0-1.42-.947-2.603-2.604-2.603-1.656 0-2.602 1.184-2.602 2.603v5.206h5.205zm7.334 0v-5.206c0-1.42.947-2.603 2.603-2.603 1.657 0 2.603 1.184 2.603 2.603v5.206h-5.206zm-1.894-12.778l.475-4.733h-4.496l.236 4.733h3.785zm3.55 0l-.472-4.733h4.73l-.472 4.733h-3.785zm-10.647 0l.237-4.733h-4.497l.474 4.733h3.786z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".471\"></path><path d=\"M233.62 280.1v-4.26c0-.71-.472-2.84-3.312-2.84-2.602 0-3.076 2.13-3.076 2.84v4.26h6.39zm-7.334-13.487v-4.497c0-1.182-.71-2.366-2.13-2.366s-2.13 1.184-2.13 2.366v4.497h4.26zm8.282 0v-4.497c0-1.182.71-2.366 2.13-2.366s2.13 1.184 2.13 2.366v4.497h-4.26z\" fill=\"#0039f0\"></path><path d=\"M239.502 287.75c0-10.344 7.452-18.73 16.644-18.73 9.195 0 16.648 8.386 16.648 18.73 0 10.345-7.453 18.73-16.648 18.73-9.192 0-16.644-8.385-16.644-18.73\" fill=\"#ad1519\"></path><path d=\"M239.502 287.75c0-10.344 7.452-18.73 16.644-18.73 9.195 0 16.648 8.386 16.648 18.73 0 10.345-7.453 18.73-16.648 18.73-9.192 0-16.644-8.385-16.644-18.73z\" fill=\"none\" stroke=\"#000\" stroke-width=\".625\"></path><path d=\"M244.44 287.714c0-7.585 5.24-13.734 11.713-13.734 6.47 0 11.71 6.15 11.71 13.734 0 7.588-5.24 13.74-11.71 13.74-6.473 0-11.714-6.152-11.714-13.74\" fill=\"#005bbf\"></path><path d=\"M244.44 287.714c0-7.585 5.24-13.734 11.713-13.734 6.47 0 11.71 6.15 11.71 13.734 0 7.588-5.24 13.74-11.71 13.74-6.473 0-11.714-6.152-11.714-13.74z\" fill=\"none\" stroke=\"#000\" stroke-width=\".625\"></path><path d=\"M250.62 278.26s-1.39 1.522-1.39 2.933c0 1.42.587 2.596.587 2.596-.21-.56-.778-.963-1.447-.963-.843 0-1.53.647-1.53 1.45 0 .233.14.597.248.796l.5 1.008c.164-.37.553-.578 1.006-.578.605 0 1.097.462 1.097 1.038 0 .086-.01.174-.032.253l-1.25.004v1.062h1.114l-.828 1.642 1.098-.428.828.934.86-.934 1.095.428-.825-1.643h1.113v-1.063l-1.252-.004a.936.936 0 0 1-.025-.253c0-.576.483-1.038 1.09-1.038.452 0 .84.207 1.01.58l.493-1.01c.11-.198.25-.562.25-.794 0-.804-.683-1.45-1.53-1.45-.67 0-1.233.402-1.444.96 0 0 .583-1.176.583-2.595 0-1.41-1.42-2.934-1.42-2.934\" fill=\"#c8b100\"></path><path d=\"M250.62 278.26s-1.39 1.522-1.39 2.933c0 1.42.587 2.596.587 2.596-.21-.56-.778-.963-1.447-.963-.843 0-1.53.647-1.53 1.45 0 .233.14.597.248.796l.5 1.008c.164-.37.553-.578 1.006-.578.605 0 1.097.462 1.097 1.038 0 .086-.01.174-.032.253l-1.25.004v1.062h1.114l-.828 1.642 1.098-.428.828.934.86-.934 1.095.428-.825-1.643h1.113v-1.063l-1.252-.004a.936.936 0 0 1-.025-.253c0-.576.483-1.038 1.09-1.038.452 0 .84.207 1.01.58l.493-1.01c.11-.198.25-.562.25-.794 0-.804-.683-1.45-1.53-1.45-.67 0-1.233.402-1.444.96 0 0 .583-1.176.583-2.595 0-1.41-1.42-2.934-1.42-2.934h.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".348\" stroke-linejoin=\"round\"></path><path d=\"M248.41 287.86h4.456v-1.063h-4.457v1.062z\" fill=\"#c8b100\"></path><path d=\"M248.41 287.86h4.456v-1.063h-4.457v1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".348\"></path><path d=\"M261.505 278.26s-1.39 1.522-1.39 2.933c0 1.42.584 2.596.584 2.596-.208-.56-.776-.963-1.444-.963-.85 0-1.532.647-1.532 1.45 0 .233.142.597.25.796l.494 1.008c.17-.37.558-.578 1.01-.578.607 0 1.094.462 1.094 1.038a.93.93 0 0 1-.03.253l-1.25.004v1.062h1.116l-.83 1.642 1.095-.428.832.934.857-.934 1.098.428-.83-1.643h1.114v-1.063l-1.247-.004a.895.895 0 0 1-.03-.253c0-.576.486-1.038 1.093-1.038.453 0 .84.207 1.006.58l.5-1.01c.107-.198.248-.562.248-.794 0-.804-.687-1.45-1.532-1.45-.667 0-1.237.402-1.446.96 0 0 .587-1.176.587-2.595 0-1.41-1.42-2.934-1.42-2.934\" fill=\"#c8b100\"></path><path d=\"M261.505 278.26s-1.39 1.522-1.39 2.933c0 1.42.584 2.596.584 2.596-.208-.56-.776-.963-1.444-.963-.85 0-1.532.647-1.532 1.45 0 .233.142.597.25.796l.494 1.008c.17-.37.558-.578 1.01-.578.607 0 1.094.462 1.094 1.038a.93.93 0 0 1-.03.253l-1.25.004v1.062h1.116l-.83 1.642 1.095-.428.832.934.857-.934 1.098.428-.83-1.643h1.114v-1.063l-1.247-.004a.895.895 0 0 1-.03-.253c0-.576.486-1.038 1.093-1.038.453 0 .84.207 1.006.58l.5-1.01c.107-.198.248-.562.248-.794 0-.804-.687-1.45-1.532-1.45-.667 0-1.237.402-1.446.96 0 0 .587-1.176.587-2.595 0-1.41-1.42-2.934-1.42-2.934h.002z\" fill=\"none\" stroke=\"#000\" stroke-width=\".348\" stroke-linejoin=\"round\"></path><path d=\"M259.293 287.86h4.455v-1.063h-4.455v1.062z\" fill=\"#c8b100\"></path><path d=\"M259.293 287.86h4.455v-1.063h-4.455v1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".348\"></path><path d=\"M256.062 287.622s-1.39 1.524-1.39 2.94c0 1.413.587 2.59.587 2.59-.212-.56-.777-.963-1.448-.963-.845 0-1.533.647-1.533 1.45 0 .237.14.596.25.796l.498 1.007c.17-.37.553-.58 1.005-.58.607 0 1.1.464 1.1 1.04a.92.92 0 0 1-.036.257l-1.247.003v1.062h1.117l-.83 1.644 1.095-.433.83.933.86-.933 1.098.432-.834-1.645h1.117v-1.062l-1.248-.003a.96.96 0 0 1-.03-.258c0-.575.488-1.04 1.095-1.04.452 0 .836.21 1.006.58l.5-1.006c.105-.2.248-.56.248-.796 0-.803-.687-1.45-1.532-1.45a1.54 1.54 0 0 0-1.448.963s.588-1.178.588-2.592c0-1.414-1.424-2.938-1.424-2.938\" fill=\"#c8b100\"></path><path d=\"M256.062 287.622s-1.39 1.524-1.39 2.94c0 1.413.587 2.59.587 2.59-.212-.56-.777-.963-1.448-.963-.845 0-1.533.647-1.533 1.45 0 .237.14.596.25.796l.498 1.007c.17-.37.553-.58 1.005-.58.607 0 1.1.464 1.1 1.04a.92.92 0 0 1-.036.257l-1.247.003v1.062h1.117l-.83 1.644 1.095-.433.83.933.86-.933 1.098.432-.834-1.645h1.117v-1.062l-1.248-.003a.96.96 0 0 1-.03-.258c0-.575.488-1.04 1.095-1.04.452 0 .836.21 1.006.58l.5-1.006c.105-.2.248-.56.248-.796 0-.803-.687-1.45-1.532-1.45a1.54 1.54 0 0 0-1.448.963s.588-1.178.588-2.592c0-1.414-1.424-2.938-1.424-2.938h.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".348\" stroke-linejoin=\"round\"></path><path d=\"M253.85 297.225h4.457v-1.062h-4.457v1.062z\" fill=\"#c8b100\"></path><path d=\"M253.85 297.225h4.457v-1.062h-4.457v1.062z\" fill=\"none\" stroke=\"#000\" stroke-width=\".348\"></path><path d=\"M289.378 238.29l-.296.022a1.58 1.58 0 0 1-.273.365c-.263.25-.658.28-.88.07a.504.504 0 0 1-.143-.42.533.533 0 0 1-.523-.007c-.264-.153-.33-.516-.137-.818.03-.06.06-.135.107-.18l-.02-.33-.356.085-.104.195c-.222.252-.553.317-.718.168a.592.592 0 0 1-.134-.27c.003.01-.085.088-.177.11-.548.134-.767-1.073-.78-1.385l-.18.255s.162.722.08 1.334a6.93 6.93 0 0 1-.296 1.222c.764.195 1.91.817 3.045 1.693 1.136.87 2.03 1.814 2.4 2.476 0 0 .588-.328 1.205-.524.612-.2 1.39-.204 1.39-.204l.222-.218c-.327.048-1.62.103-1.593-.44.004-.086.068-.18.08-.18a.72.72 0 0 1-.308-.07c-.187-.124-.183-.44.025-.702l.18-.13.01-.35-.345.048c-.032.043-.11.094-.157.138-.272.236-.664.254-.88.032a.45.45 0 0 1-.114-.477.584.584 0 0 1-.46-.048c-.265-.16-.315-.534-.11-.825a1.57 1.57 0 0 1 .315-.327l-.07-.306\" fill=\"#c8b100\"></path><path d=\"M289.378 238.29l-.296.022a1.58 1.58 0 0 1-.273.365c-.263.25-.658.28-.88.07a.504.504 0 0 1-.143-.42.533.533 0 0 1-.523-.007c-.264-.153-.33-.516-.137-.818.03-.06.06-.135.107-.18l-.02-.33-.356.085-.104.195c-.222.252-.553.317-.718.168a.592.592 0 0 1-.134-.27c.003.01-.085.088-.177.11-.548.134-.767-1.073-.78-1.385l-.18.255s.162.722.08 1.334a6.93 6.93 0 0 1-.296 1.222c.764.195 1.91.817 3.045 1.693 1.136.87 2.03 1.814 2.4 2.476 0 0 .588-.328 1.205-.524.612-.2 1.39-.204 1.39-.204l.222-.218c-.327.048-1.62.103-1.593-.44.004-.086.068-.18.08-.18a.72.72 0 0 1-.308-.07c-.187-.124-.183-.44.025-.702l.18-.13.01-.35-.345.048c-.032.043-.11.094-.157.138-.272.236-.664.254-.88.032a.45.45 0 0 1-.114-.477.584.584 0 0 1-.46-.048c-.265-.16-.315-.534-.11-.825a1.57 1.57 0 0 1 .315-.327l-.07-.306-.007-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M287.073 238.996c.05-.062.157-.06.238.003.08.06.104.16.054.218-.05.058-.153.058-.237-.007-.077-.057-.104-.156-.055-.213\"></path><path d=\"M287.073 238.996c.05-.062.157-.06.238.003.08.06.104.16.054.218-.05.058-.153.058-.237-.007-.077-.057-.104-.156-.055-.213z\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M288.044 239.814l-.335-.258c-.06-.048-.08-.123-.042-.167.038-.04.12-.04.18.002l.334.262.342.26c.058.042.08.12.042.166-.042.04-.122.036-.184-.007l-.338-.26\"></path><path d=\"M288.044 239.814l-.335-.258c-.06-.048-.08-.123-.042-.167.038-.04.12-.04.18.002l.334.262.342.26c.058.042.08.12.042.166-.042.04-.122.036-.184-.007l-.338-.26\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M286.26 238.592l-.266-.156c-.065-.04-.1-.116-.068-.167.026-.056.106-.063.172-.023l.263.157.27.156c.067.036.097.113.07.167-.03.047-.107.058-.175.02l-.265-.155\"></path><path d=\"M286.26 238.592l-.266-.156c-.065-.04-.1-.116-.068-.167.026-.056.106-.063.172-.023l.263.157.27.156c.067.036.097.113.07.167-.03.047-.107.058-.175.02l-.265-.155\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M285.203 237.862c.05-.054.158-.054.238.007.082.06.105.16.056.217-.052.058-.158.054-.24-.003-.08-.067-.103-.16-.053-.222\"></path><path d=\"M285.203 237.862c.05-.054.158-.054.238.007.082.06.105.16.056.217-.052.058-.158.054-.24-.003-.08-.067-.103-.16-.053-.222z\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M289.12 240.563c.05-.058.025-.152-.054-.218-.08-.062-.188-.065-.238-.003-.05.058-.027.156.053.217.08.062.188.062.24.003\"></path><path d=\"M289.12 240.563c.05-.058.025-.152-.054-.218-.08-.062-.188-.065-.238-.003-.05.058-.027.156.053.217.08.062.188.062.24.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M289.707 241.236l.218.21c.055.05.14.07.186.03.047-.036.04-.11-.012-.16l-.215-.214-.223-.22c-.053-.05-.137-.064-.184-.024-.05.032-.042.113.015.163l.217.216\"></path><path d=\"M289.707 241.236l.218.21c.055.05.14.07.186.03.047-.036.04-.11-.012-.16l-.215-.214-.223-.22c-.053-.05-.137-.064-.184-.024-.05.032-.042.113.015.163l.217.216\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M290.677 242.064c.05-.06.028-.155-.052-.22-.08-.063-.19-.066-.24-.004-.05.062-.026.156.055.22.08.06.19.064.237.004\"></path><path d=\"M290.677 242.064c.05-.06.028-.155-.052-.22-.08-.063-.19-.066-.24-.004-.05.062-.026.156.055.22.08.06.19.064.237.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M287.862 235.884l-.605.018-.118.89.064.142.157-.01.776-.522-.274-.52\" fill=\"#c8b100\"></path><path d=\"M287.862 235.884l-.605.018-.118.89.064.142.157-.01.776-.522-.274-.52\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M286.222 236.378l-.018.556.942.117.147-.062-.013-.152-.548-.73-.51.272\" fill=\"#c8b100\"></path><path d=\"M286.222 236.378l-.018.556.942.117.147-.062-.013-.152-.548-.73-.51.272\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M288.167 237.487l-.503.28-.55-.734-.01-.15.146-.062.945.114-.028.553\" fill=\"#c8b100\"></path><path d=\"M288.167 237.487l-.503.28-.55-.734-.01-.15.146-.062.945.114-.028.553\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M286.95 236.8a.298.298 0 0 1 .402-.095.268.268 0 0 1 .1.38.306.306 0 0 1-.402.097.272.272 0 0 1-.1-.382\" fill=\"#c8b100\"></path><path d=\"M286.95 236.8a.298.298 0 0 1 .402-.095.268.268 0 0 1 .1.38.306.306 0 0 1-.402.097.272.272 0 0 1-.1-.382z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M284.747 235.88c-.015.003-.132-.47-.262-.73-.088-.19-.4-.437-.4-.437.03-.058.423-.2.89.094.38.314-.03.888-.03.888s-.1.138-.195.185\" fill=\"#c8b100\"></path><path d=\"M284.747 235.88c-.015.003-.132-.47-.262-.73-.088-.19-.4-.437-.4-.437.03-.058.423-.2.89.094.38.314-.03.888-.03.888s-.1.138-.195.185h-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M285.805 236.2l-.43.37-.7-.607.063-.087.024-.15.947-.07.095.544\" fill=\"#c8b100\"></path><path d=\"M285.805 236.2l-.43.37-.7-.607.063-.087.024-.15.947-.07.095.544\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M284.62 235.82c.053-.152.187-.242.295-.21.106.04.15.19.1.34-.054.152-.188.24-.296.21-.112-.04-.154-.19-.1-.34\" fill=\"#c8b100\"></path><path d=\"M284.62 235.82c.053-.152.187-.242.295-.21.106.04.15.19.1.34-.054.152-.188.24-.296.21-.112-.04-.154-.19-.1-.34z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M290.182 237.335l-.603-.066-.254.868.047.15.158.003.845-.41-.193-.546\" fill=\"#c8b100\"></path><path d=\"M290.182 237.335l-.603-.066-.254.868.047.15.158.003.845-.41-.193-.546\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M288.482 237.603l-.096.55.914.24.153-.045.012-.148-.435-.804-.548.207\" fill=\"#c8b100\"></path><path d=\"M288.482 237.603l-.096.55.914.24.153-.045.012-.148-.435-.804-.548.207\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M290.248 238.956l-.54.215-.435-.8.01-.153.155-.04.913.24-.102.54\" fill=\"#c8b100\"></path><path d=\"M290.248 238.956l-.54.215-.435-.8.01-.153.155-.04.913.24-.102.54\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M289.142 238.12c.1-.124.29-.134.412-.04a.267.267 0 0 1 .046.39.31.31 0 0 1-.416.038.266.266 0 0 1-.042-.388\" fill=\"#c8b100\"></path><path d=\"M289.142 238.12c.1-.124.29-.134.412-.04a.267.267 0 0 1 .046.39.31.31 0 0 1-.416.038.266.266 0 0 1-.042-.388z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M292.207 239.215l.11.57-.895.298-.157-.032-.02-.148.374-.827.587.14\" fill=\"#c8b100\"></path><path d=\"M292.207 239.215l.11.57-.895.298-.157-.032-.02-.148.374-.827.587.14\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M292.045 240.847l-.57.127-.318-.85.036-.147.158-.02.872.355-.177.535\" fill=\"#c8b100\"></path><path d=\"M292.045 240.847l-.57.127-.318-.85.036-.147.158-.02.872.355-.177.535\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M290.494 239.268l-.185.528.872.352.16-.02.03-.147-.31-.845-.568.133\" fill=\"#c8b100\"></path><path d=\"M290.494 239.268l-.185.528.872.352.16-.02.03-.147-.31-.845-.568.133\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M291.458 240.258a.277.277 0 0 0 .016-.397.318.318 0 0 0-.42-.014.274.274 0 0 0-.01.398.308.308 0 0 0 .414.014\" fill=\"#c8b100\"></path><path d=\"M291.458 240.258a.277.277 0 0 0 .016-.397.318.318 0 0 0-.42-.014.274.274 0 0 0-.01.398.308.308 0 0 0 .414.014z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M292.866 242.104c-.003.016.51.027.807.09.21.045.538.282.538.282.058-.043.117-.433-.287-.807-.403-.29-.907.217-.907.217s-.122.12-.15.217\" fill=\"#c8b100\"></path><path d=\"M292.866 242.104c-.003.016.51.027.807.09.21.045.538.282.538.282.058-.043.117-.433-.287-.807-.403-.29-.907.217-.907.217s-.122.12-.15.217z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M292.313 241.188l-.295.477.776.523.095-.084.126-.043-.12-.894-.583.022\" fill=\"#c8b100\"></path><path d=\"M292.313 241.188l-.295.477.776.523.095-.084.126-.043-.12-.894-.583.022\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M292.95 242.21c.143-.08.212-.224.155-.316-.063-.095-.226-.106-.37-.025-.14.082-.21.22-.148.318.056.09.222.103.364.022\" fill=\"#c8b100\"></path><path d=\"M292.95 242.21c.143-.08.212-.224.155-.316-.063-.095-.226-.106-.37-.025-.14.082-.21.22-.148.318.056.09.222.103.364.022z\" fill=\"none\" stroke=\"#000\" stroke-width=\".266\"></path><path d=\"M333.666 218.77v.594h-2.596v-.593h.96v-1.337h-.634v-.596h.634v-.585h.626v.585h.625v.596h-.624v1.338h1.01\" fill=\"none\" stroke=\"#000\" stroke-width=\".307\"></path><path d=\"M179.352 231.578v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".02\"></path><path d=\"M179 231.578v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".031\"></path><path d=\"M178.667 231.578v-1.298m-.331 1.298v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".041\"></path><path d=\"M178.042 231.578v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M177.482 231.508l-.01-1.182m.274 1.197v-1.236\" fill=\"none\" stroke=\"#000\" stroke-width=\".061\"></path><path d=\"M176.964 231.455v-1.09m.262 1.12l-.007-1.158\" fill=\"none\" stroke=\"#000\" stroke-width=\".072\"></path><path d=\"M176.27 231.392v-.956m.228.972v-1.003m.234 1.034v-1.043\" fill=\"none\" stroke=\"#000\" stroke-width=\".082\"></path><path d=\"M176.026 231.385v-.926\" fill=\"none\" stroke=\"#000\" stroke-width=\".092\"></path><path d=\"M175.8 231.338v-.863\" fill=\"none\" stroke=\"#000\" stroke-width=\".102\"></path><path d=\"M175.556 231.314v-.8\" fill=\"none\" stroke=\"#000\" stroke-width=\".113\"></path><path d=\"M175.058 231.245l-.01-.638m.264.67v-.716m-.51.629v-.56\" fill=\"none\" stroke=\"#000\" stroke-width=\".123\"></path><path d=\"M174.57 231.144v-.465\" fill=\"none\" stroke=\"#000\" stroke-width=\".133\"></path><path d=\"M174.313 231.083v-.366\" fill=\"none\" stroke=\"#000\" stroke-width=\".143\"></path><path d=\"M174.05 231.052v-.272\" fill=\"none\" stroke=\"#000\" stroke-width=\".154\"></path><path d=\"M173.773 230.99v-.132\" fill=\"none\" stroke=\"#000\" stroke-width=\".184\"></path><path d=\"M180.755 231.508v-1.19m-.598 1.23l.01-1.26m-.445 1.274v-1.282\" fill=\"none\" stroke=\"#000\" stroke-width=\".01\"></path><path d=\"M332.27 231.6v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".02\"></path><path d=\"M331.917 231.6v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".031\"></path><path d=\"M331.584 231.6v-1.298m-.33 1.298v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".041\"></path><path d=\"M330.96 231.6v-1.298\" fill=\"none\" stroke=\"#000\" stroke-width=\".051\"></path><path d=\"M330.4 231.53l-.01-1.182m.274 1.197v-1.235\" fill=\"none\" stroke=\"#000\" stroke-width=\".061\"></path><path d=\"M329.88 231.476v-1.088m.264 1.12l-.01-1.16\" fill=\"none\" stroke=\"#000\" stroke-width=\".072\"></path><path d=\"M329.187 231.415v-.957m.228.972v-1.003m.234 1.034v-1.04\" fill=\"none\" stroke=\"#000\" stroke-width=\".082\"></path><path d=\"M328.944 231.407v-.925\" fill=\"none\" stroke=\"#000\" stroke-width=\".092\"></path><path d=\"M328.717 231.36v-.863\" fill=\"none\" stroke=\"#000\" stroke-width=\".102\"></path><path d=\"M328.473 231.337v-.8\" fill=\"none\" stroke=\"#000\" stroke-width=\".113\"></path><path d=\"M327.975 231.266l-.01-.637m.264.668v-.716m-.509.631v-.56\" fill=\"none\" stroke=\"#000\" stroke-width=\".123\"></path><path d=\"M327.486 231.167v-.466\" fill=\"none\" stroke=\"#000\" stroke-width=\".133\"></path><path d=\"M327.23 231.105v-.365\" fill=\"none\" stroke=\"#000\" stroke-width=\".143\"></path><path d=\"M326.968 231.074v-.273\" fill=\"none\" stroke=\"#000\" stroke-width=\".154\"></path><path d=\"M326.69 231.01v-.13\" fill=\"none\" stroke=\"#000\" stroke-width=\".184\"></path><path d=\"M333.672 231.53v-1.19m-.597 1.228l.007-1.258m-.443 1.274v-1.282\" fill=\"none\" stroke=\"#000\" stroke-width=\".01\"></path>", 579)
const _hoisted_581 = [
  DpFlagESvue_type_template_id_305428e2_hoisted_2
]
const _hoisted_582 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const _hoisted_583 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"#c60b1e\" d=\"M0 0h640v480H0z\"></path><path fill=\"#ffc400\" d=\"M0 120h640v240H0z\"></path><path d=\"M127.27 213.35s-.49 0-.76-.152c-.27-.157-1.084-.927-1.084-.927l-.652-.463-.593-.822s-.704-1.124-.38-2c.323-.873.866-1.183 1.356-1.44.49-.255 1.515-.564 1.515-.564s.818-.358 1.088-.412c.27-.05 1.25-.307 1.25-.307s.27-.152.54-.255c.273-.102.65-.102.87-.156.216-.053.76-.227 1.084-.244.504-.02 1.303.09 1.576.09.27 0 1.193.053 1.57.053.378 0 1.735-.106 2.116-.106.378 0 .652-.047 1.088 0 .432.05 1.19.306 1.41.412.217.103 1.52.566 2.006.72.49.15 1.684.357 2.228.614.54.26.87.692 1.14 1.052.274.36.324.75.433 1.01.102.255.106.807.003 1.064-.11.255-.494.784-.494.784l-.6.974-.757.614s-.544.518-.975.463c-.437-.043-4.832-.82-7.654-.82s-7.328.82-7.328.82\" fill=\"#ad1519\"></path><path d=\"M127.27 213.35s-.49 0-.76-.152c-.27-.157-1.084-.927-1.084-.927l-.652-.463-.593-.822s-.704-1.124-.38-2c.323-.873.866-1.183 1.356-1.44.49-.255 1.515-.564 1.515-.564s.818-.358 1.088-.412c.27-.05 1.25-.307 1.25-.307s.27-.152.54-.255c.273-.102.65-.102.87-.156.216-.053.76-.227 1.084-.244.504-.02 1.303.09 1.576.09.27 0 1.193.053 1.57.053.378 0 1.735-.106 2.116-.106.378 0 .652-.047 1.088 0 .432.05 1.19.306 1.41.412.217.103 1.52.566 2.006.72.49.15 1.684.357 2.228.614.54.26.87.692 1.14 1.052.274.36.324.75.433 1.01.102.255.106.807.003 1.064-.11.255-.494.784-.494.784l-.6.974-.757.614s-.544.518-.975.463c-.437-.043-4.832-.82-7.654-.82s-7.328.82-7.328.82h.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\" stroke-linejoin=\"round\"></path><path d=\"M133.306 207.055c0-1.326.593-2.396 1.324-2.396.73 0 1.325 1.07 1.325 2.395 0 1.32-.595 2.393-1.325 2.393s-1.324-1.073-1.324-2.393\" fill=\"#c8b100\"></path><path d=\"M133.306 207.055c0-1.326.593-2.396 1.324-2.396.73 0 1.325 1.07 1.325 2.395 0 1.32-.595 2.393-1.325 2.393s-1.324-1.073-1.324-2.393z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.047 207.055c0-1.22.274-2.208.608-2.208.34 0 .608.99.608 2.208 0 1.21-.27 2.2-.608 2.2-.334 0-.608-.99-.608-2.2\" fill=\"#c8b100\"></path><path d=\"M134.047 207.055c0-1.22.274-2.208.608-2.208.34 0 .608.99.608 2.208 0 1.21-.27 2.2-.608 2.2-.334 0-.608-.99-.608-2.2z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M133.762 204.522c0-.46.396-.842.886-.842s.886.382.886.842c0 .464-.396.835-.886.835s-.886-.37-.886-.835\" fill=\"#c8b100\"></path><path d=\"M135.274 204.226v.558h-1.37v-.558h.448v-1.258h-.593v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.34\" fill=\"#c8b100\"></path><path d=\"M135.274 204.226v.558h-1.37v-.558h.448v-1.258h-.593v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.34\" fill=\"none\" stroke=\"#000\" stroke-width=\".288\"></path><path d=\"M135.886 204.226v.558h-2.433v-.558h.9v-1.258h-.594v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.95\" fill=\"#c8b100\"></path><path d=\"M135.886 204.226v.558h-2.433v-.558h.9v-1.258h-.594v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.95\" fill=\"none\" stroke=\"#000\" stroke-width=\".288\"></path><path d=\"M134.903 203.715c.368.102.63.426.63.807 0 .464-.395.835-.885.835s-.886-.37-.886-.835c0-.388.277-.72.656-.81\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.65 213.198h-4.614l-.106-1.132-.217-1.18-.23-1.472c-1.272-1.678-2.44-2.78-2.834-2.543.093-.31.205-.54.45-.684 1.13-.672 3.462.94 5.216 3.59.158.24.31.483.443.726h3.81c.137-.24.288-.48.446-.727 1.75-2.648 4.085-4.26 5.212-3.59.245.144.357.376.454.686-.395-.23-1.562.866-2.84 2.544l-.227 1.473-.216 1.18-.106 1.13h-4.64\" fill=\"#c8b100\"></path><path d=\"M134.65 213.198h-4.614l-.106-1.132-.217-1.18-.23-1.472c-1.272-1.678-2.44-2.78-2.834-2.543.093-.31.205-.54.45-.684 1.13-.672 3.462.94 5.216 3.59.158.24.31.483.443.726h3.81c.137-.24.288-.48.446-.727 1.75-2.648 4.085-4.26 5.212-3.59.245.144.357.376.454.686-.395-.23-1.562.866-2.84 2.544l-.227 1.473-.216 1.18-.106 1.13h-4.643z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M126.852 206.827c.867-.51 2.893 1.095 4.538 3.59m11.087-3.59c-.87-.51-2.894 1.095-4.54 3.59\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M127.834 215.28c-.19-.548-.554-1.04-.554-1.04 1.868-.548 4.47-.892 7.364-.9 2.89.008 5.515.352 7.38.9l-.498.88c-.162.284-.373.777-.36.777-1.687-.517-3.862-.783-6.536-.786-2.67.004-5.24.33-6.58.822.014 0-.093-.31-.227-.65h.01\" fill=\"#c8b100\"></path><path d=\"M127.834 215.28c-.19-.548-.554-1.04-.554-1.04 1.868-.548 4.47-.892 7.364-.9 2.89.008 5.515.352 7.38.9l-.498.88c-.162.284-.373.777-.36.777-1.687-.517-3.862-.783-6.536-.786-2.67.004-5.24.33-6.58.822.014 0-.093-.31-.227-.65h.01\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.644 217.657c2.333-.004 4.906-.358 5.853-.603.638-.185 1.007-.47.94-.802-.032-.156-.17-.292-.353-.37-1.397-.447-3.906-.764-6.44-.768-2.53.004-5.057.32-6.45.767-.183.08-.32.216-.352.372-.07.33.302.617.935.802.95.245 3.535.6 5.867.603\" fill=\"#c8b100\"></path><path d=\"M134.644 217.657c2.333-.004 4.906-.358 5.853-.603.638-.185 1.007-.47.94-.802-.032-.156-.17-.292-.353-.37-1.397-.447-3.906-.764-6.44-.768-2.53.004-5.057.32-6.45.767-.183.08-.32.216-.352.372-.07.33.302.617.935.802.95.245 3.535.6 5.867.603z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M142.143 213.198l-.572-.514s-.54.333-1.22.23c-.677-.1-.896-.922-.896-.922s-.76.636-1.383.59c-.622-.056-1.03-.59-1.03-.59s-.675.483-1.273.436c-.597-.055-1.166-.798-1.166-.798s-.596.77-1.193.825c-.598.048-1.088-.52-1.088-.52s-.27.568-1.03.693c-.76.13-1.408-.59-1.408-.59s-.435.696-.95.877c-.514.18-1.195-.26-1.195-.26s-.11.26-.187.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.38-.873 7.23-.876 2.856.003 5.444.337 7.31.88l.19-.516\" fill=\"#c8b100\"></path><path d=\"M142.143 213.198l-.572-.514s-.54.333-1.22.23c-.677-.1-.896-.922-.896-.922s-.76.636-1.383.59c-.622-.056-1.03-.59-1.03-.59s-.675.483-1.273.436c-.597-.055-1.166-.798-1.166-.798s-.596.77-1.193.825c-.598.048-1.088-.52-1.088-.52s-.27.568-1.03.693c-.76.13-1.408-.59-1.408-.59s-.435.696-.95.877c-.514.18-1.195-.26-1.195-.26s-.11.26-.187.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.38-.873 7.23-.876 2.856.003 5.444.337 7.31.88l.19-.516h-.008z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.66 210.712l.268.05a.977.977 0 0 0-.053.356c0 .56.478 1.013 1.073 1.013.474 0 .874-.293 1.015-.698.018.01.104-.368.147-.362.032 0 .028.393.046.386.066.507.533.856 1.06.856.59 0 1.063-.453 1.063-1.012 0-.042 0-.083-.007-.123l.335-.335.183.426c-.073.13-.1.28-.1.44 0 .536.46.97 1.02.97.355 0 .664-.175.85-.434l.215-.273-.004.34c0 .332.145.632.473.687 0 0 .37.027.875-.368.496-.393.77-.72.77-.72l.03.402s-.487.804-.934 1.06c-.242.143-.617.293-.91.24-.31-.046-.533-.298-.65-.584-.22.132-.48.207-.762.207-.605 0-1.148-.334-1.363-.827-.28.3-.664.48-1.118.48a1.56 1.56 0 0 1-1.202-.552 1.547 1.547 0 0 1-1.05.406 1.564 1.564 0 0 1-1.282-.66c-.27.393-.745.66-1.278.66-.407 0-.778-.154-1.05-.406a1.56 1.56 0 0 1-1.204.552 1.49 1.49 0 0 1-1.116-.48c-.215.49-.76.827-1.364.827-.28 0-.543-.075-.763-.207-.115.286-.338.538-.648.585-.295.052-.665-.098-.91-.24-.447-.257-.973-1.06-.973-1.06l.07-.404s.276.327.77.72c.5.394.874.367.874.367.328-.055.472-.355.472-.688l-.004-.34.215.274c.183.26.494.433.85.433.56 0 1.017-.433 1.017-.968a.909.909 0 0 0-.096-.442l.18-.426.335.335a.71.71 0 0 0-.01.123c0 .56.476 1.012 1.07 1.012.525 0 .99-.35 1.058-.856.014.007.01-.386.046-.386.042-.007.132.373.147.362.14.405.543.7 1.018.7.59 0 1.07-.455 1.07-1.014a.91.91 0 0 0-.055-.357l.28-.048\" fill=\"#c8b100\"></path><path d=\"M134.66 210.712l.268.05a.977.977 0 0 0-.053.356c0 .56.478 1.013 1.073 1.013.474 0 .874-.293 1.015-.698.018.01.104-.368.147-.362.032 0 .028.393.046.386.066.507.533.856 1.06.856.59 0 1.063-.453 1.063-1.012 0-.042 0-.083-.007-.123l.335-.335.183.426c-.073.13-.1.28-.1.44 0 .536.46.97 1.02.97.355 0 .664-.175.85-.434l.215-.273-.004.34c0 .332.145.632.473.687 0 0 .37.027.875-.368.496-.393.77-.72.77-.72l.03.402s-.487.804-.934 1.06c-.242.143-.617.293-.91.24-.31-.046-.533-.298-.65-.584-.22.132-.48.207-.762.207-.605 0-1.148-.334-1.363-.827-.28.3-.664.48-1.118.48a1.56 1.56 0 0 1-1.202-.552 1.547 1.547 0 0 1-1.05.406 1.564 1.564 0 0 1-1.282-.66c-.27.393-.745.66-1.278.66-.407 0-.778-.154-1.05-.406a1.56 1.56 0 0 1-1.204.552 1.49 1.49 0 0 1-1.116-.48c-.215.49-.76.827-1.364.827-.28 0-.543-.075-.763-.207-.115.286-.338.538-.648.585-.295.052-.665-.098-.91-.24-.447-.257-.973-1.06-.973-1.06l.07-.404s.276.327.77.72c.5.394.874.367.874.367.328-.055.472-.355.472-.688l-.004-.34.215.274c.183.26.494.433.85.433.56 0 1.017-.433 1.017-.968a.909.909 0 0 0-.096-.442l.18-.426.335.335a.71.71 0 0 0-.01.123c0 .56.476 1.012 1.07 1.012.525 0 .99-.35 1.058-.856.014.007.01-.386.046-.386.042-.007.132.373.147.362.14.405.543.7 1.018.7.59 0 1.07-.455 1.07-1.014a.91.91 0 0 0-.055-.357l.28-.048h.008z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.644 213.345c-2.893.003-5.496.347-7.36.9-.127.04-.28-.056-.32-.168-.04-.118.05-.265.172-.306 1.875-.572 4.542-.933 7.508-.936 2.963.003 5.64.364 7.516.937.123.042.212.19.173.307-.036.112-.194.208-.317.168-1.867-.553-4.48-.897-7.372-.9\" fill=\"#c8b100\"></path><path d=\"M134.644 213.345c-2.893.003-5.496.347-7.36.9-.127.04-.28-.056-.32-.168-.04-.118.05-.265.172-.306 1.875-.572 4.542-.933 7.508-.936 2.963.003 5.64.364 7.516.937.123.042.212.19.173.307-.036.112-.194.208-.317.168-1.867-.553-4.48-.897-7.372-.9z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\" stroke-linejoin=\"round\"></path><path d=\"M131.844 214.37c0-.217.187-.395.42-.395.232 0 .418.178.418.396 0 .222-.186.395-.418.395-.233 0-.42-.173-.42-.394\" fill=\"#fff\"></path><path d=\"M131.844 214.37c0-.217.187-.395.42-.395.232 0 .418.178.418.396 0 .222-.186.395-.418.395-.233 0-.42-.173-.42-.394z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.677 214.542h-.93c-.17 0-.315-.137-.315-.3 0-.162.14-.294.31-.294h1.884a.3.3 0 0 1 .31.293c0 .165-.14.302-.313.302h-.946\" fill=\"#ad1519\"></path><path d=\"M134.677 214.542h-.93c-.17 0-.315-.137-.315-.3 0-.162.14-.294.31-.294h1.884a.3.3 0 0 1 .31.293c0 .165-.14.302-.313.302h-.946\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M130.015 214.86l-.665.1c-.17.024-.335-.085-.36-.248a.296.296 0 0 1 .26-.334l.668-.1.685-.105c.17-.02.327.086.356.246a.305.305 0 0 1-.264.336l-.68.105\" fill=\"#058e6e\"></path><path d=\"M130.015 214.86l-.665.1c-.17.024-.335-.085-.36-.248a.296.296 0 0 1 .26-.334l.668-.1.685-.105c.17-.02.327.086.356.246a.305.305 0 0 1-.264.336l-.68.105\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M127.326 215.328l.296-.476.63.12-.368.535-.558-.18\" fill=\"#ad1519\"></path><path d=\"M127.326 215.328l.296-.476.63.12-.368.535-.558-.18\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M136.61 214.37c0-.217.187-.395.42-.395.23 0 .418.178.418.396a.404.404 0 0 1-.417.395c-.233 0-.42-.173-.42-.394\" fill=\"#fff\"></path><path d=\"M136.61 214.37c0-.217.187-.395.42-.395.23 0 .418.178.418.396a.404.404 0 0 1-.417.395c-.233 0-.42-.173-.42-.394z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M139.276 214.86l.67.1a.314.314 0 0 0 .357-.248.294.294 0 0 0-.256-.334l-.673-.1-.68-.105c-.173-.02-.33.086-.357.246-.03.158.09.312.263.336l.676.105\" fill=\"#058e6e\"></path><path d=\"M139.276 214.86l.67.1a.314.314 0 0 0 .357-.248.294.294 0 0 0-.256-.334l-.673-.1-.68-.105c-.173-.02-.33.086-.357.246-.03.158.09.312.263.336l.676.105\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M141.91 215.356l-.236-.508-.648.054.31.57.575-.116\" fill=\"#ad1519\"></path><path d=\"M141.91 215.356l-.236-.508-.648.054.31.57.575-.116\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.636 217.115c-2.334-.003-4.447-.208-6.053-.623 1.606-.413 3.72-.67 6.053-.675 2.337.003 4.46.26 6.07.675-1.61.415-3.733.62-6.07.623\" fill=\"#ad1519\"></path><path d=\"M134.636 217.115c-2.334-.003-4.447-.208-6.053-.623 1.606-.413 3.72-.67 6.053-.675 2.337.003 4.46.26 6.07.675-1.61.415-3.733.62-6.07.623z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\" stroke-linejoin=\"round\"></path><path d=\"M142.005 212.05c.06-.18.004-.36-.125-.404-.13-.036-.288.08-.35.253-.06.183-.008.365.126.405.13.037.284-.075.35-.255\" fill=\"#c8b100\"></path><path d=\"M142.005 212.05c.06-.18.004-.36-.125-.404-.13-.036-.288.08-.35.253-.06.183-.008.365.126.405.13.037.284-.075.35-.255z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M137.355 211.15c.02-.188-.07-.355-.205-.372-.138-.017-.267.126-.288.314-.025.187.065.354.2.37.14.014.268-.13.293-.312\" fill=\"#c8b100\"></path><path d=\"M137.355 211.15c.02-.188-.07-.355-.205-.372-.138-.017-.267.126-.288.314-.025.187.065.354.2.37.14.014.268-.13.293-.312z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M131.95 211.15c-.02-.188.07-.355.208-.372.136-.017.266.126.29.314.023.187-.068.354-.205.37-.133.014-.267-.13-.292-.312\" fill=\"#c8b100\"></path><path d=\"M131.95 211.15c-.02-.188.07-.355.208-.372.136-.017.266.126.29.314.023.187-.068.354-.205.37-.133.014-.267-.13-.292-.312z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M127.3 212.05c-.06-.18-.003-.36.128-.404.13-.036.287.08.348.253.062.183.007.365-.126.405-.13.037-.285-.075-.35-.255\" fill=\"#c8b100\"></path><path d=\"M127.3 212.05c-.06-.18-.003-.36.128-.404.13-.036.287.08.348.253.062.183.007.365-.126.405-.13.037-.285-.075-.35-.255z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.636 208.463l-.823.497.612 1.326.21.14.21-.14.616-1.326-.824-.497\" fill=\"#c8b100\"></path><path d=\"M134.636 208.463l-.823.497.612 1.326.21.14.21-.14.616-1.326-.824-.497\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M132.834 210.468l.374.546 1.288-.397.134-.18-.138-.185-1.284-.375-.374.59\" fill=\"#c8b100\"></path><path d=\"M132.834 210.468l.374.546 1.288-.397.134-.18-.138-.185-1.284-.375-.374.59\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M136.45 210.468l-.373.546-1.29-.397-.136-.18.14-.185 1.287-.375.374.59\" fill=\"#c8b100\"></path><path d=\"M136.45 210.468l-.373.546-1.29-.397-.136-.18.14-.185 1.287-.375.374.59\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M129.28 209.053l-.647.61.827 1.092.22.087.162-.167.288-1.318-.85-.304\" fill=\"#c8b100\"></path><path d=\"M129.28 209.053l-.647.61.827 1.092.22.087.162-.167.288-1.318-.85-.304\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M127.923 211.24l.487.457 1.173-.633.09-.204-.17-.154-1.342-.116-.237.65\" fill=\"#c8b100\"></path><path d=\"M127.923 211.24l.487.457 1.173-.633.09-.204-.17-.154-1.342-.116-.237.65\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M131.467 210.53l-.25.602-1.346-.122-.172-.155.094-.207 1.177-.62.497.5\" fill=\"#c8b100\"></path><path d=\"M131.467 210.53l-.25.602-1.346-.122-.172-.155.094-.207 1.177-.62.497.5\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M126.628 211.41l-.108.64-1.342.14-.202-.117.043-.217 1.01-.84.598.395\" fill=\"#c8b100\"></path><path d=\"M126.628 211.41l-.108.64-1.342.14-.202-.117.043-.217 1.01-.84.598.395\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M129.22 210.863c0-.25.212-.45.472-.45s.47.2.47.45a.46.46 0 0 1-.47.446.46.46 0 0 1-.472-.447\" fill=\"#c8b100\"></path><path d=\"M129.22 210.863c0-.25.212-.45.472-.45s.47.2.47.45a.46.46 0 0 1-.47.446.46.46 0 0 1-.472-.447z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M140.02 209.053l.646.61-.828 1.092-.223.087-.157-.167-.292-1.318.853-.304\" fill=\"#c8b100\"></path><path d=\"M140.02 209.053l.646.61-.828 1.092-.223.087-.157-.167-.292-1.318.853-.304\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M141.372 211.24l-.486.457-1.174-.633-.093-.204.176-.154 1.343-.116.232.65\" fill=\"#c8b100\"></path><path d=\"M141.372 211.24l-.486.457-1.174-.633-.093-.204.176-.154 1.343-.116.232.65\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M137.833 210.53l.25.602 1.337-.122.178-.155-.098-.207-1.173-.62-.494.5\" fill=\"#c8b100\"></path><path d=\"M137.833 210.53l.25.602 1.337-.122.178-.155-.098-.207-1.173-.62-.494.5\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M142.484 211.41l.112.64 1.343.14.2-.117-.047-.217-1.01-.84-.6.395\" fill=\"#c8b100\"></path><path d=\"M142.484 211.41l.112.64 1.343.14.2-.117-.047-.217-1.01-.84-.6.395\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M134.173 210.44a.46.46 0 0 1 .47-.45c.264 0 .473.198.473.45a.46.46 0 0 1-.472.447.461.461 0 0 1-.47-.446\" fill=\"#c8b100\"></path><path d=\"M134.173 210.44a.46.46 0 0 1 .47-.45c.264 0 .473.198.473.45a.46.46 0 0 1-.472.447.461.461 0 0 1-.47-.446z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M139.144 210.863c0-.25.212-.45.47-.45a.46.46 0 0 1 .472.45.46.46 0 0 1-.47.446.46.46 0 0 1-.472-.447\" fill=\"#c8b100\"></path><path d=\"M139.144 210.863c0-.25.212-.45.47-.45a.46.46 0 0 1 .472.45.46.46 0 0 1-.47.446.46.46 0 0 1-.472-.447z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M124.814 212.158c-.015.01-.363-.464-.63-.702-.19-.167-.648-.31-.648-.31 0-.085.267-.276.558-.276a.54.54 0 0 1 .428.19l.04-.184s.234.045.342.308c.11.272.04.685.04.685s-.044.19-.13.288\" fill=\"#c8b100\"></path><path d=\"M124.814 212.158c-.015.01-.363-.464-.63-.702-.19-.167-.648-.31-.648-.31 0-.085.267-.276.558-.276a.54.54 0 0 1 .428.19l.04-.184s.234.045.342.308c.11.272.04.685.04.685s-.044.19-.13.288z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M124.832 211.923c.11-.116.342-.092.51.055.174.146.224.36.113.48-.112.12-.343.093-.512-.054-.172-.147-.222-.365-.11-.48\" fill=\"#c8b100\"></path><path d=\"M124.832 211.923c.11-.116.342-.092.51.055.174.146.224.36.113.48-.112.12-.343.093-.512-.054-.172-.147-.222-.365-.11-.48z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M144.302 212.158c.01.01.364-.464.63-.702.183-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.04-.184s-.234.045-.34.308c-.106.272-.038.685-.038.685s.04.19.13.288\" fill=\"#c8b100\"></path><path d=\"M144.302 212.158c.01.01.364-.464.63-.702.183-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.04-.184s-.234.045-.34.308c-.106.272-.038.685-.038.685s.04.19.13.288z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M144.312 211.923c-.11-.116-.34-.092-.513.055-.175.146-.225.36-.114.48.113.12.342.093.516-.054.172-.147.22-.365.11-.48\" fill=\"#c8b100\"></path><path d=\"M144.312 211.923c-.11-.116-.34-.092-.513.055-.175.146-.225.36-.114.48.113.12.342.093.516-.054.172-.147.22-.365.11-.48z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M123.997 223.074h21.395v-5.608h-21.395v5.608z\" fill=\"#c8b100\"></path><path d=\"M123.997 223.074h21.395v-5.608h-21.395v5.608z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M126.242 226.806a.934.934 0 0 1 .397-.06h16.02c.16 0 .31.026.436.077-.547-.183-.943-.68-.943-1.268 0-.586.428-1.094.982-1.285-.125.04-.313.08-.463.08H126.64a1.43 1.43 0 0 1-.45-.053l.086.014c.572.178.9.686.9 1.245a1.33 1.33 0 0 1-.934 1.25\" fill=\"#c8b100\"></path><path d=\"M126.242 226.806a.934.934 0 0 1 .397-.06h16.02c.16 0 .31.026.436.077-.547-.183-.943-.68-.943-1.268 0-.586.428-1.094.982-1.285-.125.04-.313.08-.463.08H126.64a1.43 1.43 0 0 1-.45-.053l.086.014c.572.178.9.686.9 1.245a1.33 1.33 0 0 1-.934 1.25z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M126.64 226.745h16.02c.544 0 .983.337.983.75 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75\" fill=\"#c8b100\"></path><path d=\"M126.64 226.745h16.02c.544 0 .983.337.983.75 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M126.64 223.074h16.032c.54 0 .983.286.983.634 0 .354-.444.64-.983.64H126.64c-.545 0-.984-.286-.984-.64 0-.348.44-.634.983-.634\" fill=\"#c8b100\"></path><path d=\"M126.64 223.074h16.032c.54 0 .983.286.983.634 0 .354-.444.64-.983.64H126.64c-.545 0-.984-.286-.984-.64 0-.348.44-.634.983-.634z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M149.63 317.45c-1.48 0-2.798-.31-3.77-.83-.965-.49-2.27-.79-3.71-.79-1.447 0-2.786.304-3.75.797-.97.51-2.308.822-3.77.822-1.48 0-2.797-.346-3.77-.863-.955-.47-2.238-.758-3.64-.758-1.452 0-2.74.276-3.705.777-.973.516-2.32.842-3.794.842v2.316c1.476 0 2.822-.337 3.795-.848.965-.498 2.253-.78 3.704-.78 1.398 0 2.68.29 3.64.763.97.516 2.29.866 3.77.866 1.462 0 2.8-.32 3.77-.823.964-.5 2.303-.805 3.75-.805 1.44 0 2.745.304 3.71.798.972.517 2.268.83 3.752.83l.017-2.317\" fill=\"#005bbf\"></path><path d=\"M149.63 317.45c-1.48 0-2.798-.31-3.77-.83-.965-.49-2.27-.79-3.71-.79-1.447 0-2.786.304-3.75.797-.97.51-2.308.822-3.77.822-1.48 0-2.797-.346-3.77-.863-.955-.47-2.238-.758-3.64-.758-1.452 0-2.74.276-3.705.777-.973.516-2.32.842-3.794.842v2.316c1.476 0 2.822-.337 3.795-.848.965-.498 2.253-.78 3.704-.78 1.398 0 2.68.29 3.64.763.97.516 2.29.866 3.77.866 1.462 0 2.8-.32 3.77-.823.964-.5 2.303-.805 3.75-.805 1.44 0 2.745.304 3.71.798.972.517 2.268.83 3.752.83l.017-2.317z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M149.63 319.766c-1.48 0-2.798-.313-3.77-.83-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.805-.97.504-2.308.823-3.77.823-1.48 0-2.797-.35-3.77-.865-.955-.473-2.238-.762-3.64-.762-1.452 0-2.74.282-3.705.78-.973.51-2.32.848-3.794.848v2.312c1.476 0 2.822-.33 3.795-.842.965-.505 2.253-.784 3.704-.784 1.398 0 2.68.29 3.64.764.97.515 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.825.964-.497 2.303-.8 3.75-.8 1.44 0 2.745.303 3.71.797.972.515 2.268.828 3.752.828l.017-2.312\" fill=\"#ccc\"></path><path d=\"M149.63 319.766c-1.48 0-2.798-.313-3.77-.83-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.805-.97.504-2.308.823-3.77.823-1.48 0-2.797-.35-3.77-.865-.955-.473-2.238-.762-3.64-.762-1.452 0-2.74.282-3.705.78-.973.51-2.32.848-3.794.848v2.312c1.476 0 2.822-.33 3.795-.842.965-.505 2.253-.784 3.704-.784 1.398 0 2.68.29 3.64.764.97.515 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.825.964-.497 2.303-.8 3.75-.8 1.44 0 2.745.303 3.71.797.972.515 2.268.828 3.752.828l.017-2.312\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M149.63 322.078c-1.48 0-2.798-.313-3.77-.828-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.8-.97.506-2.308.826-3.77.826-1.48 0-2.797-.347-3.77-.862-.955-.474-2.238-.764-3.64-.764-1.452 0-2.74.28-3.705.784-.973.512-2.32.842-3.794.842v2.31c1.476 0 2.822-.33 3.795-.844.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.268.827 3.752.827l.017-2.312\" fill=\"#005bbf\"></path><path d=\"M149.63 322.078c-1.48 0-2.798-.313-3.77-.828-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.8-.97.506-2.308.826-3.77.826-1.48 0-2.797-.347-3.77-.862-.955-.474-2.238-.764-3.64-.764-1.452 0-2.74.28-3.705.784-.973.512-2.32.842-3.794.842v2.31c1.476 0 2.822-.33 3.795-.844.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.268.827 3.752.827l.017-2.312\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M149.612 326.704c-1.484 0-2.78-.313-3.752-.83-.965-.492-2.27-.793-3.71-.793-1.447 0-2.786.302-3.75.8-.97.505-2.308.824-3.77.824-1.48 0-2.797-.348-3.77-.866-.955-.47-2.238-.757-3.64-.757-1.452 0-2.74.28-3.705.78-.973.514-2.32.844-3.794.844v-2.3c1.476 0 2.822-.345 3.795-.86.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.29.827 3.77.827l-.018 2.314\" fill=\"#ccc\"></path><path d=\"M149.612 326.704c-1.484 0-2.78-.313-3.752-.83-.965-.492-2.27-.793-3.71-.793-1.447 0-2.786.302-3.75.8-.97.505-2.308.824-3.77.824-1.48 0-2.797-.348-3.77-.866-.955-.47-2.238-.757-3.64-.757-1.452 0-2.74.28-3.705.78-.973.514-2.32.844-3.794.844v-2.3c1.476 0 2.822-.345 3.795-.86.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.29.827 3.77.827l-.018 2.314\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M149.612 329.02c-1.484 0-2.78-.315-3.752-.83-.965-.497-2.27-.8-3.71-.8-1.447 0-2.786.306-3.75.804-.97.504-2.308.825-3.77.825-1.48 0-2.797-.352-3.77-.867-.955-.473-2.238-.763-3.64-.763-1.452 0-2.74.283-3.705.783-.973.512-2.32.846-3.794.846v-2.296c1.476 0 2.822-.35 3.795-.865.965-.5 2.253-.775 3.704-.775 1.398 0 2.68.286 3.64.757.97.514 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.824.964-.498 2.303-.795 3.75-.795 1.44 0 2.745.297 3.71.79.972.516 2.283.83 3.765.83l-.013 2.314\" fill=\"#005bbf\"></path><path d=\"M149.612 329.02c-1.484 0-2.78-.315-3.752-.83-.965-.497-2.27-.8-3.71-.8-1.447 0-2.786.306-3.75.804-.97.504-2.308.825-3.77.825-1.48 0-2.797-.352-3.77-.867-.955-.473-2.238-.763-3.64-.763-1.452 0-2.74.283-3.705.783-.973.512-2.32.846-3.794.846v-2.296c1.476 0 2.822-.35 3.795-.865.965-.5 2.253-.775 3.704-.775 1.398 0 2.68.286 3.64.757.97.514 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.824.964-.498 2.303-.795 3.75-.795 1.44 0 2.745.297 3.71.79.972.516 2.283.83 3.765.83l-.013 2.314z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M126.242 307.952c.052.195.123.386.123.593 0 1.404-1.212 2.522-2.696 2.522h22.018c-1.483 0-2.697-1.118-2.697-2.522 0-.205.04-.398.093-.593a1.29 1.29 0 0 1-.422.05h-16.02c-.13 0-.282-.013-.398-.05\" fill=\"#c8b100\"></path><path d=\"M126.242 307.952c.052.195.123.386.123.593 0 1.404-1.212 2.522-2.696 2.522h22.018c-1.483 0-2.697-1.118-2.697-2.522 0-.205.04-.398.093-.593a1.29 1.29 0 0 1-.422.05h-16.02c-.13 0-.282-.013-.398-.05z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M126.64 306.496h16.02c.544 0 .983.34.983.754 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754\" fill=\"#c8b100\"></path><path d=\"M126.64 306.496h16.02c.544 0 .983.34.983.754 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M123.698 316.668h21.96v-5.6H123.7v5.6z\" fill=\"#c8b100\"></path><path d=\"M123.698 316.668h21.96v-5.6H123.7v5.6z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M121.98 286.673c-2.173 1.255-3.645 2.54-3.407 3.18.12.59.81 1.03 1.795 1.685 1.552 1.08 2.495 3.01 1.757 3.9 1.285-1.036 2.098-2.584 2.098-4.306 0-1.8-.856-3.422-2.242-4.46\" fill=\"#ad1519\"></path><path d=\"M121.98 286.673c-2.173 1.255-3.645 2.54-3.407 3.18.12.59.81 1.03 1.795 1.685 1.552 1.08 2.495 3.01 1.757 3.9 1.285-1.036 2.098-2.584 2.098-4.306 0-1.8-.856-3.422-2.242-4.46z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M126.844 305.59h15.604v-76.45h-15.604v76.45z\" fill=\"#ccc\"></path><path d=\"M137.967 229.244v76.285m1.753-76.286v76.285m-12.876.062h15.604v-76.45h-15.604v76.45z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M158.387 257.735c-3.405-1.407-9.193-2.45-15.834-2.67-2.29.02-4.842.234-7.477.673-9.333 1.557-16.443 5.283-15.877 8.318.01.064.03.196.045.255 0 0-3.497-7.883-3.556-8.184-.623-3.368 7.263-7.506 17.623-9.234 3.25-.543 6.42-.754 9.174-.727 6.628 0 12.387.85 15.856 2.138l.044 9.432\" fill=\"#ad1519\"></path><path d=\"M158.387 257.735c-3.405-1.407-9.193-2.45-15.834-2.67-2.29.02-4.842.234-7.477.673-9.333 1.557-16.443 5.283-15.877 8.318.01.064.03.196.045.255 0 0-3.497-7.883-3.556-8.184-.623-3.368 7.263-7.506 17.623-9.234 3.25-.543 6.42-.754 9.174-.727 6.628 0 12.387.85 15.856 2.138l.044 9.432\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M126.82 267.33c-4.328-.31-7.282-1.465-7.62-3.274-.268-1.442 1.194-3.038 3.807-4.486 1.166.125 2.48.286 3.837.286l-.025 7.475\" fill=\"#ad1519\"></path><path d=\"M126.82 267.33c-4.328-.31-7.282-1.465-7.62-3.274-.268-1.442 1.194-3.038 3.807-4.486 1.166.125 2.48.286 3.837.286l-.025 7.475\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M142.477 261.49c2.703.408 4.734 1.08 5.744 1.904l.092.166c.482.99-1.893 3.093-5.86 5.442l.025-7.513\" fill=\"#ad1519\"></path><path d=\"M142.477 261.49c2.703.408 4.734 1.08 5.744 1.904l.092.166c.482.99-1.893 3.093-5.86 5.442l.025-7.513\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M117.125 282.08c-.41-1.236 3.81-3.707 9.773-5.895 2.725-.975 4.975-1.992 7.763-3.22 8.285-3.664 14.404-7.867 13.652-9.4l-.083-.157c.442.358 1.125 7.908 1.125 7.908.757 1.405-4.844 5.546-12.472 9.2-2.44 1.167-7.595 3.072-10.028 3.924-4.352 1.51-8.68 4.358-8.282 5.414l-1.448-7.77\" fill=\"#ad1519\"></path><path d=\"M117.125 282.08c-.41-1.236 3.81-3.707 9.773-5.895 2.725-.975 4.975-1.992 7.763-3.22 8.285-3.664 14.404-7.867 13.652-9.4l-.083-.157c.442.358 1.125 7.908 1.125 7.908.757 1.405-4.844 5.546-12.472 9.2-2.44 1.167-7.595 3.072-10.028 3.924-4.352 1.51-8.68 4.358-8.282 5.414l-1.448-7.77v-.005z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M125.768 254.068c1.908-.696 3.157-1.518 2.545-3.02-.386-.956-1.372-1.14-2.844-.6l-2.61.947 2.35 5.792c.256-.116.51-.236.778-.334.262-.096.54-.168.81-.246l-1.03-2.536v-.002zm-1.134-2.796l.66-.24c.546-.2 1.165.09 1.44.765.203.515.15 1.087-.48 1.49a4.397 4.397 0 0 1-.673.313l-.946-2.328m7.231-2.422c-.274.073-.547.156-.825.21-.275.054-.56.085-.84.122l1.352 6.024 4.208-.845c-.05-.118-.116-.245-.14-.368-.03-.126-.025-.266-.033-.392-.737.212-1.544.44-2.512.635l-1.205-5.386m8.422 5.194c.795-2.185 1.756-4.28 2.702-6.4a5.287 5.287 0 0 1-1.04.07c-.503 1.537-1.13 3.074-1.79 4.605-.79-1.453-1.665-2.87-2.332-4.334-.327.042-.662.09-.993.113-.327.02-.67.015-.997.02a131.437 131.437 0 0 1 3.492 5.986c.154-.028.313-.065.48-.076.156-.01.32.005.478.01m8.797-4.63c.146-.294.295-.58.46-.853-.226-.215-.922-.527-1.736-.61-1.716-.17-2.702.593-2.817 1.63-.242 2.168 3.18 1.98 3.024 3.42-.068.62-.727.87-1.425.803-.78-.08-1.35-.508-1.45-1.145l-.213-.02a7.262 7.262 0 0 1-.455 1.106c.5.324 1.153.508 1.775.57 1.75.173 3.086-.528 3.212-1.68.227-2.06-3.23-2.18-3.096-3.393.057-.51.45-.846 1.343-.756.64.065 1.038.412 1.21.91l.17.018\" fill=\"#c8b100\"></path><path d=\"M277.852 211.606s-.705.743-1.22.85c-.515.1-1.166-.464-1.166-.464s-.464.483-1.033.612c-.57.13-1.36-.64-1.36-.64s-.54.77-1.028.95c-.49.18-1.083-.23-1.083-.23s-.216.38-.623.592c-.174.082-.46-.054-.46-.054l-.575-.358-.652-.695-.596-.234s-.27-.872-.298-1.025l-.08-.54c-.122-.624.838-1.348 2.21-1.658.788-.184 1.474-.17 1.98-.014.547-.466 1.706-.79 3.07-.79 1.234 0 2.318.26 2.916.667.59-.406 1.673-.668 2.912-.668 1.356 0 2.515.325 3.063.79.508-.155 1.19-.166 1.984.015 1.367.31 2.332 1.034 2.21 1.657l-.082.54c-.03.154-.3 1.026-.3 1.026l-.597.233-.652.694-.564.358s-.29.136-.462.054c-.407-.208-.627-.592-.627-.592s-.596.41-1.083.23c-.488-.18-1.032-.95-1.032-.95s-.785.77-1.358.64c-.568-.13-1.03-.612-1.03-.612s-.652.565-1.165.463c-.518-.106-1.216-.85-1.216-.85\" fill=\"#ad1519\"></path><path d=\"M277.852 211.606s-.705.743-1.22.85c-.515.1-1.166-.464-1.166-.464s-.464.483-1.033.612c-.57.13-1.36-.64-1.36-.64s-.54.77-1.028.95c-.49.18-1.083-.23-1.083-.23s-.216.38-.623.592c-.174.082-.46-.054-.46-.054l-.575-.358-.652-.695-.596-.234s-.27-.872-.298-1.025l-.08-.54c-.122-.624.838-1.348 2.21-1.658.788-.184 1.474-.17 1.98-.014.547-.466 1.706-.79 3.07-.79 1.234 0 2.318.26 2.916.667.59-.406 1.673-.668 2.912-.668 1.356 0 2.515.325 3.063.79.508-.155 1.19-.166 1.984.015 1.367.31 2.332 1.034 2.21 1.657l-.082.54c-.03.154-.3 1.026-.3 1.026l-.597.233-.652.694-.564.358s-.29.136-.462.054c-.407-.208-.627-.592-.627-.592s-.596.41-1.083.23c-.488-.18-1.032-.95-1.032-.95s-.785.77-1.358.64c-.568-.13-1.03-.612-1.03-.612s-.652.565-1.165.463c-.518-.106-1.216-.85-1.216-.85h-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".259\"></path><path d=\"M276.51 207.55c0-1.04.59-1.882 1.32-1.882.73 0 1.325.84 1.325 1.88 0 1.045-.594 1.89-1.325 1.89-.73 0-1.32-.845-1.32-1.89\" fill=\"#c8b100\"></path><path d=\"M276.51 207.55c0-1.04.59-1.882 1.32-1.882.73 0 1.325.84 1.325 1.88 0 1.045-.594 1.89-1.325 1.89-.73 0-1.32-.845-1.32-1.89z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.247 207.55c0-.955.274-1.732.61-1.732.336 0 .607.777.607 1.73 0 .96-.27 1.737-.608 1.737-.335 0-.61-.778-.61-1.736\" fill=\"#c8b100\"></path><path d=\"M277.247 207.55c0-.955.274-1.732.61-1.732.336 0 .607.777.607 1.73 0 .96-.27 1.737-.608 1.737-.335 0-.61-.778-.61-1.736z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M271.037 215.28a4.536 4.536 0 0 0-.56-1.04c1.87-.548 4.473-.892 7.367-.9 2.895.008 5.515.352 7.384.9l-.5.88c-.163.284-.376.777-.36.777-1.69-.517-3.863-.783-6.534-.786-2.675.004-5.246.33-6.585.822.018 0-.094-.31-.227-.65h.014\" fill=\"#c8b100\"></path><path d=\"M271.037 215.28a4.536 4.536 0 0 0-.56-1.04c1.87-.548 4.473-.892 7.367-.9 2.895.008 5.515.352 7.384.9l-.5.88c-.163.284-.376.777-.36.777-1.69-.517-3.863-.783-6.534-.786-2.675.004-5.246.33-6.585.822.018 0-.094-.31-.227-.65h.014\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.844 217.657c2.336-.004 4.907-.358 5.857-.603.634-.185 1.006-.47.936-.802-.03-.156-.168-.292-.353-.37-1.393-.447-3.904-.764-6.44-.768-2.528.004-5.052.32-6.45.767-.178.08-.32.216-.35.372-.07.33.3.617.938.802.948.245 3.53.6 5.864.603\" fill=\"#c8b100\"></path><path d=\"M277.844 217.657c2.336-.004 4.907-.358 5.857-.603.634-.185 1.006-.47.936-.802-.03-.156-.168-.292-.353-.37-1.393-.447-3.904-.764-6.44-.768-2.528.004-5.052.32-6.45.767-.178.08-.32.216-.35.372-.07.33.3.617.938.802.948.245 3.53.6 5.864.603z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M283.507 208.392c0-.23.194-.413.43-.413.243 0 .437.183.437.412 0 .228-.194.41-.436.41a.42.42 0 0 1-.43-.41\" fill=\"#fff\"></path><path d=\"M283.507 208.392c0-.23.194-.413.43-.413.243 0 .437.183.437.412 0 .228-.194.41-.436.41a.42.42 0 0 1-.43-.41zm-.244-1.439a.42.42 0 0 1 .432-.412c.24 0 .435.184.435.413 0 .225-.196.41-.435.41a.422.422 0 0 1-.432-.41zm-1.088-.9c0-.228.193-.412.436-.412.237 0 .433.185.433.412 0 .23-.196.413-.432.413a.422.422 0 0 1-.435-.413zm-1.358-.433c0-.232.195-.416.435-.416.242 0 .433.184.433.416 0 .222-.19.41-.433.41-.24 0-.435-.188-.435-.41zm-1.382.048c0-.23.194-.412.432-.412.242 0 .437.183.437.412 0 .228-.195.408-.437.408a.42.42 0 0 1-.432-.408z\" fill=\"none\" stroke=\"#000\" stroke-width=\".202\"></path><path d=\"M287.798 211.187c.13-.317.21-.67.21-1.033 0-1.527-1.21-2.768-2.712-2.768-.48 0-.93.13-1.32.354\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\" stroke-linecap=\"round\"></path><path d=\"M282.967 209.244c.14-.25.24-.552.24-.84 0-1.1-1.137-1.992-2.536-1.992-.597 0-1.145.163-1.576.432\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M288.172 209.933c0-.226.198-.413.436-.413.24 0 .435.187.435.413 0 .228-.195.41-.435.41-.238 0-.436-.182-.436-.41zm-.164-1.514c0-.23.197-.41.437-.41a.42.42 0 0 1 .433.41c0 .224-.195.408-.433.408-.24 0-.437-.184-.437-.41zm-.973-1.16a.42.42 0 0 1 .432-.41c.24 0 .434.185.434.41a.423.423 0 0 1-.433.412.423.423 0 0 1-.432-.412zm-1.304-.618c0-.224.196-.408.436-.408s.433.184.433.408c0 .23-.195.417-.434.417a.427.427 0 0 1-.435-.418zm-1.384.056c0-.23.194-.413.434-.413s.437.184.437.413c0 .224-.196.41-.437.41-.24 0-.434-.186-.434-.41z\" fill=\"none\" stroke=\"#000\" stroke-width=\".202\"></path><path d=\"M285.34 213.198l-.566-.514s-.544.333-1.223.23c-.676-.1-.893-.922-.893-.922s-.762.636-1.382.59c-.623-.056-1.03-.59-1.03-.59s-.68.483-1.277.436c-.597-.055-1.167-.798-1.167-.798s-.596.77-1.194.825c-.597.048-1.084-.52-1.084-.52s-.273.568-1.033.693c-.76.13-1.41-.59-1.41-.59s-.43.696-.948.877c-.514.18-1.19-.26-1.19-.26s-.11.26-.192.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.382-.873 7.232-.876 2.854.003 5.445.337 7.303.88l.19-.516\" fill=\"#c8b100\"></path><path d=\"M285.34 213.198l-.566-.514s-.544.333-1.223.23c-.676-.1-.893-.922-.893-.922s-.762.636-1.382.59c-.623-.056-1.03-.59-1.03-.59s-.68.483-1.277.436c-.597-.055-1.167-.798-1.167-.798s-.596.77-1.194.825c-.597.048-1.084-.52-1.084-.52s-.273.568-1.033.693c-.76.13-1.41-.59-1.41-.59s-.43.696-.948.877c-.514.18-1.19-.26-1.19-.26s-.11.26-.192.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.382-.873 7.232-.876 2.854.003 5.445.337 7.303.88l.19-.516h-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M271.258 208.392c0-.23.193-.413.435-.413.237 0 .432.183.432.412a.42.42 0 0 1-.432.41c-.242 0-.435-.182-.435-.41\" fill=\"#fff\"></path><path d=\"M271.258 208.392c0-.23.193-.413.435-.413.237 0 .432.183.432.412a.42.42 0 0 1-.432.41c-.242 0-.435-.182-.435-.41zm.245-1.439c0-.23.194-.412.435-.412.238 0 .432.184.432.413 0 .225-.194.41-.432.41-.24 0-.435-.185-.435-.41zm1.083-.9c0-.228.194-.412.435-.412.242 0 .437.185.437.412 0 .23-.195.413-.436.413a.424.424 0 0 1-.434-.413zm1.357-.433c0-.232.195-.416.435-.416.242 0 .436.184.436.416 0 .222-.194.41-.436.41-.24 0-.435-.188-.435-.41zm1.385.048c0-.23.194-.412.432-.412.242 0 .436.183.436.412 0 .228-.194.408-.436.408a.42.42 0 0 1-.432-.408z\" fill=\"none\" stroke=\"#000\" stroke-width=\".202\"></path><path d=\"M267.832 211.187a2.793 2.793 0 0 1-.21-1.033c0-1.527 1.213-2.768 2.712-2.768.48 0 .93.13 1.323.354\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\" stroke-linecap=\"round\"></path><path d=\"M272.697 209.21c-.14-.246-.275-.518-.275-.805 0-1.1 1.14-1.993 2.54-1.993a3 3 0 0 1 1.576.432\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M266.59 209.933c0-.226.192-.413.435-.413.235 0 .43.187.43.413a.42.42 0 0 1-.43.41c-.243 0-.436-.182-.436-.41zm.16-1.514c0-.23.198-.41.437-.41.24 0 .435.18.435.41 0 .224-.194.408-.435.408-.24 0-.436-.184-.436-.41zm.98-1.16c0-.225.194-.41.436-.41a.42.42 0 0 1 .432.41.423.423 0 0 1-.432.412.424.424 0 0 1-.436-.412zm1.303-.618c0-.224.194-.408.43-.408.244 0 .437.184.437.408 0 .23-.193.417-.436.417a.425.425 0 0 1-.43-.418zm1.382.056c0-.23.194-.413.436-.413a.42.42 0 0 1 .433.413.42.42 0 0 1-.432.41c-.24 0-.435-.186-.435-.41z\" fill=\"none\" stroke=\"#000\" stroke-width=\".202\"></path><path d=\"M277.86 210.712l.27.05a.998.998 0 0 0-.052.356c0 .56.48 1.013 1.07 1.013.475 0 .88-.293 1.016-.698.016.01.103-.368.146-.362.04 0 .033.393.043.386.07.507.536.856 1.062.856.59 0 1.068-.453 1.068-1.012a.712.712 0 0 0-.01-.123l.338-.335.18.426a.92.92 0 0 0-.1.44c0 .536.458.97 1.02.97.356 0 .67-.175.85-.434l.215-.273-.004.34c0 .332.146.632.47.687 0 0 .38.027.877-.368.5-.393.775-.72.775-.72l.028.402s-.49.804-.933 1.06c-.244.143-.616.293-.91.24-.314-.046-.533-.298-.65-.584a1.49 1.49 0 0 1-.765.207c-.604 0-1.147-.334-1.36-.827a1.5 1.5 0 0 1-1.12.48c-.48 0-.924-.215-1.202-.552a1.542 1.542 0 0 1-1.052.406c-.53 0-1.01-.267-1.28-.66-.27.393-.742.66-1.28.66-.406 0-.776-.154-1.05-.406a1.556 1.556 0 0 1-1.2.552c-.454 0-.84-.18-1.117-.48-.213.49-.76.827-1.36.827-.28 0-.54-.075-.763-.207-.115.286-.338.538-.648.585-.296.052-.667-.098-.91-.24-.45-.257-.977-1.06-.977-1.06l.07-.404s.27.327.77.72c.5.394.877.367.877.367.327-.055.467-.355.467-.688v-.34l.214.274c.184.26.496.433.85.433.566 0 1.022-.433 1.022-.968a.922.922 0 0 0-.1-.442l.18-.426.333.335c-.007.04-.007.08-.007.123 0 .56.476 1.012 1.06 1.012.53 0 .996-.35 1.064-.856.014.007.01-.386.046-.386.048-.007.133.373.148.362.14.405.543.7 1.018.7.592 0 1.07-.455 1.07-1.014a.982.982 0 0 0-.05-.357l.277-.048\" fill=\"#c8b100\"></path><path d=\"M277.86 210.712l.27.05a.998.998 0 0 0-.052.356c0 .56.48 1.013 1.07 1.013.475 0 .88-.293 1.016-.698.016.01.103-.368.146-.362.04 0 .033.393.043.386.07.507.536.856 1.062.856.59 0 1.068-.453 1.068-1.012a.712.712 0 0 0-.01-.123l.338-.335.18.426a.92.92 0 0 0-.1.44c0 .536.458.97 1.02.97.356 0 .67-.175.85-.434l.215-.273-.004.34c0 .332.146.632.47.687 0 0 .38.027.877-.368.5-.393.775-.72.775-.72l.028.402s-.49.804-.933 1.06c-.244.143-.616.293-.91.24-.314-.046-.533-.298-.65-.584a1.49 1.49 0 0 1-.765.207c-.604 0-1.147-.334-1.36-.827a1.5 1.5 0 0 1-1.12.48c-.48 0-.924-.215-1.202-.552a1.542 1.542 0 0 1-1.052.406c-.53 0-1.01-.267-1.28-.66-.27.393-.742.66-1.28.66-.406 0-.776-.154-1.05-.406a1.556 1.556 0 0 1-1.2.552c-.454 0-.84-.18-1.117-.48-.213.49-.76.827-1.36.827-.28 0-.54-.075-.763-.207-.115.286-.338.538-.648.585-.296.052-.667-.098-.91-.24-.45-.257-.977-1.06-.977-1.06l.07-.404s.27.327.77.72c.5.394.877.367.877.367.327-.055.467-.355.467-.688v-.34l.214.274c.184.26.496.433.85.433.566 0 1.022-.433 1.022-.968a.922.922 0 0 0-.1-.442l.18-.426.333.335c-.007.04-.007.08-.007.123 0 .56.476 1.012 1.06 1.012.53 0 .996-.35 1.064-.856.014.007.01-.386.046-.386.048-.007.133.373.148.362.14.405.543.7 1.018.7.592 0 1.07-.455 1.07-1.014a.982.982 0 0 0-.05-.357l.277-.048h.008z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.844 213.345c-2.894.003-5.493.347-7.36.9-.126.04-.28-.056-.32-.168-.04-.118.05-.265.17-.306 1.88-.572 4.545-.933 7.51-.936 2.963.003 5.64.364 7.517.937.125.042.216.19.177.307-.04.112-.2.208-.32.168-1.87-.553-4.478-.897-7.373-.9\" fill=\"#c8b100\"></path><path d=\"M277.844 213.345c-2.894.003-5.493.347-7.36.9-.126.04-.28-.056-.32-.168-.04-.118.05-.265.17-.306 1.88-.572 4.545-.933 7.51-.936 2.963.003 5.64.364 7.517.937.125.042.216.19.177.307-.04.112-.2.208-.32.168-1.87-.553-4.478-.897-7.373-.9z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M275.044 214.37c0-.217.187-.395.422-.395.23 0 .417.178.417.396a.404.404 0 0 1-.417.395c-.235 0-.422-.173-.422-.394\" fill=\"#fff\"></path><path d=\"M275.044 214.37c0-.217.187-.395.422-.395.23 0 .417.178.417.396a.404.404 0 0 1-.417.395c-.235 0-.422-.173-.422-.394z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.88 214.542h-.93c-.175 0-.32-.137-.32-.3 0-.162.14-.294.315-.294h1.883a.3.3 0 0 1 .308.293c0 .165-.14.302-.312.302h-.944\" fill=\"#ad1519\"></path><path d=\"M277.88 214.542h-.93c-.175 0-.32-.137-.32-.3 0-.162.14-.294.315-.294h1.883a.3.3 0 0 1 .308.293c0 .165-.14.302-.312.302h-.944\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M273.216 214.86l-.666.1a.316.316 0 0 1-.36-.248.294.294 0 0 1 .258-.334l.67-.1.683-.105c.172-.02.33.086.36.246a.302.302 0 0 1-.264.336l-.68.105\" fill=\"#058e6e\"></path><path d=\"M273.216 214.86l-.666.1a.316.316 0 0 1-.36-.248.294.294 0 0 1 .258-.334l.67-.1.683-.105c.172-.02.33.086.36.246a.302.302 0 0 1-.264.336l-.68.105\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M270.526 215.328l.296-.476.634.12-.368.535-.562-.18\" fill=\"#ad1519\"></path><path d=\"M270.526 215.328l.296-.476.634.12-.368.535-.562-.18\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M279.81 214.37c0-.217.19-.395.42-.395.232 0 .422.178.422.396 0 .222-.19.395-.42.395-.23 0-.42-.173-.42-.394\" fill=\"#fff\"></path><path d=\"M279.81 214.37c0-.217.19-.395.42-.395.232 0 .422.178.422.396 0 .222-.19.395-.42.395-.23 0-.42-.173-.42-.394z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M282.477 214.86l.67.1a.312.312 0 0 0 .356-.248.292.292 0 0 0-.255-.334l-.67-.1-.683-.105c-.173-.02-.332.086-.357.246-.03.158.094.312.263.336l.677.105\" fill=\"#058e6e\"></path><path d=\"M282.477 214.86l.67.1a.312.312 0 0 0 .356-.248.292.292 0 0 0-.255-.334l-.67-.1-.683-.105c-.173-.02-.332.086-.357.246-.03.158.094.312.263.336l.677.105\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M285.113 215.356l-.238-.508-.65.054.312.57.576-.116\" fill=\"#ad1519\"></path><path d=\"M285.113 215.356l-.238-.508-.65.054.312.57.576-.116\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.84 217.115c-2.335-.003-4.448-.208-6.057-.623 1.61-.413 3.722-.67 6.058-.675 2.337.003 4.46.26 6.065.675-1.604.415-3.728.62-6.064.623\" fill=\"#ad1519\"></path><path d=\"M277.84 217.115c-2.335-.003-4.448-.208-6.057-.623 1.61-.413 3.722-.67 6.058-.675 2.337.003 4.46.26 6.065.675-1.604.415-3.728.62-6.064.623z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\" stroke-linejoin=\"round\"></path><path d=\"M285.206 212.05c.06-.18.008-.36-.127-.404-.13-.036-.284.08-.346.253-.064.183-.008.365.122.405.13.037.288-.075.35-.255\" fill=\"#c8b100\"></path><path d=\"M285.206 212.05c.06-.18.008-.36-.127-.404-.13-.036-.284.08-.346.253-.064.183-.008.365.122.405.13.037.288-.075.35-.255z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M280.555 211.15c.025-.188-.07-.355-.205-.372-.133-.017-.267.126-.288.314-.025.187.064.354.202.37.136.014.266-.13.29-.312\" fill=\"#c8b100\"></path><path d=\"M280.555 211.15c.025-.188-.07-.355-.205-.372-.133-.017-.267.126-.288.314-.025.187.064.354.202.37.136.014.266-.13.29-.312z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M275.156 211.15c-.025-.188.064-.355.2-.372.138-.017.267.126.293.314.02.187-.07.354-.203.37-.136.014-.267-.13-.29-.312\" fill=\"#c8b100\"></path><path d=\"M275.156 211.15c-.025-.188.064-.355.2-.372.138-.017.267.126.293.314.02.187-.07.354-.203.37-.136.014-.267-.13-.29-.312z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M270.505 212.05c-.065-.18-.007-.36.122-.404.13-.036.288.08.35.253.06.183.007.365-.122.405-.134.037-.29-.075-.35-.255\" fill=\"#c8b100\"></path><path d=\"M270.505 212.05c-.065-.18-.007-.36.122-.404.13-.036.288.08.35.253.06.183.007.365-.122.405-.134.037-.29-.075-.35-.255z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.84 208.463l-.823.497.61 1.326.214.14.21-.14.615-1.326-.824-.497\" fill=\"#c8b100\"></path><path d=\"M277.84 208.463l-.823.497.61 1.326.214.14.21-.14.615-1.326-.824-.497\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M276.033 210.468l.376.546 1.284-.397.136-.18-.136-.185-1.285-.375-.377.59\" fill=\"#c8b100\"></path><path d=\"M276.033 210.468l.376.546 1.284-.397.136-.18-.136-.185-1.285-.375-.377.59\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M279.655 210.468l-.378.546-1.285-.397-.136-.18.136-.185 1.285-.375.378.59\" fill=\"#c8b100\"></path><path d=\"M279.655 210.468l-.378.546-1.285-.397-.136-.18.136-.185 1.285-.375.378.59\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M272.48 209.053l-.646.61.827 1.092.22.087.164-.167.29-1.318-.854-.304\" fill=\"#c8b100\"></path><path d=\"M272.48 209.053l-.646.61.827 1.092.22.087.164-.167.29-1.318-.854-.304\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M271.124 211.24l.485.457 1.173-.633.09-.204-.168-.154-1.342-.116-.24.65\" fill=\"#c8b100\"></path><path d=\"M271.124 211.24l.485.457 1.173-.633.09-.204-.168-.154-1.342-.116-.24.65\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M274.666 210.53l-.248.602-1.344-.122-.174-.155.092-.207 1.178-.62.496.5\" fill=\"#c8b100\"></path><path d=\"M274.666 210.53l-.248.602-1.344-.122-.174-.155.092-.207 1.178-.62.496.5\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M269.832 211.41l-.11.64-1.346.14-.204-.117.05-.217 1.012-.84.598.395\" fill=\"#c8b100\"></path><path d=\"M269.832 211.41l-.11.64-1.346.14-.204-.117.05-.217 1.012-.84.598.395\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M272.42 210.863c0-.25.213-.45.472-.45a.46.46 0 0 1 .47.45.46.46 0 0 1-.47.446.46.46 0 0 1-.472-.447\" fill=\"#c8b100\"></path><path d=\"M272.42 210.863c0-.25.213-.45.472-.45a.46.46 0 0 1 .47.45.46.46 0 0 1-.47.446.46.46 0 0 1-.472-.447z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M283.22 209.053l.647.61-.83 1.092-.22.087-.16-.167-.292-1.318.854-.304\" fill=\"#c8b100\"></path><path d=\"M283.22 209.053l.647.61-.83 1.092-.22.087-.16-.167-.292-1.318.854-.304\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M284.576 211.24l-.486.457-1.174-.633-.094-.204.174-.154 1.342-.116.238.65\" fill=\"#c8b100\"></path><path d=\"M284.576 211.24l-.486.457-1.174-.633-.094-.204.174-.154 1.342-.116.238.65\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M281.034 210.53l.247.602 1.345-.122.172-.155-.09-.207-1.176-.62-.496.5\" fill=\"#c8b100\"></path><path d=\"M281.034 210.53l.247.602 1.345-.122.172-.155-.09-.207-1.176-.62-.496.5\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M285.688 211.41l.108.64 1.34.14.204-.117-.05-.217-1.008-.84-.594.395\" fill=\"#c8b100\"></path><path d=\"M285.688 211.41l.108.64 1.34.14.204-.117-.05-.217-1.008-.84-.594.395\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M277.377 210.44c0-.252.207-.45.47-.45.257 0 .473.198.473.45 0 .245-.213.447-.472.447a.458.458 0 0 1-.47-.446\" fill=\"#c8b100\"></path><path d=\"M277.377 210.44c0-.252.207-.45.47-.45.257 0 .473.198.473.45 0 .245-.213.447-.472.447a.458.458 0 0 1-.47-.446z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M282.344 210.863c0-.25.212-.45.47-.45.263 0 .478.2.478.45 0 .245-.215.446-.477.446a.46.46 0 0 1-.47-.447\" fill=\"#c8b100\"></path><path d=\"M282.344 210.863c0-.25.212-.45.47-.45.263 0 .478.2.478.45 0 .245-.215.446-.477.446a.46.46 0 0 1-.47-.447z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M276.963 205.396c0-.465.396-.84.885-.84.488 0 .89.375.89.84 0 .463-.402.838-.89.838-.49 0-.885-.375-.885-.838\" fill=\"#c8b100\"></path><path d=\"M278.474 205.098v.556h-1.368v-.556h.448v-1.254h-.595v-.56h.594v-.547h.586v.548h.583v.56h-.583v1.253h.33\" fill=\"#c8b100\"></path><path d=\"M278.474 205.098v.556h-1.368v-.556h.448v-1.254h-.595v-.56h.594v-.547h.586v.548h.583v.56h-.583v1.253h.334z\" fill=\"none\" stroke=\"#000\" stroke-width=\".288\"></path><path d=\"M279.087 205.098v.556h-2.434v-.556h.9v-1.254h-.594v-.56h.594v-.547h.586v.548h.586v.56h-.586v1.253h.947\" fill=\"#c8b100\"></path><path d=\"M278.104 204.59c.366.1.633.424.633.806 0 .463-.395.838-.89.838-.488 0-.884-.375-.884-.838 0-.39.278-.713.655-.812\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M268.014 212.158c-.01.01-.364-.464-.63-.702-.187-.167-.647-.31-.647-.31 0-.085.27-.276.562-.276.168 0 .33.07.425.19l.034-.184s.237.045.34.308c.11.272.04.685.04.685s-.043.19-.126.288\" fill=\"#c8b100\"></path><path d=\"M268.014 212.158c-.01.01-.364-.464-.63-.702-.187-.167-.647-.31-.647-.31 0-.085.27-.276.562-.276.168 0 .33.07.425.19l.034-.184s.237.045.34.308c.11.272.04.685.04.685s-.043.19-.126.288z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M268.032 211.923c.113-.116.342-.092.512.055.173.146.223.36.11.48-.11.12-.338.093-.51-.054-.173-.147-.223-.365-.112-.48\" fill=\"#c8b100\"></path><path d=\"M268.032 211.923c.113-.116.342-.092.512.055.173.146.223.36.11.48-.11.12-.338.093-.51-.054-.173-.147-.223-.365-.112-.48z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M287.5 212.158c.016.01.364-.464.632-.702.184-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.035-.184s-.24.045-.343.308c-.108.272-.04.685-.04.685s.043.19.13.288\" fill=\"#c8b100\"></path><path d=\"M287.5 212.158c.016.01.364-.464.632-.702.184-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.035-.184s-.24.045-.343.308c-.108.272-.04.685-.04.685s.043.19.13.288z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M287.514 211.923c-.114-.116-.342-.092-.516.055-.173.146-.22.36-.112.48.112.12.342.093.514-.054.173-.147.225-.365.114-.48\" fill=\"#c8b100\"></path><path d=\"M287.514 211.923c-.114-.116-.342-.092-.516.055-.173.146-.22.36-.112.48.112.12.342.093.514-.054.173-.147.225-.365.114-.48z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M267.165 223.074h21.394v-5.608h-21.395v5.608z\" fill=\"#c8b100\"></path><path d=\"M267.165 223.074h21.394v-5.608h-21.395v5.608z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M286.315 226.806a.944.944 0 0 0-.396-.06h-16.023c-.16 0-.31.026-.443.077.55-.183.947-.68.947-1.268 0-.586-.43-1.094-.985-1.285.133.04.312.08.47.08h16.034c.16 0 .312-.008.448-.053l-.09.014c-.572.178-.9.686-.9 1.245 0 .538.363 1.078.937 1.25\" fill=\"#c8b100\"></path><path d=\"M286.315 226.806a.944.944 0 0 0-.396-.06h-16.023c-.16 0-.31.026-.443.077.55-.183.947-.68.947-1.268 0-.586-.43-1.094-.985-1.285.133.04.312.08.47.08h16.034c.16 0 .312-.008.448-.053l-.09.014c-.572.178-.9.686-.9 1.245 0 .538.363 1.078.937 1.25z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M269.897 226.745h16.022c.538 0 .978.337.978.75 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75\" fill=\"#c8b100\"></path><path d=\"M269.897 226.745h16.022c.538 0 .978.337.978.75 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M269.885 223.074h16.034c.538 0 .978.286.978.634 0 .354-.44.64-.98.64h-16.033c-.542 0-.982-.286-.982-.64 0-.348.44-.634.982-.634\" fill=\"#c8b100\"></path><path d=\"M269.885 223.074h16.034c.538 0 .978.286.978.634 0 .354-.44.64-.98.64h-16.033c-.542 0-.982-.286-.982-.64 0-.348.44-.634.982-.634z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M262.925 317.45c1.482 0 2.8-.31 3.77-.83.967-.49 2.273-.79 3.712-.79 1.444 0 2.787.304 3.752.797.964.51 2.302.822 3.764.822 1.476 0 2.8-.346 3.772-.863.957-.47 2.235-.758 3.642-.758 1.452 0 2.736.276 3.705.777.968.516 2.317.842 3.793.842v2.316c-1.476 0-2.825-.337-3.793-.848-.97-.498-2.253-.78-3.705-.78-1.407 0-2.685.29-3.642.763-.968.516-2.296.866-3.772.866-1.458 0-2.797-.32-3.765-.823-.966-.5-2.305-.805-3.753-.805-1.44 0-2.745.304-3.71.798-.973.517-2.27.83-3.75.83l-.022-2.317\" fill=\"#005bbf\"></path><path d=\"M262.925 317.45c1.482 0 2.8-.31 3.77-.83.967-.49 2.273-.79 3.712-.79 1.444 0 2.787.304 3.752.797.964.51 2.302.822 3.764.822 1.476 0 2.8-.346 3.772-.863.957-.47 2.235-.758 3.642-.758 1.452 0 2.736.276 3.705.777.968.516 2.317.842 3.793.842v2.316c-1.476 0-2.825-.337-3.793-.848-.97-.498-2.253-.78-3.705-.78-1.407 0-2.685.29-3.642.763-.968.516-2.296.866-3.772.866-1.458 0-2.797-.32-3.765-.823-.966-.5-2.305-.805-3.753-.805-1.44 0-2.745.304-3.71.798-.973.517-2.27.83-3.75.83l-.022-2.317z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M262.925 319.766c1.482 0 2.8-.313 3.77-.83.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.805.964.504 2.302.823 3.764.823 1.476 0 2.8-.35 3.772-.865.957-.473 2.235-.762 3.642-.762 1.452 0 2.736.282 3.705.78.968.51 2.317.848 3.793.848v2.312c-1.476 0-2.825-.33-3.793-.842-.97-.505-2.253-.784-3.705-.784-1.407 0-2.685.29-3.642.764-.968.515-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.825-.966-.497-2.305-.8-3.753-.8-1.44 0-2.745.303-3.71.797-.973.515-2.27.828-3.75.828l-.022-2.312\" fill=\"#ccc\"></path><path d=\"M262.925 319.766c1.482 0 2.8-.313 3.77-.83.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.805.964.504 2.302.823 3.764.823 1.476 0 2.8-.35 3.772-.865.957-.473 2.235-.762 3.642-.762 1.452 0 2.736.282 3.705.78.968.51 2.317.848 3.793.848v2.312c-1.476 0-2.825-.33-3.793-.842-.97-.505-2.253-.784-3.705-.784-1.407 0-2.685.29-3.642.764-.968.515-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.825-.966-.497-2.305-.8-3.753-.8-1.44 0-2.745.303-3.71.797-.973.515-2.27.828-3.75.828l-.022-2.312\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M262.925 322.078c1.482 0 2.8-.313 3.77-.828.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.8.964.506 2.302.826 3.764.826 1.476 0 2.8-.347 3.772-.862.957-.474 2.235-.764 3.642-.764 1.452 0 2.736.28 3.705.784.968.512 2.317.842 3.793.842v2.31c-1.476 0-2.825-.33-3.793-.844-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.27.827-3.75.827l-.022-2.312\" fill=\"#005bbf\"></path><path d=\"M262.925 322.078c1.482 0 2.8-.313 3.77-.828.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.8.964.506 2.302.826 3.764.826 1.476 0 2.8-.347 3.772-.862.957-.474 2.235-.764 3.642-.764 1.452 0 2.736.28 3.705.784.968.512 2.317.842 3.793.842v2.31c-1.476 0-2.825-.33-3.793-.844-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.27.827-3.75.827l-.022-2.312\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M262.946 326.704c1.48 0 2.778-.313 3.75-.83.966-.492 2.272-.793 3.71-.793 1.445 0 2.788.302 3.753.8.964.505 2.302.824 3.764.824 1.476 0 2.8-.348 3.772-.866.957-.47 2.235-.757 3.642-.757 1.452 0 2.736.28 3.705.78.968.514 2.317.844 3.793.844v-2.3c-1.476 0-2.825-.345-3.793-.86-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.29.827-3.772.827l.02 2.314\" fill=\"#ccc\"></path><path d=\"M262.946 326.704c1.48 0 2.778-.313 3.75-.83.966-.492 2.272-.793 3.71-.793 1.445 0 2.788.302 3.753.8.964.505 2.302.824 3.764.824 1.476 0 2.8-.348 3.772-.866.957-.47 2.235-.757 3.642-.757 1.452 0 2.736.28 3.705.78.968.514 2.317.844 3.793.844v-2.3c-1.476 0-2.825-.345-3.793-.86-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.29.827-3.772.827l.02 2.314\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M262.946 329.02c1.48 0 2.778-.315 3.75-.83.966-.497 2.272-.8 3.71-.8 1.445 0 2.788.306 3.753.804.964.504 2.302.825 3.764.825 1.476 0 2.8-.352 3.772-.867.957-.473 2.235-.763 3.642-.763 1.452 0 2.736.283 3.705.783.968.512 2.317.846 3.793.846v-2.296c-1.476 0-2.825-.35-3.793-.865-.97-.5-2.253-.775-3.705-.775-1.407 0-2.685.286-3.642.757-.968.514-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.824-.966-.498-2.305-.795-3.753-.795-1.44 0-2.745.297-3.71.79-.973.516-2.286.83-3.765.83l.014 2.314\" fill=\"#005bbf\"></path><path d=\"M262.946 329.02c1.48 0 2.778-.315 3.75-.83.966-.497 2.272-.8 3.71-.8 1.445 0 2.788.306 3.753.804.964.504 2.302.825 3.764.825 1.476 0 2.8-.352 3.772-.867.957-.473 2.235-.763 3.642-.763 1.452 0 2.736.283 3.705.783.968.512 2.317.846 3.793.846v-2.296c-1.476 0-2.825-.35-3.793-.865-.97-.5-2.253-.775-3.705-.775-1.407 0-2.685.286-3.642.757-.968.514-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.824-.966-.498-2.305-.795-3.753-.795-1.44 0-2.745.297-3.71.79-.973.516-2.286.83-3.765.83l.014 2.314z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M286.31 307.952c-.05.195-.117.386-.117.593 0 1.404 1.21 2.522 2.69 2.522H266.87c1.478 0 2.69-1.118 2.69-2.522 0-.205-.04-.398-.085-.593.12.045.27.05.418.05h16.022c.13 0 .28-.013.392-.05\" fill=\"#c8b100\"></path><path d=\"M286.31 307.952c-.05.195-.117.386-.117.593 0 1.404 1.21 2.522 2.69 2.522H266.87c1.478 0 2.69-1.118 2.69-2.522 0-.205-.04-.398-.085-.593.12.045.27.05.418.05h16.022c.13 0 .28-.013.392-.05h.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M269.897 306.496h16.022c.538 0 .978.34.978.754 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754\" fill=\"#c8b100\"></path><path d=\"M269.897 306.496h16.022c.538 0 .978.34.978.754 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M266.895 316.668h21.962v-5.6h-21.962v5.6z\" fill=\"#c8b100\"></path><path d=\"M266.895 316.668h21.962v-5.6h-21.962v5.6z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M290.572 286.673c2.175 1.255 3.65 2.54 3.413 3.18-.12.59-.81 1.03-1.796 1.685-1.553 1.08-2.5 3.01-1.76 3.9-1.282-1.036-2.093-2.584-2.093-4.306 0-1.8.854-3.422 2.235-4.46\" fill=\"#ad1519\"></path><path d=\"M290.572 286.673c2.175 1.255 3.65 2.54 3.413 3.18-.12.59-.81 1.03-1.796 1.685-1.553 1.08-2.5 3.01-1.76 3.9-1.282-1.036-2.093-2.584-2.093-4.306 0-1.8.854-3.422 2.235-4.46z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M270.106 305.59h15.604v-76.45h-15.604v76.45z\" fill=\"#ccc\"></path><path d=\"M281.425 229.11v76.29m1.754-76.287V305.4m-13.073.19h15.604v-76.45h-15.604v76.45z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M254.167 257.735c3.407-1.407 9.197-2.45 15.838-2.67 2.288.02 4.84.234 7.476.673 9.33 1.557 16.44 5.283 15.875 8.318-.01.064-.03.196-.047.255 0 0 3.5-7.883 3.553-8.184.627-3.368-7.256-7.506-17.615-9.234a53.48 53.48 0 0 0-9.176-.727c-6.63 0-12.39.85-15.86 2.138l-.043 9.432\" fill=\"#ad1519\"></path><path d=\"M254.167 257.735c3.407-1.407 9.197-2.45 15.838-2.67 2.288.02 4.84.234 7.476.673 9.33 1.557 16.44 5.283 15.875 8.318-.01.064-.03.196-.047.255 0 0 3.5-7.883 3.553-8.184.627-3.368-7.256-7.506-17.615-9.234a53.48 53.48 0 0 0-9.176-.727c-6.63 0-12.39.85-15.86 2.138l-.043 9.432\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M285.738 267.33c4.327-.31 7.282-1.465 7.617-3.274.27-1.442-1.195-3.038-3.805-4.486-1.17.125-2.484.286-3.84.286l.028 7.475\" fill=\"#ad1519\"></path><path d=\"M285.738 267.33c4.327-.31 7.282-1.465 7.617-3.274.27-1.442-1.195-3.038-3.805-4.486-1.17.125-2.484.286-3.84.286l.028 7.475\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M270.08 261.49c-2.706.408-4.734 1.08-5.748 1.904l-.09.166c-.486.99 1.892 3.093 5.86 5.442l-.02-7.513\" fill=\"#ad1519\"></path><path d=\"M270.08 261.49c-2.706.408-4.734 1.08-5.748 1.904l-.09.166c-.486.99 1.892 3.093 5.86 5.442l-.02-7.513\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M295.428 282.08c.41-1.236-3.81-3.707-9.772-5.895-2.725-.975-4.976-1.992-7.764-3.22-8.283-3.664-14.402-7.867-13.647-9.4l.08-.157c-.436.358-1.12 7.908-1.12 7.908-.755 1.405 4.846 5.546 12.464 9.2 2.44 1.167 7.598 3.072 10.032 3.924 4.352 1.51 8.676 4.358 8.283 5.414l1.443-7.77\" fill=\"#ad1519\"></path><path d=\"M295.428 282.08c.41-1.236-3.81-3.707-9.772-5.895-2.725-.975-4.976-1.992-7.764-3.22-8.283-3.664-14.402-7.867-13.647-9.4l.08-.157c-.436.358-1.12 7.908-1.12 7.908-.755 1.405 4.846 5.546 12.464 9.2 2.44 1.167 7.598 3.072 10.032 3.924 4.352 1.51 8.676 4.358 8.283 5.414l1.443-7.77v-.005z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M263.892 254.385c.59-2.24 1.353-4.405 2.102-6.597-.165.045-.344.08-.51.106a5.2 5.2 0 0 1-.522.047c-.356 1.576-.84 3.16-1.357 4.74-.922-1.384-1.926-2.728-2.725-4.125-.32.065-.652.143-.98.192-.32.047-.662.07-.992.102a131.248 131.248 0 0 1 4.032 5.674c.154-.04.304-.092.475-.116.154-.02.316-.017.477-.023m5.934-6.552c-.286.013-.57.034-.855.03-.282-.004-.566-.037-.847-.058l-.116 6.156 4.305.074c-.022-.126-.054-.263-.05-.392 0-.127.04-.26.06-.386-.77.05-1.61.1-2.598.082l.102-5.505m6.757 1.011c.688.058 1.35.177 2.013.297-.012-.13-.032-.26-.022-.393.01-.126.06-.253.094-.376l-5.83-.483c.015.13.037.257.023.382-.01.137-.058.26-.09.385a19.3 19.3 0 0 1 2.113.048l-.508 5.54c.284.006.568.003.85.026.283.022.565.073.845.115l.508-5.54m2.388 6.067c.28.044.564.077.843.14.277.057.548.147.818.224l.69-2.83.076.018c.16.388.37.862.48 1.135l.863 2.138c.338.054.675.098 1.008.17.34.075.668.174.996.266l-.298-.64c-.465-.966-.954-1.927-1.357-2.904 1.073.047 1.905-.342 2.113-1.204.148-.6-.09-1.07-.656-1.474-.416-.296-1.226-.453-1.748-.57l-2.35-.513-1.476 6.043m3.015-5.205c.678.15 1.524.26 1.524 1.03-.004.193-.023.33-.054.452-.22.904-.904 1.217-2.045.876l.575-2.358m8.082 7.05c-.052.668-.17 1.316-.3 2.018.294.14.586.266.87.422.285.158.547.33.82.502l.577-6.942a3.41 3.41 0 0 1-.75-.41l-6.12 3.888c.163.078.33.15.488.235.16.09.292.184.45.273.514-.433 1.054-.784 1.674-1.244l2.29 1.254v.003zm-1.734-1.585l2.038-1.32-.237 2.302-1.8-.982\" fill=\"#c8b100\"></path><path d=\"M182.19 192.43c0-1.09.933-1.973 2.08-1.973 1.146 0 2.082.883 2.082 1.974 0 1.09-.932 1.97-2.08 1.97-1.15 0-2.08-.88-2.08-1.97z\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M205.663 175.414c6.38 0 12.055.944 15.752 2.41 2.116.955 4.957 1.66 8.067 2.076 2.368.317 4.618.38 6.576.232 2.618-.05 6.404.715 10.19 2.382 3.135 1.39 5.752 3.082 7.49 4.72l-1.504 1.34-.435 3.802-4.127 4.724-2.062 1.75-4.884 3.91-2.495.204-.757 2.16-31.602-3.704-31.696 3.703-.76-2.16-2.498-.202-4.884-3.91-2.062-1.75-4.125-4.724-.43-3.803-1.51-1.34c1.745-1.637 4.362-3.328 7.49-4.72 3.787-1.666 7.574-2.432 10.19-2.38 1.957.148 4.208.084 6.576-.233 3.113-.416 5.956-1.12 8.068-2.076 3.7-1.466 9.06-2.41 15.435-2.41z\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M206.148 217.132c-11.774-.017-22.32-1.41-29.846-3.678-.55-.167-.84-.672-.807-1.194-.01-.507.275-.967.807-1.128 7.526-2.264 18.072-3.658 29.846-3.675 11.77.017 22.31 1.41 29.838 3.675.532.16.812.62.802 1.128.03.522-.255 1.027-.802 1.194-7.527 2.267-18.067 3.66-29.838 3.678\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.12 215.587c-10.626-.013-20.23-1.24-27.54-3.128 7.31-1.894 16.914-3.05 27.54-3.07 10.622.02 20.277 1.176 27.588 3.07-7.31 1.887-16.966 3.114-27.59 3.127\" fill=\"#ad1519\"></path><path d=\"M206.908 215.652v-6.305\" fill=\"none\" stroke=\"#000\" stroke-width=\".086\"></path><path d=\"M205.196 215.652v-6.305\" fill=\"none\" stroke=\"#000\" stroke-width=\".134\"></path><path d=\"M203.58 215.652v-6.305\" fill=\"none\" stroke=\"#000\" stroke-width=\".173\"></path><path d=\"M201.977 215.652v-6.305\" fill=\"none\" stroke=\"#000\" stroke-width=\".221\"></path><path d=\"M200.548 215.652v-6.305\" fill=\"none\" stroke=\"#000\" stroke-width=\".269\"></path><path d=\"M197.825 215.312l-.038-5.738m1.33 5.814v-6.003\" fill=\"none\" stroke=\"#000\" stroke-width=\".317\"></path><path d=\"M195.31 215.053v-5.286m1.274 5.438l-.037-5.626\" fill=\"none\" stroke=\"#000\" stroke-width=\".355\"></path><path d=\"M191.938 214.752v-4.645m1.106 4.72v-4.87m1.14 5.022v-5.063\" fill=\"none\" stroke=\"#000\" stroke-width=\".403\"></path><path d=\"M190.755 214.714v-4.494\" fill=\"none\" stroke=\"#000\" stroke-width=\".442\"></path><path d=\"M189.653 214.487v-4.19\" fill=\"none\" stroke=\"#000\" stroke-width=\".49\"></path><path d=\"M188.47 214.374v-3.89\" fill=\"none\" stroke=\"#000\" stroke-width=\".538\"></path><path d=\"M186.05 214.035l-.038-3.097m1.28 3.248v-3.475\" fill=\"none\" stroke=\"#000\" stroke-width=\".576\"></path><path d=\"M184.81 213.77v-2.72\" fill=\"none\" stroke=\"#000\" stroke-width=\".605\"></path><path d=\"M183.673 213.55v-2.266\" fill=\"none\" stroke=\"#000\" stroke-width=\".653\"></path><path d=\"M182.433 213.248v-1.774\" fill=\"none\" stroke=\"#000\" stroke-width=\".701\"></path><path d=\"M181.158 213.097v-1.32\" fill=\"none\" stroke=\"#000\" stroke-width=\".739\"></path><path d=\"M179.81 212.795v-.642\" fill=\"none\" stroke=\"#000\" stroke-width=\".874\"></path><path d=\"M213.72 215.312v-5.776m-2.9 5.965l.038-6.115m-2.153 6.192v-6.23\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M206.066 207.447c-11.914.023-22.608 1.517-30.135 3.836.626-.298.57-1.068-.208-3.07-.94-2.426-2.404-2.32-2.404-2.32 8.322-2.457 19.905-3.995 32.798-4.013 12.898.018 24.575 1.556 32.897 4.013 0 0-1.465-.106-2.404 2.32-.78 2.002-.837 2.772-.21 3.07-7.526-2.32-18.42-3.813-30.334-3.836\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.116 201.883c-12.893.02-24.476 1.555-32.798 4.017-.555.166-1.142-.05-1.32-.576-.18-.526.118-1.13.673-1.3 8.358-2.563 20.24-4.172 33.45-4.2 13.212.025 25.14 1.637 33.497 4.2.555.17.854.774.674 1.3-.18.525-.766.742-1.32.576-8.323-2.462-19.956-3.996-32.854-4.017\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.12 215.587c-10.626-.013-20.23-1.24-27.54-3.128 7.31-1.894 16.914-3.05 27.54-3.07 10.622.02 20.277 1.176 27.588 3.07-7.31 1.887-16.966 3.114-27.59 3.127z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\" stroke-linejoin=\"round\"></path><path d=\"M196.92 204.812c0-.55.47-.995 1.05-.995.584 0 1.057.446 1.057.995 0 .548-.473 1-1.056 1-.58 0-1.05-.452-1.05-1\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.142 205.596h-3.154c-.582 0-1.065-.443-1.065-.995 0-.548.472-.997 1.052-.997h6.376c.58 0 1.054.45 1.054.998 0 .553-.482.996-1.067.996h-3.195\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M190.293 206.465l-2.27.263c-.578.07-1.115-.32-1.187-.863-.07-.548.34-1.046.92-1.11l2.282-.266 2.32-.268c.576-.067 1.102.314 1.174.863.07.545-.352 1.046-.928 1.11l-2.31.27\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M181.072 206.664c0-.55.47-.996 1.05-.996.584 0 1.055.447 1.055.996 0 .552-.47.998-1.055.998-.58 0-1.05-.446-1.05-.998\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M174.056 208.477l1.17-1.53 3.233.408-2.587 1.886-1.817-.763\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M221.995 206.465l2.267.263c.575.07 1.117-.32 1.188-.863.065-.548-.342-1.046-.918-1.11l-2.282-.266-2.32-.268c-.58-.067-1.106.314-1.175.863-.072.545.353 1.046.928 1.11l2.312.27\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M213.26 204.812c0-.55.474-.995 1.054-.995.582 0 1.054.446 1.054.995 0 .548-.472 1-1.054 1-.58 0-1.053-.452-1.053-1m15.849 1.852c0-.55.472-.996 1.052-.996.583 0 1.054.447 1.054.996 0 .552-.47.998-1.054.998-.58 0-1.052-.446-1.052-.998\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M238.23 208.477l-1.168-1.53-3.233.408 2.584 1.886 1.817-.763\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M177.31 212.796c7.444-2.09 17.566-3.385 28.81-3.406 11.242.02 21.414 1.316 28.858 3.406\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M182.324 183.762l1.332 1.068 1.997-3.262c-2.167-1.327-3.653-3.63-3.653-6.257 0-.295.017-.584.055-.87.208-4.164 5.28-7.604 11.718-7.604 3.34 0 6.358.914 8.482 2.38.057-.644.115-1.196.205-1.782-2.34-1.365-5.375-2.185-8.687-2.185-7.403 0-13.195 4.204-13.476 9.186-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-1.06 1.738\" fill=\"#c8b100\"></path><path d=\"M182.324 183.762l1.332 1.068 1.997-3.262c-2.167-1.327-3.653-3.63-3.653-6.257 0-.295.017-.584.055-.87.208-4.164 5.28-7.604 11.718-7.604 3.34 0 6.358.914 8.482 2.38.057-.644.115-1.196.205-1.782-2.34-1.365-5.375-2.185-8.687-2.185-7.403 0-13.195 4.204-13.476 9.186-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-1.06 1.738\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M182.41 183.8c-2.527-1.886-4.095-4.45-4.095-7.27 0-3.254 2.126-6.154 5.358-8.077-1.994 1.6-3.203 3.67-3.376 5.983-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-.974 1.775\" fill=\"#c8b100\"></path><path d=\"M182.41 183.8c-2.527-1.886-4.095-4.45-4.095-7.27 0-3.254 2.126-6.154 5.358-8.077-1.994 1.6-3.203 3.67-3.376 5.983-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-.974 1.775\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M160.12 187.092c-1.416-1.584-2.283-3.633-2.283-5.873 0-1.352.312-2.643.877-3.795 2.045-4.206 8.46-7.268 16.083-7.268 2.078 0 4.065.226 5.9.644-.407.445-.726.932-1.038 1.423a25.514 25.514 0 0 0-4.863-.457c-6.98 0-12.818 2.714-14.51 6.38a7.065 7.065 0 0 0-.702 3.073c0 2.228 1.044 4.226 2.678 5.59l-2.526 4.127-1.353-1.076 1.735-2.764\" fill=\"#c8b100\"></path><path d=\"M160.12 187.092c-1.416-1.584-2.283-3.633-2.283-5.873 0-1.352.312-2.643.877-3.795 2.045-4.206 8.46-7.268 16.083-7.268 2.078 0 4.065.226 5.9.644-.407.445-.726.932-1.038 1.423a25.514 25.514 0 0 0-4.863-.457c-6.98 0-12.818 2.714-14.51 6.38a7.065 7.065 0 0 0-.702 3.073c0 2.228 1.044 4.226 2.678 5.59l-2.526 4.127-1.353-1.076 1.735-2.764v-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M162.707 173.263c-1.837 1.156-3.226 2.577-3.993 4.162a8.596 8.596 0 0 0-.877 3.794c0 2.24.867 4.288 2.282 5.872l-1.535 2.49c-1.468-1.887-2.322-4.088-2.322-6.43 0-4.033 2.566-7.557 6.444-9.89\" fill=\"#c8b100\"></path><path d=\"M162.707 173.263c-1.837 1.156-3.226 2.577-3.993 4.162a8.596 8.596 0 0 0-.877 3.794c0 2.24.867 4.288 2.282 5.872l-1.535 2.49c-1.468-1.887-2.322-4.088-2.322-6.43 0-4.033 2.566-7.557 6.444-9.89z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.037 164.416c1.692 0 3.146 1.12 3.493 2.62.226 1.325.367 2.835.398 4.444.003.167-.01.33-.01.494.004.19.04.396.043.59.06 3.374.54 6.354 1.228 8.178l-5.153 4.93-5.21-4.93c.69-1.824 1.17-4.804 1.234-8.178.003-.194.04-.4.04-.59 0-.164-.01-.327-.007-.494.025-1.61.17-3.12.395-4.445.343-1.5 1.858-2.62 3.546-2.62\" fill=\"#c8b100\"></path><path d=\"M206.037 164.416c1.692 0 3.146 1.12 3.493 2.62.226 1.325.367 2.835.398 4.444.003.167-.01.33-.01.494.004.19.04.396.043.59.06 3.374.54 6.354 1.228 8.178l-5.153 4.93-5.21-4.93c.69-1.824 1.17-4.804 1.234-8.178.003-.194.04-.4.04-.59 0-.164-.01-.327-.007-.494.025-1.61.17-3.12.395-4.445.343-1.5 1.858-2.62 3.546-2.62h.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.037 166.022c.88 0 1.62.56 1.8 1.336.213 1.254.35 2.687.378 4.2 0 .157-.008.314-.008.466 0 .188.032.376.036.567.055 3.188.512 5.997 1.167 7.726l-3.4 3.218-3.4-3.218c.65-1.725 1.106-4.538 1.163-7.725.004-.19.037-.378.04-.566 0-.152-.01-.31-.01-.466a28.14 28.14 0 0 1 .38-4.2c.177-.776.98-1.336 1.854-1.336\" fill=\"#c8b100\"></path><path d=\"M206.037 166.022c.88 0 1.62.56 1.8 1.336.213 1.254.35 2.687.378 4.2 0 .157-.008.314-.008.466 0 .188.032.376.036.567.055 3.188.512 5.997 1.167 7.726l-3.4 3.218-3.4-3.218c.65-1.725 1.106-4.538 1.163-7.725.004-.19.037-.378.04-.566 0-.152-.01-.31-.01-.466a28.14 28.14 0 0 1 .38-4.2c.177-.776.98-1.336 1.854-1.336z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M229.712 183.762l-1.332 1.068-1.997-3.262c2.165-1.327 3.653-3.63 3.653-6.257a7.08 7.08 0 0 0-.053-.87c-.207-4.164-5.285-7.604-11.718-7.604-3.348 0-6.36.914-8.487 2.38a23.008 23.008 0 0 0-.206-1.782c2.34-1.365 5.374-2.185 8.693-2.185 7.402 0 13.192 4.204 13.476 9.186.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l1.062 1.738\" fill=\"#c8b100\"></path><path d=\"M229.712 183.762l-1.332 1.068-1.997-3.262c2.165-1.327 3.653-3.63 3.653-6.257a7.08 7.08 0 0 0-.053-.87c-.207-4.164-5.285-7.604-11.718-7.604-3.348 0-6.36.914-8.487 2.38a23.008 23.008 0 0 0-.206-1.782c2.34-1.365 5.374-2.185 8.693-2.185 7.402 0 13.192 4.204 13.476 9.186.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l1.062 1.738\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M229.626 183.8c2.526-1.886 4.096-4.45 4.096-7.27 0-3.254-2.128-6.154-5.356-8.077 1.99 1.6 3.2 3.67 3.375 5.983.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l.976 1.775\" fill=\"#c8b100\"></path><path d=\"M229.626 183.8c2.526-1.886 4.096-4.45 4.096-7.27 0-3.254-2.128-6.154-5.356-8.077 1.99 1.6 3.2 3.67 3.375 5.983.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l.976 1.775\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M251.92 187.092c1.412-1.584 2.278-3.633 2.278-5.873a8.654 8.654 0 0 0-.873-3.795c-2.05-4.206-8.462-7.268-16.088-7.268-2.077 0-4.063.226-5.9.644.412.445.73.932 1.043 1.423a25.447 25.447 0 0 1 4.854-.457c6.98 0 12.822 2.714 14.51 6.38.453.936.703 1.98.703 3.073 0 2.228-1.045 4.226-2.68 5.59l2.528 4.127 1.357-1.076-1.734-2.764\" fill=\"#c8b100\"></path><path d=\"M251.92 187.092c1.412-1.584 2.278-3.633 2.278-5.873a8.654 8.654 0 0 0-.873-3.795c-2.05-4.206-8.462-7.268-16.088-7.268-2.077 0-4.063.226-5.9.644.412.445.73.932 1.043 1.423a25.447 25.447 0 0 1 4.854-.457c6.98 0 12.822 2.714 14.51 6.38.453.936.703 1.98.703 3.073 0 2.228-1.045 4.226-2.68 5.59l2.528 4.127 1.357-1.076-1.734-2.764.003-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M249.33 173.263c1.835 1.156 3.225 2.577 3.995 4.162a8.7 8.7 0 0 1 .873 3.794c0 2.24-.866 4.288-2.277 5.872l1.53 2.49c1.47-1.887 2.318-4.088 2.318-6.43 0-4.033-2.562-7.557-6.438-9.89\" fill=\"#c8b100\"></path><path d=\"M249.33 173.263c1.835 1.156 3.225 2.577 3.995 4.162a8.7 8.7 0 0 1 .873 3.794c0 2.24-.866 4.288-2.277 5.872l1.53 2.49c1.47-1.887 2.318-4.088 2.318-6.43 0-4.033-2.562-7.557-6.438-9.89z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M204.206 181.376c0-.955.82-1.724 1.83-1.724 1.007 0 1.827.77 1.827 1.724 0 .958-.82 1.732-1.828 1.732-1.01 0-1.83-.774-1.83-1.732\" fill=\"#fff\"></path><path d=\"M204.206 181.376c0-.955.82-1.724 1.83-1.724 1.007 0 1.827.77 1.827 1.724 0 .958-.82 1.732-1.828 1.732-1.01 0-1.83-.774-1.83-1.732z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M204.206 177.984c0-.954.82-1.732 1.83-1.732 1.007 0 1.827.778 1.827 1.732 0 .955-.82 1.728-1.828 1.728-1.01 0-1.83-.773-1.83-1.728m.367-3.648c0-.764.656-1.38 1.463-1.38.8 0 1.457.616 1.457 1.38 0 .763-.656 1.38-1.457 1.38-.807 0-1.463-.617-1.463-1.38m.41-3.29c0-.547.473-.994 1.053-.994.582 0 1.05.447 1.05.994 0 .553-.468 1-1.05 1-.58 0-1.053-.447-1.053-1m.21-2.876c0-.444.376-.798.843-.798.463 0 .84.354.84.798 0 .44-.377.798-.84.798-.467 0-.843-.358-.843-.798\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.19 191.786l1.187.22c-.19.48-.23 1.004-.23 1.557 0 2.464 2.116 4.47 4.72 4.47 2.093 0 3.875-1.296 4.487-3.086.07.047.45-1.616.648-1.595.165.017.147 1.728.208 1.697.303 2.252 2.362 3.777 4.68 3.777 2.602 0 4.712-1.995 4.712-4.463 0-.184-.01-.368-.036-.546l1.48-1.466.793 1.868c-.316.587-.442 1.246-.442 1.95 0 2.357 2.016 4.262 4.503 4.262 1.566 0 2.94-.753 3.748-1.895l.947-1.204-.007 1.476c0 1.482.626 2.812 2.073 3.046 0 0 1.662.103 3.863-1.625 2.203-1.728 3.416-3.16 3.416-3.16l.19 1.732s-1.83 2.827-3.82 3.98c-1.087.632-2.74 1.297-4.052 1.083-1.39-.226-2.38-1.34-2.89-2.625a6.72 6.72 0 0 1-3.413.923c-2.692 0-5.112-1.476-6.07-3.698-1.237 1.336-2.962 2.157-4.984 2.157-2.148 0-4.118-.967-5.352-2.454a6.934 6.934 0 0 1-4.68 1.787c-2.38 0-4.502-1.167-5.705-2.926-1.202 1.758-3.323 2.925-5.7 2.925a6.943 6.943 0 0 1-4.68-1.787c-1.23 1.487-3.204 2.454-5.353 2.454-2.023 0-3.747-.82-4.987-2.157-.956 2.222-3.374 3.698-6.068 3.698a6.698 6.698 0 0 1-3.408-.923c-.515 1.284-1.505 2.4-2.89 2.625-1.315.214-2.967-.45-4.056-1.084-1.99-1.15-3.817-3.978-3.817-3.978l.192-1.73s1.213 1.43 3.412 3.16c2.204 1.73 3.863 1.624 3.863 1.624 1.447-.234 2.072-1.564 2.072-3.047l-.007-1.477.947 1.204c.806 1.142 2.186 1.895 3.748 1.895 2.487 0 4.502-1.905 4.502-4.26 0-.706-.127-1.365-.443-1.952l.793-1.868 1.482 1.466a4.442 4.442 0 0 0-.036.546c0 2.468 2.106 4.463 4.71 4.463 2.322 0 4.377-1.525 4.68-3.778.064.03.047-1.68.21-1.698.197-.02.58 1.642.646 1.595.615 1.79 2.394 3.085 4.493 3.085 2.604 0 4.714-2.005 4.714-4.47 0-.552-.033-1.077-.227-1.557l1.232-.22\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M238.6 197.676c.27-.8.028-1.59-.548-1.764-.576-.18-1.268.324-1.54 1.12-.275.8-.03 1.586.547 1.767.574.172 1.265-.33 1.54-1.124m-20.519-3.973c.105-.835-.294-1.564-.895-1.633-.6-.072-1.177.544-1.285 1.377-.108.83.29 1.565.892 1.637.602.067 1.178-.55 1.287-1.382m-23.827.001c-.107-.835.296-1.564.893-1.633.6-.072 1.177.544 1.286 1.377.104.83-.29 1.565-.892 1.637-.602.067-1.178-.55-1.286-1.382m-20.518 3.975c-.273-.8-.028-1.59.548-1.764.576-.18 1.263.324 1.537 1.12.27.8.025 1.586-.548 1.767-.576.172-1.263-.33-1.537-1.124\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M182.648 183.984c1.02.643 1.908 1.715 2.217 2.912 0 0 .12-.246.68-.57.566-.317 1.044-.308 1.044-.308s-.162.93-.242 1.266c-.082.327-.09 1.326-.305 2.226-.217.9-.61 1.62-.61 1.62a1.9 1.9 0 0 0-1.51-.4 1.832 1.832 0 0 0-1.275.862s-.63-.548-1.156-1.322c-.53-.775-.89-1.71-1.09-1.992-.2-.286-.685-1.11-.685-1.11s.447-.168 1.092-.05c.642.12.844.315.844.315-.136-1.23.27-2.516.994-3.45\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M183.08 193.785a1.745 1.745 0 0 1-.648-1.037c-.08-.42.01-.835.224-1.176 0 0-.85-.43-1.762-.668-.69-.18-1.906-.188-2.274-.194l-1.1-.027s.06.167.268.53c.252.44.476.716.476.716-1.218.28-2.254 1.08-2.91 2.008.952.657 2.216 1.056 3.456.93 0 0-.108.332-.186.832-.065.413-.06.584-.06.584l1.024-.38c.342-.125 1.484-.52 2.07-.916.766-.525 1.422-1.2 1.422-1.2m2.728-.46a1.65 1.65 0 0 0 .235-1.18 1.72 1.72 0 0 0-.634-1.035s.64-.68 1.406-1.2c.584-.396 1.727-.795 2.07-.917.342-.126 1.026-.382 1.026-.382s.003.174-.062.587a5.742 5.742 0 0 1-.187.828c1.243-.13 2.508.286 3.46.948-.655.923-1.7 1.71-2.912 1.99a6.44 6.44 0 0 0 .745 1.248s-.734-.017-1.1-.023c-.368-.006-1.584-.01-2.275-.194-.91-.243-1.772-.665-1.772-.665\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M182.19 192.43c0-1.09.933-1.973 2.08-1.973 1.146 0 2.082.883 2.082 1.974 0 1.09-.932 1.97-2.08 1.97-1.15 0-2.08-.88-2.08-1.97\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M206.11 180.83c1 .908 1.77 2.263 1.87 3.658 0 0 .178-.252.873-.504.694-.252 1.227-.154 1.227-.154s-.37 1.013-.533 1.366c-.16.356-.37 1.467-.803 2.425a8.232 8.232 0 0 1-1.007 1.692 2.13 2.13 0 0 0-1.606-.72c-.644 0-1.22.284-1.6.72 0 0-.587-.726-1.012-1.69-.43-.96-.64-2.07-.8-2.426-.16-.353-.536-1.366-.536-1.366s.537-.1 1.228.154c.694.252.878.504.878.504.097-1.395.825-2.75 1.82-3.658\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M204.558 191.838a1.916 1.916 0 0 1-.507-1.275c0-.48.185-.93.494-1.268 0 0-.857-.642-1.82-1.077-.732-.334-2.09-.566-2.496-.642l-1.224-.23s.033.193.19.64c.192.542.383.89.383.89-1.41.085-2.74.786-3.662 1.697.922.903 2.247 1.588 3.662 1.68 0 0-.19.345-.382.89-.158.44-.19.638-.19.638s.813-.15 1.223-.224c.407-.082 1.764-.31 2.495-.648.964-.437 1.835-1.066 1.835-1.066m3.134-.005c.31-.345.507-.79.507-1.275 0-.48-.182-.93-.492-1.268 0 0 .857-.642 1.822-1.077.733-.334 2.09-.566 2.497-.642l1.216-.23s-.028.193-.19.64c-.192.542-.378.89-.378.89 1.41.085 2.74.786 3.657 1.697-.918.903-2.243 1.588-3.657 1.68 0 0 .186.345.378.89.16.44.19.638.19.638l-1.216-.224c-.407-.082-1.764-.31-2.497-.648-.965-.437-1.837-1.066-1.837-1.066m21.989-7.859c-1.014.643-1.902 1.715-2.213 2.912 0 0-.124-.246-.684-.57-.562-.317-1.046-.308-1.046-.308s.163.93.246 1.266c.084.327.087 1.326.302 2.226.217.9.607 1.62.607 1.62a1.91 1.91 0 0 1 1.513-.4c.56.096 1.016.426 1.278.862 0 0 .627-.548 1.157-1.322.524-.775.888-1.71 1.082-1.992.2-.286.688-1.11.688-1.11s-.45-.168-1.094-.05c-.645.12-.848.315-.848.315.144-1.23-.266-2.516-.99-3.45\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M229.254 193.785c.322-.257.57-.615.644-1.037a1.64 1.64 0 0 0-.22-1.176s.847-.43 1.757-.668c.692-.18 1.913-.188 2.274-.194l1.102-.027s-.058.167-.27.53a6.2 6.2 0 0 1-.474.716c1.215.28 2.252 1.08 2.907 2.008-.946.657-2.21 1.056-3.455.93 0 0 .112.332.188.832.06.413.056.584.056.584s-.683-.253-1.02-.38c-.343-.125-1.485-.52-2.072-.916-.762-.525-1.418-1.2-1.418-1.2m-2.73-.46a1.674 1.674 0 0 1-.235-1.18c.08-.422.314-.78.637-1.035 0 0-.644-.68-1.41-1.2-.584-.396-1.73-.795-2.07-.917a171.41 171.41 0 0 1-1.022-.382s-.003.174.06.587c.077.498.185.828.185.828-1.243-.13-2.51.286-3.456.948.655.923 1.696 1.71 2.908 1.99 0 0-.22.276-.472.716-.21.37-.27.532-.27.532s.73-.017 1.1-.023c.362-.006 1.586-.01 2.273-.194a11.117 11.117 0 0 0 1.77-.665\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M225.98 192.43c0-1.09.93-1.973 2.08-1.973 1.152 0 2.084.883 2.084 1.974 0 1.09-.932 1.97-2.084 1.97-1.15 0-2.08-.88-2.08-1.97m23.27 4.377c-.49-.518-1.505-.41-2.264.24-.76.643-.98 1.59-.49 2.105.49.518 1.505.406 2.263-.238.76-.65.98-1.596.49-2.107\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M246.295 198.062c.105-.354.342-.716.69-1.015.76-.648 1.774-.757 2.265-.24.06.07.13.16.17.243 0 0 1.054-2 2.303-2.665 1.25-.672 3.363-.502 3.363-.502 0-1.535-1.257-2.774-2.877-2.774-.952 0-1.85.394-2.38 1.062l-.22-1.03s-1.303.26-1.9 1.75c-.594 1.493.053 3.65.053 3.65s-.324-.927-.812-1.545c-.486-.612-1.735-1.284-2.386-1.59-.652-.304-1.318-.76-1.318-.76s-.03.166-.054.58a4.91 4.91 0 0 0 .015.796c-1.195-.157-2.59.038-3.675.46.464.913 1.35 1.773 2.508 2.212 0 0-.417.345-.8.723a3.94 3.94 0 0 0-.416.47s.817.117 1.228.174c.405.055 1.762.27 2.573.215a14.513 14.513 0 0 0 1.67-.215m-80.259.001c-.104-.354-.34-.716-.69-1.015-.76-.648-1.772-.757-2.266-.24-.064.07-.13.16-.17.243 0 0-1.058-2-2.306-2.665-1.245-.672-3.358-.502-3.358-.502 0-1.535 1.257-2.774 2.876-2.774.954 0 1.847.394 2.382 1.062l.217-1.03s1.304.26 1.9 1.75c.597 1.493-.053 3.65-.053 3.65s.324-.927.814-1.545c.49-.612 1.74-1.284 2.39-1.59.65-.304 1.318-.76 1.318-.76s.025.166.05.58c.027.492-.014.796-.014.796 1.192-.157 2.59.038 3.676.46-.465.913-1.348 1.773-2.51 2.212 0 0 .418.345.8.723.317.32.42.47.42.47l-1.226.174c-.412.055-1.764.27-2.575.215a14.658 14.658 0 0 1-1.674-.215\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M163.08 196.808c.494-.518 1.506-.41 2.265.24.763.643.978 1.59.49 2.105-.49.518-1.506.406-2.264-.238-.76-.65-.978-1.596-.49-2.107m40.969-6.245c0-1.09.932-1.97 2.08-1.97 1.15 0 2.085.88 2.085 1.97 0 1.09-.93 1.974-2.084 1.974-1.148 0-2.08-.884-2.08-1.974\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M201.8 160.61c0-2.23 1.906-4.03 4.252-4.03 2.347 0 4.25 1.8 4.25 4.03 0 2.22-1.903 4.02-4.25 4.02-2.346 0-4.252-1.8-4.252-4.02\" fill=\"#005bbf\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M204.938 149.316v2.174h-2.326v2.205h2.326v6.345h-2.93c-.034.206-.21.357-.21.573 0 .556.115 1.09.33 1.57.007.014.025.018.03.03h7.794c.006-.012.025-.016.03-.03.216-.48.333-1.014.333-1.57 0-.215-.177-.368-.21-.574h-2.84v-6.344h2.325v-2.206h-2.326v-2.174h-2.326z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M206.473 330.56c-12.558 0-25.006-3.078-35.47-8.2-7.713-3.82-12.828-11.524-12.828-20.34v-31.968h96.406v31.97c0 8.814-5.113 16.518-12.83 20.34-10.462 5.12-22.715 8.198-35.277 8.198\" fill=\"#ccc\"></path><path d=\"M206.473 330.56c-12.558 0-25.006-3.078-35.47-8.2-7.713-3.82-12.828-11.524-12.828-20.34v-31.968h96.406v31.97c0 8.814-5.113 16.518-12.83 20.34-10.462 5.12-22.715 8.198-35.277 8.198z\" fill=\"none\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M206.268 269.997h48.31v-53.485h-48.31v53.485z\" fill=\"#ccc\"></path><path d=\"M206.268 269.997h48.31v-53.485h-48.31v53.485z\" fill=\"none\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M206.304 301.983c0 12.634-10.706 22.874-24.04 22.874-13.34 0-24.154-10.24-24.154-22.874v-32.017h48.194v32.017\" fill=\"#ad1519\"></path><path d=\"M168.64 320.86c1.505.8 3.573 2.13 5.783 2.663l-.14-54.685h-5.644v52.022z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M158.03 301.552c.148 6.747 2.826 11.762 5.504 15.047v-47.496H158.1l-.07 32.448z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".48\" stroke-linejoin=\"round\"></path><path d=\"M179.384 324.722a26.58 26.58 0 0 0 5.644 0v-55.884h-5.644v55.884z\" fill=\"#c7b500\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M189.99 323.523c2.21-.444 4.7-1.82 5.785-2.53v-52.155h-5.644l-.14 54.685z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M158.113 269.997h48.172v-53.485h-48.172v53.485z\" fill=\"#ad1519\"></path><path d=\"M158.113 269.997h48.172v-53.485h-48.172v53.485z\" fill=\"none\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M201.02 316.067c2.35-2.087 4.56-6.837 5.363-12.25l.14-34.98h-5.644l.14 47.23z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M206.304 301.983c0 12.634-10.706 22.874-24.04 22.874-13.34 0-24.154-10.24-24.154-22.874v-32.017h48.194v32.017\" fill=\"none\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M254.624 269.966v32.017c0 12.634-10.827 22.874-24.167 22.874-13.336 0-24.153-10.24-24.153-22.874v-32.017h48.32\" fill=\"#ad1519\"></path><path d=\"M254.624 269.966v32.017c0 12.634-10.827 22.874-24.167 22.874-13.336 0-24.153-10.24-24.153-22.874v-32.017h48.32\" fill=\"none\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M215.093 294.132c.077.164.12.328.12.502 0 .59-.5 1.06-1.124 1.06-.62 0-1.123-.47-1.123-1.06 0-.174.043-.338.122-.48l-1.57-.022c-.033.16-.052.328-.052.502 0 1.11.768 2.052 1.828 2.37l-.002 3.85 1.645.01.002-3.878a2.56 2.56 0 0 0 1.63-1.55h4.418v-1.303h-5.897m21.677 0v1.302l-3.973.01a2.55 2.55 0 0 1-.256.487l4.616 5.243-1.238 1.003-4.593-5.25c-.085.027-.127.06-.216.085l-.013 8.675h-1.626l-.003-8.713c-.07-.016-.127-.05-.19-.08l-4.782 5.283-1.238-1.003 4.778-5.304a2.13 2.13 0 0 1-.2-.435h-4.106v-1.302h13.044-.004zm2.647 0v1.302h4.422c.262.73.857 1.302 1.627 1.55l.003 3.88 1.642-.01-.004-3.852c1.062-.317 1.833-1.26 1.833-2.37 0-.173-.017-.34-.058-.5h-1.562c.076.163.116.327.116.5 0 .59-.497 1.06-1.12 1.06-.618 0-1.123-.47-1.123-1.06a.98.98 0 0 1 .123-.48l-5.9-.02m-6.678 22.12c1.29-.205 2.478-.56 3.65-1.053l.807 1.373a17.6 17.6 0 0 1-4.32 1.223c-.252 1.122-1.3 1.964-2.558 1.964-1.257 0-2.305-.832-2.564-1.945a17.522 17.522 0 0 1-4.542-1.242l.81-1.373c1.236.52 2.553.868 3.92 1.058.29-.625.818-1.11 1.513-1.335l.014-6.726h1.623l.015 6.702c.72.214 1.328.705 1.63 1.352h.003zm-11.033-2.257l-.8 1.38a16.654 16.654 0 0 1-3.647-3.085c-.835.247-1.78.1-2.49-.48-1.103-.893-1.237-2.46-.293-3.5l.137-.146a15.272 15.272 0 0 1-1.267-4.804l1.642.007a13.127 13.127 0 0 0 1.05 4.105c.46-.065.954-.01 1.397.153l4.106-4.544 1.238 1-4.08 4.537c.55.838.528 1.92-.102 2.744a15.172 15.172 0 0 0 3.11 2.636zm-6.09-4.766c.405-.45 1.113-.5 1.584-.12.472.382.53 1.057.126 1.5a1.167 1.167 0 0 1-1.584.12 1.026 1.026 0 0 1-.127-1.5zm-2.07-4.493l-1.687-.378-.238-4.276 1.674-.553.002 2.453c0 .95.085 1.85.25 2.754zm1.4-5.3l1.682.395s.087 2.747.05 2.13c-.043-.72.184 2.15.184 2.15l-1.694.557c-.17-.873-.226-1.767-.226-2.687l.003-2.547h.004zm5.543 13.676a15.667 15.667 0 0 0 4.84 2.57l.374-1.626a13.696 13.696 0 0 1-4.007-2.01l-1.207 1.066m-.813 1.404a17.4 17.4 0 0 0 4.84 2.547l-1.258 1.176a18.707 18.707 0 0 1-3.955-2.03l.373-1.693m2.194-9.42l1.604.68 2.937-3.26-.964-1.386-3.577 3.966m-1.246-1.006l-.963-1.394 2.94-3.26 1.6.685-3.576 3.97m18.08 9.906l.802 1.38a16.698 16.698 0 0 0 3.646-3.085c.83.247 1.78.1 2.49-.48 1.102-.893 1.23-2.46.29-3.5l-.138-.146a15.04 15.04 0 0 0 1.263-4.804l-1.633.007a13.268 13.268 0 0 1-1.052 4.105 2.916 2.916 0 0 0-1.4.153l-4.103-4.544-1.24 1 4.08 4.537a2.36 2.36 0 0 0 .1 2.744 15.085 15.085 0 0 1-3.107 2.636zm6.086-4.766a1.16 1.16 0 0 0-1.58-.12 1.025 1.025 0 0 0-.126 1.5 1.167 1.167 0 0 0 1.584.12 1.024 1.024 0 0 0 .122-1.5zm2.07-4.493l1.688-.378.238-4.276-1.67-.553-.004 2.453c0 .95-.084 1.85-.252 2.754zm-1.396-5.3l-1.68.395s-.092 2.747-.055 2.13c.045-.72-.185 2.15-.185 2.15l1.695.557c.17-.873.227-1.767.227-2.687l-.003-2.547m-5.544 13.677a15.722 15.722 0 0 1-4.838 2.57l-.374-1.626a13.674 13.674 0 0 0 4.003-2.01l1.21 1.066m.814 1.404a17.453 17.453 0 0 1-4.84 2.547l1.258 1.176c1.41-.52 2.74-1.21 3.956-2.03l-.374-1.693m-2.193-9.42l-1.604.68-2.938-3.26.965-1.386 3.578 3.966m1.245-1.006l.963-1.394-2.938-3.26-1.6.685 3.575 3.97m-20.105-8.652l.493 1.6h4.525l.487-1.6h-5.505m21.135 0l-.496 1.6h-4.523l-.487-1.6h5.505m-11.62 21.837c0-.59.502-1.066 1.122-1.066.618 0 1.118.475 1.118 1.065 0 .587-.5 1.06-1.118 1.06-.62 0-1.123-.473-1.123-1.06zm1.902-7.752l1.69-.473v-4.28l-1.69-.462v5.215m-1.637 0l-1.684-.473v-4.28l1.684-.462v5.215\" fill=\"#c8b100\"></path><path d=\"M211.52 294.17c.194-.892.89-1.616 1.79-1.886l-.014-5.282h1.63l.002 5.31c.804.253 1.422.847 1.67 1.612l4.392.007v.24h-5.897a1.16 1.16 0 0 0-1.004-.566c-.436 0-.818.242-1 .586l-1.57-.02m12.206 0v-.24h4.08a2.37 2.37 0 0 1 .174-.385l-5.032-5.608 1.237-1.004 4.97 5.517c.085-.042.176-.08.264-.11l.004-7.35h1.627v7.304c.074.02.184.042.257.063l4.853-5.526 1.247.99-4.872 5.503c.126.185.21.39.28.608h3.952v.24h-13.045.004zm21.59 0a1.153 1.153 0 0 1 1-.566c.44 0 .818.242 1.004.586l1.562-.02c-.194-.892-.885-1.616-1.784-1.886l.01-5.28h-1.624l-.007 5.31c-.8.254-1.418.845-1.667 1.61l-4.393.007v.24h5.9m-30.13-14.918l6.054 6.786 1.24-1.004-6.086-6.76c.12-.18.207-.378.28-.59h4.428v-1.544h-4.43c-.34-1-1.333-1.718-2.502-1.718-1.448 0-2.625 1.114-2.625 2.488 0 1.088.736 2.018 1.766 2.353l-.01 5.235h1.628v-5.2c.07-.02.193-.02.26-.046zm31.94.035l-.015 5.21h-1.628v-5.23a2.452 2.452 0 0 1-.364-.15l-6.02 6.796-1.245-.99 6.135-6.93c-.05-.096-.104-.2-.14-.31h-4.452v-1.543h4.438c.342-1 1.325-1.718 2.49-1.718 1.447 0 2.625 1.114 2.625 2.488 0 1.116-.76 2.058-1.824 2.377zm-16.06-.02l-.013 3.21h-1.626l.004-3.184a2.57 2.57 0 0 1-1.715-1.61h-3.97v-1.543h3.97c.343-1 1.32-1.718 2.488-1.718 1.166 0 2.152.717 2.495 1.718h4.05v1.543h-4.06a2.528 2.528 0 0 1-1.62 1.583zm-17.75 3.895l-1.69.475v4.29l1.69.465v-5.23m1.637 0l1.684.475v4.29l-1.684.465v-5.23m30.515 0l-1.684.475v4.29l1.683.465v-5.23m1.638 0l1.69.475v4.29l-1.69.465v-5.23m-25.547.847l1.608-.683 2.937 3.265-.965 1.393-3.58-3.976m-1.243 1.01l-.96 1.398 2.936 3.262 1.6-.687-3.576-3.972m18.444-1.137l-1.608-.67-2.91 3.29.976 1.383 3.543-4.003m1.254 1l.974 1.388-2.908 3.29-1.605-.673 3.54-4.003m-20.335 9.044l.493-1.602h4.525l.488 1.602h-5.506m-6.634-17.016c0-.587.503-1.066 1.124-1.066.618 0 1.12.48 1.12 1.066 0 .588-.502 1.062-1.12 1.062-.62 0-1.124-.474-1.124-1.062zm12.1.775l-.495 1.606h-4.52l-.49-1.606h5.507m0-1.555l-.496-1.6h-4.52l-.49 1.6h5.507m15.668 17.796l-.496-1.602h-4.523l-.487 1.602h5.505m4.39-17.016c0-.587.5-1.066 1.122-1.066.62 0 1.12.48 1.12 1.066 0 .588-.5 1.062-1.12 1.062-.622 0-1.123-.474-1.123-1.062zm-16.123 0c0-.587.504-1.066 1.122-1.066.62 0 1.12.48 1.12 1.066 0 .588-.5 1.062-1.12 1.062-.618 0-1.122-.474-1.122-1.062zm6.266.775l.497 1.606h4.52l.49-1.606h-5.507m0-1.555l.497-1.6h4.52l.49 1.6h-5.507m-5.906 5.012l-1.685.474v4.29l1.685.465v-5.23m1.62 0l1.684.475v4.29l-1.684.465v-5.23\" fill=\"#c8b100\"></path><path d=\"M232.738 316.252c1.29-.204 2.478-.56 3.65-1.052l.807 1.373a17.6 17.6 0 0 1-4.32 1.223c-.252 1.122-1.3 1.964-2.558 1.964-1.257 0-2.305-.832-2.564-1.945a17.522 17.522 0 0 1-4.542-1.242l.81-1.373c1.236.52 2.553.868 3.92 1.06.29-.627.818-1.11 1.513-1.337l.014-6.726h1.623l.015 6.702c.72.214 1.328.705 1.63 1.352h.003zm-4.707-20.378a2.282 2.282 0 0 1-.198-.44h-4.107v-1.54h4.08a2.6 2.6 0 0 1 .178-.383l-5.035-5.6 1.237-1.002 4.973 5.506a2.16 2.16 0 0 1 .266-.108l.004-7.337h1.622v7.29c.073.02.184.042.257.066l4.853-5.52 1.247.992-4.872 5.49c.125.183.21.388.28.605h3.952v1.54l-3.974.012c-.058.174-.16.334-.252.487l4.616 5.247-1.238 1-4.593-5.252c-.085.03-.127.064-.22.088l-.01 8.676h-1.628l-.005-8.713c-.068-.02-.124-.056-.19-.086l-4.78 5.287-1.237-1 4.776-5.306m-12.842-16.632l6.053 6.774 1.24-1.002-6.086-6.747c.12-.18.207-.378.28-.59h4.428v-1.54h-4.43c-.34-1-1.333-1.715-2.502-1.715-1.448 0-2.625 1.112-2.625 2.482 0 1.087.736 2.014 1.766 2.348l-.01 5.227h1.628v-5.193c.07-.02.193-.02.26-.045zm6.517 34.754l-.8 1.38a16.654 16.654 0 0 1-3.647-3.085c-.835.247-1.78.1-2.49-.48-1.103-.893-1.237-2.46-.293-3.5l.137-.146a15.272 15.272 0 0 1-1.267-4.804l1.642.007a13.127 13.127 0 0 0 1.05 4.105c.46-.065.954-.01 1.397.154l4.106-4.545 1.238 1-4.08 4.537c.55.838.528 1.92-.102 2.744a15.172 15.172 0 0 0 3.11 2.636zm-8.41-13.14v-3.853c-1.06-.314-1.83-1.26-1.83-2.37 0-1.108.782-2.062 1.844-2.383l-.014-5.27h1.63l.002 5.3c.804.253 1.422.843 1.67 1.607l4.392.007v1.54h-4.42a2.56 2.56 0 0 1-1.627 1.552l-.003 3.88-1.646-.01m2.32 8.374c.406-.45 1.114-.5 1.585-.12.472.382.53 1.057.126 1.5a1.167 1.167 0 0 1-1.584.12 1.026 1.026 0 0 1-.127-1.5zm-2.068-4.493l-1.688-.378-.238-4.276 1.674-.553.002 2.453c0 .95.085 1.85.25 2.754zm1.4-5.3l1.68.395s.088 2.747.052 2.13c-.044-.72.184 2.15.184 2.15l-1.696.557c-.17-.873-.226-1.767-.226-2.687l.003-2.547h.004zm5.542 13.676a15.667 15.667 0 0 0 4.84 2.57l.374-1.626a13.696 13.696 0 0 1-4.007-2.01l-1.207 1.066m-.813 1.404a17.4 17.4 0 0 0 4.84 2.547l-1.258 1.176a18.707 18.707 0 0 1-3.955-2.03l.373-1.693\" fill=\"none\" stroke=\"#c8b100\" stroke-width=\".25\"></path><path d=\"M221.87 305.096l1.604.68 2.937-3.258-.964-1.387-3.577 3.966m-1.246-1.006l-.963-1.394 2.94-3.26 1.6.685-3.576 3.97m-7.657-9.456c0-.59.503-1.067 1.122-1.067.62 0 1.12.476 1.12 1.067 0 .59-.5 1.06-1.12 1.06-.62 0-1.123-.47-1.123-1.06zm25.736 19.362l.803 1.38a16.698 16.698 0 0 0 3.646-3.085c.83.247 1.78.1 2.49-.48 1.102-.893 1.23-2.46.29-3.5l-.138-.146a15.04 15.04 0 0 0 1.263-4.804l-1.633.007a13.268 13.268 0 0 1-1.052 4.105 2.916 2.916 0 0 0-1.4.154l-4.103-4.545-1.24 1 4.08 4.537a2.36 2.36 0 0 0 .1 2.744 15.085 15.085 0 0 1-3.107 2.636zm8.413-13.14l-.004-3.853c1.062-.314 1.832-1.26 1.832-2.37 0-1.108-.78-2.062-1.843-2.383l.012-5.27h-1.628l-.007 5.3c-.8.253-1.418.843-1.667 1.607l-4.394.007v1.54h4.423c.262.73.856 1.303 1.626 1.552l.003 3.88 1.642-.01h.004zm-2.326 8.374a1.16 1.16 0 0 0-1.58-.12 1.025 1.025 0 0 0-.126 1.5 1.167 1.167 0 0 0 1.584.12 1.024 1.024 0 0 0 .122-1.5zm2.07-4.493l1.688-.378.238-4.276-1.67-.552-.004 2.45c0 .952-.084 1.852-.252 2.755zm-1.396-5.3l-1.68.395s-.092 2.748-.055 2.13c.045-.72-.185 2.15-.185 2.15l1.695.557c.17-.873.227-1.767.227-2.687l-.003-2.547m1.662-20.16l-.014 5.203h-1.628v-5.225a2.248 2.248 0 0 1-.364-.147l-6.02 6.782-1.245-.99 6.135-6.913c-.05-.098-.104-.2-.14-.31h-4.452v-1.54h4.438c.342-1 1.325-1.715 2.49-1.715 1.447 0 2.625 1.11 2.625 2.482 0 1.115-.76 2.055-1.824 2.372zm-16.058-.02l-.014 3.204h-1.626l.004-3.177a2.568 2.568 0 0 1-1.715-1.606h-3.97v-1.54h3.97c.343-1 1.32-1.715 2.487-1.715s2.153.716 2.496 1.714h4.05v1.54h-4.06a2.523 2.523 0 0 1-1.622 1.58zm8.852 33.857a15.722 15.722 0 0 1-4.838 2.57l-.374-1.626a13.674 13.674 0 0 0 4.003-2.01l1.21 1.066m.814 1.404a17.453 17.453 0 0 1-4.84 2.547l1.258 1.176c1.41-.52 2.74-1.21 3.956-2.028l-.374-1.695m-27.418-31.372l-1.688.475v4.28l1.688.464v-5.22m1.638 0l1.684.476v4.28l-1.684.464v-5.22m30.515 0l-1.685.476v4.28l1.684.464v-5.22\" fill=\"none\" stroke=\"#c8b100\" stroke-width=\".25\"></path><path d=\"M247.108 283.145l1.69.475v4.28l-1.69.464v-5.22m-8.567 21.952l-1.604.68-2.938-3.258.965-1.387 3.578 3.966m1.245-1.006l.963-1.394-2.937-3.26-1.6.685 3.575 3.97m-18.224-20.1l1.608-.682 2.937 3.26-.965 1.39-3.58-3.968m-1.243 1.01l-.96 1.394 2.936 3.256 1.6-.685-3.576-3.966m18.444-1.136l-1.608-.667-2.91 3.282.977 1.38 3.54-3.996m1.254 1l.974 1.383-2.908 3.283-1.605-.672 3.54-3.995m-20.335 9.028l.493-1.6h4.525l.488 1.6h-5.506m0 1.548l.493 1.6h4.525l.488-1.6h-5.506m-6.634-18.53c0-.586.503-1.064 1.124-1.064.618 0 1.12.478 1.12 1.063 0 .587-.502 1.06-1.12 1.06-.62 0-1.124-.473-1.124-1.06zm12.1.773l-.495 1.603h-4.52l-.49-1.602h5.507m0-1.55l-.496-1.6h-4.52l-.49 1.6h5.507m20.046 18.504c0-.59.505-1.067 1.123-1.067.623 0 1.12.476 1.12 1.067 0 .59-.497 1.06-1.12 1.06-.618 0-1.123-.47-1.123-1.06zm-4.378-.743l-.496-1.6h-4.523l-.487 1.6h5.505m0 1.548l-.496 1.6h-4.523l-.487-1.6h5.505m-11.62 21.837c0-.59.502-1.066 1.122-1.066.618 0 1.118.475 1.118 1.065 0 .587-.5 1.06-1.118 1.06-.62 0-1.123-.473-1.123-1.06zm1.902-7.752l1.69-.473v-4.28l-1.69-.462v5.215m-1.637 0l-1.684-.473v-4.28l1.684-.462v5.215m15.744-32.616c0-.585.5-1.063 1.123-1.063.62 0 1.12.478 1.12 1.063 0 .587-.5 1.06-1.12 1.06-.622 0-1.123-.473-1.123-1.06zm-16.122 0c0-.585.504-1.063 1.122-1.063.62 0 1.12.478 1.12 1.063 0 .587-.5 1.06-1.12 1.06-.618 0-1.122-.473-1.122-1.06zm6.266.774l.497 1.603h4.52l.49-1.602h-5.507m0-1.55l.497-1.6h4.52l.49 1.6h-5.507m-5.91 4.994l-1.685.474v4.282l1.685.464v-5.22m1.62 0l1.684.474v4.282l-1.684.464v-5.22\" fill=\"none\" stroke=\"#c8b100\" stroke-width=\".25\"></path><path d=\"M227.688 294.66c0-1.376 1.178-2.49 2.63-2.49 1.446 0 2.622 1.114 2.622 2.49 0 1.37-1.176 2.482-2.623 2.482-1.45 0-2.63-1.11-2.63-2.482\" fill=\"#058e6e\"></path><path d=\"M230.892 229.69l.054-.593.082-.33s-1.546.126-2.36-.103c-.814-.23-1.548-.566-2.308-1.206-.76-.646-1.058-1.048-1.602-1.128-1.302-.21-2.306.382-2.306.382s.98.36 1.713 1.257c.73.903 1.527 1.36 1.87 1.468.57.174 2.55.05 3.093.072.544.027 1.764.183 1.764.183\" fill=\"#db4446\"></path><path d=\"M230.892 229.69l.054-.593.082-.33s-1.546.126-2.36-.103c-.814-.23-1.548-.566-2.308-1.206-.76-.646-1.058-1.048-1.602-1.128-1.302-.21-2.306.382-2.306.382s.98.36 1.713 1.257c.73.903 1.527 1.36 1.87 1.468.57.174 2.55.05 3.093.072.544.027 1.764.183 1.764.183v-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M238.124 227.515s.004.692.07 1.354c.067.633-.203 1.188-.1 1.54.1.355.15.634.29.89.128.255.2.903.2.903s-.37-.263-.713-.52c-.337-.258-.58-.418-.58-.418s.07.692.102.99c.037.295.21.854.49 1.185.278.324.833.856 1.004 1.282.177.43.142 1.378.142 1.378s-.45-.72-.837-.85c-.38-.133-1.215-.596-1.215-.596s.766.76.766 1.483c0 .722-.31 1.544-.31 1.544s-.347-.654-.796-1.083c-.454-.426-1.08-.856-1.08-.856s.49 1.12.49 1.872c0 .76-.137 2.373-.137 2.373s-.382-.623-.764-.927c-.384-.293-.835-.556-.976-.75-.136-.197.455.62.52 1.114.067.495.3 2.257 1.842 4.507.9 1.315 2.292 3.616 5.276 2.86 2.988-.754 1.88-4.77 1.253-6.645-.628-1.87-.94-3.948-.905-4.673.033-.72.554-2.856.486-3.256-.068-.39-.23-1.92.14-3.15.383-1.28.7-1.778.905-2.307.204-.526.377-.823.446-1.283.07-.46.07-1.32.07-1.32s.554 1.023.694 1.384c.138.366.138 1.447.138 1.447s.103-1.08.94-1.606c.835-.53 1.805-1.087 2.05-1.383.242-.3.313-.494.313-.494s-.07 1.845-.59 2.57c-.345.47-1.705 2.005-1.705 2.005s.698-.266 1.182-.293c.487-.037.833 0 .833 0s-.59.46-1.354 1.578c-.762 1.115-.45 1.214-1.006 2.134-.56.92-1.01.955-1.704 1.514-1.043.84-.48 4.172-.345 4.668.14.49 1.944 4.573 1.98 5.56.032.988.21 3.19-1.53 4.604-1.12.918-2.95.925-3.37 1.187-.418.258-1.245 1.08-1.245 2.79 0 1.716.62 1.975 1.106 2.404.49.43 1.113.198 1.252.53.14.326.21.523.418.72.21.195.35.427.278.785-.068.364-.868 1.186-1.146 1.782-.28.586-.835 2.137-.835 2.366 0 .232-.065.955.173 1.32 0 0 .868 1.012.277 1.21-.382.13-.755-.24-.936-.198-.518.137-.79.456-.938.43-.348-.066-.348-.236-.383-.723-.032-.492-.015-.692-.17-.692-.21 0-.313.17-.35.43-.036.262-.036.85-.276.85-.243 0-.59-.425-.798-.52-.21-.1-.8-.198-.832-.46-.036-.263.346-.822.727-.922.382-.098.73-.292.486-.49s-.486-.198-.727 0c-.244.198-.763.03-.73-.265.035-.297.104-.656.067-.822-.032-.16-.45-.49.102-.792.558-.293.798.267 1.353.167.558-.093.836-.298 1.044-.622.21-.327.173-1.02-.208-1.445-.383-.43-.764-.498-.905-.76-.14-.263-.345-.887-.345-.887s.1 1.15.03 1.316c-.066.164-.03.852-.03.852s-.382-.427-.695-.753c-.31-.33-.623-1.314-.623-1.314s-.033.92-.033 1.284c0 .357.414.69.277.822-.14.13-.796-.692-.97-.822-.177-.132-.73-.558-.976-1.022-.24-.46-.418-1.115-.485-1.35-.07-.23-.185-1.255-.07-1.514.172-.392.45-1.085.45-1.085h-1.354c-.727 0-1.25-.228-1.526.262-.277.495-.14 1.484.206 2.765.35 1.278.553 1.906.453 2.137-.102.23-.555.758-.727.853-.178.102-.664.068-.873-.027-.205-.1-.55-.267-1.213-.267-.658 0-1.076.03-1.317-.027-.243-.067-.835-.365-1.116-.3-.278.068-.757.313-.626.693.212.59-.205.724-.486.69-.277-.034-.514-.133-.868-.23-.344-.1-.867 0-.797-.397.067-.396.208-.426.38-.72.175-.3.24-.49.046-.51-.244-.025-.49-.052-.68.105-.183.153-.482.485-.727.362-.245-.13-.435-.413-.435-1.034 0-.616-.65-1.155-.053-1.128.597.028 1.357.465 1.494.13.134-.337.05-.487-.272-.75-.326-.256-.732-.41-.297-.743.434-.332.542-.332.708-.515.162-.177.394-.756.7-.613.595.283.027.695.624 1.36.598.667.976.903 1.98.797 1.003-.102 1.278-.232 1.278-.515 0-.284-.084-.795-.112-1.003-.025-.204.138-.95.138-.95s-.462.285-.598.564c-.13.284-.404.77-.404.77s-.11-.577-.08-1.048c.02-.276.117-.757.107-.852-.026-.255-.216-.9-.216-.9s-.164.696-.27.9c-.11.205-.162 1.03-.162 1.03s-.638-.556-.46-1.49c.132-.72-.11-1.67.106-1.98.213-.31.728-1.57 1.978-1.623 1.248-.047 2.223.054 2.66.03.434-.03 1.98-.31 1.98-.31s-2.85-1.462-3.5-1.902c-.65-.433-1.656-1.564-1.983-2.08-.325-.514-.623-1.513-.623-1.513s-.512.023-.975.28a4.92 4.92 0 0 0-1.192.947c-.274.31-.705 1.005-.705 1.005s.078-.9.078-1.183c0-.276-.053-.824-.053-.824s-.325 1.233-.976 1.693c-.652.468-1.41 1.11-1.41 1.11s.082-.69.082-.846c0-.153.16-.95.16-.95s-.46.687-1.166.824c-.705.126-1.738.1-1.82.54-.08.43.19 1.024.028 1.33-.163.31-.514.516-.514.516s-.407-.338-.76-.362c-.353-.027-.68.157-.68.157s-.3-.39-.19-.645c.11-.256.65-.64.517-.797-.136-.154-.57.054-.842.18-.27.13-.842.256-.788-.18.055-.437.19-.692.055-1.003-.136-.303-.055-.51.165-.59.215-.07 1.083.024 1.165-.173.08-.208-.216-.464-.788-.594-.57-.126-.842-.463-.542-.746.298-.283.38-.358.515-.616.135-.26.19-.72.707-.49.51.23.403.796.95.976.538.184 1.815-.074 2.084-.228.275-.157 1.142-.798 1.44-.954.3-.15 1.545-1.077 1.545-1.077s-.73-.51-1.003-.77c-.27-.257-.756-.87-.997-1-.246-.133-1.44-.59-1.847-.617-.407-.027-1.656-.46-1.656-.46s.57-.184.76-.338c.19-.153.62-.542.84-.514.215.028.267.028.267.028s-1.16-.056-1.407-.127c-.244-.083-.95-.52-1.218-.52-.276 0-.815.107-.815.107s.73-.463 1.327-.565c.597-.1 1.06-.08 1.06-.08s-.922-.255-1.142-.562c-.216-.31-.43-.767-.598-.975-.162-.204-.27-.54-.57-.565-.297-.027-.814.36-1.11.334-.296-.024-.516-.21-.546-.643-.02-.438 0-.286-.102-.514-.11-.234-.544-.774-.138-.9.41-.13 1.278.076 1.357-.078.083-.154-.46-.617-.812-.797-.353-.18-.922-.49-.623-.744.3-.256.596-.357.76-.59.162-.23.352-.872.706-.67.352.207.84 1.212 1.112 1.134.274-.08.294-.798.244-1.104-.055-.31 0-.85.266-.8.274.052.49.41.925.44.432.025 1.084-.1 1.03.203-.054.307-.3.688-.598 1.026-.29.337-.428 1.002-.24 1.438.19.44.68 1.137 1.112 1.416.43.282 1.245.49 1.764.822.513.338 1.71 1.284 2.116 1.387.407.105.814.31.814.31s.46-.205 1.086-.205c.623 0 2.06.102 2.603-.13.543-.234 1.25-.616 1.032-1.107-.215-.485-1.41-.924-1.303-1.306.11-.385.543-.41 1.273-.44.732-.023 1.736.13 1.924-.9.19-1.025.245-1.62-.782-1.847-1.032-.232-1.794-.255-1.98-1.002-.19-.744-.38-.924-.165-1.132.22-.2.597-.307 1.357-.354.76-.055 1.627-.055 1.872-.24.245-.173.295-.663.594-.872.297-.2 1.468-.386 1.468-.386s1.394.683 2.69 1.644c1.158.866 2.206 2.144 2.206 2.144\" fill=\"#ed72aa\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M228.124 226.792s-.162-.462-.19-.592c-.025-.127-.11-.283-.11-.283s.844 0 .816.255c-.026.26-.27.26-.325.358-.054.106-.19.262-.19.262\"></path><path d=\"M228.124 226.792s-.162-.462-.19-.592c-.025-.127-.11-.283-.11-.283s.844 0 .816.255c-.026.26-.27.26-.325.358-.054.106-.19.262-.19.262z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M231.98 225.453l-.058-.412s.734.008 1.087.257c.543.385.89.977.866 1.002-.094.09-.514-.257-.814-.36 0 0-.216.052-.434.052-.216 0-.325-.102-.354-.205-.024-.105.03-.283.03-.283l-.324-.047\"></path><path d=\"M231.98 225.453l-.058-.412s.734.008 1.087.257c.543.385.89.977.866 1.002-.094.09-.514-.257-.814-.36 0 0-.216.052-.434.052-.216 0-.325-.102-.354-.205-.024-.105.03-.283.03-.283l-.324-.047v-.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M237.27 231.262s-.327-.464-.406-.62c-.083-.15-.22-.46-.22-.46\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M217.405 226.636s.46.33.814.382c.35.054.733.054.787.054.054 0 .165-.52.108-.872-.19-1.16-1.25-1.415-1.25-1.415s.316.703.163 1.026c-.216.464-.623.826-.623.826\" fill=\"#db4446\"></path><path d=\"M217.405 226.636s.46.33.814.382c.35.054.733.054.787.054.054 0 .165-.52.108-.872-.19-1.16-1.25-1.415-1.25-1.415s.316.703.163 1.026c-.216.464-.623.826-.623.826z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M215.205 227.638s-.407-.746-1.273-.644c-.868.102-1.44.774-1.44.774s.958-.03 1.194.125c.354.233.462.826.462.826s.518-.31.68-.516a7.23 7.23 0 0 0 .377-.566\" fill=\"#db4446\"></path><path d=\"M215.205 227.638s-.407-.746-1.273-.644c-.868.102-1.44.774-1.44.774s.958-.03 1.194.125c.354.233.462.826.462.826s.518-.31.68-.516a7.23 7.23 0 0 0 .377-.566z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M214.148 230.642s-.732.105-1.138.57c-.41.462-.352 1.335-.352 1.335s.484-.51.92-.51c.437 0 1.113.152 1.113.152s-.215-.546-.215-.775c0-.23-.327-.773-.327-.773\" fill=\"#db4446\"></path><path d=\"M214.148 230.642s-.732.105-1.138.57c-.41.462-.352 1.335-.352 1.335s.484-.51.92-.51c.437 0 1.113.152 1.113.152s-.215-.546-.215-.775c0-.23-.327-.773-.327-.773z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M228.153 230.54l.323-.512.32.464-.643.047\"></path><path d=\"M228.153 230.54l.323-.512.32.464-.643.047\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M228.937 230.515l.38-.51.41.458-.79.052\"></path><path d=\"M228.937 230.515l.38-.51.41.458-.79.052\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M228.586 227.355l.787.283-.705.358-.082-.64\"></path><path d=\"M228.586 227.355l.787.283-.705.358-.082-.64\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M229.534 227.614l.706.178-.568.436-.138-.614\"></path><path d=\"M229.534 227.614l.706.178-.568.436-.138-.614\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M224.243 233.652s-.773.225-1.058.64c-.352.514-.326 1.03-.326 1.03s.65-.54 1.49-.31c.844.23.923.31 1.28.286.352-.027 1.22-.338 1.22-.338s-.705.822-.626 1.39c.082.564.187.82.164 1.106-.058.695-.57 1.544-.57 1.544s.298-.184 1.003-.337a4.58 4.58 0 0 0 1.682-.77c.38-.287.867-.98.867-.98s-.158.952 0 1.364c.162.413.216 1.595.216 1.595s.453-.4.812-.593c.19-.106.68-.362.873-.668.134-.22.3-1.024.3-1.024s.107.866.377 1.286c.273.405.676 1.67.676 1.67s.274-.82.573-1.158c.296-.334.652-.77.677-1.03.025-.256-.08-.818-.08-.818l.378.818m-10.96.59s.462-.795.898-1.054c.435-.258 1.033-.72 1.194-.77.158-.052.868-.44.868-.44m.95 4.963s1.045-.535 1.357-.722c.65-.383 1.112-1.078 1.112-1.078\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M216.616 240.357s-.406-.433-1.112-.307c-.706.13-1.166.927-1.166.927s.597-.157.95-.078c.352.077.598.435.598.435s.324-.283.432-.436c.11-.154.295-.543.295-.543\" fill=\"#db4446\"></path><path d=\"M216.616 240.357s-.406-.433-1.112-.307c-.706.13-1.166.927-1.166.927s.597-.157.95-.078c.352.077.598.435.598.435s.324-.283.432-.436c.11-.154.295-.543.295-.543h.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M215.803 243.21s-.598-.102-1.112.31c-.514.412-.542 1.207-.542 1.207s.49-.413.87-.357c.378.047.84.254.84.254s.082-.49.107-.616c.083-.36-.162-.8-.162-.8\" fill=\"#db4446\"></path><path d=\"M215.803 243.21s-.598-.102-1.112.31c-.514.412-.542 1.207-.542 1.207s.49-.413.87-.357c.378.047.84.254.84.254s.082-.49.107-.616c.083-.36-.162-.8-.162-.8z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M217.19 245.835s-.04.763.323 1.23c.38.49 1.087.567 1.087.567s-.237-.512-.274-.772c-.053-.384.325-.72.325-.72s-.35-.356-.7-.356c-.355 0-.76.05-.76.05\" fill=\"#db4446\"></path><path d=\"M217.19 245.835s-.04.763.323 1.23c.38.49 1.087.567 1.087.567s-.237-.512-.274-.772c-.053-.384.325-.72.325-.72s-.35-.356-.7-.356c-.355 0-.76.05-.76.05zm16.01 1.281s1.954 1.21 1.9 2.213c-.057 1.002-1.087 2.313-1.087 2.313\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M224.243 252.594s-.49-.616-1.166-.592c-.68.027-1.387.664-1.387.664s.844-.072 1.06.208c.22.287.435.64.435.64s.38-.2.544-.33c.162-.125.513-.59.513-.59\" fill=\"#db4446\"></path><path d=\"M224.243 252.594s-.49-.616-1.166-.592c-.68.027-1.387.664-1.387.664s.844-.072 1.06.208c.22.287.435.64.435.64s.38-.2.544-.33c.162-.125.513-.59.513-.59z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M222.153 255.29s-.893-.128-1.33.335c-.435.46-.406 1.31-.406 1.31s.545-.59 1.03-.54c.49.052 1.033.31 1.033.31s-.083-.514-.137-.746c-.054-.232-.19-.67-.19-.67\" fill=\"#db4446\"></path><path d=\"M222.153 255.29s-.893-.128-1.33.335c-.435.46-.406 1.31-.406 1.31s.545-.59 1.03-.54c.49.052 1.033.31 1.033.31s-.083-.514-.137-.746c-.054-.232-.19-.67-.19-.67z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M224.082 258.145s-.436.616-.108 1.104c.324.49 1 .722 1 .722s-.24-.358-.132-.775c.085-.326.65-.77.65-.77l-1.41-.28\" fill=\"#db4446\"></path><path d=\"M224.082 258.145s-.436.616-.108 1.104c.324.49 1 .722 1 .722s-.24-.358-.132-.775c.085-.326.65-.77.65-.77l-1.41-.28v-.002z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M235.992 259.304s-.783-.185-1.22.075c-.43.254-.784 1.335-.784 1.335s.705-.59 1.22-.518c.515.08.897.287.897.287s.078-.44.024-.744c-.033-.184-.138-.436-.138-.436\" fill=\"#db4446\"></path><path d=\"M235.992 259.304s-.783-.185-1.22.075c-.43.254-.784 1.335-.784 1.335s.705-.59 1.22-.518c.515.08.897.287.897.287s.078-.44.024-.744c-.033-.184-.138-.436-.138-.436z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M236.374 262.178s-.597.616-.382 1.13c.22.515.598 1.054.598 1.054s-.022-.766.22-.974c.35-.308 1-.36 1-.36s-.514-.462-.68-.513a15.836 15.836 0 0 1-.756-.337\" fill=\"#db4446\"></path><path d=\"M236.374 262.178s-.597.616-.382 1.13c.22.515.598 1.054.598 1.054s-.022-.766.22-.974c.35-.308 1-.36 1-.36s-.514-.462-.68-.513a15.836 15.836 0 0 1-.756-.337z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M239.358 263.08s-.298.743.274 1.23c.568.492 1.06.543 1.06.543s-.437-.774-.3-1.183c.14-.426.514-.692.514-.692s-.706-.235-.814-.208c-.107.024-.734.31-.734.31\" fill=\"#db4446\"></path><path d=\"M239.358 263.08s-.298.743.274 1.23c.568.492 1.06.543 1.06.543s-.437-.774-.3-1.183c.14-.426.514-.692.514-.692s-.706-.235-.814-.208c-.107.024-.734.31-.734.31z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M208.79 316.368c2.01.605 3.028 2.1 3.028 3.852 0 2.28-2.213 4.012-5.086 4.012-2.872 0-5.2-1.73-5.2-4.012 0-1.725.956-3.65 2.954-3.79 0 0-.06-.18-.233-.478-.208-.22-.616-.633-.616-.633s.763-.144 1.202.023c.442.167.733.446.733.446s.21-.41.5-.727c.296-.314.678-.51.678-.51s.442.37.587.62c.144.255.238.56.238.56s.406-.337.76-.473c.35-.14.805-.248.805-.248s-.13.44-.216.664c-.086.223-.133.692-.133.692\" fill=\"#ffd691\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M206.308 326.708s-3.82-2.574-5.475-2.922c-2.117-.446-4.496-.085-5.525-.14.028.03 1.234.89 1.763 1.422.53.528 2.294 1.585 3.29 1.834 3.1.778 5.948-.194 5.948-.194m1.089.225s2.447-2.544 5.007-2.895c3.027-.42 5.007.25 6.183.556.026 0-.972.474-1.5.835-.53.36-1.893 1.503-3.977 1.527-2.087.03-4.39-.22-4.772-.16-.382.05-.94.136-.94.136\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M206.664 323.786a4.852 4.852 0 0 1 .003-7.13 4.845 4.845 0 0 1 1.552 3.562 4.864 4.864 0 0 1-1.556 3.568\" fill=\"#ad1519\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M205.692 329.002s.59-1.46.648-2.713c.05-1.05-.148-2.087-.148-2.087h.763s.382 1.114.382 2.086c0 .973-.176 2.27-.176 2.27s-.528.08-.704.162c-.174.086-.764.28-.764.28\" fill=\"#058e6e\" stroke=\"#000\" stroke-width=\".499\"></path><path d=\"M254.005 190.727c0-.553.47-.993 1.05-.993.585 0 1.052.44 1.052.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995\" fill=\"#fff\"></path><path d=\"M254.005 190.727c0-.553.47-.993 1.05-.993.585 0 1.052.44 1.052.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M255.444 188.177c0-.55.468-.992 1.052-.992.58 0 1.05.443 1.05.992 0 .556-.47 1-1.05 1-.584 0-1.052-.444-1.052-1\" fill=\"#fff\"></path><path d=\"M255.444 188.177c0-.55.468-.992 1.052-.992.58 0 1.05.443 1.05.992 0 .556-.47 1-1.05 1-.584 0-1.052-.444-1.052-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M256.4 185.225c0-.55.473-.995 1.058-.995.58 0 1.05.446 1.05.995 0 .552-.47 1-1.05 1-.585 0-1.057-.448-1.057-1\" fill=\"#fff\"></path><path d=\"M256.4 185.225c0-.55.473-.995 1.058-.995.58 0 1.05.446 1.05.995 0 .552-.47 1-1.05 1-.585 0-1.057-.448-1.057-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M256.525 182.057c0-.552.47-.994 1.05-.994.58 0 1.05.442 1.05.994 0 .553-.47.996-1.05.996-.58 0-1.05-.443-1.05-.996\" fill=\"#fff\"></path><path d=\"M256.525 182.057c0-.552.47-.994 1.05-.994.58 0 1.05.442 1.05.994 0 .553-.47.996-1.05.996-.58 0-1.05-.443-1.05-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M255.743 178.94c0-.55.473-.993 1.05-.993.584 0 1.056.443 1.056.992 0 .554-.473.998-1.056.998-.578 0-1.05-.444-1.05-1\" fill=\"#fff\"></path><path d=\"M255.743 178.94c0-.55.473-.993 1.05-.993.584 0 1.056.443 1.056.992 0 .554-.473.998-1.056.998-.578 0-1.05-.444-1.05-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M254.124 176.11c0-.553.47-.996 1.05-.996.584 0 1.054.443 1.054.995s-.47.998-1.053.998c-.58 0-1.05-.446-1.05-1\" fill=\"#fff\"></path><path d=\"M254.124 176.11c0-.553.47-.996 1.05-.996.584 0 1.054.443 1.054.995s-.47.998-1.053.998c-.58 0-1.05-.446-1.05-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M251.964 173.784c0-.552.47-.998 1.05-.998.585 0 1.055.446 1.055.998 0 .55-.47.996-1.055.996-.58 0-1.05-.447-1.05-.996\" fill=\"#fff\"></path><path d=\"M251.964 173.784c0-.552.47-.998 1.05-.998.585 0 1.055.446 1.055.998 0 .55-.47.996-1.055.996-.58 0-1.05-.447-1.05-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M249.454 171.852c0-.553.473-1 1.056-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.583 0-1.056-.446-1.056-.994\" fill=\"#fff\"></path><path d=\"M249.454 171.852c0-.553.473-1 1.056-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.583 0-1.056-.446-1.056-.994z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M246.457 170.27c0-.553.47-.992 1.05-.992.584 0 1.056.44 1.056.99 0 .554-.472 1-1.055 1-.58 0-1.05-.446-1.05-1\" fill=\"#fff\"></path><path d=\"M246.457 170.27c0-.553.47-.992 1.05-.992.584 0 1.056.44 1.056.99 0 .554-.472 1-1.055 1-.58 0-1.05-.446-1.05-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M243.347 169.14c0-.548.47-.994 1.054-.994.58 0 1.053.446 1.053.995 0 .553-.473 1-1.052 1-.582 0-1.053-.447-1.053-1\" fill=\"#fff\"></path><path d=\"M243.347 169.14c0-.548.47-.994 1.054-.994.58 0 1.053.446 1.053.995 0 .553-.473 1-1.052 1-.582 0-1.053-.447-1.053-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M239.87 168.52c0-.548.47-.998 1.05-.998.585 0 1.054.45 1.054.998 0 .55-.47.997-1.053.997-.58 0-1.05-.448-1.05-.997\" fill=\"#fff\"></path><path d=\"M239.87 168.52c0-.548.47-.998 1.05-.998.585 0 1.054.45 1.054.998 0 .55-.47.997-1.053.997-.58 0-1.05-.448-1.05-.997z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M236.568 168.347c0-.55.473-.992 1.055-.992.58 0 1.053.442 1.053.992 0 .553-.473 1-1.053 1-.582 0-1.055-.447-1.055-1\" fill=\"#fff\"></path><path d=\"M236.568 168.347c0-.55.473-.992 1.055-.992.58 0 1.053.442 1.053.992 0 .553-.473 1-1.053 1-.582 0-1.055-.447-1.055-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M233.328 168.46c0-.55.474-.996 1.055-.996.584 0 1.052.447 1.052.996 0 .552-.468.998-1.052.998-.58 0-1.055-.446-1.055-.998\" fill=\"#fff\"></path><path d=\"M233.328 168.46c0-.55.474-.996 1.055-.996.584 0 1.052.447 1.052.996 0 .552-.468.998-1.052.998-.58 0-1.055-.446-1.055-.998z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M230.093 168.46c0-.55.47-.996 1.05-.996.58 0 1.052.447 1.052.996 0 .552-.472.998-1.05.998-.58 0-1.052-.446-1.052-.998\" fill=\"#fff\"></path><path d=\"M230.093 168.46c0-.55.47-.996 1.05-.996.58 0 1.052.447 1.052.996 0 .552-.472.998-1.05.998-.58 0-1.052-.446-1.052-.998z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M231.714 171.238c0-.552.47-.998 1.05-.998.584 0 1.05.446 1.05.998 0 .55-.466.998-1.05.998-.58 0-1.05-.45-1.05-.998m.658 3.068c0-.552.472-1 1.05-1 .584 0 1.056.448 1.056 1 0 .546-.472.992-1.055.992-.58 0-1.05-.446-1.05-.992m.117 3.058c0-.556.473-1 1.055-1 .58 0 1.05.444 1.05 1 0 .548-.47.995-1.05.995-.582 0-1.055-.448-1.055-.996m-.957 2.782c0-.55.47-.998 1.05-.998.584 0 1.053.45 1.053.998 0 .552-.47.995-1.053.995-.58 0-1.05-.443-1.05-.995m-1.789 2.557c0-.55.472-.998 1.05-.998.583 0 1.052.45 1.052.998 0 .55-.47.996-1.05.996-.58 0-1.052-.446-1.052-.996\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M227.642 166.53c0-.55.472-.992 1.054-.992.58 0 1.052.443 1.052.992 0 .552-.472 1-1.052 1-.582 0-1.054-.448-1.054-1\" fill=\"#fff\"></path><path d=\"M227.642 166.53c0-.55.472-.992 1.054-.992.58 0 1.052.443 1.052.992 0 .552-.472 1-1.052 1-.582 0-1.054-.448-1.054-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M224.765 164.94c0-.548.47-.997 1.052-.997.58 0 1.05.45 1.05.998 0 .55-.47.997-1.05.997-.582 0-1.052-.446-1.052-.996\" fill=\"#fff\"></path><path d=\"M224.765 164.94c0-.548.47-.997 1.052-.997.58 0 1.05.45 1.05.998 0 .55-.47.997-1.05.997-.582 0-1.052-.446-1.052-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M221.595 163.983c0-.55.472-.99 1.053-.99.58 0 1.052.44 1.052.99 0 .552-.472 1-1.052 1-.58 0-1.053-.448-1.053-1\" fill=\"#fff\"></path><path d=\"M221.595 163.983c0-.55.472-.99 1.053-.99.58 0 1.052.44 1.052.99 0 .552-.472 1-1.052 1-.58 0-1.053-.448-1.053-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M218.298 163.418c0-.55.472-.996 1.05-.996.584 0 1.052.447 1.052.996 0 .548-.468.995-1.05.995-.58 0-1.052-.447-1.052-.995\" fill=\"#fff\"></path><path d=\"M218.298 163.418c0-.55.472-.996 1.05-.996.584 0 1.052.447 1.052.996 0 .548-.468.995-1.05.995-.58 0-1.052-.447-1.052-.995z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M215.07 163.472c0-.548.47-1 1.05-1 .583 0 1.054.452 1.054 1 0 .553-.47.996-1.054.996-.58 0-1.05-.443-1.05-.996\" fill=\"#fff\"></path><path d=\"M215.07 163.472c0-.548.47-1 1.05-1 .583 0 1.054.452 1.054 1 0 .553-.47.996-1.054.996-.58 0-1.05-.443-1.05-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M211.71 164.038c0-.548.472-.993 1.052-.993.583 0 1.054.445 1.054.993 0 .555-.47 1-1.054 1-.58 0-1.052-.445-1.052-1\" fill=\"#fff\"></path><path d=\"M211.71 164.038c0-.548.472-.993 1.052-.993.583 0 1.054.445 1.054.993 0 .555-.47 1-1.054 1-.58 0-1.052-.445-1.052-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M208.6 165.112c0-.553.472-1 1.05-1 .585 0 1.056.447 1.056 1 0 .548-.47 1-1.055 1-.578 0-1.05-.452-1.05-1\" fill=\"#fff\"></path><path d=\"M208.6 165.112c0-.553.472-1 1.05-1 .585 0 1.056.447 1.056 1 0 .548-.47 1-1.055 1-.578 0-1.05-.452-1.05-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M155.928 190.727c0-.553.473-.993 1.052-.993.583 0 1.05.44 1.05.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995\" fill=\"#fff\"></path><path d=\"M155.928 190.727c0-.553.473-.993 1.052-.993.583 0 1.05.44 1.05.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M154.488 188.177c0-.55.472-.992 1.052-.992.583 0 1.055.443 1.055.992 0 .556-.472 1-1.055 1-.58 0-1.052-.444-1.052-1\" fill=\"#fff\"></path><path d=\"M154.488 188.177c0-.55.472-.992 1.052-.992.583 0 1.055.443 1.055.992 0 .556-.472 1-1.055 1-.58 0-1.052-.444-1.052-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M153.527 185.225c0-.55.472-.995 1.055-.995.58 0 1.052.446 1.052.995 0 .552-.472 1-1.052 1-.583 0-1.055-.448-1.055-1\" fill=\"#fff\"></path><path d=\"M153.527 185.225c0-.55.472-.995 1.055-.995.58 0 1.052.446 1.052.995 0 .552-.472 1-1.052 1-.583 0-1.055-.448-1.055-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M153.408 182.057c0-.552.473-.994 1.052-.994.583 0 1.055.442 1.055.994 0 .553-.472.996-1.055.996-.58 0-1.052-.443-1.052-.996\" fill=\"#fff\"></path><path d=\"M153.408 182.057c0-.552.473-.994 1.052-.994.583 0 1.055.442 1.055.994 0 .553-.472.996-1.055.996-.58 0-1.052-.443-1.052-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M154.19 178.94c0-.55.47-.993 1.05-.993.58 0 1.052.443 1.052.992 0 .554-.472.998-1.052.998-.58 0-1.05-.444-1.05-1\" fill=\"#fff\"></path><path d=\"M154.19 178.94c0-.55.47-.993 1.05-.993.58 0 1.052.443 1.052.992 0 .554-.472.998-1.052.998-.58 0-1.05-.444-1.05-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M155.805 176.11c0-.553.473-.996 1.056-.996.58 0 1.052.443 1.052.995s-.472.998-1.05.998c-.584 0-1.057-.446-1.057-1\" fill=\"#fff\"></path><path d=\"M155.805 176.11c0-.553.473-.996 1.056-.996.58 0 1.052.443 1.052.995s-.472.998-1.05.998c-.584 0-1.057-.446-1.057-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M157.966 173.784c0-.552.472-.998 1.054-.998.58 0 1.052.446 1.052.998 0 .55-.473.996-1.052.996-.582 0-1.054-.447-1.054-.996\" fill=\"#fff\"></path><path d=\"M157.966 173.784c0-.552.472-.998 1.054-.998.58 0 1.052.446 1.052.998 0 .55-.473.996-1.052.996-.582 0-1.054-.447-1.054-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M160.475 171.852c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.584 0-1.055-.446-1.055-.994\" fill=\"#fff\"></path><path d=\"M160.475 171.852c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.584 0-1.055-.446-1.055-.994z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M163.473 170.27c0-.553.47-.992 1.055-.992.58 0 1.05.44 1.05.99 0 .554-.47 1-1.05 1-.584 0-1.055-.446-1.055-1\" fill=\"#fff\"></path><path d=\"M163.473 170.27c0-.553.47-.992 1.055-.992.58 0 1.05.44 1.05.99 0 .554-.47 1-1.05 1-.584 0-1.055-.446-1.055-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M166.583 169.14c0-.548.472-.994 1.052-.994.582 0 1.054.446 1.054.995 0 .553-.473 1-1.055 1-.58 0-1.052-.447-1.052-1\" fill=\"#fff\"></path><path d=\"M166.583 169.14c0-.548.472-.994 1.052-.994.582 0 1.054.446 1.054.995 0 .553-.473 1-1.055 1-.58 0-1.052-.447-1.052-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M170.064 168.52c0-.548.47-.998 1.052-.998.578 0 1.05.45 1.05.998 0 .55-.472.997-1.05.997-.58 0-1.052-.448-1.052-.997\" fill=\"#fff\"></path><path d=\"M170.064 168.52c0-.548.47-.998 1.052-.998.578 0 1.05.45 1.05.998 0 .55-.472.997-1.05.997-.58 0-1.052-.448-1.052-.997z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M173.362 168.347c0-.55.47-.992 1.054-.992.58 0 1.05.442 1.05.992 0 .553-.47 1-1.05 1-.584 0-1.054-.447-1.054-1\" fill=\"#fff\"></path><path d=\"M173.362 168.347c0-.55.47-.992 1.054-.992.58 0 1.05.442 1.05.992 0 .553-.47 1-1.05 1-.584 0-1.054-.447-1.054-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M176.6 168.46c0-.55.472-.996 1.05-.996.585 0 1.056.447 1.056.996 0 .552-.47.998-1.055.998-.578 0-1.05-.446-1.05-.998\" fill=\"#fff\"></path><path d=\"M176.6 168.46c0-.55.472-.996 1.05-.996.585 0 1.056.447 1.056.996 0 .552-.47.998-1.055.998-.578 0-1.05-.446-1.05-.998z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M179.84 168.46c0-.55.47-.996 1.05-.996.584 0 1.056.447 1.056.996 0 .552-.472.998-1.055.998-.58 0-1.05-.446-1.05-.998\" fill=\"#fff\"></path><path d=\"M179.84 168.46c0-.55.47-.996 1.05-.996.584 0 1.056.447 1.056.996 0 .552-.472.998-1.055.998-.58 0-1.05-.446-1.05-.998z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M178.22 171.238c0-.552.472-.998 1.052-.998.582 0 1.054.446 1.054.998 0 .55-.472.998-1.054.998-.58 0-1.052-.45-1.052-.998m-.658 3.068c0-.552.467-1 1.05-1 .58 0 1.052.448 1.052 1 0 .546-.472.992-1.05.992-.585 0-1.052-.446-1.052-.992m-.122 3.058c0-.556.47-1 1.054-1 .58 0 1.05.444 1.05 1 0 .548-.47.995-1.05.995-.583 0-1.054-.448-1.054-.996m.96 2.782c0-.55.472-.998 1.05-.998.585 0 1.056.45 1.056.998 0 .552-.47.995-1.055.995-.578 0-1.05-.443-1.05-.995m1.787 2.557c0-.55.474-.998 1.052-.998.583 0 1.055.45 1.055.998 0 .55-.472.996-1.055.996-.578 0-1.052-.446-1.052-.996\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M182.288 166.53c0-.55.472-.992 1.05-.992.584 0 1.055.443 1.055.992 0 .552-.47 1-1.054 1-.58 0-1.052-.448-1.052-1\" fill=\"#fff\"></path><path d=\"M182.288 166.53c0-.55.472-.992 1.05-.992.584 0 1.055.443 1.055.992 0 .552-.47 1-1.054 1-.58 0-1.052-.448-1.052-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M185.168 164.94c0-.548.47-.997 1.05-.997.583 0 1.055.45 1.055.998 0 .55-.472.997-1.055.997-.58 0-1.05-.446-1.05-.996\" fill=\"#fff\"></path><path d=\"M185.168 164.94c0-.548.47-.997 1.05-.997.583 0 1.055.45 1.055.998 0 .55-.472.997-1.055.997-.58 0-1.05-.446-1.05-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M188.334 163.983c0-.55.473-.99 1.055-.99.58 0 1.05.44 1.05.99 0 .552-.47 1-1.05 1-.583 0-1.056-.448-1.056-1\" fill=\"#fff\"></path><path d=\"M188.334 163.983c0-.55.473-.99 1.055-.99.58 0 1.05.44 1.05.99 0 .552-.47 1-1.05 1-.583 0-1.056-.448-1.056-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M191.635 163.418c0-.55.472-.996 1.05-.996.585 0 1.057.447 1.057.996 0 .548-.472.995-1.056.995-.58 0-1.05-.447-1.05-.995\" fill=\"#fff\"></path><path d=\"M191.635 163.418c0-.55.472-.996 1.05-.996.585 0 1.057.447 1.057.996 0 .548-.472.995-1.056.995-.58 0-1.05-.447-1.05-.995z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M194.865 163.472c0-.548.467-1 1.05-1 .58 0 1.05.452 1.05 1 0 .553-.47.996-1.05.996-.583 0-1.05-.443-1.05-.996\" fill=\"#fff\"></path><path d=\"M194.865 163.472c0-.548.467-1 1.05-1 .58 0 1.05.452 1.05 1 0 .553-.47.996-1.05.996-.583 0-1.05-.443-1.05-.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M198.223 164.038c0-.548.47-.993 1.05-.993.585 0 1.052.445 1.052.993 0 .555-.467 1-1.052 1-.58 0-1.05-.445-1.05-1\" fill=\"#fff\"></path><path d=\"M198.223 164.038c0-.548.47-.993 1.05-.993.585 0 1.052.445 1.052.993 0 .555-.467 1-1.052 1-.58 0-1.05-.445-1.05-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M201.33 165.112c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47 1-1.05 1-.584 0-1.054-.452-1.054-1\" fill=\"#fff\"></path><path d=\"M201.33 165.112c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47 1-1.05 1-.584 0-1.054-.452-1.054-1z\" fill=\"none\" stroke=\"#000\" stroke-width=\".374\"></path><path d=\"M174.647 228.876h-.887v-.888h-1.553v3.55h1.553v2.44h-3.327v7.098h1.774v14.197h-3.55v7.32h27.286v-7.32h-3.55v-14.197h1.775v-7.1h-3.327v-2.438h1.554v-3.55h-1.553v.888h-.886v-.888H188.4v.888h-1.108v-.888h-1.554v3.55h1.554v2.44h-3.328v-7.765h1.774v-3.55h-1.774v.888h-.887v-.886h-1.553v.887h-.887v-.886h-1.775v3.55h1.775v7.763h-3.328v-2.44h1.552v-3.55h-1.553v.89h-.89v-.89h-1.773v.89zm-5.99 33.718h27.286m-27.285-1.775h27.285m-27.285-1.776h27.285m-27.285-1.775h27.285m-27.285-1.997h27.285m-23.736-1.553h20.187m-20.187-1.775h20.187m-20.187-1.996h20.187m-20.187-1.776h20.187m-20.187-1.775h20.187m-20.187-1.775h20.187m-20.187-1.775h20.187m-21.96-1.774h23.734m-23.735-1.775h23.735m-23.735-1.773h23.735m-23.735-1.775h23.735m-20.408-1.775h17.08m-10.203-1.774h3.327m-3.327-1.775h3.327m-3.327-1.774h3.327m-3.327-1.775h3.327m-5.102-2.22h6.876m-11.978 7.543h3.55m-5.103-2.22h6.655m-6.655 32.61v-1.774m0-1.776v-1.775m-1.774 1.774v1.775m3.327 0v-1.776m1.774 3.55v-1.775m0-1.776v-1.775m0-1.997v-1.553m0-1.775v-1.996m-1.774 7.32v-1.997m-3.327 1.996v-1.997m6.876 0v1.996m1.552-1.997v-1.553m-5.102-1.775v1.775m3.55-1.775v1.775m3.327-1.775v1.775m-1.775-1.775v-1.996m1.775-1.776v1.775m0-5.325v1.774m-1.775-3.55v1.775m1.775-3.55v1.775m-3.328-1.774v1.774m-3.55-1.774v1.774m-1.553-3.55v1.776m3.327-1.775v1.776m3.328-1.775v1.776m1.775-3.55v1.775m-3.328-1.773v1.774m-3.55-1.773v1.774m-1.553-3.548v1.775m6.655-1.775v1.775m-3.328-5.324v1.774m15.307-1.774h-3.548m5.102-2.22h-6.656m6.656 32.61v-1.774m0-1.776v-1.775m1.774 1.774v1.775m-3.327 0v-1.776m-1.774 3.55v-1.775m0-1.776v-1.775m0-1.997v-1.553m0-1.775v-1.996m1.775 7.32v-1.997m3.328 1.996v-1.997m-6.876 0v1.996m-1.554-1.997v-1.553m5.103-1.775v1.775m-3.548-1.775v1.775m-3.328-1.775v1.775m1.774-1.775v-1.996m-1.774-1.776v1.775m0-5.325v1.774m1.774-3.55v1.775m-1.774-3.55v1.775m3.328-1.774v1.774m3.55-1.774v1.774m1.552-3.55v1.776m-3.328-1.775v1.776m-3.328-1.775v1.776m-1.774-3.55v1.775m3.328-1.773v1.774m3.55-1.773v1.774m1.552-3.548v1.775m-6.656-1.775v1.775m3.328-5.324v1.774m-6.877 17.968v-1.996m0-5.325v-1.775m0 5.324V246.4m0-5.324V239.3m0-1.773v-1.775m0-3.55v-1.774m0-1.774v-1.775m-8.43 4.658h3.55m3.327-5.325h3.327m3.328 5.325h3.55\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".442\"></path><path d=\"M186.848 262.594v-4.66c0-.886-.444-3.548-4.66-3.548-3.992 0-4.435 2.662-4.435 3.55v4.658h9.095z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".442\"></path><path d=\"M179.305 258.156l-2.217-.22c0-.888.22-2.22.887-2.663l1.997 1.553c-.222.222-.667.887-.667 1.33zm5.99 0l2.218-.22c0-.888-.22-2.22-.887-2.663l-1.997 1.553c.22.222.665.887.665 1.33zm-2.218-2.218l1.11-1.996c-.445-.222-1.333-.443-1.998-.443-.444 0-1.33.22-1.775.442l1.11 1.996h1.552zm-4.215-5.545v-4.88c0-1.33-.887-2.44-2.44-2.44s-2.44 1.11-2.44 2.44v4.88h4.88zm6.876 0v-4.88c0-1.33.888-2.44 2.44-2.44 1.554 0 2.44 1.11 2.44 2.44v4.88h-4.88zm-1.774-11.979l.444-4.437h-4.215l.222 4.437h3.55zm3.328 0l-.444-4.437h4.436l-.443 4.437h-3.548zm-9.982 0l.22-4.437h-4.214l.444 4.437h3.55z\" fill=\"#c8b100\" stroke=\"#000\" stroke-width=\".442\"></path><path d=\"M185.295 262.594V258.6c0-.665-.444-2.662-3.106-2.662-2.44 0-2.885 1.997-2.885 2.662v3.994h5.99zm-6.877-12.644v-4.216c0-1.11-.665-2.218-1.997-2.218-1.33 0-1.994 1.11-1.994 2.218v4.215h3.992zm7.765 0v-4.216c0-1.11.665-2.218 1.996-2.218 1.33 0 1.995 1.11 1.995 2.218v4.215h-3.992z\" fill=\"#0039f0\"></path><path d=\"M190.808 269.766c0-9.698 6.987-17.56 15.604-17.56 8.62 0 15.608 7.862 15.608 17.56 0 9.698-6.987 17.56-15.608 17.56-8.617 0-15.604-7.862-15.604-17.56\" fill=\"#ad1519\"></path><path d=\"M190.808 269.766c0-9.698 6.987-17.56 15.604-17.56 8.62 0 15.608 7.862 15.608 17.56 0 9.698-6.987 17.56-15.608 17.56-8.617 0-15.604-7.862-15.604-17.56z\" fill=\"none\" stroke=\"#000\" stroke-width=\".586\"></path><path d=\"M195.437 269.732c0-7.112 4.913-12.875 10.982-12.875 6.064 0 10.978 5.763 10.978 12.875 0 7.114-4.914 12.88-10.98 12.88-6.068 0-10.98-5.766-10.98-12.88\" fill=\"#005bbf\"></path><path d=\"M195.437 269.732c0-7.112 4.913-12.875 10.982-12.875 6.064 0 10.978 5.763 10.978 12.875 0 7.114-4.914 12.88-10.98 12.88-6.068 0-10.98-5.766-10.98-12.88z\" fill=\"none\" stroke=\"#000\" stroke-width=\".586\"></path><path d=\"M201.232 260.868s-1.304 1.428-1.304 2.75c0 1.33.55 2.434.55 2.434-.196-.524-.73-.902-1.355-.902-.79 0-1.437.607-1.437 1.36 0 .218.134.56.235.746l.468.945c.155-.348.52-.54.944-.54.567 0 1.03.432 1.03.97a.88.88 0 0 1-.033.238l-1.17.004v.996h1.043l-.777 1.54 1.03-.4.776.875.806-.876 1.026.4-.773-1.54h1.044v-.995l-1.173-.004a.878.878 0 0 1-.024-.237c0-.538.453-.97 1.02-.97.426 0 .79.192.948.54l.464-.944c.1-.187.235-.528.235-.746 0-.753-.64-1.36-1.436-1.36-.627 0-1.156.378-1.354.902 0 0 .547-1.104.547-2.433 0-1.324-1.33-2.752-1.33-2.752\" fill=\"#c8b100\"></path><path d=\"M201.232 260.868s-1.304 1.428-1.304 2.75c0 1.33.55 2.434.55 2.434-.196-.524-.73-.902-1.355-.902-.79 0-1.437.607-1.437 1.36 0 .218.134.56.235.746l.468.945c.155-.348.52-.54.944-.54.567 0 1.03.432 1.03.97a.88.88 0 0 1-.033.238l-1.17.004v.996h1.043l-.777 1.54 1.03-.4.776.875.806-.876 1.026.4-.773-1.54h1.044v-.995l-1.173-.004a.878.878 0 0 1-.024-.237c0-.538.453-.97 1.02-.97.426 0 .79.192.948.54l.464-.944c.1-.187.235-.528.235-.746 0-.753-.64-1.36-1.436-1.36-.627 0-1.156.378-1.354.902 0 0 .547-1.104.547-2.433 0-1.324-1.33-2.752-1.33-2.752h.002z\" fill=\"none\" stroke=\"#000\" stroke-width=\".326\" stroke-linejoin=\"round\"></path><path d=\"M199.16 269.868h4.177v-.996h-4.178v.996z\" fill=\"#c8b100\"></path><path d=\"M199.16 269.868h4.177v-.996h-4.178v.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".326\"></path><path d=\"M211.436 260.868s-1.302 1.428-1.302 2.75c0 1.33.547 2.434.547 2.434-.194-.524-.726-.902-1.353-.902-.795 0-1.436.607-1.436 1.36 0 .218.135.56.235.746l.464.945c.158-.348.522-.54.947-.54.568 0 1.025.432 1.025.97a.89.89 0 0 1-.028.238l-1.17.004v.996h1.043l-.777 1.54 1.026-.4.78.875.804-.876 1.03.4-.778-1.54h1.043v-.995l-1.17-.004a.84.84 0 0 1-.028-.237c0-.538.457-.97 1.026-.97.425 0 .788.192.943.54l.467-.944c.102-.187.234-.528.234-.746 0-.753-.643-1.36-1.436-1.36-.624 0-1.16.378-1.355.902 0 0 .55-1.104.55-2.433 0-1.324-1.33-2.752-1.33-2.752\" fill=\"#c8b100\"></path><path d=\"M211.436 260.868s-1.302 1.428-1.302 2.75c0 1.33.547 2.434.547 2.434-.194-.524-.726-.902-1.353-.902-.795 0-1.436.607-1.436 1.36 0 .218.135.56.235.746l.464.945c.158-.348.522-.54.947-.54.568 0 1.025.432 1.025.97a.89.89 0 0 1-.028.238l-1.17.004v.996h1.043l-.777 1.54 1.026-.4.78.875.804-.876 1.03.4-.778-1.54h1.043v-.995l-1.17-.004a.84.84 0 0 1-.028-.237c0-.538.457-.97 1.026-.97.425 0 .788.192.943.54l.467-.944c.102-.187.234-.528.234-.746 0-.753-.643-1.36-1.436-1.36-.624 0-1.16.378-1.355.902 0 0 .55-1.104.55-2.433 0-1.324-1.33-2.752-1.33-2.752h.002z\" fill=\"none\" stroke=\"#000\" stroke-width=\".326\" stroke-linejoin=\"round\"></path><path d=\"M209.363 269.868h4.176v-.996h-4.177v.996z\" fill=\"#c8b100\"></path><path d=\"M209.363 269.868h4.176v-.996h-4.177v.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".326\"></path><path d=\"M206.333 269.646s-1.304 1.428-1.304 2.755.55 2.43.55 2.43c-.197-.524-.727-.903-1.356-.903-.792 0-1.437.608-1.437 1.36 0 .222.133.56.234.747l.47.944c.158-.347.517-.545.94-.545.57 0 1.032.436 1.032.975a.86.86 0 0 1-.033.242l-1.17.003v.996h1.047l-.778 1.54 1.026-.406.777.876.807-.876 1.03.406-.783-1.54h1.048v-.997l-1.17-.003a.9.9 0 0 1-.03-.242c0-.54.458-.975 1.028-.975.423 0 .783.198.942.545l.47-.944c.098-.188.232-.525.232-.746 0-.753-.644-1.36-1.436-1.36-.625 0-1.154.378-1.356.903 0 0 .55-1.103.55-2.43 0-1.326-1.335-2.754-1.335-2.754\" fill=\"#c8b100\"></path><path d=\"M206.333 269.646s-1.304 1.428-1.304 2.755.55 2.43.55 2.43c-.197-.524-.727-.903-1.356-.903-.792 0-1.437.608-1.437 1.36 0 .222.133.56.234.747l.47.944c.158-.347.517-.545.94-.545.57 0 1.032.436 1.032.975a.86.86 0 0 1-.033.242l-1.17.003v.996h1.047l-.778 1.54 1.026-.406.777.876.807-.876 1.03.406-.783-1.54h1.048v-.997l-1.17-.003a.9.9 0 0 1-.03-.242c0-.54.458-.975 1.028-.975.423 0 .783.198.942.545l.47-.944c.098-.188.232-.525.232-.746 0-.753-.644-1.36-1.436-1.36-.625 0-1.154.378-1.356.903 0 0 .55-1.103.55-2.43 0-1.326-1.335-2.754-1.335-2.754h.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".326\" stroke-linejoin=\"round\"></path><path d=\"M204.26 278.65h4.178v-.997h-4.178v.996z\" fill=\"#c8b100\"></path><path d=\"M204.26 278.65h4.178v-.997h-4.178v.996z\" fill=\"none\" stroke=\"#000\" stroke-width=\".326\"></path><path d=\"M237.567 223.398l-.278.02a1.483 1.483 0 0 1-.256.342c-.246.234-.616.26-.825.064a.472.472 0 0 1-.134-.393.498.498 0 0 1-.49-.006c-.248-.143-.31-.483-.13-.767.03-.054.058-.125.1-.167l-.017-.31-.336.08-.097.182c-.208.236-.518.297-.673.158a.555.555 0 0 1-.126-.253c.003.008-.08.082-.166.102-.513.126-.72-1.006-.73-1.3l-.17.24s.153.677.076 1.25c-.075.573-.278 1.146-.278 1.146.717.184 1.79.766 2.855 1.588 1.066.815 1.904 1.7 2.25 2.322 0 0 .552-.308 1.13-.49.574-.188 1.303-.192 1.303-.192l.21-.205c-.308.044-1.52.095-1.495-.413.005-.08.065-.17.076-.17a.667.667 0 0 1-.29-.065c-.175-.116-.17-.412.024-.658l.17-.123.01-.326-.325.045c-.03.04-.105.087-.15.128-.254.222-.62.238-.823.03a.422.422 0 0 1-.107-.446.548.548 0 0 1-.433-.045c-.248-.15-.295-.5-.104-.773.09-.134.266-.29.297-.307l-.067-.287\" fill=\"#c8b100\"></path><path d=\"M237.567 223.398l-.278.02a1.483 1.483 0 0 1-.256.342c-.246.234-.616.26-.825.064a.472.472 0 0 1-.134-.393.498.498 0 0 1-.49-.006c-.248-.143-.31-.483-.13-.767.03-.054.058-.125.1-.167l-.017-.31-.336.08-.097.182c-.208.236-.518.297-.673.158a.555.555 0 0 1-.126-.253c.003.008-.08.082-.166.102-.513.126-.72-1.006-.73-1.3l-.17.24s.153.677.076 1.25c-.075.573-.278 1.146-.278 1.146.717.184 1.79.766 2.855 1.588 1.066.815 1.904 1.7 2.25 2.322 0 0 .552-.308 1.13-.49.574-.188 1.303-.192 1.303-.192l.21-.205c-.308.044-1.52.095-1.495-.413.005-.08.065-.17.076-.17a.667.667 0 0 1-.29-.065c-.175-.116-.17-.412.024-.658l.17-.123.01-.326-.325.045c-.03.04-.105.087-.15.128-.254.222-.62.238-.823.03a.422.422 0 0 1-.107-.446.548.548 0 0 1-.433-.045c-.248-.15-.295-.5-.104-.773.09-.134.266-.29.297-.307l-.067-.287-.007-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M235.406 224.06c.048-.06.148-.056.223.002.074.058.095.15.05.205-.047.054-.145.054-.223-.007-.072-.054-.097-.147-.05-.2\"></path><path d=\"M235.406 224.06c.048-.06.148-.056.223.002.074.058.095.15.05.205-.047.054-.145.054-.223-.007-.072-.054-.097-.147-.05-.2z\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M236.317 224.825l-.314-.242c-.057-.044-.075-.115-.04-.156.037-.038.113-.038.17.003l.313.246.32.243c.055.04.075.11.04.155-.04.037-.115.034-.172-.007l-.317-.243\"></path><path d=\"M236.317 224.825l-.314-.242c-.057-.044-.075-.115-.04-.156.037-.038.113-.038.17.003l.313.246.32.243c.055.04.075.11.04.155-.04.037-.115.034-.172-.007l-.317-.243\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M234.644 223.68l-.25-.146c-.06-.037-.093-.11-.063-.156.026-.052.1-.06.162-.02l.247.145.252.147c.06.034.09.106.065.157-.028.044-.1.054-.165.017l-.248-.144\"></path><path d=\"M234.644 223.68l-.25-.146c-.06-.037-.093-.11-.063-.156.026-.052.1-.06.162-.02l.247.145.252.147c.06.034.09.106.065.157-.028.044-.1.054-.165.017l-.248-.144\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M233.653 222.996c.047-.05.15-.05.223.007.076.058.097.15.05.204-.047.055-.146.05-.222-.003-.075-.062-.098-.15-.05-.208\"></path><path d=\"M233.653 222.996c.047-.05.15-.05.223.007.076.058.097.15.05.204-.047.055-.146.05-.222-.003-.075-.062-.098-.15-.05-.208z\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M237.325 225.528c.047-.055.024-.143-.05-.204-.076-.06-.177-.062-.224-.003-.045.054-.024.146.05.204.076.06.177.06.225.004\"></path><path d=\"M237.325 225.528c.047-.055.024-.143-.05-.204-.076-.06-.177-.062-.224-.003-.045.054-.024.146.05.204.076.06.177.06.225.004z\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M237.876 226.16l.204.196c.05.047.13.066.174.027.043-.033.037-.1-.01-.15l-.203-.2-.208-.205c-.05-.047-.13-.06-.173-.023-.047.03-.04.105.013.152l.203.202\"></path><path d=\"M237.876 226.16l.204.196c.05.047.13.066.174.027.043-.033.037-.1-.01-.15l-.203-.2-.208-.205c-.05-.047-.13-.06-.173-.023-.047.03-.04.105.013.152l.203.202\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M238.785 226.935c.048-.057.026-.146-.05-.207-.075-.06-.176-.06-.223-.003-.047.058-.025.146.05.207.076.055.178.06.223.003\"></path><path d=\"M238.785 226.935c.048-.057.026-.146-.05-.207-.075-.06-.176-.06-.223-.003-.047.058-.025.146.05.207.076.055.178.06.223.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M236.146 221.14l-.567.018-.112.835.06.133.148-.01.727-.49-.257-.486\" fill=\"#c8b100\"></path><path d=\"M236.146 221.14l-.567.018-.112.835.06.133.148-.01.727-.49-.257-.486\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M234.608 221.604l-.016.522.883.11.137-.06-.01-.142-.516-.686-.478.256\" fill=\"#c8b100\"></path><path d=\"M234.608 221.604l-.016.522.883.11.137-.06-.01-.142-.516-.686-.478.256\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M236.432 222.644l-.47.262-.517-.687-.01-.14.137-.06.886.106-.026.518\" fill=\"#c8b100\"></path><path d=\"M236.432 222.644l-.47.262-.517-.687-.01-.14.137-.06.886.106-.026.518\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M235.29 222a.28.28 0 0 1 .378-.09.25.25 0 0 1 .095.356.287.287 0 0 1-.378.092.255.255 0 0 1-.095-.358\" fill=\"#c8b100\"></path><path d=\"M235.29 222a.28.28 0 0 1 .378-.09.25.25 0 0 1 .095.356.287.287 0 0 1-.378.092.255.255 0 0 1-.095-.358z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M233.226 221.138c-.015.003-.124-.44-.246-.686-.083-.177-.375-.408-.375-.408.03-.055.397-.188.836.088.357.294-.028.832-.028.832s-.094.13-.184.174\" fill=\"#c8b100\"></path><path d=\"M233.226 221.138c-.015.003-.124-.44-.246-.686-.083-.177-.375-.408-.375-.408.03-.055.397-.188.836.088.357.294-.028.832-.028.832s-.094.13-.184.174h-.003z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M234.217 221.437l-.402.348-.656-.57.057-.08.023-.14.888-.066.09.507\" fill=\"#c8b100\"></path><path d=\"M234.217 221.437l-.402.348-.656-.57.057-.08.023-.14.888-.066.09.507\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M233.107 221.082c.05-.143.175-.227.276-.197.1.037.14.177.093.317-.05.143-.176.225-.276.198-.105-.038-.144-.178-.093-.318\" fill=\"#c8b100\"></path><path d=\"M233.107 221.082c.05-.143.175-.227.276-.197.1.037.14.177.093.317-.05.143-.176.225-.276.198-.105-.038-.144-.178-.093-.318z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M238.32 222.5l-.564-.06-.237.815.043.14.148.003.792-.386-.18-.51\" fill=\"#c8b100\"></path><path d=\"M238.32 222.5l-.564-.06-.237.815.043.14.148.003.792-.386-.18-.51\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M236.727 222.753l-.09.515.857.225.144-.04.01-.14-.407-.754-.513.193\" fill=\"#c8b100\"></path><path d=\"M236.727 222.753l-.09.515.857.225.144-.04.01-.14-.407-.754-.513.193\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M238.383 224.02l-.507.202-.407-.75.01-.143.143-.04.857.227-.097.504\" fill=\"#c8b100\"></path><path d=\"M238.383 224.02l-.507.202-.407-.75.01-.143.143-.04.857.227-.097.504\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M237.346 223.237c.094-.116.27-.125.386-.037a.25.25 0 0 1 .043.365.29.29 0 0 1-.39.036.25.25 0 0 1-.04-.363\" fill=\"#c8b100\"></path><path d=\"M237.346 223.237c.094-.116.27-.125.386-.037a.25.25 0 0 1 .043.365.29.29 0 0 1-.39.036.25.25 0 0 1-.04-.363z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M240.22 224.264l.102.534-.838.28-.148-.03-.017-.14.348-.775.55.13\" fill=\"#c8b100\"></path><path d=\"M240.22 224.264l.102.534-.838.28-.148-.03-.017-.14.348-.775.55.13\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M240.068 225.794l-.536.12-.297-.8.034-.135.147-.02.817.333-.166.5\" fill=\"#c8b100\"></path><path d=\"M240.068 225.794l-.536.12-.297-.8.034-.135.147-.02.817.333-.166.5\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M238.613 224.314l-.173.495.818.33.15-.02.03-.137-.292-.794-.533.124\" fill=\"#c8b100\"></path><path d=\"M238.613 224.314l-.173.495.818.33.15-.02.03-.137-.292-.794-.533.124\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M239.517 225.242a.26.26 0 0 0 .015-.373.298.298 0 0 0-.393-.014.257.257 0 0 0-.01.373.29.29 0 0 0 .387.012\" fill=\"#c8b100\"></path><path d=\"M239.517 225.242a.26.26 0 0 0 .015-.373.298.298 0 0 0-.393-.014.257.257 0 0 0-.01.373.29.29 0 0 0 .387.012z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M240.837 226.973c-.003.014.48.025.757.085.198.042.504.263.504.263.054-.04.108-.405-.27-.755-.378-.27-.85.204-.85.204s-.115.112-.14.203\" fill=\"#c8b100\"></path><path d=\"M240.837 226.973c-.003.014.48.025.757.085.198.042.504.263.504.263.054-.04.108-.405-.27-.755-.378-.27-.85.204-.85.204s-.115.112-.14.203z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M240.32 226.114l-.277.447.726.492.09-.08.118-.04-.112-.84-.547.022\" fill=\"#c8b100\"></path><path d=\"M240.32 226.114l-.277.447.726.492.09-.08.118-.04-.112-.84-.547.022\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M240.917 227.072c.133-.074.198-.21.144-.296-.057-.09-.21-.1-.344-.024-.134.078-.198.207-.14.3.052.085.208.096.34.02\" fill=\"#c8b100\"></path><path d=\"M240.917 227.072c.133-.074.198-.21.144-.296-.057-.09-.21-.1-.344-.024-.134.078-.198.207-.14.3.052.085.208.096.34.02z\" fill=\"none\" stroke=\"#000\" stroke-width=\".25\"></path><path d=\"M279.087 205.098v.556h-2.434v-.556h.9v-1.254h-.594v-.56h.594v-.547h.586v.548h.586v.56h-.586v1.253h.947\" fill=\"none\" stroke=\"#000\" stroke-width=\".288\"></path><path d=\"M134.418 217.104v-1.216\" fill=\"none\" stroke=\"#000\" stroke-width=\".019\"></path><path d=\"M134.087 217.104v-1.216\" fill=\"none\" stroke=\"#000\" stroke-width=\".029\"></path><path d=\"M133.775 217.104v-1.216m-.31 1.216v-1.216\" fill=\"none\" stroke=\"#000\" stroke-width=\".038\"></path><path d=\"M133.19 217.104v-1.216\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M132.665 217.04l-.008-1.11m.256 1.123v-1.16\" fill=\"none\" stroke=\"#000\" stroke-width=\".058\"></path><path d=\"M132.18 216.99v-1.022m.245 1.05l-.007-1.086\" fill=\"none\" stroke=\"#000\" stroke-width=\".067\"></path><path d=\"M131.528 216.93v-.896m.214.91v-.94m.22.97v-.977\" fill=\"none\" stroke=\"#000\" stroke-width=\".077\"></path><path d=\"M131.3 216.924v-.868\" fill=\"none\" stroke=\"#000\" stroke-width=\".086\"></path><path d=\"M131.087 216.88v-.81\" fill=\"none\" stroke=\"#000\" stroke-width=\".096\"></path><path d=\"M130.86 216.857v-.75\" fill=\"none\" stroke=\"#000\" stroke-width=\".106\"></path><path d=\"M130.392 216.792l-.008-.598m.247.627v-.67m-.479.589v-.524\" fill=\"none\" stroke=\"#000\" stroke-width=\".115\"></path><path d=\"M129.933 216.698v-.437\" fill=\"none\" stroke=\"#000\" stroke-width=\".125\"></path><path d=\"M129.693 216.64v-.342\" fill=\"none\" stroke=\"#000\" stroke-width=\".134\"></path><path d=\"M129.448 216.612v-.256\" fill=\"none\" stroke=\"#000\" stroke-width=\".144\"></path><path d=\"M129.188 216.553v-.124\" fill=\"none\" stroke=\"#000\" stroke-width=\".173\"></path><path d=\"M135.733 217.04v-1.116m-.56 1.15l.007-1.18m-.416 1.196v-1.202\" fill=\"none\" stroke=\"#000\" stroke-width=\".01\"></path><path d=\"M277.777 217.125v-1.217\" fill=\"none\" stroke=\"#000\" stroke-width=\".019\"></path><path d=\"M277.447 217.125v-1.217\" fill=\"none\" stroke=\"#000\" stroke-width=\".029\"></path><path d=\"M277.135 217.125v-1.217m-.309 1.217v-1.217\" fill=\"none\" stroke=\"#000\" stroke-width=\".038\"></path><path d=\"M276.55 217.125v-1.217\" fill=\"none\" stroke=\"#000\" stroke-width=\".048\"></path><path d=\"M276.024 217.06l-.008-1.11m.258 1.123v-1.157\" fill=\"none\" stroke=\"#000\" stroke-width=\".058\"></path><path d=\"M275.54 217.01v-1.022m.245 1.05l-.008-1.086\" fill=\"none\" stroke=\"#000\" stroke-width=\".067\"></path><path d=\"M274.888 216.95v-.895m.214.91v-.94m.22.97v-.977\" fill=\"none\" stroke=\"#000\" stroke-width=\".077\"></path><path d=\"M274.66 216.944v-.867\" fill=\"none\" stroke=\"#000\" stroke-width=\".086\"></path><path d=\"M274.447 216.9v-.81\" fill=\"none\" stroke=\"#000\" stroke-width=\".096\"></path><path d=\"M274.22 216.878v-.75\" fill=\"none\" stroke=\"#000\" stroke-width=\".106\"></path><path d=\"M273.752 216.812l-.008-.597m.247.627v-.67m-.479.588v-.524\" fill=\"none\" stroke=\"#000\" stroke-width=\".115\"></path><path d=\"M273.293 216.72v-.438\" fill=\"none\" stroke=\"#000\" stroke-width=\".125\"></path><path d=\"M273.053 216.66v-.34\" fill=\"none\" stroke=\"#000\" stroke-width=\".134\"></path><path d=\"M272.807 216.632v-.256\" fill=\"none\" stroke=\"#000\" stroke-width=\".144\"></path><path d=\"M272.547 216.573v-.124\" fill=\"none\" stroke=\"#000\" stroke-width=\".173\"></path><path d=\"M279.092 217.06v-1.116m-.56 1.15l.008-1.178m-.415 1.194v-1.202\" fill=\"none\" stroke=\"#000\" stroke-width=\".01\"></path>", 579)
const _hoisted_1162 = [
  _hoisted_583
]

function DpFlagESvue_type_template_id_305428e2_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagESvue_type_template_id_305428e2_hoisted_1, _hoisted_581))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_582, _hoisted_1162))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagES.vue?vue&type=template&id=305428e2

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagES.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagESvue_type_script_lang_js = ({
  name: "DpFlagES",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagES.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagES.vue




;
const DpFlagES_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagESvue_type_script_lang_js, [['render',DpFlagESvue_type_template_id_305428e2_render]])

/* harmony default export */ var DpFlagES = (DpFlagES_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagFI.vue?vue&type=template&id=0200f634


const DpFlagFIvue_type_template_id_0200f634_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagFIvue_type_template_id_0200f634_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 0h512v512H0z"
}, null, -1)
const DpFlagFIvue_type_template_id_0200f634_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#003580",
  d: "M0 186.182h512v139.636H0z"
}, null, -1)
const DpFlagFIvue_type_template_id_0200f634_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#003580",
  d: "M123.152 0h139.636v512H123.152z"
}, null, -1)
const DpFlagFIvue_type_template_id_0200f634_hoisted_5 = [
  DpFlagFIvue_type_template_id_0200f634_hoisted_2,
  DpFlagFIvue_type_template_id_0200f634_hoisted_3,
  DpFlagFIvue_type_template_id_0200f634_hoisted_4
]
const DpFlagFIvue_type_template_id_0200f634_hoisted_6 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagFIvue_type_template_id_0200f634_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 0h640v480H0z"
}, null, -1)
const DpFlagFIvue_type_template_id_0200f634_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#003580",
  d: "M0 174.545h640v130.909H0z"
}, null, -1)
const DpFlagFIvue_type_template_id_0200f634_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#003580",
  d: "M175.455 0h130.909v480H175.455z"
}, null, -1)
const DpFlagFIvue_type_template_id_0200f634_hoisted_10 = [
  DpFlagFIvue_type_template_id_0200f634_hoisted_7,
  DpFlagFIvue_type_template_id_0200f634_hoisted_8,
  DpFlagFIvue_type_template_id_0200f634_hoisted_9
]

function DpFlagFIvue_type_template_id_0200f634_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagFIvue_type_template_id_0200f634_hoisted_1, DpFlagFIvue_type_template_id_0200f634_hoisted_5))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagFIvue_type_template_id_0200f634_hoisted_6, DpFlagFIvue_type_template_id_0200f634_hoisted_10))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagFI.vue?vue&type=template&id=0200f634

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagFI.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagFIvue_type_script_lang_js = ({
  name: "DpFlagFI",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagFI.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagFI.vue




;
const DpFlagFI_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagFIvue_type_script_lang_js, [['render',DpFlagFIvue_type_template_id_0200f634_render]])

/* harmony default export */ var DpFlagFI = (DpFlagFI_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagFR.vue?vue&type=template&id=5c43a0f3


const DpFlagFRvue_type_template_id_5c43a0f3_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagFRvue_type_template_id_5c43a0f3_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h512.005v512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#00267f",
    d: "M0 0h170.667v512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#f31830",
    d: "M341.333 0H512v512H341.333z"
  })
], -1)
const DpFlagFRvue_type_template_id_5c43a0f3_hoisted_3 = [
  DpFlagFRvue_type_template_id_5c43a0f3_hoisted_2
]
const DpFlagFRvue_type_template_id_5c43a0f3_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagFRvue_type_template_id_5c43a0f3_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#00267f",
    d: "M0 0h213.337v480H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#f31830",
    d: "M426.662 0H640v480H426.662z"
  })
], -1)
const DpFlagFRvue_type_template_id_5c43a0f3_hoisted_6 = [
  DpFlagFRvue_type_template_id_5c43a0f3_hoisted_5
]

function DpFlagFRvue_type_template_id_5c43a0f3_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagFRvue_type_template_id_5c43a0f3_hoisted_1, DpFlagFRvue_type_template_id_5c43a0f3_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagFRvue_type_template_id_5c43a0f3_hoisted_4, DpFlagFRvue_type_template_id_5c43a0f3_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagFR.vue?vue&type=template&id=5c43a0f3

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagFR.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagFRvue_type_script_lang_js = ({
  name: "DpFlagFR",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagFR.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagFR.vue




;
const DpFlagFR_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagFRvue_type_script_lang_js, [['render',DpFlagFRvue_type_template_id_5c43a0f3_render]])

/* harmony default export */ var DpFlagFR = (DpFlagFR_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagGB.vue?vue&type=template&id=1442a7fa


const DpFlagGBvue_type_template_id_1442a7fa_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagGBvue_type_template_id_1442a7fa_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g transform=\"translate(-256) scale(1.024)\"><g stroke-width=\"1pt\"><path fill=\"#006\" d=\"M0 0h1000.02v500.01H0z\"></path><path d=\"M0 0v55.903l888.218 444.11h111.802V444.11L111.802.003H0zm1000.02 0v55.9L111.802 500.01H0v-55.9L888.218 0h111.802z\" fill=\"#fff\"></path><path d=\"M416.675 0v500.01h166.67V0h-166.67zM0 166.67v166.67h1000.02V166.67H0z\" fill=\"#fff\"></path><path d=\"M0 200.004v100.002h1000.02V200.004H0zM450.01 0v500.01h100V0h-100zM0 500.01l333.34-166.67h74.535L74.535 500.01H0zM0 0l333.34 166.67h-74.535L0 37.27V0zm592.145 166.67L925.485 0h74.535L666.68 166.67h-74.535zm407.875 333.34L666.68 333.34h74.535l258.805 129.403v37.267z\" fill=\"#c00\"></path></g></g>", 1)
const DpFlagGBvue_type_template_id_1442a7fa_hoisted_3 = [
  DpFlagGBvue_type_template_id_1442a7fa_hoisted_2
]
const DpFlagGBvue_type_template_id_1442a7fa_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagGBvue_type_template_id_1442a7fa_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-85.333 0h682.67v512h-682.67z\"></path></clipPath></defs><g clip-path=\"url(#a)\" transform=\"translate(80) scale(.94)\"><g stroke-width=\"1pt\"><path fill=\"#006\" d=\"M-256 0H768.02v512.01H-256z\"></path><path d=\"M-256 0v57.244l909.535 454.768H768.02V454.77L-141.515 0H-256zM768.02 0v57.243L-141.515 512.01H-256v-57.243L653.535 0H768.02z\" fill=\"#fff\"></path><path d=\"M170.675 0v512.01h170.67V0h-170.67zM-256 170.67v170.67H768.02V170.67H-256z\" fill=\"#fff\"></path><path d=\"M-256 204.804v102.402H768.02V204.804H-256zM204.81 0v512.01h102.4V0h-102.4zM-256 512.01L85.34 341.34h76.324l-341.34 170.67H-256zM-256 0L85.34 170.67H9.016L-256 38.164V0zm606.356 170.67L691.696 0h76.324L426.68 170.67h-76.324zM768.02 512.01L426.68 341.34h76.324L768.02 473.848v38.162z\" fill=\"#c00\"></path></g></g>", 2)
const DpFlagGBvue_type_template_id_1442a7fa_hoisted_7 = [
  DpFlagGBvue_type_template_id_1442a7fa_hoisted_5
]

function DpFlagGBvue_type_template_id_1442a7fa_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagGBvue_type_template_id_1442a7fa_hoisted_1, DpFlagGBvue_type_template_id_1442a7fa_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagGBvue_type_template_id_1442a7fa_hoisted_4, DpFlagGBvue_type_template_id_1442a7fa_hoisted_7))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagGB.vue?vue&type=template&id=1442a7fa

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagGB.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagGBvue_type_script_lang_js = ({
  name: "DpFlagGB",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagGB.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagGB.vue




;
const DpFlagGB_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagGBvue_type_script_lang_js, [['render',DpFlagGBvue_type_template_id_1442a7fa_render]])

/* harmony default export */ var DpFlagGB = (DpFlagGB_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagGR.vue?vue&type=template&id=bcdedbec


const DpFlagGRvue_type_template_id_bcdedbec_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagGRvue_type_template_id_bcdedbec_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M0 0h666v666H0z\"></path></clipPath></defs><g transform=\"scale(.77)\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#0d5eaf\" d=\"M0 0h999v74H0z\"></path><path fill=\"#fff\" d=\"M0 74h999v74H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 148h999v74H0z\"></path><path fill=\"#fff\" d=\"M0 222h999v74H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 296h999v74H0z\"></path><path fill=\"#fff\" d=\"M0 370h999v74H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 444h999v74H0z\"></path><path fill=\"#fff\" d=\"M0 518h999v74H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 592h999v74H0zM0 0h370v370H0z\"></path><g fill=\"#fff\"><path d=\"M148 0h74v370h-74z\"></path><path d=\"M0 148h370v74H0z\"></path></g></g></g>", 2)
const DpFlagGRvue_type_template_id_bcdedbec_hoisted_4 = [
  DpFlagGRvue_type_template_id_bcdedbec_hoisted_2
]
const DpFlagGRvue_type_template_id_bcdedbec_hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagGRvue_type_template_id_bcdedbec_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M0 0h120v90H0z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\" transform=\"scale(5.33)\" stroke-width=\"1pt\"><path fill=\"#0d5eaf\" d=\"M0 0h135v10H0z\"></path><path fill=\"#fff\" d=\"M0 10h135v10H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 20h135v10H0z\"></path><path fill=\"#fff\" d=\"M0 30h135v10H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 40h135v10H0z\"></path><path fill=\"#fff\" d=\"M0 50h135v10H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 60h135v10H0z\"></path><path fill=\"#fff\" d=\"M0 70h135v10H0z\"></path><path fill=\"#0d5eaf\" d=\"M0 80h135v10H0zM0 0h50v50H0z\"></path><g fill=\"#fff\"><path d=\"M20 0h10v50H20z\"></path><path d=\"M0 20h50v10H0z\"></path></g></g>", 2)
const DpFlagGRvue_type_template_id_bcdedbec_hoisted_8 = [
  DpFlagGRvue_type_template_id_bcdedbec_hoisted_6
]

function DpFlagGRvue_type_template_id_bcdedbec_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagGRvue_type_template_id_bcdedbec_hoisted_1, DpFlagGRvue_type_template_id_bcdedbec_hoisted_4))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagGRvue_type_template_id_bcdedbec_hoisted_5, DpFlagGRvue_type_template_id_bcdedbec_hoisted_8))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagGR.vue?vue&type=template&id=bcdedbec

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagGR.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagGRvue_type_script_lang_js = ({
  name: "DpFlagGR",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagGR.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagGR.vue




;
const DpFlagGR_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagGRvue_type_script_lang_js, [['render',DpFlagGRvue_type_template_id_bcdedbec_render]])

/* harmony default export */ var DpFlagGR = (DpFlagGR_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagHR.vue?vue&type=template&id=23ea40fa


const DpFlagHRvue_type_template_id_23ea40fa_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagHRvue_type_template_id_23ea40fa_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"#171796\" d=\"M0 0h512v512H0z\"></path><path fill=\"#fff\" d=\"M0 0h512v341.333H0z\"></path><path fill=\"red\" d=\"M0 0h512v170.667H0z\"></path><path d=\"M256.032 388.425c54.742 0 99.528-44.79 99.528-99.53V170.628H156.5v118.27c0 54.74 44.79 99.528 99.53 99.528z\" fill=\"red\"></path><path d=\"M256.032 386.83c53.698 0 97.63-43.935 97.63-97.63V172.542H158.398V289.2c0 53.698 43.935 97.63 97.634 97.63z\" fill=\"#fff\"></path><g fill=\"red\"><path d=\"M199.608 176.213h-37.572v41.28h37.572zm0 82.559h37.573v-41.278H199.61zm-37.572 30.198c0 3.748.232 7.446.664 11.083h36.908v-41.28h-37.572v30.196zm112.72-30.198H237.18v41.28h37.576zm0 82.558h37.573v-41.277h-37.574zm37.574 22.582a95.136 95.136 0 0 0 21.45-22.58h-21.45v22.58zM199.61 341.33h37.573v-41.277H199.61zm-21.486 0a95.113 95.113 0 0 0 21.487 22.608V341.33h-21.486zm84.388 41.28a93.406 93.406 0 0 0 12.24-1.67v-39.61h-37.57v39.616a92.865 92.865 0 0 0 12.205 1.663c4.375.27 8.75.254 13.123 0z\"></path><path d=\"M349.2 300.053c.433-3.65.666-7.36.666-11.122v-30.155h-37.54v41.28H349.2zm-74.444-41.281h37.573v-41.278h-37.574zm0-82.559h-37.573v41.28h37.573zm75.11 41.281v-41.28H312.33v41.28z\"></path></g><path d=\"M351.97 169.417l23.296-52.81-17.75-28.66-29.405 10.887-20.644-23.6-27.205 15.59-24.256-19.867-24.258 19.867-27.204-15.59-20.648 23.597-29.406-10.885-17.754 28.668L160 169.433c29.318-13.27 61.826-20.664 96.006-20.664 34.166 0 66.658 7.387 95.968 20.647z\" fill=\"#fff\"></path><path d=\"M184.54 101.164l-.042.05-29.16-10.797-16.32 26.348 6.252 14.212 15.835 35.948a234.315 234.315 0 0 1 36.888-12.76l-13.45-52.998z\" fill=\"#0093dd\"></path><path d=\"M182.863 127.22a14.142 14.142 0 0 1 1.635 6.613c0 7.85-6.402 14.253-14.253 14.253-6.918 0-12.71-4.974-13.99-11.528 2.462 4.353 7.135 7.3 12.474 7.3 7.887 0 14.322-6.433 14.322-14.324 0-.79-.065-1.562-.19-2.318z\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".299\"></path><path d=\"M169.8 107.498l-.048.235-.993 5.116 3.924 3.43.18.156-.228.078-4.926 1.7-1.01 5.112-.047.235-.18-.158-3.932-3.417-4.93 1.683-.23.078.048-.237.993-5.114-3.922-3.43-.182-.16.228-.078 4.926-1.696 1.01-5.113.047-.236.18.156 3.932 3.42 4.93-1.683z\"></path><path d=\"M163.88 114.763l3.678 3.207 4.603-1.585zm.03-.163l8.284 1.62-3.665-3.204zm-8.89-1.74l8.28 1.62-3.678-3.205zm8.25 1.784l-8.284-1.62 3.665 3.202zm.462-.311l5.545-6.362-4.608 1.573zm-5.955 6.832l5.545-6.362-4.615 1.582zm5.671-6.253l-5.545 6.362 4.608-1.572zm5.955-6.832l-5.545 6.362 4.615-1.583zm-5.993 6.273l-2.737-7.982-.943 4.778zm2.94 8.574l-2.737-7.982-.938 4.787zm-2.58-8.037l2.737 7.984.943-4.777zm-2.94-8.575l2.737 7.985.938-4.79z\" fill=\"#f7db17\"></path><path d=\"M232 93.233l-.05.04-26.978-15.46-20.43 23.35 13.45 53a234.432 234.432 0 0 1 38.524-6.435l-4.52-54.495z\" fill=\"#171796\"></path><path d=\"M194.654 141.01a247.734 247.734 0 0 1 40.742-6.805l-1.142-13.775a261.917 261.917 0 0 0-43.002 7.18l3.4 13.4zm-6.761-26.637a275.153 275.153 0 0 1 45.23-7.555l-1.12-13.522a288.77 288.77 0 0 0-47.45 7.924l3.34 13.153z\" fill=\"red\"></path><g transform=\"translate(-256) scale(.00253)\"><path d=\"M212105 36890l-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z\" fill=\"#0093dd\"></path><g id=\"a\"><path d=\"M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z\"></path><g fill=\"#f7db17\"><path d=\"M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zm-5008 0c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zm4539 905c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-4032 0c-32 0-59 26-59 59 0 32 26 59 59 59s59-26 59-59-26-59-59-59zm4294-304c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z\"></path><path d=\"M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zm4389 911c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7-21 18-40 38-55 59s-28 43-38 67c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z\"></path><path d=\"M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z\"></path><path d=\"M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15-67 0-123-55-123-123s55-123 123-123c51 0 94 31 113 75l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54 68 0 123 55 123 123s-55 123-123 123c-12 0-25-2-36-6l33 94-2 7zm3067-416c-68 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-33 0-59 27-59 59s26 59 59 59c32 0 59-27 59-59s-26-59-59-59zm-1082-91c-67 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-32 0-59 26-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-1064-40c-68 0-123 55-123 123s55 123 123 123c67 0 123-55 123-123s-55-123-123-123zm0 64c-33 0-59 26-59 59s26 59 59 59c32 0 59-26 59-59 0-32-26-59-59-59z\" fill-rule=\"evenodd\"></path></g><path d=\"M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110zm799 5115l-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48zm59-326l-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51zm-1826-65l604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15zm51 322l515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210l402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38zm593-3082c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49zm371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16 8-6 17-13 25-19 6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z\"></path><path d=\"M203459 50602c-119 0-216 97-216 216s97 217 216 217 216-97 216-217c0-119-97-216-216-216zm0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147zm0 60c-48 0-87 39-87 87s39 87 87 87 87-39 87-87-39-87-87-87zm-1697-124c119 0 217 97 217 216s-97 217-217 217c-119 0-216-97-216-217 0-119 97-216 216-216zm0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147zm0 60c48 0 87 39 87 87s-39 87-87 87-87-39-87-87 39-87 87-87z\" fill-rule=\"evenodd\"></path></g><use height=\"100%\" width=\"100%\" xlink:href=\"#a\" transform=\"rotate(-2.173 -55532.79 156275.842)\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#a\" transform=\"rotate(2.18 459865.852 156275.76)\"></use></g><path d=\"M328.126 101.29l-.063.02-20.493-23.42-26.944 15.442-4.544 54.546a234.548 234.548 0 0 1 38.56 6.455l13.482-53.042z\" fill=\"#171796\"></path><path d=\"M285.94 104.648c.937-.227 1.86-.275 2.756.274.393.162.69.37.87.635.416-.322.838-.623 1.276-.88.615-.456 1.242-.858 1.918-1.084.966-.49 1.93-.78 2.896-.87 1.023-.175 2.05-.185 3.072-.124.852.05 1.677.285 2.464.738.713.354 1.424.71 2.138 1.065.754.42 1.508.8 2.262 1.118.956.378 2.03.505 3.177.548.56.02 1.113.02 1.654-.124.438-.117.71.162.228.458-3.542 2.173-6.318.24-8.686-.625a17.183 17.183 0 0 1 2.277 1.814c.9.87 1.908 1.75 3.69 2.56 1.08.492 2.256.88 3.766.892a9.454 9.454 0 0 0 1.66-.114c.3-.048.43-.02.434.136.005.107-.023.32-.202.438-.914.612-1.774.774-2.733.835-1.828.116-3.78-.483-5.567-1.442-1.43-.77-2.393-1.705-3.532-2.545-1.135-.838-2.116-1.303-3.17-1.526-1.04-.222-2.167-.197-3.116.096.284.056.524.19.67.36.49.288 1.116.415 2.025.518.472.056.325.382-.404.774-.437.565-1.007.868-1.763.795-1.042.69-1.414.273-1.763-.18a3.124 3.124 0 0 1-.25.838.644.644 0 0 1-.016.455c.167.258.248.51.192.784a.658.658 0 0 0 .233.42c.217.198.356.425.384.704.002.184.103.336.25.473.213.175.428.33.64.59.63.228.92.71 1.025 1.336.474.154.672.5.765.908.27.114.52.25.66.49.972.004 1.92.004 2.81.097.83.09 1.51.61 2.117 1.282.41.063.824.083 1.25-.013.437-.193.9-.34 1.404-.383.832-.07 1.667-.114 2.46.076.54.13.96.415 1.304.804.496.564 1.26.49 1.913.21.885-.377 1.622-.364 2.527.033.387-.15.775-.22 1.162-.18.33-.36.683-.447 1.044-.457.59-.02 1.018.07.906.827-.03.205-.152.402-.306.473-.27.584-.787.756-1.442.7-.07.403-.235.702-.498.894.3.928.012 1.3-.676 1.288-.144.268-.36.435-.726.382a1.474 1.474 0 0 1-.93.55c.04.242.143.355.315.616.467.708-.236.994-.88 1.004.166.47.186.937.128 1.405.655.397.744.814.14 1.227.442.773.27 1.342-.56 1.757-.013.433-.056.868-.344 1.11-.198.168-.48.198-.294.512.337.555.263 1.26-.235 1.28-.106-.01-.202.004-.21.173 0 .06-.05.117-.15.175-.596.32-1.156.688-1.67 1.11-.075.05-.15.087-.227.018-.374.815-1.073 1.642-1.844 2.475-.12.613-.466 1.028-1.04 1.243-.04.19-.162.3-.342.35.322.356.443.7.132 1.04-.382.416-.886.824-1.39.953-1.07.273-1.74.222-2.17-.187-.38-.363-.23-.636.01-.75-.66.053-.794-.296-.776-.762.038-.233.116-.202.35-.195.358.01.682-.184 1.02-.296a2 2 0 0 1 .517-.577c.12-.748.592-1.163 1.235-1.41.518-.196 1.014-.697 1.495-1.345l.89-1.53a1.32 1.32 0 0 1-.27-.812 1.578 1.578 0 0 1-.595-.552c-.465-.032-.658-.242-.726-.533a1.105 1.105 0 0 1-.35-.045c-.227.146-.457.275-.743.263a7.36 7.36 0 0 1-1.163.97c-.14.386-.415.54-.75.588-.957.114-1.53 1.306-2.055 1.79-.213.158-.344.437-.438.77-.046.628-.154 1.12-.5 1.13-.307-.014-.355-.047-.365-.08a1.266 1.266 0 0 0-.404.018c.258.285.3.64.06.955-.237.31-.578.405-.907.428-.682.045-1.233-.016-1.744-.223-.49-.2-.547-.49-.532-.774-.35-.167-.422-.334-.384-.5.048-.21.243-.32.488-.252.213-.1.425-.17.638-.21.617-.665 1.252-1.237 1.95-1.502a3.2 3.2 0 0 1 .726-.656c.08-.597.473-1.067.954-1.505a2.16 2.16 0 0 1 .235-.647c-.026-.13.01-.19.012-.31-.195-.363-.312-.798-.167-1.16a1.402 1.402 0 0 1-.054-.576c-1.147.683-1.5.45-1.633-.104-.42.35-.812.516-1.093.01-.407.12-.817.258-1.224.096-.266.103-.534.196-.84.217a3.26 3.26 0 0 1-.516.736c-.013.516-.193 1.032-.524 1.548a9.79 9.79 0 0 1-.744 1.653c.005.177-.02.355-.114.534.09.635-.124.944-.473 1.1a2.57 2.57 0 0 1-.446.77l-.028.253c.14.374.162.746-.218 1.12-.306.193-.632.395-.956.555-.382.187-.736.098-1.058-.018-.564-.202-.52-.4-.447-.592a.688.688 0 0 1-.557-.008c-.137-.086-.223-.174-.36-.263-.12-.22-.164-.42.132-.577.372-.164.625-.286.92-.587.1-.227.23-.4.41-.445.178-.415.396-.696.692-.772.217-.513.45-1.08.726-1.57.096-.15.167-.304.12-.474-.004-.14.006-.27.123-.35.066-.056.182-.106.035-.185a1.453 1.453 0 0 1 .175-1.232c.298-.45.632-1.538.316-2.072-.06-.297-.117-.64-.08-.92-.108-.005-.19.01-.298-.065-.243-.15-.445-.008-.63.263-.134.34-.268.637-.402.637-.127.876-.557 1.556-1.005 1.73-.103.403-.17.805-.113 1.208.045.437 0 .736-.203.786-.223.055-.43.184-.56.54-.035.1-.076.218-.078.36.308.32.215.716-.08 1.01-.67.657-1.5.56-2.377.303-.635-.25-.79-.516-.726-.787-.902-.076-.722-.766.024-.974.802-.225 1.452-.74 1.986-1.472.048-.87.248-1.463.716-1.556.046-.534.213-1.015.438-1.47.235-.412.38-.865.296-1.417-.498-.31-.52-.632-.06-.96.15-.09.133-.18-.054-.272-.303-.03-.266-.32-.245-.595-.012-.14-.085-.215-.22-.217-.672-.1-.505-.375-.217-.673.12-.137.202-.34.076-.42-.105-.066-.176-.296-.198-.498-.413-.312-.236-.63 0-.937-.233-.197-.342-.485-.375-.822-.766-.033-1.052-.422-.637-.99.174-.24.4-.47.673-.69.177-.286.346-.572.263-.857-.22-.56.483-.982 1.085-1.417a.94.94 0 0 1-.13-.44c-.34-.325-.254-.63.12-.917a1.15 1.15 0 0 1-.138-.446c-.843.167-.838-.336-.446-1.146-.488-.28-.35-.778.534-1.537.013-.174.046-.31.096-.402a2.04 2.04 0 0 0-1.067.325c-.338.22-.672.192-1.008.053a1.597 1.597 0 0 0-.445-.438.664.664 0 0 1-.236-.673c-.99.056-1.18-.678-.586-1.11.332-.264.575-.54.666-.84.268-.68.837-1.144 1.39-1.62 0-.195.044-.39.105-.587-.245-.164-.504-.283-.787-.306-.1-.253-.29-.526-.612-.68-.185-.112-.246-.215-.132-.466-.526-.47-.394-.756-.26-1.027z\"></path><g fill=\"#f7db17\"><path d=\"M303.935 130.196c-.06.005-.12.01-.188.008a9.02 9.02 0 0 1-.845.744c-.245-.284-.61.028-.253.2-.06.043-.122.086-.183.126-.116.31-.222.44-.567.493a1.766 1.766 0 0 0-.16.03 3.152 3.152 0 0 1 .016-.38c.015-.156.04-.305.074-.452.005-.027.012-.053-.04-.065-.054-.013-.062.015-.067.043-.033.15-.06.306-.078.463-.015.14-.02.28-.015.422-.868.278-1.37 1.182-1.96 1.824-.257.22-.386.524-.48.843-.05.17-.068.946-.242.96h-.266c-.093-.143-.22-.146-.38-.01-.36-.01-.746-.012-1.067.04-.22.237.385.148.706.346.148.09.21.264.153.507-.296.706-1.948.478-2.497.187-.256-.134-.266-.29-.256-.51.114 0 .23-.006.347-.024.197-.028.392-.086.584-.195.054-.03.11-.06.05-.17-.06-.108-.117-.078-.17-.047-.162.093-.33.14-.496.164-.172.025-.35.025-.52.018-.014 0-.03-.003-.042 0-.096-.056-.17-.122-.13-.18.042-.055.2.005.23.015.257-.12.48-.194.755-.248.582-.622 1.174-1.206 1.976-1.528.24-.29.5-.517.815-.724.11-.694.448-1.063.95-1.523.062-.286.133-.49.274-.742-.03-.158-.007-.26 0-.42-.192-.365-.306-.682-.154-1.09-.093-.295-.08-.495-.045-.768a.372.372 0 0 0-.003-.154 6.643 6.643 0 0 1 .906-.612c-.023.273-.013.56.04.858l-.002.002c-.086.094-.16.185-.21.28a.566.566 0 0 0-.08.297c0 .028 0 .056.057.053.057 0 .057-.027.054-.055a.46.46 0 0 1 .066-.24 1.26 1.26 0 0 1 .195-.256.112.112 0 0 0 .02-.028c.266-.008.526-.15.787-.36.235-.19.47-.44.703-.7-.002.38-.005.76-.01 1.138a2.5 2.5 0 0 0-.574.752c-.012.025-.025.048.023.073.05.025.064 0 .074-.026.14-.276.316-.504.52-.693h.01c.057 0 .057-.027.057-.055v-.002c.035-.03.073-.06.11-.09.26-.2.553-.35.87-.472-.05.335-.072.66-.014.975.063.344.225.668.554.95.005.006.013.01.02.01z\"></path><path d=\"M287.41 120.572c.042-.078.15-.18.186-.172l.02-.005c.12-.223.243-.43.372-.617a4.25 4.25 0 0 1 .53-.64c.02-.02.042-.038.08 0 .038.04.017.058 0 .078a4.175 4.175 0 0 0-.52.623 6.214 6.214 0 0 0-.363.606c.038.05.055.13.035.184.038.347.084.542.238.742a.216.216 0 0 1 .053-.036c.064-.154.15-.29.257-.412.13-.147.29-.27.483-.375.13-.11.238-.22.324-.337a1.54 1.54 0 0 0 .202-.35c.01-.024.02-.05.073-.03.05.02.04.05.03.074a1.7 1.7 0 0 1-.215.374 2.134 2.134 0 0 1-.35.358s-.007.005-.01.005c-.18.1-.333.215-.455.352a1.33 1.33 0 0 0-.225.35c.08.057.116.216.04.318-.23.33-.503.526-.073.81a.678.678 0 0 0 .202.546c.1.102.09.464-.154.725-.228.23-.053.17.182.197.018.005.036.013.053.018v-.003a2.72 2.72 0 0 1 .3-.455c.108-.137.227-.266.348-.387.17-.167.304-.35.4-.534.093-.18.15-.363.16-.54.002-.028.002-.056.06-.05.056.002.053.03.05.057-.012.192-.07.39-.172.587a2.25 2.25 0 0 1-.418.56c-.12.118-.233.24-.34.376a2.775 2.775 0 0 0-.285.438c.283.172.192.48.235.764.056.008.104.02.147.04a23.88 23.88 0 0 0 .177-.278l.262-.417c.014-.023.03-.048.075-.018.048.03.033.052.017.075l-.263.417c-.056.09-.112.175-.168.264l-.007.012c.174.142.187.4-.028.597-.423.32-.304.418.09.67.052.373.054.67-.027.987.003.008.003.018.005.028.01.104.018.21.026.314l.026.316c.002.028.005.056-.05.06-.056.006-.06-.022-.06-.05l-.027-.316c-.003-.028-.006-.053-.006-.08-.02.047-.04.098-.066.15-.283.62-.576 1.127-.64 1.822-.68.162-.58.833-.617 1.425-.535.724-1.158 1.304-2.02 1.592-.162.053-.555.15-.593.354-.005.074.264.233.436.14.475-.456.713-.203.167.263-.043.087-.008.186.086.27.493.442 1.715.586 2.272.235.412-.258.627-.542.268-.934.023-.555.24-1.1.827-1.256.068-.127.048-.362.018-.49-.055-.484.02-.914.14-1.38.02-.058.063-.106.16-.13.222-.047.65-.692.784-1.312.033-.134.053-.273.078-.412.035-.215.12-.253.228-.127.103-.14.1-.223.164-.382.228-.33.557-.596.94-.41a3.24 3.24 0 0 1-.186-.887c-.028-.37.008-.75.122-1.1.015-.054.032-.104.116-.09l.33-.788c.113-.263.224-.53.335-.792.01-.025.022-.05.072-.03.05.02.04.048.03.073l-.333.792c-.113.263-.222.523-.333.784.048.035.033.08.018.127-.1.315-.134.664-.11 1.005.026.37.117.727.254 1.018.012.027.027.055.022.083.182.106.18.132.172.374-.005.19.02.377.066.605.36.668-.015 1.786-.367 2.345-.17.27-.215.58-.144.89.216.21.075.43-.118.575-.015.05 0 .11.003.16.02.217-.058.4-.172.58-.296.533-.524 1.102-.762 1.66-.43.12-.517.37-.69.773-.25.07-.275.144-.382.374a2.89 2.89 0 0 1-.933.633c-.306.14-.01.273.205.42.195.144.45-.17.61-.408.174-.263.35-.184.237.02-.126.226-.217.55-.23.72-.066.18.628.32.747.326.422.02.953-.393 1.285-.603.275-.28.232-.526.11-.867l.003-.023a2.103 2.103 0 0 1-.51-.05 3.664 3.664 0 0 1-.596-.198c-.025-.01-.05-.02-.03-.073.02-.052.048-.042.073-.032.197.08.387.15.58.19.16.035.323.053.498.048l.028-.266c.22-.27.372-.536.49-.86.468-.22.47-.448.408-.95a.947.947 0 0 0 .12-.55c.307-.55.56-1.11.77-1.705.37-.49.547-.954.504-1.54.033-.226.116-.355.283-.348.123-.17.23-.344.33-.54.02.004.04.007.06.007a.09.09 0 0 1 0-.04 1.8 1.8 0 0 1 .112-.353.852.852 0 0 1 .152-.24.98.98 0 0 0 .076-.485 1.178 1.178 0 0 0-.165-.473.525.525 0 0 1-.124-.197c-.02-.08-.006-.157.072-.235.02-.02.04-.038.08 0 .037.04.02.06 0 .078-.047.043-.054.083-.042.124.015.05.056.104.104.16l.005.01c.098.17.163.343.18.523.02.18-.006.364-.087.55 0 .002-.01.014-.01.017a.77.77 0 0 0-.14.215c-.04.094-.076.202-.103.33-.003.006-.003.014-.005.02.26 0 .49-.082.74-.206l.016-.014c.127-.1.262-.256.373-.458.093-.17.17-.377.212-.615.005-.028.01-.053.066-.045.054.01.05.038.047.063a2.158 2.158 0 0 1-.225.65c-.086.16-.188.29-.29.39.406.122.758.003 1.142-.116-.055-.54-.048-.953.01-1.277.064-.352.182-.6.332-.787.017-.023.033-.043.078-.01.043.035.028.055.01.078-.14.175-.25.408-.308.74-.056.308-.066.702-.013 1.223.005 0 .013 0 .02-.004.162.276.248.476.58.26.12-.08.248-.16.35-.267.037-.042.024-.064.054-.097.317-.337.635-.65.952-.93.317-.28.636-.52.955-.715.023-.015.048-.03.076.018.03.048.006.06-.017.076-.314.19-.627.43-.94.703-.272.238-.542.5-.813.784.015.048.023.13.03.257.028.375.096.6.63.395.3-.114.33-.126.605-.29.134-.082.248-.15.326-.168.176-.136.348-.265.522-.382.17-.114.342-.217.51-.308.03-.203.075-.4.14-.59.165-.486.44-.936.787-1.36.002-.004.015-.014.017-.016a2.61 2.61 0 0 0 .71-.552c.19-.21.333-.445.44-.7.01-.026.02-.05.072-.03.05.02.04.047.03.072a2.64 2.64 0 0 1-.456.732c-.195.217-.435.41-.734.57-.336.416-.604.85-.76 1.32-.057.164-.1.33-.125.505.01.003.02.013.03.033.026.05 0 .064-.022.074a.072.072 0 0 0-.023.012c-.033.274-.026.562.025.86.235-.007.473-.14.714-.333.254-.207.515-.493.773-.784.002-.007.002-.012.01-.017.063-.21.144-.39.25-.538a1.02 1.02 0 0 1 .425-.35c.026-.01.05-.022.074.03.02.052-.003.062-.03.075a.92.92 0 0 0-.38.31c-.1.143-.18.32-.24.522-.003.394-.008.79-.01 1.183.012-.01.027-.02.04-.033a3.61 3.61 0 0 1 .987-.523c.036-.016.08.02.072.06-.056.355-.086.706-.028 1.03.056.304.192.587.466.84a2.968 2.968 0 0 1 .498-.658 4.33 4.33 0 0 1 .334-.304c.082-.074.163-.15.24-.226.083-.073.164-.15.245-.225.02-.02.04-.038.08.003.037.04.016.06-.004.078-.08.076-.16.15-.242.225l-.243.227-.002.002a3.322 3.322 0 0 0-.3.267l.014.31c.002.055.002.11.005.166.233.063.372.066.61.06.078.47.12.542.526.552a3.464 3.464 0 0 1 .015-.488 2.1 2.1 0 0 1 .122-.526c.01-.025.02-.05.07-.032.054.02.043.045.033.07-.06.158-.096.324-.116.5a3.31 3.31 0 0 0-.015.477h.033c.162.334.354.5.698.648a1.84 1.84 0 0 0 .212-.455c.05-.17.07-.34.06-.51 0-.027 0-.055.052-.057.055-.002.058.024.06.05a1.51 1.51 0 0 1-.065.548 2.024 2.024 0 0 1-.266.54c-.01.016-.02.032-.037.032.015.194.048.34.116.485.05-.108.103-.217.164-.318a1.83 1.83 0 0 1 .296-.395c.02-.02.038-.038.078 0 .038.038.02.058 0 .078a1.851 1.851 0 0 0-.278.372 4.66 4.66 0 0 0-.195.387c.038.065.086.13.142.207-.648 1.11-1.34 2.65-2.62 3.155-.66.26-.947.597-1.08 1.303a2.27 2.27 0 0 0-.586.655c-.43.144-.814.36-1.28.34 0 .3.1.432.4.434.575-.288.704-.34.755-.3.07.06-.08.472-.557.806-.073.046-.07.074-.028.15.402.63 1.457.404 2.024.255.405-.106 1.136-.587 1.34-.992.077-.187-.1-.427-.277-.625-.81.124-.655-.652.04-.33.236-.07.266-.072.332-.333.62-.24.877-.5 1.018-1.166.625-.674 1.253-1.367 1.703-2.174.125-.152.198-.42.163-.56.11-.13.172-.298.212-.45.04-.162.066-.32.06-.483 0-.028 0-.056.054-.058.055-.003.055.025.057.053a1.88 1.88 0 0 1-.063.514 4.12 4.12 0 0 1-.13.394c.042.102.062.17.15.145.542-.435 1.088-.74 1.673-1.103.04-.247.2-.37.445-.38.1.003.134-.027.17-.118.136-.343-.036-.578-.2-.86-.152-.424.12-.525.39-.727.283-.21.262-.767.273-1.088h.002c-.01-.053-.02-.11-.033-.165a2.8 2.8 0 0 0-.096-.34c-.01-.026-.018-.054.033-.072.054-.018.062.008.072.035.043.124.076.24.1.355l.03.134c.27-.14.553-.3.66-.602.093-.334-.09-.65-.25-.934a10.213 10.213 0 0 1-.635.273c-.027.01-.052.02-.072-.03-.02-.052.005-.064.03-.072a10.91 10.91 0 0 0 .734-.324c.12-.08.244-.167.333-.28.195-.28-.33-.534-.51-.648v-.023c-.262-.24-.522-.483-.786-.724-.02-.018-.04-.04-.002-.08s.058-.022.078-.002l.73.668c.04-.412.045-.807-.084-1.217-.042-.132-.09-.26-.136-.39a1.192 1.192 0 0 1-.51-.425 1.107 1.107 0 0 1-.17-.53c-.003-.027-.003-.055.053-.06.056-.002.056.026.06.053a.976.976 0 0 0 .15.476c.094.144.235.27.44.374.22.114.683.056.95-.073.373-.21-.112-.635-.226-.885-.08-.18-.1-.365-.136-.557.033-.005.066-.013.1-.018a1.066 1.066 0 0 0-.148-.157.643.643 0 0 0-.2-.12c-.025-.01-.053-.02-.033-.072.018-.053.046-.043.07-.033a.76.76 0 0 1 .236.142c.07.06.136.134.2.22a1.64 1.64 0 0 0 .108-.02c.367-.074.57-.28.792-.542a3.84 3.84 0 0 0-.4-.412c-.15-.133-.3-.26-.455-.384-.02-.017-.043-.035-.008-.078.036-.043.056-.025.08-.008.156.127.312.256.46.39.148.137.29.28.42.438.012.015.024.03.014.05.338.03.393-.038.563-.34a1.634 1.634 0 0 0-.202-.436 2.67 2.67 0 0 0-.336-.413c-.02-.02-.038-.04 0-.08.04-.037.06-.017.08 0 .13.137.252.282.348.43.096.148.17.3.215.464.157.002.326.01.46-.07.294-.176.046-.803-.03-1.046.005-.002.007-.005.012-.01a2.948 2.948 0 0 0-.117-.073c-.068-.043-.14-.086-.207-.132-.023-.015-.046-.03-.018-.076.03-.048.053-.033.076-.018l.207.13.153.097.068-.053c.216-.172.292-.4.358-.638.1-.364.122-.202.547-.265.458-.07.705-.12.976-.657.143-.07.216-.132.242-.306.045-.316.02-.478-.342-.506-.506-.04-.815.062-1.156.396.045.068.09.14.136.207.016.023.03.046-.015.078s-.06.01-.076-.014c-.044-.066-.087-.13-.13-.197-.46-.047-.83.027-1.26.19a2.095 2.095 0 0 0-.13-.054c.092.12.163.237.216.35.074.163.112.317.117.464 0 .028.002.056-.053.058-.056.003-.056-.025-.06-.053a1.106 1.106 0 0 0-.105-.422 1.966 1.966 0 0 0-.32-.473v-.003a2.797 2.797 0 0 0-1.026-.187c.055.056.113.11.17.164l.216.213c.02.02.04.038 0 .078-.038.04-.058.02-.078 0a8.744 8.744 0 0 1-.218-.212 14.575 14.575 0 0 1-.237-.236 2.99 2.99 0 0 0-.91.236 3.055 3.055 0 0 1-.62.19c.153.146.282.31.383.498.107.193.188.406.24.64.006.03.013.054-.04.067-.053.012-.06-.015-.066-.04-.05-.226-.13-.43-.23-.613a2.02 2.02 0 0 0-.377-.486c-.015-.012-.028-.028-.023-.048a1.9 1.9 0 0 1-.56.003l.224.372c.013.025.023.05-.025.073-.052.023-.065 0-.075-.025l-.207-.435a1.544 1.544 0 0 1-.506-.2c.053.2.093.415.124.642.04.3.066.623.073.962 0 .028.002.055-.054.055s-.056-.027-.056-.053a8.38 8.38 0 0 0-.07-.948 5.017 5.017 0 0 0-.16-.76 1.774 1.774 0 0 1-.228-.212 2.242 2.242 0 0 0-.607-.473 1.013 1.013 0 0 1-.223.777c-.017.023-.032.044-.078.01-.043-.035-.028-.055-.01-.078a.903.903 0 0 0 .187-.77 3.34 3.34 0 0 0-1.122-.27c.106.14.207.278.3.422.105.167.2.336.287.51a.87.87 0 0 1 .288.456c.046.17.056.352.064.537 0 .028.002.055-.054.058-.055.003-.055-.025-.058-.053a2.227 2.227 0 0 0-.058-.51.763.763 0 0 0-.258-.41.095.095 0 0 1-.016-.016 6.335 6.335 0 0 0-.286-.51 4.922 4.922 0 0 0-.352-.485l-.005-.006a5.335 5.335 0 0 0-.4-.007c.022.03.045.06.065.093.048.08.08.165.09.264.003.027.006.055-.05.06-.055.005-.058-.022-.06-.05a.532.532 0 0 0-.076-.218.72.72 0 0 0-.12-.147c-.28.007-.554.03-.82.052.278.357.5.727.673 1.106.192.423.32.858.395 1.308.005.028.01.056-.046.063-.053.01-.058-.018-.063-.046a5.15 5.15 0 0 0-.388-1.28 5.467 5.467 0 0 0-.706-1.14h-.04a3.67 3.67 0 0 0-.64.125 2.094 2.094 0 0 1 .485.409c.016.022.034.042-.01.077-.042.036-.06.016-.077-.007a1.68 1.68 0 0 0-.223-.223 2.565 2.565 0 0 0-.32-.217 5.1 5.1 0 0 0-.328.118c-.06.023-.12.046-.18.064.188.134.367.28.54.445.207.2.402.425.576.686.016.022.03.045-.015.076-.045.03-.06.006-.078-.017a4.052 4.052 0 0 0-.56-.668 4.983 4.983 0 0 0-.602-.488 2.74 2.74 0 0 1-.688.056c.142.28.266.564.36.85.1.31.172.62.194.936.002.027.004.055-.05.06-.057.005-.06-.023-.062-.05a3.77 3.77 0 0 0-.19-.912c-.1-.3-.232-.597-.382-.89-.14-.01-.28-.028-.422-.046.08.258.152.524.212.795.07.318.13.645.172.976.003.028.005.056-.048.063-.055.008-.058-.02-.063-.048-.04-.328-.1-.652-.17-.966a9.906 9.906 0 0 0-.235-.865c-.4-.433-.842-.855-1.384-1.08a1.82 1.82 0 0 1 .4 1.2c0 .025-.002.053-.055.05-.055 0-.055-.03-.053-.055a1.744 1.744 0 0 0-.13-.713 1.79 1.79 0 0 0-.374-.562 2.085 2.085 0 0 0-.382-.076 16.68 16.68 0 0 0-1.068-.07c.273.247.488.475.468.75-.002.028-.005.056-.06.05-.056-.004-.054-.032-.05-.06.017-.255-.236-.485-.533-.748-.21-.008-.426-.01-.64-.013.118.12.22.24.3.358.11.162.19.324.228.485v.008c.022.252.083.472.194.654.11.18.266.32.48.417.026.014.052.024.03.075-.024.05-.05.04-.074.027a1.168 1.168 0 0 1-.53-.46 1.606 1.606 0 0 1-.21-.693 1.34 1.34 0 0 0-.21-.447c-.095-.14-.22-.28-.366-.422l-.71-.002c.098.28.166.57.214.863.056.36.08.727.09 1.1 0 .027 0 .055-.057.055s-.057-.028-.057-.053a7.625 7.625 0 0 0-.086-1.083 4.91 4.91 0 0 0-.222-.882h-.066a1.07 1.07 0 0 0-.522-.468c-.003.026-.005.05-.013.074a.644.644 0 0 1-.1.227c-.016.024-.034.047-.08.017-.045-.03-.03-.054-.015-.076a.528.528 0 0 0 .096-.288l-.113-.048c-.114-.475-.22-.673-.6-.835-.003.13-.01.268-.035.407-.03.172-.086.346-.19.513-.015.023-.03.048-.076.018-.048-.03-.033-.053-.018-.076a1.3 1.3 0 0 0 .175-.473 2.51 2.51 0 0 0 .032-.434l-.066-.022c-.1-.666-.223-1.038-.913-1.3a1.9 1.9 0 0 1 .005.262c-.008.15-.036.3-.097.458-.01.025-.02.053-.07.033-.05-.02-.04-.045-.032-.07.055-.145.08-.287.088-.426a2.03 2.03 0 0 0-.02-.39c-.147-.168-.357-.327-.536-.504a2.53 2.53 0 0 1-.096.733c-.084.295-.22.594-.413.89-.014.023-.03.048-.075.018-.048-.03-.033-.054-.017-.076a3.27 3.27 0 0 0 .4-.86c.078-.274.106-.55.085-.825a1.11 1.11 0 0 1-.19-.28l-.015.037-.08.182c-.013.025-.023.05-.074.03-.05-.022-.04-.048-.03-.073.028-.06.053-.122.08-.182l.064-.146c-.005-.03-.01-.06-.013-.094-.023-.212-.136-.377-.29-.516l-.003-.002a1.582 1.582 0 0 1-.268.51c-.018.02-.033.04-.08.008-.042-.035-.024-.055-.01-.078.077-.096.135-.192.18-.286.04-.08.066-.162.087-.245-.07-.083-.12-.17-.16-.262a.85.85 0 0 1-.108.182c-.053.07-.12.14-.207.21-.02.017-.043.035-.078-.008-.036-.043-.013-.06.007-.078.08-.064.14-.127.187-.19a.693.693 0 0 0 .105-.187c.036-.1.048-.036.015-.195.06-.314-.058-.5-.225-.762a.076.076 0 0 1 .01-.02.952.952 0 0 0-.336.09c-.15.064-.315.163-.487.282-.023.015-.046.03-.076-.015-.033-.046-.01-.06.015-.076.18-.12.35-.222.504-.29a.96.96 0 0 1 .425-.1.394.394 0 0 0 .013-.242c-.506.188-.905.276-1.227.296a1.75 1.75 0 0 1-.81-.123c-.024-.012-.05-.022-.027-.073.02-.05.047-.04.072-.03.2.086.44.136.76.116.316-.02.705-.106 1.206-.293-.002-.005-.002-.01-.005-.015.09-.203.165-.4.215-.598a1.82 1.82 0 0 1-.534.04h-.035c-.03 0-.057-.002-.057-.055 0-.055.03-.055.056-.055h.034c.188.002.375.007.56-.054.012-.065.022-.13.032-.197.028-.22.286-.273.468-.076.152.162.29.334.44.405.304.144.646.015.89-.182l-.224-.074c-.028-.008-.053-.018-.035-.07.017-.052.043-.044.068-.034.096.03.192.06.288.093a.874.874 0 0 0 .067-.07c.628.054 1.035-.077 1.437-.482a7.394 7.394 0 0 1-.95-.033c-.305-.035-.555-.096-.74-.187-.025-.013-.05-.026-.025-.074.024-.05.05-.038.072-.025.172.085.413.143.704.176a7.45 7.45 0 0 0 1.042.03h.005l.11-.13c.17-.07.343-.148.47-.29-.732-.078-1.428-.222-2.083-.564-.17-.19-.438-.296-.723-.37-.532-.065-1.002.067-1.435.292-.114-.106-.202-.202-.314-.306-.167-.02-.324-.11-.49-.13-.223-.025-.456.018-.68-.007-.026 0-.054-.004-.047-.06.006-.055.034-.053.062-.048.223.026.455-.017.678.008.215.025.42.12.635.144.72-.27 1.313-.42 1.827-.397a6.064 6.064 0 0 1 1.844-.233l-.023-.02c-.073-.073-.038-.11 0-.147.337-.34.415-.655.307-.938-.112-.295-.415-.57-.838-.824-.45.05-.883-.07-1.36-.017-.3.032-.593.097-.88.193.24.086.45.228.62.43.213.25.365.593.446 1.023.01.05.018.103-.083.12-.1.02-.112-.032-.122-.082-.073-.393-.21-.7-.4-.926-.2-.286-.657-.398-.8-.456-.48.048-.95.1-1.36.208-.31.078-.58.187-.787.35.31-.067.63-.054.908.085.266.13.49.38.633.782.018.048.033.098-.066.13-.098.034-.115-.014-.13-.065-.12-.346-.307-.554-.527-.662-.437-.218-1.34-.028-1.723.255a4.515 4.515 0 0 0-.665.633c-.04.048-.084.093-.177.012-.094-.083-.053-.13-.01-.174.23-.26.463-.49.703-.668.234-.172.474-.296.722-.354.253-.28.628-.45 1.06-.562.423-.11.906-.165 1.397-.213-.145-.292-.33-.466-.543-.56-.227-.1-.488-.116-.77-.088-.59.202-1.115.518-1.618.875.045 0 .09 0 .133.003.15.01.283-.013.407.035.048.018.1.035.064.134-.043.118-.37.045-.484.037-.13-.008-.27.003-.427.04-.023.006-.048.013-.07.006-.616.38-1.056.764-1.567 1.196l-.086.03c-.455-.018-.77.045-.956.187-.17.13-.183.33-.15.605-.078.255-.177.536-.202.834-.534.458-1.128.916-1.404 1.584-.06.195-.165.367-.294.52.11.02.198.052.266.105a.42.42 0 0 1 .068.066 2.46 2.46 0 0 1 .058-.336c.038-.156.094-.3.167-.417.016-.023.03-.046.076-.015.047.03.032.053.017.076-.068.103-.12.238-.154.384a2.65 2.65 0 0 0-.07.544c-.004.056-.105.06-.112.005a.306.306 0 0 0-.118-.214.556.556 0 0 0-.29-.09 3.357 3.357 0 0 1-.37.338c-.107.086-.208.18-.23.32-.016.242.282.285.566.303.645.037.13.404.486.726.172.12.33.258.452.427.246.09.398.07.565-.007.034-.438-.004-.66.188-.66h.02a.82.82 0 0 1 .192-.413c.018-.02.036-.043.08-.008.042.036.024.056.006.08a.862.862 0 0 0-.13.216.8.8 0 0 0-.044.182c.033.066.025.195.023.426.366-.18.7-.226 1.075-.243.7-.82 1-.613.384-.016-.035.07-.068.13-.098.188a1.502 1.502 0 0 0-.198.642c-.18.157-1.06.88-.73 1.15.23-.034.374-.024.285.148-.11.23-.438.71-.33.972.042.096.183.086.323.053l.03-.028a6.37 6.37 0 0 0 .7-.653c.226-.246.436-.527.605-.848.024-.046.047-.09.113-.074a9.68 9.68 0 0 1 .24-.756c.094-.26.2-.524.314-.787a.056.056 0 0 1 .096-.01c.096.14.19.24.283.306a.42.42 0 0 0 .248.09c.08 0 .165-.028.248-.084.09-.063.182-.16.276-.29.015-.024.033-.046.078-.013.046.032.03.053.013.078a1.24 1.24 0 0 1-.305.317.522.522 0 0 1-.31.104.538.538 0 0 1-.312-.11 1.21 1.21 0 0 1-.253-.256c-.1.23-.19.46-.273.69a10.02 10.02 0 0 0-.246.77c.06.048.034.093.01.14a4.416 4.416 0 0 1-.64.897c-.193.214-.398.4-.598.57.028.188.076.365.162.547.382-.33.738-.663 1.052-1.007a6.38 6.38 0 0 0 .802-1.075c.015-.023.028-.048.076-.02.048.027.033.053.02.075a6.05 6.05 0 0 1-.374.565c.025.038.005.053-.015.07-.04.033-.064.165-.074.334-.014.23 0 .515.027.72.002.028.007.056-.048.064-.057.007-.06-.02-.065-.048a4.468 4.468 0 0 1-.028-.742c.003-.06.01-.116.018-.167-.083.1-.17.198-.258.296-.32.352-.683.69-1.073 1.025-.002.003-.007.005-.01.008.01.02.023.04.036.06-.34.246-.615.332-.236.66.127-.09.253-.182.38-.273l.405-.29c.02-.016.044-.033.077.012.033.046.01.06-.013.08l-.407.29c-.13.093-.26.187-.392.28a.665.665 0 0 0 .096.387.564.564 0 0 1 .085-.007c.283-.205.566-.413.85-.618.022-.017.045-.032.078.013.033.046.01.06-.012.08l-.824.598a.762.762 0 0 1-.1.127c-.277.2-1.25.8-1.145 1.214v.002c.234-.066.466-.147.69-.26.23-.12.455-.28.667-.497.02-.02.038-.038.078 0 .038.038.02.058 0 .08a2.73 2.73 0 0 1-.693.512v.01c-.002.038-.002.076-.005.114-.002.04-.002.077-.005.115-.002.028-.002.056-.058.053-.056-.002-.053-.03-.053-.058l.006-.114c.002-.02.002-.043.002-.063-.197.09-.397.16-.6.215.084.392-.12.728-.33 1.065-.12.096-1.09.883-.686 1.118.11.054.23.08.35.092z\"></path><path d=\"M287.85 106.887c-.204-.12-.464-.27-.717-.32a1.54 1.54 0 0 0-.54-.6c-.186-.122-.186-.112-.115-.246.212-.022.3-.08.303-.138.112.002.21.018.29.046.093.032.164.08.215.15.017.022.033.044.078.01.046-.034.028-.057.01-.08a.58.58 0 0 0-.268-.187 1.092 1.092 0 0 0-.395-.05c-.012 0-.022 0-.033.006a.793.793 0 0 0-.354-.058c-.144-.137-.265-.296-.207-.494.007.008.02.01.033.013.112.033.22.066.31.11a.603.603 0 0 1 .212.14c.018.02.038.04.08.003.04-.038.022-.058.004-.08a.794.794 0 0 0-.248-.168 1.903 1.903 0 0 0-.24-.09c.834-.168 1.58-.156 2.327.287.392.16.577.348.79.637l-.213.18c-.488-.013-.848.055-1.073.227-.203.152-.244.425-.25.698z\"></path></g><path d=\"M304.446 129.99c-.165.103-.3.173-.468.2a.077.077 0 0 0 .02-.02c.11-.204.235-.384.377-.545l.055-.064.008.204.008.23zm2.092 4.48c-.11.166-.248.318-.402.457a4.26 4.26 0 0 1-.51.388c-.022.015-.047.03-.077-.016-.032-.046-.01-.06.014-.077.177-.116.344-.242.496-.377.15-.134.28-.278.384-.437.015-.024.03-.047.08-.016.044.03.03.053.014.076zm1.384-1.65l-.21.32c-.015.024-.03.047-.08.016-.044-.03-.03-.053-.014-.075l.21-.32c.015-.024.03-.046.08-.016.044.03.03.053.014.078zm-.754-.106c-.036.16-.094.31-.195.45-.1.14-.25.263-.465.362-.026.012-.05.023-.074-.028-.023-.05.003-.063.028-.073.197-.09.33-.203.423-.327.093-.124.144-.263.177-.41.005-.027.012-.053.065-.04.054.013.048.038.04.066zm1.356-1.654a.998.998 0 0 0-.147.19c-.04.07-.078.146-.106.232-.01.025-.017.053-.07.035-.053-.018-.045-.046-.035-.07a1.213 1.213 0 0 1 .278-.464c.02-.02.038-.038.078 0s.022.058 0 .08zm1.108.108c-.048.157-.094.316-.152.473-.058.163-.13.322-.22.482-.015.022-.028.048-.076.02s-.035-.053-.02-.076c.09-.154.154-.31.213-.46.055-.155.1-.312.15-.47.006-.026.014-.052.067-.036.053.015.046.04.038.068zm-.502-6.485c.343.506.42 1.028.43 1.55.04-.188.082-.38.135-.57 0-.003.008-.018.008-.018.144-.203.235-.405.28-.605.046-.2.046-.402.01-.602-.004-.028-.01-.053.046-.063.053-.01.06.018.065.045.038.215.038.433-.01.648a1.792 1.792 0 0 1-.29.638 14.13 14.13 0 0 0-.23 1.06l-.01.065c-.01.055-.113.047-.113-.01 0-.04 0-.077.003-.118.008-.66.015-1.323-.412-1.95-.016-.023-.033-.046.015-.08.045-.03.063-.006.078.017zm-.844 1.087c-.005.042-.007.085-.013.125-.002.043-.007.086-.01.13-.002.027-.005.055-.06.05-.056-.005-.053-.033-.05-.06.002-.044.007-.087.01-.127.002-.043.007-.086.012-.13.002-.027.005-.055.06-.05.056.005.054.033.05.06zm-.236 1.47c.087.282.153.568.2.86.034.2.054.404.064.61a1.05 1.05 0 0 1 .076-.108 1.26 1.26 0 0 1 .357-.296c.022-.015.048-.027.076.02.027.05.005.064-.02.077a1.118 1.118 0 0 0-.325.27.75.75 0 0 0-.156.344c-.01.056-.112.046-.112-.01.003-.303-.023-.6-.068-.888a6.302 6.302 0 0 0-.195-.846c-.007-.028-.018-.053.036-.068.053-.015.06.01.068.035zm1.175.528a3.804 3.804 0 0 1 .068 1.27c-.002.027-.008.055-.063.048-.056-.008-.05-.036-.048-.064.023-.19.03-.387.02-.594a3.846 3.846 0 0 0-.086-.638c-.005-.028-.013-.053.043-.065.052-.013.06.015.065.043zm1.007-.188c.038.208.058.41.048.605-.01.197-.048.385-.13.567a1.27 1.27 0 0 0-.037.622c.035.213.116.425.212.64.013.025.023.05-.028.074-.05.022-.063-.003-.073-.028a2.71 2.71 0 0 1-.223-.666 1.385 1.385 0 0 1 .044-.68l.003-.005a1.45 1.45 0 0 0 .12-.53 2.32 2.32 0 0 0-.05-.58c-.004-.027-.01-.053.046-.063.056-.01.06.018.066.046zm.485-1.67c-.025.104-.05.21-.078.317-.026.103-.052.21-.08.316-.004.028-.012.053-.065.04-.053-.012-.048-.04-.04-.068.025-.104.05-.21.078-.316.025-.105.05-.21.078-.317.01-.028.014-.053.07-.04.053.012.048.04.04.068zm-.497-2.772c.03.096.057.192.088.288.007.028.015.053-.038.068-.053.018-.06-.01-.07-.035l-.087-.29c-.01-.027-.018-.053.035-.068.053-.015.06.01.07.036zm.255-2.108c.002.132.002.263-.008.827a.826.826 0 0 0-.25.408 1.46 1.46 0 0 0-.008.625c.004.028.01.055-.047.065-.055.01-.06-.017-.065-.045a1.52 1.52 0 0 1 .01-.673.92.92 0 0 1 .283-.46l-.022-.352c-.002-.132-.002-.263-.005-.392 0-.028 0-.056.056-.056.055 0 .055.028.055.056zm-2.093-.734c.324.213.602.448.795.727.195.28.306.602.293.98a.057.057 0 0 1-.078.05c-.182-.08-.367-.158-.55-.236.122.787.092 1.414-.08 1.895a1.71 1.71 0 0 1-1 1.052.055.055 0 0 1-.073-.068c.093-.298.148-.597.17-.896.024-.298.01-.597-.04-.893-.004-.027-.01-.055.046-.063.056-.01.06.018.063.046.05.306.065.614.04.92a4.1 4.1 0 0 1-.142.805c.392-.192.67-.5.828-.938.172-.484.197-1.126.06-1.94-.007-.044.038-.08.076-.062l.564.243a1.468 1.468 0 0 0-.273-.832c-.185-.266-.45-.49-.764-.696-.024-.015-.047-.03-.016-.078.03-.046.053-.03.076-.016zm5.478-1.076l-.046.107-.043.11c-.01.025-.02.05-.07.03-.05-.02-.04-.046-.03-.07.015-.037.03-.075.046-.11.015-.035.027-.073.043-.11.01-.024.02-.05.07-.03.05.02.04.046.03.072zm-1.288-.03a.78.78 0 0 1 .263.173c.07.068.124.15.17.238.012.026.025.05-.023.074-.05.025-.063 0-.074-.023a.832.832 0 0 0-.15-.21.632.632 0 0 0-.227-.145c-.024-.01-.05-.02-.03-.07.02-.052.047-.042.072-.032zm-1.912.55c.138.154.23.334.278.54.048.2.055.42.03.66-.003.027-.005.055-.06.05-.056-.005-.054-.033-.05-.06a1.872 1.872 0 0 0-.027-.626 1.103 1.103 0 0 0-.252-.488c-.017-.02-.038-.04.005-.08.04-.037.06-.014.08.006zm-6.465.622l-.023.218a6.966 6.966 0 0 0-.02.217c-.002.028-.005.056-.06.05-.056-.004-.054-.032-.05-.06.01-.073.017-.146.022-.217l.022-.218c.003-.028.005-.056.06-.05.057.005.054.032.052.06zm1.199-.632c.03.103.06.207.094.31l.028.095c.007.027.015.053-.038.068-.053.015-.06-.01-.068-.038l-.028-.094a14.53 14.53 0 0 0-.094-.31c-.007-.025-.015-.053.038-.068.053-.015.06.01.068.038zm2.46 1.652c.012.045.02.09.022.134a.999.999 0 0 1 0 .134c-.002.028-.005.056-.06.05-.056-.004-.054-.032-.05-.06a.893.893 0 0 0 0-.117.59.59 0 0 0-.02-.116c-.01-.028-.016-.053.037-.068.053-.016.06.01.068.04zm.846-1.872a.36.36 0 0 1 .102.167.25.25 0 0 1-.025.18c-.013.025-.028.05-.076.022-.047-.026-.034-.052-.022-.077a.15.15 0 0 0 .015-.104.267.267 0 0 0-.07-.117c-.02-.02-.038-.038 0-.078.038-.038.058-.02.078 0zm-5.87.296c0 .13.022.258.065.374.043.12.11.23.207.334.13.147.195.29.23.438.036.144.038.286.046.425 0 .028.002.055-.053.058-.056.002-.056-.025-.058-.053a2.18 2.18 0 0 0-.04-.405.92.92 0 0 0-.206-.392 1.126 1.126 0 0 1-.23-.37 1.202 1.202 0 0 1-.07-.414c0-.027 0-.055.056-.055.055 0 .055.028.055.056zm2.377 1.599c.132.245.205.485.233.728.03.24.015.486-.028.742-.048.296.015.584.177.855.148.253.384.493.687.716a3.052 3.052 0 0 1-.136-.96 1.79 1.79 0 0 1 .383-1.047 1.5 1.5 0 0 0 .232-.438c.054-.15.08-.3.102-.448.002-.028.007-.056.06-.048.056.005.05.033.048.06-.02.157-.05.314-.103.47a1.624 1.624 0 0 1-.25.47c-.24.313-.345.642-.36.983-.015.346.06.705.177 1.075.014.048-.044.088-.084.063-.382-.258-.673-.542-.853-.843a1.34 1.34 0 0 1-.19-.928c.04-.246.053-.48.026-.71a1.93 1.93 0 0 0-.222-.69c-.012-.022-.027-.047.023-.073.05-.027.064-.002.077.023zm-.954 1.459c0 .264-.073.527-.205.79-.103.207-.24.412-.402.617a3.22 3.22 0 0 0 .253-.105 2.36 2.36 0 0 0 .745-.53c.104-.108.208-.232.314-.378.014-.023.032-.046.078-.013.045.033.027.056.012.078a3.83 3.83 0 0 1-.324.39 2.65 2.65 0 0 1-.288.258 26.134 26.134 0 0 1 .073.364c.005.028.013.053-.043.066-.053.013-.06-.015-.065-.043-.018-.078-.028-.137-.04-.195-.008-.04-.016-.08-.026-.12a2.523 2.523 0 0 1-.395.224c-.152.07-.3.124-.45.18-.048.017-.094-.048-.06-.09a3.89 3.89 0 0 0 .515-.753c.124-.248.195-.493.195-.74 0-.026 0-.054.056-.054.055 0 .055.027.055.054zm-1.161-.094v.25c0 .03 0 .057-.056.057-.055 0-.055-.028-.055-.056v-.25c0-.027 0-.055.056-.055s.056.028.056.056z\"></path><path d=\"M302.363 121.35c.152.37.193.717.135 1.04-.056.325-.21.626-.44.91l-.008.007c-.22.19-.385.418-.506.673a2.79 2.79 0 0 0-.195.552c.06-.084.12-.162.194-.236.144-.146.316-.26.544-.323.232-.13.453-.27.657-.43.208-.162.4-.34.577-.54.018-.02.038-.04.08-.005.04.036.02.056.004.08-.182.204-.38.386-.592.55a5.12 5.12 0 0 1-.678.443l-.013.006a1.095 1.095 0 0 0-.5.296c-.135.134-.24.3-.345.473-.028.046-.11.016-.1-.038.055-.313.138-.61.264-.877.127-.27.3-.506.532-.706.217-.27.362-.552.415-.855.052-.305.014-.63-.13-.983-.01-.025-.02-.05.03-.073.05-.02.063.005.073.03zm2.361 3.784c-.036.1.038.195.187.387l.102.132c.2.266.274.567.28.883.004.31-.055.63-.115.942-.01.053-.1.05-.11-.003a1.91 1.91 0 0 0-.41-.918 3.663 3.663 0 0 0-.844-.74c-.023-.014-.045-.03-.015-.078.03-.045.053-.03.076-.015.344.23.642.48.868.764.172.215.3.448.377.704.037-.22.064-.44.062-.652a1.367 1.367 0 0 0-.256-.817 3.588 3.588 0 0 0-.098-.128c-.175-.225-.258-.334-.205-.49.01-.026.017-.054.07-.037.054.018.044.046.036.07zm1.006-.066c.04.043.084.086.125.132l.124.13c.02.02.037.042-.004.08-.04.038-.06.017-.078-.003-.04-.043-.084-.086-.124-.132-.04-.043-.084-.086-.124-.13-.018-.02-.038-.042.002-.08.04-.037.06-.017.08.003zm1.235.397c-.078.248-.154.494-.23.742-.078.247-.154.493-.233.74-.007.03-.015.054-.068.036-.053-.015-.045-.043-.035-.068l.23-.74c.077-.25.153-.495.232-.743.007-.027.015-.053.068-.038.053.018.046.043.035.07zm.699 4.142a.258.258 0 0 0 0 .185c.01.025.02.053-.033.07-.05.02-.06-.005-.07-.033a.37.37 0 0 1 0-.266c.01-.028.02-.053.07-.033.054.02.044.046.034.072zm-.734-1.217c-.033.13-.068.26-.1.39l-.102.392c-.008.028-.016.053-.07.04-.052-.015-.047-.04-.04-.068.034-.132.07-.26.102-.392.033-.13.068-.26.1-.39.01-.028.014-.053.07-.04.053.012.048.04.04.068zm-1.057-.005l.096.096c.02.02.037.04 0 .08-.042.037-.062.02-.08 0l-.096-.097c-.02-.02-.038-.038 0-.078.04-.038.06-.02.08 0zm-1.243-.595c-.025.074-.05.147-.078.22-.025.074-.05.147-.08.22-.01.026-.016.054-.07.033-.05-.017-.042-.045-.032-.07.025-.074.05-.147.078-.22.025-.074.05-.147.08-.22.01-.028.016-.054.07-.036.053.018.042.045.035.07zm-1.778 1.88a.74.74 0 0 0-.147.238 1.34 1.34 0 0 0-.066.268c-.006.028-.01.056-.064.046-.056-.01-.05-.036-.046-.064.018-.098.038-.194.074-.288a.82.82 0 0 1 .167-.273c.018-.02.04-.04.08-.003.04.038.022.058.002.08zm-5.092 4.987a.708.708 0 0 1-.107.17 1.277 1.277 0 0 1-.17.164c-.02.018-.043.036-.078-.01-.036-.042-.013-.06.007-.078a.872.872 0 0 0 .246-.29c.012-.026.022-.05.073-.03.052.022.04.047.03.072zm.798-.423a.376.376 0 0 1-.108.144.654.654 0 0 1-.173.1c-.027.01-.053.02-.07-.034-.02-.053.007-.063.033-.07a.455.455 0 0 0 .14-.08.305.305 0 0 0 .077-.103c.01-.024.023-.05.073-.027.05.023.038.048.028.074zm1.058-.644a.514.514 0 0 1-.066.09.56.56 0 0 1-.114.09c-.023.016-.048.032-.076-.016-.028-.05-.005-.064.02-.076a.407.407 0 0 0 .145-.142c.015-.023.028-.048.076-.018.05.028.034.05.02.076zm1.591-4.14c-.05.15-.086.296-.098.443-.014.146-.007.293.024.437.005.028.012.054-.04.066-.054.013-.06-.015-.066-.043a1.492 1.492 0 0 1-.028-.473c.015-.157.05-.314.103-.468.01-.028.018-.053.07-.035.054.017.044.045.037.07zm1.083-11.013a.93.93 0 0 1-.096.367c-.058.12-.142.24-.25.36-.018.02-.04.04-.08.002s-.022-.06-.002-.08c.102-.11.18-.222.233-.33a.82.82 0 0 0 .084-.324c0-.028 0-.056.057-.053.056 0 .053.03.053.057zm-1.106-.977c.097.167.155.337.188.506.033.167.04.337.03.504 0 .028-.003.055-.058.053-.056-.003-.053-.03-.053-.058a1.88 1.88 0 0 0-.027-.476 1.562 1.562 0 0 0-.175-.474c-.012-.023-.028-.048.02-.076.05-.028.064-.002.076.02zm-1.464 1.817a1.613 1.613 0 0 1-.433-.445.697.697 0 0 1-.1-.466c.004-.028.01-.053.062-.045.055.01.05.036.045.064a.59.59 0 0 0 .086.392c.082.137.216.273.403.412.023.015.045.033.012.08-.032.044-.055.027-.078.01zm1.62 2.755v.24c0 .028 0 .056-.054.056-.056 0-.056-.028-.056-.056v-.24c0-.028 0-.056.056-.056.055 0 .055.028.055.056zm-2.07-2.087c.326.308.52.68.624 1.093.066.255.094.526.1.81 0 0 .006-.003.01-.003.148-.05.262-.182.34-.392.084-.223.127-.532.135-.924 0-.003.004-.026.006-.03.117-.188.187-.38.235-.57.05-.19.072-.385.09-.58.005-.048.07-.068.1-.028.19.27.358.547.487.845.13.3.215.615.248.96.002.027.005.055-.05.06-.056.005-.06-.023-.06-.05a3.1 3.1 0 0 0-.24-.924 4.13 4.13 0 0 0-.386-.7 3.092 3.092 0 0 1-.077.444 2.07 2.07 0 0 1-.24.59c-.008.4-.054.716-.14.946-.09.246-.227.397-.407.458-.018.006-.033.01-.048.004-.003.136-.01.275-.02.417-.003.03-.005.057-.06.052-.057-.005-.054-.033-.052-.06.038-.462.028-.9-.073-1.294a2.11 2.11 0 0 0-.595-1.04c-.02-.017-.04-.038-.002-.078s.058-.02.078-.003zm1.214 5.195l-.07.437c-.02.144-.044.29-.067.435-.003.028-.008.055-.063.045-.053-.007-.05-.035-.046-.063l.07-.435c.02-.148.044-.292.067-.44.005-.027.007-.052.063-.044.053.01.05.035.046.063zm-2.334.988c.02.11.04.22.062.332.005.027.01.053-.046.063-.053.01-.06-.018-.066-.046l-.06-.33c-.005-.03-.01-.054.045-.064.053-.01.06.017.063.045zm2.017-2.678c-.027.22-.083.434-.17.64a2.37 2.37 0 0 1-.37.593v.003c-.2.218-.297.443-.327.678-.03.235.002.48.068.73.007.03.013.054-.04.07-.054.012-.06-.013-.07-.04a2.018 2.018 0 0 1-.07-.773c.033-.254.14-.502.354-.737a2.204 2.204 0 0 0 .514-1.175c.003-.027.008-.055.06-.047.056.008.05.036.05.064zm-.527-.783c.04.213.006.423-.082.635-.09.205-.23.412-.413.617l-.005.004c-.19.16-.324.334-.43.514a4.385 4.385 0 0 0-.263.564c-.01.026-.02.05-.073.03-.05-.02-.04-.045-.03-.07.078-.195.16-.39.27-.58.11-.19.253-.372.45-.54a2.24 2.24 0 0 0 .39-.583 1 1 0 0 0 .076-.57c-.005-.028-.01-.053.045-.066.053-.01.06.018.066.046zm-2.572 1.223c.06.424-.005.788-.164 1.107-.157.32-.408.592-.714.838-.02.017-.043.035-.078-.01-.036-.044-.013-.06.01-.08.293-.234.534-.497.683-.798.15-.3.213-.643.154-1.045-.003-.028-.008-.056.047-.064.056-.007.06.02.064.05zm-3.286 1.818c.033.066.063.132.093.197.036.07.07.14.1.21.014.026.024.05-.024.074-.05.022-.062 0-.072-.026-.033-.07-.07-.14-.1-.21l-.095-.195c-.013-.027-.023-.052.025-.075.05-.022.064 0 .074.026zm-1.302.025c-.004.25.016.5.077.737.063.237.165.468.332.688l.004.01c.083.17.13.34.164.51.023.127.038.254.046.38.16-.17.28-.34.37-.52.1-.208.153-.423.158-.646 0-.028 0-.056.056-.053.056 0 .056.027.053.055a1.673 1.673 0 0 1-.168.69c-.11.223-.27.436-.48.64-.03.033-.09.01-.092-.037a3.47 3.47 0 0 0-.05-.49 1.94 1.94 0 0 0-.153-.477 2.07 2.07 0 0 1-.346-.723 2.885 2.885 0 0 1-.083-.766c0-.027 0-.055.056-.055s.056.028.056.056zm.176 4.451a2.807 2.807 0 0 1 .192-.817c.01-.026.02-.05.07-.03.052.02.04.045.032.07a2.695 2.695 0 0 0-.185.782c-.002.027-.002.054-.06.05-.056-.003-.054-.03-.05-.06zm-.152 1.239l.068-.493c.003-.028.008-.056.064-.048.055.008.05.035.048.063l-.07.494c0 .026-.006.054-.062.047-.056-.008-.05-.036-.048-.064zm-.854 2.077c.082-.08.16-.177.234-.283a4.64 4.64 0 0 0 .218-.352c.012-.025.028-.048.076-.022.048.028.035.05.02.076a4.1 4.1 0 0 1-.223.36 2.1 2.1 0 0 1-.248.3c-.02.02-.04.037-.078 0-.04-.04-.02-.06 0-.08zm-1.23-6.97v.205c0 .028 0 .056-.056.056s-.056-.027-.056-.055v-.205c0-.027 0-.055.056-.055.055 0 .055.028.055.055zm-2.085 4.802c-.003-.05-.005-.1-.01-.15l-.01-.156c0-.028-.003-.055.052-.058.056-.003.06.023.06.053l.01.153c0 .05.004.1.01.152 0 .028 0 .055-.054.058-.056.002-.058-.023-.058-.053zm5.235-8.542c-.107.368-.19.75-.183 1.076.005.317.094.58.32.726.267.172.383.43.495.68l.02.046c.033-.123.06-.255.073-.387a1.72 1.72 0 0 0-.005-.46c-.005-.027-.01-.055.046-.065.053-.01.06.018.063.046.024.153.024.322.007.492-.02.19-.064.382-.12.55-.015.044-.08.05-.1.006a6.347 6.347 0 0 1-.084-.182c-.104-.235-.213-.478-.453-.633-.263-.17-.367-.465-.374-.817-.005-.34.078-.73.187-1.108.007-.028.015-.053.068-.038.054.015.047.04.04.068zm-.368-1.398c.036.286.026.55-.022.815a4.277 4.277 0 0 1-.248.812 2.573 2.573 0 0 0-.178 1.066c.018.362.112.72.28 1.063.01.024.024.05-.027.072-.05.026-.063 0-.073-.025a2.708 2.708 0 0 1-.106-2.22c.11-.276.195-.534.24-.79.048-.253.058-.506.023-.78-.002-.027-.007-.055.05-.062.052-.008.057.02.062.048zm-2.432 3.461a.845.845 0 0 0-.062.5c.03.17.103.342.207.515.015.022.028.048-.018.075-.048.028-.063.005-.075-.02a1.605 1.605 0 0 1-.22-.55.935.935 0 0 1 .07-.566c.013-.025.023-.05.074-.027.05.022.038.048.027.073zm-1.06-.38c.02.1.024.216.014.332-.01.1-.036.2-.076.288v.003a.424.424 0 0 0-.04.28c.02.1.07.198.138.3.015.022.03.045-.015.078-.044.033-.06.01-.077-.016a.91.91 0 0 1-.157-.34.517.517 0 0 1 .05-.353.812.812 0 0 0 .066-.25 1.18 1.18 0 0 0-.01-.3c-.005-.03-.01-.057.046-.065.055-.01.06.018.063.046zm6.2-9.181a2.474 2.474 0 0 0 .333 1.566c.016.023.028.048-.02.076-.048.028-.06.003-.076-.02-.14-.243-.245-.5-.306-.772a2.487 2.487 0 0 1-.04-.86c.003-.028.006-.056.06-.048.057.005.054.033.05.06zm-.777.752c.144.255.268.53.36.832.095.3.158.632.18 1 .004.027.004.055-.052.057-.055.003-.055-.025-.057-.053a4.024 4.024 0 0 0-.526-1.78c-.013-.026-.028-.05.02-.077.048-.028.063-.002.076.02zm-3.851.118c-.372.53-.534.96-.564 1.33-.03.37.068.68.215.965l.002.008c.102.293.147.584.14.878-.006.29-.066.584-.17.875-.01.028-.018.053-.07.033-.054-.017-.044-.045-.034-.07.103-.28.158-.56.166-.84a2.4 2.4 0 0 0-.132-.835c-.154-.3-.258-.63-.225-1.02.032-.39.2-.84.583-1.386.016-.024.033-.046.08-.016.044.033.03.056.012.078zm3.59-1.522a.784.784 0 0 1-.056.488c-.065.15-.18.29-.35.425a.865.865 0 0 0-.317.518c-.05.216-.04.467.014.748.005.028.01.055-.046.065-.053.01-.06-.017-.066-.045-.053-.296-.063-.56-.012-.79a.974.974 0 0 1 .36-.58c.153-.123.254-.252.315-.383a.677.677 0 0 0 .048-.42c-.005-.028-.012-.053.043-.066.053-.01.06.017.066.042zm-3.802.326c.073.235.075.465.007.695a1.673 1.673 0 0 1-.41.674l-.005.006c-.2.167-.32.38-.397.614a3.08 3.08 0 0 0-.12.787c-.004.03-.004.057-.06.054-.055-.002-.053-.03-.053-.058.015-.286.046-.562.127-.815a1.4 1.4 0 0 1 .426-.66c.195-.21.322-.42.385-.63a1.08 1.08 0 0 0-.007-.63c-.007-.03-.017-.055.036-.07.052-.015.06.01.067.038zm2.175.114a.814.814 0 0 0 0 .248.552.552 0 0 0 .094.227c.014.023.03.046-.016.08-.046.03-.06.01-.08-.017a.67.67 0 0 1-.11-.27.872.872 0 0 1 0-.28c.003-.03.008-.057.063-.05.056.008.05.036.048.064zm-.103-.572a.91.91 0 0 0-.46.427c-.107.2-.17.458-.19.775.012.015.02.027.02.038.106.144.18.316.225.508.05.21.068.448.06.706 0 .028-.002.056-.058.053-.056-.003-.054-.03-.054-.056a2.59 2.59 0 0 0-.058-.68 1.305 1.305 0 0 0-.192-.446c-.413.384-.615.81-.628 1.272-.015.483.175 1.01.54 1.57.014.024.03.05-.016.08s-.06.005-.076-.018c-.377-.582-.572-1.128-.557-1.634.015-.5.232-.954.68-1.364v-.003c.018-.346.086-.63.205-.852.12-.225.29-.385.516-.478.026-.01.052-.02.074.03.02.05-.005.063-.03.073zm-.618-.8c-.005.046-.01.08-.012.12-.028.262-.056.558-.256.738a.887.887 0 0 0-.233.34c-.05.128-.076.267-.093.414-.003.028-.005.056-.06.048-.057-.005-.052-.033-.05-.063a1.82 1.82 0 0 1 .102-.443.983.983 0 0 1 .26-.382c.168-.15.198-.425.22-.665.006-.046.01-.09.013-.122.003-.028.008-.056.064-.048.054.008.05.035.047.063zm6.044 6.449c.066.137.12.28.155.423.035.144.053.293.045.448 0 .027-.002.055-.058.053-.056-.002-.053-.03-.053-.057a1.53 1.53 0 0 0-.04-.418 2.075 2.075 0 0 0-.15-.4c-.012-.025-.023-.05.028-.073.05-.023.06 0 .073.025zm.018 1.983c.048.23.05.46.01.694a2.43 2.43 0 0 1-.253.71l-.255.6c-.013.026-.023.05-.074.03-.05-.02-.04-.047-.03-.072.086-.2.17-.403.256-.603l.002-.006c.124-.23.205-.455.245-.678a1.7 1.7 0 0 0-.01-.652c-.005-.028-.01-.056.043-.066.053-.013.06.015.066.043zm-1.26-1.846c.362.402.597.827.71 1.275.112.447.1.917-.037 1.408-.008.028-.016.053-.07.038-.052-.015-.045-.04-.037-.068.13-.473.144-.924.035-1.354-.108-.43-.336-.84-.685-1.23-.018-.02-.036-.04.005-.078.04-.038.06-.015.078.005zm-.111 2.226a5.687 5.687 0 0 1-.926 1.412 2.69 2.69 0 0 0-.574 1.002c-.016.05-.112.033-.107-.02a1.54 1.54 0 0 0-.055-.5 1.992 1.992 0 0 0-.223-.505v.002c-.202-.3-.288-.6-.273-.898.017-.3.136-.595.35-.89a2.77 2.77 0 0 0 .267-.626c.06-.207.09-.417.1-.627 0-.027 0-.055.057-.052.057.002.054.03.054.058a2.785 2.785 0 0 1-.384 1.305l-.003.006c-.2.28-.314.56-.33.835-.014.28.07.555.257.834l.002.002c.106.177.185.354.235.534.024.083.042.167.052.25a2.83 2.83 0 0 1 .5-.777 5.41 5.41 0 0 0 .908-1.385c.014-.025.024-.05.075-.028.05.022.038.048.027.073zm-3.302-1.062a3.08 3.08 0 0 0 .074.776c.055.24.146.466.273.673.015.023.028.048-.018.076-.048.03-.06.005-.076-.017a2.406 2.406 0 0 1-.286-.704 3.196 3.196 0 0 1-.076-.804c0-.028.003-.056.056-.053.056.002.056.03.053.055zm-1.88 1.007v.322c0 .03 0 .057-.055.057-.056 0-.056-.028-.056-.056v-.323c0-.028 0-.056.056-.056.055 0 .055.027.055.055zm.623-1.718a1.535 1.535 0 0 1-.37 1.058c-.017.02-.035.042-.078.004-.043-.036-.023-.056-.005-.08a1.37 1.37 0 0 0 .268-.47 1.46 1.46 0 0 0 .074-.513c0-.028-.002-.056.054-.056.055 0 .055.03.055.054zm-1.693 3.333c-.303-.755-.377-1.355-.3-1.843a2.1 2.1 0 0 1 .6-1.174c.2-.205.376-.407.49-.66.113-.253.167-.557.126-.967-.003-.028-.006-.055.05-.06.055-.006.055.022.06.05.04.43-.015.752-.136 1.022-.12.268-.3.48-.51.693a1.998 1.998 0 0 0-.57 1.115c-.074.47 0 1.052.295 1.788.01.026.02.05-.03.07-.05.02-.064-.004-.074-.03zm-.976-1.24a.77.77 0 0 0-.048.366c.01.12.057.245.133.37.015.022.03.047-.018.075-.048.032-.06.006-.076-.016a1.006 1.006 0 0 1-.15-.415.886.886 0 0 1 .055-.42c.01-.024.02-.05.07-.032.054.02.042.046.034.07zm4.803-3.41c.198.28.315.57.338.874.022.304-.046.617-.218.944-.013.022-.025.048-.073.022-.05-.025-.036-.05-.023-.073.162-.306.228-.6.205-.883a1.61 1.61 0 0 0-.32-.82c-.018-.022-.033-.045.013-.078.045-.033.06-.01.078.013zm1.5-1.175a2.564 2.564 0 0 1 .075 1.783c-.015.05-.106.04-.11-.015a1.905 1.905 0 0 0-.17-.75 1.626 1.626 0 0 0-.46-.57c-.02-.018-.042-.036-.007-.08.036-.042.056-.024.08-.006.214.172.376.374.487.61.068.143.12.3.15.467.032-.184.047-.37.04-.554a2.4 2.4 0 0 0-.187-.845c-.01-.025-.02-.05.03-.073.05-.02.063.005.073.03zm.89-1.217c.197.195.336.453.422.77.083.315.114.685.1 1.107v.003c-.022.18-.03.354-.01.516.02.16.064.306.148.437.015.024.03.05-.015.08-.048.03-.064.005-.08-.018a1.133 1.133 0 0 1-.163-.486 2.434 2.434 0 0 1 .007-.54 3.755 3.755 0 0 0-.094-1.07c-.08-.3-.21-.54-.392-.722-.02-.02-.04-.038 0-.08.037-.04.058-.02.078 0zm-2.364-.235c-.13.156-.207.34-.245.546-.037.206-.032.434.006.682.005.028.01.053-.045.063-.053.01-.058-.017-.063-.045a2.16 2.16 0 0 1-.005-.72c.04-.224.13-.424.268-.598.018-.02.036-.043.08-.008.042.035.024.056.006.08zm-4.632 3.119c-.02.46-.154.835-.37 1.144-.214.306-.508.55-.855.75-.023.016-.05.03-.076-.02-.028-.047-.005-.06.02-.075.33-.194.615-.427.82-.72.204-.29.33-.645.35-1.083 0-.028.004-.056.06-.053.055.002.053.03.053.058zm-.119-1.594c.025.172.015.34-.023.506a2.32 2.32 0 0 1-.187.5c-.013.024-.025.047-.073.024-.05-.025-.038-.05-.026-.074.08-.16.145-.318.18-.473a1.25 1.25 0 0 0 .023-.464c-.004-.028-.01-.056.047-.063.056-.008.06.02.063.048zm3.137-.23v.157l.053.814.005.073c.003.028.003.055-.05.06h-.018c-.007.01-.02.016-.045.016-.056 0-.056-.03-.056-.057v-.9l-.014-.22c-.003-.03-.005-.056.05-.062.056 0 .06.024.06.052v.018c.014.01.014.028.014.045zm.758-1.398c-.224.27-.312.53-.317.786-.006.255.073.51.19.764.262.422.348.842.32 1.265-.025.42-.164.837-.35 1.255-.01.025-.02.05-.072.027-.05-.022-.037-.048-.027-.073.182-.405.314-.812.34-1.217a1.973 1.973 0 0 0-.307-1.204l-.002-.005c-.124-.268-.208-.54-.203-.817.006-.28.105-.564.343-.855.017-.02.035-.043.078-.007.044.035.026.055.01.078zm-4.866-8.677c.366-.28.726-.44 1.103-.48.374-.038.76.043 1.18.24.14-.002.28-.002.42-.005.14-.003.284-.005.426-.005.028 0 .056 0 .056.056 0 .054-.03.054-.057.054-.144.003-.286.005-.427.005l-.385.004c0 .003-.004.005-.007.008-.45.397-.834.615-1.176.686a1.13 1.13 0 0 1-.93-.203c-.03-.02-.057-.04-.02-.096.04-.057.07-.04.097-.02.248.173.517.244.825.18.298-.062.637-.247 1.034-.583-.364-.16-.698-.223-1.02-.19-.35.035-.688.187-1.034.453-.028.02-.056.04-.097-.013-.04-.056-.015-.076.013-.096z\"></path><path d=\"M290.18 107.81a.28.28 0 0 1 0 .557.28.28 0 0 1-.277-.278c0-.155.124-.28.278-.28zm1.917 1.683c.2-.103.354-.215.483-.33a2.3 2.3 0 0 0 .314-.345c.015-.023.033-.046.078-.013.046.033.028.056.013.08-.09.123-.198.247-.33.365a2.44 2.44 0 0 1-.505.342c-.025.013-.05.025-.074-.023-.025-.05-.002-.064.023-.074zm3.949-1.633a.557.557 0 0 1 .31 0c.1.03.2.085.297.166.02.018.043.035.008.078-.035.043-.055.026-.078.008a.71.71 0 0 0-.258-.142.494.494 0 0 0-.25-.002c-.028.007-.053.015-.068-.04-.016-.054.012-.06.037-.07zm-2.259.09a.91.91 0 0 1 .407-.455c.182-.097.412-.137.693-.112.028.003.056.005.05.06-.004.057-.032.054-.06.052-.26-.023-.47.012-.632.098a.777.777 0 0 0-.357.403c-.01.025-.023.05-.073.027-.05-.022-.04-.048-.028-.073zm.258.37a.452.452 0 0 1 .124-.256.59.59 0 0 1 .285-.157c.027-.008.053-.015.068.038.015.053-.013.06-.038.068a.475.475 0 0 0-.233.127.37.37 0 0 0-.093.197c-.006.028-.01.053-.065.046-.053-.008-.05-.036-.045-.064zm-3.76 1.25c-.06.095-.116.194-.157.3a.878.878 0 0 0-.05.355c.002.027.005.055-.05.058-.057.002-.06-.023-.062-.05-.01-.15.016-.282.056-.4.04-.117.1-.223.167-.324.014-.024.03-.05.075-.02.048.03.033.054.018.077zm1.078.482v.167c0 .027 0 .055-.056.055-.055 0-.055-.028-.055-.056v-.168c0-.027 0-.055.055-.055.056 0 .056.028.056.055zm-.701-1.204c.11.04.22.06.332.063.11 0 .225-.014.336-.04.028-.004.053-.012.066.04.013.055-.015.062-.04.07a1.517 1.517 0 0 1-.365.043 1.062 1.062 0 0 1-.368-.07c-.028-.01-.053-.02-.033-.072.02-.052.044-.04.07-.032zm.693-2.021a.34.34 0 0 0-.222.068.403.403 0 0 0-.14.202c-.007.028-.015.054-.068.038-.053-.015-.045-.043-.038-.068a.525.525 0 0 1 .18-.258.46.46 0 0 1 .29-.092c.03 0 .057.002.057.056 0 .055-.028.055-.056.055zm-1.12.113a.85.85 0 0 0-.2.117.272.272 0 0 0-.09.12c-.01.03-.017.055-.07.037-.053-.018-.043-.043-.035-.07a.393.393 0 0 1 .124-.173.92.92 0 0 1 .23-.133c.025-.01.05-.02.07.03.024.05-.002.063-.03.074zm-.691.02a.875.875 0 0 0-.175.158.716.716 0 0 0-.115.194c-.01.026-.017.054-.07.033-.05-.017-.043-.045-.033-.07a.787.787 0 0 1 .13-.228.96.96 0 0 1 .2-.18c.02-.015.044-.03.077.015.032.046.01.06-.016.08zm-.888.712a1.817 1.817 0 0 0-.405.417c-.014.022-.032.045-.077.012-.046-.033-.028-.056-.013-.08a2.187 2.187 0 0 1 .428-.44c.022-.017.045-.032.078.01.033.047.01.062-.013.08zm.088.978c-.053.06-.106.117-.16.173l-.16.172c-.02.02-.04.04-.08.002-.04-.037-.022-.058-.002-.078l.16-.173.16-.172c.02-.02.04-.04.08-.003.04.038.023.06.002.08zm-.898.26v.346c0 .027 0 .055-.055.055s-.055-.027-.055-.054v-.345c0-.026 0-.054.056-.054s.056.028.056.055zm1.151 1.514l-.053.565c-.002.016-.002.034-.005.052-.003.028-.006.055-.06.05-.057-.005-.055-.033-.052-.06.002-.018.002-.036.005-.054l.053-.564c.003-.028.005-.055.06-.05.056.005.054.033.05.06zm-.675-.501a22.1 22.1 0 0 1-.013.367c0 .028-.003.056-.06.053-.055-.002-.052-.03-.052-.055.002-.124.008-.246.013-.37 0-.027.003-.055.06-.053.054.003.052.03.052.058zm-.628-4.791a.778.778 0 0 1 .498.498c.01.028.02.053-.035.07-.053.02-.06-.01-.07-.035a.693.693 0 0 0-.167-.27.743.743 0 0 0-.266-.162c-.025-.01-.05-.02-.033-.07.02-.054.047-.044.072-.034zm5.511 7.185c.106.24.164.48.167.718.005.24-.043.48-.144.72-.01.027-.02.052-.07.032-.052-.02-.042-.048-.032-.074.094-.225.14-.45.134-.675a1.685 1.685 0 0 0-.156-.676c-.013-.025-.023-.05.027-.073.052-.024.065.002.075.027zm-1.795 2.077c.077-.27.19-.506.322-.72.132-.216.28-.41.43-.603.172-.222.286-.465.347-.713.065-.268.067-.546.02-.81-.006-.027-.01-.052.045-.063.053-.01.06.018.063.046.05.278.048.57-.02.855a1.97 1.97 0 0 1-.367.757c-.146.19-.292.382-.422.592a2.793 2.793 0 0 0-.31.693c-.008.028-.016.053-.07.038-.052-.015-.045-.04-.037-.07zm-2.31-.61c.037-.1.092-.19.168-.268a.963.963 0 0 1 .28-.197c.026-.014.052-.024.074.024.023.05 0 .063-.028.073a.848.848 0 0 0-.25.175.61.61 0 0 0-.144.23c-.01.025-.02.053-.07.033-.052-.018-.044-.045-.034-.07zm-.45-.162c.087-.11.173-.215.272-.306.1-.093.215-.172.346-.225.025-.01.05-.02.07.03.02.054-.004.065-.032.072-.12.048-.22.12-.31.203-.095.086-.178.19-.26.293-.017.023-.032.046-.078.01-.045-.033-.027-.055-.01-.078zm2.394-2.372a.718.718 0 0 0 .276.065.88.88 0 0 0 .258-.033c.028-.008.053-.015.068.038.016.053-.012.06-.038.068a.847.847 0 0 1-.607-.038c-.025-.012-.05-.022-.028-.073.023-.05.048-.038.074-.028zm-1.191-.155c.027-.033.055-.063.083-.096l.01-.014c.018-.02.038-.04.08-.005.04.04.02.06.004.08l-.01.012a2.942 2.942 0 0 1-.086.096c-.018.02-.036.04-.08.005-.04-.035-.022-.058-.004-.078zm25.765 7.433c.053.058.1.12.14.185.037.065.068.134.093.207.01.028.02.053-.035.068-.053.018-.06-.01-.07-.035a.81.81 0 0 0-.084-.185.85.85 0 0 0-.123-.164c-.018-.02-.038-.04.003-.08.04-.037.06-.016.078.004zm-28.604 13.424c.12.11.248.213.387.284.138.068.29.11.46.11.03 0 .057 0 .057.056s-.028.056-.056.056a1.14 1.14 0 0 1-.51-.124 1.88 1.88 0 0 1-.412-.298c-.02-.018-.04-.038-.003-.08.038-.04.06-.022.08 0z\"></path><g fill=\"red\"><path d=\"M308.605 106.323a8.777 8.777 0 0 0 1.768-.083c-.556.402-1.267.673-2.034.8a.822.822 0 0 0 .288-.363.455.455 0 0 0-.023-.354zm-1.515-.157c.412.07.84.117 1.262.145.005.01.013.018.018.028.068.094.088.185.058.274-.036.1-.132.207-.29.316-.042.03-.085.06-.024.144a6.01 6.01 0 0 1-1.295.023.19.19 0 0 0 .042-.036c.154-.162.253-.33.28-.504a.67.67 0 0 0-.053-.387zm-11.198-3.218c.713-.093 1.44-.116 2.178-.098.243.098.423.242.534.432.12.213.164.49.114.838-.008.05-.015.103.088.116.104.015.112-.038.117-.09.055-.393.005-.715-.14-.968a1.117 1.117 0 0 0-.273-.313c.066.002.132.005.198.01.85.045 1.51.288 2.25.655a.145.145 0 0 1 .016.02c.157.165.21.334.185.51-.03.184-.14.383-.317.588-.033.04-.068.08.013.147.078.068.113.028.146-.013.2-.235.332-.468.365-.695a.743.743 0 0 0-.038-.372c.62.308 1.254.604 1.868.928.013.008.026.013.038.02a.12.12 0 0 0 .01.04c.05.176.03.325-.055.454-.093.134-.262.25-.508.34-.048.02-.096.037-.06.136.035.096.085.078.134.06.288-.11.49-.248.607-.42a.674.674 0 0 0 .114-.483c.407.22.814.448 1.232.648v.002c.075.147.087.28.03.4-.062.13-.203.25-.428.362-.046.023-.094.045-.05.14.047.093.095.07.14.047.27-.135.443-.29.524-.46a.58.58 0 0 0 .046-.37c.144.062.29.123.44.18a8.75 8.75 0 0 0 1.41.373.498.498 0 0 1 .12.402c-.025.13-.103.26-.23.393-.035.038-.07.073.003.146.013.013.023.02.033.028-1.58-.162-2.988-.918-4.46-1.487-.175-.07-.352-.134-.527-.203-.543-.205-1.092-.483-1.638-.706a.17.17 0 0 0-.07-.035l-.112-.035c-.023-.01-.048-.017-.07-.027 0 .002.006.005.01.007a9.05 9.05 0 0 0-1.514-.354 6.525 6.525 0 0 0-1.736-.017l-.096-.015c.05-.31.01-.584-.144-.822-.11-.17-.273-.32-.5-.443z\"></path><path d=\"M293.303 103.644a9.274 9.274 0 0 1 2.214-.643c.344.138.572.305.7.502.125.195.155.423.112.686a4.48 4.48 0 0 0-1.963.24c-.168-.35-.393-.564-.656-.68a1.327 1.327 0 0 0-.407-.107zm7.962 4.028a10.05 10.05 0 0 0-.597-.357 7.388 7.388 0 0 0-3.243-.918l.028-.026c.402-.41.49-.796.354-1.157-.106-.28-.352-.542-.69-.777.38-.02.73.002 1.125.058a8.736 8.736 0 0 1 1.935.53c.162.356.208.667.137.93-.073.276-.28.506-.615.696-.046.025-.092.05-.04.14.05.092.095.067.14.04.388-.218.625-.492.714-.826.068-.258.048-.546-.066-.867.445.2.848.437 1.13.698.365.253.727.508 1.08.777.004.45-.128.706-.345.84-.23.14-.56.156-.934.12-.05-.007-.104-.012-.115.092v.005z\"></path><path d=\"M303.43 109.3c-.657-.513-1.3-1.05-1.99-1.512.382.03.724 0 .982-.154.25-.155.415-.423.442-.86.413.318.81.655 1.187 1.017.19.18.38.357.575.532 0 .002.003.005.003.01.045.162.06.3.048.418a.49.49 0 0 1-.12.28.584.584 0 0 1-.29.165c-.185.053-.425.063-.72.03-.05-.005-.1-.01-.112.08z\"></path><path d=\"M305.7 110.796a12.284 12.284 0 0 1-.655-.362c-.503-.298-.976-.64-1.44-.996.284.022.522.007.714-.046a.8.8 0 0 0 .39-.225.688.688 0 0 0 .17-.4.984.984 0 0 0-.002-.227c.453.387.93.746 1.442 1.06.27.164.54.318.807.463a.21.21 0 0 0 .003.055c.033.208-.084.34-.296.423-.248.1-.617.14-1.04.165-.048.003-.094.005-.1.086z\"></path><path d=\"M308.124 111.748a12.69 12.69 0 0 1-2.193-.835c.39-.028.734-.074.982-.172.28-.11.443-.283.433-.558.45.227.9.425 1.36.586.08.18.085.327.01.45-.092.153-.292.28-.54.388-.048.02-.096.043-.053.137v.002z\"></path><path d=\"M313.174 111.234c.066-.01.47-.116.26.038-1.487.974-3.374.97-5.153.514.277-.124.502-.274.616-.46.086-.14.1-.3.06-.474a9.441 9.441 0 0 0 1.734.392.402.402 0 0 1-.094.27c-.094.117-.253.23-.514.345-.048.02-.096.04-.053.136.04.096.088.073.136.053.293-.13.483-.267.594-.406a.58.58 0 0 0 .14-.377 9.58 9.58 0 0 0 2.277-.036zm-10.287 25.626c-.11.117-.205.246-.296.398-.432.144-.814.36-1.28.34 0 .3.1.43.4.434.575-.29.704-.342.755-.3.07.06-.08.472-.557.806-.073.045-.07.073-.028.15.402.63 1.457.404 2.024.255.405-.107 1.136-.587 1.34-.992.077-.184-.1-.427-.277-.624-.448.068-.602-.14-.532-.283-.473-.167-1-.203-1.548-.183zm-16.174-5.098c-.33.27-.696.48-1.123.623-.162.053-.555.15-.593.354-.005.072.264.232.436.138.475-.455.713-.202.167.263-.043.09-.008.188.086.272.493.443 1.715.587 2.272.235.412-.258.627-.54.268-.933.002-.09.012-.175.028-.263l-.68-.068-.418-.243-.443-.378zm10.647 3.704c-.04.005-.084.01-.125.018-.22.238.385.15.706.347.148.09.21.264.153.507-.296.706-1.948.478-2.497.187-.256-.134-.266-.29-.256-.51.114 0 .23-.006.347-.024.197-.028.392-.086.584-.195.054-.03.11-.063.05-.17-.06-.108-.117-.078-.17-.047a1.38 1.38 0 0 1-.496.164c-.172.025-.35.025-.52.018h-.042c-.096-.056-.17-.122-.13-.18.042-.055.2.005.23.015.257-.12.48-.194.755-.248l.112-.116c.502.044.983.12 1.302.236zm-7.64-.432c-.1.06-.136.146-.21.306a2.89 2.89 0 0 1-.933.632c-.306.14-.01.274.205.42.195.145.45-.17.61-.407.175-.263.352-.185.238.02-.127.225-.218.55-.23.72-.066.18.627.32.746.325.423.02.954-.392 1.285-.602.277-.28.234-.526.113-.868l.002-.023a2.103 2.103 0 0 1-.508-.05 3.664 3.664 0 0 1-.597-.198c-.026-.01-.05-.02-.03-.074.012-.033.027-.04.045-.038l-.73-.167zm2.96-28.159c.115-.005.23-.01.345.002.215.026.42.12.635.145.72-.27 1.313-.42 1.827-.398a6.064 6.064 0 0 1 1.844-.232l-.022-.02c-.073-.074-.037-.112 0-.147.337-.342.415-.656.307-.94-.112-.293-.415-.568-.838-.82-.45.05-.883-.072-1.36-.02-.3.034-.593.1-.88.196.24.087.45.23.62.43.213.25.365.593.446 1.023.01.05.018.1-.083.12-.1.022-.112-.03-.122-.082-.073-.39-.21-.7-.4-.925-.2-.286-.657-.397-.8-.455-.48.048-.95.1-1.36.207-.31.078-.58.187-.787.35.31-.067.63-.054.91.085.265.132.49.38.632.782.018.048.033.1-.066.132-.1.032-.116-.016-.13-.066-.12-.347-.308-.554-.528-.663-.437-.218-1.34-.028-1.723.255a4.515 4.515 0 0 0-.665.633c-.023.028-.048.053-.078.056.82.056 1.644.1 2.282.355zm-2.433-.463c-.017-.046.013-.08.04-.112.23-.26.464-.49.704-.667.234-.172.474-.296.722-.355.253-.28.628-.45 1.063-.56.422-.11.905-.166 1.394-.214-.145-.29-.33-.465-.543-.56-.227-.1-.49-.115-.77-.088-.59.203-1.115.52-1.618.876.045 0 .09 0 .133.002.15.01.283-.012.407.036.05.018.1.035.064.134-.043.12-.37.045-.484.038a1.42 1.42 0 0 0-.427.04c-.025.005-.048.013-.07.005-.53.327-.93.658-1.357 1.02.324.114.577.248.74.405z\"></path></g><path d=\"M351.443 167.066l22.142-50.188-16.333-26.372-29.128 10.785-13.482 53.043a234.2 234.2 0 0 1 36.798 12.736z\" fill=\"#0093dd\"></path><path d=\"M323.206 120.643a268.71 268.71 0 0 1 42.263 14.63l-8.545 19.37a247.61 247.61 0 0 0-38.936-13.474z\" fill=\"#fff\"></path><path d=\"M358.3 151.532l5.707-12.936a265.337 265.337 0 0 0-41.692-14.43l-3.365 13.233a251.82 251.82 0 0 1 39.547 13.687l-.198.445z\" fill=\"red\"></path><path d=\"M326.424 134.244c.382-.24.79-.182 1.2-.116.33-.124.712-.167 1.127-.152a2.07 2.07 0 0 1 .616-.207c.124-.097.13-.2.018-.312a.663.663 0 0 1-.17-.377c-.657-.382-.9-.963-1.15-1.54-.375-.1-.55-.225-.59-.367a35.578 35.578 0 0 1-.542-.056c-.852.094-1.072-.182-1.376-.407-.253-.084-.473-.223-.615-.488-.092-.12-.186-.236-.28-.355-.232-.296-.162-.688.19-.665.248.028.493.028.72-.07.267-.12.664-.117.965-.092.357-.02.582-.25.93-.574-.004-.14-.004-.276-.007-.415-.055-.148.016-.214.213-.194.464.015.74.233.927.542.54.093.964.35 1.25.804.716.003 1.2.273 1.257.54.043.194-.167.416-.49.654.002.048.004.1.004.147.193.167.32.334.385.498.402.156.787.363 1.146.667 1.024-.12 2.752.625 5.087 2.115 1.515.27 2.985.69 4.397 1.3l.893.028c2.533-.374 4.987-.086 7.264 1.655.86.103 1.633.374 2.38.683.553.227 1.117.316 1.686.37.92.088 1.855.315 2.78.746 1.04.232 2.012.56 2.614 1.287.428.517.324.993-.22 1.19-.33.694-.984.724-1.965.382-.676.124-1.42-.417-2.095-.926-.94-.3-1.802-.842-2.654-1.42-.443-.33-.89-.54-1.326-.634-.342-.073-.648-.12-.853 0-.1.06-.088.096 0 .17.238.2.405.498.458.857.048.316-.002.68.016 1.067.02.407.266.703.676.956.28.172.615.354 1.098.423.23.045.296.18.288.354.13.617.248 1.24.474 1.8.063.158.184.234.366.368.625.45.3.954-.268 1.063-.498.44-.928.737-1.44.853-.407.137-.574-.03-.71-.23a.516.516 0 0 1-.473-.263c-.498-.367-.073-1.004 1.12-.73.024-.14.125-.183.227-.18-.07-.31-.112-.653.022-.975-.107-.068-.198-.154-.352-.205-.43-.136-.838-.334-1.16-.635-.61-.574-1.563-1.055-2.48-1.538-.76-.038-1.324-.387-1.92-.683-.267-.003-.535-.008-.803-.01-.236-.08-.428.002-.57.172-.237.288-.513.24-.84.202-.374-.043-.753-.015-1.128-.02-.185.046-.367.104-.567.106-.422-.023-.834-.028-1.115.208-.233.245-.466.227-.7.136-.173-.08-.3-.167-.373-.258-.294-.06-.483-.134-.547-.222-.493-.14-.632-.28-.61-.418-.654-.157-.343-.673.082-.69.5-.02.96.075 1.45.144.412.116.92.048 1.257-.256.217-.197.298-.367.564-.513-.848-.056-1.472-.205-1.933-.496-1.24-.783-2.23-.973-3.02-.31-.21.12-.375.167-.6.08a1.135 1.135 0 0 0-.623-.03c-.448.102-.89.046-1.338-.116a4.36 4.36 0 0 1-1.963.066c-.553.29-.958.324-1.216.1a9.125 9.125 0 0 1-.69-.424c-.353-.053-.504-.14-.52-.258-.45-.05-.506-.215-.503-.395-.186-.215-.115-.38.072-.518.334-.14.68-.19 1.065.007.23.11.4.215.54.324.254-.03.474 0 .667.07.14-.222.544-.232.984-.206.22-.147.483-.25.82-.28-.01-.054-.02-.107-.028-.158-.443-.116-.67-.438-.89-.762-.68-.012-1.17-.298-1.655-.597-.4.033-.72-.098-1.033-.286-.253.02-.534.03-.8-.038a2.728 2.728 0 0 1-1.494 0c-.332.03-.597-.003-.87-.028-.312.356-.66.42-1.043.237-.21-.266-.51-.44-.886-.54-.286-.093-.375-.217-.426-.35-.35-.216-.278-.43.06-.59.252-.122.568-.145 1.05.093.155.058.33.1.527.114z\"></path><path d=\"M343.107 139.33c-.033-.06-.104-.205-.36-.06-.792-.042-1.677-.03-2.343-.424-.693-.407-1.406-.832-2.173-.802a1.93 1.93 0 0 1 .84-.45c.44-.116.963-.124 1.54-.03.81.13 1.522.288 2.074.496.53.2.906.447 1.07.766a.433.433 0 0 0 .046.05c.212.137.397.277.55.423.118.108.22.222.305.343-.25.023-.51.005-.762-.045a3.07 3.07 0 0 1-.79-.273z\" fill=\"#fff\"></path><path d=\"M344.928 101.104l.046.238.996 5.16-3.964 3.457-.182.158.23.08 4.97 1.72 1.008 5.16.05.238.18-.16 3.973-3.443 4.976 1.706.232.077-.046-.238-.997-5.165 3.964-3.456.182-.16-.23-.078-4.97-1.72-1.01-5.162-.047-.238-.183.16-3.975 3.446-4.974-1.708z\"></path><path d=\"M342.5 109.9l3.703-3.228 4.658 1.604zm8.978-1.743l3.717-3.23 4.642 1.606zm8.392-1.459l-3.704 3.228-4.657-1.604zm-8.98 1.745l-3.715 3.23-4.643-1.605zm-5.436-6.863l4.648 1.593.94 4.835zm6.002 6.9l4.655 1.605.932 4.825zm5.459 6.54l-4.647-1.593-.94-4.834zm-6.001-6.903l-4.655-1.6-.932-4.826zm3.226-8.142l.944 4.823-3.717 3.23zm-2.978 8.648l.94 4.835-3.713 3.22zm-2.932 8l-.944-4.822 3.717-3.23zm2.978-8.648l-.94-4.834 3.712-3.218z\" fill=\"#f7db17\"></path>", 28)
const _hoisted_30 = [
  DpFlagHRvue_type_template_id_23ea40fa_hoisted_2
]
const _hoisted_31 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const _hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"#171796\" d=\"M0 0h640v480H0z\"></path><path fill=\"#fff\" d=\"M0 0h640v320H0z\"></path><path fill=\"red\" d=\"M0 0h640v160H0z\"></path><path d=\"M320.03 364.15c51.322 0 93.31-41.99 93.31-93.31V159.964H226.72V270.84c0 51.322 41.99 93.31 93.308 93.31z\" fill=\"red\"></path><path d=\"M320.03 362.654c50.343 0 91.53-41.19 91.53-91.53V161.76H228.5v109.365c0 50.342 41.188 91.53 91.53 91.53z\" fill=\"#fff\"></path><g fill=\"red\"><path d=\"M267.133 165.2H231.91v38.7h35.223zm0 77.4h35.225v-38.7h-35.225zm-35.223 28.31c0 3.513.217 6.98.622 10.39h34.6v-38.7H231.91v28.31zm105.675-28.31h-35.227v38.7h35.227zm0 77.398h35.224V281.3h-35.225zm35.225 21.17A89.19 89.19 0 0 0 392.92 320h-20.11v21.168zm-105.674-21.17h35.224V281.3h-35.224zm-20.144 0a89.168 89.168 0 0 0 20.144 21.194v-21.194h-20.144zm79.114 38.702c3.898-.274 7.73-.8 11.476-1.567v-37.135h-35.224v37.14a87.06 87.06 0 0 0 11.443 1.558c4.103.254 8.204.24 12.304 0z\"></path><path d=\"M407.375 281.3c.407-3.422.625-6.9.625-10.426v-28.272h-35.193v38.7h34.568zm-69.79-38.7h35.224v-38.7h-35.225zm0-77.4H302.36v38.7h35.225zM408 203.9v-38.7h-35.19v38.7z\"></path></g><path d=\"M409.972 158.83l21.84-49.51-16.64-26.87-27.567 10.207-19.355-22.125-25.504 14.616-22.742-18.626-22.74 18.626-25.505-14.616L252.4 92.655l-27.57-10.206-16.643 26.875L230 158.843c27.485-12.44 57.96-19.372 90.005-19.372 32.03 0 62.49 6.927 89.97 19.36z\" fill=\"#fff\"></path><path d=\"M253.008 94.842l-.04.047-27.338-10.124-15.3 24.7 5.86 13.325 14.847 33.702a219.67 219.67 0 0 1 34.582-11.962l-12.61-49.686z\" fill=\"#0093dd\"></path><path d=\"M251.435 119.268a13.258 13.258 0 0 1 1.533 6.2c0 7.36-6.002 13.363-13.362 13.363-6.486 0-11.917-4.662-13.116-10.807 2.308 4.08 6.69 6.844 11.694 6.844 7.395 0 13.428-6.03 13.428-13.43 0-.738-.06-1.463-.177-2.172z\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".28\"></path><path d=\"M227.59 113.915l.93-4.794-3.677-3.215-.17-.15.213-.072 4.618-1.59.945-4.794.044-.22.17.145 3.686 3.207 4.623-1.58.216-.072-.046.22-.932 4.796 3.68 3.216.17.147-.215.072-4.618 1.593-.947 4.793-.045.22-.168-.148-3.687-3.204-4.623 1.578-.216.073z\"></path><path d=\"M233.64 107.59l3.447 3.007 4.315-1.485zm.027-.15l7.766 1.517-3.436-3.004zm-8.337-1.634l7.764 1.52-3.448-3.006zm7.735 1.674l-7.765-1.52 3.436 3.002zm.435-.293l5.198-5.964-4.32 1.474zm-5.584 6.405l5.2-5.964-4.328 1.484zm5.318-5.862l-5.2 5.964 4.32-1.474zm5.583-6.405l-5.2 5.964 4.328-1.484zm-5.619 5.881l-2.566-7.483-.884 4.48zm2.756 8.038l-2.566-7.483-.88 4.49zm-2.419-7.534l2.566 7.484.885-4.478zm-2.755-8.04l2.565 7.487.88-4.49z\" fill=\"#f7db17\"></path><path d=\"M297.5 87.406l-.047.038-25.29-14.493-19.155 21.892 12.61 49.686a219.78 219.78 0 0 1 36.117-6.033l-4.237-51.09z\" fill=\"#171796\"></path><path d=\"M262.49 132.196a232.25 232.25 0 0 1 38.195-6.38l-1.07-12.913a245.548 245.548 0 0 0-40.315 6.732l3.187 12.56zm-6.34-24.971a257.957 257.957 0 0 1 42.405-7.082l-1.052-12.678a270.72 270.72 0 0 0-44.483 7.43l3.13 12.33z\" fill=\"red\"></path><g transform=\"translate(-160) scale(.00237)\"><path d=\"M212105 36890l-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z\" fill=\"#0093dd\"></path><g id=\"a\"><path d=\"M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z\"></path><g fill=\"#f7db17\"><path d=\"M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zm-5008 0c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zm4539 905c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-4032 0c-32 0-59 26-59 59 0 32 26 59 59 59s59-26 59-59-26-59-59-59zm4294-304c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z\"></path><path d=\"M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zm4389 911c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7-21 18-40 38-55 59s-28 43-38 67c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z\"></path><path d=\"M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z\"></path><path d=\"M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15-67 0-123-55-123-123s55-123 123-123c51 0 94 31 113 75l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54 68 0 123 55 123 123s-55 123-123 123c-12 0-25-2-36-6l33 94-2 7zm3067-416c-68 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-33 0-59 27-59 59s26 59 59 59c32 0 59-27 59-59s-26-59-59-59zm-1082-91c-67 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-32 0-59 26-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-1064-40c-68 0-123 55-123 123s55 123 123 123c67 0 123-55 123-123s-55-123-123-123zm0 64c-33 0-59 26-59 59s26 59 59 59c32 0 59-26 59-59 0-32-26-59-59-59z\" fill-rule=\"evenodd\"></path></g><path d=\"M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110zm799 5115l-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48zm59-326l-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51zm-1826-65l604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15zm51 322l515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210l402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38zm593-3082c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49zm371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16 8-6 17-13 25-19 6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z\"></path><path d=\"M203459 50602c-119 0-216 97-216 216s97 217 216 217 216-97 216-217c0-119-97-216-216-216zm0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147zm0 60c-48 0-87 39-87 87s39 87 87 87 87-39 87-87-39-87-87-87zm-1697-124c119 0 217 97 217 216s-97 217-217 217c-119 0-216-97-216-217 0-119 97-216 216-216zm0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147zm0 60c48 0 87 39 87 87s-39 87-87 87-87-39-87-87 39-87 87-87z\" fill-rule=\"evenodd\"></path></g><use height=\"100%\" width=\"100%\" xlink:href=\"#a\" transform=\"rotate(-2.173 -55532.79 156275.842)\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#a\" transform=\"rotate(2.18 459865.852 156275.76)\"></use></g><path d=\"M387.186 94.883l-.06.02-19.197-21.94-25.24 14.466-4.258 51.097a219.715 219.715 0 0 1 36.12 6.045l12.63-49.687z\" fill=\"#171796\"></path><path d=\"M347.668 98.03c.877-.213 1.742-.258 2.58.256.37.152.646.346.816.595.39-.3.785-.582 1.195-.824.575-.426 1.163-.803 1.795-1.014.906-.46 1.81-.732 2.714-.815.957-.164 1.92-.173 2.876-.116.8.048 1.572.268 2.31.693.667.33 1.333.666 2 .997.707.394 1.414.75 2.12 1.048.896.353 1.903.472 2.977.512.526.02 1.043.02 1.55-.116.41-.11.666.15.213.43-3.318 2.035-5.918.224-8.136-.587.813.55 1.528 1.12 2.133 1.7.844.813 1.787 1.637 3.455 2.398 1.012.46 2.114.822 3.53.834.478.004.995-.015 1.554-.107.282-.045.403-.02.408.128.004.1-.022.3-.19.41-.856.574-1.66.726-2.56.783-1.71.11-3.54-.453-5.214-1.35-1.34-.722-2.242-1.6-3.308-2.385-1.064-.785-1.984-1.22-2.972-1.43-.974-.208-2.03-.184-2.918.09.266.053.49.178.628.337.458.27 1.046.39 1.896.486.444.053.306.36-.376.726-.41.53-.944.813-1.652.744-.977.647-1.325.256-1.652-.168-.04.268-.12.53-.235.785a.602.602 0 0 1-.014.426c.156.242.232.477.18.735.026.137.07.27.218.393.205.186.335.4.36.66.004.173.1.315.236.443.2.164.4.308.6.553.59.213.862.666.96 1.25.445.145.63.468.718.852.253.106.485.234.618.46.91.002 1.8.002 2.63.09.78.083 1.416.568 1.985 1.2.383.058.772.077 1.17-.013.41-.18.844-.318 1.316-.358.78-.066 1.56-.107 2.306.07.503.122.897.39 1.22.755.464.528 1.18.457 1.79.197.83-.355 1.52-.343 2.37.03a2.33 2.33 0 0 1 1.086-.17c.31-.335.64-.418.98-.428.55-.02.952.066.848.775-.03.192-.143.377-.287.443-.254.548-.737.71-1.35.657-.067.377-.22.656-.468.836.28.87.01 1.22-.634 1.207-.135.25-.336.407-.68.358a1.38 1.38 0 0 1-.872.514c.038.227.135.334.296.578.44.664-.22.932-.822.94.154.44.173.878.118 1.316.614.372.697.764.13 1.15.415.725.254 1.258-.523 1.647-.012.405-.052.813-.322 1.04-.184.157-.45.185-.274.48.315.52.246 1.18-.22 1.198-.1-.008-.19.006-.197.165 0 .054-.05.11-.14.163-.56.3-1.084.645-1.565 1.04-.072.048-.143.08-.214.017-.35.764-1.004 1.54-1.727 2.318-.11.574-.436.963-.974 1.164a.41.41 0 0 1-.32.327c.3.334.414.657.123.974-.358.39-.83.773-1.3.894-1.004.256-1.632.208-2.035-.176-.355-.34-.216-.595.01-.7-.62.048-.745-.28-.728-.715.036-.217.11-.188.327-.18.337.008.64-.174.958-.278.123-.21.284-.39.483-.54.11-.702.555-1.09 1.157-1.32.485-.186.95-.655 1.4-1.262l.835-1.434a1.237 1.237 0 0 1-.254-.76 1.478 1.478 0 0 1-.557-.517c-.437-.032-.617-.23-.68-.5a1.1 1.1 0 0 1-.328-.044c-.214.138-.43.26-.697.247a6.86 6.86 0 0 1-1.09.91c-.13.36-.39.505-.704.55-.895.106-1.43 1.223-1.924 1.678-.2.148-.322.408-.41.72-.042.59-.144 1.05-.466 1.058-.29-.012-.335-.043-.344-.073a1.186 1.186 0 0 0-.377.016c.24.267.28.6.056.895-.223.29-.543.38-.85.4-.638.043-1.155-.014-1.634-.208-.457-.188-.512-.46-.498-.726-.33-.155-.395-.31-.36-.465.045-.2.228-.3.458-.237.2-.095.398-.16.597-.197.577-.622 1.172-1.158 1.826-1.407a2.97 2.97 0 0 1 .68-.614c.076-.56.444-1 .894-1.41.04-.202.106-.406.22-.608-.026-.12.007-.177.01-.29-.183-.34-.292-.748-.157-1.087a1.314 1.314 0 0 1-.05-.54c-1.075.64-1.407.422-1.53-.097-.394.33-.76.483-1.024.01-.383.113-.767.24-1.148.09-.25.097-.5.184-.787.203-.116.23-.273.46-.484.69-.01.484-.18.968-.49 1.45a9.272 9.272 0 0 1-.696 1.55.985.985 0 0 1-.107.5c.083.594-.116.883-.443 1.03a2.41 2.41 0 0 1-.417.72c-.01.08-.017.16-.026.237.13.35.153.7-.203 1.05-.287.18-.592.37-.896.52-.357.175-.69.092-.99-.017-.528-.19-.488-.375-.42-.555a.644.644 0 0 1-.52-.007c-.128-.08-.21-.163-.337-.246-.114-.207-.154-.394.123-.54.35-.155.586-.27.86-.55.095-.214.216-.375.387-.418.166-.388.37-.65.647-.723.204-.48.422-1.01.68-1.47.09-.14.157-.285.114-.443-.005-.13.005-.254.114-.328.06-.053.17-.1.033-.174a1.36 1.36 0 0 1 .164-1.154c.28-.422.593-1.44.297-1.94-.054-.28-.108-.6-.073-.863-.102-.006-.178.008-.28-.063-.227-.14-.417-.007-.59.246-.125.318-.25.598-.376.598-.118.82-.52 1.458-.94 1.622-.098.377-.16.753-.107 1.13.043.41 0 .69-.19.737-.208.05-.403.172-.523.506a1.05 1.05 0 0 0-.074.337c.29.3.202.67-.076.946-.625.615-1.403.525-2.225.283-.595-.235-.74-.483-.68-.737-.844-.07-.676-.718.023-.912.752-.21 1.36-.693 1.86-1.38.046-.815.233-1.37.672-1.457.042-.5.2-.95.41-1.377.22-.387.355-.81.277-1.328-.467-.29-.486-.592-.057-.9.142-.083.126-.168-.05-.254-.284-.028-.25-.3-.23-.557-.012-.13-.08-.2-.206-.202-.63-.093-.474-.35-.204-.63.114-.13.19-.318.07-.394-.096-.062-.162-.278-.183-.467-.387-.292-.22-.59 0-.877-.22-.185-.32-.455-.35-.77-.72-.03-.987-.396-.598-.927a3.38 3.38 0 0 1 .63-.647c.165-.268.324-.536.245-.803-.206-.524.453-.92 1.017-1.328a.88.88 0 0 1-.123-.41c-.32-.305-.238-.59.113-.86a1.064 1.064 0 0 1-.13-.417c-.79.156-.785-.315-.418-1.074-.457-.263-.33-.73.5-1.44a.953.953 0 0 1 .09-.378 1.92 1.92 0 0 0-1 .304c-.315.206-.628.18-.943.05a1.496 1.496 0 0 0-.417-.41.622.622 0 0 1-.22-.63c-.93.05-1.107-.636-.55-1.04.31-.248.538-.506.623-.788.25-.638.784-1.07 1.303-1.517 0-.182.042-.365.1-.55-.23-.154-.473-.265-.74-.286a1.176 1.176 0 0 0-.572-.64c-.173-.103-.23-.2-.123-.435-.493-.44-.37-.71-.244-.962z\"></path><g fill=\"#f7db17\"><path d=\"M364.524 121.963a1.37 1.37 0 0 1-.176.007 8.45 8.45 0 0 1-.79.696c-.23-.265-.572.027-.238.188l-.17.118c-.11.29-.21.413-.532.462-.05.007-.1.017-.15.03a2.953 2.953 0 0 1 .015-.36 3.48 3.48 0 0 1 .07-.42c.004-.027.01-.05-.04-.063-.05-.01-.056.016-.06.042a3.875 3.875 0 0 0-.074.433 2.75 2.75 0 0 0-.015.396c-.813.262-1.283 1.108-1.837 1.71-.24.206-.36.49-.448.79-.047.158-.064.886-.228.897-.078.003-.16 0-.248 0-.088-.132-.207-.135-.356-.01-.34-.006-.7-.01-1 .04-.206.222.36.14.66.324.14.084.198.247.143.475-.276.66-1.824.447-2.338.175-.24-.126-.25-.27-.24-.476.107 0 .216-.008.325-.024.185-.026.368-.08.548-.183.05-.028.102-.056.045-.158-.057-.103-.11-.075-.16-.046a1.25 1.25 0 0 1-.463.154 2.57 2.57 0 0 1-.486.016c-.013 0-.028-.002-.04 0-.09-.052-.158-.114-.12-.168.038-.052.187.005.215.014.24-.11.448-.182.707-.232.545-.583 1.1-1.13 1.85-1.432.226-.27.47-.483.764-.677.104-.65.42-.997.89-1.428.058-.268.124-.46.257-.695-.03-.15-.007-.244 0-.395-.18-.342-.287-.638-.145-1.02-.088-.277-.076-.464-.042-.72a.35.35 0 0 0-.003-.144 6.223 6.223 0 0 1 .848-.574c-.02.256-.01.524.04.803l-.003.003a1.28 1.28 0 0 0-.197.263.53.53 0 0 0-.073.277c0 .026 0 .052.052.05.05 0 .05-.026.05-.052a.43.43 0 0 1 .06-.225c.043-.08.107-.16.183-.24a.105.105 0 0 0 .02-.026c.248-.007.492-.14.736-.336.22-.18.44-.412.658-.656-.002.356-.005.71-.01 1.067-.213.19-.395.422-.538.705-.01.023-.023.045.022.068.047.024.06 0 .068-.023a2.27 2.27 0 0 1 .49-.65h.008c.052 0 .052-.026.052-.052v-.002a3.17 3.17 0 0 1 .917-.526c-.045.312-.066.618-.01.912.058.322.21.626.518.89.004.006.012.008.02.01z\"></path><path d=\"M349.043 112.947c.04-.073.142-.168.175-.16l.02-.006c.11-.207.227-.402.348-.577a3.98 3.98 0 0 1 .497-.6c.02-.02.038-.035.074 0 .035.038.016.055 0 .074a3.91 3.91 0 0 0-.486.583 5.82 5.82 0 0 0-.34.57c.035.046.052.12.033.172.035.324.078.507.223.694a.202.202 0 0 1 .05-.033c.06-.145.14-.273.24-.386a1.65 1.65 0 0 1 .45-.35c.125-.103.224-.207.305-.316.08-.106.145-.215.19-.327.01-.023.02-.047.07-.028.046.02.037.045.027.07-.05.12-.116.236-.2.35a2.056 2.056 0 0 1-.328.334l-.01.003c-.17.093-.313.202-.427.33a1.247 1.247 0 0 0-.21.327c.075.054.108.204.037.3-.216.31-.472.492-.07.757a.635.635 0 0 0 .19.512c.093.096.084.435-.144.68-.213.215-.05.158.17.184l.05.017v-.002c.08-.156.176-.296.28-.426a4.34 4.34 0 0 1 .327-.363c.16-.157.285-.328.375-.5.087-.17.14-.342.15-.508 0-.026 0-.052.056-.048.052.003.05.03.047.055a1.41 1.41 0 0 1-.16.55c-.095.18-.227.36-.393.522a3.78 3.78 0 0 0-.318.354 2.6 2.6 0 0 0-.27.41c.267.16.182.45.222.715.052.008.097.02.137.04a.029.029 0 0 1 .01-.015l.155-.246.247-.393c.014-.02.028-.045.07-.016.046.03.032.05.017.072l-.247.39-.157.248a.052.052 0 0 1-.007.01c.163.134.175.376-.027.56-.396.3-.284.392.086.63.046.347.048.627-.027.923l.004.026c.01.096.017.196.024.293l.025.296c.002.025.004.05-.048.056-.052.005-.054-.02-.057-.047l-.023-.298a.644.644 0 0 1-.005-.075c-.02.045-.038.092-.062.142-.265.58-.54 1.053-.6 1.705-.637.152-.542.78-.578 1.335-.502.677-1.085 1.22-1.893 1.49-.153.05-.52.14-.556.332-.005.07.247.218.408.13.445-.426.668-.19.156.247-.04.082-.007.174.08.252.463.415 1.608.55 2.13.22.385-.24.587-.506.25-.874.022-.52.225-1.03.775-1.178.064-.118.045-.338.017-.46-.052-.452.02-.855.13-1.29.02-.055.06-.1.15-.124.208-.043.61-.647.734-1.228.03-.125.05-.256.074-.386.033-.202.11-.237.213-.12.098-.13.096-.207.155-.357.213-.31.52-.56.882-.383a3.036 3.036 0 0 1-.176-.832 2.7 2.7 0 0 1 .115-1.03c.014-.05.03-.098.11-.087.103-.246.205-.49.31-.737l.312-.742c.01-.023.02-.047.067-.028.047.02.038.045.028.07l-.313.74-.31.735c.044.034.03.077.016.12a2.515 2.515 0 0 0-.102.943c.023.346.11.68.237.953.012.026.027.052.022.078.17.1.168.123.16.35-.004.18.02.354.063.567.34.627-.014 1.674-.344 2.198a1.09 1.09 0 0 0-.134.834c.204.197.07.4-.11.538-.013.048 0 .102.003.15.018.204-.055.374-.162.542-.277.5-.49 1.034-.713 1.558-.403.11-.486.346-.647.722-.235.067-.26.135-.358.35a2.71 2.71 0 0 1-.875.594c-.286.13-.01.256.192.393.183.134.422-.16.572-.382.162-.247.328-.174.22.018a1.95 1.95 0 0 0-.214.674c-.062.17.587.3.7.305.395.02.892-.367 1.203-.564.257-.262.217-.492.103-.812l.002-.02a1.97 1.97 0 0 1-.476-.048 3.432 3.432 0 0 1-.56-.185c-.024-.01-.048-.02-.03-.07.02-.046.046-.037.07-.027.185.075.363.14.543.177.15.033.303.05.467.045l.026-.25a2.7 2.7 0 0 0 .46-.804c.438-.207.44-.42.38-.89.098-.19.12-.3.112-.516a9.93 9.93 0 0 0 .723-1.597c.347-.46.513-.894.473-1.44.03-.214.11-.335.265-.328a3.82 3.82 0 0 0 .308-.505.46.46 0 0 0 .057.005.081.081 0 0 1 0-.038c.03-.126.062-.237.105-.33a.798.798 0 0 1 .142-.225.918.918 0 0 0 .07-.455 1.107 1.107 0 0 0-.153-.443.492.492 0 0 1-.116-.185c-.02-.074-.006-.148.067-.22.02-.02.038-.037.074 0s.02.056 0 .072c-.042.04-.05.078-.037.116a.456.456 0 0 0 .097.15l.005.01c.092.158.154.322.17.49a1.01 1.01 0 0 1-.083.514c0 .002-.01.014-.01.017a.722.722 0 0 0-.13.2 1.69 1.69 0 0 0-.097.308l-.004.02c.245 0 .46-.077.695-.193l.014-.014c.118-.094.243-.238.348-.428.087-.16.158-.353.2-.576.003-.026.008-.05.06-.043.05.01.045.036.043.06a2.035 2.035 0 0 1-.21.61c-.08.148-.175.27-.27.364.38.114.708.002 1.07-.11-.053-.506-.046-.893.008-1.196.06-.33.17-.56.31-.736.017-.022.03-.04.074-.01.04.034.026.052.01.074-.13.163-.235.38-.29.692-.052.29-.06.66-.01 1.147.003-.002.01-.002.018-.005.15.26.232.446.542.244.114-.076.233-.15.327-.25.035-.04.023-.06.05-.09.298-.316.596-.61.893-.87.298-.264.597-.49.895-.67.022-.016.045-.03.072.015.026.046.004.058-.017.072a6.45 6.45 0 0 0-.882.66c-.252.222-.506.468-.76.734.015.045.022.123.03.242.025.35.09.56.59.37.28-.107.307-.12.566-.273a1.34 1.34 0 0 1 .305-.157 7.99 7.99 0 0 1 .49-.358c.158-.106.32-.203.478-.29.026-.188.07-.373.13-.55.155-.456.413-.878.738-1.276l.016-.014c.27-.147.49-.32.666-.517.178-.197.31-.417.41-.656.01-.024.02-.048.07-.03.046.02.037.046.027.07-.104.25-.244.48-.426.685a2.525 2.525 0 0 1-.69.535c-.314.39-.565.797-.712 1.235a2.69 2.69 0 0 0-.116.474c.01.003.02.012.028.03.024.048 0 .06-.02.07-.008.002-.015.007-.022.012a2.81 2.81 0 0 0 .023.805c.222-.007.445-.13.67-.312.24-.194.483-.462.725-.734.002-.007.002-.012.01-.017a1.7 1.7 0 0 1 .234-.503.95.95 0 0 1 .397-.327c.024-.01.048-.022.07.028.018.048-.003.057-.03.07a.862.862 0 0 0-.355.29 1.66 1.66 0 0 0-.225.49c-.002.368-.007.738-.01 1.108.012-.01.027-.02.038-.03.273-.212.586-.368.925-.492.035-.014.076.02.068.057-.052.333-.08.663-.026.966.052.284.18.55.436.787a2.78 2.78 0 0 1 .48-.628c.096-.097.196-.188.3-.273.076-.07.152-.14.225-.21l.228-.212c.02-.02.04-.035.074.003.036.038.017.057-.002.073l-.228.21-.227.212-.003.002c-.097.08-.19.162-.28.252.003.097.008.192.013.29l.004.155c.22.06.35.062.573.057.073.438.11.507.493.517a3.244 3.244 0 0 1 .014-.457c.02-.17.054-.336.114-.493.01-.023.018-.047.066-.03.05.018.04.042.03.066a1.89 1.89 0 0 0-.108.467 3.1 3.1 0 0 0-.015.448h.03c.153.314.333.468.655.607.09-.142.157-.284.2-.426a1.37 1.37 0 0 0 .056-.476c-.002-.026-.002-.052.048-.054.052-.002.054.02.057.047.01.17-.01.342-.062.512-.05.17-.134.338-.248.506-.01.015-.02.03-.035.03.014.18.045.316.11.454a3.02 3.02 0 0 1 .153-.3c.078-.136.168-.26.277-.368.02-.02.036-.036.073 0 .036.035.02.054 0 .073-.1.1-.184.22-.26.348a3.984 3.984 0 0 0-.183.363c.036.062.08.123.133.194-.607 1.04-1.256 2.482-2.453 2.956-.62.244-.89.56-1.012 1.22-.232.18-.398.363-.55.614-.403.135-.763.337-1.2.318 0 .282.093.405.375.407.538-.27.66-.32.707-.282.066.057-.076.444-.522.756-.068.042-.066.068-.026.14.376.59 1.364.378 1.895.24.38-.1 1.064-.55 1.254-.93.072-.176-.093-.4-.26-.586-.758.116-.613-.61.04-.308.22-.066.247-.07.31-.313.58-.225.82-.47.954-1.092.586-.63 1.173-1.28 1.595-2.035.115-.142.184-.394.15-.524a1.07 1.07 0 0 0 .2-.42c.038-.153.062-.302.057-.454 0-.026-.003-.052.05-.054.052-.002.052.024.054.05.006.16-.018.32-.058.48a4.48 4.48 0 0 1-.12.37c.037.095.056.16.14.136.506-.408 1.018-.695 1.565-1.034.038-.232.188-.346.417-.355.093 0 .126-.027.16-.113.127-.32-.034-.54-.188-.805-.142-.396.11-.49.365-.68.266-.197.247-.72.257-1.02h.002l-.03-.154a2.623 2.623 0 0 0-.092-.32c-.01-.023-.016-.05.03-.066.05-.017.058.007.068.033.04.116.07.225.094.332.01.043.017.085.026.126.254-.13.52-.282.62-.564.087-.314-.084-.61-.236-.876a9.567 9.567 0 0 1-.595.256c-.023.01-.047.02-.066-.028-.02-.048.004-.06.028-.067a10.22 10.22 0 0 0 .687-.303 1.29 1.29 0 0 0 .313-.263c.182-.264-.308-.5-.48-.608 0-.007.003-.014.003-.02l-.736-.68c-.02-.016-.038-.035-.002-.073.036-.04.054-.022.073-.003l.683.626c.038-.387.043-.756-.078-1.14-.038-.124-.083-.244-.126-.365a1.116 1.116 0 0 1-.48-.398 1.037 1.037 0 0 1-.157-.496c-.003-.026-.003-.052.05-.057.052-.002.052.024.056.05.012.16.052.313.14.446.088.135.22.253.413.35.206.107.64.053.89-.068.35-.197-.106-.595-.213-.83-.076-.168-.094-.34-.128-.52.03-.006.062-.013.095-.018a1.044 1.044 0 0 0-.14-.147.602.602 0 0 0-.187-.113c-.024-.01-.05-.017-.03-.067.016-.05.042-.04.066-.03a.71.71 0 0 1 .22.132c.065.057.127.126.186.206a.875.875 0 0 0 .102-.02c.344-.067.533-.26.742-.506a3.597 3.597 0 0 0-.374-.386 10.09 10.09 0 0 0-.427-.36c-.02-.017-.04-.034-.008-.074.033-.04.052-.024.073-.007.147.12.294.24.432.365.14.128.272.263.393.41.012.014.024.028.014.047.315.03.368-.035.526-.317a1.53 1.53 0 0 0-.19-.41 2.5 2.5 0 0 0-.314-.386c-.02-.02-.036-.038 0-.074.038-.036.056-.017.073 0 .122.128.236.263.326.403.09.137.16.28.202.434.147.002.305.01.43-.067.276-.163.044-.75-.028-.98.005 0 .008-.003.012-.008a2.762 2.762 0 0 0-.11-.07c-.063-.04-.13-.08-.193-.122-.022-.014-.044-.028-.018-.07.03-.046.05-.032.07-.018l.196.124.142.09c.02-.017.043-.034.064-.05.2-.16.273-.375.334-.597.095-.343.114-.19.512-.25.43-.067.66-.114.915-.616.133-.067.2-.124.225-.287.043-.296.02-.448-.32-.474-.474-.038-.763.057-1.083.37l.128.194c.014.02.028.043-.014.073s-.056.007-.07-.014l-.12-.185c-.433-.04-.78.027-1.18.18l-.122-.05c.085.113.15.222.2.33.07.15.105.295.11.432 0 .026.003.053-.05.055-.052.002-.052-.024-.054-.05a1.036 1.036 0 0 0-.1-.396 1.842 1.842 0 0 0-.298-.442l-.003-.002a2.62 2.62 0 0 0-.96-.176c.053.053.107.105.16.154.068.067.137.133.203.2.02.018.038.035 0 .073-.035.038-.054.02-.073 0a7.742 7.742 0 0 1-.204-.2 6.458 6.458 0 0 1-.205-.198l-.02-.022a2.72 2.72 0 0 0-.85.22c-.192.08-.388.142-.58.178.142.137.263.29.357.467.1.18.176.38.226.6.004.025.01.05-.038.06-.05.013-.057-.013-.062-.037a2.147 2.147 0 0 0-.216-.574 1.89 1.89 0 0 0-.353-.455c-.015-.012-.027-.026-.022-.045a1.78 1.78 0 0 1-.526.003l.21.348c.013.024.022.047-.023.07-.048.02-.06 0-.07-.025l-.194-.408a1.446 1.446 0 0 1-.474-.187c.05.187.088.39.116.602.038.282.062.583.07.9 0 .027 0 .053-.05.053-.053 0-.053-.026-.053-.05a7.85 7.85 0 0 0-.066-.89 4.7 4.7 0 0 0-.15-.71 1.662 1.662 0 0 1-.214-.2 2.1 2.1 0 0 0-.57-.442.95.95 0 0 1-.21.728c-.014.02-.028.04-.07.01-.04-.034-.027-.053-.01-.074a.846.846 0 0 0 .175-.72 3.13 3.13 0 0 0-1.05-.254 5.312 5.312 0 0 1 .55.872c.145.122.224.27.27.43.04.16.05.33.058.502 0 .025.002.05-.05.054-.052.002-.052-.024-.054-.05a2.087 2.087 0 0 0-.055-.48.714.714 0 0 0-.243-.38.09.09 0 0 1-.014-.017 5.64 5.64 0 0 0-.268-.476 4.61 4.61 0 0 0-.33-.454l-.004-.005c-.124-.006-.25-.01-.376-.006.022.028.043.057.062.087a.577.577 0 0 1 .085.248c.004.026.006.052-.046.057-.052.005-.055-.02-.057-.048a.498.498 0 0 0-.07-.203.675.675 0 0 0-.112-.138c-.26.007-.52.03-.768.05.26.334.47.68.63 1.036.18.395.3.803.37 1.225.005.026.01.052-.043.06-.05.01-.054-.017-.06-.044a4.793 4.793 0 0 0-.362-1.2 5.12 5.12 0 0 0-.66-1.068l-.04.003c-.2.02-.404.06-.598.116.087.054.163.11.23.163.09.074.16.147.222.22.017.022.033.04-.007.074-.04.034-.058.016-.074-.006a1.573 1.573 0 0 0-.21-.208 2.403 2.403 0 0 0-.298-.204 4.91 4.91 0 0 0-.308.11c-.057.023-.11.044-.168.06.175.126.344.264.505.418.194.187.377.398.54.642.014.02.03.043-.014.07-.043.03-.057.008-.073-.013a3.796 3.796 0 0 0-.524-.627 4.668 4.668 0 0 0-.564-.457c-.214.047-.43.06-.645.052.133.263.25.528.337.796.094.29.16.58.182.877.003.027.005.053-.047.058-.053.005-.056-.02-.058-.048-.02-.29-.085-.57-.178-.853a6.224 6.224 0 0 0-.358-.834 7.972 7.972 0 0 1-.396-.043c.076.242.143.49.2.745.066.298.12.604.16.914.003.025.005.052-.044.06-.052.006-.055-.02-.06-.046a9.248 9.248 0 0 0-.158-.906 9.28 9.28 0 0 0-.22-.81c-.375-.406-.79-.8-1.297-1.012a1.704 1.704 0 0 1 .374 1.123c0 .026 0 .052-.05.05-.053 0-.053-.03-.05-.053a1.633 1.633 0 0 0-.12-.67 1.676 1.676 0 0 0-.352-.525 1.953 1.953 0 0 0-.358-.07 15.624 15.624 0 0 0-1-.067c.256.232.457.445.438.704-.002.025-.005.05-.057.046-.052-.005-.05-.03-.047-.057.016-.24-.22-.456-.498-.702-.2-.007-.4-.01-.6-.012.11.11.204.223.28.334.105.152.178.303.214.455v.007c.02.235.078.44.182.612.102.168.25.298.45.39.024.013.048.022.026.07-.02.047-.045.037-.068.025-.22-.1-.382-.247-.496-.432a1.51 1.51 0 0 1-.196-.65 1.255 1.255 0 0 0-.197-.416 2.675 2.675 0 0 0-.344-.396c-.22 0-.442-.003-.665-.003.093.264.157.534.202.81.052.335.076.68.083 1.027 0 .026 0 .052-.052.052-.053 0-.053-.026-.053-.05a7.143 7.143 0 0 0-.08-1.014 4.475 4.475 0 0 0-.21-.825h-.06a1.003 1.003 0 0 0-.49-.438.604.604 0 0 1-.107.282c-.012.02-.03.043-.072.014-.042-.027-.028-.048-.014-.07a.495.495 0 0 0 .09-.27c-.033-.014-.07-.028-.106-.045-.107-.446-.207-.63-.562-.782-.003.123-.01.25-.033.38-.028.163-.08.326-.177.483-.014.02-.03.045-.07.016-.046-.028-.032-.05-.018-.07.09-.146.138-.295.164-.444.022-.135.03-.273.03-.405l-.062-.022c-.095-.622-.21-.97-.856-1.217.007.08.01.164.005.247-.007.14-.033.282-.09.43-.01.022-.02.048-.066.03-.047-.02-.037-.043-.03-.067.052-.135.076-.268.083-.398a1.9 1.9 0 0 0-.02-.368c-.137-.156-.333-.305-.502-.47a2.28 2.28 0 0 1-.09.686 3.06 3.06 0 0 1-.385.834c-.014.022-.028.045-.07.017-.046-.028-.032-.05-.018-.07a3 3 0 0 0 .375-.807 2.2 2.2 0 0 0 .08-.773 1.04 1.04 0 0 1-.177-.26l-.015.033-.075.17c-.012.024-.022.048-.07.03-.047-.022-.037-.046-.028-.07l.076-.17.06-.138c-.005-.03-.01-.058-.012-.09-.02-.198-.127-.352-.272-.482l-.002-.002a1.482 1.482 0 0 1-.25.476c-.018.02-.032.04-.075.01-.04-.034-.023-.053-.008-.074.07-.09.125-.18.168-.268.035-.076.06-.15.08-.23a.962.962 0 0 1-.15-.246.796.796 0 0 1-.1.17c-.05.067-.115.13-.195.197-.02.018-.04.034-.074-.006-.032-.04-.01-.057.01-.073.072-.06.13-.118.174-.177a.65.65 0 0 0 .097-.176c.034-.092.046-.033.015-.182.055-.294-.054-.47-.21-.713a.07.07 0 0 1 .01-.02.89.89 0 0 0-.316.084 2.76 2.76 0 0 0-.456.265c-.022.015-.043.03-.072-.013-.03-.043-.01-.057.015-.07a3.16 3.16 0 0 1 .47-.274.9.9 0 0 1 .4-.092.37.37 0 0 0 .01-.227c-.473.176-.847.26-1.148.278a1.64 1.64 0 0 1-.76-.116c-.023-.01-.047-.02-.026-.068.02-.048.045-.038.07-.03.186.082.412.13.71.11.296-.02.66-.1 1.13-.275-.002-.003-.002-.008-.004-.013.085-.19.154-.374.2-.56a1.705 1.705 0 0 1-.5.04h-.032c-.026 0-.052-.004-.052-.053 0-.053.028-.053.052-.053h.033c.177.004.352.01.525-.048.012-.062.02-.124.03-.185.027-.206.27-.256.44-.07.142.15.272.312.412.378.284.135.604.014.834-.17l-.21-.07c-.026-.007-.05-.016-.033-.063.016-.05.04-.043.064-.034.09.03.18.057.27.088a.947.947 0 0 0 .063-.064c.587.05.97-.073 1.346-.453a6.927 6.927 0 0 1-.892-.03c-.285-.035-.52-.092-.692-.177-.024-.012-.048-.024-.024-.07.024-.046.047-.034.07-.022.16.08.385.136.658.167.277.03.604.04.976.028h.005c.034-.038.067-.078.103-.12.16-.067.322-.14.44-.273-.685-.074-1.336-.21-1.95-.53-.16-.177-.41-.276-.678-.345-.498-.06-.938.062-1.344.273-.105-.1-.188-.19-.293-.287-.156-.02-.303-.102-.46-.12-.208-.025-.426.016-.635-.008-.026-.002-.052-.005-.045-.057.005-.052.03-.05.057-.045.21.024.427-.017.635.007.2.024.393.112.594.135.673-.253 1.23-.393 1.71-.372a5.68 5.68 0 0 1 1.73-.218.102.102 0 0 1-.022-.02c-.07-.068-.036-.103 0-.136.315-.32.39-.615.287-.88-.106-.276-.39-.534-.786-.77-.422.047-.827-.067-1.275-.017a3.95 3.95 0 0 0-.826.182c.226.08.422.213.583.403.2.235.342.555.418.957.01.048.016.098-.08.114-.094.018-.103-.032-.112-.08-.07-.366-.197-.656-.375-.866-.187-.268-.616-.373-.75-.427-.45.045-.89.095-1.274.194-.29.075-.543.177-.737.328.29-.06.59-.05.85.08.25.124.46.356.593.733.017.046.03.094-.06.125-.094.03-.11-.015-.125-.062-.11-.325-.286-.52-.492-.62-.41-.205-1.257-.027-1.614.238a4.23 4.23 0 0 0-.625.594c-.038.045-.078.088-.166.012-.088-.08-.05-.12-.01-.164.216-.244.434-.46.66-.626.217-.16.442-.277.674-.33.237-.264.588-.423.993-.527.396-.103.85-.156 1.308-.2-.135-.273-.308-.437-.507-.524-.213-.095-.457-.11-.723-.083-.552.19-1.042.486-1.514.82.044 0 .086 0 .127.002.14.01.265-.012.38.033.046.017.094.033.06.126-.04.11-.346.043-.452.035a1.352 1.352 0 0 0-.4.037c-.022.005-.046.012-.067.005-.576.356-.988.716-1.467 1.12l-.08.03c-.426-.017-.72.042-.896.175-.158.12-.17.31-.14.566-.073.24-.165.503-.19.782-.5.43-1.056.858-1.314 1.484a1.42 1.42 0 0 1-.275.487.538.538 0 0 1 .25.097c.022.02.044.038.063.062.01-.107.028-.213.054-.315.036-.146.088-.28.156-.39.015-.02.03-.043.072-.014.045.028.03.05.016.07a1.2 1.2 0 0 0-.144.36c-.04.164-.062.345-.067.51-.002.053-.097.057-.104.005a.287.287 0 0 0-.11-.2.52.52 0 0 0-.27-.086c-.107.117-.228.22-.35.318-.1.08-.193.168-.215.3-.014.226.266.266.53.283.606.036.124.38.456.68.162.112.312.242.425.4.23.084.373.065.53-.006.03-.41-.006-.62.174-.62h.018a.768.768 0 0 1 .18-.386c.017-.02.034-.04.074-.007.04.033.024.052.007.073a.807.807 0 0 0-.122.204.75.75 0 0 0-.043.17c.03.062.024.183.022.4.343-.17.656-.212 1.007-.23.657-.767.936-.572.36-.013l-.092.176a1.4 1.4 0 0 0-.185.602c-.168.147-.993.825-.685 1.076.216-.03.35-.02.268.14-.102.216-.41.664-.308.91.038.09.17.08.3.05.01-.01.02-.017.03-.026a6.2 6.2 0 0 0 .656-.61 3.8 3.8 0 0 0 .566-.795c.02-.043.043-.083.104-.07a9.07 9.07 0 0 1 .226-.708c.087-.244.187-.49.293-.737.017-.035.067-.042.09-.01.09.13.178.226.266.287a.393.393 0 0 0 .232.083.42.42 0 0 0 .232-.078c.086-.06.17-.15.26-.272.013-.022.03-.043.072-.012.042.03.028.05.01.073a1.18 1.18 0 0 1-.283.296.49.49 0 0 1-.292.097.504.504 0 0 1-.29-.105 1.134 1.134 0 0 1-.238-.24c-.093.217-.178.432-.256.648-.087.24-.163.48-.23.72.055.046.032.088.01.13-.17.32-.38.598-.602.842-.18.2-.372.375-.56.533.027.177.072.343.153.513.36-.308.693-.62.987-.943.294-.325.55-.66.75-1.007.015-.02.027-.045.072-.02.044.027.03.05.018.072a5.98 5.98 0 0 1-.35.53c.023.034.004.048-.015.065-.038.03-.06.154-.07.313-.013.215 0 .483.025.675.002.026.007.052-.045.06-.052.007-.055-.02-.06-.046-.025-.2-.037-.476-.025-.694.002-.057.01-.11.016-.156-.078.092-.16.184-.242.277a11.547 11.547 0 0 1-1.014.966c.01.02.02.038.033.057-.316.23-.575.31-.22.618.12-.084.238-.17.356-.255l.38-.272c.02-.014.042-.03.073.012.03.042.01.056-.013.073l-.38.273-.37.264a.623.623 0 0 0 .09.362.528.528 0 0 1 .08-.007l.796-.58c.02-.016.043-.03.073.013.03.042.01.057-.012.073-.255.187-.514.375-.772.562a.714.714 0 0 1-.093.118c-.26.188-1.17.75-1.074 1.138v.002c.218-.06.436-.137.644-.244.216-.11.427-.26.626-.464.02-.02.036-.036.074 0 .035.035.02.054 0 .073a2.544 2.544 0 0 1-.65.482v.01l-.004.106c-.003.036-.003.072-.005.107-.002.026-.002.052-.054.05-.052-.002-.05-.03-.05-.055.003-.035.003-.07.005-.106.004-.02.004-.04.004-.06a3.62 3.62 0 0 1-.562.202c.078.367-.114.683-.31.998-.112.09-1.022.827-.643 1.047a.98.98 0 0 0 .33.087z\"></path><path d=\"M349.455 100.128c-.19-.114-.434-.254-.67-.3a1.44 1.44 0 0 0-.505-.563c-.176-.114-.176-.104-.11-.23.2-.02.283-.076.285-.13a.897.897 0 0 1 .27.043.4.4 0 0 1 .202.14c.016.02.03.042.073.01s.026-.053.01-.075a.542.542 0 0 0-.252-.175 1.023 1.023 0 0 0-.37-.047c-.01 0-.02 0-.03.005a.743.743 0 0 0-.332-.054c-.135-.127-.25-.276-.194-.46.007.006.02.008.03.01.107.03.207.062.292.102.083.036.152.08.2.133.016.02.035.038.073.002.038-.035.02-.054.004-.073a.744.744 0 0 0-.23-.16 2.052 2.052 0 0 0-.226-.082c.782-.16 1.48-.147 2.18.268.368.152.54.327.74.597l-.2.17c-.457-.013-.793.05-1.004.212-.19.14-.228.397-.235.653z\"></path></g><path d=\"M365.002 121.77c-.154.095-.28.162-.438.188a.072.072 0 0 0 .02-.02c.1-.19.22-.36.352-.51.017-.02.036-.04.052-.06l.007.19.007.215zm1.96 4.196a2.3 2.3 0 0 1-.376.428 3.99 3.99 0 0 1-.477.363c-.022.014-.046.03-.074-.014-.03-.043-.007-.057.014-.07.166-.11.322-.23.464-.354.14-.127.264-.262.36-.41.015-.023.03-.044.074-.016.043.03.03.05.014.072zm1.298-1.546c-.068.1-.132.2-.198.3-.014.023-.028.044-.073.015-.044-.028-.03-.05-.016-.07.067-.1.13-.202.197-.302.015-.02.03-.042.075-.014.042.028.028.05.014.073zm-.707-.1a1.11 1.11 0 0 1-.183.423c-.095.13-.235.246-.436.338-.024.013-.047.023-.07-.025-.02-.047.004-.06.027-.068a.987.987 0 0 0 .397-.306.972.972 0 0 0 .166-.383c.005-.026.012-.05.062-.038.05.01.045.035.038.06zm1.27-1.55a.934.934 0 0 0-.138.178 1.15 1.15 0 0 0-.1.22c-.01.022-.016.048-.066.032-.05-.017-.043-.043-.034-.067a1.136 1.136 0 0 1 .26-.433c.02-.02.037-.036.074 0 .036.035.02.054 0 .073zm1.037.103c-.044.147-.087.296-.14.443-.056.152-.122.3-.207.45-.015.02-.027.045-.072.02-.044-.027-.032-.05-.018-.072.083-.145.145-.29.2-.43.052-.146.094-.293.14-.44.006-.026.014-.05.063-.035.05.013.043.037.036.063zm-.47-6.075c.322.474.393.963.405 1.453a7.29 7.29 0 0 1 .125-.534c0-.003.007-.017.007-.017.135-.19.22-.38.263-.567.043-.188.043-.377.01-.565-.005-.026-.01-.05.042-.06.05-.008.057.018.062.044.036.2.036.405-.01.607a1.68 1.68 0 0 1-.272.596c-.088.33-.152.66-.213.993l-.013.06c-.01.05-.104.043-.104-.01 0-.037 0-.072.002-.11.007-.62.014-1.24-.386-1.828-.016-.02-.032-.042.013-.073.043-.03.06-.008.073.013zm-.79 1.017l-.012.12c-.002.04-.007.08-.01.12-.002.026-.004.052-.056.047-.052-.005-.05-.03-.048-.057.003-.04.008-.08.01-.12.002-.04.007-.08.012-.12.002-.025.005-.052.057-.047.052.005.05.03.047.057zm-.22 1.379c.08.263.142.53.187.806.03.187.05.377.06.57a.983.983 0 0 1 .07-.1c.086-.107.2-.2.334-.278.023-.014.046-.026.073.02.026.044.004.058-.02.07a1.048 1.048 0 0 0-.303.254.704.704 0 0 0-.147.322c-.01.052-.104.043-.104-.01a5.054 5.054 0 0 0-.065-.83 5.904 5.904 0 0 0-.183-.793c-.007-.026-.016-.05.034-.064.05-.013.057.01.064.034zm1.1.493a3.564 3.564 0 0 1 .064 1.19c-.003.027-.008.053-.06.046-.052-.007-.047-.033-.045-.06.02-.177.027-.362.018-.556a3.603 3.603 0 0 0-.08-.597c-.005-.027-.012-.05.04-.063.05-.012.057.014.06.04zm.943-.175c.035.194.054.384.045.566a1.47 1.47 0 0 1-.12.53 1.19 1.19 0 0 0-.037.584c.034.2.11.398.2.6.012.024.022.047-.026.07-.047.02-.06-.004-.07-.027a2.54 2.54 0 0 1-.207-.624 1.298 1.298 0 0 1 .04-.636l.003-.005a1.36 1.36 0 0 0 .11-.496 2.25 2.25 0 0 0-.044-.543c-.005-.025-.01-.05.043-.058.05-.01.055.016.06.042zm.455-1.564c-.024.097-.048.197-.074.296-.024.097-.047.197-.073.296-.004.026-.01.05-.06.038-.05-.012-.046-.038-.04-.064l.075-.296c.023-.097.047-.197.073-.296.007-.026.012-.05.064-.038.05.012.045.038.038.064zm-.468-2.598c.03.09.055.18.084.27.007.027.014.05-.036.064-.05.017-.057-.01-.064-.033-.028-.09-.054-.18-.083-.27-.008-.025-.015-.05.034-.063.05-.014.057.01.064.033zm.24-1.974c.002.123.002.247-.007.775a.773.773 0 0 0-.235.383 1.38 1.38 0 0 0-.007.585c.006.026.01.052-.04.062-.054.01-.058-.017-.063-.043a1.423 1.423 0 0 1 .01-.63.862.862 0 0 1 .265-.432l-.02-.33c-.004-.122-.004-.246-.006-.367 0-.026 0-.052.052-.052s.052.026.052.052zm-1.96-.686c.303.198.564.418.744.68.183.262.287.563.275.92a.053.053 0 0 1-.074.044c-.17-.074-.344-.147-.515-.22.115.736.087 1.324-.074 1.774-.17.477-.486.8-.937.986a.052.052 0 0 1-.07-.064c.088-.28.14-.56.162-.84.02-.278.01-.558-.038-.835-.005-.026-.01-.053.043-.06.052-.01.057.017.06.043.046.287.06.576.037.863-.02.252-.062.5-.133.754a1.5 1.5 0 0 0 .776-.88c.16-.452.185-1.054.057-1.817-.007-.04.036-.073.07-.057l.53.228c-.005-.3-.1-.555-.256-.78-.173-.25-.422-.46-.716-.652-.02-.014-.042-.028-.013-.073.028-.043.05-.028.07-.014zm5.13-1.01l-.04.1c-.016.034-.028.07-.042.103-.01.024-.02.047-.066.028-.048-.018-.038-.04-.03-.065.016-.033.03-.07.044-.102.014-.033.026-.07.04-.102.01-.022.02-.046.067-.027.047.02.038.042.028.066zm-1.205-.027c.1.04.18.095.246.16a.83.83 0 0 1 .16.224c.012.024.024.047-.02.07-.05.022-.06 0-.07-.023a.78.78 0 0 0-.14-.196.592.592 0 0 0-.213-.138c-.024-.01-.047-.02-.03-.066.02-.048.044-.038.068-.03zm-1.792.514c.13.145.216.313.26.505.046.187.053.396.03.62-.003.025-.005.05-.058.046-.052-.005-.05-.03-.045-.057.022-.212.017-.41-.026-.584a1.034 1.034 0 0 0-.237-.458c-.016-.018-.035-.037.005-.073.038-.036.057-.014.073.005zm-6.055.583l-.022.204-.02.204c0 .026-.003.052-.055.047-.052-.004-.05-.03-.044-.056l.02-.205.02-.204c.002-.025.005-.05.057-.046.052.004.05.03.047.056zm1.122-.592c.03.097.058.194.09.29l.025.09c.007.025.014.05-.036.063-.05.015-.058-.008-.065-.034l-.026-.088-.088-.292c-.007-.023-.015-.05.035-.064.05-.014.057.01.064.036zm2.305 1.547c.012.043.02.086.02.126a1.11 1.11 0 0 1 0 .127c0 .026-.004.052-.056.047-.053-.005-.05-.03-.048-.057a.837.837 0 0 0 0-.11.552.552 0 0 0-.02-.108c-.006-.027-.013-.05.036-.065.05-.014.057.012.064.038zm.795-1.753c.05.05.082.104.094.156a.234.234 0 0 1-.024.168c-.012.024-.026.048-.07.022-.046-.024-.034-.048-.023-.07a.14.14 0 0 0 .015-.1.25.25 0 0 0-.067-.108c-.02-.02-.035-.035 0-.073.036-.036.055-.02.074 0zm-5.5.278a.934.934 0 0 0 .254.663c.12.137.182.272.216.41.033.135.035.267.042.398 0 .027.003.053-.05.055-.052.003-.052-.023-.054-.05-.005-.127-.01-.255-.038-.38a.86.86 0 0 0-.192-.366 1.054 1.054 0 0 1-.216-.347 1.126 1.126 0 0 1-.066-.39c0-.025 0-.05.052-.05s.052.025.052.05zm2.226 1.497c.123.23.192.455.218.682.028.225.014.454-.026.694-.045.277.014.547.166.8.14.238.36.463.644.672a2.86 2.86 0 0 1-.128-.9c.015-.34.12-.67.358-.98.102-.133.17-.27.218-.41.05-.14.076-.282.095-.42.003-.025.008-.05.058-.044.052.004.047.03.045.057-.02.145-.047.292-.097.44a1.52 1.52 0 0 1-.235.438 1.587 1.587 0 0 0-.335.922c-.015.324.056.66.165 1.007.015.045-.04.083-.078.06-.358-.243-.63-.508-.798-.79a1.256 1.256 0 0 1-.178-.87c.038-.23.05-.45.024-.666a1.81 1.81 0 0 0-.207-.643c-.012-.022-.026-.045.022-.07.045-.025.06-.002.07.022zm-.894 1.367c0 .247-.068.493-.192.74a3.387 3.387 0 0 1-.377.578c.08-.03.16-.062.237-.1a2.212 2.212 0 0 0 .7-.497c.097-.1.194-.216.294-.353.014-.022.03-.043.073-.012.043.03.026.052.012.073a3.59 3.59 0 0 1-.305.365 2.48 2.48 0 0 1-.27.242 24.48 24.48 0 0 1 .07.34c.004.027.01.05-.04.063-.05.012-.058-.014-.063-.04l-.038-.183a1.542 1.542 0 0 0-.024-.114 2.21 2.21 0 0 1-.37.21c-.14.068-.28.117-.42.17-.046.016-.09-.045-.058-.083.2-.237.367-.472.484-.707.116-.232.182-.462.182-.692 0-.026 0-.052.052-.052s.052.026.052.052zm-1.088-.087v.234c0 .027 0 .053-.052.053s-.052-.026-.052-.052v-.233c0-.026 0-.053.052-.053s.052.027.052.053z\"></path><path d=\"M363.052 113.675c.142.348.18.673.126.976a1.85 1.85 0 0 1-.413.852l-.007.007a1.89 1.89 0 0 0-.474.63c-.078.16-.137.334-.182.516.056-.078.113-.152.182-.22.135-.138.296-.244.51-.304.218-.12.424-.253.616-.403.194-.152.374-.318.54-.505.017-.02.036-.038.074-.005s.02.052.004.073c-.17.192-.355.363-.554.517-.2.154-.41.292-.635.415l-.013.005a1.026 1.026 0 0 0-.47.277 2.287 2.287 0 0 0-.322.443c-.026.043-.104.014-.095-.036.053-.293.13-.57.25-.822.118-.25.28-.474.497-.66.204-.252.34-.518.39-.802.048-.285.013-.59-.122-.92-.01-.023-.02-.047.028-.07.048-.017.06.006.07.03zm2.211 3.545c-.033.095.036.183.175.363l.095.123c.188.25.256.53.26.827.006.29-.05.59-.106.882-.01.05-.094.047-.102-.003a1.79 1.79 0 0 0-.386-.86 3.432 3.432 0 0 0-.79-.692c-.02-.014-.043-.028-.014-.073.028-.043.05-.03.07-.015.323.216.603.45.814.716.16.202.282.42.353.66a3.4 3.4 0 0 0 .06-.612 1.28 1.28 0 0 0-.24-.766c-.036-.05-.067-.088-.093-.12-.163-.212-.24-.314-.192-.46.01-.024.017-.05.067-.034.05.017.04.043.033.067zm.943-.06c.038.04.08.08.116.122.038.04.08.08.117.123.018.02.034.038-.004.074-.038.034-.057.015-.073-.004-.038-.04-.078-.08-.116-.123-.038-.04-.08-.08-.116-.123-.016-.02-.035-.038.003-.074.038-.035.057-.016.073.003zm1.157.37c-.074.233-.145.463-.216.695-.073.232-.144.462-.218.694-.008.026-.015.05-.065.033-.05-.015-.042-.04-.033-.064.074-.234.145-.463.216-.696.073-.232.144-.462.218-.694.007-.026.014-.05.064-.036.05.017.042.04.033.067zm.654 3.88a.242.242 0 0 0 0 .173c.01.024.02.05-.03.067-.048.02-.058-.005-.067-.03a.347.347 0 0 1 0-.25c.01-.026.02-.05.066-.03.05.018.04.042.03.066zm-.687-1.14c-.03.12-.064.245-.095.365-.03.124-.062.244-.095.368-.007.026-.014.05-.064.038-.05-.014-.045-.037-.038-.063.03-.124.064-.244.095-.368.03-.122.064-.245.095-.366.007-.026.012-.05.064-.038.05.012.045.038.038.064zm-.99-.004l.09.09c.018.02.035.035 0 .073-.04.035-.058.018-.074 0l-.09-.09c-.02-.02-.036-.036 0-.074.038-.036.056-.02.073 0zm-1.165-.556a7.324 7.324 0 0 1-.073.205c-.024.07-.047.137-.074.206-.01.025-.016.05-.066.032-.047-.017-.04-.043-.03-.066a5.08 5.08 0 0 1 .073-.207 5.08 5.08 0 0 1 .073-.207c.01-.026.017-.05.067-.033s.04.043.033.066zm-1.665 1.76a.693.693 0 0 0-.138.222 1.29 1.29 0 0 0-.062.252c-.005.026-.01.052-.06.042-.05-.01-.046-.033-.042-.06.017-.09.036-.18.07-.27a.77.77 0 0 1 .155-.255c.017-.018.036-.037.074 0 .038.034.02.053.002.072zm-4.77 4.67a.663.663 0 0 1-.1.16 1.098 1.098 0 0 1-.16.154c-.02.016-.04.033-.073-.01-.033-.04-.012-.057.007-.073a.817.817 0 0 0 .23-.272c.012-.023.02-.047.068-.028.048.02.036.045.026.07zm.747-.395a.352.352 0 0 1-.1.135.612.612 0 0 1-.163.093c-.026.01-.05.02-.066-.03-.02-.05.007-.06.03-.068a.427.427 0 0 0 .13-.073.285.285 0 0 0 .075-.097c.01-.024.02-.048.068-.026.05.02.037.044.027.067zm.991-.605a.48.48 0 0 1-.062.086.524.524 0 0 1-.106.085c-.022.016-.045.03-.07-.015-.027-.045-.006-.06.018-.07a.38.38 0 0 0 .135-.134c.014-.02.026-.044.07-.016.046.026.032.048.02.07zm1.492-3.877c-.05.14-.082.278-.094.415a1.4 1.4 0 0 0 .024.41c.005.026.012.05-.038.062-.05.012-.057-.014-.06-.04a1.397 1.397 0 0 1-.028-.444c.015-.147.048-.294.098-.438.01-.026.016-.05.066-.033.05.016.04.042.033.066zm1.013-10.316a.872.872 0 0 1-.09.343 1.4 1.4 0 0 1-.235.337c-.016.02-.035.038-.073.002-.038-.036-.02-.055-.002-.074.094-.104.168-.21.218-.31a.768.768 0 0 0 .08-.304c0-.026 0-.052.053-.05.053.003.05.03.05.055zm-1.036-.915c.09.156.145.315.176.474.03.156.038.315.028.472 0 .026 0 .052-.053.05-.052-.003-.05-.03-.05-.055a1.76 1.76 0 0 0-.026-.446 1.463 1.463 0 0 0-.163-.443c-.01-.02-.026-.045.02-.07.044-.027.06-.003.07.018zm-1.372 1.702a1.51 1.51 0 0 1-.405-.417.653.653 0 0 1-.095-.437c.005-.026.01-.05.06-.042.052.01.047.033.042.06-.02.122.01.243.08.366.077.128.202.256.377.387.022.015.043.032.012.074-.03.043-.052.026-.073.012zm1.519 2.581v.225c0 .026 0 .052-.052.052s-.052-.026-.052-.052v-.225c0-.026 0-.053.052-.053s.052.027.052.053zm-1.941-1.955c.306.288.49.637.586 1.023.06.24.086.493.09.76.004 0 .008-.004.013-.004.138-.048.244-.17.318-.368.08-.21.12-.498.126-.865a.11.11 0 0 1 .007-.026 1.9 1.9 0 0 0 .22-.535 3.49 3.49 0 0 0 .084-.543c.004-.045.066-.064.095-.026.177.252.334.512.455.792.12.28.2.576.232.898 0 .026.004.052-.05.057-.05.005-.053-.02-.055-.047a2.905 2.905 0 0 0-.223-.865 3.868 3.868 0 0 0-.363-.656 2.897 2.897 0 0 1-.072.417 1.94 1.94 0 0 1-.225.553c-.007.375-.05.67-.13.887-.086.23-.214.372-.382.43-.016.003-.03.008-.044 0-.002.13-.01.26-.02.392 0 .026-.004.052-.056.048-.052-.005-.05-.03-.047-.057.035-.432.026-.842-.07-1.21a1.977 1.977 0 0 0-.556-.975c-.02-.017-.038-.036-.002-.074.035-.038.054-.02.073-.002zm1.137 4.865c-.02.137-.042.272-.063.41-.02.135-.043.272-.064.408-.002.026-.007.052-.06.042-.05-.007-.047-.033-.042-.06l.065-.407c.02-.137.043-.272.064-.41.004-.026.006-.05.058-.042.05.01.048.033.043.06zm-2.184.927l.057.31c.004.026.01.05-.043.06-.05.01-.057-.017-.062-.043l-.056-.312c-.005-.026-.01-.05.042-.06.05-.01.057.018.06.044zm1.889-2.508a2.27 2.27 0 0 1-.16.597c-.082.193-.196.38-.345.558l-.002.003a1.127 1.127 0 0 0-.306.636 1.8 1.8 0 0 0 .064.685c.007.027.012.05-.038.065-.05.012-.057-.012-.064-.038a1.89 1.89 0 0 1-.066-.723c.03-.24.13-.472.33-.692a2.1 2.1 0 0 0 .33-.53 2.1 2.1 0 0 0 .152-.57c.003-.026.008-.052.057-.045.052.007.048.033.045.06zm-.493-.734c.035.2.005.395-.078.594a2.22 2.22 0 0 1-.387.58l-.004.003a1.83 1.83 0 0 0-.403.48c-.1.172-.173.35-.247.53-.01.024-.02.047-.07.028-.046-.02-.037-.042-.027-.066.073-.183.15-.366.254-.544.104-.177.237-.348.42-.505.163-.18.288-.363.366-.546a.915.915 0 0 0 .07-.533c-.003-.025-.008-.05.044-.06.05-.01.057.016.062.042zm-2.412 1.144c.058.398-.003.74-.153 1.038-.147.3-.38.555-.668.785-.02.016-.04.033-.074-.01-.034-.04-.012-.057.01-.073.274-.22.5-.467.64-.75.14-.28.198-.6.144-.978-.003-.026-.008-.052.045-.06.052-.006.054.02.06.046zm-3.077 1.704c.03.062.06.123.088.185.034.066.065.13.095.197.012.023.022.047-.023.068-.048.022-.06 0-.07-.023-.03-.067-.063-.13-.094-.197-.028-.062-.06-.123-.088-.182-.01-.024-.02-.048.024-.07.048-.02.06 0 .07.025zm-1.221.024a2.69 2.69 0 0 0 .074.69c.06.222.154.438.31.644l.005.01c.08.158.124.317.155.478.02.12.036.237.043.356.15-.16.263-.32.346-.488a1.44 1.44 0 0 0 .15-.605c0-.026 0-.052.05-.05.053 0 .053.027.05.053a1.549 1.549 0 0 1-.158.647c-.102.208-.25.407-.448.6-.03.03-.085.01-.087-.036a3.252 3.252 0 0 0-.047-.457 1.762 1.762 0 0 0-.142-.448 1.94 1.94 0 0 1-.324-.677 2.703 2.703 0 0 1-.078-.718c0-.027 0-.053.052-.053s.052.026.052.053zm.166 4.168a2.63 2.63 0 0 1 .18-.766c.01-.022.02-.046.067-.027.05.02.038.042.03.066a2.524 2.524 0 0 0-.173.732c-.002.027-.002.053-.056.048-.053-.003-.05-.03-.048-.055zm-.142 1.162c.02-.154.043-.308.064-.462.002-.026.007-.052.06-.045.05.007.047.033.044.06-.02.153-.042.307-.064.46-.002.027-.007.053-.06.046-.05-.006-.046-.032-.044-.058zm-.799 1.946c.076-.076.15-.166.218-.266.07-.102.138-.213.204-.33.01-.023.025-.044.07-.02.045.026.033.047.02.07a4.037 4.037 0 0 1-.21.34c-.073.104-.15.2-.232.28-.02.018-.038.035-.073 0-.036-.036-.017-.055 0-.074zm-1.154-6.53v.192c0 .026 0 .053-.052.053-.05 0-.05-.027-.05-.053v-.192c0-.026 0-.052.05-.052.053 0 .053.026.053.052zm-1.953 4.499a2.863 2.863 0 0 0-.01-.142l-.01-.145c0-.026 0-.052.05-.055.053-.002.056.022.056.05l.01.142c0 .048.004.095.01.143 0 .026 0 .052-.05.054-.053.002-.056-.02-.056-.05zm4.904-8.001c-.1.343-.178.7-.17 1.007.004.296.087.543.3.68.25.16.358.403.462.638.007.015.012.03.02.043.03-.116.056-.24.068-.362.017-.15.017-.298-.005-.43-.006-.027-.01-.053.042-.062.05-.01.057.016.06.042.023.142.023.3.006.46-.02.178-.06.358-.11.514-.015.043-.077.048-.096.007a5.946 5.946 0 0 1-.078-.17c-.097-.22-.2-.447-.424-.592-.247-.158-.344-.436-.35-.765-.006-.318.072-.685.174-1.038.007-.026.014-.05.064-.036.05.013.043.037.036.063zm-.344-1.311a2.52 2.52 0 0 1-.02.763 4.006 4.006 0 0 1-.233.76 2.41 2.41 0 0 0-.166 1c.017.34.105.676.26.996.013.024.025.048-.022.07-.048.023-.06 0-.07-.025a2.537 2.537 0 0 1-.1-2.078 3.8 3.8 0 0 0 .227-.743c.045-.238.054-.475.02-.73-.002-.027-.006-.053.046-.06.05-.007.055.02.06.045zm-2.277 3.242a.79.79 0 0 0-.06.47c.03.158.097.32.195.48.014.022.026.046-.017.072-.044.025-.058.003-.07-.02a1.504 1.504 0 0 1-.206-.517.876.876 0 0 1 .066-.53c.012-.022.02-.046.07-.025.046.022.034.045.025.07zm-.993-.355c.016.092.02.2.01.31a.858.858 0 0 1-.07.27v.003a.397.397 0 0 0-.038.263c.02.092.067.185.13.28.015.02.03.042-.014.073-.042.032-.056.01-.073-.013a.852.852 0 0 1-.147-.318.484.484 0 0 1 .047-.333.76.76 0 0 0 .062-.234c.01-.098.005-.197-.01-.282-.004-.025-.01-.052.043-.06.052-.008.057.018.06.044zm5.806-8.602a2.318 2.318 0 0 0 .313 1.468c.013.02.025.045-.02.07-.045.027-.057.003-.07-.018a2.59 2.59 0 0 1-.288-.723 2.33 2.33 0 0 1-.038-.806c.002-.025.005-.05.057-.044.053.005.05.03.046.057zm-.728.705c.136.24.252.497.34.78.087.282.146.592.168.936.002.027.002.053-.05.055-.052.003-.052-.024-.055-.05a3.77 3.77 0 0 0-.492-1.668c-.01-.024-.026-.045.02-.07.044-.027.06-.004.07.018zm-3.608.111c-.347.496-.5.898-.527 1.247-.03.346.064.635.2.903l.004.007c.094.275.137.547.13.822a2.58 2.58 0 0 1-.16.82c-.008.026-.015.05-.065.03-.05-.015-.04-.042-.03-.065.094-.263.146-.524.153-.787a2.25 2.25 0 0 0-.123-.782 1.7 1.7 0 0 1-.21-.954c.03-.365.186-.787.546-1.3.015-.02.03-.042.074-.013.042.03.028.052.012.073zm3.364-1.426c.03.15.017.305-.052.457-.06.14-.168.272-.327.398a.81.81 0 0 0-.3.486c-.044.202-.034.437.016.7.005.026.01.052-.042.062-.05.01-.057-.017-.062-.043-.05-.278-.06-.525-.01-.74a.913.913 0 0 1 .335-.546.986.986 0 0 0 .297-.357c.06-.13.07-.266.045-.394-.004-.026-.01-.05.04-.06.05-.01.058.015.062.04zm-3.562.305c.07.22.07.436.007.652-.062.213-.19.424-.385.63l-.004.005a1.21 1.21 0 0 0-.37.576 2.87 2.87 0 0 0-.115.737c-.003.026-.003.052-.055.05-.052-.003-.05-.03-.05-.055a3.04 3.04 0 0 1 .12-.763c.075-.237.198-.45.4-.62.182-.195.3-.392.36-.59a1.01 1.01 0 0 0-.007-.59c-.007-.027-.017-.05.033-.065.05-.014.057.01.064.036zm2.038.107a.763.763 0 0 0 0 .232c.012.074.04.145.088.213.014.022.03.043-.014.074-.043.03-.057.01-.074-.013a.628.628 0 0 1-.104-.254.816.816 0 0 1 0-.263c.002-.026.007-.052.06-.045.052.007.047.033.044.06zm-.097-.536a.853.853 0 0 0-.43.4c-.1.188-.16.43-.18.726.013.014.02.026.02.036.1.135.168.296.21.476.048.197.065.42.058.66 0 .027 0 .053-.054.05-.052 0-.05-.028-.05-.05a2.423 2.423 0 0 0-.054-.636c-.038-.16-.097-.3-.18-.42-.386.36-.576.758-.588 1.192-.014.453.164.946.505 1.472.013.02.028.045-.015.073-.043.03-.057.005-.07-.016-.354-.546-.537-1.058-.523-1.532.015-.467.218-.894.638-1.278v-.002c.016-.325.08-.59.192-.8a.955.955 0 0 1 .483-.447c.024-.008.048-.018.07.03.018.047-.006.06-.03.07zm-.578-.749c-.005.043-.01.076-.012.112-.026.245-.052.522-.24.69a.83.83 0 0 0-.217.318 1.61 1.61 0 0 0-.088.39c-.002.025-.005.05-.057.044-.05-.005-.046-.03-.044-.06a1.71 1.71 0 0 1 .095-.414.92.92 0 0 1 .245-.358c.156-.14.185-.398.206-.623a2.69 2.69 0 0 0 .013-.114c.002-.026.007-.052.06-.045.05.007.047.033.044.06zm5.662 6.041c.062.128.11.26.144.396.035.135.05.275.044.42 0 .026-.002.052-.054.05-.053-.003-.05-.03-.05-.055a1.433 1.433 0 0 0-.038-.392c-.03-.126-.08-.25-.14-.375-.012-.023-.02-.047.026-.068.048-.022.057 0 .07.023zm.016 1.858c.046.214.048.432.01.65-.038.218-.12.44-.237.666l-.24.562c-.01.023-.02.047-.068.028-.048-.02-.038-.045-.03-.07.082-.186.16-.376.24-.563l.003-.006a2.15 2.15 0 0 0 .23-.635 1.606 1.606 0 0 0-.008-.612c-.005-.026-.01-.052.04-.062.05-.012.057.014.06.04zm-1.18-1.73c.34.377.56.775.664 1.195.106.42.095.86-.033 1.32-.007.027-.015.05-.064.037-.05-.015-.043-.038-.036-.064.123-.444.135-.866.033-1.268-.102-.403-.315-.787-.642-1.152-.017-.02-.033-.038.005-.074s.057-.015.073.004zm-.103 2.086a5.328 5.328 0 0 1-.867 1.322 2.52 2.52 0 0 0-.54.94c-.014.046-.104.03-.1-.02a1.453 1.453 0 0 0-.05-.47 1.866 1.866 0 0 0-.21-.47c-.19-.278-.27-.56-.256-.84.017-.28.128-.557.327-.834.114-.194.195-.39.252-.585a2.39 2.39 0 0 0 .092-.588c0-.026.002-.052.055-.05.052.002.05.028.05.054a2.61 2.61 0 0 1-.36 1.224l-.003.005c-.188.262-.294.523-.308.78-.015.262.064.52.24.78v.003c.1.166.174.332.222.5.02.08.038.157.047.235a2.65 2.65 0 0 1 .47-.728 4.92 4.92 0 0 0 .496-.65c.14-.217.256-.433.355-.648.013-.024.023-.048.07-.026.047.02.036.045.026.068zm-3.094-.995c-.007.258.017.5.07.727.05.225.136.436.255.63.015.022.027.046-.016.072-.045.028-.057.004-.07-.017a2.254 2.254 0 0 1-.27-.66 2.994 2.994 0 0 1-.07-.753c0-.026.003-.053.052-.05.052.002.052.028.05.052zm-1.761.943v.302c0 .027 0 .053-.052.053s-.052-.026-.052-.052v-.303c0-.026 0-.052.053-.052.052 0 .052.026.052.052zm.583-1.61c.005.178-.02.35-.073.517a1.437 1.437 0 0 1-.273.474c-.016.02-.033.042-.073.006-.042-.033-.023-.052-.006-.073.118-.14.2-.287.25-.44a1.37 1.37 0 0 0 .07-.482c0-.025-.002-.052.05-.052.052 0 .052.027.052.05zm-1.585 3.124c-.285-.708-.353-1.27-.282-1.727.072-.463.285-.813.565-1.1.187-.192.35-.382.457-.62.107-.236.157-.52.12-.904-.004-.026-.006-.052.046-.057.052-.005.052.02.057.047.038.403-.014.704-.128.958-.11.252-.282.45-.476.65a1.87 1.87 0 0 0-.535 1.043c-.07.44 0 .986.277 1.676.01.022.02.046-.028.065-.048.02-.06-.005-.07-.028zm-.915-1.164a.72.72 0 0 0-.045.344c.012.114.054.23.125.346.015.022.03.045-.016.07-.045.03-.057.006-.07-.015a.942.942 0 0 1-.14-.39.83.83 0 0 1 .05-.39c.01-.024.02-.047.067-.03.05.018.037.042.03.066zm4.498-3.194c.187.263.296.535.318.82.02.284-.043.578-.204.884-.012.02-.024.045-.07.02-.046-.022-.032-.046-.02-.068.15-.286.213-.56.192-.827a1.51 1.51 0 0 0-.3-.768c-.015-.02-.03-.042.013-.073.043-.03.057-.01.073.012zm1.406-1.1a2.402 2.402 0 0 1 .07 1.67c-.014.048-.1.04-.1-.013a1.784 1.784 0 0 0-.162-.702 1.523 1.523 0 0 0-.43-.534c-.018-.017-.04-.034-.007-.074.034-.04.053-.024.074-.007.2.16.353.35.457.57.064.136.112.283.14.44.03-.173.045-.346.038-.52a2.25 2.25 0 0 0-.175-.79c-.01-.025-.02-.048.028-.07.048-.02.06.005.07.03zm.834-1.14c.185.183.315.424.396.723.078.293.106.64.092 1.035v.002a2.02 2.02 0 0 0-.007.484.95.95 0 0 0 .137.41c.015.022.03.046-.014.074-.045.03-.06.005-.073-.017a1.06 1.06 0 0 1-.154-.455 2.28 2.28 0 0 1 .007-.507v.003a3.518 3.518 0 0 0-.088-1.005 1.478 1.478 0 0 0-.367-.676c-.02-.02-.038-.035 0-.073.035-.038.054-.02.073 0zm-2.214-.22c-.12.147-.194.32-.23.512-.035.194-.03.407.005.64.005.026.01.05-.043.06-.05.008-.054-.018-.06-.044a2.023 2.023 0 0 1-.004-.675c.038-.21.12-.397.252-.56.016-.02.033-.04.073-.008.04.034.024.052.007.074zm-4.339 2.922a1.98 1.98 0 0 1-.346 1.07 2.485 2.485 0 0 1-.8.705c-.023.014-.046.026-.072-.02-.027-.044-.005-.056.018-.07.31-.182.576-.4.768-.675.193-.273.312-.605.33-1.015 0-.026.003-.052.055-.05.052.003.05.03.05.055zm-.113-1.493c.025.16.016.317-.02.474a2.172 2.172 0 0 1-.175.466c-.012.023-.024.045-.07.023-.047-.024-.035-.048-.023-.07.076-.15.135-.298.168-.442.034-.145.043-.287.022-.437-.003-.025-.007-.05.045-.058.052-.007.057.02.06.045zm2.94-.215v.146l.05.763.005.068c.002.026.002.052-.048.057h-.016c-.006.01-.018.014-.042.014-.052 0-.052-.027-.052-.053v-.844l-.014-.206c-.003-.026-.005-.052.047-.057.05-.002.054.022.056.048v.016c.012.01.012.026.012.043zm.71-1.31c-.21.252-.293.496-.297.736-.005.24.068.478.177.715.247.397.327.79.3 1.186-.022.394-.153.785-.326 1.176-.012.024-.02.047-.07.026-.046-.02-.034-.045-.025-.07.17-.378.293-.76.317-1.14a1.848 1.848 0 0 0-.287-1.127l-.002-.004c-.116-.25-.195-.504-.19-.765.005-.262.097-.528.32-.8.017-.02.033-.04.074-.007.04.033.023.052.007.073zm-4.56-8.128c.345-.263.68-.412 1.035-.45.35-.036.713.04 1.106.225.132-.003.262-.003.392-.005.133-.002.268-.005.4-.005.027 0 .053 0 .053.052s-.026.052-.052.052c-.135.002-.268.004-.4.004-.12.003-.24.003-.36.005l-.008.008c-.422.372-.782.576-1.102.642a1.06 1.06 0 0 1-.872-.19c-.025-.018-.05-.037-.016-.09.036-.05.064-.035.09-.016a.96.96 0 0 0 .773.168c.28-.06.597-.232.97-.547-.342-.15-.655-.21-.956-.178-.326.033-.643.176-.968.424-.026.02-.052.04-.09-.01-.038-.053-.014-.072.012-.09z\"></path><path d=\"M351.64 100.993a.26.26 0 0 1 .26.26.26.26 0 0 1-.26.26.26.26 0 0 1-.26-.26.26.26 0 0 1 .26-.26zm1.794 1.577c.188-.098.332-.203.453-.31.12-.106.213-.215.294-.324.015-.02.032-.043.074-.012.043.03.027.052.012.074a2.265 2.265 0 0 1-.308.343c-.125.113-.277.22-.474.32-.023.013-.047.025-.07-.02-.022-.045 0-.06.023-.07zm3.7-1.532a.522.522 0 0 1 .29.002.766.766 0 0 1 .28.154c.018.017.04.033.006.074-.033.04-.052.023-.074.007a.666.666 0 0 0-.24-.133.463.463 0 0 0-.236-.002c-.026.007-.05.014-.064-.038-.014-.05.012-.057.036-.064zm-2.116.085a.852.852 0 0 1 .38-.426c.172-.09.387-.128.65-.105.027.003.053.005.048.057-.005.05-.03.05-.057.047-.245-.022-.442.01-.593.092a.728.728 0 0 0-.335.376c-.01.024-.02.047-.068.026-.048-.02-.038-.045-.026-.07zm.242.347a.423.423 0 0 1 .115-.24.558.558 0 0 1 .268-.147c.026-.007.05-.014.064.035.014.05-.012.057-.035.064a.445.445 0 0 0-.218.12.346.346 0 0 0-.088.184c-.005.026-.01.05-.06.042-.05-.007-.047-.033-.042-.06zm-3.522 1.17c-.057.09-.11.182-.147.282a.823.823 0 0 0-.047.332c.003.026.005.052-.047.054-.052.003-.055-.02-.057-.047a.944.944 0 0 1 .05-.374c.04-.11.096-.208.157-.303.015-.02.03-.045.072-.017.044.03.03.05.015.072zm1.009.453v.156c0 .025 0 .05-.052.05s-.052-.025-.052-.05v-.157c0-.026 0-.053.052-.053s.052.027.052.053zm-.657-1.128a.96.96 0 0 0 .31.06c.105 0 .212-.015.316-.04.026-.004.05-.01.062.04.012.05-.014.056-.038.063a1.4 1.4 0 0 1-.34.04.995.995 0 0 1-.347-.066c-.026-.01-.05-.02-.03-.067.018-.05.042-.038.065-.03zm.65-1.895a.318.318 0 0 0-.21.065.377.377 0 0 0-.13.19c-.006.026-.013.05-.063.035-.05-.014-.043-.04-.035-.064a.49.49 0 0 1 .168-.242.43.43 0 0 1 .272-.085c.026 0 .053 0 .053.05 0 .053-.027.053-.053.053zm-1.05.108a.796.796 0 0 0-.187.11.254.254 0 0 0-.083.112c-.01.026-.017.05-.066.033-.05-.016-.04-.04-.034-.066.02-.06.06-.11.117-.16a.863.863 0 0 1 .215-.127c.024-.01.048-.02.067.03.02.046-.004.058-.03.068zm-.647.018a.82.82 0 0 0-.163.147.67.67 0 0 0-.107.183c-.01.024-.017.05-.066.03-.048-.016-.04-.042-.03-.066a.737.737 0 0 1 .122-.213.9.9 0 0 1 .184-.168c.02-.015.043-.03.073.013s.01.057-.014.073zm-.833.666a1.702 1.702 0 0 0-.378.392c-.014.02-.03.042-.073.01-.044-.03-.028-.05-.013-.072.06-.083.123-.16.19-.228.066-.068.137-.13.21-.184.022-.017.043-.03.074.01.032.042.01.056-.01.072zm.084.918c-.05.054-.1.11-.15.16l-.15.162c-.017.02-.036.038-.074.002-.038-.035-.022-.054-.003-.073l.15-.16.15-.16c.018-.02.037-.04.075-.004.038.036.02.055.002.074zm-.841.244v.322c0 .026 0 .052-.052.052-.05 0-.05-.026-.05-.052v-.322c0-.026 0-.052.05-.052.053 0 .053.026.053.052zm1.077 1.416c-.015.176-.032.352-.05.53 0 .016 0 .033-.003.05-.003.025-.005.05-.057.047-.052-.005-.05-.03-.048-.057.003-.017.003-.033.005-.05l.05-.528c.002-.027.005-.053.057-.048.052.005.05.03.047.057zm-.632-.468c-.002.114-.007.23-.01.343 0 .026-.004.053-.056.05-.052-.002-.05-.028-.05-.052.003-.116.007-.23.012-.346 0-.026.002-.052.055-.05.05.003.048.03.048.055zm-.588-4.489a.73.73 0 0 1 .467.467c.01.026.017.05-.033.066-.05.017-.057-.01-.066-.033a.65.65 0 0 0-.156-.254.696.696 0 0 0-.25-.152c-.023-.01-.047-.02-.03-.067.02-.048.043-.04.066-.03zm5.162 6.731c.1.225.155.45.157.673.004.225-.04.45-.136.675-.01.024-.02.048-.067.03-.047-.02-.037-.046-.028-.07a1.547 1.547 0 0 0-.022-1.266c-.012-.023-.022-.047.026-.068.047-.022.06.002.068.026zm-1.682 1.946c.073-.254.18-.474.303-.676.123-.2.263-.384.403-.564.16-.21.268-.436.325-.668a1.82 1.82 0 0 0 .02-.76c-.005-.025-.01-.048.042-.058.05-.01.057.017.06.043.047.26.045.533-.02.8-.06.247-.17.49-.343.71a6.316 6.316 0 0 0-.397.554c-.118.195-.223.41-.29.65-.008.026-.016.05-.065.036-.05-.014-.043-.038-.036-.064zm-2.164-.572a.718.718 0 0 1 .16-.25.902.902 0 0 1 .262-.186c.024-.012.047-.02.07.024.02.047 0 .06-.027.07a.795.795 0 0 0-.234.162.573.573 0 0 0-.135.216c-.01.024-.018.05-.066.03-.047-.016-.04-.042-.03-.066zm-.42-.151c.08-.105.162-.202.254-.287.095-.088.202-.16.325-.21.023-.01.047-.02.066.027.02.05-.004.06-.03.067a.967.967 0 0 0-.29.19 2.06 2.06 0 0 0-.243.274c-.017.022-.03.043-.073.01-.043-.03-.026-.052-.01-.074zm2.244-2.223c.09.04.174.06.257.06a.826.826 0 0 0 .242-.03c.025-.007.048-.014.063.036.014.05-.012.057-.036.064a.794.794 0 0 1-.57-.036c-.022-.01-.046-.02-.025-.068.02-.048.045-.036.07-.026zm-1.118-.144c.026-.032.052-.06.078-.09l.01-.013c.017-.02.035-.038.073-.005.038.036.022.055.005.074l-.01.012c-.025.03-.05.06-.08.09-.017.02-.033.038-.073.005-.038-.034-.022-.055-.005-.074zm24.136 6.962c.05.055.093.112.13.173.036.062.065.126.088.194.01.026.017.05-.033.063-.05.017-.057-.01-.066-.033a.76.76 0 0 0-.078-.173.796.796 0 0 0-.118-.154c-.016-.02-.035-.038.003-.073.038-.036.057-.017.073.002zm-26.795 12.575c.114.105.232.2.363.266a.95.95 0 0 0 .43.104c.027 0 .053 0 .053.052 0 .05-.027.05-.053.05-.178 0-.334-.044-.48-.115-.14-.07-.267-.17-.385-.28-.02-.016-.038-.035-.002-.073.035-.038.054-.02.073-.002z\"></path><g fill=\"red\"><path d=\"M368.9 99.6a8.222 8.222 0 0 0 1.655-.08c-.52.378-1.187.63-1.905.75a.77.77 0 0 0 .27-.34.426.426 0 0 0-.02-.33zm-1.42-.148c.385.064.786.11 1.182.135.004.01.012.017.016.026.064.088.083.173.055.256-.033.094-.123.194-.27.296-.04.028-.08.057-.024.135a5.63 5.63 0 0 1-1.215.022.177.177 0 0 0 .04-.033c.145-.153.238-.31.264-.473a.627.627 0 0 0-.05-.362zm-10.49-3.014c.668-.088 1.348-.11 2.04-.093a.985.985 0 0 1 .5.406c.114.2.154.46.107.785-.007.047-.014.097.083.11.097.013.104-.037.11-.084.05-.37.003-.67-.132-.907a1.046 1.046 0 0 0-.256-.294c.062.002.124.004.185.01.797.042 1.415.27 2.107.613a.118.118 0 0 1 .017.02c.148.153.197.312.174.475-.026.173-.13.36-.296.552-.03.038-.064.074.01.138.075.064.108.026.14-.012.186-.22.31-.44.34-.652a.696.696 0 0 0-.035-.348c.583.29 1.175.566 1.75.87.013.007.025.01.037.02 0 .01.004.025.01.036a.484.484 0 0 1-.053.425c-.088.125-.247.234-.476.32-.045.016-.09.033-.056.125.033.09.08.074.125.057.27-.103.46-.233.568-.394a.63.63 0 0 0 .107-.453c.38.206.763.42 1.154.607v.002c.07.138.082.26.027.375-.057.12-.19.234-.4.338-.043.022-.088.043-.045.13.042.09.087.067.13.046.254-.125.415-.27.49-.43a.544.544 0 0 0 .043-.346c.135.06.273.116.413.168a8.1 8.1 0 0 0 1.32.35.466.466 0 0 1 .11.377.736.736 0 0 1-.212.368c-.033.035-.066.068.002.137a.27.27 0 0 0 .03.026c-1.48-.15-2.798-.86-4.177-1.393-.163-.064-.33-.126-.492-.19-.51-.192-1.024-.453-1.536-.66a.16.16 0 0 0-.066-.034c-.036-.012-.07-.024-.105-.033-.02-.01-.044-.017-.065-.027.002.003.007.005.01.008a8.477 8.477 0 0 0-1.418-.33 6.112 6.112 0 0 0-1.626-.018l-.09-.014c.05-.292.01-.548-.134-.77a1.25 1.25 0 0 0-.47-.415z\"></path><path d=\"M354.565 97.09a8.688 8.688 0 0 1 2.074-.603c.32.128.534.285.655.47.116.182.145.395.104.642a4.197 4.197 0 0 0-1.84.225c-.156-.33-.367-.53-.614-.638a1.243 1.243 0 0 0-.38-.1zm7.458 3.772a9.414 9.414 0 0 0-.56-.334 6.92 6.92 0 0 0-3.037-.86c.01-.007.016-.017.026-.024.377-.384.46-.746.332-1.085-.1-.264-.33-.508-.647-.73.355-.018.684.004 1.054.056.523.073 1.198.25 1.814.497.152.332.195.624.128.87-.07.26-.263.474-.576.652-.042.024-.085.047-.038.133.048.085.09.06.133.035.364-.204.586-.46.67-.772.063-.24.044-.51-.062-.812.417.187.794.41 1.057.654.343.237.682.476 1.014.727.002.42-.122.66-.326.786-.215.13-.523.147-.874.112-.047-.005-.097-.01-.107.087v.005z\"></path><path d=\"M364.052 102.39c-.616-.482-1.218-.985-1.865-1.42.358.03.678 0 .92-.143.234-.145.388-.396.414-.806.387.3.76.615 1.113.954.177.168.355.334.538.498 0 .002.003.004.003.01.043.15.057.28.045.39a.46.46 0 0 1-.11.263.547.547 0 0 1-.274.154c-.173.05-.398.058-.675.028-.046-.005-.094-.01-.106.073z\"></path><path d=\"M366.178 103.79c-.213-.11-.417-.223-.614-.34-.472-.28-.915-.6-1.348-.933.265.02.488.007.668-.043a.75.75 0 0 0 .365-.21c.09-.1.143-.224.16-.375a.922.922 0 0 0-.002-.215c.424.363.87.7 1.35.993.252.154.505.3.757.434-.003.017 0 .033.002.052.03.195-.078.318-.277.396-.233.092-.58.13-.974.154-.045.002-.088.005-.093.08z\"></path><path d=\"M368.448 104.68a11.886 11.886 0 0 1-2.054-.782c.365-.026.687-.068.92-.16.262-.105.414-.266.404-.524a10.8 10.8 0 0 0 1.273.55c.077.168.082.305.01.42-.085.143-.272.262-.504.364-.045.02-.09.04-.05.128v.002z\"></path><path d=\"M373.18 104.2c.06-.01.44-.11.243.035-1.394.912-3.162.91-4.828.48.26-.115.47-.255.576-.43a.57.57 0 0 0 .058-.443c.53.173 1.07.296 1.624.367a.376.376 0 0 1-.088.252c-.088.11-.237.216-.48.323-.046.02-.09.038-.05.128.037.09.082.07.127.05.276-.12.454-.25.558-.38a.55.55 0 0 0 .13-.353 8.963 8.963 0 0 0 2.133-.033zm-9.638 24.005c-.104.11-.19.23-.277.372-.405.135-.763.337-1.2.318 0 .282.093.405.375.407.538-.27.66-.32.707-.282.066.057-.076.444-.522.756-.068.043-.066.07-.026.14.376.59 1.364.38 1.895.24.38-.1 1.064-.55 1.254-.93.072-.172-.093-.4-.26-.585-.42.065-.563-.13-.497-.264-.443-.157-.936-.19-1.45-.17zm-15.152-4.775c-.307.25-.65.45-1.05.583-.153.05-.52.14-.556.33-.005.07.247.22.408.132.445-.427.668-.19.156.246-.04.084-.007.177.08.255.463.415 1.608.55 2.13.22.385-.24.587-.507.25-.874a1.74 1.74 0 0 1 .026-.246l-.637-.064-.39-.227-.416-.353zm9.974 3.47c-.038.004-.078.01-.116.016-.206.223.36.14.66.325.14.084.198.247.143.475-.276.66-1.824.447-2.338.175-.24-.126-.25-.27-.24-.476.107 0 .216-.008.325-.024.185-.026.368-.08.548-.183.05-.028.102-.06.045-.158-.057-.103-.11-.075-.16-.046a1.294 1.294 0 0 1-.463.154 2.57 2.57 0 0 1-.486.016h-.04c-.09-.052-.158-.114-.12-.168.038-.052.187.005.215.014.24-.11.448-.182.707-.232.035-.036.068-.074.104-.11.47.04.922.112 1.22.22zm-7.154-.406c-.096.057-.13.137-.198.287-.27.273-.528.437-.874.593-.287.13-.01.256.192.394.182.135.422-.16.57-.382.164-.246.33-.173.224.02-.12.21-.204.513-.216.672-.062.17.588.3.7.306.395.02.893-.367 1.203-.564.26-.264.22-.494.105-.814l.003-.02a1.97 1.97 0 0 1-.477-.05 3.432 3.432 0 0 1-.558-.184c-.024-.01-.047-.02-.028-.068.01-.03.026-.038.042-.036l-.682-.156zm2.77-26.378c.11-.005.218-.01.324.002.202.024.394.112.595.135.672-.253 1.23-.393 1.71-.372a5.68 5.68 0 0 1 1.728-.217.076.076 0 0 1-.02-.02c-.07-.067-.037-.103 0-.136.314-.32.387-.614.285-.88-.104-.274-.388-.533-.784-.77-.423.048-.828-.066-1.276-.016a4.06 4.06 0 0 0-.825.183c.224.08.42.213.582.403.2.235.34.555.417.958.01.047.016.094-.08.113-.094.02-.103-.03-.113-.078-.068-.368-.196-.657-.374-.868-.187-.268-.616-.372-.75-.427-.45.045-.89.095-1.274.194-.29.073-.544.175-.738.327.29-.062.59-.05.85.08.25.123.46.356.593.732.017.044.03.092-.062.123-.092.03-.11-.015-.123-.062-.11-.324-.287-.518-.493-.62-.41-.204-1.256-.026-1.614.24a4.23 4.23 0 0 0-.623.592c-.02.026-.045.05-.073.052.767.052 1.54.093 2.137.332zm-2.278-.434c-.017-.042.012-.073.038-.104.216-.244.434-.46.66-.626.217-.16.442-.277.674-.332.237-.263.588-.42.996-.526.395-.102.848-.154 1.305-.2-.135-.27-.308-.435-.507-.523-.213-.093-.46-.108-.723-.082-.552.19-1.042.486-1.514.82.044 0 .086 0 .127.003.14.01.265-.01.38.034.05.017.094.033.06.126-.04.11-.346.042-.452.035a1.352 1.352 0 0 0-.4.038c-.024.005-.046.012-.067.005-.495.306-.87.616-1.27.955.303.107.54.232.694.38z\"></path></g><path d=\"M409.028 156.5l20.742-47.013-15.3-24.705-27.287 10.103-12.63 49.687a219.388 219.388 0 0 1 34.472 11.93z\" fill=\"#0093dd\"></path><path d=\"M382.576 113.013a251.716 251.716 0 0 1 39.59 13.704l-8.003 18.147a231.952 231.952 0 0 0-36.474-12.623z\" fill=\"#fff\"></path><path d=\"M415.45 141.95l5.347-12.12a248.557 248.557 0 0 0-39.055-13.518l-3.152 12.398a235.895 235.895 0 0 1 37.045 12.822l-.185.417z\" fill=\"red\"></path><path d=\"M385.59 125.755c.358-.226.74-.17 1.124-.11.31-.116.668-.156 1.057-.142.167-.09.36-.154.577-.194.116-.09.12-.188.016-.293a.62.62 0 0 1-.158-.353c-.616-.357-.844-.903-1.08-1.443-.35-.09-.513-.21-.55-.343-.17-.016-.34-.033-.508-.052-.8.088-1.005-.17-1.29-.38-.236-.08-.443-.21-.575-.46l-.263-.33c-.22-.278-.153-.645.176-.624.233.027.463.027.676-.065.25-.112.62-.11.903-.086.334-.02.545-.235.87-.54-.003-.13-.003-.257-.005-.387-.052-.14.014-.202.2-.183a.98.98 0 0 1 .866.508c.505.087.903.33 1.17.753.672.004 1.125.257 1.18.506.04.182-.157.39-.46.614.002.045.004.092.004.137.18.157.3.313.36.467.377.145.737.34 1.074.623.96-.11 2.578.586 4.766 1.982a18.58 18.58 0 0 1 4.12 1.217c.28.01.558.017.836.026 2.372-.35 4.67-.08 6.804 1.55.806.097 1.53.35 2.228.64.52.213 1.047.296 1.58.346a7.93 7.93 0 0 1 2.605.698c.974.218 1.884.524 2.448 1.206.402.484.305.93-.205 1.114-.308.65-.922.678-1.84.358-.634.116-1.33-.39-1.964-.867-.878-.283-1.686-.79-2.485-1.33-.415-.31-.834-.508-1.242-.596-.32-.068-.606-.113-.798 0-.095.057-.083.09 0 .16.222.186.38.466.43.803.044.296-.004.637.013 1 .02.38.25.66.633.896.264.16.576.33 1.03.395.215.043.276.17.27.332.12.578.232 1.16.443 1.685.06.15.173.22.343.346.586.423.282.895-.25.997-.468.412-.87.69-1.35.798-.38.128-.538-.028-.666-.215a.483.483 0 0 1-.443-.247c-.467-.343-.068-.94 1.048-.685.024-.13.118-.17.213-.168-.066-.29-.104-.61.02-.912-.098-.064-.183-.145-.328-.192-.403-.128-.784-.313-1.085-.595-.572-.537-1.465-.988-2.325-1.44-.71-.036-1.24-.363-1.797-.64l-.754-.01c-.22-.073-.4.003-.534.16-.223.272-.48.227-.787.19-.35-.04-.707-.013-1.058-.018-.173.043-.343.097-.53.1-.396-.022-.783-.026-1.046.194-.218.23-.436.213-.654.128a.978.978 0 0 1-.35-.242c-.276-.057-.453-.125-.513-.208-.463-.13-.593-.26-.572-.39-.614-.148-.322-.632.076-.648.47-.02.898.07 1.358.135.386.11.863.046 1.178-.24.204-.184.28-.342.53-.48-.795-.052-1.38-.192-1.812-.464-1.16-.733-2.09-.91-2.83-.29-.197.112-.35.157-.562.076a1.063 1.063 0 0 0-.583-.028c-.42.095-.834.043-1.253-.11a4.09 4.09 0 0 1-1.84.063c-.518.272-.898.303-1.14.094a8.548 8.548 0 0 1-.646-.397c-.33-.05-.472-.132-.486-.242-.422-.046-.474-.2-.472-.368-.175-.202-.11-.356.066-.486.313-.13.638-.178.998.007.216.102.375.2.505.303.24-.028.446 0 .626.067.133-.21.51-.218.923-.195.206-.137.452-.234.768-.263-.01-.05-.018-.1-.026-.147-.414-.11-.628-.41-.834-.713-.637-.012-1.095-.28-1.55-.56-.374.032-.675-.092-.967-.267-.237.02-.5.028-.75-.036a2.55 2.55 0 0 1-1.4 0c-.31.03-.56-.002-.815-.026-.29.334-.618.394-.976.223-.197-.25-.476-.413-.83-.506-.267-.087-.35-.204-.398-.33-.327-.2-.26-.4.055-.55.236-.115.532-.136.982.086.147.055.31.093.496.107z\"></path><path d=\"M401.218 130.518c-.03-.054-.097-.192-.336-.054-.742-.04-1.57-.03-2.195-.398-.65-.382-1.318-.78-2.036-.752.215-.2.48-.34.788-.422.413-.11.9-.116 1.44-.028.76.123 1.428.27 1.945.465.497.186.848.418 1.002.717a.406.406 0 0 0 .043.047c.2.128.372.258.516.396.11.102.204.208.285.322a2.5 2.5 0 0 1-.715-.043 2.875 2.875 0 0 1-.74-.256z\" fill=\"#fff\"></path><path d=\"M402.925 94.71l.042.223.934 4.835-3.713 3.237-.17.15.215.075 4.655 1.61.946 4.834.045.223.17-.15 3.72-3.225 4.663 1.597.217.073-.043-.223-.934-4.837 3.714-3.237.17-.15-.215-.073-4.656-1.612-.945-4.834-.046-.222-.17.15-3.724 3.227-4.66-1.6z\"></path><path d=\"M400.65 102.95l3.47-3.024 4.362 1.503zm8.41-1.632l3.482-3.027 4.35 1.506zm7.862-1.368l-3.47 3.024-4.363-1.502zm-8.412 1.635l-3.48 3.024-4.35-1.503zm-5.092-6.429l4.353 1.493.883 4.528zm5.622 6.464l4.36 1.503.872 4.52zm5.114 6.125l-4.354-1.49-.88-4.53zm-5.622-6.465l-4.36-1.5-.873-4.52zm3.022-7.627l.884 4.517-3.482 3.027zm-2.79 8.101l.88 4.53-3.477 3.016zm-2.746 7.494l-.884-4.518 3.48-3.026zm2.789-8.101l-.88-4.53 3.478-3.014z\" fill=\"#f7db17\"></path>", 28)
const _hoisted_60 = [
  _hoisted_32
]

function DpFlagHRvue_type_template_id_23ea40fa_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagHRvue_type_template_id_23ea40fa_hoisted_1, _hoisted_30))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_31, _hoisted_60))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagHR.vue?vue&type=template&id=23ea40fa

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagHR.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagHRvue_type_script_lang_js = ({
  name: "DpFlagHR",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagHR.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagHR.vue




;
const DpFlagHR_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagHRvue_type_script_lang_js, [['render',DpFlagHRvue_type_template_id_23ea40fa_render]])

/* harmony default export */ var DpFlagHR = (DpFlagHR_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagHU.vue?vue&type=template&id=507e0bdd


const DpFlagHUvue_type_template_id_507e0bdd_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagHUvue_type_template_id_507e0bdd_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M512.004 511.985H0V0h512.004z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#388d00",
    d: "M512.004 511.985H0V341.323h512.004z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d43516",
    d: "M512.004 170.8H0V.137h512.004z"
  })
], -1)
const DpFlagHUvue_type_template_id_507e0bdd_hoisted_3 = [
  DpFlagHUvue_type_template_id_507e0bdd_hoisted_2
]
const DpFlagHUvue_type_template_id_507e0bdd_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagHUvue_type_template_id_507e0bdd_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M640.006 479.994H0V0h640.006z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#388d00",
    d: "M640.006 479.994H0V319.996h640.006z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d43516",
    d: "M640.006 160.127H0V.13h640.006z"
  })
], -1)
const DpFlagHUvue_type_template_id_507e0bdd_hoisted_6 = [
  DpFlagHUvue_type_template_id_507e0bdd_hoisted_5
]

function DpFlagHUvue_type_template_id_507e0bdd_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagHUvue_type_template_id_507e0bdd_hoisted_1, DpFlagHUvue_type_template_id_507e0bdd_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagHUvue_type_template_id_507e0bdd_hoisted_4, DpFlagHUvue_type_template_id_507e0bdd_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagHU.vue?vue&type=template&id=507e0bdd

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagHU.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagHUvue_type_script_lang_js = ({
  name: "DpFlagHU",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagHU.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagHU.vue




;
const DpFlagHU_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagHUvue_type_script_lang_js, [['render',DpFlagHUvue_type_template_id_507e0bdd_render]])

/* harmony default export */ var DpFlagHU = (DpFlagHU_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagIE.vue?vue&type=template&id=6c2da49e


const DpFlagIEvue_type_template_id_6c2da49e_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagIEvue_type_template_id_6c2da49e_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h511.994v512.002H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#009A49",
    d: "M0 0h170.667v512.002H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#FF7900",
    d: "M341.333 0H512v512.002H341.333z"
  })
], -1)
const DpFlagIEvue_type_template_id_6c2da49e_hoisted_3 = [
  DpFlagIEvue_type_template_id_6c2da49e_hoisted_2
]
const DpFlagIEvue_type_template_id_6c2da49e_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagIEvue_type_template_id_6c2da49e_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h639.995v480.004H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#009A49",
    d: "M0 0h213.334v480.004H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#FF7900",
    d: "M426.668 0h213.334v480.004H426.668z"
  })
], -1)
const DpFlagIEvue_type_template_id_6c2da49e_hoisted_6 = [
  DpFlagIEvue_type_template_id_6c2da49e_hoisted_5
]

function DpFlagIEvue_type_template_id_6c2da49e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagIEvue_type_template_id_6c2da49e_hoisted_1, DpFlagIEvue_type_template_id_6c2da49e_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagIEvue_type_template_id_6c2da49e_hoisted_4, DpFlagIEvue_type_template_id_6c2da49e_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIE.vue?vue&type=template&id=6c2da49e

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagIE.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagIEvue_type_script_lang_js = ({
  name: "DpFlagIE",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIE.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIE.vue




;
const DpFlagIE_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagIEvue_type_script_lang_js, [['render',DpFlagIEvue_type_template_id_6c2da49e_render]])

/* harmony default export */ var DpFlagIE = (DpFlagIE_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagIL.vue?vue&type=template&id=4d0df7b0


const DpFlagILvue_type_template_id_4d0df7b0_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagILvue_type_template_id_4d0df7b0_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M0 0h512v512H0z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\"><path fill=\"#fff\" d=\"M619.43 512H-112V0h731.43z\"></path><path fill=\"#00c\" d=\"M619.43 115.23H-112V48.003h731.43zm0 350.45H-112v-67.227h731.43zm-483-274.9l110.12 191.54 112.49-190.75-222.61-.79z\"></path><path d=\"M225.75 317.81l20.95 35.506 21.4-35.36-42.35-.145z\" fill=\"#fff\"></path><path d=\"M136.02 320.58l110.13-191.54 112.48 190.75-222.61.79z\" fill=\"#00c\"></path><path d=\"M225.75 191.61l20.95-35.506 21.4 35.36-42.35.145zm-43.78 79.5l-21.64 35.982 40.9-.127-19.26-35.855zm-21.27-66.5l41.225.29-19.834 36.26-21.39-36.55zm151.24 66.91l20.83 35.576-41.71-.533 20.88-35.043zm20.45-66.91l-41.225.29L311 241.16l21.39-36.55zm-114.27-.04l-28.394 51.515 28.8 50.297 52.73 1.217 32.044-51.515-29.61-51.92-55.572.405z\" fill=\"#fff\"></path></g>", 2)
const DpFlagILvue_type_template_id_4d0df7b0_hoisted_4 = [
  DpFlagILvue_type_template_id_4d0df7b0_hoisted_2
]
const DpFlagILvue_type_template_id_4d0df7b0_hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagILvue_type_template_id_4d0df7b0_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-87.62 0h682.67v512H-87.62z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\" transform=\"translate(82.14) scale(.94)\"><path fill=\"#fff\" d=\"M619.43 512H-112V0h731.43z\"></path><path fill=\"#00c\" d=\"M619.43 115.23H-112V48.003h731.43zm0 350.45H-112v-67.227h731.43zm-483-274.9l110.12 191.54 112.49-190.75-222.61-.79z\"></path><path d=\"M225.75 317.81l20.95 35.506 21.4-35.36-42.35-.145z\" fill=\"#fff\"></path><path d=\"M136.02 320.58l110.13-191.54 112.48 190.75-222.61.79z\" fill=\"#00c\"></path><path d=\"M225.75 191.61l20.95-35.506 21.4 35.36-42.35.145zm-43.78 79.5l-21.64 35.982 40.9-.127-19.26-35.855zm-21.27-66.5l41.225.29-19.834 36.26-21.39-36.55zm151.24 66.91l20.83 35.576-41.71-.533 20.88-35.043zm20.45-66.91l-41.225.29L311 241.16l21.39-36.55zm-114.27-.04l-28.394 51.515 28.8 50.297 52.73 1.217 32.044-51.515-29.61-51.92-55.572.405z\" fill=\"#fff\"></path></g>", 2)
const DpFlagILvue_type_template_id_4d0df7b0_hoisted_8 = [
  DpFlagILvue_type_template_id_4d0df7b0_hoisted_6
]

function DpFlagILvue_type_template_id_4d0df7b0_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagILvue_type_template_id_4d0df7b0_hoisted_1, DpFlagILvue_type_template_id_4d0df7b0_hoisted_4))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagILvue_type_template_id_4d0df7b0_hoisted_5, DpFlagILvue_type_template_id_4d0df7b0_hoisted_8))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIL.vue?vue&type=template&id=4d0df7b0

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagIL.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagILvue_type_script_lang_js = ({
  name: "DpFlagIL",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIL.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIL.vue




;
const DpFlagIL_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagILvue_type_script_lang_js, [['render',DpFlagILvue_type_template_id_4d0df7b0_render]])

/* harmony default export */ var DpFlagIL = (DpFlagIL_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagIT.vue?vue&type=template&id=5da52d8b


const DpFlagITvue_type_template_id_5da52d8b_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagITvue_type_template_id_5da52d8b_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h512.005v512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#009246",
    d: "M0 0h170.667v512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ce2b37",
    d: "M341.333 0H512v512H341.333z"
  })
], -1)
const DpFlagITvue_type_template_id_5da52d8b_hoisted_3 = [
  DpFlagITvue_type_template_id_5da52d8b_hoisted_2
]
const DpFlagITvue_type_template_id_5da52d8b_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagITvue_type_template_id_5da52d8b_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h640v479.997H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#009246",
    d: "M0 0h213.331v479.997H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ce2b37",
    d: "M426.663 0h213.331v479.997H426.663z"
  })
], -1)
const DpFlagITvue_type_template_id_5da52d8b_hoisted_6 = [
  DpFlagITvue_type_template_id_5da52d8b_hoisted_5
]

function DpFlagITvue_type_template_id_5da52d8b_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagITvue_type_template_id_5da52d8b_hoisted_1, DpFlagITvue_type_template_id_5da52d8b_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagITvue_type_template_id_5da52d8b_hoisted_4, DpFlagITvue_type_template_id_5da52d8b_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIT.vue?vue&type=template&id=5da52d8b

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagIT.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagITvue_type_script_lang_js = ({
  name: "DpFlagIT",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagIT.vue




;
const DpFlagIT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagITvue_type_script_lang_js, [['render',DpFlagITvue_type_template_id_5da52d8b_render]])

/* harmony default export */ var DpFlagIT = (DpFlagIT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagJP.vue?vue&type=template&id=bdf2d334


const DpFlagJPvue_type_template_id_bdf2d334_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagJPvue_type_template_id_bdf2d334_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  transform: "translate(-128) scale(.72249)",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h1063v708.66H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ellipse", {
    cx: "523.08",
    rx: "194.93",
    cy: "344.05",
    transform: "translate(-59.707 -34.521) scale(1.1302)",
    ry: "194.93",
    fill: "#d30000"
  })
], -1)
const DpFlagJPvue_type_template_id_bdf2d334_hoisted_3 = [
  DpFlagJPvue_type_template_id_bdf2d334_hoisted_2
]
const DpFlagJPvue_type_template_id_bdf2d334_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagJPvue_type_template_id_bdf2d334_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-88.001 32h640v480h-640z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\" transform=\"translate(88.001 -32)\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M-128 32h720v480h-720z\"></path><ellipse rx=\"194.93\" ry=\"194.93\" transform=\"translate(-168.44 8.618) scale(.76554)\" cy=\"344.05\" cx=\"523.08\" fill=\"#d30000\"></ellipse></g>", 2)
const DpFlagJPvue_type_template_id_bdf2d334_hoisted_7 = [
  DpFlagJPvue_type_template_id_bdf2d334_hoisted_5
]

function DpFlagJPvue_type_template_id_bdf2d334_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagJPvue_type_template_id_bdf2d334_hoisted_1, DpFlagJPvue_type_template_id_bdf2d334_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagJPvue_type_template_id_bdf2d334_hoisted_4, DpFlagJPvue_type_template_id_bdf2d334_hoisted_7))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagJP.vue?vue&type=template&id=bdf2d334

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagJP.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagJPvue_type_script_lang_js = ({
  name: "DpFlagJP",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagJP.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagJP.vue




;
const DpFlagJP_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagJPvue_type_script_lang_js, [['render',DpFlagJPvue_type_template_id_bdf2d334_render]])

/* harmony default export */ var DpFlagJP = (DpFlagJP_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagLT.vue?vue&type=template&id=21308b78


const DpFlagLTvue_type_template_id_21308b78_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagLTvue_type_template_id_21308b78_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  transform: "scale(.51314 1.0322)",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    transform: "scale(.93865 .69686)",
    rx: "0",
    ry: "0",
    height: "708.66",
    width: "1063",
    fill: "#007308"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    transform: "scale(.93865 .69686)",
    rx: "0",
    ry: "0",
    height: "236.22",
    width: "1063",
    y: "475.56",
    fill: "#bf0000"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ffb300",
    d: "M0 0h997.77v164.61H0z"
  })
], -1)
const DpFlagLTvue_type_template_id_21308b78_hoisted_3 = [
  DpFlagLTvue_type_template_id_21308b78_hoisted_2
]
const DpFlagLTvue_type_template_id_21308b78_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagLTvue_type_template_id_21308b78_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  transform: "scale(.64143 .96773)",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    transform: "scale(.93865 .69686)",
    rx: "0",
    ry: "0",
    width: "1063",
    height: "708.66",
    fill: "#007308"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    transform: "scale(.93865 .69686)",
    rx: "0",
    ry: "0",
    width: "1063",
    y: "475.56",
    height: "236.22",
    fill: "#bf0000"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ffb300",
    d: "M0 0h997.77v164.61H0z"
  })
], -1)
const DpFlagLTvue_type_template_id_21308b78_hoisted_6 = [
  DpFlagLTvue_type_template_id_21308b78_hoisted_5
]

function DpFlagLTvue_type_template_id_21308b78_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagLTvue_type_template_id_21308b78_hoisted_1, DpFlagLTvue_type_template_id_21308b78_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagLTvue_type_template_id_21308b78_hoisted_4, DpFlagLTvue_type_template_id_21308b78_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLT.vue?vue&type=template&id=21308b78

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagLT.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagLTvue_type_script_lang_js = ({
  name: "DpFlagLT",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLT.vue




;
const DpFlagLT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagLTvue_type_script_lang_js, [['render',DpFlagLTvue_type_template_id_21308b78_render]])

/* harmony default export */ var DpFlagLT = (DpFlagLT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagLU.vue?vue&type=template&id=c7d4b148


const DpFlagLUvue_type_template_id_c7d4b148_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#00a1de",
  d: "M0 256h512v256H0z"
}, null, -1)
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#ed2939",
  d: "M0 0h512v256H0z"
}, null, -1)
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 170.667h512v170.666H0z"
}, null, -1)
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_5 = [
  DpFlagLUvue_type_template_id_c7d4b148_hoisted_2,
  DpFlagLUvue_type_template_id_c7d4b148_hoisted_3,
  DpFlagLUvue_type_template_id_c7d4b148_hoisted_4
]
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_6 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#00a1de",
  d: "M0 240h640v240H0z"
}, null, -1)
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#ed2939",
  d: "M0 0h640v240H0z"
}, null, -1)
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  fill: "#fff",
  d: "M0 160h640v160H0z"
}, null, -1)
const DpFlagLUvue_type_template_id_c7d4b148_hoisted_10 = [
  DpFlagLUvue_type_template_id_c7d4b148_hoisted_7,
  DpFlagLUvue_type_template_id_c7d4b148_hoisted_8,
  DpFlagLUvue_type_template_id_c7d4b148_hoisted_9
]

function DpFlagLUvue_type_template_id_c7d4b148_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagLUvue_type_template_id_c7d4b148_hoisted_1, DpFlagLUvue_type_template_id_c7d4b148_hoisted_5))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagLUvue_type_template_id_c7d4b148_hoisted_6, DpFlagLUvue_type_template_id_c7d4b148_hoisted_10))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLU.vue?vue&type=template&id=c7d4b148

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagLU.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagLUvue_type_script_lang_js = ({
  name: "DpFlagLU",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLU.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLU.vue




;
const DpFlagLU_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagLUvue_type_script_lang_js, [['render',DpFlagLUvue_type_template_id_c7d4b148_render]])

/* harmony default export */ var DpFlagLU = (DpFlagLU_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagLV.vue?vue&type=template&id=bd4dd030


const DpFlagLVvue_type_template_id_bd4dd030_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagLVvue_type_template_id_bd4dd030_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h512.005v512.005H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ab231d",
    d: "M0 0h512.005v204.802H0zm0 307.203h512.005v204.802H0z"
  })
], -1)
const DpFlagLVvue_type_template_id_bd4dd030_hoisted_3 = [
  DpFlagLVvue_type_template_id_bd4dd030_hoisted_2
]
const DpFlagLVvue_type_template_id_bd4dd030_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagLVvue_type_template_id_bd4dd030_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h640v480.003H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ab231d",
    d: "M0 0h640v192.001H0zm0 288.002h640v192.001H0z"
  })
], -1)
const DpFlagLVvue_type_template_id_bd4dd030_hoisted_6 = [
  DpFlagLVvue_type_template_id_bd4dd030_hoisted_5
]

function DpFlagLVvue_type_template_id_bd4dd030_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagLVvue_type_template_id_bd4dd030_hoisted_1, DpFlagLVvue_type_template_id_bd4dd030_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagLVvue_type_template_id_bd4dd030_hoisted_4, DpFlagLVvue_type_template_id_bd4dd030_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLV.vue?vue&type=template&id=bd4dd030

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagLV.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagLVvue_type_script_lang_js = ({
  name: "DpFlagLV",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLV.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagLV.vue




;
const DpFlagLV_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagLVvue_type_script_lang_js, [['render',DpFlagLVvue_type_template_id_bd4dd030_render]])

/* harmony default export */ var DpFlagLV = (DpFlagLV_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagMT.vue?vue&type=template&id=7657cf9c


const DpFlagMTvue_type_template_id_7657cf9c_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagMTvue_type_template_id_7657cf9c_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#ce0000\" d=\"M256 0h256v511.984H256z\"></path><path fill=\"#fff\" d=\"M0 0h256v511.984H0z\"></path></g><g transform=\"matrix(.35005 0 0 .35003 40.728 -25.527)\"><path d=\"M183.107 381.66c0 2.314-2.62 4.19-5.853 4.19-3.232 0-5.852-1.876-5.852-4.19 0-2.313 2.62-4.188 5.852-4.188s5.853 1.875 5.853 4.189z\" fill-rule=\"evenodd\" fill=\"#f1eeee\"></path><path d=\"M.06 361.429v106.303h106.302c0 17.713 17.718 35.43 35.436 35.43v106.299h106.296V503.163c17.718 0 35.436-17.718 35.436-35.43h106.302V361.428H283.53c0-17.713-17.718-35.431-35.436-35.431V219.7H141.798v106.298c-17.718 0-35.436 17.718-35.436 35.43H.06z\" fill-rule=\"evenodd\" fill=\"#c00\"></path><path d=\"M3.6 364.969v99.211h106.302c0 17.713 17.712 35.437 35.43 35.437v106.298h99.216V499.617c17.718 0 35.43-17.724 35.43-35.437H386.28v-99.21H279.978c0-17.713-17.712-35.437-35.43-35.437V223.234h-99.216v106.298c-17.718 0-35.43 17.724-35.43 35.437H3.6z\" fill-rule=\"evenodd\" fill=\"#ffe600\"></path><path d=\"M7.04 368.509v92.131h106.296c0 17.712 17.718 35.43 35.436 35.43v106.3h92.124v-106.3c17.718 0 35.436-17.719 35.436-35.43h106.296v-92.132H276.332c0-17.713-17.718-35.43-35.436-35.43V226.78h-92.124v106.298c-17.718 0-35.436 17.718-35.436 35.43H7.04z\" fill-rule=\"evenodd\" fill=\"#707070\"></path><path d=\"M10.58 372.049v85.04h106.296c0 17.711 17.718 35.436 35.436 35.436v106.297h85.038V492.525c17.718 0 35.436-17.725 35.436-35.437h106.296v-85.04H272.786c0-17.712-17.718-35.43-35.436-35.43V230.32h-85.038v106.298c-17.718 0-35.436 17.718-35.436 35.43H10.58z\" fill-rule=\"evenodd\" fill=\"#a0a0a0\"></path><g fill-rule=\"evenodd\"><path d=\"M153.244 327.833c6.226 6.226 1.179 21.37-11.275 33.824s-27.597 17.5-33.824 11.274c-6.227-6.227-1.179-21.37 11.275-33.824s27.597-17.501 33.824-11.274z\" fill=\"#d0d0d0\"></path><path d=\"M145.732 335.344c6.227 6.227 4.544 18.006-3.758 26.308s-20.081 9.985-26.308 3.758c-6.227-6.226-4.544-18.005 3.758-26.308s20.08-9.985 26.308-3.758z\" fill=\"gray\"></path><path d=\"M114.406 354.133l2.505-2.505 10.022 5.011-5.011-10.022 2.505-2.506 10.022 20.044-20.043-10.022zm15.035-15.033l2.506-2.505 15.033 15.033-2.505 2.505z\" fill=\"#d0d0d0\"></path></g><g fill-rule=\"evenodd\"><path d=\"M281.617 372.927c-6.226 6.226-21.37 1.179-33.824-11.275s-17.5-27.597-11.274-33.824c6.227-6.227 21.37-1.179 33.824 11.275s17.501 27.597 11.274 33.824z\" fill=\"#d0d0d0\"></path><path d=\"M274.106 365.415c-6.227 6.227-18.006 4.544-26.308-3.758s-9.985-20.081-3.758-26.308c6.226-6.227 18.005-4.544 26.308 3.758s9.985 20.08 3.758 26.308z\" fill=\"gray\"></path><path d=\"M255.317 334.089l2.505 2.505-5.011 10.022 10.022-5.011 2.506 2.505-20.044 10.022 10.022-20.043zm15.033 15.035l2.505 2.506-15.033 15.033-2.505-2.505z\" fill=\"#d0d0d0\"></path></g><g fill-rule=\"evenodd\"><path d=\"M236.526 501.297c-6.226-6.226-1.179-21.37 11.275-33.824s27.597-17.5 33.824-11.274c6.227 6.227 1.179 21.37-11.275 33.824s-27.597 17.501-33.824 11.274z\" fill=\"#d0d0d0\"></path><path d=\"M244.038 493.786c-6.227-6.227-4.544-18.006 3.758-26.308s20.081-9.985 26.308-3.758c6.227 6.226 4.544 18.005-3.758 26.308s-20.08 9.985-26.308 3.758z\" fill=\"gray\"></path><path d=\"M275.364 474.997l-2.505 2.505-10.022-5.011 5.011 10.022-2.505 2.506-10.022-20.044 20.043 10.022zm-15.035 15.033l-2.506 2.505-15.033-15.033 2.505-2.505z\" fill=\"#d0d0d0\"></path></g><g fill-rule=\"evenodd\"><path d=\"M108.153 456.206c6.226-6.226 21.37-1.179 33.824 11.275s17.5 27.597 11.274 33.824c-6.227 6.227-21.37 1.179-33.824-11.275s-17.501-27.597-11.274-33.824z\" fill=\"#d0d0d0\"></path><path d=\"M115.664 463.718c6.227-6.227 18.006-4.544 26.308 3.758s9.985 20.081 3.758 26.308c-6.226 6.227-18.005 4.544-26.308-3.758s-9.985-20.08-3.758-26.308z\" fill=\"gray\"></path><path d=\"M134.453 495.044l-2.505-2.505 5.011-10.022-10.022 5.011-2.506-2.505L144.475 475l-10.022 20.043zm-15.033-15.035l-2.505-2.506 15.033-15.033 2.505 2.505z\" fill=\"#d0d0d0\"></path></g><path d=\"M269.29 414.57c0 41.095-34.107 74.409-76.181 74.409s-76.181-33.314-76.181-74.409 34.107-74.409 76.181-74.409 76.181 33.314 76.181 74.409z\" transform=\"matrix(.97674 0 0 1 6.263 0)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"none\"></path><path d=\"M269.29 414.57c0 41.095-34.107 74.409-76.181 74.409s-76.181-33.314-76.181-74.409 34.107-74.409 76.181-74.409 76.181 33.314 76.181 74.409z\" transform=\"matrix(.74419 0 0 .7619 51.172 98.707)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"none\"></path><path d=\"M170.08 474.8a3.543 3.543 0 1 1-7.087 0 3.543 3.543 0 0 1 7.087 0zm56.693 0a3.543 3.543 0 1 1-7.087 0 3.543 3.543 0 0 1 7.087 0zm-34.251.001v3.695h-4.725c-4.724 0-4.724 3.695 0 3.695h4.725v3.694c.016 3.83 4.123 4.291 4.424.299l.3-3.993h4.725c4.724 0 4.724-3.695 0-3.695h-4.725v-3.695c0-3.694-4.724-3.694-4.724 0z\" fill-rule=\"evenodd\" fill=\"#d0d0d0\"></path><path d=\"M180.71 162.99v7.087s-3.362 5.423-24.803 7.086-24.803 0-24.803 0c.559 6.181 4.732 17.896 3.543 31.89.835 16.291-4.103 31.042-4.103 31.042.56.848-2.018 1.279-6.527.848 3.543-3.544 3.134-13.795 3.543-28.347.409-14.553-13.527-36.456-10.63-42.519s63.78-7.087 63.78-7.087z\" fill-rule=\"evenodd\" transform=\"matrix(.33032 0 0 .29556 117.56 374.28)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path d=\"M272.84 162.26c20.858-1.077 55.859-.843 55.859-.843s8.253 18.502 7.91 28.723-3.181 18.919-7.077 14.57 1.805-3.531 2.498-14.57c.692-11.039-6.661-22.479-6.661-22.479s-14.962 7.302-37.466 5.828c-22.503-1.474-12.541-10.791-15.063-11.229z\" fill-rule=\"evenodd\" transform=\"matrix(.33032 0 0 .29556 115.22 366.9)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path d=\"M312.21 273.91c20.858-1.077 34.551 2.498 34.551 2.498s8.253 18.502 7.91 28.723-3.181 18.919-7.077 14.57 1.805-3.531 2.498-14.57c.692-11.039-6.661-22.479-6.661-22.479s-14.962 7.302-37.466 5.828c-22.503-1.474-16.084-2.975-18.606-3.413s-3.131 6.958-37.176 7.992c-34.044 1.033-51.407-7.992-51.407-7.992s-3.362 5.423-24.803 7.086-24.803 0-24.803 0c.559 6.181 4.732 17.896 3.543 31.89.835 16.291-4.103 31.042-4.103 31.042.56.848-2.018 1.279-6.527.848 3.543-3.544 3.134-13.795 3.543-28.347.409-14.553-13.527-36.456-10.63-42.519s18.333-.395 21.26-3.544c2.926-3.149-13.749-25.333-10.63-46.063 3.12-20.731 20.792-14.886 42.52-14.173 21.727.712 69.865 7.003 81.496 0 11.632-7.003 6.598-32.929 17.717-49.606 7.086-10.63 17.716-14.173 28.346-14.173 7.087 0 17.717 28.346 17.717 35.433l-3.544 3.543h-3.543v3.543c-8.088.907-9.216-7.732-14.173-14.173-2.13 9.984 7.086 42.52 7.086 63.78 0 17.716-6.622 25.525-7.038 24.276z\" fill-rule=\"evenodd\" transform=\"matrix(.33032 0 0 .29556 104.56 339.3)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path d=\"M209.06 131.1c.294 7.062-27.384 22.895-29.637 29.164s7.036 9.744 4.163 13.321c-2.872 3.578-5.24 2.251-5.828 2.914-.588.664-10.407-24.56-10.407-24.56s25.961-13.084 24.977-18.733-19.171-9.085-22.479-23.312c-3.309-14.227-1.474-41.71-4.163-47.456-2.689-5.747-34.552-11.23-34.579-19.92-.027-8.69 32.75-32.541 36.293-36.085 3.543-3.543 7.087 3.543 3.543 7.087-3.543 3.543-29.206 25.455-29.206 28.998 0 3.543 21.26 7.086 28.347 7.086 7.086 0 10.63-3.543 10.63-7.086.042-3.066-7.087-3.544-7.087-10.63 0-7.087 3.543-10.63 10.63-10.63 3.543 0 10.356 4.537 10.63 10.63.274 6.092-6.305 6.608-7.087 10.63-.781 4.02 7.087 7.086 14.173 7.086 7.087 0 31.282 20.608 34.825 24.152 3.544 3.544 7.087 3.543 3.544 7.087-3.543 3.543-1.468 7.738-5.012 4.195-3.017-3.423-3.543-7.087-3.543-7.087-.306-3.22-26.27-17.716-29.814-14.173-3.543 3.543 0 46.064 0 49.606 0 7.086 7.381 7.062 7.087 17.716z\" fill-rule=\"evenodd\" transform=\"matrix(.33032 0 0 .29556 116.1 372.43)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path fill-rule=\"evenodd\" fill=\"#a7a7a7\" d=\"M170.23 386.9h14.045v14.662H170.23z\"></path><rect transform=\"matrix(.5544 .83225 -.88236 .47057 0 0)\" fill-rule=\"evenodd\" rx=\"1.27\" ry=\".57\" height=\"1.139\" width=\"87.553\" y=\"64.582\" x=\"405.61\" fill=\"gray\"></rect><path d=\"M180.71 42.52a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z\" fill-rule=\"evenodd\" transform=\"matrix(.33032 0 0 .29556 114.05 362.81)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path d=\"M214.7 394.443c0 .867-5.434 1.886-11.705 1.886s-11.704-1.019-11.704-1.886c0-.868 5.433 1.257 11.704 1.257s11.705-2.125 11.705-1.257z\" fill-rule=\"evenodd\" fill=\"gray\"></path><path fill-rule=\"evenodd\" fill=\"#a7a7a7\" d=\"M171.4 401.56h11.704v4.189H171.4z\"></path><path d=\"M209.453 391.243c-1.135 2.126-2.212 3.643-2.405 3.388-.194-.254.57-2.184 1.704-4.31 1.135-2.125 2.212-3.642 2.405-3.388.193.255-.57 2.184-1.704 4.31zm2.979 5.497c-1.292 1.134-2.369 1.868-2.405 1.64-.037-.229.982-1.333 2.274-2.467 1.292-1.134 2.37-1.868 2.406-1.64.036.229-.982 1.333-2.275 2.467z\" fill-rule=\"evenodd\" fill=\"gray\"></path><path d=\"M210.927 394.09c.953 1.733 1.581 3.2 1.403 3.276-.178.076-1.095-1.267-2.048-3-.953-1.734-1.581-3.201-1.403-3.277.178-.076 1.095 1.267 2.048 3zm-.91 9.04c0 .29-3.668.524-8.193.524s-8.193-.234-8.193-.524c0-.289 3.669-.523 8.193-.523 4.525 0 8.193.234 8.193.523zm-26.91-1.049c0 .29-2.62.524-5.853.524-3.232 0-5.852-.235-5.852-.524 0-.29 2.62-.524 5.852-.524s5.853.235 5.853.524z\" fill-rule=\"evenodd\" fill=\"gray\"></path><path d=\"M375.49 171.92s8.938 36.133 47.04 36.633 51.215-10.838 35.8-29.972-44.084-13.182-40.379 3.33-10.752 22.019-14.154 10.407c-3.401-11.611-17.045-45.99 7.493-48.289 24.539-2.299 76.511-14.817 89.501 9.159 12.991 23.975-14.675 45.707 6.244 50.786 20.92 5.079 23.893-5.809 59.896-9.094 36.004-3.286 49.742 11.102 62.076 9.094 12.334-2.007 10.59-37.258.832-46.207-9.758-8.95-28.5-10.586-33.303-20.398-4.802-9.812-17.87-1.825-16.651-12.905s18.53 7.625 18.733 1.966c.006-.177 2.858-3.93 3.434-4.878-2.178-.828-3.421.512-5.056 1.948 1.775-2.36 1.665-3.448 2.26-5.378-.31-.727-2.461 2.734-2.825 2.011s2.505-5.632 1.206-3.852c-.45.513-3.872 3.329-3.91 1.389.058-.787 1.789-2.813 1.177-3.912-.493-.914-3.093 1.064-3.428 1.29 1.487-3.309 1.382-3.269-.048-5.721-1.249-2.452-2.16-2.395-4.2.374.849-3.979 1.08-4.821-.969-6.329-1.685-1.521-1.76-2.956-3.856 4.162.798-7.618-1.343-7.95-.454-11.562.529-3.312 3.323-4.71 7.927-3.978 8.945.13 13.728 17.954 16.651 17.9 2.924-.054 6.196-18.882 18.733-11.24 12.537 7.643 14.085 9.202 20.398 13.738 6.313 4.535-4.435 11.457-.833 20.398 3.602 8.94 28.229 38.804 21.231 69.935-6.999 31.131-25.026 36.055-26.642 49.538-1.617 13.483 57.067 7.951 72.017 12.49 14.949 4.536 24.375 23.11 24.977 26.224s-26.226 2.914-26.226 2.914-13.776-11.837-46.624-12.904c-32.847-1.068-45.355-23.109-57.651-25.87s-38.501 4.63-53.149 3.542c-14.649-1.087-29.488-4.943-38.976-7.086-9.489-2.142-56.693 35.433-56.529 44.184-9.84-.62-33.009-2.709-32.054-1.665.955 1.043 4.152-17.038 22.214-20.216 18.061-3.179 35.645-17.573 35.062-27.025-.583-9.45 3.487-41.876 4.995-55.782s8.27-20.616 6.661-27.89c-1.609-7.275-22.244-14.779-42.045-14.57-19.801.208-41.77 2.056-44.959 9.99-3.188 7.934-.781 30.964 3.331 28.308 4.111-2.657-.994-17.712 3.33-20.815 4.324-3.102 15.405-5.843 25.809-6.244 10.405-.4 28.494 14.73 28.308 19.565-.186 4.837 5.821 20.934-2.498 27.06-8.318 6.123-25.332 8.861-41.628 7.492-16.297-1.369-32.786-10.674-38.715-16.65-5.928-5.978-9.574-24.146-9.574-25.395z\" fill-rule=\"evenodd\" transform=\"matrix(.21598 0 0 .12989 76.265 416.17)\" stroke=\"gray\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path d=\"M209.473 431.552a.94.94 0 1 1-1.879 0 .94.94 0 0 1 1.879 0z\" fill-rule=\"evenodd\"></path><path d=\"M253.616 417.966l4.558.982 7.612-5.21-.59 2.736-3.965 2.649c-.74.486-1.471.931-2.192 1.334.452.632.953 1.386 1.5 2.265l2.454 3.974-.565 2.618-4.74-8.117-4.557-.982.485-2.25zm-7.756-33.513l8.816-4.06-2.395-5.202 1.18-.543 5.762 12.511-1.18.544-2.405-5.221-8.816 4.06-.962-2.09zm-13.663-16.616l8.116-7.432 1.594 1.74-.21 12.566 6.374-5.835 1.489 1.626-8.117 7.433-1.593-1.74.213-12.573-6.378 5.84-1.488-1.625zm-35.469-14.325l1.331-10.925 2.282.278-1.174 9.635 8.498 1.036-.157 1.29-10.78-1.314zm-17.447 1.578l-1.97-10.828 2.264-.412 1.737 9.55 8.42-1.531.233 1.278-10.684 1.943zm-32.257 15.904l-.807-1.008 5.743-4.608 2.553 3.189a16.252 16.252 0 0 1-1.922 3.193 16.018 16.018 0 0 1-2.622 2.647c-1.331 1.066-2.688 1.857-4.067 2.372-1.378.506-2.617.64-3.72.4-1.102-.239-1.992-.78-2.668-1.624-.669-.836-1.018-1.835-1.049-2.997-.025-1.172.339-2.348 1.093-3.53.755-1.18 1.808-2.312 3.16-3.395.981-.785 1.946-1.392 2.899-1.822.956-.437 1.803-.657 2.54-.659.74 0 1.457.194 2.154.585l-1.394 1.578c-.554-.275-1.082-.416-1.585-.423-.502-.009-1.095.138-1.774.439a9.151 9.151 0 0 0-2.054 1.268c-.82.656-1.463 1.305-1.934 1.944-.474.636-.793 1.231-.956 1.785-.158.55-.214 1.06-.171 1.53.08.81.37 1.524.866 2.145.614.766 1.332 1.241 2.159 1.426.832.179 1.747.075 2.742-.311.996-.387 1.943-.94 2.837-1.656a11.848 11.848 0 0 0 2.05-2.103c.588-.784.987-1.439 1.198-1.959l-1.281-1.6-3.99 3.194zm-.349 79.128l-8.974 6.372-6.789-9.56 1.06-.752 5.457 7.685 2.778-1.973-4.722-6.65 1.06-.753 4.722 6.65 4.076-2.894 1.332 1.875zm-13.23-14.318c1.276-.36 2.131-1.183 2.562-2.472.426-1.295.408-2.76-.054-4.396-.47-1.664-1.227-2.929-2.271-3.792-1.048-.871-2.252-1.114-3.616-.73-.861.244-1.548.688-2.057 1.332-.517.64-.826 1.453-.926 2.442-.107.984-.006 2.026.306 3.13.442 1.566 1.166 2.82 2.169 3.76.997.934 2.293 1.176 3.887.726zm.623 2.287c-1.758.497-3.344.14-4.757-1.071-1.418-1.209-2.46-2.994-3.125-5.35-.436-1.544-.596-3.003-.479-4.375s.504-2.498 1.16-3.382a4.656 4.656 0 0 1 2.563-1.783c1.074-.303 2.131-.23 3.172.213 1.041.446 1.958 1.235 2.75 2.364.788 1.135 1.388 2.427 1.797 3.879.445 1.575.6 3.052.47 4.425-.132 1.377-.524 2.503-1.178 3.377-.653.874-1.444 1.441-2.373 1.703zm.922-22.339l-11.003-.248.173-7.705c.035-1.55.162-2.724.381-3.525.213-.803.575-1.438 1.086-1.908.512-.47 1.07-.7 1.676-.687.78.018 1.43.433 1.947 1.242.517.811.83 2.051.937 3.72.198-.602.392-1.06.58-1.372a9.76 9.76 0 0 1 1.505-1.877l3.063-2.954-.065 2.892-2.34 2.249c-.677.656-1.194 1.197-1.555 1.624-.36.427-.613.812-.762 1.156a4.602 4.602 0 0 0-.315 1.038c-.042.26-.068.686-.082 1.277l-.06 2.668 4.886.11-.052 2.3zm-6.095-2.438l.111-4.944c.024-1.05-.024-1.873-.147-2.468-.126-.597-.336-1.053-.63-1.367-.298-.316-.625-.477-.98-.485-.52-.012-.955.28-1.304.873-.349.585-.538 1.52-.567 2.808l-.124 5.5 3.64.083zm30.573-48.416l.075-12.871 2.127-1.273 11.756 5.79-2.248 1.346-3.451-1.818-6.236 3.732.074 3.84-2.097 1.254zm1.983-6.453l5.055-3.026-3.12-1.684c-.952-.51-1.695-.953-2.231-1.324.173.717.265 1.48.275 2.284l.02 3.75zm53.155-3.443l11.876-4.965 2 1.458-.73 13.085-2.118-1.543.324-3.888-5.874-4.28-3.505 1.57-1.973-1.437zm6.715-.7l4.762 3.47.328-3.532c.1-1.074.215-1.931.348-2.57-.596.438-1.26.821-1.995 1.147l-3.443 1.486zm29.427 40.974l10.703-2.562 1.794 7.495c.36 1.506.537 2.674.53 3.507-.003.828-.19 1.535-.566 2.122-.375.585-.856.948-1.445 1.089-.759.181-1.492-.054-2.2-.706-.705-.65-1.324-1.772-1.853-3.36-.038.635-.108 1.129-.21 1.478a9.746 9.746 0 0 1-.98 2.196l-2.209 3.637-.673-2.812 1.692-2.77c.486-.807.848-1.464 1.089-1.967.239-.504.385-.943.442-1.314a4.56 4.56 0 0 0 .041-1.081c-.026-.263-.11-.682-.247-1.258l-.62-2.594-4.753 1.137-.535-2.237zm6.515.806l1.15 4.807c.245 1.024.501 1.807.771 2.352.274.544.593.93.958 1.161.368.228.725.3 1.07.218.506-.12.852-.512 1.04-1.174.188-.655.132-1.61-.168-2.863l-1.28-5.348-3.541.847z\" fill=\"#d0d0d0\"></path></g>", 2)
const DpFlagMTvue_type_template_id_7657cf9c_hoisted_4 = [
  DpFlagMTvue_type_template_id_7657cf9c_hoisted_2
]
const DpFlagMTvue_type_template_id_7657cf9c_hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagMTvue_type_template_id_7657cf9c_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#ce0000\" d=\"M320 0h320v480H320z\"></path><path fill=\"#fff\" d=\"M0 0h320v480H0z\"></path></g><g transform=\"translate(-12.38 -30.751) scale(1.5986)\"><path d=\"M104.824 108.068c0 .81-.918 1.466-2.049 1.466-1.131 0-2.049-.656-2.049-1.466 0-.81.918-1.466 2.049-1.466 1.131 0 2.049.656 2.049 1.466z\" fill-rule=\"evenodd\" fill=\"#f1eeee\"></path><path d=\"M40.727 100.98v37.209h37.211c0 6.2 6.202 12.402 12.404 12.402v37.207h37.208v-37.207c6.202 0 12.404-6.202 12.404-12.402h37.211V100.98h-37.211c0-6.2-6.202-12.402-12.404-12.402V51.371H90.342v37.207c-6.202 0-12.404 6.202-12.404 12.402H40.727z\" fill-rule=\"evenodd\" fill=\"#c00\"></path><path d=\"M41.969 102.22v34.727H79.18c0 6.2 6.2 12.404 12.402 12.404v37.207h34.73v-37.207c6.202 0 12.402-6.204 12.402-12.404h37.211V102.22h-37.211c0-6.2-6.2-12.404-12.402-12.404V52.609h-34.73v37.207c-6.202 0-12.402 6.204-12.402 12.404H41.969z\" fill-rule=\"evenodd\" fill=\"#ffe600\"></path><path d=\"M43.209 103.46v32.249h37.208c0 6.2 6.202 12.402 12.404 12.402v37.207h32.248v-37.207c6.202 0 12.404-6.202 12.404-12.402h37.208V103.46h-37.208c0-6.2-6.202-12.402-12.404-12.402V53.851H92.821v37.207c-6.202 0-12.404 6.202-12.404 12.402H43.209z\" fill-rule=\"evenodd\" fill=\"#707070\"></path><path d=\"M44.45 104.7v29.766h37.208c0 6.2 6.202 12.404 12.404 12.404v37.207h29.767V146.87c6.202 0 12.404-6.204 12.404-12.404h37.208V104.7h-37.208c0-6.2-6.202-12.402-12.404-12.402V55.091H94.062v37.207c-6.202 0-12.404 6.202-12.404 12.402H44.45z\" fill-rule=\"evenodd\" fill=\"#a0a0a0\"></path><g fill-rule=\"evenodd\"><path d=\"M94.37 89.223c2.179 2.18.412 7.48-3.947 11.84s-9.66 6.125-11.84 3.946c-2.18-2.18-.413-7.48 3.946-11.84s9.66-6.126 11.84-3.946z\" fill=\"#d0d0d0\"></path><path d=\"M91.74 91.852c2.18 2.18 1.59 6.303-1.316 9.209s-7.03 3.495-9.209 1.315c-2.18-2.18-1.59-6.302 1.316-9.208s7.029-3.495 9.209-1.316z\" fill=\"gray\"></path><path d=\"M80.774 98.429l.877-.877 3.508 1.754-1.754-3.508.877-.877 3.508 7.016-7.016-3.508zm5.263-5.262l.877-.877 5.263 5.262-.877.877z\" fill=\"#d0d0d0\"></path></g><g fill-rule=\"evenodd\"><path d=\"M139.308 105.009c-2.18 2.18-7.481.412-11.84-3.947s-6.127-9.66-3.947-11.84c2.18-2.179 7.48-.412 11.84 3.947s6.126 9.66 3.947 11.84z\" fill=\"#d0d0d0\"></path><path d=\"M136.678 102.38c-2.18 2.179-6.303 1.59-9.209-1.316s-3.495-7.03-1.315-9.209c2.18-2.18 6.302-1.59 9.209 1.316s3.495 7.029 1.315 9.208z\" fill=\"gray\"></path><path d=\"M130.101 91.414l.877.877-1.754 3.508 3.508-1.754.877.877-7.016 3.508 3.508-7.016zm5.262 5.263l.877.877-5.262 5.262-.877-.877z\" fill=\"#d0d0d0\"></path></g><g fill-rule=\"evenodd\"><path d=\"M123.52 149.947c-2.179-2.18-.412-7.48 3.947-11.84s9.66-6.125 11.84-3.946c2.18 2.18.413 7.48-3.946 11.84s-9.66 6.126-11.84 3.946z\" fill=\"#d0d0d0\"></path><path d=\"M126.15 147.318c-2.18-2.18-1.59-6.303 1.316-9.209s7.03-3.495 9.209-1.315c2.18 2.18 1.59 6.302-1.316 9.208s-7.029 3.495-9.209 1.316z\" fill=\"gray\"></path><path d=\"M137.116 140.741l-.877.877-3.508-1.754 1.754 3.508-.877.877-3.508-7.016 7.016 3.508zm-5.263 5.262l-.877.877-5.263-5.262.877-.877z\" fill=\"#d0d0d0\"></path></g><g fill-rule=\"evenodd\"><path d=\"M78.585 134.157c2.18-2.18 7.481-.412 11.84 3.947s6.127 9.66 3.947 11.84c-2.18 2.179-7.48.412-11.84-3.947s-6.126-9.66-3.947-11.84z\" fill=\"#d0d0d0\"></path><path d=\"M81.215 136.787c2.18-2.18 6.303-1.59 9.209 1.315s3.495 7.03 1.315 9.209c-2.18 2.18-6.302 1.59-9.209-1.316s-3.495-7.029-1.315-9.208z\" fill=\"gray\"></path><path d=\"M87.792 147.752l-.877-.877 1.754-3.508-3.508 1.754-.877-.877 7.016-3.508-3.508 7.016zm-5.262-5.263l-.877-.877 5.262-5.262.877.877z\" fill=\"#d0d0d0\"></path></g><path d=\"M269.29 414.57c0 41.095-34.107 74.409-76.181 74.409s-76.181-33.314-76.181-74.409 34.107-74.409 76.181-74.409 76.181 33.314 76.181 74.409z\" transform=\"matrix(.34191 0 0 .35003 42.921 -25.527)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"none\"></path><path d=\"M269.29 414.57c0 41.095-34.107 74.409-76.181 74.409s-76.181-33.314-76.181-74.409 34.107-74.409 76.181-74.409 76.181 33.314 76.181 74.409z\" transform=\"matrix(.2605 0 0 .26669 58.641 9.023)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"none\"></path><path d=\"M100.265 140.667a1.24 1.24 0 1 1-2.481 0 1.24 1.24 0 0 1 2.48 0zm19.845 0a1.24 1.24 0 1 1-2.48 0 1.24 1.24 0 0 1 2.48 0zm-11.99.003v1.293h-1.654c-1.654 0-1.654 1.293 0 1.293h1.654v1.294c.006 1.34 1.443 1.502 1.549.104l.105-1.398h1.654c1.653 0 1.653-1.293 0-1.293h-1.654v-1.293c0-1.293-1.654-1.293-1.654 0z\" fill-rule=\"evenodd\" fill=\"#d0d0d0\"></path><path d=\"M102.77 122.35v.733s-.389.561-2.868.733c-2.48.172-2.868 0-2.868 0 .065.64.547 1.852.41 3.3.096 1.685-.475 3.21-.475 3.21.065.089-.233.133-.754.089.41-.367.362-1.428.41-2.933.047-1.506-1.565-3.772-1.23-4.399.335-.627 7.375-.733 7.375-.733zm9.84-2.66c2.412-.111 6.459-.087 6.459-.087s.954 1.914.915 2.971c-.04 1.058-.368 1.958-.819 1.508-.45-.45.209-.366.29-1.508.08-1.142-.771-2.325-.771-2.325s-1.73.755-4.332.603c-2.602-.153-1.45-1.117-1.742-1.162z\" fill-rule=\"evenodd\" stroke=\"#707070\" stroke-width=\".146\" fill=\"#d0d0d0\"></path><path d=\"M113.43 121.58c2.412-.111 3.995.258 3.995.258s.954 1.915.915 2.972c-.04 1.057-.368 1.957-.819 1.507-.45-.45.21-.365.29-1.507.08-1.142-.771-2.326-.771-2.326s-1.73.756-4.332.603c-2.602-.152-1.86-.308-2.152-.353-.291-.045-.362.72-4.298.827-3.937.107-5.944-.827-5.944-.827s-.39.561-2.868.733c-2.48.172-2.868 0-2.868 0 .064.64.547 1.852.41 3.3.096 1.685-.475 3.21-.475 3.21.065.089-.233.133-.755.089.41-.367.363-1.428.41-2.933.047-1.506-1.564-3.772-1.23-4.399.336-.627 2.12-.04 2.46-.366.337-.326-1.59-2.621-1.23-4.766.36-2.145 2.404-1.54 4.917-1.466 2.512.074 8.078.724 9.423 0 1.345-.725.763-3.407 2.049-5.132.819-1.1 2.048-1.466 3.277-1.466.82 0 2.049 2.932 2.049 3.665l-.41.367h-.41v.366c-.935.094-1.065-.8-1.639-1.466-.246 1.033.82 4.4.82 6.598 0 1.833-.766 2.641-.814 2.512z\" fill-rule=\"evenodd\" stroke=\"#707070\" stroke-width=\".146\" fill=\"#d0d0d0\"></path><path d=\"M105.54 118.4c.034.73-3.166 2.369-3.427 3.017-.26.649.814 1.008.481 1.378-.332.37-.605.233-.673.302-.068.068-1.204-2.541-1.204-2.541s3.002-1.354 2.888-1.938c-.114-.585-2.216-.94-2.599-2.412s-.17-4.315-.481-4.91c-.311-.594-3.995-1.161-3.999-2.06-.003-.9 3.787-3.367 4.197-3.733.41-.367.82.366.41.733-.41.366-3.377 2.633-3.377 3 0 .366 2.458.733 3.277.733.82 0 1.23-.367 1.23-.733.004-.317-.82-.367-.82-1.1s.41-1.1 1.229-1.1c.41 0 1.197.47 1.229 1.1s-.729.684-.82 1.1c-.09.416.82.733 1.64.733.819 0 3.616 2.132 4.026 2.499.41.366.82.366.41.733-.41.366-.17.8-.58.434a1.503 1.503 0 0 1-.41-.733c-.035-.334-3.037-1.833-3.447-1.467-.41.367 0 4.766 0 5.132 0 .733.854.73.82 1.833z\" fill-rule=\"evenodd\" stroke=\"#707070\" stroke-width=\".146\" fill=\"#d0d0d0\"></path><path fill-rule=\"evenodd\" fill=\"#a7a7a7\" d=\"M100.32 109.9h4.917v5.132h-4.917z\"></path><rect transform=\"matrix(.55442 .83223 -.88237 .47055 0 0)\" fill-rule=\"evenodd\" rx=\".445\" ry=\".199\" height=\".399\" width=\"30.647\" y=\"-25.672\" x=\"138.6\" fill=\"gray\"></rect><path d=\"M180.71 42.52a7.087 7.087 0 1 1-14.173 0 7.087 7.087 0 0 1 14.173 0z\" fill-rule=\"evenodd\" transform=\"matrix(.11563 0 0 .10345 80.65 101.47)\" stroke=\"#707070\" stroke-width=\"1pt\" fill=\"#d0d0d0\"></path><path d=\"M115.88 112.54c0 .304-1.902.66-4.097.66-2.195 0-4.097-.356-4.097-.66 0-.304 1.902.44 4.097.44 2.195 0 4.097-.744 4.097-.44z\" fill-rule=\"evenodd\" fill=\"gray\"></path><path fill-rule=\"evenodd\" fill=\"#a7a7a7\" d=\"M100.73 115.03h4.097v1.466h-4.097z\"></path><path d=\"M114.048 111.417c-.397.744-.774 1.275-.841 1.186-.068-.089.199-.764.596-1.508.397-.744.774-1.275.842-1.186.068.089-.2.764-.597 1.508zm1.035 1.926c-.452.397-.83.654-.842.574-.013-.08.344-.466.796-.863.453-.397.83-.654.842-.574.013.08-.343.466-.796.863z\" fill-rule=\"evenodd\" fill=\"gray\"></path><path d=\"M114.564 112.414c.333.606.553 1.12.491 1.146-.062.027-.383-.443-.717-1.05-.334-.607-.553-1.12-.491-1.147.062-.027.383.444.717 1.05zm-.32 3.169c0 .1-1.284.183-2.868.183s-2.867-.082-2.867-.183c0-.102 1.284-.184 2.867-.184 1.584 0 2.868.082 2.868.184zm-9.42-.368c0 .102-.918.184-2.049.184-1.131 0-2.049-.082-2.049-.184 0-.1.918-.183 2.049-.183 1.131 0 2.049.082 2.049.183z\" fill-rule=\"evenodd\" fill=\"gray\"></path><path d=\"M95.813 127.96s.676 1.643 3.556 1.666c2.881.022 3.872-.493 2.707-1.363s-3.333-.6-3.053.151c.28.751-.813 1.001-1.07.473-.257-.527-1.289-2.09.567-2.195 1.855-.105 5.784-.674 6.766.416.982 1.09-1.11 2.078.472 2.31 1.582.23 1.807-.265 4.528-.414 2.722-.15 3.761.505 4.694.413.932-.09.8-1.694.062-2.1-.737-.407-2.154-.482-2.517-.928-.363-.446-1.351-.083-1.26-.587.093-.503 1.402.347 1.417.09 0-.008.216-.179.26-.222-.165-.038-.259.023-.383.089.135-.108.126-.157.171-.245-.023-.033-.186.124-.213.092-.028-.033.19-.257.09-.176-.033.024-.292.152-.295.064.004-.036.136-.128.09-.178-.038-.042-.235.048-.26.058.113-.15.105-.148-.004-.26-.094-.111-.163-.109-.317.017.064-.18.081-.219-.074-.287-.127-.07-.133-.135-.291.189.06-.347-.102-.362-.035-.526.04-.15.252-.214.6-.18.676.005 1.038.816 1.259.813.22-.002.468-.858 1.416-.51.948.347 1.065.417 1.542.624.477.206-.335.52-.063.927.273.407 2.134 1.764 1.605 3.18-.529 1.415-1.892 1.64-2.014 2.252-.122.613 4.314.362 5.445.568 1.13.206 1.843 1.05 1.888 1.192.046.142-1.983.133-1.983.133s-1.041-.538-3.525-.587c-2.483-.049-3.429-1.05-4.358-1.176-.93-.126-2.911.21-4.018.16-1.108-.049-2.23-.224-2.947-.321-.717-.098-4.286 1.61-4.274 2.009-.744-.029-2.495-.124-2.423-.076.072.047.314-.775 1.68-.92 1.365-.144 2.694-.798 2.65-1.228-.044-.43.264-1.904.378-2.536.114-.632.625-.938.503-1.268-.122-.331-1.682-.672-3.179-.663-1.497.01-3.157.094-3.399.454-.24.361-.059 1.408.252 1.287.311-.12-.075-.805.252-.946.327-.14 1.165-.266 1.951-.284.787-.018 2.154.67 2.14.89-.014.22.44.952-.188 1.23-.63.279-1.916.403-3.148.34-1.232-.061-2.478-.485-2.927-.756-.448-.272-.723-1.098-.723-1.155z\" fill-rule=\"evenodd\" stroke=\"gray\" stroke-width=\".078\" fill=\"#d0d0d0\"></path><path d=\"M114.053 125.53a.329.329 0 1 1-.657 0 .329.329 0 0 1 .657 0z\" fill-rule=\"evenodd\"></path><path d=\"M129.51 120.77l1.595.344 2.665-1.824-.206.958-1.389.927c-.258.17-.514.326-.767.467.158.221.334.485.525.793l.86 1.39-.198.917-1.66-2.84-1.595-.345.17-.787zm-2.72-11.73l3.086-1.421-.838-1.82.413-.191 2.017 4.38-.413.19-.842-1.828-3.086 1.421-.337-.731zm-4.78-5.81l2.841-2.602.558.61-.073 4.398 2.23-2.042.522.569-2.841 2.602-.558-.61.075-4.4-2.233 2.044-.52-.569zm-12.42-5.016l.466-3.824.799.097-.411 3.373 2.974.362-.055.452-3.773-.46zm-6.11.548l-.69-3.79.793-.144.608 3.342 2.947-.536.082.448-3.74.68zm-11.282 5.568l-.283-.353 2.01-1.613.894 1.116a5.69 5.69 0 0 1-.673 1.118 5.66 5.66 0 0 1-.917.927c-.466.373-.941.65-1.424.83-.482.177-.916.224-1.302.14a1.59 1.59 0 0 1-.934-.569 1.702 1.702 0 0 1-.367-1.049c-.009-.41.119-.822.383-1.235.264-.414.632-.81 1.106-1.189a4.786 4.786 0 0 1 1.014-.637c.335-.153.632-.23.89-.231.258 0 .51.068.754.205l-.488.552a1.293 1.293 0 0 0-.555-.148c-.176-.003-.383.048-.621.153a3.203 3.203 0 0 0-.719.444c-.287.23-.512.457-.677.681-.166.222-.278.43-.335.625-.055.192-.075.37-.06.536.028.283.13.533.304.75.214.268.466.435.755.5.292.062.612.026.96-.11.349-.135.68-.329.993-.58.272-.217.512-.463.718-.735.206-.275.345-.504.42-.686l-.45-.56-1.396 1.118zm-.13 27.7l-3.141 2.23-2.377-3.346.371-.263 1.91 2.69.973-.69-1.653-2.329.37-.263 1.654 2.328 1.427-1.013.466.656zm-4.627-5.01c.447-.126.746-.414.897-.866.149-.453.143-.965-.02-1.538-.164-.583-.429-1.025-.794-1.328-.367-.304-.788-.39-1.266-.255a1.36 1.36 0 0 0-.72.466c-.18.224-.289.509-.324.855-.037.345-.002.71.107 1.096.155.548.408.987.76 1.316.348.327.802.412 1.36.254zm.218.8c-.615.174-1.17.05-1.665-.375-.496-.423-.861-1.047-1.094-1.872-.152-.54-.209-1.051-.167-1.531s.176-.875.405-1.184a1.63 1.63 0 0 1 .898-.624 1.629 1.629 0 0 1 1.11.074c.364.156.686.432.963.828.276.397.485.849.629 1.357.156.552.21 1.068.164 1.55-.046.481-.183.875-.412 1.181-.229.306-.506.505-.83.597zm.322-7.82l-3.852-.087.061-2.697c.013-.542.057-.953.134-1.234.074-.28.2-.503.38-.668a.821.821 0 0 1 .586-.24c.273.006.5.151.682.435.18.284.29.718.328 1.302.07-.21.137-.371.203-.48.141-.232.317-.452.527-.657l1.072-1.034-.023 1.012-.82.787c-.236.23-.417.42-.543.569a1.7 1.7 0 0 0-.267.404c-.052.118-.088.24-.11.363-.015.092-.024.24-.029.447l-.021.934 1.71.04-.018.804zm-2.134-.853l.04-1.731a4.067 4.067 0 0 0-.052-.864c-.044-.209-.118-.368-.22-.478a.48.48 0 0 0-.344-.17c-.182-.004-.334.098-.456.306-.122.204-.188.531-.198.982l-.044 1.926 1.274.029zM96.55 102.2l.026-4.505.745-.446 4.115 2.027-.787.47-1.208-.636-2.183 1.307.026 1.344-.734.439zm.694-2.259l1.77-1.059-1.093-.59a8.264 8.264 0 0 1-.78-.463c.06.251.092.518.096.8l.007 1.312zm18.606-1.207l4.157-1.738.7.51-.255 4.58-.741-.54.113-1.36-2.056-1.498-1.227.55-.691-.504zm2.35-.245l1.667 1.215.115-1.237a8.44 8.44 0 0 1 .122-.9 3.692 3.692 0 0 1-.698.402l-1.205.52zm10.3 14.341l3.747-.897.628 2.624c.126.527.188.936.185 1.227 0 .29-.067.538-.198.743a.82.82 0 0 1-.506.381c-.265.064-.522-.019-.77-.247-.247-.228-.463-.62-.648-1.176a2.463 2.463 0 0 1-.074.517c-.078.26-.192.517-.343.769l-.773 1.273-.236-.984.592-.97c.17-.282.297-.512.382-.688.083-.177.135-.33.154-.46.02-.127.025-.253.015-.379a3.717 3.717 0 0 0-.087-.44l-.217-.908-1.664.398-.187-.783zm2.28.282l.403 1.683c.086.358.176.632.27.823.096.19.208.326.335.406.13.08.254.106.375.077.177-.043.298-.18.364-.411.066-.23.046-.563-.059-1.002l-.448-1.872-1.24.296z\" fill=\"#d0d0d0\"></path></g>", 2)
const DpFlagMTvue_type_template_id_7657cf9c_hoisted_8 = [
  DpFlagMTvue_type_template_id_7657cf9c_hoisted_6
]

function DpFlagMTvue_type_template_id_7657cf9c_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagMTvue_type_template_id_7657cf9c_hoisted_1, DpFlagMTvue_type_template_id_7657cf9c_hoisted_4))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagMTvue_type_template_id_7657cf9c_hoisted_5, DpFlagMTvue_type_template_id_7657cf9c_hoisted_8))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagMT.vue?vue&type=template&id=7657cf9c

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagMT.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagMTvue_type_script_lang_js = ({
  name: "DpFlagMT",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagMT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagMT.vue




;
const DpFlagMT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagMTvue_type_script_lang_js, [['render',DpFlagMTvue_type_template_id_7657cf9c_render]])

/* harmony default export */ var DpFlagMT = (DpFlagMT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagNL.vue?vue&type=template&id=75333557


const DpFlagNLvue_type_template_id_75333557_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagNLvue_type_template_id_75333557_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt",
  transform: "scale(.48166 .71932)"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "708.66",
    width: "1063",
    fill: "#fff"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "236.22",
    width: "1063",
    y: "475.56",
    fill: "#21468b"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ae1c28",
    d: "M0 0h1063v236.22H0z"
  })
], -1)
const DpFlagNLvue_type_template_id_75333557_hoisted_3 = [
  DpFlagNLvue_type_template_id_75333557_hoisted_2
]
const DpFlagNLvue_type_template_id_75333557_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagNLvue_type_template_id_75333557_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt",
  transform: "scale(1.25 .9375)"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "509.76",
    width: "512",
    fill: "#fff"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
    rx: "0",
    ry: "0",
    height: "169.92",
    width: "512",
    y: "342.08",
    fill: "#21468b"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ae1c28",
    d: "M0 0h512v169.92H0z"
  })
], -1)
const DpFlagNLvue_type_template_id_75333557_hoisted_6 = [
  DpFlagNLvue_type_template_id_75333557_hoisted_5
]

function DpFlagNLvue_type_template_id_75333557_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagNLvue_type_template_id_75333557_hoisted_1, DpFlagNLvue_type_template_id_75333557_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagNLvue_type_template_id_75333557_hoisted_4, DpFlagNLvue_type_template_id_75333557_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagNL.vue?vue&type=template&id=75333557

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagNL.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagNLvue_type_script_lang_js = ({
  name: "DpFlagNL",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagNL.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagNL.vue




;
const DpFlagNL_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagNLvue_type_script_lang_js, [['render',DpFlagNLvue_type_template_id_75333557_render]])

/* harmony default export */ var DpFlagNL = (DpFlagNL_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagPL.vue?vue&type=template&id=6a73dae2


const DpFlagPLvue_type_template_id_6a73dae2_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagPLvue_type_template_id_6a73dae2_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#e9e8e7",
    d: "M512 512H0V0h512z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d4213d",
    d: "M512 512H0V256h512z"
  })
], -1)
const DpFlagPLvue_type_template_id_6a73dae2_hoisted_3 = [
  DpFlagPLvue_type_template_id_6a73dae2_hoisted_2
]
const DpFlagPLvue_type_template_id_6a73dae2_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagPLvue_type_template_id_6a73dae2_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#e9e8e7",
    d: "M640 480H0V0h640z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d4213d",
    d: "M640 480H0V240h640z"
  })
], -1)
const DpFlagPLvue_type_template_id_6a73dae2_hoisted_6 = [
  DpFlagPLvue_type_template_id_6a73dae2_hoisted_5
]

function DpFlagPLvue_type_template_id_6a73dae2_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagPLvue_type_template_id_6a73dae2_hoisted_1, DpFlagPLvue_type_template_id_6a73dae2_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagPLvue_type_template_id_6a73dae2_hoisted_4, DpFlagPLvue_type_template_id_6a73dae2_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagPL.vue?vue&type=template&id=6a73dae2

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagPL.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagPLvue_type_script_lang_js = ({
  name: "DpFlagPL",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagPL.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagPL.vue




;
const DpFlagPL_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagPLvue_type_script_lang_js, [['render',DpFlagPLvue_type_template_id_6a73dae2_render]])

/* harmony default export */ var DpFlagPL = (DpFlagPL_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagPT.vue?vue&type=template&id=31fb6751


const DpFlagPTvue_type_template_id_31fb6751_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagPTvue_type_template_id_31fb6751_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"red\" d=\"M204.79 0h307.26v512H204.79z\"></path><path fill=\"#060\" d=\"M-.05 0h204.84v512H-.05z\"></path><g fill=\"#ff0\" fill-rule=\"evenodd\" stroke=\"#000\" stroke-width=\".573\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M293.78 326.588c-34.37-1.036-191.988-99.42-193.07-115.086l8.705-14.515c15.634 22.717 176.765 118.397 192.59 115.006l-8.225 14.59\" stroke-width=\".652\"></path><path d=\"M107.583 195.015c-3.083 8.3 41.13 35.633 94.326 67.987 53.192 32.35 99.06 52.344 102.46 49.477.207-.37 1.672-2.892 1.537-2.872-.637.96-2.188 1.264-4.608.566-14.373-4.145-51.856-21.35-98.276-49.5-46.42-28.152-86.806-54.094-93.083-65.117-.435-.764-.746-2.158-.683-3.24l-.152-.004-1.337 2.337-.184.366zM294.59 327.043c-.584 1.057-1.67 1.093-3.735.866-12.857-1.424-51.87-20.396-98.033-48.03-53.715-32.154-98.077-61.452-93.264-69.11l1.31-2.314.257.08c-4.327 12.977 87.55 65.512 92.96 68.86 53.16 32.936 97.98 52.17 101.945 47.17l-1.443 2.483v-.004z\" stroke-width=\".652\"></path><path d=\"M204.954 220.99c34.403-.27 76.857-4.7 101.29-14.438L300.978 198c-14.442 7.992-57.13 13.248-96.316 14.034-46.35-.426-79.064-4.742-95.456-15.74l-4.97 9.106c30.134 12.75 61.012 15.46 100.717 15.59\" stroke-width=\".652\"></path><path d=\"M307.662 206.746c-.84 1.344-16.775 6.84-40.247 10.894-15.915 2.426-36.675 4.5-62.582 4.526-24.614.023-44.72-1.73-59.943-3.792-24.64-3.864-37.357-9.24-42.058-11.14.45-.893.74-1.52 1.172-2.355 13.534 5.388 26.31 8.637 41.278 10.94 15.122 2.048 34.986 3.825 59.478 3.802 25.787-.026 46.318-2.258 62.14-4.612 24.07-3.882 37.22-8.878 39.065-11.2l1.7 2.936h-.002zm-4.62-8.673c-2.61 2.095-15.608 6.705-38.48 10.357-15.262 2.188-34.67 4.146-59.465 4.17-23.556.023-42.802-1.565-57.44-3.697-23.227-3.033-35.59-8.505-40.045-10.1.443-.767.895-1.528 1.358-2.292 3.468 1.747 15.398 6.59 38.942 9.926 14.472 2.052 33.747 3.58 57.187 3.557 24.677-.025 43.863-2.02 59.03-4.197 22.99-3.163 35.36-9.042 37.237-10.514l1.676 2.79zM91.985 262.44c21.16 11.38 68.158 17.117 112.633 17.51 40.494.066 93.25-6.258 112.978-16.713l-.543-11.39c-6.172 9.644-62.707 18.896-112.875 18.517-50.168-.378-96.754-8.127-112.284-18.157l.09 10.23\" stroke-width=\".652\"></path><path d=\"M318.675 260.8v2.718c-2.964 3.545-21.555 8.903-44.87 12.677-17.743 2.72-40.876 4.772-69.702 4.772-27.385 0-49.223-1.952-66.16-4.552-26.77-3.9-43.894-10.725-47.33-12.763l.014-3.17c10.325 6.866 38.3 11.888 47.692 13.425 16.825 2.583 38.534 4.52 65.782 4.52 28.69 0 51.694-2.038 69.326-4.74 16.727-2.416 40.555-8.7 45.246-12.884zm.012-9.66v2.716c-2.964 3.543-21.556 8.9-44.87 12.674-17.743 2.72-40.877 4.773-69.702 4.773-27.386 0-49.224-1.95-66.16-4.553-26.77-3.896-43.894-10.723-47.33-12.76l.014-3.17c10.324 6.863 38.297 11.886 47.69 13.42 16.826 2.586 38.535 4.525 65.784 4.525 28.69 0 51.694-2.04 69.326-4.744 16.726-2.415 40.555-8.7 45.246-12.883v.002zm-114.165 73.49c-48.665-.29-90.363-13.265-99.17-15.41l6.422 10.052c15.554 6.543 56.234 16.293 93.215 15.213 36.98-1.078 69.3-3.943 92.077-15.03l6.583-10.418c-15.52 7.31-68.344 15.52-99.128 15.594\" stroke-width=\".652\"></path><path d=\"M299.538 317.12a152.554 152.554 0 0 1-2.954 4.358c-10.743 3.788-27.67 7.765-34.813 8.925-14.59 3.007-37.164 5.227-57.2 5.237-43.11-.63-78.398-9.07-95-16.27l-1.34-2.302.22-.346 2.272.88c29.523 10.563 62.68 14.777 94.092 15.534 19.954.07 39.93-2.287 56.083-5.176 24.77-4.963 34.786-8.704 37.86-10.4l.78-.438zm5.708-9.414c.025.03.05.057.075.088a301.968 301.968 0 0 1-2.232 3.712c-5.73 2.048-21.28 6.598-43.985 9.773-14.96 2.037-24.26 4.01-54.02 4.59-55.77-1.42-91.876-12.325-100.454-15.014l-1.272-2.44c32.32 8.438 65.333 14.328 101.726 14.93 27.228-.58 38.812-2.585 53.65-4.608 26.476-4.117 39.816-8.476 43.82-9.735a3.058 3.058 0 0 0-.176-.226l2.87-1.073v.002z\" stroke-width=\".626\"></path><path d=\"M305.83 253.45c.158 32.015-16.225 60.743-29.42 73.416-18.67 17.93-43.422 29.464-72.328 29.996-32.28.593-62.715-20.45-70.878-29.695-15.96-18.074-28.955-41.025-29.372-71.957 1.977-34.94 15.694-59.278 35.576-75.968 19.883-16.69 46.357-24.818 68.405-24.237 25.438.67 55.153 13.15 75.686 37.925 13.45 16.23 19.276 33.846 22.33 60.52zM204.356 143.837c61.992 0 112.977 50.446 112.977 112.302 0 61.854-50.985 112.303-112.977 112.303-61.992 0-112.554-50.447-112.554-112.302 0-61.856 50.562-112.302 112.554-112.302\" stroke-width=\".652\"></path><path d=\"M204.66 143.45c62.046 0 112.65 50.613 112.65 112.666 0 62.052-50.605 112.663-112.65 112.663-62.05 0-112.654-50.61-112.654-112.664 0-62.053 50.606-112.665 112.653-112.665zM94.484 256.117c0 60.6 49.762 110.185 110.174 110.185 60.41 0 110.173-49.585 110.173-110.184 0-60.6-49.763-110.186-110.174-110.186-60.413 0-110.175 49.588-110.175 110.186z\" stroke-width=\".652\"></path><path d=\"M204.75 152.815c56.582 0 103.188 46.445 103.188 103.2 0 56.758-46.607 103.2-103.188 103.2-56.582 0-103.19-46.442-103.19-103.2 0-56.755 46.61-103.2 103.19-103.2zm-100.71 103.2c0 55.393 45.486 100.72 100.71 100.72 55.223 0 100.71-45.327 100.71-100.72 0-55.394-45.486-100.722-100.71-100.722S104.04 200.62 104.04 256.015z\" stroke-width=\".652\"></path><path d=\"M209.29 142.996h-9.655l.01 226.372h9.69z\" stroke-width=\".652\"></path><path d=\"M208.322 141.706h2.458l.02 228.977h-2.46l-.017-228.977zm-9.58.002h2.475l.004 228.977h-2.478V141.708z\" stroke-width=\".652\"></path><path d=\"M317.39 260.477v-8.37l-6.816-6.347-38.684-10.24-55.75-5.69-67.13 3.414-47.787 11.378-9.648 7.145v8.37l24.44-10.964 58.026-9.102h55.752l40.96 4.552 28.445 6.827z\" stroke-width=\".652\"></path><path d=\"M204.704 238.672c26.605-.05 52.418 2.52 72.892 6.507 21.127 4.223 35.996 9.506 41.08 15.44l-.006 2.938c-6.13-7.384-26.138-12.798-41.55-15.893-20.318-3.952-45.958-6.504-72.416-6.455-27.92.052-53.916 2.696-73.937 6.603C114.7 251 93.277 257.333 90.6 263.58v-3.06c1.47-4.323 17.424-10.784 39.805-15.265 20.172-3.933 46.217-6.532 74.3-6.583zm.012-9.663c26.604-.05 52.417 2.522 72.89 6.507 21.13 4.225 35.997 9.507 41.08 15.44l-.005 2.94c-6.13-7.384-26.137-12.798-41.548-15.892-20.32-3.954-45.96-6.506-72.416-6.455-27.92.05-53.79 2.696-73.814 6.6-15.503 2.94-37.804 9.524-40.29 15.77v-3.06c1.468-4.278 17.745-10.97 39.804-15.267 20.172-3.933 46.217-6.53 74.3-6.583zm-.546-49.286c41.925-.21 78.495 5.863 95.226 14.433l6.103 10.558c-14.543-7.837-53.996-15.986-101.27-14.768-38.518.237-79.675 4.24-100.324 15.258l7.286-12.185c16.947-8.79 56.914-13.248 92.98-13.294\" stroke-width=\".652\"></path><path d=\"M204.727 188.44c23.913-.065 47.02 1.284 65.395 4.6 17.113 3.185 33.433 7.965 35.767 10.536l1.808 3.197c-5.675-3.706-19.798-7.832-37.932-11.27-18.21-3.424-41.302-4.558-65.08-4.495-26.99-.093-47.96 1.332-65.957 4.47-19.034 3.56-32.24 8.65-35.496 11.066l1.773-3.38c6.33-3.23 16.372-7.12 33.25-10.16 18.61-3.4 39.802-4.42 66.472-4.565h-.002zm-.01-9.655c22.884-.06 45.48 1.216 63.092 4.382 13.89 2.704 27.627 6.926 32.658 10.682l2.646 4.204c-4.5-5-21.432-9.74-36.38-12.393-17.477-3.013-39.134-4.206-62.018-4.397-24.016.067-46.21 1.538-63.433 4.674-16.43 3.127-27.034 6.83-31.52 9.72l2.327-3.512c6.19-3.26 16.193-6.253 28.79-8.7 17.35-3.16 39.68-4.592 63.837-4.66zm55.966 124.16c-20.728-3.87-41.494-4.432-55.998-4.26-69.868.818-92.438 14.345-95.192 18.44l-5.222-8.51c17.79-12.894 55.835-20.125 100.793-19.385 23.345.382 43.49 1.932 60.438 5.215l-4.82 8.502\" stroke-width=\".652\"></path><path d=\"M204.283 297.483c19.436.29 38.513 1.093 56.927 4.527l-1.334 2.354c-17.102-3.157-35.334-4.365-55.527-4.267-25.786-.2-51.866 2.207-74.572 8.723-7.164 1.994-19.025 6.6-20.234 10.406l-1.327-2.187c.383-2.25 7.55-6.92 20.95-10.685 26.01-7.448 50.335-8.703 75.116-8.874v.004zm.882-9.78c20.137.376 40.932 1.307 61.144 5.31l-1.39 2.45c-18.252-3.622-35.69-4.83-59.636-5.198-25.867.047-53.306 1.89-78.254 9.144-8.055 2.345-21.956 7.418-22.42 11.434l-1.325-2.35c.302-3.648 12.335-8.406 23.162-11.556 25.14-7.31 52.65-9.188 78.72-9.235z\" stroke-width=\".626\"></path><path d=\"M304.408 309.908l-8.396 13.026-24.122-21.423-62.578-42.097-70.542-38.684-36.625-12.528 7.805-14.473 2.65-1.446 22.757 5.69 75.093 38.684 43.235 27.306 36.41 26.17 14.79 17.066z\" stroke-width=\".652\"></path><path d=\"M100.825 208.543c6.424-4.357 53.634 16.674 103.032 46.46 49.266 29.872 96.343 63.626 92.094 69.943l-1.397 2.198-.64.506c.136-.098.844-.964-.07-3.306-2.1-6.907-35.494-33.554-90.902-67.01-54.015-32.21-99.033-51.622-103.534-46.073l1.42-2.717h-.002zm205.3 101.18c4.063-8.024-39.726-41.01-94.016-73.128-55.54-31.478-95.568-50.006-102.88-44.48l-1.624 2.956c-.014.164.06-.2.403-.466 1.328-1.16 3.532-1.08 4.526-1.1 12.59.19 48.546 16.736 98.994 45.657 22.104 12.875 93.378 58.587 93.106 71.44.02 1.106.092 1.334-.324 1.88l1.813-2.757v-.002z\" stroke-width=\".652\"></path></g><g transform=\"translate(-68.306 28.444) scale(1.13778)\"><path d=\"M180.6 211.01c0 16.27 6.663 30.987 17.457 41.742 10.815 10.778 25.512 17.58 41.81 17.58 16.38 0 31.246-6.654 42.015-17.39 10.77-10.735 17.443-25.552 17.446-41.88h-.002v-79.19l-118.74-.14.012 79.278h.002z\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".67\"></path><path d=\"M182.82 211.12v.045c0 15.557 6.44 29.724 16.775 40.01 10.354 10.304 24.614 16.71 40.214 16.71 15.68 0 29.91-6.36 40.22-16.625 10.31-10.265 16.698-24.433 16.7-40.044h-.002V134.39l-113.84-.02-.07 76.75m91.022-53.748l.004 48.89-.04 5.173c0 1.36-.082 2.912-.24 4.233-.926 7.73-4.48 14.467-9.746 19.708-6.164 6.136-14.67 9.942-24.047 9.942-9.326 0-17.638-3.938-23.828-10.1-6.35-6.32-10.03-14.986-10.03-23.947l-.013-54.022 67.94.122v.002z\" fill=\"red\" stroke=\"#000\" stroke-width=\".507\"></path><g id=\"e\"><g id=\"d\" fill=\"#ff0\" stroke=\"#000\" stroke-width=\".5\"><path d=\"M190.19 154.43c.135-5.52 4.052-6.828 4.08-6.847.03-.02 4.232 1.407 4.218 6.898l-8.298-.05\" stroke=\"none\"></path><path d=\"M186.81 147.69l-.682 6.345 4.14.01c.04-5.25 3.975-6.124 4.07-6.104.09-.004 3.99 1.16 4.093 6.104h4.152l-.75-6.394-15.022.038v.002zm-.96 6.37h16.946c.357 0 .65.353.65.784 0 .43-.293.78-.65.78H185.85c-.357 0-.65-.35-.65-.78 0-.43.293-.784.65-.784z\"></path><path d=\"M192.01 154.03c.018-3.313 2.262-4.25 2.274-4.248 0 0 2.342.966 2.36 4.248h-4.634m-5.8-8.98h16.245c.342 0 .623.318.623.705 0 .387-.28.704-.623.704H186.21c-.342 0-.623-.316-.623-.705 0-.387.28-.705.623-.705zm.34 1.42h15.538c.327 0 .595.317.595.704 0 .388-.268.704-.595.704H186.55c-.327 0-.595-.316-.595-.704 0-.387.268-.704.595-.704zm5.02-10.59l1.227.002v.87h.895v-.89l1.257.005v.887h.896v-.89h1.258l-.002 2.01c0 .317-.254.52-.55.52h-4.41c-.296 0-.57-.236-.57-.525l-.004-1.99zm4.62 2.69l.277 6.45-4.303-.015.285-6.452 3.74.017\"></path><path id=\"a\" d=\"M190.94 141.56l.13 3.478h-4.124l.116-3.478h3.88-.002z\"></path><use height=\"100%\" width=\"100%\" xlink:href=\"#a\" x=\"10.609\"></use><path id=\"b\" d=\"M186.3 139.04l1.2.003v.872h.877v-.892l1.23.004v.89h.88v-.894l1.23.002-.003 2.012c0 .314-.25.518-.536.518h-4.317c-.29 0-.558-.235-.558-.525l-.003-1.99z\"></path><use height=\"100%\" width=\"100%\" xlink:href=\"#b\" x=\"10.609\"></use><path d=\"M193.9 140.61c-.026-.627.877-.634.866 0v1.536h-.866v-1.536\" fill=\"#000\" stroke=\"none\"></path><path id=\"c\" d=\"M188.57 142.84c-.003-.606.837-.618.826 0v1.187h-.826v-1.187\" fill=\"#000\" stroke=\"none\"></path><use height=\"100%\" width=\"100%\" xlink:href=\"#c\" x=\"10.641\"></use></g><use height=\"100%\" width=\"100%\" xlink:href=\"#d\" y=\"46.32\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#d\" transform=\"rotate(-45.202 312.766 180.004)\"></use></g><use height=\"100%\" width=\"100%\" xlink:href=\"#d\" x=\"45.714\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#e\" transform=\"matrix(-1 0 0 1 479.792 0)\"></use><g id=\"f\" fill=\"#fff\"><path d=\"M232.636 202.406v.005a8.34 8.34 0 0 0 2.212 5.69c1.365 1.467 3.245 2.378 5.302 2.378 2.067 0 3.944-.905 5.303-2.365 1.358-1.46 2.202-3.472 2.202-5.693v-10.768l-14.992-.013-.028 10.765\" fill=\"#039\"></path><circle cx=\"236.074\" cy=\"195.735\" r=\"1.486\"></circle><circle cx=\"244.392\" cy=\"195.742\" r=\"1.486\"></circle><circle cx=\"240.225\" cy=\"199.735\" r=\"1.486\"></circle><circle cx=\"236.074\" cy=\"203.916\" r=\"1.486\"></circle><circle cx=\"244.383\" cy=\"203.905\" r=\"1.486\"></circle></g><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" y=\"-26.016\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" x=\"-20.799\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" x=\"20.745\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" y=\"25.784\"></use></g>", 4)
const DpFlagPTvue_type_template_id_31fb6751_hoisted_6 = [
  DpFlagPTvue_type_template_id_31fb6751_hoisted_2
]
const DpFlagPTvue_type_template_id_31fb6751_hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagPTvue_type_template_id_31fb6751_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"red\" d=\"M256 0h384v480H256z\"></path><path fill=\"#060\" d=\"M0 0h256v480H0z\"></path><g fill=\"#ff0\" fill-rule=\"evenodd\" stroke=\"#000\" stroke-width=\".573\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M339.456 306.176c-32.224-.97-179.99-93.205-181.003-107.893l8.16-13.608c14.657 21.297 165.717 110.998 180.555 107.82l-7.712 13.677\" stroke-width=\".611\"></path><path d=\"M164.896 182.827c-2.89 7.78 38.56 33.406 88.43 63.737 49.87 30.33 92.87 49.073 96.056 46.385.195-.348 1.57-2.71 1.443-2.692-.598.9-2.052 1.184-4.32.53-13.474-3.886-48.614-20.016-92.133-46.406-43.518-26.392-81.38-50.714-87.265-61.047-.41-.716-.7-2.023-.642-3.04h-.143l-1.253 2.19-.173.342zm175.317 123.776c-.546.99-1.565 1.024-3.5.812-12.053-1.334-48.628-19.12-91.906-45.028-50.358-30.144-91.947-57.61-87.435-64.79l1.228-2.17.242.076c-4.058 12.165 82.077 61.417 87.148 64.557 49.84 30.877 91.856 48.908 95.575 44.222l-1.353 2.326v-.002z\" stroke-width=\".611\"></path><path d=\"M256.18 207.18c32.254-.256 72.055-4.41 94.96-13.537l-4.936-8.018c-13.538 7.493-53.557 12.42-90.295 13.157-43.453-.4-74.124-4.446-89.49-14.757l-4.66 8.538c28.25 11.954 57.198 14.493 94.422 14.616\" stroke-width=\".611\"></path><path d=\"M352.47 193.824c-.79 1.26-15.727 6.412-37.732 10.214-14.92 2.274-34.383 4.22-58.67 4.242-23.076.022-41.926-1.62-56.197-3.555-23.1-3.622-35.02-8.66-39.428-10.442.42-.838.692-1.426 1.098-2.21 12.688 5.053 24.666 8.1 38.698 10.258 14.177 1.92 32.8 3.587 55.76 3.566 24.176-.025 43.424-2.117 58.258-4.324 22.565-3.64 34.892-8.324 36.623-10.5l1.593 2.752h-.002zm-4.332-8.13c-2.446 1.963-14.632 6.285-36.073 9.71-14.31 2.05-32.504 3.886-55.75 3.908-22.084.022-40.127-1.466-53.85-3.465-21.775-2.844-33.365-7.974-37.543-9.47.416-.72.84-1.432 1.274-2.148 3.25 1.636 14.435 6.176 36.508 9.303 13.568 1.924 31.638 3.358 53.613 3.335 23.136-.023 41.123-1.894 55.34-3.934 21.553-2.965 33.15-8.477 34.91-9.857l1.572 2.614v.003zm-197.866 60.343c19.838 10.67 63.9 16.047 105.594 16.417 37.963.06 87.42-5.868 105.916-15.67l-.51-10.678c-5.785 9.042-58.786 17.716-105.818 17.36-47.033-.354-90.707-7.618-105.266-17.022l.084 9.59\" stroke-width=\".611\"></path><path d=\"M362.795 244.5v2.548c-2.78 3.324-20.208 8.347-42.066 11.885-16.635 2.55-38.323 4.474-65.347 4.474-25.673 0-46.147-1.83-62.024-4.268-25.1-3.656-41.152-10.056-44.375-11.966l.015-2.97c9.68 6.435 35.905 11.142 44.71 12.584 15.775 2.42 36.127 4.238 61.672 4.238 26.898 0 48.463-1.91 64.994-4.444 15.68-2.266 38.02-8.157 42.418-12.08zm.01-9.057v2.547c-2.778 3.32-20.208 8.345-42.065 11.882-16.635 2.55-38.322 4.474-65.346 4.474-25.674 0-46.147-1.828-62.025-4.268-25.098-3.653-41.15-10.053-44.374-11.964l.014-2.97c9.68 6.434 35.905 11.143 44.712 12.582 15.774 2.423 36.126 4.24 61.67 4.24 26.898 0 48.464-1.91 64.994-4.446 15.68-2.265 38.02-8.156 42.418-12.08v.003zM255.776 304.34c-45.623-.27-84.716-12.435-92.97-14.446l6.02 9.424c14.58 6.133 52.718 15.274 87.388 14.262 34.67-1.01 64.97-3.697 86.323-14.092l6.172-9.765c-14.553 6.853-64.074 14.548-92.935 14.618\" stroke-width=\".611\"></path><path d=\"M344.853 297.3a143.02 143.02 0 0 1-2.77 4.086c-10.07 3.55-25.94 7.28-32.636 8.367-13.68 2.818-34.843 4.9-53.625 4.91-40.416-.592-73.5-8.504-89.063-15.253l-1.257-2.16.205-.323 2.13.826c27.678 9.902 58.764 13.853 88.21 14.562 18.71.066 37.436-2.144 52.58-4.852 23.222-4.653 32.612-8.16 35.493-9.75l.734-.41zm5.352-8.826c.023.028.047.054.07.083a287.226 287.226 0 0 1-2.093 3.48c-5.372 1.92-19.95 6.185-41.237 9.162-14.025 1.91-22.743 3.76-50.644 4.302-52.282-1.33-86.132-11.553-94.174-14.075l-1.192-2.286c30.3 7.91 61.25 13.433 95.37 13.997 25.525-.544 36.385-2.424 50.294-4.32 24.823-3.86 37.33-7.946 41.083-9.126a2.845 2.845 0 0 0-.164-.212l2.692-1.005-.002.002z\" stroke-width=\".587\"></path><path d=\"M350.752 237.61c.148 30.013-15.21 56.946-27.582 68.827-17.502 16.81-40.707 27.623-67.807 28.12-30.26.557-58.794-19.17-66.448-27.838-14.963-16.945-27.145-38.462-27.536-67.46 1.853-32.757 14.712-55.574 33.352-71.22 18.64-15.647 43.46-23.268 64.13-22.723 23.847.63 51.705 12.33 70.955 35.554 12.61 15.22 18.072 31.733 20.935 56.74zM255.62 134.847c58.118 0 105.916 47.294 105.916 105.283 0 57.987-47.798 105.283-105.916 105.283-58.117 0-105.52-47.295-105.52-105.284 0-57.99 47.403-105.284 105.52-105.284\" stroke-width=\".611\"></path><path d=\"M255.904 134.485c58.17 0 105.612 47.45 105.612 105.624 0 58.173-47.443 105.62-105.612 105.62-58.17 0-105.612-47.446-105.612-105.62 0-58.176 47.443-105.625 105.612-105.625zM152.617 240.11c0 56.81 46.65 103.297 103.287 103.297 56.637 0 103.29-46.487 103.29-103.298 0-56.814-46.654-103.3-103.29-103.3s-103.287 46.49-103.287 103.3z\" stroke-width=\".611\"></path><path d=\"M255.99 143.264c53.046 0 96.74 43.542 96.74 96.75 0 53.21-43.695 96.75-96.74 96.75-53.046 0-96.74-43.54-96.74-96.75 0-53.208 43.695-96.75 96.74-96.75zm-94.417 96.75c0 51.93 42.645 94.426 94.416 94.426 51.77 0 94.415-42.495 94.415-94.426 0-51.93-42.643-94.426-94.416-94.426-51.772 0-94.417 42.495-94.417 94.426z\" stroke-width=\".611\"></path><path d=\"M260.245 134.06h-9.05l.01 212.223h9.082z\" stroke-width=\".611\"></path><path d=\"M259.34 132.85h2.302l.02 214.666h-2.306l-.016-214.667zm-8.984 0h2.322l.003 214.668h-2.323V132.85z\" stroke-width=\".611\"></path><path d=\"M361.59 244.197v-7.845l-6.39-5.952-36.267-9.6-52.266-5.334-62.934 3.2-44.8 10.667-9.045 6.7v7.846L172.8 233.6l54.4-8.534h52.267l38.4 4.267 26.666 6.4z\" stroke-width=\".611\"></path><path d=\"M255.947 223.755c24.942-.046 49.14 2.363 68.336 6.1 19.807 3.96 33.746 8.913 38.512 14.476l-.006 2.756c-5.748-6.923-24.505-11.998-38.953-14.9-19.05-3.705-43.086-6.098-67.89-6.05-26.174.047-50.546 2.526-69.317 6.19-15.06 2.987-35.147 8.924-37.655 14.78v-2.868c1.377-4.053 16.334-10.11 37.316-14.31 18.912-3.69 43.33-6.126 69.657-6.173zm.01-9.06c24.942-.044 49.142 2.366 68.336 6.102 19.807 3.962 33.746 8.913 38.512 14.476l-.005 2.754c-5.748-6.92-24.505-11.997-38.953-14.897-19.048-3.707-43.085-6.1-67.89-6.052-26.174.047-50.427 2.528-69.2 6.188-14.534 2.756-35.44 8.928-37.772 14.784v-2.87c1.377-4.01 16.636-10.284 37.317-14.31 18.91-3.69 43.328-6.124 69.655-6.173zm-.512-46.205c39.306-.196 73.59 5.496 89.275 13.53l5.72 9.9c-13.632-7.348-50.618-14.988-94.937-13.845-36.11.222-74.696 3.975-94.055 14.304l6.83-11.424c15.89-8.24 53.358-12.42 87.17-12.463\" stroke-width=\".611\"></path><path d=\"M255.968 176.66c22.418-.058 44.08 1.206 61.308 4.315 16.043 2.986 31.344 7.467 33.53 9.877l1.698 2.998c-5.32-3.475-18.56-7.343-35.562-10.567-17.073-3.21-38.72-4.272-61.013-4.213-25.305-.087-44.963 1.25-61.835 4.19-17.843 3.34-30.223 8.11-33.277 10.375l1.662-3.168c5.934-3.028 15.35-6.677 31.172-9.525 17.447-3.187 37.315-4.143 62.317-4.28zm-.01-9.05c21.454-.055 42.637 1.14 59.15 4.11 13.022 2.534 25.9 6.492 30.617 10.014l2.48 3.942c-4.217-4.688-20.09-9.13-34.105-11.62-16.385-2.825-36.688-3.943-58.142-4.122-22.515.063-43.323 1.442-59.47 4.382-15.403 2.93-25.343 6.402-29.55 9.112l2.183-3.292c5.805-3.056 15.182-5.862 26.99-8.157 16.266-2.962 37.202-4.306 59.85-4.37zm52.469 116.4c-19.433-3.627-38.9-4.154-52.498-3.994-65.502.768-86.662 13.45-89.244 17.29l-4.895-7.98c16.677-12.088 52.345-18.866 94.493-18.173 21.886.358 40.773 1.812 56.66 4.89l-4.518 7.97\" stroke-width=\".611\"></path><path d=\"M255.552 278.89c18.22.273 36.106 1.025 53.37 4.244l-1.252 2.207c-16.033-2.958-33.125-4.09-52.056-4-24.174-.188-48.624 2.07-69.91 8.18-6.717 1.868-17.836 6.186-18.97 9.755l-1.244-2.05c.36-2.11 7.08-6.488 19.642-10.017 24.382-6.982 47.188-8.16 70.42-8.32v.003zm.827-9.17c18.877.354 38.372 1.227 57.322 4.98L312.4 277c-17.112-3.397-33.46-4.53-55.91-4.875-24.25.044-49.974 1.773-73.363 8.573-7.55 2.2-20.583 6.955-21.018 10.72l-1.244-2.203c.283-3.42 11.565-7.88 21.715-10.833 23.57-6.853 49.36-8.615 73.8-8.66z\" stroke-width=\".587\"></path><path d=\"M349.42 290.54l-7.872 12.21-22.615-20.083-58.666-39.467-66.134-36.267-34.336-11.744 7.318-13.57 2.485-1.353 21.333 5.333 70.4 36.267 40.534 25.6L336 272l13.867 16z\" stroke-width=\".611\"></path><path d=\"M158.56 195.51c6.022-4.085 50.282 15.63 96.592 43.556 46.188 28.004 90.322 59.65 86.338 65.57l-1.31 2.062-.6.474c.128-.092.792-.904-.066-3.1-1.968-6.475-33.275-31.457-85.22-62.82-50.64-30.197-92.844-48.397-97.064-43.195l1.33-2.548zm192.47 94.855c3.807-7.522-37.244-38.447-88.14-68.557-52.07-29.51-89.595-46.88-96.45-41.7l-1.522 2.77c-.014.153.055-.188.377-.436 1.246-1.088 3.312-1.015 4.244-1.03 11.802.175 45.51 15.688 92.806 42.802 20.723 12.07 87.542 54.923 87.287 66.975.018 1.034.086 1.248-.304 1.76l1.7-2.584v-.003z\" stroke-width=\".611\"></path></g><g transform=\"translate(0 26.667) scale(1.06667)\"><path d=\"M180.6 211.01c0 16.27 6.663 30.987 17.457 41.742 10.815 10.778 25.512 17.58 41.81 17.58 16.38 0 31.246-6.654 42.015-17.39 10.77-10.735 17.443-25.552 17.446-41.88h-.002v-79.19l-118.74-.14.012 79.278h.002z\" fill=\"#fff\" stroke=\"#000\" stroke-width=\".67\"></path><path d=\"M182.82 211.12v.045c0 15.557 6.44 29.724 16.775 40.01 10.354 10.304 24.614 16.71 40.214 16.71 15.68 0 29.91-6.36 40.22-16.625 10.31-10.265 16.698-24.433 16.7-40.044h-.002V134.39l-113.84-.02-.07 76.75m91.022-53.748l.004 48.89-.04 5.173c0 1.36-.082 2.912-.24 4.233-.926 7.73-4.48 14.467-9.746 19.708-6.164 6.136-14.67 9.942-24.047 9.942-9.326 0-17.638-3.938-23.828-10.1-6.35-6.32-10.03-14.986-10.03-23.947l-.013-54.022 67.94.122v.002z\" fill=\"red\" stroke=\"#000\" stroke-width=\".507\"></path><g id=\"e\"><g id=\"d\" fill=\"#ff0\" stroke=\"#000\" stroke-width=\".5\"><path d=\"M190.19 154.43c.135-5.52 4.052-6.828 4.08-6.847.03-.02 4.232 1.407 4.218 6.898l-8.298-.05\" stroke=\"none\"></path><path d=\"M186.81 147.69l-.682 6.345 4.14.01c.04-5.25 3.975-6.124 4.07-6.104.09-.004 3.99 1.16 4.093 6.104h4.152l-.75-6.394-15.022.038v.002zm-.96 6.37h16.946c.357 0 .65.353.65.784 0 .43-.293.78-.65.78H185.85c-.357 0-.65-.35-.65-.78 0-.43.293-.784.65-.784z\"></path><path d=\"M192.01 154.03c.018-3.313 2.262-4.25 2.274-4.248 0 0 2.342.966 2.36 4.248h-4.634m-5.8-8.98h16.245c.342 0 .623.318.623.705 0 .387-.28.704-.623.704H186.21c-.342 0-.623-.316-.623-.705 0-.387.28-.705.623-.705zm.34 1.42h15.538c.327 0 .595.317.595.704 0 .388-.268.704-.595.704H186.55c-.327 0-.595-.316-.595-.704 0-.387.268-.704.595-.704zm5.02-10.59l1.227.002v.87h.895v-.89l1.257.005v.887h.896v-.89h1.258l-.002 2.01c0 .317-.254.52-.55.52h-4.41c-.296 0-.57-.236-.57-.525l-.004-1.99zm4.62 2.69l.277 6.45-4.303-.015.285-6.452 3.74.017\"></path><path id=\"a\" d=\"M190.94 141.56l.13 3.478h-4.124l.116-3.478h3.88-.002z\"></path><use height=\"100%\" width=\"100%\" xlink:href=\"#a\" x=\"10.609\"></use><path id=\"b\" d=\"M186.3 139.04l1.2.003v.872h.877v-.892l1.23.004v.89h.88v-.894l1.23.002-.003 2.012c0 .314-.25.518-.536.518h-4.317c-.29 0-.558-.235-.558-.525l-.003-1.99z\"></path><use height=\"100%\" width=\"100%\" xlink:href=\"#b\" x=\"10.609\"></use><path d=\"M193.9 140.61c-.026-.627.877-.634.866 0v1.536h-.866v-1.536\" fill=\"#000\" stroke=\"none\"></path><path id=\"c\" d=\"M188.57 142.84c-.003-.606.837-.618.826 0v1.187h-.826v-1.187\" fill=\"#000\" stroke=\"none\"></path><use height=\"100%\" width=\"100%\" xlink:href=\"#c\" x=\"10.641\"></use></g><use height=\"100%\" width=\"100%\" xlink:href=\"#d\" y=\"46.32\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#d\" transform=\"rotate(-45.202 312.766 180.004)\"></use></g><use height=\"100%\" width=\"100%\" xlink:href=\"#d\" x=\"45.714\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#e\" transform=\"matrix(-1 0 0 1 479.792 0)\"></use><g id=\"f\" fill=\"#fff\"><path d=\"M232.636 202.406v.005a8.34 8.34 0 0 0 2.212 5.69c1.365 1.467 3.245 2.378 5.302 2.378 2.067 0 3.944-.905 5.303-2.365 1.358-1.46 2.202-3.472 2.202-5.693v-10.768l-14.992-.013-.028 10.765\" fill=\"#039\"></path><circle cx=\"236.074\" cy=\"195.735\" r=\"1.486\"></circle><circle cx=\"244.392\" cy=\"195.742\" r=\"1.486\"></circle><circle cx=\"240.225\" cy=\"199.735\" r=\"1.486\"></circle><circle cx=\"236.074\" cy=\"203.916\" r=\"1.486\"></circle><circle cx=\"244.383\" cy=\"203.905\" r=\"1.486\"></circle></g><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" y=\"-26.016\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" x=\"-20.799\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" x=\"20.745\"></use><use height=\"100%\" width=\"100%\" xlink:href=\"#f\" y=\"25.784\"></use></g>", 4)
const DpFlagPTvue_type_template_id_31fb6751_hoisted_12 = [
  DpFlagPTvue_type_template_id_31fb6751_hoisted_8
]

function DpFlagPTvue_type_template_id_31fb6751_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagPTvue_type_template_id_31fb6751_hoisted_1, DpFlagPTvue_type_template_id_31fb6751_hoisted_6))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagPTvue_type_template_id_31fb6751_hoisted_7, DpFlagPTvue_type_template_id_31fb6751_hoisted_12))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagPT.vue?vue&type=template&id=31fb6751

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagPT.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagPTvue_type_script_lang_js = ({
  name: "DpFlagPT",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagPT.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagPT.vue




;
const DpFlagPT_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagPTvue_type_script_lang_js, [['render',DpFlagPTvue_type_template_id_31fb6751_render]])

/* harmony default export */ var DpFlagPT = (DpFlagPT_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagRO.vue?vue&type=template&id=ea7136ea


const DpFlagROvue_type_template_id_ea7136ea_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagROvue_type_template_id_ea7136ea_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#00319c",
    d: "M0 0h170.666v512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ffde00",
    d: "M170.666 0h170.666v512H170.666z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#de2110",
    d: "M341.332 0h170.665v512H341.332z"
  })
], -1)
const DpFlagROvue_type_template_id_ea7136ea_hoisted_3 = [
  DpFlagROvue_type_template_id_ea7136ea_hoisted_2
]
const DpFlagROvue_type_template_id_ea7136ea_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagROvue_type_template_id_ea7136ea_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#00319c",
    d: "M0 0h213.333v480H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#ffde00",
    d: "M213.333 0h213.333v480H213.333z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#de2110",
    d: "M426.666 0H640v480H426.666z"
  })
], -1)
const DpFlagROvue_type_template_id_ea7136ea_hoisted_6 = [
  DpFlagROvue_type_template_id_ea7136ea_hoisted_5
]

function DpFlagROvue_type_template_id_ea7136ea_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagROvue_type_template_id_ea7136ea_hoisted_1, DpFlagROvue_type_template_id_ea7136ea_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagROvue_type_template_id_ea7136ea_hoisted_4, DpFlagROvue_type_template_id_ea7136ea_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagRO.vue?vue&type=template&id=ea7136ea

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagRO.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagROvue_type_script_lang_js = ({
  name: "DpFlagRO",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagRO.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagRO.vue




;
const DpFlagRO_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagROvue_type_script_lang_js, [['render',DpFlagROvue_type_template_id_ea7136ea_render]])

/* harmony default export */ var DpFlagRO = (DpFlagRO_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagRU.vue?vue&type=template&id=fb7684c6


const DpFlagRUvue_type_template_id_fb7684c6_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagRUvue_type_template_id_fb7684c6_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h512.005v512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#0039a6",
    d: "M0 170.667h512.005V512H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d52b1e",
    d: "M0 341.333h512.005V512H0z"
  })
], -1)
const DpFlagRUvue_type_template_id_fb7684c6_hoisted_3 = [
  DpFlagRUvue_type_template_id_fb7684c6_hoisted_2
]
const DpFlagRUvue_type_template_id_fb7684c6_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagRUvue_type_template_id_fb7684c6_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  "fill-rule": "evenodd",
  "stroke-width": "1pt"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#0039a6",
    d: "M0 160.003h640V480H0z"
  }),
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
    fill: "#d52b1e",
    d: "M0 319.997h640V480H0z"
  })
], -1)
const DpFlagRUvue_type_template_id_fb7684c6_hoisted_6 = [
  DpFlagRUvue_type_template_id_fb7684c6_hoisted_5
]

function DpFlagRUvue_type_template_id_fb7684c6_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagRUvue_type_template_id_fb7684c6_hoisted_1, DpFlagRUvue_type_template_id_fb7684c6_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagRUvue_type_template_id_fb7684c6_hoisted_4, DpFlagRUvue_type_template_id_fb7684c6_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagRU.vue?vue&type=template&id=fb7684c6

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagRU.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagRUvue_type_script_lang_js = ({
  name: "DpFlagRU",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagRU.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagRU.vue




;
const DpFlagRU_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagRUvue_type_script_lang_js, [['render',DpFlagRUvue_type_template_id_fb7684c6_render]])

/* harmony default export */ var DpFlagRU = (DpFlagRU_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagSE.vue?vue&type=template&id=43cd1ed9


const DpFlagSEvue_type_template_id_43cd1ed9_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagSEvue_type_template_id_43cd1ed9_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M118.97 7.306H609.7v490.73H118.97z\"></path></clipPath></defs><g transform=\"translate(-124.12 -7.622) scale(1.0433)\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#006aa7\" d=\"M2.904 7.598h245.368v196.294H2.904zm0 294.132h245.368v196.295H2.904z\"></path><path fill=\"#fecc00\" d=\"M2.904 203.78h245.368v98.147H2.904z\"></path><path fill=\"#fecc00\" d=\"M247.262 7.318h98.147v490.735h-98.147z\"></path><path fill=\"#fecc00\" d=\"M342.296 203.808h441.662v98.147H342.296z\"></path><path fill=\"#006aa7\" d=\"M345.325 301.759h441.661v196.294H345.325zm0-294.161h441.661v196.294H345.325z\"></path></g></g>", 2)
const DpFlagSEvue_type_template_id_43cd1ed9_hoisted_4 = [
  DpFlagSEvue_type_template_id_43cd1ed9_hoisted_2
]
const DpFlagSEvue_type_template_id_43cd1ed9_hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagSEvue_type_template_id_43cd1ed9_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-53.421 0h682.67v512h-682.67z\"></path></clipPath></defs><g transform=\"translate(50.082) scale(.9375)\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#006aa7\" d=\"M-121.103.302h256V205.1h-256zm0 306.876h256v204.8h-256z\"></path><path fill=\"#fecc00\" d=\"M-121.103 204.984h256v102.4h-256z\"></path><path fill=\"#fecc00\" d=\"M133.843.01h102.4v511.997h-102.4z\"></path><path fill=\"#fecc00\" d=\"M232.995 205.013h460.798v102.4H232.995z\"></path><path fill=\"#006aa7\" d=\"M236.155 307.208h460.797v204.799H236.155zm0-306.906h460.797V205.1H236.155z\"></path></g></g>", 2)
const DpFlagSEvue_type_template_id_43cd1ed9_hoisted_8 = [
  DpFlagSEvue_type_template_id_43cd1ed9_hoisted_6
]

function DpFlagSEvue_type_template_id_43cd1ed9_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagSEvue_type_template_id_43cd1ed9_hoisted_1, DpFlagSEvue_type_template_id_43cd1ed9_hoisted_4))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagSEvue_type_template_id_43cd1ed9_hoisted_5, DpFlagSEvue_type_template_id_43cd1ed9_hoisted_8))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSE.vue?vue&type=template&id=43cd1ed9

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagSE.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagSEvue_type_script_lang_js = ({
  name: "DpFlagSE",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSE.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSE.vue




;
const DpFlagSE_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagSEvue_type_script_lang_js, [['render',DpFlagSEvue_type_template_id_43cd1ed9_render]])

/* harmony default export */ var DpFlagSE = (DpFlagSE_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagSI.vue?vue&type=template&id=1878f438


const DpFlagSIvue_type_template_id_1878f438_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagSIvue_type_template_id_1878f438_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M60.224 0h497.33v497.33H60.224z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#a)\" transform=\"translate(-62) scale(1.0295)\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M0 0h994.66v497.33H0z\"></path><path fill=\"#de2918\" d=\"M0 331.55h994.66v165.78H0z\"></path><path fill=\"#08399c\" d=\"M0 165.78h994.66v165.78H0z\"></path><path d=\"M282.039 90.314c-3.904 59.885-6.14 92.702-15.26 107.88-9.859 16.308-19.45 28.248-57.92 42.625-38.47-14.377-48.062-26.317-57.921-42.625-9.118-15.183-11.355-48-15.26-107.88l5.686-1.915c11.445-3.49 19.984-6.298 26.301-7.544 9.046-1.915 16.734-4.08 41.045-4.587 24.312.418 32.038 2.717 41.084 4.632 6.264 1.336 15.17 3.964 26.53 7.522l5.715 1.892z\" fill=\"#de2918\"></path><path d=\"M276.435 88.353c-3.693 59.757-6.782 87.123-11.6 100.28-9.351 22.53-24.154 34.881-56.013 46.662-31.858-11.781-46.66-24.133-56.01-46.661-4.82-13.157-7.863-40.445-11.45-100.34 11.203-3.5 19.986-6.234 26.303-7.48 9.046-1.916 16.734-4.171 41.045-4.59 24.312.419 32.09 2.674 41.136 4.59 6.317 1.246 15.282 3.98 26.59 7.54z\" fill=\"#08399c\"></path><path d=\"M208.79 106.642l1.528 3.616 6.712.92-4.349 2.623 4.205 2.81-6.116 1.026-1.862 3.277-2.093-3.375-5.823-.826 3.963-2.872-4.08-2.614 6.445-.988 1.47-3.597z\" fill=\"#fc0\"></path><path d=\"M262.537 174.474l-3.721-2.941-2.689-4.424-5.267-4.569-2.745-4.617-5.267-4.713-2.577-4.616-2.8-2.261-1.85-1.779-4.757 4.172-2.593 4.531-3.232 2.93-3.55-2.773-2.684-4.727-9.964-17.695-9.966 17.695-2.684 4.727-3.55 2.773-3.231-2.93-2.594-4.531-4.757-4.172-1.85 1.779-2.8 2.261-2.577 4.616-5.267 4.713-2.745 4.617-5.267 4.569-2.688 4.424-3.712 3.01c1.927 16.402 12.383 29.253 18.08 35.132 6.357 6.173 19.464 14.432 35.492 19.899 16.074-5.35 29.363-13.726 35.72-19.899 5.697-5.879 16.153-18.73 18.092-35.201z\" fill=\"#fff\"></path><path d=\"M224.814 81.486l1.527 3.616 6.712.92-4.349 2.622 4.205 2.812-6.116 1.025-1.862 3.276-2.093-3.374-5.823-.826 3.963-2.873-4.08-2.614 6.445-.988 1.47-3.596zm-32.034-.056l1.528 3.617 6.712.92-4.349 2.622 4.205 2.812-6.116 1.025-1.862 3.276-2.093-3.374-5.823-.826 3.963-2.873-4.08-2.614 6.445-.988 1.47-3.596z\" fill=\"#fc0\"></path><path d=\"M254.219 197.214l-7.255.022-6.694-.498-8.108-3.977-9.14.055-7.915 3.867-6.243.552-6.243-.552-7.915-3.867-9.14-.055-8.108 3.977-6.694.498-7.345-.101-3.548-6.009.132-.138 10.852 1.795 6.694-.498 8.108-3.977 9.14.055 7.915 3.867 6.243.552 6.243-.552 7.915-3.867 9.14-.055 8.108 3.977 6.694.498 10.562-1.852.14.278-3.538 6.005zm-83.995 9.238l7.18-.498 8.11-3.977 9.139.055 7.915 3.867 6.243.552 6.243-.552 7.915-3.867 9.14-.055 8.108 3.977 7.279.498 4.696-5.789-.158-.13-5.032 1.466-6.694-.498-8.109-3.977-9.139.055-7.915 3.867-6.243.552-6.243-.552-7.915-3.867-9.14-.055-8.108 3.977-6.694.498-4.932-1.243-.06.242 4.414 5.454z\" fill=\"#08399c\"></path></g>", 2)
const DpFlagSIvue_type_template_id_1878f438_hoisted_4 = [
  DpFlagSIvue_type_template_id_1878f438_hoisted_2
]
const DpFlagSIvue_type_template_id_1878f438_hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagSIvue_type_template_id_1878f438_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<defs><clipPath id=\"a\"><path fill-opacity=\".67\" d=\"M-15.067 0h682.67v512h-682.67z\"></path></clipPath></defs><g fill-rule=\"evenodd\" transform=\"translate(14.125) scale(.9375)\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M-62 0H962v512H-62z\"></path><path fill=\"#de2918\" d=\"M-62 341.33H962V512H-62z\"></path><path fill=\"#08399c\" d=\"M-62 170.67H962v170.67H-62z\"></path><path d=\"M228.37 92.976c-4.02 61.651-6.322 95.436-15.709 111.07-10.15 16.789-20.025 29.081-59.63 43.882-39.61-14.81-49.48-27.1-59.633-43.89-9.387-15.63-11.69-49.41-15.709-111.06l5.853-1.971c11.783-3.594 20.574-6.484 27.077-7.767 9.313-1.971 17.228-4.2 42.257-4.722 25.029.43 32.983 2.797 42.296 4.768 6.45 1.375 15.617 4.081 27.312 7.744l5.884 1.948z\" fill=\"#de2918\"></path><path d=\"M222.6 90.955c-3.802 61.518-6.983 89.69-11.943 103.24-9.626 23.193-24.866 35.909-57.665 48.038-32.8-12.14-48.04-24.86-57.664-48.05-4.961-13.54-8.095-41.64-11.788-103.3 11.534-3.602 20.577-6.418 27.08-7.7 9.313-1.972 17.228-4.294 42.257-4.725 25.029.431 33.037 2.753 42.35 4.724 6.503 1.283 15.732 4.098 27.373 7.763z\" fill=\"#08399c\"></path><path d=\"M152.96 109.79l1.573 3.723 6.91.947-4.478 2.7 4.33 2.894-6.298 1.055-1.916 3.374-2.156-3.474-5.995-.85 4.08-2.958-4.2-2.691 6.635-1.017 1.515-3.703z\" fill=\"#fc0\"></path><path d=\"M208.28 179.62l-3.83-3.028-2.769-4.554-5.422-4.704-2.826-4.753-5.423-4.852-2.653-4.753-2.883-2.327-1.903-1.832-4.899 4.295-2.67 4.665-3.326 3.016-3.655-2.854-2.763-4.867L153 134.855l-10.26 18.217-2.763 4.867-3.654 2.854-3.327-3.016-2.67-4.665-4.898-4.295-1.904 1.832-2.883 2.328-2.653 4.752-5.423 4.852-2.825 4.753-5.423 4.704-2.768 4.554-3.821 3.099c1.984 16.886 12.748 30.116 18.613 36.168 6.545 6.355 20.039 14.858 36.54 20.486 16.548-5.508 30.229-14.131 36.774-20.486 5.865-6.052 16.629-19.282 18.625-36.239z\" fill=\"#fff\"></path><path d=\"M169.45 83.89l1.573 3.723 6.91.947-4.478 2.7 4.33 2.894-6.298 1.055-1.916 3.374-2.156-3.474-5.995-.85 4.08-2.958-4.2-2.691 6.635-1.017 1.515-3.703zm-32.98-.056l1.573 3.723 6.91.947-4.478 2.7 4.33 2.894-6.298 1.055-1.916 3.374-2.156-3.474-5.995-.85 4.08-2.958-4.2-2.691 6.635-1.017 1.515-3.703z\" fill=\"#fc0\"></path><path d=\"M199.72 203.03l-7.468.023-6.892-.513-8.348-4.094-9.409.056-8.149 3.981-6.427.569-6.428-.569-8.148-3.98-9.41-.057-8.347 4.094-6.892.513-7.562-.104-3.652-6.187.136-.142 11.172 1.848 6.891-.512 8.348-4.095 9.41.057 8.148 3.981 6.427.568 6.428-.568 8.148-3.981 9.41-.057 8.347 4.095 6.892.512 10.874-1.906.144.286-3.643 6.182zm-86.47 9.51l7.393-.513 8.348-4.094 9.409.057 8.148 3.98 6.428.569 6.427-.568 8.149-3.981 9.41-.057 8.347 4.094 7.493.513 4.835-5.96-.163-.135-5.18 1.51-6.892-.512-8.347-4.094-9.41.056-8.148 3.981-6.428.569-6.427-.569-8.149-3.98-9.409-.057-8.347 4.094-6.892.513-5.077-1.28-.061.25 4.543 5.614z\" fill=\"#08399c\"></path></g>", 2)
const DpFlagSIvue_type_template_id_1878f438_hoisted_8 = [
  DpFlagSIvue_type_template_id_1878f438_hoisted_6
]

function DpFlagSIvue_type_template_id_1878f438_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagSIvue_type_template_id_1878f438_hoisted_1, DpFlagSIvue_type_template_id_1878f438_hoisted_4))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagSIvue_type_template_id_1878f438_hoisted_5, DpFlagSIvue_type_template_id_1878f438_hoisted_8))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSI.vue?vue&type=template&id=1878f438

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagSI.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagSIvue_type_script_lang_js = ({
  name: "DpFlagSI",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSI.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSI.vue




;
const DpFlagSI_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagSIvue_type_script_lang_js, [['render',DpFlagSIvue_type_template_id_1878f438_render]])

/* harmony default export */ var DpFlagSI = (DpFlagSI_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagSK.vue?vue&type=template&id=60155ea9


const DpFlagSKvue_type_template_id_60155ea9_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagSKvue_type_template_id_60155ea9_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"#ee1c25\" d=\"M0 0h512v512H0z\"></path><path fill=\"#0b4ea2\" d=\"M0 0h512v341.333H0z\"></path><path fill=\"#fff\" d=\"M0 0h512v170.667H0z\"></path><path d=\"M203.204 395.52c-45.893-22.106-111.539-65.982-111.539-152.775s4.15-126.265 4.15-126.265h214.781s4.15 39.472 4.15 126.265-65.645 130.67-111.542 152.775z\" fill=\"#fff\"></path><path d=\"M203.204 384c-42.103-20.28-102.329-60.534-102.329-140.16 0-79.628 3.807-115.84 3.807-115.84h197.047s3.808 36.212 3.808 115.84c0 79.626-60.226 119.88-102.332 140.16z\" fill=\"#ee1c25\"></path><path d=\"M212.21 222.962c11.4.185 33.643.631 53.448-5.996 0 0-.523 7.087-.523 15.343 0 8.258.523 15.345.523 15.345-18.166-6.08-40.601-6.206-53.448-6.043v43.98H194.2v-43.98c-12.846-.163-35.28-.037-53.448 6.042 0 0 .523-7.086.523-15.344 0-8.256-.523-15.344-.523-15.344 19.806 6.628 42.048 6.181 53.448 5.997v-27.62c-10.39-.093-25.364.403-42.293 6.069 0 0 .523-7.087.523-15.345 0-8.256-.523-15.344-.523-15.344 16.904 5.656 31.86 6.16 42.247 6.07-.534-17.491-5.63-39.536-5.63-39.536s10.487.818 14.68.818c4.196 0 14.68-.818 14.68-.818s-5.095 22.046-5.63 39.535c10.39.09 25.344-.414 42.248-6.07 0 0-.523 7.087-.523 15.344s.523 15.344.523 15.344c-16.93-5.665-31.903-6.161-42.294-6.069v27.62z\" fill=\"#fff\"></path><path d=\"M203.2 280.827c-21.203 0-32.56 29.413-32.56 29.413s-6.3-13.946-23.6-13.946c-11.704 0-20.33 10.411-25.813 20.053 21.294 33.881 55.268 54.79 81.973 67.653 26.708-12.864 60.705-33.767 82-67.653-5.483-9.642-14.11-20.053-25.814-20.053-17.3 0-23.626 13.946-23.626 13.946s-11.356-29.413-32.56-29.413z\" fill=\"#0b4ea2\"></path>", 7)
const DpFlagSKvue_type_template_id_60155ea9_hoisted_9 = [
  DpFlagSKvue_type_template_id_60155ea9_hoisted_2
]
const DpFlagSKvue_type_template_id_60155ea9_hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagSKvue_type_template_id_60155ea9_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<path fill=\"#ee1c25\" d=\"M0 0h640v480H0z\"></path><path fill=\"#0b4ea2\" d=\"M0 0h640v320H0z\"></path><path fill=\"#fff\" d=\"M0 0h640v160H0z\"></path><path d=\"M233.004 370.8c-43.025-20.724-104.568-61.858-104.568-143.226 0-81.37 3.89-118.374 3.89-118.374h201.358s3.891 37.005 3.891 118.374c0 81.368-61.543 122.502-104.571 143.226z\" fill=\"#fff\"></path><path d=\"M233.004 360c-39.472-19.013-95.934-56.75-95.934-131.4 0-74.651 3.57-108.6 3.57-108.6h184.73s3.57 33.95 3.57 108.6c0 74.65-56.462 112.387-95.936 131.4z\" fill=\"#ee1c25\"></path><path d=\"M241.446 209.027c10.688.173 31.54.591 50.109-5.622 0 0-.49 6.645-.49 14.385 0 7.742.49 14.386.49 14.386-17.032-5.7-38.064-5.819-50.108-5.666v41.231h-16.883V226.51c-12.044-.153-33.076-.034-50.108 5.665 0 0 .49-6.644.49-14.386 0-7.74-.49-14.384-.49-14.384 18.568 6.213 39.42 5.795 50.108 5.622v-25.894c-9.741-.087-23.779.378-39.65 5.69 0 0 .49-6.645.49-14.386 0-7.74-.49-14.385-.49-14.385 15.848 5.303 29.868 5.776 39.607 5.691-.501-16.398-5.278-37.065-5.278-37.065s9.831.767 13.761.767c3.934 0 13.763-.767 13.763-.767s-4.776 20.667-5.277 37.064c9.739.084 23.759-.388 39.606-5.691 0 0-.49 6.644-.49 14.385 0 7.74.49 14.385.49 14.385-15.87-5.311-29.909-5.776-39.65-5.69v25.894z\" fill=\"#fff\"></path><path d=\"M233 263.275c-19.878 0-30.525 27.575-30.525 27.575s-5.907-13.075-22.125-13.075c-10.973 0-19.06 9.761-24.2 18.8C176.113 328.34 207.964 347.941 233 360c25.039-12.06 56.91-31.657 76.875-63.425-5.14-9.039-13.227-18.8-24.2-18.8-16.219 0-22.15 13.075-22.15 13.075S252.879 263.275 233 263.275z\" fill=\"#0b4ea2\"></path>", 7)
const DpFlagSKvue_type_template_id_60155ea9_hoisted_18 = [
  DpFlagSKvue_type_template_id_60155ea9_hoisted_11
]

function DpFlagSKvue_type_template_id_60155ea9_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagSKvue_type_template_id_60155ea9_hoisted_1, DpFlagSKvue_type_template_id_60155ea9_hoisted_9))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagSKvue_type_template_id_60155ea9_hoisted_10, DpFlagSKvue_type_template_id_60155ea9_hoisted_18))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSK.vue?vue&type=template&id=60155ea9

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagSK.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagSKvue_type_script_lang_js = ({
  name: "DpFlagSK",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSK.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagSK.vue




;
const DpFlagSK_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagSKvue_type_script_lang_js, [['render',DpFlagSKvue_type_template_id_60155ea9_render]])

/* harmony default export */ var DpFlagSK = (DpFlagSK_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagTR.vue?vue&type=template&id=79d07c8e


const DpFlagTRvue_type_template_id_79d07c8e_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagTRvue_type_template_id_79d07c8e_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\"><path fill=\"#f31930\" d=\"M0 0h512v512H0z\"></path><path d=\"M348.772 263.97c0 70.63-58.247 127.883-130.1 127.883S88.572 334.6 88.572 263.97s58.247-127.88 130.1-127.88 130.1 57.254 130.1 127.88z\" fill=\"#fff\"></path><path d=\"M355.28 263.965c0 56.5-46.6 102.304-104.08 102.304s-104.08-45.804-104.08-102.305 46.598-102.303 104.08-102.303 104.08 45.803 104.08 102.303z\" fill=\"#f31830\"></path><path d=\"M374.104 204.23l-1.05 47.272-44.103 11.973 43.474 15.482-1.05 43.35 28.352-33.853 42.842 14.863-24.782-36.332 30.242-36.125-46.413 12.798-27.512-39.428z\" fill=\"#fff\"></path></g>", 1)
const DpFlagTRvue_type_template_id_79d07c8e_hoisted_3 = [
  DpFlagTRvue_type_template_id_79d07c8e_hoisted_2
]
const DpFlagTRvue_type_template_id_79d07c8e_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagTRvue_type_template_id_79d07c8e_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\"><path fill=\"#f31930\" d=\"M0 0h640v480H0z\"></path><path d=\"M406.977 247.473c0 66.215-54.606 119.89-121.97 119.89S163.04 313.686 163.04 247.472s54.606-119.89 121.968-119.89 121.97 53.677 121.97 119.89z\" fill=\"#fff\"></path><path d=\"M413.077 247.467c0 52.97-43.686 95.91-97.575 95.91s-97.574-42.94-97.574-95.91 43.686-95.91 97.574-95.91 97.575 42.94 97.575 95.91z\" fill=\"#f31830\"></path><path d=\"M430.726 191.465l-.985 44.318-41.345 11.225 40.756 14.514-.984 40.642 26.58-31.738 40.164 13.934-23.233-34.06 28.352-33.868-43.513 11.998-25.793-36.964z\" fill=\"#fff\"></path></g>", 1)
const DpFlagTRvue_type_template_id_79d07c8e_hoisted_6 = [
  DpFlagTRvue_type_template_id_79d07c8e_hoisted_5
]

function DpFlagTRvue_type_template_id_79d07c8e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagTRvue_type_template_id_79d07c8e_hoisted_1, DpFlagTRvue_type_template_id_79d07c8e_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagTRvue_type_template_id_79d07c8e_hoisted_4, DpFlagTRvue_type_template_id_79d07c8e_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagTR.vue?vue&type=template&id=79d07c8e

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagTR.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagTRvue_type_script_lang_js = ({
  name: "DpFlagTR",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagTR.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagTR.vue




;
const DpFlagTR_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagTRvue_type_script_lang_js, [['render',DpFlagTRvue_type_template_id_79d07c8e_render]])

/* harmony default export */ var DpFlagTR = (DpFlagTR_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagUS.vue?vue&type=template&id=6c461f14


const DpFlagUSvue_type_template_id_6c461f14_hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 512 512"
}
const DpFlagUSvue_type_template_id_6c461f14_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\"><g stroke-width=\"1pt\"><path d=\"M0 0h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0z\" fill=\"#bd3d44\" transform=\"scale(3.9385)\"></path><path d=\"M0 10h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0z\" fill=\"#fff\" transform=\"scale(3.9385)\"></path></g><path fill=\"#192f5d\" d=\"M0 0h98.8v70H0z\" transform=\"scale(3.9385)\"></path><g fill=\"#fff\"><path d=\"M8.233 2.996l.9 2.767h2.908l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766L24.7 8.53l-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766L74.1 8.53l-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm-74.1 7l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm-74.1 7l.9 2.767h2.908l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm-74.1 7l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm-74.1 7l.9 2.767h2.908l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm-74.1 7l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zM8.233 44.996l.9 2.767h2.908l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm-74.1 7l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zM8.233 58.996l.9 2.767h2.908l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.353 1.71.898 2.766-2.353-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.466 0l.899 2.767h2.909l-2.353 1.71.899 2.766-2.354-1.71-2.353 1.71.899-2.766-2.354-1.71h2.91zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909zm16.467 0l.899 2.767h2.909l-2.354 1.71.9 2.766-2.354-1.71-2.353 1.71.898-2.766-2.353-1.71h2.909z\" transform=\"scale(3.9385)\"></path></g></g>", 1)
const DpFlagUSvue_type_template_id_6c461f14_hoisted_3 = [
  DpFlagUSvue_type_template_id_6c461f14_hoisted_2
]
const DpFlagUSvue_type_template_id_6c461f14_hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  preserveAspectRatio: "xMidYMid slice",
  viewBox: "0 0 640 480"
}
const DpFlagUSvue_type_template_id_6c461f14_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createStaticVNode)("<g fill-rule=\"evenodd\"><g stroke-width=\"1pt\"><path d=\"M0 0h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0z\" fill=\"#bd3d44\" transform=\"scale(.9375)\"></path><path d=\"M0 39.385h972.81V78.77H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0zm0 78.77h972.81v39.385H0z\" fill=\"#fff\" transform=\"scale(.9375)\"></path></g><path fill=\"#192f5d\" d=\"M0 0h389.12v275.69H0z\" transform=\"scale(.9375)\"></path><g fill=\"#fff\"><path d=\"M32.427 11.8l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.853 0l3.541 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735H93.74zm64.856 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.269 6.734 3.54-10.896-9.269-6.735h11.458zm64.852 0l3.54 10.896h11.457l-9.269 6.735 3.54 10.896-9.268-6.734-9.27 6.734 3.541-10.896-9.27-6.735h11.458zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.27 6.734 3.542-10.896-9.27-6.735h11.458zM64.855 39.37l3.54 10.896h11.458L70.583 57l3.542 10.897-9.27-6.734-9.269 6.734L59.126 57l-9.269-6.734h11.458zm64.852 0l3.54 10.896h11.457L135.435 57l3.54 10.897-9.268-6.734-9.27 6.734L123.978 57l-9.27-6.734h11.458zm64.855 0l3.54 10.896h11.458L200.29 57l3.541 10.897-9.27-6.734-9.268 6.734L188.833 57l-9.269-6.734h11.457zm64.855 0l3.54 10.896h11.458L265.145 57l3.541 10.897-9.269-6.734-9.27 6.734L253.69 57l-9.27-6.734h11.458zm64.852 0l3.54 10.896h11.457L329.997 57l3.54 10.897-9.268-6.734-9.27 6.734L318.54 57l-9.27-6.734h11.458zM32.427 66.939l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.853 0l3.541 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735H93.74zm64.856 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.269 6.734 3.54-10.896-9.269-6.735h11.458zm64.852 0l3.54 10.896h11.457l-9.269 6.735 3.54 10.896-9.268-6.734-9.27 6.734 3.541-10.896-9.27-6.735h11.458zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.27 6.734 3.542-10.896-9.27-6.735h11.458zM64.855 94.508l3.54 10.897h11.458l-9.27 6.734 3.542 10.897-9.27-6.734-9.269 6.734 3.54-10.897-9.269-6.734h11.458zm64.852 0l3.54 10.897h11.457l-9.269 6.734 3.54 10.897-9.268-6.734-9.27 6.734 3.541-10.897-9.27-6.734h11.458zm64.855 0l3.54 10.897h11.458l-9.27 6.734 3.541 10.897-9.27-6.734-9.268 6.734 3.54-10.897-9.269-6.734h11.457zm64.855 0l3.54 10.897h11.458l-9.27 6.734 3.541 10.897-9.269-6.734-9.27 6.734 3.542-10.897-9.27-6.734h11.458zm64.852 0l3.54 10.897h11.457l-9.269 6.734 3.54 10.897-9.268-6.734-9.27 6.734 3.541-10.897-9.27-6.734h11.458zm-291.842 27.57l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.853 0l3.541 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735H93.74zm64.856 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.269 6.734 3.54-10.896-9.269-6.735h11.458zm64.852 0l3.54 10.896h11.457l-9.269 6.735 3.54 10.896-9.268-6.734-9.27 6.734 3.541-10.896-9.27-6.735h11.458zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.27 6.734 3.542-10.896-9.27-6.735h11.458zM64.855 149.647l3.54 10.897h11.458l-9.27 6.734 3.542 10.897-9.27-6.734-9.269 6.734 3.54-10.897-9.269-6.734h11.458zm64.852 0l3.54 10.897h11.457l-9.269 6.734 3.54 10.897-9.268-6.734-9.27 6.734 3.541-10.897-9.27-6.734h11.458zm64.855 0l3.54 10.897h11.458l-9.27 6.734 3.541 10.897-9.27-6.734-9.268 6.734 3.54-10.897-9.269-6.734h11.457zm64.855 0l3.54 10.897h11.458l-9.27 6.734 3.541 10.897-9.269-6.734-9.27 6.734 3.542-10.897-9.27-6.734h11.458zm64.852 0l3.54 10.897h11.457l-9.269 6.734 3.54 10.897-9.268-6.734-9.27 6.734 3.541-10.897-9.27-6.734h11.458zM32.427 177.217l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.853 0l3.541 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735H93.74zm64.856 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.269 6.734 3.54-10.896-9.269-6.735h11.458zm64.852 0l3.54 10.896h11.457l-9.269 6.735 3.54 10.896-9.268-6.734-9.27 6.734 3.541-10.896-9.27-6.735h11.458zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.27 6.734 3.542-10.896-9.27-6.735h11.458zM64.855 204.786l3.54 10.897h11.458l-9.27 6.734 3.542 10.897-9.27-6.734-9.269 6.734 3.54-10.897-9.269-6.734h11.458zm64.852 0l3.54 10.897h11.457l-9.269 6.734 3.54 10.897-9.268-6.734-9.27 6.734 3.541-10.897-9.27-6.734h11.458zm64.855 0l3.54 10.897h11.458l-9.27 6.734 3.541 10.897-9.27-6.734-9.268 6.734 3.54-10.897-9.269-6.734h11.457zm64.855 0l3.54 10.897h11.458l-9.27 6.734 3.541 10.897-9.269-6.734-9.27 6.734 3.542-10.897-9.27-6.734h11.458zm64.852 0l3.54 10.897h11.457l-9.269 6.734 3.54 10.897-9.268-6.734-9.27 6.734 3.541-10.897-9.27-6.734h11.458zM32.427 232.356l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.853 0l3.541 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735H93.74zm64.856 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.269 6.734 3.54-10.896-9.269-6.735h11.458zm64.852 0l3.54 10.896h11.457l-9.269 6.735 3.54 10.896-9.268-6.734-9.27 6.734 3.541-10.896-9.27-6.735h11.458zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.27-6.734-9.268 6.734 3.54-10.896-9.269-6.735h11.457zm64.855 0l3.54 10.896h11.458l-9.27 6.735 3.541 10.896-9.269-6.734-9.27 6.734 3.542-10.896-9.27-6.735h11.458z\" transform=\"scale(.9375)\"></path></g></g>", 1)
const DpFlagUSvue_type_template_id_6c461f14_hoisted_6 = [
  DpFlagUSvue_type_template_id_6c461f14_hoisted_5
]

function DpFlagUSvue_type_template_id_6c461f14_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.square)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagUSvue_type_template_id_6c461f14_hoisted_1, DpFlagUSvue_type_template_id_6c461f14_hoisted_3))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", DpFlagUSvue_type_template_id_6c461f14_hoisted_4, DpFlagUSvue_type_template_id_6c461f14_hoisted_6))
}
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagUS.vue?vue&type=template&id=6c461f14

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag/DpFlagUS.vue?vue&type=script&lang=js

/* harmony default export */ var DpFlagUSvue_type_script_lang_js = ({
  name: "DpFlagUS",
  props: {
    square: {type: Boolean, default: false}
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagUS.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpFlag/DpFlagUS.vue




;
const DpFlagUS_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagUSvue_type_script_lang_js, [['render',DpFlagUSvue_type_template_id_6c461f14_render]])

/* harmony default export */ var DpFlagUS = (DpFlagUS_exports_);
;// CONCATENATED MODULE: ./src/components/DpFlag/index.js
// import DpFlagAD from './DpFlagAD';

// import DpFlagAF from './DpFlagAF';
// import DpFlagAG from './DpFlagAG';
// import DpFlagAI from './DpFlagAI';
// import DpFlagAL from './DpFlagAL';
// import DpFlagAM from './DpFlagAM';
// import DpFlagAO from './DpFlagAO';
// import DpFlagAQ from './DpFlagAQ';
// import DpFlagAR from './DpFlagAR';
// import DpFlagAS from './DpFlagAS';

// import DpFlagAU from './DpFlagAU';
// import DpFlagAW from './DpFlagAW';
// import DpFlagAX from './DpFlagAX';
// import DpFlagAZ from './DpFlagAZ';

// import DpFlagBB from './DpFlagBB';
// import DpFlagBD from './DpFlagBD';

// import DpFlagBF from './DpFlagBF';

// import DpFlagBH from './DpFlagBH';
// import DpFlagBI from './DpFlagBI';
// import DpFlagBJ from './DpFlagBJ';
// import DpFlagBL from './DpFlagBL';
// import DpFlagBM from './DpFlagBM';
// import DpFlagBN from './DpFlagBN';
// import DpFlagBO from './DpFlagBO';
// import DpFlagBQ from './DpFlagBQ';
// import DpFlagBR from './DpFlagBR';
// import DpFlagBS from './DpFlagBS';
// import DpFlagBT from './DpFlagBT';
// import DpFlagBV from './DpFlagBV';
// import DpFlagBW from './DpFlagBW';
// import DpFlagBY from './DpFlagBY';
// import DpFlagBZ from './DpFlagBZ';
// import DpFlagCA from './DpFlagCA';
// import DpFlagCC from './DpFlagCC';
// import DpFlagCD from './DpFlagCD';
// import DpFlagCF from './DpFlagCF';
// import DpFlagCG from './DpFlagCG';

// import DpFlagCI from './DpFlagCI';
// import DpFlagCK from './DpFlagCK';
// import DpFlagCL from './DpFlagCL';
// import DpFlagCM from './DpFlagCM';

// import DpFlagCO from './DpFlagCO';
// import DpFlagCR from './DpFlagCR';
// import DpFlagCU from './DpFlagCU';
// import DpFlagCV from './DpFlagCV';
// import DpFlagCW from './DpFlagCW';
// import DpFlagCX from './DpFlagCX';



// import DpFlagDJ from './DpFlagDJ';

// import DpFlagDM from './DpFlagDM';
// import DpFlagDO from './DpFlagDO';
// import DpFlagDZ from './DpFlagDZ';
// import DpFlagEC from './DpFlagEC';

// import DpFlagEG from './DpFlagEG';
// import DpFlagEH from './DpFlagEH';
// import DpFlagER from './DpFlagER';

// import DpFlagES_CT from './DpFlagES_CT';
// import DpFlagET from './DpFlagET';
// import DpFlagEU from './DpFlagEU';

// import DpFlagFJ from './DpFlagFJ';
// import DpFlagFK from './DpFlagFK';
// import DpFlagFM from './DpFlagFM';
// import DpFlagFO from './DpFlagFO';

// import DpFlagGA from './DpFlagGA';

// import DpFlagGB_ENG from './DpFlagGB_ENG';
// import DpFlagGB_NIR from './DpFlagGB_NIR';
// import DpFlagGB_SCT from './DpFlagGB_SCT';
// import DpFlagGB_WLS from './DpFlagGB_WLS';
// import DpFlagGD from './DpFlagGD';
// import DpFlagGE from './DpFlagGE';
// import DpFlagGF from './DpFlagGF';
// import DpFlagGG from './DpFlagGG';
// import DpFlagGH from './DpFlagGH';
// import DpFlagGI from './DpFlagGI';
// import DpFlagGL from './DpFlagGL';
// import DpFlagGM from './DpFlagGM';
// import DpFlagGN from './DpFlagGN';
// import DpFlagGP from './DpFlagGP';
// import DpFlagGQ from './DpFlagGQ';

// import DpFlagGS from './DpFlagGS';
// import DpFlagGT from './DpFlagGT';
// import DpFlagGU from './DpFlagGU';
// import DpFlagGW from './DpFlagGW';
// import DpFlagGY from './DpFlagGY';
// import DpFlagHK from './DpFlagHK';
// import DpFlagHM from './DpFlagHM';
// import DpFlagHN from './DpFlagHN';

// import DpFlagHT from './DpFlagHT';

// import DpFlagID from './DpFlagID';


// import DpFlagIM from './DpFlagIM';
// import DpFlagIN from './DpFlagIN';
// import DpFlagIO from './DpFlagIO';
// import DpFlagIQ from './DpFlagIQ';
// import DpFlagIR from './DpFlagIR';
// import DpFlagIS from './DpFlagIS';

// import DpFlagJE from './DpFlagJE';
// import DpFlagJM from './DpFlagJM';
// import DpFlagJO from './DpFlagJO';

// import DpFlagKE from './DpFlagKE';
// import DpFlagKG from './DpFlagKG';
// import DpFlagKH from './DpFlagKH';
// import DpFlagKI from './DpFlagKI';
// import DpFlagKM from './DpFlagKM';
// import DpFlagKN from './DpFlagKN';
// import DpFlagKP from './DpFlagKP';
// import DpFlagKR from './DpFlagKR';
// import DpFlagKW from './DpFlagKW';
// import DpFlagKY from './DpFlagKY';
// import DpFlagKZ from './DpFlagKZ';
// import DpFlagLA from './DpFlagLA';
// import DpFlagLB from './DpFlagLB';
// import DpFlagLC from './DpFlagLC';
// import DpFlagLI from './DpFlagLI';
// import DpFlagLK from './DpFlagLK';
// import DpFlagLR from './DpFlagLR';
// import DpFlagLS from './DpFlagLS';



// import DpFlagLY from './DpFlagLY';
// import DpFlagMA from './DpFlagMA';
// import DpFlagMC from './DpFlagMC';
// import DpFlagMD from './DpFlagMD';
// import DpFlagME from './DpFlagME';
// import DpFlagMF from './DpFlagMF';
// import DpFlagMG from './DpFlagMG';
// import DpFlagMH from './DpFlagMH';
// import DpFlagMK from './DpFlagMK';
// import DpFlagML from './DpFlagML';
// import DpFlagMM from './DpFlagMM';
// import DpFlagMN from './DpFlagMN';
// import DpFlagMO from './DpFlagMO';
// import DpFlagMP from './DpFlagMP';
// import DpFlagMQ from './DpFlagMQ';
// import DpFlagMR from './DpFlagMR';
// import DpFlagMS from './DpFlagMS';

// import DpFlagMU from './DpFlagMU';
// import DpFlagMV from './DpFlagMV';
// import DpFlagMW from './DpFlagMW';
// import DpFlagMX from './DpFlagMX';
// import DpFlagMY from './DpFlagMY';
// import DpFlagMZ from './DpFlagMZ';
// import DpFlagNA from './DpFlagNA';
// import DpFlagNC from './DpFlagNC';
// import DpFlagNE from './DpFlagNE';
// import DpFlagNF from './DpFlagNF';
// import DpFlagNG from './DpFlagNG';
// import DpFlagNI from './DpFlagNI';

// import DpFlagNO from './DpFlagNO';
// import DpFlagNP from './DpFlagNP';
// import DpFlagNR from './DpFlagNR';
// import DpFlagNU from './DpFlagNU';
// import DpFlagNZ from './DpFlagNZ';
// import DpFlagOM from './DpFlagOM';
// import DpFlagPA from './DpFlagPA';
// import DpFlagPE from './DpFlagPE';
// import DpFlagPF from './DpFlagPF';
// import DpFlagPG from './DpFlagPG';
// import DpFlagPH from './DpFlagPH';
// import DpFlagPK from './DpFlagPK';

// import DpFlagPM from './DpFlagPM';
// import DpFlagPN from './DpFlagPN';
// import DpFlagPR from './DpFlagPR';
// import DpFlagPS from './DpFlagPS';

// import DpFlagPW from './DpFlagPW';
// import DpFlagPY from './DpFlagPY';
// import DpFlagQA from './DpFlagQA';
// import DpFlagRE from './DpFlagRE';

// import DpFlagRS from './DpFlagRS';

// import DpFlagRW from './DpFlagRW';
// import DpFlagSA from './DpFlagSA';
// import DpFlagSB from './DpFlagSB';
// import DpFlagSC from './DpFlagSC';
// import DpFlagSD from './DpFlagSD';

// import DpFlagSG from './DpFlagSG';
// import DpFlagSH from './DpFlagSH';

// import DpFlagSJ from './DpFlagSJ';

// import DpFlagSL from './DpFlagSL';
// import DpFlagSM from './DpFlagSM';
// import DpFlagSN from './DpFlagSN';
// import DpFlagSO from './DpFlagSO';
// import DpFlagSR from './DpFlagSR';
// import DpFlagSS from './DpFlagSS';
// import DpFlagST from './DpFlagST';
// import DpFlagSV from './DpFlagSV';
// import DpFlagSX from './DpFlagSX';
// import DpFlagSY from './DpFlagSY';
// import DpFlagSZ from './DpFlagSZ';
// import DpFlagTC from './DpFlagTC';
// import DpFlagTD from './DpFlagTD';
// import DpFlagTF from './DpFlagTF';
// import DpFlagTG from './DpFlagTG';
// import DpFlagTH from './DpFlagTH';
// import DpFlagTJ from './DpFlagTJ';
// import DpFlagTK from './DpFlagTK';
// import DpFlagTL from './DpFlagTL';
// import DpFlagTM from './DpFlagTM';
// import DpFlagTN from './DpFlagTN';
// import DpFlagTO from './DpFlagTO';

// import DpFlagTT from './DpFlagTT';
// import DpFlagTV from './DpFlagTV';
// import DpFlagTW from './DpFlagTW';
// import DpFlagTZ from './DpFlagTZ';
// import DpFlagUA from './DpFlagUA';
// import DpFlagUG from './DpFlagUG';
// import DpFlagUM from './DpFlagUM';
// import DpFlagUN from './DpFlagUN';

// import DpFlagUY from './DpFlagUY';
// import DpFlagUZ from './DpFlagUZ';
// import DpFlagVA from './DpFlagVA';
// import DpFlagVC from './DpFlagVC';
// import DpFlagVE from './DpFlagVE';
// import DpFlagVG from './DpFlagVG';
// import DpFlagVI from './DpFlagVI';
// import DpFlagVN from './DpFlagVN';
// import DpFlagVU from './DpFlagVU';
// import DpFlagWF from './DpFlagWF';
// import DpFlagWS from './DpFlagWS';
// import DpFlagYE from './DpFlagYE';
// import DpFlagYT from './DpFlagYT';
// import DpFlagZA from './DpFlagZA';
// import DpFlagZM from './DpFlagZM';
// import DpFlagZW from './DpFlagZW';

/* harmony default export */ var DpFlag = ({
  // DpFlagAD,
  DpFlagAE: DpFlagAE,
  // DpFlagAF,
  // DpFlagAG,
  // DpFlagAI,
  // DpFlagAL,
  // DpFlagAM,
  // DpFlagAO,
  // DpFlagAQ,
  // DpFlagAR,
  // DpFlagAS,
  DpFlagAT: DpFlagAT,
  // DpFlagAU,
  // DpFlagAW,
  // DpFlagAX,
  // DpFlagAZ,
  DpFlagBA: DpFlagBA,
  // DpFlagBB,
  // DpFlagBD,
  DpFlagBE: DpFlagBE,
  // DpFlagBF,
  DpFlagBG: DpFlagBG,
  // DpFlagBH,
  // DpFlagBI,
  // DpFlagBJ,
  // DpFlagBL,
  // DpFlagBM,
  // DpFlagBN,
  // DpFlagBO,
  // DpFlagBQ,
  // DpFlagBR,
  // DpFlagBS,
  // DpFlagBT,
  // DpFlagBV,
  // DpFlagBW,
  // DpFlagBY,
  // DpFlagBZ,
  // DpFlagCA,
  // DpFlagCC,
  // DpFlagCD,
  // DpFlagCF,
  // DpFlagCG,
  DpFlagCH: DpFlagCH,
  // DpFlagCI,
  // DpFlagCK,
  // DpFlagCL,
  // DpFlagCM,
  DpFlagCN: DpFlagCN,
  // DpFlagCO,
  // DpFlagCR,
  // DpFlagCU,
  // DpFlagCV,
  // DpFlagCW,
  // DpFlagCX,
  DpFlagCY: DpFlagCY,
  DpFlagCZ: DpFlagCZ,
  DpFlagDE: DpFlagDE,
  // DpFlagDJ,
  DpFlagDK: DpFlagDK,
  // DpFlagDM,
  // DpFlagDO,
  // DpFlagDZ,
  // DpFlagEC,
  DpFlagEE: DpFlagEE,
  // DpFlagEG,
  // DpFlagEH,
  // DpFlagER,
  DpFlagES: DpFlagES,
  // DpFlagES_CT,
  // DpFlagET,
  // DpFlagEU,
  DpFlagFI: DpFlagFI,
  // DpFlagFJ,
  // DpFlagFK,
  // DpFlagFM,
  // DpFlagFO,
  DpFlagFR: DpFlagFR,
  // DpFlagGA,
  DpFlagGB: DpFlagGB,
  // DpFlagGB_ENG,
  // DpFlagGB_NIR,
  // DpFlagGB_SCT,
  // DpFlagGB_WLS,
  // DpFlagGD,
  // DpFlagGE,
  // DpFlagGF,
  // DpFlagGG,
  // DpFlagGH,
  // DpFlagGI,
  // DpFlagGL,
  // DpFlagGM,
  // DpFlagGN,
  // DpFlagGP,
  // DpFlagGQ,
  DpFlagGR: DpFlagGR,
  // DpFlagGS,
  // DpFlagGT,
  // DpFlagGU,
  // DpFlagGW,
  // DpFlagGY,
  // DpFlagHK,
  // DpFlagHM,
  // DpFlagHN,
  DpFlagHR: DpFlagHR,
  // DpFlagHT,
  DpFlagHU: DpFlagHU,
  // DpFlagID,
  DpFlagIE: DpFlagIE,
  DpFlagIL: DpFlagIL,
  // DpFlagIM,
  // DpFlagIN,
  // DpFlagIO,
  // DpFlagIQ,
  // DpFlagIR,
  // DpFlagIS,
  DpFlagIT: DpFlagIT,
  // DpFlagJE,
  // DpFlagJM,
  // DpFlagJO,
  DpFlagJP: DpFlagJP,
  // DpFlagKE,
  // DpFlagKG,
  // DpFlagKH,
  // DpFlagKI,
  // DpFlagKM,
  // DpFlagKN,
  // DpFlagKP,
  // DpFlagKR,
  // DpFlagKW,
  // DpFlagKY,
  // DpFlagKZ,
  // DpFlagLA,
  // DpFlagLB,
  // DpFlagLC,
  // DpFlagLI,
  // DpFlagLK,
  // DpFlagLR,
  // DpFlagLS,
  DpFlagLT: DpFlagLT,
  DpFlagLU: DpFlagLU,
  DpFlagLV: DpFlagLV,
  // DpFlagLY,
  // DpFlagMA,
  // DpFlagMC,
  // DpFlagMD,
  // DpFlagME,
  // DpFlagMF,
  // DpFlagMG,
  // DpFlagMH,
  // DpFlagMK,
  // DpFlagML,
  // DpFlagMM,
  // DpFlagMN,
  // DpFlagMO,
  // DpFlagMP,
  // DpFlagMQ,
  // DpFlagMR,
  // DpFlagMS,
  DpFlagMT: DpFlagMT,
  // DpFlagMU,
  // DpFlagMV,
  // DpFlagMW,
  // DpFlagMX,
  // DpFlagMY,
  // DpFlagMZ,
  // DpFlagNA,
  // DpFlagNC,
  // DpFlagNE,
  // DpFlagNF,
  // DpFlagNG,
  // DpFlagNI,
  DpFlagNL: DpFlagNL,
  // DpFlagNO,
  // DpFlagNP,
  // DpFlagNR,
  // DpFlagNU,
  // DpFlagNZ,
  // DpFlagOM,
  // DpFlagPA,
  // DpFlagPE,
  // DpFlagPF,
  // DpFlagPG,
  // DpFlagPH,
  // DpFlagPK,
  DpFlagPL: DpFlagPL,
  // DpFlagPM,
  // DpFlagPN,
  // DpFlagPR,
  // DpFlagPS,
  DpFlagPT: DpFlagPT,
  // DpFlagPW,
  // DpFlagPY,
  // DpFlagQA,
  // DpFlagRE,
  DpFlagRO: DpFlagRO,
  // DpFlagRS,
  DpFlagRU: DpFlagRU,
  // DpFlagRW,
  // DpFlagSA,
  // DpFlagSB,
  // DpFlagSC,
  // DpFlagSD,
  DpFlagSE: DpFlagSE,
  // DpFlagSG,
  // DpFlagSH,
  DpFlagSI: DpFlagSI,
  // DpFlagSJ,
  DpFlagSK: DpFlagSK,
  // DpFlagSL,
  // DpFlagSM,
  // DpFlagSN,
  // DpFlagSO,
  // DpFlagSR,
  // DpFlagSS,
  // DpFlagST,
  // DpFlagSV,
  // DpFlagSX,
  // DpFlagSY,
  // DpFlagSZ,
  // DpFlagTC,
  // DpFlagTD,
  // DpFlagTF,
  // DpFlagTG,
  // DpFlagTH,
  // DpFlagTJ,
  // DpFlagTK,
  // DpFlagTL,
  // DpFlagTM,
  // DpFlagTN,
  // DpFlagTO,
  DpFlagTR: DpFlagTR,
  // DpFlagTT,
  // DpFlagTV,
  // DpFlagTW,
  // DpFlagTZ,
  // DpFlagUA,
  // DpFlagUG,
  // DpFlagUM,
  // DpFlagUN,
  DpFlagUS: DpFlagUS,
  // DpFlagUY,
  // DpFlagUZ,
  // DpFlagVA,
  // DpFlagVC,
  // DpFlagVE,
  // DpFlagVG,
  // DpFlagVI,
  // DpFlagVN,
  // DpFlagVU,
  // DpFlagWF,
  // DpFlagWS,
  // DpFlagYE,
  // DpFlagYT,
  // DpFlagZA,
  // DpFlagZM,
  // DpFlagZW
});

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag.vue?vue&type=script&lang=js




/* harmony default export */ var DpFlagvue_type_script_lang_js = ({
  name: "DpFlag",
  components: {...DpFlag},
  props: {
    flagISOCode: {type: String, required: true},
    square: {type: Boolean, default: false}
  },
  computed: {
    hasFlagISOCode() {
      return !isEmpty_default()(this.flagISOCode);
    }
  }
});

;// CONCATENATED MODULE: ./src/components/DpFlag.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpFlag.vue?vue&type=style&index=0&id=56c9ff3e&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpFlag.vue?vue&type=style&index=0&id=56c9ff3e&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/DpFlag.vue




;


const DpFlag_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpFlagvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-56c9ff3e"]])

/* harmony default export */ var components_DpFlag = (DpFlag_exports_);

/***/ }),

/***/ 1628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpHeader; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/pinia/dist/pinia.esm-browser.js + 1 modules
var pinia_esm_browser = __webpack_require__(8262);
// EXTERNAL MODULE: external "@dutypay/store-modules"
var store_modules_ = __webpack_require__(2706);
// EXTERNAL MODULE: ./src/components/DpImg.vue + 4 modules
var DpImg = __webpack_require__(7789);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(7361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/Avatar.vue?vue&type=script&setup=true&lang=js


const _withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-6c558033"),n=n(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(),n)
const _hoisted_1 = { class: "avatar__container" }
const _hoisted_2 = { class: "avatar__wrapper" }
const _hoisted_3 = { class: "avatar" }
const _hoisted_4 = {
  key: 0,
  class: "avatar-flag"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", { class: "clear-both" }, null, -1))

;





/* harmony default export */ var Avatarvue_type_script_setup_true_lang_js = ({
  __name: 'Avatar',
  props: {
  flagISOCode: {
    type: String
  }
},
  setup(__props) {

const props = __props



const authStore = (0,store_modules_.useAuthStore)()
const user = authStore.user;
const hasUserName = authStore.hasUserName;

const userName = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return (hasUserName) ? `${user.name.given} ${user.name.family}` : '';
});
const showNotification = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return false;
});

const composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables')
const { getJurisdictionByLocale } = composables.useJurisdictionSwitch()

return (_ctx, _cache) => {
  const _component_DpFlag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFlag")
  const _component_el_badge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-badge")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_badge, {
      hidden: !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(showNotification),
      "is-dot": "",
      class: "item"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_2, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_3, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpImg["default"]), {
              hsId: "ff0d5e0e-af9c-4fe5-966b-8979af756981",
              class: "avatar__image",
              alt: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(userName),
              srcset: [
                    {resourceSize: 'height/24', renderSize: '1x'},
                    {resourceSize: 'height/48', renderSize: '2x'},
                  ]
            }, null, 8, ["alt"])
          ]),
          ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(getJurisdictionByLocale)(_ctx.$i18n.locale), 'flagISOCode', false))
            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_4, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFlag, {
                  class: "avatar-flag__flag-icon",
                  flagISOCode: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(getJurisdictionByLocale)(_ctx.$i18n.locale).flagISOCode
                }, null, 8, ["flagISOCode"])
              ]))
            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
        ])
      ]),
      _: 1
    }, 8, ["hidden"]),
    _hoisted_5
  ]))
}
}

});
;// CONCATENATED MODULE: ./src/components/DpHeader/Avatar.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/Avatar.vue?vue&type=style&index=0&id=6c558033&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader/Avatar.vue?vue&type=style&index=0&id=6c558033&scoped=true&lang=scss

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpHeader/Avatar.vue



;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Avatarvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-6c558033"]])

/* harmony default export */ var Avatar = (__exports__);
// EXTERNAL MODULE: ./src/components/DpWrapper.vue + 6 modules
var DpWrapper = __webpack_require__(9293);
// EXTERNAL MODULE: ./src/components/DpIcon.vue + 2 modules
var DpIcon = __webpack_require__(5172);
// EXTERNAL MODULE: ./src/components/DpApplicationLogo.vue + 355 modules
var DpApplicationLogo = __webpack_require__(5159);
// EXTERNAL MODULE: ./src/components/DpTooltip.vue + 7 modules
var DpTooltip = __webpack_require__(4685);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/AvatarMenu.vue?vue&type=script&setup=true&lang=js


const AvatarMenuvue_type_script_setup_true_lang_js_withScopeId = n => (_pushScopeId("data-v-572687d6"),n=n(),_popScopeId(),n)
const AvatarMenuvue_type_script_setup_true_lang_js_hoisted_1 = { ref: "avatarMenu" }
const AvatarMenuvue_type_script_setup_true_lang_js_hoisted_2 = { class: "avatar-menu__wrapper" }
const AvatarMenuvue_type_script_setup_true_lang_js_hoisted_3 = {
  key: 0,
  class: "avatar-menu__container"
}
const AvatarMenuvue_type_script_setup_true_lang_js_hoisted_4 = { class: "avatar-menu__category" }
const AvatarMenuvue_type_script_setup_true_lang_js_hoisted_5 = { class: "avatar-menu__items" }
const _hoisted_6 = { class: "avatar-menu__container" }
const _hoisted_7 = { class: "avatar-menu__category" }
const _hoisted_8 = { class: "avatar-menu__category" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "jurisdiction-select__prefix" }
const _hoisted_11 = { class: "jurisdiction-select__option__flag" }
const _hoisted_12 = { class: "jurisdiction-select__option__translation" }
const _hoisted_13 = { class: "avatar-menu__items" }
const _hoisted_14 = ["onClick", "onKeypress"]
const _hoisted_15 = { class: "avatar-menu__category" }
const _hoisted_16 = { class: "avatar-menu__items" }
const _hoisted_17 = ["onClick", "onKeypress"]
const _hoisted_18 = { class: "avatar-menu__category" }
const _hoisted_19 = { class: "avatar-menu__items" }
const _hoisted_20 = ["onClick", "onKeypress"]
const _hoisted_21 = { class: "avatar-menu__category" }
const _hoisted_22 = { class: "avatar-menu__items" }
const _hoisted_23 = ["onClick", "onKeypress"]
const _hoisted_24 = { class: "avatar-menu__category" }
const _hoisted_25 = { class: "avatar-menu__items" }
const _hoisted_26 = ["onClick", "onKeypress"]
const _hoisted_27 = { class: "avatar-menu__legal" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }


const __default__ = {
  name: "AvatarMenu"
}

;








/* harmony default export */ var AvatarMenuvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  props: {
  companySelect: {type: Object},
  closeHandler: {type: Function},
  jurisdictionSelect: {type: Object},
  hasCompanySwitch: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props

const composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

const spanSettings = {
  xl: {span: '6'},
  lg: {span: '6'},
  md: {span: '12'},
  sm: {span: '12'},
  xs: {span: '24'}
}
const spanSettingsWide = {
  xl: {span: '12'},
  lg: {span: '12'},
  md: {span: '24'},
  sm: {span: '24'},
  xs: {span: '24'}
}



const {jurisdictionList, getJurisdictionByLocale, setJurisdiction} = composables.useJurisdictionSwitch();
const {locale} = (0,vue_i18n_esm_bundler/* useI18n */.QT)({ useScope: 'global' });
const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()
const jurisdictionsAlias = t('ds.components.DpHeader.AvatarMenu.jurisdiction.selectValues');

function handleJurisdictionSwitch(jurisdiction) {
  setJurisdiction(locale, jurisdiction)
}
const currentJurisdiction = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(getJurisdictionByLocale(locale.value))

// Settings pages menu items
const envStore = (0,store_modules_.useEnvStore)()
const authStore = (0,store_modules_.useAuthStore)()
const companyStore = (0,store_modules_.useCompanyStore)()
const router = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('router')

const accountSettings = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => [
  {
    label: t("accountSettings.accountInformation.linkLabel"),
    action: function() { router.push({ path: "/account-settings/account-information" }) }
  },
  {
    label: t("accountSettings.securitySettings.linkLabel"),
    action: function() { router.push({ path: "/account-settings/security-settings" }) }
  },
  {
    label: t('accountSettings.logout.linkLabel'),
    action: function() { window.location.href = envStore.ssoUrl + '/logout#i18n=' + locale.value }
  }
])

const companySettings = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => [
  (envStore.debug
  || ( !(0,lodash.isEmpty)(authStore.user) && authStore.user.roles.indexOf('global:admin') > -1 )
  || ( ( !(0,lodash.isEmpty)(authStore.user) && authStore.user.roles.indexOf(`company:${companyStore.selectedCompany.id}:admin`) > -1) ))
  ? {
      label: t("companySettings.integrations.linkLabel"),
      action: function() { router.push({ path: "/company-settings/integrations" }) }
    } : {},
  (envStore.debug)
  ? {
    label: t("companySettings.companyInformation.linkLabel"),
    action: function() { router.push({path: "/company-settings/company-information" }) }
  } : {}
])

const applicationSettings = []

const developerSettings = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return (!(0,lodash.isEmpty)(authStore.user)
    && (0,lodash.findIndex)(authStore.user.roles, (item) => {return item === 'global:admin' || item === 'global:developer'}) !== -1)
    ? [{
      label: t("developerSettings.translationReport.linkLabel"),
      action: function() { router.push({ path: "/developer-settings/translation-report" }) }
    }, {
      label: t("developerSettings.translationEmailReportOverview.linkLabel"),
      action: function() { router.push({ path: "/developer-settings/translation-email-report-overview" }) }
    }] : []
  })

const adminSettings = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return (!(0,lodash.isEmpty)(authStore.user)
    && (0,lodash.findIndex)(authStore.user.roles, (item) => {return item === 'global:admin'}) !== -1)
    ? [{
        label: t("adminSettings.companyAdministration.linkLabel"),
        action: function() { router.push({ path: "/admin-settings/companies" }) }
      }, {
        label: t("adminSettings.userAdministration.linkLabel"),
        action: function() { router.push({ path: "/admin-settings/users" }) }
    }] : []
  })

const legalLinks = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  let links = [];
  links.push({
    path: '/imprint',
    label: t('legalLinks.imprint.linkLabel')
  }, {
    path: '/privacy-policy',
    label: t('legalLinks.privacyPolicy.linkLabel')
  });
  if (envStore.debug) {
    links.push({
      path: '/terms-and-conditions',
      label: t('legalLinks.termsAndConditions.linkLabel')
    });
  }
  links.push({
    label: `${t('copyrightNotice.label', {currentDateDisplayOnlyYear: new Date().getFullYear()})}`
  });
  return links;
})

const notifications = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return undefined;
})

function dismissAll() {
}
function openNotification() {
}
async function callAction(action) {
  props.closeHandler();
  await action();
}

return (_ctx, _cache) => {
  const _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col")
  const _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row")
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")
  const _component_el_option = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-option")
  const _component_el_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-select")
  const _component_el_tag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tag")
  const _component_DpFlag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFlag")
  const _component_el_badge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-badge")
  const _component_router_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-link")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", AvatarMenuvue_type_script_setup_true_lang_js_hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", AvatarMenuvue_type_script_setup_true_lang_js_hoisted_2, [
      (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(notifications)))
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", AvatarMenuvue_type_script_setup_true_lang_js_hoisted_3, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { span: 24 }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, null, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { span: 12 }, {
                          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", AvatarMenuvue_type_script_setup_true_lang_js_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('notifications')), 1)
                          ]),
                          _: 1
                        }),
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { span: 12 }, {
                          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                              style: {"float":"right"},
                              size: "small",
                              type: "text",
                              onClick: _cache[0] || (_cache[0] = $event => (dismissAll())),
                              onKeypress: _cache[1] || (_cache[1] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (dismissAll()), ["enter"])),
                              tabindex: "0"
                            }, {
                              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, { type: "flex" }, {
                                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, null, {
                                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpIcon["default"]), {
                                          icon: "close",
                                          color: "#212121",
                                          size: 12,
                                          float: "left"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, null, {
                                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('dismissAll.label')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", AvatarMenuvue_type_script_setup_true_lang_js_hoisted_5, [
                      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(notifications), (notification, index) => {
                        return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                          key: `notifications-${index}`,
                          style: {"display":"block"},
                          onClick: _cache[2] || (_cache[2] = $event => (openNotification())),
                          onKeypress: _cache[3] || (_cache[3] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (openNotification()), ["enter"])),
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpApplicationLogo["default"]), {
                            height: 14,
                            type: "square",
                            application: notification.product,
                            style: {"margin-inline-end":"0.5em"}
                          }, null, 8, ["application"]),
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(notification.message), 1)
                        ], 32))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_6, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
          type: "flex",
          style: {"flex-direction":"row-reverse","flex-wrap":"wrap"}
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
            (__props.hasCompanySwitch)
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_col, {
                  key: 0,
                  xs: spanSettingsWide.xs,
                  sm: spanSettingsWide.sm,
                  md: spanSettingsWide.md,
                  lg: spanSettingsWide.lg,
                  xl: spanSettingsWide.xl,
                  class: "divider hidden-sm-and-up"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.label')), 1),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                      modelValue: __props.companySelect.selectedCompany,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((__props.companySelect.selectedCompany) = $event)),
                      "value-key": "companyId",
                      style: {"width":"100%"},
                      onChange: _cache[5] || (_cache[5] = $event => (callAction($event.action))),
                      disabled: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.get)(__props.companySelect, 'companiesList', undefined)),
                      filterable: "",
                      "default-first-option": true,
                      placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.placeholder'),
                      "popper-class": "company-select__select__popper-dropdown"
                    }, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                        ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(__props.companySelect.companiesList, (company, index) => {
                          return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_option, {
                            key: `companies-select-${index}`,
                            label: company.label,
                            value: company
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "placeholder"]),
                    ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.get)(__props.companySelect, 'companiesList', undefined)))
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_tag, {
                          key: 0,
                          type: "danger",
                          style: {"margin":".5em 0"}
                        }, {
                          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('feedforward.noCompany.message')), 1)
                          ]),
                          _: 1
                        }))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                  ]),
                  _: 1
                }, 8, ["xs", "sm", "md", "lg", "xl"]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(accountSettings)))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_col, {
                  key: 1,
                  xs: spanSettings.xs,
                  sm: spanSettings.sm,
                  md: spanSettings.md,
                  lg: spanSettings.lg,
                  xl: spanSettings.xl,
                  class: "divider"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_8, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('accountSettings.label')), 1),
                    (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(jurisdictionList)))
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_9, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                            modelValue: currentJurisdiction.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((currentJurisdiction).value = $event)),
                            "value-key": "i18n",
                            style: {"width":"100%"},
                            onChange: _cache[7] || (_cache[7] = $event => (handleJurisdictionSwitch($event))),
                            filterable: "",
                            class: "jurisdiction-select__select",
                            "popper-class": "jurisdiction-select__select__popper-dropdown"
                          }, {
                            prefix: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_10, [
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFlag, {
                                  flagISOCode: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(getJurisdictionByLocale)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(locale)).flagISOCode
                                }, null, 8, ["flagISOCode"])
                              ])
                            ]),
                            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                              ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(jurisdictionList), (jurisdiction, index) => {
                                return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_option, {
                                  key: `select-jurisdiction-${index}`,
                                  label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`ds.components.DpHeader.AvatarMenu.jurisdiction.selectValues-${jurisdiction.translationKeyId}`),
                                  value: jurisdiction
                                }, {
                                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_11, [
                                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFlag, {
                                        flagISOCode: jurisdiction.flagISOCode
                                      }, null, 8, ["flagISOCode"])
                                    ]),
                                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_12, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`ds.components.DpHeader.AvatarMenu.jurisdiction.selectValues-${jurisdiction.translationKeyId}`)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", _hoisted_13, [
                      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(accountSettings), (page, index) => {
                        return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                          key: `account-settings-${index}`,
                          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'has-notification': page.notify}),
                          onClick: $event => (callAction(page.action)),
                          onKeypress: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (callAction(page.action)), ["enter"]),
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(page.label) + " ", 1),
                          (page.notify)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_badge, {
                                key: 0,
                                "is-dot": "",
                                class: "mark"
                              }))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                          (!!(page.tooltip))
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpTooltip["default"]), {
                                key: 1,
                                modelValue: page.tooltip,
                                "onUpdate:modelValue": $event => ((page.tooltip) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                        ], 42, _hoisted_14))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["xs", "sm", "md", "lg", "xl"]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)(applicationSettings))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_col, {
                  key: 2,
                  xs: spanSettings.xs,
                  sm: spanSettings.sm,
                  md: spanSettings.md,
                  lg: spanSettings.lg,
                  xl: spanSettings.xl,
                  class: "divider"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_15, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('productSettings.label', { productName: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(envStore).applicationName })), 1),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", _hoisted_16, [
                      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(applicationSettings, (page, index) => {
                        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", {
                          key: `product-settings-${index}`,
                          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'has-notification': page.notify}),
                          onClick: $event => (callAction(page.action)),
                          onKeypress: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (callAction(page.action)), ["enter"]),
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(page.label) + " ", 1),
                          (page.notify)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_badge, {
                                key: 0,
                                "is-dot": "",
                                class: "mark"
                              }))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                          (!!(page.tooltip))
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpTooltip["default"]), {
                                key: 1,
                                modelValue: page.tooltip,
                                "onUpdate:modelValue": $event => ((page.tooltip) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                        ], 42, _hoisted_17)
                      }), 64))
                    ])
                  ]),
                  _: 1
                }, 8, ["xs", "sm", "md", "lg", "xl"]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(companySettings)))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_col, {
                  key: 3,
                  xs: spanSettings.xs,
                  sm: spanSettings.sm,
                  md: spanSettings.md,
                  lg: spanSettings.lg,
                  xl: spanSettings.xl,
                  class: "divider"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_18, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('companySettings.label')), 1),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", _hoisted_19, [
                      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(companySettings), (page, index) => {
                        return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                          key: `company-settings-${index}`,
                          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'has-notification': page.notify}),
                          onClick: $event => (callAction(page.action)),
                          onKeypress: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (callAction(page.action)), ["enter"]),
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(page.label) + " ", 1),
                          (page.notify)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_badge, {
                                key: 0,
                                "is-dot": "",
                                class: "mark"
                              }))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                          (!!(page.tooltip))
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpTooltip["default"]), {
                                key: 1,
                                modelValue: page.tooltip,
                                "onUpdate:modelValue": $event => ((page.tooltip) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                        ], 42, _hoisted_20))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["xs", "sm", "md", "lg", "xl"]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(developerSettings)))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_col, {
                  key: 4,
                  xs: spanSettings.xs,
                  sm: spanSettings.sm,
                  md: spanSettings.md,
                  lg: spanSettings.lg,
                  xl: spanSettings.xl,
                  class: "divider"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_21, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('developerSettings.label')), 1),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", _hoisted_22, [
                      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(developerSettings), (page, index) => {
                        return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                          key: `developer-settings-${index}`,
                          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'has-notification': page.notify}),
                          onClick: $event => (callAction(page.action)),
                          onKeypress: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (callAction(page.action)), ["enter"]),
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(page.label) + " ", 1),
                          (page.notify)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_badge, {
                                key: 0,
                                "is-dot": "",
                                class: "mark"
                              }))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                          (!!(page.tooltip))
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpTooltip["default"]), {
                                key: 1,
                                modelValue: page.tooltip,
                                "onUpdate:modelValue": $event => ((page.tooltip) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                        ], 42, _hoisted_23))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["xs", "sm", "md", "lg", "xl"]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(adminSettings)))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_col, {
                  key: 5,
                  xs: spanSettings.xs,
                  sm: spanSettings.sm,
                  md: spanSettings.md,
                  lg: spanSettings.lg,
                  xl: spanSettings.xl,
                  class: "divider"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_24, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('adminSettings.label')), 1),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", _hoisted_25, [
                      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(adminSettings), (page, index) => {
                        return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                          key: `admin-settings-${index}`,
                          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'has-notification': page.notify}),
                          onClick: $event => (callAction(page.action)),
                          onKeypress: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => (callAction(page.action)), ["enter"]),
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(page.label) + " ", 1),
                          (page.notify)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_badge, {
                                key: 0,
                                "is-dot": "",
                                class: "mark"
                              }))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                          (!!(page.tooltip))
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpTooltip["default"]), {
                                key: 1,
                                modelValue: page.tooltip,
                                "onUpdate:modelValue": $event => ((page.tooltip) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                        ], 42, _hoisted_26))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["xs", "sm", "md", "lg", "xl"]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
          ]),
          _: 1
        }),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
          class: "avatar-menu__close",
          onClick: _cache[8] || (_cache[8] = $event => (__props.closeHandler())),
          onKeypress: _cache[9] || (_cache[9] = $event => (__props.closeHandler())),
          tabindex: "0",
          style: {'cursor': 'pointer'}
        }, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpIcon["default"]), {
            icon: "close",
            color: "#212121",
            size: 24,
            margin: false
          })
        ], 32)
      ]),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_27, [
        (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(legalLinks)))
          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", _hoisted_28, [
              ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(legalLinks), (link, index) => {
                return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                  key: index,
                  tabindex: "0"
                }, [
                  (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(lodash.isEmpty)(link.path))
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_router_link, {
                        key: 0,
                        onClick: __props.closeHandler,
                        to: {path: link.path}
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(link.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "to"]))
                    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_29, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(link.label), 1))
                ]))
              }), 128))
            ]))
          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
      ])
    ])
  ], 512))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpHeader/AvatarMenu.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/AvatarMenu.vue?vue&type=style&index=0&id=572687d6&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader/AvatarMenu.vue?vue&type=style&index=0&id=572687d6&lang=scss

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/AvatarMenu.vue?vue&type=style&index=1&id=572687d6&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader/AvatarMenu.vue?vue&type=style&index=1&id=572687d6&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/AvatarMenu.vue?vue&type=style&index=2&id=572687d6&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader/AvatarMenu.vue?vue&type=style&index=2&id=572687d6&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/AvatarMenu.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AvatarMenuvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugewiesene Unternehmen"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Einstellungen"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpHeader.AvatarMenu.notifications"])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskonto"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerverwaltung"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutz"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "de-AT": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugewiesene Unternehmen"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Einstellungen"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskonto"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerverwaltung"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutz"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "de-CH": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugewiesene Unternehmen"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Einstellungen"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskonto"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerverwaltung"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutz"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "en-US": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigned companies"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User account settings"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Security settings"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Settings"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No assigned company. Please add a company"])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company settings"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration Settings"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company account"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer settings"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Translation report"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound message"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator settings"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company account administration"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User administration"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data protection"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Information"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "en-GB": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigned companies"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User account settings"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Security settings"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Settings"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No assigned company. Please add a company"])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company settings"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration Settings"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company account"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer settings"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Translation report"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Message"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator settings"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company account administration"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User administration"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data protection"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Information"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "it-IT": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anagrafica Azienda"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Società assegnate"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni acconto utente"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di sicurezza"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Impostazioni"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessuna azienda assegnata. Aggiungi un'azienda."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni Azienda"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di integrazione"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account aziendale"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni sviluppatore"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapporto di traduzione"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaggi in uscita"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni amministratore"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazione dell'account aziendale"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazione utenti"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protezione dati"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chi siamo"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Condizioni d'uso"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "fr-FR": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociétés affectées"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseignements personnels"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les paramètres de sécurité"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Paramètres"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune entreprise assignée. Veuillez ajouter une entreprise."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'entreprise"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte d'entreprise"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des utilisateurs"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection des données"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentions Légales"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d'utilisation"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "es-ES": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compañías"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas asignadas"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Cuenta de Usuario"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuraciones de seguridad"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar sesión"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Configuraciones"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sin empresa asignada. Añade una empresa."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Empresa"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de integración"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta corporativa"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de desarrollador"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informe de traducción"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensajes salientes"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuraciones de administrador"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administración de cuentas de empresa"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administración de Usuario"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protección de Datos"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Información sobre Empresa"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Términos de Uso"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "pl-PL": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firmy"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przypisane firmy"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia konta użytkownika"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia bezpieczeństwa"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyloguj"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Ustawienia"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak przypisanej firmy. Dodaj firmę."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Firmy"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia integracji"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto firmowe"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia programisty"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raport z tłumaczenia"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiadomości wychodzące"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia administratora"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zarządzanie kontem firmowym"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracja użytkownika"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ochrona danych"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacja o firmie"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Warunki korzystania"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "nl-NL": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijven"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toegewezen bedrijven"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instellingen gebruikersaccount"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beveiligingsinstellingen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afmelden"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Instellingen"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen toegewezen bedrijf. Voeg een bedrijf toe."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinstellingen"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integratie-instellingen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zakelijke rekening"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontwikkelaarsinstellingen"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertaalrapport"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uitgaande berichten"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beheerdersinstellingen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsaccount administratie"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersadministratie"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gegevensbescherming"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinformatie"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruiksvoorwaarden"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "bg-BG": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фирми"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възложени фирми"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на потребителския акаунт"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на сигурността"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Излизане от профила"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Настройки"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма определена компания. Моля, добавете фирма."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на компанията"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за интеграция"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Корпоративна сметка"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за програмисти"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доклад за превода"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изходящи съобщения"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на администратора"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрация на фирмена сметка"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрация на потребителя"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Защита на данни"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Автор"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия за ползване"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "bs-BA": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanije"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodijeljene kompanije"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke korisničkog računa"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sigurnosne postavke"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjavite se"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Podešavanja"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema dodijeljene kompanije. Molimo dodajte kompaniju."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Kompanije"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korporativni račun"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke programera"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvještaj o prevođenju"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administratora"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa kompanije"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija korisnika"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaštita podataka"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravila korištenja"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "zh-CN": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司介绍"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["指定公司"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户帐号设置"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个人信息"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["安全设定"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登出"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " 设定值"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有指定的公司。 请添加公司。"])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司设定"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集成设置"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企业账户"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开发人员设定"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["翻译报告"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外发邮件"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理员设置"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司账户管理"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户管理"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据保护"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司信息"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用条款"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "da-DK": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomheder"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tildelte virksomheder"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brugerkontoindstillinger"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikkerhedsindstillinger"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log ud"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Indstillinger"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intet tildelt firma. Tilføj venligst et firma."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsindstillinger"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsindstillinger"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedskonto"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udviklerindstillinger"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oversættelsesrapport"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udgående beskeder"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratorindstillinger"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration af virksomhedskonto"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brugeradministration"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data beskyttelse"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsoplysninger"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betingelser for brug"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "et-EE": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtted"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Määratud ettevõtted"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutajakonto Seaded"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turvaseaded"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logi välja"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Seadistused"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Määratud ettevõtet pole. Palun lisage ettevõte."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte Seaded"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integreerimise seaded"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte konto"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arendaja seaded"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tõlkearuanne"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Väljaminevad sõnumid"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administraatori seaded"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte konto haldamine"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutaja haldus"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Andmekaitse"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte info"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutustingimused"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "fi-FI": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yritys"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siirretyt yritykset"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttäjätilin Asetukset"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turvallisuusasetukset"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirjaudu ulos"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Asetukset"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei nimettyä yritystä. Lisää yritys."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen asetukset"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrointiasetukset"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yritystili"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kehittäjän asetukset"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käännösraportti"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähtevät viestit"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Järjestelmänvalvojan asetukset"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yritystilin hallinta"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttäjien hallinta"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datan suojelu"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen tiedot"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttöehdot"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "el-GR": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ανατεθείσες εταιρείες"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις λογαριασμού χρήστη"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ασφαλείας"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποσύνδεση"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Ρυθμίσεις"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν έχει ανατεθεί εταιρεία. Προσθέστε μια εταιρεία."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις εταιρείας"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρικός λογαριασμός"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις προγραμματιστή"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έκθεση μετάφρασης"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχειριστή"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση εταιρικού λογαριασμού"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση χρηστών"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προστασία δεδομένων"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία της εταιρείας"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οροι χρήσης"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "he-IL": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות שהוקצו"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חשבון משתמש"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות אבטחה"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["להתנתק"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " הגדרות"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין חברה שהוקצתה. אנא הוסף חברה."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חברה"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות שילוב"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חשבון תאגידי"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות מפתח"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["דוח תרגום"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הודעות יוצאות"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות מנהל"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ניהול חשבון החברה"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ניהול משתמשים"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגנת מידע"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מידע על החברה"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["תנאי שימוש"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["DutyPay GmbH - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - 2013 ©"])}
        }
      },
      "ga-IE": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí sannta"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe cuntais úsáideora"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eolas pearsanta"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe slándála"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logáil amach"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Socruithe"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan aon chuideachta sannta. Cuir cuideachta le do thoil."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Cuideachta"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe comhtháthaithe"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuntas corparáideach"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Forbróra"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuarascáil aistriúcháin"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teachtaireachtaí Amach"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe riarthóra"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riarachán cuntas cuideachta"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riarachán úsáideora"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosaint sonraí"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fógra Dlí"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téarmaí Úsáide"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "ja-JP": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["割り当てられた会社"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウント設定"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["セキュリティ設定"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログアウト"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " 設定"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["割り当てられた会社はありません。 会社を追加してください。"])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社の設定"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["統合設定"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業アカウント"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開発者設定"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["翻訳レポート"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信メッセージ"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理者設定"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業アカウント管理"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザー管理"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["データ保護"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業情報"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用規約"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "hr-HR": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tvrtka"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodijeljene tvrtke"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke korisničkog računa"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sigurnosne postavke"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjavite se"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Postavke"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema dodijeljene tvrtke. Molimo dodajte tvrtku."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Tvrtke"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korporativni račun"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke programera"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvještaj o prijevodu"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administratora"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa tvrtke"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija korisnika"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaštita podataka"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uvjeti korištenja"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "lv-LV": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piešķirtie uzņēmumi"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietotāja konta iestatījumi"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drošības iestatījumi"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atteikties"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Iestatījumi"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav norīkota uzņēmuma. Lūdzu, pievienojiet uzņēmumu."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma Iestatījumi"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrācijas iestatījumi"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korporatīvais konts"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izstrādātāja iestatījumi"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tulkošanas ziņojums"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izejošie ziņojumi"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratora iestatījumi"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma konta administrēšana"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietotāju administrēšana"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datu aizsardzība"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas informācija"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietošanas noteikumi"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "lt-LT": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paskirtos įmonės"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vartotojo paskyros nustatymai"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apsaugos nustatymai"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atsijungti"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Nustatymai"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra paskirtos įmonės. Pridėkite įmonę."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės Nustatymai"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integravimo parametrai"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės sąskaita"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kūrėjo nustatymai"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertimo ataskaita"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išeinantys pranešimai"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoriaus nustatymai"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės sąskaitos administravimas"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vartotojo administravimas"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duomenų apsauga"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanijos informacija"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naudojimo sąlygos"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "pt-PT": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas atribuídas"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definições da conta de utilizador"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definições de segurança"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sair"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Configurações"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nenhuma empresa atribuída. Adicione uma empresa."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da Empresa"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de integração"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta corporativa"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações do desenvolvedor"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relatório de tradução"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensagens de Saída"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de administrador"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administração de contas corporativas"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administração do usuário"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proteção de dados"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informações da Empresa"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termos de uso"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "ro-RO": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["întreprindere"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Companii atribuite"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări cont de utilizator"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de securitate"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deconectare"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Setări"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicio companie desemnată. Vă rugăm să adăugați o companie."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări Companie"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de integrare"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cont corporativ"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări pentru dezvoltatori"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raport de traducere"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări administrator"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrarea contului companiei"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrarea utilizatorilor"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protejarea datelor"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informații privind Compania"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termeni de utilizare"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "ru-RU": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Компании"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назначенные компании"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки учетной записи пользователя"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Персональные данные"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки безопасности"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выход"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " настройки"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет назначенной компании. Пожалуйста, добавьте компанию."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки компании"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки интеграции"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Корпоративный счет"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки разработчика"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отчет о переводе"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходящие сообщения"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки администратора"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Управление корпоративным аккаунтом"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрирование пользователей"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Защита данных"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Импрессум"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия эксплуатации"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "sv-SE": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företag"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilldelade företag"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inställningar för användarkonto"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Säkerhetsinställningar"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logga ut"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Inställningar"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inget tilldelat företag. Lägg till ett företag."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinställningar"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsinställningar"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagskonto"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utvecklarinställningar"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Översättningsrapport"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utgående meddelanden"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratörsinställningar"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration av företagskonton"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Användaradministration"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dataskydd"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinformation"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Villkor"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "sk-SK": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podnik"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridelené spoločnosti"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia používateľského účtu"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezpečnostné nastavenia"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlásiť sa"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Nastavenie"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadna pridelená spoločnosť. Pridajte spoločnosť."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia Spoločnosti"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia integrácie"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firemný účet"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia pre vývojárov"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa o preklade"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchádzajúce správy"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia správcu"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa firemného účtu"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrácia užívateľov"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ochrana dát"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podmienky používania"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "cs-CZ": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["společnost"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přiřazené společnosti"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení uživatelského účtu"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezpečnostní nastavení"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlásit se"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Nastavení"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná přiřazená společnost. Přidejte společnost."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení Společnosti"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení integrace"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firemní účet"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení vývojáře"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpráva o překladu"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchozí zprávy"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení správce"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa firemního účtu"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa uživatelů"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ochrana dat"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impresum"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podmínky použití"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "tr-TR": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirketler"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı Hesabı Ayarları"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güvenlik ayarları"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çıkış Yap"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Ayarlar"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirket yok. Lütfen bir şirket ekleyin."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurumsal hesap"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirici Ayarları"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çeviri raporu"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetici ayarları"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket hesap yönetimi"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı yönetimi"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri koruması"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Bilgisi"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanım Şartları"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "hu-HU": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalat"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosztott vállalatok"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói fiók beállításai"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biztonsági beállítások"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kijelentkezés"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Beállítások"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs kijelölt vállalat. Kérjük, adjon hozzá egy vállalatot."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati Beállítások"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrációs beállítások"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati számla"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejlesztői beállítások"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fordítási jelentés"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimenő üzenetek"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rendszergazda beállításai"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati számla adminisztráció"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói adminisztráció"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adat védelem"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Céginformáció"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Használati feltételek"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "ar-AE": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات المعينة"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب المستخدم"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الأمان"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الخروج"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " الإعدادات"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد شركة معينة. الرجاء إضافة شركة."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التكامل"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الشركات"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المطور"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تقرير الترجمة"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرسائل الصادرة"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المسؤول"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حساب الشركة"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة المستخدم"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حماية البيانات"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات الشركة"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعليمات الاستخدام"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["DutyPay GmbH - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - 2013 ©"])}
        }
      },
      "fr-BE": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociétés affectées"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseignements personnels"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les paramètres de sécurité"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Paramètres"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune entreprise assignée. Veuillez ajouter une entreprise."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'entreprise"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte d'entreprise"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des utilisateurs"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection des données"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentions Légales"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d'utilisation"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "fr-LU": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociétés affectées"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseignements personnels"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les paramètres de sécurité"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Paramètres"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune entreprise assignée. Veuillez ajouter une entreprise."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'entreprise"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte d'entreprise"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des utilisateurs"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection des données"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentions Légales"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d'utilisation"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "mt-MT": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji assenjati"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-kont tal-utent"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tas-sigurtà"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oħroġ"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Settings"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda kumpanija assenjata. Jekk jogħġbok żid kumpanija."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Kumpanija"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-integrazzjoni"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kont korporattiv"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Iżviluppatur"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport tat-traduzzjoni"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaġġ li joħroġ"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-amministratur"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazzjoni tal-kont tal-kumpanija"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazzjoni tal-utent"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protezzjoni tad-dejta"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termini ta 'Użu"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "sl-SI": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["podjetje"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodeljena podjetja"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve uporabniškega računa"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varnostne nastavitve"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjava"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Nastavitve"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni dodeljenega podjetja. Dodajte podjetje."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve podjetja"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve integracije"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Račun podjetja"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve za razvijalce"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poročilo o prevodu"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhodna sporočila"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve skrbnika"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa podjetja"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija uporabnikov"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varstvo podatkov"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacije o podjetju"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogoji uporabe"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "el-CY": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ανατεθείσες εταιρείες"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις λογαριασμού χρήστη"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ασφαλείας"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποσύνδεση"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Ρυθμίσεις"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν έχει ανατεθεί εταιρεία. Προσθέστε μια εταιρεία."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις εταιρείας"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρικός λογαριασμός"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις προγραμματιστή"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έκθεση μετάφρασης"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχειριστή"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση εταιρικού λογαριασμού"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση χρηστών"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προστασία δεδομένων"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία της εταιρείας"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οροι χρήσης"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      },
      "tr-CY": {
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirketler"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirketler"])}
        },
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı Hesabı Ayarları"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güvenlik ayarları"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çıkış Yap"])}
          }
        },
        "productSettings": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("productName")), " Ayarlar"])}
        },
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirket yok. Lütfen bir şirket ekleyin."])}
          }
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "companySettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])},
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurumsal hesap"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirici Ayarları"])},
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çeviri raporu"])}
          },
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
          }
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetici ayarları"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket hesap yönetimi"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı yönetimi"])}
          }
        },
        "legalLinks": {
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri koruması"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Bilgisi"])}
          },
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanım Şartları"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpHeader/AvatarMenu.vue



;


/* custom blocks */

if (typeof AvatarMenuvue_type_custom_index_0_blockType_i18n === 'function') AvatarMenuvue_type_custom_index_0_blockType_i18n(AvatarMenuvue_type_script_setup_true_lang_js)


;
const AvatarMenu_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AvatarMenuvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-572687d6"]])

/* harmony default export */ var AvatarMenu = (AvatarMenu_exports_);
// EXTERNAL MODULE: ./src/components/DpCollapse.vue + 4 modules
var DpCollapse = __webpack_require__(2785);
;// CONCATENATED MODULE: ./node_modules/vue-router/dist/vue-router.mjs
/* provided dependency */ var console = __webpack_require__(5108);
/*!
  * vue-router v4.1.4
  * (c) 2022 Eduardo San Martin Morote
  * @license MIT
  */



const isBrowser = typeof window !== 'undefined';

function isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === 'Module';
}
const vue_router_assign = Object.assign;
function applyToParams(fn, params) {
    const newParams = {};
    for (const key in params) {
        const value = params[key];
        newParams[key] = isArray(value)
            ? value.map(fn)
            : fn(value);
    }
    return newParams;
}
const noop = () => { };
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */
const isArray = Array.isArray;

function warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, ['[Vue Router warn]: ' + msg].concat(args));
}

const TRAILING_SLASH_RE = /\/$/;
const removeTrailingSlash = (path) => path.replace(TRAILING_SLASH_RE, '');
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */
function parseURL(parseQuery, location, currentLocation = '/') {
    let path, query = {}, searchString = '', hash = '';
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location.indexOf('#');
    let searchPos = location.indexOf('?');
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) {
        searchPos = -1;
    }
    if (searchPos > -1) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos + 1, hashPos > -1 ? hashPos : location.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location.slice(0, hashPos);
        // keep the # character
        hash = location.slice(hashPos, location.length);
    }
    // no search and no query
    path = resolveRelativePath(path != null ? path : location, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && '?') + searchString + hash,
        path,
        query,
        hash,
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */
function stringifyURL(stringifyQuery, location) {
    const query = location.query ? stringifyQuery(location.query) : '';
    return location.path + (query && '?') + query + (location.hash || '');
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */
function stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase()))
        return pathname;
    return pathname.slice(base.length) || '/';
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */
function isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return (aLastIndex > -1 &&
        aLastIndex === bLastIndex &&
        isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) &&
        isSameRouteLocationParams(a.params, b.params) &&
        stringifyQuery(a.query) === stringifyQuery(b.query) &&
        a.hash === b.hash);
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */
function isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length)
        return false;
    for (const key in a) {
        if (!isSameRouteLocationParamsValue(a[key], b[key]))
            return false;
    }
    return true;
}
function isSameRouteLocationParamsValue(a, b) {
    return isArray(a)
        ? isEquivalentArray(a, b)
        : isArray(b)
            ? isEquivalentArray(b, a)
            : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */
function isEquivalentArray(a, b) {
    return isArray(b)
        ? a.length === b.length && a.every((value, i) => value === b[i])
        : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */
function resolveRelativePath(to, from) {
    if (to.startsWith('/'))
        return to;
    if (false) {}
    if (!to)
        return from;
    const fromSegments = from.split('/');
    const toSegments = to.split('/');
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for (toPosition = 0; toPosition < toSegments.length; toPosition++) {
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === '.')
            continue;
        // go up in the from array
        if (segment === '..') {
            // we can't go below zero, but we still need to increment toPosition
            if (position > 1)
                position--;
            // continue
        }
        // we reached a non-relative path, we stop here
        else
            break;
    }
    return (fromSegments.slice(0, position).join('/') +
        '/' +
        toSegments
            // ensure we use at least the last element in the toSegments
            .slice(toPosition - (toPosition === toSegments.length ? 1 : 0))
            .join('/'));
}

var NavigationType;
(function (NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})(NavigationType || (NavigationType = {}));
var NavigationDirection;
(function (NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})(NavigationDirection || (NavigationDirection = {}));
/**
 * Starting location for Histories
 */
const START = '';
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */
function normalizeBase(base) {
    if (!base) {
        if (isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector('base');
            base = (baseEl && baseEl.getAttribute('href')) || '/';
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, '');
        }
        else {
            base = '/';
        }
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== '/' && base[0] !== '#')
        base = '/' + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return removeTrailingSlash(base);
}
// remove any character before the hash
const BEFORE_HASH_RE = /^[^#]+#/;
function createHref(base, location) {
    return base.replace(BEFORE_HASH_RE, '#') + location;
}

function getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0),
    };
}
const computeScrollPosition = () => ({
    left: window.pageXOffset,
    top: window.pageYOffset,
});
function scrollToPosition(position) {
    let scrollToOptions;
    if ('el' in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === 'string' && positionEl.startsWith('#');
        /**
         * `id`s can accept pretty much any characters, including CSS combinators
         * like `>` or `~`. It's still possible to retrieve elements using
         * `document.getElementById('~')` but it needs to be escaped when using
         * `document.querySelector('#\\~')` for it to be valid. The only
         * requirements for `id`s are them to be unique on the page and to not be
         * empty (`id=""`). Because of that, when passing an id selector, it should
         * be properly escaped for it to work with `querySelector`. We could check
         * for the id selector to be simple (no CSS combinators `+ >~`) but that
         * would make things inconsistent since they are valid characters for an
         * `id` but would need to be escaped when using `querySelector`, breaking
         * their usage and ending up in no selector returned. Selectors need to be
         * escaped:
         *
         * - `#1-thing` becomes `#\31 -thing`
         * - `#with~symbols` becomes `#with\\~symbols`
         *
         * - More information about  the topic can be found at
         *   https://mathiasbynens.be/notes/html5-id-class.
         * - Practical example: https://mathiasbynens.be/demo/html5-id
         */
        if (false) {}
        const el = typeof positionEl === 'string'
            ? isIdSelector
                ? document.getElementById(positionEl.slice(1))
                : document.querySelector(positionEl)
            : positionEl;
        if (!el) {
            ( false) &&
                0;
            return;
        }
        scrollToOptions = getElementPosition(el, position);
    }
    else {
        scrollToOptions = position;
    }
    if ('scrollBehavior' in document.documentElement.style)
        window.scrollTo(scrollToOptions);
    else {
        window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
    }
}
function getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const scrollPositions = new Map();
function saveScrollPosition(key, scrollPosition) {
    scrollPositions.set(key, scrollPosition);
}
function getSavedScrollPosition(key) {
    const scroll = scrollPositions.get(key);
    // consume it so it's not used again
    scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */
// export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }

let createBaseLocation = () => location.protocol + '//' + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param location -
 */
function createCurrentLocation(base, location) {
    const { pathname, search, hash } = location;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf('#');
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos))
            ? base.slice(hashPos).length
            : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== '/')
            pathFromHash = '/' + pathFromHash;
        return stripBase(pathFromHash, '');
    }
    const path = stripBase(pathname, base);
    return path + search + hash;
}
function useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state, }) => {
        const to = createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        }
        else {
            replace(to);
        }
        // console.log({ deltaFromCurrent })
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach(listener => {
            listener(currentLocation.value, from, {
                delta,
                type: NavigationType.pop,
                direction: delta
                    ? delta > 0
                        ? NavigationDirection.forward
                        : NavigationDirection.back
                    : NavigationDirection.unknown,
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = () => {
            const index = listeners.indexOf(callback);
            if (index > -1)
                listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history } = window;
        if (!history.state)
            return;
        history.replaceState(vue_router_assign({}, history.state, { scroll: computeScrollPosition() }), '');
    }
    function destroy() {
        for (const teardown of teardowns)
            teardown();
        teardowns = [];
        window.removeEventListener('popstate', popStateHandler);
        window.removeEventListener('beforeunload', beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener('popstate', popStateHandler);
    window.addEventListener('beforeunload', beforeUnloadListener);
    return {
        pauseListeners,
        listen,
        destroy,
    };
}
/**
 * Creates a state object
 */
function buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back,
        current,
        forward,
        replaced,
        position: window.history.length,
        scroll: computeScroll ? computeScrollPosition() : null,
    };
}
function useHistoryStateNavigation(base) {
    const { history, location } = window;
    // private variables
    const currentLocation = {
        value: createCurrentLocation(base, location),
    };
    const historyState = { value: history.state };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) {
        changeLocation(currentLocation.value, {
            back: null,
            current: currentLocation.value,
            forward: null,
            // the length is off by one, we need to decrease it
            position: history.length - 1,
            replaced: true,
            // don't add a scroll as the user may have an anchor, and we want
            // scrollBehavior to be triggered without a saved position
            scroll: null,
        }, true);
    }
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */
        const hashIndex = base.indexOf('#');
        const url = hashIndex > -1
            ? (location.host && document.querySelector('base')
                ? base
                : base.slice(hashIndex)) + to
            : createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history[replace ? 'replaceState' : 'pushState'](state, '', url);
            historyState.value = state;
        }
        catch (err) {
            if ((false)) {}
            else {
                console.error(err);
            }
            // Force the navigation, this also resets the call count
            location[replace ? 'replace' : 'assign'](url);
        }
    }
    function replace(to, data) {
        const state = vue_router_assign({}, history.state, buildState(historyState.value.back, 
        // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, { position: historyState.value.position });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = vue_router_assign({}, 
        // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history.state, {
            forward: to,
            scroll: computeScrollPosition(),
        });
        if (false) {}
        changeLocation(currentState.current, currentState, true);
        const state = vue_router_assign({}, buildState(currentLocation.value, to, null), { position: currentState.position + 1 }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push,
        replace,
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */
function createWebHistory(base) {
    base = normalizeBase(base);
    const historyNavigation = useHistoryStateNavigation(base);
    const historyListeners = useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners)
            historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = vue_router_assign({
        // it's overridden right after
        location: '',
        base,
        go,
        createHref: createHref.bind(null, base),
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: () => historyNavigation.location.value,
    });
    Object.defineProperty(routerHistory, 'state', {
        enumerable: true,
        get: () => historyNavigation.state.value,
    });
    return routerHistory;
}

/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */
function createMemoryHistory(base = '') {
    let listeners = [];
    let queue = [START];
    let position = 0;
    base = normalizeBase(base);
    function setLocation(location) {
        position++;
        if (position === queue.length) {
            // we are at the end, we can simply append a new entry
            queue.push(location);
        }
        else {
            // we are in the middle, we remove everything from here in the queue
            queue.splice(position);
            queue.push(location);
        }
    }
    function triggerListeners(to, from, { direction, delta }) {
        const info = {
            direction,
            delta,
            type: NavigationType.pop,
        };
        for (const callback of listeners) {
            callback(to, from, info);
        }
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: START,
        // TODO: should be kept in queue
        state: {},
        base,
        createHref: createHref.bind(null, base),
        replace(to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push(to, data) {
            setLocation(to);
        },
        listen(callback) {
            listeners.push(callback);
            return () => {
                const index = listeners.indexOf(callback);
                if (index > -1)
                    listeners.splice(index, 1);
            };
        },
        destroy() {
            listeners = [];
            queue = [START];
            position = 0;
        },
        go(delta, shouldTrigger = true) {
            const from = this.location;
            const direction = 
            // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? NavigationDirection.back : NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) {
                triggerListeners(this.location, from, {
                    direction,
                    delta,
                });
            }
        },
    };
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: () => queue[position],
    });
    return routerHistory;
}

/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */
function createWebHashHistory(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : '';
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes('#'))
        base += '#';
    if (false) {}
    return createWebHistory(base);
}

function isRouteLocation(route) {
    return typeof route === 'string' || (route && typeof route === 'object');
}
function isRouteName(name) {
    return typeof name === 'string' || typeof name === 'symbol';
}

/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */
const START_LOCATION_NORMALIZED = {
    path: '/',
    name: undefined,
    params: {},
    query: {},
    hash: '',
    fullPath: '/',
    matched: [],
    meta: {},
    redirectedFrom: undefined,
};

const NavigationFailureSymbol = Symbol(( false) ? 0 : '');
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */
var NavigationFailureType;
(function (NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */
    NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */
    NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */
    NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})(NavigationFailureType || (NavigationFailureType = {}));
// DEV only debug messages
const ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */]({ location, currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation
            ? '\nwhile being at\n' + JSON.stringify(currentLocation)
            : ''}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */]({ from, to, }) {
        return `Redirected from "${from.fullPath}" to "${stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */]({ from, to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */]({ from, to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */]({ from, to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    },
};
function createRouterError(type, params) {
    // keep full error messages in cjs versions
    if (false) {}
    else {
        return vue_router_assign(new Error(), {
            type,
            [NavigationFailureSymbol]: true,
        }, params);
    }
}
function isNavigationFailure(error, type) {
    return (error instanceof Error &&
        NavigationFailureSymbol in error &&
        (type == null || !!(error.type & type)));
}
const propertiesToLog = ['params', 'query', 'hash'];
function stringifyRoute(to) {
    if (typeof to === 'string')
        return to;
    if ('path' in to)
        return to.path;
    const location = {};
    for (const key of propertiesToLog) {
        if (key in to)
            location[key] = to[key];
    }
    return JSON.stringify(location, null, 2);
}

// default pattern for a param: non-greedy everything but /
const BASE_PARAM_PATTERN = '[^/]+?';
const BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true,
};
// Special Regex characters that must be escaped in static tokens
const REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */
function tokensToParser(segments, extraOptions) {
    const options = vue_router_assign({}, BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? '^' : '';
    // extracted keys
    const keys = [];
    for (const segment of segments) {
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [90 /* PathScore.Root */];
        // allow trailing slash
        if (options.strict && !segment.length)
            pattern += '/';
        for (let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++) {
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */ +
                (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */ : 0);
            if (token.type === 0 /* TokenType.Static */) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex)
                    pattern += '/';
                pattern += token.value.replace(REGEX_CHARS_RE, '\\$&');
                subSegmentScore += 40 /* PathScore.Static */;
            }
            else if (token.type === 1 /* TokenType.Param */) {
                const { value, repeatable, optional, regexp } = token;
                keys.push({
                    name: value,
                    repeatable,
                    optional,
                });
                const re = regexp ? regexp : BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    }
                    catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` +
                            err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex)
                    subPattern =
                        // avoid an optional / if there are more segments e.g. /:p?-static
                        // or /:p?-:p2
                        optional && segment.length < 2
                            ? `(?:/${subPattern})`
                            : '/' + subPattern;
                if (optional)
                    subPattern += '?';
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */;
                if (optional)
                    subSegmentScore += -8 /* PathScore.BonusOptional */;
                if (repeatable)
                    subSegmentScore += -20 /* PathScore.BonusRepeatable */;
                if (re === '.*')
                    subSegmentScore += -50 /* PathScore.BonusWildcard */;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict)
        pattern += '/?';
    if (options.end)
        pattern += '$';
    // allow paths like /dynamic to only match dynamic or dynamic/... but not dynamic_something_else
    else if (options.strict)
        pattern += '(?:/|$)';
    const re = new RegExp(pattern, options.sensitive ? '' : 'i');
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match)
            return null;
        for (let i = 1; i < match.length; i++) {
            const value = match[i] || '';
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split('/') : value;
        }
        return params;
    }
    function stringify(params) {
        let path = '';
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments) {
            if (!avoidDuplicatedSlash || !path.endsWith('/'))
                path += '/';
            avoidDuplicatedSlash = false;
            for (const token of segment) {
                if (token.type === 0 /* TokenType.Static */) {
                    path += token.value;
                }
                else if (token.type === 1 /* TokenType.Param */) {
                    const { value, repeatable, optional } = token;
                    const param = value in params ? params[value] : '';
                    if (isArray(param) && !repeatable) {
                        throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    }
                    const text = isArray(param)
                        ? param.join('/')
                        : param;
                    if (!text) {
                        if (optional) {
                            // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith('/'))
                                    path = path.slice(0, -1);
                                // do not append a slash on the next iteration
                                else
                                    avoidDuplicatedSlash = true;
                            }
                        }
                        else
                            throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || '/';
    }
    return {
        re,
        score,
        keys,
        parse,
        stringify,
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */
function compareScoreArray(a, b) {
    let i = 0;
    while (i < a.length && i < b.length) {
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff)
            return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) {
        return a.length === 1 && a[0] === 40 /* PathScore.Static */ + 40 /* PathScore.Segment */
            ? -1
            : 1;
    }
    else if (a.length > b.length) {
        return b.length === 1 && b[0] === 40 /* PathScore.Static */ + 40 /* PathScore.Segment */
            ? 1
            : -1;
    }
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */
function comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while (i < aScore.length && i < bScore.length) {
        const comp = compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp)
            return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if (isLastScoreNegative(aScore))
            return 1;
        if (isLastScoreNegative(bScore))
            return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
    // this is the ternary version
    // return aScore.length < bScore.length
    //   ? 1
    //   : aScore.length > bScore.length
    //   ? -1
    //   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */
function isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}

const ROOT_TOKEN = {
    type: 0 /* TokenType.Static */,
    value: '',
};
const VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function tokenizePath(path) {
    if (!path)
        return [[]];
    if (path === '/')
        return [[ROOT_TOKEN]];
    if (!path.startsWith('/')) {
        throw new Error(( false)
            ? 0
            : `Invalid path "${path}"`);
    }
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment)
            tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = '';
    // custom regexp for a param
    let customRe = '';
    function consumeBuffer() {
        if (!buffer)
            return;
        if (state === 0 /* TokenizerState.Static */) {
            segment.push({
                type: 0 /* TokenType.Static */,
                value: buffer,
            });
        }
        else if (state === 1 /* TokenizerState.Param */ ||
            state === 2 /* TokenizerState.ParamRegExp */ ||
            state === 3 /* TokenizerState.ParamRegExpEnd */) {
            if (segment.length > 1 && (char === '*' || char === '+'))
                crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */,
                value: buffer,
                regexp: customRe,
                repeatable: char === '*' || char === '+',
                optional: char === '*' || char === '?',
            });
        }
        else {
            crash('Invalid state to consume buffer');
        }
        buffer = '';
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while (i < path.length) {
        char = path[i++];
        if (char === '\\' && state !== 2 /* TokenizerState.ParamRegExp */) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */;
            continue;
        }
        switch (state) {
            case 0 /* TokenizerState.Static */:
                if (char === '/') {
                    if (buffer) {
                        consumeBuffer();
                    }
                    finalizeSegment();
                }
                else if (char === ':') {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */;
                }
                else {
                    addCharToBuffer();
                }
                break;
            case 4 /* TokenizerState.EscapeNext */:
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */:
                if (char === '(') {
                    state = 2 /* TokenizerState.ParamRegExp */;
                }
                else if (VALID_PARAM_RE.test(char)) {
                    addCharToBuffer();
                }
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */;
                    // go back one character if we were not modifying
                    if (char !== '*' && char !== '?' && char !== '+')
                        i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */:
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ')') {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == '\\')
                        customRe = customRe.slice(0, -1) + char;
                    else
                        state = 3 /* TokenizerState.ParamRegExpEnd */;
                }
                else {
                    customRe += char;
                }
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */:
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */;
                // go back one character if we were not modifying
                if (char !== '*' && char !== '?' && char !== '+')
                    i--;
                customRe = '';
                break;
            default:
                crash('Unknown state');
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */)
        crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}

function createRouteRecordMatcher(record, parent, options) {
    const parser = tokensToParser(tokenizePath(record.path), options);
    // warn against params with the same name
    if ((false)) {}
    const matcher = vue_router_assign(parser, {
        record,
        parent,
        // these needs to be populated by the parent
        children: [],
        alias: [],
    });
    if (parent) {
        // both are aliases or both are not aliases
        // we don't want to mix them because the order is used when
        // passing originalRecord in Matcher.addRoute
        if (!matcher.record.aliasOf === !parent.record.aliasOf)
            parent.children.push(matcher);
    }
    return matcher;
}

/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */
function createRouterMatcher(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = mergeOptions({ strict: false, end: true, sensitive: false }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = normalizeRouteRecord(record);
        if ((false)) {}
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord,
        ];
        if ('alias' in record) {
            const aliases = typeof record.alias === 'string' ? [record.alias] : record.alias;
            for (const alias of aliases) {
                normalizedRecords.push(vue_router_assign({}, mainNormalizedRecord, {
                    // this allows us to hold a copy of the `components` option
                    // so that async components cache is hold on the original record
                    components: originalRecord
                        ? originalRecord.record.components
                        : mainNormalizedRecord.components,
                    path: alias,
                    // we might be the child of an alias
                    aliasOf: originalRecord
                        ? originalRecord.record
                        : mainNormalizedRecord,
                    // the aliases are always of the same kind as the original since they
                    // are defined on the same record
                }));
            }
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords) {
            const { path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== '/') {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === '/' ? '' : '/';
                normalizedRecord.path =
                    parent.record.path + (path && connectingSlash + path);
            }
            if (false) {}
            // create the object beforehand, so it can be passed to children
            matcher = createRouteRecordMatcher(normalizedRecord, parent, options);
            if (false)
                {}
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) {
                originalRecord.alias.push(matcher);
                if ((false)) {}
            }
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher)
                    originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !isAliasRecord(matcher))
                    removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for (let i = 0; i < children.length; i++) {
                    addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
                }
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            insertMatcher(matcher);
        }
        return originalMatcher
            ? () => {
                // since other matchers are aliases, they should be removed by the original matcher
                removeRoute(originalMatcher);
            }
            : noop;
    }
    function removeRoute(matcherRef) {
        if (isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        }
        else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name)
                    matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while (i < matchers.length &&
            comparePathParserScore(matcher, matchers[i]) >= 0 &&
            // Adding children with empty path should still appear before the parent
            // https://github.com/vuejs/router/issues/1124
            (matcher.record.path !== matchers[i].record.path ||
                !isRecordChildOf(matcher, matchers[i])))
            i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !isAliasRecord(matcher))
            matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ('name' in location && location.name) {
            matcher = matcherMap.get(location.name);
            if (!matcher)
                throw createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */, {
                    location,
                });
            name = matcher.record.name;
            params = vue_router_assign(
            // paramsFromLocation is a new object
            paramsFromLocation(currentLocation.params, 
            // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter(k => !k.optional).map(k => k.name)), 
            // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location.params &&
                paramsFromLocation(location.params, matcher.keys.map(k => k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        }
        else if ('path' in location) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location.path;
            if (false) {}
            matcher = matchers.find(m => m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
            // location is a relative path
        }
        else {
            // match by name or path of current route
            matcher = currentLocation.name
                ? matcherMap.get(currentLocation.name)
                : matchers.find(m => m.re.test(currentLocation.path));
            if (!matcher)
                throw createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */, {
                    location,
                    currentLocation,
                });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = vue_router_assign({}, currentLocation.params, location.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while (parentMatcher) {
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name,
            path,
            params,
            matched,
            meta: mergeMetaFields(matched),
        };
    }
    // add initial routes
    routes.forEach(route => addRoute(route));
    return { addRoute, resolve, removeRoute, getRoutes, getRecordMatcher };
}
function paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys) {
        if (key in params)
            newParams[key] = params[key];
    }
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */
function normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: 'components' in record
            ? record.components || null
            : record.component && { default: record.component },
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */
function normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ('component' in record) {
        propsObject.default = props;
    }
    else {
        // NOTE: we could also allow a function to be applied to every component.
        // Would need user feedback for use cases
        for (const name in record.components)
            propsObject[name] = typeof props === 'boolean' ? props : props[name];
    }
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */
function isAliasRecord(record) {
    while (record) {
        if (record.record.aliasOf)
            return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */
function mergeMetaFields(matched) {
    return matched.reduce((meta, record) => vue_router_assign(meta, record.meta), {});
}
function mergeOptions(defaults, partialOptions) {
    const options = {};
    for (const key in defaults) {
        options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    }
    return options;
}
function isSameParam(a, b) {
    return (a.name === b.name &&
        a.optional === b.optional &&
        a.repeatable === b.repeatable);
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */
function checkSameParams(a, b) {
    for (const key of a.keys) {
        if (!key.optional && !b.keys.find(isSameParam.bind(null, key)))
            return warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" should have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys) {
        if (!key.optional && !a.keys.find(isSameParam.bind(null, key)))
            return warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" should have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */
function checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent &&
        parent.record.name &&
        !mainNormalizedRecord.name &&
        !mainNormalizedRecord.path) {
        warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
    }
}
function checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys) {
        if (!record.keys.find(isSameParam.bind(null, key)))
            return warn(`Absolute path "${record.record.path}" should have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function isRecordChildOf(record, parent) {
    return parent.children.some(child => child === record || isRecordChildOf(record, child));
}

/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */
// const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const HASH_RE = /#/g; // %23
const AMPERSAND_RE = /&/g; // %26
const SLASH_RE = /\//g; // %2F
const EQUAL_RE = /=/g; // %3D
const IM_RE = /\?/g; // %3F
const PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */
const ENC_BRACKET_OPEN_RE = /%5B/g; // [
const ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const ENC_CARET_RE = /%5E/g; // ^
const ENC_BACKTICK_RE = /%60/g; // `
const ENC_CURLY_OPEN_RE = /%7B/g; // {
const ENC_PIPE_RE = /%7C/g; // |
const ENC_CURLY_CLOSE_RE = /%7D/g; // }
const ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */
function commonEncode(text) {
    return encodeURI('' + text)
        .replace(ENC_PIPE_RE, '|')
        .replace(ENC_BRACKET_OPEN_RE, '[')
        .replace(ENC_BRACKET_CLOSE_RE, ']');
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */
function encodeHash(text) {
    return commonEncode(text)
        .replace(ENC_CURLY_OPEN_RE, '{')
        .replace(ENC_CURLY_CLOSE_RE, '}')
        .replace(ENC_CARET_RE, '^');
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */
function encodeQueryValue(text) {
    return (commonEncode(text)
        // Encode the space as +, encode the + to differentiate it from the space
        .replace(PLUS_RE, '%2B')
        .replace(ENC_SPACE_RE, '+')
        .replace(HASH_RE, '%23')
        .replace(AMPERSAND_RE, '%26')
        .replace(ENC_BACKTICK_RE, '`')
        .replace(ENC_CURLY_OPEN_RE, '{')
        .replace(ENC_CURLY_CLOSE_RE, '}')
        .replace(ENC_CARET_RE, '^'));
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */
function encodeQueryKey(text) {
    return encodeQueryValue(text).replace(EQUAL_RE, '%3D');
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */
function encodePath(text) {
    return commonEncode(text).replace(HASH_RE, '%23').replace(IM_RE, '%3F');
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */
function encodeParam(text) {
    return text == null ? '' : encodePath(text).replace(SLASH_RE, '%2F');
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */
function decode(text) {
    try {
        return decodeURIComponent('' + text);
    }
    catch (err) {
        ( false) && 0;
    }
    return '' + text;
}

/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */
function parseQuery(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === '' || search === '?')
        return query;
    const hasLeadingIM = search[0] === '?';
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split('&');
    for (let i = 0; i < searchParams.length; ++i) {
        // pre decode the + into space
        const searchParam = searchParams[i].replace(PLUS_RE, ' ');
        // allow the = character
        const eqPos = searchParam.indexOf('=');
        const key = decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!isArray(currentValue)) {
                currentValue = query[key] = [currentValue];
            }
            currentValue.push(value);
        }
        else {
            query[key] = value;
        }
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */
function stringifyQuery(query) {
    let search = '';
    for (let key in query) {
        const value = query[key];
        key = encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) {
                search += (search.length ? '&' : '') + key;
            }
            continue;
        }
        // keep null values
        const values = isArray(value)
            ? value.map(v => v && encodeQueryValue(v))
            : [value && encodeQueryValue(value)];
        values.forEach(value => {
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? '&' : '') + key;
                if (value != null)
                    search += '=' + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */
function normalizeQuery(query) {
    const normalizedQuery = {};
    for (const key in query) {
        const value = query[key];
        if (value !== undefined) {
            normalizedQuery[key] = isArray(value)
                ? value.map(v => (v == null ? null : '' + v))
                : value == null
                    ? value
                    : '' + value;
        }
    }
    return normalizedQuery;
}

/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */
const matchedRouteKey = Symbol(( false) ? 0 : '');
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */
const viewDepthKey = Symbol(( false) ? 0 : '');
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */
const routerKey = Symbol(( false) ? 0 : '');
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */
const routeLocationKey = Symbol(( false) ? 0 : '');
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */
const routerViewLocationKey = Symbol(( false) ? 0 : '');

/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */
function useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return () => {
            const i = handlers.indexOf(handler);
            if (i > -1)
                handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add,
        list: () => handlers,
        reset,
    };
}

function registerGuard(record, name, guard) {
    const removeFromList = () => {
        record[name].delete(guard);
    };
    onUnmounted(removeFromList);
    onDeactivated(removeFromList);
    onActivated(() => {
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */
function onBeforeRouteLeave(leaveGuard) {
    if (false) {}
    const activeRecord = inject(matchedRouteKey, 
    // to avoid warning
    {}).value;
    if (!activeRecord) {
        ( false) &&
            0;
        return;
    }
    registerGuard(activeRecord, 'leaveGuards', leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */
function onBeforeRouteUpdate(updateGuard) {
    if (false) {}
    const activeRecord = inject(matchedRouteKey, 
    // to avoid warning
    {}).value;
    if (!activeRecord) {
        ( false) &&
            0;
        return;
    }
    registerGuard(activeRecord, 'updateGuards', updateGuard);
}
function guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record &&
        // name is defined if record is because of the function overload
        (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return () => new Promise((resolve, reject) => {
        const next = (valid) => {
            if (valid === false) {
                reject(createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */, {
                    from,
                    to,
                }));
            }
            else if (valid instanceof Error) {
                reject(valid);
            }
            else if (isRouteLocation(valid)) {
                reject(createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */, {
                    from: to,
                    to: valid,
                }));
            }
            else {
                if (enterCallbackArray &&
                    // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray &&
                    typeof valid === 'function') {
                    enterCallbackArray.push(valid);
                }
                resolve();
            }
        };
        // wrapping with Promise.resolve allows it to work with both async and sync guards
        const guardReturn = guard.call(record && record.instances[name], to, from, ( false) ? 0 : next);
        let guardCall = Promise.resolve(guardReturn);
        if (guard.length < 3)
            guardCall = guardCall.then(next);
        if (false) {}
        guardCall.catch(err => reject(err));
    });
}
function canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function () {
        if (called++ === 1)
            warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1)
            next.apply(null, arguments);
    };
}
function extractComponentsGuards(matched, guardType, to, from) {
    const guards = [];
    for (const record of matched) {
        if (false) {}
        for (const name in record.components) {
            let rawComponent = record.components[name];
            if ((false)) {}
            // skip update and leave guards if the route component is not mounted
            if (guardType !== 'beforeRouteEnter' && !record.instances[name])
                continue;
            if (isRouteComponent(rawComponent)) {
                // __vccOpts is added by vue-class-component and contain the regular options
                const options = rawComponent.__vccOpts || rawComponent;
                const guard = options[guardType];
                guard && guards.push(guardToPromiseFn(guard, to, from, record, name));
            }
            else {
                // start requesting the chunk already
                let componentPromise = rawComponent();
                if (false) {}
                guards.push(() => componentPromise.then(resolved => {
                    if (!resolved)
                        return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = isESModule(resolved)
                        ? resolved.default
                        : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && guardToPromiseFn(guard, to, from, record, name)();
                }));
            }
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */
function isRouteComponent(component) {
    return (typeof component === 'object' ||
        'displayName' in component ||
        'props' in component ||
        '__vccOpts' in component);
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */
function loadRouteLocation(route) {
    return route.matched.every(record => record.redirect)
        ? Promise.reject(new Error('Cannot load a route that redirects.'))
        : Promise.all(route.matched.map(record => record.components &&
            Promise.all(Object.keys(record.components).reduce((promises, name) => {
                const rawComponent = record.components[name];
                if (typeof rawComponent === 'function' &&
                    !('displayName' in rawComponent)) {
                    promises.push(rawComponent().then(resolved => {
                        if (!resolved)
                            return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                        const resolvedComponent = isESModule(resolved)
                            ? resolved.default
                            : resolved;
                        // replace the function with the resolved component
                        // cannot be null or undefined because we went into the for loop
                        record.components[name] = resolvedComponent;
                        return;
                    }));
                }
                return promises;
            }, [])))).then(() => route);
}

// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function useLink(props) {
    const router = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(routerKey);
    const currentRoute = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(routeLocationKey);
    const route = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => router.resolve((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(props.to)));
    const activeRecordIndex = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        const { matched } = route.value;
        const { length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length)
            return -1;
        const index = currentMatched.findIndex(isSameRouteRecord.bind(null, routeMatched));
        if (index > -1)
            return index;
        // possible parent record
        const parentRecordPath = getOriginalPath(matched[length - 2]);
        return (
        // we are dealing with nested routes
        length > 1 &&
            // if the parent and matched route have the same path, this link is
            // referring to the empty child. Or we currently are on a different
            // child of the same parent
            getOriginalPath(routeMatched) === parentRecordPath &&
            // avoid comparing the child with its parent
            currentMatched[currentMatched.length - 1].path !== parentRecordPath
            ? currentMatched.findIndex(isSameRouteRecord.bind(null, matched[length - 2]))
            : index);
    });
    const isActive = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => activeRecordIndex.value > -1 &&
        includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => activeRecordIndex.value > -1 &&
        activeRecordIndex.value === currentRoute.matched.length - 1 &&
        isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if (guardEvent(e)) {
            return router[(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(props.replace) ? 'replace' : 'push']((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(props.to)
            // avoid uncaught errors are they are logged anyway
            ).catch(noop);
        }
        return Promise.resolve();
    }
    // devtools only
    if (false) {}
    return {
        route,
        href: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => route.value.href),
        isActive,
        isExactActive,
        navigate,
    };
}
const RouterLinkImpl = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    name: 'RouterLink',
    compatConfig: { MODE: 3 },
    props: {
        to: {
            type: [String, Object],
            required: true,
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: 'page',
        },
    },
    useLink,
    setup(props, { slots }) {
        const link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(useLink(props));
        const { options } = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(routerKey);
        const elClass = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
            [getLinkClass(props.activeClass, options.linkActiveClass, 'router-link-active')]: link.isActive,
            // [getLinkClass(
            //   props.inactiveClass,
            //   options.linkInactiveClass,
            //   'router-link-inactive'
            // )]: !link.isExactActive,
            [getLinkClass(props.exactActiveClass, options.linkExactActiveClass, 'router-link-exact-active')]: link.isExactActive,
        }));
        return () => {
            const children = slots.default && slots.default(link);
            return props.custom
                ? children
                : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.h)('a', {
                    'aria-current': link.isExactActive
                        ? props.ariaCurrentValue
                        : null,
                    href: link.href,
                    // this would override user added attrs but Vue will still add
                    // the listener, so we end up triggering both
                    onClick: link.navigate,
                    class: elClass.value,
                }, children);
        };
    },
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */
const RouterLink = (/* unused pure expression or super */ null && (RouterLinkImpl));
function guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey)
        return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented)
        return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0)
        return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute('target');
        if (/\b_blank\b/i.test(target))
            return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault)
        e.preventDefault();
    return true;
}
function includesParams(outer, inner) {
    for (const key in inner) {
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === 'string') {
            if (innerValue !== outerValue)
                return false;
        }
        else {
            if (!isArray(outerValue) ||
                outerValue.length !== innerValue.length ||
                innerValue.some((value, i) => value !== outerValue[i]))
                return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */
function getOriginalPath(record) {
    return record ? (record.aliasOf ? record.aliasOf.path : record.path) : '';
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */
const getLinkClass = (propClass, globalClass, defaultClass) => propClass != null
    ? propClass
    : globalClass != null
        ? globalClass
        : defaultClass;

const RouterViewImpl = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    name: 'RouterView',
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: 'default',
        },
        route: Object,
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: { MODE: 3 },
    setup(props, { attrs, slots }) {
        ( false) && 0;
        const injectedRoute = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(routerViewLocationKey);
        const routeToDisplay = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.route || injectedRoute.value);
        const injectedDepth = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(viewDepthKey, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
            let initialDepth = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(injectedDepth);
            const { matched } = routeToDisplay.value;
            let matchedRoute;
            while ((matchedRoute = matched[initialDepth]) &&
                !matchedRoute.components) {
                initialDepth++;
            }
            return initialDepth;
        });
        const matchedRouteRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => routeToDisplay.value.matched[depth.value]);
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.provide)(viewDepthKey, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => depth.value + 1));
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.provide)(matchedRouteKey, matchedRouteRef);
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.provide)(routerViewLocationKey, routeToDisplay);
        const viewRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => [viewRef.value, matchedRouteRef.value, props.name], ([instance, to, name], [oldInstance, from, oldName]) => {
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) {
                        to.leaveGuards = from.leaveGuards;
                    }
                    if (!to.updateGuards.size) {
                        to.updateGuards = from.updateGuards;
                    }
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance &&
                to &&
                // if there is no instance but to and from are the same this might be
                // the first visit
                (!from || !isSameRouteRecord(to, from) || !oldInstance)) {
                (to.enterCallbacks[name] || []).forEach(callback => callback(instance));
            }
        }, { flush: 'post' });
        return () => {
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) {
                return normalizeSlot(slots.default, { Component: ViewComponent, route });
            }
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption
                ? routePropsOption === true
                    ? route.params
                    : typeof routePropsOption === 'function'
                        ? routePropsOption(route)
                        : routePropsOption
                : null;
            const onVnodeUnmounted = vnode => {
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) {
                    matchedRoute.instances[currentName] = null;
                }
            };
            const component = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.h)(ViewComponent, vue_router_assign({}, routeProps, attrs, {
                onVnodeUnmounted,
                ref: viewRef,
            }));
            if (false) {}
            return (
            // pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            normalizeSlot(slots.default, { Component: component, route }) ||
                component);
        };
    },
});
function normalizeSlot(slot, data) {
    if (!slot)
        return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */
const RouterView = (/* unused pure expression or super */ null && (RouterViewImpl));
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function warnDeprecatedUsage() {
    const instance = getCurrentInstance();
    const parentName = instance.parent && instance.parent.type.name;
    if (parentName &&
        (parentName === 'KeepAlive' || parentName.includes('Transition'))) {
        const comp = parentName === 'KeepAlive' ? 'keep-alive' : 'transition';
        warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` +
            `Use slot props instead:\n\n` +
            `<router-view v-slot="{ Component }">\n` +
            `  <${comp}>\n` +
            `    <component :is="Component" />\n` +
            `  </${comp}>\n` +
            `</router-view>`);
    }
}

/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */
function formatRouteLocation(routeLocation, tooltip) {
    const copy = vue_router_assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map(matched => omit(matched, ['instances', 'children', 'aliasOf'])),
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip,
            value: copy,
        },
    };
}
function formatDisplay(display) {
    return {
        _custom: {
            display,
        },
    };
}
// to support multiple router instances
let routerId = 0;
function addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools)
        return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = routerId++;
    setupDevtoolsPlugin({
        id: 'org.vuejs.router' + (id ? '.' + id : ''),
        label: 'Vue Router',
        packageName: 'vue-router',
        homepage: 'https://router.vuejs.org',
        logo: 'https://router.vuejs.org/logo.png',
        componentStateTypes: ['Routing'],
        app,
    }, api => {
        if (typeof api.now !== 'function') {
            console.warn('[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        }
        // display state added by the router
        api.on.inspectComponent((payload, ctx) => {
            if (payload.instanceData) {
                payload.instanceData.state.push({
                    type: 'Routing',
                    key: '$route',
                    editable: false,
                    value: formatRouteLocation(router.currentRoute.value, 'Current Route'),
                });
            }
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance }) => {
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : '') + info.path,
                    textColor: 0,
                    tooltip: 'This component is rendered by &lt;router-view&gt;',
                    backgroundColor: PINK_500,
                });
            }
            // if multiple useLink are used
            if (isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach(devtoolsData => {
                    let backgroundColor = ORANGE_400;
                    let tooltip = '';
                    if (devtoolsData.isExactActive) {
                        backgroundColor = LIME_500;
                        tooltip = 'This is exactly active';
                    }
                    else if (devtoolsData.isActive) {
                        backgroundColor = BLUE_600;
                        tooltip = 'This link is active';
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip,
                        backgroundColor,
                    });
                });
            }
        });
        watch(router.currentRoute, () => {
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = 'router:navigations:' + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? ' ' + id : ''} Navigations`,
            color: 0x40a8c4,
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to) => {
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'Error during Navigation',
                    subtitle: to.fullPath,
                    logType: 'error',
                    time: api.now(),
                    data: { error },
                    groupId: to.meta.__navigationId,
                },
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from) => {
            const data = {
                guard: formatDisplay('beforeEach'),
                from: formatRouteLocation(from, 'Current Location during this navigation'),
                to: formatRouteLocation(to, 'Target location'),
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, '__navigationId', {
                value: navigationId++,
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: 'Start of navigation',
                    subtitle: to.fullPath,
                    data,
                    groupId: to.meta.__navigationId,
                },
            });
        });
        router.afterEach((to, from, failure) => {
            const data = {
                guard: formatDisplay('afterEach'),
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : '',
                        tooltip: 'Navigation Failure',
                        value: failure,
                    },
                };
                data.status = formatDisplay('❌');
            }
            else {
                data.status = formatDisplay('✅');
            }
            // we set here to have the right order
            data.from = formatRouteLocation(from, 'Current Location during this navigation');
            data.to = formatRouteLocation(to, 'Target location');
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'End of navigation',
                    subtitle: to.fullPath,
                    time: api.now(),
                    data,
                    logType: failure ? 'warning' : 'default',
                    groupId: to.meta.__navigationId,
                },
            });
        });
        /**
         * Inspector of Existing routes
         */
        const routerInspectorId = 'router-inspector:' + id;
        api.addInspector({
            id: routerInspectorId,
            label: 'Routes' + (id ? ' ' + id : ''),
            icon: 'book',
            treeFilterPlaceholder: 'Search routes',
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload)
                return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter(route => !route.parent);
            // reset match state to false
            routes.forEach(resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) {
                routes = routes.filter(route => 
                // save matches state based on the payload
                isRouteMatching(route, payload.filter.toLowerCase()));
            }
            // mark active routes
            routes.forEach(route => markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map(formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree(payload => {
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                refreshRoutesView();
            }
        });
        /**
         * Display information about the currently selected route record
         */
        api.on.getInspectorState(payload => {
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find(route => route.record.__vd_id === payload.nodeId);
                if (route) {
                    payload.state = {
                        options: formatRouteRecordMatcherForStateInspector(route),
                    };
                }
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function modifierForKey(key) {
    if (key.optional) {
        return key.repeatable ? '*' : '?';
    }
    else {
        return key.repeatable ? '+' : '';
    }
}
function formatRouteRecordMatcherForStateInspector(route) {
    const { record } = route;
    const fields = [
        { editable: false, key: 'path', value: record.path },
    ];
    if (record.name != null) {
        fields.push({
            editable: false,
            key: 'name',
            value: record.name,
        });
    }
    fields.push({ editable: false, key: 'regexp', value: route.re });
    if (route.keys.length) {
        fields.push({
            editable: false,
            key: 'keys',
            value: {
                _custom: {
                    type: null,
                    readOnly: true,
                    display: route.keys
                        .map(key => `${key.name}${modifierForKey(key)}`)
                        .join(' '),
                    tooltip: 'Param keys',
                    value: route.keys,
                },
            },
        });
    }
    if (record.redirect != null) {
        fields.push({
            editable: false,
            key: 'redirect',
            value: record.redirect,
        });
    }
    if (route.alias.length) {
        fields.push({
            editable: false,
            key: 'aliases',
            value: route.alias.map(alias => alias.record.path),
        });
    }
    if (Object.keys(route.record.meta).length) {
        fields.push({
            editable: false,
            key: 'meta',
            value: route.record.meta,
        });
    }
    fields.push({
        key: 'score',
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map(score => score.join(', ')).join(' | '),
                tooltip: 'Score used to sort routes',
                value: route.score,
            },
        },
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */
const PINK_500 = 0xec4899;
const BLUE_600 = 0x2563eb;
const LIME_500 = 0x84cc16;
const CYAN_400 = 0x22d3ee;
const ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const DARK = 0x666666;
function formatRouteRecordForInspector(route) {
    const tags = [];
    const { record } = route;
    if (record.name != null) {
        tags.push({
            label: String(record.name),
            textColor: 0,
            backgroundColor: CYAN_400,
        });
    }
    if (record.aliasOf) {
        tags.push({
            label: 'alias',
            textColor: 0,
            backgroundColor: ORANGE_400,
        });
    }
    if (route.__vd_match) {
        tags.push({
            label: 'matches',
            textColor: 0,
            backgroundColor: PINK_500,
        });
    }
    if (route.__vd_exactActive) {
        tags.push({
            label: 'exact',
            textColor: 0,
            backgroundColor: LIME_500,
        });
    }
    if (route.__vd_active) {
        tags.push({
            label: 'active',
            textColor: 0,
            backgroundColor: BLUE_600,
        });
    }
    if (record.redirect) {
        tags.push({
            label: typeof record.redirect === 'string'
                ? `redirect: ${record.redirect}`
                : 'redirects',
            textColor: 0xffffff,
            backgroundColor: DARK,
        });
    }
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String(routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id,
        label: record.path,
        tags,
        children: route.children.map(formatRouteRecordForInspector),
    };
}
//  incremental id for route records and inspector state
let routeRecordId = 0;
const EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length &&
        isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) {
        route.__vd_active = currentRoute.matched.some(match => isSameRouteRecord(match, route.record));
    }
    route.children.forEach(childRoute => markRouteRecordActive(childRoute, currentRoute));
}
function resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach(resetMatchStateOnRouteRecord);
}
function isRouteMatching(route, filter) {
    const found = String(route.re).match(EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) {
        return false;
    }
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ''), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach(child => isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== '/' || filter === '/') {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith('/') &&
        (decodedPath.includes(filter) || path.includes(filter)))
        return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter))
        return true;
    if (route.record.name && String(route.record.name).includes(filter))
        return true;
    return route.children.some(child => isRouteMatching(child, filter));
}
function omit(obj, keys) {
    const ret = {};
    for (const key in obj) {
        if (!keys.includes(key)) {
            // @ts-expect-error
            ret[key] = obj[key];
        }
    }
    return ret;
}

/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */
function createRouter(options) {
    const matcher = createRouterMatcher(options.routes, options);
    const parseQuery$1 = options.parseQuery || parseQuery;
    const stringifyQuery$1 = options.stringifyQuery || stringifyQuery;
    const routerHistory = options.history;
    if (false)
        {}
    const beforeGuards = useCallbacks();
    const beforeResolveGuards = useCallbacks();
    const afterGuards = useCallbacks();
    const currentRoute = shallowRef(START_LOCATION_NORMALIZED);
    let pendingLocation = START_LOCATION_NORMALIZED;
    // leave the scrollRestoration if no scrollBehavior is provided
    if (isBrowser && options.scrollBehavior && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    const normalizeParams = applyToParams.bind(null, paramValue => '' + paramValue);
    const encodeParams = applyToParams.bind(null, encodeParam);
    const decodeParams = 
    // @ts-expect-error: intentionally avoid the type check
    applyToParams.bind(null, decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if (isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        }
        else {
            record = parentOrRoute;
        }
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) {
            matcher.removeRoute(recordMatcher);
        }
        else if ((false)) {}
    }
    function getRoutes() {
        return matcher.getRoutes().map(routeMatcher => routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = vue_router_assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === 'string') {
            const locationNormalized = parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({ path: locationNormalized.path }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            if ((false)) {}
            // locationNormalized is always a new object
            return vue_router_assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href,
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if ('path' in rawLocation) {
            if (false) {}
            matcherLocation = vue_router_assign({}, rawLocation, {
                path: parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path,
            });
        }
        else {
            // remove any nullish param
            const targetParams = vue_router_assign({}, rawLocation.params);
            for (const key in targetParams) {
                if (targetParams[key] == null) {
                    delete targetParams[key];
                }
            }
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = vue_router_assign({}, rawLocation, {
                params: encodeParams(rawLocation.params),
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || '';
        if (false) {}
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = stringifyURL(stringifyQuery$1, vue_router_assign({}, rawLocation, {
            hash: encodeHash(hash),
            path: matchedRoute.path,
        }));
        const href = routerHistory.createHref(fullPath);
        if ((false)) {}
        return vue_router_assign({
            fullPath,
            // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: 
            // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === stringifyQuery
                ? normalizeQuery(rawLocation.query)
                : (rawLocation.query || {}),
        }, matchedRoute, {
            redirectedFrom: undefined,
            href,
        });
    }
    function locationAsObject(to) {
        return typeof to === 'string'
            ? parseURL(parseQuery$1, to, currentRoute.value.path)
            : vue_router_assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) {
            return createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */, {
                from,
                to,
            });
        }
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push(vue_router_assign(locationAsObject(to), { replace: true }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect } = lastMatched;
            let newTargetLocation = typeof redirect === 'function' ? redirect(to) : redirect;
            if (typeof newTargetLocation === 'string') {
                newTargetLocation =
                    newTargetLocation.includes('?') || newTargetLocation.includes('#')
                        ? (newTargetLocation = locationAsObject(newTargetLocation))
                        : // force empty params
                            { path: newTargetLocation };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            if (false) {}
            return vue_router_assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: 'path' in newTargetLocation ? {} : to.params,
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = (pendingLocation = resolve(to));
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect)
            return pushWithRedirect(vue_router_assign(locationAsObject(shouldRedirect), {
                state: typeof shouldRedirect === 'object'
                    ? vue_router_assign({}, data, shouldRedirect.state)
                    : data,
                force,
                replace,
            }), 
            // keep original redirectedFrom if it exists
            redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */, { to: toLocation, from });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, 
            // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, 
            // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from))
            .catch((error) => isNavigationFailure(error)
            ? // navigation redirects still mark the router as ready
                isNavigationFailure(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */)
                    ? error
                    : markAsReady(error) // also returns the error
            : // reject any unknown error
                triggerError(error, toLocation, from))
            .then((failure) => {
            if (failure) {
                if (isNavigationFailure(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */)) {
                    if (false) {}
                    return pushWithRedirect(
                    // keep options
                    vue_router_assign({
                        // preserve an existing replacement but allow the redirect to override it
                        replace,
                    }, locationAsObject(failure.to), {
                        state: typeof failure.to === 'object'
                            ? vue_router_assign({}, data, failure.to.state)
                            : data,
                        force,
                    }), 
                    // preserve the original redirectedFrom if any
                    redirectedFrom || toLocation);
                }
            }
            else {
                // if we fail we don't finalize the navigation
                failure = finalizeNavigation(toLocation, from, true, replace, data);
            }
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */
    function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = extractComponentsGuards(leavingRecords.reverse(), 'beforeRouteLeave', to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords) {
            record.leaveGuards.forEach(guard => {
                guards.push(guardToPromiseFn(guard, to, from));
            });
        }
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return (runGuardQueue(guards)
            .then(() => {
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list()) {
                guards.push(guardToPromiseFn(guard, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })
            .then(() => {
            // check in components beforeRouteUpdate
            guards = extractComponentsGuards(updatingRecords, 'beforeRouteUpdate', to, from);
            for (const record of updatingRecords) {
                record.updateGuards.forEach(guard => {
                    guards.push(guardToPromiseFn(guard, to, from));
                });
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        })
            .then(() => {
            // check the route beforeEnter
            guards = [];
            for (const record of to.matched) {
                // do not trigger beforeEnter on reused views
                if (record.beforeEnter && !from.matched.includes(record)) {
                    if (isArray(record.beforeEnter)) {
                        for (const beforeEnter of record.beforeEnter)
                            guards.push(guardToPromiseFn(beforeEnter, to, from));
                    }
                    else {
                        guards.push(guardToPromiseFn(record.beforeEnter, to, from));
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        })
            .then(() => {
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach(record => (record.enterCallbacks = {}));
            // check in-component beforeRouteEnter
            guards = extractComponentsGuards(enteringRecords, 'beforeRouteEnter', to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        })
            .then(() => {
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list()) {
                guards.push(guardToPromiseFn(guard, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })
            // catch any navigation canceled
            .catch(err => isNavigationFailure(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */)
            ? err
            : Promise.reject(err)));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        for (const guard of afterGuards.list())
            guard(to, from, failure);
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */
    function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error)
            return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === START_LOCATION_NORMALIZED;
        const state = !isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation)
                routerHistory.replace(toLocation.fullPath, vue_router_assign({
                    scroll: isFirstNavigation && state && state.scroll,
                }, data));
            else
                routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener)
            return;
        removeHistoryListener = routerHistory.listen((to, _from, info) => {
            if (!router.listening)
                return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect(vue_router_assign(shouldRedirect, { replace: true }), toLocation).catch(noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if (isBrowser) {
                saveScrollPosition(getScrollKey(from.fullPath, info.delta), computeScrollPosition());
            }
            navigate(toLocation, from)
                .catch((error) => {
                if (isNavigationFailure(error, 4 /* ErrorTypes.NAVIGATION_ABORTED */ | 8 /* ErrorTypes.NAVIGATION_CANCELLED */)) {
                    return error;
                }
                if (isNavigationFailure(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */)) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation
                    // avoid an uncaught rejection, let push call triggerError
                    )
                        .then(failure => {
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if (isNavigationFailure(failure, 4 /* ErrorTypes.NAVIGATION_ABORTED */ |
                            16 /* ErrorTypes.NAVIGATION_DUPLICATED */) &&
                            !info.delta &&
                            info.type === NavigationType.pop) {
                            routerHistory.go(-1, false);
                        }
                    })
                        .catch(noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) {
                    routerHistory.go(-info.delta, false);
                }
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            })
                .then((failure) => {
                failure =
                    failure ||
                        finalizeNavigation(
                        // after navigation, all matched components are resolved
                        toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta &&
                        // a new navigation has been triggered, so we do not want to revert, that will change the current history
                        // entry while a different route is displayed
                        !isNavigationFailure(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */)) {
                        routerHistory.go(-info.delta, false);
                    }
                    else if (info.type === NavigationType.pop &&
                        isNavigationFailure(failure, 4 /* ErrorTypes.NAVIGATION_ABORTED */ | 16 /* ErrorTypes.NAVIGATION_DUPLICATED */)) {
                        // manual change in hash history #916
                        // it's like a push but lacks the information of the direction
                        routerHistory.go(-1, false);
                    }
                }
                triggerAfterEach(toLocation, from, failure);
            })
                .catch(noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = useCallbacks();
    let errorHandlers = useCallbacks();
    let ready;
    /**
     * Trigger errorHandlers added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */
    function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorHandlers.list();
        if (list.length) {
            list.forEach(handler => handler(error, to, from));
        }
        else {
            if ((false)) {}
            console.error(error);
        }
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== START_LOCATION_NORMALIZED)
            return Promise.resolve();
        return new Promise((resolve, reject) => {
            readyHandlers.add([resolve, reject]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers
                .list()
                .forEach(([resolve, reject]) => (err ? reject(err) : resolve()));
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior } = options;
        if (!isBrowser || !scrollBehavior)
            return Promise.resolve();
        const scrollPosition = (!isPush && getSavedScrollPosition(getScrollKey(to.fullPath, 0))) ||
            ((isFirstNavigation || !isPush) &&
                history.state &&
                history.state.scroll) ||
            null;
        return nextTick()
            .then(() => scrollBehavior(to, from, scrollPosition))
            .then(position => position && scrollToPosition(position))
            .catch(err => triggerError(err, to, from));
    }
    const go = (delta) => routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute,
        listening: true,
        addRoute,
        removeRoute,
        hasRoute,
        getRoutes,
        resolve,
        options,
        push,
        replace,
        go,
        back: () => go(-1),
        forward: () => go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorHandlers.add,
        isReady,
        install(app) {
            const router = this;
            app.component('RouterLink', RouterLink);
            app.component('RouterView', RouterView);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, '$route', {
                enumerable: true,
                get: () => unref(currentRoute),
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if (isBrowser &&
                // used for the initial navigation client side to avoid pushing
                // multiple times when the router is used in multiple apps
                !started &&
                currentRoute.value === START_LOCATION_NORMALIZED) {
                // see above
                started = true;
                push(routerHistory.location).catch(err => {
                    if ((false))
                        {}
                });
            }
            const reactiveRoute = {};
            for (const key in START_LOCATION_NORMALIZED) {
                // @ts-expect-error: the key matches
                reactiveRoute[key] = computed(() => currentRoute.value[key]);
            }
            app.provide(routerKey, router);
            app.provide(routeLocationKey, reactive(reactiveRoute));
            app.provide(routerViewLocationKey, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function () {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = START_LOCATION_NORMALIZED;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = START_LOCATION_NORMALIZED;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (false) {}
        },
    };
    return router;
}
function runGuardQueue(guards) {
    return guards.reduce((promise, guard) => promise.then(() => guard()), Promise.resolve());
}
function extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for (let i = 0; i < len; i++) {
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find(record => isSameRouteRecord(record, recordFrom)))
                updatingRecords.push(recordFrom);
            else
                leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            // the type doesn't matter because we are comparing per reference
            if (!from.matched.find(record => isSameRouteRecord(record, recordTo))) {
                enteringRecords.push(recordTo);
            }
        }
    }
    return [leavingRecords, updatingRecords, enteringRecords];
}

/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */
function useRouter() {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(routerKey);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */
function useRoute() {
    return inject(routeLocationKey);
}



// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./node_modules/await-to-js/dist/await-to-js.es5.js
/**
 * @param { Promise } promise
 * @param { Object= } errorExt - Additional Information you can pass to the err object
 * @return { Promise }
 */
function to(promise, errorExt) {
    return promise
        .then(function (data) { return [null, data]; })
        .catch(function (err) {
        if (errorExt) {
            Object.assign(err, errorExt);
        }
        return [err, undefined];
    });
}


/* harmony default export */ var await_to_js_es5 = ((/* unused pure expression or super */ null && (to)));
//# sourceMappingURL=await-to-js.es5.js.map

// EXTERNAL MODULE: external "@dutypay/utilities"
var utilities_ = __webpack_require__(3351);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/ApplicationSwitchMenu.vue?vue&type=script&setup=true&lang=js


const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_1 = { ref: "applicationSwitch" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_2 = {
  key: 0,
  class: "application-switch__wrapper"
}
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_3 = {
  class: "application-switch__container",
  "element-loading-background": "rgba(0, 0, 0, 0.8)"
}
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_4 = { key: 0 }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_5 = { class: "application-switch__category" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_6 = { class: "dp-flex row wrap justify-content__flex-start align-items__center" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_7 = ["onClick", "onKeypress"]
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_8 = ["src", "alt"]
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_9 = { class: "application-switch__items__item-name" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_10 = { class: "block application-switch__items__item-name" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_11 = { key: 0 }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_12 = { class: "application-switch__category" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_13 = { class: "dp-flex row wrap justify-content__flex-start align-items__flex-start" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_14 = ["onClick", "onKeypress"]
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_15 = ["src", "alt"]
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_16 = { class: "application-switch__items__item-name" }
const ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_17 = { class: "block application-switch__items__item-description" }

;









/* harmony default export */ var ApplicationSwitchMenuvue_type_script_setup_true_lang_js = ({
  __name: 'ApplicationSwitchMenu',
  props: {
  closeHandler: {type: Function}
},
  emits: ['hasApplications'],
  setup(__props, { emit }) {

const props = __props

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

const tKAAliases = [
    t('activeApplication.imageAltTag.displayValues'),
    t('activeApplication.caption.displayValues'),
    t('availableApplication.imageAltTag.displayValues'),
    t('availableApplication.caption.displayValues'),
    t('availableApplication.description.displayValues')
]


const composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables')
const { isMobile } = composables.useViewportSize();

const router = useRouter()
const menuSettings = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)({
  active: [],
  available: []
})
const isAvailableApplicationsVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
const isLoading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);

const envStore = (0,store_modules_.useEnvStore)()
const apiUrls = envStore.apiUrls;
const companyStore = (0,store_modules_.useCompanyStore)()
const selectedCompany = companyStore.selectedCompany;

const assetsApiEndpoint = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return `${apiUrls.dutypay}/api/v0/assets`;
});
const hasActiveApplications = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return (menuSettings.active.length > 0);
});
const hasAvailableApplications = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return (menuSettings.available.length > 0);
});

async function getMenuSettings() {
  if (isEmpty_default()(selectedCompany) || isEmpty_default()(apiUrls))
    return;
  let err, res;
  [err, res] = await to((0,utilities_.interceptor)({
    url: `${apiUrls.dutypay}/api/v0/application-switch/`,
    method: 'POST',
    data: {
      "decision-tree-id": "7926389e-bb20-4470-b02e-cfd20d19010f",
      "params": {
        "Company": {
          "sp": {
            "company": {
              "id": selectedCompany.sp.company.id
            }
          },
          "hs": {
            "company": {
              "id": selectedCompany.id
            }
          }
        }
      }
    }
  }));
  if (!isEmpty_default()(res.data.result.active) || !isEmpty_default()(res.data.result.available)) {
    emit('hasApplications')
  }
  menuSettings.active = res.data.result.active;
  menuSettings.available = res.data.result.available;
  if(err){
    throw err;
  }
}

function hideAvailableApplications() {
  isAvailableApplicationsVisible.value = false;
}
function showAvailableApplications() {
  isAvailableApplicationsVisible.value = true;
}

async function openApplication(url) {
  isLoading.value = true;
  await envStore.switchApplication(url)
  isLoading.value = false;
  props.closeHandler();
}

async function goToStart() {
  await router.push({path: '/', slug: 'root'});
  props.closeHandler();
}

(0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(async () => {
  await getMenuSettings();
})

;(0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(selectedCompany, async () => {
  await getMenuSettings();
})

return (_ctx, _cache) => {
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")
  const _component_el_collapse_transition = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-collapse-transition")
  const _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_1, [
    ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasActiveApplications) || (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasAvailableApplications))
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_2, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: goToStart,
            class: "hidden-sm-and-up full-width"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('toStart.buttonLabel')), 1)
            ]),
            _: 1
          }),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_3, [
            ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasActiveApplications))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_4, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activeApplications.label')), 1),
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_6, [
                    ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(menuSettings.active, (item, index) => {
                      return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["application-switch__items text-align-center", {'is-mobile': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)}]),
                        onClick: $event => (openApplication(item.url)),
                        onKeypress: $event => (openApplication(item.url)),
                        key: item.application + index.toString(),
                        tabindex: "0"
                      }, [
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
                          src: `${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(assetsApiEndpoint)}/sp/${item.sp.hubSystemImage.src.id}/svg`,
                          alt: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`activeApplication.imageAltTag.displayValues-${item.sp.hubSystemImage.alt.id}`),
                          class: "application-switch__item-logo--active"
                        }, null, 8, ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_8),
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_9, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`ds.components.DpHeader.ApplicationSwitchMenu.activeApplication.caption.displayValues-${item.sp.hubSystemImage.caption.id}`)), 1)
                      ], 42, ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_7))
                    }), 128)),
                    (!isAvailableApplicationsVisible.value && (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasAvailableApplications))
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                          key: 0,
                          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["application-switch__items text-align-center dp-flex column", {'is-mobile': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)}]),
                          onClick: showAvailableApplications,
                          onKeypress: showAvailableApplications,
                          tabindex: "0"
                        }, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpIcon["default"]), {
                            icon: "plus",
                            size: 24,
                            color: "#FFFFFF"
                          }),
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_10, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('exploreMore.buttonLabel')), 1)
                        ], 34))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                  ])
                ]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasAvailableApplications))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_collapse_transition, { key: 1 }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (isAvailableApplicationsVisible.value || !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasActiveApplications))
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_11, [
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_12, [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('availableApplications.label')) + " ", 1),
                            ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(hasActiveApplications))
                              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
                                  key: 0,
                                  onClick: hideAvailableApplications,
                                  onKeypress: hideAvailableApplications,
                                  purpose: "secondaryAction",
                                  size: "tiny",
                                  tabindex: "0",
                                  style: {"margin-inline-start":".5em"}
                                }, {
                                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('showLess.label')), 1)
                                  ]),
                                  _: 1
                                }))
                              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                          ]),
                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_13, [
                            ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(menuSettings.available, (item, index) => {
                              return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                                class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["application-switch__items text-align-center", {'is-mobile': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)}]),
                                onClick: $event => (openApplication(item.url)),
                                onKeypress: $event => (openApplication(item.url)),
                                key: item.application + index.toString(),
                                tabindex: "0"
                              }, [
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
                                  src: `${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(assetsApiEndpoint)}/sp/${item.sp.hubSystemImage.src.id}/svg`,
                                  alt: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`availableApplication.imageAltTag.displayValues-${item.sp.hubSystemImage.alt.id}`),
                                  class: "application-switch__item-logo--available"
                                }, null, 8, ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_15),
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_16, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`ds.components.DpHeader.ApplicationSwitchMenu.availableApplication.caption.displayValues-${item.sp.hubSystemImage.caption.id}`)), 1),
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_17, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)(`ds.components.DpHeader.ApplicationSwitchMenu.availableApplication.description.displayValues-${item.sp.hubSystemImage.description.id}`)), 1)
                              ], 42, ApplicationSwitchMenuvue_type_script_setup_true_lang_js_hoisted_14))
                            }), 128))
                          ])
                        ]))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                  ]),
                  _: 1
                }))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
              class: "application-switch__close",
              onClick: _cache[0] || (_cache[0] = (...args) => (__props.closeHandler && __props.closeHandler(...args))),
              onKeypress: _cache[1] || (_cache[1] = (...args) => (__props.closeHandler && __props.closeHandler(...args))),
              tabindex: "0",
              style: {'cursor': 'pointer'}
            }, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpIcon["default"]), {
                icon: "close",
                color: "#ffffff",
                size: 24,
                margin: false
              })
            ], 32)
          ])), [
            [_directive_loading, isLoading.value]
          ])
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
  ], 512))
}
}

});
;// CONCATENATED MODULE: ./src/components/DpHeader/ApplicationSwitchMenu.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/ApplicationSwitchMenu.vue?vue&type=style&index=0&id=1a883235&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader/ApplicationSwitchMenu.vue?vue&type=style&index=0&id=1a883235&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader/ApplicationSwitchMenu.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ApplicationSwitchMenuvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpHeader/ApplicationSwitchMenu.vue



;
/* custom blocks */

if (typeof ApplicationSwitchMenuvue_type_custom_index_0_blockType_i18n === 'function') ApplicationSwitchMenuvue_type_custom_index_0_blockType_i18n(ApplicationSwitchMenuvue_type_script_setup_true_lang_js)


const ApplicationSwitchMenu_exports_ = ApplicationSwitchMenuvue_type_script_setup_true_lang_js;

/* harmony default export */ var ApplicationSwitchMenu = (ApplicationSwitchMenu_exports_);
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(3311);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__(5161);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader.vue?vue&type=script&setup=true&lang=js


const DpHeadervue_type_script_setup_true_lang_js_withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-35895346"),n=n(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(),n)
const DpHeadervue_type_script_setup_true_lang_js_hoisted_1 = {
  class: "dp-header",
  ref: "headerContainer"
}
const DpHeadervue_type_script_setup_true_lang_js_hoisted_2 = { class: "dp-flex row justify-content__space-between align-items__center" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_3 = { class: "hidden-xs-only dp-flex row flex-basis-1" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_4 = ["src"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_5 = ["src", "alt"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_6 = ["index", "onClick"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_7 = { class: "correct-for-border" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_8 = /*#__PURE__*/ DpHeadervue_type_script_setup_true_lang_js_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, null, -1))
const DpHeadervue_type_script_setup_true_lang_js_hoisted_9 = /*#__PURE__*/ DpHeadervue_type_script_setup_true_lang_js_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, null, -1))
const DpHeadervue_type_script_setup_true_lang_js_hoisted_10 = /*#__PURE__*/ DpHeadervue_type_script_setup_true_lang_js_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, null, -1))
const DpHeadervue_type_script_setup_true_lang_js_hoisted_11 = /*#__PURE__*/ DpHeadervue_type_script_setup_true_lang_js_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, null, -1))
const DpHeadervue_type_script_setup_true_lang_js_hoisted_12 = [
  DpHeadervue_type_script_setup_true_lang_js_hoisted_8,
  DpHeadervue_type_script_setup_true_lang_js_hoisted_9,
  DpHeadervue_type_script_setup_true_lang_js_hoisted_10,
  DpHeadervue_type_script_setup_true_lang_js_hoisted_11
]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_13 = ["src", "alt"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_14 = ["src", "alt"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_15 = { class: "header-bar__mobile-menu-items" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_16 = ["onClick"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_17 = ["onClick"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_18 = { key: 0 }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_19 = ["onClick"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_20 = { class: "dp-header__sub-header-bar hidden-xs-only" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_21 = { class: "dp-flex justify-content__space-between align-items__center" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_22 = { class: "flex-basis-1" }
const DpHeadervue_type_script_setup_true_lang_js_hoisted_23 = {
  key: 0,
  class: "sub-header-bar__menu-items"
}
const DpHeadervue_type_script_setup_true_lang_js_hoisted_24 = ["onClick"]
const DpHeadervue_type_script_setup_true_lang_js_hoisted_25 = {
  key: 0,
  class: "flex-basis-1"
}
const DpHeadervue_type_script_setup_true_lang_js_hoisted_26 = /*#__PURE__*/ DpHeadervue_type_script_setup_true_lang_js_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", { class: "el-icon-arrow-down icon-margin-start" }, null, -1))


;













const DpHeadervue_type_script_setup_true_lang_js_default_ = {
  name: "DpHeader",
  components: {
    AvatarMenu: AvatarMenu,
    Avatar: Avatar,
    DpWrapper: DpWrapper["default"],
    DpCollapse: DpCollapse["default"],
    ApplicationSwitchMenu: ApplicationSwitchMenu
  },
  props: {
    menuItems: { type: Array },
    light: { type: Boolean, default: false },
    hasCompanySwitch: { type: Boolean, default: true }
  },
  data() {
    return {
      avatarMenuVisible: false,
      applicationSwitchMenu: false,
      applicationSwitchMenuVisible: false,
      mobileMenuVisible: false,
      companySelectVisible: isEmpty_default()(get_default()(this.companySelect, 'selectedCompany', '')),
      latestKnownScrollY: 0,
      ticking: false,
      dpApplicationLogoHeight: 20,
      applicationSwitchLogoHeight: 15,
      elHeaderMargin: 0,
    };
  },
  computed: {
    ...(0,pinia_esm_browser/* mapState */.rn)(store_modules_.useCompanyStore, ['selectedCompany', 'companies']),
    companySelect() {
      let i18nLocale = this.$i18n.locale;
      let setCompany = this.setCompany;
      return {
        companyName: isEmpty_default()(get_default()(this.selectedCompany, `translations.name.legal.${i18nLocale}`, undefined))
            ? get_default()(this.selectedCompany, `name.legal`, undefined)
            : get_default()(this.selectedCompany, `translations.name.legal.${i18nLocale}`, undefined),
        selectedCompany: {companyId: get_default()(this.selectedCompany, 'id', undefined)},
        companiesList: map_default()(this.companies, function (row) {
          return {
            label: isEmpty_default()(get_default()(row, `translations.name.legal.${i18nLocale}`, undefined))
                ? get_default()(row, `name.legal`, undefined)
                : get_default()(row, `translations.name.legal.${i18nLocale}`, undefined),
            companyId: row.id,
            action: () => {
              setCompany(row.id);
              window.location.replace('/');
            }
          };
        })
      }
    },
    isEmpty() {
      return (isEmpty_default());
    },
    get() {
      return (get_default());
    },
    subHeaderMenuItems() {
      if (this.$route.matched[0] === undefined)
        return undefined;
      if (this.$route.matched[0].path === undefined)
        return undefined;
      if (find_default()(this.menuItems, {'path': this.$route.matched[0].path}) === undefined)
        return undefined;
      if (find_default()(this.menuItems, ['path', this.$route.matched[0].path]).children === undefined)
        return undefined;
      return find_default()(this.menuItems, ['path', this.$route.matched[0].path]).children || [];
    },
  },
  methods: {
    ...(0,pinia_esm_browser/* mapActions */.nv)(store_modules_.useCompanyStore, ['setCompany']),
    matchWithActiveRoute(path) {
      return !!(find_default()(this.$route.matched, (route) => {
        return route.path === path;
      }));
    },
    handleMenuItemClick(item) {
      this.$router.push(item.path);
      this.hideMobileMenu();
      this.hideAvatarMenu();
      this.hideCompanySelect();
    },
    handleClickOutside(e) {
      const el = this.$refs.headerContainer;
      if (!el.contains(e.target)) {
        this.hideMobileMenu();
        this.hideAvatarMenu();
        this.hideCompanySelect();
        this.hideApplicationSwitchMenu();
      }
    },
    hideAll() {
      this.hideMobileMenu();
      this.hideAvatarMenu();
      this.hideApplicationSwitchMenu();
    },
    showMobileMenu() {
      this.hideAll();
      this.mobileMenuVisible = true;
    },
    hideMobileMenu() {
      this.mobileMenuVisible = false;
    },
    showAvatarMenu() {
      this.hideAll();
      this.avatarMenuVisible = true;
    },
    hideAvatarMenu() {
      this.avatarMenuVisible = false;
    },
    activateApplicationSwitch() {
      this.applicationSwitchMenu = true
    },
    showApplicationSwitchMenu() {
      this.hideAll();
      this.applicationSwitchMenuVisible = true;
    },
    hideApplicationSwitchMenu() {
      this.applicationSwitchMenuVisible = false;
    },
    toggleAvatarMenu() {
      (this.avatarMenuVisible) ? this.hideAvatarMenu() : this.showAvatarMenu();
    },
    toggleMobileMenu() {
      (this.mobileMenuVisible) ? this.hideMobileMenu() : this.showMobileMenu();
    },
    toggleApplicationSwitchMenu() {
      (this.applicationSwitchMenuVisible) ? this.hideApplicationSwitchMenu() : this.showApplicationSwitchMenu();
    },
    routeToEntryPoint() {
      this.$router.push({path: '/'});
    },
    showCompanySelect() {
      this.companySelectVisible = true;
    },
    hideCompanySelect() {
      this.companySelectVisible = false;
    },
    async selectCompany(action) {
      await action();
      this.hideCompanySelect();
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside, true)
  },
};






/* harmony default export */ var DpHeadervue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(DpHeadervue_type_script_setup_true_lang_js_default_, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

const composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables')
const { isMobile } = composables.useViewportSize();

const envStore = (0,store_modules_.useEnvStore)()
const applicationVariable = envStore.applicationVariable;
const apiUrls = envStore.apiUrls;

const assetsApiEndpoint = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return `${apiUrls.dutypay}/api/v0/assets`;
});

return (_ctx, _cache) => {
  const _component_el_option = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-option")
  const _component_el_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-select")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-header__header-bar", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable)])
    }, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpWrapper["default"]), null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_2, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_3, [
              (_ctx.applicationSwitchMenu)
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                    key: 0,
                    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["header-bar__menu-items header-bar__hover dp-flex align-items__center", {'is-active': _ctx.applicationSwitchMenuVisible}]),
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggleApplicationSwitchMenu && _ctx.toggleApplicationSwitchMenu(...args))),
                    tabindex: "0"
                  }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
                      src: `${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(assetsApiEndpoint)}/56cbb4a5-0fb4-4378-9577-b5fafcf68ac5/svg`,
                      alt: "Application Switch",
                      height: "24",
                      width: "24",
                      class: "speak-never"
                    }, null, 8, DpHeadervue_type_script_setup_true_lang_js_hoisted_4)
                  ], 2))
                : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                class: "header-bar__menu-items header-bar__hover dp-flex align-items__center",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.handleMenuItemClick({path: '/', slug: 'root'}))),
                tabindex: "0"
              }, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
                  src: `${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(assetsApiEndpoint)}/logo/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable)}/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable) === 'dutypay' ? 'standard' : 'mini'}/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable) === 'dutypay' ? 'light' : 'inverted'}/svg`,
                  alt: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable),
                  class: "header-bar__application-logo speak-never"
                }, null, 8, DpHeadervue_type_script_setup_true_lang_js_hoisted_5)
              ]),
              ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(__props.menuItems, (item, index) => {
                return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["header-bar__menu-items header-bar__hover dp-flex align-items__center", {'is-active': _ctx.matchWithActiveRoute(item.path)}]),
                  key: index,
                  index: item.path,
                  onClick: $event => (_ctx.handleMenuItemClick(item)),
                  tabindex: "0"
                }, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", DpHeadervue_type_script_setup_true_lang_js_hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.label || ''), 1)
                ], 10, DpHeadervue_type_script_setup_true_lang_js_hoisted_6))
              }), 128))
            ]),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
              class: "hidden-sm-and-up header-bar__menu-items dp-flex align-items__center dp-mobile-menu-toggle",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)))
            }, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'visible': _ctx.mobileMenuVisible})
              }, DpHeadervue_type_script_setup_true_lang_js_hoisted_12, 2)
            ]),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["hidden-sm-and-up header-bar__menu-items header-bar__hover dp-flex align-items__center", {'is-active': _ctx.applicationSwitchMenuVisible}]),
              onClick: _cache[3] || (_cache[3] = $event => ((_ctx.applicationSwitchMenu) ? _ctx.toggleApplicationSwitchMenu() : _ctx.handleMenuItemClick({path: '/', slug: 'root'}))),
              tabindex: "0"
            }, [
              (_ctx.applicationSwitchMenu)
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("img", {
                    key: 0,
                    src: `${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(assetsApiEndpoint)}/logo/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable)}/mobile/light/svg`,
                    alt: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable),
                    class: "header-bar__application-logo speak-never"
                  }, null, 8, DpHeadervue_type_script_setup_true_lang_js_hoisted_13))
                : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("img", {
                    key: 1,
                    src: `${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(assetsApiEndpoint)}/logo/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable)}/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable) === 'dutypay' ? 'standard' : 'mini'}/${(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable) === 'dutypay' ? 'light' : 'inverted'}/svg`,
                    alt: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(applicationVariable),
                    class: "header-bar__application-logo speak-never"
                  }, null, 8, DpHeadervue_type_script_setup_true_lang_js_hoisted_14))
            ], 2),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["flex-basis-0 header-bar__hover dp-flex align-items__center", {'is-active': _ctx.avatarMenuVisible ||
               _ctx.matchWithActiveRoute('/account-settings') ||
               _ctx.matchWithActiveRoute('/company-settings') ||
               _ctx.matchWithActiveRoute('/developer-settings')}])
            }, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                tabindex: "0",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.toggleAvatarMenu && _ctx.toggleAvatarMenu(...args)))
              }, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(Avatar))
              ])
            ], 2)
          ]),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpCollapse["default"]), null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", DpHeadervue_type_script_setup_true_lang_js_hoisted_15, [
                ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(__props.menuItems, (menuItem, menuItemIndex) => {
                  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                    key: `mobile-menu-item-${menuItemIndex}`,
                    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'is-active': _ctx.matchWithActiveRoute(menuItem.path),
                    'has-children': menuItem.children !== undefined}),
                    onClick: $event => (menuItem.children ? ()=>{} : _ctx.handleMenuItemClick(menuItem))
                  }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
                      onClick: $event => (menuItem.children ? _ctx.handleMenuItemClick(menuItem) : ()=>{})
                    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(menuItem.label || ''), 9, DpHeadervue_type_script_setup_true_lang_js_hoisted_17),
                    (menuItem.children)
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", DpHeadervue_type_script_setup_true_lang_js_hoisted_18, [
                          ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(menuItem.children, (subMenuItem, subMenuItemIndex) => {
                            return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                              key: `mobile-menu-item-${menuItemIndex}-sub-menu-${subMenuItemIndex}`,
                              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'is-active': _ctx.matchWithActiveRoute(subMenuItem.path)}),
                              onClick: $event => (_ctx.handleMenuItemClick(subMenuItem))
                            }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(subMenuItem.label), 11, DpHeadervue_type_script_setup_true_lang_js_hoisted_19))
                          }), 128))
                        ]))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                  ], 10, DpHeadervue_type_script_setup_true_lang_js_hoisted_16))
                }), 128))
              ])
            ]),
            _: 1
          }, 512), [
            [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.mobileMenuVisible]
          ]),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpCollapse["default"]), null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(AvatarMenu), {
                companySelect: _ctx.companySelect,
                closeHandler: _ctx.hideAvatarMenu,
                hasCompanySwitch: __props.hasCompanySwitch
              }, null, 8, ["companySelect", "closeHandler", "hasCompanySwitch"])
            ]),
            _: 1
          }, 512), [
            [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.avatarMenuVisible]
          ]),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpCollapse["default"]), null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ApplicationSwitchMenu), {
                closeHandler: _ctx.hideApplicationSwitchMenu,
                onHasApplications: _ctx.activateApplicationSwitch
              }, null, 8, ["closeHandler", "onHasApplications"])
            ]),
            _: 1
          }, 512), [
            [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.applicationSwitchMenuVisible]
          ])
        ]),
        _: 1
      })
    ], 2),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_20, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpWrapper["default"]), null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_21, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_22, [
              (_ctx.subHeaderMenuItems)
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", DpHeadervue_type_script_setup_true_lang_js_hoisted_23, [
                    ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.subHeaderMenuItems, (item, index) => {
                      return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                        onClick: $event => (_ctx.handleMenuItemClick(item)),
                        key: index,
                        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'is-active': _ctx.matchWithActiveRoute(item.path)})
                      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.label), 11, DpHeadervue_type_script_setup_true_lang_js_hoisted_24))
                    }), 128))
                  ]))
                : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
            ]),
            (__props.hasCompanySwitch)
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", DpHeadervue_type_script_setup_true_lang_js_hoisted_25, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                      class: "sub-header-bar__company-switch",
                      onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.showCompanySelect && _ctx.showCompanySelect(...args)))
                    }, [
                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                        modelValue: _ctx.companySelect.selectedCompany,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.companySelect.selectedCompany) = $event)),
                        "value-key": "companyId",
                        onChange: _cache[6] || (_cache[6] = $event => (_ctx.selectCompany($event.action))),
                        size: "small",
                        filterable: "",
                        disabled: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))(_ctx.companySelect, 'companiesList', undefined)),
                        "default-first-option": true,
                        placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.placeholder'),
                        class: "dp-header__sub-header-bar__company-switch__select",
                        "popper-class": "dp-header__sub-header-bar__company-switch__select__popper-dropdown"
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                          ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.companySelect.companiesList, (company, index) => {
                            return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_option, {
                              key: `company-switch-${index}`,
                              label: company.label,
                              value: company
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "placeholder"]), [
                        [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.companySelectVisible]
                      ]),
                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))(_ctx.companySelect, 'companyName', '')), 1),
                        DpHeadervue_type_script_setup_true_lang_js_hoisted_26
                      ])
                    ])
                  ])
                ]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
          ])
        ]),
        _: 1
      })
    ])
  ], 512))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpHeader.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader.vue?vue&type=style&index=0&id=35895346&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader.vue?vue&type=style&index=0&id=35895346&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpHeader.vue?vue&type=style&index=1&id=35895346&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpHeader.vue?vue&type=style&index=1&id=35895346&lang=scss

;// CONCATENATED MODULE: ./src/components/DpHeader.vue



;



const DpHeader_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpHeadervue_type_script_setup_true_lang_js, [['__scopeId',"data-v-35895346"]])

/* harmony default export */ var DpHeader = (DpHeader_exports_);

/***/ }),

/***/ 5172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpIcon; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpIcon.vue?vue&type=script&setup=true&lang=js



const __default__ = {
  name: "DpIcon"
};







/* harmony default export */ var DpIconvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  props: {
  icon: {type: String, required: true},
  filled: {type: Boolean, default: false},
  margin: {type: Boolean, default: true}
},
  setup(__props) {

const props = __props



const composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');
const {getJurisdictionByLocale} = composables.useJurisdictionSwitch();
const {locale} = (0,vue_i18n_esm_bundler/* useI18n */.QT)({useScope: 'global'});
const classes = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
  return [
    `dp-icon__${props.icon}${props.filled ? '--filled' : ''}`,
    {
      'mirror-horizontally': (0,lodash.get)(getJurisdictionByLocale(locale.value), 'rtl', false),
      'inline-margin': props.margin
    }
  ]
});

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(classes))
  }, null, 2))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpIcon.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./src/components/DpIcon.vue



const __exports__ = DpIconvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpIcon = (__exports__);

/***/ }),

/***/ 7789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpImg; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpImg.vue?vue&type=template&id=7b84394a


const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["srcset", "sizes"]
const _hoisted_3 = ["src", "srcset", "alt"]
const _hoisted_4 = ["media", "srcset", "type"]

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.isEmpty($props.media))
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("picture", _hoisted_1, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default"),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("source", {
          srcset: $options.generateSrcset($props.hsId, 'webp'),
          sizes: $props.sizes,
          type: "image/webp"
        }, null, 8, _hoisted_2),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
          src: `${$options.assetsApiEndpoint}/${$props.hsId}/jpeg/${$props.defaultSize}`,
          srcset: $options.generateSrcset($props.hsId, 'jpeg'),
          style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)($props.style),
          alt: $props.alt
        }, null, 12, _hoisted_3)
      ]))
    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("source", {
        key: 1,
        media: $props.media,
        srcset: $options.generateSrcset($props.hsId, $props.format),
        type: `image/${$props.format}`
      }, null, 8, _hoisted_4))
}
;// CONCATENATED MODULE: ./src/components/DpImg.vue?vue&type=template&id=7b84394a

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/each.js
var each = __webpack_require__(6073);
var each_default = /*#__PURE__*/__webpack_require__.n(each);
// EXTERNAL MODULE: external "@dutypay/store-modules"
var store_modules_ = __webpack_require__(2706);
// EXTERNAL MODULE: ./node_modules/pinia/dist/pinia.esm-browser.js + 1 modules
var pinia_esm_browser = __webpack_require__(8262);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpImg.vue?vue&type=script&lang=js






/* harmony default export */ var DpImgvue_type_script_lang_js = ({
  name: "DpImg",
  props: {
    hsId: {type: String, required: true},
    alt: {type: String},
    srcset: {type: Array},
    sizes: {type: String},
    defaultSize: {type: String, default: ''},
    style: {type: String},
    media: {type: String},
    format: {type: String}
  },
  computed: {
    ...(0,pinia_esm_browser/* mapState */.rn)(store_modules_.useEnvStore, ['apiUrls']),
    isEmpty() {
      return (isEmpty_default());
    },
    assetsApiEndpoint() {
      return `${this.apiUrls.dutypay}/api/v0/assets`;
    }
  },
  methods: {
    generateSrcset(hsId, format) {
      if (isEmpty_default()(this.srcset)) {
        return `${this.assetsApiEndpoint}/${hsId}/${format}/${this.defaultSize}`;
      }
      let string = '';
      each_default()(this.srcset, (set) => {
        string += `${this.assetsApiEndpoint}/${hsId}/${format}/${set.resourceSize} ${set.renderSize}, `;
      });
      return string;
    }
  }
});

;// CONCATENATED MODULE: ./src/components/DpImg.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpImg.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpImgvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpImg = (__exports__);

/***/ }),

/***/ 5686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpImprint; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpImprint.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = ["innerHTML"]


const __default__ = {
  name: "DpImprint"
};



/* harmony default export */ var DpImprintvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('textBlock.title')), 1),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: "content",
      innerHTML: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('textBlock.content')
    }, null, 8, _hoisted_1)
  ]))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpImprint.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpImprint.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpImprintvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDeutschland<br>\nGeschäftsführer: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registereintrag</h5>Registergericht: Amtsgericht Kaiserslautern<br>\nRegisternummer: HRB 31620<br>\nUmsatzsteuer-Id: DE293589759<br><h5>Hinweis</h5>Die Inhalte der Webseite dienen nur zur Information und stellen keine Steuer-, Rechts- oder Unternehmensberatung dar. Wir übernehmen für externe Links keine Haftung. Für den Inhalt verlinkter Seiten sind ausschießlich deren Betreiber verantwortlich."])}
        }
      },
      "de-AT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDeutschland<br>\nGeschäftsführer: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registereintrag</h5>Registergericht: Amtsgericht Kaiserslautern<br>\nRegisternummer: HRB 31620<br>\nUmsatzsteuer-Id: DE293589759<br><h5>Hinweis</h5>Die Inhalte der Webseite dienen nur zur Information und stellen keine Steuer-, Rechts- oder Unternehmensberatung dar. Wir übernehmen für externe Links keine Haftung. Für den Inhalt verlinkter Seiten sind ausschießlich deren Betreiber verantwortlich."])}
        }
      },
      "de-CH": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDeutschland<br>\nGeschäftsführer: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registereintrag</h5>Registergericht: Amtsgericht Kaiserslautern<br>\nRegisternummer: HRB 31620<br>\nUmsatzsteuer-Id: DE293589759<br><h5>Hinweis</h5>Die Inhalte der Webseite dienen nur zur Information und stellen keine Steuer-, Rechts- oder Unternehmensberatung dar. Wir übernehmen für externe Links keine Haftung. Für den Inhalt verlinkter Seiten sind ausschießlich deren Betreiber verantwortlich."])}
        }
      },
      "en-US": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Information"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermany<br>\nManaging Director: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contact</h5>Phone: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Commercial Registry</h5>Register court: District Court of Kaiserslautern<br>\nRegister number: HRB 31620<br>\nVAT ID number: DE293589759<br><h5>Note</h5>The content of the website is for information only and does not constitute tax, legal or business advice. We assume no liability for external links. The operators of linked sites are solely responsible for their content."])}
        }
      },
      "en-GB": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Information"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermany<br>\nManaging Director: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contact</h5>Phone: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Commercial Registry</h5>Register court: District Court of Kaiserslautern<br>\nRegister number: HRB 31620<br>\nVAT ID number: DE293589759<br><h5>Note</h5>The content of the website is for information only and does not constitute tax, legal or business advice. We assume no liability for external links. The operators of linked sites are solely responsible for their content."])}
        }
      },
      "it-IT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chi siamo"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermania<br>\nManaging Director: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contattaci</h5>Telefono: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Dati societari</h5>Registro imprese: District Court of Kaiserslautern<br>\nNumero di registro: HRB 31620<br>\nN° PARTITA IVA: DE293589759<br><h5>Nota</h5>I contenuti del sito sono a solo scopo informativo e non costituiscono consulenza fiscale, legale o commerciale. Non ci assumiamo alcuna responsabilità per i link esterni. Il contenuto delle pagine collegate è di esclusiva responsabilità dei loro gestori."])}
        }
      },
      "fr-FR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentions Légales"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAllemagne<br>\nDirecteur général: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contact</h5>Tél: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registre du commerce</h5>Tribunal d'enregistrement: Tribunal de district Kaiserslautern<br>\nNuméro de registre: HRB 31620<br>\nNUMÉRO DE TVA: DE293589759<br><h5>Remarque</h5>Le contenu du site Web est à titre indicatif et ne constitue pas un conseil fiscal, juridique ou commercial. Nous n'assumons aucune responsabilités pour les liens externes. Les exploitants de ces liens sont seuls responsables de leur contenu."])}
        }
      },
      "es-ES": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Información sobre Empresa"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlemania<br>\nDirector ejecutivo: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contacto</h5>Tel: +49 (0)631 5600 1600<br>\nCorreo electrónico: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registro commercial</h5>Tribunal de registro: Corte de Distrito de Kaiserslautern<br>\nNúmero de registro: HRB 31620<br>\nID de IVA: DE293589759<br><h5>Nota</h5>El contenido del sitio web es solo para información y no constituye asesoramiento fiscal, legal o comercial. No asumimos ninguna responsabilidad por los enlaces externos. Los operadores de los sitios enlazados son los únicos responsables de su contenido."])}
        }
      },
      "pl-PL": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacja o firmie"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNiemcy<br>\nZarząd: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Rejestr handlowy</h5>Sąd prowadzący rejestr: Sąd Rejonowy Kaiserslautern<br>\nNumer w rejestrze: HRB 31620<br>\nNIP-UE: DE293589759<br><h5>Zastrzeżenie</h5>Treść serwisu ma jedynie charakter informacyjny i nie stanowi doradztwa podatkowego, prawnego ani gospodarczego. Nie ponosimy żadnej odpowiedzialności za treść linków zewnętrznych. Za zawartość stron obcych odpowiadają wyłącznie ich operatorzy."])}
        }
      },
      "nl-NL": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinformatie"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDuitsland<br>\nDirecteur: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contact</h5>Telefoonnummer: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registreer inschrijving</h5>Register rechtbank: Arrondissementsrechtbank Kaiserslautern<br>\nRegistratienummer: HRB 31620<br>\nBtw Nr.: DE293589759<br><h5>Notitie</h5>De inhoud van de website is louter informatief en vormt geen fiscaal, juridisch of zakelijk advies Wij aanvaarden geen aansprakelijkheid voor externe links. De beheerders van gelinkte sites zijn als enige verantwoordelijk voor hun inhoud."])}
        }
      },
      "bg-BG": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Автор"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Ул. Пирмазенсер, 1<br>\nКайзерслаутерн, 67655<br>\nГермания<br>\nУправляващ директор: Dipl.-Wirtsch.-Ing. Александър Гансел<br><h5>Контакт</h5>Тел: +49 (0)631 5600 1600<br>\nИмейл: zentrale&#64;dutypay.eu<br>\nИмейл: mail&#64;de-mail.dutypay.eu<br><h5>Вписване в регистъра</h5>Съд на регистъра: Окръжен съд Кайзерслаутерн<br>\nРегистрационен номер: HRB 31620<br>\nДДС номер: DE293589759<br><h5>Забележка</h5>Съдържанието на уебсайта е само за информация и не представлява данъчен, правен или бизнес съвет. Не поемаме отговорност за линковете към външни сайтове. Операторите на свързаните сайтове са единствено отговорни за тяхното съдържание."])}
        }
      },
      "bs-BA": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNjemačka<br>\nGeneralni direktor: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Unos u registar</h5>Registarski sud: Okružni sud Kaiserslautern<br>\nRegistraski broj: HRB 31620<br>\nPDV-Id: DE293589759<br><h5>Napomena</h5>Sadržaj web stranice je samo informativnog karaktera i ne predstavlja porezni, pravni ili poslovni savjet. Ne preuzimamo odgovornost za vanjske poveznice. Operateri povezanih web stranica isključivo su odgovorni su za njihov sadržaj."])}
        }
      },
      "zh-CN": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司信息"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>皮尔马森瑟海峡1<br>\n67655 凯撒斯劳滕<br>\n德国<br>\n首席执行官: Dipl.-Wirtsch.-Ing。 亚历山大·甘塞尔<br><h5>联系</h5>电话：+49 (0)631 5600 1600<br>\n电子邮件: zentrale&#64;dutypay.eu<br>\n电子邮件: mail&#64;de-mail.dutypay.eu<br><h5>商业登记</h5>登记法院: 凯泽斯劳滕地方法院<br>\n注册编号: HRB 31620<br>\n营业税编号：DE293589759<br><h5>注意</h5>网站的内容仅供参考，不构成税收，法律或商业建议，我们对外部链接不承担任何责任。 链接站点的运营商对其内容全权负责。"])}
        }
      },
      "da-DK": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsoplysninger"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nTyskland<br>\nAdministrerende direktør: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Telefon: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Kommercielt register</h5>Registerret: Tingret Kaiserslautern<br>\nRegistreringsnummer: HRB 31620<br>\nMoms-ID: DE293589759<br><h5>Bemærk</h5>Indholdet på webstedet er kun til orientering og udgør ikke skatterådgivning, juridisk eller forretningsrådgivning. Vi påtager os intet ansvar for eksterne links. Operatørerne af linkede sider er eneansvarlige for deres indhold."])}
        }
      },
      "et-EE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte info"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nSaksamaa<br>\nTegevdirektor: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Võta ühendust</h5>Tel: +49 (0)631 5600 1600<br>\nE-post: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Äriregister</h5>Registrikohus: Ringkonnakohus Kaiserslautern<br>\nRegistrinumber: HRB 31620<br>\nKäibemaksu ID: DE293589759<br><h5>Märge</h5>Veebisaidi sisu on üksnes informatiivne ja ei kujuta endast maksu-, juriidilist ega ärinõu. Me ei vastuta väliste linkide eest. Lingitud saitide operaatorid vastutavad ainuisikuliselt nende sisu eest."])}
        }
      },
      "fi-FI": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen tiedot"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nSaksa<br>\nToimitusjohtaja: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Ottaa yhteyttä</h5>Puhelin: +49 (0)631 5600 1600<br>\nSähköposti: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Kaupparekisteri</h5>Rekisterituomioistuin: Käräjäoikeus Kaiserslautern<br>\nRekisterinumero: HRB 31620<br>\nALV-tunnus: DE293589759<br><h5>Merkintä</h5>Verkkosivuston sisältö on vain tiedoksi, eikä se ole vero-, laki- tai liike-elämän neuvontaa. Emme ole vastuussa ulkoisista linkeistä. Linkitettyjen sivustojen ylläpitäjät ovat yksin vastuussa niiden sisällöstä."])}
        }
      },
      "el-GR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία της εταιρείας"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Κάιζερσλαουτερν<br>\nΓερμανία<br>\nΔιευθύνων Σύμβουλος: Διπλωματούχος-Wirtsch.-Ing. Αλέξανδρος Γκάνσελ<br><h5>Επικοινωνία</h5>Τηλέφωνο: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Εμπορικό μητρώο</h5>Πρωτοδικείο: Περιφερειακό Δικαστήριο Καϊζερσλάουτερν<br>\nΑριθμός μητρώο: HRB 31620<br>\nΑΦΜ: DE293589759<br><h5>Σημείωση</h5>Το περιεχόμενο του ιστότοπου είναι μόνο για ενημέρωση και δεν αποτελεί φορολογική, νομική ή επιχειρηματική συμβουλή. Δεν αναλαμβάνουμε καμία ευθύνη για εξωτερικούς συνδέσμους. Οι χειριστές συνδεδεμένων ιστότοπων είναι αποκλειστικά υπεύθυνοι για το περιεχόμενό τους."])}
        }
      },
      "he-IL": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מידע על החברה"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nגרמניה<br> \nמנכ\"ל: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>איש קשר</h5>טלפון: <span dir=\"ltr\">+49 (0)631 5600 1600</span><br>\nדוא\"ל: zentrale&#64;dutypay.eu<br>\nדה-מייל: mail&#64;de-mail.dutypay.eu<br><h5>רישום מסחרי</h5>בית משפט רשום: בית המשפט המחוזי קייזרסלאוטרן<br>\nמספר רישום: HRB 31620<br>\nמזהה מס מכירה: DE293589759<br>\n<h5>הערה</h5>תוכן האתר הינו למידע בלבד ואינו מהווה ייעוץ מס, משפטי או עסקי. אנו לא לוקחים אחריות על קישורים חיצוניים. מפעילי האתרים המקושרים אחראים אך ורק לתוכן שלהם."])}
        }
      },
      "ga-IE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fógra Dlí"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAn Ghearmáin<br>\nStiúrthóir Bainistíochta: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Teagmháil</h5>Teil: +49 (0)631 5600 1600<br>\nRíomhphost: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Taifead sa chlár</h5>Cúirt chláraithe: Cúirt dúiche Kaiserslautern<br>\nUimhir chlárúcháin: HRB 31620<br>\nUimh. CBL: DE293589759<br><h5>Fógra</h5>Is chun críocha eolais amháin atá ábhar an láithreáin ghréasáin seo agus ní comhairle cánach, dlí ná gnó é. Ní ghlacaimid le haon dliteanas as naisc sheachtracha. Is iad oibreoirí na láithreán gréasáin nasctha amháin atá go hiomlán freagrach as aon ábhar orthu."])}
        }
      },
      "ja-JP": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業情報"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nドイツ<br>\nマネージングディレクター: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>連絡先</h5>Tel: +49 (0)631 5600 1600<br>\nメール: zentrale&#64;dutypay.eu<br>\nデメール: mail&#64;de-mail.dutypay.eu<br><h5>商用レジストリ</h5>登録裁判所: 地方裁判所Kaiserslautern<br>\n登録番号: HRB 31620<br>\n付加価値税 ID: DE293589759<br><h5>注意</h5>ウェブサイトのコンテンツは情報提供のみを目的としており、税務、法律、またはビジネス上のアドバイスを構成するものではありません。外部リンクについては責任を負いません。 リンクされたサイトの運営者は、そのコンテンツに対して単独で責任を負います。"])}
        }
      },
      "hr-HR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNjemačka<br>\nDirektor: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Unos u registar</h5>Registarski sud: Okružni sud u Kaiserslautern<br>\nRegistraski broj: HRB 31620<br>\nPDV-Id: DE293589759<br><h5>Napomena</h5>Sadržaj web stranice je samo informativnog karaktera i ne predstavlja porezni, pravni ili poslovni savjet. Ne preuzimamo odgovornost za vanjske poveznice. Operateri povezanih web stranica isključivo su odgovorni su za njihov sadržaj."])}
        }
      },
      "lv-LV": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas informācija"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nVācija<br>\nRīkotājdirektors: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakts</h5>Tālrunis: +49 (0)631 5600 1600<br>\nE-pasts: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Komercreģistrs</h5>Reģistra tiesa: Kaizerslauternes rajona tiesa<br>\nReģistrācijas numurs: HRB 31620<br>\nPVN ID: DE293589759<br><h5>Piezīme</h5>Vietnes saturs ir tikai informatīvs, un tas nav nodokļu, juridiskas vai uzņēmējdarbības konsultācijas. Mēs neuzņemamies atbildību par ārējām saitēm. Saistīto vietņu operatori ir atbildīgi tikai par to saturu."])}
        }
      },
      "lt-LT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanijos informacija"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nVokietija<br>\nGeneralinis direktorius: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontaktas</h5>Tel.: +49 (0)631 5600 1600<br>\nEl. Paštas: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Komercinis registras</h5>Registrų teismas: Apygardos teismas Kaiserslautern<br>\nRegistracijos numeris: HRB 31620<br>\nPVM mokėtojo ID: DE293589759<br><h5>Pastaba</h5>Svetainės turinys yra tik informacinis ir nėra mokesčių, teisinė ar verslo konsultacija. Mes neprisiimame jokios atsakomybės už išorines nuorodas. Už jų turinį atsakingi tik susietų svetainių operatoriai."])}
        }
      },
      "pt-PT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informações da Empresa"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlemanha<br>\nDiretor-Geral: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contato</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registro de entrada</h5>Tribunal de registro: Tribunal da Comarca de Kaiserslautern<br>\nNúmero de registro: HRB 31620<br>\nNIPC: DE293589759<br><h5>Nota</h5>O conteúdo do site é meramente informativo e não constitui aconselhamento fiscal, jurídico ou empresarial.Não assumimos qualquer responsabilidade por links externos. Os operadores de sites vinculados são os únicos responsáveis por seu conteúdo."])}
        }
      },
      "ro-RO": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informații privind Compania"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermania<br>\nDirector general: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Date de contact</h5>Tel: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registrul Comercial</h5>Judecătoria registrului: Judecătoria Kaiserslautern<br>\nNumăr de înregistrare: HRB 31620<br>\nNumăr TVA: DE293589759<br><h5>Notă</h5>Conținutul site-ului este doar cu titlu informativ și nu constituie consultanță fiscală, juridică sau de afaceri. Nu ne asumăm nicio răspundere pentru link-uri externe. Operatorii site-urilor conectate sunt singurii responsabili pentru conținutul lor."])}
        }
      },
      "ru-RU": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Импрессум"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Пирмазенсера, 1<br>\n67655 Кайзерслаутерн<br>\nГермания<br>\nУправляющий директор: Дипл. -Виртш.-инж. Александр Гансель<br><h5>Связаться с нами</h5>Тел .: +49 (0)631 5600 1600<br>\nЭлектронная почта: zentrale&#64;dutypay.eu<br>\nЭлектронная почта: mail&#64;de-mail.dutypay.eu<br><h5>Регистрация записи</h5>Регистрационный суд: Окружной суд Кайзерслаутерн<br>\nРегистрационный номер: HRB 31620<br>\nНалоговый номер: DE293589759<br><h5>Cсылкa</h5>Содержание веб-сайта предназначено только для информации и не является налоговой, юридической или деловой консультацией. Мы не несем ответственности за внешние ссылки. Операторы связанных сайтов несут полную ответственность за их содержание."])}
        }
      },
      "sv-SE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinformation"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nTyskland<br>\nVerkställande direktör: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-post: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Kommersiellt register</h5>Registreringsdomstol: Tingsrätten Kaiserslautern<br>\nRegistreringsnummer: HRB 31620<br>\nMoms-ID: DE293589759<br><h5>Notera</h5>Webbplatsens innehåll är endast till för information och utgör inte skatteråd, juridisk rådgivning eller affärsrådgivning. Vi tar inget ansvar för externa länkar. Operatörerna av länkade webbplatser är ensamma ansvariga för deras innehåll."])}
        }
      },
      "sk-SK": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNemecko<br>\nVýkonný riaditeľ: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel.č: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registračné údaje</h5>Registrový súd: Okresný súd Kaiserslautern<br>\nIČO: HRB 31620<br>\nIČ-DPH: DE293589759<br><h5>Poznámka</h5>Obsah webových stránok slúži iba na informačné účely a nepredstavuje daňové, právne ani obchodné poradenstvo. Za externé odkazy nepreberáme žiadnu zodpovednosť. Za ich obsah zodpovedajú výlučne prevádzkovatelia odkazovaných stránok. \n"])}
        }
      },
      "cs-CZ": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impresum"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNěmecko<br>\nVedoucí společnosti: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Telefon: +49 (0)631 5600 1600<br>\nE-mailová adresa: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registrační údaje</h5>Rejstříkový soud: Okresní soud v Kaiserslauternu<br>\nIČ: HRB 31620<br>\nDIČ: DE293589759<br><h5>Poznámka</h5>Obsah webových stránek slouží pouze pro informaci a nepředstavuje daňové, právní ani obchodní poradenství. Za externí odkazy nepřebíráme žádnou odpovědnost. Za jejich obsah odpovídají výhradně provozovatelé odkazových stránek."])}
        }
      },
      "tr-TR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Bilgisi"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlmanya<br>\nGenel müdür: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>İletişim</h5>Tel: +49 (0)631 5600 1600<br>\nE-posta: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Ticari kayıt</h5>Kayıt mahkemesi: Bölge Mahkemesi Kaiserslautern<br>\nKayıt numarası: HRB 31620<br>\nSatış vergisi kimliği: DE293589759<br><h5>Not</h5>Web sitesinin içeriği yalnızca bilgi amaçlıdır ve vergi, hukuk veya ticari tavsiye teşkil etmez Dış bağlantılar için hiçbir sorumluluk kabul etmiyoruz. Bağlantı verilen sitelerin operatörleri, içeriklerinden yalnızca sorumludur."])}
        }
      },
      "hu-HU": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Céginformáció"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNémetország<br>\nÜgyvezető igazgató: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kapcsolat</h5>Tel: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Kereskedelmi nyilvántartás</h5>Nyilvántartó bíróság: Kerületi Bíróság Kaiserslautern<br>\nNyilvántartási szám: HRB 31620<br>\nForgalmi adó azonosító: DE293589759<br>\n<h5>Megjegyzés</h5>A weboldal tartalma csak tájékoztató jellegű, és nem minősül adó-, jogi vagy üzleti tanácsadásnak. A külső linkekért felelősséget nem vállalunk. A linkelt webhelyek üzemeltetői kizárólag azok tartalmáért felelnek."])}
        }
      },
      "ar-AE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات الشركة"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>شارع بيرماسنزر .1<br>\nكايزرسلاوترن\n67655<br>\nألمانيا<br>\nالرئيس التنفيذى: دبل-ويرش.-إنغ. الكسندر جانسيل <br><h5>تصل</h5>هاتف: <span dir=\"ltr\">+49 (0)631 5600 1600</span><br>\nالبريد الإلكتروني: zentrale&#64;dutypay.eu <br>\nالبريد الإلكتروني: mail&#64;de-mail.dutypay.eu<br><h5>السجل التجاري</h5>سجل المحكمة: Amtsgericht Kaiserslautern<br>\nرقم التسجيل: HRB 31620<br>\nمعرف ضريبة المبيعات: DE293589759<br><h5>ملحوظة</h5>محتوى الموقع للعلم فقط ولا يشكل مشورة ضريبية أو قانونية أو تجارية ، ولا نتحمل أي مسؤولية عن الروابط الخارجية. مشغلو المواقع المرتبطة هم وحدهم المسؤولون عن محتواها."])}
        }
      },
      "fr-BE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentions Légales"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAllemagne<br>\nDirecteur général: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contact</h5>Tél: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registre du commerce</h5>Tribunal d'enregistrement: Tribunal de district Kaiserslautern<br>\nNuméro de registre: HRB 31620<br>\nNUMÉRO DE TVA: DE293589759<br><h5>Remarque</h5>Le contenu du site Web est à titre indicatif et ne constitue pas un conseil fiscal, juridique ou commercial. Nous n'assumons aucune responsabilités pour les liens externes. Les exploitants de ces liens sont seuls responsables de leur contenu."])}
        }
      },
      "fr-LU": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentions Légales"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAllemagne<br>\nDirecteur général: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Contact</h5>Tél: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Registre du commerce</h5>Tribunal d'enregistrement: Tribunal de district Kaiserslautern<br>\nNuméro de registre: HRB 31620<br>\nNUMÉRO DE TVA: DE293589759<br><h5>Remarque</h5>Le contenu du site Web est à titre indicatif et ne constitue pas un conseil fiscal, juridique ou commercial. Nous n'assumons aucune responsabilités pour les liens externes. Les exploitants de ces liens sont seuls responsables de leur contenu."])}
        }
      },
      "mt-MT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazzjoni dwar il-kumpanija"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nIl-Ġermanja<br>\nDirettur Maniġerjali: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kuntatt</h5>Tel: +49 (0)631 5600 1600<br>\nImejl: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Reġistru kummerċjali</h5>Qorti tar-Reġistru: Qorti Distrettwali Kaiserslautern<br>\nNumru tar-reġistru: HRB 31620<br>\nID tal-VAT: DE293589759<br><h5>Nota</h5>Il-kontenut tal-websajt huwa għall-informazzjoni biss u ma jikkostitwixxix parir ta 'taxxa, legali jew ta' negozju. L-operaturi ta 'siti marbuta huma unikament responsabbli għall-kontenut tagħhom."])}
        }
      },
      "sl-SI": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacije o podjetju"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNemčija<br>\nGeneralni direktor: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>Kontakt</h5>Tel: +49 (0)631 5600 1600<br>\nE-pošta: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Trgovinski register</h5>Registrsko sodišč: Okrožno sodišče Kaiserslautern<br>\nRegisternummer: HRB 31620<br>\nID prometnega davka: DE293589759<br><h5>Opomba</h5>Vsebina spletnega mesta je zgolj informativne narave in ne predstavlja davčnega, pravnega ali poslovnega nasveta. Za zunanje povezave ne prevzemamo odgovornosti. Za njihovo vsebino so izključno odgovorni upravljavci povezanih strani."])}
        }
      },
      "el-CY": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία της εταιρείας"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Κάιζερσλαουτερν<br>\nΓερμανία<br>\nΔιευθύνων Σύμβουλος: Διπλωματούχος-Wirtsch.-Ing. Αλέξανδρος Γκάνσελ<br><h5>Επικοινωνία</h5>Τηλέφωνο: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Εμπορικό μητρώο</h5>Πρωτοδικείο: Περιφερειακό Δικαστήριο Καϊζερσλάουτερν<br>\nΑριθμός μητρώο: HRB 31620<br>\nΑΦΜ: DE293589759<br><h5>Σημείωση</h5>Το περιεχόμενο του ιστότοπου είναι μόνο για ενημέρωση και δεν αποτελεί φορολογική, νομική ή επιχειρηματική συμβουλή. Δεν αναλαμβάνουμε καμία ευθύνη για εξωτερικούς συνδέσμους. Οι χειριστές συνδεδεμένων ιστότοπων είναι αποκλειστικά υπεύθυνοι για το περιεχόμενό τους."])}
        }
      },
      "tr-CY": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Bilgisi"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h5>DutyPay GmbH</h5>Pirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlmanya<br>\nGenel müdür: Dipl.-Wirtsch.-Ing. Alexander Gansel<br><h5>İletişim</h5>Tel: +49 (0)631 5600 1600<br>\nE-posta: zentrale&#64;dutypay.eu<br>\nDe-Mail: mail&#64;de-mail.dutypay.eu<br><h5>Ticari kayıt</h5>Kayıt mahkemesi: Bölge Mahkemesi Kaiserslautern<br>\nKayıt numarası: HRB 31620<br>\nSatış vergisi kimliği: DE293589759<br><h5>Not</h5>Web sitesinin içeriği yalnızca bilgi amaçlıdır ve vergi, hukuk veya ticari tavsiye teşkil etmez Dış bağlantılar için hiçbir sorumluluk kabul etmiyoruz. Bağlantı verilen sitelerin operatörleri, içeriklerinden yalnızca sorumludur."])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpImprint.vue


/* custom blocks */
;
if (typeof DpImprintvue_type_custom_index_0_blockType_i18n === 'function') DpImprintvue_type_custom_index_0_blockType_i18n(DpImprintvue_type_script_setup_true_lang_js)


const __exports__ = DpImprintvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpImprint = (__exports__);

/***/ }),

/***/ 3316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpListItem; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpListItem.vue?vue&type=template&id=16445848&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-16445848"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dp-list-item__quick-actions background-gradient-1"
}

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-list-item", {'hover-animation': $props.hoverAnimation, ...$options.classesMarked}])
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      onClick: _cache[0] || (_cache[0] = $event => ($props.action()))
    }, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-list-item__headline", {'pointer': $props.pointer}])
      }, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "headline", {}, undefined, true)
      ], 2),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-list-item__content", {'pointer': $props.pointer}])
      }, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, undefined, true)
      ], 2)
    ]),
    ($props.quickActions)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "quick-actions", {}, undefined, true)
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
  ], 2))
}
;// CONCATENATED MODULE: ./src/components/DpListItem.vue?vue&type=template&id=16445848&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpListItem.vue?vue&type=script&lang=js

  /* harmony default export */ var DpListItemvue_type_script_lang_js = ({
    name: "DpListItem",
    props: {
      action: {type: Function, default: () => {}},
      quickActions: {type: Boolean, default: false},
      pointer: {type: Boolean, default: false},
      hoverAnimation: {type: Boolean, default: false},
      marked: {type: String, default: ''}
    },
    computed: {
      classesMarked() {
        return {
          'marked__success': this.marked === 'success',
          'marked__warning': this.marked === 'warning',
          'marked__error': this.marked === 'error' || this.marked === 'danger'
        }
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpListItem.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpListItem.vue?vue&type=style&index=0&id=16445848&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpListItem.vue?vue&type=style&index=0&id=16445848&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpListItem.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpListItemvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpListItem.vue




;
/* custom blocks */

if (typeof DpListItemvue_type_custom_index_0_blockType_i18n === 'function') DpListItemvue_type_custom_index_0_blockType_i18n(DpListItemvue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpListItemvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-16445848"]])

/* harmony default export */ var DpListItem = (__exports__);

/***/ }),

/***/ 6989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpMobileCollapse; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileCollapse.vue?vue&type=template&id=7aecd514&scoped=true


const _withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-7aecd514"),n=n(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", { class: "el-icon-arrow-right" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", {
      onClick: _cache[0] || (_cache[0] = $event => ($data.show = !$data.show))
    }, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'dp-mobile-collapse-headline-icon': true, 'active': $data.show})
      }, _hoisted_2, 2),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "headline", {}, () => [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.headline), 1)
      ], true)
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 512), [
      [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, $data.show]
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpMobileCollapse.vue?vue&type=template&id=7aecd514&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileCollapse.vue?vue&type=script&lang=js

  /* harmony default export */ var DpMobileCollapsevue_type_script_lang_js = ({
    name: "DpMobileCollapse",
    props: {
      headline: {type: String, default: ''}
    },
    data() {
      return {
        show: true
      };
    }
  });

;// CONCATENATED MODULE: ./src/components/DpMobileCollapse.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileCollapse.vue?vue&type=style&index=0&id=7aecd514&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpMobileCollapse.vue?vue&type=style&index=0&id=7aecd514&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileCollapse.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpMobileCollapsevue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpMobileCollapse.vue




;
/* custom blocks */

if (typeof DpMobileCollapsevue_type_custom_index_0_blockType_i18n === 'function') DpMobileCollapsevue_type_custom_index_0_blockType_i18n(DpMobileCollapsevue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpMobileCollapsevue_type_script_lang_js, [['render',render],['__scopeId',"data-v-7aecd514"]])

/* harmony default export */ var DpMobileCollapse = (__exports__);

/***/ }),

/***/ 6993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpMobileFileDownload; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileFileDownload.vue?vue&type=template&id=447e1d73&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-447e1d73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dp-flex partition outlined" }
const _hoisted_2 = { class: "flex-basis-1" }
const _hoisted_3 = { class: "flex-basis-1" }
const _hoisted_4 = { class: "block file-name" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = ["href"]

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpFileIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFileIcon")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_2, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFileIcon, { "file-extension": $props.fileExtension }, null, 8, ["file-extension"])
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_3, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.fileName), 1),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "info", {}, undefined, true),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_5, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
          href: _ctx.link,
          target: "_blank"
        }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('download.label')), 9, _hoisted_6)
      ])
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpMobileFileDownload.vue?vue&type=template&id=447e1d73&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileFileDownload.vue?vue&type=script&lang=js

  // TODO: Discuss its necessity
  /* harmony default export */ var DpMobileFileDownloadvue_type_script_lang_js = ({
    name: "DpMobileFileDownload",
    props: {
      fileName: {type: String, required: true},
      fileExtension: {type: String, required: true},
      fileLink: {type: String, required: true}
    }
  });

;// CONCATENATED MODULE: ./src/components/DpMobileFileDownload.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileFileDownload.vue?vue&type=style&index=0&id=447e1d73&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpMobileFileDownload.vue?vue&type=style&index=0&id=447e1d73&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileFileDownload.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpMobileFileDownloadvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpMobileFileDownload.vue




;
/* custom blocks */

if (typeof DpMobileFileDownloadvue_type_custom_index_0_blockType_i18n === 'function') DpMobileFileDownloadvue_type_custom_index_0_blockType_i18n(DpMobileFileDownloadvue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpMobileFileDownloadvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-447e1d73"]])

/* harmony default export */ var DpMobileFileDownload = (__exports__);

/***/ }),

/***/ 9529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpMobileListItem; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileListItem.vue?vue&type=template&id=7842e5ea


const _hoisted_1 = { class: "dp-mobile-list-item" }
const _hoisted_2 = { class: "dp-mobile-list-item__headline" }
const _hoisted_3 = { class: "dp-mobile-list-item__description" }

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_2, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "headline")
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_3, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "description")
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpMobileListItem.vue?vue&type=template&id=7842e5ea

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileListItem.vue?vue&type=script&lang=js

  /* harmony default export */ var DpMobileListItemvue_type_script_lang_js = ({
    inheritAttrs: true,
    name: "DpMobileListItem"
  });

;// CONCATENATED MODULE: ./src/components/DpMobileListItem.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpMobileListItem.vue?vue&type=style&index=0&id=7842e5ea&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpMobileListItem.vue?vue&type=style&index=0&id=7842e5ea&lang=scss

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpMobileListItem.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpMobileListItemvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpMobileListItem = (__exports__);

/***/ }),

/***/ 6313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpNoDataIndicator; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNoDataIndicator.vue?vue&type=script&setup=true&lang=js


const _withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-dd1ce0fc"),n=n(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(),n)
const _hoisted_1 = { class: "no-data-indicator__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", null, [
    /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
      d: "M57.39,18A29,29,0,0,1,17.71,57.24",
      fill: "none",
      stroke: "#e8e8e8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5.34"
    }),
    /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
      d: "M10.72,51.71A29,29,0,0,1,52.48,11.46",
      fill: "none",
      stroke: "#e8e8e8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5.34"
    }),
    /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("line", {
      x1: "6.68",
      y1: "58.23",
      x2: "58.23",
      y2: "6.68",
      fill: "none",
      stroke: "#e8e8e8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5.34"
    })
  ])
], -1))
const _hoisted_3 = { class: "no-data-indicator__text" }


  const __default__ = {
    name: "DpNoDataIndicator"
  }

;

/* harmony default export */ var DpNoDataIndicatorvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    _hoisted_2,
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", _hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('nothingToShow.label')), 1),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
  ]))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpNoDataIndicator.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNoDataIndicator.vue?vue&type=style&index=0&id=dd1ce0fc&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpNoDataIndicator.vue?vue&type=style&index=0&id=dd1ce0fc&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNoDataIndicator.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpNoDataIndicatorvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen!"])}
        }
      },
      "de-AT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen!"])}
        }
      },
      "de-CH": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen!"])}
        }
      },
      "en-US": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display!"])}
        }
      },
      "en-GB": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display!"])}
        }
      },
      "it-IT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessun dato da visualizzare!"])}
        }
      },
      "fr-FR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "es-ES": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡No hay información para mostrar!"])}
        }
      },
      "pl-PL": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak danych do wyświetlenia!"])}
        }
      },
      "nl-NL": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen gegevens om weer te geven!"])}
        }
      },
      "bg-BG": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма данни за показване!"])}
        }
      },
      "bs-BA": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz!"])}
        }
      },
      "zh-CN": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有数据显示！"])}
        }
      },
      "da-DK": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data at vise!"])}
        }
      },
      "et-EE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole andmeid, mida kuvada!"])}
        }
      },
      "fi-FI": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei näytettäviä tietoja!"])}
        }
      },
      "el-GR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        }
      },
      "he-IL": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין נתונים להצגה!"])}
        }
      },
      "ga-IE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan aon sonraí le taispeáint!"])}
        }
      },
      "ja-JP": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表示するデータがありません！"])}
        }
      },
      "hr-HR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz!"])}
        }
      },
      "lv-LV": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav datu, ko parādīt!"])}
        }
      },
      "lt-LT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra rodomų duomenų!"])}
        }
      },
      "pt-PT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sem dados para exibir!"])}
        }
      },
      "ro-RO": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu sunt date de afișat!"])}
        }
      },
      "ru-RU": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет данных для отображения!"])}
        }
      },
      "sv-SE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data att visa!"])}
        }
      },
      "sk-SK": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadne údaje na zobrazenie!"])}
        }
      },
      "cs-CZ": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná data k zobrazení!"])}
        }
      },
      "tr-TR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        }
      },
      "hu-HU": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs megjeleníthető adat!"])}
        }
      },
      "ar-AE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض!"])}
        }
      },
      "fr-BE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "fr-LU": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "mt-MT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda dejta li trid turi!"])}
        }
      },
      "sl-SI": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni podatkov za prikaz!"])}
        }
      },
      "el-CY": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        }
      },
      "tr-CY": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        }
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpNoDataIndicator.vue



;
/* custom blocks */

if (typeof DpNoDataIndicatorvue_type_custom_index_0_blockType_i18n === 'function') DpNoDataIndicatorvue_type_custom_index_0_blockType_i18n(DpNoDataIndicatorvue_type_script_setup_true_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpNoDataIndicatorvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-dd1ce0fc"]])

/* harmony default export */ var DpNoDataIndicator = (__exports__);

/***/ }),

/***/ 451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpNotificationPersist; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNotificationPersist.vue?vue&type=template&id=bb7093c2&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-bb7093c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dp-flex row justify-content__flex-start" }
const _hoisted_2 = { class: "dp-flex column justify-content__flex-start flex-grow-1" }
const _hoisted_3 = {
  key: 0,
  class: "dp-notification-persist__title"
}
const _hoisted_4 = {
  key: 1,
  class: "dp-notification-persist__content"
}
const _hoisted_5 = {
  key: 2,
  class: "dp-notification-persist__controls"
}
const _hoisted_6 = {
  key: 0,
  class: "dp-notification-persist__content full-width"
}
const _hoisted_7 = {
  key: 1,
  class: "dp-notification-persist__controls full-width"
}

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse")

  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpCollapse, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([
        'dp-notification-persist',
        'dp-flex',
        'column',
        `dp-color__background__${$props.type}`,
        `dp-color__font__${$props.type}`,
        (!$options.hasTitle) ? 'compact' : ''
      ])
      }, [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_1, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-notification-persist__icon flex-basis-0", {'compact': !$options.hasTitle}])
          }, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)($options.iconClass)
            }, null, 2)
          ], 2),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_2, [
            ($options.hasTitle)
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_3, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "title", {}, () => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.title), 1)
                  ], true)
                ]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!$props.fullWidthMessage)
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_4, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.message), 1)
                  ], true)
                ]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (!$props.fullWidthMessage && $options.hasTitle && _ctx.$slots.controls)
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_5, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "controls", {}, undefined, true)
                ]))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
          ])
        ]),
        ($props.fullWidthMessage)
          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_6, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.message), 1)
              ], true)
            ]))
          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
        ($props.fullWidthMessage && $options.hasTitle && _ctx.$slots.controls)
          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_7, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "controls", {}, undefined, true)
            ]))
          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
      ], 2)
    ]),
    _: 3
  }, 512)), [
    [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, $props.visible]
  ])
}
;// CONCATENATED MODULE: ./src/components/DpNotificationPersist.vue?vue&type=template&id=bb7093c2&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNotificationPersist.vue?vue&type=script&lang=js

  /* harmony default export */ var DpNotificationPersistvue_type_script_lang_js = ({
    name: "DpNotificationPersist",
    props: {
      visible: {type: Boolean, default: true},
      type: {type: String, default: 'info'},
      flipIcon: {type: Boolean, default: false},
      title: {type: String},
      message: {type: String, default: undefined},
      fullWidthMessage: {type: Boolean, default: false}
    },
    data() {
      return {
        iconClasses: {
          'danger': 'el-icon-remove',
          'error': 'el-icon-error',
          'warning': 'el-icon-warning',
          'success': 'el-icon-success',
          'info': 'el-icon-info'
        },
      };
    },
    computed: {
      hasTitle() {
        return this.title || this.$slots.title;
      },
      iconClass() {
        let classes = [];
        classes.push(this.iconClasses[this.type]);
        if (this.flipIcon)
          classes.push('flip-icon');
        return classes;
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpNotificationPersist.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNotificationPersist.vue?vue&type=style&index=0&id=bb7093c2&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpNotificationPersist.vue?vue&type=style&index=0&id=bb7093c2&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpNotificationPersist.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpNotificationPersistvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpNotificationPersist.vue




;
/* custom blocks */

if (typeof DpNotificationPersistvue_type_custom_index_0_blockType_i18n === 'function') DpNotificationPersistvue_type_custom_index_0_blockType_i18n(DpNotificationPersistvue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpNotificationPersistvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-bb7093c2"]])

/* harmony default export */ var DpNotificationPersist = (__exports__);

/***/ }),

/***/ 6204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpPageSection; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpPageSection.vue?vue&type=template&id=0e7564e2&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-0e7564e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dp-page-section" }

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, undefined, true)
  ]))
}
;// CONCATENATED MODULE: ./src/components/DpPageSection.vue?vue&type=template&id=0e7564e2&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpPageSection.vue?vue&type=script&lang=js

  /* harmony default export */ var DpPageSectionvue_type_script_lang_js = ({
    name: "DpPageSection"
  });

;// CONCATENATED MODULE: ./src/components/DpPageSection.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpPageSection.vue?vue&type=style&index=0&id=0e7564e2&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpPageSection.vue?vue&type=style&index=0&id=0e7564e2&scoped=true&lang=css

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpPageSection.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpPageSectionvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-0e7564e2"]])

/* harmony default export */ var DpPageSection = (__exports__);

/***/ }),

/***/ 4133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpPrivacyPolicy; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpPrivacyPolicy.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = ["innerHTML"]


  const __default__ = {
    name: "DpPrivacyPolicy"
  };



/* harmony default export */ var DpPrivacyPolicyvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('textBlock.title')), 1),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: "content",
      innerHTML: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('textBlock.content')
    }, null, 8, _hoisted_1)
  ]))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpPrivacyPolicy.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpPrivacyPolicy.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpPrivacyPolicyvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Datenschutz auf einen Blick</h4><h5>Allgemeine Hinweise</h5><p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p><h5>Datenerfassung auf unserer Website</h5><p>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>\n<p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p><h5>Wie erfassen wir Ihre Daten?</h5><p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>\n\n<p>Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website betreten.</p><h5>Wofür nutzen wir Ihre Daten?</h5><p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p><h5>Welche Rechte haben Sie bezüglich Ihrer Daten?</h5><p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p><h4>2. Allgemeine Hinweise und Pflichtinformationen</h4><h5>Datenschutz</h5><p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>\n\n<p>Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen.</p>\n\n<p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.</p><h5>Hinweis zur verantwortlichen Stelle</h5><p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDeutschland</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.</p><h5>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h5><p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p><h5>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h5><p>Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Recht auf Datenübertragbarkeit</h5><p>Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.</p><h5>Recht auf Bestätigung und Auskunft</h5><p>Sie haben jederzeit das Recht, von uns eine Bestätigung darüber zu erhalten, ob Sie betreffende personenbezogene Daten verarbeitet werden. Ist dies der Fall, so haben Sie das Recht, von uns eine unentgeltliche Auskunft über die zu Ihnen gespeicherten personenbezogenen Daten zu verlangen.</p><h5>Recht auf Berichtigung</h5><p>Sie haben das Recht, von uns unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogenen Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollständigung unvollständiger personenbezogenen Daten zu verlangen.</p><h5>Recht auf Löschung („Recht auf Vergessenwerden“)</h5><p>Sie haben gemäß Artikel 17 DSGVO das Recht, von uns zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, und wir sind verpflichtet, personenbezogene Daten unverzüglich zu löschen, wenn einer der nachfolgenden Gründe zutrifft:</p>\n<p><ol><li>Die personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.</li>\n<li>Die betroffene Person widerruft ihre Einwilligung, auf die sich die Verarbeitung gemäß Artikel 6 Absatz 1 Buchstabe a oder Artikel 9 Absatz 2 Buchstabe a stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.</li>\n<li>Die betroffene Person legt gemäß Artikel 21 Absatz 1 Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder die betroffene Person legt gemäß Artikel 21 Absatz 2 Widerspruch gegen die Verarbeitung ein.</li>\n<li>Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>\n<li>Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.</li>\n<li>Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Artikel 8 Absatz 1 erhoben.</li>\n</ol>\n</p><h5>Recht auf Einschränkung der Verarbeitung</h5><p>Sie haben gem. Artikel 18 DSGVO das Recht, von uns die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:</p>\n<p><ol>\n<li>die Richtigkeit der personenbezogenen Daten von der betroffenen Person bestritten wird, und zwar für eine Dauer, die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen,\n</li>\n<li>die Verarbeitung unrechtmäßig ist und die betroffene Person die Löschung der personenbezogenen Daten ablehnt und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangt;\n</li>\n<li>der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigt, die betroffene Person sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigt, oder\n</li>\n<li>die betroffene Person Widerspruch gegen die Verarbeitung gemäß Artikel 21 Absatz 1 eingelegt hat, solange noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person überwiegen.\n</li></ol></p><h5>SSL- bzw. TLS-Verschlüsselung</h5><p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von 'http://' auf 'https://' wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>\n\n<p>Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.</p><h4>3. Datenschutzbeauftragter</h4><h5>Gesetzlich vorgeschriebener Datenschutzbeauftragter</h5><p>Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nDeutschland</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Datenerfassung auf unserer Website</h4><h5>Cookies</h5><p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.</p>\n\n<p>Die meisten der von uns verwendeten Cookies sind so genannte “Session-Cookies”. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.</p>\n\n<p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.</p>\n\n<p>Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Artikel 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerklärung gesondert behandelt.</p><h5>Server-Log-Dateien</h5><p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>\n<p><ul><li>Browsertyp und Browserversion</li>\n<li>verwendetes Betriebssystem</li>\n<li>Referrer URL</li>\n<li>Hostname des zugreifenden Rechners</li>\n<li>Uhrzeit der Serveranfrage</li>\n<li>IP-Adresse</li>\n</ul></p>\n\n<p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>\n\n<p>Grundlage für die Datenverarbeitung ist Artikel 6 Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.</p><h5>Kontaktformular</h5><p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>\n\n<p>Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Artikel 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.</p>\n\n<p>Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.</p>"])}
        }
      },
      "de-AT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Datenschutz auf einen Blick</h4><h5>Allgemeine Hinweise</h5><p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p><h5>Datenerfassung auf unserer Website</h5><p>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>\n<p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p><h5>Wie erfassen wir Ihre Daten?</h5><p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>\n\n<p>Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website betreten.</p><h5>Wofür nutzen wir Ihre Daten?</h5><p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p><h5>Welche Rechte haben Sie bezüglich Ihrer Daten?</h5><p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p><h4>2. Allgemeine Hinweise und Pflichtinformationen</h4><h5>Datenschutz</h5><p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>\n\n<p>Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen.</p>\n\n<p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.</p><h5>Hinweis zur verantwortlichen Stelle</h5><p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDeutschland</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.</p><h5>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h5><p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p><h5>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h5><p>Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Recht auf Datenübertragbarkeit</h5><p>Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.</p><h5>Recht auf Bestätigung und Auskunft</h5><p>Sie haben jederzeit das Recht, von uns eine Bestätigung darüber zu erhalten, ob Sie betreffende personenbezogene Daten verarbeitet werden. Ist dies der Fall, so haben Sie das Recht, von uns eine unentgeltliche Auskunft über die zu Ihnen gespeicherten personenbezogenen Daten zu verlangen.</p><h5>Recht auf Berichtigung</h5><p>Sie haben das Recht, von uns unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogenen Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollständigung unvollständiger personenbezogenen Daten zu verlangen.</p><h5>Recht auf Löschung („Recht auf Vergessenwerden“)</h5><p>Sie haben gemäß Artikel 17 DSGVO das Recht, von uns zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, und wir sind verpflichtet, personenbezogene Daten unverzüglich zu löschen, wenn einer der nachfolgenden Gründe zutrifft:</p>\n<p><ol>\n<li>Die personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.</li>\n<li>Die betroffene Person widerruft ihre Einwilligung, auf die sich die Verarbeitung gemäß Artikel 6 Absatz 1 Buchstabe a oder Artikel 9 Absatz 2 Buchstabe a stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.</li>\n<li>Die betroffene Person legt gemäß Artikel 21 Absatz 1 Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder die betroffene Person legt gemäß Artikel 21 Absatz 2 Widerspruch gegen die Verarbeitung ein.</li>\n<li>Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>\n<li>Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.</li>\n<li>Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Artikel 8 Absatz 1 erhoben.</li>\n</ol></p><h5>Recht auf Einschränkung der Verarbeitung</h5><p>Sie haben gem. Artikel 18 DSGVO das Recht, von uns die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:</p>\n<p><ol><li>die Richtigkeit der personenbezogenen Daten von der betroffenen Person bestritten wird, und zwar für eine Dauer, die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen,\n</li>\n<li>die Verarbeitung unrechtmäßig ist und die betroffene Person die Löschung der personenbezogenen Daten ablehnt und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangt;\n</li>\n<li>der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigt, die betroffene Person sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigt, oder\n</li>\n<li>die betroffene Person Widerspruch gegen die Verarbeitung gemäß Artikel 21 Absatz 1 eingelegt hat, solange noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person überwiegen.\n</li></ol></p><h5>SSL- bzw. TLS-Verschlüsselung</h5><p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von 'http://' auf 'https://' wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>\n\n<p>Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.</p><h4>3. Datenschutzbeauftragter</h4><h5>Gesetzlich vorgeschriebener Datenschutzbeauftragter</h5><p>Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nDeutschland</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Datenerfassung auf unserer Website</h4><h5>Cookies</h5><p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.</p>\n\n<p>Die meisten der von uns verwendeten Cookies sind so genannte “Session-Cookies”. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.</p>\n\n<p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.</p>\n\n<p>Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Artikel 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerklärung gesondert behandelt.</p><h5>Server-Log-Dateien</h5><p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>\n<p><ul>\n<li>Browsertyp und Browserversion</li>\n<li>verwendetes Betriebssystem</li>\n<li>Referrer URL</li>\n<li>Hostname des zugreifenden Rechners</li>\n<li>Uhrzeit der Serveranfrage</li>\n<li>IP-Adresse</li>\n</ul></p>\n<p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>\n<p>Grundlage für die Datenverarbeitung ist Artikel 6 Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.</p><h5>Kontaktformular</h5><p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>\n\n<p>Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Artikel 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.</p>\n\n<p>Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.</p>"])}
        }
      },
      "de-CH": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Datenschutz auf einen Blick</h4><h5>Allgemeine Hinweise</h5><p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p><h5>Datenerfassung auf unserer Website</h5><p>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>\n<p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p><h5>Wie erfassen wir Ihre Daten?</h5><p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>\n\n<p>Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website betreten.</p><h5>Wofür nutzen wir Ihre Daten?</h5><p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p><h5>Welche Rechte haben Sie bezüglich Ihrer Daten?</h5><p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p><h4>2. Allgemeine Hinweise und Pflichtinformationen</h4><h5>Datenschutz</h5><p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>\n\n<p>Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen.</p>\n\n<p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.</p><h5>Hinweis zur verantwortlichen Stelle</h5><p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDeutschland</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.</p><h5>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h5><p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p><h5>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h5><p>Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Recht auf Datenübertragbarkeit</h5><p>Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.</p><h5>Recht auf Bestätigung und Auskunft</h5><p>Sie haben jederzeit das Recht, von uns eine Bestätigung darüber zu erhalten, ob Sie betreffende personenbezogene Daten verarbeitet werden. Ist dies der Fall, so haben Sie das Recht, von uns eine unentgeltliche Auskunft über die zu Ihnen gespeicherten personenbezogenen Daten zu verlangen.</p><h5>Recht auf Berichtigung</h5><p>Sie haben das Recht, von uns unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogenen Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollständigung unvollständiger personenbezogenen Daten zu verlangen.</p><h5>Recht auf Löschung („Recht auf Vergessenwerden“)</h5><p>Sie haben gemäß Artikel 17 DSGVO das Recht, von uns zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, und wir sind verpflichtet, personenbezogene Daten unverzüglich zu löschen, wenn einer der nachfolgenden Gründe zutrifft:</p>\n<p><ol><li>Die personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.</li>\n<li>Die betroffene Person widerruft ihre Einwilligung, auf die sich die Verarbeitung gemäß Artikel 6 Absatz 1 Buchstabe a oder Artikel 9 Absatz 2 Buchstabe a stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.</li>\n<li>Die betroffene Person legt gemäß Artikel 21 Absatz 1 Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder die betroffene Person legt gemäß Artikel 21 Absatz 2 Widerspruch gegen die Verarbeitung ein.</li>\n<li>Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>\n<li>Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.</li>\n<li>Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Artikel 8 Absatz 1 erhoben.</li>\n</ol></p><h5>Recht auf Einschränkung der Verarbeitung</h5><p>Sie haben gem. Artikel 18 DSGVO das Recht, von uns die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:</p>\n<p><ol>\n<li>die Richtigkeit der personenbezogenen Daten von der betroffenen Person bestritten wird, und zwar für eine Dauer, die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen,\n</li>\n<li>die Verarbeitung unrechtmäßig ist und die betroffene Person die Löschung der personenbezogenen Daten ablehnt und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangt;\n</li>\n<li>der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigt, die betroffene Person sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigt, oder\n</li>\n<li>die betroffene Person Widerspruch gegen die Verarbeitung gemäß Artikel 21 Absatz 1 eingelegt hat, solange noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person überwiegen.\n</li></ol></p><h5>SSL- bzw. TLS-Verschlüsselung</h5><p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von 'http://' auf 'https://' wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>\n\n<p>Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.</p><h4>3. Datenschutzbeauftragter</h4><h5>Gesetzlich vorgeschriebener Datenschutzbeauftragter</h5><p>Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nDeutschland</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Datenerfassung auf unserer Website</h4><h5>Cookies</h5><p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.</p>\n\n<p>Die meisten der von uns verwendeten Cookies sind so genannte “Session-Cookies”. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.</p>\n\n<p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.</p>\n\n<p>Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Artikel 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerklärung gesondert behandelt.</p><h5>Server-Log-Dateien</h5><p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>\n<p><ul><li>Browsertyp und Browserversion</li>\n<li>verwendetes Betriebssystem</li>\n<li>Referrer URL</li>\n<li>Hostname des zugreifenden Rechners</li>\n<li>Uhrzeit der Serveranfrage</li>\n<li>IP-Adresse</li>\n</ul></p>\n<p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>\n<p>Grundlage für die Datenverarbeitung ist Artikel 6 Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.</p><h5>Kontaktformular</h5><p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>\n\n<p>Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Artikel 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.</p>\n\n<p>Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.</p>"])}
        }
      },
      "en-US": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privacy Policy"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Data protection at a glance</h4><h5>General information</h5><p>The following information provides a simple overview of what happens to your personal data when you visit our website. Personal data is any data that allows you to be personally identified. You can find detailed information on the subject of data protection in our Privacy Policy, which is set out beneath this text.</p><h5>Data collection on our website</h5><p>Who is responsible for data processing on this website?</p>\n<p>Data processing on this website is conducted by the website operator. You can find its contact details in the Legal Notice of this website.</p><h5>How do we record your data?</h5><p>On the one hand, your data is collected as a result of you providing it to us. This may be data that you enter into a contact form, for example.</p>\n\n<p>Other data is automatically recorded by our IT systems when you visit the website. This data is primarily technical data (for example web browser, operating system or the time the site is accessed). That data is recorded automatically as soon as you access our website.</p><h5>What do we use your data for?</h5><p>Some of the data is collected to ensure error-free provision of the website. Other data may be used to analyze your user behavior.</p><h5>What rights do you have with regard to your data?</h5><p>You have the right to request information from us at any time and free of charge on the origin, recipients and purpose of your personal data stored by us. You also have the right to demand the rectification, blocking or erasure of that data. For that purpose and for any other questions you may have on the subject of data protection, you can contact us at any time at the address specified in the Legal Notice. You also have a right to lodge a complaint with the competent supervisory authority.</p>\n<h4>2. General information and mandatory information</h4><h5>Data protection</h5><p>The operators of this website attach great importance to the protection of your data. We handle your personal data confidentially and in accordance with the statutory data protection regulations and this Privacy Policy.</p>\n\n<p>If you use this website, various personal data will be collected. This Privacy Policy explains what data we collect and what we use it for.</p>\n\n<p>We advise you that data transmission on the internet (e.g. during communication by e-mail) may be subject to security vulnerabilities. End-to-end protection of the data against access by third parties is not possible.</p><h5>Information on the controller</h5><p>The controller for data processing on this website is:</p>\n\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermany</p>\n\n<p>Tel. +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>The controller is the natural or legal person which, either alone or together with others, decides on the purposes and means of the processing of personal data (e.g. names, e-mail addresses and the like).</p><h5>Withdrawing your consent to the data processing</h5><p>Many data processing operations are only possible with your explicit consent. You can withdraw already granted consent at any time. An informal notification sent to us by e-mail is sufficient for this. The legality of data processing that occurred prior to such withdrawal is not affected by this.</p>\n\n<h5>Right to lodge a complaint with the competent supervisory authority</h5><p>In the event of a breach of data protection laws the affected person is entitled to lodge a complaint with the competent supervisory authority. The competent supervisory authority in issues related to data protection laws is the State Data Protection Officer of the federal state in which our company’s registered office is located. Through the following link you can find a list of data protection officers and their contact details: </p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Right to data portability</h5><p>You are entitled to a right to have data that we process by automated means on the basis of your consent or in performance of a contract delivered either to yourself or to a third party in a commonly used, machine-readable format. If you request the direct transfer of the data to another controller, this will only be done insofar as it is technically practicable.</p><h5>Right to confirmation and information</h5><p>You have the right to receive a confirmation from us as to whether personal data relating to you is processed. If this is the case you have the right to request information from us, free of charge, on your stored personal data.</p><h5>Right to rectification</h5><p>You have the right to request the prompt rectification of any incorrect personal data concerning you. You have the right, taking into account the purposes of the processing, to demand the completion of incomplete personal data.</p><h5>Right to erasure (“right to be forgotten”)</h5><p>Pursuant to Article 17 GDPR you have the right to request from us the prompt erasure of personal data concerning you, and we are obliged to promptly erase personal data if one of the following reasons applies:</p>\n<p><ol>\n<li>The personal data is no longer necessary for the purposes for which it was collected or otherwise processed.</li>\n<li>The data subject withdraws his/her consent on which the processing is based in accordance with Article 6 (1) point a) or Article 9 (2) lit. a), and there is no other legal basis for the processing.</li>\n<li>The data subject objects to the processing in accordance with Article 21 (1) and there are no overriding legitimate grounds for the processing, or the data subject objects to the processing in accordance with Article 21 (2).</li>\n<li>The personal data has been unlawfully processed.</li>\n<li>The personal data must be erased for compliance with a legal obligation under EU or Member State law to which the controller is subject.</li>\n<li>The personal data was collected in relation to the offer of information society services in accordance with Article 8 (1).</li>\n</ol></p>\n<h5>Right to restriction of processing</h5><p>You have the right under Article 18 GDPR to request from us the restriction of processing if one of the following conditions is fulfilled:</p>\n<p><ol>\n<li>The correctness of the personal data is contested by the data subject for a period that enables the controller to verify the correctness of the personal data.</li>\n<li>Processing is unlawful and the data subject refuses the erasure of the personal data and instead demands restriction of the use of the personal data.</li>\n<li>The controller no longer needs the personal data for the purposes of the processing, but the data subject needs it for the purpose of establishing, exercising or defending legal claims.</li>\n<li>The data subject has submitted an objection to processing in accordance with Article 21 (1) and it has not yet been established whether the legitimate grounds of the controller override the grounds of the data subject.</li>\n</ol></p>\n<h5>SSL/TLS encryption</h5><p>This website uses SSL/TLS encryption for reasons related to security and in order to protect the transfer of confidential content, such as orders or enquiries which you send to us as the website operator. You can recognize an encrypted connection in that the address line of the browser changes from \"http://\" to \"https://\" and by the padlock symbol in your browser toolbar.</p>\n\n<p>When SSL/TLS encryption is enabled, the data that you transmit to us cannot be read by third parties.</p><h4>3. Data protection officer</h4><h5>Legally required data protection officer</h5><p>We have appointed a data protection officer for our company.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nGermany</p>\n\n<p>Tel. +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Data collection on our website</h4><h5>Cookies</h5><p>Some of our web pages use “cookies”. Cookies do not cause any damage to your computer and do not contain viruses. They serve the purpose of making our service more user-friendly, effective and secure. Cookies are small text files which are deposited on your computer and are stored by your browser.</p>\n\n<p>Most of the cookies used by us are “session cookies”. They are automatically erased after the end of your visit. Other cookies remain stored on your end device until you erase them. These cookies enable us to recognize your browser the next time you visit us.</p>\n\n<p>You can adjust your browser settings so that you are informed of the installation of cookies and can decide whether to accept them on a case-by-case basis, block the acceptance of cookies either for particular cases or in general or activate automatic erasure of the cookies when you close the browser. If you disable cookies, the functionality of this website may be restricted.</p>\n\n<p>Cookies which are necessary for carrying out the electronic communication process or to provide certain functions required by you (e.g. the shopping cart function) are stored on the basis of Article 6 (1) lit. f) GDPR. The website operator has a legitimate interest in the storage of cookies for the purpose of optimized provision of its services without technical flaws. Insofar as other cookies (e.g. cookies for analyzing your surfing behavior) are stored, they are dealt with separately in this privacy policy.</p><h5>Server log files</h5><p>The provider of this site automatically collects and stores information in “server log files”, which your browser automatically transmits to us. This includes:</p>\n<p><ul>\n<li>Browser type and browser version</li>\n<li>The operating system used</li>\n<li>The referrer URL</li>\n<li>The host name of the accessing computer</li>\n<li>The time of the server request</li>\n<li>IP address</li>\n</ul></p>\n\n<p>This data is not combined with other data sources.</p>\n\n<p>The basis for data processing is Article 6 (1) lit. f) GDPR, which permits the processing of data for the purpose of performing a contract or for pre-contractual measures.</p>\n<h5>Contact form</h5><p>If you send us enquiries by contact form, your data from the enquiry form, including the contact details specified by you in it, will be stored by us for the purpose of processing the enquiry and for follow-up queries. We will not pass that data on without your consent.</p>\n\n<p>The data entered in the contact form is thus processed exclusively on the basis of your consent (Article 6 (1) lit. a) GDPR). You can withdraw that consent at any time. An informal notification sent to us by e-mail is sufficient for this. The legality of the data processing operations that occurred prior to such withdrawal is not affected by it.</p>\n\n<p>The data entered by you in the contact form remains with us until you request its erasure or withdraw your consent to the storage or if the purpose of the storage of the data no longer applies (e.g. after the completion of the processing of your enquiry). Mandatory provisions of law, particularly statutory retention periods, remain unaffected.</p>"])}
        }
      },
      "en-GB": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privacy Policy"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Data protection at a glance</h4><h5>General information</h5><p>The following information provides a simple overview of what happens to your personal data when you visit our website. Personal data is any data that allows you to be personally identified. You can find detailed information on the subject of data protection in our Privacy Policy, which is set out beneath this text.</p><h5>Data collection on our website</h5><p>Who is responsible for data processing on this website?</p>\n<p>Data processing on this website is conducted by the website operator. You can find its contact details in the Legal Notice of this website.</p><h5>How do we record your data?</h5><p>On the one hand, your data is collected as a result of you providing it to us. This may be data that you enter into a contact form, for example.</p>\n\n<p>Other data is automatically recorded by our IT systems when you visit the website. This data is primarily technical data (for example web browser, operating system or the time the site is accessed). That data is recorded automatically as soon as you access our website.</p><h5>What do we use your data for?</h5><p>Some of the data is collected to ensure error-free provision of the website. Other data may be used to analyse your user behaviour.</p><h5>What rights do you have with regard to your data?</h5><p>You have the right to request information from us at any time and free of charge on the origin, recipients and purpose of your personal data stored by us. You also have the right to demand the rectification, blocking or erasure of that data. For that purpose and for any other questions you may have on the subject of data protection, you can contact us at any time at the address specified in the Legal Notice. You also have a right to lodge a complaint with the competent supervisory authority.</p>\n<h4>2. General information and mandatory information</h4><h5>Data protection</h5><p>The operators of this website attach great importance to the protection of your data. We handle your personal data confidentially and in accordance with the statutory data protection regulations and this Privacy Policy.</p>\n\n<p>If you use this website, various personal data will be collected. This Privacy Policy explains what data we collect and what we use it for.</p>\n\n<p>We advise you that data transmission on the internet (e.g. during communication by e-mail) may be subject to security vulnerabilities. End-to-end protection of the data against access by third parties is not possible.</p><h5>Information on the controller</h5><p>The controller for data processing on this website is:</p>\n\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermany</p>\n\n<p>Tel. +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>The controller is the natural or legal person which, either alone or together with others, decides on the purposes and means of the processing of personal data (e.g. names, e-mail addresses and the like).</p><h5>Withdrawing your consent to the data processing</h5><p>Many data processing operations are only possible with your explicit consent. You can withdraw already granted consent at any time. An informal notification sent to us by e-mail is sufficient for this. The legality of data processing that occurred prior to such withdrawal is not affected by this.</p>\n\n<h5>Right to lodge a complaint with the competent supervisory authority</h5><p>In the event of a breach of data protection laws the affected person is entitled to lodge a complaint with the competent supervisory authority. The competent supervisory authority in issues related to data protection laws is the State Data Protection Officer of the federal state in which our company’s registered office is located. Through the following link you can find a list of data protection officers and their contact details: </p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Right to data portability</h5><p>You are entitled to a right to have data that we process by automated means on the basis of your consent or in performance of a contract delivered either to yourself or to a third party in a commonly used, machine-readable format. If you request the direct transfer of the data to another controller, this will only be done insofar as it is technically practicable.</p><h5>Right to confirmation and information</h5><p>You have the right to receive a confirmation from us as to whether personal data relating to you is processed. If this is the case you have the right to request information from us, free of charge, on your stored personal data.</p><h5>Right to rectification</h5><p>You have the right to request the prompt rectification of any incorrect personal data concerning you. You have the right, taking into account the purposes of the processing, to demand the completion of incomplete personal data.</p><h5>Right to erasure (“right to be forgotten”)</h5><p>Pursuant to Article 17 GDPR you have the right to request from us the prompt erasure of personal data concerning you, and we are obliged to promptly erase personal data if one of the following reasons applies:</p>\n<p><ol>\n<li>The personal data is no longer necessary for the purposes for which it was collected or otherwise processed.</li>\n<li>The data subject withdraws his/her consent on which the processing is based in accordance with Article 6 (1) point a) or Article 9 (2) lit. a), and there is no other legal basis for the processing.</li>\n<li>The data subject objects to the processing in accordance with Article 21 (1) and there are no overriding legitimate grounds for the processing, or the data subject objects to the processing in accordance with Article 21 (2).</li>\n<li>The personal data has been unlawfully processed.</li>\n<li>The personal data must be erased for compliance with a legal obligation under EU or Member State law to which the controller is subject.</li>\n<li>The personal data was collected in relation to the offer of information society services in accordance with Article 8 (1).</li>\n</ol></p>\n<h5>Right to restriction of processing</h5><p>You have the right under Article 18 GDPR to request from us the restriction of processing if one of the following conditions is fulfilled:</p>\n<p><ol>\n<li>The correctness of the personal data is contested by the data subject for a period that enables the controller to verify the correctness of the personal data.</li>\n<li>Processing is unlawful and the data subject refuses the erasure of the personal data and instead demands restriction of the use of the personal data.</li>\n<li>The controller no longer needs the personal data for the purposes of the processing, but the data subject needs it for the purpose of establishing, exercising or defending legal claims.</li>\n<li>The data subject has submitted an objection to processing in accordance with Article 21 (1) and it has not yet been established whether the legitimate grounds of the controller override the grounds of the data subject.</li>\n</ol></p>\n<h5>SSL/TLS encryption</h5><p>This website uses SSL/TLS encryption for reasons related to security and in order to protect the transfer of confidential content, such as orders or enquiries which you send to us as the website operator. You can recognise an encrypted connection in that the address line of the browser changes from “http://” to “https://” and by the padlock symbol in your browser toolbar.</p>\n\n<p>When SSL/TLS encryption is enabled, the data that you transmit to us cannot be read by third parties.</p>\n<h4>3. Data protection officer</h4><h5>Legally required data protection officer</h5><p>We have appointed a data protection officer for our company.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nGermany</p>\n\n<p>Tel. +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Data collection on our website</h4><h5>Cookies</h5><p>Some of our web pages use “cookies”. Cookies do not cause any damage to your computer and do not contain viruses. They serve the purpose of making our service more user-friendly, effective and secure. Cookies are small text files which are deposited on your computer and are stored by your browser.</p>\n\n<p>Most of the cookies used by us are “session cookies”. They are automatically erased after the end of your visit. Other cookies remain stored on your end device until you erase them. These cookies enable us to recognise your browser the next time you visit us.</p>\n\n<p>You can adjust your browser settings so that you are informed of the installation of cookies and can decide whether to accept them on a case-by-case basis, block the acceptance of cookies either for particular cases or in general or activate automatic erasure of the cookies when you close the browser. If you disable cookies, the functionality of this website may be restricted.</p>\n\n<p>Cookies which are necessary for carrying out the electronic communication process or to provide certain functions required by you (e.g. the shopping cart function) are stored on the basis of Article 6 (1) lit. f) GDPR. The website operator has a legitimate interest in the storage of cookies for the purpose of optimised provision of its services without technical flaws. Insofar as other cookies (e.g. cookies for analysing your surfing behaviour) are stored, they are dealt with separately in this privacy policy.</p><h5>Server log files</h5><p>The provider of this site automatically collects and stores information in “server log files”, which your browser automatically transmits to us. This includes:</p>\n<p><ul>\n<li>Browser type and browser version</li>\n<li>The operating system used</li>\n<li>The referrer URL</li>\n<li>The host name of the accessing computer</li>\n<li>The time of the server request</li>\n<li>IP address</li>\n</ul></p>\n\n<p>This data is not combined with other data sources.</p>\n\n<p>The basis for data processing is Article 6 (1) lit. f) GDPR, which permits the processing of data for the purpose of performing a contract or for pre-contractual measures.</p>\n<h5>Contact form</h5><p>If you send us enquiries by contact form, your data from the enquiry form, including the contact details specified by you in it, will be stored by us for the purpose of processing the enquiry and for follow-up queries. We will not pass that data on without your consent.</p>\n\n<p>The data entered in the contact form is thus processed exclusively on the basis of your consent (Article 6 (1) lit. a) GDPR). You can withdraw that consent at any time. An informal notification sent to us by e-mail is sufficient for this. The legality of the data processing operations that occurred prior to such withdrawal is not affected by it.</p>\n\n<p>The data entered by you in the contact form remains with us until you request its erasure or withdraw your consent to the storage or if the purpose of the storage of the data no longer applies (e.g. after the completion of the processing of your enquiry). Mandatory provisions of law, particularly statutory retention periods, remain unaffected.</p>"])}
        }
      },
      "it-IT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informativa sulla privacy"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. La privacy a colpo d’occhio</h4><h5>Note generali</h5><p>Le presenti note forniscono una semplice panoramica sul trattamento dei dati personali in caso di visita al nostro sito web.\nSono dati personali tutti i dati che identificano la persona dell’utente. Per maggiori informazioni relative alla protezione dei dati, invitiamo a consultare la nostra informativa sulla privacy riportata in calce.</p>\n<h5>Rilevazione dei dati sul nostro sito web</h5><p>Chi è il titolare del trattamento dei dati sul sito?</p>\n<p>Il trattamento dei dati su questo sito web avviene a cura del gestore del sito stesso, i cui recapiti sono riportati nella sezione Note legali del sito.</p>\n<h5>In che modo raccogliamo i dati dell’utente?</h5><p>I dati vengono raccolti nel momento in cui l’utente ce li comunica. Si tratta ad esempio dei dati inseriti in un modulo di contatto.</p>\n\n<p>Altri dati vengono raccolti automaticamente dai nostri sistemi informatici nel contesto della visita al sito web. Si tratta in tale caso di dati tecnici (tra cui browser, sistema operativo oppure orario di visualizzazione pagina). La rilevazione di tali dati avviene in automatico non appena l’utente accede al sito.</p><h5>Come vengono utilizzati i dati?</h5><p>Una parte dei dati viene raccolta allo scopo di garantire il perfetto funzionamento del sito. Altri dati sono utilizzati allo scopo di analizzare il comportamento dell’utente.</p><h5>Quali sono i diritti dell’utente relativamente ai propri dati personali?</h5><p>L’utente ha il diritto di ottenere in qualsiasi momento informazioni a titolo gratuito sull’origine, i destinatari e lo scopo del trattamento dei dati personali salvati. L’utente ha inoltre il diritto di richiedere la rettifica, il blocco o l’eliminazione di tali dati. Per maggiori informazioni sul tema della protezione dei dati personali, è possibile contattare in qualsiasi momento l’indirizzo riportato nelle Note legali. L’utente ha inoltre il diritto di inoltrare reclamo presso l'autorità di controllo competente.</p><h4>2. Note generali e informazioni obbligatorie</h4><h5>Protezione dei dati</h5><p>Il gestore di queste pagine web ha molto a cuore i dati personali dell’utente. Trattiamo i dati personali dell’utente con la massima riservatezza e in conformità alle disposizioni di legge in materia di protezione dei dati nonché alla presente informativa sulla privacy.</p>\n\n<p>Nel momento in cui l’utente visita questo sito, vengono raccolti diversi suoi dati personali. La presente informativa sulla privacy illustra quali dati raccogliamo e a quali scopi.</p>\n\n<p>Segnaliamo che la trasmissione di dati via Internet (ad es. in caso di comunicazioni via e-mail) può presentare lacune nella sicurezza. Non è possibile garantire la protezione dei dati contro l'accesso da parte di terzi.</p><h5>Indicazione del titolare del trattamento</h5><p>Titolare del trattamento dei dati personali su questo sito è la società</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermania</p>\n\n<p>Telefono: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n\n<p>Titolare del trattamento è la persona fisica o giuridica che, singolarmente o congiuntamente a terzi, determini scopi e mezzi del trattamento dei dati personali (tra cui nomi, indirizzi e-mail, ecc.).</p><h5>Revoca del consenso al trattamento dei dati personali</h5><p>Molti dei processi di trattamento dei dati sono soggetti all’espresso consenso dell’utente. L’utente ha la facoltà di revocare il consenso prestato in qualsiasi momento. A tale scopo è sufficiente inviarne comunicazione via e-mail. Resta salva la liceità del trattamento dei dati avvenuto fino al momento della revoca.</p>\n<h5>Diritto di reclamo presso l'autorità di controllo competente</h5><p>In caso di violazione delle norme vigenti in materia di protezione dei dati personali, l’utente ha il diritto di inoltrare reclamo presso l'autorità di controllo competente. Autorità di controllo competente in materia di protezione dei dati è il Garante dello stato federale in cui ha sede la nostra azienda. L'elenco dei Garanti con i rispettivi recapiti è consultabile al seguente link:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Diritto alla portabilità dei dati</h5><p>L’utente ha il diritto di richiedere la consegna, in formato leggibile a macchina, per sé o per terzi dei dati da noi trattati in forma automatizzata in base al consenso prestato o ai fini dell’adempimento di un contratto. Qualora l’utente richieda la trasmissione diretta dei dati ad altro titolare del trattamento, ciò avverrà nella misura tecnicamente fattibile.</p><h5>Diritto di certificazione e informazione</h5><p>L’utente ha il diritto di ottenere in qualsiasi momento l’attestazione del trattamento dei suoi dati personali. Se il trattamento è confermato, l’utente ha il diritto di richiederci informazioni a titolo gratuito circa i propri dati personali salvati.</p><h5>Diritto di rettifica</h5><p>L’utente ha il diritto di richiedere la tempestiva rettifica di eventuali dati personali non corretti. Nel rispetto degli scopi del trattamento, l’utente ha il diritto di richiedere l’integrazione di eventuali dati personali incompleti.</p><h5>Diritto alla cancellazione (“diritto all’oblio”)</h5><p>Ai sensi dell'art. 17 del GDPR, l’utente ha il diritto di richiedere che i dati personali vengano immediatamente cancellati; la nostra azienda ha a sua volta l’obbligo di provvedervi tempestivamente a fronte di uno dei seguenti motivi:</p>\n<p><ol>\n<li>I dati personali dell’interessato non sono più necessari agli scopi per i quali sono stati raccolti o in qualsiasi modo elaborati.</li>\n<li>L’interessato revoca il proprio consenso al trattamento ai sensi dell’articolo 6 comma 1 lettera a o dell’articolo 9 comma 2 lettera a del GDPR, e non sussiste inoltre ulteriore fondamento giuridico per il trattamento.</li>\n<li>L’interessato si oppone al trattamento ai sensi dell’articolo 21 comma 1 del GDPR; inoltre non sussistono legittime ragioni prioritarie per il trattamento, o l’interessato si oppone al trattamento ai sensi dell’articolo 21 comma 2 del GDPR.</li>\n<li>I dati personali sono oggetto di trattamento illegale.</li>\n<li>La cancellazione dei dati personali è necessaria all'adempimento di un obbligo ai sensi del diritto dell'Unione o del diritto degli stami membri, cui il Responsabile è soggetto.</li>\n<li>I dati personali sono stati raccolti nel contesto dei servizi offerti dalla società di informazioni ai sensi dell’articolo 8 comma 1 del GDPR.</li>\n</ol></p><h5>Diritto alla limitazione del trattamento</h5><p>Ai sensi dell'articolo 18 del GDPR, l’utente ha il diritto di richiedere la limitazione del trattamento a fronte di uno dei seguenti presupposti:</p>\n<p><ol>\n<li>La correttezza dei dati personali viene contestata dall’interessato, e ciò per un periodo che consenta al Responsabile di verificare la correttezza dei dati personali;</li>\n<li>a fronte di un trattamento illegittimo e qualora l’interessato rifiuti la cancellazione dei dati, esigendo invece la limitazione del loro utilizzo;</li>\n<li>il Titolare del trattamento non necessita più dei dati personali allo scopo del trattamento, l’interessato invece necessita di tali dati al fine di far valere, esercitare o difendere diritti o rivendicazioni;</li>\n<li>l’interessato si è opposto al trattamento ai sensi dell’articolo 21 comma 1 del GDPR e non è ancora noto se prevalgano le legittime ragioni del Titolare del trattamento nei confronti dell’interessato.</li>\n</ol></p><h5>Crittografia SSL o TLS</h5><p>Per ragioni di sicurezza e allo scopo di proteggere la trasmissione di contenuti riservati, tra cui ordini o richieste d'offerta inviati al gestore del sito stesso, questo sito si avvale della crittografia SSL o TLS. Il collegamento criptato si riconosce nel momento in cui la barra di indirizzo del browser passa da “http://” a “https://” e compare il simbolo del lucchetto.</p>\n\n<p>Una volta attivata la crittografia SSL o TLS, i dati a noi trasmessi non potranno essere letti da terzi.</p><h4>3. Responsabile della privacy</h4><h5>Responsabile della privacy ai sensi di legge</h5><p>La nostra azienda ha designato quale Responsabile della privacy la signora</p>\n\t\n<p>Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nGermania</p>\n\n<p>Telefono: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Rilevazione dei dati sul nostro sito </h4><h5>Cookie</h5><p>Il sito utilizza in alcuni casi cosiddetti cookie. Detti cookie non danneggiano il computer dell’utente, non veicolano virus e consentono una più dinamica e sicura fruizione della nostra offerta. I cookie sono piccoli file di testo salvati dal browser sul dispositivo dell’utente.</p>\n\n<p>Gran parte di tali cookie sono i “cookie di sessione”, cancellati in automatico una volta che l’utente esce dal sito. Altri cookie restano memorizzati sul dispositivo fino a che l’utente non li elimina. I cookie ci consentono di riconoscere il browser dell’utente alla visita successiva.</p>\n\n<p>L’utente ha la possibilità di impostare il browser in modo da essere informato del salvataggio di determinati cookie, per decidere di volta in volta quali abilitare o escludere, nonché di attivare l'eliminazione automatica dei cookie alla chiusura del browser. Segnaliamo tuttavia che la disattivazione dei cookie potrebbe limitare le funzionalità del sito.</p>\n\n<p>I cookie necessari alle procedure elettroniche di comunicazione o alla messa a disposizione di determinate funzioni richieste dall’utente (tra cui il carrello acquisti) vengono memorizzati ai sensi dell’articolo 6 c. 1 lett. f del GDPR. È nel legittimo interesse del gestore del sito salvare i cookie necessari alla fornitura tecnicamente impeccabile e ottimizzata dei propri servizi. Gli eventuali altri cookie salvati (tra cui cookie di analisi della navigazione nel sito) vengono contemplati a parte nella presente informativa sulla privacy.</p><h5>File di log</h5><p>Il provider di questo sito raccoglie e salva in automatico nei cosiddetti file di log le informazioni che ci vengono trasmesse in automatico dal browser dell’utente. Si tratta delle seguenti informazioni:</p>\n<p><ul>\n<li>Tipo e versione di browser</li>\n<li>Sistema operativo utilizzato</li>\n<li>URL</li>\n<li>Nome dell’host del computer che accede</li>\n<li>Ora della richiesta al server</li>\n<li>Indirizzo IP</li>\n</ul></p>\n\n<p>Tali dati non vengono associati a quelli provenienti da altre fonti.</p>\n\n<p>Base giuridica del trattamento dei dati è l'articolo 6 c. 1 lett. f del GDPR, che contempla il trattamento dei dati ai fini degli adempimenti contrattuali o delle misure precontrattuali.</p><h5>Modulo di contatto</h5><p>Nel momento in cui l’utente ci invia una richiesta utilizzando il modulo di contatto, i dati contenuti nel modulo, inclusi i recapiti forniti, verranno da noi salvati allo scopo di evadere la richiesta e di eventuali comunicazioni successive. Da parte nostra non inoltriamo tali dati a terzi senza previo consenso dell’utente.</p>\n\n<p>Il trattamento dei dati indicati nel modulo di contatto avviene pertanto esclusivamente sulla base giuridica del consenso (articolo 6 c. 1 lett. a del GDPR). L’utente ha la facoltà di revocare il consenso prestato in qualsiasi momento. A tale scopo è sufficiente inviarcene comunicazione informale via e-mail. Resta salva la liceità del trattamento dei dati avvenuto fino al momento della revoca.</p>\n\n<p>I dati indicati dall’utente nel modulo di contatto saranno da noi conservati fino a che l’utente non ne richiederà l’eliminazione, revochi il consenso al salvataggio o venga meno lo scopo del salvataggio stesso (ad es. una volta evasa la richiesta inviata dall’utente). Restano salvi gli eventuali obblighi di legge, in particolare i periodi di conservazione dei dati.</p>"])}
        }
      },
      "fr-FR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politique de confidentialité"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. La protection des données en un coup d'œil</h4><h5>Remarques générales</h5><p>Les remarques suivantes fournissent un simple aperçu de ce que deviennent vos données à caractère personnel lorsque vous visitez notre site Web. Les données à caractère personnel sont toutes les données permettant de vous identifier personnellement. Vous trouverez des informations détaillées au sujet de la protection des données dans notre politique de confidentialité ci-après.</p><h5>La collecte de données sur notre site Web</h5><p>Qui est responsable de la collecte des données sur ce site ?</p>\n\n<p>Le propriétaire du site est responsable du traitement des données sur ce site. Ses coordonnées figurent dans les mentions légales.</p>\n\n<h5>Comment collectons-nous vos données ?</h5><p>D'une part, nous collectons les données que vous nous communiquez. Il peut s'agir de données que vous saisissez dans un formulaire de contact, par exemple.</p>\n\n<p>D'autres données sont collectées automatiquement via nos systèmes informatiques lorsque vous consultez le site Web. Il s'agit principalement de données techniques (par ex. le navigateur internet, le système d'exploitation ou l'heure de visite de la page). Ces données sont collectées automatiquement dès que vous visitez notre site Web.</p><h5>À quoi nous servent vos données ?</h5><p>Une partie des données que nous collectons est destinée à garantir le bon fonctionnement du site Web. D'autres données peuvent nous servir à analyser votre comportement d'utilisateur.</p><h5>Quels sont vos droits concernant vos données ?</h5><p>Vous avez le droit de recevoir gratuitement et à tout moment des informations sur l'origine, le destinataire et la finalité de vos données à caractère personnel stockées. Vous avez également le droit d'exiger la rectification, le blocage ou l'effacement de ces données. À cette fin, ainsi que pour toute autre question concernant la protection des données, vous pouvez nous contacter à tout moment à l'adresse indiquée dans les mentions légales. En outre, vous disposez d'un droit de recours auprès de l'autorité de contrôle compétente.</p><h4>2. Remarques générales et informations obligatoires</h4><h5>Protection des données</h5><p>Les propriétaires de ce site prennent très au sérieux la protection de vos données personnelles. Nous traitons vos données à caractère personnel de manière confidentielle et conformément aux dispositions légales en matière de protection des données, et à la présente politique de confidentialité.</p>\n\n<p>Nous collectons diverses données à caractère personnel dès lors que vous consultez ce site Web. Notre politique de confidentialité précise quelles données nous collectons et à quelles fins nous les utilisons.</p>\n\n<p>Nous tenons à souligner que la transmission de données sur Internet (par ex. les communications via e-mail) peut présenter des failles en matière de sécurité. Une protection complète des données contre tout accès par des tiers n'est pas possible. </p>\n<h5>Information concernant l'organisme responsable</h5><p>Le responsable du traitement des données sur ce site est:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAllemagne</p>\n\n<p>Téléphone: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu</p>\n\n<p>Le responsable est la personne physique ou morale qui, seule ou en collaboration avec d'autres, décide des finalités et des moyens du traitement des données à caractère personnel (par ex. les noms, adresses e-mail, etc.).</p><h5>Retrait de votre consentement au traitement des données</h5><p>De nombreuses opérations de traitement des données ne sont possibles qu'avec votre consentement explicite. Vous pouvez retirer à tout moment tout consentement déjà donné. Pour ce faire, une notification informelle par e-mail suffit. La légalité du traitement des données effectué jusqu'au moment du retrait n'est pas affectée par la révocation.</p><h5>Droit de recours auprès de l'autorité de contrôle compétente</h5><p>En cas de manquement à la législation sur la protection des données, la personne concernée dispose d'un droit de recours auprès de l'autorité de contrôle compétente. L'autorité de contrôle compétente en matière de droit de la protection des données est le délégué à la protection des données du Land dans lequel notre entreprise est basée. Une liste des délégués à la protection des données et de leurs coordonnées est disponible en cliquant sur le lien suivant:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Droit à la portabilité des données</h5><p>Vous avez le droit d'obtenir que les données que nous traitons automatiquement sur la base de votre consentement ou en exécution d'un contrat vous soient transmises ou soient transmises à un tiers dans un format couramment utilisé et lisible par machine. Si vous demandez la transmission directe des données à un autre responsable, celle-ci n'aura lieu que dans la mesure où cela est techniquement possible.</p><h5>Droit de confirmation et droit d'accès</h5><p>Vous avez le droit d'obtenir de notre part, à tout moment, la confirmation que nous traitons des données à caractère personnel vous concernant. Si tel est le cas, vous avez le droit de nous demander d'accéder gratuitement à vos données personnelles conservées.</p><h5>Droit de rectification</h5><p>Vous avez le droit de nous demander de rectifier sans délai toute\ndonnée à caractère personnel inexacte vous concernant. Compte tenu des finalités du traitement, vous avez le droit de demander que les données à caractère personnel incomplètes soient complétées.</p><h5>Droit à l'effacement (« droit à l'oubli »)</h5><p>Conformément à l'article 17 du règlement général sur la protection des données (RGPD), vous avez le droit d'exiger que nous effacions sans délai les données à caractère personnel vous concernant, et nous sommes tenus de supprimer sans délai les données à caractère personnel si l'une des raisons suivantes s'applique:</p>\n<p><ol>\n<li>Les données à caractère personnel ne sont plus nécessaires aux fins pour lesquelles elles ont été collectées ou autrement traitées.</li>\n<li> La personne concernée retire le consentement sur lequel le traitement était fondé en vertu de l'article 6, alinéa 1, point a) ou de l'article 9, alinéa 2, point a), et il n'existe aucune autre base juridique pour le traitement.</li>\n<li>La personne concernée s'oppose au traitement en vertu de l'article 21, alinéa 1, et il n'existe aucune raison impérieuse et légitime justifiant ce traitement, ou la personne concernée s'oppose au traitement en vertu de l'article 21, alinéa 2.</li>\n<li>Les données à caractère personnel ont été traitées illégalement.</li>\n<li>La suppression des données à caractère personnel est nécessaire afin de satisfaire à une obligation légale en vertu du droit de l'Union ou du droit des États membres à laquelle le responsable du traitement est soumis.</li>\n<li>Les données à caractère personnel ont été collectées en relation avec la prestation de services de la société de l'information, conformément à l'article 8, alinéa 1.</li>\n</ol></p>\n<h5>Droit à la limitation du traitement</h5><p>Conformément à l'article 18 RGPD, vous avez le droit d'exiger que nous limitions le traitement si l'une des conditions suivantes est remplie:</p>\n<p><ol>\n<li>L'exactitude des données à caractère personnel est contestée par la personne concernée, pendant une période qui permet au responsable du traitement de vérifier l'exactitude des données à caractère personnel.</li>\n<li>Le traitement est illégal et la personne concernée refuse la suppression de ses données à caractère personnel et demande à la place la limitation de l'utilisation des données à caractère personnel.</li>\n<li>Le responsable du traitement n'a plus besoin des données à caractère personnel aux fins du traitement, mais la personne concernée en a besoin pour exercer ou défendre ses droits.</li>\n<li>La personne concernée s'est opposée au traitement en vertu de l'article 21, alinéa 1, en attendant de déterminer si les raisons légitimes invoquées par le responsable du traitement l'emportent sur celles invoquées par la personne\nconcernée.</li>\n</ol></p>\n\n<h5>Cryptage SSL ou TLS</h5><p>Pour des raisons de sécurité et pour protéger la transmission de contenus confidentiels, tels que les commandes ou les demandes que vous nous envoyez en tant que propriétaires du site, ce site utilise le cryptage SSL ou TLS. Vous pouvez reconnaître une connexion cryptée au fait que la ligne d'adresse du navigateur passe de « http:// » à « https:// » et au symbole du cadenas dans le champ de votre navigateur.</p>\n\n<p>Si le cryptage SSL ou TLS est activé, les données que vous nous transmettez ne peuvent pas être lues par des tiers.</p>\n<h4>3. Délégué à la protection des données</h4><h5>Obligation légale de désigner un Délégué à la protection des données</h5><p>Nous avons désigné une déléguée à la protection des données au sein de notre entreprise.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAllemagne</p>\n\n<p>Téléphone: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. La collecte de données sur notre site Web</h4><h5>Cookies</h5><p>Les sites Internet utilisent des « cookies ». Les cookies n'endommagent pas votre ordinateur et ne contiennent pas de virus. Les cookies contribuent à rendre notre offre plus accessible, plus efficace et plus sûre. Les cookies sont de petits fichiers texte qui sont stockés sur votre ordinateur et enregistrés par votre navigateur.</p>\n\n<p>Les cookies que nous utilisons le plus souvent sont des « cookies de session ». Ils sont automatiquement supprimés à la fin de votre visite. Les autres cookies restent enregistrés sur votre terminal jusqu'à ce que vous les supprimiez. Ces cookies nous permettent de reconnaître votre navigateur la prochaine fois que vous consultez notre site.</p>\n\n<p>Vous pouvez configurer votre navigateur de manière à ce qu'il vous informe de la présence de cookies, qu’il autorise les cookies au cas par cas uniquement, qu'il refuse les cookies dans certains cas ou, de manière générale, qu'il active la suppression automatique des cookies lorsque vous fermez votre navigateur. Si vous désactivez les cookies, la fonctionnalité de ce site Web peut être limitée.</p>\n\n<p>Les cookies nécessaires à la communication électronique ou à la mise à disposition de certaines fonctionnalités dont vous avez besoin (par ex. la fonctionnalité « panier ») sont enregistrés sur la base de l'article 6, alinéa 1, point f) RGPD. Le propriétaire du site Web a un intérêt légitime à ce que des cookies soient stockés pour lui permettre de fournir ses services sans erreur et de manière optimale sur le plan technique. Dans la mesure où d'autres cookies (par exemple des cookies permettant d’analyser votre comportement de navigation) sont enregistrés, ceux-ci sont traités séparément dans la présente politique de confidentialité.</p><h5>Fichiers journaux du serveur</h5><p>Le fournisseur du site collecte et stocke automatiquement des informations dans ces fichiers journaux du serveur, que votre navigateur nous transmet automatiquement. Les données collectées sont les suivantes:</p>\n<p><ul>\n<li>Type et version du navigateur</li>\n<li>Système d'exploitation utilisé</li>\n<li>URL de référence</li>\n<li>Nom d'hôte de l'ordinateur connecté</li>\n<li>Heure de consultation du serveur</li>\n<li>Adresse IP</li>\n</ul></p>\n\n<p>Ces données ne peuvent pas être recoupées avec d'autres sources de données.</p>\n\n<p>La base du traitement des données est l'article 6, alinéa 1, point b) RGPD, qui autorise le traitement des données pour l'exécution d'un contrat ou de mesures précontractuelles.</p>\n<h5>Formulaire de contact</h5><p>Si vous nous envoyez des demandes de renseignement via le formulaire de contact, nous stockons les données que vous fournissez via ce formulaire, y compris vos coordonnées, afin de traiter votre demande et en cas de questions complémentaires. Nous ne transmettons pas ces données sans votre consentement.</p>\n\n<p>Le traitement des données saisies dans le formulaire de contact est donc exclusivement basé sur votre consentement (article 6, alinéa 1, point a) RGPD). Vous\npouvez révoquer ce consentement à tout moment. Une notification informelle par e-mail suffit. La légalité du traitement des données effectué jusqu'au moment du retrait n'est pas affectée par la révocation.</p>\n\n<p>Les données saisies via le formulaire de contact restent en notre possession jusqu'à ce que vous nous demandiez de les effacer, que vous révoquiez votre consentement au stockage ou que la finalité pour laquelle les données ont été stockées cesse de s'appliquer (par ex. après le traitement de votre demande). Les dispositions légales obligatoires, en particulier les périodes de conservation, restent inchangées.</p>\n"])}
        }
      },
      "es-ES": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Política de privacidad"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Resumen de la protección de datos</h4><h5>Aspectos generales</h5><p>La información siguiente le ofrece una visión general simplificada de lo que sucede con sus datos personales cuando visita nuestro sitio web. Los datos personales son aquellos con los que podemos identificarlo personalmente. Encontrará más información sobre la protección de datos en nuestra política de privacidad, expuesta a continuación de este texto.</p><h5>Recogida de datos en nuestro sitio web</h5><p>¿Quién es el responsable de la recogida de datos en este sitio web?</p>\n<p>El encargado del tratamiento de los datos en este sitio web es el operador del sitio, cuyos datos de contacto se pueden consultar en el aviso legal.</p><h5>¿Cómo recogemos sus datos?</h5><p>Por una parte, recogemos sus datos en caso de que nos los proporcione. Estos datos pueden ser, por ejemplo, aquellos que introduzca en un formulario de contacto.</p>\n\n<p>Nuestros sistemas informáticos registrarán otros datos automáticamente cuando visite nuestro sitio web. Estos son principalmente datos técnicos, como, por ejemplo, el navegador de internet, el sistema operativo y la hora de la consulta. El registro de estos datos se realiza de forma automática en cuanto entra en nuestro sitio web.</p><h5>¿Para qué usamos sus datos?</h5><p>Una parte de los datos se recoge para garantizar una facilitación sin errores del sitio web. Otros datos se utilizan para analizar su comportamiento de usuario.</p><h5>¿Qué derechos tiene respecto a sus datos?</h5><p>Tiene derecho a obtener, en todo momento y de forma gratuita, información sobre el origen, los destinatarios y la finalidad de sus datos personales guardados. Asimismo, tiene derecho a exigir que se rectifiquen, bloqueen y supriman estos datos. A este respecto y para otras cuestiones sobre protección de datos, puede ponerse en contacto con nosotros en cualquier momento mediante la dirección que figura en el aviso legal. Además, tiene derecho a presentar reclamaciones ante las autoridades de control competentes.</p><h4>2. Aspectos generales e información obligatoria</h4><h5>Protección de datos</h5><p>Como operadores de este sitio web, la protección de sus datos personales es muy importante para nosotros. Trataremos sus datos personales de forma confidencial y conforme a las disposiciones legales de protección de datos y a la presente política de privacidad.</p>\n\n<p>Si utiliza este sitio web, recogeremos varios datos personales. Esta política de privacidad explica qué datos recogemos y para qué fines los utilizamos.</p>\n\n<p>Le advertimos de que la transmisión de datos por internet (p. ej., por correo electrónico) puede presentar fallos de seguridad, por lo que no se pueden proteger los datos completamente frente al acceso de terceros.</p><h5>Nota sobre el responsable</h5><p>El responsable del tratamiento de datos en este sitio web es:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlemania</p>\n\n<p>Teléfono: +49 (0)631 5600 1600<br>\nCorreo electrónico: zentrale&#64;dutypay.eu</p>\n\n<p>El responsable es la persona física o jurídica que, sola o junto con otros, decide sobre la finalidad y los medios del tratamiento de los datos personales (p. ej., nombre, dirección de correo electrónico, etc.).</p><h5>Revocación del consentimiento para el tratamiento de los datos</h5><p>Muchos procesos de tratamiento de datos solo son posibles con su consentimiento explícito. Puede revocar su consentimiento en cualquier momento mediante un comunicado informal por correo electrónico. La legitimidad del tratamiento de datos hasta la revocación no se verá afectada.</p><h5>Derecho a presentar reclamaciones ante las autoridades de control competentes</h5><p>En casos de infracciones legales en materia de protección de datos, el interesado tiene derecho a presentar reclamaciones ante las autoridades de control competentes. La autoridad de control competente en cuestiones legales de protección de datos es el delegado de protección de datos del estado federado en el que nuestra empresa tiene su sede. En el enlace siguiente encontrará una lista de los delegados de protección de datos y sus datos de contacto (en alemán):</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Derecho a la portabilidad de los datos</h5><p>Tiene derecho a hacer que se le entreguen, a usted o a un tercero, los datos tratados de forma automatizada con base en su consentimiento o para ejecutar un contrato, en un formato de uso común y lectura mecánica. En caso de que solicite la transferencia directa de los datos a otro responsable, esto solo se llevará a cabo cuando sea técnicamente posible.</p><h5>Derecho de confirmación y acceso</h5><p>Tiene derecho a que le proporcionemos confirmación de si se están tratando o no datos personales que le conciernen. Si es el caso, tiene derecho a obtener información gratuita sobre los datos personales que tengamos guardados.</p><h5>Derecho de rectificación</h5><p>Tiene derecho a exigir que rectifiquemos sin dilación indebida los datos personales que sean inexactos. Teniendo en cuenta los fines del tratamiento, tiene derecho a pedir que se completen datos personales que sean incompletos.</p><h5>Derecho de supresión («derecho al olvido»)</h5><p>Conforme al artículo 17 del RGPD, tiene derecho a exigirnos que suprimamos inmediatamente los datos personales que le conciernan y nosotros nos comprometemos a suprimir dichos datos personales sin dilación indebida cuando concurra alguna de las circunstancias siguientes:</p>\n<p><ol>\n<li>los datos personales ya no sean necesarios en relación con los fines para los que fueron recogidos o tratados de otro modo;</li>\n<li>el interesado retire el consentimiento en el que se basa el tratamiento conforme al artículo 6, apartado 1, letra a), o el artículo 9, apartado 2, letra a) del RGPD, y este no se base en otro fundamento jurídico;</li>\n<li>el interesado se oponga al tratamiento con arreglo al artículo 21, apartado 1, y no prevalezcan otros motivos legítimos para el tratamiento, o bien el interesado se oponga al tratamiento con arreglo al artículo 21, apartado 2, del RGPD;</li>\n<li>los datos personales hayan sido tratados ilícitamente;</li>\n<li>los datos personales deban suprimirse para el cumplimiento de una obligación legal establecida en el Derecho de la Unión o de los Estados miembros que se aplique al responsable del tratamiento;</li>\n<li>los datos personales se hayan obtenido en relación con la oferta de servicios de la sociedad de la información mencionados en el artículo 8, apartado 1, del RGPD.</li>\n</ol></p><h5>Derecho a la limitación del tratamiento</h5><p>Según el artículo 18 del RGPD, tiene derecho a exigirnos la limitación del tratamiento de los datos cuando se cumpla alguna de las condiciones siguientes:</p>\n<p><ol>\n<li>el interesado impugne la exactitud de los datos personales durante un plazo que permita al responsable verificar dicha exactitud;</li>\n<li>el tratamiento sea ilícito y el interesado se oponga a la supresión de los datos personales y solicite en su lugar la limitación de su uso;</li>\n<li>el responsable ya no necesite los datos personales para los fines del tratamiento, pero el interesado los necesite para la formulación, el ejercicio o la defensa de reclamaciones; o</li>\n<li>el interesado se haya opuesto al tratamiento en virtud del artículo 21, apartado 1, del RGPD, mientras se verifica si los motivos legítimos del responsable prevalecen sobre los del interesado.</li>\n</ol></p><h5>Cifrado SSL o TLS</h5><p>Por motivos de seguridad y para proteger la transmisión de contenidos confidenciales, como pedidos o solicitudes que envíe a los operadores de la página, en este sitio web se utiliza un cifrado SSL o TLS. Se puede reconocer que la conexión está cifrada porque la dirección del navegador cambia de «http://» a «https://» y presenta el símbolo de un candado.</p>\n\n<p>En caso de que esté activado el cifrado SSL o TLS, los datos que nos transfiera no podrán ser leídos por terceros.</p><h4>3. Delegado de protección de datos</h4><h5>Delegado de protección de datos prescrito por la ley</h5><p>Hemos nombrado a una delegada de protección de datos en nuestra empresa.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAlemania</p>\n\n<p>Teléfono: +498941325320<br>\nCorreo electrónico: datenschutz&#64;heydata.eu</p><h4>4. Recogida de datos en nuestro sitio web</h4><h5>Cookies</h5><p>En algunas ocasiones, este sitio web utiliza las denominadas cookies. Estas no causan daños en el ordenador ni contienen virus, sino que sirven para hacer que nuestra oferta sea más fácil de usar, efectiva y segura. Las cookies son pequeños archivos de texto que se instalan en su ordenador y que su navegador guarda.</p>\n\n<p>La mayoría de las cookies que utilizamos son «cookies de sesión», que se borran automáticamente al finalizar su visita. Hay otras cookies que permanecen en su terminal hasta que las borre y que nos permiten reconocer su navegador en su próxima visita.</p>\n\n<p>Puede configurar su navegador para que se lo informe sobre la instalación de cookies y pueda decidir si las acepta individualmente o si las rechaza en determinados casos o en general, así como para que se borren automáticamente al cerrar el navegador. En caso de desactivar las cookies, la funcionalidad de este sitio web puede verse limitada.</p>\n\n<p>Las cookies necesarias para el proceso de comunicación electrónica o para facilitarle determinadas funciones que usted requiera (p. ej., la función del carrito de la compra) se guardarán de conformidad con el artículo 6, apartado 1, letra f), del RGPD. El operador del sitio web tiene un interés legítimo en guardar cookies para ofrecer sus servicios de forma óptima y sin fallos técnicos. Si se guardan otras cookies (p. ej., cookies para analizar su comportamiento de navegación), estas se tratarán en esta política de privacidad por separado.</p><h5>Archivos de registro del servidor</h5><p>El proveedor de los sitios web recoge y almacena información automáticamente en archivos de registro del servidor, que su navegador nos transfiere de forma automática. Esta información es la siguiente:</p>\n<p><ul>\n<li>Tipo y versión del navegador</li>\n<li>Sistema operativo utilizado</li>\n<li>URL referente</li>\n<li>Nombre de host del ordenador desde el que se accede</li>\n<li>Hora de la consulta del servidor</li>\n<li>Dirección IP</li>\n</ul></p>\n\n<p>Estos datos no se combinan con otras fuentes de datos.</p>\n\n<p>El fundamento del tratamiento de los datos es el artículo 6, apartado 1, letra f), del RGPD, conforme al cual el tratamiento de datos está permitido para ejecutar un contrato o medidas precontractuales.</p><h5>Formulario de contacto</h5><p>Si nos envía consultas a través del formulario de contacto, guardaremos los datos que introduzca en el formulario, incluidos los datos de contacto que indique, con el fin de tramitar su solicitud y, en caso de que sea necesario, formularle preguntas adicionales. No transferiremos estos datos sin su consentimiento.</p>\n\n<p>Por lo tanto, el tratamiento de los datos introducidos en el formulario de contacto se efectúa exclusivamente con base en su consentimiento (artículo 6, apartado 1, letra a), del RGPD). Puede revocar su consentimiento en cualquier momento mediante un comunicado informal por correo electrónico. La legitimidad de los procesos de tratamiento de datos hasta la revocación no se verá afectada.</p>\n\n<p>Guardaremos los datos que nos haya indicado en el formulario de contacto hasta que nos pida que los suprimamos, revoque su consentimiento para que los tengamos almacenados o la finalidad de su almacenamiento deje de existir (p. ej., una vez tramitada su solicitud). Las disposiciones legales obligatorias (en particular, los plazos de conservación) no se verán afectadas.</p>"])}
        }
      },
      "pl-PL": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oświadczenie o ochronie danych osobowych"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Ochrona danych osobowych w skrócie</h4><h5>Informacje ogólne</h5><p>Poniższe wskazówki mają za zadanie w prosty sposób przekazać informację, co dzieje się z Twoimi danymi osobowymi, gdy odwiedzasz naszą stronę internetową. Dane osobowe to wszystkie dane, przy pomocy których można Cię zidentyfikować jako osobę. Szczegółowe informacje dotyczące ochrony danych osobowych znajdziesz w naszym Oświadczeniu o ochronie danych osobowych, które zamieściliśmy poniżej tego tekstu.</p><h5>Gromadzenie danych osobowych na naszej stronie internetowej</h5><p>Kto odpowiada za gromadzenie danych osobowych na tej stronie internetowej?</p>\n\n<p>Za przetwarzanie danych osobowych na tej stronie internetowej odpowiada jej operator. Dane kontaktowe operatora można znaleźć w nocie prawnej tej strony internetowej.</p><h5>W jaki sposób gromadzimy Twoje dane osobowe?</h5><p>Twoje dane osobowe zbieramy m.in. w związku z tym, że nam je przekazujesz. Są to przykładowo dane podawane w formularzu kontaktowym.</p>\n\n<p>Inne dane są natomiast gromadzone automatycznie przez nasze systemy informatyczne wtedy, gdy odwiedzisz naszą stronę internetową. Są to przede wszystkim dane techniczne (np. informacje na temat przeglądarki internetowej, systemu operacyjnego lub godziny otwarcia strony). Gromadzenie tych danych następuje automatycznie po wejściu na naszą stronę internetową.</p><h5>Do jakich celów wykorzystujemy Twoje dane osobowe?</h5><p>Część danych osobowych jest gromadzona w celu umożliwienia bezawaryjnego funkcjonowania strony internetowej. Inne dane mogą być wykorzystywane do analizy Twojego zachowania jako użytkownika.</p><h5>Jakie przysługują Ci prawa w związku z ochroną swoich danych osobowych?</h5><p>W każdej chwili masz prawo do nieodpłatnego otrzymania informacji o źródle, odbiorcach i celu przechowywania swoich danych osobowych. Ponadto możesz zażądać sprostowania, zablokowania lub usunięcia tych danych. Jeśli chcesz tego dokonać lub masz jakieś pytania dotyczące ochrony danych osobowych, możesz w każdej chwili skontaktować się z nami pod adresem, który został podany w nocie prawnej. Masz również możliwość wniesienia skargi do właściwego organu nadzorczego.</p><h4>2. Informacje ogólne i informacje obowiązkowe</h4><h5>Ochrona danych osobowych</h5><p>Operatorzy tych stron bardzo poważnie podchodzą do ochrony Twoich danych personalnych. Z Twoimi danymi osobowymi obchodzimy się poufnie i zgodnie z ustawowymi przepisami o ochronie danych osobowych oraz niniejszym Oświadczeniem o ochronie danych osobowych.</p>\n\n<p>Podczas korzystania z tej strony internetowej gromadzone są różne dane osobowe. Niniejsze Oświadczenie o ochronie danych osobowych wyjaśnia, jakie dane zbieramy i do jakich celów je wykorzystujemy.</p>\n\n<p>Prosimy pamiętać, że przekazywanie danych w Internecie (np. w ramach komunikacji mailowej) może być narażone na luki bezpieczeństwa. Pełna ochrona danych przed dostępem osób trzecich nie jest możliwa. </p><h5>Informacje dotyczące administratora</h5><p>Administratorem danych na tej stronie internetowej jest: </p>\n\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNiemcy</p>\n\n<p>tel.: +49 (0)631 5600 1600<br>\ne-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Administratorem jest osoba fizyczna lub prawna, która samodzielnie lub wspólnie z innymi decyduje o celach i środkach przetwarzania danych osobowych (np. nazwiska, adresy e-mail itp.).</p><h5>Cofnięcie zgody na przetwarzanie danych</h5><p>Wiele operacji przetwarzania danych może zostać przeprowadzonych wyłącznie za Twoją wyraźną zgodą. W każdej chwili możesz cofnąć wcześniej udzieloną zgodę. W tym celu wystarczy przesłać do nas nieformalne powiadomienie o tym fakcie drogą mailową. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano przed jej wycofaniem.</p><h5>Prawo do wniesienia skargi do właściwego organu nadzorczego</h5><p>W przypadku naruszenia przepisów o ochronie danych osobowych osoba, której dane dotyczą, ma prawo wnieść skargę do właściwego organu nadzorczego. Właściwym organem nadzorczym w kwestiach prawnych związanych z ochroną danych osobowych jest inspektor ochrony danych właściwy dla kraju związkowego, w którym nasza firma ma swoją siedzibę. Listę inspektorów ochrony danych oraz ich dane kontaktowe znajdziesz pod tym linkiem:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Prawo do przenoszenia danych</h5><p>Masz prawo zażądać, by dane, które przetwarzamy w zautomatyzowany sposób na podstawie Twojej zgody lub w celu realizacji umowy, zostały dostarczone do Ciebie lub osoby trzeciej w powszechnie używanym formacie nadającym się do odczytu maszynowego. Jeśli zażądasz, by dane zostały przeniesione bezpośrednio do innego administratora, odbędzie się to tylko, pod warunkiem że jest wykonalne pod względem technicznym.</p><h5>Prawo do potwierdzenia przetwarzania oraz prawo dostępu do informacji</h5><p>W każdej chwili możesz zażądać od nas potwierdzenia, czy przetwarzamy Twoje dane osobowe. Jeśli ma to miejsce, możesz zażądać od nas nieodpłatnego dostępu do informacji o zapisanych danych dotyczących Twojej osoby.</p><h5>Prawo do sprostowania danych</h5><p>Masz prawo zażądać od nas niezwłocznego sprostowania nieprawidłowych danych dotyczących Twojej osoby. Uwzględniając cele przetwarzania, możesz zażądać uzupełnienia swoich niekompletnych danych osobowych.</p><h5>Prawo do usunięcia danych (prawo do „bycia zapomnianym”)</h5><p>Zgodnie z artykułem 17 RODO masz prawo zażądać od nas niezwłocznego usunięcia swoich danych osobowych, my natomiast mamy obowiązek niezwłocznie usunąć dane osobowe, jeśli zachodzi któraś z następujących okoliczności:</p>\n<p><ol>\n<li>Dane osobowe przestały być potrzebne do celów, w jakich zostały zebrane lub w inny sposób przetworzone.</li>\n<li>Osoba, której dane dotyczą, wycofa swoją zgodę, na podstawie której odbywało się przetwarzanie zgodnie z artykułem 6 ustęp 1 litera a lub artykułem 9 ustęp 2 litera a, i nie występuje żadna inna podstawa prawna przetwarzania.</li>\n<li>Osoba, której dane dotyczą, wyrazi sprzeciw wobec przetwarzania zgodnie z artykułem 21 ustęp 1 i nie występują żadne nadrzędne powody uzasadniające przetwarzanie, lub osoba, której dane dotyczą, wyrazi sprzeciw wobec przetwarzania zgodnie z artykułem 21 ustęp 2.</li>\n<li>Dane osobowe były przetwarzane niezgodnie z prawem.</li>\n<li>Usunięcie danych osobowych jest wymagane w związku z wypełnieniem obowiązku prawnego wynikającego z prawa unijnego lub prawa państw członkowskich, któremu podlega administrator.</li>\n<li>Dane osobowe zostały zebrane w ramach oferowanych usług społeczeństwa informacyjnego zgodnie z artykułem 8 ustęp 1.</li>\n</ol></p><h5>Prawo do ograniczenia przetwarzania danych</h5><p>Zgodnie z artykułem 18 RODO masz prawo zażądać od nas ograniczenia przetwarzania danych, jeśli zachodzi któraś z następujących okoliczności:</p>\n<p><ol>\n<li>osoba, której dane dotyczą, kwestionuje prawidłowość danych osobowych – na okres, który pozwoli administratorowi na sprawdzenie poprawności tych danych;</li>\n<li> przetwarzanie jest niezgodne z prawem, a osoba, której dane dotyczą, odmówi usunięcia danych osobowych i zamiast tego zażąda ograniczenia korzystania z danych osobowych;</li>\n<li>administrator nie potrzebuje już danych osobowych do celów przetwarzania, jednak są one niezbędne osobie, której dane dotyczą, do ustalenia, dochodzenia lub obrony roszczeń prawnych, lub</li>\n<li>osoba, której dane dotyczą, wyraziła sprzeciw wobec przetwarzania na podstawie artykułu 21 ustęp 1 – do czasu stwierdzenia, czy uzasadnione powody administratora są nadrzędne wobec powodu sprzeciwu osoby, której dane dotyczą.</li>\n</ol></p><h5>Szyfrowanie SSL lub TLS</h5><p>Ta strona korzysta z opcji szyfrowania SSL lub TLS ze względów bezpieczeństwa oraz w celu zapewnienia ochrony przekazywania treści poufnych, takich jak np. zamówienia lub zapytania, które przesyłasz do nas jako do operatora strony. Zaszyfrowane połączenie poznasz po tym, że w pasku adresu przeglądarki w miejscu „http://” pojawi się „https://” oraz ikonka kłódki w pasku przeglądarki.</p>\n\n<p>Jeśli szyfrowanie SSL lub TLS jest włączone, dane, które do nas przesyłasz, nie mogą zostać odczytane przez osoby trzecie.</p><h4>3. Inspektor ochrony danych</h4><h5>Inspektor ochrony danych wymagany przepisami prawa</h5><p>Powołaliśmy dla naszej firmy inspektora ochrony danych.</p>\n\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNiemcy</p>\n\n<p>tel.: +498941325320<br>\nemail: datenschutz&#64;heydata.eu</p><h4>4. Gromadzenie danych osobowych na naszej stronie internetowej</h4><h5>Pliki cookies</h5><p>Strony internetowe korzystają częściowo z tzw. plików cookies. Pliki cookies nie powodują żadnych uszkodzeń na Twoim komputerze ani nie zawierają wirusów. Pliki cookies służą do tego, by uczynić naszą ofertę bardziej przyjazną dla użytkownika, bardziej efektywną i bezpieczną. Cookies to małe pliki tekstowe, które są zapisywane na Twoim komputerze i przechowywane w Twojej przeglądarce.</p>\n\n<p>Większość stosowanych przez nas plików cookies to tzw. sesyjne pliki cookies. Pliki te są automatycznie usuwane po zakończeniu Twojej wizyty. Inne pliki cookies pozostają na Twoim urządzeniu końcowym do momentu, aż je usuniesz. Pliki te pozwalają nam na ponowne rozpoznanie Twojej przeglądarki podczas kolejnej wizyty.</p>\n\n<p>Możesz dokonać odpowiednich ustawień przeglądarki, tak aby otrzymywać informacje o stosowaniu plików cookies i decydować pojedynczo o ich zaakceptowaniu lub zablokować je w określonych przypadkach, lub na stałe, oraz aktywować funkcję automatycznego usuwania plików cookies po zamknięciu przeglądarki. Wyłączenie plików cookies może sprawić, że niektóre funkcje naszej strony internetowej nie będą dostępne.</p>\n\n<p>Pliki cookies, które są potrzebne do realizacji procesu komunikacji elektronicznej lub w celu dostarczenia określonych, oczekiwanych przez Ciebie funkcji (np. funkcja koszyka), są przechowywane zgodnie z artykułem 6 ust. 1 lit. f RODO. Operator strony internetowej ma uzasadniony interes w przechowywaniu plików cookies w celu poprawnego technicznie i zoptymalizowanego świadczenia swoich usług. Jeśli przechowywane są inne pliki cookies (np. pliki cookies przeznaczone do analizy Twojego zachowania podczas przeglądania zasobów witryny), zostaną one ujęte w niniejszym Oświadczeniu o ochronie danych osobowych odrębnie.</p><h5>Pliki dziennika serwera</h5><p>Dostawca stron automatycznie zbiera i przechowuje informacje w tak zwanych plikach dziennika serwera, które Twoja przeglądarka przesyła do nas automatycznie. Są to następujące informacje:</p>\n<p><ul>\n<li>typ i wersja przeglądarki</li>\n<li>używany system operacyjny</li>\n<li>URL strony odsyłającej</li>\n<li>nazwa hosta komputera uzyskującego dostęp</li>\n<li>godzina zapytania serwera</li>\n<li>adres IP</li>\n</ul></p>\n\n<p>Nie dochodzi do łączenia tych danych z innymi źródłami danych.</p>\n\n<p>Podstawę przetwarzania danych stanowi artykuł 6 ust. 1 lit. f RODO, który pozwala na przetwarzanie danych w celu realizacji umowy lub działań przedumownych.</p><h5>Formularz kontaktowy</h5><p>Jeśli przesyłasz do nas zapytania za pośrednictwem formularza kontaktowego, informacje zawarte w formularzu zapytania oraz przekazane w nim dane kontaktowe są u nas przechowywane w celu udzielenia odpowiedzi na zapytanie i na wypadek pytań dodatkowych. Danych tych nie przekazujemy bez Twojej zgody.</p>\n\n<p>Przetwarzanie danych podanych w formularzu kontaktowym odbywa się zatem wyłącznie na podstawie Twoje zgody (artykuł 6 ust. 1 lit. a RODO). W każdej chwili możesz cofnąć tę zgodę. W tym celu wystarczy wysłać do nas nieformalne powiadomienie o tym fakcie drogą mailową. Wycofanie zgody nie wpływa na zgodność z prawem operacji przetwarzania, których dokonano przed jej wycofaniem.</p>\n\n<p>Dane podane przez Ciebie w formularzu kontaktowym pozostaną u nas do momentu, aż zażądasz od nas ich usunięcia, wycofasz swoją zgodę na przechowywanie tych danych lub ustanie cel, w jakim dane te były przechowywane (np. po udzieleniu finalnej odpowiedzi na Twoje zapytanie). Obowiązujące przepisy ustawowe – w szczególności terminy przechowywania danych – pozostają bez zmian.</p>"])}
        }
      },
      "nl-NL": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privacyverklaring"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Gegevensbescherming in één oogopslag</h4><h5>Algemene informatie</h5><p>Het volgende biedt u een duidelijk overzicht van wat er met uw persoonsgegevens gebeurt als u onze website bezoekt. Persoonsgegevens zijn alle gegevens waarmee u persoonlijk kunt worden geïdentificeerd. Gedetailleerde informatie over gegevensbescherming vindt u in onze privacyverklaring die na deze tekst volgt.</p><h5>Gegevensverzameling op onze website</h5><p>Wie is verantwoordelijk voor het verzamelen van gegevens op deze website?</p>\n<p>De gegevensverwerking op deze website wordt uitgevoerd door de websitebeheerder. U vindt zijn contactgegevens in het colofon (impressum) van deze website.</p><h5>Hoe verzamelen wij uw gegevens?</h5><p>Enerzijds worden uw gegevens verzameld doordat u die aan ons verstrekt. Hierbij kan het bijvoorbeeld om gegevens gaan die u in een contactformulier invult.</p>\n\n<p>Andere gegevens worden bij uw bezoek aan de website automatisch door onze IT-systemen verzameld. Dit zijn voornamelijk technische gegevens (bijv. internetbrowser, besturingssysteem of tijdstip van paginatoegang). Deze gegevens worden automatisch verzameld zodra u onze website betreedt. </p><h5>Waarvoor gebruiken wij uw gegevens?</h5><p>Een deel van de gegevens wordt verzameld om ervoor te zorgen dat de website correct wordt aangeboden. Andere gegevens kunnen worden gebruikt om uw gebruikersgedrag te analyseren.</p>\n<h5>Welke rechten heeft u met betrekking tot uw gegevens?</h5><p>U heeft te allen tijde het recht om kosteloos informatie te verkrijgen over de herkomst, ontvanger en het doel van uw opgeslagen persoonsgegevens. U heeft ook het recht om te verzoeken dat deze gegevens worden gecorrigeerd, afgeschermd of verwijderd. Hiertoe en ook voor eventuele andere vragen over gegevensbescherming kunt u te allen tijde contact met ons opnemen op het in het colofon (impressum) vermelde adres. Bovendien heeft u het recht een klacht in te dienen bij de bevoegde toezichthoudende autoriteit.</p><h4>2. Algemene informatie en verplichte informatie</h4><h5>Gegevensbescherming</h5><p>De beheerders van deze pagina's nemen de bescherming van uw persoonsgegevens zeer serieus. Wij behandelen uw persoonsgegevens vertrouwelijk en in overeenstemming met de wettelijke bepalingen inzake gegevensbescherming en deze privacyverklaring.</p>\n\n<p>Wanneer u deze website gebruikt, worden verschillende persoonsgegevens verzameld. Deze privacyverklaring legt uit welke gegevens wij verzamelen en waarvoor we ze gebruiken.</p>\n\n<p>Wij wijzen erop dat de overdracht van gegevens op het internet (bijv. bij communicatie via e-mail) onderhevig kan zijn aan kwetsbaarheden in de beveiliging. Het is niet mogelijk om gegevens volledig te beschermen tegen toegang door derden.</p> \n<h5>Informatie over de verantwoordelijke instantie</h5><p>De verantwoordelijke voor de gegevensverwerking op deze website is:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nDuitsland</p>\n\n<p>Telefoon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>De verantwoordelijke instantie is de natuurlijke of rechtspersoon die alleen of samen met anderen beslist over de doeleinden van en middelen voor de verwerking van persoonsgegevens (bijv. namen, e-mailadressen, enz.).</p>\n<h5>Intrekking van uw toestemming voor gegevensverwerking</h5><p>Veel gegevensverwerkingen zijn alleen mogelijk met uw uitdrukkelijke toestemming. U kunt uw toestemming te allen tijde intrekken. Daartoe is een informeel bericht per e-mail naar ons voldoende. Het intrekken van de toestemming laat de rechtmatigheid van de verwerking op basis van de toestemming vóór de intrekking daarvan, onverlet.</p>\n<h5>Recht om klacht in te dienen bij de bevoegde toezichthoudende autoriteit</h5><p>In geval van inbreuken op de gegevensbescherming heeft de betrokkene het recht om een klacht in te dienen bij de bevoegde toezichthoudende autoriteit. De bevoegde toezichthoudende autoriteit voor kwesties op het gebied van gegevensbescherming is de functionaris voor gegevensbescherming van de Duitse deelstaat waarin onze onderneming is gevestigd. Een lijst met functionarissen voor gegevensbescherming en hun contactgegevens vindt u via de volgende link:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Recht op overdraagbaarheid van gegevens</h5><p>U heeft het recht om persoonsgegevens die wij op basis van uw toestemming of ter uitvoering van een overeenkomst automatisch hebben verwerkt, te verkrijgen of aan een derde over te dragen in een gestructureerde, gangbare en machineleesbare vorm. Indien u de rechtstreekse overdracht aan een andere verwerkingsverantwoordelijke wenst, gebeurt dit uitsluitend indien dit technisch mogelijk is.</p>\n<h5>Recht op bevestiging en mededeling</h5><p>U heeft te allen tijde het recht om van ons een bevestiging te ontvangen of u betreffende persoonsgegevens zijn verwerkt. Indien dit het geval is, heeft u het recht om gratis mededeling van ons te verkrijgen over de opgeslagen persoonsgegevens die u betreffen.</p><h5>Recht op rectificatie</h5><p>U heeft het recht om van ons onverwijld rectificatie van u betreffende onjuiste persoonsgegevens te verkrijgen. Met inachtneming van de doeleinden van de verwerking heeft u het recht vervollediging van onvolledige persoonsgegevens te verkrijgen.</p><h5>Recht op gegevenswissing („recht op vergetelheid”)</h5><p>U heeft overeenkomstig artikel 17 van de AVG het recht van ons te verkrijgen dat u betreffende persoonsgegevens onverwijld worden gewist, en wij zijn verplicht om persoonsgegevens onverwijld te wissen wanneer een van de volgende gevallen van toepassing is:</p>\n<p><ol>\n<li>De persoonsgegevens zijn niet langer nodig voor de doeleinden waarvoor zij zijn verzameld of anderszins verwerkt.</li>\n<li>De betrokkene trekt de toestemming waarop de verwerking overeenkomstig artikel 6, lid 1, punt a of artikel 9, lid 2, punt a berust, in, en er is geen andere rechtsgrond voor de\nverwerking.</li>\n<li>De betrokkene maakt overeenkomstig artikel 21, lid 1, bezwaar tegen de verwerking, en er zijn geen prevalerende dwingende gerechtvaardigde gronden voor de verwerking, of de betrokkene maakt bezwaar tegen de verwerking overeenkomstig artikel 21, lid 2.</li>\n<li>De persoonsgegevens zijn onrechtmatig verwerkt.</li>\n<li>De persoonsgegevens moeten worden gewist om te voldoen aan een in het Unierecht of het lidstatelijke recht neergelegde wettelijke verplichting die op de verwerkingsverantwoordelijke rust.</li>\n<li>De persoonsgegevens zijn verzameld in verband met een aanbod van diensten van de informatiemaatschappij als bedoeld in artikel 8, lid 1.</li>\n</ol></p>\n\n<h5>Recht op beperking van de verwerking</h5><p>U heeft overeenkomstig artikel 18 van de AVG het recht van ons de beperking van de verwerking te verkrijgen indien een van de volgende elementen van toepassing is:</p>\n<p><ol>\n<li>de juistheid van de persoonsgegevens wordt betwist door de betrokkene, gedurende een periode die de verwerkingsverantwoordelijke in staat stelt de juistheid van de persoonsgegevens te controleren;</li>\n<li>de verwerking is onrechtmatig en de betrokkene verzet zich tegen het wissen van de persoonsgegevens en verzoekt in de plaats daarvan om beperking van het gebruik ervan;</li>\n<li>de verwerkingsverantwoordelijke heeft de persoonsgegevens niet meer nodig voor de verwerkingsdoeleinden, maar de betrokkene heeft deze nodig voor de instelling, uitoefening of onderbouwing van een rechtsvordering;</li>\n<li>de betrokkene heeft overeenkomstig artikel 21, lid 1, bezwaar gemaakt tegen de verwerking, in afwachting van het antwoord op de vraag of de gerechtvaardigde gronden van de verwerkingsverantwoordelijke zwaarder wegen dan die van de betrokkene.</li>\n</ol></p><h5>SSL- of TLS-versleuteling</h5><p>Deze website gebruikt SSL- of TLS-versleuteling om veiligheidsredenen en om de overdracht van vertrouwelijke informatie te beschermen, zoals bestellingen of verzoeken die u aan ons als websitebeheerder stuurt. U herkent een versleutelde verbinding aan het feit dat de adresregel van de browser verandert van 'http://' in 'https://' en aan het slotsymbooltje in uw browserregel.</p>\n\n<p>Als SSL- of TLS-versleuteling is geactiveerd, kunnen de gegevens die u ons toestuurt niet door derden worden gelezen.</p><h4>3. Functionaris voor gegevensbescherming</h4><h5>Wettelijk voorgeschreven Functionaris voor gegevensbescherming</h5><p>Voor onze onderneming hebben wij een functionaris voor gegevensbescherming aangewezen.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nDuitsland</p>\n\n<p>Telefoon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Gegevensverzameling op onze website</h4><h5>Cookies</h5><p>Sommige internetpagina's maken gebruik van zogenaamde cookies. Cookies beschadigen uw computer niet en bevatten geen virussen. Cookies dienen om ons aanbod gebruiksvriendelijker, effectiever en veiliger te maken. Cookies zijn kleine tekstbestanden die door uw browser op uw computer worden opgeslagen.</p>\n\n<p>De meeste van de door ons gebruikte cookies zijn zogenaamde 'session-cookies'. Ze worden automatisch verwijderd aan het einde van uw bezoek. Andere cookies blijven op uw apparaat opgeslagen totdat u ze verwijdert. Deze cookies stellen ons in staat om uw browser te herkennen bij een volgend bezoek.</p>\n\n<p>U kunt uw browser zo instellen dat u op de hoogte wordt gesteld wanneer er cookies worden geplaatst en dat u alleen in individuele gevallen cookies toestaat, cookies accepteert voor specifieke gevallen of deze in het algemeen uitsluit en het automatisch verwijderen van cookies activeert wanneer de browser wordt gesloten. Als cookies worden gedeactiveerd, kan de functionaliteit van deze website beperkt zijn.</p>\n\n<p>Cookies, die noodzakelijk zijn voor de uitvoering van het elektronische communicatieproces of voor de levering van bepaalde door u gewenste functies (bijv. winkelwagenfunctie), worden opgeslagen op basis van artikel 6, lid 1, punt f van de AVG. De websitebeheerder heeft een gerechtvaardigd belang bij het opslaan van cookies voor de technisch foutloze en geoptimaliseerde levering van zijn diensten. Voor zover andere cookies (bijv. cookies voor de analyse van uw surfgedrag) worden opgeslagen, worden deze in deze privacyverklaring afzonderlijk behandeld.</p>\n\n<h5>Serverlogbestanden</h5><p>De aanbieder van de pagina's verzamelt en bewaart automatisch informatie in zogenaamde serverlogbestanden, die uw browser automatisch aan ons doorgeeft. Dit zijn:</p>\n\n<p><ul>\n<li>browsertype en browserversie</li>\n<li>gebruikt besturingssysteem</li>\n<li>verwijzende URL</li>\n<li>hostnaam van de toegangscomputer</li>\n<li>tijdstip van het serververzoek</li>\n<li>IP-adres</li>\n</ul></p>\n\n<p>Deze gegevens worden niet samengevoegd met andere gegevensbronnen.</p>\n\n<p>De basis voor de gegevensverwerking is artikel 6, lid 1, punt b van de AVG, dat de verwerking van gegevens voor de uitvoering van een overeenkomst of precontractuele maatregelen toelaat.</p>\n<h5>Contactformulier</h5><p>Als u ons vragen stuurt via het contactformulier, worden uw gegevens uit het aanvraagformulier, inclusief de daar door u verstrekte contactgegevens, door ons opgeslagen voor de verwerking van de aanvraag en in geval van vervolgvragen. Wij geven deze gegevens niet door zonder uw toestemming.</p>\n\n<p>De verwerking van de gegevens in het contactformulier gebeurt derhalve uitsluitend op basis van uw toestemming (artikel 6, lid 1, punt a van de AVG). U kunt uw toestemming te allen tijde intrekken. Daartoe is een informeel bericht per e-mail naar ons voldoende. Het intrekken van de toestemming laat de rechtmatigheid van de gegevensverwerkingen op basis van de toestemming vóór de intrekking daarvan, onverlet.</p>\n\n<p>De door u in het contactformulier verstrekte gegevens worden door ons bewaard, totdat u ons vraagt deze gegevens te wissen, uw toestemming voor de opslag intrekt of het doel van de gegevensopslag niet langer van toepassing is (bijv. nadat uw verzoek volledig is bewerkt). Verplichte wettelijke bepalingen - met name bewaartermijnen - blijven onaangetast.</p>\n"])}
        }
      },
      "bg-BG": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Декларация за поверителност"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Накратко за защитата на данните</h4><h5>Общи указания</h5><p>Указанията по-долу съдържат най-важната информация за това какво се случва с Вашите лични данни, когато посетите нашия уебсайт. Лични данни са всички данни, с които можете да бъдете идентифицирани като личност. Подробна информация по темата за защита на данните ще намерите в декларацията за поверителност под този текст.</p><h5>Събиране на данни на нашия уебсайт</h5><p>Кой носи отговорност за събирането на данни на този уебсайт?</p>\n\n<p>Данните на този уебсайт се обработват от оператора на сайта. Данните за контакт са посочени в раздела с правна информация (Импресум) на този уебсайт.</p>\n<h5>Как събираме Вашите данни?</h5><p>От една страна, събираме данните, които Вие ни предоставяте. Това може да са например данни, които въвеждате във формуляра за контакт.</p>\n\n<p>Други данни се записват автоматично от нашите ИТ системи, когато посетите уебсайта. Това са предимно технически данни (напр. уеб браузър, операционна система или час на посещение на страницата). Данните се събират автоматично, веднага щом влезете в нашия уебсайт. </p>\n<h5>За какво използваме Вашите данни?</h5><p>Част от данните се събират, за да се осигури правилно предоставяне на уебсайта. Друга част от данните се използват за анализ на Вашето потребителско поведение.</p>\n<h5>Какви права имате по отношение на Вашите данни?</h5><p>Имате право да получавате безвъзмездно информация за произхода, получателя и предназначението на записаните за Вас лични данни във всеки един момент. Освен това имате правото да поискате коригиране, блокиране или изтриване на тези данни. За тази цел, както и за други въпроси по темата за защита на данните, можете да се свържете с нас по всяко време на адреса, посочен в раздела с правна информация. Също така имате право на обжалване пред компетентния надзорен орган.</p><h4>2. Общи указания и задължителна информация</h4><h5>Защита на данните</h5><p>Операторите на тези сайтове подхождат много сериозно към защитата на Вашите лични данни. Третираме Вашите лични данни като поверителни в съответствие със законовите разпоредби за защита на данните, както и с тази декларация за поверителност.</p>\n\n<p>При използването на този уебсайт се събират различни лични данни. Настоящата декларация за поверителност съдържа информация за това, кои данни събираме и за каква цел ги използваме.</p>\n\n<p>Напомняме, че предаването на данни в интернет (напр. при комуникация по имейл) може да има пропуски в сигурността. Не е възможно данните да бъдат напълно защитени от достъп на трети страни. </p><h5>Указание за отговорния орган</h5><p>Отговорният орган за обработването на данните от този уебсайт е:</p>\n<p>DutyPay GmbH<br>\nУл. Пирмазенсер, 1<br>\n67655 Кайзерслаутерн<br>\nГермания</p>\n\n<p>Телефон: +49 (0)631 5600 1600<br>\nИмейл: zentrale&#64;dutypay.eu</p>\n\n<p>Отговорен орган е физическото или юридическото лице, което взема решения само или заедно с други хора относно целите и средствата за обработване на лични данни (напр. имена, имейл адреси и др.).</p><h5>Оттегляне на съгласие за обработка на данните</h5><p>Много операции по обработване на данни са възможни само с Вашето изрично съгласие. Можете да оттеглите даденото съгласие във всеки един момент. Достатъчно е да ни изпратите съобщение по имейл, написано в свободен текст. Законосъобразността на обработката на данни до датата на оттегляне на съгласието не се влияе от оттеглянето.</p><h5>Право на обжалване пред компетентния надзорен орган</h5><p>При нарушение на разпоредбите за защита на личните данни засегнатото лице има право да обжалва пред компетентния надзорен орган. Компетентен\nнадзорен орган по въпросите, свързани със защитата на данните, е служителят по защита на данните в провинцията, в която се намира седалището на нашата компания. Списък на служителите по защита на данни в провинциите, както и техните данни за контакт, ще намерите на\nследния линк:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Право на преносимост на данните</h5><p>Имате право да предоставите на себе си или на трето лице в стандартен машинно четим формат данните, които обработваме въз основа на Ваше съгласие или при изпълнение на договор. Ако изискате данните да бъдат директно прехвърлени на друг администратор, това се прави само при наличие на техническа възможност.</p><h5>Право на получаване на потвърждение и уведомление</h5><p>Имате право във всеки един момент да получите от нас потвърждение за това дали Вашите лични данни се обработват. Ако това е така, имате право да получите безплатно информация за съхраняваните за Вас лични данни.</p><h5>Право на коригиране</h5><p>Имате право да изискате от нас да коригираме незабавно сгрешените Ви лични данни. Като се имат предвид целите на обработването, имате право да поискате непълните лични данни да бъдат допълнени.</p><h5>Право на изтриване (Право „да бъдеш забравен“)</h5><p>Съгласно член 17 от ОРЗД имате правото да поискате незабавно да изтрием Вашите лични данни, а ние сме длъжни незабавно да изтрием личните данни, когато е приложимо едно от следните условия:</p>\n<p><ol>\n<li>Личните данни повече не са необходими за целите, за които са били събрани или обработвани по друг начин.</li>\n<li>Субектът на данните оттегля своето съгласие, на което се основава обработването на данните съгласно член 6, параграф 1, буква а) или член 9 параграф 2, буква а), и няма друго правно основание за обработването.</li>\n<li>Субектът на данните възразява срещу обработването съгласно съгласно член 21, параграф 1 и няма законни основания за обработването, които да имат преимущество, или субектът на данните възразява срещу обработването съгласно член 21, параграф 2.</li>\n<li>Личните данни са били обработвани незаконосъобразно.</li>\n<li>Личните данни трябва да бъдат изтрити с цел спазването на правно задължение по правото на Съюза или правото на държава членка, което се прилага спрямо администратора.</li>\n<li>Личните данни са били събрани във връзка с предлагането на услуги на информационното общество по член 8 параграф 1.</li>\n</ol></p>\n\n<h5>Право на ограничаване на обработвката</h5><p>Съгласно член 18 от ОРЗД имате право да изискате ограничаване на извършваната от нас обработка, ако е налице едно от следните условия:</p>\n<p><ol>\n<li>точността на личните данни се оспорва от субекта на данните за срок, който позволява на администратора да провери точността на личните данни;</li>\n<li>обработването е неправомерно, но субектът на данните не желае личните данни да бъдат изтрити, а изисква вместо това ограничаване на използването им;</li>\n<li>администраторът не се нуждае повече от личните данни за целите на обработката, но субектът на данните ги изисква за установяването, упражняването или защитата на правни претенции, или</li>\n<li>субектът на данните е възразил срещу обработката съгласно член 21, параграф 1 в очакване на проверка дали законните основания на администратора имат преимущество пред интересите на субекта на данните.</li>\n</ol></p><h5>SSL или TLS криптиране</h5><p>От съображения за сигурност и за да защити предаването на информация с поверително съдържание, като например поръчки или запитвания, изпратени до нас в качеството ни на администратор, този сайт използва SSL или TLS криптиране. Ще познаете криптираната връзка по това, че адресната лента на браузъра се променя от 'http://' на 'https://', както и по символа с катинарче върху адресната лента на браузъра.</p>\n\n<p>Ако SSL или TLS криптирането е активирано, данните, които изпращате до нас, не могат да бъдат прочетени от трети лица.</p><h4>3. Орган по защита на данните</h4><h5>Длъжностно лице по защита на данните</h5><p>За нашата компания сме назначили длъжностно лице по защита на данните.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Берлин<br>\nГермания</p>\n\n<p>Телефон: +498941325320<br>\nИмейл: datenschutz&#64;heydata.eu</p><h4>4. Събиране на данни на нашия уебсайт</h4><h5>Бисквитки</h5><p>Интернет страниците използват частично т.нар. бисквитки. Бисквитките не нанасят вреди на Вашия компютър и не съдържат вируси. Целта на бисквитките е да направят нашата услуга по-ефективна, сигурна и още по лесна за използване. Бисквитките са малки текстови файлове, които се съхраняват във Вашия компютър и които Вашият браузър записва.</p>\n\n<p>Повечето от използваните бисквитки са т.нар. „бисквитки за сесия“. Изтриват се автоматично, след като приключите посещението си. Други бисквитки остават във Вашето крайно устройство до момента на изтриването им. Тези бисквитки ни дават възможност да идентифицираме отново Вашия браузър при следващо посещение.</p>\n\n<p>Можете да настроите своя браузър така, че да бъдете информирани за поставянето на бисквитки и да ги разрешавате само в конкретен случай, да изключвате приемането на бисквитки в определени случаи или въобще, както да активирате автоматичното им изтриване при затваряне на браузъра. Деактивирането на бисквитки може да ограничи функционалността на този уеб сайт.</p>\n\n<p>Бисквитките, необходими за изпълнение на електронни комуникационни операции или за предоставяне на определени, желани от Вас функции (напр. Функция „количка“), се записват въз основа на член 6, параграф 1, буква. е от ОРЗД. Операторът на сайта има законен интерес от съхранението на бисквитки, за да предоставя услуги, които са технически изрядни и оптимизирани. Ако се записват други бисквитки (напр. бисквитки за анализ на Вашето поведение при сърфиране), те се третират отделно в тази декларация за поверителност.</p><h5>Регистри на сървъра</h5><p>Операторът на сайтовете събира и съхранява автоматично информация в така наречените регистри на сървъра, които Вашият браузър ни изпраща автоматично. Това са:</p>\n<p><ul>\n<li>Тип и версия на браузъра</li>\n<li>Използвана операционна система</li>\n<li>Препращащ URL</li>\n<li>Име на хост на достъпващия компютър</li>\n<li>Час на заявката за сървъра</li>\n<li>IP адрес</li>\n</ul></p>\n\n<p>Не се извършва комбиниране на тези данни с други източници на данни.</p>\n\n<p>Обработването на данни се базира на чл. 6, параграф 1, буква. е от ОРЗД, който разрешава обработването на данни с цел изпълнение на договор или на преддоговорни действия.</p>\n<h5>Формуляр за контакт</h5><p>Ако ни изпратите запитване от формуляра за контакт, ще запишем данните от формуляр, както и посочените там данни за контакт с цел обработване на запитването и ако впоследствие възникнат въпроси. Не предоставяме тези данни на други страни без Вашето съгласие.</p>\n\n<p>Така обработването на въведените във формуляра за контакт данни става само и единствено въз основа на Вашето съгласие (чл. 6, параграф 1, буква a от ОРЗД). Можете да оттеглите даденото съгласие във всеки един момент. Достатъчно е да изпратите съобщение по имейл, написано в свободен текст. Законосъобразността на обработката на данни до датата на оттегляне на съгласието не се повлиява от оттеглянето.</p>\n\n<p>Данните, които сте въвели във формуляра за контакт, остават при нас до момента, в който поискате да ги изтрием, оттеглите съгласието си те да бъдат съхранявани или ако целта за съхранението на тези данни отпадне (напр. след приключена обработка на Вашето запитване). Задължителните законови разпоредби, и по-специално сроковете за съхранение, остават без промяна.</p>"])}
        }
      },
      "bs-BA": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izjava o zaštiti podataka"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Kratak pregled informacija o zaštiti podataka</h4><h5>Opće informacije</h5><p>Sljedeće informacije pružaju jednostavan pregled onoga šta se događa s Vašim ličnim podacima kada posjetite našu internetsku stranicu. Lični podaci su svi podaci s kojima se možete lično identificirati. Opsežne informacije o temi zaštite podataka možete pronaći u našoj Izjavi o zaštiti podataka ispod ovog teksta.</p>\n<h5>Prikupljanje podataka na našoj internetskoj stranici</h5><p>Ko je odgovoran za prikupljanje podataka na ovoj internetskoj stranici?</p>\n\n<p>Obradu podataka na ovoj internetskoj stranici obavlja vlasnik internetske stranice. Podatke za kontakt vlasnika možete pronaći u odjeljku Impressum ove internetske stranice.</p>\n\n<h5>Kako prikupljamo Vaše podatke?</h5><p>Vaši podaci se s jedne strane prikupljaju tako što nam ih saopćite. To npr. mogu biti podaci koje unesete u obrazac za kontakt.</p>\n\n<p>Druge podatke automatski prikupljaju naši IT sistemi kada posjetite našu internetsku stranicu. To su uglavnom tehnički podaci (npr. internetski preglednik, operativni sistem ili vrijeme pregleda stranice). Prikupljanje ovih podataka se obavlja automatski čim uđete na našu internetsku stranicu. </p>\n<h5>Za šta koristimo Vaše podatke?</h5><p>Neki podaci se prikupljaju kako bi se osiguralo da internetska stranica bespijekorno funkcionira. Ostali podaci se mogu koristiti za analizu Vašeg ponašanja kao korisnika.</p>\n<h5>Koja su Vaša prava u vezi s Vašim podacima?</h5><p>Imate pravo da u svakom trenutku besplatno dobijete informacije o porijeklu, primaocu i namjeni Vaših pohranjenih ličnih podataka. Osim toga, imate pravo da zatražite ispravak, blokiranje ili brisanje tih podataka. Ako imate još pitanja o zaštiti podataka, uvijek nam se možete obratiti na adresu navedenu u odjeljku Impressum. Također imate pravo da podnesete žalbu nadležnom nadzornom tijelu.</p><h4>2. Opće napomene i obavezne informacije</h4><h5>Zaštita podataka</h5><p>Vlasnici ovih stranica vrlo ozbiljno shvataju zaštitu Vaših ličnih podataka. S Vašim ličnim podacima postupamo povjerljivo i u skladu sa zakonskim propisima o zaštiti podataka i ovom Izjavom o zaštiti podataka.</p>\n\n<p>Kada koristite ovu internetsku stranicu, prikupljaju se razni lični podaci. U ovoj Izjavi o zaštiti podataka objašnjavamo koje podatke prikupljamo i u koje svrhe ih koristimo.</p>\n\n<p>Napominjemo da prijenos podataka na Internetu (npr. kada komuniciramo putem e-pošte) može imati sigurnosne nedostatke. Potpuna zaštita podataka od pristupa trećih lica nije moguća.</p><h5>Informacije o odgovornom tijelu</h5><p>Odgovorno tijelo za obradu podataka na ovoj internetskoj stranici je:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNjemačka</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-pošta: zentrale&#64;dutypay.eu</p>\n\n<p>Odgovorno tijelo je fizička ili pravna osoba koja sama ili zajedno s drugima odlučuje o svrhama i načinima obrade ličnih podataka (npr. imena i prezimena, adrese e-pošte i sl.).</p><h5>Povlačenje Vašeg pristanka za obradu podataka</h5><p>Mnogi postupci obrade podataka su mogući samo uz Vaš izričit pristanak. Svoj pristanak možete povući u svakom trenutku. Dovoljno je da nam pošaljete neformalnu poruku putem e-pošte. Povlačenje pristanka neće uticati na zakonitost obrade podataka prije povlačenja.</p>\n\n<h5>Pravo na podnošenje žalbe nadležnom nadzornom tijelu</h5><p>U slučaju kršenja Zakona o zaštiti podataka, imate pravo da podnesete žalbu nadležnom nadzornom tijelu. Nadležno nadzorno tijelo za pitanja zaštite podataka je državni službenik za zaštitu podataka savezne države u kojoj je sjedište našeg preduzeća. Listu službenika za zaštitu podataka i njihove podatke za kontakt možete pronaći na sljedećem linku: </p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Pravo na prenosivost podataka</h5><p>Imate pravo da podatke koje automatski obrađujemo na osnovi Vašeg pristanka ili radi ispunjavanja ugovora primite Vi ili treća lica u uobičajeno upotrebljavanom i mašinski čitljivom formatu. Ako zatražite direktan prijenos podataka drugoj odgovornoj osobi, to će biti učinjeno samo ako je to tehnički izvedivo.</p><h5>Pravo na potvrdu i informacije</h5><p>Imate pravo u svakom trenutku od nas dobiti potvrdu o tome da li se obrađuju lični podaci koji se odnose na Vas. Ako je to slučaj, imate pravo od nas zahtijevati besplatne informacije o Vašim ličnim podacima koji su pohranjeni.</p><h5>Pravo na ispravak</h5><p>Imate pravo od nas zahtijevati da bez odgađanja ispravimo sve netačne lične podatke koji se odnose na Vas. Uzimajući u obzir svrhe obrade, imate pravo zatražiti dopunu nepotpunih ličnih podataka.</p><h5>Pravo na brisanje („pravo na zaborav“)</h5><p>U skladu s članom 17 GDPR-a, imate pravo od nas zahtijevati da lične podatke koji se odnose na Vas bez odgađanja izbrišemo, a lične podatke dužni smo bez odlaganja izbrisati ako se to odnosi na jedan od sljedećih razloga:</p>\n<p><ol>\n<li>Ako lični podaci više nisu potrebni u svrhe za koje su prikupljeni ili ako su obrađeni na neki drugi način.</li>\n<li>Ako povlačite svoj pristanak na kojem se zasnivala obrada u skladu s članom 6 stav 1. tačka (a) ili članom 9 stav 2. tačka (a) i ako ne postoji druga pravna osnova za obradu.</li>\n<li>Ako ulažete prigovor na obradu u skladu s članom 21 stav 1. i ako nema nužnih osnovanih razloga za obradu ili ako ulažete prigovor na obradu u skladu s članom 21 stav 2.</li>\n<li>Ako su lični podaci obrađeni nezakonito.</li>\n<li>Ako je brisanje ličnih podataka potrebno za ispunjavanje zakonske obaveze prema pravu Evropske unije ili zakonu država članica kojima podliježe odgovorna osoba.</li>\n<li>Ako su lični podaci prikupljeni u vezi s uslugama informacijskog društva koje se nude u skladu s članom 8 stav 1.</li></ol></p><h5>Pravo na ograničenje obrade</h5><p>Prema članu 18 GDPR-a, imate pravo od nas zahtijevati da ograničimo obradu ako je ispunjen jedan od sljedećih preduslova:</p>\n<p><ol>\n<li>Ako osporavate tačnost svojih ličnih podataka u periodu koji odgovornoj osobi omogućava da provjeri tačnost ličnih podataka;</li>\n<li>Ako je obrada nezakonita, a Vi odbijate izbrisati lične podatke i umjesto toga zahtijevate ograničenje upotrebe ličnih podataka;</li>\n<li>Ako odgovorna osoba više ne treba lične podatke u svrhe obrade, ali ih Vi trebate za dokazivanje prava, ostvarivanje ili odbranu pravnih zahtjeva, ili</li>\n<li>Ako ste uložili prigovor na obradu u skladu s članom 21 stav 1., a još nije utvrđeno jesu li opravdani razlozi odgovorne osobe iznad Vaših razloga.</li>\n</ol></p><h5>SSL ili TLS kriptografski protokol</h5><p>Ova stranica iz sigurnosnih razloga i radi zaštite prijenosa povjerljivog sadržaja, kao što su narudžbe ili upiti koje nam šaljete kao korisnik stranice, primjenjuje SSL ili TLS kriptografski protokol. Šifriranu vezu možete prepoznati po tome što se adresni redak preglednika mijenja iz 'http://' u 'https://' i po simbolu katanca u retku preglednika.</p>\n<p>Ako je SSL ili TLS kriptografski protokol aktiviran, podatke koje nam prosljeđujete ne mogu čitati treća lica.</p><h4>3. Službenik za zaštitu podataka</h4><h5>Zakonski službenik za zaštitu podataka</h5><p>Imenovali smo službenika za zaštitu podataka za naše preduzeće.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNjemačka</p>\n\n<p>Telefon: +498941325320<br>\nE-pošta: datenschutz&#64;heydata.eu</p><h4>4. Prikupljanje podataka na našoj internetskoj stranici</h4><h5>Kolačići</h5><p>Neke internetske stranice djelimično upotrebljavaju takozvane kolačiće. Kolačići ne štete Vašem računaru i ne sadrže viruse. Kolačići služe za to da našu ponudu učinimo jednostavnijom za korisnika, učinkovitijom i sigurnijom. Kolačići su male tekstualne datoteke koje se spremaju na Vaš računar i koje memoriše Vaš preglednik.</p>\n\n<p>Većina kolačića koje upotrebljavamo su takozvani “kolačići sesije“. Oni se automatski brišu nakon Vaše posjete. Ostali kolačići ostaju spremljeni na Vašem krajnjem uređaju dok ih ne izbrišete. Ovi kolačići nam omogućavaju prepoznavanje Vašeg preglednika prilikom sljedeće posjete.</p>\n\n<p>Preglednik možete podesiti tako da Vas obavijesti o postavljanju kolačića, da prihvatate kolačiće samo u pojedinačnom slučaju, da isključite prihvatanje kolačića za određene slučajeve ili općenito i da aktivirate automatsko brisanje kolačića nakon zatvaranja preglednika. Deaktivacijom kolačića može se ograničiti funkcionalnost ove internetske stranice.</p>\n\n<p>Kolačići koji su potrebni za provođenje elektronske komunikacije ili za pružanje određenih funkcija koje su Vam potrebne (npr. funkcija korpe za kupovinu) spremaju se na osnovi člana 6 stav 1. tačka (f) GDPR-a. Vlasnik internetske stranice ima opravdan interes za pohranu kolačića za tehnički besprijekorno i optimizirano pružanje svojih usluga. Ako se pohranjuju drugi kolačići (npr. kolačići za analizu Vašeg ponašanja na Internetu), obrađuju se zasebno u ovoj Izjavi o zaštiti podataka.</p><h5>Datoteke zapisnika servera</h5><p>Pružalac stranica automatski prikuplja i pohranjuje podatke u takozvane datoteke zapisnika servera koje nam automatski prenosi Vaš preglednik. To su:</p>\n\n<ul>\n<li>vrsta i verzija preglednika</li>\n<li>operativni sistem korisnika</li>\n<li>prethodno posjećena stranica s koje se pristupilo našoj internetskoj stranici</li>\n<li>naziv hosta računara koji pristupa</li>\n<li>vrijeme zahtjeva servera</li>\n<li>IP adresa</li>\n</ul>\n\n<p>Ti podaci se ne spremaju s drugim izvorima podataka.</p>\n\n<p>Osnova za obradu podataka je članak 6 stav 1. tačka (f) GDPR-a koji omogućavae obradu podataka radi izvršavanja ugovora ili predugovornih mjera.</p><h5>Obrazac za kontakt</h5><p>Ako nam pošaljete upite putem obrasca za kontakt, Vaše podatke iz obrasca za upit, uključujući i podatke za kontakt koje ste tamo naveli, ćemo pohraniti u svrhu obrade upita i za slučaj dodatnih pitanja. Ove podatke ne prosljeđujemo bez Vašeg pristanka.</p>\n\n<p>Obrada podataka unesenih u obrazac za kontakt se obavlja isključivo na osnovi Vašeg pristanka (član 6. stav 1. tačka (a) GDPR-a). Ovaj pristanak možete povući u svakom trenutku. Dovoljno je da nam pošaljete neformalnu poruku putem e-pošte. Povlačenje pristanka neće uticati na zakonitost postupaka obrade podataka prije povlačenja.</p>\n\n<p>Podaci koje unesete u obrazac za kontakt će ostati kod nas dok ne zatražite da ih izbrišemo, dok ne povučete svoj pristanak za pohranu podataka ili ako svrha pohrane podataka više ne postoji (npr. nakon obrade Vašeg zahtjeva). Obavezne zakonske odredbe – a posebno rokovi čuvanja – ostaju nepromijenjene.</p>"])}
        }
      },
      "zh-CN": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据保护声明"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. 数据保护一览</h4><h5>一般提示</h5><p>以下提示简要概述了，当您访问我们的网站时，将如何处理您的数据。个人相关数据是指可以用来识别您的个人身份的所有数据。有关数据保护主题的详细信息，请参阅本文下方列出的，我们的数据保护声明。</p>\n\n<h5>我们网站上的数据采集。</h5><p>由谁负责本网站的数据采集？</p>\n\n<p>本网站上的数据处理由网络运营商进行。您可以在本网站的版本说明中找到他们的联系方式。</p>\n\n<h5>我们如何采集您的数据？</h5><p>一种方式是，收集您告知我们的数据。例如，这可以是你在联系表格中输入的数据。</p>\n\n<p>当您访问我们的网站时，将由我们的 IT 系统自动收集其他数据。这其中主要是技术数据（例如，网页浏览器，操作系统或者浏览页面的时间）。只要就如我们的网站，便会自动采集这些数据。</p><h5>我们用您的数据来干什么？</h5><p>获得这些数据中的一部分，是为了确保网站的正常运行。而其他数据可用于分析您的用户行为。</p>\n<h5>您拥有哪些涉及您 数据的权利？</h5><p>您有权利随时获得您的已保存个人相关数据的来源、接收方和用途的相关信息。此外，您也有权利要求，更正、组织或删除这些数据。您对此以及对数据保护主题有任何其他疑问，可以随时通过版本说明中所指定的地址与我们联系。您也有权利向主管监督机构投诉。</p><h4>2. 般提示和强制性信息</h4><h5>数据保护</h5><p>本网站的运营商非常重视您的个人数据保护。我们将根据法定数据保护法规以及本数据保护声明，保密处理您的个人相关数据。</p>\n\n<p>当您使用本网站时，将收集多种个人相关数据。本数据保护声明阐述了，我们将收集那些数据并将其用于什么。</p>\n\n<p>我们必须在此指出，互联网上的数据传输（例如，通过电子邮件通信）可能存在安全漏洞。无法完全无漏洞地保护数据，以防止第三方访问。</p><h5>负责机构的相关提示</h5><p>负责本网站上数据处理的机构是：</p>\n<p>DutyPay GmbH<br>\n皮尔马森瑟海峡1<br>\n67655 凯撒斯劳滕<br>\n德国</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>负责机构是自然人或者法人，由他们独立或共同决定处理个人相关数据（例如，姓名、电子邮件地址等）的目的和方式。</p><h5>撤销您对数据处理的许可</h5><p>许多数据处理过程是必须要经过您的明确许可才可行的。您可以随时撤销您已授权的许可。对此，通过一封邮件，非正式地通知我们即可。撤销前已完成数据处理的合法性不受此类撤销影响。</p><h5>向主管监督部门提出投诉的权利</h5><p>在违反数据保护法规的情况下，相关人员有权利向主管监督部门提出投诉。数据保护法律问题的主管监督部门是我们公司所在联邦州的地区数据保护部门。在以下链接中可以获取数据保护部门的列表以及其联系方式数据：</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>数据可转移权</h5>您有权利，要求我们根据您的许可或按照合同规定自动处理的数据，以通用的机器可读格式转移给第三方。如果您要求将数据直接传输给其他负责方，则只能在技术上可行的情况下进行此类操作。<h5>确认和知情权</h5>您有权利随时从我方处确认是否正在处理您的个人相关数据。在这种情况下，您有权利要求我们提供有关您的已保存个人相关数据的免费答复服务。<h5>更正权</h5>您有权利要求我们立即更正与您相关的任何不正确的个人相关数据。考虑到处理目的，您有权利要求完善不完整的个人相关数据。<h5>删除权（“遗忘权”）</h5><p>根据通用数据保护条例第 17 条，您有权利要求我们立即删除您的个人相关数据，如果涉及以下原因之一，我们则有义务立即删除您的个人相关数据：</p>\n<p><ol>\n<li>个人相关数据对于获取或进行其他方式处理而言不再是必需的。</li>\n<li>相关人员撤销了由他授权的，依据第 6 条第 1 款 a 项或者第 9 条第 2 款 a 项进行数据处理的许可，和没有其他处理法律依据的许可。</li>\n<li>相关人员根据第 21 条第 1 款，反对处理，并且没有更高优先级的合法理由，或者相关人员根据第 21 条第 2 款反对处理。</li>\n<li>个人相关数据被非法处理。</li>\n<li>为履行联盟法规或责任方所遵守成员国法律规定的法律义务，则必须删除个人相关数据。</li>\n<li>所获取的个人相关数据必须与第 8 条第 1 款提供的信息社会服务有关。</li>\n</ol></p>\n\n<h5>限制处理权</h5><p>根据通用数据保护条例第 18 条，如果满足以下前提条件之一，您有权利要求我们限制处理：</p>\n<p><ol>\n<li>相关人员对个人相关数据的准确性提出质疑，使负责人有权检查个人数据的准确性。</li>\n<li>处理是非法的，相关人员拒绝删除个人相关数据，而是要求限制个人相关数据的使用：</li>\n<li>责任方出于处理目的不再需要地数据，但相关人员需要它们进行援引、行使或捍卫合法要求，或者</li>\n<li>相关人员根据第 21 条反对处理。第 1 款已提出，只要尚未确定责任方的理由是否超过相关人员的正当理由。</li>\n</ol></p>\n<h5>SSL 或者 TLS 加密</h5><p>出于安全原因，并为了保护私密内容的传输（例如，您发送给作为网站运营方的我们的订单或问题）本网站采用 SSL 或者 TLS 加密。您可以通过浏览器地址栏中，从“http://”变换为“https://”以及您的浏览器行中的锁定符号来对此进行辨别。</p>\n\n<p>如果已激活了 SLL 或者 TLS 加密，第三方将无法读取您传输给我们的数据。</p><h4>3. 数据保护官</h4><h5>法定数据保护官</h5><p>我们已为我们的公司任命了一名数据保护官。</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627柏林<br>\n德国</p>\n\n<p>电话: +498941325320<br>\n电子邮件: datenschutz&#64;heydata.eu</p><h4>4. 我们网站上的数据采集。</h4><h5>Cookie</h5><p>网站上局部使用所谓的 Cookie。Cookie 不会损坏您的计算机，也不含任何病毒。Cookie 用于使我们的网站服务更加用户友好、更高效和更安全。Cookie 是存储在您的计算机上并由浏览器保存的小型文本文件。</p>\n\n<p>我们使用的大部分 Cookie 时所谓的“Session-Cookie”。您的访问结束后，将自动删除它们。其他 Cookie 将一直保存在您的终端设备上，直到您将其删除。通过这些 Cookie，我们可以在您下次访问时再次识别您的浏览器。</p>\n\n<p>您可以设置您的浏览器，使其通知您有关 Cookie 的设置，并且仅在特定情况下接受或者在一般情况下不接受 Cookie，并在关闭浏览器时激活 Cookie 的自动删除。如果禁用 Cookie，本网站的功能可能会受到限制。</p>\n\n<p>将根据通用数据保护条例第 6 条第 1 款 f 项，存储执行电子通信过程或者提供某些您使用功能所需的 Cookie。网站运营方在 Cookie 存储方面具有合法权益，以便在技术上无错误且最优化地提供其服务。如果存储了其他 Cookie（例如，用于分析您\n上网行为的 Cookie），则在本数据保护声明中特殊处理它们。</p><h5>服务器日志文件</h5><p>网站供应商将自动收集信息并将其保存在所谓的服务器日志文件中，您的浏览器会将其自动发送给我们。这些信息包括：</p>\n<p><ul>\n<li>所用操作系统的</li>\n<li>浏览器类型和浏览器版本</li>\n<li>引用页 URL</li>\n<li>访问计算机的主机名称</li>\n<li>服务器请求时间</li>\n<li>IP 地址</li>\n</ul></p>\n\n<p>这些数据不与其他数据源合并。</p>\n\n<p>此类数据处理的基础是通用数据条例的第 6 条 1 款 f 项，允许处理数据以使其符合合同或合同前的措施。</p><h5>联系表格</h5><p>如果您通过联系表格向我们进行咨询，我们将保存请求表格中您的数据，包括您在其中提供的联系数据，以便我们处理请求和在后续问题中使用。未经您的许可，我们不会转交这些数据。</p>\n\n<p>仅在您许可的情况下，处理联系表格中所输入的数据（通用数据条例第 6 条 1 款 a 项）。您可以随时撤销此类许可。对此，通过一封邮件，非正式地通知我们即可。撤销前已完成数据处理过程的合法性不受此类撤销影响。</p>\n\n<p>您在联系表格中输入的数据将一直由我们保存，直到您要求我们将其删除，撤销存储许可或者数据存储目的不再适用（例如，在处理完您的请求之后）。强制性法律规定（特别是保存期限内）不受影响。</p>"])}
        }
      },
      "da-DK": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Databeskyttelseserklæring"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Databeskyttelse i korte træk</h4><h5>Generel information</h5><p>Nedenstående informationer giver et overskueligt overblik over, hvad der sker med dine personoplysninger, når du besøger vores hjemmeside. Personoplysninger er alle oplysninger, der kan bruges til at identificere dig personligt. Du kan se detaljerede informationer om emnet databeskyttelse i vores databeskyttelseserklæring, der findes under denne tekst.</p><h5>Dataindsamling på vores hjemmeside</h5><p>Hvem er ansvarlig for dataindsamlingen på denne hjemmeside?</p>\n<p>Databehandlingen på denne hjemmeside udføres af ejeren af hjemmesiden. Du kan se dennes kontaktoplysninger under Impressum på denne hjemmeside.</p>\n\n<h5>Hvordan indsamler vi dine data?</h5><p>Dine data indsamles blandt andet, når du giver os dem. Det kan f.eks. være data, som du indtaster i en kontaktformular.</p>\n<p>Andre data registreres automatisk af vores it-systemer, når du besøger hjemmesiden. Dette er hovedsageligt tekniske data (f.eks. internetbrowser, operativsystem eller tidspunktet for besøg på siden). Disse data indsamles automatisk, så snart du går ind på vores hjemmeside. </p><h5>Hvad bruger vi dine data til?</h5><p>Nogle af dataene indsamles for at sikre, at hjemmesiden fungerer fejlfrit. Andre data kan bruges til at analysere din brugeradfærd.</p>\n\n<h5>Hvilke rettigheder har du med hensyn til dine data?</h5><p>Du har til enhver tid ret til gratis at modtage information om, hvor dine lagrede personoplysninger stammer fra, hvem der modtager dem, og hvilket formål de tjener. Du har også ret til at kræve rettelse, blokering eller sletning af disse data. Du kan når som helst kontakte os herom på adressen anført under Impressum, samt hvis du har yderligere spørgsmål om databeskyttelse. Herudover har du ret til at indgive en klage til den kompetente tilsynsmyndighed.</p><h4>2. Generel information og obligatoriske informationer</h4><h5>Databeskyttelse</h5><p>Ejerne af disse sider tager beskyttelsen af dine personoplysninger meget alvorligt. Vi behandler dine personoplysninger fortroligt og i overensstemmelse med de lovbestemte databeskyttelsesregler og denne databeskyttelseserklæring.</p>\n<p>Når du bruger denne hjemmeside, indsamles der forskellige personoplysninger. Denne databeskyttelseserklæring forklarer, hvilke data vi indsamler, og hvad vi bruger dem til.</p>\n<p>Vi gør opmærksom på, at der kan være sikkerhedshuller ved datatransmission på internettet (f.eks. når man kommunikerer via e-mail). Det er ikke muligt at beskytte dataene fuldstændigt mod tredjeparts adgang. </p><h5>Information om ansvarligt organ</h5><p>Det ansvarlige organ for databehandling på denne hjemmeside er:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nTyskland</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Det ansvarlige organ er den fysiske eller juridiske person, der alene eller sammen med andre træffer beslutning om formål med og midler til behandling af personoplysninger (f.eks. navne, e-mailadresser o.l.).</p><h5>Tilbagekaldelse af dit samtykke til databehandling</h5><p>Mange databehandlingsoperationer er kun mulige med dit udtrykkelige samtykke. Du kan når som helst trække et allerede meddelt samtykke tilbage. En uformel e-mail til os herom er tilstrækkelig. Lovligheden af den databehandling, der er udført indtil tilbagekaldelsen, forbliver uberørt af tilbagekaldelsen.</p><h5>Ret til at klage til den kompetente tilsynsmyndighed</h5><p>I tilfælde af overtrædelse af databeskyttelsesloven har den registrerede person ret til at indgive en klage til den kompetente tilsynsmyndighed. Den kompetente tilsynsmyndighed i databeskyttelsesspørgsmål er datatilsynet ( 'Landesdatenschutzbeauftragte') i den delstat, hvor vores virksomhed har sit hovedkvarter. En liste over databeskyttelsesrådgivere og deres kontaktoplysninger findes via følgende link: </p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Ret til dataportabilitet</h5><p>Du har ret til at få udleveret data, som vi behandler automatisk på baggrund af dit samtykke eller i forbindelse med opfyldelse af en kontrakt, til dig selv eller til en tredjepart i et sædvanligt, maskinlæsbart format. Hvis du beder om, at dataene skal overføres direkte til en anden ansvarlig person, vil dette kun ske, hvis det er teknisk muligt.</p><h5>Ret til bekræftelse og information</h5><p>Du har til enhver tid ret til at modtage en bekræftelse fra os om, hvorvidt personoplysninger vedrørende dig behandles. Hvis dette er tilfældet, har du ret til at anmode om gratis information fra os om de personoplysninger, der er gemt om dig.</p><h5>Ret til berigtigelse</h5><p>Du har ret til straks at bede os om at rette forkerte personoplysninger vedrørende dig. Under hensyntagen til formålene med behandlingen har du ret til at få fuldstændiggjort ufuldstændige personoplysninger.</p><h5>Ret til sletning ('retten til at blive glemt')</h5><p>I henhold til artikel 17 i Persondataforordningen (GDPR) har du ret til at kræve af os, at personoplysninger vedrørende dig straks bliver slettet, og vi er forpligtet til straks at slette personoplysninger, hvis der er tale om en af følgende grunde:</p>\n<p><ol>\n<li>Personoplysningerne er ikke længere nødvendige til de formål, hvortil de blev indsamlet eller på anden måde behandlet.</li>\n<li>Den registrerede tilbagetrækker det samtykke, som behandlingen var baseret på i henhold til artikel 6, stk. 1, litra a) eller artikel 9, stk. 2, litra a), og der er intet andet juridisk grundlag for behandlingen.</li>\n<li>Den registrerede gør indsigelse mod behandlingen i henhold til artikel 21, stk. 1, og der foreligger ikke legitime grunde til behandlingen, som går forud for indsigelsen, eller den registrerede gør indsigelse mod behandlingen i medfør af artikel 21, stk. 2.</li>\n<li>Personoplysningerne er blevet behandlet ulovligt.</li>\n<li>Personoplysningerne skal slettes for at overholde en retlig forpligtelse i EU-lovgivningen eller medlemsstaternes nationale lovgivning, som den dataansvarlige er underlagt.</li>\n<li>Personoplysningerne er blevet indsamlet i forbindelse med udbud af informationssamfundstjenester som omhandlet i artikel 8, stk. 1.</li>\n</ol></p><h5>Ret til begrænsning af behandling</h5><p>I henhold til artikel 18 i GDPR har du ret til fra os at opnå begrænsning af behandling, hvis et af følgende forhold gør sig gældende:</p>\n<p><ol>\n<li>rigtigheden af personoplysningerne bestrides af den registrerede, i perioden indtil den dataansvarlige har haft mulighed for at fastslå, om personoplysningerne er korrekte;</li>\n<li>behandlingen er ulovlig, og den registrerede modsætter sig sletning af personoplysningerne og i stedet anmoder om, at anvendelse heraf begrænses;</li>\n<li>den dataansvarlige ikke længere har brug for personoplysningerne til behandlingen, men den registrerede har brug for dem for at kunne gøre retskrav gældende eller udøve eller forsvare retskrav, eller</li>\n<li>den registrerede har gjort indsigelse mod behandlingen i henhold til artikel 21, stk. 1, i perioden mens det kontrolleres, om den dataansvarliges legitime interesser går forud for den registreredes legitime interesser.</li>\n</ol></p>\n<h5>SSL- og TLS-kryptering</h5><p>Denne hjemmeside anvender SSL- og TLS-kryptering af sikkerhedsmæssige årsager og som beskyttelse ved overførsel af fortroligt indhold, som f.eks. bestillinger og forespørgsler, som du sender til os i vores egenskab af ejere af hjemmesiden. Du kan genkende en krypteret forbindelse ved, at adresselinjen i browseren skifter fra 'http://' til 'https://', og på hængelås-ikonet i browserlinjen.</p>\n\n<p>Når SSL- og TLS-kryptering er aktiveret, kan de data, som du overfører til os, ikke læses af tredjeparter.</p><h4>3. Databeskyttelsesrådgiver</h4><h5>Lovpligtig databeskyttelsesådgiver</h5><p>Vi har udpeget en databeskyttelsesrådgiver for vores virksomhed.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nTyskland</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Dataindsamling på vores hjemmeside</h4><h5>Cookies</h5><p>Internetsider bruger til dels såkaldte cookies. Cookies skader ikke din computer og indeholder ikke vira. Cookies tjener til at gøre vores tilbud mere brugervenligt, mere effektivt og mere sikkert. Cookies er små tekstfiler, der lagres på din computer og gemmes af din browser.</p>\n\n<p>De fleste af de cookies, vi bruger, er såkaldte 'session cookies'. De slettes automatisk efter dit besøg. Andre cookies forbliver gemt på din enhed, indtil du sletter dem. Disse cookies gør det muligt for os at genkende din browser, næste gang du besøger vores hjemmeside.</p>\n\n<p>Du kan indstille din browser således, at du bliver informeret om lagring af cookies og kun tillader cookies i enkeltstående tilfælde, udelukker accept af cookies i bestemte tilfælde eller generelt samt aktiverer automatisk sletning af cookies, når browseren lukkes. Hvis cookies deaktiveres, kan denne hjemmesides funktioner være begrænsede.</p>\n\n<p>Cookies, som er nødvendige til udførelse af den elektroniske kommunikationsproces eller til at stille bestemte funktioner, som du ønsker, til rådighed (f.eks. indkøbskurv-funktionen), gemmes på grundlag af artikel 6, stk. 1, litra f) i GDPR. Ejeren af hjemmesiden har en legitim interesse i at gemme cookies, så ejerens ydelser kan stilles teknisk fejlfrit og optimeret til rådighed. I det omfang der gemmes andre cookies (f.eks. cookies til analyse af din onlineadfærd), behandles disse separat i denne databeskyttelseserklæring.</p><h5>Serverlogfiler</h5><p>Udbyderen af siderne indsamler og gemmer automatisk oplysninger i såkaldte serverlogfiler, som din browser automatisk sender til os. Disse er:</p>\n<p><ul>\n<li>Browsertype og browserversion</li>\n<li>Anvendt operativsystem</li>\n<li>Henvisnings-URL</li>\n<li>Værtsnavn på den tilgående computer</li>\n<li>Klokkeslæt for serverforespørgslen</li>\n<li>IP-adresse</li>\n</ul></p>\n\n<p>Disse data kombineres ikke med andre datakilder.</p>\n\n<p>Grundlaget for databehandling er artikel 6, stk. 1, lit. f) i GDPR, som tillader behandling af data til opfyldelse af en kontrakt eller udførelse af foranstaltninger forud for en kontrakt.</p><h5>Kontaktformular</h5><p>Hvis du sender os forespørgsler ved hjælp af kontaktformularen, gemmer vi dine oplysninger fra forespørgselsformularen, herunder de kontaktoplysninger, du har angivet der, med henblik på behandling af forespørgslen og i tilfælde af opfølgningsspørgsmål. Vi videregiver ikke disse oplysninger uden dit samtykke.</p>\n\n<p>Behandlingen af de data, der er indtastet i kontaktformularen, finder således sted udelukkende på baggrund af dit samtykke (artikel 6, stk. 1, litra a) i GDPR). Du kan til enhver tid tilbagekalde dette samtykke. En uformel e-mail til os herom er tilstrækkelig. Lovligheden af de databehandlingsoperationer, der er udført indtil tilbagekaldelsen, forbliver uberørt af tilbagekaldelsen.</p>\n\n<p>De data, du har indtastet i kontaktformularen, forbliver hos os, indtil du beder os om at slette dem eller tilbagekalder dit samtykke til opbevaring, eller indtil formålet med datalagringen ikke længere eksisterer (f.eks. efter at din anmodning er behandlet). Obligatoriske lovbestemmelser – navnlig opbevaringsperioder – forbliver uberørt.</p>"])}
        }
      },
      "et-EE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Andmekaitse deklaratsioon"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Andmekaitse lühiülevaade</h4><h5>Üldised märkused</h5><p>Järgmine teave annab lihtsa ülevaate sellest, mis juhtub teie isikuandmetega, kui te meie veebisaiti külastate. Isikuandmed on kõik andmed, mille abil saab teie isikut tuvastada. Üksikasjalikku teavet andmekaitse kohta leiate meie andmekaitse deklaratsioonist, mis on toodud selle teksti all.</p><h5>Andmete kogumine meie veebisaidil</h5><p>Kes vastutab andmete kogumise eest\nsellel veebisaidil?</p>\n<p>Sellel veebisaidil töötleb andmeid veebisaidi operaator.\nVeebisaidi operaatori kontaktandmed leiate selle veebisaidi impressumist.</p>\n\n\n<h5>Kuidas me teie andmeid kogume?</h5><p>Osa andmetest kogutakse siis, kui te need meile ise esitate. Need võivad olla näiteks andmed, mille sisestate kontaktivormil.</p>\n<p>Muud andmed salvestavad meie IT-süsteemid automaatselt veebisaidi külastamise ajal. Need on peamiselt tehnilised andmed (nt veebilehitseja, operatsioonisüsteem või veebisaidi avamise aeg). Need andmed kogutakse automaatselt kohe, kui sisenete meie veebisaidile. </p><h5>Milleks me teie andmeid kasutame?</h5><p>Osa andmetest kogutakse selleks, et tagada veebisaidi tõrgeteta toimimine. Teisi andmeid saab kasutada teie kui veebisaidi kasutaja käitumise analüüsimiseks.</p>\n<h5>Millised on teie õigused seoses oma andmetega?</h5><p>Teil on õigus saada igal ajal tasuta teavet teie kohta salvestatud isikuandmete päritolu, vastuvõtja ja eesmärgi kohta. Samuti on teil õigus nõuda nende andmete parandamist, blokeerimist või kustutamist. Kui teil on andmekaitse kohta täiendavaid küsimusi, võite meiega igal ajal ühendust võtta impressumis toodud aadressil. Samuti on teil õigus esitada kaebus pädevale järelevalveasutusele.</p><h4>2. Üldised juhised ja kohustuslik teave</h4><h5>Andmekaitse</h5><p>Selle veebisaidi operaatorid võtavad teie isikuandmete kaitset väga tõsiselt. Töötleme teie isikuandmeid konfidentsiaalselt ja kooskõlas õigusaktides sätestatud andmekaitsestandardite ja käesoleva andmekaitsedeklaratsiooniga.</p>\n\n<p>Selle veebisaidi kasutamise ajal kogutakse mitmesuguseid isikuandmeid. Käesolev andmekaitsedeklaratsioon selgitab, milliseid andmeid me kogume ja milleks me neid kasutame.</p>\n\n<p>Juhime tähelepanu sellele, et andmete edastamisel interneti kaudu (nt e-posti teel) võib esineda turvaauke. Andmete täielik kaitse kolmandate isikute juurdepääsu eest ei ole võimalik. </p><h5>Märkus isikuandmete vastutava töötleja kohta</h5><p>Isikuandmete vastutava töötleja sellel veebisaidil on:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nSaksamaa</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-post: zentrale&#64;dutypay.eu</p>\n\n<p>Vastutav töötleja on füüsiline või juriidiline isik, kes üksi või koos teistega otsustab isikuandmete (nt nimed, e-posti aadressid jms) töötlemise eesmärkide ja vahendite üle.</p><h5>Andmetöötluseks antud nõusoleku tagasivõtmine</h5><p>Paljud andmetöötlustoimingud on võimalikud ainult teie sõnaselgel nõusolekul. Võite igal ajal oma nõusoleku tagasi võtta. Selleks piisab, kui teavitate meid e-posti teel. Nõusoleku tagasivõtmine ei mõjuta enne seda toimunud andmetöötluse õiguspärasust.</p>\n\n<h5>Kaebuse esitamise õigus vastutavale järelevalveasutusele</h5><p>Andmekaitseõiguse rikkumise korral on asjaomasel isikul õigus esitada kaebus pädevale järelevalveasutusele. Pädev järelevalveasutus andmekaitseküsimustes on selle riigi andmekaitsevolinik, kus asub meie ettevõte. Andmekaitsevolinike ja nende kontaktandmete loetelu leiate järgnevalt aadressilt:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Õigus andmete ülekandmisele</h5><p>Teil on õigus lasta edastada andmed, mida me töötleme automaatselt teie nõusoleku alusel või lepingu täitmiseks, teile või kolmandale isikule üldkasutatavas vormingus ning masinloetaval kujul. Kui taotlete andmete otsest edastamist teisele vastutavale töötlejale, tehakse seda ainult siis, kui see on tehniliselt võimalik.</p><h5>Õigus tutvuda oma andmetega</h5><p>Teil on igal ajal õigus saada meilt kinnitus selle kohta, kas teiega seotud isikuandmeid töödeldakse.&nbsp; Sellisel juhul on teil õigus nõuda meilt tasuta teavet enda kohta salvestatud isikuandmete kohta.</p><h5>Õigus andmete parandamisele</h5><p>Teil on õigus nõuda meilt viivitamatult teid puudutavate ebaõigete isikuandmete parandamist. Teil on õigus nõuda oma mittetäielike isikuandmete täiendamist, kui see on isikuandmete töötlemise eesmärki arvestades asjakohane.</p><h5>Õigus andmete kustutamisele („õigus olla unustatud“)</h5><p>Kooskõlas isikuandmete kaitse üldmääruse artikliga 17 on teil õigus nõuda teid puudutavate isikuandmete viivitamata kustutamist ja me oleme kohustatud teie isikuandmed viivitamatult kustutama, kui esineb üks järgmistest alustest.</p>\n<p><ol>\n<li>Isikuandmed pole enam vajalikud eesmärkidel, milleks neid koguti või muul viisil töödeldi.</li>\n<li>Andmesubjekt võtab tagasi töötlemise aluseks oleva nõusoleku kooskõlas artikli 6 lõike 1 punktiga a või artikli 9 lõike 2 punktiga a ja töötlemiseks puudub muu õiguslik alus.</li>\n<li>Andmesubjekt esitab töötlemisele vastuväiteid kooskõlas artikli 21 lõikega 1 ja töötlemiseks ei ole ülekaalukaid õiguslikke põhjuseid või andmesubjekt esitab töötlemisele vastuväiteid kooskõlas artikli 21 lõikega 2.</li>\n<li>Isikuandmeid töödeldi ebaseaduslikult.</li>\n<li>Isikuandmete kustutamine on vajalik liidu õigusest või vastutava isiku suhtes kehtivate liikmesriikide õigusest tuleneva juriidilise kohustuse täitmiseks.</li>\n<li>Isikuandmeid koguti seoses artikli 8 lõike 1 kohaselt pakutavate infoühiskonna teenustega.</li>\n</ol></p>\n<h5>Õigus andmete töötlemise piiramisele</h5><p>Teil on isikuandmete kaitse üldmääruse artikli 18 järgi õigus nõuda töötlemise piiramist, kui on täidetud üks järgmistest tingimustest:</p>\n<p><ol>\n<li>andmesubjekt vaidlustab isikuandmete õigsuse ajavahemiku jooksul, mis võimaldab vastutaval töötlejal kontrollida isikuandmete õigsust;</li>\n<li>töötlemine on ebaseaduslik ja andmesubjekt keeldub isikuandmete kustutamisest ja nõuab selle asemel isikuandmete kasutamise piiramist;</li>\n<li>vastutav töötleja ei vaja enam isikuandmeid töötlemise eesmärgil, kuid andmesubjekt vajab neid õiguslike nõuete esitamiseks, täitmiseks või kaitsmiseks või</li>\n<li>andmesubjekt on esitanud töötlemisele vastuväite kooskõlas artikli 21 lõikega 1 seni, kuni pole veel kindlaks tehtud, kas vastutava töötleja õigustatud huvid kaaluvad üles andmesubjekti põhjendused.</li>\n</ol></p>\n\n<h5>SSL- või TLS-krüptimine</h5><p>Turvalisuse huvides ja meile kui veebisaidi operaatorile konfidentsiaalse sisu edastamise, näiteks tellimuste või päringute kaitsmiseks, kasutab see veebisait SSL- või TLS-krüptimist. Krüptitud ühenduse tunneb ära selle järgi, et veebilehitseja aadressirida muutub aadressilt 'http://' aadressiks 'https://' ja aadressireale ilmub lukusümbol.</p>\n\n<p>Kui SSL- või TLS-krüptimine on aktiveeritud, ei saa kolmandad osapooled teie poolt meile edastatud andmeid lugeda.</p><h4>3. Andmekaitsevolinik</h4><h5>Õigusaktide järgselt nõutav andmekaitsevolinik</h5><p>Oleme määranud oma ettevõttele andmekaitsevoliniku.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nSaksamaa</p>\n\n<p>Telefon: +498941325320<br>\nE-post: datenschutz&#64;heydata.eu</p><h4>4. Andmete kogumine meie veebisaidil</h4><h5>Küpsised</h5><p>Veebisaidid kasutavad osaliselt niinimetatud küpsiseid. Küpsised ei kahjusta teie arvutit ega sisalda viirusi. Küpsiste abil muudetakse meie pakkumine kasutajasõbralikumaks, tõhusamaks ja ohutumaks. Küpsised on väikesed tekstifailid, mis laaditakse teie arvutisse ja mille teie veebilehitseja salvestab.</p>\n\n<p>Enamik meie kasutatavatest küpsistest on niinimetatud seansiküpsised. Need kustutatakse pärast teie külastust automaatselt. Muud küpsised jäävad teie lõppseadmesse salvestatuks, kuni need kustutate. Need küpsised võimaldavad meil teie veebilehitseja järgmisel külastamisel ära tunda.</p>\n\n<p>Te võite oma veebilehitseja seadistada nii, et teid teavitataks küpsiste salvestamisest ja te lubate küpsiseid ainult üksikjuhtudel, välistate küpsiste lubamise teatud juhtudel või üldiselt ning aktiveerite veebilehitseja sulgemisel küpsiste automaatse kustutamise. Küpsiste inaktiveerimine võib selle veebisaidi funktsionaalsust piirata.</p>\n\n<p>Elektroonilise sideprotsessi toimimiseks või teie soovitud funktsioonide (nt ostukorvi funktsioon) kasutamiseks vajalikud küpsised salvestatakse isikuandmete kaitse üldmääruse artikli 6 lõike 1 punkti f alusel. Veebisaidi operaatoril on õigustatud huvi küpsiste salvestamiseks oma teenuste tehniliste tõrgeteta ja optimeeritud pakkumiseks. Kui salvestatakse muid küpsiseid (nt küpsiseid teie külastuskäitumise analüüsimiseks), käsitletakse neid selles andmekaitsedeklaratsioonis eraldi.</p><h5>Serveri logifailid</h5><p>Veebisaidi pakkuja kogub ja salvestab automaatselt teavet niinimetatud serveri logifailidesse, mille teie veebilehitseja edastab meile automaatselt. Need on:</p>\n<p><ul>\n<li>veebilehitseja tüüp ja versioon</li>\n<li>kasutatav operatsioonisüsteem</li>\n<li>suunav URL</li>\n<li>veebisaiti külastava arvuti hostinimi</li>\n<li>serveri päringu kellaaeg</li>\n<li>IP-aadress</li>\n</ul></p>\n\n<p>Neid andmeid ei kombineerita teiste andmeallikatega.</p>\n\n<p>Andmetöötluse aluseks on isikuandmete kaitse üldmääruse artikli 6 lõige 1 punkt f, mis võimaldab töödelda isikuandmeid lepingu täitmiseks või lepingueelsete meetmete jaoks.</p>\n\n<h5>Kontaktivorm</h5><p>Kui saadate meile päringuid kontaktivormi abil, salvestame teie päringuvormis olevad andmed, sealhulgas seal esitatud kontaktandmed päringu töötlemise eesmärgil\nja täiendavate küsimuste jaoks. Me ei edasta neid andmeid ilma teie nõusolekuta.</p>\n\n<p>Kontaktivormis sisestatud isikuandmete töötlemine toimub seega eranditult teie nõusoleku alusel (isikuandmete kaitse üldmääruse artikli 6 lõige 1). Võite selle nõusoleku igal ajal tagasi võtta. Selleks piisab, kui teavitate meid e-posti teel. Tühistamine ei mõjuta enne tühistamist läbi viidud andmetöötlustoimingute seaduslikkust.</p>\n\n<p>Teie poolt kontaktivormi sisestatud andmeid salvestame seni, kuni palute meil need kustutada, tühistate oma nõusoleku salvestamiseks või andmete säilitamise eesmärk enam ei kehti (nt pärast teie päringu töötlemist). See ei puuduta kohustuslikke õigusnorme, eelkõige andmete salvestamise tähtaegu.</p>\n"])}
        }
      },
      "fi-FI": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tietosuojaseloste"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Tietosuoja yhdellä silmäyksellä</h4><h5>Yleisiä ohjeita</h5><p>Seuraavissa ohjeissa on selostettu yksinkertaisella tavalla, mitä henkilötiedoillesi tapahtuu, kun vierailet verkkosivuillamme. Henkilötiedot ovat kaikki tietoja, joiden avulla sinut voidaan tunnistaa henkilökohtaisesti. Tarkempaa tietoa tietosuojasta saat tämän tekstin alta löytyvästä tietosuojaselosteesta.</p><h5>Tietojen kerääminen verkkosivuiltamme</h5><p>Kuka on vastuussa tietojen keräämisestä näiltä verkkosivuilta?</p>\n<p>Näillä verkkosivuilla tietojenkäsittely tapahtuu verkkosivujen tarjoajan toimesta.\nVerkkosivujen tarjoajan yhteystiedot löytyvät tämän verkkosivun julkaisutiedoista.</p><h5>Kuinka keräämme tietoja sinusta?</h5><p>Keräämme ensinnäkin itse antamiasi tietoja sinusta. Kyseessä voi olla esimerkiksi yhteydenottolomakkeessa ilmoittamasi tiedot.</p>\n\n<p>Kun vierailet verkkosivuillamme, tietotekniikka-järjestelmämme kerää automaattisesti sinusta muita tietoja. Nämä ovat ennen kaikkea teknisiä tietoja (kuten internet-selain, käyttöjärjestelmä tai kellonaika, jolloin kävit sivuillamme). Nämä tiedot kerätään automaattisesti heti, kun olette avannut sivustomme. </p><h5>Mihin tarkoitukseen käytämme tietojasi?</h5><p>Osa tiedoista kerätään, jotta voisimme taata verkkosivujemme virheettömän käytön onnistumisen. Muita tietoja voidaan käyttää käyttäjäkäyttäytymisesi analysoimiseen.</p>\n\n\n<h5>Mitä oikeuksia sinulla on tietojesi suhteen?</h5><p>Sinulla on aina oikeus saada ilmaiseksi tietoa itseesi liittyvien tallennettujen henkilötietojen alkuperästä, vastaanottajista ja tarkoitusperästä. Lisäksi sinulla on oikeus vaatia näiden tietojen oikaisua, niiden käytön estämistä tai näiden tietojen poistamista kokonaan. Jos sinulla on tähän liittyvää tai muuta kysyttävää, voit milloin tahansa ottaa yhteyttä meihin. Yhteystietomme löytyvät julkaisutiedoista. Lisäksi sinulla on oikeus tehdä valitus vastaavalle valvontaviranomaiselle.</p><h4>2. Yleisiä ohjeita ja pakolliset tiedot</h4><h5>Tietosuoja</h5><p>Näiden sivujen ylläpitäjä suhtautuu henkilötietojesi suojaamiseen vakavasti. Käsittelemme henkilötietojasi luottamuksellisesti ja tietosuojalainsäännöksiä sekä tätä tietosuojaselostetta noudattaen.</p>\n\n<p>Kun käyt tällä verkkosivulla, keräämme sinusta erilaisia henkilötietoja. Esillä olevasta tietosuojaselosteessa on selvitetty, mitä tietoja keräämme ja mihin niitä käytämme.</p>\n\n<p>Haluaisimme muistuttaa vielä, että internetissä tapahtuvassa tietojensiirrossa (esim. jos kyseessä on viestittely sähköpostitse) voi olla turva-aukkoja. Tietoja ei voi suojata aukottomasti kolmannen osapuolen hyökkäykseltä.</p><h5>Tietoa rekisterinpitäjästä</h5><p>Näillä verkkosivuilla tapahtuvasta tietojenkäsittelystä on vastuussa:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nSaksa</p>\n\n<p>Puhelin: +49 (0)631 5600 1600<br>\nSähköposti: zentrale&#64;dutypay.eu</p>\n\n<p>Rekisterinpitäjä on luonnollinen henkilö tai oikeushenkilö, joka yksin tai yhdessä toisten kanssa määrittelee henkilötietojen (esim. nimen tai sähköpostiosoitteen) käsittelyn tarkoitukset ja keinot.</p><h5>Tietojenkäsittelyyn myöntämäsi suostumuksen peruuttaminen</h5><p>Monet tietojenkäsittelytapahtumat ovat mahdollisia vain nimenomaisella suostumuksellasi. Voit peruuttaa milloin vain jo myöntämäsi suostumuksen. Tähän riittää epävirallinen ilmoitus sähköpostitse. Tämä ei ei vaikuta ennen suostumuksen peruuttamista suoritetun käsittelyn lainmukaisuuteen.</p><h5>Oikeus tehdä valitus vastaavalle  valvontaviranomaiselle</h5><p>Jos tietosuojaasi on loukattu, sinulla on oikeus valittaa asiasta toimivaltaiselle valvontaviranomaiselle. Toimivaltainen tietosuojaan liittyvistä asioista vastaava valvontaviranomainen on Saksassa liittovaltion, jossa on päätoimipaikkamme on, tietosuojavaltuutettu. Seuraavasta linkistä löytyy luettelo tietosuojavastaavista yhteystietoineen:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Oikeus siirtää tiedot järjestelmästä toiseen</h5><p>Sinulla on oikeus vaatia tietoja, joita käsittelemme suostumuksesi perusteella tai sopimuksen pohjalta automaattisesti, itsellesi tai kolmannelle osapuolelle yleisesti käytetyssä, koneellisesti luettavassa muodossa. Mikäli vaadit tietojen suoraa toimittamista toiselle rekisterinpitäjälle, tämä tapahtuu vain, mikäli se on teknisesti mahdollista.</p><h5>Oikeus saada vahvistus ja ilmoitus</h5><p>Sinulla on oikeus saada meiltä milloin tahansa vahvistus siitä, käsitelläänkö sinua koskevia henkilötietoja. Jos näin on, sinulla on oikeus saada meiltä ilman korvausta ilmoitus siitä, mitä henkilötietojasi on tallennettu.</p><h5>Oikeus tietojen oikaisuun</h5><p>Sinulla on oikeus p vaatia, että rekisterinpitäjä oikaisee ilman aiheetonta viivytystä sinua koskevat epätarkat ja virheelliset henkilötiedot. Ottaen huomioon tarkoitukset, joihin tietoja käsiteltiin, sinulla on oikeus saada puutteelliset henkilötiedot täydennettyä.</p><h5>Oikeus tietojen poistamiseen (”oikeus tulla unohdetuksi”)</h5><p>Sinulla on yleisen tietosuoja-asetuksen 17 artiklan mukainenoikeus saada rekisterinpitäjä poistamaan sinua koskevat henkilötiedot ilman aiheetonta viivytystä, ja meillä on poistaa henkilötiedot ilman aiheetonta viivytystä, edellyttäen että jokin seuraavista perusteista täyttyy:</p>\n<p><ol>\n<li>Henkilötietoja ei enää tarvita niihin tarkoituksiin, joita varten ne kerättiin tai joita varten niitä muutoin käsiteltiin.</li>\n<li>Rekisteröity peruuttaa suostumuksen, johon käsittely on perustunut 6 artiklan  1 kohdan a alakohdan tai i 9 artiklan 2 kohdan a alakohdan mukaisesti, eikä käsittelyyn ole muuta laillista perustetta mukaisesti.</li>\n<li>Rekisteröity vastustaa käsittelyä 21 artiklan 1 kohdan nojalla eikä käsittelyyn ole olemassa perusteltua syytä tai rekisteröity vastustaa käsittelyä 21 artiklan 2 kohdan nojalla.</li>\n<li>Henkilötietoja on käsitelty lainvastaisesti.</li>\n<li>Henkilötiedot on poistettava unionin oikeuteen tai jäsenvaltion lainsäädäntöön perustuvan rekisterinpitäjään sovellettavan lakisääteisen velvoitteen noudattamiseksi.</li>\n<li>Henkilötiedot on kerätty 8 artiklan 1 kohdassa tarkoitetun tietoyhteiskunnan palvelujen tarjoamisen yhteydessä.</li>\n</ol></p>\n<h5>Oikeus käsittelyn rajoittamiseen</h5><p>Sinulla on tietosuoja-asetuksen 18 artiklan mukainen oikeus siihen, että rajoitamme käsittelyä, jos kyseessä on yksi seuraavista:</p>\n<p><ol>\n<li>rekisteröity kiistää henkilötietojen paikkansapitävyyden, jolloin käsittelyä rajoitetaan ajaksi, jonka kuluessa rekisterinpitäjä voi varmistaa niiden paikkansapitävyyden,</li>\n<li>käsittely on lainvastaista ja rekisteröity vastustaa henkilötietojen poistamista ja vaatii sen sijaan niiden käytön rajoittamista,</li>\n<li>rekisterinpitäjä ei enää tarvitse kyseisiä henkilötietoja käsittelyn tarkoituksiin, mutta rekisteröity tarvitsee niitä oikeudellisen vaateen laatimiseksi, esittämiseksi tai puolustamiseksi, tai</li>\n<li>rekisteröity on vastustanut henkilötietojen käsittelyä 21 artiklan 1 kohdan nojalla odotettaessa sen todentamista, syrjäyttävätkö rekisterinpitäjän oikeutetut perusteet rekisteröidyn perusteet.</li>\n</ol></p><h5>SSL- tai TLS-koodaus</h5><p>Tämä sivu käyttää turvallisuussyistä ja luottamuksellisten sisältöjen kuten tilausten tai kyselyiden, jotka olet lähettänyt meille sivujen tarjoajana, siirron suojaamiseksi SSL- tai TLS-koodausta. Koodatun yhteyden tunnistaa siitä, että selaimen osoiterivi on vaihtunut 'http://' stä 'https://' hen ja että selainrivillä näkyy lukkosymboli.</p>\n<p>Kun SSL- tai TLS-koodaus on aktiivinen, kolmas osapuoli ei pysty lukemaan meille lähettämiäsi tietoja.</p><h4>3. Tietosuojavastaava</h4><h5>Lakisääteinen Tietosuojavastaava</h5><p>Olemme nimittäneet yritykseemme tietosuojavastaavan.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nSaksa</p>\n\n<p>Puhelin: +498941325320<br>\nSähköposti: datenschutz&#64;heydata.eu</p><h4>4. Tietojen kerääminen verkkosivuiltamme</h4><h5>Evästeet</h5><p>Internet-sivujen joissain osissa käytetään niin sanottuja evästeitä. Evästeet eivät aiheuta haittaa tietokoneellesi, eikä niissä ole viruksia Evästeiden tehtävänä on tehdä tarjouksistamme käyttäjäystävällisimpiä, tehokkaampia ja turvallisempia. Evästeet ovat pieniä tekstitiedostoja, jotka siirretään tietokoneellesi ja jotka selaimesi tallentaa.</p>\n\n<p>Suurin osa käyttämistämme evästeistä on niin sanottuja istuntoevästeitä. Ne poistetaan automaattisesti verkkosivuvierailusi jälkeen. Muut evästeet jäävät tallennetuiksi loppulaitteellesi, kunnes poistat ne itse. Nämä evästeet mahdollistavat meille sen, että pystymme tunnistamaan selaimesi seuraavan verkkovierailusi yhteydessä.</p>\n\n<p>Voit asettaa selaimesi asetukset siten, että saat tietoa evästeiden asettamisesta ja että sallit evästeet vain yksittäistapauksessa, estät evästeiden käytön tietyissä tapauksissa tai yleisesti sekä aktivoit evästeiden automaattisen poiston selaimen sulkemisen yhteydessä. Evästeiden toiminnan estäminen voi rajoittaa näiden verkkosivujen käyttöä.</p>\n\n<p>Evästeet, joita tarvitaan sähköiseen tiedonsiirtoon tai tiettyjen toivomiesi toimintojen (esim. ostoskoritoiminnon) käyttämiseksi, tallennetaan tietosuoja-asetuksen6 artiklan 1 kohdan f alakohdan mukaisesti. Verkkosivujen tarjoajalla on oikeutettu etu tallentaa evästeet, jotta se pystyisi tarjoamaan teknisesti virheettömän ja optimoidun verkkopalvelun. Mikäli evästeet (esim. selailukäytöstäsi analysoivat evästeet) tallennetaan, ne käsitellään erikseen tässä tietosuojaselosteessa.</p>\n<h5>Palvelimen lokitiedot</h5><p>Sivujen tarjoaja kerää ja tallentaa automaattisesti tietoa niin sanotuista palvelimen lokitiedoista, jotka palvelimesi lähettää meille automaattisesti. Näitä ovat:</p>\n<p><ul>\n<li>Palvelintyyppi ja palvelinversio</li>\n<li>Käytetty käyttöjärjestelmä</li>\n<li>Viittaajan URL-osoite</li>\n<li>Käyttävän tietokoneen isäntänimi</li>\n<li>Palvelinkyselyn kellonaika</li>\n<li>IP-osoite</li>\n</ul></p>\n\n<p>Näitä tietoja ei yhdistetä muihin tietolähteisiin.</p>\n\n<p>Tällaisen tietojenkäsittelyn perustana on tietosuoja-asetuksen 6 artiklan 1 kohdan b alakohta, jonka mukaan tietojenkäsittely on mahdollista sellaisen sopimuksen täytäntöön panemiseksi, jossa rekisteröity on osapuolena, tai sopimuksen tekemistä edeltävien toimenpiteiden toteuttamiseksi.</p><h5>Yhteydenottokaavake</h5><p>Jos lähetät meille kyselyjä yhteydenottokaavakkeella, tallennamme tietosi kyselykaavakkeelta ja siinä ilmoittamasi yhteystiedot kyselyn käsittelyä ja jatkokysymyksiä varten. Näitä tietoja emme luovuta eteenpäin ilman suostumustasi.</p>\n\n<p>Näin siis yhteydenottokaavakkeessa ilmoitettujen tietojenkäsittely tapahtuu ainoastaan myöntämääsi suostumuksen perusteella (tietosuoja-asetuksen 6 artiklan 1 kohdan a alakohta). Voit peruttaa suostumuksesi milloin vain. Tähän riittää epävirallinen ilmoitus sähköpostitse. Tämä ei vaikuta ennen suostumuksen peruuttamista suoritetun käsittelyn lainmukaisuuteen.</p>\n\n<p>Yhteydenottokaavakkeessa ilmoittamasi tiedot jäävät meille, kunnes pyydät meitä poistamaan ne, peruutat suostumuksesi tietojen tallennukseen tai\ntietojentallennuksen tarkoitus ei ole enää ajankohtainen (esim. kyselysi käsittely on päättynyt). Tämä ei koske pakollisia lakisääteisiä määräyksiä kuten säilytysaikoja.</p>\n\n"])}
        }
      },
      "el-GR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δήλωση προστασίας δεδομένων"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Προστασία δεδομένων με μια ματιά</h4><h5>Γενικές πληροφορίες</h5><p>Οι ακόλουθες πληροφορίες παρέχουν μια απλή επισκόπηση του τι συμβαίνει στα προσωπικά σας δεδομένα όταν επισκέπτεστε τον ιστότοπό μας.\nΤα προσωπικά δεδομένα είναι όλα τα δεδομένα με τα οποία μπορείτε να ταυτοποιηθείτε προσωπικά. Λεπτομερείς πληροφορίες σχετικά με το θέμα της προστασίας δεδομένων μπορείτε να βρείτε στη δήλωση προστασίας δεδομένων που αναφέρεται παρακάτω σε αυτό το κείμενο.</p>\n<h5>Συλλογή δεδομένων στον ιστότοπό μας</h5><p>Ποιος είναι υπεύθυνος για τη συλλογή δεδομένων σε αυτόν τον ιστότοπο;</p>\n<p>Η επεξεργασία δεδομένων σε αυτόν τον ιστότοπο πραγματοποιείται από τον χειριστή του ιστότοπου. Μπορείτε να βρείτε αυτά τα στοιχεία επικοινωνίας στα στοιχεία έκδοσης αυτού του ιστότοπου.</p><h5>Πώς συλλέγουμε τα δεδομένα σας;</h5><p>Τα δεδομένα σας συλλέγονται πρωτίστως όταν τα παρέχετε σε εμάς. Μπορεί να πρόκειται, π.χ. για δεδομένα που εισάγετε σε μια φόρμα επικοινωνίας.</p>\n\n<p>Άλλα δεδομένα καταγράφονται αυτόματα από τα συστήματα πληροφορικής μας όταν επισκέπτεστε τον ιστότοπο. Πρόκειται κυρίως για τεχνικά δεδομένα (π.χ. πρόγραμμα περιήγησης Διαδικτύου, λειτουργικό σύστημα ή ώρα επίσκεψης της σελίδας). Αυτά τα δεδομένα συλλέγονται αυτόματα μόλις μπείτε στον ιστότοπό μας.</p><h5>Για ποιον λόγο χρησιμοποιούμε τα δεδομένα σας;</h5><p>Ορισμένα από τα δεδομένα συλλέγονται προκειμένου να διασφαλιστεί ότι ο ιστότοπος δεν περιέχει σφάλματα. Άλλα δεδομένα μπορούν να χρησιμοποιηθούν για την ανάλυση της συμπεριφοράς σας ως χρήστη.</p><h5>Ποια δικαιώματα έχετε σχετικά με τα δεδομένα σας;</h5><p>Έχετε ανά πάσα στιγμή το δικαίωμα να λαμβάνετε δωρεάν πληροφορίες σχετικά με την προέλευση, τον παραλήπτη και τον σκοπό των αποθηκευμένων προσωπικών σας δεδομένων. Έχετε επίσης το δικαίωμα να ζητήσετε τη διόρθωση, τον αποκλεισμό ή τη διαγραφή αυτών των δεδομένων. Μπορείτε να επικοινωνήσετε μαζί μας ανά πάσα στιγμή στη διεύθυνση που αναφέρεται στα στοιχεία έκδοσης, εάν έχετε περαιτέρω απορίες σχετικά με την προστασία δεδομένων. Έχετε επίσης το δικαίωμα να υποβάλετε καταγγελία στην αρμόδια εποπτική αρχή.</p><h4>2. Γενικές υποδείξεις και υποχρεωτικές πληροφορίες</h4><h5>Προστασία δεδομένων</h5><p>Οι χειριστές αυτού του ιστότοπου λαμβάνουν την προστασία των προσωπικών σας δεδομένων πολύ σοβαρά. Αντιμετωπίζουμε τα προσωπικά σας δεδομένα εμπιστευτικά και σύμφωνα με τους ισχύοντες κανονισμούς για την προστασία των δεδομένων και την παρούσα δήλωση προστασίας δεδομένων.</p>\n\n<p>Όταν χρησιμοποιείτε αυτόν τον ιστότοπο, συλλέγονται διάφορα προσωπικά δεδομένα. Αυτή η δήλωση προστασίας δεδομένων εξηγεί ποια δεδομένα συλλέγουμε και για ποιον σκοπό τα χρησιμοποιούμε.</p>\n\n<p>Επισημαίνουμε ότι η διαβίβαση δεδομένων μέσω του Διαδικτύου (π.χ. κατά την επικοινωνία μέσω e-mail) μπορεί να παρουσιάσει κενά ασφάλειας. Δεν είναι δυνατή η πλήρης προστασία των δεδομένων έναντι πρόσβασης από τρίτους.</p><h5>Σημείωση για τον αρμόδιο φορέα</h5><p>Ο αρμόδιος φορέας για την επεξεργασία δεδομένων σε αυτόν τον ιστότοπο είναι:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Κάιζερσλαουτερν<br>\nΓερμανία</p>\n\n<p>Τηλέφωνο: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu</p>\n\n<p>Ο αρμόδιος φορέας είναι το φυσικό ή νομικό πρόσωπο που, μόνος ή από κοινού με άλλους, αποφασίζει για τους σκοπούς και τα μέσα επεξεργασίας προσωπικών δεδομένων (π.χ. ονόματα, διευθύνσεις e-mail κ.λπ.).</p><h5>Ανάκληση της συγκατάθεσής σας για την επεξεργασία δεδομένων</h5><p>Πολλές διαδικασίες επεξεργασίας δεδομένων είναι δυνατές μόνο με τη ρητή συγκατάθεσή σας. Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Αρκεί ένα ανεπίσημο e-mail σε εμάς. Η νομιμότητα της επεξεργασίας δεδομένων που πραγματοποιήθηκε πριν από την ανάκληση παραμένει ανεπηρέαστη από την ανάκληση.</p><h5>Δικαίωμα καταγγελίας στην αρμόδια εποπτική αρχή</h5><p>Σε περίπτωση παραβίασης της νομοθεσίας περί προστασίας δεδομένων, το υποκείμενο των δεδομένων έχει το δικαίωμα να υποβάλει καταγγελία στην αρμόδια εποπτική αρχή. Η αρμόδια εποπτική αρχή για θέματα προστασίας δεδομένων είναι ο υπεύθυνος προστασίας δεδομένων του ομοσπονδιακού κρατιδίου στο οποίο εδρεύει η εταιρεία μας. Μια λίστα υπεύθυνων προστασίας δεδομένων και τα στοιχεία επικοινωνίας τους βρίσκονται στον παρακάτω σύνδεσμο:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Δικαίωμα φορητότητας δεδομένων</h5></p>Έχετε το δικαίωμα να διαβιβάσετε τα δεδομένα, που επεξεργαζόμαστε αυτόματα βάσει της συγκατάθεσής σας ή στο πλαίσιο εκπλήρωσης μιας σύμβασης, σε εσάς ή σε τρίτο μέρος σε κοινή, αναγνώσιμη από μηχάνημα μορφή. Εάν ζητήσετε την άμεση διαβίβαση των δεδομένων σε άλλο υπεύθυνο άτομο, αυτό θα γίνει μόνο εάν είναι τεχνικά εφικτό.</p><h5>Δικαίωμα επιβεβαίωσης και ενημέρωσης</h5><p>Έχετε το δικαίωμα ανά πάσα στιγμή να λάβετε επιβεβαίωση από εμάς σχετικά με το εάν υποβάλλονται σε επεξεργασία προσωπικά δεδομένα που σχετίζονται με εσάς. Σε αυτήν την περίπτωση, έχετε το δικαίωμα να ζητήσετε δωρεάν πληροφορίες από εμάς σχετικά με τα προσωπικά δεδομένα που είναι αποθηκευμένα για εσάς.</p><h5>Δικαίωμα διόρθωσης</h5><p>Έχετε το δικαίωμα να μας ζητήσετε να διορθώσουμε αμέσως τυχόν εσφαλμένα προσωπικά δεδομένα που σας αφορούν. Λαμβάνοντας υπόψη τους σκοπούς της επεξεργασίας, έχετε το δικαίωμα να ζητήσετε τη συμπλήρωση ελλιπών προσωπικών δεδομένων.</p><h5>Δικαίωμα διαγραφής («δικαίωμα λήθης»)</h5><p>Σύμφωνα με το άρθρο 17 του GDPR, έχετε το δικαίωμα να ζητήσετε την άμεση διαγραφή προσωπικών δεδομένων που σας αφορούν και είμαστε υποχρεωμένοι να διαγράψουμε τα προσωπικά δεδομένα αμέσως εάν ισχύει ένας από τους ακόλουθους λόγους:</p>\n<p><ol>\n<li>Τα προσωπικά δεδομένα δεν είναι πλέον απαραίτητα για τους σκοπούς για τους οποίους συλλέχθηκαν ή υποβλήθηκαν σε άλλη επεξεργασία.</li>\n<li>Το υποκείμενο των δεδομένων ανακαλεί τη συγκατάθεση στην οποία βασίστηκε η επεξεργασία σύμφωνα με το άρθρο 6 παράγραφος 1 στοιχείο α) ή το άρθρο 9 παράγραφος 2 στοιχείο α) και δεν υπάρχει άλλη νομική βάση για την επεξεργασία.</li>\n<li>Το υποκείμενο των δεδομένων αντιτίθεται στην επεξεργασία σύμφωνα με το άρθρο 21 παράγραφος 1 και δεν υπάρχουν επιτακτικοί νόμιμοι λόγοι για την επεξεργασία, ή το υποκείμενο των δεδομένων αντιτίθεται στην επεξεργασία σύμφωνα με το άρθρο 21 παράγραφος 2.</li>\n<li>Τα προσωπικά δεδομένα υποβλήθηκαν παράνομα σε επεξεργασία.</li>\n<li>Η διαγραφή των προσωπικών δεδομένων είναι απαραίτητη για την εκπλήρωση νομικής υποχρέωσης σύμφωνα με το δίκαιο της Ένωσης ή το δίκαιο των κρατών μελών στο οποίο υπόκειται ο υπεύθυνος.</li>\n<li>Τα προσωπικά δεδομένα συλλέχθηκαν σε σχέση με τις υπηρεσίες της εταιρείας πληροφοριών που προσφέρονται σύμφωνα με το άρθρο 8 παράγραφος 1.</li>\n</ol></p><h5>Δικαίωμα περιορισμού της επεξεργασίας</h5><p>Σύμφωνα με Άρθρο 18 GDPR, έχετε το δικαίωμα να ζητήσετε να περιορίσουμε την επεξεργασία εάν εκπληρώνεται μία από τις ακόλουθες προϋποθέσεις:</p>\n<p><ol>\n<li>η ορθότητα των προσωπικών δεδομένων αμφισβητείται από το υποκείμενο των δεδομένων&nbsp; για μια περίοδο που επιτρέπει στον υπεύθυνο να ελέγξει την ορθότητα των προσωπικών δεδομένων,</li>\n<li>η επεξεργασία είναι παράνομη και το υποκείμενο των δεδομένων απορρίπτει τη διαγραφή των προσωπικών δεδομένων και αντ’ αυτού ζητά να περιοριστεί η χρήση των προσωπικών δεδομένων,</li>\n<li>ο υπεύθυνος επεξεργασίας των προσωπικών δεδομένων δεν χρειάζεται πλέον τα προσωπικά δεδομένα για σκοπούς επεξεργασίας, αλλά το υποκείμενο των δεδομένων τα χρειάζεται για να διεκδικήσει, να ασκήσει ή να υπερασπιστεί νομικές αξιώσεις ή</li>\n<li>το υποκείμενο των δεδομένων υπέβαλε ένσταση κατά της επεξεργασίας σύμφωνα με το άρθρο 21 παράγραφος 1, εφόσον δεν έχει ακόμη καθοριστεί, εάν οι νόμιμοι λόγοι του υπεύθυνου υπερισχύουν εκείνων του υποκειμένου των δεδομένων.</li>\n</ol></p><h5>Κρυπτογράφηση SSL ή/και TLS</h5><p>Για λόγους ασφαλείας και για την προστασία της διαβίβασης εμπιστευτικού περιεχομένου, όπως παραγγελίες ή ερωτήσεις που μας στέλνετε ως διαχειριστής ιστότοπου, αυτός ο ιστότοπος χρησιμοποιεί Κρυπτογράφηση SSL ή TLS. Μπορείτε να αναγνωρίσετε μια κρυπτογραφημένη σύνδεση από τη γραμμή διευθύνσεων του προγράμματος περιήγησης που αλλάζει από 'http://' σε 'https://' και από το σύμβολο της κλειδαριάς στη γραμμή του προγράμματος περιήγησής σας.</p>\n\n<p>Εάν η κρυπτογράφηση SSL ή TLS είναι ενεργοποιημένη, τα δεδομένα που μας διαβιβάζετε δεν μπορούν να διαβαστούν από τρίτους.</p><h4>3. Υπεύθυνος προστασίας δεδομένων</h4><h5>Νόμιμος υπεύθυνος προστασίας δεδομένων</h5><p>Έχουμε διορίσει έναν υπεύθυνο προστασίας δεδομένων για την εταιρεία μας.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Βερολίνο<br>\nΓερμανία</p>\n\n<p>Τηλέφωνο: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Συλλογή δεδομένων στον ιστότοπό μας</h4><h5>Cookies</h5><p>Οι ιστότοποι χρησιμοποιούν μερικώς τα λεγόμενα cookies. Τα cookies δεν βλάπτουν τον υπολογιστή σας και δεν περιέχουν ιούς. Τα cookies χρησιμεύουν για να κάνουν τις υπηρεσίες μας πιο φιλικές, πιο αποτελεσματικές και ασφαλέστερες. Τα cookies είναι μικρά αρχεία κειμένου που εγκαθίστανται στον υπολογιστή σας και αποθηκεύονται από το πρόγραμμα περιήγησής σας.</p>\n<p>Τα περισσότερα από τα cookies που χρησιμοποιούμε είναι τα λεγόμενα «session cookies». Διαγράφονται αυτόματα μετά την επίσκεψή σας. Άλλα cookies παραμένουν αποθηκευμένα στη συσκευή σας έως ότου τα διαγράψετε. Αυτά τα cookies μας δίνουν τη δυνατότητα να αναγνωρίσουμε το πρόγραμμα περιήγησής σας κατά την επόμενη επίσκεψή σας.</p>\n<p>Μπορείτε να ρυθμίσετε το πρόγραμμα περιήγησής σας έτσι ώστε να ενημερώνεστε για την εγκατάσταση των cookies και να επιτρέπετε τα cookies μόνο σε μεμονωμένες περιπτώσεις, να αποκλείσετε την αποδοχή των cookies για ορισμένες περιπτώσεις ή εν γένει και να ενεργοποιήσετε την αυτόματη διαγραφή των cookies όταν κλείνετε το πρόγραμμα περιήγησης. Εάν τα cookies είναι απενεργοποιημένα, η λειτουργικότητα αυτού του ιστότοπου ενδέχεται να είναι περιορισμένη.</p>\n<p>Τα cookies που απαιτούνται για τη διεξαγωγή της διαδικασίας ηλεκτρονικής επικοινωνίας ή για την παροχή ορισμένων λειτουργιών που χρειάζεστε (π.χ. λειτουργία καλαθιού αγορών) αποθηκεύονται βάσει του άρθρου 6 παράγραφος 1 στοιχείο στ) GDPR. Ο διαχειριστής της ιστοσελίδας έχει έννομο συμφέρον να αποθηκεύει cookies για την τεχνικά χωρίς σφάλματα και βελτιστοποιημένη παροχή των υπηρεσιών του. Εάν αποθηκεύονται άλλα cookies (π.χ. cookies για την ανάλυση της συμπεριφοράς περιήγησής σας), αντιμετωπίζονται ξεχωριστά σε αυτήν τη δήλωση προστασίας δεδομένων.</p><h5>Αρχεία καταγραφής διακομιστή</h5><p>Ο πάροχος ιστότοπου συλλέγει και αποθηκεύει αυτόματα πληροφορίες στα λεγόμενα αρχεία καταγραφής διακομιστή, τα οποία διαβιβάζει αυτόματα το πρόγραμμα περιήγησής σας σε εμάς. Αυτά είναι:</p>\n<p><ul>\n<li>Τύπος προγράμματος περιήγησης και έκδοση προγράμματος περιήγησης</li>\n<li>Λειτουργικό σύστημα που χρησιμοποιείται</li>\n<li>Διεύθυνση URL αναφοράς</li>\n<li>Όνομα κεντρικού υπολογιστή στον υπολογιστή πρόσβασης</li>\n<li>Ώρα του αιτήματος διακομιστή</li>\n<li>Διεύθυνση IP</li>\n</ul></p>\n\n<p>Αυτά τα δεδομένα δεν θα συγχωνευτούν με άλλες πηγές δεδομένων.</p>\n\n<p>Η βάση για την επεξεργασία δεδομένων είναι το άρθρο 6 παράγραφος 1 στοιχείο στ) GDPR, το οποίο επιτρέπει στην επεξεργασία δεδομένων να εκπληρώνει συμβάσεις ή προσυμβατικά μέτρα.</p><h5>Φόρμα Επικοινωνίας</h5><p>Εάν μας στείλετε ερώτημα χρησιμοποιώντας τη φόρμα επικοινωνίας, τα στοιχεία σας από τη φόρμα αιτήματος, συμπεριλαμβανομένων των στοιχείων επικοινωνίας που δώσατε εκεί, θα αποθηκευτούν από εμάς για τους σκοπούς της επεξεργασίας του ερωτήματος και σε περίπτωση επακόλουθων ερωτήσεων. Δεν διαβιβάζουμε αυτά τα δεδομένα χωρίς τη συγκατάθεσή σας.</p>\n\n<p>Η επεξεργασία των δεδομένων που εισάγονται στη φόρμα επικοινωνίας πραγματοποιείται αποκλειστικά βάσει της συγκατάθεσής σας (άρθρο 6 παράγραφος 1 στοιχείο α) GDPR). Μπορείτε να ανακαλέσετε αυτήν τη συγκατάθεση ανά πάσα στιγμή. Αρκεί ένα ανεπίσημο e-mail σε εμάς. Η νομιμότητα των διαδικασιών επεξεργασίας δεδομένων που πραγματοποιήθηκαν πριν από την ανάκληση παραμένει ανεπηρέαστη από την ανάκληση.</p>\n\n<p>Τα δεδομένα που εισάγετε στη φόρμα επικοινωνίας θα διατηρούνται σε εμάς έως ότου μας ζητήσετε να τα διαγράψουμε, να ανακαλέσετε τη συγκατάθεσή σας για αποθήκευση ή να μην ισχύει πλέον ο σκοπός της αποθήκευσης δεδομένων (π.χ. μετά την επεξεργασία του αιτήματός σας). Οι υποχρεωτικές νομικές διατάξεις – ιδίως οι περίοδοι αποθήκευσης – παραμένουν ανεπηρέαστες.</p>\n\n"])}
        }
      },
      "he-IL": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הצהרת הגנה על מידע"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. הגנה על מידע במבט חטוף</h4><h5>הוראות כלליות</h5><p>ההוראות הבאות מספקות סקירה קצרה לגבי אופן הטיפול בנתוניכם האישיים, בזמן שאתם מבקרים באתרנו. נתונים אישיים הם כל הנתונים שבאמצעותם ניתן לזהותכם. מידע מקיף בנושא הגנה על מידע ניתן למצוא בהצהרת הגנת המידע שלנו, בתחתיתו של טקסט זה</p><h5>איסוף נתונים באתרנו</h5><p>מי האחראי לאיסוף הנתונים באתר זה?</p>\n<p>עיבוד הנתונים באתר זה מתבצע על ידי מפעיל האתר. פרטים על המפעיל ניתן למצוא במקטע \"אודות\" (Impressum) שבאתר זה.</p><h5>כיצד הנתונים נאספים?</h5><p>הנתונים הנאספים הם, מצד אחד, אלה שאתם מוסרים לנו כנושאי המידע, כגון הנתונים שהזנתם בטופס יצירת הקשר.</p>\n\n<p>תונים אחרים נאספים באופן אוטומטי בעת ביקורכם באתר, באמצעות מערכות המחשוב שלנו. אלו הם בראש ובראשונה נתונים טכניים (כגון סוג הדפדפן, מערכת ההפעלה או שעת הכניסה לאתר). איסוף נתונים זה מתבצע באופן אוטומטי, ברגע כניסתכם לאתר.</p>\n<h5>לאיזו מטרה משמשים נתוניכם?</h5><p>חלק מהנתונים נאספים כדי להבטיח שהשימוש באתר יתבצע ללא תקלות. נתונים אחרים יכולים לשמש לשם ניתוח התנהגותכם כמשתמשים.</p><h5>מהן זכויותיכם בנוגע לנתוניכם?</h5><p>זכותכם לקבל בכל עת וללא עלות כספית מידע על מקור נתוניכם האישיים שנאספו על ידינו, על הנמען המטפל ועל מטרת השימוש שנעשה בהם. נוסף על כך, זכותכם לדרוש תיקון, חסימה או מחיקה של נתונים אלה. למימוש זכות זו, ולשאלות נוספות הנוגעות להגנה על נתונים, תוכלו לפנות אלינו בכל עת לפי הכתובת המפורטת בפסקה 'אודות' שצוינה לעיל. מעבר לכך, זכותכם להתלונן בפני רשויות הפיקוח המוסמכות.</p><h4>2. הוראות כלליות וחובת היידוע</h4><h5>הגנה על מידע</h5><p>מפעיל אתר זה מתייחס ברצינות רבה להגנה על פרטיכם האישיים. אנו מעבדים את נתוניכם האישיים בצורה חסויה ובהתאם להוראות חוק ההגנה על מידע, כמו גם בהתאם להוראות הצהרה זו</p>\n\n<p>בזמן שאתם משתמשים באתר זה, נאספים נתונים שונים המוגדרים כנתונים אישיים. הצהרה זו שלפניכם מבהירה אילו נתונים אנו אוספים ומה השימוש שאנו עושים בהם.</p>\n\n<p>לשימת ליבכם, העברת נתונים באינטרנט (כגון בעת תקשורת דוא\"ל) עלולה להיות כרוכה בפערי אבטחה. לא ניתן להבטיח הגנה מושלמת על הנתונים מפני חדירה וניצול מכיוונו של צד שלישי.</p><h5>הוראה לגבי הגוף המוסמך</h5><p>הגוף המוסמך לעיבוד הנתונים באתר זה הוא:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nגרמניה</p>\n\n<p>טלפון: +49 (0)631 5600 1600<br>\nדוא\"ל: zentrale&#64;dutypay.eu</p>\n\n<p>הגוף המוסמך הוא אישיות טבעית או משפטית, הקובעת לבדה או יחד עם אחרים את מטרות ואמצעי עיבוד הנתונים האישיים (כגון שמות, כתובות דוא\"ל וכד').</p><h5>ביטול הסכמה לעיבוד נתונים אישיים</h5><p>תהליכי עיבוד נתונים אישיים רבים אפשריים רק אם הסכמתם להם במפורש. באפשרותכם לבטל בכל עת הסכמה שכבר ניתנה. לשם כך די אם תשלחו אלינו הודעת דוא\"ל רגילה. ביטול ההסכמה לא יפגע בעיבוד הנתונים שבוצע קודם לביטול ההסכמה.</p><h5>זכות התלונה אצל רשויות הפיקוח המוסמכות</h5><p>במקרה של הפרת חוק ההגנה על מידע עומדת לנפגע הזכות להתלונן בפני רשויות הפיקוח המוסמכות. רשות הפיקוח המוסמכת לענייני חוק הגנת המידע היא הממונה הארצי על הגנת מידע במדינת המחוז שבה יושבת חברתנו. את רשימת הממונים על הגנת המידע ופרטי ההתקשרות עמם ניתן למצוא בקישור שלהלן:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>זכות לניוד נתונים</h5><p>זכותכם לקבל נתונים שאותם עיבדנו באופן אוטומטי על סמך הסכמתכם או במסגרת מילוי הוראות הסכם או לניידם לידי צד שלישי, בפורמט זמין וקריא. בקשה מצדכם לניוד נתונים לאחריותו של צד שלישי תבוצע רק אם הדבר יתאפשר מבחינה טכנית.</p><h5>זכות לאישור ולקבלת מידע</h5><p>זכותכם בכל עת לקבל מאיתנו אישור באשר לעיבוד שנעשה בנתוניכם האישיים. במקרה כזה, זכותכם לקבל מאיתנו מידע לגבי נתוניכם האישיים המאוחסנים אצלנו. שירות זה מוענק ללא עלות כספית.</p><h5>זכות לתיקון</h5><p>זכותכם לדרוש מאיתנו בכל עת תיקון מיידי של פרטים אישיים שאינם נכונים. בהתאם למטרת עיבוד הנתונים, זכותכם לדרוש השלמת פרטים אישיים חסרים.</p><h5>זכות למחיקה ('הזכות להישכח')</h5><p>בהתאם לסעיף 17 בתקנות הכלליות של האיחוד האירופי לאסדרת הגנת מידע (GDPR) זכותכם לדרוש מאיתנו, למחוק לאלתר את כל הנתונים האישיים הנוגעים לכם, ואנו מחויבים למחוק את נתוניכם האישיים כאמור ללא דיחוי, בהתקיים אחד התנאים הבאים</p>\n\n<p><ol>\n<li>הנתונים האישיים אינם נדרשים עוד עבור המטרות שלשמן נאספו או עובדו בכל דרך אחרת;</li>\n<li>נושא המידע שפרטיו האישיים נאספו ביטל את הסכמתו לעיבודם בהתאם לסעיף 6 פסקה 1(א') או לסעיף 9 פסקה 2(א'), ולא קיים עוד בסיס חוקי אחר לעיבוד כאמור;</li>\n<li>נושא המידע שפרטיו האישיים נאספו הגיש התנגדות לעיבוד הפרטים בהתאם לסעיף 21 פסקה 1 ולא קיימים נימוקים מוצדקים בדרגת קדימות לעיבוד כאמור, או שנושא המידע שפרטיו האישיים נאספו הגיש התנגדות לעיבוד הפרטים בהתאם לסעיף 21 פסקה 2;</li>\n<li>הנתונים האישיים עובדו שלא כחוק;</li>\n<li>מחיקת הנתונים האישיים נדרשת לשם מילוי חובה חוקית בהתאם לחוק האירופי או לחוק של המדינות החברות באיחוד האירופי, אליו כפוף האחראי על איסוף הנתונים;</li>\n<li>הנתונים האישיים נאספו בקשר לשירות של חברת מידע בהתאם ל-סעיף 8 פסקה 1.</li>\n</ol></p><h5>הזכות להגבלת העיבוד</h5><p>בהתאם לסעיף 18 GDPR, זכותכם לדרוש מאיתנו להגביל את עיבוד הנתונים, אם התקיים אחד מהתנאים הבאים:</p>\n\n<p><ol>\n<li>נושא המידע שנתוניו האישיים נאספו חולק על נכונות הנתונים האישיים, וזאת בפרק זמן המאפשר לאחראי לאיסוף הנתונים לבדוק את נכונות הפרטים האישיים;</li>\n<li>העיבוד נעשה בצורה לא חוקית ונושא המידע שפרטיו האישיים נאספו דחה את מחיקת הפרטים האישיים ובמקום זאת ביקש להגביל את השימוש בהם;</li>\n<li>האחראי על איסוף הנתונים כבר אינו זקוק לפרטים אלה לצרכים שלשמם עובדו, אולם נושא המידע שפרטיו האישיים נאספו זקוק להם לשם תביעה, מימוש זכויותיו או הגנה מפני תביעה משפטית, או</li>\n<li>שנושא המידע שנתוניו האישיים נאספו הגיש תביעה נגד עיבוד הנתונים בהתאם להוראות סעיף 21 פסקה 1, כל עוד לא נקבע אם הנימוקים המוצדקים של האחראי לאיסוף הנתונים גוברים על נימוקיו של נושא המידע.</li>\n</ol></p><h5>הצפנת SSL או TLS</h5><p>מסיבות של בטיחות ולשם הגנה על העברת חומר חסוי, כגון הזמנות או בקשות שאתם שולחים אלינו כמפעילי האתר, אתר זה משתמש בהצפנה מסוג SSL או TLS. קשר מוצפן ניתן לזיהוי בכך ששורת כתובת ה-URL של הדפדפן משתנה מ- 'http://' ל-'https://' וכשסמליל המנעול מופיע לצידה.<7</p>\n\n<p>בהפעלה של הצפנת SSL או TLS, הנתונים שאתם מעבירים אלינו לא ניתנים לקריאה על ידי צד ג'.</p><h4>3. האחראי על אבטחת נתונים</h4><h5>האחראי על אבטחת נתונים בהתאם לחוק</h5><p>מטעם חברתנו מינינו את האדם הבא כאחראי על אבטחת הנתונים:</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627ברלין<br>\nגרמניה</p>\n\n<p>טלפון: <span dir=\"ltr\">+498941325320</span><br>\nדוא\"ל: datenschutz&#64;heydata.eu</p><h4>4. איסוף נתונים באתרנו</h4><h5>עוגיות</h5><p>אתרי אינטרנט עושים לעתים שימוש ב\"עוגיות\" (Cookies). עוגיות אינן פוגעות במחשבכם ואינן מכילות וירוסים. עוגיות משמשות לשיפור חוויית המשתמש וכן להגברת היעילות והבטיחות של האתר. עוגיות הן קבצי טקסט קטנים הנשלחים אל מחשבכם והנשמרים על ידי הדפדפן.</p>\n\n<p>רוב העוגיות שבהן אנו משתמשים נקראות \"עוגיות זמניות\". הן נמחקות אוטומטית עם סיום ביקורכם באתרנו. עוגיות אחרות נשמרות במחשבכם עד שתמחקו אותן בעצמכם. עוגיות אלה מאפשרות לנו לזהות את הדפדפן שלכם בביקורכם הבא באתרנו.</p>\n\n<p>באפשרותכם להגדיר את הדפדפן שלכם כך שיודיע לכם על משלוח של עוגיות, שיאפשר את שמירתן רק במקרים מסוימים, או שלא יאפשר את שמירתן כלל, וכן שיבצע מחיקה אוטומטית של כולן עם סגירת הדפדפן. השבתת העוגיות עלולה להגביל את תפקוד האתר.</p>\n\n<p>עוגיות המשמשות לביצוע תהליכי תקשורת אלקטרוניים, או הנדרשות להכנת פונקציות מסוימות שהתבקשו על ידכם (כגון פונקציית סל הקניות), נשמרות בהתאם להוראות סעיף 6 פסקה 1(ו') ל- GDPR. למפעיל האתר יש עניין מוצדק באחסון קבצי עוגיות לצורך אספקת שירותיו ללא תקלות ובצורה משופרת מבחינה טכנית. בכל הנוגע לאחסונן של עוגיות אחרות (כגון עוגיות לצורך ניתוח הרגלי הגלישה שלכם), הם יידונו בנפרד בהצהרת הגנה על מידע זו.</p><h5>קבצי יומן השרת</h5><p>ספק האתרים אוסף ומאחסן מידע באופן אוטומטי במה שמכונה קבצי יומן השרת, המועברים אלינו ישירות מהדפדפן שלכם, ואלו הם:</p>\n\n<ul>\n<li>סוג הדפדפן וגרסתו</li>\n<li>מערכת ההפעלה של מחשבכם</li>\n<li>כתובת האתר המפנה</li>\n<li>שם השרת המארח את מחשבכם</li>\n<li>שעת שיגורה של בקשת השרת</li>\n<li>כתובות IP</li>\n</ul>\n<p>נתונים אלה אינם מוצלבים עם מקורות מידע אחרים.</p>\n\n<p>חוקיות עיבוד הנתונים מתבססת על סעיף 6 פסקה 1(ו') ל- GDPR, המאפשר עיבוד נתונים לשם מילוי הוראות הסכם או נקיטה בצעדים שמקדימים להסכם.<7</p>\n<h5>טופס יצירת הקשר</h5><p>אם תשלחו אלינו בקשות באמצעות טופס יצירת הקשר, נתוניכם, כולל פרטי הקשר שהוזנו על ידכם, יאוחסנו על ידנו לשם עיבוד הבקשה ולצורכי מעקב באותו נושא. אנו לא נעביר נתונים אלה הלאה ללא הסכמתכם.</p>\n\n<p>עיבוד הנתונים המופיעים בטופס יצירת הקשר יבוצע אך ורק על סמך הסכמתכם (סעיף 6 פסקה 1(א') ל-GDPR. באפשרותכם לבטל הסכמה זו בכל עת. לשם כך די אם תשלחו אלינו הודעת דוא\"ל רגילה. ביטול ההסכמה לא יפגע בתהליכי עיבוד נתונים שבוצעו קודם לביטול ההסכמה.</p>\n\n<p>הנתונים שמסרתם בטופס יצירת הקשר יישמרו אצלנו עד לקבלת דרישתכם למחיקתם או לביטול הסכמתכם לשמירתם וכן במקרה שתבוטל המטרה שלשמה אוחסנו (למשל, לאחר עיבוד בקשתכם). הוראות חוקיות מחייבות – בייחוד לגבי תקופות שמירה של נתונים – נותרות בעינן.</p>"])}
        }
      },
      "ga-IE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosaint sonraí"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1.Sracfhéachaint ar chosaint sonraí</h4><h5>Comhairle Ghinearálta</h5><p>Tugann an fhaisnéis seo a leanas forbhreathnú simplí ar an méid a tharlaíonn do do shonraí pearsanta nuair a thugann tú cuairt ar ár suíomh gréasáin. Is í sonraí pearsanta na sonraí go léir ar féidir tú a aithint go pearsanta leo. Is féidir faisnéis mhionsonraithe ar ábhar na cosanta sonraí a fháil inár ndearbhú cosanta sonraí atá liostaithe faoin téacs seo.</p><h5>Bailiú sonraí ar ár suíomh gréasáin</h5><p>Cé atá freagrach as bailiú sonraí ar an suíomh gréasáin seo?</p>\n<p>Is é oibreoir an láithreáin ghréasáin a dhéanann an phróiseáil sonraí ar an suíomh gréasáin seo. Is féidir leat a gcuid sonraí teagmhála a fháil in inphrionta an láithreáin ghréasáin seo.</p><h5>Conas a bhailímid do chuid sonraí?</h5><p>Ar thaobh amháin, bailítear do chuid sonraí nuair a sholáthraíonn tú iad dúinn. Is féidir seo a bheith e.g. sonraí a chuireann tú isteach i bhfoirm teagmhála.</p>\n\n<p>Déanann ár gcórais TF sonraí eile a thaifeadadh go huathoibríoch nuair a thugann tú cuairt ar an suíomh gréasáin. Sonraí teicniúla den chuid is mó iad seo (e.g. brabhsálaí Idirlín, córas oibriúcháin nó am an leathanaigh breathnaíodh ). Bailítear na sonraí seo go huathoibríoch a luaithe a iontrálann tú ar ár suíomh gréasáin.</p><h5>Cén úsáid a bhainimid as do chuid sonraí?</h5><p>Bailítear cuid de na sonraí d’fhonn a chinntiú go bhfuil an suíomh Gréasáin saor ó earráidí. Is féidir sonraí eile a úsáid chun d’iompar úsáideora a anailísiú.</p><h5>Cad iad na cearta atá agat maidir le do chuid sonraí?</h5><p>Tá sé de cheart agat faisnéis a fháil faoi bhunús, faighteoir agus cuspóir do shonraí pearsanta stóráilte saor in aisce ag am ar bith. Tá sé de cheart agat freisin ceartú, blocáil nó scriosadh na sonraí seo a iarraidh. Féadfaidh tú teagmháil a dhéanamh linn tráth ar bith ag an seoladh a thugtar san fhógra dlíthiúil má tá aon cheist eile agat faoi chosaint sonraí. Tá sé de cheart agat freisin gearán a dhéanamh leis an údarás maoirseachta inniúil.</p><h4>2. Faisnéis ghinearálta agus faisnéis éigeantach</h4><h5>Cosaint Sonraí</h5><p>Glacann oibreoirí an suímh gréasáin seo cosaint do shonraí pearsanta an-dáiríre. Caithimid le do chuid sonraí pearsanta faoi rún agus de réir na rialachán reachtúil um chosaint sonraí agus an dearbhú cosanta sonraí seo.</p>\n\n<p>Bailítear sonraí pearsanta éagsúla nuair a úsáideann tú an suíomh gréasáin seo. Mínítear sa dearbhú cosanta sonraí seo na sonraí a bhailímid agus cén úsáid a bhainimid astu.</p>\n\n<p>Ba mhaith linn a chur in iúl go bhféadfadh bearnaí slándála a bheith ag tarchur sonraí ar an idirlíon (e.g. ag cumarsáid trí ríomhphost). Ní féidir cosaint iomlán a dhéanamh ar na sonraí i gcoinne rochtana ag tríú páirtithe.</p><h5>Nóta ar an gcomhlacht freagrach</h5><p>Is é an comhlacht freagrach seo as próiseáil sonraí ar an suíomh gréasáin seo:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAn Ghearmáin</p>\n\n<p>Guthán: +49 (0)631 5600 1600<br>\nRíomhphos: zentrale&#64;dutypay.eu</p>\n\n<p>Is é an comhlacht freagrach an duine nádúrtha nó dlíthiúil a chinneann, ina aonar nó i gcomhpháirt le daoine eile, na críocha agus na modhanna chun sonraí pearsanta a phróiseáil (e.g. ainmneacha, seoltaí ríomhphoist, srl.).</p><h5>Cúlghairm do thoiliú le próiseáil sonraí</h5><p>Ní féidir go leor oibríochtaí próiseála sonraí a dhéanamh ach le do thoiliú sainráite. Féadfaidh tú do thoiliú a tharraingt siar tráth ar bith. Is leor ríomhphost neamhfhoirmiúil chugainn. Níl aon tionchar ag an gcúlghairm ar dhlíthiúlacht na próiseála sonraí a rinneadh roimh an gcúlghairm.</p><h5>Ceart achomhairc chuig an údarás maoirseachta inniúil</h5><p>Tá sé de cheart ag an duine lena mbaineann gearán a dhéanamh leis an údarás maoirseachta inniúil, i gcás sáruithe ar an dlí um chosaint sonraí. Is é an t-údarás maoirseachta inniúil ar shaincheisteanna cosanta sonraí oifigeach cosanta sonraí stáit an stáit chónaidhme ina bhfuil ár gcuideachta bunaithe. Is féidir liosta na n-oifigeach cosanta sonraí agus a gcuid sonraí teagmhála a fháil ag an nasc seo a leanas: </p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Ceart chun iniomparthacht sonraí</h5><p>Tá sé de cheart agat, sonraí a bheith agat, go ndéanaimid próiseáil go huathoibríoch ar bhonn do thoiliú nó i gcomhlíonadh conartha, a thugtar duit féin nó do thríú páirtí i bhformáid choiteann, inléite ag meaisín. Má iarrann tú go n-aistreofar na sonraí go díreach chuig duine eile atá i gceannas, ní dhéanfar é seo ach má tá sé indéanta go teicniúil.</p><h5>Ceart chun dearbhaithe agus faisnéise</h5><p>Tá sé de cheart agat tráth ar bith dearbhú a fháil uainn i dtaobh an bhfuil sonraí pearsanta a bhaineann leat á bpróiseáil. Más é seo an cás, tá sé de cheart agat faisnéis saor in aisce a iarraidh uainn faoi na sonraí pearsanta atá stóráilte fút.</p><h5>Ceart chun ceartaithe</h5><p>Tá sé de cheart agat iarraidh orainn aon sonraí pearsanta míchearta a bhaineann leat a cheartú gan mhoill. Agus críocha na próiseála á gcur san áireamh, tá sé de cheart agat a iarraidh go gcomhlánófar sonraí pearsanta neamhiomlána.</p><h5>Ceart chun scriosadh ('ceart go ndéanfaí dearmad ort')</h5><p>De réir Airteagal 17 den GDPR, tá sé de cheart agat a éileamh go scriosfaimid sonraí pearsanta a bhaineann leat láithreach, agus tá oibleagáid orainn sonraí pearsanta a scriosadh láithreach má tá feidhm ag ceann de na cúiseanna seo a leanas:</p>\n<p><ol>\n<li>Ní gá na sonraí pearsanta a thuilleadh chun na críocha ar bailíodh iad nó ar próiseáladh iad ar bhealach eile.</li>\n<li>Déanann an duine is ábhar do na sonraí a dtoiliú ar a raibh an phróiseáil bunaithe a chúlghairm de réir Airteagal 6 (1) (a) nó Airteagal 9 (2) (a) agus níl aon bhunús dlí eile leis an bpróiseáil.</li>\n<li>Cuireann an t-ábhar sonraí i gcoinne na próiseála de réir Airteagal 21 mír 1 agus níl aon chúiseanna dlisteanacha sáraitheacha ann maidir leis an bpróiseáil, nó cuireann an duine is ábhar do na sonraí i gcoinne na próiseála de réir Airteagal 21 mír 2.</li>\n<li>Próiseáladh na sonraí pearsanta go neamhdhleathach.</li>\n<li>Is gá sonraí pearsanta a scriosadh chun oibleagáid dhlíthiúil a chomhlíonadh faoi dhlí an Aontais nó faoi dhlí na mballstát a bhfuil an duine atá freagrach faoina réir.</li>\n<li>Bailíodh na sonraí pearsanta maidir le seirbhísí na sochaí faisnéise a tairgeadh de réir Airteagal 8 (1).</li>\n</ol></p><h5>Ceart chun próiseáil a shrianadh</h5><p>De réir Airteagal 18 GDPR, tá sé de cheart agat a éileamh go gcuirfimid srian ar phróiseáil má chomhlíontar ceann de na coinníollacha seo a leanas:</p>\n<p><ol>\n<li>déanann an t-ábhar sonraí cruinneas na sonraí pearsanta a chonspóid ar feadh tréimhse a chuireann ar chumas an duine atá freagrach cruinneas na sonraí pearsanta a sheiceáil,</li>\n<li>go bhfuil an phróiseáil neamhdhleathach agus go ndiúltaíonn an duine lena mbaineann na sonraí pearsanta a scriosadh agus ina ionad sin iarrann sé go gcuirfí srian ar úsáid na sonraí pearsanta;</li>\n<li>ní theastaíonn na sonraí pearsanta ón rialaitheoir a thuilleadh chun críocha próiseála, ach ní mór d’ábhar na sonraí éilimh dhlíthiúla a dhearbhú, a fheidhmiú nó a chosaint, nó</li>\n<li>rinne an duine lena mbaineann agóid i gcoinne na próiseála a thaisceadh de réir Airteagal 21 mír 1, fad nach mbeidh cinneadh déanta fós an bhfuil cúiseanna dlisteanacha an duine atá freagrach níos tábhachtaí ná cúiseanna an duine lena mbaineann.</li>\n</ol></p><h5>Criptiú SSL nó TLS</h5><p>Úsáideann an láithreán seo SSL nó criptiú TLS ar chúiseanna slándála agus chun tarchur ábhar rúnda a chosaint, mar orduithe nó fiosrúcháin a sheolann tú chugainn mar oibreoir an láithreáin. Is féidir leat nasc criptithe a aithint toisc go n-athraíonn líne seoltaí an bhrabhsálaí ó 'http://' go 'https://' agus de réir siombail an ghlais i líne do bhrabhsálaí.</p>\n\n<p>Má ghníomhachtaítear an criptiú SSL nó TLS, ní féidir le tríú páirtithe na sonraí a tharchuireann tú chugainn a léamh.</p><h4>3. Oifigeach cosanta sonraí</h4><h5>Oifigeach reachtúil um chosaint sonraí</h5><p>Tá oifigeach cosanta sonraí ceaptha againn dár gcuideachta.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Beirlín<br>\nAn Ghearmáin</p>\n\n<p>Guthán: +498941325320<br>\nRíomhphos: datenschutz&#64;heydata.eu</p><h4>4. Bailiú sonraí ar ár suíomh gréasáin</h4><h5>Fianáin</h5><p>Úsáideann cuid de na suíomhanna Gréasáin fianáin mar a thugtar orthu. Ní dhéanann fianáin dochar do ríomhaire agus níl víris iontu. Déanann fianáin ár dtairiscint a dhéanamh níos soláimhsithe, níos éifeachtaí agus níos sábháilte. Is comhaid bheaga téacs iad fianáin a stóráiltear ar do ríomhaire agus a shábhálann do bhrabhsálaí.</p>\n\n<p>Tugtar 'fianáin seisiúin' ar an gcuid is mó de na fianáin a úsáidimid. Scriostar iad go huathoibríoch tar éis do chuairte. Fanann fianáin eile stóráilte ar do ghléas go dtí go scriosann tú iad. Cuireann na fianáin seo ar ár gcumas do bhrabhsálaí a aithint an chéad uair eile a thugann tú cuairt.</p>\n\n<p>Féadfaidh tú do bhrabhsálaí a shocrú ionas go mbeidh tú ar an eolas faoi socruithe fianán agus gan fianáin a cheadú ach i gcásanna aonair, glacadh le fianáin a eisiamh do chásanna áirithe nó go ginearálta, agus scriosadh uathoibríoch fianán a ghníomhachtú nuair a dhúnann tú an brabhsálaí. Má dhéantar fianáin a dhíghníomhachtú, féadfar feidhmiúlacht an láithreáin ghréasáin seo a theorannú.</p>\n\n<p>Stóráiltear fianáin a éilítear chun an próiseas cumarsáide leictreonaí a dhéanamh nó chun feidhmeanna áirithe a theastaíonn uait a sholáthar (e.g. feidhm cart siopadóireachta) ar bhonn Airteagal 6 Mír 1 pointe f GDPR. Tá leas dlisteanach ag oibreoir an láithreáin ghréasáin fianáin a stóráil chun a sheirbhísí a sholáthar go teicniúil agus saor ó earráidí. Má stóráiltear fianáin eile (e.g. fianáin chun anailís a dhéanamh ar d’iompar surfála), déileálfar leo ar leithligh sa dearbhú cosanta sonraí seo.</p><h5>Comhaid logála freastalaí</h5><p>Bailíonn agus sábhálann soláthróir an láithreáin ghréasáin faisnéis go huathoibríoch i gcomhaid logála freastalaí mar a thugtar air, a tharchuireann do bhrabhsálaí chugainn go huathoibríoch. Is iad seo:</p>\n<p><ul>\n<li>Cineál brabhsálaí agus leagan brabhsálaí</li>\n<li>córas oibriúcháin a úsáidtear</li>\n<li>URL an Atreoraithe</li>\n<li>Ainm óstach an ríomhaire rochtana</li>\n<li>Am an iarratais ar an bhfreastalaí</li>\n<li>Seoladh IP</li>\n</ul></p>\n\n<p>Ní chuirtear na sonraí seo le chéile le foinsí sonraí eile.</p>\n\n<p>Is é an bunús le haghaidh próiseála sonraí ná Airteagal 6 Mír 1 pointe f GDPR, a cheadaíonn sonraí a phróiseáil chun conradh nó bearta réamhchonarthacha a chomhlíonadh.</p><h5>Foirm teagmhála</h5><p>Má sheolann tú fiosrúcháin chugainn ag baint úsáide as an bhfoirm teagmhála, stórálfaidh muid do chuid sonraí ón bhfoirm fhiosrúcháin, lena n-áirítear na sonraí teagmhála a thug tú ann, chun an fiosrúchán a phróiseáil agus i gcás ceisteanna leantacha. Ní chuirimid na sonraí seo ar aghaidh gan do thoiliú.</p>\n\n<p>Déantar próiseáil na sonraí a iontráiltear san fhoirm teagmhála go heisiach ar bhonn do thoiliú (Airteagal 6 Mír 1 pointe a. GDPR). Féadfaidh tú an toiliú seo a chúlghairm tráth ar bith. Is leor r-phost neamhfhoirmiúil chugainn. Níl aon tionchar ag an gcúlghairm ar dhlíthiúlacht na n-oibríochtaí próiseála sonraí a rinneadh roimh an gcúlghairm.</p>\n\n<p>Fanfaidh na sonraí a iontrálann tú san fhoirm teagmhála linn go dtí go n-iarrfaidh tú orainn iad a scriosadh, do thoiliú le stóráil a chúlghairm nó nach mbeidh feidhm leis an gcuspóir le haghaidh stórála sonraí a thuilleadh (e.g. tar éis d’iarratas a phróiseáil). Ní dhéantar aon tionchar ar fhorálacha éigeantacha dlí, go háirithe tréimhsí coinneála.</p>"])}
        }
      },
      "ja-JP": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["個人情報保護方針"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1.データ保護の概要 </h4><h5>一般的な注意 </h5><p>以下の注意事項は当社ウェブサイトを訪問された場合の個人関連データの取扱いに関する内容を簡単にまとめたものです。個人関連データとは個人を識別し得るあらゆる情報を指します。データ保護に関する詳細については、本文書下に記載の当社の個人情報保護方針を参照してください。</p><h5>当社ウェブサイト上でのデータ収集</h5><p>このウェブサイト上のデータ収集の責任者は誰ですか？</p>\n<p>このウェブサイトのデータ処理はウェブサイト運用者が行います。当該運用者の連絡先は当ウェブサイトの発行者情報をご覧ください。</p><h5>個人データはどのように収集されますか？</h5><p>個人データはユーザーが当社にこれを提供することで収集されます。これにはユーザーがお問い合わせフォームに記入したデータなどが該当します。 </p>\n\n<p>その他のデータは、ウェブサイト訪問時に自動的に当社のITシステムにより収集されます。これには特に技術的データが該当します（インターネットブラウザ、オペレーションシステム、サイトアクセス時刻など）。これらのデータの収集はユーザーが当社ウェブサイトを訪問した時点で自動的に行われます。</p><h5>個人データの使用目的は何ですか？</h5><p>データの一部はウェブサイトを確実に問題なく閲覧できるようにするために収集されます。その他のデータはユーザー行動の分析のために使用する場合があります。</p><h5>個人データに関してユーザーにはどのような権利がありますか？</h5><p>ユーザーは随時、無償で、保存された個人関連データの発信元、受信者および目的に関する情報を受け取る権利があります。また、当該データの修正、阻止または削除を要求する権利があります。データ保護に関するその他のご質問は、随時、発行者情報に記載の当社宛先までお問い合わせください。その他ユーザーには管轄の規制当局に苦情を申し立てる権利があります。</p><h4>2. 一般的な注意および義務情報 </h4><h5>データ保護</h5><p>本サイトの運用者は個人データの保護を真摯に受けとめ重視しています。当社は個人関連データを機密かつ法的なデータ保護規定ならびに本個人情報保護方針に従って取り扱います。</p>\n\n<p>本ウェブサイトをご利用になる場合、様々な個人関連データが収集されます。現行の個人情報保護方針で、当社が収集するデータの種類および使用目的について説明しています。 </p>\n\n<p>インターネットでのデータ転送（メールによる通信の場合など）にはセキュリティ上の欠陥が生じる恐れがあることを予めご了承ください。第三者によるアクセスからデータを完全に保護することはできません。 </p><h5>責任機関に関する注意事項</h5><p>本ウェブサイト上のデータ処理に関する責任機関は以下の通りです。 </p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nドイツ</p>\n\n<p>TEL: +49 (0)631 5600 1600<br>\nメール: zentrale&#64;dutypay.eu</p>\n\n<p>責任機関は個人関連データ（氏名、メールアドレスなど）の処理の目的および手段について、単独または他者と共同で決断する、自然人または法人です。 </p><h5>データ処理に関する同意の撤回 </h5><p>データ処理プロセスの多くはユーザーの明示的な同意をもってのみ実現されます。ユーザーは一度与えた同意を随時撤回することができます。撤回は当社へ簡単なメールを送信するだけで可能です。撤回までに行われたデータ処理の正当性は、撤回により影響を受けることはありません。</p><h5>管轄の規制当局における苦情申し立て</h5><p>データ保護法違反が生じた場合、当事者は管轄の規制当局に苦情を申し立てる権利があります。データ保護法上の問題における管轄の規制当局は、当社が本拠地とする州の州データ保護責任者です。データ保護責任者の一覧および当該連絡先は次のリンクを参照してください：</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>データ可搬性に関する権利 </h5><p>ユーザーは、ユーザーの同意に基づいて当社が処理するか、契約の履行により自動処理されたデータを、本人または第三者に、一般的な機械可読形式で転送させる権利があります。他の責任者へのデータの直接転送を要求する場合、これは、技術的に可能な限りにおいてのみ実行されます。</p><h5>確認および情報開示に関する権利</h5><p>ユーザーは随時、該当する個人関連データを処理するかどうかについての確認書を、当社から受け取る権利があります。この場合、ユーザーは、当社から無償で、保存された本人の個人関連データに関する情報の開示を要求する権利があります。 </p><h5>修正に関する権利</h5><p>ユーザーは、該当する誤った個人関連データを即時修正するよう当社に要求する権利があります。処理の目的を考慮して、不完全な個人関連データの完全化を要求する権利があります。</p><h5>削除に関する権利（「忘却の権利」）</h5><p>DSGVO第17条に従い、ユーザーには該当する個人関連データを即刻削除するよう当社に要求する権利があり、当社は、以下の根拠の一つに該当する場合、個人関連データを即刻削除する義務を負います。 </p>\n<p><ol>\n<li>個人関連データがその収集またはその他の処理の目的に関して不要となった場合。</li>\n<li>当事者が第6条1項のa、または第9条2項のaにもとづく同意を撤回し、処理に関するその他の法的根拠を失った場合。</li>\n<li>当事者が第21条1項に従い、処理に対する撤回を申し立て、処理に関して優先される正当な根拠がなくなった場合、または、当事者が第21条2項に従い、処理に対する撤回を申し立てた場合。</li>\n<li> 個人関連データが違法に処理された場合。</li>\n<li>個人関連データの削除が、法的義務を履行するために、責任者が準拠すべき組合法、または加盟国の法律にもとづいて必要とされる場合。</li>\n<li>個人関連データが、第8条1項に従い、情報社会の提供するサービスに関連して収集された場合。</li>\n</ol></p>\n<h5>処理の制限に関する権利</h5><p>ユーザーはDSGVO第18条に従い、以下の前提条件がある場合、当社に対して処理の制限を要求する権利があります。</p>\n<p><ol>\n<li>個人関連データの正確性について当事者が異議を唱え、責任者が当該個人関連データの正確性について確認できる期間を設ける場合。</li>\n<li>当該処理が違法であり、当事者が個人関連データの削除を拒否し、そのかわりに当該個人関連データの使用制限を要求する場合。</li>\n<li>責任者は当該個人関連データをその処理目的に関してもはや必要としていないが、当事者が法的権限の主張、履行または弁護のためにこれを必要とする場合。</li>\n<li>当事者が処理に対する異議を第21条1項に従い申し立て、責任者の法的根拠が当事者のこれを上回ることが決定していない場合。</li>\n</ol></p><h5>SSLまたはTLS暗号化 </h5><p>このサイトはセキュリティ上の理由から、またユーザーがサイト運用者としての当社に送信する注文や問い合わせなど、機密事項の転送を保護する目的で、SSLまたはTLS暗号化を使用しています。暗号化された接続は、ブラウザのアドレスバーが「http://」から「https://」に置き換えられ、錠のマークがユーザーのブラウザバーに表示されることで識別できます。</p>\n\n<p>SSLまたはTLS暗号化が有効になると、ユーザーが当社に送信するデータを第三者が読むことはできません。</p><h4>3. データ保護責任者 </h4><h5>法的に規定されたデータ保護責任者</h5><p>当社は社内でデータ保護責任者を指名しました。</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627ベルリン<br>\nドイツ</p>\n\n<p>TEL: +498941325320<br>\nメール: datenschutz&#64;heydata.eu</p><h4>4. 当社ウェブサイトでのデータ収集</h4><h5>Cookie</h5><p>インターネットサイトは部分的にいわゆるCookieを使用しています。Cookieはユーザーのコンピュータに損害を与えるものではなく、ウィルスも含んでいません。Cookieは当社のサービスを、よりユーザーにとって使いやすく、効率的かつ安全にするために使用されます。Cookieは小さなテキストファイルで、ユーザーのコンピュータに配置され、ユーザーのブラウザに保存されます。</p>\n\n<p>当社が使用するCookieのほとんどはいわゆる「セッションCookie」です。これはユーザーが閲覧を終了すると自動的に削除されます。その他のCookieはユーザーが削除するまで、ユーザーの端末機器に保存されます。これらのCookieにより、当社は次回訪問時にユーザーのブラウザを再認識することができます。</p>\n\n<p>ユーザーはブラウザを、Cookieの設置について通知、Cookieをその都度許可、Cookieを特定のケースのみ承認または通常拒否、ならびにブラウザを閉じた時点でCookieを自動的に削除するよう設定することができます。Cookieを無効にすると、本ウェブサイトの機能性が制限されることがあります。</p>\n\n<p>電子通信処理の実行、またはユーザーが希望する特定の機能（買物カゴ機能など）の設定の実行に必要なCookieは、DSGVO第6条1項のfにもとづいて保存されます。ウェブサイト運用者は技術的なエラーのない、最適なサービス提供を目的としたCookieの保存について、正当な利益を有します。その他のCookie（ユーザーのサーフィン行動の分析など）が保存される場合、これらは本個人情報保護方針で別途取り扱われます。 </p><h5>サーバーログファイル</h5><p>サイトのプロバイダはユーザーのブラウザが自動的に当社に送信するいわゆるサーバーログファイルに、自動的に情報を収集し保存します。これには以下を含みます。</p>\n<p><ul>\n<li>ブラウザタイプおよびブラウザバージョン</li>\n<li>利用するオペレーションシステム</li>\n<li>リファラURL</li>\n<li>アクセスするコンピュータのホストネーム</li>\n<li>サーバーリクエストの時刻</li>\n<li>IPアドレス </li>\n</ul></p>\n\n<p>これらのデータを他のデータソースと組み合わせることはありません。</p>\n\n<p>データ処理の基本法はDSGVO第6条1項のfであり、契約または事前契約措置を履行する目的でデータの処理を実行します。</p>\n\n<h5>お問い合わせフォーム </h5><p>お問い合わせフォームから当社にお問い合わせいただく場合、フォームに記入された連絡先などの記入事項は、お問い合わせの対応や関連質問などがあった場合に備え、当社に保存されます。これらのデータを本人の同意なく転送することはありません。</p>\n\n<p>お問い合わせフォームに入力されたデータの処理は、本人の同意に基づいてのみ行われます（DSGVO第6条1項のa）。この同意は随時撤回することができます。撤回は当社への簡単なメール送信で可能です。撤回までに行われたデータ処理プロセスの正当性は、撤回によって影響を受けません。</p>\n\n<p>お問い合わせフォームに入力されたデータは、本人が削除を要求、保存に関する同意を撤回、またはデータ保存目的が損失（お問い合わせの処理が完了するなど）するまで、当社にて維持されます。強制法的規定、特に保管期限については、影響を受けません。</p>"])}
        }
      },
      "hr-HR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izjava o zaštiti osobnih podataka"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Brzi pregled zaštite podataka</h4><h5>Opće informacije</h5><p>Sljedeće informacije pružaju jednostavan pregled onoga što se događa s vašim osobnim podacima kada posjetite našu internetsku stranicu. Osobni podaci su svi podaci s kojima se može utvrditi vaš identitet. Detaljne informacije o zaštiti podataka možete pronaći u našoj Izjavi o zaštiti osobnih podataka koja je navedena u nastavku ovog teksta.</p><h5>Prikupljanje podataka na našoj internetskoj stranici</h5><p>Tko je odgovoran za prikupljanje podataka\nna ovoj internetskoj stranici?</p>\n<p>Obradu podataka na ovoj internetskoj stranici provodi operator internetske stranice. Njegove kontaktne podatke možete pronaći u impresumu ove internetske stranice.</p><h5>Kako prikupljamo vaše podatke?</h5><p>Vaše podatke s jedne strane prikupljamo tako da nam ih sami priopćite. To može uključivati, npr. podatke koje unesete u kontaktni obrazac.</p>\n\n<p>Ostale podatke automatski bilježe naši informacijski sustavi kada posjetite internetsku stranicu. To su prije svega tehnički podaci (npr. internetski preglednik, operacijski sustav ili vrijeme pregleda stranice). Ovi se podaci prikupljaju automatski čim posjetite našu internetsku stranicu.</p><h5>Za što upotrebljavamo vaše podatke?</h5><p>Dio podataka se prikuplja kako bi se osigurao pravilan rad internetske stranice. Ostali podaci mogu se upotrijebiti za analizu vašeg korisničkog ponašanja.</p>\n<h5>Koja prava imate u vezi sa svojim podacima?</h5><p>Imate pravo u bilo kojem trenutku besplatno dobiti podatke o podrijetlu, primatelju i namjeni vaših pohranjenih osobnih podataka. Osim toga, imate pravo zatražiti ispravak, blokiranje ili brisanje ovih podataka. Ako imate dodatna pitanja o navedenom ili o samoj zaštiti podataka, možete nam se u bilo kojem trenutku obratiti na adresu navedenu u impresumu. Također imate pravo podnijeti pritužbu nadležnom nadzornom tijelu.</p><h4>2. Opće informacije i obvezne informacije</h4><h5>Zaštita podataka</h5><p>Operatori ove internetske stranice vrlo ozbiljno shvaćaju zaštitu vaših osobnih podataka. S vašim osobnim podacima postupamo povjerljivo te u skladu sa zakonskim propisima o zaštiti osobnih podataka i ovom Izjavom o zaštiti osobnih podataka.</p>\n\n<p>Kada posjećujete ovu internetsku stranicu, prikupljaju se razni osobni podaci. Ova Izjava o zaštiti osobnih podataka objašnjava koje podatke prikupljamo i za što ih upotrebljavamo.</p>\n\n<p>Pri tome bismo željeli istaknuti da prijenos podataka putem interneta (npr. kada komuniciramo putem e-pošte) može imati sigurnosne nedostatke. Potpuna zaštita podataka od pristupa trećih osoba nije moguća.</p><h5>Napomena o odgovornom tijelu</h5><p>Tijelo odgovorno za obradu osobnih podataka na ovoj internetskoj stranici jest:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNjemačka</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-pošta: zentrale&#64;dutypay.eu</p>\n\n<p>Odgovorno tijelo je fizička ili pravna osoba koja sama ili zajedno s drugima odlučuje o svrhama i načinima obrade osobnih podataka (npr. imena, adresa e-pošte itd.).</p><h5>Povlačenje vaše privole za obradu osobnih podataka</h5><p>Mnogi postupci obrade osobnih podataka mogući su samo uz vašu izričitu privolu. Svoju privolu možete povući u bilo kojem trenutku. Dovoljno je samo da nam pošaljete neformalnu obavijest putem e-maila. Zakonitost obrade osobnih podataka do povlačenja privole ostaje neizmijenjena sve do samog opoziva.</p>\n\n<h5>Podnošenje pritužbe nadležnom nadzornom tijelu</h5><p>U slučaju kršenja zakona o zaštiti osobnih podataka ispitanik ima pravo podnijeti pritužbu nadležnom nadzornom tijelu. Nadležno nadzorno tijelo za pitanja o zaštiti osobnih podataka jest službenik za zaštitu osobnih podataka savezne države u kojoj se nalazi sjedište naše tvrtke. Popis službenika za zaštitu osobnih podataka i njihove kontaktne podatke možete pronaći na sljedećoj poveznici:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Pravo na prenosivost podataka</h5><p>Podatke koje automatski obrađujemo na temelju vaše privole ili radi ispunjavanja ugovora imate pravo proslijediti sebi ili trećoj osobi u uobičajenom, strojno čitljivom obliku. Ako zatražite izravan prijenos podataka drugom voditelju obrade, potonje će uslijediti samo ako je to tehnički izvedivo.</p><h5>Pravo na potvrdu i pristup</h5><p>Imate pravo u bilo kojem trenutku od nas dobiti potvrdu o tome obrađujemo li osobne podatke koji se odnose na vas. Ako je to slučaj, imate pravo zatražiti od nas besplatan pristup osobnim podacima koji su pohranjeni o vama.</p><h5>Pravo na ispravak</h5><p>Imate pravo bez odgađanja zatražiti od nas da ispravimo sve s vama povezane netočne osobne podatke. Uzimajući u obzir svrhe obrade, imate pravo zatražiti dopunu nepotpunih osobnih podataka.</p><h5>Pravo na brisanje („pravo na zaborav“)</h5><p>U skladu s člankom 17. Opće uredbe o zaštiti osobnih podataka imate pravo zatražiti da odmah izbrišemo osobne podatke koji se odnose na vas, a osobne podatke dužni smo odmah izbrisati ako se na njih odnosi jedan od sljedećih razloga:</p>\n<p><ol>\n<li>Osobni podaci više nisu potrebni u svrhe u koje su prikupljeni ili na bilo koji drugi način.</li>\n<li>Ispitanik povlači svoju privolu na kojoj se temeljila obrada u skladu s člankom 6. stavkom 1. točkom (a) ili člankom 9. stavkom 2. točkom (a) i ne postoji druga pravna osnova za obradu.</li>\n<li>Ispitanik podnosi u skladu s člankom 21. stavkom 1. prigovor na obradu i ne postoje nužni opravdani razlozi za obradu ili ispitanik podnosi prigovor na obradu u skladu s člankom 21. stavkom 2.</li>\n<li>Osobni podaci obrađeni su nezakonito.</li>\n<li>Brisanje osobnih podataka potrebno je za ispunjenje zakonske obveze prema pravu Unije ili zakonu država članica kojima podliježe voditelj obrade.</li>\n<li>Osobni podaci prikupljeni su u svezi s ponuđenim uslugama informacijskog društva u skladu s člankom 8. stavkom 1.</li>\n</ol></p><h5>Pravo na ograničenje obrade</h5><p>Prema članku 18. Opće uredbe o zaštiti osobnih podataka, imate pravo zahtijevati da ograničimo obradu ako je ispunjen jedan od sljedećih uvjeta:</p>\n<p><ol>\n<li>ispitanik osporava točnost osobnih podataka, na razdoblje kojim se voditelju obrade omogućuje provjera točnosti osobnih podataka;</li>\n<li>obrada je nezakonita i ispitanik odbija brisanje osobnih podataka te umjesto toga zahtijeva ograničenje upotrebe osobnih podataka;</li>\n<li>voditelj obrade više ne treba osobne podatke za potrebe obrade, ali ih ispitanik traži radi postavljanja, ostvarivanja ili obrane pravnih zahtjeva;</li>\n<li>ispitanik je podnio prigovor na obradu u skladu s člankom 21. stavkom 1. očekujući potvrdu nadilaze li legitimni razlozi voditelja obrade razloge ispitanika.</li>\n</ol></p><h5>SSL ili TLS šifriranje</h5><p>Ova internetska stranica koristi se SSL ili TLS šifriranjem radi sigurnosti i zaštite prijenosa povjerljivog sadržaja, kao što su, npr. narudžbe ili upiti koje nam pošaljete kao operatoru internetske stranice. Šifriranu vezu prepoznat ćete po tome što se adresna traka preglednika promijeni iz „http://„ u „https://„ i po simbolu zaključavanja u traci preglednika.</p>\n\n<p>Ako je SSL ili TLS šifriranje aktivirano, podatke koje nam proslijedite treće osobe ne mogu pročitati.</p><h4>3. Službenik za zaštitu osobnih podataka</h4><h5>Zakonski propisan službenik za zaštitu osobnih podataka</h5><p>Imenovali smo službenika za zaštitu osobnih podataka za svoju tvrtku.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNjemačka</p>\n\n<p>Telefon: +498941325320<br>\nE-pošta: datenschutz&#64;heydata.eu</p><h4>4. Prikupljanje podataka na našoj internetskoj stranici</h4><h5>Kolačići</h5><p>Internetske stranice djelomično koriste takozvane kolačiće. Kolačići na vašem računalu ne stvaraju nikakvu štetu i ne sadrže viruse. Kolačići nam služe kako bi naša ponuda bila jednostavnija za upotrebu, učinkovitija i sigurnija. Kolačići su male tekstne datoteke koje se pohranjuju na vaše računalo i spremaju u vaš preglednik.</p>\n\n<p>Većina kolačića kojima se koristimo su takozvani „sesijski kolačići“. Automatski se brišu nakon vašeg posjeta. Ostali kolačići ostaju pohranjeni na vašem uređaju sve dok ih ne izbrišete. Ovi nam kolačići omogućuju prepoznavanje vašeg preglednika prilikom sljedećeg posjeta.</p>\n\n<p>Svoj preglednik možete namjestiti tako da budete informirani o postavljanju kolačića te da to dopustite samo u pojedinačnim slučajevima, isključite prihvaćanje kolačića za određene slučajeve ili općenito i da aktivirate automatsko brisanje kolačića kada zatvorite preglednik. Ako se kolačići deaktiviraju, funkcionalnost ove internetske stranice može biti ograničena.</p>\n\n<p>Kolačići koji su potrebni za provođenje postupka komunikacije elektroničkim putem ili za pružanje određenih funkcija koje su vam potrebne (npr. funkcija košarice) pohranjuju se na temelju članka 6. stavka 1. točke (f) Opće uredbe o zaštiti osobnih podataka. Operator internetske stranice ima legitimni interes za pohranu kolačića u svrhu tehnički neometanog i optimiziranog pružanja svojih usluga. Ako se pohranjuju drugi kolačići (npr. kolačići za analizu vašeg\nponašanja pregledavanja), potonji će biti zasebno navedeni u ovoj Izjavi o zaštiti osobnih podataka.</p><h5>Datoteke zapisnika poslužitelja</h5><p>Davatelj pristupa stranicama automatski prikuplja i pohranjuje podatke u takozvane datoteke zapisnika poslužitelja koje nam vaš preglednik automatski prenosi. To su:</p>\n\n<p><ul>\n<li>vrsta i inačica preglednika,</li>\n<li>upotrijebljeni operacijski sustav, </li>\n<li>URL referenta,</li>\n<li>naziv glavnog računala s kojeg pristupate,</li>\n<li>vrijeme zahtjeva poslužitelja,</li>\n<li>IP adresa.</li>\n</ul></p>\n\n<p>Ti se podaci ne kombiniraju s drugim izvorima podataka.</p>\n\n<p>Osnova za obradu podataka je članak 6. stavak 1. točka (f) Opće uredbe o zaštiti osobnih podataka koji omogućuje obradu podataka za izvršenje ugovora ili predugovornih mjera.</p><h5>Kontaktni obrazac</h5><p>Ako nam pošaljete upite pomoću kontaktnog obrasca, vaše podatke iz obrasca za slanje upita, uključujući kontaktne podatke koje ste tamo naveli, pohranit ćemo u svrhu obrade upita i u slučaju dodatnih pitanja. Te podatke nećemo proslijediti trećim stranama bez vaše privole.</p>\n\n<p>Obrada podataka upisanih u kontaktni obrazac odvija se isključivo na temelju vaše privole (članak 6. stavak 1. točka (a) Opće uredbe o zaštiti osobnih podataka). Svoju privolu možete povući u bilo kojem trenutku. Dovoljno je samo da nam pošaljete neformalnu obavijest putem e-maila. Zakonitost postupaka obrade osobnih podataka do povlačenja privole ostaje neizmijenjena sve do samog povlačenja.</p>\n\n<p>Podaci koje unesete u kontaktni obrazac ostat će kod nas sve dok ne zatražite da ih izbrišemo, povučete svoju privolu za pohranu ili svrha pohrane podataka više ne bude primjenjiva (npr. nakon zaključene obrade vašeg zahtjeva). Obvezne zakonske odredbe – osobito razdoblja čuvanja – ostaju nepromijenjene.</p>"])}
        }
      },
      "lv-LV": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privātuma politika"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Īsumā par datu aizsardzību </h4><h5>Vispārīgi norādījumi</h5><p>Šie norādījumi sniedz vienkāršu pārskatu pār to, kas notiek ar jūsu personas datiem, kad jūs apmeklējat mūsu tīmekļa vietni. Personas dati ir visi dati, pēc kuriem jūs var identificēt. Plašāka informācija par tēmu “Datu aizsardzība” ir pieejama privātuma politikā šī teksta beigās.</p><h5>Datu vākšana mūsu tīmekļa vietnē</h5><p>Kas ir atbildīgs par datu vākšanu šajā tīmekļa vietnē?</p>\n\n<p>Datu apstrādi šajā tīmekļa vietnē veic tīmekļa vietnes operators. Tā kontaktinformācija ir norādīta šīs tīmekļa vietnes sadaļā “Ziņas par izdevēju”.</p><h5>Kā mēs vācam jūsu datus?</h5><p>Viens veids, kā tiek ievākti jūsu dati ir tas, ka jūs mums tos paziņojat. Tie, piemēram, var būt dati, kurus jūs ievadāt saziņas veidlapā.</p>\n\n<p>Cits datus automātiski vāc mūsu IT sistēmas, kad apmeklējat tīmekļa vietni. Tie, galvenokārt, ir tehniski dati (piemēram, interneta pārlūkprogramma, operētājsistēma vai lapas atvēršanas laiks). Šie dati tiek ievākti automātiski, tiklīdz jūs apmeklējat mūsu tīmekļa vietni.</p><h5>Kam mēs izmantojam šos datus?</h5><p>Daļa šo datu tiek ievākta, lai nodrošinātu nevainojamu tīmekļa vietnes darbību. Citi dati var tikt izmantoti, lai analizētu to, kā jūs lietojat vietni.</p><h5>Kādas ir jūsu tiesības attiecībā uz jūsu datiem?</h5><p>Jums ir tiesības jebkurā laikā bez maksas saņemt informāciju par jūsu saglabāto datu izcelsmi, saņēmēju un saglabāšanas nolūku. Turklāt jums ir tiesības pieprasīt šo datu labošanu, dzēšanu vai piekļuves liegšanu. Ar šo vai citiem jautājumiem saistībā ar datu aizsardzību jūs jebkurā laikā varat vērsties pie mums, rakstot uz sadaļā “Ziņas par izdevēju” norādīto adresi. Papildus tam jums ir tiesības iesniegt sūdzību atbildīgajā uzraudzības iestādē.</p><h4>2. Vispārīgi norādījumi un obligātā informācija</h4><h5>Datu aizsardzība</h5><p>Šo lapu operatori pret jūsu personas datu aizsardzību attiecas ļoti nopietni. Mēs jūsu personas datus apstrādājam konfidenciāli un saskaņā ar datu aizsardzības tiesību normām, kā arī šo privātuma politiku.</p>\n\n<p>Apmeklējot šo lapu, tiek ievākti dažādi personas dati. Šī privātuma politika paskaidro, kādus datus mēs ievācam un kam mēs tos izmantojam. </p>\n\n<p>Vēlamies Jūs informēt, ka datu pārraidei internetā (piemēram, komunikācijai e-pastā) var būt drošības nepilnības. Datu aizsardzība pret trešo personu piekļuvi bez nepilnībām nav iespējama.</p><h5>Norāde par pārzini</h5><p>Pārzinis, kas ir atbildīgs par datu apstrādi šajā tīmekļa vietnē, ir:</p>\n\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nVācija</p>\n\n<p>Tālrunis: +49 (0)631 5600 1600<br>\nE-pasts: zentrale&#64;dutypay.eu</p>\n\n<p>Pārzinis ir fiziska vai juridiska persona, kas viena vai kopā ar citiem izlemj par personas datu (piemēram, vārds, e-pasta adrese u.tml.) apstrādes nolūkiem un līdzekļiem.</p><h5>Jūsu piekrišanas par datu apstrādi atsaukšana</h5><p>Daudzas datu apstrādes darbības ir iespējamas tikai ar jūsu nepārprotamu piekrišanu. Jau sniegtu piekrišanu jūs jebkurā laikā varat atsaukt. Lai to izdarītu, pietiek ar neformāla paziņojuma nosūtīšanu mums pa e-pastu. Piekrišanas atsaukšana neskar līdz tam veiktās datu apstrādes tiesiskumu.</p>\n\n<h5>Tiesības iesniegt sūdzību atbildīgajā uzraudzības iestādē</h5><p>Datu aizsardzības pārkāpumu gadījumā datu subjektam ir tiesības iesniegt sūdzību atbildīgajā uzraudzības iestādē. Atbildīgā uzraudzības iestāde par datu aizsardzību ir tās federālās zemes datu aizsardzības speciālists, kurā ir mūsu uzņēmuma juridiskā adrese. Datu aizsardzības speciālistu saraksts, kā arī to kontaktinformācija ir pieejama šajā saitē:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Tiesības uz datu pārnešanu</h5><p>Jums ir tiesības, ka dati, kurus mēs esam automātiski apstrādājuši, balstoties uz jūsu piekrišanu, vai lai izpildītu līgumu, tiek izsniegti jums vai trešai personai plaši izmantotā, mašīnlasāmā formātā. Ja jūs pieprasāt tiešu datu pārnešanu citam pārzinim, tas tiek izdarīts tikai tiktāl, cik tas ir tehniski iespējams.</p><h5>Tiesības uz apstiprinājumu un informāciju</h5><p>Jums jebkurā laikā ir tiesības no mums saņemt apstiprinājumu par to, vai mēs apstrādājam jūsu personas datus. Apstiprinošas atbildes gadījumā jums ir tiesības mums bez maksas pieprasīt informāciju par saglabātajiem jūsu personas datiem.</p><h5>Tiesības uz labošanu</h5><p>Jums ir tiesības pieprasīt, lai mēs nekavējoties izlabojam nepareizus jūsu personas datus. Ņemot vērā apstrādes nolūkus, jums ir tiesības pieprasīt nepilnīgu personas datu papildināšanu.</p>\n<h5>Tiesības uz dzēšanu (“Tiesības tikt aizmirstam”)</h5><p>Saskaņā ar VDAR 17. pantu jums ir tiesības mums pieprasīt, ka jūsu personas dati nekavējoties tiek izdzēsti, un mums ir pienākums nekavējoties dzēst personas datus, ja ir viens no tālāk minētajiem iemesliem:</p>\n\n<p><ol>\n<li>Personas dati vairs nav nepieciešami saistībā ar nolūkiem, kādos tie tika vākti vai citādi apstrādāti.</li>\n<li>Datu subjekts atsauc savu piekrišanu, uz kuras pamata veikta apstrāde saskaņā ar 6. panta 1. punkta a) apakšpunktu vai 9. panta 2. punkta a) apakšpunktu, un ja nav cita likumīga pamata apstrādei.</li>\n<li>Datu subjekts iebilst pret apstrādi saskaņā ar 21. panta 1. punktu, un apstrādei nav nekāda svarīgāka leģitīma pamata, vai arī datu subjekts iebilst pret apstrādi saskaņā ar 21. panta 2. punktu.</li>\n<li>Personas dati ir apstrādāti nelikumīgi.</li>\n<li>Personas dati ir jādzēš, lai nodrošinātu, ka tiek pildīts juridisks pienākums, kas noteikts Savienības vai dalībvalsts tiesību aktos, kuri ir piemērojami pārzinim.</li>\n<li>Personas dati ir savākti saistībā ar informācijas sabiedrības pakalpojumu piedāvāšanu, kā minēts 8. panta 1. punktā.</li>\n</ol></p><h5>Tiesības ierobežot apstrādi</h5><p>Saskaņā ar VDAR 18. pantu jums ir tiesības pieprasīt ierobežot apstrādi, ja ir viens no šādiem apstākļiem:</p>\n<p><ol>\n<li>datu subjekts apstrīd personas datu precizitāti – uz laiku, kurā pārzinis var pārbaudīt personas datu precizitāti</li>\n<li>apstrāde ir nelikumīga, un datu subjekts iebilst pret personas datu dzēšanu un tās vietā pieprasa datu izmantošanas ierobežošanu</li>\n<li>pārzinim personas dati apstrādei vairs nav vajadzīgi, taču tie ir nepieciešami datu subjektam, lai celtu, īstenotu vai aizstāvētu likumīgas prasības</li>\n<li>datu subjekts ir iebildis pret apstrādi saskaņā ar 21. panta 1. punktu, kamēr nav pārbaudīts, vai pārziņa leģitīmie iemesli nav svarīgāki par datu subjekta leģitīmajiem iemesliem</li>\n</ol></p>\n<h5>SSL/TLS šifrēšana</h5><p>Drošības iemeslu dēļ un lai aizsargātu konfidenciāla satura, piemēram, pasūtījumu vai pieprasījumu, pārraidi mums kā vietnes operatoram, tiek izmantota SSL/TLS šifrēšana. Šifrētu savienojumu Jūs varat atpazīt pēc tā, ka pārlūkprogrammas adreses rindā “http://” tiek nomainīts uz “https://” un pēc atslēgas simbola.</p>\n\n<p>Ja SSL/TLS šifrēšana ir aktivizēta, trešās personas nevar lasīt datus, kurus jūs pārsūtat mums.</p><h4>3. Datu aizsardzības speciālists</h4><h5>Likumā noteiktais datu aizsardzības speciālists</h5><p>Mēs mūsu uzņēmumam esam piesaistījuši datu aizsardzības speciālistu.</p>\n\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nVācija</p>\n\n<p>Tālrunis:+498941325320<br>\nE-pasts: datenschutz&#64;heydata.eu</p><h4>4. Datu vākšana mūsu tīmekļa vietnē</h4><h5>Sīkdatnes</h5><p>Interneta lapas mēdz izmantot sīkdatnes. Sīkdatnes nerada kaitējumu jūsu datoram un nesatur vīrusus. Sīkdatnes kalpo tam, lai mūsu piedāvājumu padarītu lietotājiem ērtāku, efektīvāku un drošāku. Sīkdatnes ir nelielas teksta datnes, kuras tiek ievietotas jūsu datorā un kuras saglabā jūsu pārlūkprogramma.</p>\n\n<p>Lielākā daļa sīkdatņu, kuras mēs izmantojam, ir tā sauktās “sesijas sīkdatnes”. Tās tiek automātiski izdzēstas pēc jūsu apmeklējuma. Citas sīkdatnes tiek saglabātas jūsu gala iekārtā, līdz jūs tās izdzēšat. Šīs sīkdatnes mums ļauj atpazīst jūsu pārlūkprogrammu nākamā apmeklējuma reizē.</p>\n\n<p>Jūs varat iestatīt jūsu pārlūkprogrammā, ka jūs tiekat informēts par sīkdatņu ievietošanu un to atļaut tikai atsevišķos gadījumos, konkrētos gadījumos vai nekad neatļaut, kā arī iestatīt automātisku sīkdatņu dzēšanu, aizverot pārlūkprogrammu. Deaktivizējot sīkdatnes, šīs tīmekļa vietnes funkcionalitāte var būt ierobežota.</p>\n\n<p>Sīkdatnes, kas ir nepieciešamas elektroniskai komunikācijai vai konkrētu funkciju nodrošināšanai (piemēram, groza funkcija), tiek saglabātas, pamatojoties uz VDAR 6. panta 1. punkta f) apakšpunktu. Tīmekļa vietnes operatoram ir leģitīmas intereses saglabāt sīkdatnes, lai nodrošinātu nevainojamus un optimizētus pakalpojumus. Ciktāl tiek saglabātas citas sīkdatnes (piemēram, sīkdatnes jūsu interneta izmantošanas paradumu analizēšanai), tiek atsevišķi aprakstīts šajā privātuma politikā.</p><h5>Serveru žurnalēšanas datnes</h5><p>Šo lapu operators automātiski vāc un saglabā informāciju tā sauktajās serveru žurnalēšanas datnēs, kuras jūsu pārlūkprogramma automātiski nosūta mums. Tās ir:</p>\n\n<p><ul>\n<li>Pārlūkprogrammas veids un versija</li>\n<li>Izmantotā operētājsistēma</li>\n<li>Nosūtītāja URL</li>\n<li>Piekļūstošā datora resursdatora nosaukums</li>\n<li>Servera pieprasījuma laiks</li>\n<li>IP adrese</li>\n</ul></p>\n\n<p>Šie dati netiek apvienoti ar citiem datu avotiem.</p>\n\n<p>Datu apstrāde tiek veikta, pamatojoties uz VDAR 6. panta 1. punkta f) apakšpunktu, kurā tiek atļauta datu apstrāde līguma izpildei vai darbībām pirms līguma noslēgšanas.</p>\n<h5>Saziņas veidlapa</h5><p>Ja jūs mums nosūtat pieprasījumu, izmantojot saziņas veidlapu, tad mēs saglabājam pieprasījuma veidlapā norādīto informāciju, tostarp jūsu norādīto kontaktinformāciju, lai apstrādātu šo pieprasījumu un gadījumā, ja par to saņemam tālākus jautājumus. Mēs šos datus nenododam trešām personām bez jūsu piekrišanas.</p>\n\n<p>Saziņas veidlapā ievadīto datu apstrāde tātad notiek tikai tad, ja esat sniedzis savu piekrišanu (VDAR 6. panta 1. punkta a) apakšpunkts). Jūs šo piekrišanu varat atsaukt jebkurā laikā. Lai to izdarītu, pietiek ar neformāla paziņojuma nosūtīšanu mums pa e-pastu. Piekrišanas atsaukšana neskar līdz tam veiktās datu apstrādes tiesiskumu.</p>\n\n<p>Datus, kurus jūs ievadāt saziņas veidlapā, mēs glabājam, līdz jūs mums pieprasāt tos izdzēst, atsaucat savu piekrišanu par datu saglabāšanu vai ja zūd datu glabāšanas nolūks (piemēram, kad jūsu pieprasījuma apstrāde ir pabeigta). Tas neskar obligātus tiesību aktu noteikumus, jo īpaši attiecībā uz uzglabāšanas ilgumu.</p>"])}
        }
      },
      "lt-LT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pareiškimas apie privatumo apsaugą"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Trumpa privatumo apsaugos apžvalga</h4><h5>Bendrieji nurodymai</h5><p>Šiuose nurodymuose trumpai apžvelgiama, kas nutinka su jūsų asmens duomenimis, kai lankotės mūsų interneto svetainėje. Asmens duomenys – tai visi duomenys, kuriuos naudojant gali būti nustatyta jūsų tapatybė. Išsamią informaciją apie privatumą rasite po šiuo tekstu pateiktame mūsų pareiškime apie privatumo apsaugą.</p><h5>Duomenų rinkimas mūsų interneto svetainėje</h5><p>Kas yra atsakingas už duomenų rinkimą šioje interneto svetainėje?</p>\n<p>Duomenų rinkimą šioje interneto svetainėje atlieka interneto svetainės operatorius. Jo kontaktinius duomenis rasite interneto svetainės teisiniame pranešime.</p><h5>Kaip renkame jūsų duomenis?</h5><p>Viena vertus, jūsų duomenys renkami, kai jūs juos mums pranešate. Tai gali būti, pvz., duomenys, kuriuos jūs suvedate užpildydami paklausimo formą.</p>\n\n<p>Kitus duomenis automatiškai renka mūsų IT sistemos jums lankantis interneto svetainėje. Tai yra visų pirma techniniai duomenys (pvz., internetinė naršyklė, operacinė sistema arba puslapio peržiūros laikas). Šie duomenys renkami automatiškai, kai tik apsilankote mūsų interneto svetainėje.</p><h5>Kam naudojame jūsų duomenis?</h5><p>Dalis duomenų yra renkami siekiant užtikrinti nepriekaištingą interneto svetainės teikimą. Kiti duomenys gali būti naudojami analizuojant jūsų kaip naudotojo elgseną.</p><h5>Kokias su savo duomenimis susijusias teises turite?</h5><p>Jūs turite teisę bet kuriuo metu gauti nemokamą informaciją apie jūsų saugomų asmens duomenų kilmę, gavėjus ir tikslą. Be to, turite teisę pareikalauti šiuos duomenis ištaisyti, padaryti neprieinamus ar ištrinti. Dėl to ir kitais privatumo apsaugos klausimais galite bet kuriuo metu kreiptis teisiniame pranešime nurodytu adresu. Be to, turite teisę pateikti skundą kompetentingai priežiūros institucijai.</p><h4>2. Bendrieji nurodymai ir privaloma informacija</h4><h5>Privatumo apsauga</h5><p>Šios svetainės operatorius labai rimtai vertina jūsų asmens duomenų apsaugą. Mes tvarkome jūsų asmens duomenis konfidencialiai ir pagal duomenų apsaugą reglamentuojančius teisės aktus bei šį pareiškimą apie privatumo apsaugą.</p>\n\n<p>Jei naudojatės šia interneto svetaine, renkami įvairūs asmens duomenys. Pateiktas pareiškimas apie privatumo apsaugą paaiškina, kokius duomenis renkame ir kam jie naudojami.</p>\n\n<p>Nurodome, kad duomenų perdavimas internetu (pvz., elektroninio pašto ryšio metu) gali turėti pažeidžiamumo spragų. Neįmanoma užtikrinti duomenų apsaugą be jokių spragų nuo trečiųjų šalių prieigos.</p><h5>Nuoroda apie atsakingą įstaigą</h5><p>Už duomenų tvarkymą šioje interneto svetainėje atsakinga įstaiga yra:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nVokietija</p>\n\n<p>Telefonas: +49 (0)631 5600 1600<br>\nEl. paštas: zentrale&#64;dutypay.eu</p>\n\n<p>Atsakinga įstaiga yra fizinis ar juridinis asmuo, kuris vienas ar kartu su kitais sprendžia asmens duomenų (pvz., pavardžių, el. pašto adresų ar pan.) tvarkymo tikslų ir priemonių klausimus.</p><h5>Sutikimo tvarkyti duomenis atšaukimas</h5><p>Daugelis duomenų tvarkymo operacijų yra galimos tik gavus jūsų aiškų sutikimą. Jau duotą sutikimą galite bet kuriuo metu atšaukti. Tam pakanka el. paštu atsiųsto neformalaus pranešimo. Tai nedaro poveikio iki atšaukimo vykdyto duomenų tvarkymo teisėtumui.</p><h5>Teisė pateikti skundą kompetentingai priežiūros institucijai</h5><p>Duomenų teisinės apsaugos pažeidimų atveju duomenų subjektas turi teisę pateikti skundą kompetentingai priežiūros institucijai. Kompetentinga priežiūros institucija asmens duomenų teisinės apsaugos susijusiais klausimais yra žemių duomenų apsaugos pareigūnas toje federalinėje žemėje, kurioje yra mūsų įmonės buveinė. Duomenų apsaugos pareigūnų sąrašą bei jų kontaktinius duomenis rasite šioje nuorodoje:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Teisė į duomenų perkeliamumą</h5><p>Jūs turite teisę duomenis, kuriuos automatiškai tvarkome jūsų sutikimu arba vykdant sutartį, gauti įprastai naudojamu kompiuterio skaitomu formatu patys arba juos reikalauti pateikti trečiajai šaliai. Jei reikalaujate tiesiogiai perkelti duomenis kitam duomenų valdytojui, tai atliekama tik tada, jei tai techniškai įmanoma.</p><h5>Teisi gauti patvirtinimą ir informaciją</h5><p>Jūs turite teisę bet kuriuo metu gauti mūsų patvirtinimą apie tai, ar su jumis susiję asmens duomenys yra tvarkomi. Jei duomenys yra tvarkomi, jūs turite teisę gauti nemokamą informaciją apie jūsų išsaugotus asmens duomenis.</p><h5>Teisė reikalauti ištaisyti duomenis</h5><p>Jūs turite teisę reikalauti, kad mes nedelsiant ištaisytume su jumis susijusius neteisingus asmens duomenis. Atsižvelgiant į tvarkymo tikslus, jūs turite teisę reikalauti, kad būtų papildyti neišsamūs asmens duomenys.</p><h5>Teisė reikalauti ištrinti duomenis („teisė būti pamirštam“)</h5><p>Pagal BDAR 17 straipsnį turite teisę reikalauti, kad su jumis susiję asmens duomenys būtų nedelsiant ištrinti, o mes esame įpareigoti asmens duomenis nedelsiant ištrinti, jei yra tokios priežastys:</p>\n<p><ol>\n<li>asmens duomenys nebėra būtini tikslams, kuriems jie buvo surinkti arba buvo kitu būdu tvarkomi.</li>\n<li>Duomenų subjektas atšaukia sutikimą, kuriuo pagal 6 straipsnio 1 dalies a punktą arba 9 straipsnio 2 dalies a punktą grindžiamas duomenų tvarkymas, ir nėra jokio kito teisinio pagrindo tvarkyti duomenis.</li>\n<li>Duomenų subjektas nesutinka su duomenų tvarkymu pagal 21 straipsnio 1 dalį ir nėra viršesnių teisėtų priežasčių tvarkyti duomenis arba duomenų subjektas nesutinka su duomenų tvarkymu pagal 21 straipsnio 2 dalį.</li>\n<li>Asmens duomenys buvo neteisėtai tvarkomi.</li>\n<li>Asmens duomenys turi būti ištrinti laikantis Sąjungos arba valstybės narės teisėje, kuri taikoma duomenų valdytojui, nustatytos teisinės prievolės.</li>\n<li>Asmens duomenys buvo surinkti 8 straipsnio 1 dalyje nurodyto informacinės visuomenės paslaugų siūlymo kontekste.</li>\n</ol></p><h5>Teisė apriboti duomenų tvarkymą</h5><p>Remiantis BDAR 18 str. turite teisę reikalauti, kad būtų apribotas duomenų tvarkymas, kai taikomas vienas iš šių nurodytų atvejų:</p>\n<p><ol>\n<li>duomenų subjektas ginčija asmens duomenų tikslumą, duomenų tvarkymas apribojamas laikotarpiui, per kurį duomenų valdytojas gali patikrinti asmens duomenų tikslumą,</li>\n<li>asmens duomenų tvarkymas yra neteisėtas ir duomenų subjektas nesutinka, kad duomenys būtų ištrinti, ir vietoj to prašo apriboti jų naudojimą;</li>\n<li>valdytojui nebereikia asmens duomenų tvarkymo tikslais, tačiau jų reikia duomenų subjektui siekiant pareikšti, vykdyti arba apginti teisinius reikalavimus; arba</li>\n<li>duomenų subjektas pagal 21 straipsnio 1 dalį, kad asmens duomenys būtų tvarkomi, kol bus patikrinta, ar duomenų valdytojo teisėtos priežastys yra viršesnės už duomenų subjekto priežastis.</li>\n</ol></p><h5>SSL arba TLS šifravimas</h5></p>Šioje svetainėje saugumo sumetimais ir siekiant apsaugoti konfidencialaus turinio perdavimą, pavyzdžiui, užsakymus ar užklausas, kurias siunčiate mums kaip svetainės operatoriui, naudojamas SSL arba TLS šifravimas. Šifruotą ryšį atpažinsite iš naršyklės adreso eilutės pasikeitimo iš „http://“ į „https://“ ir spynos simbolio atsiradimo jūsų naršyklės eilutėje.</p>\n\n<p>Jei SSL arba TLS šifravimas yra suaktyvintas, jūsų mums siunčiamų duomenų negali perskaityti trečiosios šalys.</p>\n<h4>3. Duomenų apsaugos pareigūnas</h4><h5>Įstatymais numatytas duomenų apsaugos pareigūnas</h5><p>Savo įmonei paskyrėme duomenų apsaugos pareigūną.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nVokietija</p>\n\n<p>Telefonas: +498941325320<br>\nEl. paštas: datenschutz&#64;heydata.eu</p><h4>4. Duomenų rinkimas mūsų interneto svetainėje</h4><h5>Slapukai</h5><p>Interneto puslapiai dalinai naudoja slapukus. Slapukai nedaro žalos jūsų kompiuteriui ir neturi virusų. Slapukai yra skirti padaryti mūsų pasiūlymą patogesnį naudotojams, veiksmingesnį ir saugesnį. Slapukai – tai maži tekstiniai failai, kuriuos jūsų naudojama naršyklė išsaugo jūsų kompiuteryje.</p>\n\n<p>Dauguma mūsų naudojamų slapukų yra taip vadinamieji „seanso slapukai“. Pasibaigus jūsų apsilankymui jie automatiškai ištrinami. Kiti slapukai išlieka išsaugoti jūsų kompiuteryje, kol jų neištrinate. Šių slapukų pagalba kito apsilankymo metu atpažįstama jūsų naršyklė.</p>\n\n<p>Galite nusistatyti savo naršyklės nuostatas taip, kad būtumėte informuojami apie slapukų naudojimą ir leistumėte slapukus naudoti tik atskiru atveju, priimti slapukus tam tikrais atvejais arba bendrai neleisti jų naudoti bei suaktyvinti automatinį slapukų ištrynimą uždarant naršyklę. Išaktyvinus slapukus gali būti ribojamos šios interneto svetainės funkcijos.</p>\n\n<p>Slapukai, kurie yra reikalingi vykdyti elektroninius ryšius arba teikti tam tikras jūsų pageidaujamas funkcijas (pvz., pirkinių krepšelio funkciją), išsaugomi pagal BDAR 6 str. 1 dalies f punktą. Siekdamas užtikrinti techniškai nepriekaištingą ir optimizuotą savo paslaugų teikimą, interneto svetainės operatorius turi teisėtą interesą išsaugoti slapukus. Jei išsaugomi kiti slapukai (pvz., slapukai, skirti analizuoti jūsų naršymo elgseną), jie šiame pareiškime apie privatumo apsaugą nagrinėjami atskirai.</p><h5>Serverio žurnalų failai</h5><p>Svetainių teikėjas automatiškai renka ir išsaugo informaciją taip vadinamuosiuose serverio žurnalų failuose, kuriuos jūsų naršyklė mums automatiškai perduoda. Tai yra:</p>\n<p><ul>\n<li>naršyklės tipas ir naršyklės versija;</li>\n<li>naudojama operacinė sistema;</li>\n<li>nurodomasis URL adresas;</li>\n<li>prieigos kompiuterio pagrindinio kompiuterio vardas;</li>\n<li>serverio užklausos laikas;</li>\n<li>IP adresas.</li>\n</ul></p>\n\n<p>Šie duomenys nederinami su kitais duomenų šaltiniais.</p>\n\n<p>Tvarkymo pagrindas yra BDAR 6 str. 1 dalies f punktas, pagal kurį tvarkyti duomenis leidžiama vykdant sutartį arba ikisutartines priemones.</p>\n<h5>Paklausimo forma</h5><p>Jei užklausas mums pateikiate naudodami paklausimo formą, jūsų užklausos formos duomenis, įskaitant ten jūsų suvestus duomenis, išsaugosime užklausos tvarkymo tikslu ir tiems atvejams, jei kiltų tolesnių klausimų. Šių duomenų neperduodame be jūsų sutikimo.</p>\n\n<p>Paklausimo formoje įvesti duomenys tvarkomi remiantis jūsų sutikimu (BDAR 6 straipsnio 1 dalies a punktas). Šį sutikimą galite bet kuriuo metu atšaukti. Tam pakanka el. paštu atsiųsto neformalaus pranešimo. Tai nedaro poveikio iki atšaukimo vykdyto duomenų tvarkymo operacijų teisėtumui.</p>\n\n<p>Duomenys, kuriuos įvedate paklausimo formoje, lieka mums, kol pareikalausite juos ištrinti, atšaukti sutikimą saugoti arba nebelieka duomenų saugojimo tikslo (pvz., po to, kai baigiamas jūsų užklausos tvarkymas). Tai nedaro poveikio privalomojo pobūdžio teisės nuostatoms, visų pirma saugojimo laikotarpiams.</p>"])}
        }
      },
      "pt-PT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Política de privacidade"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Visão geral da proteção de dados</h4><h5>Informações gerais</h5><p>As informações que se seguem oferecem uma noção geral sobre o que acontece com os seus dados pessoais ao visitar o nosso website. Por dados pessoais entende-se todos os dados que permitem a sua identificação pessoal. Para informações detalhadas sobre a proteção de dados, consulte a nossa política de privacidade que apresentamos mais adiante neste texto.</p><h5>Recolha de dados no nosso website</h5><p>Quem é responsável pela recolha de dados neste website?</p>\n<p>O tratamento dos dados neste website é realizado pelo operador do website. Pode consultar os seus dados de contacto no aviso legal deste website.</p>\n\n<h5>De que forma procedemos à recolha dos seus dados?</h5><p>Em parte, os seus dados são recolhidos com base na comunicação que nos faz dos mesmos. Por exemplo, pode tratar-se de dados que tenha introduzido num formulário de contacto.</p>\n\n<p>Outros dados são recolhidos de forma automática pelos nossos sistemas de TI ao visitar o website. Trata-se sobretudo de dados técnicos (por exemplo, navegador de Internet, sistema operativo ou hora de acesso à página). A recolha destes dados decorre automaticamente assim que aceder ao nosso website.</p>\n<h5>Para que fins utilizamos os seus dados?</h5><p>Uma parte dos dados é recolhida para garantir uma disponibilização sem falhas do website. Outros dados podem ser utilizados para a análise do seu comportamento de utilizador.</p>\n<h5>Quais são os seus direitos relativamente aos seus dados?</h5><p>Tem, a qualquer momento, o direito de obter gratuitamente informações sobre a origem, os destinatários e a finalidade dos seus dados pessoais guardados. Adicionalmente, tem o direito de exigir a retificação, o bloqueio ou a eliminação destes dados. Neste contexto e relativamente a outras questões sobre a proteção de dados, pode, a qualquer momento, entrar em contacto connosco através do endereço referido no aviso legal. Para além disso, tem o direito de apresentar reclamação à autoridade de controlo competente.</p>\n<h4>2. Informações gerais e obrigatórias</h4><h5>Proteção de dados</h5><p>Os operadores destas páginas dão grande importância à proteção dos seus dados pessoais. Os seus dados pessoais são tratados de forma confidencial, assim como em conformidade com as disposições legais de proteção de dados e a presente política de privacidade.</p>\n\n<p>Ao utilizar este website, são recolhidos diversos dados pessoais. A presente política de privacidade explica que dados serão recolhidos e para que finalidade.</p>\n\n<p>Alertamos para o facto de que a transmissão de dados na Internet (por exemplo, no caso de comunicação por e-mail) pode apresentar falhas de segurança. Não é possível garantir uma proteção dos dados sem falhas contra o acesso por terceiros.</p>\n\n<h5>Informação relativamente à entidade responsável</h5><p>A entidade responsável pelo tratamento de dados neste website é a:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlemanha</p>\n\n<p>Telefone: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>A entidade responsável é a pessoa singular ou coletiva que, individualmente ou em conjunto com outros, decide sobre as finalidades e os meios de tratamento dos dados pessoais (por exemplo, nomes, endereços de e-mail ou semelhantes).</p>\n<h5>Revogação do seu consentimento para o tratamento dos dados</h5><p>Muitos processos aplicados ao tratamento de dados são apenas possíveis mediante o seu consentimento expresso. Pode revogar, a qualquer momento, um consentimento previamente dado. Para tal, é suficiente que nos envie uma comunicação informal por e-mail. A licitude do tratamento de dados realizado até à revogação não é comprometida pela mesma.</p><h5>Direito de apresentar reclamação à autoridade de controlo competente</h5><p>No caso de infrações às normas de proteção de dados, o titular dos dados tem o direito de apresentar reclamação à autoridade de controlo competente. A autoridade de controlo competente em questões legais de proteção de dados é o encarregado da proteção de dados do estado federal em que a nossa empresa\ntem a sua sede. Pode consultar uma lista dos encarregados da proteção de dados com os respetivos contactos na ligação que se segue:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Direito de portabilidade dos dados</h5><p>Tem o direito de receber os dados, que tratamos com base no seu consentimento ou de forma automatizada para a execução de um contrato, num formato de uso corrente e de leitura automática, ou de solicitar a sua transmissão a terceiros. No caso de exigir a transmissão direta dos dados a outro responsável, isto será apenas realizado na medida em que tal seja tecnicamente possível.</p>\n\n<h5>Direito a confirmação e de acesso</h5><p>Tem, a qualquer momento, o direito de obter da nossa parte uma confirmação sobre se dados pessoais que lhe digam respeito são ou não objeto de tratamento. Se for o caso, tem o direito de nos exigir gratuitamente informação sobre os seus dados pessoais guardados.</p><h5>Direito de retificação</h5><p>Tem o direito de exigir-nos a retificação imediata de dados pessoais inexatos que lhe digam respeito. Tendo em conta as finalidades do tratamento, tem o direito de exigir que os seus dados pessoais incompletos sejam completados.</p><h5>Direito à eliminação («direito a ser esquecido»)</h5><p>Nos termos do artigo 17.º do RGPD, tem o direito de exigir-nos a eliminação imediata dos seus dados pessoais, sendo que nós temos a obrigação de apagar imediatamente os dados pessoais caso se aplique um dos seguintes motivos:</p>\n<p><ol>\n<li>Os dados pessoais deixaram de ser necessários para as finalidades que motivaram a sua recolha ou tratamento.</li>\n<li>O titular retira o consentimento em que se baseia o tratamento nos termos do artigo 6.º, n.º 1, alínea a), ou do artigo 9.º, n.º 2, alínea a), e se não existir outro fundamento jurídico para o tratamento.</li>\n<li>O titular opõe-se ao tratamento nos termos do artigo 21.º, n.º 1 e não existem interesses legítimos prevalecentes que justifiquem o tratamento, ou o titular opõe-se ao tratamento nos termos do artigo 21.º, n.º 2.</li>\n<li>Os dados pessoais foram tratados ilicitamente.</li>\n<li>Os dados pessoais têm de ser eliminados para o cumprimento de uma obrigação jurídica decorrente do direito da União ou de um Estado-Membro a que o responsável esteja sujeito.</li>\n<li>Os dados pessoais foram recolhidos no contexto da oferta de serviços da sociedade da informação segundo o artigo 8.º, n.º 1.</li>\n</ol></p>\n<h5>Direito à limitação do tratamento</h5><p>Nos termos do artigo 18.º do RGPD, tem o direito de obter da nossa parte a limitação do tratamento, se se aplicar uma das seguintes situações:</p>\n<p><ol>\n<li>Se o titular dos dados contestar a exatidão dos dados pessoais, durante um período que permita ao responsável verificar a sua exatidão.</li>\n<li>Se o tratamento for ilícito e o titular dos dados se opuser à eliminação dos dados pessoais e solicitar, em contrapartida, a limitação da sua utilização.</li>\n<li>Se o responsável já não precisar dos dados pessoais para fins de tratamento, mas esses dados sejam requeridos pelo titular para efeitos de declaração, exercício ou defesa de direitos num processo judicial.</li>\n<li>Se o titular dos dados se tiver oposto ao tratamento nos termos do artigo 21.º, n.º 1, até se verificar que os motivos legítimos do responsável prevalecem sobre os do titular dos dados.</li>\n</ol></p>\n<h5>Encriptação SSL ou TLS</h5><p>Por motivos de segurança e para a proteção da transmissão\nde conteúdos confidenciais, tais como, por exemplo, encomendas ou pedidos que nos sejam enviados enquanto operador do website, esta página utiliza uma encriptação SSL ou TLS. Pode identificar uma ligação encriptada através da barra de endereço do navegador que muda de «http://» para «https://», e através do símbolo de um cadeado na barra do seu navegador.</p>\n\n<p>Se a encriptação SSL ou TLS estiver ativada, os dados que nos são transmitidos não poderão ser lidos por terceiros.</p>\n<h4>3. Encarregado da proteção de dados</h4><h5>Encarregado da proteção de dados legalmente prescrito</h5><p>Contratámos para a nossa empresa um encarregado da proteção de dados.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAlemanha</p>\n\n<p>Telefone: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Recolha de dados no nosso website</h4><h5>Cookies</h5><p>As páginas de Internet utilizam em parte os chamados cookies. Os cookies não provocam danos no seu computador e não contêm vírus. Os cookies servem para tornar a nossa oferta mais adequada para o utilizador, mais eficaz e mais segura. Os cookies são pequenos ficheiros de texto que são colocados no seu computador e guardados pelo seu navegador.</p>\n\n<p>Os cookies utilizados por nós são maioritariamente os chamados «cookies de sessão». Estes são automaticamente eliminados depois de sair da nossa página. Outros cookies ficarão armazenados no seu dispositivo até que os elimine. Estes cookies permitem-nos reconhecer o seu navegador na sua próxima visita.</p>\n\n<p>Pode configurar o seu navegador de forma a ser informado sobre a colocação de cookies e permitir cookies apenas em casos particulares, excluir a aceitação de cookies em casos específicos ou de forma geral e ativar a eliminação automática dos cookies ao fechar o navegador. Se desativar os cookies, a funcionalidade deste website poderá ficar limitada.</p>\n\n<p>Os cookies necessários para a execução do processo de comunicação eletrónica ou para a disponibilização de determinadas funções solicitadas (por exemplo, a função de cesto de compras) são armazenados com base no artigo 6.º, n.º 1, alínea f) do RGPD. O operador do website tem um interesse legítimo no armazenamento de cookies para garantir uma disponibilização tecnicamente irrepreensível e otimizada dos seus serviços. Caso sejam guardados outros cookies (por exemplo, cookies para a análise do seu comportamento de navegação), estes serão abordados separadamente\nnesta política de privacidade.</p>\n\n<h5>Ficheiros de registo do servidor</h5><p>O fornecedor das páginas recolhe e guarda automaticamente informações nos denominados ficheiros de registo do servidor (server log files), os quais o seu navegador nos transmite automaticamente. Estas informações são:</p>\n<p><ul>\n<li>Tipo e versão do navegador</li>\n<li>Sistema operativo utilizado</li>\n<li>URL de referência</li>\n<li>Nome de host do computador de acesso</li>\n<li>Hora do pedido do servidor</li>\n<li>Endereço IP</li>\n</ul></p>\n\n<p>Não reunimos estes dados com outras fontes de dados.</p>\n\n<p>A base para o tratamento dos dados é o artigo 6.º, n.º 1, alínea f) do RGPD, que permite o tratamento dos dados para fins de execução de um contrato ou de medidas pré-contratuais.</p>\n<h5>Formulário de contacto</h5><p>Se nos enviar pedidos através de um formulário de contacto,\nos seus dados retirados do formulário, incluindo os dados de contacto que facultar, serão guardados para fins de processamento do pedido e para o caso de questões complementares. Estes dados não são transmitidos a terceiros sem o seu consentimento.</p>\n\n<p>O tratamento dos dados facultados através do formulário de contacto será assim exclusivamente realizado com base no seu consentimento (artigo 6.º, n.º 1, alínea a) do RGPD). Pode revogar o seu consentimento a qualquer momento. Para tal, é suficiente que nos envie uma comunicação informal por e-mail. A licitude dos processos de tratamento de dados realizados até à revogação não é comprometida pela mesma.</p>\n\n<p>Os dados facultados por si no formulário de contacto permanecem na nossa posse até solicitar a sua eliminação, revogar o seu consentimento de armazenamento ou\ndeixar de se aplicar o motivo para o armazenamento dos dados (por exemplo, após a conclusão do tratamento do seu pedido). As disposições legais obrigatórias – em particular os prazos de conservação – permanecem inalteradas.</p>\n\n\n"])}
        }
      },
      "ro-RO": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declarație privind protecția datelor"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Protecția datelor pe scurt</h4><h5>Informații generale</h5><p>Următoarele informații vă prezintă simplu și pe scurt ceea ce se întâmplă cu datele dumneavoastră cu caracter personal atunci când vizitați site-ul nostru web. Date cu caracter personal sunt toate datele cu care puteți fi identificat personal. Găsiți informații detaliate cu privire la subiectul protecției datelor în declarația noastră privind protecția datelor, care urmează sub acest text.</p><h5>Colectarea datelor pe site-ul nostru web</h5><p>Cine este responsabil pentru colectarea datelor pe acest site web?</p>\n<p>Prelucrarea datelor pe acest site web este efectuată de către operatorul site-ului web. Datele de contact ale acestuia le puteți găsi pe acest site web la Informații legale.</p>\n<h5>Cum colectăm datele dumneavoastră?</h5><p>Pe de o parte, datele dumneavoastră sunt colectate prin transmiterea lor de către dumneavoastră. În acest sens poate fi vorba de ex. despre date pe care le introduceți într-un formular de contact.</p>\n\n<p>Alte date sunt colectate automat de către sistemele noastre IT la vizitarea site-ului web. Acestea sunt în special date tehnice (de ex. browserul web, sistemul de operare sau ora accesării paginii). Colectarea acestor date are loc automat, de îndată ce intrați pe site-ul nostru web.</p><h5>În ce scopuri utilizăm datele dumneavoastră?</h5><p>O parte dintre date sunt colectate pentru a garanta că vă punem la dispoziție site-ul nostru web fără erori. Alte date pot fi utilizate pentru analiza comportamentului dumneavoastră în calitate de utilizator.</p>\n<h5>Ce drepturi aveți cu privire la datele dumneavoastră?</h5><p>Aveți în orice moment dreptul de a primi gratuit informații despre originea, destinatarul și scopul utilizării datelor dumneavoastră cu caracter personal stocate de noi. De asemenea, aveți dreptul de a solicita corectarea, blocarea sau ștergerea acestor date. Legat de aceste aspecte, precum și pentru întrebări suplimentare legate de protecția datelor, ne puteți contacta oricând la adresa menționată la Informații legale. De asemenea, aveți dreptul de a depune o plângere la autoritatea de supraveghere competentă.</p><h4>2. Informații generale și informații obligatorii</h4><h5>Protecția datelor</h5><p>Operatorii acestui site web tratează protecția datelor dumneavoastră cu maximă seriozitate. Datele dumneavoastră cu caracter personal sunt tratate în mod confidențial și în conformitate cu reglementările legale privind protecția datelor și cu prezenta declarație privind protecția datelor.</p>\n\n<p>Atunci când utilizați acest site web, sunt colectate diverse date cu caracter personal. Prezenta declarație privind protecția datelor explică ce date colectăm și în ce scopuri le folosim.</p>\n\n<p>Vă rugăm să aveți în vedere că transmiterea datelor pe Internet (de ex. în cadrul comunicării prin e-mail) poate prezenta vulnerabilități de securitate. O protecție completă a datelor împotriva accesării lor de către terți nu este posibilă.</p>\n<h5>Informație privind entitatea responsabilă</h5><p>Entitatea responsabilă pentru prelucrarea datelor pe acest site web este:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nGermania</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Entitatea responsabilă este persoana fizică sau juridică care, singură sau împreună cu alte persoane, decide asupra scopurilor și mijloacelor de prelucrare a datelor cu caracter personal (de ex. nume, adrese de e-mail etc.).</p>\n<h5>Retragerea consimțământului dumneavoastră pentru prelucrarea datelor</h5><p>Multe operațiuni de prelucrare a datelor sunt posibile numai cu acordul dumneavoastră expres. Vă puteți retrage în orice moment consimțământul dat. În acest scop este suficient să ne trimiteți o notificare informală prin e-mail. Retragerea consimțământului nu afectează legalitatea prelucrărilor de date care au avut loc anterior retragerii consimțământului.</p>\n<h5>Dreptul de a depune o plângere la autoritatea de supraveghere competentă</h5><p>În cazul încălcării legislației privind protecția datelor, persoana vizată are dreptul de a depune o plângere la autoritatea de supraveghere competentă. Autoritatea de supraveghere competentă pentru chestiuni legate de protecție a datelor este\nautoritatea responsabilă cu protecția datelor din landul în care își are sediul societatea noastră. Găsiți o listă a entităților responsabile cu protecția datelor și a detaliilor de contact ale acestora accesând următorul link:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p>\n<h5>Dreptul la portabilitatea datelor</h5><p>Aveți dreptul de a vi se furniza, dumneavoastră personal sau unui terț, datele pe care le prelucrăm automat în baza consimțământului dumneavoastră sau în scopul încheierii unui contract, într-un format utilizat în mod curent și care poate fi citit automat. Transferul direct al datelor către o altă persoană responsabilă, în cazul în care îl solicitați, se va face numai dacă este posibil din punct de vedere tehnic.</p>\n<h5>Dreptul de a solicita o confirmare și dreptul la informații</h5><p>Aveți în orice moment dreptul de a obține din partea noastră o confirmare dacă se prelucrează sau nu date cu caracter personal care vă privesc. În acest caz, aveți dreptul să solicitați informații gratuite de la noi cu privire la datele cu caracter personal stocate care vă vizează.</p><h5>Dreptul la rectificare</h5><p>Aveți dreptul de a obține de la noi neîntârziat rectificarea datelor cu caracter personal inexacte care vă privesc. Ținându-se seama de scopurile prelucrării datelor, aveți dreptul de a obține completarea datelor cu caracter personal incomplete.</p>\n<h5>Dreptul la ștergerea datelor („dreptul de a fi uitat”)</h5><p>În conformitate cu articolul 17 RGPD, aveți dreptul să ne solicitați ștergerea neîntârziată a datelor cu caracter personal care vă privesc, iar noi avem obligația de a șterge neîntârziat datele cu caracter personal fără întârzieri nejustificate în cazul în care se aplică unul dintre următoarele motive:</p>\n<p><ol>\n<li>Datele cu caracter personal nu mai sunt necesare pentru îndeplinirea scopurilor pentru care au fost colectate sau prelucrate.</li>\n<li>Persoana vizată își retrage consimțământul în baza căruia are loc prelucrarea, în conformitate cu articolul 6 alineatul 1 litera a sau cu articolul 9 alineatul 2 litera a și nu există niciun alt temei juridic pentru prelucrarea datelor</li>\n<li>Persoana vizată se opune prelucrării în temeiul articolului 21 alineatul 1 și nu există motive legitime care să prevaleze în ceea ce privește prelucrarea, sau persoana vizată se opune prelucrării în temeiul articolului 21 alineatul 2.</li>\n<li>Datele cu caracter personal au fost prelucrate ilegal.</li>\n<li>Ștergerea datelor cu caracter personal este obligatorie în scopul îndeplinirii unei obligații legale în temeiul dreptului Uniunii sau al dreptului intern sub incidența căruia se află persoana responsabilă.</li>\n<li>Datele cu caracter personal au fost colectate în legătură cu oferirea de servicii ale societății informaționale în conformitate cu articolul 8 alineatul 1.</li>\n</ol></p>\n<h5>Dreptul la restricționarea prelucrării</h5><p>În conformitate cu articolul 18 RGPD, aveți dreptul de a ne solicita restricționarea prelucrării datelor în cazul în care este îndeplinită una din următoarele condiții:</p>\n<p><ol>\n<li>persoana vizată contestă exactitatea datelor, pentru o perioadă care îi permite persoanei responsabile să verifice exactitatea datelor;</li>\n<li>prelucrarea este ilegală, iar persoana vizată se opune ștergerii datelor cu caracter personal, solicitând în schimb restricționarea utilizării lor;</li>\n<li>persoana responsabilă nu mai are nevoie de datele cu caracter personal în scopul prelucrării, dar persoana vizată i le solicită pentru constatarea, exercitarea sau apărarea unui drept în instanță; sau</li>\n<li>persoana vizată s-a opus prelucrării în conformitate cu articolul 21 alineatul 1, pentru intervalul de timp în care se verifică dacă drepturile legitime ale persoanei responsabile prevalează asupra celor ale persoanei vizate.</li>\n</ol></p>\n<h5>Criptare SSL respectiv TLS</h5><p>Din motive de securitate și pentru protecția transmiterii de conținuturi confidențiale, cum ar fi de exemplu comenzi sau solicitări pe care ni le transmiteți nouă în calitate de operatori ai site-ului web, această pagină utilizează criptarea SSL respectiv TLS. Puteți recunoaște o conexiune criptată prin faptul că în bara de adrese a browserului http:// se schimbă în „https://” și prin afișarea simbolului lacăt în bara de adrese a browserului.</p>\n\n<p>Atunci când este activată criptarea SSL respectiv TLS, datele pe care ni le transmiteți nu pot fi citite și de terți.</p>\n<h4>3. Responsabilul cu protecția datelor</h4><h5>Responsabilul cu protecția datelor conform prevederilor legale</h5><p>Pentru societatea noastră am desemnat un responsabil cu protecția datelor.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nGermania</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Colectarea datelor pe site-ul nostru web</h4><h5>Cookie-uri</h5><p>Unele site-uri web folosesc parțial așa-numitele cookie-uri. Cookie-urile nu produc daune computerului dumneavoastră și nu conțin viruși. Cookie-urile sunt folosite pentru a face oferta noastră mai ușor de utilizat, mai eficientă și mai sigură. Cookie-urile sunt mici fișiere-text care sunt plasate pe computerul dumneavoastră și sunt salvate de browserul dumneavoastră.</p>\n\n<p>Majoritatea cookie-urilor utilizate de noi sunt așa-numitele „cookie-uri de sesiune”. Ele sunt șterse automat la terminarea vizitei dumneavoastră. Alte cookie-uri rămân stocate pe dispozitivul dumneavoastră până când le ștergeți. Aceste cookie-uri ne permit să recunoaștem browserul dumneavoastră la următoarea vizită.</p>\n\n<p>Vă puteți configura browserul astfel încât să fiți informat cu privire la utilizarea cookie-urilor și să permiteți cookie-urile numai în cazuri individuale, să excludeți acceptarea cookie-urilor pentru anumite cazuri sau în toate cazurile și să activați ștergerea automată a cookie-urilor la închiderea browserului. La dezactivarea cookie-urilor, funcționalitatea acestui site web poate fi restricționată.</p>\n\n<p>Cookie-urile necesare pentru efectuarea operațiunii de comunicare electronică sau pentru furnizarea anumitor funcții de care aveți nevoie (de ex. funcția coșului de cumpărături) sunt stocate în baza articolului 6 alin. 1 lit. f RGPD. Operatorul site-ului are un interes legitim în stocarea cookie-urilor pentru furnizarea fără erori tehnice și optimizată a serviciilor sale. În cazul în care sunt stocate alte cookie-uri (de ex. cookie-uri pentru analiza comportamentului dumneavoastră de navigare), aceste vor fi tratate separat în prezenta declarație de protecție a datelor.</p>\n\n\n<h5>Fișiere-jurnal ale serverului</h5><p>Furnizorul site-ului web colectează și salvează automat informații în așa-numitele fișiere jurnal ale serverului, pe care browserul dumneavoastră ni le transmite automat. Acestea sunt:</p>\n<p><ul>\n<li>tipul și versiunea browserului</li>\n<li>sistemul de operare utilizat</li>\n<li>URL sursă</li>\n<li>numele de gazdă al computerului de pe care se face accesul</li>\n<li>ora solicitării către server</li>\n<li>adresa IP</li>\n</ul></p>\n\n<p>Nu se realizează o fuziune a acestor date cu alte surse de date.</p>\n\n<p>Prelucrarea datelor are loc în baza articolului 6 alin. 1 lit. f RGPD, care permite prelucrarea datelor în vederea executării unui contract sau a unor prevederi antecontractuale.</p>\n<h5>Formularul de contact</h5><p>Atunci când ne transmiteți solicitări folosind formularul de contact, informațiile dumneavoastră din formularul de solicitare, inclusiv datele de contact pe care le-ați furnizat acolo, vor fi stocate de noi în scopul procesării solicitării și pentru cazul unor întrebări ulterioare. Nu transmitem aceste date fără consimțământul dumneavoastră.</p>\n\n<p>Astfel, prelucrarea datelor furnizate în formularul de contact are loc exclusiv în baza consimțământului dumneavoastră (articolul 6 alin. 1 lit. a RGPD). Vă puteți retrage în orice moment acest consimțământ. În acest scop este suficient să ne trimiteți o notificare informală prin e-mail. Retragerea consimțământului nu afectează legalitatea operațiunilor de prelucrare a datelor care au avut loc anterior retragerii consimțământului.</p>\n\n<p>Datele introduse de dumneavoastră în formularul de contact sunt păstrate la noi până când ne solicitați ștergerea lor, vă retrageți consimțământul pentru stocarea acestor date sau nu mai este valabil scopul stocării datelor (de ex. la finalizarea procesării solicitării dumneavoastră). Această prevedere nu aduce atingere dispozițiilor legale obligatorii - în special perioadelor de păstrare a datelor.</p>\n\n\n\n"])}
        }
      },
      "ru-RU": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Политика конфиденциальности"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Защита данных</h4><h5>Общие сведения</h5><p>В данном разделе вы найдёте общие сведения о том, что происходит с вашими персональными данными при посещении нашего сайта. Персональные данные — это информация, благодаря которой вас можно идентифицировать. Более подробную информацию о защите данных вы найдёте в нашем положении о конфиденциальности.</p>\n<h5>Сбор данных на сайте</h5><p>Кто несёт ответственность за сбор данных на нашем сайте?</p>\n<p>Обработка персональных данных на сайте ведётся владельцем сайта. Контактные данные компании можно найти на сайте в разделе «О нас».</p><h5>Как ведётся сбор данных?</h5><p>Мы собираем данные, которые нам сообщаются. Например, данные из заполняемой вами контактной формы.</p>\n\n<p>Другие данные сохраняются ИТ-системами автоматически при посещении сайта. Прежде всего, это технические характеристики (например, браузер, операционная система или точное время запроса страницы). Сбор данных происходит автоматически, как только вы заходите на сайт.</p><h5>Зачем нужен сбор данных?</h5><p>Сбор данных обеспечивает бесперебойное пользование сайтом. Данные также могут использоваться для анализа поведения пользователя.</p>\n<h5>Какие права вы имеете в отношении персональных данных?</h5><p>В любое время вы можете бесплатно получить информацию о происхождении, получателе или цели сбора персональных данных. Кроме того, вы имеете право на внесение изменений, блокировку или удаление данных. По вопросам персональных данных можно в любое время обратиться к нам по адресу, указанному в разделе «О нас». Вы также можете подать жалобу в уполномоченный орган.</p><h4>2. Общие сведения и обязательная информация</h4><h5>Защита данных</h5><p>Владелец сайта несёт ответственность за защиту ваших персональных данных. Сбор и хранение персональных данных ведутся строго конфиденциально в соответствии с положениями законодательства о защите информации, а также с настоящим положением.</p>\n\n<p>При посещении сайта ведётся сбор различных данных. В настоящем положении о конфиденциальности указано, какие данные собираются и для чего они используются.</p>\n\n<p>Обращаем ваше внимание на то, что передача данных в Интернете (например, переписка по электронной почте) небезопасна. Абсолютную защиту данных от доступа к ним третьих лиц обеспечить невозможно.</p><h5>Контакты ответственной организации</h5><p>Организация, ответственная за обработку персональных данных на сайте:</p>\n<p>DutyPay GmbH<br>\nПирмазенсера, 1<br>\n67655 Кайзерслаутерн<br>\nГермания</p>\n\n<p>Телефон: +49 (0)631 5600 1600<br>\nЭлектронная почта: zentrale&#64;dutypay.eu</p>\n\n<p>Ответственная организация — это физическое или юридическое лицо, которое единолично или совместно с другими принимает решение о целях и способах обработки персональных данных (например, имена, электронная почта и т. п.).</p><h5>Отзыв согласия на обработку персональных данных</h5><p>Многие операции по обработке данных возможны только с полного согласия пользователя. Вы можете в любое время отозвать согласие на обработку данных. Достаточно отправить сообщение в свободной форме на адрес нашей электронной почты. Правомерность обработки данных до отзыва согласия не подлежит оспариванию.</p>\n\n<h5>Подача жалобы в уполномоченный орган</h5><p>В случае нарушения положения о защите данных потерпевший может обратиться с жалобой в уполномоченный орган. Уполномоченным органом по вопросам защиты персональных данных является уполномоченный по защите персональных данных федеральной земли, в которой находится наша компания. Список уполномоченных по защите персональных данных, а также их контакты можно найти по ссылке:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p>\n<h5>Право на передачу персональных данных</h5><p>Вы имеете право на передачу данных, обработанных автоматически на основании вашего согласия или вследствие заполнения договора, третьему лицу в общепринятом, пригодном для машинного считывания формате. Передача данных другому ответственному лицу осуществляется только при условии наличия технических возможностей.</p><h5>Право на получение справочной информации</h5><p>Вы также имеете право на получение информации о том, производится ли обработка ваших персональных данных. В данном случае вы вправе бесплатно получить информацию о том, какие персональные данные обрабатываются.</p><h5>Право на внесение изменений</h5><p>Вы имеете право потребовать незамедлительно внести изменения в ваши персональные данные, если они неверны. Принимая во внимание цели обработки, вы имеете право потребовать дополнить персональные данные.</p><h5>Право на удаление («право на забвение»)</h5><p>Согласно статье 17 Общего регламента о защите данных вы вправе потребовать от нас незамедлительного удаления персональных данных, и мы обязуемся эти данные незамедлительно удалить в случае, если:</p>\n<p><ol>\n<li>Персональные данные не нужны более в целях, для которых они собирались или обрабатывались.</li>\n<li>Субъект данных отзывает согласие, на основании которого осуществлялась обработка согласно статье 6 п. 1 лит. а или статье 9 п. 2 лит. а, и нет никаких других юридических оснований для дальнейшей обработки.</li>\n<li>Субъект данных заявляет согласно статье 21 п. 1 своё несогласие с обработкой данных, и нет никаких других первоочередных обоснованных требований по обработке, или субъект данных заявляет согласно статье 21 п. 2 своё несогласие с обработкой данных.</li>\n<li>Персональные данные обрабатывались незаконно.</li>\n<li>Удаление персональных данных необходимо для выполнения правовых обязательств согласно праву Европейского Союза или союзных государств, под юрисдикцию которых подпадает ответственное лицо.</li>\n<li>Персональные данные были собраны в отношении услуг, предоставляемых информационным обществом согласно статье 8 п. 1.</li>\n</ol></p><h5>Право на ограничение обработки</h5><p>Согласно статье 18 Общего регламента о защите данных вы имеете право потребовать ограничения обработки, если:</p>\n<p><ol>\n<li>правильность персональных данных оспаривается субъектом данных, а именно на период времени, в течение которого ответственное лицо может перепроверить правильность персональных данных;</li>\n<li>обработка является неправомерной, и субъект данных отказывается от удаления данных, но требует ограничения по использованию персональных данных;</li>\n<li>ответственное лицо более не нуждается в персональных данных, но данные необходимы субъекту данных для предъявления, исполнения или защиты правовых претензий;</li>\n<li>субъект данных заявил о своём несогласии с обработкой согласно статье 21 п. 1 пока не установлено, превалируют ли правовые основания ответственного лица над правовыми основаниями субъекта данных.</li>\n</ol></p><h5>Шифрование SSL/TLS</h5><p>По соображениям безопасности, а также в целях защиты передачи конфиденциального контента, например, заказов и заявок, которые вы отправляете владельцу сайта, на данном сайте используется протоколы шифрования SSL или TLS. Зашифрованное соединение можно узнать по изменению адресной строки браузера с “http://” на “https://” и значку замка в строке браузера.</p>\n\n<p>Если протокол шифрования SSL или TLS активирован, то передаваемые нам данные не попадут к третьим лицам.</p><h4>3. Уполномоченный по защите данных</h4><h5>Законный уполномоченный по защите данных</h5><p>Уполномоченный по защите данных нашей компании:</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nГермания</p>\n\n<p>Телефон: +498941325320<br>\nЭлектронная почта: datenschutz&#64;heydata.eu</p><h4>4. Сбор данных на сайте</h4><h5>Куки</h5><p>Интернет-сайты иногда используют так называемые куки. Куки не причиняют вреда компьютеру и не содержат вирусов. Они служат для того, чтобы сделать услуги более удобными для пользователя, эффективными и полезными. Куки — это небольшие текстовые файлы, которые хранятся в браузере компьютера.</p>\n\n<p>Большинство используемых нами куки — это так называемые сессионные куки. Они автоматически удаляются после того, как вы покинули сайт. Другие куки остаются на компьютере до их удаления. Эти куки позволяют нам распознать браузер при следующем посещении.</p>\n\n<p>Вы можете настроить браузер так, чтобы получать информацию об использовании куки, разрешать их использовать только в исключительных или в определённых случаях или вообще отключить, а также активировать автоматическое удаление куки при закрытии браузера. При деактивации куки функционирование данного сайта может быть ограничено.</p>\n\n<p>Куки, которые необходимы для осуществления электронной коммуникации или доступа к определенным функциям (например, «Корзина», сохраняются на основании ст. 6 п. 1 лит. f Общего регламента о защите данных. Владелец сайта правомерно заинтересован в сборе куки-файлов для обеспечения бесперебойной работы сайта и оптимального предоставления услуг. Другим куки (например, куки для анализа поисковых запросов) в данном положении о защите данных посвящён отдельный пункт.</p>\n\n<h5>Лог-файлы сервера</h5><p>Провайдер сайта автоматически собирает информацию в так называемых лог-файлах сервера, которые ваш браузер также отправляет нам автоматически:</p>\n<p><ul>\n<li>тип и версия браузера;</li>\n<li>операционная система;</li>\n<li>URL перехода;</li>\n<li>имя хоста компьютера;</li>\n<li>точное время поискового запроса;</li>\n<li>IP-адрес.</li>\n</ul></p>\n\n<p>Слияние или объединение выше указанных данных с какими-либо данными из других источников не осуществляется.</p>\n\n<p>Основанием для обработки данных является ст. 6 п. 1 лит. f Общего регламента о защите данных, разрешающего обработку данных в рамках заключения договора или проведения преддоговорных мероприятий.</p><h5>Контактная форма</h5><p>При заполнении контактной формы ваши данные из регистрационной формы, включая указанные контактные данные, в целях обработки заявки и в случае возникновения дополнительных вопросов сохраняются у нас. Без вашего согласия эти данные никому не передаются.</p>\n\n<p>Обработка указанных в контактной форме данных осуществляется исключительно на основании вашего согласия (ст. 6 п. 1 лит. а Общего регламента о защите данных). Вы можете в любое время отозвать согласие. Достаточно отправить сообщение в свободной форме на адрес нашей электронной почты. Правомерность обработки данных до их отзыва не подлежит оспариванию.</p>\n\n<p>Указанные вами в контактной форме данные остаются у нас, пока вы не запросите их удалить, не отзовёте согласие на хранение, или отсутствует причина для хранения (например, после обработки вашего запроса). Настоящий пункт не распространяется на некоторые правовые положения, предусмотренные законом о сроках хранения.</p>"])}
        }
      },
      "sv-SE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dataskyddspolicy"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Dataskydd i översikt</h4><h5>Allmän information</h5><p>Följande anvisningar ger en enkel överblick över vad som händer med dina personuppgifter när du besöker vår webbplats. Personuppgifter är alla uppgifter med vilka du personligen kan identifieras. Utförlig information om ämnet dataskydd hittar du i vår dataskyddspolicy som finns under denna text.</p><h5>Dataregistrering på vår webbplats</h5><p>Vem är ansvarig för dataregistreringen på denna webbplats?</p>\n<p>Databehandlingen på denna webbplats sker genom webbplatsoperatörens försorg. Dennes kontaktuppgifter finns under företagsinformationen för denna webbplats.</p><h5>Hur registrerar vi dina uppgifter?</h5><p>Dina uppgifter inhämtas dels genom att du meddelar oss dem. Härvidlag kan det t.ex. handla om uppgifter som du angett i ett kontaktformulär.</p>\n\n<p>Andra uppgifter kommer automatiskt registreras vid besök på webbplatsen genom våra IT-system. Detta är framför allt tekniska data (t.ex. webbläsare, operativsystem eller tidpunkt för inläsning av webbsidan). Registreringen av denna data sker automatiskt så snart du besöker vår webbplats.</p><h5>Vad används dina uppgifter till? </h5><p>En del av uppgifterna inhämtas för att säkerställa en felfri funktion av webbplatsen. Andra uppgifter kan användas för att analysera dess användarförhållanden.</p><h5>Vilka rättigheter har du beträffande dina uppgifter?</h5><p>Du har när som helst rätt att utan kostnad erhålla upplysningar om ursprung till, mottagare av och syfte med dina lagrade personuppgifter. Du har även rätt att kräva korrigering, begränsning av åtkomst till (spärra) eller radering av dessa uppgifter. Vid frågor om detta eller vid andra frågor kring dataskydd kan du när som helst kontakta oss på den adress som anges i den rättsliga informationen. Vidare står dig en besvärsrätt hos relevanta tillsynsmyndigheter till förfogande.</p><h4>2. Allmänna anvisningar och obligatorisk information </h4><h5>Dataskydd</h5><p>Ägaren till denna sida tar skyddet av dina personuppgifter på stort allvar. Vi behandlar dina personuppgifter konfidentiellt och i enlighet med lagstadgade dataskyddsföreskrifter och med denna dataskyddspolicy.</p>\n\n<p>Olika personuppgifter hämtas in när denna webbplats används. Denna föreliggande dataskyddsdeklaration förklarar vilka uppgifter vi registrerar och vad vi använder dem till.</p>\n\n<p>Vi vill påpeka att dataöverföring på internet (t.ex. vid kommunikation via e-post) kan ha säkerhetsbrister. Ett garanterat skydd av uppgifter mot åtkomst av tredje part är inte möjligt.</p><h5>Uppgifter om ansvarigt organ</h5><p>Ansvarigt verksamhetsställe för databehandlingen på denna webbplats är:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nTyskland</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-post: zentrale&#64;dutypay.eu</p>\n\n<p>Det ansvariga organet är den fysiska eller juridiska person, som ensam eller gemensamt med andra beslutar om ändamål och åtgärder för behandling av personuppgifter (t.ex. namn, e-postadresser o. dyl.)</p>\n<h5>Återkallande av medgivande till  databehandling</h5><p>Många databehandlingsprocedurer är endast möjliga med ditt uttryckliga medgivande. Du kan när som helst återkalla ett redan givet medgivande. Det räcker med att du skickar ett enkelt meddelane via e-post till oss. Rättmätigheten i den fram till återkallandet utförda databehandlingen förblir oberörd av återkallandet.</p>\n\n<h5>Besvärsrätt hos relevant tillsynsmyndighet</h5><p>I händelse av dataskyddsrättsliga överträdelser står för den berörda parten en besvärsrätt hos relevant tillsynsmyndighet till förfogande. Relevant tillsynsmyndighet i dataskyddsrättsliga frågor är den dataskyddsansvarige i den delstat där vårt företag har sitt säte. En lista med dataskyddsansvariga och deras kontaktuppgifter finns på följande länk:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Rätt till överföringsbarhet av uppgifter</h5><p>Uppgifter som vi på grundval av ditt medgivande eller för att fullgöra avtalsskyldigheter bearbetar automatiskt, har du rätt att få dig, eller tredje part, tillsända i ett gängse, maskinläsbart format. Om du begär direkt överföring av data till någon annan sker detta endast så långt det är tekniskt görbart.</p><h5>Rätt till bekräftelse och upplysningar</h5><p>Du har rätt att när som helst av oss erhålla en bekräftelse på om personuppgifter som gäller dig har behandlats. Om detta är fallet  har du rätt att begära kostnadsfria upplysningar av oss om personuppgifter som lagrats om dig.</p><h5>Rätt till rättelse</h5><p>Du har rätt att kräva ofördröjlig korrigering av berörda felaktiga personuppgifter av oss. Under beaktande av syftet med behandlingen har du rätt att kräva komplettering av ofullständiga personuppgifter.</p><h5>Rätt till radering (\"rätten att glömmas bort\")</h5><p>Du har rätt att enligt artikel 17 i DSGVO (dataskyddslagstiftningen) kräva att personuppgifter som gäller dig raderas ofördröjligen. Vi är förpliktigade att ofördröjligen radera personuppgifter om något av följande skäl föreligger:</p>\n<p><ol>\n<li>Personuppgifterna är för de syften för vilka de inhämtats, eller på annat vis har behandlats, inte längre nödvändiga.</li>\n<li>Den berörda personen återkallar sitt medgivande på vilket behandling enligt artikel 6 avsnitt 1 bokstav a eller artikel 9 avsnitt 2 bokstav a grundade sig och det saknas annan rättslig grund för behandling.</li>\n<li>Den berörda personen motsätter sig behandlingen enligt artikel 21 avsnitt 1 och det föreligger inga prioriterade skäl för behandlingen, eller den berörda personen motsätter sig behandlingen enligt artikel 21 avsnitt 2.</li>\n<li>Personuppgifterna har behandlats på ett otillåtet sätt.</li>\n<li>Raderandet av personuppgifter syftar till att uppfylla de rättsliga förpliktelserna enligt den europeiska unionsrätten eller lagarna i medlemsstaterna som den ansvarige är underkastad.</li>\n<li>Personuppgifterna har inhämtats i relation till erbjudna tjänster från IT-företaget enligt artikel 8 avsnitt 1.</li>\n</ol></p><h5>Rätt till begränsning av behandlingen</h5><p>Du har enligt artikel 18 DSGVO rätt att av oss kräva begränsningar i behandlingen om någon av följande förutsättningar föreligger:</p>\n<p><ol>\n<li>Korrektheten i personuppgifterna för den berörda personen bestrids och under en tidsperiod som gör det möjligt för den ansvarige att kontrollera korrektheten i personuppgifterna,</li>\n<li>Behandlingen är otillåten och den berörda personen avstår från att kräva radering av personuppgifterna och kräver istället begränsning av användningen av personuppgifter;</li>\n<li>Den ansvarige behöver inte längre personuppgifterna för syftet med behandlingen men den berörda personen behöver dem för gällandegörande, utövande eller försvarande av rättsliga anspråk, eller</li>\n<li>Den berörda personen har motsatt sig behandlingen enligt artikel 21 avsnitt 1 och så länge det fortfarande inte är fastslaget huruvida den ansvariges skäliga grund eller den berörda personens skäliga grund väger över.</li>\n</ol></p><h5>SSL- resp. TLS-kryptering</h5><p>Denna sida nyttjar SSL- resp. TLS-kryptering av säkerhetsskäl och för att skydda överföring av konfidentiellt innehåll, exempelvis beställningar eller förfrågningar som du skickar till oss som webbplatsoperatör. En krypterad anslutning känns igen på att adressraden i webbläsaren slår om från “http://” till “https://” och på hänglåssymbolen i webbläsarens textrad.</p>\n\n<p>Om SSL- resp. TLS-kryptering är aktiverat kan data som du överför till oss inte avlyssnas av tredje part.</p><h4>3. Dataskyddsansvarig person</h4><h5>I lag påbjuden dataskyddsansvarig person</h5><p>Vi har för vårt bolags räkning anlitat en dataskyddsansvarig person.</p>\n\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nTyskland</p>\n\n<p>Telefon: +498941325320<br>\nE-post: datenschutz&#64;heydata.eu</p><h4>4. Dataregistrering på vår webbplats </h4><h5>Cookies</h5><p>Internetsidor använder ibland så kallade cookies. Cookies gör ingen skada på datorn och innehåller inga virus. Cookies tjänar till att göra vårt utbud användarvänligt, effektivt och säkert. Cookies är små textfiler som lagras på datorn och som din webbläsare sparar. De flesta cookies vi använder är så kallade sessionscookies.</p>\n\n<p>Dessa cookies raderas automatiskt efter ditt besök på vår webbplats. Andra cookies blir kvar på användarenheten tills du raderar dem. Dessa cookies gör det möjligt för oss att känna igen din webbläsare vid nästa besök.</p>\n\n<p>Du kan ställa in webbläsaren så att du informeras om utplaceringen av cookies och endast tillåter cookies i enskilda fall, godkänner cookies för särskilda fall eller generellt blockerar cookies. Du kan också ställa in automatisk radering av cookies när webbläsaren stängs. Om du inaktiverar cookies kan funktionaliteten på denna webbplats bli begränsad.</p>\n\n<p>Cookies som krävs för att genomföra elektroniska kommunikationsförfaranden eller för att tillhandahålla vissa av dig efterfrågade funktioner (t.ex. varukorgsfunktioner) sparas grundat på artikel 6 avsnitt 1 punkt f) i GDPR. Webbplatsoperatören har ett berättigat intresse att lagra cookies för tekniskt felfritt och optimerat tillhandahållande av sina tjänster. Såvida andra cookies (t.ex. cookies för analys av dina surfförhållanden) sparas, behandlas detta separat i denna dataskyddsdeklaration.</p><h5>Serverloggfiler</h5><p>Leverantören av sidorna inhämtar och sparar automatiskt information i så kallade Server-Log-filer som din webbläsare automatiskt vidarebefordrar till oss. Dessa är:</p>\n<p><ul>\n<li>Webbläsare och webbläsarversion</li>\n<li>Använt operativsystem</li>\n<li>Ursprungs-URL</il>\n<li>Värdnamn för åtkomstdatorn</li>\n<li>Tidpunkt för serveranropet</li>\n<li>IP-adress</li>\n</ul></p>\n\n<p>En samkörning av dessa uppgifter med andra datakällor kommer inte att företas.</p>\n\n<p>Rättslig grund för databehandlingen är artikel 6 avsnitt 1 pkt. f) i GDPR, vilken tillåter behandling av data för att uppfylla en avtalsförpliktelse eller föregående åtgärder som krävs för detsamma.</p>\n<h5>Kontaktformulär</h5><p>Om du gör en förfrågan till oss via kontaktformuläret kommer dina uppgifter från kontaktformuläret, inklusive de av dig däri angivna kontaktuppgifterna, att sparas med syfte att behandla förfrågan och för eventuella kompletterande förfrågningar. Dessa uppgifter lämnar vi inte vidare utan ditt medgivande.</p>\n\n<p>Behandlingen av angivna uppgifter i kontaktformuläret sker därför endast grundat på ditt medgivande (artikel 6 avsnitt 1 pkt. a) i GDPR). Du kan när som helst återkalla ditt medgivande. Det räcker med att du skickar ett enkelt meddelande via e-post till oss. Rättmätigheten i de fram till återkallandet utförda databehandlingsförfarandena förblir oberörd av återkallandet.</p>\n\n<p>De uppgifter du anger i kontaktformuläret förblir hos oss, tills du begär att vi raderar dem, tills du återkallar ditt medgivande till lagring eller tills syftet med datalagringen bortfaller (t.ex. att behandlingen av din förfrågan avslutats). Obligatoriska rättsliga bestämmelser – speciellt lagringsperioder – berörs inte av detta.</p>"])}
        }
      },
      "sk-SK": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhlásenie o ochrane osobných údajov"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Stručný prehľad o ochrane osobných údajov</h4><h5>Všeobecné informácie</h5><p>Nasledujúce informácie vám poskytnú stručný prehľad o tom, čo sa stane s vašimi osobnými údajmi pri návšteve našej internetovej stránky. Osobné údaje sú všetky údaje, vďaka ktorým môžete byť osobne identifikovaní. Podrobné informácie o téme ochrany osobných údajov nájdete v našom vyhlásení o ochrane osobných údajov uvedenom v ďalšej časti.</p><h5>Zber údajov na našej internetovej stránke</h5><p>Kto je zodpovedný za zber údajov na tejto internetovej stránke?</p>\n<p>Spracúvanie údajov na tejto internetovej stránke prebieha zo strany prevádzkovateľa internetovej stránky. Kontakty na tohto prevádzkovateľa nájdete na tejto internetovej stránke v časti Právne informácie.</p>\n<h5>Akým spôsobom zbierame vaše údaje?</h5><p>Vaše údaje zbierame na jednej strane na základe toto, že nám ich poskytnete. Môžu to byť napr. údaje, ktoré uvediete v kontaktnom formulári.</p>\n\n<p>Ostatné údaje sa zbierajú naše IT systémy automaticky pri návšteve internetovej stránky. Sú to predovšetkým technické údaje (napr. internetový prehliadač, operačný systém alebo čas načítania stránky). Tieto údaje sa zbierajú automaticky hneď pri vstupe na našu internetovú stránku.</p><h5>Na čo použijeme vaše údaje?</h5><p>Časť údajov zbierame na účely zabezpečenia bezchybného poskytovania internetovej stránky. Ostatné údaje môžu byť použité na analýzu vášho užívateľského správania.</p><h5>Aké práva máte v súvislosti s vašimi údajmi?</h5><p>Máte právo kedykoľvek bezplatne získať informáciu o pôvode, príjemcoch a účele vašich uložených osobných údajov. Okrem toho máte právo žiadať opravu, zablokovanie alebo vymazanie týchto údajov. V tejto súvislosti a v prípade ďalších otázok týkajúcich sa ochrany osobných údajov sa môžete kedykoľvek obrátiť na nás na adrese uvedenej v časti Právne informácie. Okrem toho máte právo podať sťažnosť na príslušnom dozornom orgáne.</p><h4>2. Všeobecné informácie a povinné informácie</h4><h5>Ochrana osobných údajov</h5><p>Prevádzkovatelia týchto stránok berú ochranu vašich osobných údajov veľmi vážne. S vašimi osobnými údajmi zaobchádzame dôverne a v súlade so zákonnými predpismi na ochranu osobných údajov a s týmto vyhlásením o ochrane osobných údajov.</p>\n\n<p>Pri používaní tejto internetovej stránky sa zbierajú rôzne osobné údaje. Toto vyhlásenie o ochrane osobných údajov objasňuje, ktoré údaje zbierame a na čo ich používame.</p>\n\n<p>Upozorňujeme na to, že pri prenose údajov cez internet (napr. pri komunikácii prostredníctvom e-mailu) sa môžu vyskytnúť bezpečnostné medzery. Absolútna ochrana údajov pred prístupom tretích strán nie je možná. </p><h5>Informácia o prevádzkovateľovi</h5><p>Za spracúvanie údajov na tejto internetovej stránke je zodpovedný prevádzkovateľ:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNemecko</p>\n\n<p>Telefón: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Prevádzkovateľ je fyzická alebo právnická osoba, ktorá sama alebo spoločne s inými rozhoduje o účele a prostriedkoch spracúvania osobných údajov (napr. mien, e-mailových adries a pod.).</p>\n<h5>Odvolanie vášho súhlasu so spracúvaním osobných údajov</h5><p>Mnohé procesy spracúvania osobných údajov sú možné len s vaším výslovným súhlasom. Poskytnutý súhlas môžete kedykoľvek odvolať. Stačí nám poslať neformálne oznámenie prostredníctvom e-mailu. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania vychádzajúceho zo súhlasu pred jeho odvolaním.</p>\n<h5>Právo podať sťažnosť na príslušnom dozornom orgáne</h5><p>V prípade porušenia ochrany osobných údajov má dotknutá osoba právo podať sťažnosť na príslušnom dozornom orgáne. Príslušným dozorným orgánom pre otázky týkajúce dodržiavania predpisov na ochranu osobných údajov je Zodpovedná osoba spolkového kraja, v ktorom má naša spoločnosť svoje sídlo. Zoznam zodpovedných osôb a ich kontaktné údaje nájdete na tomto odkaze: </p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Právo na prenosnosť údajov</h5><p>Máte právo získať osobné údaje, ktoré spracúvame automatizovane na základe vášho súhlasu alebo na účely plnenia zmluvy, v štruktúrovanom, bežne používanom a strojovo čitateľnom formáte a máte právo preniesť tieto údaje ďalšiemu prevádzkovateľovi. Ak žiadate o priamy prenos údajov inému prevádzkovateľovi, tento prenos sa uskutoční len ak je to technicky možné.</p><h5>Právo na potvrdenie a na prístup k údajom</h5><p>Máte právo získať od nás potvrdenie o tom, či sa spracúvajú osobné údaje, ktoré sa vás týkajú. Ak tomu tak je, máte právo bezplatne žiadať od nás informáciu o uložených osobných údajoch, ktoré sa vás týkajú.</p><h5>Právo na opravu</h5><p>Máte právo žiadať od nás, aby sme bez zbytočného odkladu opraviliv nesprávne osobné údaje, ktoré sa vás týkajú. So zreteľom na účely spracúvania máte právo na doplnenie neúplných osobných údajov.</p>\n<h5>Právo na vymazanie („právo na zabudnutie“)</h5><p>Podľa článku 17 GDPR máte právo žiadať od nás, aby sme bez zbytočného odkladu vymazali osobné údaje, ktoré sa vás týkajú a my sme povinní bez zbytočného odkladu vymazať osobné údaje, ak je splnený niektorý z týchto dôvodov:</p>\n<p><ol>\n<li>Osobné údaje už nie sú potrebné na účely, na ktoré sa získavali alebo inak spracúvali.</li>\n<li>Dotknutá osoba odvolá súhlas, na základe ktorého sa spracúvanie vykonáva, podľa článku 6 ods. 1 písm. a) alebo článku 9 ods. 2 písm. a), a ak neexistuje iný právny základ pre\nspracúvanie.</li>\n<li>Dotknutá osoba namieta voči spracúvaniu podľa článku 21 ods. 1 a neprevažujú žiadne oprávnené dôvody na spracúvanie alebo dotknutá osoba namieta voči spracúvaniu podľa článku 21 ods. 2.</li>\n<li>Osobné údaje sa spracúvali nezákonne.</li>\n<li>Osobné údaje musia byť vymazané, aby sa splnila zákonná povinnosť podľa práva Únie alebo práva členského štátu, ktorému prevádzkovateľ podlieha.</li>\n<li>Osobné údaje sa získavali v súvislosti s ponukou služieb na informačnej spoločnosti podľa článku 8 ods. 1.</li>\n</ol></p>\n<h5>Právo na obmedzenie spracúvania</h5><p>Podľa článku 18 GDPR máte právo žiadať od nás, aby sme obmedzili spracúvanie, pokiaľ ide o jeden z týchto prípadov:</p>\n<p><ol>\n<li>dotknutá osoba napadne správnosť osobných údajov, a to počas obdobia umožňujúceho prevádzkovateľovi overiť správnosť osobných údajov;</li>\n<li>spracúvanie je protizákonné a dotknutá osoba namieta proti vymazaniu osobných údajov a žiada namiesto toho obmedzenie ich použitia;</li>\n<li>prevádzkovateľ už nepotrebuje osobné údaje na účely spracúvania, ale potrebuje ich dotknutá osoba na preukázanie, uplatňovanie alebo obhajovanie právnych nárokov, alebo</li>\n<li>dotknutá osoba namietala voči spracúvaniu podľa článku 21 ods. 1, a to až do overenia, či oprávnené dôvody na strane prevádzkovateľa prevažujú na oprávnenými dôvodmi dotknutej osoby.</li>\n</ol></p>\n<h5>Šifrovanie SSL alebo TLS</h5><p>Táto stránka používa z bezpečnostných dôvodov a na ochranu pri prenose dôverných obsahov, ako napríklad objednávok alebo dopytov, ktoré posielate nám ako prevádzkovateľovi stránky, šifrovanie SSL alebo TLS. Šifrované spojenie spoznáte podľa toho, že adresný riadok prehliadača sa zmení z “http://” na “https://” a podľa symbolu zámky v hornom riadku vášho prehliadača.</p>\n\n<p>Ak je aktivované šifrovanie SSL alebo TLS, tretie strany nemôžu čítať údaje, ktoré nám poskytujete.</p>\n<h4>3. Zodpovedná osoba</h4><h5>Zákonom stanovená Zodpovedná osoba</h5><p>V našej spoločnosti sme vymenovali zodpovednú osobu.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNemecko</p>\n\n<p>Telefón: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Zber údajov na našej internetovej stránke</h4><h5>Súbory cookies</h5><p>Internetové stránky používajú takzvané súbory cookies. Súbory cookies nespôsobujú vo vašom počítači žiadne škody a neobsahujú žiadne vírusy. Súbory cookies slúžia na praktickejšiu, efektívnejšiu a bezpečnejšiu prezentáciu našej ponuky. Cookies sú malé textové súbory, ktoré sa nainštalujú vo vašom počítači a ktoré uloží váš prehliadač.</p>\n\n<p>Väčšina nami používaných súborov cookies sú takzvané „dočasné cookies“ (session cookies). Po ukončení vašej návštevy sa automaticky vymažú. Iné súbory cookies zostanú uložené vo vašom koncovom zariadení až kým ich nevymažete. Tieto súbory cookies nám umožňujú identifikovať váš prehliadač pri ďalšej návšteve.</p>\n\n<p>Váš prehliadač si môžete nastaviť tak, aby ste boli informovaní o uložení cookies,\na aby ste povolili cookies len v jednotlivých prípadoch, aby ste v určitých prípadoch všeobecne zakázali súbory cookies a aby ste po zatvorení prehliadača aktivovali automatické vymazanie súborov cookies. V prípade deaktivácie súborov cookies môže byť obmedzená funkčnosť tejto internetovej stránky.</p>\n\n<p>Súbory cookies, ktoré sú nevyhnutné na realizáciu elektronickej komunikácie\nalebo na poskytnutie určitých vami požadovaných funkcií (napr. funkcie nákupného košíka), sa ukladajú na základe článku 6 ods. 1 písm. f) GDPR. Prevádzkovateľ internetovej stránky má oprávnený záujem na ukladaní súborov cookies na účely technicky bezchybného a optimalizovaného poskytovania svojich služieb. V prípade, že sa ukladajú aj iné súbory cookies (napr. cookies na analýzu vášho správania pri surfovaní), tieto sú v tomto vyhlásení o ochrane osobných údajov samostatne ošetrené.</p>\n\n\n<h5>Protokolové súbory servera</h5><p>Prevádzkovateľ stránok zbiera a automaticky ukladá informácie v takzvaných protokolových v súboroch servera, ktoré nám váš prehliadač automaticky prepošle. Sú to:</p>\n<p><ul>\n<li>typ a verzia prehliadača</li>\n<li>použitý operačný systém</li>\n<li>predchádzajúca navštívená stránka (referrer URL)</li>\n<li>názov hostiteľa (hostname) prístupového počítača</li>\n<li>čas dopytu servera</li>\n<li>IP adresa</li>\n</ul></p>\n\n<p>Tieto údaje sa nespájajú s inými zdrojmi údajov.</p>\n\n<p>Základom spracúvania údajov je článok 6 ods. 1 písm. f) GDPR, ktorý povoľuje spracúvanie údajov na účely plnenia zmluvy alebo predzmluvných opatrení.</p>\n<h5>Kontaktný formulár</h5><p>Ak nám posielate požiadavky prostredníctvom kontaktného formulára, vaše údaje z tohto formulára vrátane kontaktných údajov, ktoré ste v ňom uviedli, budú u nás uložené na účely spracovania požiadavky a pre prípad ďalších otázok. Tieto údaje neposkytneme ďalej bez vášho súhlasu.</p>\n\n<p>Údaje uvedené v kontaktnom formulári sa spracúvajú výhradne na základe vášho súhlasu (článok 6 ods. 1 písm. a) GDPR). Tento súhlas môžete kedykoľvek odvolať. Stačí nám poslať neformálne oznámenie prostredníctvom e-mailu. Odvolanie súhlasu nemá vplyv na zákonnosť spracúvania vychádzajúceho zo súhlasu pred jeho odvolaním.</p>\n\n<p>Údaje, ktoré ste uviedli v kontaktnom formulári uchováme u nás dovtedy, kým nás nevyzvete na ich vymazanie, neodvoláte súhlas s ich uložením alebo kým nezanikne dôvod na uloženie týchto údajov (napr. po ukončení spracovania vašej požiadavky). Záväzné zákonné ustanovenia, najmä lehoty uchovávania, zostávajú nedotknuté.</p>\n\n"])}
        }
      },
      "cs-CZ": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prohlášení o ochraně údajů"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Přehled ochrany údajů</h4><h5>Všeobecná upozornění</h5><p>Následující upozornění uvádějí jednoduchý přehled toho, co se děje s Vašimi osobními údaji, když navštívíte naši webovou stránku.\nOsobní údaje jsou veškeré údaje, s nimiž je možné Vás osobně identifikovat. Podrobné informace k tématu ochrany údajů najdete v našem prohlášení o ochraně údajů, uvedeném pod tímto textem.</p>\n<h5>Shromažďování údajů na naší webové stránce</h5><p>Kdo je odpovědný za shromažďování údajů na této webové stránce?</p>\n<p>Zpracování údajů na této webové stránce provádí provozovatel webové stránky. Jeho kontaktní údaje můžete zjistit v tiráži této webové stránky.</p>\n<h5>Jak Vaše údaje shromažďujeme?</h5><p>Vaše údaje jsou získávány jednak tím, že nám je sdělíte. Zde se může např. jednat o údaje, které uvedete v kontaktním formuláři.</p>\n\n<p>Jiné údaje jsou automaticky zaznamenávány IT systémy při návštěvě naší webové stránky. To jsou především technické údaje (např. internetový prohlížeč, operační systém nebo čas vyvolání stránky). Záznam těchto údajů probíhá automaticky, jakmile vstoupíte na naši webovou stránku.</p><h5>K čemu Vaše údaje používáme?</h5><p>Část údajů je získávána, aby bylo zajištěno bezchybné poskytování webové stránky. Jiné údaje mohou být použity k analýze Vašeho uživatelského chování.</p><h5>Jaká práva máte ohledně svých údajů?</h5><p>Máte kdykoli právo dostat bezplatně informace o původu, příjemci a účelu Vašich uložených osobních údajů. Kromě toho máte právo požadovat opravu, zablokování nebo výmaz těchto údajů. Za tímto účelem, jakož i s dalšími dotazy k tématu ochrany údajů se na náš můžete kdykoli obrátit na adrese uvedené v tiráži. Dále máte právo podat stížnost u příslušného dozorového úřadu.</p><h4>2. Všeobecná upozornění a povinné informace</h4><h5>Ochrana údajů</h5><p>Provozovatelé těchto stránek berou ochranu Vašich osobních údajů velice vážně. S Vašimi osobními údaji nakládáme jako s důvěrnými a v souladu se zákonnými předpisy na ochranu údajů a s tímto prohlášením o ochraně údajů.</p>\n\n<p>Když použijete tuto webovou stránku, budou shromažďovány různé osobní údaje. Toto prohlášení o ochraně osobních údajů vysvětluje, jaké údaje shromažďujeme a k čemu je používáme.</p>\n\n<p>Upozorňujeme na to, že přenos údajů na internetu (např. při komunikaci e-mailem) může vykazovat bezpečnostní mezery. Dokonalá ochrana údajů před přístupem třetích osob není možná.</p><h5>Odkaz na odpovědné místo</h5><p>Odpovědným místem pro zpracování údajů na této webové stránce je:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNěmecko</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Odpovědné místo je fyzická nebo právnická osoba, která sama nebo společně s jinými rozhoduje o účelu a způsobu zpracování osobních údajů (např. jména, e-mailové adresy apod.).</p><h5>Odvolání souhlasu se zpracováním údajů</h5><p>Mnoho procesů zpracování údajů je možných jen s Vaším výslovným souhlasem. Již udělený souhlas můžete kdykoli odvolat. Stačí k tomu prosté sdělení, které nám zašlete e-mailem. Zákonnost zpracování údajů provedeného do odvolání zůstává odvoláním nedotčena.</p>\n<h5>Právo na stížnost u příslušného dozorového úřadu</h5><p>V případě porušení předpisů na ochranu osobních údajů má subjekt údajů právo na stížnost u příslušného dozorového úřadu. Příslušným dozorovým úřadem v otázkách ochrany údajů je zemský inspektor ochrany údajů té spolkové země, v níž má naše společnost své sídlo. Seznam inspektorů ochrany dat a jejich kontaktní údaje můžete najít pod následujícím odkazem:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Právo na přenositelnost údajů</h5><p>Máte právo dostat údaje, které na základě Vašeho souhlasu nebo při plnění smlouvy automatizovaně zpracováváme pro sebe nebo třetí stranu, v běžně používaném, strojově čitelném formátu. Pokud požadujete přímé předání údajů jinému správci, bude toto provedeno pouze tehdy, pokud je to technicky proveditelné.</p><h5>Právo na potvrzení a informace</h5><p>Kdykoli máte právo dostat od nás potvrzení o tom, zda jsou zpracovávány osobní údaje, které se Vás týkají. Je-li tomu tak, pak máte právo požadovat od nás bezplatnou informaci o Vašich uložených osobních údajích.</p><h5>Právo na opravu</h5><p>Máte právo od nás požadovat okamžitou opravu nepřesných osobních údajů, které se Vás týkají. S přihlédnutím k účelům zpracování máte právo na doplnění neúplných osobních údajů.</p><h5>Právo na výmaz („právo být zapomenut“)</h5><p>Podle článku 17 nařízení o GDPR máte právo od nás požadovat, abychom bez zbytečného odkladu vymazali osobní údaje, které se Vás týkají, a my máme povinnost osobní údaje bez zbytečného odkladu vymazat, pokud platí jeden z těchto důvodů:</p>\n<p><ol>\n<li>Osobní údaje již nejsou potřebné pro účely, pro které byly shromážděny nebo jinak zpracovávány.</li>\n<li>Subjekt údajů odvolá souhlas, na jehož základě byly údaje podle čl. 6 odst. 1 písm. a) nebo  čl. 9 odst. 2 písm. a) zpracovávány, a neexistuje žádný další právní důvod pro zpracování.</li>\n<li>Subjekt údajů vznese námitky proti zpracování podle čl. 21 odst. 1 a neexistují žádné převažující oprávněné důvody pro zpracování, nebo subjekt údajů vznese námitky proti zpracování podle čl. 21 odst. 2.</li>\n<li>Osobní údaje byly zpracovávány protiprávně.</li>\n<li>Osobní údaje musí být vymazány ke splnění právní povinnosti stanovené v právu Unie nebo členského státu, které se na správce vztahuje</li>\n<li>Osobní údaje byly shromážděny v souvislosti s nabídkou služeb informační společnosti podle čl. 8 odst. 1.</li>\n</ol></p>\n<h5>Právo na omezení zpracování</h5><p>V souladu s článkem 18 GDPR máte právo na to, abychom omezili zpracování, a to v kterémkoli z těchto případů:</p>\n<p><ol>\n<li>subjekt údajů popírá přesnost osobních údajů, a to na dobu potřebnou k tomu, aby správce mohl přesnost osobních údajů ověřit;</li>\n<li>zpracování je protiprávní a subjekt údajů odmítá výmaz osobních údajů a žádá místo toho o omezení jejich použití;</li>\n<li>správce již osobní údaje nepotřebuje pro účely zpracování, ale subjekt údajů je požaduje pro určení, výkon nebo obhajobu právních nároků;</li>\n<li>subjekt údajů vznesl námitku proti zpracování podle čl. 21 odst. 1, dokud nebude ověřeno, zda oprávněné důvody správce převažují nad oprávněnými důvody subjektu údajů.</li>\n</ol></p>\n<h5>Šifrování SSL, popř. TLS</h5><p>Tato stránka používá z bezpečnostních důvodů a na ochranu přenosu důvěrných obsahů, jako například objednávky nebo poptávky, které nám zasíláte jako provozovateli stránky, šifrování SSL, popř. TLS. Zašifrované spojení poznáte podle toho, že adresní řádek prohlížeče se změní z „http://“ na „https://“ a podle symbolu klíče v řádku svého prohlížeče.</p>\n\n<p>Když je šifrování SSL, popř. TLS aktivováno, nemůže údaje, které nám předáváte, číst i třetí strana.</p><h4>3. Inspektor ochrany údajů</h4><h5>Zákonem předepsaný inspektor ochrany údajů</h5><p>Pro naši společnost jsme jmenovali inspektora ochrany údajů.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNěmecko</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Shromažďování údajů na naší webové stránce</h4><h5>Cookies</h5><p>Internetové stránky částečně používají takzvaná cookies. Cookies nezpůsobují na Vašem počítači žádné škody a neobsahují žádné viry. Cookies slouží k tomu, aby byla naše nabídka uživatelsky příjemnější, efektivnější a bezpečnější. Cookies jsou malé textové soubory, které se vkládají do Vašeho počítače, a ukládá je Váš prohlížeč.</p>\n\n<p>Většina námi používaných cookies jsou takzvaná „session-cookies“. Ta jsou po skončení Vaší návštěvy automaticky vymazána. Jiná cookies zůstávají uložena na Vašem koncovém zařízení do doby, než je vymažete. Tato cookies nám umožňují opět identifikovat Váš prohlížeč při následující návštěvě.</p>\n\n<p>Svůj prohlížeč můžete nastavit tak, že budete o vložení cookies informováni a povolíte je jen v jednotlivém případě, vyloučíte přijetí cookies pro určité případy nebo obecně, a aktivujete automatické vymazání cookies při zavření prohlížeče. Při deaktivaci cookies může být funkčnost této webové stránky omezena.</p>\n\n<p>Cookies, která jsou potřeba k provádění elektronické komunikace nebo k poskytnutí určitých, Vámi požadovaných funkcí (např. funkce nákupního košíku), budou uložena na základě čl. 6 odst. 1 písm. f) GDPR. Provozovatel webové stránky má oprávněný zájem na ukládání cookies pro technicky bezvadné a optimalizované poskytování svých služeb. Pokud jsou ukládána jiná cookies (např. cookies pro analýzu Vašeho chování při surfování), je to v tomto prohlášení o ochraně údajů ošetřeno zvlášť.</p><h5>Soubory server-log</h5><p>Poskytovatel stránek automaticky shromažďuje a ukládá informace do takzvaných souborů server-log, které nám Váš prohlížeč předává automaticky. To jsou:</p>\n\n<p><ul>\n<li>typ a verze prohlížeče</li>\n<li>použitý operační systém</li>\n<li>referer URL</li>\n<li>hostname přistupujícího počítače</li>\n<li>čas dotazu na server</li>\n<li>IP adresa</li>\n</ul></p>\n\n<p>Spojení těchto údajů s jinými zdroji údajů se neprovádí.</p>\n\n<p>Základem pro zpracování údajů je čl. 6 odst. 1 písm. f) GDPR, který povoluje zpracování údajů pro plnění smluv nebo předsmluvní opatření.</p><h5>Kontaktní formulář</h5><p>Pokud nám zasíláte poptávky prostřednictvím kontaktního formuláře, uložíme Vaše údaje z poptávkového formuláře, včetně Vámi zde uvedených kontaktních údajů, pro zpracování poptávky a pro případ následných dotazů. Tyto údaje nebudeme bez Vašeho souhlasu předávat dál.</p>\n\n<p>Zpracování údajů uvedených v kontaktním formuláři se tak provádí výhradně na základě Vašeho souhlasu (čl. 6 odst. 1 písm. a) GDPR). Tento souhlas můžete kdykoli odvolat. Stačí k tomu prosté sdělení, které nám zašlete e-mailem. Zákonnost zpracování údajů provedených až do odvolání zůstává odvoláním nedotčena.</p>\n\n<p>Údaje Vámi uvedené v kontaktním formuláři zůstávají u nás, dokud nás nevyzvete k jejich vymazání, neodvoláte svůj souhlas s jejich ukládáním, nebo nezanikne účel, za kterým jsou ukládány (např. po ukončeném zpracování Vaší poptávky). Povinná zákonná ustanovení, zejména lhůty uchovávání, zůstávají nedotčena.</p>"])}
        }
      },
      "tr-TR": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri Koruma Beyanı"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Bir bakışta veri koruması</h4><h5>Genel açıklamalar</h5><p>Aşağıdaki açıklamalar, web sitemizi ziyaret ettiğinizde kişisel verilerinize ne olduğuna dair basit bir genel bakış sunmaktadır. Kişisel veri, kişisel olarak kimliğinizin belirlenmesine yönelik her türlü bilgiyi ifade eder. Veri koruma konusuyla ilgili ayrıntılı bilgileri, bu metnin altında yer alan veri koruma beyanımızda bulabilirsiniz.</p><h5>Web sitemizde veri toplama</h5><p>Bu web sitesinde verilerin toplanmasından kim sorumludur?</p>\n<p>Bu web sitesinde verilerin işlenmesi, web sitesi operatörü tarafından yürütülür. Operatörün iletişim bilgilerini bu web sitesinin Künye bölümünde bulabilirsiniz.</p>\n<h5>Verilerinizi nasıl topluyoruz?</h5><p>Bir taraftan, verileriniz bize ilettiğinizde toplanır. Bunlar, örneğin bir iletişim formuna girdiğiniz veriler olabilir.</p>\n<p>Diğer veriler, web sitesini ziyaret ettiğinizde BT sistemlerimiz tarafından otomatik olarak toplanır. Bunlar, öncelikli olarak teknik verilerdir (örneğin internet tarayıcısı, işletim sistemi veya sitenin görüntülenme zamanı). Bu verilerin toplanması, web sitemize girdiğinizde otomatik olarak gerçekleşir.</p>\n<h5>Verilerinizi ne için kullanıyoruz?</h5><p>Verilerin bir kısmı, web sitesinin hatasız bir şekilde kullanıma sunulmasını sağlamak için kullanılır. Diğer veriler kullanıcı davranışınızı analiz etmek için kullanılabilir.</p><h5>Verilerinizle ilgili olarak hangi haklara sahipsiniz?</h5><p>Operatör tarafından depolanan kişisel verilerinizin kaynağı, alıcısı ve amacı hakkında dilediğiniz zaman ücretsiz bilgi alma hakkına sahipsiniz. Ayrıca, bu verilerin düzeltilmesini, engellenmesini veya silinmesini isteme hakkına sahipsiniz. Bu konuda ve veri koruma hakkındaki diğer sorularınız için, Künye bölümünde verilen adresten dilediğiniz zaman bizimle iletişime geçebilirsiniz. Ayrıca, yetkili denetim makamına şikayette bulunma hakkınız da vardır.</p><h4>2. Genel açıklamalar ve zorunlu bilgiler</h4><h5>Veri koruma</h5><p>Bu web sitesinin operatörleri, kişisel verilerinizin korunmasını son derece ciddiye almaktadır. Kişisel verilerinizi gizli ve yasal veri koruma düzenlemelerinin yanı sıra bu veri koruma beyanına uygun olarak ele almaktayız.</p>\n\n<p>Bu web sitesini kullandığınızda, çeşitli kişisel veriler toplanmaktadır. Bu veri koruma beyanı, hangi verileri topladığımızı ve ne için kullandığımızı açıklamaktadır.</p>\n\n<p>İnternet üzerinden veri iletiminin (örneğin e-posta ile iletişim sırasında) güvenlik açıkları olabileceğini belirtmek isteriz. Verilerin üçüncü şahısların erişimine karşı tam olarak korunması mümkün değildir.</p><h5>Veri sorumlusuna ilişkin not</h5><p>Bu web sitesinde verilerin işlenmesinden aşağıdaki kuruluş sorumludur:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlmanya</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-posta: zentrale&#64;dutypay.eu</p>\n\n<p>Veri sorumlusu, kişisel verilerin (örneğin isimler, e-posta adresleri vb.) işlenme amaçlarına ve araçlarına tek başına veya başkalarıyla birlikte karar veren gerçek veya tüzel kişidir.</p>\n<h5>Verilerin işlenmesi için verdiğiniz açık rızanın iptali</h5><p>Birçok veri işleme süreci, ancak sizin açık rızanızla mümkündür. Daha önce vermiş olduğunuz bir açık rızayı dilediğiniz zaman iptal edebilirsiniz. Bunun için bize şekle bağlı olmayan bir e-posta ile bildirimde bulunmanız yeterlidir. İptale kadar gerçekleştirilen veri işlemenin yasallığı, iptal işleminden etkilenmez.</p>\n<h5>Yetkili denetim makamına şikayette bulunma hakkı</h5><p>Veri koruma yasasıyla ilgili ihlaller durumunda, ilgili kişi yetkili denetim makamına şikayette bulunma hakkına sahiptir. Veri koruma yasasıyla ilgili konularda, şirketimizin merkezinin bulunduğu federal eyaletin eyalet veri koruma görevlisi, yetkili denetim makamıdır. Veri koruma görevlilerinin bir listesi ve bunların iletişim bilgileri, şu bağlantıda bulunabilir:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p>\n<h5>Veri taşınabilirliği hakkı</h5><p>Açık rızanız veya bir sözleşmenin yerine getirilmesi temelinde otomatik olarak işlediğimiz verilerin size veya üçüncü bir tarafa, yaygın olarak kullanılan, makine tarafından okunabilir bir formatta teslim edilmesini isteme hakkınız bulunmaktadır. Verilerin başka bir veri sorumlusuna doğrudan aktarılmasını istemeniz halinde, bu yalnızca teknik olarak mümkün olduğu sürece gerçekleşir.</p>\n<h5>Onay ve bilgi isteme hakkı</h5><p>Sizinle ilgili kişisel verilerin işlenip işlenmediği konusunda bizden dilediğiniz zaman bir onay alma hakkına sahipsiniz. Böyle bir durumda, sizinle ilgili olarak depolanan kişisel veriler hakkında bizden ücretsiz bilgi isteme hakkına sahipsiniz.</p><h5>Düzeltme yapılmasını isteme hakkı</h5><p>Sizinle ilgili her türlü yanlış kişisel veriyi derhal düzeltmemizi isteme hakkına sahipsiniz. Veri işlemenin amaçlarını göz önünde bulundurarak, eksik kişisel verilerin tamamlanmasını isteme hakkına sahipsiniz.</p><h5>Sildirme hakkı (\"Unutulma hakkı\")</h5><p>Genel Veri Koruma Yönetmeliği'nin (DSGVO) 17. maddesi uyarınca, bizden sizinle ilgili kişisel verilerin derhal silinmesini isteme hakkınız, bizim de aşağıdaki nedenlerden birinin geçerli olması durumunda, söz konusu kişisel verileri gecikmeksizin silme yükümlülüğümüz vardır:</p>\n<p><ol>\n<li>Kişisel veriler, toplandıkları veya başka bir şekilde işlendikleri amaçlar için artık gerekli değilse.</li>\n<li>İlgili kişi, madde 6 fıkra 1, a bendi veya madde 9 fıkra 2, a bendi uyarınca gerçekleştirilen veri işlemenin dayanağını oluşturan açık rızasını iptal ederse ve veri işleme için başka bir yasal dayanak yoksa.</li>\n<li>İlgili kişi, madde 21 fıkra 1 uyarınca verilerin işlenmesine itiraz ederse ve verilerin işlenmesi için öncelikli meşru gerekçeler mevcut değilse veya ilgili kişi madde 21 fıkra 2 uyarınca verilerin işlenmesine itiraz ederse.</li>\n<li>Kişisel veriler yasalara aykırı şekilde işlenmişse.</li>\n<li>Kişisel verilerin silinmesi, veri sorumlusunun tabi olduğu Birlik Yasası veya üye devlet yasaları uyarınca yasal bir yükümlülüğün yerine getirilmesi için gerekliyse.</li>\n<li>Kişisel veriler, madde 8 fıkra 1 uyarınca sunulan bilgi toplumu hizmetleri ile ilgili olarak toplanmışsa.</li>\n</ol></p>\n\n<h5>Veri işlemenin kısıtlanmasını isteme hakkı</h5><p>Genel Veri Koruma Yönetmeliği'nin (DSGVO) 18. maddesi uyarınca, aşağıdaki koşullardan birinin mevcut olması halinde bizden veri işlemenin kısıtlanmasını isteme hakkınız vardır:</p>\n<p><ol>\n<li>ilgili kişi tarafından kişisel verilerin doğruluğuna itiraz edilmesi halinde; bu durumda veri sorumlusunun kişisel verilerin doğruluğunu kontrol etmesine olanak sağlayacak bir süre boyunca kısıtlama yapılır,</li>\n<li>veri işlemenin yasalara aykırı olması ve ilgili kişinin kişisel verilerin silinmesini reddetmesi ve bunun yerine kişisel verilerin kullanımının kısıtlanmasını istemesi halinde;</li>\n<li>veri sorumlusu, veri işleme amaçları için kişisel verilere artık ihtiyaç duymuyorsa, ancak ilgili kişi yasal talepleri ileri sürmek, uygulamak veya savunmak için kişisel verilere ihtiyaç duyuyorsa veya</li>\n<li>ilgili kişi, madde 21 fıkra 1 uyarınca verilerin işlenmesine itiraz etmişse, veri sorumlusunun meşru gerekçelerinin ilgili kişinin gerekçelerine göre daha ağır basıp basmadığı belirleninceye kadar kısıtlama yapılır.</li>\n</ol></p>\n\n<h5>SSL veya TLS şifreleme</h5><p>Bu web sitesi, güvenlik nedenleriyle ve web sitesi operatörü olarak bize göndermiş olduğunuz örneğin siparişler veya talepler gibi gizli içeriklerin iletimini korumak amacıyla, SSL veya TLS şifrelemesi kullanmaktadır. Şifreli bir bağlantıyı, internet tarayıcısının adres satırının \"http://\"'den \"https://\"'ye değişmesinden ve tarayıcı satırınızdaki kilit simgesinden tanıyabilirsiniz.</p>\n\n<p>SSL veya TLS şifrelemesi etkinleştirilmişse, bize iletmiş olduğunuz veriler üçüncü taraflarca okunamaz.</p>\n<h4>3. Veri koruma görevlisi</h4><h5>Yasa gereği veri koruma görevlisi</h5><p>Şirketimiz için bir veri koruma görevlisi atamış bulunmaktayız.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAlmanya</p>\n\n<p>Telefon: +498941325320<br>\nE-posta: datenschutz&#64;heydata.eu</p><h4>4. Web sitemizde veri toplama</h4><h5>Çerezler (Cookies)</h5><p>Bazı internet siteleri, çerez (cookie) adı verilen tanımlama bilgilerini kullanır. Çerezler bilgisayarınıza zarar vermez ve virüs içermez. Çerezler, hizmetimizi daha kullanıcı dostu, etkili ve güvenli hale getirmek için kullanılır. Çerezler, bilgisayarınıza kaydedilen ve tarayıcınız tarafından depolanan küçük metin dosyalarıdır.</p>\n\n<p>Tarafımızdan kullanılan çerezlerin çoğu, \"oturum çerezleri\" olarak tanımlanan çerezlerdir. Bu çerezler, web sitemizi ziyaretiniz sonlandıktan sonra, otomatik olarak silinir. Diğer çerezler, siz onları silinceye kadar cihazınızda depolanır. Çerezler, bir sonraki ziyaretinizde tarayıcınızı tanımamıza olanak sağlar.</p>\n\n<p>Tarayıcınızı, çerezlerin yerleştirilmesi hakkında bilgi sahibi olacak ve çerezlere yalnızca bireysel durumlarda izin verecek şekilde ayarlayabilir, belirli durumlarda veya genel olarak çerezlerin kabul edilmesini hariç tutabilir ve tarayıcıyı kapattığınızda çerezlerin otomatik olarak silinmesini etkinleştirebilirsiniz. Çerezlerin devre dışı bırakılması durumunda, bu web sitesinin işlevselliği sınırlanabilir.</p>\n\n<p>Elektronik iletişim sürecini yürütmek veya istediğiniz belirli işlevleri (örneğin alışveriş sepeti işlevi) sağlamak için gerekli olan çerezler, Genel Veri Koruma Yönetmeliği'nin (DSGVO) 6. maddesi, 1. fıkrası, f alt bendi temelinde depolanır. Web sitesi operatörü, hizmetlerinin teknik olarak hatasız ve optimize edilmiş bir şekilde sağlanması için çerezlerin depolanmasında meşru bir menfaate sahiptir. Diğer çerezler (örneğin internette gezinme davranışınızı analiz etmeye yönelik çerezler) saklandığı ölçüde, bu çerezler bu veri koruma beyanında ayrı olarak ele alınır.</p><h5>Sunucu günlük dosyaları</h5><p>Web sitesi sağlayıcısı, internet tarayıcınızın otomatik olarak bize ilettiği bilgileri, sunucu günlük dosyaları olarak adlandırılan dosyalarda otomatik olarak toplar ve depolar. Bu bilgiler şunlardır:</p>\n<p><ul>\n<li>Tarayıcı türü ve tarayıcı sürümü</li>\n<li>Kullanılan işletim sistemi</li>\n<li>Yönlendiren URL</li>\n<li>Erişim sağlayan bilgisayarın ana bilgisayar adı</li>\n<li>Sunucu isteğinin zamanı</li>\n<li>IP adresi</li>\n</ul></p>\n\n<p>Bu verilerin başka veri kaynaklarıyla birleştirilmesi gerçekleştirilmez.</p>\n\n<p>Veri işlemenin dayanağı, bir sözleşmenin veya sözleşme öncesi önlemlerin yerine getirilmesi için verilerin işlenmesine izin veren Genel Veri Koruma Yönetmeliği'nin (DSGVO) 6. maddesi, 1. fıkrası, f alt bendidir.</p><h5>İletişim formu</h5><p>İletişim formu aracılığıyla bize talepler göndermeniz halinde, talebin işleme konulması ve müteakip sorularınız için, orada belirtmiş olduğunuz iletişim adresi de dâhil olmak üzere, talep formundaki bilgileriniz tarafımızdan saklanır. Bu verileri sizin açık rızanız olmadan paylaşmayız.</p>\n\n<p>Buna göre, iletişim formuna girilen verilerin işlenmesi, münhasıran sizin açık rızanız temelinde gerçekleştirilir (DSGVO madde 6, fıkra 1, alt bent a). Bu açık rızayı dilediğiniz zaman iptal edebilirsiniz. Bunun için bize şekle bağlı olmayan bir e-posta ile bildirimde bulunmanız yeterlidir. İptale kadar gerçekleştirilen veri işleme süreçlerinin yasallığı, iptal işleminden etkilenmez.</p>\n\n<p>Tarafınızdan iletişim formuna girilen veriler, bizden verileri silmemizi isteyinceye, verilerin saklanması için vermiş olduğunuz açık rızanızı iptal edinceye veya veri saklama amacı ortadan kalkıncaya kadar (örneğin talebiniz işlendikten sonra)\nbizde kalır. Zorlayıcı yasal hükümler - özellikle saklama süreleriyle ilgili olanlar - bundan etkilenmez.</p>\n\n"])}
        }
      },
      "hu-HU": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adatvédelmi nyilatkozat"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Adavédelem röviden</h4><h5>Általános tudnivalók</h5><p>Az alábbi megjegyzések egyszerű áttekintést nyújtanak arról, hogy mi történik személyes adataival akkor, amikor meglátogatja weboldalunkat. Személyes adat minden olyan adat, amelyek segítségével ön azonosítható. Az adatvédelemre vonatkozó részletes információk jelen szöveg alatti adatvédelmi nyilatkozatban találhatók.</p><h5>Adatgyűjtés a honlapunkon</h5><p>Ki a felelős a weboldalon történő adatgyűjtésért?</p>\n<p>Az adatfeldolgozást a honlapon az oldal üzemeltetője végzi. A honlapon az impresszum tartalmazza az üzemeltető elérhetőségét.</p><h5>Hogyan történik az adatgyűjtés?</h5><p>Az adatok az ön által történő megadás során kerülnek gyűjtésre. Ilyen adatok lehetnek például egy kapcsolatfelvételi űrlapon az ön által megadott adatok.</p>\n\n<p>A honlap látogatása során informatikai rendszereink automatikusan gyűjtenek egyéb adatokat. Ezek főként technikai adatok (internet böngésző, operációs rendszer vagy az oldal megnyitásának időpontja). Az ilyen adatok gyűjtése automatikusan történik a honlapunkra való belépéskor.</p><h5>Mire használjuk az adatait?</h5><p>Az adatok egy része a honlap hibátlan működése érdekében kerül begyűjtésre. Egyéb adatok a felhasználói magatartás elemzése céljából kerülnek felhasználásra.</p>\n<h5>Melyek az ön jogai az adatokkal kapcsolatosan?</h5><p>Önnek bármikor jogában áll ingyenesen tájékoztatást kapni a tárolt személyes adatok eredetéről, címzettjéről és céljáról. Továbbá önnek jogában áll ezen adatok módosítását, zárolását vagy törlését kérni. Az adatvédelemmel kapcsolatos további kérdések esetén bármikor felveheti velünk a kapcsolatot az impresszumban megadott címen. Továbbá önnek bármikor joga van panaszt tenni az illetékes felügyeleti hatóságnál.</p><h4>2. Általános tudnivalók és kötelező információk</h4><h5>Adatvédelem</h5><p>Az oldal üzemeltetői nagyon komolyan veszik az ön személyes adatainak védelmét. Személyes adatait bizalmasan és a törvényben előírt adatvédelmi előírásoknak, valamint a jelen adatvédelmi nyilatkozatnak megfelelően kezeljük.</p>\n\n<p>A honlap használata során különböző személyes adatokat gyűjtünk. Jelen adatvédelmi nyilatkozat tartalmazza, hogy milyen adatokat gyűjtünk és mire használjuk fel azokat.</p>\n\n<p>Felhívjuk a figyelmét, hogy az interneten keresztül történő adatátvitel (pl. az e-mailen való kommunikáció) során biztonsági rések keletkezhetnek. Ennek következtében nem lehetséges az adatok teljes védelme harmadik felek hozzáférésével szemben.</p><h5>Az adatvédelemért felelős szerv</h5><p>Jelen honlap adatkezelője:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNémetország</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-mail: zentrale&#64;dutypay.eu</p>\n\n<p>Az adatkezelő az a természetes vagy jogi személy, aki egyedül vagy másokkal közösen dönt a személyes adatok (pl. nevek, e-mail címek) feldolgozásának céljairól és módjáról.</p><h5>Az adatfeldolgozáshoz való hozzájárulás visszavonása</h5><p>Számos adatfeldolgozási művelet csakis az ön kifejezett hozzájárulásával lehetséges. Az adatfeldolgozáshoz adott beleegyezését bármikor visszavonhatja. Ehhez elegendő egy e-mailben küldött informális üzenet. A visszavonás nem érinti a beleegyezés visszavonásáig végzett adatfeldolgozás jogszerűségét. </p><h5>Az illetékes felügyeleti hatóságnál való panasztétel joga</h5><p>Adatvédelmi jogsértés esetén az érintett személynek joga van panaszt tenni az illetékes felügyeleti hatóságnál. Az adatvédelmi ügyekben illetékes felügyeleti hatóság annak a szövetségi államnak az adatvédelmi biztosa, ahol vállalatunk székhelye található. Az adatvédelemmel megbízott biztosok listája és elérhetősége az alábbi link alatt találhatók:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Az adatok továbbításához való jog</h5><p>Önnek joga van ahhoz, hogy a hozzájárulása vagy egy szerződés alapján általunk automatikusan feldolgozott adatokat önnek vagy harmadik személynek megfelelő, géppel olvasható formátumban kézbesítsük. Az ön kérésére az adatoknak másik adatkezelőhöz való továbbítását csak akkor teljesítjük, ha ez technikailag megvalósítható.</p><h5>A megerősítéshez és tájékoztatáshoz való jog</h5><p>Önnek bármikor jogában áll megerősítést kapni tőlünk az önre vonatkozó személyes adatok feldolgozására vonatkozóan. Minden ilyen esetben önnek joga van ingyenes információt kérni az általunk tárolt személyes adataira vonatkozóan.</p><h5>Az adatok helyesbítéséhez való jog</h5><p>Önnek joga van haladéktalanul kérni tőlünk az önre vonatkozó pontatlan személyes adatok helyesbítését. Az adatkezelés céljait figyelembe véve, önnek jogában áll kérni a hiányos személyes adatok kiegészítését.</p><h5>A törléshez való jog („az elfeledtetéshez való jog“)</h5><p>Az Általános adatvédelmi rendelet (GDPR) 17. cikkének értelmében önnek joga van kérni az érintett személyes adatok azonnali törlését és mi kötelesek vagyunk a személyes adatokat haladéktalanul törölni az alábbi esetekben:</p>\n<p><ol>\n<li>Megszűnt a személyes adatok begyűjtésének a célja és nincs szükség az adatok további tárolására vagy egyéb jellegű feldolgozására.</li>\n<li>Az érintett személy visszavonja a 6. cikk (1) bekezdés a) betűjén vagy a 9. cikk (2) bekezdés a) betűjén alapuló hozzájárulását és hiányzik bármilyen más, az adatfeldolgozásra vonatkozó jogi alap.</li>\n<li>Az érintett személy a 21. cikk (1) bekezdés alapján ellenzi az adatok feldolgozását és nem léteznek az adatfeldolgozás szükségességét alátámasztó elsőrendű okok illetve az érintett személy a 21. cikk (2) bekezdése alapján tiltakozást nyújt be az adatok feldolgozása ellen.</li>\n<li>A személyes adatok jogellenesen kerültek feldolgozásra.</li>\n<li>Szükség van a személyes adatok törlésére az adatkezelés felelősére vonatkozó uniós vagy tagállami jognak megfelelően.</li>\n<li>A személyes adatok az információs cég által kínált, a 8. cikk (1) bekezdése szerinti szolgáltatásokra vonatkozóan kerültek begyűjtésre.</li>\n</ol></p><h5>A feldolgozás korlátozásának joga</h5><p>Az Általános adatvédelmi rendelet (GDPR) 18. cikkének értelmében önnek joga van kérni a személyes adatok feldolgozásának korlátozását az alábbi esetek valamelyikének fennállásakor:</p>\n<p><ol>\n<li>a személyes adatok pontosságát az érintett személy egy olyan időtartamra vitatja, ami lehetővé teszi az adatkezelő számára a személyes adatok pontosságának az ellenőrzését;</li>\n<li>az adatfeldolgozás jogellenes, az érintett személy elutasítja a személyes adatok törlését és ehelyett a személyes adatok feldolgozásának korlátozását kéri;</li>\n<li>az adatkezelőnek a továbbiakban nincs szüksége a személyes adatok feldolgozására, de az érintett személynek szüksége van a személyes adatokra jogi követeléseinek érvényesítéséhez, illetve védelméhez, vagy</li>\n<li>az érintett személy a 21. cikk (1) bekezdése alapján tiltakozást nyújtott be az adatok feldolgozása ellen, abban az esetben, ha még nincs megállapítva, hogy az adatkezelő jogosultsága elsőbbséget élvez az érintett személy jogosultságával szemben</li>\n</ol></p><h5>SSL ill. TLS titkosítás</h5><p>Biztonsági okokból, valamint a bizalmas tartalmak, mint például hozzánk, az oldal üzemeltetőjéhez küldött rendelések vagy kérések továbbításának védelme érdekében ez az oldal SSL ill. TLS titkosítást használ. A titkosított kapcsolatot a böngésző címsorában a „http://“ helyett megjelenő https://, valamint a lakat-szimbólum jelzi.</p>\n\n<p>Az SSL vagy TLS titkosítás aktiválása esetén az ön által hozzánk küldött adatok harmadik személy számára nem elérhetők.</p>\n<h4>3. Adatvédelmi biztos</h4><h5>Törvény által előírt adatvédelmi biztos</h5><p>Kineveztünk egy adatvédelmi biztost cégünk számára.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNémetország</p>\n\n<p>Telefon: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Adatgyűjtés a honlapunkon</h4><h5>Cookie-k</h5><p>A weboldalak néha úgynevezett cookie-kat (sütiket) használnak. A cookie-k nem okoznak kárt a számítógépben és nem tartalmaznak vírusokat. A cookie-k segítségével felhasználóbarátabbá, hatékonyabbá és biztonságosabbá tesszük a honlapunkat. A cookie-k kisméretű szövegfájlok, amelyeket a böngésző tárol a számítógépen.</p>\n\n<p>Az általunk használt cookie-k többsége úgynevezett „munkameneti cookie“. Ezek az oldal látogatásának befejeztével automatikusan törlődnek. A többi cookie mindaddig tárolva marad a számítógépén, amíg ön nem törli őket. Ezek a cookie-k lehetővé teszik számunkra, hogy felismerjük böngészőjét az oldal következő látogatásakor.</p>\n\n<p>Böngészőjét könnyen beállíthatja úgy, hogy tájékoztatást kapjon a cookie-k telepítéséről, hogy csak egyes esetekben engedélyezze a cookie-kat, kizárja a cookie-kat teljesen vagy egyes esetekben, valamint aktiválja a cookie-k automatikus törlését a böngésző bezárásakor. A cookie-k letiltása befolyásolhatja az oldal működését.</p>\n\n<p>Az elektronikus kommunikációs folyamat elvégzéséhez vagy az ön által használni kívánt bizonyos funkciók (pl. bevásárlókocsi-funkció) biztosításához szükséges cookie-kat a rendszer az Általános adatvédelmi rendelet (GDPR) 6. cikke (1) bekezdése f betűjének előírása szerint tárolja. A technikailag hibátlan és optimalizált szolgáltatásai biztosítása érdekében a weboldal üzemeltetőjének jogos érdeke fűződik a cookie-k tárolásához. Amennyiben más (pl. a böngészési viselkedés elemzésére szolgáló) cookie-k kerülnek telepítésre, akkor ezt a jelen adatvédelmi nyilatkozatban külön tárgyaljuk.</p><h5>Szervernapló-fájlok</h5><p>Az oldalak üzemeltetője úgynevezett szervernapló-fájlokban gyűjti és tárolja az adatokat, amiket a böngésző automatikusan továbbít nekünk. Ezek a következők:</p>\n<p><ul>\n<li>a böngésző típusa és verziója</li>\n<li>a használt operációs rendszer</li>\n<li>a hivatkozás URL címe</li>\n<li>a gazdagép neve</li>\n<li>a szerverre érkezett kérés időpontja</li>\n<li>az IP cím</li>\n</ul></p>\n\n<p>Ezek az adatok nem kerülnek más adatforrásokkal való egyesítésre.</p>\n\n<p>Az adatkezelés az Általános adatvédelmi rendelet (GDPR) 6. cikke (1) bekezdésének f betűje szerint történik, ami megengedi az adatok feldolgozását szerződésteljesítés vagy előszerződési intézkedések céljából.</p><h5>Kapcsolatfelvételi űrlap</h5><p>Ha a kapcsolatfelvételi űrlapon keresztül küld nekünk megkeresést, a jelentkezési lapon megadott adatait, beleértve az ott megadott elérhetőségeket is minden további figyelmeztetés nélkül tároljuk a kérelem feldolgozása céljából. Ezeket az adatokat nem osztjuk meg az ön beleegyezése nélkül.</p>\n\n<p>A kapcsolatfelvételi űrlapon megadott adatok feldolgozása ezért kizárólag az ön beleegyezése alapján történik (az Általános adatvédelmi rendelet (GDPR) 6. cikke (1) bekezdésének a) betűje). Ezt a beleegyezését bármikor visszavonhatja. Ehhez elegendő egy e-mailben küldött informális üzenet. A visszavonás nem érinti a beleegyezés visszavonásáig végzett adatfeldolgozás jogszerűségét.</p>\n\n<p>A kapcsolatfelvételi űrlapon megadott adatokat mindaddig tároljuk, amíg ön nem kéri ezek törlését, nem vonja vissza a tárolásra vonatkozó belegyezését vagy nem szűnik meg az adattárolás célja (pl. az ön megkeresésének feldolgozása után). Ez nem érinti a kötelező érvényű – különösképpen a megőrzési időre vonatkozó - törvényes rendelkezéseket.</p>"])}
        }
      },
      "ar-AE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سياسة حماية البيانات"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. نبذة عن حماية البيانات</h4><h5>إرشادات عامة</h5><p>نعرض فيما يلي معلومات عامة حول عملية معالجة البيانات الشخصية عند زيارة موقعنا الإلكتروني. والبيانات الشخصية هي كل البيانات التي يمكن تحديد هويتك من خلالها. وللاطلاع على معلومات مفصلة حول موضوع حماية البيانات، نرجو منك قراءة سياستنا في حماية البيانات الواردة فيما يلي.<p>\n<h5>جمع البيانات على موقعنا الإلكتروني</h5><p>من المسؤول عن جمع البيانات على هذا الموقع الإلكتروني؟</p>\n\n<p>تُعالج البيانات على هذا الموقع من قِبل مُشغِّل الموقع.\nيمكنك الحصول على بيانات الاتصال به ضمن معلومات فريق تحرير الموقع.</p>\n\n<h5>كيف تُجمع البيانات؟</h5><p>تختلف طرق جمع البيانات، إذ قد يتم جمعها عندما تزودنا بها. ويتم ذلك عند تعبئة نماذج الاتصال مثلاً.</p>\n\n<p>وقد يتم ذلك بصورة آلية من خلال النظم التقنية المستخدمة عند زيارة الموقع، \nهذه البيانات تقنية بصورة أساسية (مثل: متصفح الإنترنت، أو نظام التشغيل، أو وقت تصفح الموقع)، يتم جمعها آليًا ما أن تقوم بزيارة الموقع. \n</p><h5>ما هو الغرض من استخدام البيانات؟</h5><p>يتم جمع جزء من البيانات للتأكد من خلو الموقع من الأخطاء، بينما تستخدم بيانات أخرى لتحليل أنماط سلوك المستخدمين.</p><h5>ما الحقوق التي تتمتع بها فيما يتعلق بالبيانات؟</h5><p>يحق لك في أي وقت الحصول على معلومات حول مصدر بياناتك الشخصية المخزنة والجهة التي تستلمها والغرض من الحصول عليها، كما يحق لك طلب تصحيح البيانات أو حظرها أو حذفها. ويمكنك التواصل معنا في أي وقت على العنوان الوارد ضمن هيئة التحرير للحصول على إجابات على أي أسئلة أخرى لديك حول موضوع حماية البيانات. ونؤكد هنا أيضًا على حقك في تقديم أي شكوى إلى الجهة المشرفة المختصة.</p><h4>2. إرشادات عامة ومعلومات إلزامية</h4><h5>حماية البيانات</h5><p>يتعامل مُشغِّل الموقع مع حماية بياناتك الشخصية بحرص، إذ يتم ذلك بسرية ووفق اللوائح القانونية لحماية البيانات وبما يتماشى مع سياسة حماية البيانات هذه.</p>\n\n<p>ويتم جمع بيانات شخصية مختلفة عند زيارة هذا الموقع، نبين في سياسة حماية البيانات التالية أنواع البيانات التي يتم جمعها والغرض من ذلك.</p>\n\n<p>وننوه هنا إلى أن نقل البيانات عبر الإنترنت (من خلال الاتصال عبر البريد الإلكتروني مثلاً) قد لا يخلو من الثغرات الأمنية،\n ولذلك فإن حماية البيانات من وصول أي طرف ثالث إليها أمر غير ممكن.</p><h5>ملاحظة حول الجهة المسؤولة</h5><p>الجهة المسؤولة عن معالجة البيانات على هذا الموقع هي:</p>\n\n<p>DutyPay GmbH<br>\nشارع بيرماسنزر .1<br>\n67655 كايزرسلاوترن<br>\nألمانيا</p>\n\n<p>هاتف: <span dir=\"ltr\">+49 (0)631 5600 1600</span><br>\nالبريد الإلكتروني: zentrale&#64;dutypay.eu</p>\n\n<p>الجهة المسؤولة هي الشخص الطبيعي أو الاعتباري الذي يقرر وحده أو بموجب قرار مشترك، بوسائل معالجة البيانات الشخصية (كالأسماء وعناوين البريد الإلكتروني وغيرها) والغرض من ذلك.</p><h5>إلغاء الموافقة على معالجة البيانات</h5><p>لا يمكن إجراء العديد من أشكال معالجة البيانات دون الحصول على موافقة صريحة من طرفك.\n ويمكنك إلغاء الموافقة على معالجة البيانات في أي وقت. \nويتم ذلك بتوجيه رسالة إلكترونية عادية إلينا فقط، تظل شرعية معالجة البيانات التي تم إجراؤها قبل الإلغاء قائمة دون أن تتأثر بالإلغاء.</p><h5>تقديم الشكاوى إلى الجهة المشرفة المختصة</h5><p>في حال انتهاك حقوق حماية البيانات، يحق للشخص المعني تقديم شكوى لدى الجهة المشرفة المختصة.</p>\n<p>السلطة المشرفة المختصة بقضايا حماية البيانات هي المسؤولة المكلفة بالأمر في الولاية التي يقع مقر شركتنا فيها. يمكن الاطلاع على قائمة مسؤولي حماية البيانات ومعلومات الاتصال بهم على الرابط التالي:</p>\n\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>الحق في نقل البيانات</h5>يحق لك الحصول على البيانات التي تتم معالجتها آليًا بموجب موافقتك أو تنفيذًا لعقد يتم بموجبه نقل البيانات إليك أو إلى طرف ثالث بصيغة عامة يمكن قراءتها آليًا. لن يتم نقل البيانات مباشرة إلى جهة أخرى مسؤولة، في حال طلبت ذلك، إلا إذا كان ذلك ممكنًا من الناحية الفنية.<h5>الحق في المصادقة والوصول إلى المعلومات</h5>يحق لك في أي وقت الحصول على تأكيد من طرفنا بشأن حالة معالجة بياناتك الشخصية. فإذا كانت البيانات قيد المعالجة، فلك الحق في طلب الحصول على معلومات مجانية حول بياناتك الشخصية المُخزنة.<h5>الحق قي التصحيح</h5>يحق لك إرسال طلب لتصحيح أي بيانات شخصية غير صحيحة تتعلق بك على الفور، <br>\n\nوبالنظر إلى أغراض المعالجة، يحق لك طلب استكمال بياناتك الشخصية غير المكتملة.\n<h5>('الحق في الحذف ('الحق في النسيان</h5><p>وفقًا للمادة 17 من النظام الأوروبي العام لحماية البيانات، لك الحق في المطالبة بحذف بياناتك الشخصية على الفور، ونحن ملزمون بذلك إذا توفر أحد الأسباب التالية:</p>\n<p><ol>\n<li> لم تعد البيانات الشخصية ضرورية لتحقيق الأغراض التي تم جمعها أو معالجتها من أجلها.</li>\n<li>يسحب الشخص المعني موافقته التي تستند معالجة البيانات إليها عملاً بالمادة 6 الفقرة 1 الحرف أ أو المادة 9 الفقرة 2 الحرف أ، ولا يوجد أي أساس قانوني للمعالجة.</li>\n<li>يتقدم الشخص المعني باعتراض على المعالجة، عملاً بالمادة 21 الجملة 1، ولا توجد أسباب مشروعة للمعالجة، أو أن يتقدم الشخص المعني باعتراض على المعالجة عملاً بالمادة 21 الجملة 2.</li>\n<li>تتم معالجة البيانات دون الاستناد إلى أساس قانوني.</li>\n<li>يكون حذف البيانات الشخصية ضروريًا للوفاء بالالتزام القانوني المحدد بموجب قانون الاتحاد الأوروبي أو القانون الساري في الدول الأعضاء الذي تخضع له الجهة المسؤولة.</li>\n<li>تم جمع البيانات الشخصية ذات الصلة بخدمات مجتمع المعلومات المقدمة عملاً بالمادة 8 الفقرة 1.</li>\n</ol></p>\n\n\n<h5>الحق في تقييد المعالجة</h5><p>يحق لك بموجب المادة 18 من النظام الأوروبي العام لحماية البيانات، المطالبة بتقييد المعالجة في حال استيفاء أحد الشروط التالية:</p>\n<p><ol>\n<li>الطعن في صحة البيانات الشخصية للشخص المعني، وذلك للفترة اللازمة لتتحقق الجهة المسؤولة من صحة البيانات الشخصية؛ أو</li>\n<li>إذا كانت المعالجة غير قانونية ورفض الشخص المعني حذف البيانات الشخصية وطلب بدلاً من ذلك تقييد استخدام البيانات الشخصية؛ أو</li>\n<li>لم تعد الجهة المسؤولة بحاجة إلى البيانات الشخصية لأغراض المعالجة، ولكن صاحب البيانات بحاجة إليها لغايات تأكيد الدعاوى القانونية أو ممارستها أو الدفاع عنها؛ أو</li>\n<li>قدم الشخص المعني اعتراضًا على المعالجة، عملاً بالمادة 21 الفقرة 1، طالما لم يتم تحديد ما إذا كانت الأسباب المشروعة التي تقدمها الجهة المسؤولة تفوق الأسباب التي يقدمها الشخص المعني.</li>\n</ol></p><h5>بروتوكول طبقة المقابس الآمنة</h5><p>لأسباب أمنية ولحماية نقل المحتوى السري، كالطلبات أو الاستفسارات التي ترسلها إلينا بصفتك مُشغلاً للموقع، يستخدم هذا الموقع بروتوكول طبقة المقابس الأمنية. و يمكنك التعرف على الاتصال المشفر إذا عرفت أن شريط العنوان في المتصفح يتغير من \"http//:\"إلى \"https//:\" وعند ظهور رمز القفل في شريط المتصفح.</p>\n\n<p>وفي حال تفعيل بروتوكول طبقة المقابس الآمنة، لا يمكن لأي طرف ثالث قراءة البيانات التي ترسلها إلينا.</p><h4>3. مسؤول حماية البيانات</h4><h5>مسؤول حماية البيانات المكلف بموجب القانون</h5><p>قمنا بتعيين مسؤولاً عن حماية البيانات في الشركة.</p>\n\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627برلين<br>\nألمانيا</p>\n\n<p>هاتف: <span dir=\"ltr\">+498941325320</span><br>\nالبريد الإلكتروني:&nbsp; datenschutz&#64;heydata.eu </p><h4>4. جمع البيانات على موقعنا الإلكتروني</h4><h5>ملفات تعريف الارتباط</h5><p>تستخدم مواقع الإنترنت ما يسمى بملفات تعريف الارتباط، \nوهي ملفات لا تتسبب بأي ضرر للحواسيب ولا تحتوي على فيروسات، بل تستخدم لتمكيننا من تقديم عرض أسهل استخدامًا وأكثر فعالية وأمنًا. وهذه الملفات هي ملفات نصية صغيرة يتم تخزينها على جهاز الحاسوب وتُحفظ بواسطة المتصفح.</p>\n\n<p>ويطلق على معظم ملفات تعريف الارتباط التي نستخدمها اسم 'ملفات تعريف ارتباط الجلسة'، ويتم حذفها آليًا بعد إنهاء زيارتك للصفحة. وهناك أنواع أخرى من هذه الملفات التي تظل مخزنة على حاسوبك إلى أن تحذفها بنفسك، وتساعدنا هذه الملفات في التعرف على المتصفح الخاص بك عند زيارة موقعنا مرة أخرى.</p>\n\n<p>ويمكنك ضبط إعدادات المتصفح بحيث يتم إخطارك بتنصيب ملفات تعريف الارتباط، والسماح بملفات التعريف هذه في حالات دون غيرها، ومنعها في حالات معينة أو حالات أخرى عامة، وتنشيط الحذف الآلي لها عند إغلاق المتصفح. وإذا تم إبطال ملفات تعريف الارتباط، فقد يتم تقييد وظائف الموقع.</p>\n\n<p>يتم تخزين ملفات تعريف الارتباط المطلوبة لتنفيذ عمليات الاتصال الإلكترونية أو لتوفير وظائف معينة ترغب فيها (مثل وظيفة عربة التسوق) بالاستناد إلى المادة 6 الفقرة 1 الحرف و من النظام الأوروبي العام لحماية البيانات، وإذا كان لدى مُشغل موقع الإنترنت مصلحة مشروعة في تخزين ملفات تعريف الارتباط لتوفير خدمات محسنة خالية من الأخطاء الفنية</p>\n\n<p>وفي حال تم تخزين ملفات تعريف الارتباط الأخرى (مثل ملفات تعريف الارتباط لتحليل سلوك التصفح الخاص بك)، فسيتم التعامل معها بشكل منفصل في سياسة حماية البيانات هذه.</p>\n\n<h5>ملفات سجل الخادم</h5><p>يعمل موفر الموقع الإلكتروني على جمع المعلومات وحفظها آليًا فيما يسمى بملفات سجل الخادم، والتي ينقلها المتصفح الذي تستخدمه إلينا آليًا. وهي:</p>\n<p><ul>\n<li>نوع المتصفح والإصدار</li>\n<li>نظام التشغيل المستخدم</li>\n<li>المُحيل URL عنوان</li>\n<li>اسم مضيف جهاز الحاسوب الذي يتم الوصول إليه</li>\n<li>وقت طلب الخادم</li>\n<li>عنوان بروتوكول الإنترنت</li>\n</ul></p>\n\n<p>ولن يتم دمج هذه البيانات بمصادر البيانات الأخرى.</p>\n\n<p>ونستند في معالجة البيانات على المادة 6 الفقرة 1 الحرف ومن النظام الأوروبي العام لحماية البيانات، والتي تسمح بمعالجة البيانات الخاصة بأداء العقد أو الإجراءات التعاقدية السابقة.</p><h5>نموذج الاتصال</h5><p>في حال إرسال أي استفسارات إلينا باستخدام نموذج الاتصال، سنعمل على تخزين المعلومات وبيانات الاتصال الواردة في النموذج لأغراض معالجة الطلب، ومتابعة المسألة. ونؤكد هنا على أننا لن ننقل هذه البيانات دون موافقتك.</p>\n\n<p>تتم معالجة البيانات المدخلة في نموذج الاتصال عند موافقتك حصرًا (المادة 6 الفقرة 1 الحرف أ من النظام الأوروبي العام لحماية البيانات). \nوننوه هنا إلى أن بإمكانك إلغاء موافقتك في أي وقت. ويتم ذلك بتوجيه رسالة إلكترونية عادية إلينا فقط، وتظل شرعية عمليات معالجة البيانات التي تم إجراؤها قبل الإلغاء قائمة دون أن تتأثر بالإلغاء.</p>\n\n<p>ونؤكد كذلك على أن البيانات المقدمة في نموذج الاتصال ستظل لدينا إلى أن تطلب حذفها، أو إلى حين إبطال موافقتك على تخزينها أو إذا لم يعد الغرض من جمع البيانات قائمًا (بعد معالجة طلبك مثلاً). وننوه أخيرًا إلى أن الأحكام القانونية الإلزامية - خاصة فترات التخزين - تظل كما هي دون تغيير.</p>\n"])}
        }
      },
      "fr-BE": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politique de confidentialité"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. La protection des données en un coup d'œil</h4><h5>Remarques générales</h5><p>Les remarques suivantes fournissent un simple aperçu de ce que deviennent vos données à caractère personnel lorsque vous visitez notre site Web. Les données à caractère personnel sont toutes les données permettant de vous identifier personnellement. Vous trouverez des informations détaillées au sujet de la protection des données dans notre politique de confidentialité ci-après.</p><h5>La collecte de données sur notre site Web</h5><p>Qui est responsable de la collecte des données sur ce site ?</p>\n\n<p>Le propriétaire du site est responsable du traitement des données sur ce site. Ses coordonnées figurent dans les mentions légales.</p>\n<h5>Comment collectons-nous vos données ?</h5><p>D'une part, nous collectons les données que vous nous communiquez. Il peut s'agir de données que vous saisissez dans un formulaire de contact, par exemple.</p>\n\n<p>D'autres données sont collectées automatiquement via nos systèmes informatiques lorsque vous consultez le site Web. Il s'agit principalement de données techniques (par ex. le navigateur internet, le système d'exploitation ou l'heure de visite de la page). Ces données sont collectées automatiquement dès que vous visitez notre site Web.</p><h5>À quoi nous servent vos données ?</h5><p>Une partie des données que nous collectons est destinée à garantir le bon fonctionnement du site Web. D'autres données peuvent nous servir à analyser votre comportement d'utilisateur.</p><h5>Quels sont vos droits concernant vos données ?</h5><p>Vous avez le droit de recevoir gratuitement et à tout moment des informations sur l'origine, le destinataire et la finalité de vos données à caractère personnel stockées. Vous avez également le droit d'exiger la rectification, le blocage ou l'effacement de ces données. À cette fin, ainsi que pour toute autre question concernant la protection des données, vous pouvez nous contacter à tout moment à l'adresse indiquée dans les mentions légales. En outre, vous disposez d'un droit de recours auprès de l'autorité de contrôle compétente.</p><h4>2. Remarques générales et informations obligatoires</h4><h5>Protection des données</h5><p>Les propriétaires de ce site prennent très au sérieux la protection de vos données personnelles. Nous traitons vos données à caractère personnel de manière confidentielle et conformément aux dispositions légales en matière de protection des données, et à la présente politique de confidentialité.</p>\n\n<p>Nous collectons diverses données à caractère personnel dès lors que vous consultez ce site Web. Notre politique de confidentialité précise quelles données nous collectons et à quelles fins nous les utilisons.</p>\n\n<p>Nous tenons à souligner que la transmission de données sur Internet (par ex. les communications via e-mail) peut présenter des failles en matière de sécurité. Une protection complète des données contre tout accès par des tiers n'est pas possible. </p>\n<h5>Information concernant l'organisme responsable</h5><p>Le responsable du traitement des données sur ce site est:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAllemagne</p>\n\n<p>Téléphone: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu</p>\n\n<p>Le responsable est la personne physique ou morale qui, seule ou en collaboration avec d'autres, décide des finalités et des moyens du traitement des données à caractère personnel (par ex. les noms, adresses e-mail, etc.).</p><h5>Retrait de votre consentement au traitement des données</h5><p>De nombreuses opérations de traitement des données ne sont possibles qu'avec votre consentement explicite. Vous pouvez retirer à tout moment tout consentement déjà donné. Pour ce faire, une notification informelle par e-mail suffit. La légalité du traitement des données effectué jusqu'au moment du retrait n'est pas affectée par la révocation.</p><h5>Droit de recours auprès de l'autorité de contrôle compétente</h5><p>En cas de manquement à la législation sur la protection des données, la personne concernée dispose d'un droit de recours auprès de l'autorité de contrôle compétente. L'autorité de contrôle compétente en matière de droit de la protection des données est le délégué à la protection des données du Land dans lequel notre entreprise est basée. Une liste des délégués à la protection des données et de leurs coordonnées est disponible en cliquant sur le lien suivant:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Droit à la portabilité des données</h5><p>Vous avez le droit d'obtenir que les données que nous traitons automatiquement sur la base de votre consentement ou en exécution d'un contrat vous soient transmises ou soient transmises à un tiers dans un format couramment utilisé et lisible par machine. Si vous demandez la transmission directe des données à un autre responsable, celle-ci n'aura lieu que dans la mesure où cela est techniquement possible.</p><h5>Droit de confirmation et droit d'accès</h5><p>Vous avez le droit d'obtenir de notre part, à tout moment, la confirmation que nous traitons des données à caractère personnel vous concernant. Si tel est le cas, vous avez le droit de nous demander d'accéder gratuitement à vos données personnelles conservées.</p><h5>Droit de rectification</h5><p>Vous avez le droit de nous demander de rectifier sans délai toute\ndonnée à caractère personnel inexacte vous concernant. Compte tenu des finalités du traitement, vous avez le droit de demander que les données à caractère personnel incomplètes soient complétées.</p><h5>Droit à l'effacement (« droit à l'oubli »)</h5><p>Conformément à l'article 17 du règlement général sur la protection des données (RGPD), vous avez le droit d'exiger que nous effacions sans délai les données à caractère personnel vous concernant, et nous sommes tenus de supprimer sans délai les données à caractère personnel si l'une des raisons suivantes s'applique:</p>\n<p><ol>\n<li>Les données à caractère personnel ne sont plus nécessaires aux fins pour lesquelles elles ont été collectées ou autrement traitées.</li>\n<li> La personne concernée retire le consentement sur lequel le traitement était fondé en vertu de l'article 6, alinéa 1, point a) ou de l'article 9, alinéa 2, point a), et il n'existe aucune autre base juridique pour le traitement.</li>\n<li>La personne concernée s'oppose au traitement en vertu de l'article 21, alinéa 1, et il n'existe aucune raison impérieuse et légitime justifiant ce traitement, ou la personne concernée s'oppose au traitement en vertu de l'article 21, alinéa 2.</li>\n<li>Les données à caractère personnel ont été traitées illégalement.</li>\n<li>La suppression des données à caractère personnel est nécessaire afin de satisfaire à une obligation légale en vertu du droit de l'Union ou du droit des États membres à laquelle le responsable du traitement est soumis.</li>\n<li>Les données à caractère personnel ont été collectées en relation avec la prestation de services de la société de l'information, conformément à l'article 8, alinéa 1.</li>\n</ol></p>\n<h5>Droit à la limitation du traitement</h5><p>Conformément à l'article 18 RGPD, vous avez le droit d'exiger que nous limitions le traitement si l'une des conditions suivantes est remplie:</p>\n<p><ol>\n<li>L'exactitude des données à caractère personnel est contestée par la personne concernée, pendant une période qui permet au responsable du traitement de vérifier l'exactitude des données à caractère personnel.</li>\n<li>Le traitement est illégal et la personne concernée refuse la suppression de ses données à caractère personnel et demande à la place la limitation de l'utilisation des données à caractère personnel.</li>\n<li>Le responsable du traitement n'a plus besoin des données à caractère personnel aux fins du traitement, mais la personne concernée en a besoin pour exercer ou défendre ses droits.</li>\n<li>La personne concernée s'est opposée au traitement en vertu de l'article 21, alinéa 1, en attendant de déterminer si les raisons légitimes invoquées par le responsable du traitement l'emportent sur celles invoquées par la personne\nconcernée.</li>\n</ol></p>\n\n<h5>Cryptage SSL ou TLS</h5><p>Pour des raisons de sécurité et pour protéger la transmission de contenus confidentiels, tels que les commandes ou les demandes que vous nous envoyez en tant que propriétaires du site, ce site utilise le cryptage SSL ou TLS. Vous pouvez reconnaître une connexion cryptée au fait que la ligne d'adresse du navigateur passe de « http:// » à « https:// » et au symbole du cadenas dans le champ de votre navigateur.</p>\n\n<p>Si le cryptage SSL ou TLS est activé, les données que vous nous transmettez ne peuvent pas être lues par des tiers.</p>\n<h4>3. Délégué à la protection des données</h4><h5>Obligation légale de désigner un Délégué à la protection des données</h5><p>Nous avons désigné une déléguée à la protection des données au sein de notre entreprise.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAllemagne</p>\n\n<p>Téléphone: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. La collecte de données sur notre site Web</h4><h5>Cookies</h5><p>Les sites Internet utilisent des « cookies ». Les cookies n'endommagent pas votre ordinateur et ne contiennent pas de virus. Les cookies contribuent à rendre notre offre plus accessible, plus efficace et plus sûre. Les cookies sont de petits fichiers texte qui sont stockés sur votre ordinateur et enregistrés par votre navigateur.</p>\n\n<p>Les cookies que nous utilisons le plus souvent sont des « cookies de session ». Ils sont automatiquement supprimés à la fin de votre visite. Les autres cookies restent enregistrés sur votre terminal jusqu'à ce que vous les supprimiez. Ces cookies nous permettent de reconnaître votre navigateur la prochaine fois que vous consultez notre site.</p>\n\n<p>Vous pouvez configurer votre navigateur de manière à ce qu'il vous informe de la présence de cookies, qu’il autorise les cookies au cas par cas uniquement, qu'il refuse les cookies dans certains cas ou, de manière générale, qu'il active la suppression automatique des cookies lorsque vous fermez votre navigateur. Si vous désactivez les cookies, la fonctionnalité de ce site Web peut être limitée.</p>\n\n<p>Les cookies nécessaires à la communication électronique ou à la mise à disposition de certaines fonctionnalités dont vous avez besoin (par ex. la fonctionnalité « panier ») sont enregistrés sur la base de l'article 6, alinéa 1, point f) RGPD. Le propriétaire du site Web a un intérêt légitime à ce que des cookies soient stockés pour lui permettre de fournir ses services sans erreur et de manière optimale sur le plan technique. Dans la mesure où d'autres cookies (par exemple des cookies permettant d’analyser votre comportement de navigation) sont enregistrés, ceux-ci sont traités séparément dans la présente politique de confidentialité.</p><h5>Fichiers journaux du serveur</h5><p>Le fournisseur du site collecte et stocke automatiquement des informations dans ces fichiers journaux du serveur, que votre navigateur nous transmet automatiquement. Les données collectées sont les suivantes:</p>\n<p><ul>\n<li>Type et version du navigateur</li>\n<li>Système d'exploitation utilisé</li>\n<li>URL de référence</li>\n<li>Nom d'hôte de l'ordinateur connecté</li>\n<li>Heure de consultation du serveur</li>\n<li>Adresse IP</li>\n</ul></p>\n\n<p>Ces données ne peuvent pas être recoupées avec d'autres sources de données.</p>\n\n<p>La base du traitement des données est l'article 6, alinéa 1, point b) RGPD, qui autorise le traitement des données pour l'exécution d'un contrat ou de mesures précontractuelles.</p>\n<h5>Formulaire de contact</h5><p>Si vous nous envoyez des demandes de renseignement via le formulaire de contact, nous stockons les données que vous fournissez via ce formulaire, y compris vos coordonnées, afin de traiter votre demande et en cas de questions complémentaires. Nous ne transmettons pas ces données sans votre consentement.</p>\n\n<p>Le traitement des données saisies dans le formulaire de contact est donc exclusivement basé sur votre consentement (article 6, alinéa 1, point a) RGPD). Vous\npouvez révoquer ce consentement à tout moment. Une notification informelle par e-mail suffit. La légalité du traitement des données effectué jusqu'au moment du retrait n'est pas affectée par la révocation.</p>\n\n<p>Les données saisies via le formulaire de contact restent en notre possession jusqu'à ce que vous nous demandiez de les effacer, que vous révoquiez votre consentement au stockage ou que la finalité pour laquelle les données ont été stockées cesse de s'appliquer (par ex. après le traitement de votre demande). Les dispositions légales obligatoires, en particulier les périodes de conservation, restent inchangées.</p>\n"])}
        }
      },
      "fr-LU": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politique de confidentialité"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. La protection des données en un coup d'œil</h4><h5>Remarques générales</h5><p>Les remarques suivantes fournissent un simple aperçu de ce que deviennent vos données à caractère personnel lorsque vous visitez notre site Web. Les données à caractère personnel sont toutes les données permettant de vous identifier personnellement. Vous trouverez des informations détaillées au sujet de la protection des données dans notre politique de confidentialité ci-après.</p><h5>La collecte de données sur notre site Web</h5><p>Qui est responsable de la collecte des données sur ce site ?</p>\n\n<p>Le propriétaire du site est responsable du traitement des données sur ce site. Ses coordonnées figurent dans les mentions légales.</p><h5>Comment collectons-nous vos données ?</h5><p>D'une part, nous collectons les données que vous nous communiquez. Il peut s'agir de données que vous saisissez dans un formulaire de contact, par exemple.</p>\n\n<p>D'autres données sont collectées automatiquement via nos systèmes informatiques lorsque vous consultez le site Web. Il s'agit principalement de données techniques (par ex. le navigateur internet, le système d'exploitation ou l'heure de visite de la page). Ces données sont collectées automatiquement dès que vous visitez notre site Web.</p><h5>À quoi nous servent vos données ?</h5><p>Une partie des données que nous collectons est destinée à garantir le bon fonctionnement du site Web. D'autres données peuvent nous servir à analyser votre comportement d'utilisateur.</p><h5>Quels sont vos droits concernant vos données ?</h5><p>Vous avez le droit de recevoir gratuitement et à tout moment des informations sur l'origine, le destinataire et la finalité de vos données à caractère personnel stockées. Vous avez également le droit d'exiger la rectification, le blocage ou l'effacement de ces données. À cette fin, ainsi que pour toute autre question concernant la protection des données, vous pouvez nous contacter à tout moment à l'adresse indiquée dans les mentions légales. En outre, vous disposez d'un droit de recours auprès de l'autorité de contrôle compétente.</p><h4>2. Remarques générales et informations obligatoires</h4><h5>Protection des données</h5><p>Les propriétaires de ce site prennent très au sérieux la protection de vos données personnelles. Nous traitons vos données à caractère personnel de manière confidentielle et conformément aux dispositions légales en matière de protection des données, et à la présente politique de confidentialité.</p>\n\n<p>Nous collectons diverses données à caractère personnel dès lors que vous consultez ce site Web. Notre politique de confidentialité précise quelles données nous collectons et à quelles fins nous les utilisons.</p>\n\n<p>Nous tenons à souligner que la transmission de données sur Internet (par ex. les communications via e-mail) peut présenter des failles en matière de sécurité. Une protection complète des données contre tout accès par des tiers n'est pas possible.</p><h5>Information concernant l'organisme responsable</h5><p>Le responsable du traitement des données sur ce site est:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAllemagne</p>\n\n<p>Téléphone: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu</p>\n\n<p>Le responsable est la personne physique ou morale qui, seule ou en collaboration avec d'autres, décide des finalités et des moyens du traitement des données à caractère personnel (par ex. les noms, adresses e-mail, etc.).</p><h5>Retrait de votre consentement au traitement des données</h5><p>De nombreuses opérations de traitement des données ne sont possibles qu'avec votre consentement explicite. Vous pouvez retirer à tout moment tout consentement déjà donné. Pour ce faire, une notification informelle par e-mail suffit. La légalité du traitement des données effectué jusqu'au moment du retrait n'est pas affectée par la révocation.</p><h5>Droit de recours auprès de l'autorité de contrôle compétente</h5><p>En cas de manquement à la législation sur la protection des données, la personne concernée dispose d'un droit de recours auprès de l'autorité de contrôle compétente. L'autorité de contrôle compétente en matière de droit de la protection des données est le délégué à la protection des données du Land dans lequel notre entreprise est basée. Une liste des délégués à la protection des données et de leurs coordonnées est disponible en cliquant sur le lien suivant:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Droit à la portabilité des données</h5><p>Vous avez le droit d'obtenir que les données que nous traitons automatiquement sur la base de votre consentement ou en exécution d'un contrat vous soient transmises ou soient transmises à un tiers dans un format couramment utilisé et lisible par machine. Si vous demandez la transmission directe des données à un autre responsable, celle-ci n'aura lieu que dans la mesure où cela est techniquement possible.</p><h5>Droit de confirmation et droit d'accès</h5><p>Vous avez le droit d'obtenir de notre part, à tout moment, la confirmation que nous traitons des données à caractère personnel vous concernant. Si tel est le cas, vous avez le droit de nous demander d'accéder gratuitement à vos données personnelles conservées.</p><h5>Droit de rectification</h5><p>Vous avez le droit de nous demander de rectifier sans délai toute\ndonnée à caractère personnel inexacte vous concernant. Compte tenu des finalités du traitement, vous avez le droit de demander que les données à caractère personnel incomplètes soient complétées.</p><h5>Droit à l'effacement (« droit à l'oubli »)</h5><p>Conformément à l'article 17 du règlement général sur la protection des données (RGPD), vous avez le droit d'exiger que nous effacions sans délai les données à caractère personnel vous concernant, et nous sommes tenus de supprimer sans délai les données à caractère personnel si l'une des raisons suivantes s'applique:</p>\n<p><ol>\n<li>Les données à caractère personnel ne sont plus nécessaires aux fins pour lesquelles elles ont été collectées ou autrement traitées.</li>\n<li> La personne concernée retire le consentement sur lequel le traitement était fondé en vertu de l'article 6, alinéa 1, point a) ou de l'article 9, alinéa 2, point a), et il n'existe aucune autre base juridique pour le traitement.</li>\n<li>La personne concernée s'oppose au traitement en vertu de l'article 21, alinéa 1, et il n'existe aucune raison impérieuse et légitime justifiant ce traitement, ou la personne concernée s'oppose au traitement en vertu de l'article 21, alinéa 2.</li>\n<li>Les données à caractère personnel ont été traitées illégalement.</li>\n<li>La suppression des données à caractère personnel est nécessaire afin de satisfaire à une obligation légale en vertu du droit de l'Union ou du droit des États membres à laquelle le responsable du traitement est soumis.</li>\n<li>Les données à caractère personnel ont été collectées en relation avec la prestation de services de la société de l'information, conformément à l'article 8, alinéa 1.</li>\n</ol></p>\n<h5>Droit à la limitation du traitement</h5><p>Conformément à l'article 18 RGPD, vous avez le droit d'exiger que nous limitions le traitement si l'une des conditions suivantes est remplie:</p>\n<p><ol>\n<li>L'exactitude des données à caractère personnel est contestée par la personne concernée, pendant une période qui permet au responsable du traitement de vérifier l'exactitude des données à caractère personnel.</li>\n<li>Le traitement est illégal et la personne concernée refuse la suppression de ses données à caractère personnel et demande à la place la limitation de l'utilisation des données à caractère personnel.</li>\n<li>Le responsable du traitement n'a plus besoin des données à caractère personnel aux fins du traitement, mais la personne concernée en a besoin pour exercer ou défendre ses droits.</li>\n<li>La personne concernée s'est opposée au traitement en vertu de l'article 21, alinéa 1, en attendant de déterminer si les raisons légitimes invoquées par le responsable du traitement l'emportent sur celles invoquées par la personne\nconcernée.</li>\n</ol></p>\n\n<h5>Cryptage SSL ou TLS</h5><p>Pour des raisons de sécurité et pour protéger la transmission de contenus confidentiels, tels que les commandes ou les demandes que vous nous envoyez en tant que propriétaires du site, ce site utilise le cryptage SSL ou TLS. Vous pouvez reconnaître une connexion cryptée au fait que la ligne d'adresse du navigateur passe de « http:// » à « https:// » et au symbole du cadenas dans le champ de votre navigateur.</p>\n\n<p>Si le cryptage SSL ou TLS est activé, les données que vous nous transmettez ne peuvent pas être lues par des tiers.</p>\n<h4>3. Délégué à la protection des données</h4><h5>Obligation légale de désigner un Délégué à la protection des données</h5><p>Nous avons désigné une déléguée à la protection des données au sein de notre entreprise.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAllemagne</p>\n\n<p>Téléphone: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. La collecte de données sur notre site Web</h4><h5>Cookies</h5><p>Les sites Internet utilisent des « cookies ». Les cookies n'endommagent pas votre ordinateur et ne contiennent pas de virus. Les cookies contribuent à rendre notre offre plus accessible, plus efficace et plus sûre. Les cookies sont de petits fichiers texte qui sont stockés sur votre ordinateur et enregistrés par votre navigateur.</p>\n\n<p>Les cookies que nous utilisons le plus souvent sont des « cookies de session ». Ils sont automatiquement supprimés à la fin de votre visite. Les autres cookies restent enregistrés sur votre terminal jusqu'à ce que vous les supprimiez. Ces cookies nous permettent de reconnaître votre navigateur la prochaine fois que vous consultez notre site.</p>\n\n<p>Vous pouvez configurer votre navigateur de manière à ce qu'il vous informe de la présence de cookies, qu’il autorise les cookies au cas par cas uniquement, qu'il refuse les cookies dans certains cas ou, de manière générale, qu'il active la suppression automatique des cookies lorsque vous fermez votre navigateur. Si vous désactivez les cookies, la fonctionnalité de ce site Web peut être limitée.</p>\n\n<p>Les cookies nécessaires à la communication électronique ou à la mise à disposition de certaines fonctionnalités dont vous avez besoin (par ex. la fonctionnalité « panier ») sont enregistrés sur la base de l'article 6, alinéa 1, point f) RGPD. Le propriétaire du site Web a un intérêt légitime à ce que des cookies soient stockés pour lui permettre de fournir ses services sans erreur et de manière optimale sur le plan technique. Dans la mesure où d'autres cookies (par exemple des cookies permettant d’analyser votre comportement de navigation) sont enregistrés, ceux-ci sont traités séparément dans la présente politique de confidentialité.</p><h5>Fichiers journaux du serveur</h5><p>Le fournisseur du site collecte et stocke automatiquement des informations dans ces fichiers journaux du serveur, que votre navigateur nous transmet automatiquement. Les données collectées sont les suivantes:</p>\n<p><ul>\n<li>Type et version du navigateur</li>\n<li>Système d'exploitation utilisé</li>\n<li>URL de référence</li>\n<li>Nom d'hôte de l'ordinateur connecté</li>\n<li>Heure de consultation du serveur</li>\n<li>Adresse IP</li>\n</ul></p>\n\n<p>Ces données ne peuvent pas être recoupées avec d'autres sources de données.</p>\n\n<p>La base du traitement des données est l'article 6, alinéa 1, point b) RGPD, qui autorise le traitement des données pour l'exécution d'un contrat ou de mesures précontractuelles.</p>\n<h5>Formulaire de contact</h5><p>Si vous nous envoyez des demandes de renseignement via le formulaire de contact, nous stockons les données que vous fournissez via ce formulaire, y compris vos coordonnées, afin de traiter votre demande et en cas de questions complémentaires. Nous ne transmettons pas ces données sans votre consentement.</p>\n\n<p>Le traitement des données saisies dans le formulaire de contact est donc exclusivement basé sur votre consentement (article 6, alinéa 1, point a) RGPD). Vous\npouvez révoquer ce consentement à tout moment. Une notification informelle par e-mail suffit. La légalité du traitement des données effectué jusqu'au moment du retrait n'est pas affectée par la révocation.</p>\n\n<p>Les données saisies via le formulaire de contact restent en notre possession jusqu'à ce que vous nous demandiez de les effacer, que vous révoquiez votre consentement au stockage ou que la finalité pour laquelle les données ont été stockées cesse de s'appliquer (par ex. après le traitement de votre demande). Les dispositions légales obligatoires, en particulier les périodes de conservation, restent inchangées.</p>\n"])}
        }
      },
      "mt-MT": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dikjarazzjoni ta' Protezzjoni tad-Data"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Protezzjoni tad-data f'daqqa t'għajn</h4><h5>Noti ġenerali</h5><p>In-noti li ġejjin jipprovdu ħarsa ġenerali sempliċi ta 'x'jiġri mid-data personali tiegħek meta żżur il-websajt tagħna. B'data personali nirreferu għad-data kollha li tikkonċernak u li biha tista' tiġi identifikat/a personalment. Għal aktar informazzjoni dettaljata dwar is-suġġett tal-protezzjoni tad-data, aqra d-Dikjarazzjoni ta' Protezzjoni tad-Data tagħna elenkata taħt dawn in-noti.</p><h5>Ġbir ta' data fuq il-websajt tagħna</h5><p>Min huwa responsabbli għall-ġbir tad-data\nfuq din il-websajt?</p>\n\n<p>L-ipproċessar tad-data fuq din il-websajt titwettaq mill-operatur tal-websajt. Id-dettalji biex tikkuntattja din-il-persuna jinsabu fl-Imprint ta' din il-websajt.</p>\n\n\n<h5>Kif niġbru d-data tiegħek?</h5><p>Min-naħa l-waħda, aħna niġbru d-data tiegħek meta inti tipprovdihilna. Din, pereżempju, tista' tkun data mogħtija f'xi formola ta' kuntatt.</p>\n\n<p>Meta żżur il-websajt tagħna, tinġabar ukoll aktar data awtomatikament mis-sistemi tal-IT tagħna. Din hija prinċipalment data teknika (bħall-browser tal-Internet, is-sistema operattiva jew il-ħin tal-aċċess fuq il-websajt). Il-ġbir ta' din id-data jitwettaq awtomatikament malli taċċedi l-websajt tagħna.</p><h5>Għal liema raġuni nużaw id-data tiegħek?</h5><p>Parti mid-data tinġabar sabiex jiġi żgurat li l-websajt taħdem mingħajr problemi. Data oħra tista' tintuża biex tiġi analizzata l-imġieba tiegħek bħala utent.</p>\n<h5>Liema drittijiet għandek f'rigward id-data tiegħek?</h5><p>F'kull ħin u mument, għandek id-dritt li tirċievi informazzjoni mingħajr ħlas dwar l-oriġini, ir-riċevitur u l-iskop tad-data maħżuna li tikkonċernak. Int għandek ukoll id-dritt li titlob li din id-data tiġi rettifikata, ristretta jew imħassra. Jekk għandek xi mistoqsijiet dwar dan jew dwar is-suġġett tal-protezzjoni tad-data, tista' tikkuntattjana f'kull ħin u mument fuq l-indirizz ipprovdut fl-Imprint. Għandek ukoll id-dritt li tressaq ilment għand l-awtorità superviżorja.</p><h4>2. Noti ġenerali u informazzjoni obbligatorja</h4><h5>Protezzjoni tad-data</h5><p>L-operatur ta' dawn il-paġni Web jieħu d-data personali tiegħek bis-serjetà. Aħna nittrattaw id-data personali tiegħek b'mod kunfidenzjali u skont ir-regolamenti statutorji dwar il-protezzjoni tad-data u din id-Dikjarazzjoni ta' Protezzjoni tad-Data.</p>\n\n<p>Meta tuża l-websajt tagħna, tinġabar data diversa li tikkonċernak. Din id-Dikjarazzjoni ta' Protezzjoni tad-Data tispjega liema data niġbru u għal xiex nużawha.</p>\n\n<p>Nixtiequ nirrimarkaw li t-trażmissjoni tad-data fuq l-Internet (eż. waqt komunikazzjoni bl-email) jista' jkollha nuqqasijiet f'termini ta' sigurtà. Mhux possibbli li tingħata protezzjoni sħiħa tad-data kontra l-aċċess minn partijiet terzi.</p>\n<h5>Noti dwar il-kontrollur</h5><p>Il-kontrollur għall-ipproċessar tad-data fuq din il-websajt huwa:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nIl-Ġermanja</p>\n\n<p>Tel.: +49 (0)631 5600 1600<br>\nImejl: zentrale&#64;dutypay.eu</p>\n\n<p>Il-kontrollur huwa l-persuna fiżika jew ġuridika li, waħedha jew flimkien ma' oħrajn, tiddeċiedi dwar l-iskopijiet u l-mezzi tal-ipproċessar tad-data personali (eż. l-ismijiet, l-indirizzi tal-imejl, eċċ.).</p>\n<h5>Revokar tal-kunsens tiegħek għall-ipproċessar tad-data</h5><p>Ħafna operazzjonijiet ta' pproċessar ta' data huma possibbli biss bil-kunsens espress tiegħek. Tista' tirrevoka l-kunsens tiegħek fi kwalunkwe ħin. Biex tagħmel dan, huwa biżżejjed li tiktbilna imejl informali. Il-legalità tal-ipproċessar tad-data li jkun ġie mwettaq qabel ir-revoka ma tiġix affettwata mir-revoka.</p>\n<h5>Dritt li tressaq ilment għand l-awtorità superviżorja</h5><p>Fil-każ ta' ksur tal-liġi dwar il-protezzjoni tad-data, il-persuna kkonċernata għandha d-dritt li tressaq ilment għand l-awtorità superviżorja kompetenti. L-awtorità superviżorja kompetenti għal kwistjonijiet ta' protezzjoni tad-data hija l-uffiċjal tal-protezzjoni tad-data tal-istat federali li fih hija rreġistrata l-kumpanija tagħna. Fil-link li ġej issib lista ta' uffiċjali tal-protezzjoni tad-data u\nd-dettalji ta' kuntatt tagħhom:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Dritt għall-portabbiltà tad-data</h5><p>Int għandek id-dritt li tirċievi d-data li nipproċessaw awtomatikament abbażi tal-kunsens tiegħek jew fit-twettiq ta' kuntratt f'format strutturat, użat komunement\nu li jinqara permezz ta' magna jew li din id-data tintbagħat lil parti terza. Jekk titlob it-trasferiment dirett tad-data lil kontrollur ieħor responsabbli, dan jitwettaq biss jekk ikun teknikament fattibbli.</p><h5>Dritt ta' konferma u informazzjoni</h5><p>Int għandek id-dritt fi kwalunkwe ħin li tirċievi konferma mingħandna dwar jekk id-data personali li tikkonċernak hix qed tiġi pproċessata. F'dak il-każ, għandek id-dritt li titlob informazzjoni mingħandna b'xejn dwar id-data personali maħżuna li tikkonċernak.</p><h5>Dritt għar-rettifika</h5><p>Int għandek id-dritt li titlobna biex nikkoreġu kwalunkwe data personali skorretta li tikkonċernak mingħajr dewmien. B'kont meħud tal-għanijiet tal-ipproċessar, inti għandek id-dritt li tikseb il-kompletezza tad-data personali mhux kompluta.</p>\n<h5>Dritt għal tħassir (\"dritt li wieħed jintesa\")</h5><p>Skont l-Artikolu 17 tar-Regolament Ġenerali dwar il-Protezzjoni tad-Data (RĠPD), għandek id-dritt li titlobna nħassru d-data personali dwarek u aħna għandna l-obbligu li nħassru d-data personali mingħajr dewmien żejjed jekk tkun tapplika\nwaħda minn dawn ir-raġunijiet li ġejjin:</p>\n<p><ol>\n<li>Id-data personali ma tkunx għadha meħtieġa fir-rigward tal-għanijiet li għalihom tkun inġabret jew ġiet ipproċessata mod ieħor id-data.</li>\n<li>Is-suġġett tad-data jirtira l-kunsens li fuqu huwa bbażat l-ipproċessar skont  l-Artikolu 6 (1) jew  l-Artikolu 9 (2) u fejn ma jkun hemm l-ebda raġuni legali għall-ipproċessar.</li>\n<li>Is-suġġett tad-data joġġezzjona għall-ipproċessar skont l-Artikolu 21 (1) u ma jkun hemm l-ebda raġuni leġittima prevalenti għall-ipproċessar, jew is-suġġett tad-data joġġezzjona għall-ipproċessar skont l-Artikolu 21 (2).</li>\n<li>Id-data personali tkun ġiet ipproċessata illegalment.</li>\n<li>Id-data personali tkun trid titħassar biex ikun hemm konformità ma' obbligu legali fil-liġi tal-Unjoni jew ta' Stat Membru li għalih huwa soġġett il-kontrollur.</li>\n<li>Id-data personali tkun inġabret fir-rigward tal-offerta ta' servizzi tas-soċjetà tal-informazzjoni msemmija fl-Artikolu 8 (1).</li>\n</ol></p>\n\n<h5>Dritt għal restrizzjoni tal-ipproċessar</h5><p>Skont l-Artikolu 18 tar-RĠPD għandek id-dritt li tikseb mingħandna r-restrizzjoni tal-ipproċessar fejn tkun tapplika waħda minn dawn:</p>\n<p><ol>\n<li>is-suġġett tad-data jikkontesta l-eżattezza tad-data personali, għal perijodu li jippermetti li l-kontrollur jivverifika l-eżattezza tad-data personali;</li>\n<li>l-ipproċessar huwa illegali u s-suġġett tad-data jopponi t-tħassir tad-data personali u jitlob minflok ir-restrizzjoni tal-użu tagħha;</li>\n<li>il-kontrollur ma jkollux aktar bżonn tad-data personali għall-għanijiet tal-ipproċessar, iżda din tkun meħtieġa mis-suġġett tad-data għall-istabbiliment, l-eżerċizzju jew id-difiża ta' talbiet legali, jew</li>\n<li>is-suġġett tad-data jkun oġġezzjona għall-ipproċessar skont l-Artikolu 21 (1) sakemm jiġi vverifikat jekk il-kriterji leġittimi tal-kontrollur jegħlbux dawk tas-suġġett tad-data.</li>\n</ol></p>\n<h5>Kriptar tal-konnessjoni SSL jew TLS</h5><p>Għal raġunijiet ta' sigurtà u biex nipproteġu t-trasmissjoni ta' kontenut kunfidenzjali, bħal ordnijiet jew talbiet li tibgħatilna bħala l-operatur tas-sit, dan is-sit jikkripta l-konnessjoni SSL jew TLS. Tista' tagħraf konnessjoni kriptata mill-fatt li l-prefiss fil-linja tal-indirizz tal-browser tinbidel minn \"http: //\" għal \"https: //\" u mis-simbolu ta' katnazz fil-linja tal-indirizz fil-browser tiegħek.</p>\n\n<p>Meta l-kriptaġġ SSL jew TLS ikun attivat, id-data li tittrażmettilna ma tistax tinqara minn partijiet terzi.</p>\n<h4>3. Uffiċjal għall-protezzjoni tad-data</h4><h5>Uffiċjal għall-protezzjoni tad-data meħtieġ legalment</h5><p>Aħna ħtarna uffiċjal għall-protezzjoni tad-data għall-kumpanija tagħna.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nIl-Ġermanja</p>\n\n<p>Tel.: +498941325320<br>\nImejl: datenschutz&#64;heydata.eu</p><h4>4. Ġbir ta' data fuq il-websajt tagħna</h4><h5>Cookies</h5><p>Uħud mill-websajts jużaw l-hekk imsejħa \"cookies\". Il-cookies ma jagħmlux ħsara lill-kompjuter tiegħek u ma fihomx vajrusiijiet. Aħna nużaw il-cookies biex nagħmlu l-offerta tagħna aktar faċli, aktar effettiva u aktar sigura għall-utent. Il-cookies huma fajls tat-test żgħar li jinżammu fuq il-kompjuter tiegħek u li jiġu ssejvjati mill-browser tiegħek.</p>\n\n<p>Ħafna mill-cookies li nużaw aħna huma l-hekk imsejħa \"session cookies\". Dawn jitħassru awtomatikament wara ż-żjara tiegħek. Tipi oħra ta' cookies jibqgħu issejvjati fuq it-tagħmir tiegħek sakemm tħassarhom int. Dawn il-cookies jippermettulna\nnagħrfu l-browser tiegħek meta terġa' żżur il-websajt tagħna.</p>\n\n<p>Tista' tissettja l-browser tiegħek bit-tali mod li jinfurmak dwar il-ħażna ta' cookies u tippermetti biss cookies skont il-każ, tiċħad l-użu ta' cookies għal ċerti każijiet jew b'mod ġenerali, u tattiva t-tħassir awtomatiku tal-cookies malli tagħlaq il-browser. Jekk il-cookies jiġu disattivati, tista' tiġi ristretta l-funzjonalità ta' din il-websajt.</p>\n\n<p>Cookies li huma meħtieġa biex iwettqu l-proċess ta' komunikazzjoni elettronika jew biex jipprovdu ċerti funzjonijiet li tixtieq int (bħall-funzjoni ta' shopping cart) jiġu ssejvjati abbażi tal-Artikolu 6(1)(f) tar-RĠPD. L-operatur tal-websajt għandu interess leġittimu li jissejvja l-cookies għall-provvediment ottimizzat u teknikament ħieles minn żbalji tas-servizzi tiegħu. Jekk ikun hemm xi cookies oħra (eż. cookies għall-analiżi tal-imġieba tiegħek fin-navigazzjoni) ssejvjati, dawn jiġu ttrattati separatament f'din id-Dikjarazzjoni ta' Protezzjoni tad-Data.</p>\n\n\n\n<h5>Fajls tas-server logs</h5><p>Il-provditur tal-websajt jiġbor u jaħżen awtomatikament informazzjoni fil-fajls tas-server logs li l-browser tiegħek jittrażmettilna awtomatikament. Il-fajls fihom:</p>\n<p><ul>\n<li>it-tip u l-verżjoni tal-browser</li>\n<li>is-sistema operattiva wżata</li>\n<li>ir-riferitur tal-URL (Referrer URL)</li>\n<li>isem il-host (hostmname) tal-kompjuter li jaċċedi l-paġna</li>\n<li>il-ħin tal-aċċess għas-server</li>\n<li>l-indirizz IP</li>\n</ul></p>\n\n<p>Aħna ma ngħaqqdux din l-informazzjoni ma sorsi oħra ta' informazzjoni.</p>\n\n<p>L-ipproċessar tad-data jitwettaq abbażi tal-Artikolu 6(1)(f) tar-RĠPD, li jippermetti l-ipproċessar ta' data għat-twettiq ta' kuntratt jew miżuri prekuntrattwali.</p><h5>Formola ta' kuntatt</h5><p>Jekk tibgħatilna inkjesti permezz tal-formola ta' kuntatt, id-dettalji tiegħek mill-formola tal-inkjesta, inklużi d-dettalji ta' kuntatt li tkun ipprovdejt hemmhekk, jiġu maħżuna minna għall-iskop li nipproċessaw l-inkjesta u f'każ li jkollok xi mistoqsijiet ulterjuri. Aħna ma ngħaddux din id-data lil ħaddieħor mingħajr il-kunsens tiegħek.</p>\n\n<p>L-ipproċessar tad-data mdaħħla fil-formola ta' kuntatt jitwettaq esklussivament abbażi tal-kunsens tiegħek (l-Artikolu 6(1)(a) tar-RĠPD). Inti tista' tirrevoka l-kunsens tiegħek meta trid. Huwa biżżejjed li tiktbilna imejl informali. Il-legalità tal-proċessi għall-ipproċessar tad-data li jkunu ġew imwettqa qabel ir-revoka ma tiġix affettwata mir-revoka.</p>\n\n<p>Id-data li ddaħħal fil-formola ta' kuntatt tibqa' għandna sakemm titlobna nħassruha, tirrevoka l-kunsens tiegħek għall-ħażna jew inkella sakemm l-iskop għall-ħażna tad-data ma jibqax japplika (pereżempju, wara li t-talba tiegħek tkun ġiet ipproċessata). Id-dispożizzjonijiet statutorji obbligatorji – speċjalment il-perjodi ta' żamma – ma jiġux affettwati.</p>\n\n"])}
        }
      },
      "sl-SI": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izjava o varstvu podatkov"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Na kratko o varstvu podatkov</h4><h5>Splošne informacije</h5><p>Naslednje informacije vam nudijo preprost pregled nad tem, kaj se zgodi z vašimi osebnimi podatki, ko obiščete naše spletno mesto. Osebni podatki so vsi podatki, s pomočjo katerih vas je mogoče identificirati. Podrobne informacije o varstvu podatkov najdete v naši izjavi o varstvu podatkov pod tem besedilom.</p><h5>Zbiranje podatkov na našem spletnem mestu</h5><p>Kdo je odgovoren za zbiranje podatkov na tem spletnem mestu?</p>\n<p>Podatke, ki se zbirajo na tem spletnem mestu, obdeluje upravljavec spletnega mesta. Njegove kontaktne podatke najdete na tem spletnem mestu.</p><h5>Kako zbiramo vaše podatke?</h5><p>Med drugim podatke zbiramo tako, da nam jih posredujete vi sami. Pri tem gre lahko na primer za podatke, ki jih vnesete v kontaktni obrazec.</p>\n\n<p>Druge podatke pa ob vašem obisku spletnega mesta samodejno zbirajo naši informacijski sistemi. To vključuje predvsem tehnične podatke (npr. spletni brskalnik, operacijski sistem ali ura, kdaj ste obiskali spletno mesto). Ti podatki se zbirajo samodejno, čim odprete naše spletno mesto.</p><h5>Zakaj uporabljamo vaše podatke?</h5><p>Nekatere podatke zbiramo, da lahko zagotovimo brezhibno delovanje spletnega mesta. Drugi podatki pa se lahko uporabijo za analizo vedenja uporabnikov.</p><h5>Kakšne pravice imate v zvezi z vašimi podatki?</h5><p>Imate pravico, da kadar koli zahtevate brezplačne informacije o izvoru, prejemniku in namenu zbiranja vaših shranjenih osebnih podatkov. Prav tako imate pravico zahtevati popravek, blokado ali izbris teh podatkov. Če imate vprašanja glede svojih pravic ali varstva podatkov, se lahko kadar koli obrnete na nas s pomočjo kontaktnih podatkov, ki jih najdete na spletnem mestu. Poleg tega imate tudi pravico do vložitve pritožbe pri pristojnem nadzornem organu.</p><h4>2. Splošne in obvezne informacije</h4><h5>Varstvo podatkov</h5><p>Upravljavci teh spletnih strani varstvo vaših osebnih podatkov jemljejo zelo resno. Vaše osebne podatke obravnavamo kot zaupne in v skladu z zakonodajo na področju varstva podatkov ter to izjavo o varstvu podatkov.</p>\n\n<p>Če uporabljate to spletno mesto, se pri tem zbirajo različni osebni podatki. Ta izjava o varstvu podatkov pojasnjuje, katere podatke zbiramo in za kaj jih uporabljamo.</p>\n\n<p>Opozarjamo na to, da lahko pri prenosu podatkov na internetu (npr. med komuniranjem po elektronski pošti) pride do varnostnih pomanjkljivosti. Popolna zaščita podatkov pred dostopom tretjih oseb ni mogoča.</p><h5>Informacije o odgovorni osebi</h5><p>Oseba, ki je odgovorna za obdelavo podatkov na tem spletnem mestu:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nNemčija</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nElektronska pošta: zentrale&#64;dutypay.eu</p>\n\n<p>Odgovorna oseba ja fizična ali pravna oseba, ki samostojno ali skupaj z drugimi odloča o namenu in načinu obdelave osebnih podatkov (npr. imen, naslovov elektronske pošte ipd.).</p><h5>Preklic vašega soglasja za obdelavo podatkov</h5><p>Številni postopki obdelave podatkov so mogoči le z vašim izrecnim soglasjem. Soglasje, ki ste ga že podali, lahko kadar koli tudi prekličete. Za to zadošča že neformalna zahteva, ki nam jo posredujete po elektronski pošti. Preklic soglasja ne vpliva na zakonitost obdelave podatkov pred preklicem soglasja.</p><h5>Pravica do vložitve pritožbe pri pristojnem nadzornem organu</h5><p>V primeru kršitev predpisov na področju varstva podatkov imate pravico do vložitve pritožbe pri pristojnem nadzornem organu. Za kršitve predpisov na področju varstva podatkov je pristojna deželni pooblaščenec za varstvo podatkov zvezne države, v kateri se nahaja sedež našega podjetja. Seznam pooblaščencev za varstvo podatkov ter njihovi kontaktni podatki so na voljo na naslednji povezavi:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Pravica do prenosljivosti podatkov</h5><p>Imate pravico zahtevati, da se podatki, ki jih na podlagi vašega soglasja ali za izpolnjevanje pogodbe samodejno obdelujemo, v splošno uporabljani in strojno berljivi obliki prenesejo vam ali tretji osebi. V kolikor želite, da se podatki neposredno prenesejo drugi odgovorni osebi, bo to izvedeno le, če je tehnično mogoče.</p><h5>Pravica do pridobitve potrditve in sporočila o obdelavi osebnih podatkov</h5><p>Kadar koli lahko zahtevate, da vam pošljemo potrditev, ali obdelujemo osebne podatke, ki se nanašajo na vas. Če je tako, imate pravico, da od nas zahtevate breplačne informacije o shranjenih osebnih podatkih, ki se nanašajo na vas.</p><h5>Pravica do popravka</h5><p>Imate pravico zahtevati od nas, da nemudoma popravimo netočne osebne podatke, ki se nanašajo na vas. Ob upoštevanju namenov obdelave podatkov imate pravico zahtevati dopolnitev pomanjkljivih osebnih podatkov.</p><h5>Pravica do izbrisa (\"pravica do pozabe\")</h5><p>V skladu s členom 17 splošne uredbe o varstvu podatkov imate pravico zahtevati, da nemudoma izbrišemo osebne podatke, ki se nanašajo na vas, in obvezani smo, da zadevne osebne podatke nemudoma izbrišemo, če velja eden od naslednjih razlogov:</p>\n<p><ol>\n<li>Osebni podatki za namene, za katere so bili zbrani ali na drug način obdelani, niso več potrebni.</li>\n<li>Posameznik, na katerega se nanašajo osebni podatki, prekliče svoje soglasje, na katerem temelji obdelava podatkov v skladu s členom 6(1)(a) ali členom 9(2)(a) in za obdelavo ne obstaja druga pravna podlaga.</li>\n<li>Posameznik, na katerega se nanašajo osebni podatki, obdelavi podatkov ugovarja v skladu s členom 21(1) in za obdelavo ne obstajajo nobeni prevladujoči zakoniti razlogi, ali pa posameznik, na katerega se nanašajo osebni podatki, obdelavi ugovarja v skladu s členom 21(2).</li>\n<li>Osebni podatki so bili obdelani nezakonito.</li>\n<li>Osebne podatke je treba izbrisati za izpolnitev pravne obveznosti v skladu s pravom Unije ali pravom države članice, ki velja za odgovorno osebo.</li>\n<li>Osebni podatki so bili zbrani v zvezi s ponudbo storitev informacijske družbe v skladu s členom 8(1).</li>\n</ol></p><h5>Pravica do omejitve obdelave</h5><p>V skladu s členom 18 splošne uredbe o varstvu podatkov lahko zahtevate, da omejimo obdelavo podatkov, če velja eden od naslednjih pogojev:</p>\n<p><ol>\n<li>posameznik, na katerega se nanašajo osebni podatki, oporeka točnosti podatkov, in sicer za obdobje, ki upravljavcu omogoča preveriti točnost osebnih podatkov;</li>\n<li>je obdelava nezakonita in posameznik, na katerega se nanašajo osebni podatki, nasprotuje izbrisu osebnih podatkov ter namesto tega zahteva omejitev njihove uporabe;</li>\n<li>upravljavec osebnih podatkov ne potrebuje več za namene obdelave, temveč jih posameznik, na katerega se nanašajo osebni podatki, potrebuje za uveljavljanje, izvajanje ali obrambo pravnih zahtevkov, ali</li>\n<li>je posameznik, na katerega se nanašajo osebni podatki, vložil ugovor v zvezi z obdelavo v skladu s členom 21(1), dokler se ne preveri, ali zakoniti razlogi upravljavca prevladajo nad razlogi posameznika, na katerega se nanašajo osebni podatki.</li>\n</ol></p><h5>Šifriranje SSL oziroma TLS</h5><p>Iz varnostnih razlogov in za zaščito prenosa zaupnih vsebin, kot so na primer naročila ali zahteve, ki nam jih posredujete kot upravljavcu spletne strani, uporabljamo šifriranje SSL oziroma TLS. Šifrirano povezavo prepoznate po tem, da se naslov spletnega mesta v vašem brskalniku iz »http://« spremeni v »https://« in po simbolu ključavnice zraven naslova spletnega mesta.</p>\n\n<p>Ko je šifriranje SSL oziroma TLS vključeno, tretje osebe ne morejo dostopati do podatkov, ki nam jih pošiljate.</p><h4>3. Pooblaščenec za varstvo podatkov</h4><h5>Zakonsko določeni pooblaščenec za varstvo podatkov</h5><p>Za naše podjetje smo imenovali pooblaščenca za varstvo podatkov.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nNemčija</p>\n\n<p>Telefon: +498941325320<br>\nElektronska pošta: datenschutz&#64;heydata.eu</p><h4>4. Zbiranje podatkov na našem spletnem mestu</h4><h5>Piškotki</h5><p>Spletne strani deloma uporabljajo tako imenovane piškotke. Piškotki ne škodujejo vašemu računalniku in ne vsebujejo virusov. Piškotki nam omogočajo, da oblikujemo uporabniku prijaznejšo ponudbo ter učinkovite in varne spletne strani. Piškotki so majhne besedilne datoteke, ki jih brskalnik shrani na vašem računalniku.</p>\n\n<p>Večinoma uporabljamo tako imenovane začasne ali sejne piškotke. Ti se samodejno izbrišejo, ko zapustite naše spletno mesto. Drugi piškotki se shranijo na vaši končni napravi, dokler jih ne izbrišete. Ti piškotki nam omogočajo, da ob vašem naslednjem obisku prepoznamo vaš brskalnik.</p>\n\n<p>V vašem brskalniku lahko izberete nastavitev, da ste vedno obveščeni o uporabi piškotkov in jih omogočite le v posameznem primeru, uporabo piškotkov omogočite v določenih primerih ali pa na splošno onemogočite njihovo uporabo. Lahko izberete tudi možnost, da se piškotki izbrišejo, ko zaprete brskalnik. Če onemogočite uporabo piškotkov, lahko to vpliva na delovanje tega spletnega mesta.</p>\n\n<p>Piškotki, ki so potrebni za postopke elektronske komunikacije ali zagotavljanje določenih funkcij, ki jih zahtevate (na primer možnost nakupovalnega vozička), se shranjujejo na podlagi člena 6(1)(f) splošne uredbe o varstvu podatkov. Upravljavec spletnega mesta ima zakoniti interes za shranjevanje piškotkov, da lahko zagotavlja tehnično brezhibno delovanje in optimiziranje svojih storitev. Če se shranjujejo drugi piškotki (na primer piškotki za analizo vašega vedenja na spletu), so ti v tej izjavi o varstvu podatkov obravnavani ločeno.</p><h5>Dnevniške datoteke strežnika</h5><p>Ponudnik spletnih strani samodejno zbira in shranjuje informacije v tako imenovanih dnevniških datotekah strežnika, ki nam jih samodejno posreduje vaš brskalnik. To so:</p>\n<p><ul>\n<li>vrsta in različica brskalnika,</li>\n<li>operacijski sistem vaše naprave,</li>\n<li>naslov spletnega mesta, s katerega ste prispeli na naše spletno mesto,</li>\n<li>ime računalnika, prek katerega dostopate do našega spletnega mesta,</li>\n<li>ura, kdaj je bila zahteva posredovana strežniku,</li>\n<li>IP naslov.</li>\n</ul></p>\n\n<p>Ti podatki se ne združujejo s podatki, pridobljenimi iz drugih virov.</p>\n\n<p>Osnova za obdelavo podatkov je člen 6(1)(f) splošne uredbe o varstvu podatkov, ki obdelavo podatkov dovoljuje za izvajanje pogodbe ali predpogodbenih ukrepov.</p><h5>Kontaktni obrazec</h5><p>Če nam zahteve posredujete s pomočjo kontaktnega obrazca, bomo podatke, ki jih navedete v obrazcu, vključno z vašimi kontaktnii podatki, shranili za namene obdelave vaše zahteve in za primer dodatnih vprašanj. Teh podatkov brez vašega soglasja ne bomo posredovali tretjim osebam.</p>\n\n<p>Obdelava podatkov, ki jih vnesete v kontaktni obrazec, tako poteka izključno na podlagi vašega soglasja (člen 6(1)(a) splošne uredbe o varstvu podatkov). To soglasje lahko kadar koli prekličete. Za to zadošča že neformalna zahteva, ki nam jo posredujete po elektronski pošti. Preklic soglasja ne vpliva na zakonitost obdelave podatkov pred preklicem soglasja.</p>\n\n<p>Podatke, ki nam jih posredujete v kontaktnem obrazcu, hranimo dokler ne zahtevate njihovega izbrisa, prekličete svoje soglasje za hranjenje podatkov ali hranjenje podatkov ni več potrebno (na primer ko je obdelava vaše zahteve zaključena). To ne vpliva na zavezujoče zakonske določbe – predvsem roke za hranjenje podatkov.</p>"])}
        }
      },
      "el-CY": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δήλωση προστασίας δεδομένων"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Προστασία δεδομένων με μια ματιά</h4><h5>Γενικές πληροφορίες</h5><p>Οι ακόλουθες πληροφορίες παρέχουν μια απλή επισκόπηση του τι συμβαίνει στα προσωπικά σας δεδομένα όταν επισκέπτεστε τον ιστότοπό μας.\nΤα προσωπικά δεδομένα είναι όλα τα δεδομένα με τα οποία μπορείτε να ταυτοποιηθείτε προσωπικά. Λεπτομερείς πληροφορίες σχετικά με το θέμα της προστασίας δεδομένων μπορείτε να βρείτε στη δήλωση προστασίας δεδομένων που αναφέρεται παρακάτω σε αυτό το κείμενο.</p>\n<h5>Συλλογή δεδομένων στον ιστότοπό μας</h5><p>Ποιος είναι υπεύθυνος για τη συλλογή δεδομένων σε αυτόν τον ιστότοπο;</p>\n<p>Η επεξεργασία δεδομένων σε αυτόν τον ιστότοπο πραγματοποιείται από τον χειριστή του ιστότοπου. Μπορείτε να βρείτε αυτά τα στοιχεία επικοινωνίας στα στοιχεία έκδοσης αυτού του ιστότοπου.</p><h5>Πώς συλλέγουμε τα δεδομένα σας;</h5><p>Τα δεδομένα σας συλλέγονται πρωτίστως όταν τα παρέχετε σε εμάς. Μπορεί να πρόκειται, π.χ. για δεδομένα που εισάγετε σε μια φόρμα επικοινωνίας.</p>\n\n<p>Άλλα δεδομένα καταγράφονται αυτόματα από τα συστήματα πληροφορικής μας όταν επισκέπτεστε τον ιστότοπο. Πρόκειται κυρίως για τεχνικά δεδομένα (π.χ. πρόγραμμα περιήγησης Διαδικτύου, λειτουργικό σύστημα ή ώρα επίσκεψης της σελίδας). Αυτά τα δεδομένα συλλέγονται αυτόματα μόλις μπείτε στον ιστότοπό μας.</p><h5>Για ποιον λόγο χρησιμοποιούμε τα δεδομένα σας;</h5><p>Ορισμένα από τα δεδομένα συλλέγονται προκειμένου να διασφαλιστεί ότι ο ιστότοπος δεν περιέχει σφάλματα. Άλλα δεδομένα μπορούν να χρησιμοποιηθούν για την ανάλυση της συμπεριφοράς σας ως χρήστη.</p><h5>Ποια δικαιώματα έχετε σχετικά με τα δεδομένα σας;</h5><p>Έχετε ανά πάσα στιγμή το δικαίωμα να λαμβάνετε δωρεάν πληροφορίες σχετικά με την προέλευση, τον παραλήπτη και τον σκοπό των αποθηκευμένων προσωπικών σας δεδομένων. Έχετε επίσης το δικαίωμα να ζητήσετε τη διόρθωση, τον αποκλεισμό ή τη διαγραφή αυτών των δεδομένων. Μπορείτε να επικοινωνήσετε μαζί μας ανά πάσα στιγμή στη διεύθυνση που αναφέρεται στα στοιχεία έκδοσης, εάν έχετε περαιτέρω απορίες σχετικά με την προστασία δεδομένων. Έχετε επίσης το δικαίωμα να υποβάλετε καταγγελία στην αρμόδια εποπτική αρχή.</p><h4>2. Γενικές υποδείξεις και υποχρεωτικές πληροφορίες</h4><h5>Προστασία δεδομένων</h5><p>Οι χειριστές αυτού του ιστότοπου λαμβάνουν την προστασία των προσωπικών σας δεδομένων πολύ σοβαρά. Αντιμετωπίζουμε τα προσωπικά σας δεδομένα εμπιστευτικά και σύμφωνα με τους ισχύοντες κανονισμούς για την προστασία των δεδομένων και την παρούσα δήλωση προστασίας δεδομένων.</p>\n\n<p>Όταν χρησιμοποιείτε αυτόν τον ιστότοπο, συλλέγονται διάφορα προσωπικά δεδομένα. Αυτή η δήλωση προστασίας δεδομένων εξηγεί ποια δεδομένα συλλέγουμε και για ποιον σκοπό τα χρησιμοποιούμε.</p>\n\n<p>Επισημαίνουμε ότι η διαβίβαση δεδομένων μέσω του Διαδικτύου (π.χ. κατά την επικοινωνία μέσω e-mail) μπορεί να παρουσιάσει κενά ασφάλειας. Δεν είναι δυνατή η πλήρης προστασία των δεδομένων έναντι πρόσβασης από τρίτους.</p><h5>Σημείωση για τον αρμόδιο φορέα</h5><p>Ο αρμόδιος φορέας για την επεξεργασία δεδομένων σε αυτόν τον ιστότοπο είναι:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Κάιζερσλαουτερν<br>\nΓερμανία</p>\n\n<p>Τηλέφωνο: +49 (0)631 5600 1600<br>\nE-Mail: zentrale&#64;dutypay.eu</p>\n\n<p>Ο αρμόδιος φορέας είναι το φυσικό ή νομικό πρόσωπο που, μόνος ή από κοινού με άλλους, αποφασίζει για τους σκοπούς και τα μέσα επεξεργασίας προσωπικών δεδομένων (π.χ. ονόματα, διευθύνσεις e-mail κ.λπ.).</p><h5>Ανάκληση της συγκατάθεσής σας για την επεξεργασία δεδομένων</h5><p>Πολλές διαδικασίες επεξεργασίας δεδομένων είναι δυνατές μόνο με τη ρητή συγκατάθεσή σας. Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Αρκεί ένα ανεπίσημο e-mail σε εμάς. Η νομιμότητα της επεξεργασίας δεδομένων που πραγματοποιήθηκε πριν από την ανάκληση παραμένει ανεπηρέαστη από την ανάκληση.</p><h5>Δικαίωμα καταγγελίας στην αρμόδια εποπτική αρχή</h5><p>Σε περίπτωση παραβίασης της νομοθεσίας περί προστασίας δεδομένων, το υποκείμενο των δεδομένων έχει το δικαίωμα να υποβάλει καταγγελία στην αρμόδια εποπτική αρχή. Η αρμόδια εποπτική αρχή για θέματα προστασίας δεδομένων είναι ο υπεύθυνος προστασίας δεδομένων του ομοσπονδιακού κρατιδίου στο οποίο εδρεύει η εταιρεία μας. Μια λίστα υπεύθυνων προστασίας δεδομένων και τα στοιχεία επικοινωνίας τους βρίσκονται στον παρακάτω σύνδεσμο:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p><h5>Δικαίωμα φορητότητας δεδομένων</h5><p>Έχετε το δικαίωμα να διαβιβάσετε τα δεδομένα, που επεξεργαζόμαστε αυτόματα βάσει της συγκατάθεσής σας ή στο πλαίσιο εκπλήρωσης μιας σύμβασης, σε εσάς ή σε τρίτο μέρος σε κοινή, αναγνώσιμη από μηχάνημα μορφή. Εάν ζητήσετε την άμεση διαβίβαση των δεδομένων σε άλλο υπεύθυνο άτομο, αυτό θα γίνει μόνο εάν είναι τεχνικά εφικτό.</p><h5>Δικαίωμα επιβεβαίωσης και ενημέρωσης</h5><p>Έχετε το δικαίωμα ανά πάσα στιγμή να λάβετε επιβεβαίωση από εμάς σχετικά με το εάν υποβάλλονται σε επεξεργασία προσωπικά δεδομένα που σχετίζονται με εσάς. Σε αυτήν την περίπτωση, έχετε το δικαίωμα να ζητήσετε δωρεάν πληροφορίες από εμάς σχετικά με τα προσωπικά δεδομένα που είναι αποθηκευμένα για εσάς.</p><h5>Δικαίωμα διόρθωσης</h5><p>Έχετε το δικαίωμα να μας ζητήσετε να διορθώσουμε αμέσως τυχόν εσφαλμένα προσωπικά δεδομένα που σας αφορούν. Λαμβάνοντας υπόψη τους σκοπούς της επεξεργασίας, έχετε το δικαίωμα να ζητήσετε τη συμπλήρωση ελλιπών προσωπικών δεδομένων.</p><h5>Δικαίωμα διαγραφής («δικαίωμα λήθης»)</h5><p>Σύμφωνα με το άρθρο 17 του GDPR, έχετε το δικαίωμα να ζητήσετε την άμεση διαγραφή προσωπικών δεδομένων που σας αφορούν και είμαστε υποχρεωμένοι να διαγράψουμε τα προσωπικά δεδομένα αμέσως εάν ισχύει ένας από τους ακόλουθους λόγους:</p>\n<p><ol>\n<li>Τα προσωπικά δεδομένα δεν είναι πλέον απαραίτητα για τους σκοπούς για τους οποίους συλλέχθηκαν ή υποβλήθηκαν σε άλλη επεξεργασία.</li>\n<li>Το υποκείμενο των δεδομένων ανακαλεί τη συγκατάθεση στην οποία βασίστηκε η επεξεργασία σύμφωνα με το άρθρο 6 παράγραφος 1 στοιχείο α) ή το άρθρο 9 παράγραφος 2 στοιχείο α) και δεν υπάρχει άλλη νομική βάση για την επεξεργασία.</li>\n<li>Το υποκείμενο των δεδομένων αντιτίθεται στην επεξεργασία σύμφωνα με το άρθρο 21 παράγραφος 1 και δεν υπάρχουν επιτακτικοί νόμιμοι λόγοι για την επεξεργασία, ή το υποκείμενο των δεδομένων αντιτίθεται στην επεξεργασία σύμφωνα με το άρθρο 21 παράγραφος 2.</li>\n<li>Τα προσωπικά δεδομένα υποβλήθηκαν παράνομα σε επεξεργασία.</li>\n<li>Η διαγραφή των προσωπικών δεδομένων είναι απαραίτητη για την εκπλήρωση νομικής υποχρέωσης σύμφωνα με το δίκαιο της Ένωσης ή το δίκαιο των κρατών μελών στο οποίο υπόκειται ο υπεύθυνος.</li>\n<li>Τα προσωπικά δεδομένα συλλέχθηκαν σε σχέση με τις υπηρεσίες της εταιρείας πληροφοριών που προσφέρονται σύμφωνα με το άρθρο 8 παράγραφος 1.</li>\n</ol></p><h5>Δικαίωμα περιορισμού της επεξεργασίας</h5><p>Σύμφωνα με Άρθρο 18 GDPR, έχετε το δικαίωμα να ζητήσετε να περιορίσουμε την επεξεργασία εάν εκπληρώνεται μία από τις ακόλουθες προϋποθέσεις:</p>\n<p><ol>\n<li>η ορθότητα των προσωπικών δεδομένων αμφισβητείται από το υποκείμενο των δεδομένων&nbsp; για μια περίοδο που επιτρέπει στον υπεύθυνο να ελέγξει την ορθότητα των προσωπικών δεδομένων,</li>\n<li>η επεξεργασία είναι παράνομη και το υποκείμενο των δεδομένων απορρίπτει τη διαγραφή των προσωπικών δεδομένων και αντ’ αυτού ζητά να περιοριστεί η χρήση των προσωπικών δεδομένων,</li>\n<li>ο υπεύθυνος επεξεργασίας των προσωπικών δεδομένων δεν χρειάζεται πλέον τα προσωπικά δεδομένα για σκοπούς επεξεργασίας, αλλά το υποκείμενο των δεδομένων τα χρειάζεται για να διεκδικήσει, να ασκήσει ή να υπερασπιστεί νομικές αξιώσεις ή</li>\n<li>το υποκείμενο των δεδομένων υπέβαλε ένσταση κατά της επεξεργασίας σύμφωνα με το άρθρο 21 παράγραφος 1, εφόσον δεν έχει ακόμη καθοριστεί, εάν οι νόμιμοι λόγοι του υπεύθυνου υπερισχύουν εκείνων του υποκειμένου των δεδομένων.</li>\n</ol></p><h5>Κρυπτογράφηση SSL ή/και TLS</h5><p>Για λόγους ασφαλείας και για την προστασία της διαβίβασης εμπιστευτικού περιεχομένου, όπως παραγγελίες ή ερωτήσεις που μας στέλνετε ως διαχειριστής ιστότοπου, αυτός ο ιστότοπος χρησιμοποιεί Κρυπτογράφηση SSL ή TLS. Μπορείτε να αναγνωρίσετε μια κρυπτογραφημένη σύνδεση από τη γραμμή διευθύνσεων του προγράμματος περιήγησης που αλλάζει από 'http://' σε 'https://' και από το σύμβολο της κλειδαριάς στη γραμμή του προγράμματος περιήγησής σας.</p>\n\n<p>Εάν η κρυπτογράφηση SSL ή TLS είναι ενεργοποιημένη, τα δεδομένα που μας διαβιβάζετε δεν μπορούν να διαβαστούν από τρίτους.</p><h4>3. Υπεύθυνος προστασίας δεδομένων</h4><h5>Νόμιμος υπεύθυνος προστασίας δεδομένων</h5><p>Έχουμε διορίσει έναν υπεύθυνο προστασίας δεδομένων για την εταιρεία μας.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Βερολίνο<br>\nΓερμανία</p>\n\n<p>Τηλέφωνο: +498941325320<br>\nE-Mail: datenschutz&#64;heydata.eu</p><h4>4. Συλλογή δεδομένων στον ιστότοπό μας</h4><h5>Cookies</h5><p>Οι ιστότοποι χρησιμοποιούν μερικώς τα λεγόμενα cookies. Τα cookies δεν βλάπτουν τον υπολογιστή σας και δεν περιέχουν ιούς. Τα cookies χρησιμεύουν για να κάνουν τις υπηρεσίες μας πιο φιλικές, πιο αποτελεσματικές και ασφαλέστερες. Τα cookies είναι μικρά αρχεία κειμένου που εγκαθίστανται στον υπολογιστή σας και αποθηκεύονται από το πρόγραμμα περιήγησής σας.</p>\n<p>Τα περισσότερα από τα cookies που χρησιμοποιούμε είναι τα λεγόμενα «session cookies». Διαγράφονται αυτόματα μετά την επίσκεψή σας. Άλλα cookies παραμένουν αποθηκευμένα στη συσκευή σας έως ότου τα διαγράψετε. Αυτά τα cookies μας δίνουν τη δυνατότητα να αναγνωρίσουμε το πρόγραμμα περιήγησής σας κατά την επόμενη επίσκεψή σας.</p>\n<p>Μπορείτε να ρυθμίσετε το πρόγραμμα περιήγησής σας έτσι ώστε να ενημερώνεστε για την εγκατάσταση των cookies και να επιτρέπετε τα cookies μόνο σε μεμονωμένες περιπτώσεις, να αποκλείσετε την αποδοχή των cookies για ορισμένες περιπτώσεις ή εν γένει και να ενεργοποιήσετε την αυτόματη διαγραφή των cookies όταν κλείνετε το πρόγραμμα περιήγησης. Εάν τα cookies είναι απενεργοποιημένα, η λειτουργικότητα αυτού του ιστότοπου ενδέχεται να είναι περιορισμένη.</p>\n<p>Τα cookies που απαιτούνται για τη διεξαγωγή της διαδικασίας ηλεκτρονικής επικοινωνίας ή για την παροχή ορισμένων λειτουργιών που χρειάζεστε (π.χ. λειτουργία καλαθιού αγορών) αποθηκεύονται βάσει του άρθρου 6 παράγραφος 1 στοιχείο στ) GDPR. Ο διαχειριστής της ιστοσελίδας έχει έννομο συμφέρον να αποθηκεύει cookies για την τεχνικά χωρίς σφάλματα και βελτιστοποιημένη παροχή των υπηρεσιών του. Εάν αποθηκεύονται άλλα cookies (π.χ. cookies για την ανάλυση της συμπεριφοράς περιήγησής σας), αντιμετωπίζονται ξεχωριστά σε αυτήν τη δήλωση προστασίας δεδομένων.</p><h5>Αρχεία καταγραφής διακομιστή</h5><p>Ο πάροχος ιστότοπου συλλέγει και αποθηκεύει αυτόματα πληροφορίες στα λεγόμενα αρχεία καταγραφής διακομιστή, τα οποία διαβιβάζει αυτόματα το πρόγραμμα περιήγησής σας σε εμάς. Αυτά είναι:</p>\n<p><ul>\n<li>Τύπος προγράμματος περιήγησης και έκδοση προγράμματος περιήγησης</li>\n<li>Λειτουργικό σύστημα που χρησιμοποιείται</li>\n<li>Διεύθυνση URL αναφοράς</li>\n<li>Όνομα κεντρικού υπολογιστή στον υπολογιστή πρόσβασης</li>\n<li>Ώρα του αιτήματος διακομιστή</li>\n<li>Διεύθυνση IP</li>\n</ul></p>\n<p>Αυτά τα δεδομένα δεν θα συγχωνευτούν με άλλες πηγές δεδομένων.</p>\n\n<p>Η βάση για την επεξεργασία δεδομένων είναι το άρθρο 6 παράγραφος 1 στοιχείο στ) GDPR, το οποίο επιτρέπει στην επεξεργασία δεδομένων να εκπληρώνει συμβάσεις ή προσυμβατικά μέτρα.</p><h5>Φόρμα Επικοινωνίας</h5><p>Εάν μας στείλετε ερώτημα χρησιμοποιώντας τη φόρμα επικοινωνίας, τα στοιχεία σας από τη φόρμα αιτήματος, συμπεριλαμβανομένων των στοιχείων επικοινωνίας που δώσατε εκεί, θα αποθηκευτούν από εμάς για τους σκοπούς της επεξεργασίας του ερωτήματος και σε περίπτωση επακόλουθων ερωτήσεων. Δεν διαβιβάζουμε αυτά τα δεδομένα χωρίς τη συγκατάθεσή σας.</p>\n\n<p>Η επεξεργασία των δεδομένων που εισάγονται στη φόρμα επικοινωνίας πραγματοποιείται αποκλειστικά βάσει της συγκατάθεσής σας (άρθρο 6 παράγραφος 1 στοιχείο α) GDPR). Μπορείτε να ανακαλέσετε αυτήν τη συγκατάθεση ανά πάσα στιγμή. Αρκεί ένα ανεπίσημο e-mail σε εμάς. Η νομιμότητα των διαδικασιών επεξεργασίας δεδομένων που πραγματοποιήθηκαν πριν από την ανάκληση παραμένει ανεπηρέαστη από την ανάκληση.</p>\n\n<p>Τα δεδομένα που εισάγετε στη φόρμα επικοινωνίας θα διατηρούνται σε εμάς έως ότου μας ζητήσετε να τα διαγράψουμε, να ανακαλέσετε τη συγκατάθεσή σας για αποθήκευση ή να μην ισχύει πλέον ο σκοπός της αποθήκευσης δεδομένων (π.χ. μετά την επεξεργασία του αιτήματός σας). Οι υποχρεωτικές νομικές διατάξεις – ιδίως οι περίοδοι αποθήκευσης – παραμένουν ανεπηρέαστες.</p>\n\n"])}
        }
      },
      "tr-CY": {
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri Koruma Beyanı"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<h4>1. Bir bakışta veri koruması</h4><h5>Genel açıklamalar</h5><p>Aşağıdaki açıklamalar, web sitemizi ziyaret ettiğinizde kişisel verilerinize ne olduğuna dair basit bir genel bakış sunmaktadır. Kişisel veri, kişisel olarak kimliğinizin belirlenmesine yönelik her türlü bilgiyi ifade eder. Veri koruma konusuyla ilgili ayrıntılı bilgileri, bu metnin altında yer alan veri koruma beyanımızda bulabilirsiniz.</p><h5>Web sitemizde veri toplama</h5><p>Bu web sitesinde verilerin toplanmasından kim sorumludur?</p>\n<p>Bu web sitesinde verilerin işlenmesi, web sitesi operatörü tarafından yürütülür. Operatörün iletişim bilgilerini bu web sitesinin Künye bölümünde bulabilirsiniz.</p>\n<h5>Verilerinizi nasıl topluyoruz?</h5><p>Bir taraftan, verileriniz bize ilettiğinizde toplanır. Bunlar, örneğin bir iletişim formuna girdiğiniz veriler olabilir.</p>\n<p>Diğer veriler, web sitesini ziyaret ettiğinizde BT sistemlerimiz tarafından otomatik olarak toplanır. Bunlar, öncelikli olarak teknik verilerdir (örneğin internet tarayıcısı, işletim sistemi veya sitenin görüntülenme zamanı). Bu verilerin toplanması, web sitemize girdiğinizde otomatik olarak gerçekleşir.</p>\n<h5>Verilerinizi ne için kullanıyoruz?</h5><p>Verilerin bir kısmı, web sitesinin hatasız bir şekilde kullanıma sunulmasını sağlamak için kullanılır. Diğer veriler kullanıcı davranışınızı analiz etmek için kullanılabilir.</p><h5>Verilerinizle ilgili olarak hangi haklara sahipsiniz?</h5><p>Operatör tarafından depolanan kişisel verilerinizin kaynağı, alıcısı ve amacı hakkında dilediğiniz zaman ücretsiz bilgi alma hakkına sahipsiniz. Ayrıca, bu verilerin düzeltilmesini, engellenmesini veya silinmesini isteme hakkına sahipsiniz. Bu konuda ve veri koruma hakkındaki diğer sorularınız için, Künye bölümünde verilen adresten dilediğiniz zaman bizimle iletişime geçebilirsiniz. Ayrıca, yetkili denetim makamına şikayette bulunma hakkınız da vardır.</p><h4>2. Genel açıklamalar ve zorunlu bilgiler</h4><h5>Veri koruma</h5><p>Bu web sitesinin operatörleri, kişisel verilerinizin korunmasını son derece ciddiye almaktadır. Kişisel verilerinizi gizli ve yasal veri koruma düzenlemelerinin yanı sıra bu veri koruma beyanına uygun olarak ele almaktayız.</p>\n\n<p>Bu web sitesini kullandığınızda, çeşitli kişisel veriler toplanmaktadır. Bu veri koruma beyanı, hangi verileri topladığımızı ve ne için kullandığımızı açıklamaktadır.</p>\n\n<p>İnternet üzerinden veri iletiminin (örneğin e-posta ile iletişim sırasında) güvenlik açıkları olabileceğini belirtmek isteriz. Verilerin üçüncü şahısların erişimine karşı tam olarak korunması mümkün değildir.</p><h5>Veri sorumlusuna ilişkin not</h5><p>Bu web sitesinde verilerin işlenmesinden aşağıdaki kuruluş sorumludur:</p>\n<p>DutyPay GmbH<br>\nPirmasenser Str. 1<br>\n67655 Kaiserslautern<br>\nAlmanya</p>\n\n<p>Telefon: +49 (0)631 5600 1600<br>\nE-posta: zentrale&#64;dutypay.eu</p>\n\n<p>Veri sorumlusu, kişisel verilerin (örneğin isimler, e-posta adresleri vb.) işlenme amaçlarına ve araçlarına tek başına veya başkalarıyla birlikte karar veren gerçek veya tüzel kişidir.</p>\n<h5>Verilerin işlenmesi için verdiğiniz açık rızanın iptali</h5><p>Birçok veri işleme süreci, ancak sizin açık rızanızla mümkündür. Daha önce vermiş olduğunuz bir açık rızayı dilediğiniz zaman iptal edebilirsiniz. Bunun için bize şekle bağlı olmayan bir e-posta ile bildirimde bulunmanız yeterlidir. İptale kadar gerçekleştirilen veri işlemenin yasallığı, iptal işleminden etkilenmez.</p>\n<h5>Yetkili denetim makamına şikayette bulunma hakkı</h5><p>Veri koruma yasasıyla ilgili ihlaller durumunda, ilgili kişi yetkili denetim makamına şikayette bulunma hakkına sahiptir. Veri koruma yasasıyla ilgili konularda, şirketimizin merkezinin bulunduğu federal eyaletin eyalet veri koruma görevlisi, yetkili denetim makamıdır. Veri koruma görevlilerinin bir listesi ve bunların iletişim bilgileri, şu bağlantıda bulunabilir:</p>\n<p><a href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'>https://www.bfdi.bund.de</a></p>\n<h5>Veri taşınabilirliği hakkı</h5><p>Açık rızanız veya bir sözleşmenin yerine getirilmesi temelinde otomatik olarak işlediğimiz verilerin size veya üçüncü bir tarafa, yaygın olarak kullanılan, makine tarafından okunabilir bir formatta teslim edilmesini isteme hakkınız bulunmaktadır. Verilerin başka bir veri sorumlusuna doğrudan aktarılmasını istemeniz halinde, bu yalnızca teknik olarak mümkün olduğu sürece gerçekleşir.</p>\n<h5>Onay ve bilgi isteme hakkı</h5><p>Sizinle ilgili kişisel verilerin işlenip işlenmediği konusunda bizden dilediğiniz zaman bir onay alma hakkına sahipsiniz. Böyle bir durumda, sizinle ilgili olarak depolanan kişisel veriler hakkında bizden ücretsiz bilgi isteme hakkına sahipsiniz.</p><h5>Düzeltme yapılmasını isteme hakkı</h5><p>Sizinle ilgili her türlü yanlış kişisel veriyi derhal düzeltmemizi isteme hakkına sahipsiniz. Veri işlemenin amaçlarını göz önünde bulundurarak, eksik kişisel verilerin tamamlanmasını isteme hakkına sahipsiniz.</p><h5>Sildirme hakkı (\"Unutulma hakkı\")</h5><p>Genel Veri Koruma Yönetmeliği'nin (DSGVO) 17. maddesi uyarınca, bizden sizinle ilgili kişisel verilerin derhal silinmesini isteme hakkınız, bizim de aşağıdaki nedenlerden birinin geçerli olması durumunda, söz konusu kişisel verileri gecikmeksizin silme yükümlülüğümüz vardır:</p>\n<p><ol>\n<li>Kişisel veriler, toplandıkları veya başka bir şekilde işlendikleri amaçlar için artık gerekli değilse.</li>\n<li>İlgili kişi, madde 6 fıkra 1, a bendi veya madde 9 fıkra 2, a bendi uyarınca gerçekleştirilen veri işlemenin dayanağını oluşturan açık rızasını iptal ederse ve veri işleme için başka bir yasal dayanak yoksa.</li>\n<li>İlgili kişi, madde 21 fıkra 1 uyarınca verilerin işlenmesine itiraz ederse ve verilerin işlenmesi için öncelikli meşru gerekçeler mevcut değilse veya ilgili kişi madde 21 fıkra 2 uyarınca verilerin işlenmesine itiraz ederse.</li>\n<li>Kişisel veriler yasalara aykırı şekilde işlenmişse.</li>\n<li>Kişisel verilerin silinmesi, veri sorumlusunun tabi olduğu Birlik Yasası veya üye devlet yasaları uyarınca yasal bir yükümlülüğün yerine getirilmesi için gerekliyse.</li>\n<li>Kişisel veriler, madde 8 fıkra 1 uyarınca sunulan bilgi toplumu hizmetleri ile ilgili olarak toplanmışsa.</li>\n</ol></p>\n\n<h5>Veri işlemenin kısıtlanmasını isteme hakkı</h5><p>Genel Veri Koruma Yönetmeliği'nin (DSGVO) 18. maddesi uyarınca, aşağıdaki koşullardan birinin mevcut olması halinde bizden veri işlemenin kısıtlanmasını isteme hakkınız vardır:</p>\n<p><ol>\n<li>ilgili kişi tarafından kişisel verilerin doğruluğuna itiraz edilmesi halinde; bu durumda veri sorumlusunun kişisel verilerin doğruluğunu kontrol etmesine olanak sağlayacak bir süre boyunca kısıtlama yapılır,</li>\n<li>veri işlemenin yasalara aykırı olması ve ilgili kişinin kişisel verilerin silinmesini reddetmesi ve bunun yerine kişisel verilerin kullanımının kısıtlanmasını istemesi halinde;</li>\n<li>veri sorumlusu, veri işleme amaçları için kişisel verilere artık ihtiyaç duymuyorsa, ancak ilgili kişi yasal talepleri ileri sürmek, uygulamak veya savunmak için kişisel verilere ihtiyaç duyuyorsa veya</li>\n<li>ilgili kişi, madde 21 fıkra 1 uyarınca verilerin işlenmesine itiraz etmişse, veri sorumlusunun meşru gerekçelerinin ilgili kişinin gerekçelerine göre daha ağır basıp basmadığı belirleninceye kadar kısıtlama yapılır.</li>\n</ol></p>\n\n<h5>SSL veya TLS şifreleme</h5><p>Bu web sitesi, güvenlik nedenleriyle ve web sitesi operatörü olarak bize göndermiş olduğunuz örneğin siparişler veya talepler gibi gizli içeriklerin iletimini korumak amacıyla, SSL veya TLS şifrelemesi kullanmaktadır. Şifreli bir bağlantıyı, internet tarayıcısının adres satırının \"http://\" den \"https://\" ye değişmesinden ve tarayıcı satırınızdaki kilit simgesinden tanıyabilirsiniz.</p>\n\n<p>SSL veya TLS şifrelemesi etkinleştirilmişse, bize iletmiş olduğunuz veriler üçüncü taraflarca okunamaz.</p>\n<h4>3. Veri koruma görevlisi</h4><h5>Yasa gereği veri koruma görevlisi</h5><p>Şirketimiz için bir veri koruma görevlisi atamış bulunmaktayız.</p>\n<p>heyData GmbH<br>\n<br>\nKantstraße 99<br>\n10627Berlin<br>\nAlmanya</p>\n\n<p>Telefon: +498941325320<br>\nE-posta: datenschutz&#64;heydata.eu</p><h4>4. Web sitemizde veri toplama</h4><h5>Çerezler (Cookies)</h5><p>Bazı internet siteleri, çerez (cookie) adı verilen tanımlama bilgilerini kullanır. Çerezler bilgisayarınıza zarar vermez ve virüs içermez. Çerezler, hizmetimizi daha kullanıcı dostu, etkili ve güvenli hale getirmek için kullanılır. Çerezler, bilgisayarınıza kaydedilen ve tarayıcınız tarafından depolanan küçük metin dosyalarıdır.</p>\n\n<p>Tarafımızdan kullanılan çerezlerin çoğu, \"oturum çerezleri\" olarak tanımlanan çerezlerdir. Bu çerezler, web sitemizi ziyaretiniz sonlandıktan sonra, otomatik olarak silinir. Diğer çerezler, siz onları silinceye kadar cihazınızda depolanır. Çerezler, bir sonraki ziyaretinizde tarayıcınızı tanımamıza olanak sağlar.</p>\n\n<p>Tarayıcınızı, çerezlerin yerleştirilmesi hakkında bilgi sahibi olacak ve çerezlere yalnızca bireysel durumlarda izin verecek şekilde ayarlayabilir, belirli durumlarda veya genel olarak çerezlerin kabul edilmesini hariç tutabilir ve tarayıcıyı kapattığınızda çerezlerin otomatik olarak silinmesini etkinleştirebilirsiniz. Çerezlerin devre dışı bırakılması durumunda, bu web sitesinin işlevselliği sınırlanabilir.</p>\n\n<p>Elektronik iletişim sürecini yürütmek veya istediğiniz belirli işlevleri (örneğin alışveriş sepeti işlevi) sağlamak için gerekli olan çerezler, Genel Veri Koruma Yönetmeliği'nin (DSGVO) 6. maddesi, 1. fıkrası, f alt bendi temelinde depolanır. Web sitesi operatörü, hizmetlerinin teknik olarak hatasız ve optimize edilmiş bir şekilde sağlanması için çerezlerin depolanmasında meşru bir menfaate sahiptir. Diğer çerezler (örneğin internette gezinme davranışınızı analiz etmeye yönelik çerezler) saklandığı ölçüde, bu çerezler bu veri koruma beyanında ayrı olarak ele alınır.</p><h5>Sunucu günlük dosyaları</h5><p>Web sitesi sağlayıcısı, internet tarayıcınızın otomatik olarak bize ilettiği bilgileri, sunucu günlük dosyaları olarak adlandırılan dosyalarda otomatik olarak toplar ve depolar. Bu bilgiler şunlardır:</p>\n<p><ul>\n<li>Tarayıcı türü ve tarayıcı sürümü</li>\n<li>Kullanılan işletim sistemi</li>\n<li>Yönlendiren URL</li>\n<li>Erişim sağlayan bilgisayarın ana bilgisayar adı</li>\n<li>Sunucu isteğinin zamanı</li>\n<li>IP adresi</li>\n</ul></p>\n\n<p>Bu verilerin başka veri kaynaklarıyla birleştirilmesi gerçekleştirilmez.</p>\n\n<p>Veri işlemenin dayanağı, bir sözleşmenin veya sözleşme öncesi önlemlerin yerine getirilmesi için verilerin işlenmesine izin veren Genel Veri Koruma Yönetmeliği'nin (DSGVO) 6. maddesi, 1. fıkrası, f alt bendidir.</p><h5>İletişim formu</h5><p>İletişim formu aracılığıyla bize talepler göndermeniz halinde, talebin işleme konulması ve müteakip sorularınız için, orada belirtmiş olduğunuz iletişim adresi de dâhil olmak üzere, talep formundaki bilgileriniz tarafımızdan saklanır. Bu verileri sizin açık rızanız olmadan paylaşmayız.</p>\n\n<p>Buna göre, iletişim formuna girilen verilerin işlenmesi, münhasıran sizin açık rızanız temelinde gerçekleştirilir (DSGVO madde 6, fıkra 1, alt bent a). Bu açık rızayı dilediğiniz zaman iptal edebilirsiniz. Bunun için bize şekle bağlı olmayan bir e-posta ile bildirimde bulunmanız yeterlidir. İptale kadar gerçekleştirilen veri işleme süreçlerinin yasallığı, iptal işleminden etkilenmez.</p>\n\n<p>Tarafınızdan iletişim formuna girilen veriler, bizden verileri silmemizi isteyinceye, verilerin saklanması için vermiş olduğunuz açık rızanızı iptal edinceye veya veri saklama amacı ortadan kalkıncaya kadar (örneğin talebiniz işlendikten sonra)\nbizde kalır. Zorlayıcı yasal hükümler - özellikle saklama süreleriyle ilgili olanlar - bundan etkilenmez.</p>\n\n"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpPrivacyPolicy.vue


/* custom blocks */
;
if (typeof DpPrivacyPolicyvue_type_custom_index_0_blockType_i18n === 'function') DpPrivacyPolicyvue_type_custom_index_0_blockType_i18n(DpPrivacyPolicyvue_type_script_setup_true_lang_js)


const __exports__ = DpPrivacyPolicyvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpPrivacyPolicy = (__exports__);

/***/ }),

/***/ 5171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpReadEditDelete; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadEditDelete.vue?vue&type=template&id=18f69fcd

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return null
}
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadEditDelete.vue?vue&type=script&lang=js

/* harmony default export */ var DpReadEditDeletevue_type_script_lang_js = ({
  name: "DpRED"
});

;// CONCATENATED MODULE: ./src/components/DpReadEditDelete.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpReadEditDelete.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpReadEditDeletevue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpReadEditDelete = (__exports__);

/***/ }),

/***/ 7953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpReadValue; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadValue.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = { style: {"color":"rgba(0,0,0,.6)"} }
const _hoisted_2 = ["dir"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"color":"rgba(0,0,0,.5)"} }
const _hoisted_5 = {
  key: 1,
  style: {"color":"rgba(0,0,0,.5)"}
}
const _hoisted_6 = { style: {"color":"rgba(0,0,0,.5)"} }


;

const __default__ = {
  inheritAttrs: true,
  name: "DpReadValue",
  props: {
    dataKey: {type: String, required: true},
    dataValue: {type: [String, Object, Array]},
    dataKeyStyle: {type: Object},
    dataValueStyle: {type: Object},
    inline: {type: Boolean, default: false},
    padding: {type: Boolean, default: false},
    paddingLeft: {type: Boolean, default: false},
    paddingRight: {type: Boolean, default: false},
    copyToClipboard: {type: Boolean, default: false},
    bdo: {type: String}
  },
  computed: {
    isEmpty() {
      return (isEmpty_default());
    }
  }
}

;

/* harmony default export */ var DpReadValuevue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  const _component_el_tag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tag")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: ['dp-simple-card__read-item', {'display-inline': __props.inline, 'padding-left': __props.paddingLeft, 'padding-right': __props.paddingRight || __props.padding}]
  }, _ctx.$attrs), [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: "dp-simple-card__read-key",
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataKeyStyle)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.dataKey), 5),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [
      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(__props.dataValue))
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
            key: 0,
            class: "dp-simple-card__read-value",
            style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataValueStyle)
          }, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('noEntry.label')), 1)
          ], 4))
        : (typeof __props.dataValue === 'string')
          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
              key: 1,
              class: "dp-simple-card__read-value",
              style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataValueStyle)
            }, [
              (!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(__props.bdo))
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("bdo", {
                    key: 0,
                    dir: __props.bdo
                  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.dataValue), 9, _hoisted_2))
                : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 1 }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.dataValue), 1)
                  ], 64))
            ], 4))
          : (Array.isArray(__props.dataValue))
            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                key: 2,
                class: "dp-simple-card__read-value",
                style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataValueStyle)
              }, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [
                  ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(__props.dataValue, (item, index) => {
                    return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", { key: index }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item), 1))
                  }), 128))
                ])
              ], 4))
            : (typeof __props.dataValue === 'object')
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                  key: 3,
                  class: "dp-simple-card__read-value",
                  style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataValueStyle)
                }, [
                  (__props.dataValue.type !== undefined && __props.dataValue.type === 'media/image')
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                        key: 0,
                        style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({height: __props.dataValue.meta.displayAt.height, width: __props.dataValue.meta.displayAt.width})
                      }, [
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                          class: "dp-simple-card__read-value__image",
                          style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({'background-image': `url(${__props.dataValue.url})`})
                        }, null, 4)
                      ], 4))
                    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", _hoisted_3, [
                        ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(Object.keys(__props.dataValue), (itemKey, index) => {
                          return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", { key: index }, [
                            (__props.dataValue.hasOwnProperty(itemKey))
                              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 0 }, [
                                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemKey), 1),
                                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(": " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.dataValue[itemKey]), 1)
                                ], 64))
                              : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", _hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('undefined.label')), 1))
                          ]))
                        }), 128))
                      ]))
                ], 4))
              : (typeof __props.dataValue === 'boolean')
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                    key: 4,
                    class: "dp-simple-card__read-value",
                    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataValueStyle)
                  }, [
                    (__props.dataValue === true)
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_tag, {
                          key: 0,
                          size: "mini",
                          effect: "light",
                          type: "success"
                        }, {
                          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('active.label')), 1)
                          ]),
                          _: 1
                        }))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                    (__props.dataValue === false)
                      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_tag, {
                          key: 1,
                          size: "mini",
                          effect: "light",
                          type: "danger"
                        }, {
                          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('inactive.label')), 1)
                          ]),
                          _: 1
                        }))
                      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                  ], 4))
                : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                    key: 5,
                    class: "dp-simple-card__read-value",
                    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataValueStyle)
                  }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", _hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('undefined.label')), 1)
                  ], 4))
    ])
  ], 16))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpReadValue.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadValue.vue?vue&type=style&index=0&id=20e52f3b&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpReadValue.vue?vue&type=style&index=0&id=20e52f3b&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadValue.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpReadValuevue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpReadValue.active.label"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpReadValue.inactive.label"])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpReadValue.undefined.label"])}
        }
      },
      "de-AT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-CH": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-US": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No entry"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-GB": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No entry"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "it-IT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vietato l'ingresso"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-FR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée interdite"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "es-ES": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay entrada"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pl-PL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak wejścia"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "nl-NL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen toegang"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bg-BG": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не е вход"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bs-BA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zabranjen ulaz"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "zh-CN": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["禁止入内"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "da-DK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen adgang"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "et-EE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sissepääs puudub"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fi-FI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei sisäänkäyntiä"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-GR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απαγορεύεται η είσοδος"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "he-IL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין כניסה"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ga-IE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan iontráil"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ja-JP": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["立入り禁止"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hr-HR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zabranjen ulaz"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lv-LV": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iebraukt aizliegts"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lt-LT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra įėjimo"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pt-PT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrada proibida"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ro-RO": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicio intrare"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ru-RU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет входа"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sv-SE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen ingång"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sk-SK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zákaz vstupu"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "cs-CZ": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vstup zakázán"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-TR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giriş yok"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hu-HU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belépni tilos"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-AE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ممنوع الدخول"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-BE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée interdite"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-LU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée interdite"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "mt-MT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda dħul"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni vstopa"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απαγορεύεται η είσοδος"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giriş yok"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpReadValue.vue



;
/* custom blocks */

if (typeof DpReadValuevue_type_custom_index_0_blockType_i18n === 'function') DpReadValuevue_type_custom_index_0_blockType_i18n(DpReadValuevue_type_script_setup_true_lang_js)


const __exports__ = DpReadValuevue_type_script_setup_true_lang_js;

/* harmony default export */ var DpReadValue = (__exports__);

/***/ }),

/***/ 5785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpReadValues; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/pinia/dist/pinia.esm-browser.js + 1 modules
var pinia_esm_browser = __webpack_require__(8262);
// EXTERNAL MODULE: external "@dutypay/store-modules"
var store_modules_ = __webpack_require__(2706);
// EXTERNAL MODULE: ./node_modules/chai/index.mjs
var chai = __webpack_require__(2757);
// EXTERNAL MODULE: ./src/components/DpReadValue.vue + 5 modules
var DpReadValue = __webpack_require__(7953);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadValues.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = ["dir"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { style: {"color":"rgba(0,0,0,.5)"} }
const _hoisted_6 = {
  key: 1,
  style: {"color":"rgba(0,0,0,.5)"}
}
const _hoisted_7 = {
  key: 4,
  style: {"color":"rgba(0,0,0,.6)"}
}
const _hoisted_8 = {
  key: 5,
  style: {"color":"rgba(0,0,0,.5)"}
}


;





const tests = [
  {
    title: "Single value",
    description: "We have a single value and no descriptive phrase for the value.",
    props: {
      data: {firstRow: "Some value as a string"},
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.include( "Some value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "firstRow" );
    }
  },
  {
    title: "Key map",
    description: "Set a string that describes the value on the right hand side. The keys have to match.",
    props: {
      data: {firstRow: "Some value as a string"},
      keyMap: {firstRow: "First row"},
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.include( "Some value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "First row" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "firstRow" );
    }
  },
  {
    title: "Key map incomplete",
    description: "Print more than one value. The keyMap is intentionally incomplete.",
    props: {
      data: {
        firstRow: "Some value as a string",
        secondRow: "Another value as a string",
      },
      keyMap: {
        firstRow: "A value",
      },
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.include( "Some value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "Another value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "A value" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "firstRow" );
      (0,chai/* expect */.l_)(component.text()).to.include( "secondRow" );
    }
  },
  {
    title: "Empty values",
    description: "Rows with empty values are ignored.",
    props: {
      data: {
        firstRow: "",
        secondRow: "Another value as a string",
      },
      keyMap: {
        firstRow: "A value",
      },
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.not.include( "Some value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "Another value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "A value" );
      (0,chai/* expect */.l_)(component.text()).to.include( "secondRow" );
    }
  },
  {
    title: "Show empty values",
    description: "Print empty values with showEmptyValues.",
    props: {
      data: {
        firstRow: "",
        secondRow: "Another value as a string",
      },
      keyMap: {
        firstRow: "A value",
      },
      showEmptyValues: true
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.not.include( "Some value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "Another value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "A value" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "firstRow" );
      (0,chai/* expect */.l_)(component.text()).to.include( "secondRow" );
    }
  },
  {
    title: "Show only mapped keys",
    description: "Hide values that have no corresponding key in keyMap.",
    props: {
      data: {
        firstRow: "Some value as a string",
        secondRow: "Another value as a string",
      },
      keyMap: {
        firstRow: "A value",
      },
      showOnlyMappedKeys: true
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.text()).to.include( "Some value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "Another value as a string" );
      (0,chai/* expect */.l_)(component.text()).to.include( "A value" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "firstRow" );
      (0,chai/* expect */.l_)(component.text()).to.not.include( "secondRow" );
    }
  },
  {
    title: "Enforce reading direction",
    description: "Overwrite reading direction for a set of keys.",
    props: {
      data: {
        firstRow: "+49 (0)631 56 001 600",
        secondRow: "+49 (0)631 56 001 600",
      },
      keyMap: {
        firstRow: "Reading direction is RTL",
        secondRow: "Enforced LTR reading direction"
      },
      bdoKeyMap: {
        secondRow: 'ltr'
      }
    },
    style: {direction: 'rtl'},
    assert: function(component) {
      (0,chai/* expect */.l_)(component.find('bdo[dir="ltr"]').text()).to.contain( "+49 (0)631 56 001 600" );
    }
  },
  {
    title: "Set column styles",
    description: "Overwrite or add CSS rules for either the key column or value column.",
    props: {
      data: {
        firstRow: "Some value as a string"
      },
      keyMap: {
        firstRow: "A value"
      },
      keyColumnStyle: {textDecoration: 'underline'},
      dataColumnStyle: {color: '#ff0000'}
    },
    assert: function(component) {
      (0,chai/* expect */.l_)(component.find('.dp-read-values__grid__key-column[style="text-decoration: underline;"]').text()).to.contain('A value');
      (0,chai/* expect */.l_)(component.find('.dp-read-values__grid__read-value[style="color: rgb(255, 0, 0);"]').text()).to.contain('Some value as a string');
    }
  },
  {
    title: "Mobile view",
    description: "Toggle the mobile version of this component.",
    props: {
      data: {
        firstRow: "Some value as a string",
        secondRow: "Another value as a string",
      },
      keyMap: {
        firstRow: "A value",
        secondRow: "Another value",
      }
    }
  }
];

const __default__ = {
  name: "DpReadValues",
  description: "Print values of objects.",
  props: {
    data: {type: [Object, Array], required: true, desc: 'Value column'},
    keyMap: {type: Object, desc: 'Key column'},
    bdoKeyMap: {type: Object, desc: 'Key-value pair with bdo dir value for the key.'},
    showOnlyMappedKeys: {type: Boolean, default: false, desc: 'Hide key-value pairs that have no key in keyMap.'},
    showEmptyValues: {type: Boolean, default: false, desc: 'Show values that are empty.'},
    keyColumnStyle: {type: Object, desc: 'Overwrite styles for the key column.'},
    dataColumnStyle: {type: Object, desc: 'Overwrite styles for the value column.'}
  },
  components: {DpReadValue: DpReadValue["default"]},
  tests,
  stubs: {
    ElTag: {
      template: '<span><slot></slot></span>'
    }
  },
  computed: {
    isEmpty: () => {
      return (isEmpty_default());
    },
    ...(0,pinia_esm_browser/* mapState */.rn)(store_modules_.useEnvStore, ['countries'])
  }
}

;


/* harmony default export */ var DpReadValuesvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

const composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables')
const { isMobile } = composables.useViewportSize();

return (_ctx, _cache) => {
  const _component_el_tag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tag")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(Object.keys(__props.data), (dataKey, index) => {
      return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [
        ((__props.showEmptyValues || !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(__props.data[dataKey])) && (__props.showOnlyMappedKeys ? (__props.keyMap !== undefined && __props.keyMap[dataKey] !== undefined) : true))
          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 0 }, [
              ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile))
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                    key: `dp-read-values-index-${index}`
                  }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpReadValue["default"]), {
                      "data-key": (__props.keyMap) ? __props.keyMap[dataKey] : dataKey,
                      "data-value": __props.data[dataKey],
                      "data-key-style": __props.keyColumnStyle,
                      "data-value-style": __props.dataColumnStyle,
                      bdo: (__props.bdoKeyMap && !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(__props.bdoKeyMap[dataKey])) ? __props.bdoKeyMap[dataKey] : undefined
                    }, null, 8, ["data-key", "data-value", "data-key-style", "data-value-style", "bdo"])
                  ]))
                : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                    class: "dp-read-values__grid",
                    key: `dp-read-values-index-${index}`
                  }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                      class: "dp-read-values__grid__key-column",
                      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.keyColumnStyle)
                    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((__props.keyMap && __props.keyMap[dataKey]) ? __props.keyMap[dataKey] : dataKey), 5),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                      class: "dp-read-values__grid__read-value",
                      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(__props.dataColumnStyle)
                    }, [
                      (typeof __props.data[dataKey] === 'string')
                        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 0 }, [
                            (__props.bdoKeyMap && !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(__props.bdoKeyMap[dataKey]))
                              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("bdo", {
                                  key: 0,
                                  dir: __props.bdoKeyMap[dataKey]
                                }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.data[dataKey]), 9, _hoisted_1))
                              : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 1 }, [
                                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.data[dataKey]), 1)
                                ], 64))
                          ], 64))
                        : (Array.isArray(__props.data[dataKey]))
                          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", _hoisted_2, [
                              ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(__props.data[dataKey], (item, index) => {
                                return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                                  key: `list${index}`
                                }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item), 1))
                              }), 128))
                            ]))
                          : (typeof __props.data[dataKey] === 'object')
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 2 }, [
                                (__props.data[dataKey].type !== undefined && __props.data[dataKey].type === 'media/image')
                                  ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                                      key: 0,
                                      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({height: __props.data[dataKey].meta.displayAt.height, width: __props.data[dataKey].meta.displayAt.width})
                                    }, [
                                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                                        class: "dp-read-values__grid__read-value__image",
                                        style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({'background-image': `url(${__props.data[dataKey].url})`})
                                      }, null, 4)
                                    ], 4))
                                  : (__props.data[dataKey].type !== undefined && __props.data[dataKey].type === 'script/country')
                                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_3, [
                                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((_ctx.countries !== undefined && !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(_ctx.countries)) ? _ctx.countries[__props.data[dataKey].country[1]][_ctx.$i18n.locale] : __props.data[dataKey].country[1]), 1)
                                      ]))
                                    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", _hoisted_4, [
                                        ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(Object.keys(__props.data[dataKey]), (itemKey, index) => {
                                          return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                                            key: `object${index}`
                                          }, [
                                            (__props.data[dataKey].hasOwnProperty(itemKey))
                                              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 0 }, [
                                                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemKey), 1),
                                                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(": " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.data[dataKey][itemKey]), 1)
                                                ], 64))
                                              : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", _hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('undefined.label')), 1))
                                          ]))
                                        }), 128))
                                      ]))
                              ], 64))
                            : (typeof __props.data[dataKey] === 'boolean')
                              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 3 }, [
                                  (__props.data[dataKey] === true)
                                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_tag, {
                                        key: 0,
                                        size: "small",
                                        effect: "plain",
                                        type: "success"
                                      }, {
                                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('active.label')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                                  (__props.data[dataKey] === false)
                                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_tag, {
                                        key: 1,
                                        size: "small",
                                        effect: "plain",
                                        type: "danger"
                                      }, {
                                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('inactive.label')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                                ], 64))
                              : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(__props.data[dataKey]))
                                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('noEntry.label')), 1))
                                : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", _hoisted_8, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('undefined.label')), 1))
                    ], 4)
                  ]))
            ], 64))
          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
      ], 64))
    }), 256))
  ]))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpReadValues.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadValues.vue?vue&type=style&index=0&id=4165a361&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpReadValues.vue?vue&type=style&index=0&id=4165a361&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReadValues.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpReadValuesvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpReadValues.active.label"])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpReadValues.inactive.label"])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ds.components.DpReadValues.undefined.label"])}
        }
      },
      "de-AT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-CH": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-US": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-GB": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "it-IT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-FR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "es-ES": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pl-PL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "nl-NL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bg-BG": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bs-BA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "zh-CN": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "da-DK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "et-EE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fi-FI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-GR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "he-IL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ga-IE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ja-JP": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hr-HR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lv-LV": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lt-LT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pt-PT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ro-RO": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ru-RU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sv-SE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sk-SK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "cs-CZ": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-TR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hu-HU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-AE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-BE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-LU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "mt-MT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpReadValues.vue



;
/* custom blocks */

if (typeof DpReadValuesvue_type_custom_index_0_blockType_i18n === 'function') DpReadValuesvue_type_custom_index_0_blockType_i18n(DpReadValuesvue_type_script_setup_true_lang_js)


const __exports__ = DpReadValuesvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpReadValues = (__exports__);

/***/ }),

/***/ 1843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpReminder; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReminder.vue?vue&type=template&id=46ac7eda


const _hoisted_1 = {
  key: 0,
  class: "dp-reminder"
}
const _hoisted_2 = {
  key: 0,
  class: "dp-reminder__close-button"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpIcon")
  const _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse")
  const _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col")
  const _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row")
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")

  return (!$props.dismissed)
    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
        ($props.closable)
          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_2, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
                onClick: _cache[0] || (_cache[0] = $event => ($props.dismissed=true))
              }, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpIcon, {
                  icon: "close",
                  size: 32,
                  color: "#909399",
                  float: "none"
                })
              ])
            ]))
          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
          ]),
          _: 3
        }, 512), [
          [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, $data.activateDefaultSlot]
        ]),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, { class: "dp-reminder__phrases" }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "phrases", {}, () => [
                      ($props.headline)
                        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("h3", _hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.headline), 1))
                        : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                      ($props.description)
                        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", _hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.description), 1))
                        : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                    ])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "extraContent"),
            (!$options.isEmpty($props.primaryButton) || !$options.isEmpty($props.secondaryButton))
              ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_row, {
                  key: 0,
                  justify: "space-around",
                  gutter: 25,
                  align: "middle"
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                      sm: 12,
                      class: "dp-reminder__buttons"
                    }, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                        (!$options.isEmpty($props.secondaryButton))
                          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
                              key: 0,
                              size: "large",
                              purpose: "secondaryAction",
                              onClick: _cache[1] || (_cache[1] = $event => ($props.secondaryButton.action()))
                            }, {
                              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.secondaryButton.label), 1)
                              ]),
                              _: 1
                            }))
                          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                      ]),
                      _: 1
                    }),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                      sm: 12,
                      class: "dp-reminder__buttons"
                    }, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                        (!$options.isEmpty($props.primaryButton))
                          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
                              key: 0,
                              size: "large",
                              purpose: "primaryAction",
                              onClick: _cache[2] || (_cache[2] = $event => (($props.primaryButton.action)? $props.primaryButton.action() : $data.activateDefaultSlot = true))
                            }, {
                              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.primaryButton.label), 1)
                              ]),
                              _: 1
                            }))
                          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
          ]),
          _: 3
        }, 512), [
          [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !$data.activateDefaultSlot]
        ])
      ]))
    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
}
;// CONCATENATED MODULE: ./src/components/DpReminder.vue?vue&type=template&id=46ac7eda

// EXTERNAL MODULE: ./src/components/DpCollapse.vue + 4 modules
var DpCollapse = __webpack_require__(2785);
// EXTERNAL MODULE: ./src/components/DpIcon.vue + 2 modules
var DpIcon = __webpack_require__(5172);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReminder.vue?vue&type=script&lang=js

  
  
  

  /* harmony default export */ var DpRemindervue_type_script_lang_js = ({
    name: "DpReminder",
    components: {DpIcon: DpIcon["default"], DpCollapse: DpCollapse["default"]},
    props: {
      headline: {type: String},
      description: {type: String},
      primaryButton: {type: Object},
      secondaryButton: {type: Object},
      dismissed: {type: Boolean, default: false},
      closable: {type: Boolean, default: true}
    },
    computed: {
      isEmpty() { return (isEmpty_default()); }
    },
    data() {
      return {
        activateDefaultSlot: false,
      };
    }
  });

;// CONCATENATED MODULE: ./src/components/DpReminder.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReminder.vue?vue&type=style&index=0&id=46ac7eda&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpReminder.vue?vue&type=style&index=0&id=46ac7eda&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpReminder.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpRemindervue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpReminder.vue




;
/* custom blocks */

if (typeof DpRemindervue_type_custom_index_0_blockType_i18n === 'function') DpRemindervue_type_custom_index_0_blockType_i18n(DpRemindervue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpRemindervue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpReminder = (__exports__);

/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpSimpleCrud; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/DpCollapse.vue + 4 modules
var DpCollapse = __webpack_require__(2785);
// EXTERNAL MODULE: ./src/components/DpReadValues.vue + 5 modules
var DpReadValues = __webpack_require__(5785);
// EXTERNAL MODULE: ./src/components/DpTable.vue + 6 modules
var DpTable = __webpack_require__(4059);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpSimpleCrud.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = { class: "dp-simple-crud" }
const _hoisted_2 = { class: "dp-simple-crud__head" }
const _hoisted_3 = { style: {"margin-inline-start":"0.5em"} }
const _hoisted_4 = { class: "dp-simple-crud__body" }
const _hoisted_5 = { key: 0 }


;




const __default__ = {
  name: "DpSimpleCrud",
  components: {DpReadValues: DpReadValues["default"], DpCollapse: DpCollapse["default"], DpTable: DpTable["default"]},
  props: {
    modelValue: {type: [Object, Array]},
    keyMap: {type: Object},
    headline: {type: String},
    showDefaultSlot: {type: Boolean},
    readOnly: {type: Boolean, default: false},
    buttonLabel: {type: String, default: undefined},
    buttonIcon: {type: [Boolean, String], default: true},
    rtl: {type: Boolean, default: false},
    screenSizeIsMobile: {type: Boolean, default: false}
  },
  data() {
    return {
      isActive: this.slotValue,
      isDefaultSlotMounted: false
    };
  },
  computed: {
    actionButtonLabel() {
      return (!isEmpty_default()(this.buttonLabel) && this.buttonLabel !== undefined) ? this.buttonLabel : this.t('edit.buttonLabel');
    },
    slotValue() {
      return (this.readOnly) ? false : this.showDefaultSlot;
    }
  },
  watch: {
    showDefaultSlot: {
      handler() {
        if (this.slotValue === true)
          this.activateSlot();
        else
          this.deactivateSlot();
      }
    }
  },
  methods: {
    activateSlot() {
      this.isDefaultSlotMounted = true;
      this.$nextTick(() => {
        this.isActive = true;
        this.$emit('activate-slot');
      });
    },
    deactivateSlot() {
      this.isActive = false;
      setTimeout(() => {
        this.isDefaultSlotMounted = false;
        this.$emit('deactivate-slot');
      }, 300);
    }
  }
}

;

/* harmony default export */ var DpSimpleCrudvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  const _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_1, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_2, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "head", {}, () => [
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-flex justify-content__space-between", {
                'row wrap align-items__center': !__props.rtl && !__props.screenSizeIsMobile,
                'row wrap align-items__center reverse': __props.rtl && !__props.screenSizeIsMobile,
                'column align-items__flex-end': __props.rtl & __props.screenSizeIsMobile,
                'column align-items__flex-start': !__props.rtl & __props.screenSizeIsMobile}])
        }, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h4", null, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "headline", {}, () => [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(__props.headline), 1)
            ])
          ]),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpCollapse["default"]), null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
              (!__props.readOnly)
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
                    key: 0,
                    type: "text",
                    class: "dp-simple-crud__head__action",
                    tabindex: "0",
                    onClick: _ctx.activateSlot,
                    onKeypress: _ctx.activateSlot
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_3, [
                        (__props.buttonIcon)
                          ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", {
                              key: 0,
                              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([(__props.buttonIcon === true) ? 'el-icon-edit' : __props.buttonIcon, 'icon-margin-end'])
                            }, null, 2))
                          : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.actionButtonLabel), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick", "onKeypress"]))
                : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
            ]),
            _: 1
          }, 512), [
            [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.isActive && !__props.readOnly]
          ])
        ], 2)
      ])
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_4, [
      (_ctx.isDefaultSlotMounted)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_5, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpCollapse["default"]), null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
              ]),
              _: 3
            }, 512), [
              [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.isActive && !__props.readOnly]
            ])
          ]))
        : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpCollapse["default"]), null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (__props.modelValue !== undefined)
            ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "read", {
                key: 0,
                data: __props.modelValue
              }, () => [
                (Array.isArray(__props.modelValue))
                  ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpTable["default"]), {
                      key: 0,
                      size: "large",
                      data: __props.modelValue,
                      columns: __props.keyMap
                    }, null, 8, ["data", "columns"]))
                  : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DpReadValues["default"]), {
                      key: 1,
                      data: __props.modelValue,
                      keyMap: __props.keyMap,
                      screenSizeIsMobile: __props.screenSizeIsMobile
                    }, null, 8, ["data", "keyMap", "screenSizeIsMobile"]))
              ])
            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "read", { key: 1 })
        ]),
        _: 3
      }, 512), [
        [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.isActive]
      ])
    ])
  ]))
}
}

}));
;// CONCATENATED MODULE: ./src/components/DpSimpleCrud.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpSimpleCrud.vue?vue&type=style&index=0&id=34d3af2c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpSimpleCrud.vue?vue&type=style&index=0&id=34d3af2c&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpSimpleCrud.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpSimpleCrudvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "de-AT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "de-CH": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "en-US": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])}
        }
      },
      "en-GB": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])}
        }
      },
      "it-IT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifica"])}
        }
      },
      "fr-FR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "es-ES": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "pl-PL": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj"])}
        }
      },
      "nl-NL": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bewerken"])}
        }
      },
      "bg-BG": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактиране"])}
        }
      },
      "bs-BA": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uredi"])}
        }
      },
      "zh-CN": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑"])}
        }
      },
      "da-DK": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rediger"])}
        }
      },
      "et-EE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redigeeri"])}
        }
      },
      "fi-FI": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Muuta"])}
        }
      },
      "el-GR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επεξεργασία"])}
        }
      },
      "he-IL": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ערוך"])}
        }
      },
      "ga-IE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir in eagar"])}
        }
      },
      "ja-JP": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["編集"])}
        }
      },
      "hr-HR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Urediti"])}
        }
      },
      "lv-LV": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rediģēt"])}
        }
      },
      "lt-LT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redaguoti"])}
        }
      },
      "pt-PT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "ro-RO": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editare"])}
        }
      },
      "ru-RU": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактировать"])}
        }
      },
      "sv-SE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redigera"])}
        }
      },
      "sk-SK": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upraviť"])}
        }
      },
      "cs-CZ": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upravit"])}
        }
      },
      "tr-TR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Düzenle"])}
        }
      },
      "hu-HU": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szerkeszt"])}
        }
      },
      "ar-AE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحرير"])}
        }
      },
      "fr-BE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "fr-LU": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "mt-MT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editja"])}
        }
      },
      "sl-SI": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uredi"])}
        }
      },
      "el-CY": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επεξεργασία"])}
        }
      },
      "tr-CY": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Düzenle"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/components/DpSimpleCrud.vue



;
/* custom blocks */

if (typeof DpSimpleCrudvue_type_custom_index_0_blockType_i18n === 'function') DpSimpleCrudvue_type_custom_index_0_blockType_i18n(DpSimpleCrudvue_type_script_setup_true_lang_js)


const __exports__ = DpSimpleCrudvue_type_script_setup_true_lang_js;

/* harmony default export */ var DpSimpleCrud = (__exports__);

/***/ }),

/***/ 4059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpTable; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTable.vue?vue&type=template&id=46dd8a00&scoped=true


const _withScopeId = n => (_pushScopeId("data-v-46dd8a00"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["colspan"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["colspan"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "dp-table__align-right"
}
const _hoisted_6 = ["onClick", "onKeypress"]
const _hoisted_7 = ["onClick", "onKeypress"]
const _hoisted_8 = ["colspan"]

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpNoDataIndicator = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpNoDataIndicator")
  const _component_DpIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpIcon")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("table", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([
        'dp-table',
        `dp-table__${this.size}`,
        `dp-table__border__${this.border}`
      ]),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
        'width':$props.width
      }),
    ref: ($props.reference) ? $props.reference : ''
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("thead", null, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("tr", null, [
        ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)($data.tableColumns, (column, index) => {
          return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("th", {
            colspan: ($props.expandable && index + 1 === $data.tableColumns.length) ? 2 : 1,
            key: index,
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({
            'dp-table__align-left': column.align === 'left',
            'dp-table__align-right': column.align === 'right',
            'dp-table__align-center': column.align === 'center'
            })
          }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((column.label) ? column.label : ''), 11, _hoisted_1))
        }), 128))
      ])
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("tbody", null, [
      ($options.isEmpty($data.localCopyOfData))
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("tr", _hoisted_2, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("td", {
              colspan: $data.tableColumns.length+1
            }, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpNoDataIndicator)
            ], 8, _hoisted_3)
          ]))
        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, { key: 1 }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)($data.localCopyOfData, (row, rowIndex) => {
            return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
              key: ($props.reference) ? $props.reference+rowIndex.toString() : rowIndex
            }, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("tr", {
                class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({
                    'dp-table__expanded': $data.expanded[rowIndex]===true && $props.expandable && !!_ctx.$scopedSlots[rowIndex],
                    'dp-table__expandable': $props.expandable && $props.expandOnClick,
                    'dp-table__clickable': $props.clickable,
                  }),
                onClick: () => {
                        if(typeof row.action === 'function' && !!(row.action))
                          row.action();
                        if($props.expandable && $props.expandOnClick && !!_ctx.$scopedSlots[rowIndex])
                          ($data.expanded[rowIndex]) ? $options.reduceRow(rowIndex) : $options.expandRow(rowIndex)
                      }
              }, [
                ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)($data.tableColumns, (cell, cellIndex) => {
                  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("td", {
                    key: cellIndex,
                    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({
                      'dp-table__align-left': cell.align && cell.align === 'left',
                      'dp-table__align-right': cell.align && cell.align === 'right',
                      'dp-table__align-center': cell.align && cell.align === 'center',
                      'dp-table__column-head': cell.head && cell.head === true
                    })
                  }, [
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, ($props.slotPrefix) ? $props.slotPrefix + cell.prop.toString() : cell.prop, { row: row }, () => [
                      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(row[cell.prop]), 1)
                    ], true)
                  ], 2))
                }), 128)),
                ($props.expandable === true && !!(_ctx.$scopedSlots[rowIndex]))
                  ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("td", _hoisted_5, [
                      ($data.expanded[rowIndex] === true)
                        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                            key: 0,
                            onClick: $event => ($options.reduceRow(rowIndex)),
                            onKeypress: $event => ($options.reduceRow(rowIndex)),
                            tabindex: "0"
                          }, [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "expand-controls-reduce", {}, () => [
                              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpIcon, {
                                icon: "reduce",
                                size: 14,
                                float: "none",
                                color: "#212121",
                                style: {"cursor":"pointer"}
                              })
                            ], true)
                          ], 40, _hoisted_6))
                        : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                            key: 1,
                            onClick: $event => ($options.expandRow(rowIndex)),
                            onKeypress: $event => ($options.expandRow(rowIndex)),
                            tabindex: "0"
                          }, [
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "expand-controls-expand", {}, () => [
                              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpIcon, {
                                icon: "expand",
                                size: 14,
                                float: "none",
                                color: "#212121",
                                style: {"cursor":"pointer"}
                              })
                            ], true)
                          ], 40, _hoisted_7))
                    ]))
                  : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
              ], 10, _hoisted_4),
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("tr", null, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("td", {
                  colspan: $data.tableColumns.length+1
                }, [
                  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, ($props.slotPrefix) ? $props.slotPrefix + rowIndex.toString() : rowIndex, { row: row }, undefined, true)
                ], 8, _hoisted_8)
              ], 512), [
                [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, $data.expanded[rowIndex]===true && $props.expandable && !!_ctx.$scopedSlots[rowIndex]]
              ])
            ], 64))
          }), 128))
    ])
  ], 6))
}
;// CONCATENATED MODULE: ./src/components/DpTable.vue?vue&type=template&id=46dd8a00&scoped=true

// EXTERNAL MODULE: ./src/components/DpIcon.vue + 2 modules
var DpIcon = __webpack_require__(5172);
// EXTERNAL MODULE: ./node_modules/lodash/reduce.js
var reduce = __webpack_require__(4061);
var reduce_default = /*#__PURE__*/__webpack_require__.n(reduce);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/DpNoDataIndicator.vue + 5 modules
var DpNoDataIndicator = __webpack_require__(6313);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTable.vue?vue&type=script&lang=js

  
  
  
  

  /* harmony default export */ var DpTablevue_type_script_lang_js = ({
    name: "DpTable",
    components: {DpNoDataIndicator: DpNoDataIndicator["default"], DpIcon: DpIcon["default"]},
    props: {
      size: {type: String, default: 'default'},
      data: {type: Array, required: true},
      columns: {type: [Array, Object], required: true},
      width: {type: String, default: "100%"},
      clickable: {type: Boolean, default: false},
      expandable: {type: Boolean, default: false},
      expandOnClick: {type: Boolean, default: true},
      slotPrefix: {type: String},
      reference: {type: String},
      border: {type: String},
      rtl: {type: Boolean, default: false}
    },
    data() {
      return {
        expanded: [],
        localCopyOfData: this.data,
        tableColumns: this.transformColumnsObject()
      };
    },
    computed: {
      isEmpty() {
        return (isEmpty_default());
      }
    },
    methods: {
      expandRow(rowIndex) {
        this.reduceRow();
        this.$set(this.expanded, rowIndex, true);
      },
      reduceRow() {
        this.expanded = Array(this.data.length).fill(false);
      },
      transformColumnsObject() {
        if (typeof this.columns === 'object' && !(Array.isArray(this.columns))) {
          return reduce_default()(this.columns, function (result, value, key) {
            result.push({prop: key, label: value});
            return result;
          }, []);
        } else {
          return this.columns;
        }
      }
    },
    mounted() {
      this.reduceRow();
    },
    watch: {
      data: {
        deep: true,
        handler(newData) {
          this.localCopyOfData = newData;
          this.reduceRow();
        }
      },
      columns: {
        deep: true,
        handler() {
          this.tableColumns = this.transformColumnsObject();
        }
      }
    }
  });

;// CONCATENATED MODULE: ./src/components/DpTable.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTable.vue?vue&type=style&index=0&id=46dd8a00&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpTable.vue?vue&type=style&index=0&id=46dd8a00&scoped=true&lang=scss

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpTable.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpTablevue_type_script_lang_js, [['render',render],['__scopeId',"data-v-46dd8a00"]])

/* harmony default export */ var DpTable = (__exports__);

/***/ }),

/***/ 4685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpTooltip; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTooltip.vue?vue&type=template&id=79fb6760&scoped=true


const _withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-79fb6760"),n=n(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", { class: "el-icon-info" }, null, -1))

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tooltip")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_tooltip, {
    content: $data.content,
    effect: "light",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({'dp-tooltip__margin': $props.margin}),
    placement: "top"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [
        _hoisted_1
      ], true),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "description", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["content", "class"]))
}
;// CONCATENATED MODULE: ./src/components/DpTooltip.vue?vue&type=template&id=79fb6760&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTooltip.vue?vue&type=script&lang=js

  /* harmony default export */ var DpTooltipvue_type_script_lang_js = ({
    name: "DpTooltip",
    props: {
      modelValue: {required: true},
      margin: {type: Boolean, default: true}
    },
    data() {
      return {
        content: this.modelValue
      };
    },
    watch: {
      modelValue: {
        handler() {
          this.content = this.modelValue;
        }
      }
    },

  });

;// CONCATENATED MODULE: ./src/components/DpTooltip.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTooltip.vue?vue&type=style&index=0&id=79fb6760&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpTooltip.vue?vue&type=style&index=0&id=79fb6760&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpTooltip.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DpTooltipvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpTooltip.vue




;
/* custom blocks */

if (typeof DpTooltipvue_type_custom_index_0_blockType_i18n === 'function') DpTooltipvue_type_custom_index_0_blockType_i18n(DpTooltipvue_type_script_lang_js)


;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpTooltipvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-79fb6760"]])

/* harmony default export */ var DpTooltip = (__exports__);

/***/ }),

/***/ 9293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DpWrapper; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpWrapper.vue?vue&type=template&id=20ad7704


function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col")
  const _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row")

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_row, {
    type: "flex",
    justify: "center"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
        class: "wrapper__col",
        xs: 24,
        sm: 22,
        md: 20,
        lg: 18
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
;// CONCATENATED MODULE: ./src/components/DpWrapper.vue?vue&type=template&id=20ad7704

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpWrapper.vue?vue&type=script&lang=js

  const wrapper = {
    name: "DpWrapper"
  };

  /* harmony default export */ var DpWrappervue_type_script_lang_js = (wrapper);

;// CONCATENATED MODULE: ./src/components/DpWrapper.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/DpWrapper.vue?vue&type=style&index=0&id=20ad7704&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DpWrapper.vue?vue&type=style&index=0&id=20ad7704&lang=css

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/DpWrapper.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DpWrappervue_type_script_lang_js, [['render',render]])

/* harmony default export */ var DpWrapper = (__exports__);

/***/ }),

/***/ 4475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WebsiteLogo; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./src/assets/AACE_Logo_RGB.png
var AACE_Logo_RGB_namespaceObject = __webpack_require__.p + "img/AACE_Logo_RGB.6c4d8cdc.png";
;// CONCATENATED MODULE: ./src/assets/AACE_Logo_RGB@05x.png
var AACE_Logo_RGB_05x_namespaceObject = __webpack_require__.p + "img/AACE_Logo_RGB@05x.eb5c58c6.png";
;// CONCATENATED MODULE: ./src/assets/AACE_Logo_RGB@2x.png
var AACE_Logo_RGB_2x_namespaceObject = __webpack_require__.p + "img/AACE_Logo_RGB@2x.fc4945fb.png";
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebsiteLogo.vue?vue&type=template&id=c5f109f6&scoped=true






const _withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-c5f109f6"),n=n(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(),n)
const _hoisted_1 = AACE_Logo_RGB_05x_namespaceObject + ' 0.5x, ' + AACE_Logo_RGB_2x_namespaceObject + ' 2x'
const _hoisted_2 = {
  key: 0,
  id: "dutypay-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "273.84",
  height: "60",
  viewBox: "0 0 273.84 60"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = {
  key: 1,
  id: "giz-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "230.81",
  height: "60",
  viewBox: "0 0 230.81 60"
}
const _hoisted_15 = ["fill"]
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]
const _hoisted_20 = ["fill"]
const _hoisted_21 = ["fill"]
const _hoisted_22 = {
  key: 2,
  id: "aace-logo",
  src: AACE_Logo_RGB_namespaceObject,
  srcset: _hoisted_1,
  border: "0"
}
const _hoisted_23 = {
  key: 3,
  id: "100bridges-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "421.43",
  height: "60",
  viewBox: "0 0 421.43 60"
}
const _hoisted_24 = ["fill"]
const _hoisted_25 = ["fill"]
const _hoisted_26 = ["fill"]
const _hoisted_27 = ["fill"]
const _hoisted_28 = ["fill"]
const _hoisted_29 = ["fill"]
const _hoisted_30 = ["fill"]
const _hoisted_31 = ["fill"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M291.41,289.27s.1.05.15,0,0-.07,0-.06Z",
  transform: "translate(-207.47 -267.99)"
}, null, -1))
const _hoisted_33 = ["fill"]
const _hoisted_34 = ["fill"]
const _hoisted_35 = ["fill"]
const _hoisted_36 = ["fill"]
const _hoisted_37 = ["fill"]
const _hoisted_38 = ["fill"]
const _hoisted_39 = ["fill"]
const _hoisted_40 = ["fill"]
const _hoisted_41 = ["fill"]
const _hoisted_42 = ["fill"]
const _hoisted_43 = ["fill"]
const _hoisted_44 = ["fill"]
const _hoisted_45 = ["fill"]
const _hoisted_46 = ["fill"]
const _hoisted_47 = ["fill"]
const _hoisted_48 = ["fill"]
const _hoisted_49 = ["fill"]
const _hoisted_50 = ["fill"]
const _hoisted_51 = ["fill"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  d: "M298.64,295.16s0,.14,0,.11a.11.11,0,0,0,0-.1Z",
  transform: "translate(-207.47 -267.99)"
}, null, -1))
const _hoisted_53 = ["fill"]
const _hoisted_54 = ["fill"]
const _hoisted_55 = ["fill"]

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    ($props.logo === 'dutypay')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_2, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("polygon", {
            points: "8.07 60 4.99 57.78 1.91 60 3.06 56.38 0 54.13 3.8 54.12 4.99 50.51 6.18 54.12 9.98 54.13 6.92 56.38 8.07 60",
            fill: $props.color?$props.color:'#eeb111'
          }, null, 8, _hoisted_3),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("polygon", {
            points: "31.4 60 28.31 57.78 25.23 60 26.39 56.38 23.32 54.13 27.12 54.12 28.31 50.51 29.5 54.12 33.3 54.13 30.24 56.38 31.4 60",
            fill: $props.color?$props.color:'#eeb111'
          }, null, 8, _hoisted_4),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("polygon", {
            points: "54.71 60 51.63 57.78 48.55 60 49.71 56.38 46.65 54.13 50.44 54.12 51.63 50.51 52.83 54.12 56.62 54.13 53.56 56.38 54.71 60",
            fill: $props.color?$props.color:'#eeb111'
          }, null, 8, _hoisted_5),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("polygon", {
            points: "78.04 60 74.96 57.78 71.87 60 73.03 56.38 69.97 54.13 73.77 54.12 74.96 50.51 76.15 54.12 79.94 54.13 76.88 56.38 78.04 60",
            fill: $props.color?$props.color:'#eeb111'
          }, null, 8, _hoisted_6),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("polygon", {
            points: "101.36 60 98.28 57.78 95.2 60 96.35 56.38 93.29 54.13 97.09 54.12 98.28 50.51 99.47 54.12 103.26 54.13 100.2 56.38 101.36 60",
            fill: $props.color?$props.color:'#eeb111'
          }, null, 8, _hoisted_7),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M264.48,51.56a65.77,65.77,0,0,1,10.93.65,19,19,0,0,1,6.16,2.21A14.16,14.16,0,0,1,288,62a21.25,21.25,0,0,1,.66,11.4,27,27,0,0,1-4.81,11.37,24.28,24.28,0,0,1-9.16,7.53,25.73,25.73,0,0,1-7,2.18,69.44,69.44,0,0,1-11.18.65H236l7.94-43.52ZM254.3,60.29,249.6,86h8.83q7.8,0,12.47-3.28a14.3,14.3,0,0,0,5.81-9.61q1.16-6.32-2.29-9.59t-11.3-3.27Z",
            transform: "translate(-235.3 -51.56)",
            fill: $props.color?$props.color:'#221f72'
          }, null, 8, _hoisted_8),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M331.84,62.58l-5.92,32.5H315.4l.89-4.89a23.67,23.67,0,0,1-6.79,4.27A19.91,19.91,0,0,1,302,95.87a17.78,17.78,0,0,1-7.28-1.31,8.43,8.43,0,0,1-4.24-3.81,8.68,8.68,0,0,1-.9-3.68,33.94,33.94,0,0,1,.74-6.58l3.26-17.9h10.52l-2.87,15.75c-.66,3.61-.57,6.09.29,7.43s2.64,2,5.36,2a11.88,11.88,0,0,0,7.64-2.42,10.68,10.68,0,0,0,3.85-6.75l2.93-16Z",
            transform: "translate(-235.3 -51.56)",
            fill: $props.color?$props.color:'#221f72'
          }, null, 8, _hoisted_9),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M384.41,62.58l-13.66,23.2-5.25-23.2H349.68L351.24,54H340.73l-1.56,8.55h-4.95l-1.4,7.66h4.95l-3.31,18.15q-.76,4.15,1.52,6t8.34,1.84h7.1l1.43-7.84h-4.4c-1.52,0-2.44-.19-2.77-.58s-.29-1.66.1-3.83l2.51-13.74h7.62L363,95.85a5.09,5.09,0,0,1,.13,1,7.56,7.56,0,0,1-.1,1.26,3.59,3.59,0,0,1-1.4,2.43,5.15,5.15,0,0,1-3.11.83h-8.43l-1.63,9.88h9.69a22.8,22.8,0,0,0,3.4-.19,7.4,7.4,0,0,0,2.15-.69A11.05,11.05,0,0,0,367,108a25.65,25.65,0,0,0,3.17-4.1L396,62.58Z",
            transform: "translate(-235.3 -51.56)",
            fill: $props.color?$props.color:'#221f72'
          }, null, 8, _hoisted_10),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M399.18,95.08l7.92-43.52h18.52q8.52,0,12.06,3.15t2.35,9.7q-1.18,6.51-5.88,9.67t-13.22,3.16H407L403.7,95.08ZM407.75,73h13.17q7.21,0,10.35-1.94c2.07-1.29,3.41-3.53,4-6.71s.08-5.47-1.54-6.78-4.82-2-9.62-2H410.93Z",
            transform: "translate(-235.3 -51.56)",
            fill: $props.color?$props.color:'#007dc3'
          }, null, 8, _hoisted_11),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M471.6,91,471,94.66a14.83,14.83,0,0,1-2,.44,10.37,10.37,0,0,1-1.76.15,3.48,3.48,0,0,1-3-1.13c-.54-.77-.73-2.06-.54-3.93a21.73,21.73,0,0,1-6.91,4.33,24,24,0,0,1-8.43,1.35c-4.05,0-7-.83-8.9-2.5s-2.55-4.05-2-7.09A9.69,9.69,0,0,1,439,82.45a11,11,0,0,1,3.18-3,14.74,14.74,0,0,1,4-1.62,79.08,79.08,0,0,1,8.35-1.41l3.52-.41q8.32-.95,9-4.54a3.59,3.59,0,0,0-1.63-4c-1.4-.92-3.62-1.37-6.65-1.37q-5.73,0-9,1.84a8.49,8.49,0,0,0-4.23,5.56h-4.33A13.29,13.29,0,0,1,447,65.13q4.44-2.79,11.91-2.79a24.7,24.7,0,0,1,7.53.91,7.55,7.55,0,0,1,4.1,3,6.16,6.16,0,0,1,.93,2.85A19.14,19.14,0,0,1,471,74l-.32,1.77-2.26,12.39a5.29,5.29,0,0,0-.09,2.66c.2.38.64.55,1.32.55a6,6,0,0,0,.95-.08,6.61,6.61,0,0,0,1-.22m-5.7-13.27a17.57,17.57,0,0,1-3.83,1.2q-2.51.54-8.13,1.34-7.43,1.09-9.56,2.33a5.28,5.28,0,0,0-2.6,3.76,3.93,3.93,0,0,0,1.59,4.13,9.92,9.92,0,0,0,6,1.54,19.3,19.3,0,0,0,10.55-2.75,10.57,10.57,0,0,0,5.15-7.19l.1-.5Z",
            transform: "translate(-235.3 -51.56)",
            fill: $props.color?$props.color:'#007dc3'
          }, null, 8, _hoisted_12),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M485.42,98.93q-3.18,4.83-5.72,6.25a13.09,13.09,0,0,1-6.56,1.39,10.11,10.11,0,0,1-1.65-.14c-.59-.11-1.26-.26-2-.45l.74-4q1.33.27,2.37.39a12.16,12.16,0,0,0,1.81.14,7,7,0,0,0,4.42-1.49A25.32,25.32,0,0,0,483.62,95l-9.45-31.8h5.05l7.44,27.67,17.63-27.67h4.85Z",
            transform: "translate(-235.3 -51.56)",
            fill: $props.color?$props.color:'#007dc3'
          }, null, 8, _hoisted_13)
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.logo === 'giz')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_14, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M971.53,567.22V554.67a4.43,4.43,0,0,0-1.81-3.64,5.73,5.73,0,0,0-3.89-1.42h-.63a5.54,5.54,0,0,0-4,1.67,5,5,0,0,0-1.79,3.8v11.6a4.94,4.94,0,0,0,1.79,3.79,5.51,5.51,0,0,0,4,1.68h.63a5.78,5.78,0,0,0,3.89-1.43,4.28,4.28,0,0,0,1.81-3.5Zm-.74,9.13a5.9,5.9,0,0,0-.61.47l-.06,0-.13.1-.13.1-.13.09-.14.09-.15.09-.15.09-.16.08-.16.08-.16.08-.17.07-.17.07-.17.06-.16.06L968,578l-.17,0-.16,0-.17,0-.16,0-.16,0a11.82,11.82,0,0,1-2,.17h-.51a12.07,12.07,0,0,1-8.34-3.28,10.86,10.86,0,0,1-3.47-7.93v-12.5a10.86,10.86,0,0,1,3.47-7.93,12.07,12.07,0,0,1,8.34-3.28h.66a13.71,13.71,0,0,1,1.76.13l.16,0,.17,0,.16,0,.17,0,.17,0,.17,0,.18.06.17.06.17.06.17.07.16.07.16.08.16.08.15.08.14.08.05,0,.06,0,.06,0,.06,0,.06,0,.06,0,.06,0,.06,0,0,0,.06,0,0,0,.06,0,0,.05,0,0,.05,0,0,.05,0,0,0,0,.1.08.08,0,.12,0h.25l.11,0,.11-.06.09-.08a.31.31,0,0,0,.07-.09.27.27,0,0,0,.06-.1.56.56,0,0,0,0-.12.49.49,0,0,0,0-.12c0-.41,0-1,.45-1.11a3.34,3.34,0,0,1,.89,0h4.22c.43,0,1.08-.11,1.26.42a6.73,6.73,0,0,1,0,1.62v26.65a65,65,0,0,1-.17,7.12c-.75,6.57-4,12.15-11,13.38a14.51,14.51,0,0,1-11.65-3.44c-.4-.33-1.22-.88-1.19-1.44a.89.89,0,0,1,.24-.53s2.69-2.85,2.89-3.1.46-.51.76-.51.87.4,1.64.85a12.2,12.2,0,0,0,4.21,1.7A6.53,6.53,0,0,0,967,586c3.53-1.15,4.5-5.6,4.71-9.09v-.12a.13.13,0,0,1,0-.06l0-.06s0,0,0,0a.14.14,0,0,1,0-.06l0,0,0,0,0-.05,0,0,0,0-.05,0,0,0-.06,0H971l-.06,0-.1.06Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_15),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M1026,577.54V573a.72.72,0,0,0-.21-.58.75.75,0,0,0-.55-.19H1012.6a1,1,0,0,1-.65-.16.55.55,0,0,1-.2-.43,1.13,1.13,0,0,1,.16-.56l13.85-26.12a1.69,1.69,0,0,0,.1-.27,1,1,0,0,0,.05-.27c0-.39-.29-.6-.84-.61h-22.68a.66.66,0,0,0-.77.77v4.58a.66.66,0,0,0,.77.77h11.85a1.07,1.07,0,0,1,.63.16.53.53,0,0,1,.21.45,1,1,0,0,1-.05.27,1.69,1.69,0,0,1-.11.27l-14,26.12a1.69,1.69,0,0,0-.11.27,1,1,0,0,0-.05.27c0,.39.3.6.84.61h23.62a.65.65,0,0,0,.76-.76Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_16),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M986.77,539.32a1,1,0,0,0,.23.58,1,1,0,0,0,.7.24h4.77a1,1,0,0,0,.69-.24.79.79,0,0,0,.23-.57v-5.44a.83.83,0,0,0-.93-.95h-.38a1,1,0,0,0-.82.35l-4,4.48-.19.22a1,1,0,0,0-.3.73v.6Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_17),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M993.36,544.55a.84.84,0,0,0-.2-.61.83.83,0,0,0-.63-.21h-5a.87.87,0,0,0-.63.24.88.88,0,0,0-.19.58v32.93a.92.92,0,0,0,.19.62.86.86,0,0,0,.63.2h5a.77.77,0,0,0,.63-.24.82.82,0,0,0,.2-.58V544.55Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_18),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M1043.3,577.7a.41.41,0,0,0-.34-.15h-3.06l3.44-6.6a.61.61,0,0,0,.09-.31.51.51,0,0,0-.16-.38.56.56,0,0,0-.4-.16h-3.46a.4.4,0,0,0-.35.15.47.47,0,0,0-.11.31.48.48,0,0,0,.11.32.4.4,0,0,0,.35.14h2.87l-3.43,6.58a.59.59,0,0,0-.07.29.62.62,0,0,0,.14.41.48.48,0,0,0,.39.17H1043a.43.43,0,0,0,.34-.14.49.49,0,0,0,.12-.32.47.47,0,0,0-.12-.31Zm5.94-4.68a.39.39,0,0,0-.15-.34.48.48,0,0,0-.31-.12.49.49,0,0,0-.32.12.39.39,0,0,0-.15.34v3.57a1,1,0,0,1-.3.72,1,1,0,0,1-.74.3h-.11a1,1,0,0,1-1-1V573a.39.39,0,0,0-.14-.34.49.49,0,0,0-.32-.12.48.48,0,0,0-.31.12.39.39,0,0,0-.15.34v3.58a2.29,2.29,0,0,0,.16.87,1.68,1.68,0,0,0,1.05.95,2.65,2.65,0,0,0,.74.11h.11a2,2,0,0,0,.6-.09,1.12,1.12,0,0,0,.44-.26.47.47,0,0,0,.17.27.61.61,0,0,0,.3.08.53.53,0,0,0,.31-.11.4.4,0,0,0,.15-.33V573Zm6.2,3.77a1.6,1.6,0,0,0-.24-.93,1.69,1.69,0,0,0-.58-.52,2.65,2.65,0,0,0-.76-.28l-.75-.18a2,2,0,0,1-.58-.24.52.52,0,0,1-.24-.47v0a.59.59,0,0,1,.28-.46,1.29,1.29,0,0,1,.77-.2h.05a1.37,1.37,0,0,1,.64.12l.43.21a.54.54,0,0,0,.26.07.41.41,0,0,0,.32-.13.44.44,0,0,0,.12-.3.45.45,0,0,0-.17-.36l-.21-.15a1.79,1.79,0,0,0-.34-.17,2.48,2.48,0,0,0-.46-.15,2.58,2.58,0,0,0-.58-.06h0a3,3,0,0,0-.64.08,2.1,2.1,0,0,0-.64.26,1.53,1.53,0,0,0-.5.48,1.23,1.23,0,0,0-.21.73,1.42,1.42,0,0,0,.24.88,1.57,1.57,0,0,0,.58.47,2.65,2.65,0,0,0,.75.25,5,5,0,0,1,.76.19,1.85,1.85,0,0,1,.58.29.7.7,0,0,1,.24.58v0a.79.79,0,0,1-.31.56,1.27,1.27,0,0,1-.85.25h-.06a1.24,1.24,0,0,1-.7-.23,2.46,2.46,0,0,1-.58-.53.36.36,0,0,0-.19-.16.59.59,0,0,0-.22-.05.48.48,0,0,0-.33.13.4.4,0,0,0-.14.32,1.07,1.07,0,0,0,.06.23,1.89,1.89,0,0,0,.38.51,2.28,2.28,0,0,0,.5.38,3.32,3.32,0,0,0,.59.24,2.61,2.61,0,0,0,.6.08h.07a2.43,2.43,0,0,0,.75-.11,2,2,0,0,0,.68-.32,1.62,1.62,0,0,0,.49-.52,1.47,1.47,0,0,0,.18-.74v-.05Zm6.39,1a.44.44,0,0,0-.3-.16.36.36,0,0,1-.31-.4v-2.81a1.87,1.87,0,0,0-.55-1.32,1.91,1.91,0,0,0-.6-.4,1.93,1.93,0,0,0-.75-.15h-.09a2.12,2.12,0,0,0-.49.06,1.58,1.58,0,0,0-.5.18,1.78,1.78,0,0,0-.45.34,1.81,1.81,0,0,0-.36.55.48.48,0,0,0,0,.22.37.37,0,0,0,.15.31.51.51,0,0,0,.31.11.59.59,0,0,0,.23-.05.47.47,0,0,0,.18-.19,1.38,1.38,0,0,1,.39-.46,1,1,0,0,1,.59-.15h.09a1.18,1.18,0,0,1,.69.22.91.91,0,0,1,.29.76.41.41,0,0,1,0,.11.15.15,0,0,1,0,.1.63.63,0,0,1-.33.15l-.6.12-.71.15a2.58,2.58,0,0,0-.7.29,1.62,1.62,0,0,0-.52.49,1.47,1.47,0,0,0-.2.79v.14a1.54,1.54,0,0,0,.17.75,1.7,1.7,0,0,0,.44.55,1.92,1.92,0,0,0,.62.32,2.25,2.25,0,0,0,.72.11h.11a1.88,1.88,0,0,0,1.3-.47,1.28,1.28,0,0,0,.32.29,1.33,1.33,0,0,0,.51.17h.08a.4.4,0,0,0,.34-.14.52.52,0,0,0,.11-.32.48.48,0,0,0-.09-.27Zm-1.53-1.22a1,1,0,0,1-.31.74,1.05,1.05,0,0,1-.73.29h-.11a1.12,1.12,0,0,1-.75-.23.74.74,0,0,1-.28-.61v-.1a.61.61,0,0,1,.21-.49,1.51,1.51,0,0,1,.54-.26,3.71,3.71,0,0,1,.71-.15l.72-.14v1Zm10.62-2.08a2.14,2.14,0,0,0-.16-.87,1.68,1.68,0,0,0-1-1,2.3,2.3,0,0,0-.74-.12h-.11a1.92,1.92,0,0,0-.84.19,2.06,2.06,0,0,0-.66.5,2.3,2.3,0,0,0-.66-.5,2,2,0,0,0-.84-.19h-.11a1.72,1.72,0,0,0-.6.1,1,1,0,0,0-.44.27.46.46,0,0,0-.17-.28.5.5,0,0,0-.61,0,.42.42,0,0,0-.15.34v5.07a.37.37,0,0,0,.14.33.48.48,0,0,0,.32.11.47.47,0,0,0,.31-.11.37.37,0,0,0,.15-.33v-3.67a.82.82,0,0,1,.31-.68,1.12,1.12,0,0,1,.73-.26h.11a1.06,1.06,0,0,1,.74.29,1,1,0,0,1,.3.75v3.54a.46.46,0,0,0,.14.36.54.54,0,0,0,.32.11.51.51,0,0,0,.31-.11.43.43,0,0,0,.15-.36v-3.54a1,1,0,0,1,1-1h.11a1.06,1.06,0,0,1,.74.26,1,1,0,0,1,.29.76v3.59a.39.39,0,0,0,.14.33.5.5,0,0,0,.32.11.45.45,0,0,0,.31-.11.37.37,0,0,0,.15-.33V574.5Zm9.27,0a2.33,2.33,0,0,0-.15-.87,1.77,1.77,0,0,0-.43-.6,1.7,1.7,0,0,0-.63-.35,2.25,2.25,0,0,0-.74-.12h-.11a2,2,0,0,0-.84.19,2.3,2.3,0,0,0-.66.5,2.06,2.06,0,0,0-.66-.5,1.92,1.92,0,0,0-.84-.19H1075a1.63,1.63,0,0,0-.59.1,1,1,0,0,0-.45.27.39.39,0,0,0-.17-.28.49.49,0,0,0-.28-.09.52.52,0,0,0-.33.12.44.44,0,0,0-.14.34v5.07a.39.39,0,0,0,.14.33.5.5,0,0,0,.32.11.45.45,0,0,0,.31-.11.37.37,0,0,0,.15-.33v-3.67a.85.85,0,0,1,.31-.68,1.16,1.16,0,0,1,.73-.26h.11a1,1,0,0,1,.74.29,1,1,0,0,1,.3.75v3.54a.43.43,0,0,0,.15.36.51.51,0,0,0,.31.11.54.54,0,0,0,.32-.11.46.46,0,0,0,.14-.36v-3.54a1,1,0,0,1,1-1h.11a1.09,1.09,0,0,1,.75.26,1,1,0,0,1,.28.76v3.59a.37.37,0,0,0,.15.33.45.45,0,0,0,.31.11.48.48,0,0,0,.32-.11.39.39,0,0,0,.14-.33V574.5Zm6,0a1.92,1.92,0,0,0-.57-1.4,1.86,1.86,0,0,0-.62-.41,1.94,1.94,0,0,0-.76-.15h-.12a1.94,1.94,0,0,0-.76.15,2.19,2.19,0,0,0-.62.42,1.93,1.93,0,0,0-.42.63,1.9,1.9,0,0,0-.15.75v2.09a1.94,1.94,0,0,0,.15.76,1.85,1.85,0,0,0,.42.61,2.16,2.16,0,0,0,.62.41,1.94,1.94,0,0,0,.76.15h.12a1.86,1.86,0,0,0,1.09-.32,1.9,1.9,0,0,0,.68-.83.39.39,0,0,0,0-.2.43.43,0,0,0-.15-.34.43.43,0,0,0-.55-.07.41.41,0,0,0-.17.23,1.22,1.22,0,0,1-.36.43.94.94,0,0,1-.59.18h-.12a1,1,0,0,1-.73-.3,1,1,0,0,1-.3-.72V576h2.64a.45.45,0,0,0,.33-.14.44.44,0,0,0,.13-.32v-1Zm-.92.61h-2.18v-.61a1,1,0,0,1,.31-.74,1,1,0,0,1,.73-.3h.12a1,1,0,0,1,.71.3,1,1,0,0,1,.31.75v.6Zm6.94-.62a2.24,2.24,0,0,0-.16-.86,2,2,0,0,0-.42-.62,1.66,1.66,0,0,0-.62-.35,2.3,2.3,0,0,0-.74-.12h-.11a1.63,1.63,0,0,0-.59.1,1,1,0,0,0-.45.27.42.42,0,0,0-.17-.28.51.51,0,0,0-.62,0,.41.41,0,0,0-.14.34v5.07a.37.37,0,0,0,.14.33.48.48,0,0,0,.32.11.47.47,0,0,0,.31-.11.37.37,0,0,0,.15-.33v-3.58a1,1,0,0,1,.3-.73,1,1,0,0,1,.73-.3h.11a1.06,1.06,0,0,1,1,1v3.58a.39.39,0,0,0,.14.33.5.5,0,0,0,.32.11.48.48,0,0,0,.32-.11.39.39,0,0,0,.14-.33v-3.58Zm6.52,3.29a.44.44,0,0,0-.3-.16.36.36,0,0,1-.31-.4v-2.81a1.87,1.87,0,0,0-.55-1.32,1.91,1.91,0,0,0-.6-.4,1.93,1.93,0,0,0-.75-.15h-.09a2.12,2.12,0,0,0-.49.06,1.58,1.58,0,0,0-.5.18,1.78,1.78,0,0,0-.45.34,1.81,1.81,0,0,0-.36.55.48.48,0,0,0-.05.22.37.37,0,0,0,.15.31.51.51,0,0,0,.31.11.59.59,0,0,0,.23-.05.47.47,0,0,0,.18-.19,1.38,1.38,0,0,1,.39-.46,1,1,0,0,1,.59-.15h.09a1.18,1.18,0,0,1,.69.22.91.91,0,0,1,.29.76.41.41,0,0,1,0,.11.15.15,0,0,1,0,.1.63.63,0,0,1-.33.15l-.6.12-.71.15a2.58,2.58,0,0,0-.7.29,1.62,1.62,0,0,0-.52.49,1.47,1.47,0,0,0-.2.79v.14a1.54,1.54,0,0,0,.17.75,1.7,1.7,0,0,0,.44.55,1.92,1.92,0,0,0,.62.32,2.25,2.25,0,0,0,.72.11h.11a1.88,1.88,0,0,0,1.3-.47,1.28,1.28,0,0,0,.32.29,1.33,1.33,0,0,0,.51.17h.08a.4.4,0,0,0,.34-.14.52.52,0,0,0,.11-.32.48.48,0,0,0-.09-.27Zm-1.53-1.22a1,1,0,0,1-.31.74,1.05,1.05,0,0,1-.73.29h-.11a1.12,1.12,0,0,1-.75-.23.74.74,0,0,1-.28-.61v-.1a.61.61,0,0,1,.21-.49,1.51,1.51,0,0,1,.54-.26,3.71,3.71,0,0,1,.71-.15l.72-.14v1Zm6.46-3.42a1.34,1.34,0,0,0-.57-.46,1.89,1.89,0,0,0-.69-.14,1.45,1.45,0,0,0-.4,0,1.25,1.25,0,0,0-.27.08.69.69,0,0,0-.21.13.32.32,0,0,0-.17-.19.46.46,0,0,0-.23-.06.51.51,0,0,0-.32.12.42.42,0,0,0-.15.34v5a.43.43,0,0,0,.15.36.51.51,0,0,0,.31.11.56.56,0,0,0,.32-.11.46.46,0,0,0,.14-.36v-3.77a1.5,1.5,0,0,1,0-.29.54.54,0,0,1,.11-.26.51.51,0,0,1,.24-.18,1,1,0,0,1,.43-.08.6.6,0,0,1,.36.09,1.25,1.25,0,0,1,.2.17.53.53,0,0,0,.38.17.45.45,0,0,0,.31-.12.41.41,0,0,0,.13-.32.57.57,0,0,0-.1-.31Zm6,1.35a1.9,1.9,0,0,0-.15-.75,1.93,1.93,0,0,0-.42-.63,2.19,2.19,0,0,0-.62-.42,2,2,0,0,0-.77-.15h-.09a1.73,1.73,0,0,0-.6.11.86.86,0,0,0-.45.29v-2.47a.39.39,0,0,0-.15-.34.47.47,0,0,0-.31-.12.51.51,0,0,0-.32.12.42.42,0,0,0-.14.34v7.62a.39.39,0,0,0,.14.32.55.55,0,0,0,.32.1.6.6,0,0,0,.29-.08.38.38,0,0,0,.16-.27,1.09,1.09,0,0,0,.39.24,1.55,1.55,0,0,0,.65.11h.11a1.9,1.9,0,0,0,.75-.15,2.08,2.08,0,0,0,.63-.41,1.85,1.85,0,0,0,.42-.61,1.79,1.79,0,0,0,.16-.76v-2.09Zm-.92,2.08a1,1,0,0,1-.3.72,1,1,0,0,1-.74.3h-.11a1.07,1.07,0,0,1-.72-.25.84.84,0,0,1-.31-.7v-2.25a.81.81,0,0,1,.31-.67,1.08,1.08,0,0,1,.72-.26h.11a1,1,0,0,1,.74.31,1,1,0,0,1,.3.72v2.08Zm6.93-2.07a1.92,1.92,0,0,0-.57-1.4,2,2,0,0,0-1.38-.56h-.12a1.94,1.94,0,0,0-1.8,1.2,1.9,1.9,0,0,0-.15.75v2.09a1.94,1.94,0,0,0,.15.76,1.85,1.85,0,0,0,.42.61,1.92,1.92,0,0,0,.62.41,1.94,1.94,0,0,0,.76.15h.12a1.81,1.81,0,0,0,1.08-.32,1.92,1.92,0,0,0,.69-.83.4.4,0,0,0,0-.2.42.42,0,0,0-.14-.34.49.49,0,0,0-.33-.14.48.48,0,0,0-.23.07.46.46,0,0,0-.17.23,1.3,1.3,0,0,1-.35.43,1,1,0,0,1-.59.18h-.12a1,1,0,0,1-1-1V576h2.64a.42.42,0,0,0,.32-.14.45.45,0,0,0,.14-.32v-1Zm-.92.61h-2.18v-.61a1,1,0,0,1,.31-.74,1,1,0,0,1,.73-.3h.12a1,1,0,0,1,1,1v.6Zm3.9-4.64a.39.39,0,0,0-.15-.34.46.46,0,0,0-.62,0,.39.39,0,0,0-.15.34v.27a.39.39,0,0,0,.15.34.46.46,0,0,0,.62,0,.39.39,0,0,0,.15-.34v-.27Zm0,2.53a.39.39,0,0,0-.15-.34.46.46,0,0,0-.62,0,.39.39,0,0,0-.15.34v5.07a.37.37,0,0,0,.15.33.49.49,0,0,0,.62,0,.37.37,0,0,0,.15-.33V573Zm4.79,4.75a.47.47,0,0,0-.32-.16.8.8,0,0,1-.49-.2.59.59,0,0,1-.21-.49v-3.4h.65a.39.39,0,0,0,.34-.15.47.47,0,0,0,.12-.31.51.51,0,0,0-.12-.32.42.42,0,0,0-.34-.14h-.65v-2.11a.39.39,0,0,0-.15-.34.48.48,0,0,0-.31-.12.49.49,0,0,0-.32.12.39.39,0,0,0-.14.34v2.11h-.43a.42.42,0,0,0-.34.14.51.51,0,0,0-.12.32.47.47,0,0,0,.12.31.39.39,0,0,0,.34.15h.43V577a1.58,1.58,0,0,0,.12.61,1.39,1.39,0,0,0,.34.51,1.43,1.43,0,0,0,.5.34,1.63,1.63,0,0,0,.62.12.4.4,0,0,0,.35-.14.45.45,0,0,0,.11-.31.48.48,0,0,0-.1-.31Zm6.84.59a5.81,5.81,0,0,1-.52-1.06,7.94,7.94,0,0,1-.36-1.3,7.84,7.84,0,0,1-.13-1.48,7.66,7.66,0,0,1,.49-2.73,5.88,5.88,0,0,1,.5-1.07,3.79,3.79,0,0,1,.59-.77.45.45,0,0,0,.13-.29.44.44,0,0,0-.15-.32.49.49,0,0,0-.31-.13.47.47,0,0,0-.32.14,5.63,5.63,0,0,0-.71.94,6.86,6.86,0,0,0-.57,1.22,9.61,9.61,0,0,0-.39,1.43,9.1,9.1,0,0,0-.14,1.58,9.48,9.48,0,0,0,.14,1.62,8.51,8.51,0,0,0,.4,1.45,6.56,6.56,0,0,0,.58,1.22,4.69,4.69,0,0,0,.73.92.43.43,0,0,0,.3.15.46.46,0,0,0,.33-.15.38.38,0,0,0,.16-.3.4.4,0,0,0-.15-.3,4.12,4.12,0,0,1-.6-.77Zm6.89-4a.45.45,0,0,0-.14-.32.41.41,0,0,0-.32-.14H1135a.44.44,0,0,0-.35.14.48.48,0,0,0-.11.32.45.45,0,0,0,.11.31.41.41,0,0,0,.35.15h1.27v1.41a1.37,1.37,0,0,1-.41,1,1.42,1.42,0,0,1-.43.29,1.24,1.24,0,0,1-.54.11h-.12a1.19,1.19,0,0,1-.54-.11,1.46,1.46,0,0,1-.44-.29,1.71,1.71,0,0,1-.3-.44,1.33,1.33,0,0,1-.1-.54v-3.91a1.35,1.35,0,0,1,.1-.53,1.66,1.66,0,0,1,.3-.43,1.37,1.37,0,0,1,1-.41h.12a1.28,1.28,0,0,1,.94.34,1.62,1.62,0,0,1,.44.85.43.43,0,0,0,.17.3.5.5,0,0,0,.29.09.47.47,0,0,0,.31-.12.4.4,0,0,0,.15-.33V572a2.3,2.3,0,0,0-.26-.79,2.21,2.21,0,0,0-.51-.63,2.58,2.58,0,0,0-.7-.41,2.34,2.34,0,0,0-.83-.15h-.12a2.26,2.26,0,0,0-.9.18,2.34,2.34,0,0,0-.73.49,2.36,2.36,0,0,0-.68,1.63v3.91a2.28,2.28,0,0,0,.19.91,2.14,2.14,0,0,0,.49.72,2.18,2.18,0,0,0,.73.49,2.44,2.44,0,0,0,.9.17h.12a2.43,2.43,0,0,0,.89-.17,2.22,2.22,0,0,0,.74-.49,2.48,2.48,0,0,0,.49-.72,2.27,2.27,0,0,0,.18-.91v-1.87Zm3.35-3.88a.42.42,0,0,0-.14-.34.51.51,0,0,0-.32-.12.47.47,0,0,0-.31.12.39.39,0,0,0-.15.34v7.6a.37.37,0,0,0,.15.33.45.45,0,0,0,.31.11.5.5,0,0,0,.32-.11.39.39,0,0,0,.14-.33v-7.6Zm6.73,7.21a.41.41,0,0,0-.35-.15h-3l3.44-6.6a.61.61,0,0,0,.09-.31.55.55,0,0,0-.16-.38.58.58,0,0,0-.4-.16h-3.47a.41.41,0,0,0-.35.15.53.53,0,0,0-.11.31.54.54,0,0,0,.11.32.41.41,0,0,0,.35.14h2.88l-3.43,6.58a.6.6,0,0,0-.08.29.68.68,0,0,0,.14.41.51.51,0,0,0,.4.17h3.64a.44.44,0,0,0,.35-.14.48.48,0,0,0,.11-.32.45.45,0,0,0-.11-.31Zm4.17-4.76a8.92,8.92,0,0,0-.38-1.44,6.25,6.25,0,0,0-.58-1.22,4.4,4.4,0,0,0-.72-.93.44.44,0,0,0-.31-.14.51.51,0,0,0-.32.13.47.47,0,0,0-.14.32.41.41,0,0,0,.13.29,3.81,3.81,0,0,1,.6.77,5.88,5.88,0,0,1,.5,1.07,7.56,7.56,0,0,1,.35,1.29,8.39,8.39,0,0,1,.12,1.44,7.84,7.84,0,0,1-.13,1.48,9.09,9.09,0,0,1-.35,1.3,6.54,6.54,0,0,1-.52,1.06,4.14,4.14,0,0,1-.61.77.43.43,0,0,0-.13.29.42.42,0,0,0,.15.31.45.45,0,0,0,.32.15.43.43,0,0,0,.31-.15,4.67,4.67,0,0,0,.72-.92,6.58,6.58,0,0,0,.59-1.22,7.68,7.68,0,0,0,.39-1.45,8.56,8.56,0,0,0,.15-1.62,9.19,9.19,0,0,0-.14-1.58Zm9.59,1.43a.45.45,0,0,0-.14-.32.43.43,0,0,0-.32-.14h-1.74a.43.43,0,0,0-.34.14.49.49,0,0,0-.12.32.47.47,0,0,0,.12.31.41.41,0,0,0,.34.15h1.28v1.41a1.32,1.32,0,0,1-.11.53,1.71,1.71,0,0,1-.3.44,1.46,1.46,0,0,1-.44.29,1.19,1.19,0,0,1-.54.11h-.12a1.17,1.17,0,0,1-.53-.11,1.35,1.35,0,0,1-.44-.29,1.37,1.37,0,0,1-.41-1v-3.91a1.36,1.36,0,0,1,.11-.53,1.28,1.28,0,0,1,.3-.43,1.23,1.23,0,0,1,.44-.3,1.32,1.32,0,0,1,.53-.11h.12a1.26,1.26,0,0,1,.94.34,1.63,1.63,0,0,1,.45.85.46.46,0,0,0,.16.3.53.53,0,0,0,.3.09.48.48,0,0,0,.31-.12.4.4,0,0,0,.15-.33V572a2.3,2.3,0,0,0-.26-.79,2.61,2.61,0,0,0-.51-.63,2.58,2.58,0,0,0-.7-.41,2.36,2.36,0,0,0-.84-.15h-.12a2.25,2.25,0,0,0-.89.18,2.34,2.34,0,0,0-.73.49,2.49,2.49,0,0,0-.5.73,2.26,2.26,0,0,0-.18.9v3.91a2.27,2.27,0,0,0,.18.91,2.32,2.32,0,0,0,.5.72,2.18,2.18,0,0,0,.73.49,2.43,2.43,0,0,0,.89.17h.12a2.44,2.44,0,0,0,.9-.17,2.18,2.18,0,0,0,.73-.49,2.31,2.31,0,0,0,.68-1.63v-1.87Zm9.35.13a2.33,2.33,0,0,0-.16-.87,1.77,1.77,0,0,0-.43-.6,1.66,1.66,0,0,0-.62-.35,2.3,2.3,0,0,0-.74-.12h-.11a1.92,1.92,0,0,0-.84.19,2.06,2.06,0,0,0-.66.5,2.3,2.3,0,0,0-.66-.5,2,2,0,0,0-.85-.19h-.1a1.68,1.68,0,0,0-.6.1,1.13,1.13,0,0,0-.45.27.39.39,0,0,0-.17-.28.48.48,0,0,0-.27-.09.5.5,0,0,0-.33.12.42.42,0,0,0-.15.34v5.07a.37.37,0,0,0,.15.33.47.47,0,0,0,.31.11.48.48,0,0,0,.32-.11.37.37,0,0,0,.14-.33v-3.67a.83.83,0,0,1,.32-.68,1.12,1.12,0,0,1,.73-.26h.1a1,1,0,0,1,1.05,1v3.54a.43.43,0,0,0,.14.36.54.54,0,0,0,.32.11.53.53,0,0,0,.31-.11.43.43,0,0,0,.15-.36v-3.54a1,1,0,0,1,1-1h.11a1.08,1.08,0,0,1,.74.26,1,1,0,0,1,.29.76v3.59a.37.37,0,0,0,.14.33.48.48,0,0,0,.32.11.47.47,0,0,0,.31-.11.37.37,0,0,0,.15-.33V574.5Zm6.26,0a1.9,1.9,0,0,0-.15-.75,1.93,1.93,0,0,0-1-1,1.92,1.92,0,0,0-.77-.15h-.08a1.83,1.83,0,0,0-.61.11.88.88,0,0,0-.44.29v-2.47a.39.39,0,0,0-.15-.34.48.48,0,0,0-.31-.12.49.49,0,0,0-.32.12.39.39,0,0,0-.14.34v7.62a.36.36,0,0,0,.14.32.53.53,0,0,0,.32.1.6.6,0,0,0,.29-.08.37.37,0,0,0,.15-.27,1.14,1.14,0,0,0,.4.24,1.55,1.55,0,0,0,.65.11h.1a1.94,1.94,0,0,0,.76-.15,2.08,2.08,0,0,0,.63-.41,2.21,2.21,0,0,0,.42-.61,2,2,0,0,0,.16-.76v-2.09Zm-.92,2.08a1,1,0,0,1-.31.72,1,1,0,0,1-.74.3h-.1a1.07,1.07,0,0,1-.72-.25.84.84,0,0,1-.31-.7v-2.25a.81.81,0,0,1,.31-.67,1.08,1.08,0,0,1,.72-.26h.1a1,1,0,0,1,.74.31,1,1,0,0,1,.31.72v2.08Zm7.9-6.1a.39.39,0,0,0-.15-.34.47.47,0,0,0-.31-.12.51.51,0,0,0-.32.12.42.42,0,0,0-.14.34v3.2h-2.87v-3.2a.39.39,0,0,0-.15-.34.47.47,0,0,0-.31-.12.51.51,0,0,0-.32.12.42.42,0,0,0-.14.34v7.6a.39.39,0,0,0,.14.33.5.5,0,0,0,.32.11.45.45,0,0,0,.31-.11.37.37,0,0,0,.15-.33v-3.48h2.87v3.48a.4.4,0,0,0,.14.34.55.55,0,0,0,.32.1.5.5,0,0,0,.31-.1.38.38,0,0,0,.15-.34v-7.6Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_19),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M1041.47,556.94a.39.39,0,0,0-.34-.14,1.61,1.61,0,0,0-.63.12,1.49,1.49,0,0,0-.82.84,1.68,1.68,0,0,0-.12.63v1h-.27a.41.41,0,0,0-.35.15.53.53,0,0,0-.11.31.54.54,0,0,0,.11.32.41.41,0,0,0,.35.14h.27v4.57a.39.39,0,0,0,.14.34.54.54,0,0,0,.32.11.53.53,0,0,0,.31-.11.39.39,0,0,0,.15-.34v-4.57h.56a.41.41,0,0,0,.35-.14.49.49,0,0,0,.12-.32.53.53,0,0,0-.11-.31.42.42,0,0,0-.36-.15h-.56v-1a.67.67,0,0,1,.17-.47.57.57,0,0,1,.47-.2.39.39,0,0,0,.34-.15.48.48,0,0,0,.12-.31.49.49,0,0,0-.12-.32Zm5.39.32a.41.41,0,0,0-.15-.35.5.5,0,0,0-.32-.11.45.45,0,0,0-.31.11.44.44,0,0,0-.14.35v.26a.41.41,0,0,0,.15.35.51.51,0,0,0,.31.11.56.56,0,0,0,.32-.11.44.44,0,0,0,.14-.35v-.26Zm-2.23,0a.44.44,0,0,0-.14-.35.48.48,0,0,0-.32-.11.45.45,0,0,0-.31.11.41.41,0,0,0-.15.35v.26a.41.41,0,0,0,.15.35.51.51,0,0,0,.31.11.54.54,0,0,0,.32-.11.44.44,0,0,0,.14-.35v-.26Zm2.68,2.53a.41.41,0,0,0-.15-.35.51.51,0,0,0-.31-.11.56.56,0,0,0-.32.11.44.44,0,0,0-.14.35v3.56a1,1,0,0,1-1,1h-.11a1,1,0,0,1-.73-.3,1,1,0,0,1-.3-.73v-3.56a.41.41,0,0,0-.15-.35.51.51,0,0,0-.31-.11.56.56,0,0,0-.32.11.44.44,0,0,0-.14.35v3.57a2.08,2.08,0,0,0,.16.87,1.63,1.63,0,0,0,.42.6,1.66,1.66,0,0,0,.62.35,2.36,2.36,0,0,0,.75.12h.11a1.87,1.87,0,0,0,.59-.09,1.1,1.1,0,0,0,.45-.27.39.39,0,0,0,.17.27.5.5,0,0,0,.29.09.47.47,0,0,0,.31-.12.39.39,0,0,0,.15-.33v-5.06Zm5.16.13a1.18,1.18,0,0,0-.56-.45,1.72,1.72,0,0,0-.7-.14,2.25,2.25,0,0,0-.4,0l-.26.09a.53.53,0,0,0-.21.12.35.35,0,0,0-.17-.19.46.46,0,0,0-.23,0,.51.51,0,0,0-.32.12.41.41,0,0,0-.15.34v5a.4.4,0,0,0,.15.35.47.47,0,0,0,.31.12.51.51,0,0,0,.32-.12.42.42,0,0,0,.14-.35v-3.77a2.83,2.83,0,0,1,0-.29.68.68,0,0,1,.11-.26.62.62,0,0,1,.25-.19,1,1,0,0,1,.43-.07.62.62,0,0,1,.36.09l.2.16a.5.5,0,0,0,.38.17.45.45,0,0,0,.31-.12.4.4,0,0,0,.13-.31.54.54,0,0,0-.11-.32Zm6.91-2.66a.41.41,0,0,0-.15-.35.47.47,0,0,0-.31-.11.48.48,0,0,0-.32.11.44.44,0,0,0-.14.35v7.59a.42.42,0,0,0,.14.34.54.54,0,0,0,.32.11.53.53,0,0,0,.31-.11.39.39,0,0,0,.15-.34v-7.59Zm6.47,4a2.33,2.33,0,0,0-.16-.87,1.72,1.72,0,0,0-.43-.61,1.7,1.7,0,0,0-.61-.36,2.6,2.6,0,0,0-.74-.11h-.11a2,2,0,0,0-.6.09,1.27,1.27,0,0,0-.44.27.42.42,0,0,0-.17-.27.51.51,0,0,0-.62,0,.41.41,0,0,0-.15.34v5.06a.39.39,0,0,0,.15.34.53.53,0,0,0,.31.11.54.54,0,0,0,.32-.11.39.39,0,0,0,.14-.34v-3.57a1,1,0,0,1,.31-.74,1.05,1.05,0,0,1,.73-.29h.11a1,1,0,0,1,1,1v3.57a.39.39,0,0,0,.15.34.56.56,0,0,0,.32.11.49.49,0,0,0,.31-.11.39.39,0,0,0,.14-.34v-3.57Zm4.53,3.26a.42.42,0,0,0-.32-.16,1,1,0,0,1-.49-.2.61.61,0,0,1-.21-.49v-3.41h.65a.41.41,0,0,0,.35-.14.54.54,0,0,0,.11-.32.53.53,0,0,0-.11-.31.41.41,0,0,0-.35-.15h-.65v-2.1a.41.41,0,0,0-.15-.35.45.45,0,0,0-.31-.11.5.5,0,0,0-.32.11.44.44,0,0,0-.14.35v2.1H1068a.41.41,0,0,0-.34.15.48.48,0,0,0-.12.31.49.49,0,0,0,.12.32.4.4,0,0,0,.34.14h.43v3.43a1.63,1.63,0,0,0,.12.62,1.57,1.57,0,0,0,.34.51,1.52,1.52,0,0,0,.51.34,1.58,1.58,0,0,0,.61.12.44.44,0,0,0,.36-.14.53.53,0,0,0,.1-.32.47.47,0,0,0-.1-.3Zm5.8-3.25a2,2,0,0,0-.15-.78,1.93,1.93,0,0,0-.42-.63,2,2,0,0,0-.62-.41,2.14,2.14,0,0,0-.76-.14h-.12a1.94,1.94,0,0,0-.76.15,1.89,1.89,0,0,0-.62.42,1.79,1.79,0,0,0-.42.62,1.94,1.94,0,0,0-.15.76v2.08a1.91,1.91,0,0,0,.15.76,1.75,1.75,0,0,0,.42.61,1.89,1.89,0,0,0,.62.42,1.94,1.94,0,0,0,.76.15h.12a1.88,1.88,0,0,0,1.08-.32,1.92,1.92,0,0,0,.69-.83.46.46,0,0,0,0-.21.43.43,0,0,0-.15-.34.46.46,0,0,0-.33-.13.41.41,0,0,0-.23.07.42.42,0,0,0-.16.22,1.37,1.37,0,0,1-.36.44,1,1,0,0,1-.59.18h-.12a1,1,0,0,1-.73-.3,1,1,0,0,1-.3-.72v-.62h2.64a.42.42,0,0,0,.33-.14.44.44,0,0,0,.13-.32v-1Zm-.92.6h-2.18v-.61a1,1,0,0,1,.31-.73,1,1,0,0,1,.73-.3h.12a1,1,0,0,1,.71.3,1,1,0,0,1,.31.75v.59Zm5.89-2a1.25,1.25,0,0,0-.57-.45,1.7,1.7,0,0,0-.69-.14,2.1,2.1,0,0,0-.4,0l-.27.09a.53.53,0,0,0-.21.12.35.35,0,0,0-.17-.19.46.46,0,0,0-.23,0,.51.51,0,0,0-.32.12.41.41,0,0,0-.15.34v5a.4.4,0,0,0,.15.35.47.47,0,0,0,.31.12.49.49,0,0,0,.32-.12.42.42,0,0,0,.14-.35v-3.77a1.43,1.43,0,0,1,0-.29.47.47,0,0,1,.11-.26.52.52,0,0,1,.24-.19,1,1,0,0,1,.43-.07.6.6,0,0,1,.36.09,1.26,1.26,0,0,1,.2.16.5.5,0,0,0,.38.17.45.45,0,0,0,.31-.12.4.4,0,0,0,.13-.31.6.6,0,0,0-.1-.32Zm5.7,1.36a2.14,2.14,0,0,0-.16-.87,1.58,1.58,0,0,0-.42-.61,1.83,1.83,0,0,0-.62-.36,2.55,2.55,0,0,0-.74-.11h-.11a1.92,1.92,0,0,0-.59.09,1.23,1.23,0,0,0-.45.27.39.39,0,0,0-.17-.27.5.5,0,0,0-.29-.09.52.52,0,0,0-.33.12.43.43,0,0,0-.14.34v5.06a.42.42,0,0,0,.14.34.56.56,0,0,0,.32.11.51.51,0,0,0,.31-.11.39.39,0,0,0,.15-.34v-3.57a1,1,0,0,1,.31-.74,1,1,0,0,1,.73-.29h.1a1,1,0,0,1,.74.3,1,1,0,0,1,.3.73v3.57a.39.39,0,0,0,.15.34.52.52,0,0,0,.32.11.53.53,0,0,0,.31-.11.42.42,0,0,0,.14-.34v-3.57Zm6.52,3.28a.48.48,0,0,0-.29-.16.36.36,0,0,1-.32-.4v-2.81a1.89,1.89,0,0,0-.14-.72,1.91,1.91,0,0,0-.4-.6,1.85,1.85,0,0,0-.61-.4,2,2,0,0,0-.75-.14h-.08a2.12,2.12,0,0,0-.5,0,2.3,2.3,0,0,0-.5.18,1.83,1.83,0,0,0-.45.35,2,2,0,0,0-.36.54.48.48,0,0,0,0,.22.37.37,0,0,0,.15.31.48.48,0,0,0,.31.12.46.46,0,0,0,.23-.06.37.37,0,0,0,.18-.19,1.47,1.47,0,0,1,.39-.45,1.07,1.07,0,0,1,.6-.15h.08a1.08,1.08,0,0,1,.69.22.9.9,0,0,1,.29.76v.11l0,.09a.56.56,0,0,1-.34.16l-.6.11c-.22,0-.46.09-.71.16a2.63,2.63,0,0,0-.69.28,1.55,1.55,0,0,0-.52.5,1.38,1.38,0,0,0-.21.78v.15a1.6,1.6,0,0,0,.61,1.29,1.73,1.73,0,0,0,.63.33,2.45,2.45,0,0,0,.71.11h.11a2,2,0,0,0,1.31-.47,1.08,1.08,0,0,0,.31.29,1.52,1.52,0,0,0,.51.17h.09a.42.42,0,0,0,.33-.14.46.46,0,0,0,.11-.32.49.49,0,0,0-.09-.28Zm-1.53-1.21a1,1,0,0,1-.31.73,1,1,0,0,1-.73.3h-.11a1.15,1.15,0,0,1-.74-.23.77.77,0,0,1-.29-.62v-.1a.57.57,0,0,1,.21-.48,1.7,1.7,0,0,1,.54-.27,6.81,6.81,0,0,1,.71-.15,6.57,6.57,0,0,0,.72-.14v1Zm5.64,1.19a.43.43,0,0,0-.32-.16.93.93,0,0,1-.49-.2.59.59,0,0,1-.22-.49v-3.41h.66a.39.39,0,0,0,.34-.14.49.49,0,0,0,.12-.32.48.48,0,0,0-.12-.31.39.39,0,0,0-.34-.15h-.66v-2.1a.44.44,0,0,0-.14-.35.48.48,0,0,0-.32-.11.47.47,0,0,0-.31.11.41.41,0,0,0-.15.35v2.1h-.42a.43.43,0,0,0-.35.15.53.53,0,0,0-.11.31.54.54,0,0,0,.11.32.42.42,0,0,0,.35.14h.42v3.43a1.63,1.63,0,0,0,.12.62,1.56,1.56,0,0,0,.85.85,1.63,1.63,0,0,0,.62.12.42.42,0,0,0,.35-.14.54.54,0,0,0,.11-.32.47.47,0,0,0-.1-.3Zm3-7.28a.41.41,0,0,0-.15-.35.45.45,0,0,0-.31-.11.48.48,0,0,0-.32.11.44.44,0,0,0-.14.35v.26a.44.44,0,0,0,.14.35.54.54,0,0,0,.32.11.51.51,0,0,0,.31-.11.41.41,0,0,0,.15-.35v-.26Zm0,2.53a.41.41,0,0,0-.15-.35.51.51,0,0,0-.31-.11.54.54,0,0,0-.32.11.44.44,0,0,0-.14.35v5.06a.42.42,0,0,0,.14.34.54.54,0,0,0,.32.11.51.51,0,0,0,.31-.11.39.39,0,0,0,.15-.34v-5.06Zm6.18,1.49a1.78,1.78,0,0,0-.15-.76,1.94,1.94,0,0,0-1.79-1.19h-.13a1.92,1.92,0,0,0-1.79,1.19,1.79,1.79,0,0,0-.16.76v2.08a1.76,1.76,0,0,0,.16.76,1.87,1.87,0,0,0,.41.61,2,2,0,0,0,1.38.57h.13a2,2,0,0,0,1.38-.57,1.87,1.87,0,0,0,.41-.61,1.75,1.75,0,0,0,.15-.76v-2.08Zm-.92,2.07a1,1,0,0,1-.3.73,1,1,0,0,1-.72.3h-.11a1,1,0,0,1-.74-.3,1,1,0,0,1-.31-.73v-2.08a1,1,0,0,1,.31-.72,1,1,0,0,1,.72-.3h.13a1,1,0,0,1,1,1v2.08Zm7-2.07a2.14,2.14,0,0,0-.16-.87,1.66,1.66,0,0,0-1-1,2.55,2.55,0,0,0-.74-.11h-.11a1.87,1.87,0,0,0-.59.09,1.23,1.23,0,0,0-.45.27.39.39,0,0,0-.17-.27.5.5,0,0,0-.29-.09.52.52,0,0,0-.33.12.43.43,0,0,0-.14.34v5.06a.42.42,0,0,0,.14.34.54.54,0,0,0,.32.11.51.51,0,0,0,.31-.11.39.39,0,0,0,.15-.34v-3.57a1,1,0,0,1,.31-.74,1,1,0,0,1,.72-.29h.11a1,1,0,0,1,.74.3,1,1,0,0,1,.3.73v3.57a.42.42,0,0,0,.14.34.56.56,0,0,0,.32.11.54.54,0,0,0,.32-.11.42.42,0,0,0,.14-.34v-3.57Zm6.52,3.28a.48.48,0,0,0-.3-.16.36.36,0,0,1-.31-.4v-2.81a1.72,1.72,0,0,0-.15-.72,1.75,1.75,0,0,0-.4-.6,1.8,1.8,0,0,0-.6-.4,2.08,2.08,0,0,0-.75-.14h-.09a2.09,2.09,0,0,0-.49,0,2.3,2.3,0,0,0-.5.18,1.83,1.83,0,0,0-.45.35,2,2,0,0,0-.36.54.48.48,0,0,0-.05.22.37.37,0,0,0,.15.31.46.46,0,0,0,.54.06.47.47,0,0,0,.18-.19,1.35,1.35,0,0,1,.39-.45,1,1,0,0,1,.59-.15h.09a1.12,1.12,0,0,1,.69.22.9.9,0,0,1,.29.76.45.45,0,0,1,0,.11.12.12,0,0,1,0,.09.56.56,0,0,1-.33.16l-.6.11c-.22,0-.46.09-.71.16a2.63,2.63,0,0,0-.69.28,1.69,1.69,0,0,0-.53.5,1.46,1.46,0,0,0-.2.78v.15a1.6,1.6,0,0,0,.61,1.29,1.76,1.76,0,0,0,.62.33,2.57,2.57,0,0,0,.72.11h.11a2,2,0,0,0,1.31-.47,1.08,1.08,0,0,0,.31.29,1.52,1.52,0,0,0,.51.17h.08a.43.43,0,0,0,.34-.14.52.52,0,0,0,.11-.32.49.49,0,0,0-.09-.28Zm-1.53-1.21a1,1,0,0,1-.31.73,1,1,0,0,1-.73.3h-.11a1.2,1.2,0,0,1-.75-.23.76.76,0,0,1-.28-.62v-.1a.57.57,0,0,1,.21-.48,1.7,1.7,0,0,1,.54-.27,6.3,6.3,0,0,1,.71-.15c.25,0,.49-.08.72-.14v1Zm5.4,1.17a.44.44,0,0,0-.36-.14.7.7,0,0,1-.47-.21.63.63,0,0,1-.19-.47v-6.44a.41.41,0,0,0-.15-.35.45.45,0,0,0-.31-.11.5.5,0,0,0-.32.11.44.44,0,0,0-.14.35v6.45a1.63,1.63,0,0,0,.12.62,1.57,1.57,0,0,0,.34.51,1.52,1.52,0,0,0,.51.34,1.58,1.58,0,0,0,.61.12.44.44,0,0,0,.36-.14.53.53,0,0,0,.1-.32.55.55,0,0,0-.1-.32Zm5.79-3.23a2,2,0,0,0-.15-.78,1.82,1.82,0,0,0-1-1,2.12,2.12,0,0,0-.75-.14h-.13a1.9,1.9,0,0,0-.75.15,1.93,1.93,0,0,0-.63.42,1.77,1.77,0,0,0-.41.62,1.79,1.79,0,0,0-.16.76v2.08a1.76,1.76,0,0,0,.16.76,1.73,1.73,0,0,0,.41.61,1.93,1.93,0,0,0,.63.42,1.9,1.9,0,0,0,.75.15h.13a1.88,1.88,0,0,0,1.08-.32,1.83,1.83,0,0,0,.68-.83.36.36,0,0,0,0-.21.46.46,0,0,0-.14-.34.48.48,0,0,0-.33-.13.39.39,0,0,0-.23.07.44.44,0,0,0-.17.22,1.25,1.25,0,0,1-.36.44.91.91,0,0,1-.58.18h-.13a1,1,0,0,1-1-1v-.62h2.64a.42.42,0,0,0,.33-.14.44.44,0,0,0,.13-.32v-1Zm-.92.6h-2.18v-.61a1,1,0,0,1,.31-.73,1,1,0,0,1,.74-.3h.12a1,1,0,0,1,1,1v.59Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_20),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M1044.09,545.92a2.25,2.25,0,0,0-.18-.89,2.29,2.29,0,0,0-.49-.73,2.62,2.62,0,0,0-.72-.49,2.25,2.25,0,0,0-.89-.18h-2a.48.48,0,0,0-.46.46v7.45a.45.45,0,0,0,.14.32.43.43,0,0,0,.32.14h2a2.25,2.25,0,0,0,1.61-.67,2.3,2.3,0,0,0,.67-1.63v-3.78Zm-.92,3.78a1.4,1.4,0,0,1-.1.54,1.71,1.71,0,0,1-.3.44,1.37,1.37,0,0,1-1,.4h-1.5v-6.53h1.51a1.41,1.41,0,0,1,.54.11,1.28,1.28,0,0,1,.43.3,1.62,1.62,0,0,1,.29.43,1.4,1.4,0,0,1,.1.54v3.77Zm7.08-1.65a2,2,0,0,0-.15-.78,2.26,2.26,0,0,0-.42-.62,1.76,1.76,0,0,0-.63-.41,1.9,1.9,0,0,0-.75-.15h-.12a1.94,1.94,0,0,0-.76.15,1.79,1.79,0,0,0-.62.42,1.91,1.91,0,0,0-.57,1.38v2.08a2,2,0,0,0,.15.77,1.85,1.85,0,0,0,.42.61,1.92,1.92,0,0,0,.62.41,1.94,1.94,0,0,0,.76.15h.12a1.81,1.81,0,0,0,1.08-.32,1.83,1.83,0,0,0,.68-.83.31.31,0,0,0,0-.2.46.46,0,0,0-.14-.34.49.49,0,0,0-.33-.14.48.48,0,0,0-.23.07.44.44,0,0,0-.17.22,1.17,1.17,0,0,1-.36.44.91.91,0,0,1-.58.18h-.12a1,1,0,0,1-1-1v-.61h2.64a.43.43,0,0,0,.32-.14.47.47,0,0,0,.14-.32v-1Zm-.92.61h-2.18v-.61a1,1,0,0,1,.31-.74,1,1,0,0,1,.73-.3h.12a1,1,0,0,1,.71.3,1,1,0,0,1,.31.75v.6Zm6.87-2.11a.39.39,0,0,0-.14-.34.49.49,0,0,0-.32-.12.48.48,0,0,0-.31.12.39.39,0,0,0-.15.34v3.56a1,1,0,0,1-.3.73,1,1,0,0,1-.74.3h-.11a1,1,0,0,1-.72-.3,1,1,0,0,1-.31-.73v-3.56a.42.42,0,0,0-.14-.34.49.49,0,0,0-.32-.12.48.48,0,0,0-.31.12.39.39,0,0,0-.15.34v3.57a2.34,2.34,0,0,0,.16.88,1.9,1.9,0,0,0,.42.6,1.93,1.93,0,0,0,.63.35,2.6,2.6,0,0,0,.74.11h.11a2,2,0,0,0,.6-.09,1.12,1.12,0,0,0,.44-.26.42.42,0,0,0,.17.27.6.6,0,0,0,.29.08.54.54,0,0,0,.32-.11.4.4,0,0,0,.14-.34v-5.06Zm4.7,4.75a.45.45,0,0,0-.32-.16.8.8,0,0,1-.49-.2.59.59,0,0,1-.21-.49v-3.4h.65a.41.41,0,0,0,.35-.15.51.51,0,0,0,.11-.31.54.54,0,0,0-.11-.32.44.44,0,0,0-.35-.14h-.65V544a.39.39,0,0,0-.15-.34.47.47,0,0,0-.31-.12.49.49,0,0,0-.32.12.42.42,0,0,0-.14.34v2.11h-.43a.43.43,0,0,0-.34.14.49.49,0,0,0-.12.32.47.47,0,0,0,.12.31.41.41,0,0,0,.34.15h.43v3.43a1.58,1.58,0,0,0,.12.61,1.56,1.56,0,0,0,.85.85,1.58,1.58,0,0,0,.61.12.42.42,0,0,0,.36-.14.5.5,0,0,0,.1-.31.48.48,0,0,0-.1-.31Zm6-1a1.68,1.68,0,0,0-.23-.93,1.72,1.72,0,0,0-.59-.52,2.7,2.7,0,0,0-.75-.28l-.76-.18a2.07,2.07,0,0,1-.58-.24.53.53,0,0,1-.24-.47v0a.58.58,0,0,1,.28-.45,1.32,1.32,0,0,1,.78-.2h0a1.45,1.45,0,0,1,.65.12l.42.21a.6.6,0,0,0,.27.07.39.39,0,0,0,.31-.13.45.45,0,0,0,.12-.31.41.41,0,0,0-.17-.35l-.21-.15a1.79,1.79,0,0,0-.34-.18,3.18,3.18,0,0,0-.46-.14,2.49,2.49,0,0,0-.57-.06h0a3,3,0,0,0-.64.08,2.1,2.1,0,0,0-.64.26,1.53,1.53,0,0,0-.5.48,1.21,1.21,0,0,0-.21.73,1.37,1.37,0,0,0,.24.87,1.58,1.58,0,0,0,.58.48,3,3,0,0,0,.76.25,5.13,5.13,0,0,1,.75.19,1.75,1.75,0,0,1,.58.29.7.7,0,0,1,.24.58v0a.79.79,0,0,1-.31.56,1.27,1.27,0,0,1-.85.25h-.06a1.19,1.19,0,0,1-.69-.23,2.12,2.12,0,0,1-.58-.53.42.42,0,0,0-.2-.16.54.54,0,0,0-.22-.05.47.47,0,0,0-.32.12.4.4,0,0,0-.15.33,1.07,1.07,0,0,0,.06.23,1.89,1.89,0,0,0,.38.51,2.42,2.42,0,0,0,.51.38,3,3,0,0,0,.58.24,2.61,2.61,0,0,0,.6.08h.08a2.43,2.43,0,0,0,.75-.11,2.36,2.36,0,0,0,.68-.32,1.59,1.59,0,0,0,.48-.52,1.47,1.47,0,0,0,.18-.74v0Zm5.73-.56a.46.46,0,0,0-.62,0,.46.46,0,0,0-.15.35,1.09,1.09,0,0,1-.32.73.94.94,0,0,1-.71.3h-.11a1,1,0,0,1-.74-.3,1,1,0,0,1-.3-.72V548a1,1,0,0,1,.3-.73,1,1,0,0,1,.73-.3h.12a1,1,0,0,1,.71.29,1.12,1.12,0,0,1,.32.75.44.44,0,0,0,.15.34.45.45,0,0,0,.31.11.51.51,0,0,0,.31-.11.41.41,0,0,0,.15-.35,1.79,1.79,0,0,0-.16-.76,2,2,0,0,0-.42-.62,1.85,1.85,0,0,0-.61-.42,1.94,1.94,0,0,0-.76-.15h-.12a1.94,1.94,0,0,0-.76.15,1.86,1.86,0,0,0-1,1,1.83,1.83,0,0,0-.16.77v2.08a2,2,0,0,0,.15.77,1.85,1.85,0,0,0,.42.61,2,2,0,0,0,.62.41,1.94,1.94,0,0,0,.76.15h.12a1.94,1.94,0,0,0,.76-.15,2,2,0,0,0,.62-.42,1.85,1.85,0,0,0,.42-.61,2,2,0,0,0,.15-.77.4.4,0,0,0-.15-.35Zm6.23-1.72a2,2,0,0,0-.16-.76,2.16,2.16,0,0,0-.41-.62,2,2,0,0,0-1.38-.57h-.1a1.81,1.81,0,0,0-.61.1,1,1,0,0,0-.44.26V544a.39.39,0,0,0-.15-.34.49.49,0,0,0-.32-.12.48.48,0,0,0-.31.12.39.39,0,0,0-.15.34v7.59a.38.38,0,0,0,.15.34.47.47,0,0,0,.31.11.48.48,0,0,0,.32-.11.38.38,0,0,0,.15-.34V548a.91.91,0,0,1,.09-.41,1.1,1.1,0,0,1,.25-.31,1.08,1.08,0,0,1,.35-.19,1.4,1.4,0,0,1,.41-.06,1.21,1.21,0,0,1,.38.06,1.24,1.24,0,0,1,.36.19.87.87,0,0,1,.24.32,1.08,1.08,0,0,1,.1.46v3.57a.38.38,0,0,0,.14.34.48.48,0,0,0,.32.11.47.47,0,0,0,.31-.11.38.38,0,0,0,.15-.34V548Zm6,0a2,2,0,0,0-.15-.78,1.89,1.89,0,0,0-.42-.62,1.81,1.81,0,0,0-.62-.41,1.94,1.94,0,0,0-.76-.15h-.12a1.94,1.94,0,0,0-.76.15,1.79,1.79,0,0,0-.62.42,1.91,1.91,0,0,0-.57,1.38v2.08a2,2,0,0,0,.15.77,1.85,1.85,0,0,0,.42.61,1.92,1.92,0,0,0,.62.41,1.94,1.94,0,0,0,.76.15h.12a1.81,1.81,0,0,0,1.08-.32,1.92,1.92,0,0,0,.69-.83.39.39,0,0,0,0-.2.43.43,0,0,0-.15-.34.49.49,0,0,0-.33-.14.51.51,0,0,0-.23.07.44.44,0,0,0-.17.22,1.24,1.24,0,0,1-.35.44,1,1,0,0,1-.59.18h-.12a1,1,0,0,1-.73-.3,1,1,0,0,1-.3-.72v-.61h2.64a.45.45,0,0,0,.33-.14.5.5,0,0,0,.13-.32v-1Zm-.92.61h-2.18v-.61a1,1,0,0,1,.31-.74,1,1,0,0,1,.73-.3h.12a1,1,0,0,1,1,1v.6Zm11.64-.76a.47.47,0,0,0-.14-.33.45.45,0,0,0-.32-.13h-1.74a.4.4,0,0,0-.34.14.49.49,0,0,0-.12.32.48.48,0,0,0,.12.31.41.41,0,0,0,.34.15h1.28v1.41a1.32,1.32,0,0,1-.11.53,1.49,1.49,0,0,1-.3.44,1.35,1.35,0,0,1-.44.29,1.17,1.17,0,0,1-.53.11h-.13a1.17,1.17,0,0,1-.53-.11,1.35,1.35,0,0,1-.44-.29,1.49,1.49,0,0,1-.3-.44,1.33,1.33,0,0,1-.11-.54v-3.91a1.36,1.36,0,0,1,.11-.53,1.45,1.45,0,0,1,.3-.43,1.23,1.23,0,0,1,.44-.3,1.32,1.32,0,0,1,.53-.11h.13a1.25,1.25,0,0,1,.93.34,1.63,1.63,0,0,1,.45.85.41.41,0,0,0,.17.29.43.43,0,0,0,.29.1.48.48,0,0,0,.31-.12.4.4,0,0,0,.15-.33v-.08a2.32,2.32,0,0,0-.26-.78,2.61,2.61,0,0,0-.51-.63,2.58,2.58,0,0,0-.7-.41,2.34,2.34,0,0,0-.83-.15h-.13a2.25,2.25,0,0,0-.89.18,2.34,2.34,0,0,0-.73.49,2.49,2.49,0,0,0-.5.73,2.26,2.26,0,0,0-.18.9v3.91a2.27,2.27,0,0,0,.18.91,2.44,2.44,0,0,0,.5.72,2.18,2.18,0,0,0,.73.49,2.43,2.43,0,0,0,.89.17h.13a2.43,2.43,0,0,0,.89-.17,2.18,2.18,0,0,0,.73-.49,2.44,2.44,0,0,0,.5-.72,2.27,2.27,0,0,0,.18-.91V547.9Zm6.14.15a2,2,0,0,0-.15-.78,1.89,1.89,0,0,0-.42-.62,1.64,1.64,0,0,0-.62-.41,1.94,1.94,0,0,0-.76-.15h-.12a1.9,1.9,0,0,0-.75.15,1.93,1.93,0,0,0-.63.42,1.91,1.91,0,0,0-.57,1.38v2.08a2,2,0,0,0,.15.77,1.85,1.85,0,0,0,.42.61,2.08,2.08,0,0,0,.63.41,1.9,1.9,0,0,0,.75.15h.12a1.84,1.84,0,0,0,1.09-.32,1.9,1.9,0,0,0,.68-.83.39.39,0,0,0,0-.2.43.43,0,0,0-.15-.34.45.45,0,0,0-.32-.14.48.48,0,0,0-.23.07.39.39,0,0,0-.17.22,1.17,1.17,0,0,1-.36.44.94.94,0,0,1-.59.18h-.12a1,1,0,0,1-.72-.3,1,1,0,0,1-.31-.72v-.61h2.64a.46.46,0,0,0,.46-.46v-1Zm-.92.61h-2.18v-.61a1,1,0,0,1,1-1h.13a1,1,0,0,1,.7.3,1,1,0,0,1,.31.75v.6Zm7,1.66a1.5,1.5,0,0,0-.82-1.45,2.7,2.7,0,0,0-.75-.28l-.76-.18a2,2,0,0,1-.58-.24.53.53,0,0,1-.24-.47v0a.58.58,0,0,1,.28-.45,1.31,1.31,0,0,1,.77-.2h0a1.37,1.37,0,0,1,.64.12l.43.21a.56.56,0,0,0,.26.07.41.41,0,0,0,.32-.13.45.45,0,0,0,.12-.31.44.44,0,0,0-.17-.35l-.21-.15a1.79,1.79,0,0,0-.34-.18,3.63,3.63,0,0,0-.46-.14,2.56,2.56,0,0,0-.57-.06h0a3,3,0,0,0-.64.08,2.1,2.1,0,0,0-.64.26,1.53,1.53,0,0,0-.5.48,1.21,1.21,0,0,0-.21.73,1.37,1.37,0,0,0,.24.87,1.5,1.5,0,0,0,.58.48,3,3,0,0,0,.75.25,5,5,0,0,1,.76.19,1.85,1.85,0,0,1,.58.29.7.7,0,0,1,.24.58v0a.79.79,0,0,1-.31.56,1.27,1.27,0,0,1-.85.25h-.06a1.19,1.19,0,0,1-.69-.23,2.33,2.33,0,0,1-.59-.53.36.36,0,0,0-.19-.16.54.54,0,0,0-.22-.05.47.47,0,0,0-.32.12.4.4,0,0,0-.15.33,1.07,1.07,0,0,0,.06.23,1.89,1.89,0,0,0,.38.51,2.64,2.64,0,0,0,.5.38,3.32,3.32,0,0,0,.59.24,2.61,2.61,0,0,0,.6.08h.07a2.54,2.54,0,0,0,.76-.11,2.3,2.3,0,0,0,.67-.32,1.62,1.62,0,0,0,.49-.52,1.47,1.47,0,0,0,.18-.74v0Zm5.87-2.27a2,2,0,0,0-.15-.78,1.89,1.89,0,0,0-.42-.62,1.72,1.72,0,0,0-.62-.41,1.94,1.94,0,0,0-.76-.15h-.12a1.94,1.94,0,0,0-.76.15,1.94,1.94,0,0,0-1.19,1.8v2.08a2,2,0,0,0,.15.77,1.85,1.85,0,0,0,.42.61,2.16,2.16,0,0,0,.62.41,1.94,1.94,0,0,0,.76.15h.12a1.84,1.84,0,0,0,1.09-.32,1.9,1.9,0,0,0,.68-.83.39.39,0,0,0,0-.2.43.43,0,0,0-.15-.34.43.43,0,0,0-.55-.07.39.39,0,0,0-.17.22,1.17,1.17,0,0,1-.36.44.94.94,0,0,1-.59.18h-.12a1,1,0,0,1-.73-.3,1,1,0,0,1-.3-.72v-.61h2.64a.46.46,0,0,0,.46-.46v-1Zm-.92.61h-2.18v-.61a1,1,0,0,1,1-1h.12a1,1,0,0,1,.71.3,1,1,0,0,1,.31.75v.6Zm4.92,2.63a.4.4,0,0,0-.35-.15.67.67,0,0,1-.47-.2.66.66,0,0,1-.2-.48V544a.42.42,0,0,0-.14-.34.49.49,0,0,0-.32-.12.47.47,0,0,0-.31.12.39.39,0,0,0-.15.34v6.46a1.58,1.58,0,0,0,.12.61,1.52,1.52,0,0,0,.34.51,1.57,1.57,0,0,0,.51.34,1.63,1.63,0,0,0,.62.12.4.4,0,0,0,.35-.14.51.51,0,0,0,.11-.31.54.54,0,0,0-.11-.32Zm3.8,0a.4.4,0,0,0-.35-.15.69.69,0,0,1-.47-.2.65.65,0,0,1-.19-.48V544a.39.39,0,0,0-.15-.34.48.48,0,0,0-.31-.12.49.49,0,0,0-.32.12.39.39,0,0,0-.14.34v6.46a1.58,1.58,0,0,0,.12.61,1.39,1.39,0,0,0,.34.51,1.43,1.43,0,0,0,.5.34,1.63,1.63,0,0,0,.62.12.4.4,0,0,0,.35-.14.45.45,0,0,0,.11-.31.48.48,0,0,0-.11-.32Zm6-1a1.6,1.6,0,0,0-.24-.93,1.69,1.69,0,0,0-.58-.52,2.76,2.76,0,0,0-.76-.28l-.76-.18a2.07,2.07,0,0,1-.58-.24.54.54,0,0,1-.23-.47v0a.55.55,0,0,1,.28-.45,1.26,1.26,0,0,1,.77-.2h0a1.4,1.4,0,0,1,.64.12l.42.21a.6.6,0,0,0,.27.07.42.42,0,0,0,.32-.13.45.45,0,0,0,.12-.31.44.44,0,0,0-.17-.35l-.22-.15a1.69,1.69,0,0,0-.33-.18,4.21,4.21,0,0,0-.46-.14,2.65,2.65,0,0,0-.58-.06h0a3,3,0,0,0-.63.08,2.16,2.16,0,0,0-.65.26,1.75,1.75,0,0,0-.5.48,1.21,1.21,0,0,0-.2.73,1.37,1.37,0,0,0,.23.87,1.58,1.58,0,0,0,.58.48,3.08,3.08,0,0,0,.76.25,5.27,5.27,0,0,1,.76.19,1.85,1.85,0,0,1,.58.29.7.7,0,0,1,.24.58v0a.82.82,0,0,1-.31.56,1.3,1.3,0,0,1-.86.25h-.06a1.23,1.23,0,0,1-.69-.23,2.28,2.28,0,0,1-.58-.53.4.4,0,0,0-.19-.16.63.63,0,0,0-.22-.05.52.52,0,0,0-.33.12.39.39,0,0,0-.14.33,1.07,1.07,0,0,0,.06.23,1.85,1.85,0,0,0,.37.51,2.42,2.42,0,0,0,.51.38,3,3,0,0,0,.59.24,2.47,2.47,0,0,0,.6.08h.07a2.43,2.43,0,0,0,.75-.11,2.24,2.24,0,0,0,.68-.32,1.59,1.59,0,0,0,.48-.52,1.38,1.38,0,0,0,.19-.74v0Zm5.73-.56a.49.49,0,0,0-.32-.12.48.48,0,0,0-.31.12.46.46,0,0,0-.15.35,1.08,1.08,0,0,1-.31.73,1,1,0,0,1-.72.3h-.11a1,1,0,0,1-.73-.3,1,1,0,0,1-.31-.72V548a1,1,0,0,1,1-1h.12a1,1,0,0,1,.72.29,1.11,1.11,0,0,1,.31.75.44.44,0,0,0,.15.34.47.47,0,0,0,.31.11.54.54,0,0,0,.32-.11.44.44,0,0,0,.14-.35,1.94,1.94,0,0,0-.15-.76,2.42,2.42,0,0,0-.42-.62,1.89,1.89,0,0,0-.62-.42,1.94,1.94,0,0,0-.76-.15h-.12a1.9,1.9,0,0,0-.75.15,1.92,1.92,0,0,0-.62.41,2.06,2.06,0,0,0-.42.62,2,2,0,0,0-.16.77v2.08a2,2,0,0,0,.15.77,2,2,0,0,0,.42.61,2.08,2.08,0,0,0,.63.41,1.9,1.9,0,0,0,.75.15h.12a1.94,1.94,0,0,0,.76-.15,1.79,1.79,0,0,0,.62-.42,1.85,1.85,0,0,0,.42-.61,2,2,0,0,0,.15-.77.42.42,0,0,0-.14-.35Zm6.1-1.72a1.94,1.94,0,0,0-.15-.76,2,2,0,0,0-.42-.62,1.79,1.79,0,0,0-.62-.42,1.94,1.94,0,0,0-.76-.15h-.09a1.77,1.77,0,0,0-.61.1,1.09,1.09,0,0,0-.45.26V544a.42.42,0,0,0-.14-.34.49.49,0,0,0-.32-.12.47.47,0,0,0-.31.12.39.39,0,0,0-.15.34v7.59a.38.38,0,0,0,.15.34.45.45,0,0,0,.31.11.48.48,0,0,0,.32-.11.4.4,0,0,0,.14-.34V548a.8.8,0,0,1,.1-.41,1,1,0,0,1,.25-.31,1.08,1.08,0,0,1,.35-.19,1.39,1.39,0,0,1,.4-.06,1.32,1.32,0,0,1,.39.06,1.08,1.08,0,0,1,.35.19.8.8,0,0,1,.25.32,1.08,1.08,0,0,1,.09.46v3.57a.38.38,0,0,0,.15.34.45.45,0,0,0,.31.11.48.48,0,0,0,.32-.11.4.4,0,0,0,.14-.34V548Zm6.5,3.29a.4.4,0,0,0-.3-.16.36.36,0,0,1-.31-.4V548a1.8,1.8,0,0,0-.15-.73,1.71,1.71,0,0,0-.4-.59,1.75,1.75,0,0,0-.6-.4,1.93,1.93,0,0,0-.75-.15h-.09a2.2,2.2,0,0,0-.5.06,1.62,1.62,0,0,0-.49.18,1.82,1.82,0,0,0-.46.34,1.79,1.79,0,0,0-.35.55.36.36,0,0,0,0,.22.37.37,0,0,0,.14.3.49.49,0,0,0,.32.12.59.59,0,0,0,.23-.05.47.47,0,0,0,.18-.19,1.29,1.29,0,0,1,.39-.46,1,1,0,0,1,.59-.15h.09a1.12,1.12,0,0,1,.69.22.91.91,0,0,1,.29.76s0,.07,0,.11a.17.17,0,0,1,0,.1.63.63,0,0,1-.33.15l-.6.12-.72.15a2.65,2.65,0,0,0-.69.29,1.62,1.62,0,0,0-.52.49,1.37,1.37,0,0,0-.2.78v.15a1.54,1.54,0,0,0,.17.75,1.7,1.7,0,0,0,.44.55,1.92,1.92,0,0,0,.62.32,2.21,2.21,0,0,0,.72.11h.11a1.94,1.94,0,0,0,1.3-.47,1.12,1.12,0,0,0,.32.29,1.33,1.33,0,0,0,.51.17h.08a.37.37,0,0,0,.33-.14.47.47,0,0,0,.12-.32.46.46,0,0,0-.09-.27Zm-1.53-1.22a1,1,0,0,1-.31.74,1.05,1.05,0,0,1-.73.29H1143a1.12,1.12,0,0,1-.75-.23.75.75,0,0,1-.28-.62v-.09a.61.61,0,0,1,.21-.49,1.51,1.51,0,0,1,.54-.26,3.71,3.71,0,0,1,.71-.15l.72-.14v1Zm5.59-6.4a.41.41,0,0,0-.35-.15,1.59,1.59,0,0,0-.62.12,1.56,1.56,0,0,0-.5.33,1.72,1.72,0,0,0-.33.51,1.91,1.91,0,0,0-.11.64v1h-.27a.43.43,0,0,0-.34.14.49.49,0,0,0-.12.32.47.47,0,0,0,.12.31.41.41,0,0,0,.34.15h.27v4.56a.38.38,0,0,0,.15.34.45.45,0,0,0,.31.11.5.5,0,0,0,.32-.11.4.4,0,0,0,.14-.34v-4.56h.57a.39.39,0,0,0,.34-.15.47.47,0,0,0,.12-.31.54.54,0,0,0-.11-.32.42.42,0,0,0-.35-.14h-.57v-1a.68.68,0,0,1,.18-.48.58.58,0,0,1,.46-.2.44.44,0,0,0,.35-.14.5.5,0,0,0,.11-.32.51.51,0,0,0-.11-.31Zm4,7.59a.47.47,0,0,0-.32-.16.8.8,0,0,1-.49-.2.59.59,0,0,1-.21-.49v-3.4h.65a.43.43,0,0,0,.35-.15.51.51,0,0,0,.11-.31.54.54,0,0,0-.11-.32.45.45,0,0,0-.35-.14h-.65V544a.39.39,0,0,0-.15-.34.48.48,0,0,0-.31-.12.49.49,0,0,0-.32.12.42.42,0,0,0-.14.34v2.11h-.43a.42.42,0,0,0-.34.14.49.49,0,0,0-.12.32.47.47,0,0,0,.12.31.39.39,0,0,0,.34.15h.43v3.43a1.58,1.58,0,0,0,.12.61,1.56,1.56,0,0,0,.85.85,1.58,1.58,0,0,0,.61.12.4.4,0,0,0,.35-.14.45.45,0,0,0,.11-.31.48.48,0,0,0-.1-.31Z",
            transform: "translate(-952.83 -532.94)",
            fill: $props.color?$props.color:'#d93337',
            "fill-rule": "evenodd"
          }, null, 8, _hoisted_21)
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.logo === 'aace')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("img", _hoisted_22))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
    ($props.logo === '100bridges')
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", _hoisted_23, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M368.82,297.13a19.15,19.15,0,0,0,4.69-2.29,13.45,13.45,0,0,0,3.2-3,11.52,11.52,0,0,0,1.84-3.54,13.15,13.15,0,0,0,.59-3.92,16.81,16.81,0,0,0-1.21-6.58,12.31,12.31,0,0,0-3.93-5,19.63,19.63,0,0,0-6.9-3.18,40.58,40.58,0,0,0-10.23-1.12h-21.1v59.4h23a30.35,30.35,0,0,0,9.36-1.32,19.67,19.67,0,0,0,6.86-3.7,16.38,16.38,0,0,0,4.26-5.61,16.72,16.72,0,0,0,1.43-7,12,12,0,0,0-2.9-8.4C375.88,299.64,372.87,298.09,368.82,297.13Zm-20.75-19.35h8.8a20.53,20.53,0,0,1,4.48.4,7.64,7.64,0,0,1,3.1,1.39,5.54,5.54,0,0,1,1.82,2.5,10.48,10.48,0,0,1,.61,3.77,8.85,8.85,0,0,1-.73,3.69,6.48,6.48,0,0,1-2.07,2.5,9.59,9.59,0,0,1-3.37,1.35,21.81,21.81,0,0,1-4.58.43h-8.06Zm20,35.3a7.09,7.09,0,0,1-1.57,2.76,9.81,9.81,0,0,1-3.08,1.91,14.49,14.49,0,0,1-4.86.65h-10.5V302.16H358.5a16,16,0,0,1,4.7.56,8.55,8.55,0,0,1,3.1,1.51,5.73,5.73,0,0,1,1.7,2.47,8.85,8.85,0,0,1,.53,3.24A11.19,11.19,0,0,1,368.08,313.08Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_24),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M414.91,304.32a9.22,9.22,0,0,0-2.21-1.6A22.66,22.66,0,0,0,418,300a17.77,17.77,0,0,0,4-3.88,17.56,17.56,0,0,0,2.4-4.8,19,19,0,0,0-.46-12.6,13.64,13.64,0,0,0-4.13-5.46,20.46,20.46,0,0,0-7.24-3.6,39.64,39.64,0,0,0-10.67-1.27H383.2v59.4h12.3V305.22h4.16a5.32,5.32,0,0,1,2.49.47,4.36,4.36,0,0,1,1.54,1.59L415,325.47a4.79,4.79,0,0,0,4.5,2.36h11.08l-13.82-21.38A11.52,11.52,0,0,0,414.91,304.32Zm-4.37-10.59A10,10,0,0,1,407,295.8a15.48,15.48,0,0,1-5.16.75H395.5V277.78h6.37c3.83,0,6.69.76,8.55,2.31a8,8,0,0,1,2.8,6.56,11.28,11.28,0,0,1-.66,3.92A8.2,8.2,0,0,1,410.54,293.73Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_25),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("rect", {
            x: "225.46",
            y: "0.44",
            width: "12.38",
            height: "59.41",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_26),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M510.09,283.89a15.42,15.42,0,0,1,5.55-4,18.7,18.7,0,0,1,7.33-1.39,27.74,27.74,0,0,1,4.29.29,17.66,17.66,0,0,1,3.35.79,21,21,0,0,1,3,1.23c.89.45,1.87,1,2.78,1.58a4.13,4.13,0,0,0,2.85.65,3.3,3.3,0,0,0,2-1.58l3.47-5.35a24.87,24.87,0,0,0-4-3.09,31.64,31.64,0,0,0-4.87-2.44,33.28,33.28,0,0,0-5.77-1.59,37.4,37.4,0,0,0-6.75-.58,33.83,33.83,0,0,0-12.58,2.21,27.19,27.19,0,0,0-9.56,6.13,25.78,25.78,0,0,0-3.35,4A26.77,26.77,0,0,0,485,270.64a33.46,33.46,0,0,0-12.42-2.21H449.71v59.4h22.86A33.26,33.26,0,0,0,485,325.62a28.61,28.61,0,0,0,9.6-6.09,27,27,0,0,0,3.5-4.26,26.55,26.55,0,0,0,3.51,4.12,28,28,0,0,0,9.95,6.2,35.07,35.07,0,0,0,13,2.26,37.07,37.07,0,0,0,10.63-1.54,30.77,30.77,0,0,0,9.45-4.75v-24H524.68v6.74a1.83,1.83,0,0,0,.66,1.51,2.59,2.59,0,0,0,1.8.67h6.6v9.78a25.89,25.89,0,0,1-4.44,1.52,19.35,19.35,0,0,1-5.17.65,21.5,21.5,0,0,1-7.68-1.4,15.8,15.8,0,0,1-5.93-3.93,17.1,17.1,0,0,1-3.87-6.44,25.41,25.41,0,0,1-1.33-8.55,23.92,23.92,0,0,1,1.2-8.06A17.93,17.93,0,0,1,510.09,283.89Zm-21,22.67a16.82,16.82,0,0,1-3.53,6.34,14.6,14.6,0,0,1-5.6,4,19.09,19.09,0,0,1-7.43,1.35H462.09V278h10.48a19.08,19.08,0,0,1,7.43,1.39,15.63,15.63,0,0,1,5.6,4,16.48,16.48,0,0,1,3.53,6.33,25.65,25.65,0,0,1,1.27,8.4A26,26,0,0,1,489.13,306.56Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_27),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("polygon", {
            points: "340.92 59.84 378.78 59.84 378.78 50.23 353.3 50.23 353.3 34.61 373.1 34.61 373.1 25.32 353.3 25.32 353.3 10.04 378.78 10.04 378.78 0.44 340.92 0.44 340.92 59.84",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_28),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M627.77,302.63a13.91,13.91,0,0,0-3-4.32,16.92,16.92,0,0,0-4.25-2.9,40.87,40.87,0,0,0-4.81-2c-1.69-.58-3.29-1.13-4.87-1.59a26.27,26.27,0,0,1-4.2-1.65,10,10,0,0,1-3-2.17,4.67,4.67,0,0,1-1.15-3.18,6.23,6.23,0,0,1,2.1-4.88c1.37-1.24,3.47-1.87,6.25-1.87a12.34,12.34,0,0,1,4.12.63A28.82,28.82,0,0,1,618,280c.89.5,1.72.94,2.39,1.36a3.69,3.69,0,0,0,1.92.63,2.39,2.39,0,0,0,1.47-.42,4.11,4.11,0,0,0,1.15-1.36l3-5.63a21.52,21.52,0,0,0-7.57-4.53,28.07,28.07,0,0,0-9.69-1.6,22.5,22.5,0,0,0-8.31,1.44,18.82,18.82,0,0,0-6.11,3.81,16.39,16.39,0,0,0-3.76,5.41,15.9,15.9,0,0,0-1.29,6.28,17.78,17.78,0,0,0,1.15,6.77,13.44,13.44,0,0,0,3,4.56,15.84,15.84,0,0,0,4.21,3,43.61,43.61,0,0,0,4.83,1.9c1.67.56,3.27,1,4.85,1.46a22.8,22.8,0,0,1,4.19,1.58,9.33,9.33,0,0,1,3,2.29,5.4,5.4,0,0,1,1.14,3.59,7,7,0,0,1-2.3,5.67,9.93,9.93,0,0,1-6.5,2,13.07,13.07,0,0,1-5-.84,31.06,31.06,0,0,1-3.64-1.74c-1-.68-1.94-1.27-2.75-1.75a4,4,0,0,0-2.3-.83,2.93,2.93,0,0,0-1.49.42,3.68,3.68,0,0,0-1.17,1l-3.54,5.73a19.87,19.87,0,0,0,3.93,3.07,28.82,28.82,0,0,0,4.8,2.43,31.65,31.65,0,0,0,5.26,1.57,30.62,30.62,0,0,0,5.53.57,25.22,25.22,0,0,0,8.68-1.46,18.87,18.87,0,0,0,6.4-4.12,18,18,0,0,0,4-6.06,20.34,20.34,0,0,0,1.36-7.39A15.28,15.28,0,0,0,627.77,302.63Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_29),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M290.87,291.53s.09-.07.06-.07-.06.05-.08.07-.13.07-.13.05.06-.05,0-.07,0,.05-.06.06-.13-.05-.19,0,0,.07,0,.11-.05,0-.07,0,0,0,0,0a.19.19,0,0,1,0,.08c.07-.08.21-.19.25-.14s-.15.34-.08.34,0-.13,0-.18c.12-.32.08-.08.28-.23C291,291.52,290.89,291.57,290.87,291.53Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_30),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M293.3,287l-.06,0,0,0s.1,0,.13,0S293.32,287,293.3,287Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_31),
          _hoisted_32,
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M291.66,289.23s-.07,0-.07-.05,0-.05,0-.07a.05.05,0,0,0,0,0s0,.09,0,.11.11.07.15.11,0,.07,0,.07S291.74,289.3,291.66,289.23Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_33),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M294.56,284.65c.06.08.06.28.16,0S294.61,284.63,294.56,284.65Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_34),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M296.05,288.85l0,0,.06.09s0-.05,0-.06A.24.24,0,0,0,296.05,288.85Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_35),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M290.78,290.67l0-.05C290.88,290.41,290.84,290.53,290.78,290.67Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_36),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M298.66,280.6a.41.41,0,0,0,0,.08.21.21,0,0,0,0,.07.93.93,0,0,0,0-.13Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_37),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M304.36,284.84s0,0,0,0a.43.43,0,0,0,0-.05l0-.09s0,0,0,0S304.25,284.75,304.36,284.84Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_38),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M306.07,305.58s-.08.05-.11.09.11.1.1.16-.11.1-.08.15.09-.07.15-.07S306.18,305.65,306.07,305.58Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_39),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M290.14,291.36a.21.21,0,0,0,0-.06Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_40),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M291,289.89s0,0,0,0c0,.16,0,.29.1.06C291.1,289.88,291,289.92,291,289.89Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_41),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M290.49,292.52s.06-.1,0-.13,0,.08,0,.12l0,.09a1,1,0,0,1,.22-.1C290.67,292.45,290.53,292.56,290.49,292.52Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_42),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M299,296.71c0-.08-.08-.16-.07-.25s0,0,0,0,0-.06,0-.09,0-.09,0-.08,0,.06,0,0,0-.09,0-.14a.48.48,0,0,0-.08-.18c0,.09,0,.2,0,.23a.47.47,0,0,1-.06.21,1,1,0,0,1-.13.23l0,0,0,.05C298.57,296.81,299,296.81,299,296.71Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_43),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M307.49,303l0,0s0,0,0,0Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_44),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M317.93,299.81a0,0,0,0,0,0,0s-.11,0-.08,0A.08.08,0,0,0,317.93,299.81Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_45),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M307.3,302.86l.13.1v0a.08.08,0,0,0,0,0,.57.57,0,0,0-.15-.12S307.29,302.85,307.3,302.86Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_46),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M298.66,280.76a.21.21,0,0,1,0,.13s0,.06,0,.09,0,0,0,0a.28.28,0,0,0,0-.09C298.69,280.71,298.67,280.76,298.66,280.76Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_47),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M297.07,268a29.67,29.67,0,0,0-24.5,12.93,29.7,29.7,0,0,0-53.83,12V268.27H207.47V328h11.27V302.42a29.7,29.7,0,0,0,53.83,12A29.69,29.69,0,1,0,297.07,268Zm-4,19.09a.09.09,0,0,1-.07,0Zm-12.67,12s0,0,0-.07.14,0,.21,0,.12,0,.16,0-.08-.08-.12-.06,0,.05,0,.06a.9.9,0,0,1-.28-.17s0,0,.06,0,0,0,0,0a.37.37,0,0,1,.21,0c.07,0,.11.07.18.1s-.12-.12-.09-.19.12,0,.17,0,0-.06.06-.07l.22,0s0,0,0,0-.06,0-.09,0a.18.18,0,0,1-.07-.05s0,0,0,0a.93.93,0,0,1-.26,0s.06,0,.08,0a1.4,1.4,0,0,1,.17-.09s.05,0,.07,0,0-.09.07-.13l.07,0s-.06,0-.07,0,.07-.07.1-.1,0-.07.07-.08,0,.06.06.05a.43.43,0,0,0,.18-.06s-.06,0-.06,0,.05,0,.05,0a3,3,0,0,1-.33,0c-.17-.05,0,0,0-.17s-.26,0-.32-.13.15-.14.15-.14,0,0,0,0a.24.24,0,0,1,.13-.13c.06,0,.12,0,.18,0l0,0c.1-.24-.19-.06-.2-.13s.07,0,.09,0,0-.11,0-.11.07-.13,0-.17-.09.08-.12.05.05-.07.06-.11-.07,0,0,0,.44,0,.48.09,0,.14,0,.15.05-.07.09-.1.27.2.28.17-.05-.11-.05-.18.25,0,.25-.05a.35.35,0,0,0,.15-.12s-.12,0-.12,0,0,0-.1,0,0,0,0,0,0,0,0,0-.18,0-.16-.11.2,0,.25,0-.1-.07-.07-.1.09,0,.13,0,0-.07,0-.09,0,0,.06,0-.31,0,.1-.19l.08,0a1.14,1.14,0,0,1,.33.08c.05,0-.14.12-.11.17s.1,0,.13-.06,0-.08,0-.08.12.19.2.15.06-.1.1-.12.11,0,.15,0,.1,0,.14,0,.09.06.13.08.07,0,.08,0a.28.28,0,0,1,0,.2s0,0,0,0c.09.34.05-.1.14.2,0,.08-.17.2-.17.2s.27-.13.25.18-.25.14-.31.21,0,.18-.16.15-.07,0-.1-.07.09.07.06.11-.13,0-.17,0,.06,0,.06.07,0,.13,0,.19.06.09.06.14-.06.06-.06.11.05.06,0,.09-.09,0-.11,0,0,.06.05.1,0,0,0,0a.82.82,0,0,1,0,.27,2.93,2.93,0,0,1-.34.5s-.05,0-.06.06,0,.11,0,.17h0c0-.06,0,0-.11,0s0-.05-.06-.06-.23.07-.27,0,0,0,0,0,0,0-.08,0-.15-.07-.26,0,0,0,0,.06-.15.07-.15.07,0-.05-.07,0-.08.09-.13.13-.06-.15-.21-.13,0,.09,0,.13-.07,0-.11.06,0,.06-.07.07,0,0,0,0a0,0,0,0,0-.06,0s0,.06,0,.07-.22-.09-.27-.08-.1.05-.16.06.09-.11,0-.09a.77.77,0,0,1-.25,0c0-.05.27-.13.3-.2s0,0,0,0a2.39,2.39,0,0,1-.41,0l.11,0s0,0,0,0l0,0c.07-.07,0,0,.13,0s.18,0,.15-.07l-.37,0c-.07,0-.13-.12-.12-.2S280.38,299.11,280.4,299.1Zm-15.85-1.69a10.09,10.09,0,0,0-1.39,1.29,17.82,17.82,0,0,1-1.18,1.4,4.44,4.44,0,0,0-1.16,1.83,5.45,5.45,0,0,0,.31,3.46,6.6,6.6,0,0,1,.42,1.88c.08,1,.06,1.13-.24,1.58a3.8,3.8,0,0,1-1.17.94,3.22,3.22,0,0,0-1,.72,7.55,7.55,0,0,1-.71.89c-.5.54-.56.69-.5,1.15a4,4,0,0,0,.26,1c.24.59.1.85-.67,1.28s-.92.57-.92,1.4c0,.54-.07.8-.21.85a2,2,0,0,0-.56.63,13.41,13.41,0,0,1-2.83,2.85,3.35,3.35,0,0,1-1.5.28,9.4,9.4,0,0,0-1.59.13c-.47.09-.62.06-.78-.13a1.36,1.36,0,0,1-.17-.8,1.6,1.6,0,0,0-.33-1.1,2.48,2.48,0,0,1-.36-.69,4,4,0,0,0-.57-.92,2.66,2.66,0,0,1-.66-1.71,11.4,11.4,0,0,0-1.21-4.11,5.56,5.56,0,0,1-.6-1.44,5.38,5.38,0,0,1,.75-2.54,2,2,0,0,0,.26-1.94,3.13,3.13,0,0,1-.14-1,2.08,2.08,0,0,0-.26-1.08,4.83,4.83,0,0,1-.46-1.16,3.53,3.53,0,0,0-1-1.56c-.72-.78-.77-.88-.69-1.37a7.15,7.15,0,0,0,.07-3,1.73,1.73,0,0,0-1.62-.77c-.56,0-.65,0-.72-.35a1.23,1.23,0,0,0-.69-.66,3.43,3.43,0,0,0-3,.27,3,3,0,0,1-1.72.35,8.11,8.11,0,0,0-1.79.19,3.87,3.87,0,0,1-1.3.14,6.52,6.52,0,0,1-2.63-2.42A5.47,5.47,0,0,0,228.8,291c-.11,0-.26-.13-.34-.29s-.11-.29,0-.29.17-.6-.07-.92-.17-.32.11-.71.32-.64.32-1.52a6.94,6.94,0,0,0-.2-1.7c-.2-.6-.2-.62.31-1.36.28-.41.68-1.09.9-1.51a5.44,5.44,0,0,1,1.66-1.9,2.7,2.7,0,0,0,1.28-1.38,2.35,2.35,0,0,1,1.17-1.93,3.57,3.57,0,0,0,.95-.87c.16-.28.29-.36.4-.27a3.2,3.2,0,0,0,1,.23,2,2,0,0,0,1.67-.37,5,5,0,0,1,3.27-.73,6.8,6.8,0,0,0,1.9-.16c.21-.09.42-.13.47-.08a3.16,3.16,0,0,1,.08.94c0,.74,0,.89.37,1.21a2.09,2.09,0,0,0,.82.45c1.24.29,1.45.39,1.69.79a1,1,0,0,0,.78.51,4.41,4.41,0,0,1,.93.31,2,2,0,0,0,.73.2,1.15,1.15,0,0,0,1-1.13c0-.64.26-.68,1.24-.19a11.41,11.41,0,0,0,4.36.85l.79,0,0,.51c0,.39.09.74.56,1.51.33.55.87,1.51,1.18,2.14a13.78,13.78,0,0,0,.91,1.6,1.72,1.72,0,0,1,.33.9c0,.55.17.88.8,1.67a3.08,3.08,0,0,1,.56,1c.07.32.36.66,1,1.19a5.06,5.06,0,0,1,1.11,1.17c.1.23.23.42.28.42s.12.2.17.43a1.33,1.33,0,0,0,1.28.87,23.94,23.94,0,0,0,3.13-.65c.06,0,.14,0,.18.12a11.23,11.23,0,0,1-1,2.3C265.74,296.43,265.68,296.51,264.55,297.41Zm54.3-10.83a1.53,1.53,0,0,1,.21.27,8.84,8.84,0,0,1,.62,1.15c.09.22.18.75-.17.8,0,.26-.14.61.08.79a.88.88,0,0,1,.31.79c.31,0,.46.45.73.48a.19.19,0,0,0,.14,0c-.12.05,0,.09,0,.13s-.19.11-.22.12.13.18.1.21-.07,0-.1,0,0,.06,0,.09-.28-.08-.29-.08,0,.05-.07.09-.17.1-.15.14.06,0,.07.06-.17,0-.18,0,.11.11,0,.23-.07,0-.09,0,.07.12.07.16l-.08.35c0,.05-.11,0-.18,0s0,.05-.06.06-.6-.19-.61,0c0,0,0,.08,0,.09s.09-.05.13,0,.18.21.16.29a.1.1,0,0,1-.16,0,.27.27,0,0,1-.07-.14s0-.1,0-.1h-.24s-.51.28-.39.58.3.15.46.57-.08.46.11.69.53.49.61.72,0,.27.07.57.08.42.16.69a4.3,4.3,0,0,0,.26.6l-.19,0-.08,0a.79.79,0,0,0-.26,0c-.07,0-.22,0-.26.12s0,.29-.05.26-.07,0-.07.07,0,.12,0,.07-.1,0-.09.06,0,.17-.05.15,0,.18,0,.18a1.63,1.63,0,0,1-.17.31c-.05,0-.1,0-.09,0s-.11-.06-.12,0a1.3,1.3,0,0,0,0,.26c0,.1.07.18.07.21,0,.4-.15,0-.2.14s.09,0,.06.06-.1-.1-.11,0,.15.11.2.19-.16,0-.19,0,0,.13,0,.19-.05,0-.07,0,0,.05,0,.07a.44.44,0,0,1-.12.15c-.08.08-.09-.05-.1,0s.07.09,0,.12-.14,0-.19-.06H318c0,.05.1.07.13.1s.05.07,0,.07h-.05a.31.31,0,0,1,0,.18s-.07,0-.06,0,.06,0,.07,0,0,.07,0,.11.05.07.05.11-.05,0-.05,0,.06.16,0,.24-.05,0-.05,0,.13.17.07.17-.08-.13-.12-.1.06.1.06.15-.2.18-.07.34.07,0,.28,0c.06,0,.07.08.12.09s.06,0,.09,0,.06.08.1.11.28.18.28.21-.07.17.07.28h0c0-.08-.12-.37-.11-.38s.08-.09.1-.06,0,.12,0,.18a.75.75,0,0,0,0,.16c0,.07,0,.21.09.26s.07-.06.07,0-.08.17.06.31a.37.37,0,0,0,.15,0h.07s.07.19.13.2.07,0,.1,0a3.39,3.39,0,0,1,.52.29c.05,0,.08.1.13.12s.09,0,.13,0h.05v0c0,.46,0,.2-.16.54,0,.07,0,.27,0,.29s-.36.23-.48.14.25-.06-.2-.18c0,0,0,.05-.05.05l-.25-.08s0-.1-.07-.09a.31.31,0,0,0-.14.06c.22.09-.1.08,0,0h0s-.14.05-.18,0-.06,0-.08,0l-.2.09s0,0-.07-.06h-.24c0-.05,0-.3-.06-.3l-.15,0s-.06.09-.1.09-.15-.1-.39-.07c-.07,0,0,.15,0,.19s-.13-.1-.2-.07c-.23.11-.16.44-.47.44-.11,0,0-.16,0-.16s-.38.06-.56,0l-.11,0s0-.05,0-.05-.26.07-.26.07-.12,0-.18,0c-.45.1,0,0-.21.16l-.35.13c-.06,0-.12-.06-.18-.07l-.24.1c-.1,0-.2-.09-.3-.07s-.06.07-.1.08c-.23.11-.32-.08-.32.28l-.06,0s0-.06-.07-.07-.08,0-.12,0a3.29,3.29,0,0,1-.42-.21,2.45,2.45,0,0,0-.62-.19c-.1,0-.19.1-.29.07s-.37-.24-.41-.23.08.07.06.1L312,304c-.13,0-.18-.18-.3-.23s-.33.07-.48,0,.33-.11.21-.22-.08.08-.12.06,0-.1,0-.14.07,0,.11,0,.09,0,.12,0,0,0,0,0,0,0,0-.05a.59.59,0,0,1,.14-.06s0,0,0,0,0-.09.06-.11.12,0,.17,0,0,0,0,0,0-.05,0-.08-.17-.11-.21-.18.07,0,.08,0,0,0,0,0,.06-.09.08-.14-.08-.23,0-.28.06,0,.16.17c0,0,0-.05,0-.07s-.06-.26,0-.28.19.1.25,0,0,0,0-.06-.15,0-.22,0-.07-.08-.13-.09c-.22,0-.19.07-.33-.1s-.08-.06-.07-.08.07,0,.1,0a.21.21,0,0,0,.11,0c.05-.05,0-.15.11-.18s0,0,0,0,.23,0,.2-.05-.11,0-.16,0,.06-.15.06-.15.22-.32.27-.35,0,0,0,0,.09,0,.11,0,0-.2-.1-.24a.2.2,0,0,0-.13,0c-.14.06,0,.05,0,.13s-.34.17-.41.25,0,.1-.05.14,0-.06,0-.06a1.36,1.36,0,0,0-.33.14c-.05,0-.05.25-.07.27s-.05-.05-.09,0l-.18.22c0,.06,0,.16,0,.19s-.09-.1-.15-.09-.1.16-.17.24,0,0,0,0-.17-.06-.28.09,0,.12-.08.17-.06,0-.09.07,0,.47-.2.5-.1-.11-.15-.08a1.07,1.07,0,0,0,.12.24c.07.09.51.51.64.47s.09-.06.13-.1,0-.16,0-.16,0,0,0,.05a.12.12,0,0,0,.1,0s0-.12,0-.15l.33-.07s-.06.11-.07.17.11.27-.05.33h-.12c-.05,0-.06.1-.12.1s-.08-.05-.12-.06a.17.17,0,0,0-.14,0s-.09.08-.05.12,0,0,0,0,0,.05-.1.09,0,.16-.06.21-.06,0-.09,0a.35.35,0,0,0-.16.08c-.25.17-.17.62-.56.66-.07,0-.07-.05-.12-.07s-.16,0-.18,0,.09-.05.12-.08,0-.05-.08-.16.14-.09-.07-.31-.15,0-.22,0-.23-.12-.28-.12-.12.13-.32.05.18-.23.19-.24,0,0,0,0a.15.15,0,0,1,0-.06l.17-.15s0,0,0-.05.05,0,.07,0a2,2,0,0,0,.29-.3s-.07.05-.1,0,.05-.29-.08-.21,0,.1-.08.14-.11-.1-.18-.11,0,.09-.06.1,0,0-.06,0,0,.05,0,.05-.12,0-.17,0-.09.1-.15.12a.27.27,0,0,1-.18,0s0-.06,0-.07-.31.05-.33,0,.14-.1.12-.18-.07,0-.08,0-.11,0-.16,0,0,.08,0,.07a.42.42,0,0,1-.15-.11s.17,0,.18,0l.41-.05c.07,0,0-.09.05-.14l.1-.08c-.24.16-.49.31-.5-.14,0,0,0,0-.05,0s0,.07,0,.16.12.17,0,.19h-.13s-.07.07-.09,0,0-.18-.07-.15,0,.12,0,.19-.23,0-.4.19.09.07,0,.17-.07,0-.07.05,0,.07,0,.1a3.61,3.61,0,0,1-.17.46s0,.07-.07.07-.09,0-.13,0,0,.08,0,.09,0,0,0,0,.15.12-.08.21c-.07,0-.06-.15-.13-.17s0,.06,0,.09a.57.57,0,0,0,0,.26c.06.1,0,0,.07,0s0,0,0,0,0,0,0,0,0,.21,0,.26h0a0,0,0,0,0,0,0s0,0,0,0a1.72,1.72,0,0,1,0,.32c0,.1-.24.11-.3.16s0,.14-.08.13,0,0,0,0-.24.12-.1.21,0,0,0-.06,0-.15.07-.12-.14.34-.14.35.24.91.11,1-.07,0-.11,0c-.28.07-.1.07-.18.24s-.06,0-.08.05.05,0,.05,0a1.19,1.19,0,0,0,0,.33c0,.05.05.11,0,.15s-.1,0-.14,0l0,0s-.06,0-.06.07,0,.05,0,.06-.1.07-.13.11.2-.09.28.12c0,0,0,0,0,.05l.22.14c.16.17-.09.27.28.49.2.13.57.07.74.12s0,.07,0,.1,0,.11,0,.16-.21.1-.28.1-.06-.06-.07-.09c0,.18,0,0-.22.06a.35.35,0,0,0-.16.08s0,.07,0,.08-.21-.1-.34.07,0,.09,0,.14a1.42,1.42,0,0,1-.08.18c-.1.17-.31.2-.42.36s-.15.36-.3.49,0-.11,0-.15a.08.08,0,0,0,0-.07s-.05,0-.05-.06.4-.28.41-.38-.43.16-.54.12c-.3-.11,0-.1-.1-.23s-.31.07-.38.06c-.25,0-.28-.18-.45,0a.46.46,0,0,1-.12.12c-.22.11-.1-.16-.32,0s0,.19-.19.27-.17-.13-.31.05,0,.07.06.08.07.16.13.22h.08l0,0s0,0,0,0,0,.06.06.07.27.05.3.17-.2-.1-.2-.1-.34-.08-.36.07.18.06.24.12,0,.21,0,.18-.14-.18-.26-.25H303s-.09,0-.11,0c-.18.19.34.24.3.31s-.22,0-.28,0a1.21,1.21,0,0,1-.08-.25c-.06-.08-.28,0-.36-.1s0-.1,0-.25-.09.05-.14.09-.1.07-.1.13.07,0,.07.08l-.05.23c0,.15.2.22.29.32l.1.2c0,.05.45.25.39.34s-.32-.13-.35-.12,0,0,0,.07-.1.17,0,.16,0-.05,0,0,0,0,0,.06.23,0,.09.16a1.19,1.19,0,0,1-.36.16s0,0,.07,0,0,0,.07,0,0,0,.05.06,0,0,.05,0a.55.55,0,0,1,.18,0s0,.1.08.1.11-.07.16,0,0,.12,0,.14.14-.07.19,0,0,.14.13.15.2-.05.31.08,0,0,0,.11,0,.06.06.09,0,.09,0,.12.14.1.06.23-.05,0-.07,0,0,0,0,0a.38.38,0,0,0-.11-.08s0,0,0,0-.14-.19-.22-.22,0,.09-.1.1-.35.11-.33.15.12,0,.17.06-.05,0-.05,0,0,0,.05,0,0,.08,0,.1.23,0,.31.14-.13.07-.2.07h-.22s0-.05,0-.07h0c-.06,0-.14-.05-.18,0s.19.28.22.33,0,.07,0,.09.06,0,.07,0,.13.23.16.3-.06,0-.06,0,0,0,0,0,0,0,0,.06.19.11.17.18-.07,0-.1,0,0-.06,0-.08,0,0-.07,0-.18-.41-.38-.14a1.07,1.07,0,0,0,0,.27s0,.08,0,.07c-.19,0-.07-.21-.13-.3h0a.83.83,0,0,1-.11-.15s0-.11-.09-.12c-.37-.09,0,.27-.17.33s-.16-.15-.17-.21h0c-.07,0-.11-.09-.12-.17s.07,0,.09-.17-.19-.28-.3-.31,0,.05-.06,0,0-.11,0-.15-.25,0-.14-.13h0c.13-.09.07-.16.1-.3s0,0,0,0,0,0,0,0,.15.07.21,0,0-.09.13-.19.19,0,.27.07a2.7,2.7,0,0,0,.41.07c.07,0,.12.11.2.12s.09,0,.08-.07-.1,0-.11,0,.19.09.28-.17c0,0-.05,0-.08,0s0-.05,0-.05,0,.1-.06.05-.11,0-.21,0-.07-.12-.13-.13,0,.12-.06.12-.05-.33-.15-.15,0,.09,0,.12-.31-.05-.36,0-.18.14-.33.17-.11-.1-.15-.13,0,.06,0,.07a.33.33,0,0,1-.13.11s0,0,0,0,0-.11-.05-.19a.37.37,0,0,0-.12-.13s0,0-.05,0,0-.1-.06-.12-.21.15-.1-.14c0,0,0,0-.05,0s0-.06,0-.08-.3-.21-.39-.29,0-.09,0-.12-.16.07-.23-.15v-.05c0-.05,0-.09,0-.12s-.06,0-.07,0,0-.09-.07-.12-.55-.2-.49-.33.13,0,.15,0-.15-.11-.17-.2,0,0,0-.05,0-.07,0-.11,0-.07,0-.1.08,0,.1,0,0-.08,0-.08,0,.07,0,.09,0-.26,0-.34-.11-.05-.11-.14a.34.34,0,0,1,0-.2s.09,0,.12,0,0,0,0,0,0-.14,0-.17-.12,0-.18,0a.31.31,0,0,1-.17-.09s0-.07,0-.09-.13-.07-.19-.15,0-.05,0-.07-.13.17-.24-.07a.05.05,0,0,1,0-.05.48.48,0,0,1-.31-.1c-.41-.33-.35-.11-.62-.25,0,0,0,0,0,0l-.16-.06c-.05,0-.11,0-.15,0s0,0,0-.05,0,0,0,0,.11,0,.17,0,.22.13.34.14,0-.05,0-.05a.11.11,0,0,0-.07,0h0c-.11,0-.05,0-.08-.1H298a.91.91,0,0,0-.21-.11c-.09,0-.15-.18-.23-.21s-.14,0-.2,0-.08-.13-.24-.1a1.2,1.2,0,0,1-.27.08c0-.05,0-.13,0-.19s-.21-.08-.26-.12l.05,0c-.05-.07-.41-.27-.42-.37,0-.29.17-.07.28-.1s-.13-.05-.19-.08a2.41,2.41,0,0,1-.24-.21c-.15-.17,0-.38-.13-.54s-.07,0-.1,0-.06-.2-.29-.19c-.07,0,0,.21-.08.24h0v0a.49.49,0,0,1,0,.12c-.09.14-.06,0-.1,0v0h0a.14.14,0,0,1,0,.07.91.91,0,0,1-.09.17s-.06-.16-.09-.21-.18-.11-.13-.16h0a.32.32,0,0,1,0-.17v0c0-.05-.08-.1-.08-.16s.05,0,.07,0,.16-.15.09-.22-.14-.08-.23,0h0c0-.07-.15-.09-.22-.06s0,.11,0,.14-.08,0-.13,0-.21.18-.33.2-.08,0-.11,0,0,.05,0,.09,0,0,0,.06h0s0,.08,0,.1,0-.05,0,0,0,.09,0,.11,0,0,0,0h0s.12.06.13.11c.05.22-.14.13-.2.27a3,3,0,0,0,.11.5,4.93,4.93,0,0,0,.7.53c.11.06.14,0,.24.11a7,7,0,0,1,.35.86,1.34,1.34,0,0,0,.4.42c.05,0,.12,0,.16.08s0,.06,0,.08c.21.22.61.15.86.11.05,0,.17-.1.24,0s-.39.3-.1.5.67.17,1,.32c.1,0,.14.14.26.18a2.16,2.16,0,0,1,.43.14s0,.07,0,.1.34.11.42.38c0,.1,0,.07-.06.14s0,.19,0,.21-.08,0-.13,0c-.24-.1-.14-.24-.26-.4s-.3,0-.42,0-.24-.23-.38-.08-.21.41-.21.43,0,.05,0,.08-.19.14-.06.31.1,0,.19,0,.15.12.24.16.08,0,.09,0,0,.06,0,.09c0,.22.11,0,.1.29s-.32.11-.46.27,0,.23,0,.37-.1.09-.18.15-.06.54-.45.43c-.07,0-.16-.23-.11-.31s.11,0,.15-.08a.42.42,0,0,0,0-.12s0-.07,0-.11-.09-.07-.08-.11.22-.07.27-.14,0-.18-.08-.27,0-.22-.08-.32a.68.68,0,0,0-.09-.17l-.06,0c-.14-.21,0-.08-.08-.32s-.19-.14-.42-.13c0,0,0,0,0,0a.54.54,0,0,0-.12-.09c-.05,0-.14,0-.17-.06s.06-.1.05-.17a.48.48,0,0,0-.08-.16c-.19-.26-.22.1-.44,0,0,0,.15-.13.07-.18-.28-.21,0,0-.31,0,0,0,0,0,0-.07a.9.9,0,0,0-.27-.38c-.21-.08-.05.07-.12.06s-.13-.1-.21-.1-.12.11-.18.1-.06-.12-.11-.17-.2,0-.24-.06l-.12-.16c-.05-.05-.14-.06-.19-.11s0-.12-.09-.2l-.15-.1s0,0-.07,0-.08-.2-.17-.27-.24,0-.39-.09,0,0,.05-.05-.05-.16-.07-.18-.05,0-.06,0,0-.08-.06-.1-.11,0-.14-.06,0-.09,0-.11-.12,0-.18,0,0-.08,0-.13a.41.41,0,0,0-.08-.34c-.17-.24-.05-.45-.25-.62a.07.07,0,0,0-.07,0s0,0,0,0-.06-.06-.1-.06,0,.07,0,.06a.39.39,0,0,1-.16-.1s-.22-.22-.28-.22,0,0,0,.05a0,0,0,0,1-.05,0,.6.6,0,0,0-.28-.12.92.92,0,0,0-.25.15s0,.08,0,.1-.09,0-.11,0-.09.17-.16.23-.28.09-.39.11a.64.64,0,0,0-.16.06s0,0,0,0,0,0,0,0a.29.29,0,0,0-.13.05s0,.07,0,.1-.09,0-.13,0,0,.09-.06.12-.07,0-.1,0,0,.05,0,.07-.09,0-.1.08.06.08,0,.1-.12,0-.17,0-.12.08-.18.11,0-.09-.17-.1,0,0,0,.06h-.07s-.05,0-.06,0,.06-.05-.05-.11h-.08a.37.37,0,0,1-.15,0s0-.12,0-.16-.05,0-.08,0-.14,0-.13,0,.14,0,.15-.1-.08-.11-.14-.1,0,.09,0,.12a.23.23,0,0,1-.16.06c-.12,0-.08-.23-.11-.2s.13.18.06.21c-.24.1-.14-.06-.14-.09s-.28-.06-.31-.08-.14-.13-.21-.08-.21.2-.3.24-.23,0-.33.14,0,.05,0,.07-.12.13-.13.21.06,0,.06,0-.06.1,0,.26.19.16.16.25-.12.05-.16.08.1.21,0,.35-.37.21-.47.25a1,1,0,0,0-.28.12s-.11.15-.18.16c-.27.08-.74,0-.95.2s-.16.08-.15.15.14.05.13.1-.24.08-.25.09-.13.2-.21.28a3.2,3.2,0,0,0-.64.73.93.93,0,0,0,.09.59s.31.19.24.24-.18.06-.24.1,0,.06,0,.06,0,0-.05,0a.47.47,0,0,0-.19.06s0,.08,0,.1-.06,0-.08,0,0,.1,0,.13-.09,0-.11,0,0,.12,0,.16-.2,0-.21.23c0,.06.12.09.11.14s-.11.05-.17,0-.08,0-.12-.05a.66.66,0,0,0-.5.13c-.24.15-.24.46-.49.58-.09.05-.12-.2-.36-.14,0,0-.07.08-.12.09s-.23-.11-.3-.11-.2,0-.3,0-.08-.06-.14-.08a3.78,3.78,0,0,0-.64-.09c-.1,0-.14.14-.23.18s-.28-.09-.45,0-.12.13-.19.24-.06,0-.09,0-.09.1-.15.12,0,0,0-.06l-.11,0s0-.1-.07-.13-.07,0-.1,0a1.21,1.21,0,0,1-.14-.39s.11.11.1,0-.05,0-.06,0,0,0,0,0-.14,0-.14-.2c0,0,.31-.14.24-.16s-.1.12-.17.1,0-.1-.05-.15a.94.94,0,0,0-.09-.12l-.21-.2s.1-.1.06-.1,0,.1-.09.1-.07-.05-.11-.07a.84.84,0,0,0-.37,0l-.28.12s-.46-.25-.58-.29l-.07,0h-.14s-.09.06-.1,0,.18-.34.21-.4,0-.17,0-.25.06,0,.08,0,0,0-.06,0,0-.11,0-.17-.05-.05-.05-.08.13-.17.15-.27a.92.92,0,0,0,0-.16s-.12-.1-.07-.11,0,.24.25.14c0,0-.07,0-.1-.06s0-.09,0-.12,0,.08,0,.07-.05-.05-.08-.05-.05,0-.08,0a.41.41,0,0,1-.19,0s0-.06-.05-.19-.07-.11-.09-.16.21-.4.24-.48-.06-.11,0-.15.12,0,.18,0,0,0,0,0,.07-.05.1-.08a2.59,2.59,0,0,0,.25-.39s.05-.1.09-.13.07.05.06,0-.08-.05-.08-.09,0-.06.06-.1.09-.2.15-.3.14,0,.18-.09,0-.11,0-.1-.06.13-.11.15,0-.1.07-.14a.72.72,0,0,0,.11-.32s0,0,0-.06a1.33,1.33,0,0,1,0-.49s.12,0,.11,0-.11,0-.14-.07.15-.11.16-.18-.07-.12-.07-.18,0,0,.06,0,0,0,0-.05.13-.05.18-.09.05,0,0,0-.1.05-.14.06-.06-.06,0-.09.15,0,.17-.07-.1,0-.14,0a.1.1,0,0,1-.06-.08c0-.08.06,0,.07,0s0-.07,0-.1.09,0,.1-.09c0-.38-.27.05-.34-.32s.17-.18.18-.22-.06,0-.08,0,0,0,0,0a.6.6,0,0,1,.19,0,2.7,2.7,0,0,0,.66-.27c.07,0,.15-.13.22-.08s-.05.11,0,.12.1-.1.17-.1.19.37.38.41c0,0,.06-.08.1-.07.22.06.1.06.32.09.05,0,.15,0,.2,0s.07.06.12.06.11-.08.17-.06.07.11.11.14.14,0,.19,0,0,0,0,.05.07,0,.09,0a1.51,1.51,0,0,0,1,.31s0,0,0-.05h.09c.06,0,.23,0,.27.09s-.06.06,0,.06,0,0,0,0,.23.18.29.18,0-.06,0-.07.05,0,.08,0c.23,0,.08,0,.17.1s.09,0,.13,0,.07.07.1.1a.83.83,0,0,0,.58,0c.22-.1.32-.85.4-1.08,0,0,0-.1.07-.11s.11.05.12,0,0-.1-.08-.11,0,.11-.08.09,0-.15.05-.23a2.29,2.29,0,0,1,.2-.64s.14.15.17.23c.11.23,0,0,0,.27,0,0,.07.08.08.13s0,.09,0,.08.06-.06.06-.09-.07-.06-.11-.1,0-.29,0-.4a1.24,1.24,0,0,0-.14-.18.55.55,0,0,0-.11-.1h0c.05,0,.1,0,.14,0s-.11-.11-.1-.17.09-.09.1-.15-.05-.09-.05-.14.05-.1.05-.16h-.07s0,.06,0,.05,0-.08-.08-.1-.05,0-.08,0,0-.07,0-.09-.06.16-.19-.1a1.2,1.2,0,0,0,0-.23h0a.83.83,0,0,1-.09-.16c0-.07.12-.15.14-.18s-.16-.12-.16-.13a.12.12,0,0,1,0-.12s0,0,0,0c-.32,0,0-.11,0-.28s-.32,0-.33-.05.08-.09.13-.12,0,0-.05,0,0,0,0,0,0,0-.05,0-.12,0-.18,0l0,0h0c0-.1.09-.2-.07-.21s-.07.1-.13.06-.11-.13-.15-.16-.07,0-.1,0,0-.17-.17-.15c0,0,0,0,0,0s-.13.07-.18,0,0-.11,0-.17-.13-.07-.19-.11l0,0h.23s.06,0,.06,0a1,1,0,0,0-.12-.2h.14s.1,0,.08,0-.15,0-.17-.07.11,0,.12-.08-.47.27-.31-.15a2.44,2.44,0,0,1,.34-.1c.08,0-.11.1.07,0s.11-.07.17-.05,0,.11.07.12,0-.09,0-.1.09.1.14.09,0-.12.07-.15,0,0,.07,0,.1-.05.14,0,0,.1,0,.12,0,0,.05-.05.16.3.19.36,0,0,0,0A.59.59,0,0,1,284,303s.08-.09.11-.07,0,.3.2.22,0-.12.06-.17,0,.1.09.11a.66.66,0,0,0,.14,0s.14.07.15,0-.16-.15-.14-.24a1,1,0,0,1,.06-.16s0,0,0,0a.48.48,0,0,0,.06-.18s0,0-.05,0,0-.11,0-.14-.06,0-.07-.05a.3.3,0,0,1,0-.16s0,0,0,0a1,1,0,0,0,0-.17s0,0,0,0l.18.08s0,0,.06,0,.12,0,.18,0,0,.06,0,.09l0,0a.77.77,0,0,0,.07.27c.32.05-.14-.14.11,0s.26.07.37.12.06.08.1.09.14-.08.28-.12H286c-.08,0-.16-.08-.05-.26s.6-.14.74-.22.09-.07.15-.1.13,0,.15-.06-.06-.07-.07-.12a.12.12,0,0,1,0-.08s.05,0,.05,0,0,0,0,0h0l-.15,0s-.06.08-.1.08-.2-.13-.27-.15-.44.09-.47,0,.11,0,0-.06,0,0,0,.06,0,0-.05,0,.06-.05,0-.05,0,.05-.07,0,0-.05,0-.07,0,.07,0,.06-.17-.19-.19-.16.06.09.05.14-.44,0-.46,0,.06.09,0,.14,0,0-.07,0h0s-.16-.11-.2-.09,0,.09-.05.13,0-.05,0-.07a.21.21,0,0,0-.09-.1.69.69,0,0,0-.54-.12s-.08.37-.2.43-.25-.19-.32-.22.08.07,0,.05-.23-.12-.33-.09,0,.08-.06.1-.1,0-.15,0h0s-.11.23-.14.23,0-.11-.05-.15-.23,0-.23-.11.31-.07.31-.07a.12.12,0,0,0,.09-.07s0,0,0,0,.05,0,.07,0,.07-.12.12-.16.06,0,.09,0,0-.05,0-.06.1-.05.14-.1,0-.21.07-.23.07.06.1.06c.18,0,0-.25.4-.18.15,0,.34.23.49.11s0-.11.06-.16.38-.25.42-.3-.2.11-.23.13l-.12,0s0,0-.06,0c-.19.05-.15.22-.38.08-.08-.05-.06-.18-.13-.25s-.18.08-.26,0,0-.25,0-.28,0,0,0,0,0-.06-.17,0c0,0,0,0,0,.06a.29.29,0,0,1-.16,0s-.11-.05-.09-.08.1,0,.15,0-.2,0-.22,0a.32.32,0,0,1,0-.17c0-.15.29-.06.33-.08s.06-.09.11-.1.08,0,.12,0a1,1,0,0,0,.42-.35.91.91,0,0,0-.07-.38c-.13-.16-.28.3-.33,0,0-.05.15-.06.25-.14s0-.06,0-.08a.12.12,0,0,1,.05,0,.1.1,0,0,1-.07,0s0,0,0,0c0-.17-.16-.2,0-.26.14.11.25.17.1.24a.39.39,0,0,0,.21,0s0-.07,0-.06.08.07.14.08.13-.09.21,0,.05.16.1.13,0-.12,0-.17,0,0,.09,0a.34.34,0,0,1,0-.14.23.23,0,0,1,.1-.12s.11,0,.1,0-.11,0-.13-.09c-.1-.22.17-.05.17-.14s-.06,0,0-.08.09-.09.08-.15-.1.09-.21.1,0-.15,0-.21-.05.06-.08.05,0-.11,0-.16l-.09-.19c0-.1.25-.35.26-.35s0,0,0,0,.15,0,.16-.08-.09,0-.14,0-.06,0-.1,0-.07.08-.11.1-.09,0-.13,0-.07,0-.11.07,0,0,0,0,0-.06,0-.07,0,.05,0,.06,0,0,0,0,0-.16-.13-.17,0,.1,0,.23-.07-.08-.11-.13c-.22-.29,0,.05-.29-.13-.08,0,.11,0,.1,0s0-.17.13-.29-.14,0,.11-.19c0,0,.08,0,.09-.05s-.11-.24-.12-.25,0,0,0-.05,0-.12,0-.18.09,0,.16,0c.26.12-.13-.07-.13-.08a.33.33,0,0,1,0-.17s0-.09,0-.12a2.06,2.06,0,0,0-.35.19c-.06.05,0,.16,0,.25s-.07,0-.1,0a.15.15,0,0,0,0,.07s0,0,0,.07-.08.09-.11.15,0,.05,0,.06a.26.26,0,0,1-.19,0c-.05,0,.06-.09.09-.13s0-.16.07-.22l.17-.14s-.1,0-.12,0,.21-.16.1-.18-.07.1-.11.07.11-.07.14-.12,0-.2,0-.26a.19.19,0,0,1,.1-.1s.11.08.11,0-.09,0-.11-.08.26-.16.27-.16-.1,0-.1,0,.08-.06.09-.1,0,0-.07,0,0,.06-.09.08-.2.14-.27.11,0,0,0,0,0,0,0,0-.37.16-.43.05,0,0,0,0,0,.17.22-.09-.36-.08,0-.2a.19.19,0,0,0,.05.09l0,0,0-.09s.06,0,.08,0,.13,0,.18,0-.42,0-.36-.11.25,0,.27,0-.2-.17,0-.23c.05,0,.11.06.17,0s-.05-.18-.05-.18.14,0,.18,0,0-.12,0-.18a.56.56,0,0,0,0-.13s-.27-.28-.1-.35.05.12.1.1,0-.19.07-.13l.13.07c0-.11-.06-.11-.06-.21s.1,0,.12,0,0-.12,0-.18,0,0,0,0,.14.07.17,0-.07-.08-.09-.13.08,0,.08,0,0-.05,0-.06.06,0,.06,0-.06,0-.05-.06.06-.09.09-.14.13.07.15.12,0,0,0,0,0,.11,0,.14.05-.06.08-.07a2.08,2.08,0,0,1,.54,0c.06,0,.14,0,.18,0s-.06.08-.08.13,0,.09,0,.14a6.89,6.89,0,0,1-.6.4c-.15.12.07,0,.15.05s0,0-.07.07,0,.06-.08.07,0-.06,0-.06-.06,0-.08,0-.06,0-.09,0,.09.19.13.14,0,0,0,0,.08,0,.13,0,.19-.1.3-.07.1.06.16.07.56,0,.63.19a.17.17,0,0,1,0,.14l-.18.18a.21.21,0,0,0,0,.11s0,0,0,0-.39.57-.49.58-.21-.06-.35,0,.05,0,.07,0a1,1,0,0,0,.18-.05c.1,0,0,.07,0,.09s.12.07.11.13-.18,0-.23,0c-.24,0,.19.14-.31.1,0,0,0,.09,0,.09s0,0,0,0,.19.12.26.07,0-.08.07-.09a2.14,2.14,0,0,1,.34.24c.06,0,.08.23.13.29s.08,0,.1.07,0,0,0,.06a.71.71,0,0,0,0,.15,5.71,5.71,0,0,0,.11.83s0,0,0,0,.05,0,.08.07.11,0,.24.17,0,.15.07.21.14,0,.14.17-.08,0-.09.09.12.3.15.41-.09-.07-.1.1.28.33.14.48-.15,0-.23.18c0,0,.06,0,.07,0s0,.07.06.09.07.06.09.05,0-.21.2-.18.69.15.62.57c0,.13-.21.48-.34.53s-.12-.08-.13,0,.29.1,0,.19c0,0,0,0-.06,0h0c-.07,0-.16,0-.19,0s.12,0,.15,0,0,.09,0,.13-.23,0-.32.07-.08,0-.06,0,.23-.07.23,0-.1,0-.13,0,0,.05.08.05l0,0s0-.05,0-.05l.06,0,.2,0a1.18,1.18,0,0,0,.28,0c.18,0,.48-.31.66-.27s.07.1.21.1,0-.07.08-.06.18.16.21.14,0-.11,0-.14-.08,0-.11,0-.06-.06-.09,0,0,.05,0,.05a.88.88,0,0,1-.29-.16c0-.06.12-.08.26,0s.16.29.28.14-.17-.05-.18-.12.11,0,.14,0,0-.07-.06-.08-.05,0-.08,0a1.13,1.13,0,0,1-.18-.12c-.06,0,.18,0,.26-.1s0-.11,0-.15.06,0,.09,0,.06-.07.09-.11a1.13,1.13,0,0,0,.23-.34c0-.13,0-.38.11-.5h.06c.05,0,.11,0,.17,0s.16-.13.23-.23a1.68,1.68,0,0,1,.8-.22c.15,0,.16.4.37.19.05,0-.14,0-.19,0s.11-.32.17-.35.09,0,.13,0c.58,0-.61-.07.28,0l0,0c.05.09.08.44.28.37s-.07-.56.11-.56c0,0,0,0,0,.05a.16.16,0,0,0,.1,0c.07,0,.15-.06.22,0h0s-.2,0-.19-.07.12-.29.05-.37-.19.06-.22,0,0,0,.06,0-.06-.05,0-.05.21.05.23-.1-.18-.21-.19-.24a.75.75,0,0,1,0-.3s.07-.08,0-.11-.14,0-.14,0,.11,0,.14,0,0-.1,0-.16,0-.12,0-.15-.27,0-.31-.13.06-.19.06-.29a.07.07,0,0,1,0-.05s0-.11,0-.08a.25.25,0,0,1,0,.08.11.11,0,0,1,0,.05h0a0,0,0,0,0,0,0c.24.11.09-.2.07-.23s0-.06,0-.05,0,.09-.07.1,0-.06,0-.08,0-.11,0-.16,0-.1,0-.13a0,0,0,0,1,0,0h0s-.05-.35,0-.32,0,.09,0,.13.4-.24.42-.24,0,.21,0,.25.09,0,.15,0h0s0-.09,0-.12-.06,0-.07,0,0-.05,0-.08-.1-.13,0-.23a.12.12,0,0,1,.15,0s0,.08,0,.07,0-.11.07-.13h.1s0,0,0,0-.18,0-.24,0-.1.07-.15.08,0,0-.07,0a.47.47,0,0,0-.17,0s0,.06,0,.07,0-.26-.14.15c0,0,0,.23,0,.23-.26,0-.12-.5,0-.55s.32,0,.45-.05.14-.33.3-.42.13,0,.18,0,.09-.14.15-.14-.06.08-.07.15,0,0,.08.16-.06.5-.2.46-.08-.08-.14-.08,0,0,0,0a1.83,1.83,0,0,0,.23.07c0,.05,0,.1,0,.16s.07.07.05.11-.07,0-.1,0,.12,0,.11.09l0,0s.05.08.09.08.23-.1.27.07-.17.38-.23.35-.06-.14-.12-.16-.06.38-.08.43a.23.23,0,0,1-.21.17c-.06,0-.18-.09-.16,0s.15,0,.18.08-.2.11-.2.12.07,0,.09,0-.05,0-.05.06a.3.3,0,0,0,0,.13s.05,0,.05.05-.14.12-.16.21.06,0,.09,0a.2.2,0,0,1,.1.15s-.05-.06-.08-.05-.15.17-.1.14,0-.07.08-.07,0,0,0,.05.05,0,.07,0a.24.24,0,0,1,.15,0,.08.08,0,0,1,0,.07h0s-.05,0,0,0,0,0,.05,0a.13.13,0,0,1,0,.12s-.12.07-.09.1.18-.08.19,0-.08.13,0,.15.05-.11.11-.12.22.15.26.13.17-.18.22-.08-.43.41-.14.44c.06,0,.11-.07.17-.07s0,.23.16.12.07-.22.14-.26.22-.08.26,0,0-.07,0-.08a1.49,1.49,0,0,1,.14-.12,1.86,1.86,0,0,0,.1-.2.64.64,0,0,1,.21.05h.1c.05,0,0,.11.05.16s.08,0,.1,0,.07.15.14.14.12,0,.18,0,0,.05,0,.07a.82.82,0,0,0,.06.19c0,.06.1.08.16.1.26.09,0-.16.08-.2s.07,0,.11,0,.12-.1.19-.13a5.85,5.85,0,0,1,.83-.3s.07-.2.2-.31.14,0,.21-.07.52-.38.8-.33l.14.05c.07,0,.08,0,.09.06h0a.16.16,0,0,1,.08.06s0,0,0,0a.18.18,0,0,1-.09-.09l-.09-.06h-.07s0,.05,0,.07,0,.25.17.31a.57.57,0,0,0,.69-.48,1.37,1.37,0,0,1,0-.19s0,0,0,0,.22,0,.31-.11l.16-.26a.94.94,0,0,0,.06-.31c0-.07-.07-.13,0-.19h0l0-.05c-.07-.2,0-.07,0-.27s-.19-.36-.1-.47h0l0,0s0-.1,0-.15,0-.1,0-.15.13-.11.15-.19-.09-.42.1-.61.17-.09.25-.16.12-.14.19-.11,0,.12,0,.16.25.1.32.17.07.17.12.25.06,0,.14.05.07.05.12,0,.3-.24.32-.35-.15-.4-.18-.56,0-.1,0-.28,0-.12,0-.18.06-.06,0-.08c-.16-.19-.16.1-.21.13s-.07-.05-.11-.06-.08,0-.12,0,0-.13-.07-.2-.14-.12-.17-.21.08-.15.06-.22-.25.06-.14-.23c0-.08.27-.06.3-.12s-.06-.07,0-.11.28-.12.36-.15-.06-.09,0-.11.05,0,.08.05a.37.37,0,0,0,.25,0,.26.26,0,0,0,.11-.12s0-.09,0-.1,0,.08.08.09c.25,0-.08-.06.06-.09s.05,0,.07,0a4.66,4.66,0,0,0,.93,0c.22-.14-.11-.31,0-.43s0,0,.06,0,.08.08.11.05,0-.1,0-.15.18,0,.21,0c.18,0-.16-.25.26-.27.14,0,.59.07.37-.11,0,0-.11,0-.16,0s-.06-.19-.25-.11-.15.13-.25.08,0,0,0-.05a.35.35,0,0,0-.11-.1s-.09,0-.11,0,0-.25-.07-.35-.15.22-.16.22-.13,0-.18,0,0,0,0,.06a.29.29,0,0,1-.12.1s-.17-.09-.17-.09,0,0,0,.07h-.05s0,0,0,0,.24,0-.13.16,0-.12-.11-.17,0,.21-.06.26,0-.07-.06-.07-.15-.05-.17,0,.12.07.13.13c.07.29-.22,0-.23,0s0,.14,0,.15a1.13,1.13,0,0,1-.22.14s0-.06,0-.05,0,.05,0,.07,0,0-.05,0-.12,0-.16,0,.06.06,0,.08-.23.06-.28.09,0,.09-.08.11-.13.07-.18,0,.06-.14,0-.12,0,.23-.27.33c0,0,0,0,.05-.07s.09,0,.11-.08.05-.12,0-.11,0,.14-.09.12.08-.09.07-.14-.08,0-.11,0c-.19-.07-.09-.2-.05-.32s0,0,0,0a1.43,1.43,0,0,1-.22.15s.1,0,0-.21c0,0,0,0,0,0a.07.07,0,0,1-.06,0s0,0,0,0,0,0-.08,0-.06-.07-.11-.08-.11,0-.16,0,0-.11,0-.11,0,.27-.2,0a.31.31,0,0,1-.05-.1s.07,0,.05-.05-.15-.11-.14-.31c0,0,.09,0,.09,0s0,0,0-.08,0,0,.05-.07-.05,0-.05,0,0-.06,0-.08-.11-.09-.09-.16.13,0,.14-.05-.08-.08-.12-.13a.08.08,0,0,1,0,0s0,0,0,0,0,0-.06,0,0,0,0-.05a.83.83,0,0,0-.07-.13s-.07,0-.08,0,0-.25,0-.37,0-.05,0-.05,0,.08,0,.07,0-.06,0-.08,0,0,0,0,0-.18,0-.18c-.08-.2-.13.33-.09-.18,0-.09.21-.22.23-.3s-.25,0-.13-.19a.18.18,0,0,1,.17-.06s0,.1.07.11,0-.08,0-.11.21,0,.14-.21c0,0-.07-.05-.07-.09s0,.07.06.05,0-.2,0-.26.07.05.1.05a.81.81,0,0,0,.06-.2c0-.13.21-.11.24-.26s-.05-.05,0-.07.09-.1.13-.19,0-.09,0-.14.11-.09.12-.16,0-.08,0-.12a.63.63,0,0,1,0-.19s0,0,.06,0,0-.05,0-.07.09-.07.13-.1.13,0,.15-.07c.09-.22-.12-.07-.14-.14s0-.23-.05-.41-.05,0-.1,0,0-.06,0-.06-.11.05-.16,0,0-.14-.08-.17-.18.09-.25.13-.06-.06-.1-.06,0,.05,0,.05-.14-.05-.19,0,0,.12,0,.14-.21-.08-.33-.1,0,0,0,.07,0,0,0,0-.05.1,0,.15a0,0,0,0,0,0,0l.07,0-.07,0h0l-.17-.05s-.05-.07-.06-.05.2.05.21.14-.09,0-.14,0,0,0,0,0,.09.06,0,.1,0,0,0,0,0,0,0,0-.24,0-.27.12,0,0,.06,0a.37.37,0,0,1,.13.15c0,.14-.19.21-.2.36s.25.2.31.34-.15.21-.18.28-.06.48-.16.49,0-.05,0,0,0,.13,0,.15,0-.09,0-.08,0,0,0,0h0s0,.07,0,.08-.12,0-.14.07,0,.09-.06.11-.11-.07-.14,0,.08.11.06.17-.08-.08-.11-.06,0,.1,0,.14,0,.14-.07.17-.1-.06-.16-.05.07,0,.08.05,0,0,0,0,0,0,0-.06h-.05s0,0,0,.07-.06,0-.09,0,0,0,.05,0,0,0,0,0,0,.09,0,.11-.15,0-.12,0,.19,0,.17,0-.09.1-.13.16,0,0-.05,0-.07,0-.07,0,.06,0,.07,0-.07,0-.1,0l0,.08c0,.05.06.2,0,.19s0-.08,0-.07,0,.11,0,.14-.05,0-.08,0a.34.34,0,0,0-.17,0c-.12.09.09.13.18.24s0,0,0,0h0c0,.06,0,.12,0,.18s0,.07-.05.11a.66.66,0,0,0,0,.14h0c0,.06.12.14.07.18s-.11-.08-.18-.06.13.23.1.4-.07,0-.07,0,.05.05.06.08,0,0,0,0a.34.34,0,0,0,0,.1s0,.07,0,.1,0,0,0,0,0,0,0,0a.06.06,0,0,0,0,.06s.07.06.08.11,0,.09,0,.14h0s0,.06,0,.06.24-.05.32,0,0,.07,0,.1a.29.29,0,0,0,.11.11s0,0,.05,0,0,.05,0,.06.41-.16.2.07c0,0-.1-.07-.15-.05s.05.05.08.08,0,.11.08.14,0-.07.07-.06,0,.09.05.11.2,0,.18.26-.08,0-.09,0,0,0-.07.08,0,.15-.22.25c0,0,0,.07,0,.08s-.06,0-.09,0-.11.06-.17.06,0-.12,0-.17,0-.05-.06-.08,0,0,0,0,0-.12-.09-.14a.12.12,0,0,0-.12.06s.06,0,.07,0,0,.13,0,.17.14,0,.12.07-.32-.09-.37-.08-.09.11-.16.11-.06-.11-.1-.1,0,.09,0,.13,0,0-.05,0a.65.65,0,0,0-.19,0s0,0,0,.05.14,0,.19,0,.15.09.22.07-.06-.11,0-.1.06.08.11.1.11,0,.15,0-.06.08,0,.11.07,0,.1,0-.05-.06,0-.06.07,0,.1,0,.11.05.17,0,0-.11,0-.13.09,0,.13,0,.06-.12.12-.13.13.07.11.11-.14,0-.2,0,0,0,0,0a.34.34,0,0,1,.07.15s0,0-.05,0a.35.35,0,0,0-.15.12c0,.05,0,.12,0,.17s0-.11-.08-.1,0,.1,0,.09,0-.3-.09-.28,0,.34-.12.44-.12,0-.17,0,.06,0,.06,0-.08,0-.1.05.05,0,.05,0,0,0,0,0l0,0s-.41-.05-.38,0,0,0,.06,0,0,0,0,0,0,.06,0,.05,0-.05,0-.05a.22.22,0,0,1,.28.13h-.05s0,.07,0,.07-.14-.08-.18,0,.12,0,.17.05a.29.29,0,0,1,.07.2s-.1,0-.11,0,.17.25.11.32-.13,0-.18,0,0,0,0,.05.16.07.16.14-.11.08-.1.14.08.05.11.09,0,0,0,0a.67.67,0,0,0-.07.18c0,.05.1.22.09.23s-.06,0-.08,0,.07.19.05.29-.07,0-.07,0,0,.06,0,.08c-.08.26-.05-.19-.08.08s0,.42-.17.54,0,0,0,0,0,0,0-.05-.13,0-.13,0,0,0,0,0-.08.05-.12.09,0-.06-.05-.06a.26.26,0,0,1-.14.05s-.07,0-.11,0-.07,0-.08,0,.07.09.05.13-.11,0-.17,0-.05.07-.08.11c-.2.3.06.2,0,.4a.35.35,0,0,1-.09.17s-.17,0-.19,0c-.19,0-.13.12-.33.12s-.11,0-.17-.05a.37.37,0,0,1-.11,0c-.05,0,.09-.06.09-.06s-.05-.08,0-.13.06-.07.08-.11-.41-.57-.37-.63.14.09.21.06-.16-.12-.13-.18.13,0,.16,0a.19.19,0,0,0,0-.19s-.06,0-.09,0,0-.14-.1-.19-.09,0-.12-.08,0-.07,0-.1a1.71,1.71,0,0,0-.11-.17s0,0,0,0,0,0-.06,0a.31.31,0,0,1-.09-.11c0-.07,0-.26-.05-.35s-.07,0-.09,0a.27.27,0,0,1,0-.13c0-.12.21-.39.1-.52s-.06.31-.35,0c0,0,0-.19,0-.24s-.1-.44-.1-.44.12,0,.17,0,0-.08,0-.11c-.16-.26-.08.12-.34-.12,0,0,0-.07,0-.1s0,0,0,0,0-.19,0-.17,0,0,0,.05,0-.06,0-.08l-.06-.23c0-.05.07-.15,0-.15s.14.24-.05.38l0,0c0-.05,0-.1,0-.14s-.1-.11-.11-.07.07.1.1.16,0,.1,0,.14.11.07.06.18,0,0,0,0,0,0-.05,0,0,.24-.05.24,0-.11,0-.09.12.17-.21.17c0,0,0-.08,0-.1s-.11-.11-.13-.07.07.09.1.14-.21,0-.23.12.08.06.06.08-.14,0-.18.05.07,0,.07.07c-.05.32-.11-.09-.15.07s0,0,0,.05-.24.29-.24.3,0,0-.06,0,0,.14-.1.15-.05-.12-.11-.1,0,.12-.07.15-.08,0-.12,0,0,0-.05,0-.05,0-.16,0-.12.09-.15.05.1-.07.08-.12-.07.06-.11.06a.33.33,0,0,1-.19,0c-.13-.06.13-.14.15-.2s-.05-.06-.08-.05,0,.08-.06.08-.09,0-.14,0-.15-.18-.2-.21-.06,0-.1,0a.62.62,0,0,1-.14-.28s.06-.08.07-.14,0-.16,0-.14,0,.14.08.17,0-.08.08-.1.08.16.15.14,0-.08,0-.11.18,0,.27-.09-.07,0-.11,0-.1,0-.14,0,0,.12-.07.09-.05-.11-.07-.17.11,0,.14-.08-.07,0-.07,0a.2.2,0,0,1,.1-.08s.14,0,.16-.06-.19,0-.23,0-.05.05-.05,0,.14-.07.13-.13a.16.16,0,0,0-.18-.06c-.1,0-.06.27-.17.26s0-.1,0-.13-.12-.06-.13-.11.09,0,.13,0,0-.14.08-.16.06.06.1.07,0,0,0-.05h.05s-.07,0-.07,0l.3-.14c-.25,0-.09.19-.33,0h0s0-.06,0-.06.07,0,.11,0,0,0,0-.05a.43.43,0,0,1,0-.07s.13,0,.14,0-.1,0-.1-.08,0,0,0-.07,0,0-.06,0a.39.39,0,0,0-.08.1c0,.06,0,.14-.06.18s0-.06,0-.08-.08-.07-.05-.14.15-.21.08-.19-.13.37-.22.19a.85.85,0,0,1-.06-.17c0-.07.11,0,.25-.05s.07-.23.07-.23c0-.25-.17.07-.24.08s0-.08,0-.11-.15-.15-.11-.16.11.06.16.1h0s0,0,0-.06.1-.06.15-.1,0,0,0,0-.17.09-.22.06,0-.22,0-.25.12.08.19.08.16-.18.33-.09.07.1.12.12-.05-.11.13-.16,0,.33.24.32-.06-.14-.05-.24.4.15.35-.13c0-.05-.11.05-.16,0s0-.05,0-.08.22-.17.14-.2-.13.28-.14.32a.75.75,0,0,1-.17,0s0,0,0,0l-.17-.07h0s0,.1-.06.11a2.28,2.28,0,0,0-.31-.1s0,0,0,0a.36.36,0,0,1-.27,0s-.13-.13-.11-.15.11-.08.16-.1.18.06.18,0-.12,0-.18,0-.07.05-.11,0,0-.15.08-.15.21.1.3,0-.27,0-.32-.09.18,0,.14-.06-.11,0-.15,0,0-.17,0-.24a.21.21,0,0,1,.14-.07.3.3,0,0,1,.24.08s-.05.09,0,.12,0-.09,0-.1.06.07.1.08-.07-.06-.05-.07.22.11.36,0,0,0-.07,0c-.27,0,.14.07-.09.08,0,0-.28-.11-.39-.12s-.07,0-.11,0-.13.07-.14,0,.12-.06.14-.11-.14-.1-.14-.18.07,0,.09,0,0,.13.07.13-.05-.14,0-.14.09.11.16.11,0-.14.06-.11,0,.1,0,.15,0,0,0,0,0-.11.07-.11,0,0,0,.07.12.07.14,0-.1,0-.12-.05a.25.25,0,0,1-.05-.16s0-.05,0-.07v0s0,0,0,0a.17.17,0,0,1,.13,0s0,.07,0,.1.06.08.07.13,0,0,0,0,0,0,0,0c0-.16-.2-.26.07-.31.1,0,.11.12.11.26a.06.06,0,0,1,0-.06c.05,0,.18,0,.16,0s-.12,0-.17-.05,0-.1-.06-.14a1.46,1.46,0,0,0-.28-.14s0,0,0,0h.1s0,.05,0,.05.12-.16.23-.07,0,.1,0,.12,0-.09,0-.11.17.14.17.15.14,0,.11-.07-.11,0-.15,0,0-.12.12-.15l-.15,0c-.47,0-.06-.05-.07-.14s-.11-.06-.15-.11,0-.12.18-.09c0,0,0,.09.09.11s.06,0,.09,0a.22.22,0,0,1,.14,0l0,0c0-.05.05-.1.1-.1s0,0,0,.07.08,0,.1.07,0,.07,0,.1.14.11.17.05-.13-.08-.13-.14.08,0,.11,0-.05,0-.07,0,.05,0,0,0-.07.06-.1.05a.23.23,0,0,1-.08-.16l.06,0s-.08-.08,0-.06.32.16.29-.05-.25.23-.21-.11c0-.07.2-.19.25-.16s0,.13,0,.17,0,0,.07,0,.14,0,.11-.05-.13.08-.12,0,.08-.07.12-.11.05-.14.11-.15,0,.08.05.11.07.05.07.09-.07.07-.06.12,0,0,.07,0,.11.12.13.08-.09-.11-.09-.17.32,0,.33,0a.22.22,0,0,0,.05-.19s-.1,0-.09,0,.34-.12.33-.2-.2-.06-.16-.11.17,0,.18-.1c0-.31-.26.07-.32.12s-.12.05-.1.09.12,0,.18,0l0,0-.13.07s-.23.2-.29.19,0-.07,0-.11-.07-.05-.06-.08.1-.06.15-.1,0,0-.05,0,0,0,0,0-.14.15-.22.12.06-.15.14-.2.11,0,.14-.07-.07,0-.1,0,0,0,0,0,0-.11,0-.15.07,0,.09,0,0,0,0,0,0-.05,0-.07.08,0,.1,0,0-.07,0-.1.1,0,.11-.07-.1-.07-.07-.08.1.08.16.06-.06,0-.09-.08.08-.12.14-.16.09.14.16.17a.12.12,0,0,0,.14,0s-.1,0-.09,0,.13,0,.15-.08-.24.18-.17-.12.12.34.18-.11c0,0-.07,0-.08,0s0,0,0,0h0a.52.52,0,0,1-.17.12c-.12.05.22-.15.19-.18s0,0-.06,0h0s-.06,0-.05,0,.26,0,.3-.05,0-.06,0-.07.27,0,.31-.27c0,0-.06,0-.09.06h-.12s-.08.05-.08,0,.29-.1.22-.23-.27.06-.19-.13.12,0,.18-.06,0,0-.05,0a.24.24,0,0,1-.05-.1c0-.05.06-.22.11-.22s.09.09.15.1,0-.05,0-.08,0-.11-.05-.13-.11,0-.14,0,.13-.06.17-.07.07-.14.18-.11.07.08.12.08-.06,0-.07-.08,0,0,.05,0a.34.34,0,0,0,.14-.09c.07,0-.14.08-.21.1s0-.05,0-.06-.13.13-.22.12c-.27,0,.15-.09.2-.13s0,0-.06,0-.1,0-.15,0-.05-.14,0-.2c.05-.29.17-.17.36-.25s-.12-.12-.15-.17.07,0,.1,0-.13-.13.06-.07c0,0,0,0,0,.05s0-.06,0-.07,0-.05,0,0,0,.09,0,.1.15,0,.16-.08-.08-.08-.09-.13.18-.12.25-.09,0,.14,0,.14,0-.11,0-.14h0l0,0s0-.06,0-.07,0,0-.07.07-.17.09-.25,0,.06-.07.09-.11.06-.33.18-.24-.12.07-.08.1.08,0,.13-.06a.16.16,0,0,1,.11.05c.05.05.13.22.11.15s-.09-.1-.08-.16.1-.06.13-.11,0,0-.07,0-.15.09-.21-.06,0,0,.05-.07h0c0-.07.19,0,.22,0s-.18-.17-.2-.17,0,0,0,.05-.16.21-.2.18-.07-.11,0-.16.09,0,.12-.05-.07,0-.08,0,.1-.08.14,0,0,0,0,0,.32,0,.31-.21-.05,0-.07,0,0,0,0,0,0,0,0,0h-.08s-.11,0-.13,0c-.1-.2.21-.06.21-.06s0-.12,0-.18,0,.06,0,.09,0,0,0,0,0,.09,0,.13.17.26.21.22-.29-.45-.18-.51.12,0,.18.09,0,0,0-.06-.16,0-.14-.07.11,0,.17-.06c.33,0,0,.11.26.21s-.17-.24,0-.24.06.05.1.05.11,0,.1-.05c0-.33-.24,0-.31,0s0,0,0,0,0,0,0,0,0,0-.05,0-.13,0-.15,0a.17.17,0,0,1,0-.07c-.05,0-.11,0-.13.05s0,.13-.05.17,0-.09,0-.12a.11.11,0,0,0-.11,0s0,.06,0,.08l-.09.08-.07.09v0c0-.06.06-.1.08-.17s0-.07,0-.1.12,0,.16-.06-.27-.11,0-.35.13.18.1.35a.1.1,0,0,1,.06-.08s0,.05,0,0,0-.41.12-.23a.61.61,0,0,1,.09.2.22.22,0,0,1,.12-.07s0,.07.08.07a.37.37,0,0,0,.18,0c.08-.05-.16,0-.18-.09a.09.09,0,0,1,.08-.07c.05,0,.12.09.13.05s-.13,0-.13-.07.1,0,.13-.06,0,0,0,0a.19.19,0,0,1-.07-.19c0-.07.17,0,.18-.07s0-.11,0-.18a.47.47,0,0,1,0-.17c0-.06.06.16.11.19a.22.22,0,0,0,.18,0s-.23-.09-.22-.14.07-.13.13-.12,0,.1.08.14.09,0,.14.07.05.12.06.09-.39-.14-.22-.5c0-.06.16-.14.22-.1s0,.4,0,.42,0,0,.05,0,0-.11,0-.15.12,0,.13,0-.11,0-.13-.09.06-.37.18-.23a2.78,2.78,0,0,1,0,.5s-.12.15-.06.16.07-.22.12-.26.11,0,.16,0,0,0-.06-.05-.17-.1-.12-.21c.2-.45,0,.06.23-.1.07,0,0-.15.05-.21s0,0,.05,0,0,0,0,.06l.12.07s.06.07.1.09-.07-.06-.09-.1l0,0a.59.59,0,0,0,0-.27s-.27.2-.33,0,.2-.18.26-.16.08.08.14.09,0,0,0-.05,0,0,.06,0h.14c.1,0,0,.26.18.24,0,0,.06-.06.05-.1s-.05,0-.07,0-.06,0-.06,0,.09,0,.06-.07,0-.09,0-.24.23-.1.26-.14-.09,0-.1-.06.18-.11.19-.13-.21-.16-.21-.18.12.06.14,0-.07-.11-.06-.17.19,0,.32,0c-.3-.3.12-.3.15-.12s-.1.07-.14.12l.13,0a3.89,3.89,0,0,1-.19.42h0s0,0,0,0,.06,0,.08,0-.13.1,0,.14,0,.08,0,.13,0,.24.12.11,0-.07,0-.1,0-.08,0-.12-.07,0,0-.06a2.63,2.63,0,0,1,.25-.69l.06.21c0,.05-.1.08-.09.13s.08-.05.1,0,0,.14,0,.16.13,0,.18,0-.07-.05-.07-.09,0-.13,0-.17.1-.07.13-.11,0,0-.05,0-.15,0-.15-.1.12,0,.14,0,0-.12,0-.17.06.07.1.05.11-.08.23,0-.16.39-.18.44,0,0,.05,0,.07-.12.13-.14,0,.07,0,.11-.11.11-.08.17.11-.1.15-.07l0,0s.05,0,.06,0-.07-.08-.07-.08a1,1,0,0,1,0-.34c.14-.18.23.16.24.16.5,0-.26-.3.24-.15.26.08.07.09,0,.19s0,0,.05,0,.09-.06.14-.06,0,0,0,0l.08,0,0,0a.61.61,0,0,1,.14.1s0,0-.05,0-.09,0-.12.07,0,.17-.07.2-.38,0-.52.13a.24.24,0,0,1,.08,0l.11,0s0,0,0,0,.15,0,.19,0-.1.1-.07.14.05-.11.1-.1,0,.27,0,.29,0-.09,0-.1.13,0,.19,0,0,0,0-.06a.32.32,0,0,1,0-.14s0,0,0,0a.54.54,0,0,0,.18,0l.38,0s-.07-.06-.07-.1a.31.31,0,0,1,0-.19s.22.07.25.1.16-.07.22,0a.17.17,0,0,1,0,.19c-.07.08-.25-.15-.32-.07a.17.17,0,0,0,0,.19s.1-.08.14-.05,0,.07,0,.11.39-.16.41-.09-.11-.11,0,.17c0,0,.1,0,.1.09s-.2.14-.06.24,0-.07,0-.1.08-.1.11-.16v-.05a.67.67,0,0,1,.07-.17c.12-.11.17,0,.28,0s.27-.15.48-.1a7,7,0,0,1,.84.22c.05,0,.09.08.15.1s.08,0,.12,0,0,.07.06.08.13,0,.15,0-.06,0-.11,0h0s0,0,0,0,.54.23.58.13-.09-.07-.09-.12.06,0,.08,0,.1.08.14.1.08,0,.11,0,.07.08.11.12.12-.07.19-.06.07.18.13.23l0,0c.09,0,.08.16.12.2s.08,0,.12,0,.11.42.09.54,0,.17,0,.28a1.11,1.11,0,0,1-.79.79,1.59,1.59,0,0,1-.38,0c-.16,0-.3.08-.46.09a.78.78,0,0,1-.21,0c-.09,0-.27-.13-.37-.09s0,.09-.09.11-.05-.06-.08-.06-.08,0-.11,0,0-.11,0-.11,0,.09-.05.11a.21.21,0,0,1-.16,0s-.33-.08-.37-.16.05-.07,0-.11a2.45,2.45,0,0,0-.43.06s0,.05,0,.05.22-.09.29.06-.05,0-.06,0,0,0,.05,0,0,0,0,.05,0,0,0,0,.09.11.15.12c.25.05.12-.06.35.08,0,0,.09,0,.11.07s-.19.11-.12.17.07-.05.11-.06a1.72,1.72,0,0,1,.56.17l.11.15s.13,0,.09.07-.1-.06-.14,0,.11.16.11.17c.1.27,0,.06-.11.28,0,0,.07,0,.09,0l.26.25s0,0,0,.07.14,0,.15.09-.07.08,0,.11.08-.07.11,0-.06,0-.06.09a.19.19,0,0,0,0,.16,1.71,1.71,0,0,0,.36.1s0-.15.3,0c.65.25-.4-.14.18.19a5.68,5.68,0,0,0,.59,0s0-.08,0-.11.06,0,.08,0,0-.3-.1-.41-.05,0-.12,0,0-.06,0-.05,0,0,0,.06,0,0,0,0a.26.26,0,0,1-.19.06,2.26,2.26,0,0,1-.54-.41c0-.05.11-.06.15-.1s-.08-.12-.08-.19.56.09.58.09.12-.07.18-.06,0,0,0,.05h0c.08-.09.47.06.53,0s0-.11.06-.14.19.09.33,0-.09-.11-.12-.17,0,0,0-.05-.49-.28-.6-.42,0-.31.08-.49,0-.16,0-.22.2-.19.25-.36a3,3,0,0,1,0-.44.47.47,0,0,1,.17,0c.11,0,0,.09,0,.09.24-.14.08-.21.32-.12.05,0,.11,0,.16,0s0,0,0,.07a.09.09,0,0,1,.08-.05c.12,0,.16.23.28.22s0-.06-.21-.27,0-.33-.08-.53l0,0s-.08,0-.1-.09,0-.05,0-.06a.32.32,0,0,0,0-.09,1.43,1.43,0,0,0-.26-.15c-.05,0-.1.05-.17,0s-.1-.28-.11-.33,0-.16,0-.16a.69.69,0,0,1-.14-.24c0-.05,0-.1,0-.15s0,.08-.06.07,0-.23-.38-.31c0,0-.32-.06-.23-.12s.21,0,.3,0,.29-.22.37-.25a.49.49,0,0,1,.29-.05s0,0,0,0a.22.22,0,0,0,.1.09c.16.07.4.09.49.29a.8.8,0,0,0-.17.14c0,.05-.25.18-.22.25h0s.05.05,0,.08-.15.18,0,.3.25,0,.33,0,.24.27.34.22.1-.21.15-.16,0,.12,0,.16,0-.08,0-.12a.86.86,0,0,1,.21-.26s.07,0,.09,0-.13-.27-.15-.29,0-.22-.05-.28-.19-.06-.12-.19.07.05.08,0,0-.08,0-.12.08,0,.1,0,0-.07,0-.07.13,0,.19,0-.13,0-.17,0,0-.08,0-.1-.1,0-.13,0,.07,0,.11,0a.24.24,0,0,0,.13-.09c.07-.07.07-.27.11-.35s0,.06,0,.09,0,0,0,0a2.4,2.4,0,0,1,.05-.46s.07,0,.1,0,0-.1,0-.15,0,0,0,0,0,0,0,0,.05,0,.05,0,0-.14.07-.18.13.23.2.22,0-.12,0-.19,0,0,0,0l-.16,0s0-.09,0-.08a.24.24,0,0,0,0,.07s0,0,0,0,0,0,0,0a1.38,1.38,0,0,1,.33-.81s0,0,.05,0,0,.06,0,.09-.19.19-.17.21.09-.07.15-.06,0,.06,0,.08a.67.67,0,0,0,.06.15c.07.06.2.07.24.15s-.38.28-.06.27c0,0,.05-.07.09-.1s.09,0,.11,0-.05-.1,0-.12.05.11.08.09,0-.13,0-.15.12.05.18,0-.13-.19-.13-.21.05-.19.1-.31,0-.1,0-.15,0,0,.07,0c.2-.05.07-.07.14-.12s.07,0,.1,0a.6.6,0,0,0,.13-.09c.05-.06-.06-.14-.06-.21s.07-.06.08-.1-.05-.15,0-.18.16.13.16.07-.12,0-.16-.1a.64.64,0,0,1,.1-.23s0,0,0,.06.05,0,.07,0c.4,0,.11.08.21.22s.11.16.25.1.09,0,.11,0c.12-.27-.17-.14-.22-.31s.11-.13.14-.18,0-.19,0-.27-.6-.21-.71-.28,0-.12.06-.2-.11-.12-.11-.19.25-.1.25-.1a4.09,4.09,0,0,1,.51-.4,1.73,1.73,0,0,1,.64-.17H310a.32.32,0,0,0,.14,0,1.4,1.4,0,0,0,.16-.1c.09,0-.14.08,0,.09-.07,0-.07.35,0,.39a2.58,2.58,0,0,0,.92.67,7.32,7.32,0,0,0,.89.17,30.61,30.61,0,0,1,.13,3.45l.09.13c.05.09-.09,0-.09.09,0,.49.52.78.66,1.24.05.13.18.17.32.22s.17.26.31.35a16.21,16.21,0,0,1,2.38,3.05,3.55,3.55,0,0,0,.84.8,7.26,7.26,0,0,0,1.59.44C318.58,285.87,318.62,286.32,318.85,286.58ZM283.41,304s0,.07,0,.09S283.39,304,283.41,304Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_48),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M305.71,282.41s-.06.07-.06.11.16.12.15.07-.1,0-.11-.07A.15.15,0,0,1,305.71,282.41Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_49),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M281.52,298.6s-.1,0-.12-.06,0-.06,0-.08a1.09,1.09,0,0,1-.2.12A.91.91,0,0,0,281.52,298.6Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_50),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M284,304.36a.49.49,0,0,1,.27.08c-.05-.05-.13-.14-.22-.12Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_51),
          _hoisted_52,
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M301.21,312.84s-.1-.13-.15-.1,0,.12,0,.17.22,0,.27-.08S301.22,312.84,301.21,312.84Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_53),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M292.17,298.6c-.07-.06-.07-.2-.17-.25.05,0,.05.1.08.14s.25.46.25.2C292.33,298.63,292.22,298.65,292.17,298.6Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_54),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
            d: "M293.86,297.93s.09-.13.1-.14l.17,0a.15.15,0,0,0-.09,0C293.9,297.75,293.86,297.78,293.86,297.93Z",
            transform: "translate(-207.47 -267.99)",
            fill: $props.color?$props.color:'#515151'
          }, null, 8, _hoisted_55)
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
  ]))
}
;// CONCATENATED MODULE: ./src/components/WebsiteLogo.vue?vue&type=template&id=c5f109f6&scoped=true

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebsiteLogo.vue?vue&type=script&lang=js

  /* harmony default export */ var WebsiteLogovue_type_script_lang_js = ({
    name: "WebsiteLogo",
    props: {
      color: {
        type: String,
      },
      logo: {
        type: String,
        default: 'dutypay'
      }
      //TODO: Size of the logo
    }
  });

;// CONCATENATED MODULE: ./src/components/WebsiteLogo.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-64.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebsiteLogo.vue?vue&type=style&index=0&id=c5f109f6&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/WebsiteLogo.vue?vue&type=style&index=0&id=c5f109f6&scoped=true&lang=scss

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/WebsiteLogo.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(WebsiteLogovue_type_script_lang_js, [['render',render],['__scopeId',"data-v-c5f109f6"]])

/* harmony default export */ var WebsiteLogo = (__exports__);

/***/ }),

/***/ 7227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WebsitePrivacyPolicy; }
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm-bundler.js + 4 modules
var vue_i18n_esm_bundler = __webpack_require__(9150);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebsitePrivacyPolicy.vue?vue&type=script&setup=true&lang=js


const _hoisted_1 = ["innerHTML"]


  const __default__ = {
    name: "WebsitePrivacyPolicy"
  };



/* harmony default export */ var WebsitePrivacyPolicyvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const { t } = (0,vue_i18n_esm_bundler/* useI18n */.QT)()

return (_ctx, _cache) => {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('textBlock.title')), 1),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: "content",
      innerHTML: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('textBlock.content')
    }, null, 8, _hoisted_1)
  ]))
}
}

}));
;// CONCATENATED MODULE: ./src/components/WebsitePrivacyPolicy.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebsitePrivacyPolicy.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function WebsitePrivacyPolicyvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      
    }
  })
}

;// CONCATENATED MODULE: ./src/components/WebsitePrivacyPolicy.vue


/* custom blocks */
;
if (typeof WebsitePrivacyPolicyvue_type_custom_index_0_blockType_i18n === 'function') WebsitePrivacyPolicyvue_type_custom_index_0_blockType_i18n(WebsitePrivacyPolicyvue_type_script_setup_true_lang_js)


const __exports__ = WebsitePrivacyPolicyvue_type_script_setup_true_lang_js;

/* harmony default export */ var WebsitePrivacyPolicy = (__exports__);

/***/ }),

/***/ 6430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(4029);
var availableTypedArrays = __webpack_require__(3083);
var callBound = __webpack_require__(1924);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(6410)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var gOPD = __webpack_require__(882);
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		if (typeof g[typedArray] === 'function') {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr) {
				var proto = getPrototypeOf(arr);
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor) {
					var superProto = getPrototypeOf(proto);
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				toStrTags[typedArray] = descriptor.get;
			}
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var foundName = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!foundName) {
			try {
				var name = getter.call(value);
				if (name === typedArray) {
					foundName = name;
				}
			} catch (e) {}
		}
	});
	return foundName;
};

var isTypedArray = __webpack_require__(5692);

module.exports = function whichTypedArray(value) {
	if (!isTypedArray(value)) { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 8230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./CookieNotice.vue": 9017,
	"./DpApplicationContainer.vue": 9166,
	"./DpApplicationLogo.vue": 5159,
	"./DpButton.vue": 549,
	"./DpCollapse.vue": 2785,
	"./DpContent.vue": 7381,
	"./DpCopyToClipboard.vue": 9867,
	"./DpDismissAll.vue": 4577,
	"./DpExpand.vue": 4177,
	"./DpFeaturedButton.vue": 9574,
	"./DpFeedforward.vue": 9963,
	"./DpFileIcon.vue": 7602,
	"./DpFlag.vue": 4776,
	"./DpHeader.vue": 1628,
	"./DpIcon.vue": 5172,
	"./DpImg.vue": 7789,
	"./DpImprint.vue": 5686,
	"./DpListItem.vue": 3316,
	"./DpMobileCollapse.vue": 6989,
	"./DpMobileFileDownload.vue": 6993,
	"./DpMobileListItem.vue": 9529,
	"./DpNoDataIndicator.vue": 6313,
	"./DpNotificationPersist.vue": 451,
	"./DpPageSection.vue": 6204,
	"./DpPrivacyPolicy.vue": 4133,
	"./DpReadEditDelete.vue": 5171,
	"./DpReadValue.vue": 7953,
	"./DpReadValues.vue": 5785,
	"./DpReminder.vue": 1843,
	"./DpSimpleCrud.vue": 5527,
	"./DpTable.vue": 4059,
	"./DpTooltip.vue": 4685,
	"./DpWrapper.vue": 9293,
	"./WebsiteLogo.vue": 4475,
	"./WebsitePrivacyPolicy.vue": 7227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8230;

/***/ }),

/***/ 2706:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2706__;

/***/ }),

/***/ 3351:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3351__;

/***/ }),

/***/ 7203:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7203__;

/***/ }),

/***/ 6952:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 3083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 2757:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l_": function() { return /* binding */ expect; }
/* harmony export */ });
/* unused harmony exports version, Assertion, AssertionError, util, config, use, should, assert, core */
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4960);


const expect = _index_js__WEBPACK_IMPORTED_MODULE_0__.expect;
const version = _index_js__WEBPACK_IMPORTED_MODULE_0__.version;
const Assertion = _index_js__WEBPACK_IMPORTED_MODULE_0__.Assertion;
const AssertionError = _index_js__WEBPACK_IMPORTED_MODULE_0__.AssertionError;
const util = _index_js__WEBPACK_IMPORTED_MODULE_0__.util;
const config = _index_js__WEBPACK_IMPORTED_MODULE_0__.config;
const use = _index_js__WEBPACK_IMPORTED_MODULE_0__.use;
const should = _index_js__WEBPACK_IMPORTED_MODULE_0__.should;
const assert = _index_js__WEBPACK_IMPORTED_MODULE_0__.assert;
const core = _index_js__WEBPACK_IMPORTED_MODULE_0__.core;

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (chai)));


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(7679)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./src/lib.js
/* harmony default export */ var lib = ({
  install: (app) => {
    const components = __webpack_require__(8230);
    components.keys().forEach(fileName => {
      app.component(components(fileName).default.name, components(fileName).default);
    });
  }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (lib);


}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=dutypay-design-system.umd.js.map